/* ================================================================================================== */
/* js/machinata-reporting-bundle.js */
/* Copyright 2021 Dan Krusi / Nerves GmbH */
/* License: Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) */
/* Link: https://nerves.ch */
/* Profile: reactjs */
/* Debug: yes */
/* Language: en */
/* Package: Machinata.Core */
/* Theme: default */
/* Build: 941a6590-3a33-4a37-97eb-662c9cabda58 */
/* Date: 19.07.2021 12:54 UTC */
/* ================================================================================================== */


/* -------------------------------------------------------------------------------------------------- */
/* profile-reactjs.js */
/* File: js/machinata-reporting-bundle.js/profile-reactjs.js */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Specific reactjs Profile Code
/// </summary>
/// <hidden/>


/// <summary>
/// Enable strict JS
/// </summary>
/// <hidden/>
"use strict";

// Turn off define and require loading for all vendor plugins in this file...
const define = null;
const require = null;

// ES-Lint is entirely disabled for this bundle. Vega/D3 cause too many troubles...
/* eslint-disable */

// Most of the CommonJS/AMD/UMD loaders cause lint errors, so unfortunately we must disable this lint rule...
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */


/* -------------------------------------------------------------------------------------------------- */
/* module-es6.js */
/* File: js/machinata-reporting-bundle.js/module-es6.js */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Provides ES6 module loading support
/// </summary>
if (typeof Machinata === "undefined") var Machinata = ((typeof global !== 'undefined') ? global : window).MACHINATA;

Machinata.Reporting = {};
export default Machinata.Reporting;


/* -------------------------------------------------------------------------------------------------- */
/* d3.js */
/* File: js/machinata-reporting-bundle.js/d3.js */
/* -------------------------------------------------------------------------------------------------- */

// https://d3js.org v5.14.2 Copyright 2019 Mike Bostock
(function (global, factory) {
false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof exports === 'object' */ && typeof module !== 'undefined' ? factory(exports) :
typeof define === 'function' && define.amd ? define(['exports'], factory) :
(global = global || self, factory(global.d3 = global.d3 || {}));
}(((typeof global !== 'undefined') ? global : window), (function (exports) { 'use strict'; /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: }(this, (function (exports) { 'use strict'; */

var version = "5.14.2";

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
}

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;

function pairs(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
}

function pair(a, b) {
  return [a, b];
}

function cross(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = pair;

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
}

function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function number(x) {
  return x === null ? NaN : +x;
}

function variance(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
}

function deviation(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
}

function extent(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
}

var array = Array.prototype;

var slice = array.slice;
var map = array.map;

function constant(x) {
  return function() {
    return x;
  };
}

function identity(x) {
  return x;
}

function sequence(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function thresholdSturges(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

function histogram() {
  var value = identity,
      domain = extent,
      threshold = thresholdSturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = sequence(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisectRight(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
}

function threshold(values, p, valueof) {
  if (valueof == null) valueof = number;
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

function freedmanDiaconis(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

function scott(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
}

function max(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
}

function mean(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
}

function median(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return threshold(numbers.sort(ascending), 0.5);
}

function merge(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
}

function min(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
}

function permute(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}

function scan(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = ascending;

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
}

function shuffle(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
}

function sum(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
}

function transpose(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
}

function length(d) {
  return d.length;
}

function zip() {
  return transpose(arguments);
}

var slice$1 = Array.prototype.slice;

function identity$1(x) {
  return x;
}

var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number$1(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$1) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number$1)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "currentColor"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "currentColor")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "currentColor")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1)
            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1));

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice$1.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}

var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
}

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

function creator(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
}

function none() {}

function selector(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}

function selection_select(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

function empty() {
  return [];
}

function selectorAll(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

function selection_selectAll(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
}

function matcher(selector) {
  return function() {
    return this.matches(selector);
  };
}

function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

function sparse(update) {
  return new Array(update.length);
}

function selection_enter() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

function constant$1(x) {
  return function() {
    return x;
  };
}

var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

function selection_data(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$1(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}

function selection_exit() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}

function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}

function selection_merge(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
}

function selection_order() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

function selection_sort(compare) {
  if (!compare) compare = ascending$1;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
}

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

function selection_nodes() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
}

function selection_node() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
}

function selection_size() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}

function selection_empty() {
  return !this.node();
}

function selection_each(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

function selection_attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
}

function defaultView(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
}

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

function selection_style(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

function selection_property(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
}

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

function selection_classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
}

function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

function selection_text(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
}

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

function selection_html(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
}

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

function selection_raise() {
  return this.each(raise);
}

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function selection_lower() {
  return this.each(lower);
}

function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}

function constantNull() {
  return null;
}

function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

function selection_remove() {
  return this.each(remove);
}

function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

function selection_datum(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}

var filterEvents = {};

exports.event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = exports.event; // Events can be reentrant (e.g., focus).
    exports.event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      exports.event = event0;
    }
  };
}

function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

function selection_on(typename, value, capture) {
  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
}

function customEvent(event1, listener, that, args) {
  var event0 = exports.event;
  event1.sourceEvent = exports.event;
  exports.event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    exports.event = event0;
  }
}

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

function selection_dispatch(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
}

var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

function select(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
}

function create(name) {
  return select(creator(name).call(document.documentElement));
}

var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};

function sourceEvent() {
  var current = exports.event, source;
  while (source = current.sourceEvent) current = source;
  return current;
}

function point(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
}

function mouse(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
}

function selectAll(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
}

function touch(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return point(node, touch);
    }
  }

  return null;
}

function touches(node, touches) {
  if (touches == null) touches = sourceEvent().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = point(node, touches[i]);
  }

  return points;
}

function nopropagation() {
  exports.event.stopImmediatePropagation();
}

function noevent() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
}

function dragDisable(view) {
  var root = view.document.documentElement,
      selection = select(view).on("dragstart.drag", noevent, true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", noevent, true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
}

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", noevent, true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}

function constant$2(x) {
  return function() {
    return x;
  };
}

function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !exports.event.ctrlKey && !exports.event.button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
}

function defaultTouchable() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

function drag() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = dispatch("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
    if (!gesture) return;
    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(exports.event.view);
    nopropagation();
    mousemoving = false;
    mousedownx = exports.event.clientX;
    mousedowny = exports.event.clientY;
    gesture("start");
  }

  function mousemoved() {
    noevent();
    if (!mousemoving) {
      var dx = exports.event.clientX - mousedownx, dy = exports.event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(exports.event.view, mousemoving);
    noevent();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = exports.event.changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, touch, this, arguments)) {
        nopropagation();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = exports.event.changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        noevent();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = exports.event.changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        nopropagation();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$2(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant$2(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$2(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$2(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? new Rgb(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? new Rgb((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new Rgb(
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * deg2rad;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

define(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));

var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

function basis$1(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

function basisClosed(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

function constant$3(x) {
  return function() {
    return x;
  };
}

function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$3(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : constant$3(isNaN(a) ? b : a);
}

var interpolateRgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb$1(start, end) {
    var r = color((start = rgb(start)).r, (end = rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$1.gamma = rgbGamma;

  return rgb$1;
})(1);

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = rgb(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);
var rgbBasisClosed = rgbSpline(basisClosed);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function array$1(a, b) {
  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolateValue(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$3(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function discrete(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

function hue$1(a, b) {
  var i = hue(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return identity$2;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
function interpolateZoom(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    };
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    };
  }

  i.duration = S * 1000;

  return i;
}

function hsl$1(hue) {
  return function(start, end) {
    var h = hue((start = hsl(start)).h, (end = hsl(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hsl$2 = hsl$1(hue);
var hslLong = hsl$1(nogamma);

function lab$1(start, end) {
  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
      a = nogamma(start.a, end.a),
      b = nogamma(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

function hcl$1(hue) {
  return function(start, end) {
    var h = hue((start = hcl(start)).h, (end = hcl(end)).h),
        c = nogamma(start.c, end.c),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hcl$2 = hcl$1(hue);
var hclLong = hcl$1(nogamma);

function cubehelix$1(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix$1(start, end) {
      var h = hue((start = cubehelix(start)).h, (end = cubehelix(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix$1.gamma = cubehelixGamma;

    return cubehelix$1;
  })(1);
}

var cubehelix$2 = cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);

function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}

function quantize(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
}

var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

function timeout$1(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

function interval$1(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
}

var emptyOn = dispatch("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function schedule(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create$1(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}

function init(node, id) {
  var schedule = get$1(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set$1(node, id) {
  var schedule = get$1(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function get$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create$1(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout$1(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout$1(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

function interrupt(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
}

function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

function transition_tween(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get$1(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
}

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set$1(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get$1(node, id).value[name];
  };
}

function interpolate(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
}

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrConstantNS$1(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrFunction$1(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attrFunctionNS$1(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value));
}

function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

function transition_delay(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get$1(this.node(), id).delay;
}

function durationFunction(id, value) {
  return function() {
    set$1(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set$1(this, id).duration = value;
  };
}

function transition_duration(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get$1(this.node(), id).duration;
}

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set$1(this, id).ease = value;
  };
}

function transition_ease(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get$1(this.node(), id).ease;
}

function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
}

function transition_merge(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
}

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set$1;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

function transition_on(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get$1(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
}

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

function transition_select(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
}

function transition_selectAll(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
}

var Selection$1 = selection.prototype.constructor;

function transition_selection() {
  return new Selection$1(this._groups, this._parents);
}

function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function styleFunction$1(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = set$1(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = styleRemove$1(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, styleRemove$1(name))
    : typeof value === "function" ? this
      .styleTween(name, styleFunction$1(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, styleConstant$1(name, i, value), priority)
      .on("end.style." + name, null);
}

function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

function transition_text(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction$1(tweenValue(this, "text", value))
      : textConstant$1(value == null ? "" : value + ""));
}

function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
}

function transition_transition() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get$1(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
}

function transition_end() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = set$1(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });
  });
}

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return selection().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  end: transition_end
};

function linear$1(t) {
  return +t;
}

function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}

function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

function selection_transition(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
}

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

var root$1 = [null];

function active(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], root$1, name, +i);
      }
    }
  }

  return null;
}

function constant$4(x) {
  return function() {
    return x;
  };
}

function BrushEvent(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}

function nopropagation$1() {
  exports.event.stopImmediatePropagation();
}

function noevent$1() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
}

var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

function number1(e) {
  return [+e[0], +e[1]];
}

function number2(e) {
  return [number1(e[0]), number1(e[1])];
}

function toucher(identifier) {
  return function(target) {
    return touch(target, exports.event.touches, identifier);
  };
}

var X = {
  name: "x",
  handles: ["w", "e"].map(type),
  input: function(x, e) { return x == null ? null : [[+x[0], e[0][1]], [+x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y == null ? null : [[e[0][0], +y[0]], [e[1][0], +y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(type),
  input: function(xy) { return xy == null ? null : number2(xy); },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter$1() {
  return !exports.event.ctrlKey && !exports.event.button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  if (svg.hasAttribute("viewBox")) {
    svg = svg.viewBox.baseVal;
    return [[svg.x, svg.y], [svg.x + svg.width, svg.y + svg.height]];
  }
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

function defaultTouchable$1() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local$1(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty$1(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush$1(X);
}

function brushY() {
  return brush$1(Y);
}

function brush() {
  return brush$1(XY);
}

function brush$1(dim) {
  var extent = defaultExtent,
      filter = defaultFilter$1,
      touchable = defaultTouchable$1,
      keys = true,
      listeners = dispatch("start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local$1(this).extent;
          select(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .on("mousedown.brush", started)
      .filter(touchable)
        .on("touchstart.brush", started)
        .on("touchmove.brush", touchmoved)
        .on("touchend.brush touchcancel.brush", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = interpolateValue(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && selection1 === null ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 !== null && selection1 !== null ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            interrupt(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  brush.clear = function(group) {
    brush.move(group, null);
  };

  function redraw() {
    var group = select(this),
        selection = local$1(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args, clean) {
    return (!clean && that.__brush.emitter) || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      else this.emit("brush");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (touchending && !exports.event.touches) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = exports.event.target.__data__.type,
        mode = (keys && exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (keys && exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local$1(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx = 0,
        dy = 0,
        moving,
        shifting = signX && signY && keys && exports.event.shiftKey,
        lockX,
        lockY,
        pointer = exports.event.touches ? toucher(exports.event.changedTouches[0].identifier) : mouse,
        point0 = pointer(that),
        point = point0,
        emit = emitter(that, arguments, true).beforestart();

    if (type === "overlay") {
      if (selection) moving = true;
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = select(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (exports.event.touches) {
      emit.moved = moved;
      emit.ended = ended;
    } else {
      var view = select(exports.event.view)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);
      if (keys) view
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true);

      dragDisable(exports.event.view);
    }

    nopropagation$1();
    interrupt(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = pointer(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      noevent$1();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      nopropagation$1();
      if (exports.event.touches) {
        if (exports.event.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
      } else {
        yesdrag(exports.event.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty$1(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }

    function keyupped() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (exports.event.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }
  }

  function touchmoved() {
    emitter(this, arguments).moved();
  }

  function touchended() {
    emitter(this, arguments).ended();
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = number2(extent.apply(this, arguments));
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$4(number2(_)), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$4(!!_), brush) : filter;
  };

  brush.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$4(!!_), brush) : touchable;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.keyModifiers = function(_) {
    return arguments.length ? (keys = !!_, brush) : keys;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

var cos = Math.cos;
var sin = Math.sin;
var pi$1 = Math.PI;
var halfPi$1 = pi$1 / 2;
var tau$1 = pi$1 * 2;
var max$1 = Math.max;

function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

function chord() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = sequence(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(sequence(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = max$1(0, tau$1 - padAngle * n) / k;
    dx = k ? padAngle : tau$1 / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
}

var slice$2 = Array.prototype.slice;

function constant$5(x) {
  return function() {
    return x;
  };
}

var pi$2 = Math.PI,
    tau$2 = 2 * pi$2,
    epsilon$1 = 1e-6,
    tauEpsilon = tau$2 - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$2 + tau$2;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$2)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

function ribbon() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = slice$2.call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - halfPi$1,
        sa1 = endAngle.apply(this, argv) - halfPi$1,
        sx0 = sr * cos(sa0),
        sy0 = sr * sin(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - halfPi$1,
        ta1 = endAngle.apply(this, argv) - halfPi$1;

    if (!context) context = buffer = path();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$5(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
}

var prefix = "$";

function Map() {}

Map.prototype = map$1.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map$1(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

function nest() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = map$1(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
}

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return map$1();
}

function setMap(map, key, value) {
  map.set(key, value);
}

function Set() {}

var proto = map$1.prototype;

Set.prototype = set$2.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set$2(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

function keys(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}

function values(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}

function entries(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
}

var array$2 = Array.prototype;

var slice$3 = array$2.slice;

function ascending$2(a, b) {
  return a - b;
}

function area(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
}

function constant$6(x) {
  return function() {
    return x;
  };
}

function contains(ring, hole) {
  var i = -1, n = hole.length, c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
}

function ringContains(ring, point) {
  var x = point[0], y = point[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
  }
  return contains;
}

function segmentContains(a, b, c) {
  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}

function collinear(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}

function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}

function noop$1() {}

var cases = [
  [],
  [[[1.0, 1.5], [0.5, 1.0]]],
  [[[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [0.5, 1.0]]],
  [[[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 0.5], [1.0, 1.5]]],
  [[[1.0, 0.5], [0.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 0.5]]],
  [[[1.0, 1.5], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.5, 1.0]]],
  [[[1.0, 1.5], [1.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 1.5]]],
  []
];

function contours() {
  var dx = 1,
      dy = 1,
      threshold = thresholdSturges,
      smooth = smoothLinear;

  function contours(values) {
    var tz = threshold(values);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var domain = extent(values), start = domain[0], stop = domain[1];
      tz = tickStep(start, stop, tz);
      tz = sequence(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(ascending$2);
    }

    return tz.map(function(value) {
      return contour(values, value);
    });
  }

  // Accumulate, smooth contour rings, assign holes to exterior rings.
  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
  function contour(values, value) {
    var polygons = [],
        holes = [];

    isorings(values, value, function(ring) {
      smooth(ring, values, value);
      if (area(ring) > 0) polygons.push([ring]);
      else holes.push(ring);
    });

    holes.forEach(function(hole) {
      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
        if (contains((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });

    return {
      type: "MultiPolygon",
      value: value,
      coordinates: polygons
    };
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = new Array,
        fragmentByEnd = new Array,
        x, y, t0, t1, t2, t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);

    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
          end = [line[1][0] + x, line[1][1] + y],
          startIndex = index(start),
          endIndex = index(end),
          f, g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
      }
    }
  }

  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }

  function smoothLinear(ring, values, value) {
    ring.forEach(function(point) {
      var x = point[0],
          y = point[1],
          xt = x | 0,
          yt = y | 0,
          v0,
          v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }

  contours.contour = contour;

  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };

  contours.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$6(slice$3.call(_)) : constant$6(_), contours) : threshold;
  };

  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : noop$1, contours) : smooth === smoothLinear;
  };

  return contours;
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurX(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var j = 0; j < m; ++j) {
    for (var i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source.data[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source.data[i - w + j * n];
        }
        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurY(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var i = 0; i < n; ++i) {
    for (var j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source.data[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source.data[i + (j - w) * n];
        }
        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}

function defaultX(d) {
  return d[0];
}

function defaultY(d) {
  return d[1];
}

function defaultWeight() {
  return 1;
}

function density() {
  var x = defaultX,
      y = defaultY,
      weight = defaultWeight,
      dx = 960,
      dy = 500,
      r = 20, // blur radius
      k = 2, // log2(grid cell size)
      o = r * 3, // grid offset, to pad for blur
      n = (dx + o * 2) >> k, // grid width
      m = (dy + o * 2) >> k, // grid height
      threshold = constant$6(20);

  function density(data) {
    var values0 = new Float32Array(n * m),
        values1 = new Float32Array(n * m);

    data.forEach(function(d, i, data) {
      var xi = (+x(d, i, data) + o) >> k,
          yi = (+y(d, i, data) + o) >> k,
          wi = +weight(d, i, data);
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        values0[xi + yi * n] += wi;
      }
    });

    // TODO Optimize.
    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);

    var tz = threshold(values0);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var stop = max(values0);
      tz = tickStep(0, stop, tz);
      tz = sequence(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }

    return contours()
        .thresholds(tz)
        .size([n, m])
      (values0)
        .map(transform);
  }

  function transform(geometry) {
    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }

  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }

  function transformRing(coordinates) {
    coordinates.forEach(transformPoint);
  }

  // TODO Optimize.
  function transformPoint(coordinates) {
    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
  }

  function resize() {
    o = r * 3;
    n = (dx + o * 2) >> k;
    m = (dy + o * 2) >> k;
    return density;
  }

  density.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$6(+_), density) : x;
  };

  density.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$6(+_), density) : y;
  };

  density.weight = function(_) {
    return arguments.length ? (weight = typeof _ === "function" ? _ : constant$6(+_), density) : weight;
  };

  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };

  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k = Math.floor(Math.log(_) / Math.LN2), resize();
  };

  density.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$6(slice$3.call(_)) : constant$6(_), density) : threshold;
  };

  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
  };

  return density;
}

var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "] || \"\"";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

function pad(value, width) {
  var s = value + "", length = s.length;
  return length < width ? new Array(width - length + 1).join(0) + s : s;
}

function formatYear(year) {
  return year < 0 ? "-" + pad(-year, 6)
    : year > 9999 ? "+" + pad(year, 6)
    : pad(year, 4);
}

function formatDate(date) {
  var hours = date.getUTCHours(),
      minutes = date.getUTCMinutes(),
      seconds = date.getUTCSeconds(),
      milliseconds = date.getUTCMilliseconds();
  return isNaN(date) ? "Invalid Date"
      : formatYear(date.getUTCFullYear()) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2)
      + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z"
      : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z"
      : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z"
      : "");
}

function dsvFormat(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }

  function formatBody(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(value) {
    return value == null ? ""
        : value instanceof Date ? formatDate(value)
        : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\""
        : value;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatBody: formatBody,
    formatRows: formatRows,
    formatRow: formatRow,
    formatValue: formatValue
  };
}

var csv = dsvFormat(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatBody = csv.formatBody;
var csvFormatRows = csv.formatRows;
var csvFormatRow = csv.formatRow;
var csvFormatValue = csv.formatValue;

var tsv = dsvFormat("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatBody = tsv.formatBody;
var tsvFormatRows = tsv.formatRows;
var tsvFormatRow = tsv.formatRow;
var tsvFormatValue = tsv.formatValue;

function autoType(object) {
  for (var key in object) {
    var value = object[key].trim(), number, m;
    if (!value) value = null;
    else if (value === "true") value = true;
    else if (value === "false") value = false;
    else if (value === "NaN") value = NaN;
    else if (!isNaN(number = +value)) value = number;
    else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
      if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
      value = new Date(value);
    }
    else continue;
    object[key] = value;
  }
  return object;
}

// https://github.com/d3/d3-dsv/issues/45
var fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

function responseBlob(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.blob();
}

function blob(input, init) {
  return fetch(input, init).then(responseBlob);
}

function responseArrayBuffer(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.arrayBuffer();
}

function buffer(input, init) {
  return fetch(input, init).then(responseArrayBuffer);
}

function responseText(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.text();
}

function text(input, init) {
  return fetch(input, init).then(responseText);
}

function dsvParse(parse) {
  return function(input, init, row) {
    if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
    return text(input, init).then(function(response) {
      return parse(response, row);
    });
  };
}

function dsv(delimiter, input, init, row) {
  if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
  var format = dsvFormat(delimiter);
  return text(input, init).then(function(response) {
    return format.parse(response, row);
  });
}

var csv$1 = dsvParse(csvParse);
var tsv$1 = dsvParse(tsvParse);

function image(input, init) {
  return new Promise(function(resolve, reject) {
    var image = new Image;
    for (var key in init) image[key] = init[key];
    image.onerror = reject;
    image.onload = function() { resolve(image); };
    image.src = input;
  });
}

function responseJson(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.json();
}

function json(input, init) {
  return fetch(input, init).then(responseJson);
}

function parser(type) {
  return function(input, init)  {
    return text(input, init).then(function(text) {
      return (new DOMParser).parseFromString(text, type);
    });
  };
}

var xml = parser("application/xml");

var html = parser("text/html");

var svg = parser("image/svg+xml");

function center$1(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
}

function constant$7(x) {
  return function() {
    return x;
  };
}

function jiggle() {
  return (Math.random() - 0.5) * 1e-6;
}

function tree_add(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
}

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, abort.
  if (x0 > x1 || y0 > y1) return this;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

function tree_cover(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    while (x0 > x || x >= x1 || y0 > y || y >= y1) {
      i = (y < y0) << 1 | (x < x0);
      parent = new Array(4), parent[i] = node, node = parent, z *= 2;
      switch (i) {
        case 0: x1 = x0 + z, y1 = y0 + z; break;
        case 1: x0 = x1 - z, y1 = y0 + z; break;
        case 2: x1 = x0 + z, y0 = y1 - z; break;
        case 3: x0 = x1 - z, y0 = y1 - z; break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
}

function tree_data() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
}

function tree_extent(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
}

function Quad(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
}

function tree_find(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new Quad(node[3], xm, ym, x2, y2),
        new Quad(node[2], x1, ym, xm, y2),
        new Quad(node[1], xm, y1, x2, ym),
        new Quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
}

function tree_remove(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
}

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

function tree_root() {
  return this._root;
}

function tree_size() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
}

function tree_visit(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
    }
  }
  return this;
}

function tree_visitAfter(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
}

function defaultX$1(d) {
  return d[0];
}

function tree_x(_) {
  return arguments.length ? (this._x = _, this) : this._x;
}

function defaultY$1(d) {
  return d[1];
}

function tree_y(_) {
  return arguments.length ? (this._y = _, this) : this._y;
}

function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX$1 : x, y == null ? defaultY$1 : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;

function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

function collide(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = constant$7(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(), l += x * x;
            if (y === 0) y = jiggle(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : radius;
  };

  return force;
}

function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

function link(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = constant$7(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle();
        y = target.y + target.vy - source.y - source.vy || jiggle();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = map$1(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$7(+_), initializeDistance(), force) : distance;
  };

  return force;
}

function x$1(d) {
  return d.x;
}

function y$1(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

function simulation(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = map$1(),
      stepper = timer(step),
      event = dispatch("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick(iterations) {
    var i, n = nodes.length, node;

    if (iterations === undefined) iterations = 1;

    for (var k = 0; k < iterations; ++k) {
      alpha += (alphaTarget - alpha) * alphaDecay;

      forces.each(function (force) {
        force(alpha);
      });

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (node.fx == null) node.x += node.vx *= velocityDecay;
        else node.x = node.fx, node.vx = 0;
        if (node.fy == null) node.y += node.vy *= velocityDecay;
        else node.y = node.fy, node.vy = 0;
      }
    }

    return simulation;
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (node.fx != null) node.x = node.fx;
      if (node.fy != null) node.y = node.fy;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
}

function manyBody() {
  var nodes,
      node,
      alpha,
      strength = constant$7(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, x$1, y$1).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = jiggle(), l += x * x;
        if (y === 0) y = jiggle(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = jiggle(), l += x * x;
      if (y === 0) y = jiggle(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
}

function radial(radius, x, y) {
  var nodes,
      strength = constant$7(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = constant$7(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
}

function x$2(x) {
  var strength = constant$7(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = constant$7(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : x;
  };

  return force;
}

function y$2(y) {
  var strength = constant$7(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = constant$7(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : y;
  };

  return force;
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
function formatDecimal(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent$1(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?(\*(\d+(\.\d*)?))?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  this.fill = match[1] || " ";
  this.align = match[2] || ">";
  this.sign = match[3] || "-";
  this.symbol = match[4] || "";
  this.zero = !!match[5];
  this.width = match[6] && +match[6];
  this.comma = !!match[7];
  this.precision = match[8] && +match[8].slice(1);
  this.trim = !!match[9];
  this.type = match[10] || "";
  this.scale = parseFloat(match[12]) || 1;
}

FormatSpecifier.prototype.toString = function () {
  return this.fill
    + this.align
    + this.sign
    + this.symbol
    + (this.zero ? "0" : "")
    + (this.width == null ? "" : Math.max(1, this.width | 0))
    + (this.comma ? "," : "")
    + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
    + (this.trim ? "~" : "")
    + this.type
    + "*" + this.scale;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

function identity$3(x) {
  return x;
}

var prefixes = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

function formatLocale (locale) {
  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
    currency = locale.currency,
    decimal = locale.decimal,
    numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$3,
    percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
      align = specifier.align,
      sign = specifier.sign,
      symbol = specifier.symbol,
      zero = specifier.zero,
      width = specifier.width,
      comma = specifier.comma,
      precision = specifier.precision,
      trim = specifier.trim,
      type = specifier.type,
      scale = specifier.scale;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
      suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
      maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? 6
      : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
        valueSuffix = suffix,
        i, n, c;

      value *= scale;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
        padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function () {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
      e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
      k = Math.pow(10, -e),
      prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  exports.format = locale.format;
  exports.formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
}

// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

function adder() {
  return new Adder;
}

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add$1(temp, y, this.t);
    add$1(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add$1(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}

var epsilon$2 = 1e-6;
var epsilon2$1 = 1e-12;
var pi$3 = Math.PI;
var halfPi$2 = pi$3 / 2;
var quarterPi = pi$3 / 4;
var tau$3 = pi$3 * 2;

var degrees$1 = 180 / pi$3;
var radians = pi$3 / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos$1 = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var log = Math.log;
var pow = Math.pow;
var sin$1 = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi$3 : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi$2 : x < -1 ? -halfPi$2 : Math.asin(x);
}

function haversin(x) {
  return (x = sin$1(x / 2)) * x;
}

function noop$2() {}

function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

function geoStream(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
}

var areaRingSum = adder();

var areaSum = adder(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: noop$2,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? tau$3 + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$2;
  },
  sphere: function() {
    areaSum.add(tau$3);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
}

function areaPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = cos$1(phi),
      sinPhi = sin$1(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
      v = k * sdLambda * sin$1(adLambda);
  areaRingSum.add(atan2(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

function area$1(object) {
  areaSum.reset();
  geoStream(object, areaStream);
  return areaSum * 2;
}

function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

var lambda0$1, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00$1, phi00$1, // first point
    p0, // previous 3D point
    deltaSum = adder(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    areaStream.polygonStart();
  },
  polygonEnd: function() {
    areaStream.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon$2) phi1 = 90;
    else if (deltaSum < -epsilon$2) phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  },
  sphere: function() {
    lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * degrees$1 * sign,
        phii,
        antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * degrees$1;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * degrees$1;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda < lambda0$1) lambda0$1 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi;
  }
  areaStream.point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  areaStream.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream.lineEnd();
  if (abs(deltaSum) > epsilon$2) lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

function bounds(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0$1 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0$1, phi0], [lambda1, phi1]];
}

var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00$2, phi00$2, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: noop$2,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00$2, phi00$2);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00$2 = lambda, phi00$2 = phi;
  lambda *= radians, phi *= radians;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = sqrt(cx * cx + cy * cy + cz * cz),
      w = asin(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroid(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  geoStream(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < epsilon2$1) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < epsilon$2) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < epsilon2$1) return [NaN, NaN];
  }

  return [atan2(y, x) * degrees$1, asin(z / sqrt(m)) * degrees$1];
}

function constant$8(x) {
  return function() {
    return x;
  };
}

function compose(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
}

function rotationIdentity(lambda, phi) {
  return [abs(lambda) > pi$3 ? lambda + Math.round(-lambda / tau$3) * tau$3 : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau$3) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos$1(deltaPhi),
      sinDeltaPhi = sin$1(deltaPhi),
      cosDeltaGamma = cos$1(deltaGamma),
      sinDeltaGamma = sin$1(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      asin(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      asin(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

function rotation(rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  };

  return forward;
}

// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos$1(radius),
      sinRadius = sin$1(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau$3;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$3;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau$3 - epsilon$2) % tau$3;
}

function circle() {
  var center = constant$8([0, 0]),
      radius = constant$8(90),
      precision = constant$8(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= degrees$1, x[1] *= degrees$1;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * radians,
        p = precision.apply(this, arguments) * radians;
    ring = [];
    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : constant$8([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$8(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$8(+_), circle) : precision;
  };

  return circle;
}

function clipBuffer() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$2,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}

function pointEqual(a, b) {
  return abs(a[0] - b[0]) < epsilon$2 && abs(a[1] - b[1]) < epsilon$2;
}

function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
function clipRejoin(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (pointEqual(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link$1(subject);
  link$1(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}

function link$1(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

var sum$1 = adder();

function longitude(point) {
  if (abs(point[0]) <= pi$3)
    return point[0];
  else
    return sign(point[0]) * ((abs(point[0]) + pi$3) % tau$3 - pi$3);
}

function polygonContains(polygon, point) {
  var lambda = longitude(point),
      phi = point[1],
      sinPhi = sin$1(phi),
      normal = [sin$1(lambda), -cos$1(lambda), 0],
      angle = 0,
      winding = 0;

  sum$1.reset();

  if (sinPhi === 1) phi = halfPi$2 + epsilon$2;
  else if (sinPhi === -1) phi = -halfPi$2 - epsilon$2;

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = longitude(point0),
        phi0 = point0[1] / 2 + quarterPi,
        sinPhi0 = sin$1(phi0),
        cosPhi0 = cos$1(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = longitude(point1),
          phi1 = point1[1] / 2 + quarterPi,
          sinPhi1 = sin$1(phi1),
          cosPhi1 = cos$1(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > pi$3,
          k = sinPhi0 * sinPhi1;

      sum$1.add(atan2(k * sign * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
      angle += antimeridian ? delta + sign * tau$3 : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -epsilon$2 || angle < epsilon$2 && sum$1 < -epsilon$2) ^ (winding & 1);
}

function clip(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = clipBuffer(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
}

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi$2 - epsilon$2 : halfPi$2 - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - halfPi$2 - epsilon$2 : halfPi$2 - b[1]);
}

var clipAntimeridian = clip(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi$3, -halfPi$2]
);

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi$3 : -pi$3,
          delta = abs(lambda1 - lambda0);
      if (abs(delta - pi$3) < epsilon$2) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$2 : -halfPi$2);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi$3) { // line crosses antimeridian
        if (abs(lambda0 - sign0) < epsilon$2) lambda0 -= sign0 * epsilon$2; // handle degeneracies
        if (abs(lambda1 - sign1) < epsilon$2) lambda1 -= sign1 * epsilon$2;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon$2
      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi$2;
    stream.point(-pi$3, phi);
    stream.point(0, phi);
    stream.point(pi$3, phi);
    stream.point(pi$3, 0);
    stream.point(pi$3, -phi);
    stream.point(0, -phi);
    stream.point(-pi$3, -phi);
    stream.point(-pi$3, 0);
    stream.point(-pi$3, phi);
  } else if (abs(from[0] - to[0]) > epsilon$2) {
    var lambda = from[0] < to[0] ? pi$3 : -pi$3;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

function clipCircle(radius) {
  var cr = cos$1(radius),
      delta = 6 * radians,
      smallRadius = cr > 0,
      notHemisphere = abs(cr) > epsilon$2; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return cos$1(lambda) * cos$1(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? pi$3 : -pi$3), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
            point1[0] += epsilon$2;
            point1[1] += epsilon$2;
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = cartesian(a),
        pb = cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = cartesianCross(pa, pb),
        n2n2 = cartesianDot(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = cartesianCross(n1, n2),
        A = cartesianScale(n1, c1),
        B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = cartesianDot(A, u),
        uu = cartesianDot(u, u),
        t2 = w * w - uu * (cartesianDot(A, A) - 1);

    if (t2 < 0) return;

    var t = sqrt(t2),
        q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = spherical(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = abs(delta - pi$3) < epsilon$2,
        meridian = polar || delta < epsilon$2;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$2 ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > pi$3 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi$3 - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$3, radius - pi$3]);
}

function clipLine(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
}

var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return abs(p[0] - x0) < epsilon$2 ? direction > 0 ? 0 : 3
        : abs(p[0] - x1) < epsilon$2 ? direction > 0 ? 2 : 1
        : abs(p[1] - y0) < epsilon$2 ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = clipBuffer(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = merge(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

function extent$1() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
}

var lengthSum = adder(),
    lambda0$2,
    sinPhi0$1,
    cosPhi0$1;

var lengthStream = {
  sphere: noop$2,
  point: noop$2,
  lineStart: lengthLineStart,
  lineEnd: noop$2,
  polygonStart: noop$2,
  polygonEnd: noop$2
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop$2;
}

function lengthPointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin$1(phi),
      cosPhi = cos$1(phi),
      delta = abs(lambda - lambda0$2),
      cosDelta = cos$1(delta),
      sinDelta = sin$1(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x * x + y * y), z));
  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
}

function length$1(object) {
  lengthSum.reset();
  geoStream(object, lengthStream);
  return +lengthSum;
}

var coordinates = [null, null],
    object$1 = {type: "LineString", coordinates: coordinates};

function distance(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length$1(object$1);
}

var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ao, bo, ab;
  for (var i = 0, n = coordinates.length; i < n; i++) {
    bo = distance(coordinates[i], point);
    if (bo === 0) return true;
    if (i > 0) {
      ab = distance(coordinates[i], coordinates[i - 1]);
      if (
        ab > 0 &&
        ao <= ab &&
        bo <= ab &&
        (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2$1 * ab
      )
        return true;
    }
    ao = bo;
  }
  return false;
}

function containsPolygon(coordinates, point) {
  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * radians, point[1] * radians];
}

function contains$1(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
}

function graticuleX(y0, y1, dy) {
  var y = sequence(y0, y1 - epsilon$2, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = sequence(x0, x1 - epsilon$2, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return sequence(ceil(X0 / DX) * DX, X1, DX).map(X)
        .concat(sequence(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(sequence(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$2; }).map(x))
        .concat(sequence(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$2; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]])
      .extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
}

function graticule10() {
  return graticule()();
}

function interpolate$1(a, b) {
  var x0 = a[0] * radians,
      y0 = a[1] * radians,
      x1 = b[0] * radians,
      y1 = b[1] * radians,
      cy0 = cos$1(y0),
      sy0 = sin$1(y0),
      cy1 = cos$1(y1),
      sy1 = sin$1(y1),
      kx0 = cy0 * cos$1(x0),
      ky0 = cy0 * sin$1(x0),
      kx1 = cy1 * cos$1(x1),
      ky1 = cy1 * sin$1(x1),
      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
      k = sin$1(d);

  var interpolate = d ? function(t) {
    var B = sin$1(t *= d) / k,
        A = sin$1(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      atan2(y, x) * degrees$1,
      atan2(z, sqrt(x * x + y * y)) * degrees$1
    ];
  } : function() {
    return [x0 * degrees$1, y0 * degrees$1];
  };

  interpolate.distance = d;

  return interpolate;
}

function identity$4(x) {
  return x;
}

var areaSum$1 = adder(),
    areaRingSum$1 = adder(),
    x00,
    y00,
    x0$1,
    y0$1;

var areaStream$1 = {
  point: noop$2,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: function() {
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$2;
    areaSum$1.add(abs(areaRingSum$1));
    areaRingSum$1.reset();
  },
  result: function() {
    var area = areaSum$1 / 2;
    areaSum$1.reset();
    return area;
  }
};

function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}

function areaPointFirst$1(x, y) {
  areaStream$1.point = areaPoint$1;
  x00 = x0$1 = x, y00 = y0$1 = y;
}

function areaPoint$1(x, y) {
  areaRingSum$1.add(y0$1 * x - x0$1 * y);
  x0$1 = x, y0$1 = y;
}

function areaRingEnd$1() {
  areaPoint$1(x00, y00);
}

var x0$2 = Infinity,
    y0$2 = x0$2,
    x1 = -x0$2,
    y1 = x1;

var boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: noop$2,
  polygonEnd: noop$2,
  result: function() {
    var bounds = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds;
  }
};

function boundsPoint$1(x, y) {
  if (x < x0$2) x0$2 = x;
  if (x > x1) x1 = x;
  if (y < y0$2) y0$2 = y;
  if (y > y1) y1 = y;
}

// TODO Enforce positive area for exterior, negative area for interior?

var X0$1 = 0,
    Y0$1 = 0,
    Z0$1 = 0,
    X1$1 = 0,
    Y1$1 = 0,
    Z1$1 = 0,
    X2$1 = 0,
    Y2$1 = 0,
    Z2$1 = 0,
    x00$1,
    y00$1,
    x0$3,
    y0$3;

var centroidStream$1 = {
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.point = centroidPoint$1;
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  },
  result: function() {
    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
        : [NaN, NaN];
    X0$1 = Y0$1 = Z0$1 =
    X1$1 = Y1$1 = Z1$1 =
    X2$1 = Y2$1 = Z2$1 = 0;
    return centroid;
  }
};

function centroidPoint$1(x, y) {
  X0$1 += x;
  Y0$1 += y;
  ++Z0$1;
}

function centroidLineStart$1() {
  centroidStream$1.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream$1.point = centroidPointLine;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}

function centroidRingStart$1() {
  centroidStream$1.point = centroidPointFirstRing;
}

function centroidRingEnd$1() {
  centroidPointRing(x00$1, y00$1);
}

function centroidPointFirstRing(x, y) {
  centroidStream$1.point = centroidPointRing;
  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0$3,
      dy = y - y0$3,
      z = sqrt(dx * dx + dy * dy);

  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;

  z = y0$3 * x - x0$3 * y;
  X2$1 += z * (x0$3 + x);
  Y2$1 += z * (y0$3 + y);
  Z2$1 += z * 3;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau$3);
        break;
      }
    }
  },
  result: noop$2
};

var lengthSum$1 = adder(),
    lengthRing,
    x00$2,
    y00$2,
    x0$4,
    y0$4;

var lengthStream$1 = {
  point: noop$2,
  lineStart: function() {
    lengthStream$1.point = lengthPointFirst$1;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint$1(x00$2, y00$2);
    lengthStream$1.point = noop$2;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum$1;
    lengthSum$1.reset();
    return length;
  }
};

function lengthPointFirst$1(x, y) {
  lengthStream$1.point = lengthPoint$1;
  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
}

function lengthPoint$1(x, y) {
  x0$4 -= x, y0$4 -= y;
  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
  x0$4 = x, y0$4 = y;
}

function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle$1(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle$1(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle$1(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

function index$1(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    geoStream(object, projectionStream(areaStream$1));
    return areaStream$1.result();
  };

  path.measure = function(object) {
    geoStream(object, projectionStream(lengthStream$1));
    return lengthStream$1.result();
  };

  path.bounds = function(object) {
    geoStream(object, projectionStream(boundsStream$1));
    return boundsStream$1.result();
  };

  path.centroid = function(object) {
    geoStream(object, projectionStream(centroidStream$1));
    return centroidStream$1.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$4) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
}

function transform(methods) {
  return {
    stream: transformer(methods)
  };
}

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};

function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  geoStream(object, projection.stream(boundsStream$1));
  fitBounds(boundsStream$1.result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)

function resample(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
}

function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample$1(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = sqrt(a * a + b * b + c * c),
          phi2 = asin(c /= m),
          lambda2 = abs(abs(c) - 1) < epsilon$2 || abs(lambda0 - lambda1) < epsilon$2 ? (lambda0 + lambda1) / 2 : atan2(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});

function transformRotate(rotate) {
  return transformer({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function scaleTranslate(k, dx, dy) {
  function transform(x, y) {
    return [dx + k * x, dy - k * y];
  }
  transform.invert = function(x, y) {
    return [(x - dx) / k, (dy - y) / k];
  };
  return transform;
}

function scaleTranslateRotate(k, dx, dy, alpha) {
  var cosAlpha = cos$1(alpha),
      sinAlpha = sin$1(alpha),
      a = cosAlpha * k,
      b = sinAlpha * k,
      ai = cosAlpha / k,
      bi = sinAlpha / k,
      ci = (sinAlpha * dy - cosAlpha * dx) / k,
      fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform(x, y) {
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform.invert = function(x, y) {
    return [ai * x - bi * y + ci, fi - bi * x - ai * y];
  };
  return transform;
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, // pre-rotate
      alpha = 0, // post-rotate
      theta = null, preclip = clipAntimeridian, // pre-clip angle
      x0 = null, y0, x1, y1, postclip = identity$4, // post-clip extent
      delta2 = 0.5, // precision
      projectResample,
      projectTransform,
      projectRotateTransform,
      cache,
      cacheStream;

  function projection(point) {
    return projectRotateTransform(point[0] * radians, point[1] * radians);
  }

  function invert(point) {
    point = projectRotateTransform.invert(point[0], point[1]);
    return point && [point[0] * degrees$1, point[1] * degrees$1];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
  };

  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees$1;
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return fitExtent(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return fitSize(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return fitWidth(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return fitHeight(projection, height, object);
  };

  function recenter() {
    var center = scaleTranslateRotate(k, 0, 0, alpha).apply(null, project(lambda, phi)),
        transform = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], alpha);
    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose(project, transform);
    projectRotateTransform = compose(rotate, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = pi$3 / 3,
      m = projectionMutator(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
  };

  return p;
}

function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos$1(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}

function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (abs(n) < epsilon$2) return cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;

  function project(x, y) {
    var r = sqrt(c - 2 * n * sin$1(y)) / n;
    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

function conicEqualArea() {
  return conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
}

function albers() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
}

// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
function albersUsa() {
  var cache,
      cacheStream,
      lower48 = albers(), lower48Point,
      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + epsilon$2, y + 0.120 * k + epsilon$2], [x - 0.214 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + epsilon$2, y + 0.166 * k + epsilon$2], [x - 0.115 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return fitExtent(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return fitSize(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return fitWidth(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return fitHeight(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
}

function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos$1(x),
        cy = cos$1(y),
        k = scale(cx * cy);
    return [
      k * cy * sin$1(x),
      k * sin$1(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = sqrt(x * x + y * y),
        c = angle(z),
        sc = sin$1(c),
        cc = cos$1(c);
    return [
      atan2(x * sc, z * cc),
      asin(z && y * sc / z)
    ];
  }
}

var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});

function azimuthalEqualArea() {
  return projection(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
}

var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin$1(c);
});

azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});

function azimuthalEquidistant() {
  return projection(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
}

function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi$2 + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi$2];
};

function mercator() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / tau$3);
}

function mercatorProjection(project) {
  var m = projection(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = pi$3 * scale(),
        t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

function tany(y) {
  return tan((halfPi$2 + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : log(cy0 / cos$1(y1)) / log(tany(y1) / tany(y0)),
      f = cy0 * pow(tany(y0), n) / n;

  if (!n) return mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -halfPi$2 + epsilon$2) y = -halfPi$2 + epsilon$2; }
    else { if (y > halfPi$2 - epsilon$2) y = halfPi$2 - epsilon$2; }
    var r = f / pow(tany(y), n);
    return [r * sin$1(n * x), f - r * cos$1(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi$2];
  };

  return project;
}

function conicConformal() {
  return conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
}

function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

function equirectangular() {
  return projection(equirectangularRaw)
      .scale(152.63);
}

function conicEquidistantRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (abs(n) < epsilon$2) return equirectangularRaw;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin$1(nx), g - gy * cos$1(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
  };

  return project;
}

function conicEquidistant() {
  return conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
}

var A1 = 1.340264,
    A2 = -0.081106,
    A3 = 0.000893,
    A4 = 0.003796,
    M = sqrt(3) / 2,
    iterations = 12;

function equalEarthRaw(lambda, phi) {
  var l = asin(M * sin$1(phi)), l2 = l * l, l6 = l2 * l2 * l2;
  return [
    lambda * cos$1(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
    l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
  ];
}

equalEarthRaw.invert = function(x, y) {
  var l = y, l2 = l * l, l6 = l2 * l2 * l2;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if (abs(delta) < epsilon2$1) break;
  }
  return [
    M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos$1(l),
    asin(sin$1(l) / M)
  ];
};

function equalEarth() {
  return projection(equalEarthRaw)
      .scale(177.158);
}

function gnomonicRaw(x, y) {
  var cy = cos$1(y), k = cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

gnomonicRaw.invert = azimuthalInvert(atan);

function gnomonic() {
  return projection(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
}

function scaleTranslate$1(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$4 : transformer({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

function identity$5() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity$4, // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = identity$4,
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate$1((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate$1(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate$1(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate$1(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return fitExtent(projection, extent, object);
    },
    fitSize: function(size, object) {
      return fitSize(projection, size, object);
    },
    fitWidth: function(width, object) {
      return fitWidth(projection, width, object);
    },
    fitHeight: function(height, object) {
      return fitHeight(projection, height, object);
    }
  };
}

function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (abs(delta) > epsilon$2 && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

function naturalEarth1() {
  return projection(naturalEarth1Raw)
      .scale(175.295);
}

function orthographicRaw(x, y) {
  return [cos$1(y) * sin$1(x), sin$1(y)];
}

orthographicRaw.invert = azimuthalInvert(asin);

function orthographic() {
  return projection(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + epsilon$2);
}

function stereographicRaw(x, y) {
  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});

function stereographic() {
  return projection(stereographicRaw)
      .scale(250)
      .clipAngle(142);
}

function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi$2 + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi$2];
};

function transverseMercator() {
  var m = mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
}

function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

function cluster() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
}

function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

function node_count() {
  return this.eachAfter(count);
}

function node_each(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
}

function node_eachBefore(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
}

function node_eachAfter(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
}

function node_sum(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
}

function node_sort(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}

function node_path(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
}

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

function node_ancestors() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}

function node_descendants() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
}

function node_leaves() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}

function node_links() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
}

function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy
};

var slice$4 = Array.prototype.slice;

function shuffle$1(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

function enclose(circles) {
  var i = 0, n = (circles = shuffle$1(slice$4.call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
}

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

function place(b, a, c) {
  var dx = b.x - a.x, x, a2,
      dy = b.y - a.y, y, b2,
      d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node$1(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node$1(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

function siblings(circles) {
  packEnclose(circles);
  return circles;
}

function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

function constantZero() {
  return 0;
}

function constant$9(x) {
  return function() {
    return x;
  };
}

function defaultRadius$1(d) {
  return Math.sqrt(d.value);
}

function index$2() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius$1))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant$9(+x), pack) : padding;
  };

  return pack;
}

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

function roundNode(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}

function treemapDice(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
}

function partition() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
}

var keyPrefix$1 = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

function stratify() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix$1 + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix$1 + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
}

function defaultSeparation$1(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
function tree() {
  var separation = defaultSeparation$1,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
}

function treemapSlice(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
}

var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

var squarify = (function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi);

function index$3() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$9(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$9(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$9(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$9(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$9(+x), treemap) : paddingLeft;
  };

  return treemap;
}

function binary(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
}

function sliceDice(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
}

var resquarify = (function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(phi);

function area$2(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
}

function centroid$1(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
}

// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function cross$1(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}

function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

function hull(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
}

function contains$2(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
}

function length$2(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
}

function defaultSource$1() {
  return Math.random();
}

var uniform = (function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(defaultSource$1);

var normal = (function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(defaultSource$1);

var logNormal = (function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = normal.source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(defaultSource$1);

var irwinHall = (function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(defaultSource$1);

var bates = (function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(defaultSource$1);

var exponential$1 = (function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(defaultSource$1);

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.interpolator(domain); break;
    default: this.interpolator(interpolator).domain(domain); break;
  }
  return this;
}

var array$3 = Array.prototype;

var map$2 = array$3.map;
var slice$5 = array$3.slice;

var implicit = {name: "implicit"};

function ordinal() {
  var index = map$1(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = map$1();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$1() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

function constant$a(x) {
  return function() {
    return x;
  };
}

function number$2(x) {
  return +x;
}

var unit = [0, 1];

function identity$6(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant$a(isNaN(b) ? NaN : 0.5);
}

function clamper(domain) {
  var a = domain[0], b = domain[domain.length - 1], t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer$1() {
  var domain = unit,
      range = unit,
      interpolate = interpolateValue,
      transform,
      untransform,
      unknown,
      clamp = identity$6,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = map$2.call(_, number$2), clamp === identity$6 || (clamp = clamper(domain)), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = slice$5.call(_), interpolate = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? clamper(domain) : identity$6, scale) : clamp !== identity$6;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous(transform, untransform) {
  return transformer$1()(transform, untransform);
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return exports.formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return exports.format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear$2() {
  var scale = continuous(identity$6, identity$6);

  scale.copy = function() {
    return copy(scale, linear$2());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function identity$7(domain) {
  var unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = map$2.call(_, number$2), scale) : domain.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return identity$7(domain).unknown(unknown);
  };

  domain = arguments.length ? map$2.call(domain, number$2) : [0, 1];

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = exports.format(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  return scale;
}

function log$1() {
  var scale = loggish(transformer$1()).domain([1, 10]);

  scale.copy = function() {
    return copy(scale, log$1()).base(scale.base());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function transformSymlog(c) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return linearish(scale);
}

function symlog() {
  var scale = symlogish(transformer$1());

  scale.copy = function() {
    return copy(scale, symlog()).constant(scale.constant());
  };

  return initRange.apply(scale, arguments);
}

function transformPow(exponent) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(identity$6, identity$6),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(identity$6, identity$6)
        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
        : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return linearish(scale);
}

function pow$1() {
  var scale = powish(transformer$1());

  scale.copy = function() {
    return copy(scale, pow$1()).exponent(scale.exponent());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function sqrt$1() {
  return pow$1.apply(null, arguments).exponent(0.5);
}

function quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : range[bisectRight(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), rescale()) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

function quantize$1() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x <= x ? range[bisectRight(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = slice$5.call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function() {
    return domain.slice();
  };

  scale.copy = function() {
    return quantize$1()
        .domain([x0, x1])
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(linearish(scale), arguments);
}

function threshold$1() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x <= x ? range[bisectRight(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = slice$5.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold$1()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

var t0$1 = new Date,
    t1$1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};
var milliseconds = millisecond.range;

var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});
var seconds = second.range;

var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});
var minutes = minute.range;

var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});
var hours = hour.range;

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
}, function(date) {
  return date.getDate() - 1;
});
var days = day.range;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});
var months = month.range;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};
var years = year.range;

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});
var utcMinutes = utcMinute.range;

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});
var utcHours = utcHour.range;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});
var utcDays = utcDay.range;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});
var utcMonths = utcMonth.range;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};
var utcYears = utcYear.range;

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear$1,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day$1;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day$1 = week.getUTCDay();
          week = day$1 > 4 || day$1 === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day$1 = week.getDay();
          week = day$1 > 4 || day$1 === 0 ? monday.ceil(week) : monday(week);
          week = day.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day$1 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad$1(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad$1(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad$1(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad$1(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad$1(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad$1(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad$1(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad$1(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad$1(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad$1(sunday.count(year(d) - 1, d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad$1(thursday.count(year(d), d) + (year(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad$1(monday.count(year(d) - 1, d), p, 2);
}

function formatYear$1(d, p) {
  return pad$1(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad$1(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad$1(z / 60 | 0, "0", 2)
      + pad$1(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad$1(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad$1(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad$1(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad$1(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad$1(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad$1(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad$1(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad$1(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad$1(utcSunday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad$1(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad$1(utcMonday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad$1(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad$1(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale$1;

defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  exports.timeFormat = locale$1.format;
  exports.timeParse = locale$1.parse;
  exports.utcFormat = locale$1.utcFormat;
  exports.utcParse = locale$1.utcParse;
  return locale$1;
}

var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : exports.utcFormat(isoSpecifier);

function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : exports.utcParse(isoSpecifier);

var durationSecond$1 = 1000,
    durationMinute$1 = durationSecond$1 * 60,
    durationHour$1 = durationMinute$1 * 60,
    durationDay$1 = durationHour$1 * 24,
    durationWeek$1 = durationDay$1 * 7,
    durationMonth = durationDay$1 * 30,
    durationYear = durationDay$1 * 365;

function date$1(t) {
  return new Date(t);
}

function number$3(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = continuous(identity$6, identity$6),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond$1],
    [second,  5,  5 * durationSecond$1],
    [second, 15, 15 * durationSecond$1],
    [second, 30, 30 * durationSecond$1],
    [minute,  1,      durationMinute$1],
    [minute,  5,  5 * durationMinute$1],
    [minute, 15, 15 * durationMinute$1],
    [minute, 30, 30 * durationMinute$1],
    [  hour,  1,      durationHour$1  ],
    [  hour,  3,  3 * durationHour$1  ],
    [  hour,  6,  6 * durationHour$1  ],
    [  hour, 12, 12 * durationHour$1  ],
    [   day,  1,      durationDay$1   ],
    [   day,  2,  2 * durationDay$1   ],
    [  week,  1,      durationWeek$1  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(tickStep(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(map$2.call(_, number$3)) : domain().map(date$1);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

function time() {
  return initRange.apply(calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

function utcTime() {
  return initRange.apply(calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
}

function transformer$2() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = identity$6,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function copy$1(source, target) {
  return target
      .domain(source.domain())
      .interpolator(source.interpolator())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function sequential() {
  var scale = linearish(transformer$2()(identity$6));

  scale.copy = function() {
    return copy$1(scale, sequential());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialLog() {
  var scale = loggish(transformer$2()).domain([1, 10]);

  scale.copy = function() {
    return copy$1(scale, sequentialLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = symlogish(transformer$2());

  scale.copy = function() {
    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialPow() {
  var scale = powish(transformer$2());

  scale.copy = function() {
    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

function sequentialQuantile() {
  var domain = [],
      interpolator = identity$6;

  function scale(x) {
    if (!isNaN(x = +x)) return interpolator((bisectRight(domain, x) - 1) / (domain.length - 1));
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return scale;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return initInterpolator.apply(scale, arguments);
}

function transformer$3() {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      t0,
      t1,
      t2,
      k10,
      k21,
      interpolator = identity$6,
      transform,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
    return scale;
  };
}

function diverging() {
  var scale = linearish(transformer$3()(identity$6));

  scale.copy = function() {
    return copy$1(scale, diverging());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingLog() {
  var scale = loggish(transformer$3()).domain([0.1, 1, 10]);

  scale.copy = function() {
    return copy$1(scale, divergingLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSymlog() {
  var scale = symlogish(transformer$3());

  scale.copy = function() {
    return copy$1(scale, divergingSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingPow() {
  var scale = powish(transformer$3());

  scale.copy = function() {
    return copy$1(scale, divergingPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

function colors(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}

var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

var Tableau10 = colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

function ramp(scheme) {
  return rgbBasis(scheme[scheme.length - 1]);
}

var scheme = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(colors);

var BrBG = ramp(scheme);

var scheme$1 = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(colors);

var PRGn = ramp(scheme$1);

var scheme$2 = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(colors);

var PiYG = ramp(scheme$2);

var scheme$3 = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(colors);

var PuOr = ramp(scheme$3);

var scheme$4 = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(colors);

var RdBu = ramp(scheme$4);

var scheme$5 = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(colors);

var RdGy = ramp(scheme$5);

var scheme$6 = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(colors);

var RdYlBu = ramp(scheme$6);

var scheme$7 = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(colors);

var RdYlGn = ramp(scheme$7);

var scheme$8 = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(colors);

var Spectral = ramp(scheme$8);

var scheme$9 = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(colors);

var BuGn = ramp(scheme$9);

var scheme$a = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(colors);

var BuPu = ramp(scheme$a);

var scheme$b = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(colors);

var GnBu = ramp(scheme$b);

var scheme$c = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(colors);

var OrRd = ramp(scheme$c);

var scheme$d = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(colors);

var PuBuGn = ramp(scheme$d);

var scheme$e = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(colors);

var PuBu = ramp(scheme$e);

var scheme$f = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(colors);

var PuRd = ramp(scheme$f);

var scheme$g = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(colors);

var RdPu = ramp(scheme$g);

var scheme$h = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(colors);

var YlGnBu = ramp(scheme$h);

var scheme$i = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(colors);

var YlGn = ramp(scheme$i);

var scheme$j = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(colors);

var YlOrBr = ramp(scheme$j);

var scheme$k = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(colors);

var YlOrRd = ramp(scheme$k);

var scheme$l = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(colors);

var Blues = ramp(scheme$l);

var scheme$m = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(colors);

var Greens = ramp(scheme$m);

var scheme$n = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(colors);

var Greys = ramp(scheme$n);

var scheme$o = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(colors);

var Purples = ramp(scheme$o);

var scheme$p = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(colors);

var Reds = ramp(scheme$p);

var scheme$q = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(colors);

var Oranges = ramp(scheme$q);

function cividis(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb("
      + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67)))))))
      + ")";
}

var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var c = cubehelix();

function rainbow(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c.h = 360 * t - 100;
  c.s = 1.5 - 1.5 * ts;
  c.l = 0.8 - 0.9 * ts;
  return c + "";
}

var c$1 = rgb(),
    pi_1_3 = Math.PI / 3,
    pi_2_3 = Math.PI * 2 / 3;

function sinebow(t) {
  var x;
  t = (0.5 - t) * Math.PI;
  c$1.r = 255 * (x = Math.sin(t)) * x;
  c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
  c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
  return c$1 + "";
}

function turbo(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb("
      + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66)))))))
      + ")";
}

function ramp$1(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var viridis = ramp$1(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));

var magma = ramp$1(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp$1(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp$1(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function constant$b(x) {
  return function constant() {
    return x;
  };
}

var abs$1 = Math.abs;
var atan2$1 = Math.atan2;
var cos$2 = Math.cos;
var max$2 = Math.max;
var min$1 = Math.min;
var sin$2 = Math.sin;
var sqrt$2 = Math.sqrt;

var epsilon$3 = 1e-12;
var pi$4 = Math.PI;
var halfPi$3 = pi$4 / 2;
var tau$4 = 2 * pi$4;

function acos$1(x) {
  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
}

function asin$1(x) {
  return x >= 1 ? halfPi$3 : x <= -1 ? -halfPi$3 : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon$3) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt$2(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt$2(max$2(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$b(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi$3,
        a1 = endAngle.apply(this, arguments) - halfPi$3,
        da = abs$1(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$3)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$4 - epsilon$3) {
      context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$3) {
        context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon$3) && (padRadius ? +padRadius.apply(this, arguments) : sqrt$2(r0 * r0 + r1 * r1)),
          rc = min$1(abs$1(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$3) {
        var p0 = asin$1(rp / r0 * sin$2(ap)),
            p1 = asin$1(rp / r1 * sin$2(ap));
        if ((da0 -= p0 * 2) > epsilon$3) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$3) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos$2(a01),
          y01 = r1 * sin$2(a01),
          x10 = r0 * cos$2(a10),
          y10 = r0 * sin$2(a10);

      // Apply rounded corners?
      if (rc > epsilon$3) {
        var x11 = r1 * cos$2(a11),
            y11 = r1 * sin$2(a11),
            x00 = r0 * cos$2(a00),
            y00 = r0 * sin$2(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi$4 && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$2(ax * ax + ay * ay) * sqrt$2(bx * bx + by * by))) / 2),
              lc = sqrt$2(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min$1(rc, (r0 - lc) / (kc - 1));
          rc1 = min$1(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$3)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$3) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$3) || !(da0 > epsilon$3)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$3) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$4 / 2;
    return [cos$2(a) * r, sin$2(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$b(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$b(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$b(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$b(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$b(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$b(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$b(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x$3(p) {
  return p[0];
}

function y$3(p) {
  return p[1];
}

function line() {
  var x = x$3,
      y = y$3,
      defined = constant$b(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$b(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$b(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$b(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function area$3() {
  var x0 = x$3,
      x1 = null,
      y0 = constant$b(0),
      y1 = y$3,
      defined = constant$b(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$b(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$b(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$b(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$b(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$b(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$b(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$b(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

function descending$1(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function identity$8(d) {
  return d;
}

function pie() {
  var value = identity$8,
      sortValues = descending$1,
      sort = null,
      startAngle = constant$b(0),
      endAngle = constant$b(tau$4),
      padAngle = constant$b(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau$4, Math.max(-tau$4, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$b(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$b(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$b(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$b(+_), pie) : padAngle;
  };

  return pie;
}

var curveRadialLinear = curveRadial(curveLinear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

function lineRadial$1() {
  return lineRadial(line().curve(curveRadialLinear));
}

function areaRadial() {
  var a = area$3().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
}

function pointRadial(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}

var slice$6 = Array.prototype.slice;

function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link$2(curve) {
  var source = linkSource,
      target = linkTarget,
      x = x$3,
      y = y$3,
      context = null;

  function link() {
    var buffer, argv = slice$6.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = path();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$b(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$b(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial$1(context, x0, y0, x1, y1) {
  var p0 = pointRadial(x0, y0),
      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
      p2 = pointRadial(x1, y0),
      p3 = pointRadial(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link$2(curveHorizontal);
}

function linkVertical() {
  return link$2(curveVertical);
}

function linkRadial() {
  var l = link$2(curveRadial$1);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

var circle$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi$4);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$4);
  }
};

var cross$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};

var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

var diamond = {
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};

var ka = 0.89081309152928522810,
    kr = Math.sin(pi$4 / 10) / Math.sin(7 * pi$4 / 10),
    kx = Math.sin(tau$4 / 10) * kr,
    ky = -Math.cos(tau$4 / 10) * kr;

var star = {
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau$4 * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};

var square = {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};

var sqrt3 = Math.sqrt(3);

var triangle = {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};

var c$2 = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

var wye = {
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c$2 * x0 - s * y0, s * x0 + c$2 * y0);
    context.lineTo(c$2 * x1 - s * y1, s * x1 + c$2 * y1);
    context.lineTo(c$2 * x2 - s * y2, s * x2 + c$2 * y2);
    context.lineTo(c$2 * x0 + s * y0, c$2 * y0 - s * x0);
    context.lineTo(c$2 * x1 + s * y1, c$2 * y1 - s * x1);
    context.lineTo(c$2 * x2 + s * y2, c$2 * y2 - s * x2);
    context.closePath();
  }
};

var symbols = [
  circle$2,
  cross$2,
  diamond,
  square,
  star,
  triangle,
  wye
];

function symbol() {
  var type = constant$b(circle$2),
      size = constant$b(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$b(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$b(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
}

function noop$3() {}

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$2(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function basis$2(context) {
  return new Basis(context);
}

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function basisClosed$1(context) {
  return new BasisClosed(context);
}

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function basisOpen(context) {
  return new BasisOpen(context);
}

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

var bundle = (function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85);

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$3(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinal = (function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalClosed = (function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalOpen = (function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function point$4(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon$3) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon$3) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRom = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomClosed = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomOpen = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

function linearClosed(context) {
  return new LinearClosed(context);
}

function sign$1(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$5(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point$5(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point$5(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point$5(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

function natural(context) {
  return new Natural(context);
}

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

function step(context) {
  return new Step(context, 0.5);
}

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

function none$1(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function none$2(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stack() {
  var keys = constant$b([]),
      order = none$2,
      offset = none$1,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$b(slice$6.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$b(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none$2 : typeof _ === "function" ? _ : constant$b(slice$6.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
  };

  return stack;
}

function expand(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none$1(series, order);
}

function diverging$1(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
}

function silhouette(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  none$1(series, order);
}

function wiggle(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  none$1(series, order);
}

function appearance(series) {
  var peaks = series.map(peak);
  return none$2(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
}

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}

function ascending$3(series) {
  var sums = series.map(sum$2);
  return none$2(series).sort(function(a, b) { return sums[a] - sums[b]; });
}

function sum$2(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

function descending$2(series) {
  return ascending$3(series).reverse();
}

function insideOut(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum$2),
      order = appearance(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
}

function reverse(series) {
  return none$2(series).reverse();
}

function constant$c(x) {
  return function() {
    return x;
  };
}

function x$4(d) {
  return d[0];
}

function y$4(d) {
  return d[1];
}

function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$4
            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$4)) {
      delete edges[i];
    }
  }
}

function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > epsilon$4 || Math.abs(endY - startY) > epsilon$4) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < epsilon$4 && y1 - endY > epsilon$4 ? [x0, Math.abs(startX - x0) < epsilon$4 ? startY : y1]
              : Math.abs(endY - y1) < epsilon$4 && x1 - endX > epsilon$4 ? [Math.abs(startY - y1) < epsilon$4 ? startX : x1, y1]
              : Math.abs(endX - x1) < epsilon$4 && endY - y0 > epsilon$4 ? [x1, Math.abs(startX - x1) < epsilon$4 ? startY : y0]
              : Math.abs(endY - y0) < epsilon$4 && endX - x0 > epsilon$4 ? [Math.abs(startY - y0) < epsilon$4 ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2$2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < epsilon$4
      && Math.abs(y - lArc.circle.cy) < epsilon$4) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < epsilon$4
      && Math.abs(y - rArc.circle.cy) < epsilon$4) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > epsilon$4) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > epsilon$4) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -epsilon$4) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -epsilon$4) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

var epsilon$4 = 1e-6;
var epsilon2$2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new RedBlackTree;
  circles = new RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
};

function voronoi() {
  var x = x$4,
      y = y$4,
      extent = null;

  function voronoi(data) {
    return new Diagram(data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / epsilon$4) * epsilon$4, Math.round(y(d, i, data) / epsilon$4) * epsilon$4];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$c(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$c(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
}

function constant$d(x) {
  return function() {
    return x;
  };
}

function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}

function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity$9 = new Transform(1, 0, 0);

transform$1.prototype = Transform.prototype;

function transform$1(node) {
  while (!node.__zoom) if (!(node = node.parentNode)) return identity$9;
  return node.__zoom;
}

function nopropagation$2() {
  exports.event.stopImmediatePropagation();
}

function noevent$2() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
}

// Ignore right-click, since that should open the context menu.
function defaultFilter$2() {
  return !exports.event.ctrlKey && !exports.event.button;
}

function defaultExtent$1() {
  var e = this;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    if (e.hasAttribute("viewBox")) {
      e = e.viewBox.baseVal;
      return [[e.x, e.y], [e.x + e.width, e.y + e.height]];
    }
    return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
  }
  return [[0, 0], [e.clientWidth, e.clientHeight]];
}

function defaultTransform() {
  return this.__zoom || identity$9;
}

function defaultWheelDelta() {
  return -exports.event.deltaY * (exports.event.deltaMode === 1 ? 0.05 : exports.event.deltaMode ? 1 : 0.002);
}

function defaultTouchable$2() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

function zoom() {
  var filter = defaultFilter$2,
      extent = defaultExtent$1,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable$2,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = interpolateZoom,
      listeners = dispatch("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform, point) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform, point);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k, p) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    }, p);
  };

  zoom.scaleTo = function(selection, k, p) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p,
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    }, p);
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    });
  };

  zoom.translateTo = function(selection, x, y, p) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
      return constrain(identity$9.translate(p0[0], p0[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    }, p);
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, point) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point,
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args, clean) {
    return (!clean && that.__zooming) || new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.active = 0;
    this.extent = extent.apply(that, args);
    this.taps = 0;
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.that.__zooming = this;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        delete this.that.__zooming;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = mouse(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      interrupt(this);
      g.start();
    }

    noevent$2();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments, true),
        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = mouse(this),
        x0 = exports.event.clientX,
        y0 = exports.event.clientY;

    dragDisable(exports.event.view);
    nopropagation$2();
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt(this);
    g.start();

    function mousemoved() {
      noevent$2();
      if (!g.moved) {
        var dx = exports.event.clientX - x0, dy = exports.event.clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(exports.event.view, g.moved);
      noevent$2();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = mouse(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);

    noevent$2();
    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
    else select(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = exports.event.touches,
        n = touches.length,
        g = gesture(this, arguments, exports.event.changedTouches.length === n),
        started, i, t, p;

    nopropagation$2();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = touch(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
      else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
    }

    if (touchstarting) touchstarting = clearTimeout(touchstarting);

    if (started) {
      if (g.taps < 2) touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      interrupt(this);
      g.start();
    }
  }

  function touchmoved() {
    if (!this.__zooming) return;
    var g = gesture(this, arguments),
        touches = exports.event.changedTouches,
        n = touches.length, i, t, p, l;

    noevent$2();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    g.taps = 0;
    for (i = 0; i < n; ++i) {
      t = touches[i], p = touch(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended() {
    if (!this.__zooming) return;
    var g = gesture(this, arguments),
        touches = exports.event.changedTouches,
        n = touches.length, i, t;

    nopropagation$2();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else {
      g.end();
      // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
      if (g.taps === 2) {
        var p = select(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
      }
    }
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant$d(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$d(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$d(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$d([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
}

exports.active = active;
exports.arc = arc;
exports.area = area$3;
exports.areaRadial = areaRadial;
exports.ascending = ascending;
exports.autoType = autoType;
exports.axisBottom = axisBottom;
exports.axisLeft = axisLeft;
exports.axisRight = axisRight;
exports.axisTop = axisTop;
exports.bisect = bisectRight;
exports.bisectLeft = bisectLeft;
exports.bisectRight = bisectRight;
exports.bisector = bisector;
exports.blob = blob;
exports.brush = brush;
exports.brushSelection = brushSelection;
exports.brushX = brushX;
exports.brushY = brushY;
exports.buffer = buffer;
exports.chord = chord;
exports.clientPoint = point;
exports.cluster = cluster;
exports.color = color;
exports.contourDensity = density;
exports.contours = contours;
exports.create = create;
exports.creator = creator;
exports.cross = cross;
exports.csv = csv$1;
exports.csvFormat = csvFormat;
exports.csvFormatBody = csvFormatBody;
exports.csvFormatRow = csvFormatRow;
exports.csvFormatRows = csvFormatRows;
exports.csvFormatValue = csvFormatValue;
exports.csvParse = csvParse;
exports.csvParseRows = csvParseRows;
exports.cubehelix = cubehelix;
exports.curveBasis = basis$2;
exports.curveBasisClosed = basisClosed$1;
exports.curveBasisOpen = basisOpen;
exports.curveBundle = bundle;
exports.curveCardinal = cardinal;
exports.curveCardinalClosed = cardinalClosed;
exports.curveCardinalOpen = cardinalOpen;
exports.curveCatmullRom = catmullRom;
exports.curveCatmullRomClosed = catmullRomClosed;
exports.curveCatmullRomOpen = catmullRomOpen;
exports.curveLinear = curveLinear;
exports.curveLinearClosed = linearClosed;
exports.curveMonotoneX = monotoneX;
exports.curveMonotoneY = monotoneY;
exports.curveNatural = natural;
exports.curveStep = step;
exports.curveStepAfter = stepAfter;
exports.curveStepBefore = stepBefore;
exports.customEvent = customEvent;
exports.descending = descending;
exports.deviation = deviation;
exports.dispatch = dispatch;
exports.drag = drag;
exports.dragDisable = dragDisable;
exports.dragEnable = yesdrag;
exports.dsv = dsv;
exports.dsvFormat = dsvFormat;
exports.easeBack = backInOut;
exports.easeBackIn = backIn;
exports.easeBackInOut = backInOut;
exports.easeBackOut = backOut;
exports.easeBounce = bounceOut;
exports.easeBounceIn = bounceIn;
exports.easeBounceInOut = bounceInOut;
exports.easeBounceOut = bounceOut;
exports.easeCircle = circleInOut;
exports.easeCircleIn = circleIn;
exports.easeCircleInOut = circleInOut;
exports.easeCircleOut = circleOut;
exports.easeCubic = cubicInOut;
exports.easeCubicIn = cubicIn;
exports.easeCubicInOut = cubicInOut;
exports.easeCubicOut = cubicOut;
exports.easeElastic = elasticOut;
exports.easeElasticIn = elasticIn;
exports.easeElasticInOut = elasticInOut;
exports.easeElasticOut = elasticOut;
exports.easeExp = expInOut;
exports.easeExpIn = expIn;
exports.easeExpInOut = expInOut;
exports.easeExpOut = expOut;
exports.easeLinear = linear$1;
exports.easePoly = polyInOut;
exports.easePolyIn = polyIn;
exports.easePolyInOut = polyInOut;
exports.easePolyOut = polyOut;
exports.easeQuad = quadInOut;
exports.easeQuadIn = quadIn;
exports.easeQuadInOut = quadInOut;
exports.easeQuadOut = quadOut;
exports.easeSin = sinInOut;
exports.easeSinIn = sinIn;
exports.easeSinInOut = sinInOut;
exports.easeSinOut = sinOut;
exports.entries = entries;
exports.extent = extent;
exports.forceCenter = center$1;
exports.forceCollide = collide;
exports.forceLink = link;
exports.forceManyBody = manyBody;
exports.forceRadial = radial;
exports.forceSimulation = simulation;
exports.forceX = x$2;
exports.forceY = y$2;
exports.formatDefaultLocale = defaultLocale;
exports.formatLocale = formatLocale;
exports.formatSpecifier = formatSpecifier;
exports.geoAlbers = albers;
exports.geoAlbersUsa = albersUsa;
exports.geoArea = area$1;
exports.geoAzimuthalEqualArea = azimuthalEqualArea;
exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
exports.geoAzimuthalEquidistant = azimuthalEquidistant;
exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
exports.geoBounds = bounds;
exports.geoCentroid = centroid;
exports.geoCircle = circle;
exports.geoClipAntimeridian = clipAntimeridian;
exports.geoClipCircle = clipCircle;
exports.geoClipExtent = extent$1;
exports.geoClipRectangle = clipRectangle;
exports.geoConicConformal = conicConformal;
exports.geoConicConformalRaw = conicConformalRaw;
exports.geoConicEqualArea = conicEqualArea;
exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
exports.geoConicEquidistant = conicEquidistant;
exports.geoConicEquidistantRaw = conicEquidistantRaw;
exports.geoContains = contains$1;
exports.geoDistance = distance;
exports.geoEqualEarth = equalEarth;
exports.geoEqualEarthRaw = equalEarthRaw;
exports.geoEquirectangular = equirectangular;
exports.geoEquirectangularRaw = equirectangularRaw;
exports.geoGnomonic = gnomonic;
exports.geoGnomonicRaw = gnomonicRaw;
exports.geoGraticule = graticule;
exports.geoGraticule10 = graticule10;
exports.geoIdentity = identity$5;
exports.geoInterpolate = interpolate$1;
exports.geoLength = length$1;
exports.geoMercator = mercator;
exports.geoMercatorRaw = mercatorRaw;
exports.geoNaturalEarth1 = naturalEarth1;
exports.geoNaturalEarth1Raw = naturalEarth1Raw;
exports.geoOrthographic = orthographic;
exports.geoOrthographicRaw = orthographicRaw;
exports.geoPath = index$1;
exports.geoProjection = projection;
exports.geoProjectionMutator = projectionMutator;
exports.geoRotation = rotation;
exports.geoStereographic = stereographic;
exports.geoStereographicRaw = stereographicRaw;
exports.geoStream = geoStream;
exports.geoTransform = transform;
exports.geoTransverseMercator = transverseMercator;
exports.geoTransverseMercatorRaw = transverseMercatorRaw;
exports.gray = gray;
exports.hcl = hcl;
exports.hierarchy = hierarchy;
exports.histogram = histogram;
exports.hsl = hsl;
exports.html = html;
exports.image = image;
exports.interpolate = interpolateValue;
exports.interpolateArray = array$1;
exports.interpolateBasis = basis$1;
exports.interpolateBasisClosed = basisClosed;
exports.interpolateBlues = Blues;
exports.interpolateBrBG = BrBG;
exports.interpolateBuGn = BuGn;
exports.interpolateBuPu = BuPu;
exports.interpolateCividis = cividis;
exports.interpolateCool = cool;
exports.interpolateCubehelix = cubehelix$2;
exports.interpolateCubehelixDefault = cubehelix$3;
exports.interpolateCubehelixLong = cubehelixLong;
exports.interpolateDate = date;
exports.interpolateDiscrete = discrete;
exports.interpolateGnBu = GnBu;
exports.interpolateGreens = Greens;
exports.interpolateGreys = Greys;
exports.interpolateHcl = hcl$2;
exports.interpolateHclLong = hclLong;
exports.interpolateHsl = hsl$2;
exports.interpolateHslLong = hslLong;
exports.interpolateHue = hue$1;
exports.interpolateInferno = inferno;
exports.interpolateLab = lab$1;
exports.interpolateMagma = magma;
exports.interpolateNumber = interpolateNumber;
exports.interpolateNumberArray = numberArray;
exports.interpolateObject = object;
exports.interpolateOrRd = OrRd;
exports.interpolateOranges = Oranges;
exports.interpolatePRGn = PRGn;
exports.interpolatePiYG = PiYG;
exports.interpolatePlasma = plasma;
exports.interpolatePuBu = PuBu;
exports.interpolatePuBuGn = PuBuGn;
exports.interpolatePuOr = PuOr;
exports.interpolatePuRd = PuRd;
exports.interpolatePurples = Purples;
exports.interpolateRainbow = rainbow;
exports.interpolateRdBu = RdBu;
exports.interpolateRdGy = RdGy;
exports.interpolateRdPu = RdPu;
exports.interpolateRdYlBu = RdYlBu;
exports.interpolateRdYlGn = RdYlGn;
exports.interpolateReds = Reds;
exports.interpolateRgb = interpolateRgb;
exports.interpolateRgbBasis = rgbBasis;
exports.interpolateRgbBasisClosed = rgbBasisClosed;
exports.interpolateRound = interpolateRound;
exports.interpolateSinebow = sinebow;
exports.interpolateSpectral = Spectral;
exports.interpolateString = interpolateString;
exports.interpolateTransformCss = interpolateTransformCss;
exports.interpolateTransformSvg = interpolateTransformSvg;
exports.interpolateTurbo = turbo;
exports.interpolateViridis = viridis;
exports.interpolateWarm = warm;
exports.interpolateYlGn = YlGn;
exports.interpolateYlGnBu = YlGnBu;
exports.interpolateYlOrBr = YlOrBr;
exports.interpolateYlOrRd = YlOrRd;
exports.interpolateZoom = interpolateZoom;
exports.interrupt = interrupt;
exports.interval = interval$1;
exports.isoFormat = formatIso;
exports.isoParse = parseIso;
exports.json = json;
exports.keys = keys;
exports.lab = lab;
exports.lch = lch;
exports.line = line;
exports.lineRadial = lineRadial$1;
exports.linkHorizontal = linkHorizontal;
exports.linkRadial = linkRadial;
exports.linkVertical = linkVertical;
exports.local = local;
exports.map = map$1;
exports.matcher = matcher;
exports.max = max;
exports.mean = mean;
exports.median = median;
exports.merge = merge;
exports.min = min;
exports.mouse = mouse;
exports.namespace = namespace;
exports.namespaces = namespaces;
exports.nest = nest;
exports.now = now;
exports.pack = index$2;
exports.packEnclose = enclose;
exports.packSiblings = siblings;
exports.pairs = pairs;
exports.partition = partition;
exports.path = path;
exports.permute = permute;
exports.pie = pie;
exports.piecewise = piecewise;
exports.pointRadial = pointRadial;
exports.polygonArea = area$2;
exports.polygonCentroid = centroid$1;
exports.polygonContains = contains$2;
exports.polygonHull = hull;
exports.polygonLength = length$2;
exports.precisionFixed = precisionFixed;
exports.precisionPrefix = precisionPrefix;
exports.precisionRound = precisionRound;
exports.quadtree = quadtree;
exports.quantile = threshold;
exports.quantize = quantize;
exports.radialArea = areaRadial;
exports.radialLine = lineRadial$1;
exports.randomBates = bates;
exports.randomExponential = exponential$1;
exports.randomIrwinHall = irwinHall;
exports.randomLogNormal = logNormal;
exports.randomNormal = normal;
exports.randomUniform = uniform;
exports.range = sequence;
exports.rgb = rgb;
exports.ribbon = ribbon;
exports.scaleBand = band;
exports.scaleDiverging = diverging;
exports.scaleDivergingLog = divergingLog;
exports.scaleDivergingPow = divergingPow;
exports.scaleDivergingSqrt = divergingSqrt;
exports.scaleDivergingSymlog = divergingSymlog;
exports.scaleIdentity = identity$7;
exports.scaleImplicit = implicit;
exports.scaleLinear = linear$2;
exports.scaleLog = log$1;
exports.scaleOrdinal = ordinal;
exports.scalePoint = point$1;
exports.scalePow = pow$1;
exports.scaleQuantile = quantile;
exports.scaleQuantize = quantize$1;
exports.scaleSequential = sequential;
exports.scaleSequentialLog = sequentialLog;
exports.scaleSequentialPow = sequentialPow;
exports.scaleSequentialQuantile = sequentialQuantile;
exports.scaleSequentialSqrt = sequentialSqrt;
exports.scaleSequentialSymlog = sequentialSymlog;
exports.scaleSqrt = sqrt$1;
exports.scaleSymlog = symlog;
exports.scaleThreshold = threshold$1;
exports.scaleTime = time;
exports.scaleUtc = utcTime;
exports.scan = scan;
exports.schemeAccent = Accent;
exports.schemeBlues = scheme$l;
exports.schemeBrBG = scheme;
exports.schemeBuGn = scheme$9;
exports.schemeBuPu = scheme$a;
exports.schemeCategory10 = category10;
exports.schemeDark2 = Dark2;
exports.schemeGnBu = scheme$b;
exports.schemeGreens = scheme$m;
exports.schemeGreys = scheme$n;
exports.schemeOrRd = scheme$c;
exports.schemeOranges = scheme$q;
exports.schemePRGn = scheme$1;
exports.schemePaired = Paired;
exports.schemePastel1 = Pastel1;
exports.schemePastel2 = Pastel2;
exports.schemePiYG = scheme$2;
exports.schemePuBu = scheme$e;
exports.schemePuBuGn = scheme$d;
exports.schemePuOr = scheme$3;
exports.schemePuRd = scheme$f;
exports.schemePurples = scheme$o;
exports.schemeRdBu = scheme$4;
exports.schemeRdGy = scheme$5;
exports.schemeRdPu = scheme$g;
exports.schemeRdYlBu = scheme$6;
exports.schemeRdYlGn = scheme$7;
exports.schemeReds = scheme$p;
exports.schemeSet1 = Set1;
exports.schemeSet2 = Set2;
exports.schemeSet3 = Set3;
exports.schemeSpectral = scheme$8;
exports.schemeTableau10 = Tableau10;
exports.schemeYlGn = scheme$i;
exports.schemeYlGnBu = scheme$h;
exports.schemeYlOrBr = scheme$j;
exports.schemeYlOrRd = scheme$k;
exports.select = select;
exports.selectAll = selectAll;
exports.selection = selection;
exports.selector = selector;
exports.selectorAll = selectorAll;
exports.set = set$2;
exports.shuffle = shuffle;
exports.stack = stack;
exports.stackOffsetDiverging = diverging$1;
exports.stackOffsetExpand = expand;
exports.stackOffsetNone = none$1;
exports.stackOffsetSilhouette = silhouette;
exports.stackOffsetWiggle = wiggle;
exports.stackOrderAppearance = appearance;
exports.stackOrderAscending = ascending$3;
exports.stackOrderDescending = descending$2;
exports.stackOrderInsideOut = insideOut;
exports.stackOrderNone = none$2;
exports.stackOrderReverse = reverse;
exports.stratify = stratify;
exports.style = styleValue;
exports.sum = sum;
exports.svg = svg;
exports.symbol = symbol;
exports.symbolCircle = circle$2;
exports.symbolCross = cross$2;
exports.symbolDiamond = diamond;
exports.symbolSquare = square;
exports.symbolStar = star;
exports.symbolTriangle = triangle;
exports.symbolWye = wye;
exports.symbols = symbols;
exports.text = text;
exports.thresholdFreedmanDiaconis = freedmanDiaconis;
exports.thresholdScott = scott;
exports.thresholdSturges = thresholdSturges;
exports.tickFormat = tickFormat;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
exports.ticks = ticks;
exports.timeDay = day;
exports.timeDays = days;
exports.timeFormatDefaultLocale = defaultLocale$1;
exports.timeFormatLocale = formatLocale$1;
exports.timeFriday = friday;
exports.timeFridays = fridays;
exports.timeHour = hour;
exports.timeHours = hours;
exports.timeInterval = newInterval;
exports.timeMillisecond = millisecond;
exports.timeMilliseconds = milliseconds;
exports.timeMinute = minute;
exports.timeMinutes = minutes;
exports.timeMonday = monday;
exports.timeMondays = mondays;
exports.timeMonth = month;
exports.timeMonths = months;
exports.timeSaturday = saturday;
exports.timeSaturdays = saturdays;
exports.timeSecond = second;
exports.timeSeconds = seconds;
exports.timeSunday = sunday;
exports.timeSundays = sundays;
exports.timeThursday = thursday;
exports.timeThursdays = thursdays;
exports.timeTuesday = tuesday;
exports.timeTuesdays = tuesdays;
exports.timeWednesday = wednesday;
exports.timeWednesdays = wednesdays;
exports.timeWeek = sunday;
exports.timeWeeks = sundays;
exports.timeYear = year;
exports.timeYears = years;
exports.timeout = timeout$1;
exports.timer = timer;
exports.timerFlush = timerFlush;
exports.touch = touch;
exports.touches = touches;
exports.transition = transition;
exports.transpose = transpose;
exports.tree = tree;
exports.treemap = index$3;
exports.treemapBinary = binary;
exports.treemapDice = treemapDice;
exports.treemapResquarify = resquarify;
exports.treemapSlice = treemapSlice;
exports.treemapSliceDice = sliceDice;
exports.treemapSquarify = squarify;
exports.tsv = tsv$1;
exports.tsvFormat = tsvFormat;
exports.tsvFormatBody = tsvFormatBody;
exports.tsvFormatRow = tsvFormatRow;
exports.tsvFormatRows = tsvFormatRows;
exports.tsvFormatValue = tsvFormatValue;
exports.tsvParse = tsvParse;
exports.tsvParseRows = tsvParseRows;
exports.utcDay = utcDay;
exports.utcDays = utcDays;
exports.utcFriday = utcFriday;
exports.utcFridays = utcFridays;
exports.utcHour = utcHour;
exports.utcHours = utcHours;
exports.utcMillisecond = millisecond;
exports.utcMilliseconds = milliseconds;
exports.utcMinute = utcMinute;
exports.utcMinutes = utcMinutes;
exports.utcMonday = utcMonday;
exports.utcMondays = utcMondays;
exports.utcMonth = utcMonth;
exports.utcMonths = utcMonths;
exports.utcSaturday = utcSaturday;
exports.utcSaturdays = utcSaturdays;
exports.utcSecond = second;
exports.utcSeconds = seconds;
exports.utcSunday = utcSunday;
exports.utcSundays = utcSundays;
exports.utcThursday = utcThursday;
exports.utcThursdays = utcThursdays;
exports.utcTuesday = utcTuesday;
exports.utcTuesdays = utcTuesdays;
exports.utcWednesday = utcWednesday;
exports.utcWednesdays = utcWednesdays;
exports.utcWeek = utcSunday;
exports.utcWeeks = utcSundays;
exports.utcYear = utcYear;
exports.utcYears = utcYears;
exports.values = values;
exports.variance = variance;
exports.version = version;
exports.voronoi = voronoi;
exports.window = defaultView;
exports.xml = xml;
exports.zip = zip;
exports.zoom = zoom;
exports.zoomIdentity = identity$9;
exports.zoomTransform = transform$1;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/* -------------------------------------------------------------------------------------------------- */
/* vega.js */
/* File: js/machinata-reporting-bundle.js/vega.js */
/* -------------------------------------------------------------------------------------------------- */

(function (global, factory) {
  false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof exports === 'object' */ && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global =  /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof globalThis !== 'undefined' ? globalThis :  */global || self, factory(global.vega = {}));
}(((typeof global !== 'undefined') ? global : window), (function (exports) { 'use strict'; /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: }(this, (function (exports) { 'use strict'; */

  var name = "vega";
  var version$1 = "5.20.2";
  var description = "The Vega visualization grammar.";
  var keywords$1 = [
  	"vega",
  	"visualization",
  	"interaction",
  	"dataflow",
  	"library",
  	"data",
  	"d3"
  ];
  var license = "BSD-3-Clause";
  var author = "UW Interactive Data Lab (http://idl.cs.washington.edu)";
  var main = "build/vega-node.js";
  var module = "build/vega.module.js";
  var unpkg = "build/vega.min.js";
  var jsdelivr = "build/vega.min.js";
  var types = "index.d.ts";
  var repository = "vega/vega";
  var scripts = {
  	bundle: "rollup -c --config-bundle",
  	prebuild: "rimraf build && rimraf build-es5",
  	build: "rollup -c --config-core --config-bundle --config-ie",
  	postbuild: "node schema-copy",
  	pretest: "yarn build --config-test",
  	test: "TZ=America/Los_Angeles tape 'test/**/*-test.js'",
  	prepublishOnly: "yarn test && yarn build",
  	postpublish: "./schema-deploy.sh"
  };
  var dependencies = {
  	"vega-crossfilter": "~4.0.5",
  	"vega-dataflow": "~5.7.4",
  	"vega-encode": "~4.8.3",
  	"vega-event-selector": "~2.0.6",
  	"vega-expression": "~4.0.1",
  	"vega-force": "~4.0.7",
  	"vega-format": "~1.0.4",
  	"vega-functions": "~5.12.0",
  	"vega-geo": "~4.3.8",
  	"vega-hierarchy": "~4.0.9",
  	"vega-label": "~1.0.0",
  	"vega-loader": "~4.4.0",
  	"vega-parser": "~6.1.3",
  	"vega-projection": "~1.4.5",
  	"vega-regression": "~1.0.9",
  	"vega-runtime": "~6.1.3",
  	"vega-scale": "~7.1.1",
  	"vega-scenegraph": "~4.9.4",
  	"vega-statistics": "~1.7.9",
  	"vega-time": "~2.0.4",
  	"vega-transforms": "~4.9.4",
  	"vega-typings": "~0.21.0",
  	"vega-util": "~1.16.1",
  	"vega-view": "~5.10.1",
  	"vega-view-transforms": "~4.5.8",
  	"vega-voronoi": "~4.1.5",
  	"vega-wordcloud": "~4.1.3"
  };
  var devDependencies = {
  	"vega-schema": "*"
  };
  var pkg = {
  	name: name,
  	version: version$1,
  	description: description,
  	keywords: keywords$1,
  	license: license,
  	author: author,
  	main: main,
  	module: module,
  	unpkg: unpkg,
  	jsdelivr: jsdelivr,
  	types: types,
  	repository: repository,
  	scripts: scripts,
  	dependencies: dependencies,
  	devDependencies: devDependencies
  };

  function accessor(fn, fields, name) {
    fn.fields = fields || [];
    fn.fname = name;
    return fn;
  }

  function accessorName(fn) {
    return fn == null ? null : fn.fname;
  }

  function accessorFields(fn) {
    return fn == null ? null : fn.fields;
  }

  function getter(path) {
    return path.length === 1 ? get1(path[0]) : getN(path);
  }

  const get1 = field => function (obj) {
    return obj[field];
  };

  const getN = path => {
    const len = path.length;
    return function (obj) {
      for (let i = 0; i < len; ++i) {
        obj = obj[path[i]];
      }

      return obj;
    };
  };

  function error(message) {
    throw Error(message);
  }

  function splitAccessPath(p) {
    const path = [],
          n = p.length;
    let q = null,
        b = 0,
        s = '',
        i,
        j,
        c;
    p = p + '';

    function push() {
      path.push(s + p.substring(i, j));
      s = '';
      i = j + 1;
    }

    for (i = j = 0; j < n; ++j) {
      c = p[j];

      if (c === '\\') {
        s += p.substring(i, j);
        s += p.substring(++j, ++j);
        i = j;
      } else if (c === q) {
        push();
        q = null;
        b = -1;
      } else if (q) {
        continue;
      } else if (i === b && c === '"') {
        i = j + 1;
        q = c;
      } else if (i === b && c === "'") {
        i = j + 1;
        q = c;
      } else if (c === '.' && !b) {
        if (j > i) {
          push();
        } else {
          i = j + 1;
        }
      } else if (c === '[') {
        if (j > i) push();
        b = i = j + 1;
      } else if (c === ']') {
        if (!b) error('Access path missing open bracket: ' + p);
        if (b > 0) push();
        b = 0;
        i = j + 1;
      }
    }

    if (b) error('Access path missing closing bracket: ' + p);
    if (q) error('Access path missing closing quote: ' + p);

    if (j > i) {
      j++;
      push();
    }

    return path;
  }

  function field$1(field, name, opt) {
    const path = splitAccessPath(field);
    field = path.length === 1 ? path[0] : field;
    return accessor((opt && opt.get || getter)(path), [field], name || field);
  }

  const id = field$1('id');
  const identity$6 = accessor(_ => _, [], 'identity');
  const zero$2 = accessor(() => 0, [], 'zero');
  const one$2 = accessor(() => 1, [], 'one');
  const truthy = accessor(() => true, [], 'true');
  const falsy = accessor(() => false, [], 'false');

  function log$1$1(method, level, input) {
    const args = [level].concat([].slice.call(input));
    console[method].apply(console, args); // eslint-disable-line no-console
  }

  const None$2 = 0;
  const Error$1 = 1;
  const Warn = 2;
  const Info = 3;
  const Debug = 4;

  function logger(_, method) {
    let level = _ || None$2;
    return {
      level(_) {
        if (arguments.length) {
          level = +_;
          return this;
        } else {
          return level;
        }
      },

      error() {
        if (level >= Error$1) log$1$1(method || 'error', 'ERROR', arguments);
        return this;
      },

      warn() {
        if (level >= Warn) log$1$1(method || 'warn', 'WARN', arguments);
        return this;
      },

      info() {
        if (level >= Info) log$1$1(method || 'log', 'INFO', arguments);
        return this;
      },

      debug() {
        if (level >= Debug) log$1$1(method || 'log', 'DEBUG', arguments);
        return this;
      }

    };
  }

  var isArray = Array.isArray;

  function isObject(_) {
    return _ === Object(_);
  }

  const isLegalKey = key => key !== '__proto__';

  function mergeConfig(...configs) {
    return configs.reduce((out, source) => {
      for (const key in source) {
        if (key === 'signals') {
          // for signals, we merge the signals arrays
          // source signals take precedence over
          // existing signals with the same name
          out.signals = mergeNamed(out.signals, source.signals);
        } else {
          // otherwise, merge objects subject to recursion constraints
          // for legend block, recurse for the layout entry only
          // for style block, recurse for all properties
          // otherwise, no recursion: objects overwrite, no merging
          const r = key === 'legend' ? {
            layout: 1
          } : key === 'style' ? true : null;
          writeConfig(out, key, source[key], r);
        }
      }

      return out;
    }, {});
  }

  function writeConfig(output, key, value, recurse) {
    if (!isLegalKey(key)) return;
    let k, o;

    if (isObject(value) && !isArray(value)) {
      o = isObject(output[key]) ? output[key] : output[key] = {};

      for (k in value) {
        if (recurse && (recurse === true || recurse[k])) {
          writeConfig(o, k, value[k]);
        } else if (isLegalKey(k)) {
          o[k] = value[k];
        }
      }
    } else {
      output[key] = value;
    }
  }

  function mergeNamed(a, b) {
    if (a == null) return b;
    const map = {},
          out = [];

    function add(_) {
      if (!map[_.name]) {
        map[_.name] = 1;
        out.push(_);
      }
    }

    b.forEach(add);
    a.forEach(add);
    return out;
  }

  function peek$1(array) {
    return array[array.length - 1];
  }

  function toNumber(_) {
    return _ == null || _ === '' ? null : +_;
  }

  const exp$2 = sign => x => sign * Math.exp(x);

  const log$4 = sign => x => Math.log(sign * x);

  const symlog$1 = c => x => Math.sign(x) * Math.log1p(Math.abs(x / c));

  const symexp = c => x => Math.sign(x) * Math.expm1(Math.abs(x)) * c;

  const pow$4 = exponent => x => x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);

  function pan(domain, delta, lift, ground) {
    const d0 = lift(domain[0]),
          d1 = lift(peek$1(domain)),
          dd = (d1 - d0) * delta;
    return [ground(d0 - dd), ground(d1 - dd)];
  }

  function panLinear(domain, delta) {
    return pan(domain, delta, toNumber, identity$6);
  }

  function panLog(domain, delta) {
    var sign = Math.sign(domain[0]);
    return pan(domain, delta, log$4(sign), exp$2(sign));
  }

  function panPow(domain, delta, exponent) {
    return pan(domain, delta, pow$4(exponent), pow$4(1 / exponent));
  }

  function panSymlog(domain, delta, constant) {
    return pan(domain, delta, symlog$1(constant), symexp(constant));
  }

  function zoom$1(domain, anchor, scale, lift, ground) {
    const d0 = lift(domain[0]),
          d1 = lift(peek$1(domain)),
          da = anchor != null ? lift(anchor) : (d0 + d1) / 2;
    return [ground(da + (d0 - da) * scale), ground(da + (d1 - da) * scale)];
  }

  function zoomLinear(domain, anchor, scale) {
    return zoom$1(domain, anchor, scale, toNumber, identity$6);
  }

  function zoomLog(domain, anchor, scale) {
    const sign = Math.sign(domain[0]);
    return zoom$1(domain, anchor, scale, log$4(sign), exp$2(sign));
  }

  function zoomPow(domain, anchor, scale, exponent) {
    return zoom$1(domain, anchor, scale, pow$4(exponent), pow$4(1 / exponent));
  }

  function zoomSymlog(domain, anchor, scale, constant) {
    return zoom$1(domain, anchor, scale, symlog$1(constant), symexp(constant));
  }

  function quarter(date) {
    return 1 + ~~(new Date(date).getMonth() / 3);
  }

  function utcquarter(date) {
    return 1 + ~~(new Date(date).getUTCMonth() / 3);
  }

  function array$5(_) {
    return _ != null ? isArray(_) ? _ : [_] : [];
  }
  /**
   * Span-preserving range clamp. If the span of the input range is less
   * than (max - min) and an endpoint exceeds either the min or max value,
   * the range is translated such that the span is preserved and one
   * endpoint touches the boundary of the min/max range.
   * If the span exceeds (max - min), the range [min, max] is returned.
   */


  function clampRange(range, min, max) {
    let lo = range[0],
        hi = range[1],
        span;

    if (hi < lo) {
      span = hi;
      hi = lo;
      lo = span;
    }

    span = hi - lo;
    return span >= max - min ? [min, max] : [lo = Math.min(Math.max(lo, min), max - span), lo + span];
  }

  function isFunction(_) {
    return typeof _ === 'function';
  }

  const DESCENDING = 'descending';

  function compare$1(fields, orders, opt) {
    opt = opt || {};
    orders = array$5(orders) || [];
    const ord = [],
          get = [],
          fmap = {},
          gen = opt.comparator || comparator;
    array$5(fields).forEach((f, i) => {
      if (f == null) return;
      ord.push(orders[i] === DESCENDING ? -1 : 1);
      get.push(f = isFunction(f) ? f : field$1(f, null, opt));
      (accessorFields(f) || []).forEach(_ => fmap[_] = 1);
    });
    return get.length === 0 ? null : accessor(gen(get, ord), Object.keys(fmap));
  }

  const ascending$3 = (u, v) => (u < v || u == null) && v != null ? -1 : (u > v || v == null) && u != null ? 1 : (v = v instanceof Date ? +v : v, u = u instanceof Date ? +u : u) !== u && v === v ? -1 : v !== v && u === u ? 1 : 0;

  const comparator = (fields, orders) => fields.length === 1 ? compare1(fields[0], orders[0]) : compareN(fields, orders, fields.length);

  const compare1 = (field, order) => function (a, b) {
    return ascending$3(field(a), field(b)) * order;
  };

  const compareN = (fields, orders, n) => {
    orders.push(0); // pad zero for convenient lookup

    return function (a, b) {
      let f,
          c = 0,
          i = -1;

      while (c === 0 && ++i < n) {
        f = fields[i];
        c = ascending$3(f(a), f(b));
      }

      return c * orders[i];
    };
  };

  function constant$4(_) {
    return isFunction(_) ? _ : () => _;
  }

  function debounce(delay, handler) {
    let tid;
    return e => {
      if (tid) clearTimeout(tid);
      tid = setTimeout(() => (handler(e), tid = null), delay);
    };
  }

  function extend$1(_) {
    for (let x, k, i = 1, len = arguments.length; i < len; ++i) {
      x = arguments[i];

      for (k in x) {
        _[k] = x[k];
      }
    }

    return _;
  }
  /**
   * Return an array with minimum and maximum values, in the
   * form [min, max]. Ignores null, undefined, and NaN values.
   */


  function extent(array, f) {
    let i = 0,
        n,
        v,
        min,
        max;

    if (array && (n = array.length)) {
      if (f == null) {
        // find first valid value
        for (v = array[i]; i < n && (v == null || v !== v); v = array[++i]);

        min = max = v; // visit all other values

        for (; i < n; ++i) {
          v = array[i]; // skip null/undefined; NaN will fail all comparisons

          if (v != null) {
            if (v < min) min = v;
            if (v > max) max = v;
          }
        }
      } else {
        // find first valid value
        for (v = f(array[i]); i < n && (v == null || v !== v); v = f(array[++i]));

        min = max = v; // visit all other values

        for (; i < n; ++i) {
          v = f(array[i]); // skip null/undefined; NaN will fail all comparisons

          if (v != null) {
            if (v < min) min = v;
            if (v > max) max = v;
          }
        }
      }
    }

    return [min, max];
  }

  function extentIndex(array, f) {
    const n = array.length;
    let i = -1,
        a,
        b,
        c,
        u,
        v;

    if (f == null) {
      while (++i < n) {
        b = array[i];

        if (b != null && b >= b) {
          a = c = b;
          break;
        }
      }

      if (i === n) return [-1, -1];
      u = v = i;

      while (++i < n) {
        b = array[i];

        if (b != null) {
          if (a > b) {
            a = b;
            u = i;
          }

          if (c < b) {
            c = b;
            v = i;
          }
        }
      }
    } else {
      while (++i < n) {
        b = f(array[i], i, array);

        if (b != null && b >= b) {
          a = c = b;
          break;
        }
      }

      if (i === n) return [-1, -1];
      u = v = i;

      while (++i < n) {
        b = f(array[i], i, array);

        if (b != null) {
          if (a > b) {
            a = b;
            u = i;
          }

          if (c < b) {
            c = b;
            v = i;
          }
        }
      }
    }

    return [u, v];
  }

  const hop = Object.prototype.hasOwnProperty;

  function has$1(object, property) {
    return hop.call(object, property);
  }

  const NULL = {};

  function fastmap(input) {
    let obj = {},
        test;

    function has$1$1(key) {
      return has$1(obj, key) && obj[key] !== NULL;
    }

    const map = {
      size: 0,
      empty: 0,
      object: obj,
      has: has$1$1,

      get(key) {
        return has$1$1(key) ? obj[key] : undefined;
      },

      set(key, value) {
        if (!has$1$1(key)) {
          ++map.size;
          if (obj[key] === NULL) --map.empty;
        }

        obj[key] = value;
        return this;
      },

      delete(key) {
        if (has$1$1(key)) {
          --map.size;
          ++map.empty;
          obj[key] = NULL;
        }

        return this;
      },

      clear() {
        map.size = map.empty = 0;
        map.object = obj = {};
      },

      test(_) {
        if (arguments.length) {
          test = _;
          return map;
        } else {
          return test;
        }
      },

      clean() {
        const next = {};
        let size = 0;

        for (const key in obj) {
          const value = obj[key];

          if (value !== NULL && (!test || !test(value))) {
            next[key] = value;
            ++size;
          }
        }

        map.size = size;
        map.empty = 0;
        map.object = obj = next;
      }

    };
    if (input) Object.keys(input).forEach(key => {
      map.set(key, input[key]);
    });
    return map;
  }

  function flush(range, value, threshold, left, right, center) {
    if (!threshold && threshold !== 0) return center;
    const t = +threshold;
    let a = range[0],
        b = peek$1(range),
        l; // swap endpoints if range is reversed

    if (b < a) {
      l = a;
      a = b;
      b = l;
    } // compare value to endpoints


    l = Math.abs(value - a);
    const r = Math.abs(b - value); // adjust if value is within threshold distance of endpoint

    return l < r && l <= t ? left : r <= t ? right : center;
  }

  function inherits(child, parent, members) {
    const proto = child.prototype = Object.create(parent.prototype);
    Object.defineProperty(proto, 'constructor', {
      value: child,
      writable: true,
      enumerable: true,
      configurable: true
    });
    return extend$1(proto, members);
  }
  /**
   * Predicate that returns true if the value lies within the span
   * of the given range. The left and right flags control the use
   * of inclusive (true) or exclusive (false) comparisons.
   */


  function inrange(value, range, left, right) {
    let r0 = range[0],
        r1 = range[range.length - 1],
        t;

    if (r0 > r1) {
      t = r0;
      r0 = r1;
      r1 = t;
    }

    left = left === undefined || left;
    right = right === undefined || right;
    return (left ? r0 <= value : r0 < value) && (right ? value <= r1 : value < r1);
  }

  function isBoolean$1(_) {
    return typeof _ === 'boolean';
  }

  function isDate$1(_) {
    return Object.prototype.toString.call(_) === '[object Date]';
  }

  function isIterable(_) {
    return _ && isFunction(_[Symbol.iterator]);
  }

  function isNumber$1(_) {
    return typeof _ === 'number';
  }

  function isRegExp(_) {
    return Object.prototype.toString.call(_) === '[object RegExp]';
  }

  function isString(_) {
    return typeof _ === 'string';
  }

  function key(fields, flat, opt) {
    if (fields) {
      fields = flat ? array$5(fields).map(f => f.replace(/\\(.)/g, '$1')) : array$5(fields);
    }

    const len = fields && fields.length,
          gen = opt && opt.get || getter,
          map = f => gen(flat ? [f] : splitAccessPath(f));

    let fn;

    if (!len) {
      fn = function () {
        return '';
      };
    } else if (len === 1) {
      const get = map(fields[0]);

      fn = function (_) {
        return '' + get(_);
      };
    } else {
      const get = fields.map(map);

      fn = function (_) {
        let s = '' + get[0](_),
            i = 0;

        while (++i < len) s += '|' + get[i](_);

        return s;
      };
    }

    return accessor(fn, fields, 'key');
  }

  function lerp(array, frac) {
    const lo = array[0],
          hi = peek$1(array),
          f = +frac;
    return !f ? lo : f === 1 ? hi : lo + f * (hi - lo);
  }

  const DEFAULT_MAX_SIZE = 10000; // adapted from https://github.com/dominictarr/hashlru/ (MIT License)

  function lruCache(maxsize) {
    maxsize = +maxsize || DEFAULT_MAX_SIZE;
    let curr, prev, size;

    const clear = () => {
      curr = {};
      prev = {};
      size = 0;
    };

    const update = (key, value) => {
      if (++size > maxsize) {
        prev = curr;
        curr = {};
        size = 1;
      }

      return curr[key] = value;
    };

    clear();
    return {
      clear,
      has: key => has$1(curr, key) || has$1(prev, key),
      get: key => has$1(curr, key) ? curr[key] : has$1(prev, key) ? update(key, prev[key]) : undefined,
      set: (key, value) => has$1(curr, key) ? curr[key] = value : update(key, value)
    };
  }

  function merge$3(compare, array0, array1, output) {
    const n0 = array0.length,
          n1 = array1.length;
    if (!n1) return array0;
    if (!n0) return array1;
    const merged = output || new array0.constructor(n0 + n1);
    let i0 = 0,
        i1 = 0,
        i = 0;

    for (; i0 < n0 && i1 < n1; ++i) {
      merged[i] = compare(array0[i0], array1[i1]) > 0 ? array1[i1++] : array0[i0++];
    }

    for (; i0 < n0; ++i0, ++i) {
      merged[i] = array0[i0];
    }

    for (; i1 < n1; ++i1, ++i) {
      merged[i] = array1[i1];
    }

    return merged;
  }

  function repeat(str, reps) {
    let s = '';

    while (--reps >= 0) s += str;

    return s;
  }

  function pad$2(str, length, padchar, align) {
    const c = padchar || ' ',
          s = str + '',
          n = length - s.length;
    return n <= 0 ? s : align === 'left' ? repeat(c, n) + s : align === 'center' ? repeat(c, ~~(n / 2)) + s + repeat(c, Math.ceil(n / 2)) : s + repeat(c, n);
  }
  /**
   * Return the numerical span of an array: the difference between
   * the last and first values.
   */


  function span(array) {
    return array && peek$1(array) - array[0] || 0;
  }

  function $(x) {
    return isArray(x) ? '[' + x.map($) + ']' : isObject(x) || isString(x) ? // Output valid JSON and JS source strings.
    // See http://timelessrepo.com/json-isnt-a-javascript-subset
    JSON.stringify(x).replace('\u2028', '\\u2028').replace('\u2029', '\\u2029') : x;
  }

  function toBoolean(_) {
    return _ == null || _ === '' ? null : !_ || _ === 'false' || _ === '0' ? false : !!_;
  }

  const defaultParser = _ => isNumber$1(_) ? _ : isDate$1(_) ? _ : Date.parse(_);

  function toDate(_, parser) {
    parser = parser || defaultParser;
    return _ == null || _ === '' ? null : parser(_);
  }

  function toString(_) {
    return _ == null || _ === '' ? null : _ + '';
  }

  function toSet(_) {
    const s = {},
          n = _.length;

    for (let i = 0; i < n; ++i) s[_[i]] = true;

    return s;
  }

  function truncate$1(str, length, align, ellipsis) {
    const e = ellipsis != null ? ellipsis : '\u2026',
          s = str + '',
          n = s.length,
          l = Math.max(0, length - e.length);
    return n <= length ? s : align === 'left' ? e + s.slice(n - l) : align === 'center' ? s.slice(0, Math.ceil(l / 2)) + e + s.slice(n - ~~(l / 2)) : s.slice(0, l) + e;
  }

  function visitArray(array, filter, visitor) {
    if (array) {
      if (filter) {
        const n = array.length;

        for (let i = 0; i < n; ++i) {
          const t = filter(array[i]);
          if (t) visitor(t, i, array);
        }
      } else {
        array.forEach(visitor);
      }
    }
  }

  var EOL = {},
      EOF = {},
      QUOTE = 34,
      NEWLINE = 10,
      RETURN = 13;

  function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function (name, i) {
      return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
  }

  function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function (row, i) {
      return f(object(row), i, columns);
    };
  } // Compute unique columns in order of discovery.


  function inferColumns(rows) {
    var columnSet = Object.create(null),
        columns = [];
    rows.forEach(function (row) {
      for (var column in row) {
        if (!(column in columnSet)) {
          columns.push(columnSet[column] = column);
        }
      }
    });
    return columns;
  }

  function pad$1(value, width) {
    var s = value + "",
        length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
  }

  function formatYear$1(year) {
    return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
  }

  function formatDate(date) {
    var hours = date.getUTCHours(),
        minutes = date.getUTCMinutes(),
        seconds = date.getUTCSeconds(),
        milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : formatYear$1(date.getUTCFullYear()) + "-" + pad$1(date.getUTCMonth() + 1, 2) + "-" + pad$1(date.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
  }

  function dsvFormat (delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
        DELIMITER = delimiter.charCodeAt(0);

    function parse(text, f) {
      var convert,
          columns,
          rows = parseRows(text, function (row, i) {
        if (convert) return convert(row, i - 1);
        columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
      });
      rows.columns = columns || [];
      return rows;
    }

    function parseRows(text, f) {
      var rows = [],
          // output rows
      N = text.length,
          I = 0,
          // current character index
      n = 0,
          // current line number
      t,
          // current token
      eof = N <= 0,
          // current token followed by EOF?
      eol = false; // current token followed by EOL?
      // Strip the trailing newline.

      if (text.charCodeAt(N - 1) === NEWLINE) --N;
      if (text.charCodeAt(N - 1) === RETURN) --N;

      function token() {
        if (eof) return EOF;
        if (eol) return eol = false, EOL; // Unescape quotes.

        var i,
            j = I,
            c;

        if (text.charCodeAt(j) === QUOTE) {
          while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);

          if ((i = I) >= N) eof = true;else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;else if (c === RETURN) {
            eol = true;
            if (text.charCodeAt(I) === NEWLINE) ++I;
          }
          return text.slice(j + 1, i - 1).replace(/""/g, "\"");
        } // Find next delimiter or newline.


        while (I < N) {
          if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;else if (c === RETURN) {
            eol = true;
            if (text.charCodeAt(I) === NEWLINE) ++I;
          } else if (c !== DELIMITER) continue;
          return text.slice(j, i);
        } // Return last token before EOF.


        return eof = true, text.slice(j, N);
      }

      while ((t = token()) !== EOF) {
        var row = [];

        while (t !== EOL && t !== EOF) row.push(t), t = token();

        if (f && (row = f(row, n++)) == null) continue;
        rows.push(row);
      }

      return rows;
    }

    function preformatBody(rows, columns) {
      return rows.map(function (row) {
        return columns.map(function (column) {
          return formatValue(row[column]);
        }).join(delimiter);
      });
    }

    function format(rows, columns) {
      if (columns == null) columns = inferColumns(rows);
      return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
    }

    function formatBody(rows, columns) {
      if (columns == null) columns = inferColumns(rows);
      return preformatBody(rows, columns).join("\n");
    }

    function formatRows(rows) {
      return rows.map(formatRow).join("\n");
    }

    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }

    function formatValue(value) {
      return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
    }

    return {
      parse: parse,
      parseRows: parseRows,
      format: format,
      formatBody: formatBody,
      formatRows: formatRows,
      formatRow: formatRow,
      formatValue: formatValue
    };
  }

  function identity$5 (x) {
    return x;
  }

  function transform$3 (transform) {
    if (transform == null) return identity$5;
    var x0,
        y0,
        kx = transform.scale[0],
        ky = transform.scale[1],
        dx = transform.translate[0],
        dy = transform.translate[1];
    return function (input, i) {
      if (!i) x0 = y0 = 0;
      var j = 2,
          n = input.length,
          output = new Array(n);
      output[0] = (x0 += input[0]) * kx + dx;
      output[1] = (y0 += input[1]) * ky + dy;

      while (j < n) output[j] = input[j], ++j;

      return output;
    };
  }

  function reverse$1 (array, n) {
    var t,
        j = array.length,
        i = j - n;

    while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
  }

  function feature (topology, o) {
    if (typeof o === "string") o = topology.objects[o];
    return o.type === "GeometryCollection" ? {
      type: "FeatureCollection",
      features: o.geometries.map(function (o) {
        return feature$1(topology, o);
      })
    } : feature$1(topology, o);
  }

  function feature$1(topology, o) {
    var id = o.id,
        bbox = o.bbox,
        properties = o.properties == null ? {} : o.properties,
        geometry = object$1(topology, o);
    return id == null && bbox == null ? {
      type: "Feature",
      properties: properties,
      geometry: geometry
    } : bbox == null ? {
      type: "Feature",
      id: id,
      properties: properties,
      geometry: geometry
    } : {
      type: "Feature",
      id: id,
      bbox: bbox,
      properties: properties,
      geometry: geometry
    };
  }

  function object$1(topology, o) {
    var transformPoint = transform$3(topology.transform),
        arcs = topology.arcs;

    function arc(i, points) {
      if (points.length) points.pop();

      for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
        points.push(transformPoint(a[k], k));
      }

      if (i < 0) reverse$1(points, n);
    }

    function point(p) {
      return transformPoint(p);
    }

    function line(arcs) {
      var points = [];

      for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);

      if (points.length < 2) points.push(points[0]); // This should never happen per the specification.

      return points;
    }

    function ring(arcs) {
      var points = line(arcs);

      while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.


      return points;
    }

    function polygon(arcs) {
      return arcs.map(ring);
    }

    function geometry(o) {
      var type = o.type,
          coordinates;

      switch (type) {
        case "GeometryCollection":
          return {
            type: type,
            geometries: o.geometries.map(geometry)
          };

        case "Point":
          coordinates = point(o.coordinates);
          break;

        case "MultiPoint":
          coordinates = o.coordinates.map(point);
          break;

        case "LineString":
          coordinates = line(o.arcs);
          break;

        case "MultiLineString":
          coordinates = o.arcs.map(line);
          break;

        case "Polygon":
          coordinates = polygon(o.arcs);
          break;

        case "MultiPolygon":
          coordinates = o.arcs.map(polygon);
          break;

        default:
          return null;
      }

      return {
        type: type,
        coordinates: coordinates
      };
    }

    return geometry(o);
  }

  function stitch (topology, arcs) {
    var stitchedArcs = {},
        fragmentByStart = {},
        fragmentByEnd = {},
        fragments = [],
        emptyIndex = -1; // Stitch empty arcs first, since they may be subsumed by other arcs.

    arcs.forEach(function (i, j) {
      var arc = topology.arcs[i < 0 ? ~i : i],
          t;

      if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
        t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
      }
    });
    arcs.forEach(function (i) {
      var e = ends(i),
          start = e[0],
          end = e[1],
          f,
          g;

      if (f = fragmentByEnd[start]) {
        delete fragmentByEnd[f.end];
        f.push(i);
        f.end = end;

        if (g = fragmentByStart[end]) {
          delete fragmentByStart[g.start];
          var fg = g === f ? f : f.concat(g);
          fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
        } else {
          fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        }
      } else if (f = fragmentByStart[end]) {
        delete fragmentByStart[f.start];
        f.unshift(i);
        f.start = start;

        if (g = fragmentByEnd[start]) {
          delete fragmentByEnd[g.end];
          var gf = g === f ? f : g.concat(f);
          fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
        } else {
          fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        }
      } else {
        f = [i];
        fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
      }
    });

    function ends(i) {
      var arc = topology.arcs[i < 0 ? ~i : i],
          p0 = arc[0],
          p1;
      if (topology.transform) p1 = [0, 0], arc.forEach(function (dp) {
        p1[0] += dp[0], p1[1] += dp[1];
      });else p1 = arc[arc.length - 1];
      return i < 0 ? [p1, p0] : [p0, p1];
    }

    function flush(fragmentByEnd, fragmentByStart) {
      for (var k in fragmentByEnd) {
        var f = fragmentByEnd[k];
        delete fragmentByStart[f.start];
        delete f.start;
        delete f.end;
        f.forEach(function (i) {
          stitchedArcs[i < 0 ? ~i : i] = 1;
        });
        fragments.push(f);
      }
    }

    flush(fragmentByEnd, fragmentByStart);
    flush(fragmentByStart, fragmentByEnd);
    arcs.forEach(function (i) {
      if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]);
    });
    return fragments;
  }

  function mesh (topology) {
    return object$1(topology, meshArcs.apply(this, arguments));
  }
  function meshArcs(topology, object, filter) {
    var arcs, i, n;
    if (arguments.length > 1) arcs = extractArcs(topology, object, filter);else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
    return {
      type: "MultiLineString",
      arcs: stitch(topology, arcs)
    };
  }

  function extractArcs(topology, object, filter) {
    var arcs = [],
        geomsByArc = [],
        geom;

    function extract0(i) {
      var j = i < 0 ? ~i : i;
      (geomsByArc[j] || (geomsByArc[j] = [])).push({
        i: i,
        g: geom
      });
    }

    function extract1(arcs) {
      arcs.forEach(extract0);
    }

    function extract2(arcs) {
      arcs.forEach(extract1);
    }

    function extract3(arcs) {
      arcs.forEach(extract2);
    }

    function geometry(o) {
      switch (geom = o, o.type) {
        case "GeometryCollection":
          o.geometries.forEach(geometry);
          break;

        case "LineString":
          extract1(o.arcs);
          break;

        case "MultiLineString":
        case "Polygon":
          extract2(o.arcs);
          break;

        case "MultiPolygon":
          extract3(o.arcs);
          break;
      }
    }

    geometry(object);
    geomsByArc.forEach(filter == null ? function (geoms) {
      arcs.push(geoms[0].i);
    } : function (geoms) {
      if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i);
    });
    return arcs;
  }

  function ascending$2 (a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }

  function bisector$1 (f) {
    let delta = f;
    let compare = f;

    if (f.length === 1) {
      delta = (d, x) => f(d) - x;

      compare = ascendingComparator$1(f);
    }

    function left(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;

      while (lo < hi) {
        const mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
      }

      return lo;
    }

    function right(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;

      while (lo < hi) {
        const mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
      }

      return lo;
    }

    function center(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      const i = left(a, x, lo, hi - 1);
      return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }

    return {
      left,
      center,
      right
    };
  }

  function ascendingComparator$1(f) {
    return (d, x) => ascending$2(f(d), x);
  }

  function number$6 (x) {
    return x === null ? NaN : +x;
  }
  function* numbers$2(values, valueof) {
    if (valueof === undefined) {
      for (let value of values) {
        if (value != null && (value = +value) >= value) {
          yield value;
        }
      }
    } else {
      let index = -1;

      for (let value of values) {
        if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
          yield value;
        }
      }
    }
  }

  const ascendingBisect = bisector$1(ascending$2);
  const bisectRight$1 = ascendingBisect.right;
  const bisectLeft$1 = ascendingBisect.left;
  bisector$1(number$6).center;

  function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;

    if (valueof === undefined) {
      for (let value of values) {
        if (value != null && (value = +value) >= value) {
          delta = value - mean;
          mean += delta / ++count;
          sum += delta * (value - mean);
        }
      }
    } else {
      let index = -1;

      for (let value of values) {
        if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
          delta = value - mean;
          mean += delta / ++count;
          sum += delta * (value - mean);
        }
      }
    }

    if (count > 1) return sum / (count - 1);
  }

  function deviation(values, valueof) {
    const v = variance(values, valueof);
    return v ? Math.sqrt(v) : v;
  }

  // https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
  class Adder {
    constructor() {
      this._partials = new Float64Array(32);
      this._n = 0;
    }

    add(x) {
      const p = this._partials;
      let i = 0;

      for (let j = 0; j < this._n && j < 32; j++) {
        const y = p[j],
              hi = x + y,
              lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
        if (lo) p[i++] = lo;
        x = hi;
      }

      p[i] = x;
      this._n = i + 1;
      return this;
    }

    valueOf() {
      const p = this._partials;
      let n = this._n,
          x,
          y,
          lo,
          hi = 0;

      if (n > 0) {
        hi = p[--n];

        while (n > 0) {
          x = hi;
          y = p[--n];
          hi = x + y;
          lo = y - (hi - x);
          if (lo) break;
        }

        if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
          y = lo * 2;
          x = hi + y;
          if (y == x - hi) hi = x;
        }
      }

      return hi;
    }

  }

  function permute (source, keys) {
    return Array.from(keys, key => source[key]);
  }

  var e10 = Math.sqrt(50),
      e5 = Math.sqrt(10),
      e2 = Math.sqrt(2);
  function ticks (start, stop, count) {
    var reverse,
        i = -1,
        n,
        ticks,
        step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [start];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

    if (step > 0) {
      let r0 = Math.round(start / step),
          r1 = Math.round(stop / step);
      if (r0 * step < start) ++r0;
      if (r1 * step > stop) --r1;
      ticks = new Array(n = r1 - r0 + 1);

      while (++i < n) ticks[i] = (r0 + i) * step;
    } else {
      step = -step;
      let r0 = Math.round(start * step),
          r1 = Math.round(stop * step);
      if (r0 / step < start) ++r0;
      if (r1 / step > stop) --r1;
      ticks = new Array(n = r1 - r0 + 1);

      while (++i < n) ticks[i] = (r0 + i) / step;
    }

    if (reverse) ticks.reverse();
    return ticks;
  }
  function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count),
        power = Math.floor(Math.log(step) / Math.LN10),
        error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
  }
  function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count),
        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
        error = step0 / step1;
    if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
  }

  function max$2(values, valueof) {
    let max;

    if (valueof === undefined) {
      for (const value of values) {
        if (value != null && (max < value || max === undefined && value >= value)) {
          max = value;
        }
      }
    } else {
      let index = -1;

      for (let value of values) {
        if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) {
          max = value;
        }
      }
    }

    return max;
  }

  function min$2(values, valueof) {
    let min;

    if (valueof === undefined) {
      for (const value of values) {
        if (value != null && (min > value || min === undefined && value >= value)) {
          min = value;
        }
      }
    } else {
      let index = -1;

      for (let value of values) {
        if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) {
          min = value;
        }
      }
    }

    return min;
  }

  // ISC license, Copyright 2018 Vladimir Agafonkin.

  function quickselect(array, k, left = 0, right = array.length - 1, compare = ascending$2) {
    while (right > left) {
      if (right - left > 600) {
        const n = right - left + 1;
        const m = k - left + 1;
        const z = Math.log(n);
        const s = 0.5 * Math.exp(2 * z / 3);
        const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
        const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
        const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
        quickselect(array, k, newLeft, newRight, compare);
      }

      const t = array[k];
      let i = left;
      let j = right;
      swap$1(array, left, k);
      if (compare(array[right], t) > 0) swap$1(array, left, right);

      while (i < j) {
        swap$1(array, i, j), ++i, --j;

        while (compare(array[i], t) < 0) ++i;

        while (compare(array[j], t) > 0) --j;
      }

      if (compare(array[left], t) === 0) swap$1(array, left, j);else ++j, swap$1(array, j, right);
      if (j <= k) left = j + 1;
      if (k <= j) right = j - 1;
    }

    return array;
  }

  function swap$1(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
  }

  function quantile$1(values, p, valueof) {
    values = Float64Array.from(numbers$2(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return min$2(values);
    if (p >= 1) return max$2(values);
    var n,
        i = (n - 1) * p,
        i0 = Math.floor(i),
        value0 = max$2(quickselect(values, i0).subarray(0, i0 + 1)),
        value1 = min$2(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
  }
  function quantileSorted(values, p, valueof = number$6) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n,
        i = (n - 1) * p,
        i0 = Math.floor(i),
        value0 = +valueof(values[i0], i0, values),
        value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
  }

  function mean(values, valueof) {
    let count = 0;
    let sum = 0;

    if (valueof === undefined) {
      for (let value of values) {
        if (value != null && (value = +value) >= value) {
          ++count, sum += value;
        }
      }
    } else {
      let index = -1;

      for (let value of values) {
        if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
          ++count, sum += value;
        }
      }
    }

    if (count) return sum / count;
  }

  function median (values, valueof) {
    return quantile$1(values, 0.5, valueof);
  }

  function* flatten(arrays) {
    for (const array of arrays) {
      yield* array;
    }
  }

  function merge$2(arrays) {
    return Array.from(flatten(arrays));
  }

  function range$1$1 (start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1,
        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
        range = new Array(n);

    while (++i < n) {
      range[i] = start + i * step;
    }

    return range;
  }

  function sum(values, valueof) {
    let sum = 0;

    if (valueof === undefined) {
      for (let value of values) {
        if (value = +value) {
          sum += value;
        }
      }
    } else {
      let index = -1;

      for (let value of values) {
        if (value = +valueof(value, ++index, values)) {
          sum += value;
        }
      }
    }

    return sum;
  }

  // Computes the decimal coefficient and exponent of the specified number x with
  // significant digits p, where x is positive and p is in [1, 21] or undefined.
  // For example, formatDecimal(1.23) returns ["123", 0].
  function formatDecimal (x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity

    var i,
        coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).

    return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
  }

  function exponent (x) {
    return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
  }

  function formatGroup (grouping, thousands) {
    return function (value, width) {
      var i = value.length,
          t = [],
          j = 0,
          g = grouping[0],
          length = 0;

      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = grouping[j = (j + 1) % grouping.length];
      }

      return t.reverse().join(thousands);
    };
  }

  function formatNumerals (numerals) {
    return function (value) {
      return value.replace(/[0-9]/g, function (i) {
        return numerals[+i];
      });
    };
  }

  // [[fill]align][sign][symbol][0][width][,][.precision][~][type]
  var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?(\*(\d+(\.\d*)?))?$/i;
  function formatSpecifier(specifier) {
    return new FormatSpecifier(specifier);
  }
  formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

  function FormatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    this.fill = match[1] || " ";
    this.align = match[2] || ">";
    this.sign = match[3] || "-";
    this.symbol = match[4] || "";
    this.zero = !!match[5];
    this.width = match[6] && +match[6];
    this.comma = !!match[7];
    this.precision = match[8] && +match[8].slice(1);
    this.trim = !!match[9];
    this.type = match[10] || "";
    this.scale = parseFloat(match[12]) || 1;
  }

  FormatSpecifier.prototype.toString = function () {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type + "*" + this.scale;
  };

  // Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
  function formatTrim (s) {
    out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
      switch (s[i]) {
        case ".":
          i0 = i1 = i;
          break;

        case "0":
          if (i0 === 0) i0 = i;
          i1 = i;
          break;

        default:
          if (i0 > 0) {
            if (!+s[i]) break out;
            i0 = 0;
          }

          break;
      }
    }

    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
  }

  var prefixExponent;
  function formatPrefixAuto (x, p) {
    var d = formatDecimal(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1],
        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
        n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
  }

  function formatRounded (x, p) {
    var d = formatDecimal(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
  }

  var formatTypes = {
    "%": function (x, p) {
      return (x * 100).toFixed(p);
    },
    "b": function (x) {
      return Math.round(x).toString(2);
    },
    "c": function (x) {
      return x + "";
    },
    "d": function (x) {
      return Math.round(x).toString(10);
    },
    "e": function (x, p) {
      return x.toExponential(p);
    },
    "f": function (x, p) {
      return x.toFixed(p);
    },
    "g": function (x, p) {
      return x.toPrecision(p);
    },
    "o": function (x) {
      return Math.round(x).toString(8);
    },
    "p": function (x, p) {
      return formatRounded(x * 100, p);
    },
    "r": formatRounded,
    "s": formatPrefixAuto,
    "X": function (x) {
      return Math.round(x).toString(16).toUpperCase();
    },
    "x": function (x) {
      return Math.round(x).toString(16);
    }
  };

  function identity$4 (x) {
    return x;
  }

  var prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
  function formatLocale$1 (locale) {
    var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$4,
        currency = locale.currency,
        decimal = locale.decimal,
        numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$4,
        percent = locale.percent || "%";

    function newFormat(specifier) {
      specifier = formatSpecifier(specifier);
      var fill = specifier.fill,
          align = specifier.align,
          sign = specifier.sign,
          symbol = specifier.symbol,
          zero = specifier.zero,
          width = specifier.width,
          comma = specifier.comma,
          precision = specifier.precision,
          trim = specifier.trim,
          type = specifier.type,
          scale = specifier.scale; // The "n" type is an alias for ",g".

      if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
      else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.

      if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
      // For SI-prefix, the suffix is lazily computed.

      var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
          suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : ""; // What format function should we use?
      // Is this an integer type?
      // Can this type generate exponential notation?

      var formatType = formatTypes[type],
          maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
      // or clamp the specified precision to the supported range.
      // For significant precision, it must be in [1, 21].
      // For fixed precision, it must be in [0, 20].

      precision = precision == null ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));

      function format(value) {
        var valuePrefix = prefix,
            valueSuffix = suffix,
            i,
            n,
            c;
        value *= scale;

        if (type === "c") {
          valueSuffix = formatType(value) + valueSuffix;
          value = "";
        } else {
          value = +value; // Perform the initial formatting.

          var valueNegative = value < 0;
          value = formatType(Math.abs(value), precision); // Trim insignificant zeros.

          if (trim) value = formatTrim(value); // If a negative value rounds to zero during formatting, treat as positive.

          if (valueNegative && +value === 0) valueNegative = false; // Compute the prefix and suffix.

          valuePrefix = (valueNegative ? sign === "(" ? sign : "-" : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
          valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
          // grouped, and fractional or exponential “suffix” part that is not.

          if (maybeSuffix) {
            i = -1, n = value.length;

            while (++i < n) {
              if (c = value.charCodeAt(i), 48 > c || c > 57) {
                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                value = value.slice(0, i);
                break;
              }
            }
          }
        } // If the fill character is not "0", grouping is applied before padding.


        if (comma && !zero) value = group(value, Infinity); // Compute the padding.

        var length = valuePrefix.length + value.length + valueSuffix.length,
            padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.

        if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.

        switch (align) {
          case "<":
            value = valuePrefix + value + valueSuffix + padding;
            break;

          case "=":
            value = valuePrefix + padding + value + valueSuffix;
            break;

          case "^":
            value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
            break;

          default:
            value = padding + valuePrefix + value + valueSuffix;
            break;
        }

        return numerals(value);
      }

      format.toString = function () {
        return specifier + "";
      };

      return format;
    }

    function formatPrefix(specifier, value) {
      var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
          e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
          k = Math.pow(10, -e),
          prefix = prefixes[8 + e / 3];
      return function (value) {
        return f(k * value) + prefix;
      };
    }

    return {
      format: newFormat,
      formatPrefix: formatPrefix
    };
  }

  var locale$2;
  var format$3;
  var formatPrefix;
  defaultLocale$2({
    decimal: ".",
    thousands: ",",
    grouping: [3],
    currency: ["$", ""]
  });
  function defaultLocale$2(definition) {
    locale$2 = formatLocale$1(definition);
    format$3 = locale$2.format;
    formatPrefix = locale$2.formatPrefix;
    return locale$2;
  }

  function precisionFixed (step) {
    return Math.max(0, -exponent(Math.abs(step)));
  }

  function precisionPrefix (step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
  }

  function precisionRound (step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, exponent(max) - exponent(step)) + 1;
  }

  var t0$2 = new Date(),
      t1$1 = new Date();
  function newInterval(floori, offseti, count, field) {
    function interval(date) {
      return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }

    interval.floor = function (date) {
      return floori(date = new Date(+date)), date;
    };

    interval.ceil = function (date) {
      return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };

    interval.round = function (date) {
      var d0 = interval(date),
          d1 = interval.ceil(date);
      return date - d0 < d1 - date ? d0 : d1;
    };

    interval.offset = function (date, step) {
      return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };

    interval.range = function (start, stop, step) {
      var range = [],
          previous;
      start = interval.ceil(start);
      step = step == null ? 1 : Math.floor(step);
      if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date

      do range.push(previous = new Date(+start)), offseti(start, step), floori(start); while (previous < start && start < stop);

      return range;
    };

    interval.filter = function (test) {
      return newInterval(function (date) {
        if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
      }, function (date, step) {
        if (date >= date) {
          if (step < 0) while (++step <= 0) {
            while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty

          } else while (--step >= 0) {
            while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty

          }
        }
      });
    };

    if (count) {
      interval.count = function (start, end) {
        t0$2.setTime(+start), t1$1.setTime(+end);
        floori(t0$2), floori(t1$1);
        return Math.floor(count(t0$2, t1$1));
      };

      interval.every = function (step) {
        step = Math.floor(step);
        return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function (d) {
          return field(d) % step === 0;
        } : function (d) {
          return interval.count(0, d) % step === 0;
        });
      };
    }

    return interval;
  }

  var millisecond = newInterval(function () {// noop
  }, function (date, step) {
    date.setTime(+date + step);
  }, function (start, end) {
    return end - start;
  }); // An optimized implementation for this simple case.

  millisecond.every = function (k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return newInterval(function (date) {
      date.setTime(Math.floor(date / k) * k);
    }, function (date, step) {
      date.setTime(+date + step * k);
    }, function (start, end) {
      return (end - start) / k;
    });
  };

  var durationSecond$2 = 1e3;
  var durationMinute$2 = 6e4;
  var durationHour$2 = 36e5;
  var durationDay$2 = 864e5;
  var durationWeek$2 = 6048e5;

  var second = newInterval(function (date) {
    date.setTime(date - date.getMilliseconds());
  }, function (date, step) {
    date.setTime(+date + step * durationSecond$2);
  }, function (start, end) {
    return (end - start) / durationSecond$2;
  }, function (date) {
    return date.getUTCSeconds();
  });

  var minute = newInterval(function (date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$2);
  }, function (date, step) {
    date.setTime(+date + step * durationMinute$2);
  }, function (start, end) {
    return (end - start) / durationMinute$2;
  }, function (date) {
    return date.getMinutes();
  });

  var hour = newInterval(function (date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$2 - date.getMinutes() * durationMinute$2);
  }, function (date, step) {
    date.setTime(+date + step * durationHour$2);
  }, function (start, end) {
    return (end - start) / durationHour$2;
  }, function (date) {
    return date.getHours();
  });

  var day = newInterval(date => date.setHours(0, 0, 0, 0), (date, step) => date.setDate(date.getDate() + step), (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$2) / durationDay$2, date => date.getDate() - 1);

  function weekday$1(i) {
    return newInterval(function (date) {
      date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
      date.setHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setDate(date.getDate() + step * 7);
    }, function (start, end) {
      return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$2) / durationWeek$2;
    });
  }

  var sunday = weekday$1(0);
  var monday = weekday$1(1);
  weekday$1(2);
  weekday$1(3);
  var thursday = weekday$1(4);
  weekday$1(5);
  weekday$1(6);

  var month = newInterval(function (date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setMonth(date.getMonth() + step);
  }, function (start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
  }, function (date) {
    return date.getMonth();
  });

  var year = newInterval(function (date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setFullYear(date.getFullYear() + step);
  }, function (start, end) {
    return end.getFullYear() - start.getFullYear();
  }, function (date) {
    return date.getFullYear();
  }); // An optimized implementation for this simple case.

  year.every = function (k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function (date) {
      date.setFullYear(Math.floor(date.getFullYear() / k) * k);
      date.setMonth(0, 1);
      date.setHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setFullYear(date.getFullYear() + step * k);
    });
  };

  var utcMinute = newInterval(function (date) {
    date.setUTCSeconds(0, 0);
  }, function (date, step) {
    date.setTime(+date + step * durationMinute$2);
  }, function (start, end) {
    return (end - start) / durationMinute$2;
  }, function (date) {
    return date.getUTCMinutes();
  });

  var utcHour = newInterval(function (date) {
    date.setUTCMinutes(0, 0, 0);
  }, function (date, step) {
    date.setTime(+date + step * durationHour$2);
  }, function (start, end) {
    return (end - start) / durationHour$2;
  }, function (date) {
    return date.getUTCHours();
  });

  var utcDay = newInterval(function (date) {
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCDate(date.getUTCDate() + step);
  }, function (start, end) {
    return (end - start) / durationDay$2;
  }, function (date) {
    return date.getUTCDate() - 1;
  });

  function utcWeekday(i) {
    return newInterval(function (date) {
      date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
      date.setUTCHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setUTCDate(date.getUTCDate() + step * 7);
    }, function (start, end) {
      return (end - start) / durationWeek$2;
    });
  }

  var utcSunday = utcWeekday(0);
  var utcMonday = utcWeekday(1);
  utcWeekday(2);
  utcWeekday(3);
  var utcThursday = utcWeekday(4);
  utcWeekday(5);
  utcWeekday(6);

  var utcMonth = newInterval(function (date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
  }, function (start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
  }, function (date) {
    return date.getUTCMonth();
  });

  var utcYear = newInterval(function (date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
  }, function (start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
  }, function (date) {
    return date.getUTCFullYear();
  }); // An optimized implementation for this simple case.

  utcYear.every = function (k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function (date) {
      date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
      date.setUTCMonth(0, 1);
      date.setUTCHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
  };

  const YEAR = 'year';
  const QUARTER = 'quarter';
  const MONTH = 'month';
  const WEEK = 'week';
  const DATE = 'date';
  const DAY = 'day';
  const DAYOFYEAR = 'dayofyear';
  const HOURS = 'hours';
  const MINUTES = 'minutes';
  const SECONDS = 'seconds';
  const MILLISECONDS = 'milliseconds';
  const TIME_UNITS = [YEAR, QUARTER, MONTH, WEEK, DATE, DAY, DAYOFYEAR, HOURS, MINUTES, SECONDS, MILLISECONDS];
  const UNITS = TIME_UNITS.reduce((o, u, i) => (o[u] = 1 + i, o), {});

  function timeUnits(units) {
    const u = array$5(units).slice(),
          m = {}; // check validity

    if (!u.length) error('Missing time unit.');
    u.forEach(unit => {
      if (has$1(UNITS, unit)) {
        m[unit] = 1;
      } else {
        error(`Invalid time unit: ${unit}.`);
      }
    });
    const numTypes = (m[WEEK] || m[DAY] ? 1 : 0) + (m[QUARTER] || m[MONTH] || m[DATE] ? 1 : 0) + (m[DAYOFYEAR] ? 1 : 0);

    if (numTypes > 1) {
      error(`Incompatible time units: ${units}`);
    } // ensure proper sort order


    u.sort((a, b) => UNITS[a] - UNITS[b]);
    return u;
  }

  const defaultSpecifiers = {
    [YEAR]: '%Y ',
    [QUARTER]: 'Q%q ',
    [MONTH]: '%b ',
    [DATE]: '%d ',
    [WEEK]: 'W%U ',
    [DAY]: '%a ',
    [DAYOFYEAR]: '%j ',
    [HOURS]: '%H:00',
    [MINUTES]: '00:%M',
    [SECONDS]: ':%S',
    [MILLISECONDS]: '.%L',
    [`${YEAR}-${MONTH}`]: '%Y-%m ',
    [`${YEAR}-${MONTH}-${DATE}`]: '%Y-%m-%d ',
    [`${HOURS}-${MINUTES}`]: '%H:%M'
  };

  function timeUnitSpecifier(units, specifiers) {
    const s = extend$1({}, defaultSpecifiers, specifiers),
          u = timeUnits(units),
          n = u.length;
    let fmt = '',
        start = 0,
        end,
        key;

    for (start = 0; start < n;) {
      for (end = u.length; end > start; --end) {
        key = u.slice(start, end).join('-');

        if (s[key] != null) {
          fmt += s[key];
          start = end;
          break;
        }
      }
    }

    return fmt.trim();
  }

  const t0$1 = new Date();

  function localYear(y) {
    t0$1.setFullYear(y);
    t0$1.setMonth(0);
    t0$1.setDate(1);
    t0$1.setHours(0, 0, 0, 0);
    return t0$1;
  }

  function dayofyear(d) {
    return localDayOfYear(new Date(d));
  }

  function week(d) {
    return localWeekNum(new Date(d));
  }

  function localDayOfYear(d) {
    return day.count(localYear(d.getFullYear()) - 1, d);
  }

  function localWeekNum(d) {
    return sunday.count(localYear(d.getFullYear()) - 1, d);
  }

  function localFirst(y) {
    return localYear(y).getDay();
  }

  function localDate$1(y, m, d, H, M, S, L) {
    if (0 <= y && y < 100) {
      const date = new Date(-1, m, d, H, M, S, L);
      date.setFullYear(y);
      return date;
    }

    return new Date(y, m, d, H, M, S, L);
  }

  function utcdayofyear(d) {
    return utcDayOfYear(new Date(d));
  }

  function utcweek(d) {
    return utcWeekNum(new Date(d));
  }

  function utcDayOfYear(d) {
    const y = Date.UTC(d.getUTCFullYear(), 0, 1);
    return utcDay.count(y - 1, d);
  }

  function utcWeekNum(d) {
    const y = Date.UTC(d.getUTCFullYear(), 0, 1);
    return utcSunday.count(y - 1, d);
  }

  function utcFirst(y) {
    t0$1.setTime(Date.UTC(y, 0, 1));
    return t0$1.getUTCDay();
  }

  function utcDate$1(y, m, d, H, M, S, L) {
    if (0 <= y && y < 100) {
      const date = new Date(Date.UTC(-1, m, d, H, M, S, L));
      date.setUTCFullYear(d.y);
      return date;
    }

    return new Date(Date.UTC(y, m, d, H, M, S, L));
  }

  function floor(units, step, get, inv, newDate) {
    const s = step || 1,
          b = peek$1(units),
          _ = (unit, p, key) => {
      key = key || unit;
      return getUnit(get[key], inv[key], unit === b && s, p);
    };

    const t = new Date(),
          u = toSet(units),
          y = u[YEAR] ? _(YEAR) : constant$4(2012),
          m = u[MONTH] ? _(MONTH) : u[QUARTER] ? _(QUARTER) : zero$2,
          d = u[WEEK] && u[DAY] ? _(DAY, 1, WEEK + DAY) : u[WEEK] ? _(WEEK, 1) : u[DAY] ? _(DAY, 1) : u[DATE] ? _(DATE, 1) : u[DAYOFYEAR] ? _(DAYOFYEAR, 1) : one$2,
          H = u[HOURS] ? _(HOURS) : zero$2,
          M = u[MINUTES] ? _(MINUTES) : zero$2,
          S = u[SECONDS] ? _(SECONDS) : zero$2,
          L = u[MILLISECONDS] ? _(MILLISECONDS) : zero$2;
    return function (v) {
      t.setTime(+v);
      const year = y(t);
      return newDate(year, m(t), d(t, year), H(t), M(t), S(t), L(t));
    };
  }

  function getUnit(f, inv, step, phase) {
    const u = step <= 1 ? f : phase ? (d, y) => phase + step * Math.floor((f(d, y) - phase) / step) : (d, y) => step * Math.floor(f(d, y) / step);
    return inv ? (d, y) => inv(u(d, y), y) : u;
  } // returns the day of the year based on week number, day of week,
  // and the day of the week for the first day of the year


  function weekday(week, day, firstDay) {
    return day + week * 7 - (firstDay + 6) % 7;
  } // -- LOCAL TIME --


  const localGet = {
    [YEAR]: d => d.getFullYear(),
    [QUARTER]: d => Math.floor(d.getMonth() / 3),
    [MONTH]: d => d.getMonth(),
    [DATE]: d => d.getDate(),
    [HOURS]: d => d.getHours(),
    [MINUTES]: d => d.getMinutes(),
    [SECONDS]: d => d.getSeconds(),
    [MILLISECONDS]: d => d.getMilliseconds(),
    [DAYOFYEAR]: d => localDayOfYear(d),
    [WEEK]: d => localWeekNum(d),
    [WEEK + DAY]: (d, y) => weekday(localWeekNum(d), d.getDay(), localFirst(y)),
    [DAY]: (d, y) => weekday(1, d.getDay(), localFirst(y))
  };
  const localInv = {
    [QUARTER]: q => 3 * q,
    [WEEK]: (w, y) => weekday(w, 0, localFirst(y))
  };

  function timeFloor(units, step) {
    return floor(units, step || 1, localGet, localInv, localDate$1);
  } // -- UTC TIME --


  const utcGet = {
    [YEAR]: d => d.getUTCFullYear(),
    [QUARTER]: d => Math.floor(d.getUTCMonth() / 3),
    [MONTH]: d => d.getUTCMonth(),
    [DATE]: d => d.getUTCDate(),
    [HOURS]: d => d.getUTCHours(),
    [MINUTES]: d => d.getUTCMinutes(),
    [SECONDS]: d => d.getUTCSeconds(),
    [MILLISECONDS]: d => d.getUTCMilliseconds(),
    [DAYOFYEAR]: d => utcDayOfYear(d),
    [WEEK]: d => utcWeekNum(d),
    [DAY]: (d, y) => weekday(1, d.getUTCDay(), utcFirst(y)),
    [WEEK + DAY]: (d, y) => weekday(utcWeekNum(d), d.getUTCDay(), utcFirst(y))
  };
  const utcInv = {
    [QUARTER]: q => 3 * q,
    [WEEK]: (w, y) => weekday(w, 0, utcFirst(y))
  };

  function utcFloor(units, step) {
    return floor(units, step || 1, utcGet, utcInv, utcDate$1);
  }

  const timeIntervals = {
    [YEAR]: year,
    [QUARTER]: month.every(3),
    [MONTH]: month,
    [WEEK]: sunday,
    [DATE]: day,
    [DAY]: day,
    [DAYOFYEAR]: day,
    [HOURS]: hour,
    [MINUTES]: minute,
    [SECONDS]: second,
    [MILLISECONDS]: millisecond
  };
  const utcIntervals = {
    [YEAR]: utcYear,
    [QUARTER]: utcMonth.every(3),
    [MONTH]: utcMonth,
    [WEEK]: utcSunday,
    [DATE]: utcDay,
    [DAY]: utcDay,
    [DAYOFYEAR]: utcDay,
    [HOURS]: utcHour,
    [MINUTES]: utcMinute,
    [SECONDS]: second,
    [MILLISECONDS]: millisecond
  };

  function timeInterval(unit) {
    return timeIntervals[unit];
  }

  function utcInterval(unit) {
    return utcIntervals[unit];
  }

  function offset$3(ival, date, step) {
    return ival ? ival.offset(date, step) : undefined;
  }

  function timeOffset(unit, date, step) {
    return offset$3(timeInterval(unit), date, step);
  }

  function utcOffset(unit, date, step) {
    return offset$3(utcInterval(unit), date, step);
  }

  function sequence$1(ival, start, stop, step) {
    return ival ? ival.range(start, stop, step) : undefined;
  }

  function timeSequence(unit, start, stop, step) {
    return sequence$1(timeInterval(unit), start, stop, step);
  }

  function utcSequence(unit, start, stop, step) {
    return sequence$1(utcInterval(unit), start, stop, step);
  }

  const durationSecond$1 = 1000,
        durationMinute$1 = durationSecond$1 * 60,
        durationHour$1 = durationMinute$1 * 60,
        durationDay$1 = durationHour$1 * 24,
        durationWeek$1 = durationDay$1 * 7,
        durationMonth$1 = durationDay$1 * 30,
        durationYear$1 = durationDay$1 * 365;
  const Milli = [YEAR, MONTH, DATE, HOURS, MINUTES, SECONDS, MILLISECONDS],
        Seconds = Milli.slice(0, -1),
        Minutes = Seconds.slice(0, -1),
        Hours = Minutes.slice(0, -1),
        Day = Hours.slice(0, -1),
        Week = [YEAR, WEEK],
        Month = [YEAR, MONTH],
        Year = [YEAR];
  const intervals = [[Seconds, 1, durationSecond$1], [Seconds, 5, 5 * durationSecond$1], [Seconds, 15, 15 * durationSecond$1], [Seconds, 30, 30 * durationSecond$1], [Minutes, 1, durationMinute$1], [Minutes, 5, 5 * durationMinute$1], [Minutes, 15, 15 * durationMinute$1], [Minutes, 30, 30 * durationMinute$1], [Hours, 1, durationHour$1], [Hours, 3, 3 * durationHour$1], [Hours, 6, 6 * durationHour$1], [Hours, 12, 12 * durationHour$1], [Day, 1, durationDay$1], [Week, 1, durationWeek$1], [Month, 1, durationMonth$1], [Month, 3, 3 * durationMonth$1], [Year, 1, durationYear$1]];

  function bin$1(opt) {
    const ext = opt.extent,
          max = opt.maxbins || 40,
          target = Math.abs(span(ext)) / max;
    let i = bisector$1(i => i[2]).right(intervals, target),
        units,
        step;

    if (i === intervals.length) {
      units = Year, step = tickStep(ext[0] / durationYear$1, ext[1] / durationYear$1, max);
    } else if (i) {
      i = intervals[target / intervals[i - 1][2] < intervals[i][2] / target ? i - 1 : i];
      units = i[0];
      step = i[1];
    } else {
      units = Milli;
      step = Math.max(tickStep(ext[0], ext[1], max), 1);
    }

    return {
      units,
      step
    };
  }

  function localDate(d) {
    if (0 <= d.y && d.y < 100) {
      var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
      date.setFullYear(d.y);
      return date;
    }

    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
  }

  function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
      var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
      date.setUTCFullYear(d.y);
      return date;
    }

    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
  }

  function newDate(y, m, d) {
    return {
      y: y,
      m: m,
      d: d,
      H: 0,
      M: 0,
      S: 0,
      L: 0
    };
  }

  function formatLocale(locale) {
    var locale_dateTime = locale.dateTime,
        locale_date = locale.date,
        locale_time = locale.time,
        locale_periods = locale.periods,
        locale_weekdays = locale.days,
        locale_shortWeekdays = locale.shortDays,
        locale_months = locale.months,
        locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods),
        periodLookup = formatLookup(locale_periods),
        weekdayRe = formatRe(locale_weekdays),
        weekdayLookup = formatLookup(locale_weekdays),
        shortWeekdayRe = formatRe(locale_shortWeekdays),
        shortWeekdayLookup = formatLookup(locale_shortWeekdays),
        monthRe = formatRe(locale_months),
        monthLookup = formatLookup(locale_months),
        shortMonthRe = formatRe(locale_shortMonths),
        shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
      "a": formatShortWeekday,
      "A": formatWeekday,
      "b": formatShortMonth,
      "B": formatMonth,
      "c": null,
      "d": formatDayOfMonth,
      "e": formatDayOfMonth,
      "f": formatMicroseconds,
      "g": formatYearISO,
      "G": formatFullYearISO,
      "H": formatHour24,
      "I": formatHour12,
      "j": formatDayOfYear,
      "L": formatMilliseconds,
      "m": formatMonthNumber,
      "M": formatMinutes,
      "p": formatPeriod,
      "q": formatQuarter,
      "Q": formatUnixTimestamp,
      "s": formatUnixTimestampSeconds,
      "S": formatSeconds,
      "u": formatWeekdayNumberMonday,
      "U": formatWeekNumberSunday,
      "V": formatWeekNumberISO,
      "w": formatWeekdayNumberSunday,
      "W": formatWeekNumberMonday,
      "x": null,
      "X": null,
      "y": formatYear,
      "Y": formatFullYear,
      "Z": formatZone,
      "%": formatLiteralPercent
    };
    var utcFormats = {
      "a": formatUTCShortWeekday,
      "A": formatUTCWeekday,
      "b": formatUTCShortMonth,
      "B": formatUTCMonth,
      "c": null,
      "d": formatUTCDayOfMonth,
      "e": formatUTCDayOfMonth,
      "f": formatUTCMicroseconds,
      "g": formatUTCYearISO,
      "G": formatUTCFullYearISO,
      "H": formatUTCHour24,
      "I": formatUTCHour12,
      "j": formatUTCDayOfYear,
      "L": formatUTCMilliseconds,
      "m": formatUTCMonthNumber,
      "M": formatUTCMinutes,
      "p": formatUTCPeriod,
      "q": formatUTCQuarter,
      "Q": formatUnixTimestamp,
      "s": formatUnixTimestampSeconds,
      "S": formatUTCSeconds,
      "u": formatUTCWeekdayNumberMonday,
      "U": formatUTCWeekNumberSunday,
      "V": formatUTCWeekNumberISO,
      "w": formatUTCWeekdayNumberSunday,
      "W": formatUTCWeekNumberMonday,
      "x": null,
      "X": null,
      "y": formatUTCYear,
      "Y": formatUTCFullYear,
      "Z": formatUTCZone,
      "%": formatLiteralPercent
    };
    var parses = {
      "a": parseShortWeekday,
      "A": parseWeekday,
      "b": parseShortMonth,
      "B": parseMonth,
      "c": parseLocaleDateTime,
      "d": parseDayOfMonth,
      "e": parseDayOfMonth,
      "f": parseMicroseconds,
      "g": parseYear,
      "G": parseFullYear,
      "H": parseHour24,
      "I": parseHour24,
      "j": parseDayOfYear,
      "L": parseMilliseconds,
      "m": parseMonthNumber,
      "M": parseMinutes,
      "p": parsePeriod,
      "q": parseQuarter,
      "Q": parseUnixTimestamp,
      "s": parseUnixTimestampSeconds,
      "S": parseSeconds,
      "u": parseWeekdayNumberMonday,
      "U": parseWeekNumberSunday,
      "V": parseWeekNumberISO,
      "w": parseWeekdayNumberSunday,
      "W": parseWeekNumberMonday,
      "x": parseLocaleDate,
      "X": parseLocaleTime,
      "y": parseYear,
      "Y": parseFullYear,
      "Z": parseZone,
      "%": parseLiteralPercent
    }; // These recursive directive definitions must be deferred.

    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);

    function newFormat(specifier, formats) {
      return function (date) {
        var string = [],
            i = -1,
            j = 0,
            n = specifier.length,
            c,
            pad,
            format;
        if (!(date instanceof Date)) date = new Date(+date);

        while (++i < n) {
          if (specifier.charCodeAt(i) === 37) {
            string.push(specifier.slice(j, i));
            if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);else pad = c === "e" ? " " : "0";
            if (format = formats[c]) c = format(date, pad);
            string.push(c);
            j = i + 1;
          }
        }

        string.push(specifier.slice(j, i));
        return string.join("");
      };
    }

    function newParse(specifier, Z) {
      return function (string) {
        var d = newDate(1900, undefined, 1),
            i = parseSpecifier(d, specifier, string += "", 0),
            week,
            day$1;
        if (i != string.length) return null; // If a UNIX timestamp is specified, return it.

        if ("Q" in d) return new Date(d.Q);
        if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.

        if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.

        if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.

        if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.

        if ("V" in d) {
          if (d.V < 1 || d.V > 53) return null;
          if (!("w" in d)) d.w = 1;

          if ("Z" in d) {
            week = utcDate(newDate(d.y, 0, 1)), day$1 = week.getUTCDay();
            week = day$1 > 4 || day$1 === 0 ? utcMonday.ceil(week) : utcMonday(week);
            week = utcDay.offset(week, (d.V - 1) * 7);
            d.y = week.getUTCFullYear();
            d.m = week.getUTCMonth();
            d.d = week.getUTCDate() + (d.w + 6) % 7;
          } else {
            week = localDate(newDate(d.y, 0, 1)), day$1 = week.getDay();
            week = day$1 > 4 || day$1 === 0 ? monday.ceil(week) : monday(week);
            week = day.offset(week, (d.V - 1) * 7);
            d.y = week.getFullYear();
            d.m = week.getMonth();
            d.d = week.getDate() + (d.w + 6) % 7;
          }
        } else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
          day$1 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
          d.m = 0;
          d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
        } // If a time zone is specified, all fields are interpreted as UTC and then
        // offset according to the specified time zone.


        if ("Z" in d) {
          d.H += d.Z / 100 | 0;
          d.M += d.Z % 100;
          return utcDate(d);
        } // Otherwise, all fields are in local time.


        return localDate(d);
      };
    }

    function parseSpecifier(d, specifier, string, j) {
      var i = 0,
          n = specifier.length,
          m = string.length,
          c,
          parse;

      while (i < n) {
        if (j >= m) return -1;
        c = specifier.charCodeAt(i++);

        if (c === 37) {
          c = specifier.charAt(i++);
          parse = parses[c in pads ? specifier.charAt(i++) : c];
          if (!parse || (j = parse(d, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }

      return j;
    }

    function parsePeriod(d, string, i) {
      var n = periodRe.exec(string.slice(i));
      return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }

    function parseShortWeekday(d, string, i) {
      var n = shortWeekdayRe.exec(string.slice(i));
      return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }

    function parseWeekday(d, string, i) {
      var n = weekdayRe.exec(string.slice(i));
      return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }

    function parseShortMonth(d, string, i) {
      var n = shortMonthRe.exec(string.slice(i));
      return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }

    function parseMonth(d, string, i) {
      var n = monthRe.exec(string.slice(i));
      return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }

    function parseLocaleDateTime(d, string, i) {
      return parseSpecifier(d, locale_dateTime, string, i);
    }

    function parseLocaleDate(d, string, i) {
      return parseSpecifier(d, locale_date, string, i);
    }

    function parseLocaleTime(d, string, i) {
      return parseSpecifier(d, locale_time, string, i);
    }

    function formatShortWeekday(d) {
      return locale_shortWeekdays[d.getDay()];
    }

    function formatWeekday(d) {
      return locale_weekdays[d.getDay()];
    }

    function formatShortMonth(d) {
      return locale_shortMonths[d.getMonth()];
    }

    function formatMonth(d) {
      return locale_months[d.getMonth()];
    }

    function formatPeriod(d) {
      return locale_periods[+(d.getHours() >= 12)];
    }

    function formatQuarter(d) {
      return 1 + ~~(d.getMonth() / 3);
    }

    function formatUTCShortWeekday(d) {
      return locale_shortWeekdays[d.getUTCDay()];
    }

    function formatUTCWeekday(d) {
      return locale_weekdays[d.getUTCDay()];
    }

    function formatUTCShortMonth(d) {
      return locale_shortMonths[d.getUTCMonth()];
    }

    function formatUTCMonth(d) {
      return locale_months[d.getUTCMonth()];
    }

    function formatUTCPeriod(d) {
      return locale_periods[+(d.getUTCHours() >= 12)];
    }

    function formatUTCQuarter(d) {
      return 1 + ~~(d.getUTCMonth() / 3);
    }

    return {
      format: function (specifier) {
        var f = newFormat(specifier += "", formats);

        f.toString = function () {
          return specifier;
        };

        return f;
      },
      parse: function (specifier) {
        var p = newParse(specifier += "", false);

        p.toString = function () {
          return specifier;
        };

        return p;
      },
      utcFormat: function (specifier) {
        var f = newFormat(specifier += "", utcFormats);

        f.toString = function () {
          return specifier;
        };

        return f;
      },
      utcParse: function (specifier) {
        var p = newParse(specifier += "", true);

        p.toString = function () {
          return specifier;
        };

        return p;
      }
    };
  }
  var pads = {
    "-": "",
    "_": " ",
    "0": "0"
  },
      numberRe = /^\s*\d+/,
      // note: ignores next directive
  percentRe = /^%/,
      requoteRe = /[\\^$*+?|[\]().{}]/g;

  function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "",
        string = (sign ? -value : value) + "",
        length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }

  function requote(s) {
    return s.replace(requoteRe, "\\$&");
  }

  function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
  }

  function formatLookup(names) {
    return new Map(names.map((name, i) => [name.toLowerCase(), i]));
  }

  function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
  }

  function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
  }

  function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
  }

  function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
  }

  function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
  }

  function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
  }

  function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
  }

  function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
  }

  function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
  }

  function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
  }

  function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
  }

  function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
  }

  function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
  }

  function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
  }

  function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
  }

  function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
  }

  function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
  }

  function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }

  function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
  }

  function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
  }

  function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
  }

  function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
  }

  function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
  }

  function formatDayOfYear(d, p) {
    return pad(1 + day.count(year(d), d), p, 3);
  }

  function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
  }

  function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
  }

  function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
  }

  function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
  }

  function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
  }

  function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
  }

  function formatWeekNumberSunday(d, p) {
    return pad(sunday.count(year(d) - 1, d), p, 2);
  }

  function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? thursday(d) : thursday.ceil(d);
  }

  function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad(thursday.count(year(d), d) + (year(d).getDay() === 4), p, 2);
  }

  function formatWeekdayNumberSunday(d) {
    return d.getDay();
  }

  function formatWeekNumberMonday(d, p) {
    return pad(monday.count(year(d) - 1, d), p, 2);
  }

  function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
  }

  function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
  }

  function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
  }

  function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? thursday(d) : thursday.ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
  }

  function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
  }

  function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
  }

  function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
  }

  function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
  }

  function formatUTCDayOfYear(d, p) {
    return pad(1 + utcDay.count(utcYear(d), d), p, 3);
  }

  function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
  }

  function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
  }

  function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
  }

  function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
  }

  function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
  }

  function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
  }

  function formatUTCWeekNumberSunday(d, p) {
    return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
  }

  function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
  }

  function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
  }

  function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
  }

  function formatUTCWeekNumberMonday(d, p) {
    return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
  }

  function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
  }

  function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
  }

  function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
  }

  function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
  }

  function formatUTCZone() {
    return "+0000";
  }

  function formatLiteralPercent() {
    return "%";
  }

  function formatUnixTimestamp(d) {
    return +d;
  }

  function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
  }

  var locale$1;
  var timeFormat$1;
  var timeParse$1;
  var utcFormat$1;
  var utcParse$1;
  defaultLocale$1({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  });
  function defaultLocale$1(definition) {
    locale$1 = formatLocale(definition);
    timeFormat$1 = locale$1.format;
    timeParse$1 = locale$1.parse;
    utcFormat$1 = locale$1.utcFormat;
    utcParse$1 = locale$1.utcParse;
    return locale$1;
  }

  function memoize(method) {
    const cache = {};
    return spec => cache[spec] || (cache[spec] = method(spec));
  }

  function trimZeroes(numberFormat, decimalChar) {
    return x => {
      const str = numberFormat(x),
            dec = str.indexOf(decimalChar);
      if (dec < 0) return str;
      let idx = rightmostDigit(str, dec);
      const end = idx < str.length ? str.slice(idx) : '';

      while (--idx > dec) if (str[idx] !== '0') {
        ++idx;
        break;
      }

      return str.slice(0, idx) + end;
    };
  }

  function rightmostDigit(str, dec) {
    let i = str.lastIndexOf('e'),
        c;
    if (i > 0) return i;

    for (i = str.length; --i > dec;) {
      c = str.charCodeAt(i);
      if (c >= 48 && c <= 57) return i + 1; // is digit
    }
  }

  function numberLocale(locale) {
    const format = memoize(locale.format),
          formatPrefix = locale.formatPrefix;
    return {
      format,
      formatPrefix,

      formatFloat(spec) {
        const s = formatSpecifier(spec || ',');

        if (s.precision == null) {
          s.precision = 12;

          switch (s.type) {
            case '%':
              s.precision -= 2;
              break;

            case 'e':
              s.precision -= 1;
              break;
          }

          return trimZeroes(format(s), // number format
          format('.1f')(1)[1] // decimal point character
          );
        } else {
          return format(s);
        }
      },

      formatSpan(start, stop, count, specifier) {
        specifier = formatSpecifier(specifier == null ? ',f' : specifier);
        const step = tickStep(start, stop, count),
              value = Math.max(Math.abs(start), Math.abs(stop));
        let precision;

        if (specifier.precision == null) {
          switch (specifier.type) {
            case 's':
              {
                if (!isNaN(precision = precisionPrefix(step, value))) {
                  specifier.precision = precision;
                }

                return formatPrefix(specifier, value);
              }

            case '':
            case 'e':
            case 'g':
            case 'p':
            case 'r':
              {
                if (!isNaN(precision = precisionRound(step, value))) {
                  specifier.precision = precision - (specifier.type === 'e');
                }

                break;
              }

            case 'f':
            case '%':
              {
                if (!isNaN(precision = precisionFixed(step))) {
                  specifier.precision = precision - (specifier.type === '%') * 2;
                }

                break;
              }
          }
        }

        return format(specifier);
      }

    };
  }

  let defaultNumberLocale;
  resetNumberFormatDefaultLocale();

  function resetNumberFormatDefaultLocale() {
    return defaultNumberLocale = numberLocale({
      format: format$3,
      formatPrefix: formatPrefix
    });
  }

  function numberFormatLocale(definition) {
    return numberLocale(formatLocale$1(definition));
  }

  function numberFormatDefaultLocale(definition) {
    return arguments.length ? defaultNumberLocale = numberFormatLocale(definition) : defaultNumberLocale;
  }

  function timeMultiFormat(format, interval, spec) {
    spec = spec || {};

    if (!isObject(spec)) {
      error(`Invalid time multi-format specifier: ${spec}`);
    }

    const second = interval(SECONDS),
          minute = interval(MINUTES),
          hour = interval(HOURS),
          day = interval(DATE),
          week = interval(WEEK),
          month = interval(MONTH),
          quarter = interval(QUARTER),
          year = interval(YEAR),
          L = format(spec[MILLISECONDS] || '.%L'),
          S = format(spec[SECONDS] || ':%S'),
          M = format(spec[MINUTES] || '%I:%M'),
          H = format(spec[HOURS] || '%I %p'),
          d = format(spec[DATE] || spec[DAY] || '%a %d'),
          w = format(spec[WEEK] || '%b %d'),
          m = format(spec[MONTH] || '%B'),
          q = format(spec[QUARTER] || '%B'),
          y = format(spec[YEAR] || '%Y');
    return date => (second(date) < date ? L : minute(date) < date ? S : hour(date) < date ? M : day(date) < date ? H : month(date) < date ? week(date) < date ? d : w : year(date) < date ? quarter(date) < date ? m : q : y)(date);
  }

  function timeLocale(locale) {
    const timeFormat = memoize(locale.format),
          utcFormat = memoize(locale.utcFormat);
    return {
      timeFormat: spec => isString(spec) ? timeFormat(spec) : timeMultiFormat(timeFormat, timeInterval, spec),
      utcFormat: spec => isString(spec) ? utcFormat(spec) : timeMultiFormat(utcFormat, utcInterval, spec),
      timeParse: memoize(locale.parse),
      utcParse: memoize(locale.utcParse)
    };
  }

  let defaultTimeLocale;
  resetTimeFormatDefaultLocale();

  function resetTimeFormatDefaultLocale() {
    return defaultTimeLocale = timeLocale({
      format: timeFormat$1,
      parse: timeParse$1,
      utcFormat: utcFormat$1,
      utcParse: utcParse$1
    });
  }

  function timeFormatLocale(definition) {
    return timeLocale(formatLocale(definition));
  }

  function timeFormatDefaultLocale(definition) {
    return arguments.length ? defaultTimeLocale = timeFormatLocale(definition) : defaultTimeLocale;
  }

  const createLocale = (number, time) => extend$1({}, number, time);

  function locale(numberSpec, timeSpec) {
    const number = numberSpec ? numberFormatLocale(numberSpec) : numberFormatDefaultLocale();
    const time = timeSpec ? timeFormatLocale(timeSpec) : timeFormatDefaultLocale();
    return createLocale(number, time);
  }

  function defaultLocale(numberSpec, timeSpec) {
    const args = arguments.length;

    if (args && args !== 2) {
      error('defaultLocale expects either zero or two arguments.');
    }

    return args ? createLocale(numberFormatDefaultLocale(numberSpec), timeFormatDefaultLocale(timeSpec)) : createLocale(numberFormatDefaultLocale(), timeFormatDefaultLocale());
  }

  function resetDefaultLocale() {
    resetNumberFormatDefaultLocale();
    resetTimeFormatDefaultLocale();
    return defaultLocale();
  }

  const protocol_re = /^([A-Za-z]+:)?\/\//; // Matches allowed URIs. From https://github.com/cure53/DOMPurify/blob/master/src/regexp.js with added file://

  const allowed_re = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape

  const whitespace_re = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g; // eslint-disable-line no-control-regex
  // Special treatment in node.js for the file: protocol

  const fileProtocol = 'file://';
  /**
   * Factory for a loader constructor that provides methods for requesting
   * files from either the network or disk, and for sanitizing request URIs.
   * @param {function} fetch - The Fetch API for HTTP network requests.
   *   If null or undefined, HTTP loading will be disabled.
   * @param {object} fs - The file system interface for file loading.
   *   If null or undefined, local file loading will be disabled.
   * @return {function} A loader constructor with the following signature:
   *   param {object} [options] - Optional default loading options to use.
   *   return {object} - A new loader instance.
   */

  function loaderFactory(fetch, fs) {
    return options => ({
      options: options || {},
      sanitize: sanitize,
      load: load$1,
      fileAccess: !!fs,
      file: fileLoader(fs),
      http: httpLoader(fetch)
    });
  }
  /**
   * Load an external resource, typically either from the web or from the local
   * filesystem. This function uses {@link sanitize} to first sanitize the uri,
   * then calls either {@link http} (for web requests) or {@link file} (for
   * filesystem loading).
   * @param {string} uri - The resource indicator (e.g., URL or filename).
   * @param {object} [options] - Optional loading options. These options will
   *   override any existing default options.
   * @return {Promise} - A promise that resolves to the loaded content.
   */


  async function load$1(uri, options) {
    const opt = await this.sanitize(uri, options),
          url = opt.href;
    return opt.localFile ? this.file(url) : this.http(url, options);
  }
  /**
   * URI sanitizer function.
   * @param {string} uri - The uri (url or filename) to check.
   * @param {object} options - An options hash.
   * @return {Promise} - A promise that resolves to an object containing
   *  sanitized uri data, or rejects it the input uri is deemed invalid.
   *  The properties of the resolved object are assumed to be
   *  valid attributes for an HTML 'a' tag. The sanitized uri *must* be
   *  provided by the 'href' property of the returned object.
   */


  async function sanitize(uri, options) {
    options = extend$1({}, this.options, options);
    const fileAccess = this.fileAccess,
          result = {
      href: null
    };
    let isFile, loadFile, base;
    const isAllowed = allowed_re.test(uri.replace(whitespace_re, ''));

    if (uri == null || typeof uri !== 'string' || !isAllowed) {
      error('Sanitize failure, invalid URI: ' + $(uri));
    }

    const hasProtocol = protocol_re.test(uri); // if relative url (no protocol/host), prepend baseURL

    if ((base = options.baseURL) && !hasProtocol) {
      // Ensure that there is a slash between the baseURL (e.g. hostname) and url
      if (!uri.startsWith('/') && base[base.length - 1] !== '/') {
        uri = '/' + uri;
      }

      uri = base + uri;
    } // should we load from file system?


    loadFile = (isFile = uri.startsWith(fileProtocol)) || options.mode === 'file' || options.mode !== 'http' && !hasProtocol && fileAccess;

    if (isFile) {
      // strip file protocol
      uri = uri.slice(fileProtocol.length);
    } else if (uri.startsWith('//')) {
      if (options.defaultProtocol === 'file') {
        // if is file, strip protocol and set loadFile flag
        uri = uri.slice(2);
        loadFile = true;
      } else {
        // if relative protocol (starts with '//'), prepend default protocol
        uri = (options.defaultProtocol || 'http') + ':' + uri;
      }
    } // set non-enumerable mode flag to indicate local file load


    Object.defineProperty(result, 'localFile', {
      value: !!loadFile
    }); // set uri

    result.href = uri; // set default result target, if specified

    if (options.target) {
      result.target = options.target + '';
    } // set default result rel, if specified (#1542)


    if (options.rel) {
      result.rel = options.rel + '';
    } // provide control over cross-origin image handling (#2238)
    // https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image


    if (options.context === 'image' && options.crossOrigin) {
      result.crossOrigin = options.crossOrigin + '';
    } // return


    return result;
  }
  /**
   * File system loader factory.
   * @param {object} fs - The file system interface.
   * @return {function} - A file loader with the following signature:
   *   param {string} filename - The file system path to load.
   *   param {string} filename - The file system path to load.
   *   return {Promise} A promise that resolves to the file contents.
   */


  function fileLoader(fs) {
    return fs ? filename => new Promise((accept, reject) => {
      fs.readFile(filename, (error, data) => {
        if (error) reject(error);else accept(data);
      });
    }) : fileReject;
  }
  /**
   * Default file system loader that simply rejects.
   */


  async function fileReject() {
    error('No file system access.');
  }
  /**
   * HTTP request handler factory.
   * @param {function} fetch - The Fetch API method.
   * @return {function} - An http loader with the following signature:
   *   param {string} url - The url to request.
   *   param {object} options - An options hash.
   *   return {Promise} - A promise that resolves to the file contents.
   */


  function httpLoader(fetch) {
    return fetch ? async function (url, options) {
      const opt = extend$1({}, this.options.http, options),
            type = options && options.response,
            response = await fetch(url, opt);
      return !response.ok ? error(response.status + '' + response.statusText) : isFunction(response[type]) ? response[type]() : response.text();
    } : httpReject;
  }
  /**
   * Default http request handler that simply rejects.
   */


  async function httpReject() {
    error('No HTTP fetch method available.');
  }

  const isValid = _ => _ != null && _ === _;

  const isBoolean = _ => _ === 'true' || _ === 'false' || _ === true || _ === false;

  const isDate = _ => !Number.isNaN(Date.parse(_));

  const isNumber = _ => !Number.isNaN(+_) && !(_ instanceof Date);

  const isInteger = _ => isNumber(_) && Number.isInteger(+_);

  const typeParsers = {
    boolean: toBoolean,
    integer: toNumber,
    number: toNumber,
    date: toDate,
    string: toString,
    unknown: identity$6
  };
  const typeTests = [isBoolean, isInteger, isNumber, isDate];
  const typeList = ['boolean', 'integer', 'number', 'date'];

  function inferType(values, field) {
    if (!values || !values.length) return 'unknown';
    const n = values.length,
          m = typeTests.length,
          a = typeTests.map((_, i) => i + 1);

    for (let i = 0, t = 0, j, value; i < n; ++i) {
      value = field ? values[i][field] : values[i];

      for (j = 0; j < m; ++j) {
        if (a[j] && isValid(value) && !typeTests[j](value)) {
          a[j] = 0;
          ++t;
          if (t === typeTests.length) return 'string';
        }
      }
    }

    return typeList[a.reduce((u, v) => u === 0 ? v : u, 0) - 1];
  }

  function inferTypes(data, fields) {
    return fields.reduce((types, field) => {
      types[field] = inferType(data, field);
      return types;
    }, {});
  }

  function delimitedFormat(delimiter) {
    const parse = function (data, format) {
      const delim = {
        delimiter: delimiter
      };
      return dsv(data, format ? extend$1(format, delim) : delim);
    };

    parse.responseType = 'text';
    return parse;
  }

  function dsv(data, format) {
    if (format.header) {
      data = format.header.map($).join(format.delimiter) + '\n' + data;
    }

    return dsvFormat(format.delimiter).parse(data + '');
  }

  dsv.responseType = 'text';

  function isBuffer(_) {
    return typeof Buffer === 'function' && isFunction(Buffer.isBuffer) ? Buffer.isBuffer(_) : false;
  }

  function json(data, format) {
    const prop = format && format.property ? field$1(format.property) : identity$6;
    return isObject(data) && !isBuffer(data) ? parseJSON(prop(data), format) : prop(JSON.parse(data));
  }

  json.responseType = 'json';

  function parseJSON(data, format) {
    if (!isArray(data) && isIterable(data)) {
      data = [...data];
    }

    return format && format.copy ? JSON.parse(JSON.stringify(data)) : data;
  }

  const filters = {
    interior: (a, b) => a !== b,
    exterior: (a, b) => a === b
  };

  function topojson(data, format) {
    let method, object, property, filter;
    data = json(data, format);

    if (format && format.feature) {
      method = feature;
      property = format.feature;
    } else if (format && format.mesh) {
      method = mesh;
      property = format.mesh;
      filter = filters[format.filter];
    } else {
      error('Missing TopoJSON feature or mesh parameter.');
    }

    object = (object = data.objects[property]) ? method(data, object, filter) : error('Invalid TopoJSON object: ' + property);
    return object && object.features || [object];
  }

  topojson.responseType = 'json';
  const format$2 = {
    dsv: dsv,
    csv: delimitedFormat(','),
    tsv: delimitedFormat('\t'),
    json: json,
    topojson: topojson
  };

  function formats$1(name, reader) {
    if (arguments.length > 1) {
      format$2[name] = reader;
      return this;
    } else {
      return has$1(format$2, name) ? format$2[name] : null;
    }
  }

  function responseType(type) {
    const f = formats$1(type);
    return f && f.responseType || 'text';
  }

  function read(data, schema, timeParser, utcParser) {
    schema = schema || {};
    const reader = formats$1(schema.type || 'json');
    if (!reader) error('Unknown data format type: ' + schema.type);
    data = reader(data, schema);
    if (schema.parse) parse$5(data, schema.parse, timeParser, utcParser);
    if (has$1(data, 'columns')) delete data.columns;
    return data;
  }

  function parse$5(data, types, timeParser, utcParser) {
    if (!data.length) return; // early exit for empty data

    const locale = timeFormatDefaultLocale();
    timeParser = timeParser || locale.timeParse;
    utcParser = utcParser || locale.utcParse;
    let fields = data.columns || Object.keys(data[0]),
        datum,
        field,
        i,
        j,
        n,
        m;
    if (types === 'auto') types = inferTypes(data, fields);
    fields = Object.keys(types);
    const parsers = fields.map(field => {
      const type = types[field];
      let parts, pattern;

      if (type && (type.startsWith('date:') || type.startsWith('utc:'))) {
        parts = type.split(/:(.+)?/, 2); // split on first :

        pattern = parts[1];

        if (pattern[0] === '\'' && pattern[pattern.length - 1] === '\'' || pattern[0] === '"' && pattern[pattern.length - 1] === '"') {
          pattern = pattern.slice(1, -1);
        }

        const parse = parts[0] === 'utc' ? utcParser : timeParser;
        return parse(pattern);
      }

      if (!typeParsers[type]) {
        throw Error('Illegal format pattern: ' + field + ':' + type);
      }

      return typeParsers[type];
    });

    for (i = 0, n = data.length, m = fields.length; i < n; ++i) {
      datum = data[i];

      for (j = 0; j < m; ++j) {
        field = fields[j];
        datum[field] = parsers[j](datum[field]);
      }
    }
  }

  const loader = loaderFactory(typeof fetch !== 'undefined' && fetch, // use built-in fetch API
  null // no file system access
  );

  function UniqueList(idFunc) {
    const $ = idFunc || identity$6,
          list = [],
          ids = {};

    list.add = _ => {
      const id = $(_);

      if (!ids[id]) {
        ids[id] = 1;
        list.push(_);
      }

      return list;
    };

    list.remove = _ => {
      const id = $(_);

      if (ids[id]) {
        ids[id] = 0;
        const idx = list.indexOf(_);
        if (idx >= 0) list.splice(idx, 1);
      }

      return list;
    };

    return list;
  }
  /**
   * Invoke and await a potentially async callback function. If
   * an error occurs, trap it and route to Dataflow.error.
   * @param {Dataflow} df - The dataflow instance
   * @param {function} callback - A callback function to invoke
   *   and then await. The dataflow will be passed as the single
   *   argument to the function.
   */


  async function asyncCallback(df, callback) {
    try {
      await callback(df);
    } catch (err) {
      df.error(err);
    }
  }

  const TUPLE_ID_KEY = Symbol('vega_id');
  let TUPLE_ID = 1;
  /**
   * Checks if an input value is a registered tuple.
   * @param {*} t - The value to check.
   * @return {boolean} True if the input is a tuple, false otherwise.
   */

  function isTuple(t) {
    return !!(t && tupleid(t));
  }
  /**
   * Returns the id of a tuple.
   * @param {object} t - The input tuple.
   * @return {*} the tuple id.
   */


  function tupleid(t) {
    return t[TUPLE_ID_KEY];
  }
  /**
   * Sets the id of a tuple.
   * @param {object} t - The input tuple.
   * @param {*} id - The id value to set.
   * @return {object} the input tuple.
   */


  function setid(t, id) {
    t[TUPLE_ID_KEY] = id;
    return t;
  }
  /**
   * Ingest an object or value as a data tuple.
   * If the input value is an object, an id field will be added to it. For
   * efficiency, the input object is modified directly. A copy is not made.
   * If the input value is a literal, it will be wrapped in a new object
   * instance, with the value accessible as the 'data' property.
   * @param datum - The value to ingest.
   * @return {object} The ingested data tuple.
   */


  function ingest$1(datum) {
    const t = datum === Object(datum) ? datum : {
      data: datum
    };
    return tupleid(t) ? t : setid(t, TUPLE_ID++);
  }
  /**
   * Given a source tuple, return a derived copy.
   * @param {object} t - The source tuple.
   * @return {object} The derived tuple.
   */


  function derive(t) {
    return rederive(t, ingest$1({}));
  }
  /**
   * Rederive a derived tuple by copying values from the source tuple.
   * @param {object} t - The source tuple.
   * @param {object} d - The derived tuple.
   * @return {object} The derived tuple.
   */


  function rederive(t, d) {
    for (const k in t) d[k] = t[k];

    return d;
  }
  /**
   * Replace an existing tuple with a new tuple.
   * @param {object} t - The existing data tuple.
   * @param {object} d - The new tuple that replaces the old.
   * @return {object} The new tuple.
   */


  function replace$1(t, d) {
    return setid(d, tupleid(t));
  }
  /**
   * Generate an augmented comparator function that provides stable
   * sorting by tuple id when the given comparator produces ties.
   * @param {function} cmp - The comparator to augment.
   * @param {function} [f] - Optional tuple accessor function.
   * @return {function} An augmented comparator function.
   */


  function stableCompare(cmp, f) {
    return !cmp ? null : f ? (a, b) => cmp(a, b) || tupleid(f(a)) - tupleid(f(b)) : (a, b) => cmp(a, b) || tupleid(a) - tupleid(b);
  }

  function isChangeSet(v) {
    return v && v.constructor === changeset;
  }

  function changeset() {
    const add = [],
          // insert tuples
    rem = [],
          // remove tuples
    mod = [],
          // modify tuples
    remp = [],
          // remove by predicate
    modp = []; // modify by predicate

    let clean = null,
        reflow = false;
    return {
      constructor: changeset,

      insert(t) {
        const d = array$5(t),
              n = d.length;

        for (let i = 0; i < n; ++i) add.push(d[i]);

        return this;
      },

      remove(t) {
        const a = isFunction(t) ? remp : rem,
              d = array$5(t),
              n = d.length;

        for (let i = 0; i < n; ++i) a.push(d[i]);

        return this;
      },

      modify(t, field, value) {
        const m = {
          field: field,
          value: constant$4(value)
        };

        if (isFunction(t)) {
          m.filter = t;
          modp.push(m);
        } else {
          m.tuple = t;
          mod.push(m);
        }

        return this;
      },

      encode(t, set) {
        if (isFunction(t)) modp.push({
          filter: t,
          field: set
        });else mod.push({
          tuple: t,
          field: set
        });
        return this;
      },

      clean(value) {
        clean = value;
        return this;
      },

      reflow() {
        reflow = true;
        return this;
      },

      pulse(pulse, tuples) {
        const cur = {},
              out = {};
        let i, n, m, f, t, id; // build lookup table of current tuples

        for (i = 0, n = tuples.length; i < n; ++i) {
          cur[tupleid(tuples[i])] = 1;
        } // process individual tuples to remove


        for (i = 0, n = rem.length; i < n; ++i) {
          t = rem[i];
          cur[tupleid(t)] = -1;
        } // process predicate-based removals


        for (i = 0, n = remp.length; i < n; ++i) {
          f = remp[i];
          tuples.forEach(t => {
            if (f(t)) cur[tupleid(t)] = -1;
          });
        } // process all add tuples


        for (i = 0, n = add.length; i < n; ++i) {
          t = add[i];
          id = tupleid(t);

          if (cur[id]) {
            // tuple already resides in dataset
            // if flagged for both add and remove, cancel
            cur[id] = 1;
          } else {
            // tuple does not reside in dataset, add
            pulse.add.push(ingest$1(add[i]));
          }
        } // populate pulse rem list


        for (i = 0, n = tuples.length; i < n; ++i) {
          t = tuples[i];
          if (cur[tupleid(t)] < 0) pulse.rem.push(t);
        } // modify helper method


        function modify(t, f, v) {
          if (v) {
            t[f] = v(t);
          } else {
            pulse.encode = f;
          }

          if (!reflow) out[tupleid(t)] = t;
        } // process individual tuples to modify


        for (i = 0, n = mod.length; i < n; ++i) {
          m = mod[i];
          t = m.tuple;
          f = m.field;
          id = cur[tupleid(t)];

          if (id > 0) {
            modify(t, f, m.value);
            pulse.modifies(f);
          }
        } // process predicate-based modifications


        for (i = 0, n = modp.length; i < n; ++i) {
          m = modp[i];
          f = m.filter;
          tuples.forEach(t => {
            if (f(t) && cur[tupleid(t)] > 0) {
              modify(t, m.field, m.value);
            }
          });
          pulse.modifies(m.field);
        } // upon reflow request, populate mod with all non-removed tuples
        // otherwise, populate mod with modified tuples only


        if (reflow) {
          pulse.mod = rem.length || remp.length ? tuples.filter(t => cur[tupleid(t)] > 0) : tuples.slice();
        } else {
          for (id in out) pulse.mod.push(out[id]);
        } // set pulse garbage collection request


        if (clean || clean == null && (rem.length || remp.length)) {
          pulse.clean(true);
        }

        return pulse;
      }

    };
  }

  const CACHE = '_:mod:_';
  /**
   * Hash that tracks modifications to assigned values.
   * Callers *must* use the set method to update values.
   */

  function Parameters() {
    Object.defineProperty(this, CACHE, {
      writable: true,
      value: {}
    });
  }

  Parameters.prototype = {
    /**
     * Set a parameter value. If the parameter value changes, the parameter
     * will be recorded as modified.
     * @param {string} name - The parameter name.
     * @param {number} index - The index into an array-value parameter. Ignored if
     *   the argument is undefined, null or less than zero.
     * @param {*} value - The parameter value to set.
     * @param {boolean} [force=false] - If true, records the parameter as modified
     *   even if the value is unchanged.
     * @return {Parameters} - This parameter object.
     */
    set(name, index, value, force) {
      const o = this,
            v = o[name],
            mod = o[CACHE];

      if (index != null && index >= 0) {
        if (v[index] !== value || force) {
          v[index] = value;
          mod[index + ':' + name] = -1;
          mod[name] = -1;
        }
      } else if (v !== value || force) {
        o[name] = value;
        mod[name] = isArray(value) ? 1 + value.length : -1;
      }

      return o;
    },

    /**
     * Tests if one or more parameters has been modified. If invoked with no
     * arguments, returns true if any parameter value has changed. If the first
     * argument is array, returns trues if any parameter name in the array has
     * changed. Otherwise, tests if the given name and optional array index has
     * changed.
     * @param {string} name - The parameter name to test.
     * @param {number} [index=undefined] - The parameter array index to test.
     * @return {boolean} - Returns true if a queried parameter was modified.
     */
    modified(name, index) {
      const mod = this[CACHE];

      if (!arguments.length) {
        for (const k in mod) {
          if (mod[k]) return true;
        }

        return false;
      } else if (isArray(name)) {
        for (let k = 0; k < name.length; ++k) {
          if (mod[name[k]]) return true;
        }

        return false;
      }

      return index != null && index >= 0 ? index + 1 < mod[name] || !!mod[index + ':' + name] : !!mod[name];
    },

    /**
     * Clears the modification records. After calling this method,
     * all parameters are considered unmodified.
     */
    clear() {
      this[CACHE] = {};
      return this;
    }

  };
  let OP_ID = 0;
  const PULSE = 'pulse',
        NO_PARAMS = new Parameters(); // Boolean Flags

  const SKIP$1$1 = 1,
        MODIFIED = 2;
  /**
   * An Operator is a processing node in a dataflow graph.
   * Each operator stores a value and an optional value update function.
   * Operators can accept a hash of named parameters. Parameter values can
   * either be direct (JavaScript literals, arrays, objects) or indirect
   * (other operators whose values will be pulled dynamically). Operators
   * included as parameters will have this operator added as a dependency.
   * @constructor
   * @param {*} [init] - The initial value for this operator.
   * @param {function(object, Pulse)} [update] - An update function. Upon
   *   evaluation of this operator, the update function will be invoked and the
   *   return value will be used as the new value of this operator.
   * @param {object} [params] - The parameters for this operator.
   * @param {boolean} [react=true] - Flag indicating if this operator should
   *   listen for changes to upstream operators included as parameters.
   * @see parameters
   */

  function Operator(init, update, params, react) {
    this.id = ++OP_ID;
    this.value = init;
    this.stamp = -1;
    this.rank = -1;
    this.qrank = -1;
    this.flags = 0;

    if (update) {
      this._update = update;
    }

    if (params) this.parameters(params, react);
  }

  function flag(bit) {
    return function (state) {
      const f = this.flags;
      if (arguments.length === 0) return !!(f & bit);
      this.flags = state ? f | bit : f & ~bit;
      return this;
    };
  }

  Operator.prototype = {
    /**
     * Returns a list of target operators dependent on this operator.
     * If this list does not exist, it is created and then returned.
     * @return {UniqueList}
     */
    targets() {
      return this._targets || (this._targets = UniqueList(id));
    },

    /**
     * Sets the value of this operator.
     * @param {*} value - the value to set.
     * @return {Number} Returns 1 if the operator value has changed
     *   according to strict equality, returns 0 otherwise.
     */
    set(value) {
      if (this.value !== value) {
        this.value = value;
        return 1;
      } else {
        return 0;
      }
    },

    /**
     * Indicates that operator evaluation should be skipped on the next pulse.
     * This operator will still propagate incoming pulses, but its update function
     * will not be invoked. The skip flag is reset after every pulse, so calling
     * this method will affect processing of the next pulse only.
     */
    skip: flag(SKIP$1$1),

    /**
     * Indicates that this operator's value has been modified on its most recent
     * pulse. Normally modification is checked via strict equality; however, in
     * some cases it is more efficient to update the internal state of an object.
     * In those cases, the modified flag can be used to trigger propagation. Once
     * set, the modification flag persists across pulses until unset. The flag can
     * be used with the last timestamp to test if a modification is recent.
     */
    modified: flag(MODIFIED),

    /**
     * Sets the parameters for this operator. The parameter values are analyzed for
     * operator instances. If found, this operator will be added as a dependency
     * of the parameterizing operator. Operator values are dynamically marshalled
     * from each operator parameter prior to evaluation. If a parameter value is
     * an array, the array will also be searched for Operator instances. However,
     * the search does not recurse into sub-arrays or object properties.
     * @param {object} params - A hash of operator parameters.
     * @param {boolean} [react=true] - A flag indicating if this operator should
     *   automatically update (react) when parameter values change. In other words,
     *   this flag determines if the operator registers itself as a listener on
     *   any upstream operators included in the parameters.
     * @param {boolean} [initonly=false] - A flag indicating if this operator
     *   should calculate an update only upon its initiatal evaluation, then
     *   deregister dependencies and suppress all future update invocations.
     * @return {Operator[]} - An array of upstream dependencies.
     */
    parameters(params, react, initonly) {
      react = react !== false;
      const argval = this._argval = this._argval || new Parameters(),
            argops = this._argops = this._argops || [],
            deps = [];
      let name, value, n, i;

      const add = (name, index, value) => {
        if (value instanceof Operator) {
          if (value !== this) {
            if (react) value.targets().add(this);
            deps.push(value);
          }

          argops.push({
            op: value,
            name: name,
            index: index
          });
        } else {
          argval.set(name, index, value);
        }
      };

      for (name in params) {
        value = params[name];

        if (name === PULSE) {
          array$5(value).forEach(op => {
            if (!(op instanceof Operator)) {
              error('Pulse parameters must be operator instances.');
            } else if (op !== this) {
              op.targets().add(this);
              deps.push(op);
            }
          });
          this.source = value;
        } else if (isArray(value)) {
          argval.set(name, -1, Array(n = value.length));

          for (i = 0; i < n; ++i) add(name, i, value[i]);
        } else {
          add(name, -1, value);
        }
      }

      this.marshall().clear(); // initialize values

      if (initonly) argops.initonly = true;
      return deps;
    },

    /**
     * Internal method for marshalling parameter values.
     * Visits each operator dependency to pull the latest value.
     * @return {Parameters} A Parameters object to pass to the update function.
     */
    marshall(stamp) {
      const argval = this._argval || NO_PARAMS,
            argops = this._argops;
      let item, i, op, mod;

      if (argops) {
        const n = argops.length;

        for (i = 0; i < n; ++i) {
          item = argops[i];
          op = item.op;
          mod = op.modified() && op.stamp === stamp;
          argval.set(item.name, item.index, op.value, mod);
        }

        if (argops.initonly) {
          for (i = 0; i < n; ++i) {
            item = argops[i];
            item.op.targets().remove(this);
          }

          this._argops = null;
          this._update = null;
        }
      }

      return argval;
    },

    /**
     * Detach this operator from the dataflow.
     * Unregisters listeners on upstream dependencies.
     */
    detach() {
      const argops = this._argops;
      let i, n, item, op;

      if (argops) {
        for (i = 0, n = argops.length; i < n; ++i) {
          item = argops[i];
          op = item.op;

          if (op._targets) {
            op._targets.remove(this);
          }
        }
      } // remove references to the source and pulse object,
      // if present, to prevent memory leaks of old data.


      this.pulse = null;
      this.source = null;
    },

    /**
     * Delegate method to perform operator processing.
     * Subclasses can override this method to perform custom processing.
     * By default, it marshalls parameters and calls the update function
     * if that function is defined. If the update function does not
     * change the operator value then StopPropagation is returned.
     * If no update function is defined, this method does nothing.
     * @param {Pulse} pulse - the current dataflow pulse.
     * @return The output pulse or StopPropagation. A falsy return value
     *   (including undefined) will let the input pulse pass through.
     */
    evaluate(pulse) {
      const update = this._update;

      if (update) {
        const params = this.marshall(pulse.stamp),
              v = update.call(this, params, pulse);
        params.clear();

        if (v !== this.value) {
          this.value = v;
        } else if (!this.modified()) {
          return pulse.StopPropagation;
        }
      }
    },

    /**
     * Run this operator for the current pulse. If this operator has already
     * been run at (or after) the pulse timestamp, returns StopPropagation.
     * Internally, this method calls {@link evaluate} to perform processing.
     * If {@link evaluate} returns a falsy value, the input pulse is returned.
     * This method should NOT be overridden, instead overrride {@link evaluate}.
     * @param {Pulse} pulse - the current dataflow pulse.
     * @return the output pulse for this operator (or StopPropagation)
     */
    run(pulse) {
      if (pulse.stamp < this.stamp) return pulse.StopPropagation;
      let rv;

      if (this.skip()) {
        this.skip(false);
        rv = 0;
      } else {
        rv = this.evaluate(pulse);
      }

      return this.pulse = rv || pulse;
    }

  };
  /**
   * Add an operator to the dataflow graph. This function accepts a
   * variety of input argument types. The basic signature supports an
   * initial value, update function and parameters. If the first parameter
   * is an Operator instance, it will be added directly. If it is a
   * constructor for an Operator subclass, a new instance will be instantiated.
   * Otherwise, if the first parameter is a function instance, it will be used
   * as the update function and a null initial value is assumed.
   * @param {*} init - One of: the operator to add, the initial value of
   *   the operator, an operator class to instantiate, or an update function.
   * @param {function} [update] - The operator update function.
   * @param {object} [params] - The operator parameters.
   * @param {boolean} [react=true] - Flag indicating if this operator should
   *   listen for changes to upstream operators included as parameters.
   * @return {Operator} - The added operator.
   */

  function add$3(init, update, params, react) {
    let shift = 1,
        op;

    if (init instanceof Operator) {
      op = init;
    } else if (init && init.prototype instanceof Operator) {
      op = new init();
    } else if (isFunction(init)) {
      op = new Operator(null, init);
    } else {
      shift = 0;
      op = new Operator(init, update);
    }

    this.rank(op);

    if (shift) {
      react = params;
      params = update;
    }

    if (params) this.connect(op, op.parameters(params, react));
    this.touch(op);
    return op;
  }
  /**
   * Connect a target operator as a dependent of source operators.
   * If necessary, this method will rerank the target operator and its
   * dependents to ensure propagation proceeds in a topologically sorted order.
   * @param {Operator} target - The target operator.
   * @param {Array<Operator>} - The source operators that should propagate
   *   to the target operator.
   */


  function connect(target, sources) {
    const targetRank = target.rank,
          n = sources.length;

    for (let i = 0; i < n; ++i) {
      if (targetRank < sources[i].rank) {
        this.rerank(target);
        return;
      }
    }
  }

  let STREAM_ID = 0;
  /**
   * Models an event stream.
   * @constructor
   * @param {function(Object, number): boolean} [filter] - Filter predicate.
   *   Events pass through when truthy, events are suppressed when falsy.
   * @param {function(Object): *} [apply] - Applied to input events to produce
   *   new event values.
   * @param {function(Object)} [receive] - Event callback function to invoke
   *   upon receipt of a new event. Use to override standard event processing.
   */

  function EventStream(filter, apply, receive) {
    this.id = ++STREAM_ID;
    this.value = null;
    if (receive) this.receive = receive;
    if (filter) this._filter = filter;
    if (apply) this._apply = apply;
  }
  /**
   * Creates a new event stream instance with the provided
   * (optional) filter, apply and receive functions.
   * @param {function(Object, number): boolean} [filter] - Filter predicate.
   *   Events pass through when truthy, events are suppressed when falsy.
   * @param {function(Object): *} [apply] - Applied to input events to produce
   *   new event values.
   * @see EventStream
   */


  function stream(filter, apply, receive) {
    return new EventStream(filter, apply, receive);
  }

  EventStream.prototype = {
    _filter: truthy,
    _apply: identity$6,

    targets() {
      return this._targets || (this._targets = UniqueList(id));
    },

    consume(_) {
      if (!arguments.length) return !!this._consume;
      this._consume = !!_;
      return this;
    },

    receive(evt) {
      if (this._filter(evt)) {
        const val = this.value = this._apply(evt),
              trg = this._targets,
              n = trg ? trg.length : 0;

        for (let i = 0; i < n; ++i) trg[i].receive(val);

        if (this._consume) {
          evt.preventDefault();
          evt.stopPropagation();
        }
      }
    },

    filter(filter) {
      const s = stream(filter);
      this.targets().add(s);
      return s;
    },

    apply(apply) {
      const s = stream(null, apply);
      this.targets().add(s);
      return s;
    },

    merge() {
      const s = stream();
      this.targets().add(s);

      for (let i = 0, n = arguments.length; i < n; ++i) {
        arguments[i].targets().add(s);
      }

      return s;
    },

    throttle(pause) {
      let t = -1;
      return this.filter(() => {
        const now = Date.now();

        if (now - t > pause) {
          t = now;
          return 1;
        } else {
          return 0;
        }
      });
    },

    debounce(delay) {
      const s = stream();
      this.targets().add(stream(null, null, debounce(delay, e => {
        const df = e.dataflow;
        s.receive(e);
        if (df && df.run) df.run();
      })));
      return s;
    },

    between(a, b) {
      let active = false;
      a.targets().add(stream(null, null, () => active = true));
      b.targets().add(stream(null, null, () => active = false));
      return this.filter(() => active);
    },

    detach() {
      // ensures compatibility with operators (#2753)
      // remove references to other streams and filter functions that may
      // be bound to subcontexts that need to be garbage collected.
      this._filter = truthy;
      this._targets = null;
    }

  };
  /**
   * Create a new event stream from an event source.
   * @param {object} source - The event source to monitor. The input must
   *  support the addEventListener method.
   * @param {string} type - The event type.
   * @param {function(object): boolean} [filter] - Event filter function.
   * @param {function(object): *} [apply] - Event application function.
   *   If provided, this function will be invoked and the result will be
   *   used as the downstream event value.
   * @return {EventStream}
   */

  function events$1(source, type, filter, apply) {
    const df = this,
          s = stream(filter, apply),
          send = function (e) {
      e.dataflow = df;

      try {
        s.receive(e);
      } catch (error) {
        df.error(error);
      } finally {
        df.run();
      }
    };

    let sources;

    if (typeof source === 'string' && typeof document !== 'undefined') {
      sources = document.querySelectorAll(source);
    } else {
      sources = array$5(source);
    }

    const n = sources.length;

    for (let i = 0; i < n; ++i) {
      sources[i].addEventListener(type, send);
    }

    return s;
  }

  function parse$4(data, format) {
    const locale = this.locale();
    return read(data, format, locale.timeParse, locale.utcParse);
  }
  /**
   * Ingests new data into the dataflow. First parses the data using the
   * vega-loader read method, then pulses a changeset to the target operator.
   * @param {Operator} target - The Operator to target with ingested data,
   *   typically a Collect transform instance.
   * @param {*} data - The input data, prior to parsing. For JSON this may
   *   be a string or an object. For CSV, TSV, etc should be a string.
   * @param {object} format - The data format description for parsing
   *   loaded data. This object is passed to the vega-loader read method.
   * @returns {Dataflow}
   */


  function ingest(target, data, format) {
    data = this.parse(data, format);
    return this.pulse(target, this.changeset().insert(data));
  }
  /**
   * Request data from an external source, parse it, and return a Promise.
   * @param {string} url - The URL from which to load the data. This string
   *   is passed to the vega-loader load method.
   * @param {object} [format] - The data format description for parsing
   *   loaded data. This object is passed to the vega-loader read method.
   * @return {Promise} A Promise that resolves upon completion of the request.
   *   The resolved object contains the following properties:
   *   - data: an array of parsed data (or null upon error)
   *   - status: a code for success (0), load fail (-1), or parse fail (-2)
   */


  async function request(url, format) {
    const df = this;
    let status = 0,
        data;

    try {
      data = await df.loader().load(url, {
        context: 'dataflow',
        response: responseType(format && format.type)
      });

      try {
        data = df.parse(data, format);
      } catch (err) {
        status = -2;
        df.warn('Data ingestion failed', url, err);
      }
    } catch (err) {
      status = -1;
      df.warn('Loading failed', url, err);
    }

    return {
      data,
      status
    };
  }

  async function preload(target, url, format) {
    const df = this,
          pending = df._pending || loadPending(df);
    pending.requests += 1;
    const res = await df.request(url, format);
    df.pulse(target, df.changeset().remove(truthy).insert(res.data || []));
    pending.done();
    return res;
  }

  function loadPending(df) {
    let accept;
    const pending = new Promise(a => accept = a);
    pending.requests = 0;

    pending.done = () => {
      if (--pending.requests === 0) {
        df._pending = null;
        accept(df);
      }
    };

    return df._pending = pending;
  }

  const SKIP$2 = {
    skip: true
  };
  /**
   * Perform operator updates in response to events. Applies an
   * update function to compute a new operator value. If the update function
   * returns a {@link ChangeSet}, the operator will be pulsed with those tuple
   * changes. Otherwise, the operator value will be updated to the return value.
   * @param {EventStream|Operator} source - The event source to react to.
   *   This argument can be either an EventStream or an Operator.
   * @param {Operator|function(object):Operator} target - The operator to update.
   *   This argument can either be an Operator instance or (if the source
   *   argument is an EventStream), a function that accepts an event object as
   *   input and returns an Operator to target.
   * @param {function(Parameters,Event): *} [update] - Optional update function
   *   to compute the new operator value, or a literal value to set. Update
   *   functions expect to receive a parameter object and event as arguments.
   *   This function can either return a new operator value or (if the source
   *   argument is an EventStream) a {@link ChangeSet} instance to pulse
   *   the target operator with tuple changes.
   * @param {object} [params] - The update function parameters.
   * @param {object} [options] - Additional options hash. If not overridden,
   *   updated operators will be skipped by default.
   * @param {boolean} [options.skip] - If true, the operator will
   *  be skipped: it will not be evaluated, but its dependents will be.
   * @param {boolean} [options.force] - If true, the operator will
   *   be re-evaluated even if its value has not changed.
   * @return {Dataflow}
   */

  function on(source, target, update, params, options) {
    const fn = source instanceof Operator ? onOperator : onStream;
    fn(this, source, target, update, params, options);
    return this;
  }

  function onStream(df, stream, target, update, params, options) {
    const opt = extend$1({}, options, SKIP$2);
    let func, op;
    if (!isFunction(target)) target = constant$4(target);

    if (update === undefined) {
      func = e => df.touch(target(e));
    } else if (isFunction(update)) {
      op = new Operator(null, update, params, false);

      func = e => {
        op.evaluate(e);
        const t = target(e),
              v = op.value;
        isChangeSet(v) ? df.pulse(t, v, options) : df.update(t, v, opt);
      };
    } else {
      func = e => df.update(target(e), update, opt);
    }

    stream.apply(func);
  }

  function onOperator(df, source, target, update, params, options) {
    if (update === undefined) {
      source.targets().add(target);
    } else {
      const opt = options || {},
            op = new Operator(null, updater(target, update), params, false);
      op.modified(opt.force);
      op.rank = source.rank; // immediately follow source

      source.targets().add(op); // add dependency

      if (target) {
        op.skip(true); // skip first invocation

        op.value = target.value; // initialize value

        op.targets().add(target); // chain dependencies

        df.connect(target, [op]); // rerank as needed, #1672
      }
    }
  }

  function updater(target, update) {
    update = isFunction(update) ? update : constant$4(update);
    return target ? function (_, pulse) {
      const value = update(_, pulse);

      if (!target.skip()) {
        target.skip(value !== this.value).value = value;
      }

      return value;
    } : update;
  }
  /**
   * Assigns a rank to an operator. Ranks are assigned in increasing order
   * by incrementing an internal rank counter.
   * @param {Operator} op - The operator to assign a rank.
   */


  function rank(op) {
    op.rank = ++this._rank;
  }
  /**
   * Re-ranks an operator and all downstream target dependencies. This
   * is necessary when upstream dependencies of higher rank are added to
   * a target operator.
   * @param {Operator} op - The operator to re-rank.
   */


  function rerank(op) {
    const queue = [op];
    let cur, list, i;

    while (queue.length) {
      this.rank(cur = queue.pop());

      if (list = cur._targets) {
        for (i = list.length; --i >= 0;) {
          queue.push(cur = list[i]);
          if (cur === op) error('Cycle detected in dataflow graph.');
        }
      }
    }
  }
  /**
   * Sentinel value indicating pulse propagation should stop.
   */


  const StopPropagation = {}; // Pulse visit type flags

  const ADD = 1 << 0,
        REM = 1 << 1,
        MOD$1 = 1 << 2,
        ADD_REM = ADD | REM,
        ADD_MOD = ADD | MOD$1,
        ALL = ADD | REM | MOD$1,
        REFLOW = 1 << 3,
        SOURCE = 1 << 4,
        NO_SOURCE = 1 << 5,
        NO_FIELDS = 1 << 6;
  /**
   * A Pulse enables inter-operator communication during a run of the
   * dataflow graph. In addition to the current timestamp, a pulse may also
   * contain a change-set of added, removed or modified data tuples, as well as
   * a pointer to a full backing data source. Tuple change sets may not
   * be fully materialized; for example, to prevent needless array creation
   * a change set may include larger arrays and corresponding filter functions.
   * The pulse provides a {@link visit} method to enable proper and efficient
   * iteration over requested data tuples.
   *
   * In addition, each pulse can track modification flags for data tuple fields.
   * Responsible transform operators should call the {@link modifies} method to
   * indicate changes to data fields. The {@link modified} method enables
   * querying of this modification state.
   *
   * @constructor
   * @param {Dataflow} dataflow - The backing dataflow instance.
   * @param {number} stamp - The current propagation timestamp.
   * @param {string} [encode] - An optional encoding set name, which is then
   *   accessible as Pulse.encode. Operators can respond to (or ignore) this
   *   setting as appropriate. This parameter can be used in conjunction with
   *   the Encode transform in the vega-encode module.
   */

  function Pulse(dataflow, stamp, encode) {
    this.dataflow = dataflow;
    this.stamp = stamp == null ? -1 : stamp;
    this.add = [];
    this.rem = [];
    this.mod = [];
    this.fields = null;
    this.encode = encode || null;
  }

  function materialize(data, filter) {
    const out = [];
    visitArray(data, filter, _ => out.push(_));
    return out;
  }

  function filter$1(pulse, flags) {
    const map = {};
    pulse.visit(flags, t => {
      map[tupleid(t)] = 1;
    });
    return t => map[tupleid(t)] ? null : t;
  }

  function addFilter(a, b) {
    return a ? (t, i) => a(t, i) && b(t, i) : b;
  }

  Pulse.prototype = {
    /**
     * Sentinel value indicating pulse propagation should stop.
     */
    StopPropagation,

    /**
     * Boolean flag indicating ADD (added) tuples.
     */
    ADD,

    /**
     * Boolean flag indicating REM (removed) tuples.
     */
    REM,

    /**
     * Boolean flag indicating MOD (modified) tuples.
     */
    MOD: MOD$1,

    /**
     * Boolean flag indicating ADD (added) and REM (removed) tuples.
     */
    ADD_REM,

    /**
     * Boolean flag indicating ADD (added) and MOD (modified) tuples.
     */
    ADD_MOD,

    /**
     * Boolean flag indicating ADD, REM and MOD tuples.
     */
    ALL,

    /**
     * Boolean flag indicating all tuples in a data source
     * except for the ADD, REM and MOD tuples.
     */
    REFLOW,

    /**
     * Boolean flag indicating a 'pass-through' to a
     * backing data source, ignoring ADD, REM and MOD tuples.
     */
    SOURCE,

    /**
     * Boolean flag indicating that source data should be
     * suppressed when creating a forked pulse.
     */
    NO_SOURCE,

    /**
     * Boolean flag indicating that field modifications should be
     * suppressed when creating a forked pulse.
     */
    NO_FIELDS,

    /**
     * Creates a new pulse based on the values of this pulse.
     * The dataflow, time stamp and field modification values are copied over.
     * By default, new empty ADD, REM and MOD arrays are created.
     * @param {number} flags - Integer of boolean flags indicating which (if any)
     *   tuple arrays should be copied to the new pulse. The supported flag values
     *   are ADD, REM and MOD. Array references are copied directly: new array
     *   instances are not created.
     * @return {Pulse} - The forked pulse instance.
     * @see init
     */
    fork(flags) {
      return new Pulse(this.dataflow).init(this, flags);
    },

    /**
     * Creates a copy of this pulse with new materialized array
     * instances for the ADD, REM, MOD, and SOURCE arrays.
     * The dataflow, time stamp and field modification values are copied over.
     * @return {Pulse} - The cloned pulse instance.
     * @see init
     */
    clone() {
      const p = this.fork(ALL);
      p.add = p.add.slice();
      p.rem = p.rem.slice();
      p.mod = p.mod.slice();
      if (p.source) p.source = p.source.slice();
      return p.materialize(ALL | SOURCE);
    },

    /**
     * Returns a pulse that adds all tuples from a backing source. This is
     * useful for cases where operators are added to a dataflow after an
     * upstream data pipeline has already been processed, ensuring that
     * new operators can observe all tuples within a stream.
     * @return {Pulse} - A pulse instance with all source tuples included
     *   in the add array. If the current pulse already has all source
     *   tuples in its add array, it is returned directly. If the current
     *   pulse does not have a backing source, it is returned directly.
     */
    addAll() {
      let p = this;
      const reuse = !p.source || p.add === p.rem // special case for indexed set (e.g., crossfilter)
      || !p.rem.length && p.source.length === p.add.length;

      if (reuse) {
        return p;
      } else {
        p = new Pulse(this.dataflow).init(this);
        p.add = p.source;
        p.rem = []; // new operators can ignore rem #2769

        return p;
      }
    },

    /**
     * Initialize this pulse based on the values of another pulse. This method
     * is used internally by {@link fork} to initialize a new forked tuple.
     * The dataflow, time stamp and field modification values are copied over.
     * By default, new empty ADD, REM and MOD arrays are created.
     * @param {Pulse} src - The source pulse to copy from.
     * @param {number} flags - Integer of boolean flags indicating which (if any)
     *   tuple arrays should be copied to the new pulse. The supported flag values
     *   are ADD, REM and MOD. Array references are copied directly: new array
     *   instances are not created. By default, source data arrays are copied
     *   to the new pulse. Use the NO_SOURCE flag to enforce a null source.
     * @return {Pulse} - Returns this Pulse instance.
     */
    init(src, flags) {
      const p = this;
      p.stamp = src.stamp;
      p.encode = src.encode;

      if (src.fields && !(flags & NO_FIELDS)) {
        p.fields = src.fields;
      }

      if (flags & ADD) {
        p.addF = src.addF;
        p.add = src.add;
      } else {
        p.addF = null;
        p.add = [];
      }

      if (flags & REM) {
        p.remF = src.remF;
        p.rem = src.rem;
      } else {
        p.remF = null;
        p.rem = [];
      }

      if (flags & MOD$1) {
        p.modF = src.modF;
        p.mod = src.mod;
      } else {
        p.modF = null;
        p.mod = [];
      }

      if (flags & NO_SOURCE) {
        p.srcF = null;
        p.source = null;
      } else {
        p.srcF = src.srcF;
        p.source = src.source;
        if (src.cleans) p.cleans = src.cleans;
      }

      return p;
    },

    /**
     * Schedules a function to run after pulse propagation completes.
     * @param {function} func - The function to run.
     */
    runAfter(func) {
      this.dataflow.runAfter(func);
    },

    /**
     * Indicates if tuples have been added, removed or modified.
     * @param {number} [flags] - The tuple types (ADD, REM or MOD) to query.
     *   Defaults to ALL, returning true if any tuple type has changed.
     * @return {boolean} - Returns true if one or more queried tuple types have
     *   changed, false otherwise.
     */
    changed(flags) {
      const f = flags || ALL;
      return f & ADD && this.add.length || f & REM && this.rem.length || f & MOD$1 && this.mod.length;
    },

    /**
     * Forces a "reflow" of tuple values, such that all tuples in the backing
     * source are added to the MOD set, unless already present in the ADD set.
     * @param {boolean} [fork=false] - If true, returns a forked copy of this
     *   pulse, and invokes reflow on that derived pulse.
     * @return {Pulse} - The reflowed pulse instance.
     */
    reflow(fork) {
      if (fork) return this.fork(ALL).reflow();
      const len = this.add.length,
            src = this.source && this.source.length;

      if (src && src !== len) {
        this.mod = this.source;
        if (len) this.filter(MOD$1, filter$1(this, ADD));
      }

      return this;
    },

    /**
     * Get/set metadata to pulse requesting garbage collection
     * to reclaim currently unused resources.
     */
    clean(value) {
      if (arguments.length) {
        this.cleans = !!value;
        return this;
      } else {
        return this.cleans;
      }
    },

    /**
     * Marks one or more data field names as modified to assist dependency
     * tracking and incremental processing by transform operators.
     * @param {string|Array<string>} _ - The field(s) to mark as modified.
     * @return {Pulse} - This pulse instance.
     */
    modifies(_) {
      const hash = this.fields || (this.fields = {});

      if (isArray(_)) {
        _.forEach(f => hash[f] = true);
      } else {
        hash[_] = true;
      }

      return this;
    },

    /**
     * Checks if one or more data fields have been modified during this pulse
     * propagation timestamp.
     * @param {string|Array<string>} _ - The field(s) to check for modified.
     * @param {boolean} nomod - If true, will check the modified flag even if
     *   no mod tuples exist. If false (default), mod tuples must be present.
     * @return {boolean} - Returns true if any of the provided fields has been
     *   marked as modified, false otherwise.
     */
    modified(_, nomod) {
      const fields = this.fields;
      return !((nomod || this.mod.length) && fields) ? false : !arguments.length ? !!fields : isArray(_) ? _.some(f => fields[f]) : fields[_];
    },

    /**
     * Adds a filter function to one more tuple sets. Filters are applied to
     * backing tuple arrays, to determine the actual set of tuples considered
     * added, removed or modified. They can be used to delay materialization of
     * a tuple set in order to avoid expensive array copies. In addition, the
     * filter functions can serve as value transformers: unlike standard predicate
     * function (which return boolean values), Pulse filters should return the
     * actual tuple value to process. If a tuple set is already filtered, the
     * new filter function will be appended into a conjuntive ('and') query.
     * @param {number} flags - Flags indicating the tuple set(s) to filter.
     * @param {function(*):object} filter - Filter function that will be applied
     *   to the tuple set array, and should return a data tuple if the value
     *   should be included in the tuple set, and falsy (or null) otherwise.
     * @return {Pulse} - Returns this pulse instance.
     */
    filter(flags, filter) {
      const p = this;
      if (flags & ADD) p.addF = addFilter(p.addF, filter);
      if (flags & REM) p.remF = addFilter(p.remF, filter);
      if (flags & MOD$1) p.modF = addFilter(p.modF, filter);
      if (flags & SOURCE) p.srcF = addFilter(p.srcF, filter);
      return p;
    },

    /**
     * Materialize one or more tuple sets in this pulse. If the tuple set(s) have
     * a registered filter function, it will be applied and the tuple set(s) will
     * be replaced with materialized tuple arrays.
     * @param {number} flags - Flags indicating the tuple set(s) to materialize.
     * @return {Pulse} - Returns this pulse instance.
     */
    materialize(flags) {
      flags = flags || ALL;
      const p = this;

      if (flags & ADD && p.addF) {
        p.add = materialize(p.add, p.addF);
        p.addF = null;
      }

      if (flags & REM && p.remF) {
        p.rem = materialize(p.rem, p.remF);
        p.remF = null;
      }

      if (flags & MOD$1 && p.modF) {
        p.mod = materialize(p.mod, p.modF);
        p.modF = null;
      }

      if (flags & SOURCE && p.srcF) {
        p.source = p.source.filter(p.srcF);
        p.srcF = null;
      }

      return p;
    },

    /**
     * Visit one or more tuple sets in this pulse.
     * @param {number} flags - Flags indicating the tuple set(s) to visit.
     *   Legal values are ADD, REM, MOD and SOURCE (if a backing data source
     *   has been set).
     * @param {function(object):*} - Visitor function invoked per-tuple.
     * @return {Pulse} - Returns this pulse instance.
     */
    visit(flags, visitor) {
      const p = this,
            v = visitor;

      if (flags & SOURCE) {
        visitArray(p.source, p.srcF, v);
        return p;
      }

      if (flags & ADD) visitArray(p.add, p.addF, v);
      if (flags & REM) visitArray(p.rem, p.remF, v);
      if (flags & MOD$1) visitArray(p.mod, p.modF, v);
      const src = p.source;

      if (flags & REFLOW && src) {
        const sum = p.add.length + p.mod.length;
        if (sum === src.length) ;else if (sum) {
          visitArray(src, filter$1(p, ADD_MOD), v);
        } else {
          // if no add/rem/mod tuples, visit source
          visitArray(src, p.srcF, v);
        }
      }

      return p;
    }

  };
  /**
   * Represents a set of multiple pulses. Used as input for operators
   * that accept multiple pulses at a time. Contained pulses are
   * accessible via the public "pulses" array property. This pulse doe
   * not carry added, removed or modified tuples directly. However,
   * the visit method can be used to traverse all such tuples contained
   * in sub-pulses with a timestamp matching this parent multi-pulse.
   * @constructor
   * @param {Dataflow} dataflow - The backing dataflow instance.
   * @param {number} stamp - The timestamp.
   * @param {Array<Pulse>} pulses - The sub-pulses for this multi-pulse.
   */

  function MultiPulse(dataflow, stamp, pulses, encode) {
    const p = this,
          n = pulses.length;
    let c = 0;
    this.dataflow = dataflow;
    this.stamp = stamp;
    this.fields = null;
    this.encode = encode || null;
    this.pulses = pulses;

    for (let i = 0; i < n; ++i) {
      const pulse = pulses[i];
      if (pulse.stamp !== stamp) continue;

      if (pulse.fields) {
        const hash = p.fields || (p.fields = {});

        for (const f in pulse.fields) {
          hash[f] = 1;
        }
      }

      if (pulse.changed(p.ADD)) c |= p.ADD;
      if (pulse.changed(p.REM)) c |= p.REM;
      if (pulse.changed(p.MOD)) c |= p.MOD;
    }

    this.changes = c;
  }

  inherits(MultiPulse, Pulse, {
    /**
     * Creates a new pulse based on the values of this pulse.
     * The dataflow, time stamp and field modification values are copied over.
     * @return {Pulse}
     */
    fork(flags) {
      const p = new Pulse(this.dataflow).init(this, flags & this.NO_FIELDS);

      if (flags !== undefined) {
        if (flags & p.ADD) this.visit(p.ADD, t => p.add.push(t));
        if (flags & p.REM) this.visit(p.REM, t => p.rem.push(t));
        if (flags & p.MOD) this.visit(p.MOD, t => p.mod.push(t));
      }

      return p;
    },

    changed(flags) {
      return this.changes & flags;
    },

    modified(_) {
      const p = this,
            fields = p.fields;
      return !(fields && p.changes & p.MOD) ? 0 : isArray(_) ? _.some(f => fields[f]) : fields[_];
    },

    filter() {
      error('MultiPulse does not support filtering.');
    },

    materialize() {
      error('MultiPulse does not support materialization.');
    },

    visit(flags, visitor) {
      const p = this,
            pulses = p.pulses,
            n = pulses.length;
      let i = 0;

      if (flags & p.SOURCE) {
        for (; i < n; ++i) {
          pulses[i].visit(flags, visitor);
        }
      } else {
        for (; i < n; ++i) {
          if (pulses[i].stamp === p.stamp) {
            pulses[i].visit(flags, visitor);
          }
        }
      }

      return p;
    }

  });
  /* eslint-disable require-atomic-updates */

  /**
   * Evaluates the dataflow and returns a Promise that resolves when pulse
   * propagation completes. This method will increment the current timestamp
   * and process all updated, pulsed and touched operators. When invoked for
   * the first time, all registered operators will be processed. This method
   * should not be invoked by third-party clients, use {@link runAsync} or
   * {@link run} instead.
   * @param {string} [encode] - The name of an encoding set to invoke during
   *   propagation. This value is added to generated Pulse instances;
   *   operators can then respond to (or ignore) this setting as appropriate.
   *   This parameter can be used in conjunction with the Encode transform in
   *   the vega-encode package.
   * @param {function} [prerun] - An optional callback function to invoke
   *   immediately before dataflow evaluation commences.
   * @param {function} [postrun] - An optional callback function to invoke
   *   after dataflow evaluation completes. The callback will be invoked
   *   after those registered via {@link runAfter}.
   * @return {Promise} - A promise that resolves to this dataflow after
   *   evaluation completes.
   */

  async function evaluate(encode, prerun, postrun) {
    const df = this,
          async = []; // if the pulse value is set, this is a re-entrant call

    if (df._pulse) return reentrant(df); // wait for pending datasets to load

    if (df._pending) await df._pending; // invoke prerun function, if provided

    if (prerun) await asyncCallback(df, prerun); // exit early if there are no updates

    if (!df._touched.length) {
      df.debug('Dataflow invoked, but nothing to do.');
      return df;
    } // increment timestamp clock


    const stamp = ++df._clock; // set the current pulse

    df._pulse = new Pulse(df, stamp, encode); // initialize priority queue, reset touched operators

    df._touched.forEach(op => df._enqueue(op, true));

    df._touched = UniqueList(id);
    let count = 0,
        op,
        next,
        error;

    try {
      while (df._heap.size() > 0) {
        // dequeue operator with highest priority
        op = df._heap.pop(); // re-queue if rank changed

        if (op.rank !== op.qrank) {
          df._enqueue(op, true);

          continue;
        } // otherwise, evaluate the operator


        next = op.run(df._getPulse(op, encode));

        if (next.then) {
          // await if operator returns a promise directly
          next = await next;
        } else if (next.async) {
          // queue parallel asynchronous execution
          async.push(next.async);
          next = StopPropagation;
        } // propagate evaluation, enqueue dependent operators


        if (next !== StopPropagation) {
          if (op._targets) op._targets.forEach(op => df._enqueue(op));
        } // increment visit counter


        ++count;
      }
    } catch (err) {
      df._heap.clear();

      error = err;
    } // reset pulse map


    df._input = {};
    df._pulse = null;
    df.debug(`Pulse ${stamp}: ${count} operators`);

    if (error) {
      df._postrun = [];
      df.error(error);
    } // invoke callbacks queued via runAfter


    if (df._postrun.length) {
      const pr = df._postrun.sort((a, b) => b.priority - a.priority);

      df._postrun = [];

      for (let i = 0; i < pr.length; ++i) {
        await asyncCallback(df, pr[i].callback);
      }
    } // invoke postrun function, if provided


    if (postrun) await asyncCallback(df, postrun); // handle non-blocking asynchronous callbacks

    if (async.length) {
      Promise.all(async).then(cb => df.runAsync(null, () => {
        cb.forEach(f => {
          try {
            f(df);
          } catch (err) {
            df.error(err);
          }
        });
      }));
    }

    return df;
  }
  /**
   * Queues dataflow evaluation to run once any other queued evaluations have
   * completed and returns a Promise that resolves when the queued pulse
   * propagation completes. If provided, a callback function will be invoked
   * immediately before evaluation commences. This method will ensure a
   * separate evaluation is invoked for each time it is called.
   * @param {string} [encode] - The name of an encoding set to invoke during
   *   propagation. This value is added to generated Pulse instances;
   *   operators can then respond to (or ignore) this setting as appropriate.
   *   This parameter can be used in conjunction with the Encode transform in
   *   the vega-encode package.
   * @param {function} [prerun] - An optional callback function to invoke
   *   immediately before dataflow evaluation commences.
   * @param {function} [postrun] - An optional callback function to invoke
   *   after dataflow evaluation completes. The callback will be invoked
   *   after those registered via {@link runAfter}.
   * @return {Promise} - A promise that resolves to this dataflow after
   *   evaluation completes.
   */


  async function runAsync(encode, prerun, postrun) {
    // await previously queued functions
    while (this._running) await this._running; // run dataflow, manage running promise


    const clear = () => this._running = null;

    (this._running = this.evaluate(encode, prerun, postrun)).then(clear, clear);
    return this._running;
  }
  /**
   * Requests dataflow evaluation and the immediately returns this dataflow
   * instance. If there are pending data loading or other asynchronous
   * operations, the dataflow will evaluate asynchronously after this method
   * has been invoked. To track when dataflow evaluation completes, use the
   * {@link runAsync} method instead. This method will raise an error if
   * invoked while the dataflow is already in the midst of evaluation.
   * @param {string} [encode] - The name of an encoding set to invoke during
   *   propagation. This value is added to generated Pulse instances;
   *   operators can then respond to (or ignore) this setting as appropriate.
   *   This parameter can be used in conjunction with the Encode transform in
   *   the vega-encode module.
   * @param {function} [prerun] - An optional callback function to invoke
   *   immediately before dataflow evaluation commences.
   * @param {function} [postrun] - An optional callback function to invoke
   *   after dataflow evaluation completes. The callback will be invoked
   *   after those registered via {@link runAfter}.
   * @return {Dataflow} - This dataflow instance.
   */


  function run(encode, prerun, postrun) {
    return this._pulse ? reentrant(this) : (this.evaluate(encode, prerun, postrun), this);
  }
  /**
   * Schedules a callback function to be invoked after the current pulse
   * propagation completes. If no propagation is currently occurring,
   * the function is invoked immediately. Callbacks scheduled via runAfter
   * are invoked immediately upon completion of the current cycle, before
   * any request queued via runAsync. This method is primarily intended for
   * internal use. Third-party callers using runAfter to schedule a callback
   * that invokes {@link run} or {@link runAsync} should not use this method,
   * but instead use {@link runAsync} with prerun or postrun arguments.
   * @param {function(Dataflow)} callback - The callback function to run.
   *   The callback will be invoked with this Dataflow instance as its
   *   sole argument.
   * @param {boolean} enqueue - A boolean flag indicating that the
   *   callback should be queued up to run after the next propagation
   *   cycle, suppressing immediate invocation when propagation is not
   *   currently occurring.
   * @param {number} [priority] - A priority value used to sort registered
   *   callbacks to determine execution order. This argument is intended
   *   for internal Vega use only.
   */


  function runAfter(callback, enqueue, priority) {
    if (this._pulse || enqueue) {
      // pulse propagation is currently running, queue to run after
      this._postrun.push({
        priority: priority || 0,
        callback: callback
      });
    } else {
      // pulse propagation already complete, invoke immediately
      try {
        callback(this);
      } catch (err) {
        this.error(err);
      }
    }
  }
  /**
   * Raise an error for re-entrant dataflow evaluation.
   */


  function reentrant(df) {
    df.error('Dataflow already running. Use runAsync() to chain invocations.');
    return df;
  }
  /**
   * Enqueue an operator into the priority queue for evaluation. The operator
   * will be enqueued if it has no registered pulse for the current cycle, or if
   * the force argument is true. Upon enqueue, this method also sets the
   * operator's qrank to the current rank value.
   * @param {Operator} op - The operator to enqueue.
   * @param {boolean} [force] - A flag indicating if the operator should be
   *   forceably added to the queue, even if it has already been previously
   *   enqueued during the current pulse propagation. This is useful when the
   *   dataflow graph is dynamically modified and the operator rank changes.
   */


  function enqueue(op, force) {
    const q = op.stamp < this._clock;
    if (q) op.stamp = this._clock;

    if (q || force) {
      op.qrank = op.rank;

      this._heap.push(op);
    }
  }
  /**
   * Provide a correct pulse for evaluating an operator. If the operator has an
   * explicit source operator, we will try to pull the pulse(s) from it.
   * If there is an array of source operators, we build a multi-pulse.
   * Otherwise, we return a current pulse with correct source data.
   * If the pulse is the pulse map has an explicit target set, we use that.
   * Else if the pulse on the upstream source operator is current, we use that.
   * Else we use the pulse from the pulse map, but copy the source tuple array.
   * @param {Operator} op - The operator for which to get an input pulse.
   * @param {string} [encode] - An (optional) encoding set name with which to
   *   annotate the returned pulse. See {@link run} for more information.
   */


  function getPulse(op, encode) {
    const s = op.source,
          stamp = this._clock;
    return s && isArray(s) ? new MultiPulse(this, stamp, s.map(_ => _.pulse), encode) : this._input[op.id] || singlePulse(this._pulse, s && s.pulse);
  }

  function singlePulse(p, s) {
    if (s && s.stamp === p.stamp) {
      return s;
    }

    p = p.fork();

    if (s && s !== StopPropagation) {
      p.source = s.source;
    }

    return p;
  }

  const NO_OPT = {
    skip: false,
    force: false
  };
  /**
   * Touches an operator, scheduling it to be evaluated. If invoked outside of
   * a pulse propagation, the operator will be evaluated the next time this
   * dataflow is run. If invoked in the midst of pulse propagation, the operator
   * will be queued for evaluation if and only if the operator has not yet been
   * evaluated on the current propagation timestamp.
   * @param {Operator} op - The operator to touch.
   * @param {object} [options] - Additional options hash.
   * @param {boolean} [options.skip] - If true, the operator will
   *   be skipped: it will not be evaluated, but its dependents will be.
   * @return {Dataflow}
   */

  function touch(op, options) {
    const opt = options || NO_OPT;

    if (this._pulse) {
      // if in midst of propagation, add to priority queue
      this._enqueue(op);
    } else {
      // otherwise, queue for next propagation
      this._touched.add(op);
    }

    if (opt.skip) op.skip(true);
    return this;
  }
  /**
   * Updates the value of the given operator.
   * @param {Operator} op - The operator to update.
   * @param {*} value - The value to set.
   * @param {object} [options] - Additional options hash.
   * @param {boolean} [options.force] - If true, the operator will
   *   be re-evaluated even if its value has not changed.
   * @param {boolean} [options.skip] - If true, the operator will
   *   be skipped: it will not be evaluated, but its dependents will be.
   * @return {Dataflow}
   */


  function update$6(op, value, options) {
    const opt = options || NO_OPT;

    if (op.set(value) || opt.force) {
      this.touch(op, opt);
    }

    return this;
  }
  /**
   * Pulses an operator with a changeset of tuples. If invoked outside of
   * a pulse propagation, the pulse will be applied the next time this
   * dataflow is run. If invoked in the midst of pulse propagation, the pulse
   * will be added to the set of active pulses and will be applied if and
   * only if the target operator has not yet been evaluated on the current
   * propagation timestamp.
   * @param {Operator} op - The operator to pulse.
   * @param {ChangeSet} value - The tuple changeset to apply.
   * @param {object} [options] - Additional options hash.
   * @param {boolean} [options.skip] - If true, the operator will
   *   be skipped: it will not be evaluated, but its dependents will be.
   * @return {Dataflow}
   */


  function pulse(op, changeset, options) {
    this.touch(op, options || NO_OPT);
    const p = new Pulse(this, this._clock + (this._pulse ? 0 : 1)),
          t = op.pulse && op.pulse.source || [];
    p.target = op;
    this._input[op.id] = changeset.pulse(p, t);
    return this;
  }

  function Heap(cmp) {
    let nodes = [];
    return {
      clear: () => nodes = [],
      size: () => nodes.length,
      peek: () => nodes[0],
      push: x => {
        nodes.push(x);
        return siftdown(nodes, 0, nodes.length - 1, cmp);
      },
      pop: () => {
        const last = nodes.pop();
        let item;

        if (nodes.length) {
          item = nodes[0];
          nodes[0] = last;
          siftup(nodes, 0, cmp);
        } else {
          item = last;
        }

        return item;
      }
    };
  }

  function siftdown(array, start, idx, cmp) {
    let parent, pidx;
    const item = array[idx];

    while (idx > start) {
      pidx = idx - 1 >> 1;
      parent = array[pidx];

      if (cmp(item, parent) < 0) {
        array[idx] = parent;
        idx = pidx;
        continue;
      }

      break;
    }

    return array[idx] = item;
  }

  function siftup(array, idx, cmp) {
    const start = idx,
          end = array.length,
          item = array[idx];
    let cidx = (idx << 1) + 1,
        ridx;

    while (cidx < end) {
      ridx = cidx + 1;

      if (ridx < end && cmp(array[cidx], array[ridx]) >= 0) {
        cidx = ridx;
      }

      array[idx] = array[cidx];
      idx = cidx;
      cidx = (idx << 1) + 1;
    }

    array[idx] = item;
    return siftdown(array, start, idx, cmp);
  }
  /**
   * A dataflow graph for reactive processing of data streams.
   * @constructor
   */


  function Dataflow() {
    this.logger(logger());
    this.logLevel(Error$1);
    this._clock = 0;
    this._rank = 0;
    this._locale = defaultLocale();

    try {
      this._loader = loader();
    } catch (e) {// do nothing if loader module is unavailable
    }

    this._touched = UniqueList(id);
    this._input = {};
    this._pulse = null;
    this._heap = Heap((a, b) => a.qrank - b.qrank);
    this._postrun = [];
  }

  function logMethod(method) {
    return function () {
      return this._log[method].apply(this, arguments);
    };
  }

  Dataflow.prototype = {
    /**
     * The current timestamp of this dataflow. This value reflects the
     * timestamp of the previous dataflow run. The dataflow is initialized
     * with a stamp value of 0. The initial run of the dataflow will have
     * a timestap of 1, and so on. This value will match the
     * {@link Pulse.stamp} property.
     * @return {number} - The current timestamp value.
     */
    stamp() {
      return this._clock;
    },

    /**
     * Gets or sets the loader instance to use for data file loading. A
     * loader object must provide a "load" method for loading files and a
     * "sanitize" method for checking URL/filename validity. Both methods
     * should accept a URI and options hash as arguments, and return a Promise
     * that resolves to the loaded file contents (load) or a hash containing
     * sanitized URI data with the sanitized url assigned to the "href" property
     * (sanitize).
     * @param {object} _ - The loader instance to use.
     * @return {object|Dataflow} - If no arguments are provided, returns
     *   the current loader instance. Otherwise returns this Dataflow instance.
     */
    loader(_) {
      if (arguments.length) {
        this._loader = _;
        return this;
      } else {
        return this._loader;
      }
    },

    /**
     * Gets or sets the locale instance to use for formatting and parsing
     * string values. The locale object should be provided by the
     * vega-format library, and include methods such as format, timeFormat,
     * utcFormat, timeParse, and utcParse.
     * @param {object} _ - The locale instance to use.
     * @return {object|Dataflow} - If no arguments are provided, returns
     *   the current locale instance. Otherwise returns this Dataflow instance.
     */
    locale(_) {
      if (arguments.length) {
        this._locale = _;
        return this;
      } else {
        return this._locale;
      }
    },

    /**
     * Get or set the logger instance used to log messages. If no arguments are
     * provided, returns the current logger instance. Otherwise, sets the logger
     * and return this Dataflow instance. Provided loggers must support the full
     * API of logger objects generated by the vega-util logger method. Note that
     * by default the log level of the new logger will be used; use the logLevel
     * method to adjust the log level as needed.
     */
    logger(logger) {
      if (arguments.length) {
        this._log = logger;
        return this;
      } else {
        return this._log;
      }
    },

    /**
     * Logs an error message. By default, logged messages are written to console
     * output. The message will only be logged if the current log level is high
     * enough to permit error messages.
     */
    error: logMethod('error'),

    /**
     * Logs a warning message. By default, logged messages are written to console
     * output. The message will only be logged if the current log level is high
     * enough to permit warning messages.
     */
    warn: logMethod('warn'),

    /**
     * Logs a information message. By default, logged messages are written to
     * console output. The message will only be logged if the current log level is
     * high enough to permit information messages.
     */
    info: logMethod('info'),

    /**
     * Logs a debug message. By default, logged messages are written to console
     * output. The message will only be logged if the current log level is high
     * enough to permit debug messages.
     */
    debug: logMethod('debug'),

    /**
     * Get or set the current log level. If an argument is provided, it
     * will be used as the new log level.
     * @param {number} [level] - Should be one of None, Warn, Info
     * @return {number} - The current log level.
     */
    logLevel: logMethod('level'),

    /**
     * Empty entry threshold for garbage cleaning. Map data structures will
     * perform cleaning once the number of empty entries exceeds this value.
     */
    cleanThreshold: 1e4,
    // OPERATOR REGISTRATION
    add: add$3,
    connect,
    rank,
    rerank,
    // OPERATOR UPDATES
    pulse,
    touch,
    update: update$6,
    changeset,
    // DATA LOADING
    ingest,
    parse: parse$4,
    preload,
    request,
    // EVENT HANDLING
    events: events$1,
    on,
    // PULSE PROPAGATION
    evaluate,
    run,
    runAsync,
    runAfter,
    _enqueue: enqueue,
    _getPulse: getPulse
  };
  /**
   * Abstract class for operators that process data tuples.
   * Subclasses must provide a {@link transform} method for operator processing.
   * @constructor
   * @param {*} [init] - The initial value for this operator.
   * @param {object} [params] - The parameters for this operator.
   * @param {Operator} [source] - The operator from which to receive pulses.
   */

  function Transform(init, params) {
    Operator.call(this, init, null, params);
  }

  inherits(Transform, Operator, {
    /**
     * Overrides {@link Operator.evaluate} for transform operators.
     * Internally, this method calls {@link evaluate} to perform processing.
     * If {@link evaluate} returns a falsy value, the input pulse is returned.
     * This method should NOT be overridden, instead overrride {@link evaluate}.
     * @param {Pulse} pulse - the current dataflow pulse.
     * @return the output pulse for this operator (or StopPropagation)
     */
    run(pulse) {
      if (pulse.stamp < this.stamp) return pulse.StopPropagation;
      let rv;

      if (this.skip()) {
        this.skip(false);
      } else {
        rv = this.evaluate(pulse);
      }

      rv = rv || pulse;

      if (rv.then) {
        rv = rv.then(_ => this.pulse = _);
      } else if (rv !== pulse.StopPropagation) {
        this.pulse = rv;
      }

      return rv;
    },

    /**
     * Overrides {@link Operator.evaluate} for transform operators.
     * Marshalls parameter values and then invokes {@link transform}.
     * @param {Pulse} pulse - the current dataflow pulse.
     * @return {Pulse} The output pulse (or StopPropagation). A falsy return
         value (including undefined) will let the input pulse pass through.
    */
    evaluate(pulse) {
      const params = this.marshall(pulse.stamp),
            out = this.transform(params, pulse);
      params.clear();
      return out;
    },

    /**
     * Process incoming pulses.
     * Subclasses should override this method to implement transforms.
     * @param {Parameters} _ - The operator parameter values.
     * @param {Pulse} pulse - The current dataflow pulse.
     * @return {Pulse} The output pulse (or StopPropagation). A falsy return
     *   value (including undefined) will let the input pulse pass through.
     */
    transform() {}

  });
  const transforms = {};

  function definition$1(type) {
    const t = transform$2(type);
    return t && t.Definition || null;
  }

  function transform$2(type) {
    type = type && type.toLowerCase();
    return has$1(transforms, type) ? transforms[type] : null;
  }

  function* numbers$1(values, valueof) {
    if (valueof == null) {
      for (let value of values) {
        if (value != null && value !== '' && (value = +value) >= value) {
          yield value;
        }
      }
    } else {
      let index = -1;

      for (let value of values) {
        value = valueof(value, ++index, values);

        if (value != null && value !== '' && (value = +value) >= value) {
          yield value;
        }
      }
    }
  }

  function quantiles(array, p, f) {
    const values = Float64Array.from(numbers$1(array, f)); // don't depend on return value from typed array sort call
    // protects against undefined sort results in Safari (vega/vega-lite#4964)

    values.sort(ascending$2);
    return p.map(_ => quantileSorted(values, _));
  }

  function quartiles(array, f) {
    return quantiles(array, [0.25, 0.50, 0.75], f);
  } // Theory, Practice, and Visualization. Wiley.


  function estimateBandwidth(array, f) {
    const n = array.length,
          d = deviation(array, f),
          q = quartiles(array, f),
          h = (q[2] - q[0]) / 1.34,
          v = Math.min(d, h) || d || Math.abs(q[0]) || 1;
    return 1.06 * v * Math.pow(n, -0.2);
  }

  function bin(_) {
    // determine range
    const maxb = _.maxbins || 20,
          base = _.base || 10,
          logb = Math.log(base),
          div = _.divide || [5, 2];
    let min = _.extent[0],
        max = _.extent[1],
        step,
        level,
        minstep,
        v,
        i,
        n;
    const span = _.span || max - min || Math.abs(min) || 1;

    if (_.step) {
      // if step size is explicitly given, use that
      step = _.step;
    } else if (_.steps) {
      // if provided, limit choice to acceptable step sizes
      v = span / maxb;

      for (i = 0, n = _.steps.length; i < n && _.steps[i] < v; ++i);

      step = _.steps[Math.max(0, i - 1)];
    } else {
      // else use span to determine step size
      level = Math.ceil(Math.log(maxb) / logb);
      minstep = _.minstep || 0;
      step = Math.max(minstep, Math.pow(base, Math.round(Math.log(span) / logb) - level)); // increase step size if too many bins

      while (Math.ceil(span / step) > maxb) {
        step *= base;
      } // decrease step size if allowed


      for (i = 0, n = div.length; i < n; ++i) {
        v = step / div[i];
        if (v >= minstep && span / v <= maxb) step = v;
      }
    } // update precision, min and max


    v = Math.log(step);
    const precision = v >= 0 ? 0 : ~~(-v / logb) + 1,
          eps = Math.pow(base, -precision - 1);

    if (_.nice || _.nice === undefined) {
      v = Math.floor(min / step + eps) * step;
      min = min < v ? v - step : v;
      max = Math.ceil(max / step) * step;
    }

    return {
      start: min,
      stop: max === min ? min + step : max,
      step: step
    };
  }

  exports.random = Math.random;

  function setRandom(r) {
    exports.random = r;
  }

  function bootstrapCI(array, samples, alpha, f) {
    if (!array.length) return [undefined, undefined];
    const values = Float64Array.from(numbers$1(array, f)),
          n = values.length,
          m = samples;
    let a, i, j, mu;

    for (j = 0, mu = Array(m); j < m; ++j) {
      for (a = 0, i = 0; i < n; ++i) {
        a += values[~~(exports.random() * n)];
      }

      mu[j] = a / n;
    }

    mu.sort(ascending$2);
    return [quantile$1(mu, alpha / 2), quantile$1(mu, 1 - alpha / 2)];
  } // Dot density binning for dot plot construction.
  // Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
  // https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf


  function dotbin(array, step, smooth, f) {
    f = f || (_ => _);

    const n = array.length,
          v = new Float64Array(n);
    let i = 0,
        j = 1,
        a = f(array[0]),
        b = a,
        w = a + step,
        x;

    for (; j < n; ++j) {
      x = f(array[j]);

      if (x >= w) {
        b = (a + b) / 2;

        for (; i < j; ++i) v[i] = b;

        w = x + step;
        a = x;
      }

      b = x;
    }

    b = (a + b) / 2;

    for (; i < j; ++i) v[i] = b;

    return smooth ? smoothing(v, step + step / 4) : v;
  } // perform smoothing to reduce variance
  // swap points between "adjacent" stacks
  // Wilkinson defines adjacent as within step/4 units


  function smoothing(v, thresh) {
    const n = v.length;
    let a = 0,
        b = 1,
        c,
        d; // get left stack

    while (v[a] === v[b]) ++b;

    while (b < n) {
      // get right stack
      c = b + 1;

      while (v[b] === v[c]) ++c; // are stacks adjacent?
      // if so, compare sizes and swap as needed


      if (v[b] - v[b - 1] < thresh) {
        d = b + (a + c - b - b >> 1);

        while (d < b) v[d++] = v[b];

        while (d > b) v[d--] = v[a];
      } // update left stack indices


      a = b;
      b = c;
    }

    return v;
  }

  function lcg$1(seed) {
    // Random numbers using a Linear Congruential Generator with seed value
    // Uses glibc values from https://en.wikipedia.org/wiki/Linear_congruential_generator
    return function () {
      seed = (1103515245 * seed + 12345) % 2147483647;
      return seed / 2147483647;
    };
  }

  function integer(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }

    let a, b, d;
    const dist = {
      min(_) {
        if (arguments.length) {
          a = _ || 0;
          d = b - a;
          return dist;
        } else {
          return a;
        }
      },

      max(_) {
        if (arguments.length) {
          b = _ || 0;
          d = b - a;
          return dist;
        } else {
          return b;
        }
      },

      sample() {
        return a + Math.floor(d * exports.random());
      },

      pdf(x) {
        return x === Math.floor(x) && x >= a && x < b ? 1 / d : 0;
      },

      cdf(x) {
        const v = Math.floor(x);
        return v < a ? 0 : v >= b ? 1 : (v - a + 1) / d;
      },

      icdf(p) {
        return p >= 0 && p <= 1 ? a - 1 + Math.floor(p * d) : NaN;
      }

    };
    return dist.min(min).max(max);
  }

  const SQRT2PI = Math.sqrt(2 * Math.PI);
  const SQRT2 = Math.SQRT2;
  let nextSample = NaN;

  function sampleNormal(mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    let x = 0,
        y = 0,
        rds,
        c;

    if (nextSample === nextSample) {
      x = nextSample;
      nextSample = NaN;
    } else {
      do {
        x = exports.random() * 2 - 1;
        y = exports.random() * 2 - 1;
        rds = x * x + y * y;
      } while (rds === 0 || rds > 1);

      c = Math.sqrt(-2 * Math.log(rds) / rds); // Box-Muller transform

      x *= c;
      nextSample = y * c;
    }

    return mean + x * stdev;
  }

  function densityNormal(value, mean, stdev) {
    stdev = stdev == null ? 1 : stdev;
    const z = (value - (mean || 0)) / stdev;
    return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI);
  } // Approximation from West (2009)
  // Better Approximations to Cumulative Normal Functions


  function cumulativeNormal(value, mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    const z = (value - mean) / stdev,
          Z = Math.abs(z);
    let cd;

    if (Z > 37) {
      cd = 0;
    } else {
      const exp = Math.exp(-Z * Z / 2);
      let sum;

      if (Z < 7.07106781186547) {
        sum = 3.52624965998911e-02 * Z + 0.700383064443688;
        sum = sum * Z + 6.37396220353165;
        sum = sum * Z + 33.912866078383;
        sum = sum * Z + 112.079291497871;
        sum = sum * Z + 221.213596169931;
        sum = sum * Z + 220.206867912376;
        cd = exp * sum;
        sum = 8.83883476483184e-02 * Z + 1.75566716318264;
        sum = sum * Z + 16.064177579207;
        sum = sum * Z + 86.7807322029461;
        sum = sum * Z + 296.564248779674;
        sum = sum * Z + 637.333633378831;
        sum = sum * Z + 793.826512519948;
        sum = sum * Z + 440.413735824752;
        cd = cd / sum;
      } else {
        sum = Z + 0.65;
        sum = Z + 4 / sum;
        sum = Z + 3 / sum;
        sum = Z + 2 / sum;
        sum = Z + 1 / sum;
        cd = exp / sum / 2.506628274631;
      }
    }

    return z > 0 ? 1 - cd : cd;
  } // Approximation of Probit function using inverse error function.


  function quantileNormal(p, mean, stdev) {
    if (p < 0 || p > 1) return NaN;
    return (mean || 0) + (stdev == null ? 1 : stdev) * SQRT2 * erfinv(2 * p - 1);
  } // Approximate inverse error function. Implementation from "Approximating
  // the erfinv function" by Mike Giles, GPU Computing Gems, volume 2, 2010.
  // Ported from Apache Commons Math, http://www.apache.org/licenses/LICENSE-2.0


  function erfinv(x) {
    // beware that the logarithm argument must be
    // commputed as (1.0 - x) * (1.0 + x),
    // it must NOT be simplified as 1.0 - x * x as this
    // would induce rounding errors near the boundaries +/-1
    let w = -Math.log((1 - x) * (1 + x)),
        p;

    if (w < 6.25) {
      w -= 3.125;
      p = -3.6444120640178196996e-21;
      p = -1.685059138182016589e-19 + p * w;
      p = 1.2858480715256400167e-18 + p * w;
      p = 1.115787767802518096e-17 + p * w;
      p = -1.333171662854620906e-16 + p * w;
      p = 2.0972767875968561637e-17 + p * w;
      p = 6.6376381343583238325e-15 + p * w;
      p = -4.0545662729752068639e-14 + p * w;
      p = -8.1519341976054721522e-14 + p * w;
      p = 2.6335093153082322977e-12 + p * w;
      p = -1.2975133253453532498e-11 + p * w;
      p = -5.4154120542946279317e-11 + p * w;
      p = 1.051212273321532285e-09 + p * w;
      p = -4.1126339803469836976e-09 + p * w;
      p = -2.9070369957882005086e-08 + p * w;
      p = 4.2347877827932403518e-07 + p * w;
      p = -1.3654692000834678645e-06 + p * w;
      p = -1.3882523362786468719e-05 + p * w;
      p = 0.0001867342080340571352 + p * w;
      p = -0.00074070253416626697512 + p * w;
      p = -0.0060336708714301490533 + p * w;
      p = 0.24015818242558961693 + p * w;
      p = 1.6536545626831027356 + p * w;
    } else if (w < 16.0) {
      w = Math.sqrt(w) - 3.25;
      p = 2.2137376921775787049e-09;
      p = 9.0756561938885390979e-08 + p * w;
      p = -2.7517406297064545428e-07 + p * w;
      p = 1.8239629214389227755e-08 + p * w;
      p = 1.5027403968909827627e-06 + p * w;
      p = -4.013867526981545969e-06 + p * w;
      p = 2.9234449089955446044e-06 + p * w;
      p = 1.2475304481671778723e-05 + p * w;
      p = -4.7318229009055733981e-05 + p * w;
      p = 6.8284851459573175448e-05 + p * w;
      p = 2.4031110387097893999e-05 + p * w;
      p = -0.0003550375203628474796 + p * w;
      p = 0.00095328937973738049703 + p * w;
      p = -0.0016882755560235047313 + p * w;
      p = 0.0024914420961078508066 + p * w;
      p = -0.0037512085075692412107 + p * w;
      p = 0.005370914553590063617 + p * w;
      p = 1.0052589676941592334 + p * w;
      p = 3.0838856104922207635 + p * w;
    } else if (Number.isFinite(w)) {
      w = Math.sqrt(w) - 5.0;
      p = -2.7109920616438573243e-11;
      p = -2.5556418169965252055e-10 + p * w;
      p = 1.5076572693500548083e-09 + p * w;
      p = -3.7894654401267369937e-09 + p * w;
      p = 7.6157012080783393804e-09 + p * w;
      p = -1.4960026627149240478e-08 + p * w;
      p = 2.9147953450901080826e-08 + p * w;
      p = -6.7711997758452339498e-08 + p * w;
      p = 2.2900482228026654717e-07 + p * w;
      p = -9.9298272942317002539e-07 + p * w;
      p = 4.5260625972231537039e-06 + p * w;
      p = -1.9681778105531670567e-05 + p * w;
      p = 7.5995277030017761139e-05 + p * w;
      p = -0.00021503011930044477347 + p * w;
      p = -0.00013871931833623122026 + p * w;
      p = 1.0103004648645343977 + p * w;
      p = 4.8499064014085844221 + p * w;
    } else {
      p = Infinity;
    }

    return p * x;
  }

  function gaussian(mean, stdev) {
    let mu, sigma;
    const dist = {
      mean(_) {
        if (arguments.length) {
          mu = _ || 0;
          return dist;
        } else {
          return mu;
        }
      },

      stdev(_) {
        if (arguments.length) {
          sigma = _ == null ? 1 : _;
          return dist;
        } else {
          return sigma;
        }
      },

      sample: () => sampleNormal(mu, sigma),
      pdf: value => densityNormal(value, mu, sigma),
      cdf: value => cumulativeNormal(value, mu, sigma),
      icdf: p => quantileNormal(p, mu, sigma)
    };
    return dist.mean(mean).stdev(stdev);
  }

  function kde(support, bandwidth) {
    const kernel = gaussian();
    let n = 0;
    const dist = {
      data(_) {
        if (arguments.length) {
          support = _;
          n = _ ? _.length : 0;
          return dist.bandwidth(bandwidth);
        } else {
          return support;
        }
      },

      bandwidth(_) {
        if (!arguments.length) return bandwidth;
        bandwidth = _;
        if (!bandwidth && support) bandwidth = estimateBandwidth(support);
        return dist;
      },

      sample() {
        return support[~~(exports.random() * n)] + bandwidth * kernel.sample();
      },

      pdf(x) {
        let y = 0,
            i = 0;

        for (; i < n; ++i) {
          y += kernel.pdf((x - support[i]) / bandwidth);
        }

        return y / bandwidth / n;
      },

      cdf(x) {
        let y = 0,
            i = 0;

        for (; i < n; ++i) {
          y += kernel.cdf((x - support[i]) / bandwidth);
        }

        return y / n;
      },

      icdf() {
        throw Error('KDE icdf not supported.');
      }

    };
    return dist.data(support);
  }

  function sampleLogNormal(mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    return Math.exp(mean + sampleNormal() * stdev);
  }

  function densityLogNormal(value, mean, stdev) {
    if (value <= 0) return 0;
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    const z = (Math.log(value) - mean) / stdev;
    return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI * value);
  }

  function cumulativeLogNormal(value, mean, stdev) {
    return cumulativeNormal(Math.log(value), mean, stdev);
  }

  function quantileLogNormal(p, mean, stdev) {
    return Math.exp(quantileNormal(p, mean, stdev));
  }

  function lognormal(mean, stdev) {
    let mu, sigma;
    const dist = {
      mean(_) {
        if (arguments.length) {
          mu = _ || 0;
          return dist;
        } else {
          return mu;
        }
      },

      stdev(_) {
        if (arguments.length) {
          sigma = _ == null ? 1 : _;
          return dist;
        } else {
          return sigma;
        }
      },

      sample: () => sampleLogNormal(mu, sigma),
      pdf: value => densityLogNormal(value, mu, sigma),
      cdf: value => cumulativeLogNormal(value, mu, sigma),
      icdf: p => quantileLogNormal(p, mu, sigma)
    };
    return dist.mean(mean).stdev(stdev);
  }

  function mixture$1(dists, weights) {
    let m = 0,
        w;

    function normalize(x) {
      const w = [];
      let sum = 0,
          i;

      for (i = 0; i < m; ++i) {
        sum += w[i] = x[i] == null ? 1 : +x[i];
      }

      for (i = 0; i < m; ++i) {
        w[i] /= sum;
      }

      return w;
    }

    const dist = {
      weights(_) {
        if (arguments.length) {
          w = normalize(weights = _ || []);
          return dist;
        }

        return weights;
      },

      distributions(_) {
        if (arguments.length) {
          if (_) {
            m = _.length;
            dists = _;
          } else {
            m = 0;
            dists = [];
          }

          return dist.weights(weights);
        }

        return dists;
      },

      sample() {
        const r = exports.random();
        let d = dists[m - 1],
            v = w[0],
            i = 0; // first select distribution

        for (; i < m - 1; v += w[++i]) {
          if (r < v) {
            d = dists[i];
            break;
          }
        } // then sample from it


        return d.sample();
      },

      pdf(x) {
        let p = 0,
            i = 0;

        for (; i < m; ++i) {
          p += w[i] * dists[i].pdf(x);
        }

        return p;
      },

      cdf(x) {
        let p = 0,
            i = 0;

        for (; i < m; ++i) {
          p += w[i] * dists[i].cdf(x);
        }

        return p;
      },

      icdf() {
        throw Error('Mixture icdf not supported.');
      }

    };
    return dist.distributions(dists).weights(weights);
  }

  function sampleUniform(min, max) {
    if (max == null) {
      max = min == null ? 1 : min;
      min = 0;
    }

    return min + (max - min) * exports.random();
  }

  function densityUniform(value, min, max) {
    if (max == null) {
      max = min == null ? 1 : min;
      min = 0;
    }

    return value >= min && value <= max ? 1 / (max - min) : 0;
  }

  function cumulativeUniform(value, min, max) {
    if (max == null) {
      max = min == null ? 1 : min;
      min = 0;
    }

    return value < min ? 0 : value > max ? 1 : (value - min) / (max - min);
  }

  function quantileUniform(p, min, max) {
    if (max == null) {
      max = min == null ? 1 : min;
      min = 0;
    }

    return p >= 0 && p <= 1 ? min + p * (max - min) : NaN;
  }

  function uniform(min, max) {
    let a, b;
    const dist = {
      min(_) {
        if (arguments.length) {
          a = _ || 0;
          return dist;
        } else {
          return a;
        }
      },

      max(_) {
        if (arguments.length) {
          b = _ == null ? 1 : _;
          return dist;
        } else {
          return b;
        }
      },

      sample: () => sampleUniform(a, b),
      pdf: value => densityUniform(value, a, b),
      cdf: value => cumulativeUniform(value, a, b),
      icdf: p => quantileUniform(p, a, b)
    };

    if (max == null) {
      max = min == null ? 1 : min;
      min = 0;
    }

    return dist.min(min).max(max);
  } // Ordinary Least Squares


  function ols(uX, uY, uXY, uX2) {
    const delta = uX2 - uX * uX,
          slope = Math.abs(delta) < 1e-24 ? 0 : (uXY - uX * uY) / delta,
          intercept = uY - slope * uX;
    return [intercept, slope];
  }

  function points(data, x, y, sort) {
    data = data.filter(d => {
      let u = x(d),
          v = y(d);
      return u != null && (u = +u) >= u && v != null && (v = +v) >= v;
    });

    if (sort) {
      data.sort((a, b) => x(a) - x(b));
    }

    const n = data.length,
          X = new Float64Array(n),
          Y = new Float64Array(n); // extract values, calculate means

    let i = 0,
        ux = 0,
        uy = 0,
        xv,
        yv,
        d;

    for (d of data) {
      X[i] = xv = +x(d);
      Y[i] = yv = +y(d);
      ++i;
      ux += (xv - ux) / i;
      uy += (yv - uy) / i;
    } // mean center the data


    for (i = 0; i < n; ++i) {
      X[i] -= ux;
      Y[i] -= uy;
    }

    return [X, Y, ux, uy];
  }

  function visitPoints(data, x, y, callback) {
    let i = -1,
        u,
        v;

    for (const d of data) {
      u = x(d);
      v = y(d);

      if (u != null && (u = +u) >= u && v != null && (v = +v) >= v) {
        callback(u, v, ++i);
      }
    }
  } // License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE


  function rSquared(data, x, y, uY, predict) {
    let SSE = 0,
        SST = 0;
    visitPoints(data, x, y, (dx, dy) => {
      const sse = dy - predict(dx),
            sst = dy - uY;
      SSE += sse * sse;
      SST += sst * sst;
    });
    return 1 - SSE / SST;
  } // License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE


  function linear$2(data, x, y) {
    let X = 0,
        Y = 0,
        XY = 0,
        X2 = 0,
        n = 0;
    visitPoints(data, x, y, (dx, dy) => {
      ++n;
      X += (dx - X) / n;
      Y += (dy - Y) / n;
      XY += (dx * dy - XY) / n;
      X2 += (dx * dx - X2) / n;
    });

    const coef = ols(X, Y, XY, X2),
          predict = x => coef[0] + coef[1] * x;

    return {
      coef: coef,
      predict: predict,
      rSquared: rSquared(data, x, y, Y, predict)
    };
  } // License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE


  function log$3(data, x, y) {
    let X = 0,
        Y = 0,
        XY = 0,
        X2 = 0,
        n = 0;
    visitPoints(data, x, y, (dx, dy) => {
      ++n;
      dx = Math.log(dx);
      X += (dx - X) / n;
      Y += (dy - Y) / n;
      XY += (dx * dy - XY) / n;
      X2 += (dx * dx - X2) / n;
    });

    const coef = ols(X, Y, XY, X2),
          predict = x => coef[0] + coef[1] * Math.log(x);

    return {
      coef: coef,
      predict: predict,
      rSquared: rSquared(data, x, y, Y, predict)
    };
  }

  function exp$1(data, x, y) {
    // eslint-disable-next-line no-unused-vars
    const [xv, yv, ux, uy] = points(data, x, y);
    let YL = 0,
        XY = 0,
        XYL = 0,
        X2Y = 0,
        n = 0,
        dx,
        ly,
        xy;
    visitPoints(data, x, y, (_, dy) => {
      dx = xv[n++];
      ly = Math.log(dy);
      xy = dx * dy;
      YL += (dy * ly - YL) / n;
      XY += (xy - XY) / n;
      XYL += (xy * ly - XYL) / n;
      X2Y += (dx * xy - X2Y) / n;
    });

    const [c0, c1] = ols(XY / uy, YL / uy, XYL / uy, X2Y / uy),
          predict = x => Math.exp(c0 + c1 * (x - ux));

    return {
      coef: [Math.exp(c0 - c1 * ux), c1],
      predict: predict,
      rSquared: rSquared(data, x, y, uy, predict)
    };
  } // License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE


  function pow$3(data, x, y) {
    let X = 0,
        Y = 0,
        XY = 0,
        X2 = 0,
        YS = 0,
        n = 0;
    visitPoints(data, x, y, (dx, dy) => {
      const lx = Math.log(dx),
            ly = Math.log(dy);
      ++n;
      X += (lx - X) / n;
      Y += (ly - Y) / n;
      XY += (lx * ly - XY) / n;
      X2 += (lx * lx - X2) / n;
      YS += (dy - YS) / n;
    });

    const coef = ols(X, Y, XY, X2),
          predict = x => coef[0] * Math.pow(x, coef[1]);

    coef[0] = Math.exp(coef[0]);
    return {
      coef: coef,
      predict: predict,
      rSquared: rSquared(data, x, y, YS, predict)
    };
  }

  function quad(data, x, y) {
    const [xv, yv, ux, uy] = points(data, x, y),
          n = xv.length;
    let X2 = 0,
        X3 = 0,
        X4 = 0,
        XY = 0,
        X2Y = 0,
        i,
        dx,
        dy,
        x2;

    for (i = 0; i < n;) {
      dx = xv[i];
      dy = yv[i++];
      x2 = dx * dx;
      X2 += (x2 - X2) / i;
      X3 += (x2 * dx - X3) / i;
      X4 += (x2 * x2 - X4) / i;
      XY += (dx * dy - XY) / i;
      X2Y += (x2 * dy - X2Y) / i;
    }

    const X2X2 = X4 - X2 * X2,
          d = X2 * X2X2 - X3 * X3,
          a = (X2Y * X2 - XY * X3) / d,
          b = (XY * X2X2 - X2Y * X3) / d,
          c = -a * X2,
          predict = x => {
      x = x - ux;
      return a * x * x + b * x + c + uy;
    }; // transform coefficients back from mean-centered space


    return {
      coef: [c - b * ux + a * ux * ux + uy, b - 2 * a * ux, a],
      predict: predict,
      rSquared: rSquared(data, x, y, uy, predict)
    };
  } // License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
  // ... which was adapted from regression-js by Tom Alexander
  // Source: https://github.com/Tom-Alexander/regression-js/blob/master/src/regression.js#L246
  // License: https://github.com/Tom-Alexander/regression-js/blob/master/LICENSE


  function poly(data, x, y, order) {
    // use more efficient methods for lower orders
    if (order === 1) return linear$2(data, x, y);
    if (order === 2) return quad(data, x, y);
    const [xv, yv, ux, uy] = points(data, x, y),
          n = xv.length,
          lhs = [],
          rhs = [],
          k = order + 1;
    let i, j, l, v, c;

    for (i = 0; i < k; ++i) {
      for (l = 0, v = 0; l < n; ++l) {
        v += Math.pow(xv[l], i) * yv[l];
      }

      lhs.push(v);
      c = new Float64Array(k);

      for (j = 0; j < k; ++j) {
        for (l = 0, v = 0; l < n; ++l) {
          v += Math.pow(xv[l], i + j);
        }

        c[j] = v;
      }

      rhs.push(c);
    }

    rhs.push(lhs);

    const coef = gaussianElimination(rhs),
          predict = x => {
      x -= ux;
      let y = uy + coef[0] + coef[1] * x + coef[2] * x * x;

      for (i = 3; i < k; ++i) y += coef[i] * Math.pow(x, i);

      return y;
    };

    return {
      coef: uncenter(k, coef, -ux, uy),
      predict: predict,
      rSquared: rSquared(data, x, y, uy, predict)
    };
  }

  function uncenter(k, a, x, y) {
    const z = Array(k);
    let i, j, v, c; // initialize to zero

    for (i = 0; i < k; ++i) z[i] = 0; // polynomial expansion


    for (i = k - 1; i >= 0; --i) {
      v = a[i];
      c = 1;
      z[i] += v;

      for (j = 1; j <= i; ++j) {
        c *= (i + 1 - j) / j; // binomial coefficent

        z[i - j] += v * Math.pow(x, j) * c;
      }
    } // bias term


    z[0] += y;
    return z;
  } // Given an array for a two-dimensional matrix and the polynomial order,
  // solve A * x = b using Gaussian elimination.


  function gaussianElimination(matrix) {
    const n = matrix.length - 1,
          coef = [];
    let i, j, k, r, t;

    for (i = 0; i < n; ++i) {
      r = i; // max row

      for (j = i + 1; j < n; ++j) {
        if (Math.abs(matrix[i][j]) > Math.abs(matrix[i][r])) {
          r = j;
        }
      }

      for (k = i; k < n + 1; ++k) {
        t = matrix[k][i];
        matrix[k][i] = matrix[k][r];
        matrix[k][r] = t;
      }

      for (j = i + 1; j < n; ++j) {
        for (k = n; k >= i; k--) {
          matrix[k][j] -= matrix[k][i] * matrix[i][j] / matrix[i][i];
        }
      }
    }

    for (j = n - 1; j >= 0; --j) {
      t = 0;

      for (k = j + 1; k < n; ++k) {
        t += matrix[k][j] * coef[k];
      }

      coef[j] = (matrix[n][j] - t) / matrix[j][j];
    }

    return coef;
  }

  const maxiters = 2,
        epsilon$5 = 1e-12; // Adapted from science.js by Jason Davies
  // Source: https://github.com/jasondavies/science.js/blob/master/src/stats/loess.js
  // License: https://github.com/jasondavies/science.js/blob/master/LICENSE

  function loess(data, x, y, bandwidth) {
    const [xv, yv, ux, uy] = points(data, x, y, true),
          n = xv.length,
          bw = Math.max(2, ~~(bandwidth * n)),
          // # nearest neighbors
    yhat = new Float64Array(n),
          residuals = new Float64Array(n),
          robustWeights = new Float64Array(n).fill(1);

    for (let iter = -1; ++iter <= maxiters;) {
      const interval = [0, bw - 1];

      for (let i = 0; i < n; ++i) {
        const dx = xv[i],
              i0 = interval[0],
              i1 = interval[1],
              edge = dx - xv[i0] > xv[i1] - dx ? i0 : i1;
        let W = 0,
            X = 0,
            Y = 0,
            XY = 0,
            X2 = 0;
        const denom = 1 / Math.abs(xv[edge] - dx || 1); // avoid singularity!

        for (let k = i0; k <= i1; ++k) {
          const xk = xv[k],
                yk = yv[k],
                w = tricube(Math.abs(dx - xk) * denom) * robustWeights[k],
                xkw = xk * w;
          W += w;
          X += xkw;
          Y += yk * w;
          XY += yk * xkw;
          X2 += xk * xkw;
        } // linear regression fit


        const [a, b] = ols(X / W, Y / W, XY / W, X2 / W);
        yhat[i] = a + b * dx;
        residuals[i] = Math.abs(yv[i] - yhat[i]);
        updateInterval(xv, i + 1, interval);
      }

      if (iter === maxiters) {
        break;
      }

      const medianResidual = median(residuals);
      if (Math.abs(medianResidual) < epsilon$5) break;

      for (let i = 0, arg, w; i < n; ++i) {
        arg = residuals[i] / (6 * medianResidual); // default to epsilon (rather than zero) for large deviations
        // keeping weights tiny but non-zero prevents singularites

        robustWeights[i] = arg >= 1 ? epsilon$5 : (w = 1 - arg * arg) * w;
      }
    }

    return output$1(xv, yhat, ux, uy);
  } // weighting kernel for local regression


  function tricube(x) {
    return (x = 1 - x * x * x) * x * x;
  } // advance sliding window interval of nearest neighbors


  function updateInterval(xv, i, interval) {
    const val = xv[i];
    let left = interval[0],
        right = interval[1] + 1;
    if (right >= xv.length) return; // step right if distance to new right edge is <= distance to old left edge
    // step when distance is equal to ensure movement over duplicate x values

    while (i > left && xv[right] - val <= val - xv[left]) {
      interval[0] = ++left;
      interval[1] = right;
      ++right;
    }
  } // generate smoothed output points
  // average points with repeated x values


  function output$1(xv, yhat, ux, uy) {
    const n = xv.length,
          out = [];
    let i = 0,
        cnt = 0,
        prev = [],
        v;

    for (; i < n; ++i) {
      v = xv[i] + ux;

      if (prev[0] === v) {
        // average output values via online update
        prev[1] += (yhat[i] - prev[1]) / ++cnt;
      } else {
        // add new output point
        cnt = 0;
        prev[1] += uy;
        prev = [v, yhat[i]];
        out.push(prev);
      }
    }

    prev[1] += uy;
    return out;
  } // subdivide up to accuracy of 0.1 degrees


  const MIN_RADIANS = 0.1 * Math.PI / 180; // Adaptively sample an interpolated function over a domain extent

  function sampleCurve(f, extent, minSteps, maxSteps) {
    minSteps = minSteps || 25;
    maxSteps = Math.max(minSteps, maxSteps || 200);

    const point = x => [x, f(x)],
          minX = extent[0],
          maxX = extent[1],
          span = maxX - minX,
          stop = span / maxSteps,
          prev = [point(minX)],
          next = [];

    if (minSteps === maxSteps) {
      // no adaptation, sample uniform grid directly and return
      for (let i = 1; i < maxSteps; ++i) {
        prev.push(point(minX + i / minSteps * span));
      }

      prev.push(point(maxX));
      return prev;
    } else {
      // sample minimum points on uniform grid
      // then move on to perform adaptive refinement
      next.push(point(maxX));

      for (let i = minSteps; --i > 0;) {
        next.push(point(minX + i / minSteps * span));
      }
    }

    let p0 = prev[0],
        p1 = next[next.length - 1];

    while (p1) {
      // midpoint for potential curve subdivision
      const pm = point((p0[0] + p1[0]) / 2);

      if (pm[0] - p0[0] >= stop && angleDelta(p0, pm, p1) > MIN_RADIANS) {
        // maximum resolution has not yet been met, and
        // subdivision midpoint sufficiently different from endpoint
        // save subdivision, push midpoint onto the visitation stack
        next.push(pm);
      } else {
        // subdivision midpoint sufficiently similar to endpoint
        // skip subdivision, store endpoint, move to next point on the stack
        p0 = p1;
        prev.push(p1);
        next.pop();
      }

      p1 = next[next.length - 1];
    }

    return prev;
  }

  function angleDelta(p, q, r) {
    const a0 = Math.atan2(r[1] - p[1], r[0] - p[0]),
          a1 = Math.atan2(q[1] - p[1], q[0] - p[0]);
    return Math.abs(a0 - a1);
  }

  function multikey(f) {
    return x => {
      const n = f.length;
      let i = 1,
          k = String(f[0](x));

      for (; i < n; ++i) {
        k += '|' + f[i](x);
      }

      return k;
    };
  }

  function groupkey(fields) {
    return !fields || !fields.length ? function () {
      return '';
    } : fields.length === 1 ? fields[0] : multikey(fields);
  }

  function measureName(op, field, as) {
    return as || op + (!field ? '' : '_' + field);
  }

  const noop$4 = () => {};

  const base_op = {
    init: noop$4,
    add: noop$4,
    rem: noop$4,
    idx: 0
  };
  const AggregateOps = {
    values: {
      init: m => m.cell.store = true,
      value: m => m.cell.data.values(),
      idx: -1
    },
    count: {
      value: m => m.cell.num
    },
    __count__: {
      value: m => m.missing + m.valid
    },
    missing: {
      value: m => m.missing
    },
    valid: {
      value: m => m.valid
    },
    sum: {
      init: m => m.sum = 0,
      value: m => m.sum,
      add: (m, v) => m.sum += +v,
      rem: (m, v) => m.sum -= v
    },
    product: {
      init: m => m.product = 1,
      value: m => m.valid ? m.product : undefined,
      add: (m, v) => m.product *= v,
      rem: (m, v) => m.product /= v
    },
    mean: {
      init: m => m.mean = 0,
      value: m => m.valid ? m.mean : undefined,
      add: (m, v) => (m.mean_d = v - m.mean, m.mean += m.mean_d / m.valid),
      rem: (m, v) => (m.mean_d = v - m.mean, m.mean -= m.valid ? m.mean_d / m.valid : m.mean)
    },
    average: {
      value: m => m.valid ? m.mean : undefined,
      req: ['mean'],
      idx: 1
    },
    variance: {
      init: m => m.dev = 0,
      value: m => m.valid > 1 ? m.dev / (m.valid - 1) : undefined,
      add: (m, v) => m.dev += m.mean_d * (v - m.mean),
      rem: (m, v) => m.dev -= m.mean_d * (v - m.mean),
      req: ['mean'],
      idx: 1
    },
    variancep: {
      value: m => m.valid > 1 ? m.dev / m.valid : undefined,
      req: ['variance'],
      idx: 2
    },
    stdev: {
      value: m => m.valid > 1 ? Math.sqrt(m.dev / (m.valid - 1)) : undefined,
      req: ['variance'],
      idx: 2
    },
    stdevp: {
      value: m => m.valid > 1 ? Math.sqrt(m.dev / m.valid) : undefined,
      req: ['variance'],
      idx: 2
    },
    stderr: {
      value: m => m.valid > 1 ? Math.sqrt(m.dev / (m.valid * (m.valid - 1))) : undefined,
      req: ['variance'],
      idx: 2
    },
    distinct: {
      value: m => m.cell.data.distinct(m.get),
      req: ['values'],
      idx: 3
    },
    ci0: {
      value: m => m.cell.data.ci0(m.get),
      req: ['values'],
      idx: 3
    },
    ci1: {
      value: m => m.cell.data.ci1(m.get),
      req: ['values'],
      idx: 3
    },
    median: {
      value: m => m.cell.data.q2(m.get),
      req: ['values'],
      idx: 3
    },
    q1: {
      value: m => m.cell.data.q1(m.get),
      req: ['values'],
      idx: 3
    },
    q3: {
      value: m => m.cell.data.q3(m.get),
      req: ['values'],
      idx: 3
    },
    min: {
      init: m => m.min = undefined,
      value: m => m.min = Number.isNaN(m.min) ? m.cell.data.min(m.get) : m.min,
      add: (m, v) => {
        if (v < m.min || m.min === undefined) m.min = v;
      },
      rem: (m, v) => {
        if (v <= m.min) m.min = NaN;
      },
      req: ['values'],
      idx: 4
    },
    max: {
      init: m => m.max = undefined,
      value: m => m.max = Number.isNaN(m.max) ? m.cell.data.max(m.get) : m.max,
      add: (m, v) => {
        if (v > m.max || m.max === undefined) m.max = v;
      },
      rem: (m, v) => {
        if (v >= m.max) m.max = NaN;
      },
      req: ['values'],
      idx: 4
    },
    argmin: {
      init: m => m.argmin = undefined,
      value: m => m.argmin || m.cell.data.argmin(m.get),
      add: (m, v, t) => {
        if (v < m.min) m.argmin = t;
      },
      rem: (m, v) => {
        if (v <= m.min) m.argmin = undefined;
      },
      req: ['min', 'values'],
      idx: 3
    },
    argmax: {
      init: m => m.argmax = undefined,
      value: m => m.argmax || m.cell.data.argmax(m.get),
      add: (m, v, t) => {
        if (v > m.max) m.argmax = t;
      },
      rem: (m, v) => {
        if (v >= m.max) m.argmax = undefined;
      },
      req: ['max', 'values'],
      idx: 3
    }
  };
  const ValidAggregateOps = Object.keys(AggregateOps);

  function measure(key, value) {
    return out => extend$1({
      name: key,
      out: out || key
    }, base_op, value);
  }

  ValidAggregateOps.forEach(key => {
    AggregateOps[key] = measure(key, AggregateOps[key]);
  });

  function createMeasure(op, name) {
    return AggregateOps[op](name);
  }

  function compareIndex(a, b) {
    return a.idx - b.idx;
  }

  function resolve(agg) {
    const map = {};
    agg.forEach(a => map[a.name] = a);

    const getreqs = a => {
      if (!a.req) return;
      a.req.forEach(key => {
        if (!map[key]) getreqs(map[key] = AggregateOps[key]());
      });
    };

    agg.forEach(getreqs);
    return Object.values(map).sort(compareIndex);
  }

  function init() {
    this.valid = 0;
    this.missing = 0;

    this._ops.forEach(op => op.init(this));
  }

  function add$2(v, t) {
    if (v == null || v === '') {
      ++this.missing;
      return;
    }

    if (v !== v) return;
    ++this.valid;

    this._ops.forEach(op => op.add(this, v, t));
  }

  function rem(v, t) {
    if (v == null || v === '') {
      --this.missing;
      return;
    }

    if (v !== v) return;
    --this.valid;

    this._ops.forEach(op => op.rem(this, v, t));
  }

  function set$3(t) {
    this._out.forEach(op => t[op.out] = op.value(this));

    return t;
  }

  function compileMeasures(agg, field) {
    const get = field || identity$6,
          ops = resolve(agg),
          out = agg.slice().sort(compareIndex);

    function ctr(cell) {
      this._ops = ops;
      this._out = out;
      this.cell = cell;
      this.init();
    }

    ctr.prototype.init = init;
    ctr.prototype.add = add$2;
    ctr.prototype.rem = rem;
    ctr.prototype.set = set$3;
    ctr.prototype.get = get;
    ctr.fields = agg.map(op => op.out);
    return ctr;
  }

  function TupleStore(key) {
    this._key = key ? field$1(key) : tupleid;
    this.reset();
  }

  const prototype$1 = TupleStore.prototype;

  prototype$1.reset = function () {
    this._add = [];
    this._rem = [];
    this._ext = null;
    this._get = null;
    this._q = null;
  };

  prototype$1.add = function (v) {
    this._add.push(v);
  };

  prototype$1.rem = function (v) {
    this._rem.push(v);
  };

  prototype$1.values = function () {
    this._get = null;
    if (this._rem.length === 0) return this._add;
    const a = this._add,
          r = this._rem,
          k = this._key,
          n = a.length,
          m = r.length,
          x = Array(n - m),
          map = {};
    let i, j, v; // use unique key field to clear removed values

    for (i = 0; i < m; ++i) {
      map[k(r[i])] = 1;
    }

    for (i = 0, j = 0; i < n; ++i) {
      if (map[k(v = a[i])]) {
        map[k(v)] = 0;
      } else {
        x[j++] = v;
      }
    }

    this._rem = [];
    return this._add = x;
  }; // memoizing statistics methods


  prototype$1.distinct = function (get) {
    const v = this.values(),
          map = {};
    let n = v.length,
        count = 0,
        s;

    while (--n >= 0) {
      s = get(v[n]) + '';

      if (!has$1(map, s)) {
        map[s] = 1;
        ++count;
      }
    }

    return count;
  };

  prototype$1.extent = function (get) {
    if (this._get !== get || !this._ext) {
      const v = this.values(),
            i = extentIndex(v, get);
      this._ext = [v[i[0]], v[i[1]]];
      this._get = get;
    }

    return this._ext;
  };

  prototype$1.argmin = function (get) {
    return this.extent(get)[0] || {};
  };

  prototype$1.argmax = function (get) {
    return this.extent(get)[1] || {};
  };

  prototype$1.min = function (get) {
    const m = this.extent(get)[0];
    return m != null ? get(m) : undefined;
  };

  prototype$1.max = function (get) {
    const m = this.extent(get)[1];
    return m != null ? get(m) : undefined;
  };

  prototype$1.quartile = function (get) {
    if (this._get !== get || !this._q) {
      this._q = quartiles(this.values(), get);
      this._get = get;
    }

    return this._q;
  };

  prototype$1.q1 = function (get) {
    return this.quartile(get)[0];
  };

  prototype$1.q2 = function (get) {
    return this.quartile(get)[1];
  };

  prototype$1.q3 = function (get) {
    return this.quartile(get)[2];
  };

  prototype$1.ci = function (get) {
    if (this._get !== get || !this._ci) {
      this._ci = bootstrapCI(this.values(), 1000, 0.05, get);
      this._get = get;
    }

    return this._ci;
  };

  prototype$1.ci0 = function (get) {
    return this.ci(get)[0];
  };

  prototype$1.ci1 = function (get) {
    return this.ci(get)[1];
  };
  /**
   * Group-by aggregation operator.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
   * @param {Array<function(object): *>} [params.fields] - An array of accessors to aggregate.
   * @param {Array<string>} [params.ops] - An array of strings indicating aggregation operations.
   * @param {Array<string>} [params.as] - An array of output field names for aggregated values.
   * @param {boolean} [params.cross=false] - A flag indicating that the full
   *   cross-product of groupby values should be generated, including empty cells.
   *   If true, the drop parameter is ignored and empty cells are retained.
   * @param {boolean} [params.drop=true] - A flag indicating if empty cells should be removed.
   */


  function Aggregate$1(params) {
    Transform.call(this, null, params);
    this._adds = []; // array of added output tuples

    this._mods = []; // array of modified output tuples

    this._alen = 0; // number of active added tuples

    this._mlen = 0; // number of active modified tuples

    this._drop = true; // should empty aggregation cells be removed

    this._cross = false; // produce full cross-product of group-by values

    this._dims = []; // group-by dimension accessors

    this._dnames = []; // group-by dimension names

    this._measures = []; // collection of aggregation monoids

    this._countOnly = false; // flag indicating only count aggregation

    this._counts = null; // collection of count fields

    this._prev = null; // previous aggregation cells

    this._inputs = null; // array of dependent input tuple field names

    this._outputs = null; // array of output tuple field names
  }

  Aggregate$1.Definition = {
    'type': 'Aggregate',
    'metadata': {
      'generates': true,
      'changes': true
    },
    'params': [{
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'ops',
      'type': 'enum',
      'array': true,
      'values': ValidAggregateOps
    }, {
      'name': 'fields',
      'type': 'field',
      'null': true,
      'array': true
    }, {
      'name': 'as',
      'type': 'string',
      'null': true,
      'array': true
    }, {
      'name': 'drop',
      'type': 'boolean',
      'default': true
    }, {
      'name': 'cross',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'key',
      'type': 'field'
    }]
  };
  inherits(Aggregate$1, Transform, {
    transform(_, pulse) {
      const aggr = this,
            out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
            mod = _.modified();

      aggr.stamp = out.stamp;

      if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
        aggr._prev = aggr.value;
        aggr.value = mod ? aggr.init(_) : {};
        pulse.visit(pulse.SOURCE, t => aggr.add(t));
      } else {
        aggr.value = aggr.value || aggr.init(_);
        pulse.visit(pulse.REM, t => aggr.rem(t));
        pulse.visit(pulse.ADD, t => aggr.add(t));
      } // Indicate output fields and return aggregate tuples.


      out.modifies(aggr._outputs); // Should empty cells be dropped?

      aggr._drop = _.drop !== false; // If domain cross-product requested, generate empty cells as needed
      // and ensure that empty cells are not dropped

      if (_.cross && aggr._dims.length > 1) {
        aggr._drop = false;
        aggr.cross();
      }

      if (pulse.clean() && aggr._drop) {
        out.clean(true).runAfter(() => this.clean());
      }

      return aggr.changes(out);
    },

    cross() {
      const aggr = this,
            curr = aggr.value,
            dims = aggr._dnames,
            vals = dims.map(() => ({})),
            n = dims.length; // collect all group-by domain values

      function collect(cells) {
        let key, i, t, v;

        for (key in cells) {
          t = cells[key].tuple;

          for (i = 0; i < n; ++i) {
            vals[i][v = t[dims[i]]] = v;
          }
        }
      }

      collect(aggr._prev);
      collect(curr); // iterate over key cross-product, create cells as needed

      function generate(base, tuple, index) {
        const name = dims[index],
              v = vals[index++];

        for (const k in v) {
          const key = base ? base + '|' + k : k;
          tuple[name] = v[k];
          if (index < n) generate(key, tuple, index);else if (!curr[key]) aggr.cell(key, tuple);
        }
      }

      generate('', {}, 0);
    },

    init(_) {
      // initialize input and output fields
      const inputs = this._inputs = [],
            outputs = this._outputs = [],
            inputMap = {};

      function inputVisit(get) {
        const fields = array$5(accessorFields(get)),
              n = fields.length;
        let i = 0,
            f;

        for (; i < n; ++i) {
          if (!inputMap[f = fields[i]]) {
            inputMap[f] = 1;
            inputs.push(f);
          }
        }
      } // initialize group-by dimensions


      this._dims = array$5(_.groupby);
      this._dnames = this._dims.map(d => {
        const dname = accessorName(d);
        inputVisit(d);
        outputs.push(dname);
        return dname;
      });
      this.cellkey = _.key ? _.key : groupkey(this._dims); // initialize aggregate measures

      this._countOnly = true;
      this._counts = [];
      this._measures = [];
      const fields = _.fields || [null],
            ops = _.ops || ['count'],
            as = _.as || [],
            n = fields.length,
            map = {};
      let field, op, m, mname, outname, i;

      if (n !== ops.length) {
        error('Unmatched number of fields and aggregate ops.');
      }

      for (i = 0; i < n; ++i) {
        field = fields[i];
        op = ops[i];

        if (field == null && op !== 'count') {
          error('Null aggregate field specified.');
        }

        mname = accessorName(field);
        outname = measureName(op, mname, as[i]);
        outputs.push(outname);

        if (op === 'count') {
          this._counts.push(outname);

          continue;
        }

        m = map[mname];

        if (!m) {
          inputVisit(field);
          m = map[mname] = [];
          m.field = field;

          this._measures.push(m);
        }

        if (op !== 'count') this._countOnly = false;
        m.push(createMeasure(op, outname));
      }

      this._measures = this._measures.map(m => compileMeasures(m, m.field));
      return {}; // aggregation cells (this.value)
    },

    // -- Cell Management -----
    cellkey: groupkey(),

    cell(key, t) {
      let cell = this.value[key];

      if (!cell) {
        cell = this.value[key] = this.newcell(key, t);
        this._adds[this._alen++] = cell;
      } else if (cell.num === 0 && this._drop && cell.stamp < this.stamp) {
        cell.stamp = this.stamp;
        this._adds[this._alen++] = cell;
      } else if (cell.stamp < this.stamp) {
        cell.stamp = this.stamp;
        this._mods[this._mlen++] = cell;
      }

      return cell;
    },

    newcell(key, t) {
      const cell = {
        key: key,
        num: 0,
        agg: null,
        tuple: this.newtuple(t, this._prev && this._prev[key]),
        stamp: this.stamp,
        store: false
      };

      if (!this._countOnly) {
        const measures = this._measures,
              n = measures.length;
        cell.agg = Array(n);

        for (let i = 0; i < n; ++i) {
          cell.agg[i] = new measures[i](cell);
        }
      }

      if (cell.store) {
        cell.data = new TupleStore();
      }

      return cell;
    },

    newtuple(t, p) {
      const names = this._dnames,
            dims = this._dims,
            n = dims.length,
            x = {};

      for (let i = 0; i < n; ++i) {
        x[names[i]] = dims[i](t);
      }

      return p ? replace$1(p.tuple, x) : ingest$1(x);
    },

    clean() {
      const cells = this.value;

      for (const key in cells) {
        if (cells[key].num === 0) {
          delete cells[key];
        }
      }
    },

    // -- Process Tuples -----
    add(t) {
      const key = this.cellkey(t),
            cell = this.cell(key, t);
      cell.num += 1;
      if (this._countOnly) return;
      if (cell.store) cell.data.add(t);
      const agg = cell.agg;

      for (let i = 0, n = agg.length; i < n; ++i) {
        agg[i].add(agg[i].get(t), t);
      }
    },

    rem(t) {
      const key = this.cellkey(t),
            cell = this.cell(key, t);
      cell.num -= 1;
      if (this._countOnly) return;
      if (cell.store) cell.data.rem(t);
      const agg = cell.agg;

      for (let i = 0, n = agg.length; i < n; ++i) {
        agg[i].rem(agg[i].get(t), t);
      }
    },

    celltuple(cell) {
      const tuple = cell.tuple,
            counts = this._counts; // consolidate stored values

      if (cell.store) {
        cell.data.values();
      } // update tuple properties


      for (let i = 0, n = counts.length; i < n; ++i) {
        tuple[counts[i]] = cell.num;
      }

      if (!this._countOnly) {
        const agg = cell.agg;

        for (let i = 0, n = agg.length; i < n; ++i) {
          agg[i].set(tuple);
        }
      }

      return tuple;
    },

    changes(out) {
      const adds = this._adds,
            mods = this._mods,
            prev = this._prev,
            drop = this._drop,
            add = out.add,
            rem = out.rem,
            mod = out.mod;
      let cell, key, i, n;
      if (prev) for (key in prev) {
        cell = prev[key];
        if (!drop || cell.num) rem.push(cell.tuple);
      }

      for (i = 0, n = this._alen; i < n; ++i) {
        add.push(this.celltuple(adds[i]));
        adds[i] = null; // for garbage collection
      }

      for (i = 0, n = this._mlen; i < n; ++i) {
        cell = mods[i];
        (cell.num === 0 && drop ? rem : mod).push(this.celltuple(cell));
        mods[i] = null; // for garbage collection
      }

      this._alen = this._mlen = 0; // reset list of active cells

      this._prev = null;
      return out;
    }

  });
  const EPSILON$1 = 1e-14;
  /**
   * Generates a binning function for discretizing data.
   * @constructor
   * @param {object} params - The parameters for this operator. The
   *   provided values should be valid options for the {@link bin} function.
   * @param {function(object): *} params.field - The data field to bin.
   */

  function Bin(params) {
    Transform.call(this, null, params);
  }

  Bin.Definition = {
    'type': 'Bin',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'interval',
      'type': 'boolean',
      'default': true
    }, {
      'name': 'anchor',
      'type': 'number'
    }, {
      'name': 'maxbins',
      'type': 'number',
      'default': 20
    }, {
      'name': 'base',
      'type': 'number',
      'default': 10
    }, {
      'name': 'divide',
      'type': 'number',
      'array': true,
      'default': [5, 2]
    }, {
      'name': 'extent',
      'type': 'number',
      'array': true,
      'length': 2,
      'required': true
    }, {
      'name': 'span',
      'type': 'number'
    }, {
      'name': 'step',
      'type': 'number'
    }, {
      'name': 'steps',
      'type': 'number',
      'array': true
    }, {
      'name': 'minstep',
      'type': 'number',
      'default': 0
    }, {
      'name': 'nice',
      'type': 'boolean',
      'default': true
    }, {
      'name': 'name',
      'type': 'string'
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': ['bin0', 'bin1']
    }]
  };
  inherits(Bin, Transform, {
    transform(_, pulse) {
      const band = _.interval !== false,
            bins = this._bins(_),
            start = bins.start,
            step = bins.step,
            as = _.as || ['bin0', 'bin1'],
            b0 = as[0],
            b1 = as[1];

      let flag;

      if (_.modified()) {
        pulse = pulse.reflow(true);
        flag = pulse.SOURCE;
      } else {
        flag = pulse.modified(accessorFields(_.field)) ? pulse.ADD_MOD : pulse.ADD;
      }

      pulse.visit(flag, band ? t => {
        const v = bins(t); // minimum bin value (inclusive)

        t[b0] = v; // maximum bin value (exclusive)
        // use convoluted math for better floating point agreement
        // see https://github.com/vega/vega/issues/830
        // infinite values propagate through this formula! #2227

        t[b1] = v == null ? null : start + step * (1 + (v - start) / step);
      } : t => t[b0] = bins(t));
      return pulse.modifies(band ? as : b0);
    },

    _bins(_) {
      if (this.value && !_.modified()) {
        return this.value;
      }

      const field = _.field,
            bins = bin(_),
            step = bins.step;
      let start = bins.start,
          stop = start + Math.ceil((bins.stop - start) / step) * step,
          a,
          d;

      if ((a = _.anchor) != null) {
        d = a - (start + step * Math.floor((a - start) / step));
        start += d;
        stop += d;
      }

      const f = function (t) {
        let v = toNumber(field(t));
        return v == null ? null : v < start ? -Infinity : v > stop ? +Infinity : (v = Math.max(start, Math.min(v, stop - step)), start + step * Math.floor(EPSILON$1 + (v - start) / step));
      };

      f.start = start;
      f.stop = bins.stop;
      f.step = step;
      return this.value = accessor(f, accessorFields(field), _.name || 'bin_' + accessorName(field));
    }

  });

  function SortedList(idFunc, source, input) {
    const $ = idFunc;
    let data = source || [],
        add = input || [],
        rem = {},
        cnt = 0;
    return {
      add: t => add.push(t),
      remove: t => rem[$(t)] = ++cnt,
      size: () => data.length,
      data: (compare, resort) => {
        if (cnt) {
          data = data.filter(t => !rem[$(t)]);
          rem = {};
          cnt = 0;
        }

        if (resort && compare) {
          data.sort(compare);
        }

        if (add.length) {
          data = compare ? merge$3(compare, data, add.sort(compare)) : data.concat(add);
          add = [];
        }

        return data;
      }
    };
  }
  /**
   * Collects all data tuples that pass through this operator.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(*,*): number} [params.sort] - An optional
   *   comparator function for additionally sorting the collected tuples.
   */


  function Collect$1(params) {
    Transform.call(this, [], params);
  }

  Collect$1.Definition = {
    'type': 'Collect',
    'metadata': {
      'source': true
    },
    'params': [{
      'name': 'sort',
      'type': 'compare'
    }]
  };
  inherits(Collect$1, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.ALL),
            list = SortedList(tupleid, this.value, out.materialize(out.ADD).add),
            sort = _.sort,
            mod = pulse.changed() || sort && (_.modified('sort') || pulse.modified(sort.fields));
      out.visit(out.REM, list.remove);
      this.modified(mod);
      this.value = out.source = list.data(stableCompare(sort), mod); // propagate tree root if defined

      if (pulse.source && pulse.source.root) {
        this.value.root = pulse.source.root;
      }

      return out;
    }

  });
  /**
   * Generates a comparator function.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<string|function>} params.fields - The fields to compare.
   * @param {Array<string>} [params.orders] - The sort orders.
   *   Each entry should be one of "ascending" (default) or "descending".
   */

  function Compare$1(params) {
    Operator.call(this, null, update$5, params);
  }

  inherits(Compare$1, Operator);

  function update$5(_) {
    return this.value && !_.modified() ? this.value : compare$1(_.fields, _.orders);
  }
  /**
   * Count regexp-defined pattern occurrences in a text field.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - An accessor for the text field.
   * @param {string} [params.pattern] - RegExp string defining the text pattern.
   * @param {string} [params.case] - One of 'lower', 'upper' or null (mixed) case.
   * @param {string} [params.stopwords] - RegExp string of words to ignore.
   */


  function CountPattern(params) {
    Transform.call(this, null, params);
  }

  CountPattern.Definition = {
    'type': 'CountPattern',
    'metadata': {
      'generates': true,
      'changes': true
    },
    'params': [{
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'case',
      'type': 'enum',
      'values': ['upper', 'lower', 'mixed'],
      'default': 'mixed'
    }, {
      'name': 'pattern',
      'type': 'string',
      'default': '[\\w"]+'
    }, {
      'name': 'stopwords',
      'type': 'string',
      'default': ''
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': ['text', 'count']
    }]
  };

  function tokenize(text, tcase, match) {
    switch (tcase) {
      case 'upper':
        text = text.toUpperCase();
        break;

      case 'lower':
        text = text.toLowerCase();
        break;
    }

    return text.match(match);
  }

  inherits(CountPattern, Transform, {
    transform(_, pulse) {
      const process = update => tuple => {
        var tokens = tokenize(get(tuple), _.case, match) || [],
            t;

        for (var i = 0, n = tokens.length; i < n; ++i) {
          if (!stop.test(t = tokens[i])) update(t);
        }
      };

      const init = this._parameterCheck(_, pulse),
            counts = this._counts,
            match = this._match,
            stop = this._stop,
            get = _.field,
            as = _.as || ['text', 'count'],
            add = process(t => counts[t] = 1 + (counts[t] || 0)),
            rem = process(t => counts[t] -= 1);

      if (init) {
        pulse.visit(pulse.SOURCE, add);
      } else {
        pulse.visit(pulse.ADD, add);
        pulse.visit(pulse.REM, rem);
      }

      return this._finish(pulse, as); // generate output tuples
    },

    _parameterCheck(_, pulse) {
      let init = false;

      if (_.modified('stopwords') || !this._stop) {
        this._stop = new RegExp('^' + (_.stopwords || '') + '$', 'i');
        init = true;
      }

      if (_.modified('pattern') || !this._match) {
        this._match = new RegExp(_.pattern || '[\\w\']+', 'g');
        init = true;
      }

      if (_.modified('field') || pulse.modified(_.field.fields)) {
        init = true;
      }

      if (init) this._counts = {};
      return init;
    },

    _finish(pulse, as) {
      const counts = this._counts,
            tuples = this._tuples || (this._tuples = {}),
            text = as[0],
            count = as[1],
            out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
      let w, t, c;

      for (w in counts) {
        t = tuples[w];
        c = counts[w] || 0;

        if (!t && c) {
          tuples[w] = t = ingest$1({});
          t[text] = w;
          t[count] = c;
          out.add.push(t);
        } else if (c === 0) {
          if (t) out.rem.push(t);
          counts[w] = null;
          tuples[w] = null;
        } else if (t[count] !== c) {
          t[count] = c;
          out.mod.push(t);
        }
      }

      return out.modifies(as);
    }

  });
  /**
   * Perform a cross-product of a tuple stream with itself.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object):boolean} [params.filter] - An optional filter
   *   function for selectively including tuples in the cross product.
   * @param {Array<string>} [params.as] - The names of the output fields.
   */

  function Cross(params) {
    Transform.call(this, null, params);
  }

  Cross.Definition = {
    'type': 'Cross',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'filter',
      'type': 'expr'
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': ['a', 'b']
    }]
  };
  inherits(Cross, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE),
            as = _.as || ['a', 'b'],
            a = as[0],
            b = as[1],
            reset = !this.value || pulse.changed(pulse.ADD_REM) || _.modified('as') || _.modified('filter');

      let data = this.value;

      if (reset) {
        if (data) out.rem = data;
        data = pulse.materialize(pulse.SOURCE).source;
        out.add = this.value = cross(data, a, b, _.filter || truthy);
      } else {
        out.mod = data;
      }

      out.source = this.value;
      return out.modifies(as);
    }

  });

  function cross(input, a, b, filter) {
    var data = [],
        t = {},
        n = input.length,
        i = 0,
        j,
        left;

    for (; i < n; ++i) {
      t[a] = left = input[i];

      for (j = 0; j < n; ++j) {
        t[b] = input[j];

        if (filter(t)) {
          data.push(ingest$1(t));
          t = {};
          t[a] = left;
        }
      }
    }

    return data;
  }

  const Distributions = {
    kde: kde,
    mixture: mixture$1,
    normal: gaussian,
    lognormal: lognormal,
    uniform: uniform
  };
  const DISTRIBUTIONS = 'distributions',
        FUNCTION = 'function',
        FIELD = 'field';
  /**
   * Parse a parameter object for a probability distribution.
   * @param {object} def - The distribution parameter object.
   * @param {function():Array<object>} - A method for requesting
   *   source data. Used for distributions (such as KDE) that
   *   require sample data points. This method will only be
   *   invoked if the 'from' parameter for a target data source
   *   is not provided. Typically this method returns backing
   *   source data for a Pulse object.
   * @return {object} - The output distribution object.
   */

  function parse$3(def, data) {
    const func = def[FUNCTION];

    if (!has$1(Distributions, func)) {
      error('Unknown distribution function: ' + func);
    }

    const d = Distributions[func]();

    for (const name in def) {
      // if data field, extract values
      if (name === FIELD) {
        d.data((def.from || data()).map(def[name]));
      } // if distribution mixture, recurse to parse each definition
      else if (name === DISTRIBUTIONS) {
          d[name](def[name].map(_ => parse$3(_, data)));
        } // otherwise, simply set the parameter
        else if (typeof d[name] === FUNCTION) {
            d[name](def[name]);
          }
    }

    return d;
  }
  /**
   * Grid sample points for a probability density. Given a distribution and
   * a sampling extent, will generate points suitable for plotting either
   * PDF (probability density function) or CDF (cumulative distribution
   * function) curves.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {object} params.distribution - The probability distribution. This
   *   is an object parameter dependent on the distribution type.
   * @param {string} [params.method='pdf'] - The distribution method to sample.
   *   One of 'pdf' or 'cdf'.
   * @param {Array<number>} [params.extent] - The [min, max] extent over which
   *   to sample the distribution. This argument is required in most cases, but
   *   can be omitted if the distribution (e.g., 'kde') supports a 'data' method
   *   that returns numerical sample points from which the extent can be deduced.
   * @param {number} [params.minsteps=25] - The minimum number of curve samples
   *   for plotting the density.
   * @param {number} [params.maxsteps=200] - The maximum number of curve samples
   *   for plotting the density.
   * @param {number} [params.steps] - The exact number of curve samples for
   *   plotting the density. If specified, overrides both minsteps and maxsteps
   *   to set an exact number of uniform samples. Useful in conjunction with
   *   a fixed extent to ensure consistent sample points for stacked densities.
   */


  function Density(params) {
    Transform.call(this, null, params);
  }

  const distributions = [{
    'key': {
      'function': 'normal'
    },
    'params': [{
      'name': 'mean',
      'type': 'number',
      'default': 0
    }, {
      'name': 'stdev',
      'type': 'number',
      'default': 1
    }]
  }, {
    'key': {
      'function': 'lognormal'
    },
    'params': [{
      'name': 'mean',
      'type': 'number',
      'default': 0
    }, {
      'name': 'stdev',
      'type': 'number',
      'default': 1
    }]
  }, {
    'key': {
      'function': 'uniform'
    },
    'params': [{
      'name': 'min',
      'type': 'number',
      'default': 0
    }, {
      'name': 'max',
      'type': 'number',
      'default': 1
    }]
  }, {
    'key': {
      'function': 'kde'
    },
    'params': [{
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'from',
      'type': 'data'
    }, {
      'name': 'bandwidth',
      'type': 'number',
      'default': 0
    }]
  }];
  const mixture = {
    'key': {
      'function': 'mixture'
    },
    'params': [{
      'name': 'distributions',
      'type': 'param',
      'array': true,
      'params': distributions
    }, {
      'name': 'weights',
      'type': 'number',
      'array': true
    }]
  };
  Density.Definition = {
    'type': 'Density',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'extent',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'steps',
      'type': 'number'
    }, {
      'name': 'minsteps',
      'type': 'number',
      'default': 25
    }, {
      'name': 'maxsteps',
      'type': 'number',
      'default': 200
    }, {
      'name': 'method',
      'type': 'string',
      'default': 'pdf',
      'values': ['pdf', 'cdf']
    }, {
      'name': 'distribution',
      'type': 'param',
      'params': distributions.concat(mixture)
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'default': ['value', 'density']
    }]
  };
  inherits(Density, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);

      if (!this.value || pulse.changed() || _.modified()) {
        const dist = parse$3(_.distribution, source$1(pulse)),
              minsteps = _.steps || _.minsteps || 25,
              maxsteps = _.steps || _.maxsteps || 200;
        let method = _.method || 'pdf';

        if (method !== 'pdf' && method !== 'cdf') {
          error('Invalid density method: ' + method);
        }

        if (!_.extent && !dist.data) {
          error('Missing density extent parameter.');
        }

        method = dist[method];
        const as = _.as || ['value', 'density'],
              domain = _.extent || extent(dist.data()),
              values = sampleCurve(method, domain, minsteps, maxsteps).map(v => {
          const tuple = {};
          tuple[as[0]] = v[0];
          tuple[as[1]] = v[1];
          return ingest$1(tuple);
        });
        if (this.value) out.rem = this.value;
        this.value = out.add = out.source = values;
      }

      return out;
    }

  });

  function source$1(pulse) {
    return () => pulse.materialize(pulse.SOURCE).source;
  }

  function fieldNames(fields, as) {
    if (!fields) return null;
    return fields.map((f, i) => as[i] || accessorName(f));
  }

  function partition$1$1(data, groupby, field) {
    const groups = [],
          get = f => f(t);

    let map, i, n, t, k, g; // partition data points into groups

    if (groupby == null) {
      groups.push(data.map(field));
    } else {
      for (map = {}, i = 0, n = data.length; i < n; ++i) {
        t = data[i];
        k = groupby.map(get);
        g = map[k];

        if (!g) {
          map[k] = g = [];
          g.dims = k;
          groups.push(g);
        }

        g.push(field(t));
      }
    }

    return groups;
  }

  const Output$5 = 'bin';
  /**
   * Dot density binning for dot plot construction.
   * Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
   * https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The value field to bin.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
   * @param {number} [params.step] - The step size (bin width) within which dots should be
   *   stacked. Defaults to 1/30 of the extent of the data *field*.
   * @param {boolean} [params.smooth=false] - A boolean flag indicating if dot density
   *   stacks should be smoothed to reduce variance.
   */

  function DotBin(params) {
    Transform.call(this, null, params);
  }

  DotBin.Definition = {
    'type': 'DotBin',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'step',
      'type': 'number'
    }, {
      'name': 'smooth',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'as',
      'type': 'string',
      'default': Output$5
    }]
  };

  const autostep = (data, field) => span(extent(data, field)) / 30;

  inherits(DotBin, Transform, {
    transform(_, pulse) {
      if (this.value && !(_.modified() || pulse.changed())) {
        return pulse; // early exit
      }

      const source = pulse.materialize(pulse.SOURCE).source,
            groups = partition$1$1(pulse.source, _.groupby, identity$6),
            smooth = _.smooth || false,
            field = _.field,
            step = _.step || autostep(source, field),
            sort = stableCompare((a, b) => field(a) - field(b)),
            as = _.as || Output$5,
            n = groups.length; // compute dotplot bins per group

      let min = Infinity,
          max = -Infinity,
          i = 0,
          j;

      for (; i < n; ++i) {
        const g = groups[i].sort(sort);
        j = -1;

        for (const v of dotbin(g, step, smooth, field)) {
          if (v < min) min = v;
          if (v > max) max = v;
          g[++j][as] = v;
        }
      }

      this.value = {
        start: min,
        stop: max,
        step: step
      };
      return pulse.reflow(true).modifies(as);
    }

  });
  /**
   * Wraps an expression function with access to external parameters.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function} params.expr - The expression function. The
   *  function should accept both a datum and a parameter object.
   *  This operator's value will be a new function that wraps the
   *  expression function with access to this operator's parameters.
   */

  function Expression$1(params) {
    Operator.call(this, null, update$4, params);
    this.modified(true);
  }

  inherits(Expression$1, Operator);

  function update$4(_) {
    const expr = _.expr;
    return this.value && !_.modified('expr') ? this.value : accessor(datum => expr(datum, _), accessorFields(expr), accessorName(expr));
  }
  /**
   * Computes extents (min/max) for a data field.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The field over which to compute extends.
   */


  function Extent(params) {
    Transform.call(this, [undefined, undefined], params);
  }

  Extent.Definition = {
    'type': 'Extent',
    'metadata': {},
    'params': [{
      'name': 'field',
      'type': 'field',
      'required': true
    }]
  };
  inherits(Extent, Transform, {
    transform(_, pulse) {
      const extent = this.value,
            field = _.field,
            mod = pulse.changed() || pulse.modified(field.fields) || _.modified('field');

      let min = extent[0],
          max = extent[1];

      if (mod || min == null) {
        min = +Infinity;
        max = -Infinity;
      }

      pulse.visit(mod ? pulse.SOURCE : pulse.ADD, t => {
        const v = toNumber(field(t));

        if (v != null) {
          // NaNs will fail all comparisons!
          if (v < min) min = v;
          if (v > max) max = v;
        }
      });

      if (!Number.isFinite(min) || !Number.isFinite(max)) {
        let name = accessorName(field);
        if (name) name = ` for field "${name}"`;
        pulse.dataflow.warn(`Infinite extent${name}: [${min}, ${max}]`);
        min = max = undefined;
      }

      this.value = [min, max];
    }

  });
  /**
   * Provides a bridge between a parent transform and a target subflow that
   * consumes only a subset of the tuples that pass through the parent.
   * @constructor
   * @param {Pulse} pulse - A pulse to use as the value of this operator.
   * @param {Transform} parent - The parent transform (typically a Facet instance).
   */

  function Subflow(pulse, parent) {
    Operator.call(this, pulse);
    this.parent = parent;
    this.count = 0;
  }

  inherits(Subflow, Operator, {
    /**
     * Routes pulses from this subflow to a target transform.
     * @param {Transform} target - A transform that receives the subflow of tuples.
     */
    connect(target) {
      this.detachSubflow = target.detachSubflow;
      this.targets().add(target);
      return target.source = this;
    },

    /**
     * Add an 'add' tuple to the subflow pulse.
     * @param {Tuple} t - The tuple being added.
     */
    add(t) {
      this.count += 1;
      this.value.add.push(t);
    },

    /**
     * Add a 'rem' tuple to the subflow pulse.
     * @param {Tuple} t - The tuple being removed.
     */
    rem(t) {
      this.count -= 1;
      this.value.rem.push(t);
    },

    /**
     * Add a 'mod' tuple to the subflow pulse.
     * @param {Tuple} t - The tuple being modified.
     */
    mod(t) {
      this.value.mod.push(t);
    },

    /**
     * Re-initialize this operator's pulse value.
     * @param {Pulse} pulse - The pulse to copy from.
     * @see Pulse.init
     */
    init(pulse) {
      this.value.init(pulse, pulse.NO_SOURCE);
    },

    /**
     * Evaluate this operator. This method overrides the
     * default behavior to simply return the contained pulse value.
     * @return {Pulse}
     */
    evaluate() {
      // assert: this.value.stamp === pulse.stamp
      return this.value;
    }

  });
  /**
   * Facets a dataflow into a set of subflows based on a key.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(Dataflow, string): Operator} params.subflow - A function
   *   that generates a subflow of operators and returns its root operator.
   * @param {function(object): *} params.key - The key field to facet by.
   */

  function Facet$1(params) {
    Transform.call(this, {}, params);
    this._keys = fastmap(); // cache previously calculated key values
    // keep track of active subflows, use as targets array for listeners
    // this allows us to limit propagation to only updated subflows

    const a = this._targets = [];
    a.active = 0;

    a.forEach = f => {
      for (let i = 0, n = a.active; i < n; ++i) {
        f(a[i], i, a);
      }
    };
  }

  inherits(Facet$1, Transform, {
    activate(flow) {
      this._targets[this._targets.active++] = flow;
    },

    // parent argument provided by PreFacet subclass
    subflow(key, flow, pulse, parent) {
      const flows = this.value;
      let sf = has$1(flows, key) && flows[key],
          df,
          p;

      if (!sf) {
        p = parent || (p = this._group[key]) && p.tuple;
        df = pulse.dataflow;
        sf = new Subflow(pulse.fork(pulse.NO_SOURCE), this);
        df.add(sf).connect(flow(df, key, p));
        flows[key] = sf;
        this.activate(sf);
      } else if (sf.value.stamp < pulse.stamp) {
        sf.init(pulse);
        this.activate(sf);
      }

      return sf;
    },

    clean() {
      const flows = this.value;
      let detached = 0;

      for (const key in flows) {
        if (flows[key].count === 0) {
          const detach = flows[key].detachSubflow;
          if (detach) detach();
          delete flows[key];
          ++detached;
        }
      } // remove inactive targets from the active targets array


      if (detached) {
        const active = this._targets.filter(sf => sf && sf.count > 0);

        this.initTargets(active);
      }
    },

    initTargets(act) {
      const a = this._targets,
            n = a.length,
            m = act ? act.length : 0;
      let i = 0;

      for (; i < m; ++i) {
        a[i] = act[i];
      }

      for (; i < n && a[i] != null; ++i) {
        a[i] = null; // ensure old flows can be garbage collected
      }

      a.active = m;
    },

    transform(_, pulse) {
      const df = pulse.dataflow,
            key = _.key,
            flow = _.subflow,
            cache = this._keys,
            rekey = _.modified('key'),
            subflow = key => this.subflow(key, flow, pulse);

      this._group = _.group || {};
      this.initTargets(); // reset list of active subflows

      pulse.visit(pulse.REM, t => {
        const id = tupleid(t),
              k = cache.get(id);

        if (k !== undefined) {
          cache.delete(id);
          subflow(k).rem(t);
        }
      });
      pulse.visit(pulse.ADD, t => {
        const k = key(t);
        cache.set(tupleid(t), k);
        subflow(k).add(t);
      });

      if (rekey || pulse.modified(key.fields)) {
        pulse.visit(pulse.MOD, t => {
          const id = tupleid(t),
                k0 = cache.get(id),
                k1 = key(t);

          if (k0 === k1) {
            subflow(k1).mod(t);
          } else {
            cache.set(id, k1);
            subflow(k0).rem(t);
            subflow(k1).add(t);
          }
        });
      } else if (pulse.changed(pulse.MOD)) {
        pulse.visit(pulse.MOD, t => {
          subflow(cache.get(tupleid(t))).mod(t);
        });
      }

      if (rekey) {
        pulse.visit(pulse.REFLOW, t => {
          const id = tupleid(t),
                k0 = cache.get(id),
                k1 = key(t);

          if (k0 !== k1) {
            cache.set(id, k1);
            subflow(k0).rem(t);
            subflow(k1).add(t);
          }
        });
      }

      if (pulse.clean()) {
        df.runAfter(() => {
          this.clean();
          cache.clean();
        });
      } else if (cache.empty > df.cleanThreshold) {
        df.runAfter(cache.clean);
      }

      return pulse;
    }

  });
  /**
   * Generates one or more field accessor functions.
   * If the 'name' parameter is an array, an array of field accessors
   * will be created and the 'as' parameter will be ignored.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {string} params.name - The field name(s) to access.
   * @param {string} params.as - The accessor function name.
   */

  function Field$1(params) {
    Operator.call(this, null, update$3, params);
  }

  inherits(Field$1, Operator);

  function update$3(_) {
    return this.value && !_.modified() ? this.value : isArray(_.name) ? array$5(_.name).map(f => field$1(f)) : field$1(_.name, _.as);
  }
  /**
   * Filters data tuples according to a predicate function.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.expr - The predicate expression function
   *   that determines a tuple's filter status. Truthy values pass the filter.
   */


  function Filter(params) {
    Transform.call(this, fastmap(), params);
  }

  Filter.Definition = {
    'type': 'Filter',
    'metadata': {
      'changes': true
    },
    'params': [{
      'name': 'expr',
      'type': 'expr',
      'required': true
    }]
  };
  inherits(Filter, Transform, {
    transform(_, pulse) {
      const df = pulse.dataflow,
            cache = this.value,
            // cache ids of filtered tuples
      output = pulse.fork(),
            add = output.add,
            rem = output.rem,
            mod = output.mod,
            test = _.expr;
      let isMod = true;
      pulse.visit(pulse.REM, t => {
        const id = tupleid(t);
        if (!cache.has(id)) rem.push(t);else cache.delete(id);
      });
      pulse.visit(pulse.ADD, t => {
        if (test(t, _)) add.push(t);else cache.set(tupleid(t), 1);
      });

      function revisit(t) {
        const id = tupleid(t),
              b = test(t, _),
              s = cache.get(id);

        if (b && s) {
          cache.delete(id);
          add.push(t);
        } else if (!b && !s) {
          cache.set(id, 1);
          rem.push(t);
        } else if (isMod && b && !s) {
          mod.push(t);
        }
      }

      pulse.visit(pulse.MOD, revisit);

      if (_.modified()) {
        isMod = false;
        pulse.visit(pulse.REFLOW, revisit);
      }

      if (cache.empty > df.cleanThreshold) df.runAfter(cache.clean);
      return output;
    }

  });
  /**
   * Flattens array-typed field values into new data objects.
   * If multiple fields are specified, they are treated as parallel arrays,
   * with output values included for each matching index (or null if missing).
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<function(object): *>} params.fields - An array of field
   *   accessors for the tuple fields that should be flattened.
   * @param {string} [params.index] - Optional output field name for index
   *   value. If unspecified, no index field is included in the output.
   * @param {Array<string>} [params.as] - Output field names for flattened
   *   array fields. Any unspecified fields will use the field name provided
   *   by the fields accessors.
   */

  function Flatten(params) {
    Transform.call(this, [], params);
  }

  Flatten.Definition = {
    'type': 'Flatten',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'fields',
      'type': 'field',
      'array': true,
      'required': true
    }, {
      'name': 'index',
      'type': 'string'
    }, {
      'name': 'as',
      'type': 'string',
      'array': true
    }]
  };
  inherits(Flatten, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE),
            fields = _.fields,
            as = fieldNames(fields, _.as || []),
            index = _.index || null,
            m = as.length; // remove any previous results

      out.rem = this.value; // generate flattened tuples

      pulse.visit(pulse.SOURCE, t => {
        const arrays = fields.map(f => f(t)),
              maxlen = arrays.reduce((l, a) => Math.max(l, a.length), 0);
        let i = 0,
            j,
            d,
            v;

        for (; i < maxlen; ++i) {
          d = derive(t);

          for (j = 0; j < m; ++j) {
            d[as[j]] = (v = arrays[j][i]) == null ? null : v;
          }

          if (index) {
            d[index] = i;
          }

          out.add.push(d);
        }
      });
      this.value = out.source = out.add;
      if (index) out.modifies(index);
      return out.modifies(as);
    }

  });
  /**
   * Folds one more tuple fields into multiple tuples in which the field
   * name and values are available under new 'key' and 'value' fields.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.fields - An array of field accessors
   *   for the tuple fields that should be folded.
   * @param {Array<string>} [params.as] - Output field names for folded key
   *   and value fields, defaults to ['key', 'value'].
   */

  function Fold(params) {
    Transform.call(this, [], params);
  }

  Fold.Definition = {
    'type': 'Fold',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'fields',
      'type': 'field',
      'array': true,
      'required': true
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': ['key', 'value']
    }]
  };
  inherits(Fold, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE),
            fields = _.fields,
            fnames = fields.map(accessorName),
            as = _.as || ['key', 'value'],
            k = as[0],
            v = as[1],
            n = fields.length;
      out.rem = this.value;
      pulse.visit(pulse.SOURCE, t => {
        for (let i = 0, d; i < n; ++i) {
          d = derive(t);
          d[k] = fnames[i];
          d[v] = fields[i](t);
          out.add.push(d);
        }
      });
      this.value = out.source = out.add;
      return out.modifies(as);
    }

  });
  /**
   * Invokes a function for each data tuple and saves the results as a new field.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.expr - The formula function to invoke for each tuple.
   * @param {string} params.as - The field name under which to save the result.
   * @param {boolean} [params.initonly=false] - If true, the formula is applied to
   *   added tuples only, and does not update in response to modifications.
   */

  function Formula(params) {
    Transform.call(this, null, params);
  }

  Formula.Definition = {
    'type': 'Formula',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'expr',
      'type': 'expr',
      'required': true
    }, {
      'name': 'as',
      'type': 'string',
      'required': true
    }, {
      'name': 'initonly',
      'type': 'boolean'
    }]
  };
  inherits(Formula, Transform, {
    transform(_, pulse) {
      const func = _.expr,
            as = _.as,
            mod = _.modified(),
            flag = _.initonly ? pulse.ADD : mod ? pulse.SOURCE : pulse.modified(func.fields) || pulse.modified(as) ? pulse.ADD_MOD : pulse.ADD;

      if (mod) {
        // parameters updated, need to reflow
        pulse = pulse.materialize().reflow(true);
      }

      if (!_.initonly) {
        pulse.modifies(as);
      }

      return pulse.visit(flag, t => t[as] = func(t, _));
    }

  });
  /**
   * Generates data tuples using a provided generator function.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(Parameters): object} params.generator - A tuple generator
   *   function. This function is given the operator parameters as input.
   *   Changes to any additional parameters will not trigger re-calculation
   *   of previously generated tuples. Only future tuples are affected.
   * @param {number} params.size - The number of tuples to produce.
   */

  function Generate(params) {
    Transform.call(this, [], params);
  }

  inherits(Generate, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.ALL),
            gen = _.generator;
      let data = this.value,
          num = _.size - data.length,
          add,
          rem,
          t;

      if (num > 0) {
        // need more tuples, generate and add
        for (add = []; --num >= 0;) {
          add.push(t = ingest$1(gen(_)));
          data.push(t);
        }

        out.add = out.add.length ? out.materialize(out.ADD).add.concat(add) : add;
      } else {
        // need fewer tuples, remove
        rem = data.slice(0, -num);
        out.rem = out.rem.length ? out.materialize(out.REM).rem.concat(rem) : rem;
        data = data.slice(-num);
      }

      out.source = this.value = data;
      return out;
    }

  });
  const Methods$1 = {
    value: 'value',
    median: median,
    mean: mean,
    min: min$2,
    max: max$2
  };
  const Empty$1 = [];
  /**
   * Impute missing values.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The value field to impute.
   * @param {Array<function(object): *>} [params.groupby] - An array of
   *   accessors to determine series within which to perform imputation.
   * @param {function(object): *} params.key - An accessor for a key value.
   *   Each key value should be unique within a group. New tuples will be
   *   imputed for any key values that are not found within a group.
   * @param {Array<*>} [params.keyvals] - Optional array of required key
   *   values. New tuples will be imputed for any key values that are not
   *   found within a group. In addition, these values will be automatically
   *   augmented with the key values observed in the input data.
   * @param {string} [method='value'] - The imputation method to use. One of
   *   'value', 'mean', 'median', 'max', 'min'.
   * @param {*} [value=0] - The constant value to use for imputation
   *   when using method 'value'.
   */

  function Impute(params) {
    Transform.call(this, [], params);
  }

  Impute.Definition = {
    'type': 'Impute',
    'metadata': {
      'changes': true
    },
    'params': [{
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'key',
      'type': 'field',
      'required': true
    }, {
      'name': 'keyvals',
      'array': true
    }, {
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'method',
      'type': 'enum',
      'default': 'value',
      'values': ['value', 'mean', 'median', 'max', 'min']
    }, {
      'name': 'value',
      'default': 0
    }]
  };

  function getValue(_) {
    var m = _.method || Methods$1.value,
        v;

    if (Methods$1[m] == null) {
      error('Unrecognized imputation method: ' + m);
    } else if (m === Methods$1.value) {
      v = _.value !== undefined ? _.value : 0;
      return () => v;
    } else {
      return Methods$1[m];
    }
  }

  function getField$1(_) {
    const f = _.field;
    return t => t ? f(t) : NaN;
  }

  inherits(Impute, Transform, {
    transform(_, pulse) {
      var out = pulse.fork(pulse.ALL),
          impute = getValue(_),
          field = getField$1(_),
          fName = accessorName(_.field),
          kName = accessorName(_.key),
          gNames = (_.groupby || []).map(accessorName),
          groups = partition$4(pulse.source, _.groupby, _.key, _.keyvals),
          curr = [],
          prev = this.value,
          m = groups.domain.length,
          group,
          value,
          gVals,
          kVal,
          g,
          i,
          j,
          l,
          n,
          t;

      for (g = 0, l = groups.length; g < l; ++g) {
        group = groups[g];
        gVals = group.values;
        value = NaN; // add tuples for missing values

        for (j = 0; j < m; ++j) {
          if (group[j] != null) continue;
          kVal = groups.domain[j];
          t = {
            _impute: true
          };

          for (i = 0, n = gVals.length; i < n; ++i) t[gNames[i]] = gVals[i];

          t[kName] = kVal;
          t[fName] = Number.isNaN(value) ? value = impute(group, field) : value;
          curr.push(ingest$1(t));
        }
      } // update pulse with imputed tuples


      if (curr.length) out.add = out.materialize(out.ADD).add.concat(curr);
      if (prev.length) out.rem = out.materialize(out.REM).rem.concat(prev);
      this.value = curr;
      return out;
    }

  });

  function partition$4(data, groupby, key, keyvals) {
    var get = f => f(t),
        groups = [],
        domain = keyvals ? keyvals.slice() : [],
        kMap = {},
        gMap = {},
        gVals,
        gKey,
        group,
        i,
        j,
        k,
        n,
        t;

    domain.forEach((k, i) => kMap[k] = i + 1);

    for (i = 0, n = data.length; i < n; ++i) {
      t = data[i];
      k = key(t);
      j = kMap[k] || (kMap[k] = domain.push(k));
      gKey = (gVals = groupby ? groupby.map(get) : Empty$1) + '';

      if (!(group = gMap[gKey])) {
        group = gMap[gKey] = [];
        groups.push(group);
        group.values = gVals;
      }

      group[j - 1] = t;
    }

    groups.domain = domain;
    return groups;
  }
  /**
   * Extend input tuples with aggregate values.
   * Calcuates aggregate values and joins them with the input stream.
   * @constructor
   */


  function JoinAggregate(params) {
    Aggregate$1.call(this, params);
  }

  JoinAggregate.Definition = {
    'type': 'JoinAggregate',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'fields',
      'type': 'field',
      'null': true,
      'array': true
    }, {
      'name': 'ops',
      'type': 'enum',
      'array': true,
      'values': ValidAggregateOps
    }, {
      'name': 'as',
      'type': 'string',
      'null': true,
      'array': true
    }, {
      'name': 'key',
      'type': 'field'
    }]
  };
  inherits(JoinAggregate, Aggregate$1, {
    transform(_, pulse) {
      const aggr = this,
            mod = _.modified();

      let cells; // process all input tuples to calculate aggregates

      if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
        cells = aggr.value = mod ? aggr.init(_) : {};
        pulse.visit(pulse.SOURCE, t => aggr.add(t));
      } else {
        cells = aggr.value = aggr.value || this.init(_);
        pulse.visit(pulse.REM, t => aggr.rem(t));
        pulse.visit(pulse.ADD, t => aggr.add(t));
      } // update aggregation cells


      aggr.changes(); // write aggregate values to input tuples

      pulse.visit(pulse.SOURCE, t => {
        extend$1(t, cells[aggr.cellkey(t)].tuple);
      });
      return pulse.reflow(mod).modifies(this._outputs);
    },

    changes() {
      const adds = this._adds,
            mods = this._mods;
      let i, n;

      for (i = 0, n = this._alen; i < n; ++i) {
        this.celltuple(adds[i]);
        adds[i] = null; // for garbage collection
      }

      for (i = 0, n = this._mlen; i < n; ++i) {
        this.celltuple(mods[i]);
        mods[i] = null; // for garbage collection
      }

      this._alen = this._mlen = 0; // reset list of active cells
    }

  });
  /**
   * Compute kernel density estimates (KDE) for one or more data groups.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors
   *   to groupby.
   * @param {function(object): *} params.field - An accessor for the data field
   *   to estimate.
   * @param {number} [params.bandwidth=0] - The KDE kernel bandwidth.
   *   If zero or unspecified, the bandwidth is automatically determined.
   * @param {boolean} [params.counts=false] - A boolean flag indicating if the
   *   output values should be probability estimates (false, default) or
   *   smoothed counts (true).
   * @param {string} [params.cumulative=false] - A boolean flag indicating if a
   *   density (false) or cumulative distribution (true) should be generated.
   * @param {Array<number>} [params.extent] - The domain extent over which to
   *   plot the density. If unspecified, the [min, max] data extent is used.
   * @param {string} [params.resolve='independent'] - Indicates how parameters for
   *   multiple densities should be resolved. If "independent" (the default), each
   *   density may have its own domain extent and dynamic number of curve sample
   *   steps. If "shared", the KDE transform will ensure that all densities are
   *   defined over a shared domain and curve steps, enabling stacking.
   * @param {number} [params.minsteps=25] - The minimum number of curve samples
   *   for plotting the density.
   * @param {number} [params.maxsteps=200] - The maximum number of curve samples
   *   for plotting the density.
   * @param {number} [params.steps] - The exact number of curve samples for
   *   plotting the density. If specified, overrides both minsteps and maxsteps
   *   to set an exact number of uniform samples. Useful in conjunction with
   *   a fixed extent to ensure consistent sample points for stacked densities.
   */

  function KDE(params) {
    Transform.call(this, null, params);
  }

  KDE.Definition = {
    'type': 'KDE',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'cumulative',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'counts',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'bandwidth',
      'type': 'number',
      'default': 0
    }, {
      'name': 'extent',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'resolve',
      'type': 'enum',
      'values': ['shared', 'independent'],
      'default': 'independent'
    }, {
      'name': 'steps',
      'type': 'number'
    }, {
      'name': 'minsteps',
      'type': 'number',
      'default': 25
    }, {
      'name': 'maxsteps',
      'type': 'number',
      'default': 200
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'default': ['value', 'density']
    }]
  };
  inherits(KDE, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);

      if (!this.value || pulse.changed() || _.modified()) {
        const source = pulse.materialize(pulse.SOURCE).source,
              groups = partition$1$1(source, _.groupby, _.field),
              names = (_.groupby || []).map(accessorName),
              bandwidth = _.bandwidth,
              method = _.cumulative ? 'cdf' : 'pdf',
              as = _.as || ['value', 'density'],
              values = [];
        let domain = _.extent,
            minsteps = _.steps || _.minsteps || 25,
            maxsteps = _.steps || _.maxsteps || 200;

        if (method !== 'pdf' && method !== 'cdf') {
          error('Invalid density method: ' + method);
        }

        if (_.resolve === 'shared') {
          if (!domain) domain = extent(source, _.field);
          minsteps = maxsteps = _.steps || maxsteps;
        }

        groups.forEach(g => {
          const density = kde(g, bandwidth)[method],
                scale = _.counts ? g.length : 1,
                local = domain || extent(g);
          sampleCurve(density, local, minsteps, maxsteps).forEach(v => {
            const t = {};

            for (let i = 0; i < names.length; ++i) {
              t[names[i]] = g.dims[i];
            }

            t[as[0]] = v[0];
            t[as[1]] = v[1] * scale;
            values.push(ingest$1(t));
          });
        });
        if (this.value) out.rem = this.value;
        this.value = out.add = out.source = values;
      }

      return out;
    }

  });
  /**
   * Generates a key function.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<string>} params.fields - The field name(s) for the key function.
   * @param {boolean} params.flat - A boolean flag indicating if the field names
   *  should be treated as flat property names, side-stepping nested field
   *  lookups normally indicated by dot or bracket notation.
   */

  function Key$1(params) {
    Operator.call(this, null, update$2, params);
  }

  inherits(Key$1, Operator);

  function update$2(_) {
    return this.value && !_.modified() ? this.value : key(_.fields, _.flat);
  }
  /**
   * Load and parse data from an external source. Marshalls parameter
   * values and then invokes the Dataflow request method.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {string} params.url - The URL to load from.
   * @param {object} params.format - The data format options.
   */


  function Load$1(params) {
    Transform.call(this, [], params);
    this._pending = null;
  }

  inherits(Load$1, Transform, {
    transform(_, pulse) {
      const df = pulse.dataflow;

      if (this._pending) {
        // update state and return pulse
        return output(this, pulse, this._pending);
      }

      if (stop(_)) return pulse.StopPropagation;

      if (_.values) {
        // parse and ingest values, return output pulse
        return output(this, pulse, df.parse(_.values, _.format));
      } else if (_.async) {
        // return promise for non-blocking async loading
        const p = df.request(_.url, _.format).then(res => {
          this._pending = array$5(res.data);
          return df => df.touch(this);
        });
        return {
          async: p
        };
      } else {
        // return promise for synchronous loading
        return df.request(_.url, _.format).then(res => output(this, pulse, array$5(res.data)));
      }
    }

  });

  function stop(_) {
    return _.modified('async') && !(_.modified('values') || _.modified('url') || _.modified('format'));
  }

  function output(op, pulse, data) {
    data.forEach(ingest$1);
    const out = pulse.fork(pulse.NO_FIELDS & pulse.NO_SOURCE);
    out.rem = op.value;
    op.value = out.source = out.add = data;
    op._pending = null;
    if (out.rem.length) out.clean(true);
    return out;
  }
  /**
   * Extend tuples by joining them with values from a lookup table.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Map} params.index - The lookup table map.
   * @param {Array<function(object): *} params.fields - The fields to lookup.
   * @param {Array<string>} params.as - Output field names for each lookup value.
   * @param {*} [params.default] - A default value to use if lookup fails.
   */


  function Lookup(params) {
    Transform.call(this, {}, params);
  }

  Lookup.Definition = {
    'type': 'Lookup',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'index',
      'type': 'index',
      'params': [{
        'name': 'from',
        'type': 'data',
        'required': true
      }, {
        'name': 'key',
        'type': 'field',
        'required': true
      }]
    }, {
      'name': 'values',
      'type': 'field',
      'array': true
    }, {
      'name': 'fields',
      'type': 'field',
      'array': true,
      'required': true
    }, {
      'name': 'as',
      'type': 'string',
      'array': true
    }, {
      'name': 'default',
      'default': null
    }]
  };
  inherits(Lookup, Transform, {
    transform(_, pulse) {
      const keys = _.fields,
            index = _.index,
            values = _.values,
            defaultValue = _.default == null ? null : _.default,
            reset = _.modified(),
            n = keys.length;

      let flag = reset ? pulse.SOURCE : pulse.ADD,
          out = pulse,
          as = _.as,
          set,
          m,
          mods;

      if (values) {
        m = values.length;

        if (n > 1 && !as) {
          error('Multi-field lookup requires explicit "as" parameter.');
        }

        if (as && as.length !== n * m) {
          error('The "as" parameter has too few output field names.');
        }

        as = as || values.map(accessorName);

        set = function (t) {
          for (var i = 0, k = 0, j, v; i < n; ++i) {
            v = index.get(keys[i](t));
            if (v == null) for (j = 0; j < m; ++j, ++k) t[as[k]] = defaultValue;else for (j = 0; j < m; ++j, ++k) t[as[k]] = values[j](v);
          }
        };
      } else {
        if (!as) {
          error('Missing output field names.');
        }

        set = function (t) {
          for (var i = 0, v; i < n; ++i) {
            v = index.get(keys[i](t));
            t[as[i]] = v == null ? defaultValue : v;
          }
        };
      }

      if (reset) {
        out = pulse.reflow(true);
      } else {
        mods = keys.some(k => pulse.modified(k.fields));
        flag |= mods ? pulse.MOD : 0;
      }

      pulse.visit(flag, set);
      return out.modifies(as);
    }

  });
  /**
   * Computes global min/max extents over a collection of extents.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<Array<number>>} params.extents - The input extents.
   */

  function MultiExtent$1(params) {
    Operator.call(this, null, update$1, params);
  }

  inherits(MultiExtent$1, Operator);

  function update$1(_) {
    if (this.value && !_.modified()) {
      return this.value;
    }

    const ext = _.extents,
          n = ext.length;
    let min = +Infinity,
        max = -Infinity,
        i,
        e;

    for (i = 0; i < n; ++i) {
      e = ext[i];
      if (e[0] < min) min = e[0];
      if (e[1] > max) max = e[1];
    }

    return [min, max];
  }
  /**
   * Merge a collection of value arrays.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<Array<*>>} params.values - The input value arrrays.
   */


  function MultiValues$1(params) {
    Operator.call(this, null, update, params);
  }

  inherits(MultiValues$1, Operator);

  function update(_) {
    return this.value && !_.modified() ? this.value : _.values.reduce((data, _) => data.concat(_), []);
  }
  /**
   * Operator whose value is simply its parameter hash. This operator is
   * useful for enabling reactive updates to values of nested objects.
   * @constructor
   * @param {object} params - The parameters for this operator.
   */


  function Params$2(params) {
    Transform.call(this, null, params);
  }

  inherits(Params$2, Transform, {
    transform(_, pulse) {
      this.modified(_.modified());
      this.value = _;
      return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS); // do not pass tuples
    }

  });
  /**
   * Aggregate and pivot selected field values to become new fields.
   * This operator is useful to construction cross-tabulations.
   * @constructor
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors
   *  to groupby. These fields act just like groupby fields of an Aggregate transform.
   * @param {function(object): *} params.field - The field to pivot on. The unique
   *  values of this field become new field names in the output stream.
   * @param {function(object): *} params.value - The field to populate pivoted fields.
   *  The aggregate values of this field become the values of the new pivoted fields.
   * @param {string} [params.op] - The aggregation operation for the value field,
   *  applied per cell in the output stream. The default is "sum".
   * @param {number} [params.limit] - An optional parameter indicating the maximum
   *  number of pivoted fields to generate. The pivoted field names are sorted in
   *  ascending order prior to enforcing the limit.
   */

  function Pivot(params) {
    Aggregate$1.call(this, params);
  }

  Pivot.Definition = {
    'type': 'Pivot',
    'metadata': {
      'generates': true,
      'changes': true
    },
    'params': [{
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'value',
      'type': 'field',
      'required': true
    }, {
      'name': 'op',
      'type': 'enum',
      'values': ValidAggregateOps,
      'default': 'sum'
    }, {
      'name': 'limit',
      'type': 'number',
      'default': 0
    }, {
      'name': 'key',
      'type': 'field'
    }]
  };
  inherits(Pivot, Aggregate$1, {
    _transform: Aggregate$1.prototype.transform,

    transform(_, pulse) {
      return this._transform(aggregateParams(_, pulse), pulse);
    }

  }); // Shoehorn a pivot transform into an aggregate transform!
  // First collect all unique pivot field values.
  // Then generate aggregate fields for each output pivot field.

  function aggregateParams(_, pulse) {
    const key = _.field,
          value = _.value,
          op = (_.op === 'count' ? '__count__' : _.op) || 'sum',
          fields = accessorFields(key).concat(accessorFields(value)),
          keys = pivotKeys(key, _.limit || 0, pulse); // if data stream content changes, pivot fields may change
    // flag parameter modification to ensure re-initialization

    if (pulse.changed()) _.set('__pivot__', null, null, true);
    return {
      key: _.key,
      groupby: _.groupby,
      ops: keys.map(() => op),
      fields: keys.map(k => get$4(k, key, value, fields)),
      as: keys.map(k => k + ''),
      modified: _.modified.bind(_)
    };
  } // Generate aggregate field accessor.
  // Output NaN for non-existent values; aggregator will ignore!


  function get$4(k, key, value, fields) {
    return accessor(d => key(d) === k ? value(d) : NaN, fields, k + '');
  } // Collect (and optionally limit) all unique pivot values.


  function pivotKeys(key, limit, pulse) {
    const map = {},
          list = [];
    pulse.visit(pulse.SOURCE, t => {
      const k = key(t);

      if (!map[k]) {
        map[k] = 1;
        list.push(k);
      }
    });
    list.sort(ascending$3);
    return limit ? list.slice(0, limit) : list;
  }
  /**
   * Partitions pre-faceted data into tuple subflows.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(Dataflow, string): Operator} params.subflow - A function
   *   that generates a subflow of operators and returns its root operator.
   * @param {function(object): Array<object>} params.field - The field
   *   accessor for an array of subflow tuple objects.
   */


  function PreFacet$1(params) {
    Facet$1.call(this, params);
  }

  inherits(PreFacet$1, Facet$1, {
    transform(_, pulse) {
      const flow = _.subflow,
            field = _.field,
            subflow = t => this.subflow(tupleid(t), flow, pulse, t);

      if (_.modified('field') || field && pulse.modified(accessorFields(field))) {
        error('PreFacet does not support field modification.');
      }

      this.initTargets(); // reset list of active subflows

      if (field) {
        pulse.visit(pulse.MOD, t => {
          const sf = subflow(t);
          field(t).forEach(_ => sf.mod(_));
        });
        pulse.visit(pulse.ADD, t => {
          const sf = subflow(t);
          field(t).forEach(_ => sf.add(ingest$1(_)));
        });
        pulse.visit(pulse.REM, t => {
          const sf = subflow(t);
          field(t).forEach(_ => sf.rem(_));
        });
      } else {
        pulse.visit(pulse.MOD, t => subflow(t).mod(t));
        pulse.visit(pulse.ADD, t => subflow(t).add(t));
        pulse.visit(pulse.REM, t => subflow(t).rem(t));
      }

      if (pulse.clean()) {
        pulse.runAfter(() => this.clean());
      }

      return pulse;
    }

  });
  /**
   * Performs a relational projection, copying selected fields from source
   * tuples to a new set of derived tuples.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<function(object): *} params.fields - The fields to project,
   *   as an array of field accessors. If unspecified, all fields will be
   *   copied with names unchanged.
   * @param {Array<string>} [params.as] - Output field names for each projected
   *   field. Any unspecified fields will use the field name provided by
   *   the field accessor.
   */

  function Project(params) {
    Transform.call(this, null, params);
  }

  Project.Definition = {
    'type': 'Project',
    'metadata': {
      'generates': true,
      'changes': true
    },
    'params': [{
      'name': 'fields',
      'type': 'field',
      'array': true
    }, {
      'name': 'as',
      'type': 'string',
      'null': true,
      'array': true
    }]
  };
  inherits(Project, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE),
            fields = _.fields,
            as = fieldNames(_.fields, _.as || []),
            derive = fields ? (s, t) => project(s, t, fields, as) : rederive;
      let lut;

      if (this.value) {
        lut = this.value;
      } else {
        pulse = pulse.addAll();
        lut = this.value = {};
      }

      pulse.visit(pulse.REM, t => {
        const id = tupleid(t);
        out.rem.push(lut[id]);
        lut[id] = null;
      });
      pulse.visit(pulse.ADD, t => {
        const dt = derive(t, ingest$1({}));
        lut[tupleid(t)] = dt;
        out.add.push(dt);
      });
      pulse.visit(pulse.MOD, t => {
        out.mod.push(derive(t, lut[tupleid(t)]));
      });
      return out;
    }

  });

  function project(s, t, fields, as) {
    for (let i = 0, n = fields.length; i < n; ++i) {
      t[as[i]] = fields[i](s);
    }

    return t;
  }
  /**
   * Proxy the value of another operator as a pure signal value.
   * Ensures no tuples are propagated.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {*} params.value - The value to proxy, becomes the value of this operator.
   */


  function Proxy$1(params) {
    Transform.call(this, null, params);
  }

  inherits(Proxy$1, Transform, {
    transform(_, pulse) {
      this.value = _.value;
      return _.modified('value') ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
    }

  });
  /**
   * Generates sample quantile values from an input data stream.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - An accessor for the data field
   *   over which to calculate quantile values.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors
   *   to groupby.
   * @param {Array<number>} [params.probs] - An array of probabilities in
   *   the range (0, 1) for which to compute quantile values. If not specified,
   *   the *step* parameter will be used.
   * @param {Array<number>} [params.step=0.01] - A probability step size for
   *   sampling quantile values. All values from one-half the step size up to
   *   1 (exclusive) will be sampled. This parameter is only used if the
   *   *quantiles* parameter is not provided.
   */

  function Quantile$1(params) {
    Transform.call(this, null, params);
  }

  Quantile$1.Definition = {
    'type': 'Quantile',
    'metadata': {
      'generates': true,
      'changes': true
    },
    'params': [{
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'probs',
      'type': 'number',
      'array': true
    }, {
      'name': 'step',
      'type': 'number',
      'default': 0.01
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'default': ['prob', 'value']
    }]
  };
  const EPSILON$2 = 1e-14;
  inherits(Quantile$1, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
            as = _.as || ['prob', 'value'];

      if (this.value && !_.modified() && !pulse.changed()) {
        out.source = this.value;
        return out;
      }

      const source = pulse.materialize(pulse.SOURCE).source,
            groups = partition$1$1(source, _.groupby, _.field),
            names = (_.groupby || []).map(accessorName),
            values = [],
            step = _.step || 0.01,
            p = _.probs || range$1$1(step / 2, 1 - EPSILON$2, step),
            n = p.length;
      groups.forEach(g => {
        const q = quantiles(g, p);

        for (let i = 0; i < n; ++i) {
          const t = {};

          for (let i = 0; i < names.length; ++i) {
            t[names[i]] = g.dims[i];
          }

          t[as[0]] = p[i];
          t[as[1]] = q[i];
          values.push(ingest$1(t));
        }
      });
      if (this.value) out.rem = this.value;
      this.value = out.add = out.source = values;
      return out;
    }

  });
  /**
   * Relays a data stream between data processing pipelines.
   * If the derive parameter is set, this transform will create derived
   * copies of observed tuples. This provides derived data streams in which
   * modifications to the tuples do not pollute an upstream data source.
   * @param {object} params - The parameters for this operator.
   * @param {number} [params.derive=false] - Boolean flag indicating if
   *   the transform should make derived copies of incoming tuples.
   * @constructor
   */

  function Relay$1(params) {
    Transform.call(this, null, params);
  }

  inherits(Relay$1, Transform, {
    transform(_, pulse) {
      let out, lut;

      if (this.value) {
        lut = this.value;
      } else {
        out = pulse = pulse.addAll();
        lut = this.value = {};
      }

      if (_.derive) {
        out = pulse.fork(pulse.NO_SOURCE);
        pulse.visit(pulse.REM, t => {
          const id = tupleid(t);
          out.rem.push(lut[id]);
          lut[id] = null;
        });
        pulse.visit(pulse.ADD, t => {
          const dt = derive(t);
          lut[tupleid(t)] = dt;
          out.add.push(dt);
        });
        pulse.visit(pulse.MOD, t => {
          const dt = lut[tupleid(t)];

          for (const k in t) {
            dt[k] = t[k]; // down stream writes may overwrite re-derived tuples
            // conservatively mark all source fields as modified

            out.modifies(k);
          }

          out.mod.push(dt);
        });
      }

      return out;
    }

  });
  /**
   * Samples tuples passing through this operator.
   * Uses reservoir sampling to maintain a representative sample.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {number} [params.size=1000] - The maximum number of samples.
   */

  function Sample(params) {
    Transform.call(this, [], params);
    this.count = 0;
  }

  Sample.Definition = {
    'type': 'Sample',
    'metadata': {},
    'params': [{
      'name': 'size',
      'type': 'number',
      'default': 1000
    }]
  };
  inherits(Sample, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE),
            mod = _.modified('size'),
            num = _.size,
            map = this.value.reduce((m, t) => (m[tupleid(t)] = 1, m), {});

      let res = this.value,
          cnt = this.count,
          cap = 0; // sample reservoir update function

      function update(t) {
        let p, idx;

        if (res.length < num) {
          res.push(t);
        } else {
          idx = ~~((cnt + 1) * exports.random());

          if (idx < res.length && idx >= cap) {
            p = res[idx];
            if (map[tupleid(p)]) out.rem.push(p); // eviction

            res[idx] = t;
          }
        }

        ++cnt;
      }

      if (pulse.rem.length) {
        // find all tuples that should be removed, add to output
        pulse.visit(pulse.REM, t => {
          const id = tupleid(t);

          if (map[id]) {
            map[id] = -1;
            out.rem.push(t);
          }

          --cnt;
        }); // filter removed tuples out of the sample reservoir

        res = res.filter(t => map[tupleid(t)] !== -1);
      }

      if ((pulse.rem.length || mod) && res.length < num && pulse.source) {
        // replenish sample if backing data source is available
        cap = cnt = res.length;
        pulse.visit(pulse.SOURCE, t => {
          // update, but skip previously sampled tuples
          if (!map[tupleid(t)]) update(t);
        });
        cap = -1;
      }

      if (mod && res.length > num) {
        const n = res.length - num;

        for (let i = 0; i < n; ++i) {
          map[tupleid(res[i])] = -1;
          out.rem.push(res[i]);
        }

        res = res.slice(n);
      }

      if (pulse.mod.length) {
        // propagate modified tuples in the sample reservoir
        pulse.visit(pulse.MOD, t => {
          if (map[tupleid(t)]) out.mod.push(t);
        });
      }

      if (pulse.add.length) {
        // update sample reservoir
        pulse.visit(pulse.ADD, update);
      }

      if (pulse.add.length || cap < 0) {
        // output newly added tuples
        out.add = res.filter(t => !map[tupleid(t)]);
      }

      this.count = cnt;
      this.value = out.source = res;
      return out;
    }

  });
  /**
   * Generates data tuples for a specified sequence range of numbers.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {number} params.start - The first number in the sequence.
   * @param {number} params.stop - The last number (exclusive) in the sequence.
   * @param {number} [params.step=1] - The step size between numbers in the sequence.
   */

  function Sequence(params) {
    Transform.call(this, null, params);
  }

  Sequence.Definition = {
    'type': 'Sequence',
    'metadata': {
      'generates': true,
      'changes': true
    },
    'params': [{
      'name': 'start',
      'type': 'number',
      'required': true
    }, {
      'name': 'stop',
      'type': 'number',
      'required': true
    }, {
      'name': 'step',
      'type': 'number',
      'default': 1
    }, {
      'name': 'as',
      'type': 'string',
      'default': 'data'
    }]
  };
  inherits(Sequence, Transform, {
    transform(_, pulse) {
      if (this.value && !_.modified()) return;
      const out = pulse.materialize().fork(pulse.MOD),
            as = _.as || 'data';
      out.rem = this.value ? pulse.rem.concat(this.value) : pulse.rem;
      this.value = range$1$1(_.start, _.stop, _.step || 1).map(v => {
        const t = {};
        t[as] = v;
        return ingest$1(t);
      });
      out.add = pulse.add.concat(this.value);
      return out;
    }

  });
  /**
   * Propagates a new pulse without any tuples so long as the input
   * pulse contains some added, removed or modified tuples.
   * @param {object} params - The parameters for this operator.
   * @constructor
   */

  function Sieve$1(params) {
    Transform.call(this, null, params);
    this.modified(true); // always treat as modified
  }

  inherits(Sieve$1, Transform, {
    transform(_, pulse) {
      this.value = pulse.source;
      return pulse.changed() ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
    }

  });
  /**
   * Discretize dates to specific time units.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The data field containing date/time values.
   */

  function TimeUnit(params) {
    Transform.call(this, null, params);
  }

  const OUTPUT = ['unit0', 'unit1'];
  TimeUnit.Definition = {
    'type': 'TimeUnit',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field',
      'required': true
    }, {
      'name': 'interval',
      'type': 'boolean',
      'default': true
    }, {
      'name': 'units',
      'type': 'enum',
      'values': TIME_UNITS,
      'array': true
    }, {
      'name': 'step',
      'type': 'number',
      'default': 1
    }, {
      'name': 'maxbins',
      'type': 'number',
      'default': 40
    }, {
      'name': 'extent',
      'type': 'date',
      'array': true
    }, {
      'name': 'timezone',
      'type': 'enum',
      'default': 'local',
      'values': ['local', 'utc']
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': OUTPUT
    }]
  };
  inherits(TimeUnit, Transform, {
    transform(_, pulse) {
      const field = _.field,
            band = _.interval !== false,
            utc = _.timezone === 'utc',
            floor = this._floor(_, pulse),
            offset = (utc ? utcInterval : timeInterval)(floor.unit).offset,
            as = _.as || OUTPUT,
            u0 = as[0],
            u1 = as[1],
            step = floor.step;

      let min = floor.start || Infinity,
          max = floor.stop || -Infinity,
          flag = pulse.ADD;

      if (_.modified() || pulse.modified(accessorFields(field))) {
        pulse = pulse.reflow(true);
        flag = pulse.SOURCE;
        min = Infinity;
        max = -Infinity;
      }

      pulse.visit(flag, t => {
        const v = field(t);
        let a, b;

        if (v == null) {
          t[u0] = null;
          if (band) t[u1] = null;
        } else {
          t[u0] = a = b = floor(v);
          if (band) t[u1] = b = offset(a, step);
          if (a < min) min = a;
          if (b > max) max = b;
        }
      });
      floor.start = min;
      floor.stop = max;
      return pulse.modifies(band ? as : u0);
    },

    _floor(_, pulse) {
      const utc = _.timezone === 'utc'; // get parameters

      const {
        units,
        step
      } = _.units ? {
        units: _.units,
        step: _.step || 1
      } : bin$1({
        extent: _.extent || extent(pulse.materialize(pulse.SOURCE).source, _.field),
        maxbins: _.maxbins
      }); // check / standardize time units

      const tunits = timeUnits(units),
            prev = this.value || {},
            floor = (utc ? utcFloor : timeFloor)(tunits, step);
      floor.unit = peek$1(tunits);
      floor.units = tunits;
      floor.step = step;
      floor.start = prev.start;
      floor.stop = prev.stop;
      return this.value = floor;
    }

  });
  /**
   * An index that maps from unique, string-coerced, field values to tuples.
   * Assumes that the field serves as a unique key with no duplicate values.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The field accessor to index.
   */

  function TupleIndex(params) {
    Transform.call(this, fastmap(), params);
  }

  inherits(TupleIndex, Transform, {
    transform(_, pulse) {
      const df = pulse.dataflow,
            field = _.field,
            index = this.value,
            set = t => index.set(field(t), t);

      let mod = true;

      if (_.modified('field') || pulse.modified(field.fields)) {
        index.clear();
        pulse.visit(pulse.SOURCE, set);
      } else if (pulse.changed()) {
        pulse.visit(pulse.REM, t => index.delete(field(t)));
        pulse.visit(pulse.ADD, set);
      } else {
        mod = false;
      }

      this.modified(mod);
      if (index.empty > df.cleanThreshold) df.runAfter(index.clean);
      return pulse.fork();
    }

  });
  /**
   * Extracts an array of values. Assumes the source data has already been
   * reduced as needed (e.g., by an upstream Aggregate transform).
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The domain field to extract.
   * @param {function(*,*): number} [params.sort] - An optional
   *   comparator function for sorting the values. The comparator will be
   *   applied to backing tuples prior to value extraction.
   */

  function Values$1(params) {
    Transform.call(this, null, params);
  }

  inherits(Values$1, Transform, {
    transform(_, pulse) {
      const run = !this.value || _.modified('field') || _.modified('sort') || pulse.changed() || _.sort && pulse.modified(_.sort.fields);

      if (run) {
        this.value = (_.sort ? pulse.source.slice().sort(stableCompare(_.sort)) : pulse.source).map(_.field);
      }
    }

  });

  function WindowOp(op, field, param, as) {
    const fn = WindowOps[op](field, param);
    return {
      init: fn.init || zero$2,
      update: function (w, t) {
        t[as] = fn.next(w);
      }
    };
  }

  const WindowOps = {
    row_number: function () {
      return {
        next: w => w.index + 1
      };
    },
    rank: function () {
      let rank;
      return {
        init: () => rank = 1,
        next: w => {
          const i = w.index,
                data = w.data;
          return i && w.compare(data[i - 1], data[i]) ? rank = i + 1 : rank;
        }
      };
    },
    dense_rank: function () {
      let drank;
      return {
        init: () => drank = 1,
        next: w => {
          const i = w.index,
                d = w.data;
          return i && w.compare(d[i - 1], d[i]) ? ++drank : drank;
        }
      };
    },
    percent_rank: function () {
      const rank = WindowOps.rank(),
            next = rank.next;
      return {
        init: rank.init,
        next: w => (next(w) - 1) / (w.data.length - 1)
      };
    },
    cume_dist: function () {
      let cume;
      return {
        init: () => cume = 0,
        next: w => {
          const d = w.data,
                c = w.compare;
          let i = w.index;

          if (cume < i) {
            while (i + 1 < d.length && !c(d[i], d[i + 1])) ++i;

            cume = i;
          }

          return (1 + cume) / d.length;
        }
      };
    },
    ntile: function (field, num) {
      num = +num;
      if (!(num > 0)) error('ntile num must be greater than zero.');
      const cume = WindowOps.cume_dist(),
            next = cume.next;
      return {
        init: cume.init,
        next: w => Math.ceil(num * next(w))
      };
    },
    lag: function (field, offset) {
      offset = +offset || 1;
      return {
        next: w => {
          const i = w.index - offset;
          return i >= 0 ? field(w.data[i]) : null;
        }
      };
    },
    lead: function (field, offset) {
      offset = +offset || 1;
      return {
        next: w => {
          const i = w.index + offset,
                d = w.data;
          return i < d.length ? field(d[i]) : null;
        }
      };
    },
    first_value: function (field) {
      return {
        next: w => field(w.data[w.i0])
      };
    },
    last_value: function (field) {
      return {
        next: w => field(w.data[w.i1 - 1])
      };
    },
    nth_value: function (field, nth) {
      nth = +nth;
      if (!(nth > 0)) error('nth_value nth must be greater than zero.');
      return {
        next: w => {
          const i = w.i0 + (nth - 1);
          return i < w.i1 ? field(w.data[i]) : null;
        }
      };
    },
    prev_value: function (field) {
      let prev;
      return {
        init: () => prev = null,
        next: w => {
          const v = field(w.data[w.index]);
          return v != null ? prev = v : prev;
        }
      };
    },
    next_value: function (field) {
      let v, i;
      return {
        init: () => (v = null, i = -1),
        next: w => {
          const d = w.data;
          return w.index <= i ? v : (i = find$2(field, d, w.index)) < 0 ? (i = d.length, v = null) : v = field(d[i]);
        }
      };
    }
  };

  function find$2(field, data, index) {
    for (let n = data.length; index < n; ++index) {
      const v = field(data[index]);
      if (v != null) return index;
    }

    return -1;
  }

  const ValidWindowOps = Object.keys(WindowOps);

  function WindowState(_) {
    const ops = array$5(_.ops),
          fields = array$5(_.fields),
          params = array$5(_.params),
          as = array$5(_.as),
          outputs = this.outputs = [],
          windows = this.windows = [],
          inputs = {},
          map = {},
          counts = [],
          measures = [];
    let countOnly = true;

    function visitInputs(f) {
      array$5(accessorFields(f)).forEach(_ => inputs[_] = 1);
    }

    visitInputs(_.sort);
    ops.forEach((op, i) => {
      const field = fields[i],
            mname = accessorName(field),
            name = measureName(op, mname, as[i]);
      visitInputs(field);
      outputs.push(name); // Window operation

      if (has$1(WindowOps, op)) {
        windows.push(WindowOp(op, fields[i], params[i], name));
      } // Aggregate operation
      else {
          if (field == null && op !== 'count') {
            error('Null aggregate field specified.');
          }

          if (op === 'count') {
            counts.push(name);
            return;
          }

          countOnly = false;
          let m = map[mname];

          if (!m) {
            m = map[mname] = [];
            m.field = field;
            measures.push(m);
          }

          m.push(createMeasure(op, name));
        }
    });

    if (counts.length || measures.length) {
      this.cell = cell(measures, counts, countOnly);
    }

    this.inputs = Object.keys(inputs);
  }

  const prototype = WindowState.prototype;

  prototype.init = function () {
    this.windows.forEach(_ => _.init());
    if (this.cell) this.cell.init();
  };

  prototype.update = function (w, t) {
    const cell = this.cell,
          wind = this.windows,
          data = w.data,
          m = wind && wind.length;
    let j;

    if (cell) {
      for (j = w.p0; j < w.i0; ++j) cell.rem(data[j]);

      for (j = w.p1; j < w.i1; ++j) cell.add(data[j]);

      cell.set(t);
    }

    for (j = 0; j < m; ++j) wind[j].update(w, t);
  };

  function cell(measures, counts, countOnly) {
    measures = measures.map(m => compileMeasures(m, m.field));
    const cell = {
      num: 0,
      agg: null,
      store: false,
      count: counts
    };

    if (!countOnly) {
      var n = measures.length,
          a = cell.agg = Array(n),
          i = 0;

      for (; i < n; ++i) a[i] = new measures[i](cell);
    }

    if (cell.store) {
      var store = cell.data = new TupleStore();
    }

    cell.add = function (t) {
      cell.num += 1;
      if (countOnly) return;
      if (store) store.add(t);

      for (let i = 0; i < n; ++i) {
        a[i].add(a[i].get(t), t);
      }
    };

    cell.rem = function (t) {
      cell.num -= 1;
      if (countOnly) return;
      if (store) store.rem(t);

      for (let i = 0; i < n; ++i) {
        a[i].rem(a[i].get(t), t);
      }
    };

    cell.set = function (t) {
      let i, n; // consolidate stored values

      if (store) store.values(); // update tuple properties

      for (i = 0, n = counts.length; i < n; ++i) t[counts[i]] = cell.num;

      if (!countOnly) for (i = 0, n = a.length; i < n; ++i) a[i].set(t);
    };

    cell.init = function () {
      cell.num = 0;
      if (store) store.reset();

      for (let i = 0; i < n; ++i) a[i].init();
    };

    return cell;
  }
  /**
   * Perform window calculations and write results to the input stream.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(*,*): number} [params.sort] - A comparator function for sorting tuples within a window.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors by which to partition tuples into separate windows.
   * @param {Array<string>} params.ops - An array of strings indicating window operations to perform.
   * @param {Array<function(object): *>} [params.fields] - An array of accessors
   *   for data fields to use as inputs to window operations.
   * @param {Array<*>} [params.params] - An array of parameter values for window operations.
   * @param {Array<string>} [params.as] - An array of output field names for window operations.
   * @param {Array<number>} [params.frame] - Window frame definition as two-element array.
   * @param {boolean} [params.ignorePeers=false] - If true, base window frame boundaries on row
   *   number alone, ignoring peers with identical sort values. If false (default),
   *   the window boundaries will be adjusted to include peer values.
   */


  function Window(params) {
    Transform.call(this, {}, params);
    this._mlen = 0;
    this._mods = [];
  }

  Window.Definition = {
    'type': 'Window',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'sort',
      'type': 'compare'
    }, {
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'ops',
      'type': 'enum',
      'array': true,
      'values': ValidWindowOps.concat(ValidAggregateOps)
    }, {
      'name': 'params',
      'type': 'number',
      'null': true,
      'array': true
    }, {
      'name': 'fields',
      'type': 'field',
      'null': true,
      'array': true
    }, {
      'name': 'as',
      'type': 'string',
      'null': true,
      'array': true
    }, {
      'name': 'frame',
      'type': 'number',
      'null': true,
      'array': true,
      'length': 2,
      'default': [null, 0]
    }, {
      'name': 'ignorePeers',
      'type': 'boolean',
      'default': false
    }]
  };
  inherits(Window, Transform, {
    transform(_, pulse) {
      this.stamp = pulse.stamp;

      const mod = _.modified(),
            cmp = stableCompare(_.sort),
            key = groupkey(_.groupby),
            group = t => this.group(key(t)); // initialize window state


      let state = this.state;

      if (!state || mod) {
        state = this.state = new WindowState(_);
      } // partition input tuples


      if (mod || pulse.modified(state.inputs)) {
        this.value = {};
        pulse.visit(pulse.SOURCE, t => group(t).add(t));
      } else {
        pulse.visit(pulse.REM, t => group(t).remove(t));
        pulse.visit(pulse.ADD, t => group(t).add(t));
      } // perform window calculations for each modified partition


      for (let i = 0, n = this._mlen; i < n; ++i) {
        processPartition(this._mods[i], state, cmp, _);
      }

      this._mlen = 0;
      this._mods = []; // TODO don't reflow everything?

      return pulse.reflow(mod).modifies(state.outputs);
    },

    group(key) {
      let group = this.value[key];

      if (!group) {
        group = this.value[key] = SortedList(tupleid);
        group.stamp = -1;
      }

      if (group.stamp < this.stamp) {
        group.stamp = this.stamp;
        this._mods[this._mlen++] = group;
      }

      return group;
    }

  });

  function processPartition(list, state, cmp, _) {
    const sort = _.sort,
          range = sort && !_.ignorePeers,
          frame = _.frame || [null, 0],
          data = list.data(cmp),
          // use cmp for stable sort
    n = data.length,
          b = range ? bisector$1(sort) : null,
          w = {
      i0: 0,
      i1: 0,
      p0: 0,
      p1: 0,
      index: 0,
      data: data,
      compare: sort || constant$4(-1)
    };
    state.init();

    for (let i = 0; i < n; ++i) {
      setWindow(w, frame, i, n);
      if (range) adjustRange(w, b);
      state.update(w, data[i]);
    }
  }

  function setWindow(w, f, i, n) {
    w.p0 = w.i0;
    w.p1 = w.i1;
    w.i0 = f[0] == null ? 0 : Math.max(0, i - Math.abs(f[0]));
    w.i1 = f[1] == null ? n : Math.min(n, i + Math.abs(f[1]) + 1);
    w.index = i;
  } // if frame type is 'range', adjust window for peer values


  function adjustRange(w, bisect) {
    const r0 = w.i0,
          r1 = w.i1 - 1,
          c = w.compare,
          d = w.data,
          n = d.length - 1;
    if (r0 > 0 && !c(d[r0], d[r0 - 1])) w.i0 = bisect.left(d, d[r0]);
    if (r1 < n && !c(d[r1], d[r1 + 1])) w.i1 = bisect.right(d, d[r1]);
  }

  var tx = /*#__PURE__*/Object.freeze({
    __proto__: null,
    aggregate: Aggregate$1,
    bin: Bin,
    collect: Collect$1,
    compare: Compare$1,
    countpattern: CountPattern,
    cross: Cross,
    density: Density,
    dotbin: DotBin,
    expression: Expression$1,
    extent: Extent,
    facet: Facet$1,
    field: Field$1,
    filter: Filter,
    flatten: Flatten,
    fold: Fold,
    formula: Formula,
    generate: Generate,
    impute: Impute,
    joinaggregate: JoinAggregate,
    kde: KDE,
    key: Key$1,
    load: Load$1,
    lookup: Lookup,
    multiextent: MultiExtent$1,
    multivalues: MultiValues$1,
    params: Params$2,
    pivot: Pivot,
    prefacet: PreFacet$1,
    project: Project,
    proxy: Proxy$1,
    quantile: Quantile$1,
    relay: Relay$1,
    sample: Sample,
    sequence: Sequence,
    sieve: Sieve$1,
    subflow: Subflow,
    timeunit: TimeUnit,
    tupleindex: TupleIndex,
    values: Values$1,
    window: Window
  });

  const pi$3 = Math.PI,
        tau$3 = 2 * pi$3,
        epsilon$4 = 1e-6,
        tauEpsilon = tau$3 - epsilon$4;

  function Path$1() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath

    this._ = "";
  }

  function path$3() {
    return new Path$1();
  }

  Path$1.prototype = path$3.prototype = {
    constructor: Path$1,
    moveTo: function (x, y) {
      this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function () {
      if (this._x1 !== null) {
        this._x1 = this._x0, this._y1 = this._y0;
        this._ += "Z";
      }
    },
    lineTo: function (x, y) {
      this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function (x1, y1, x, y) {
      this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function (x1, y1, x2, y2, x, y) {
      this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function (x1, y1, x2, y2, r) {
      x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
      var x0 = this._x1,
          y0 = this._y1,
          x21 = x2 - x1,
          y21 = y2 - y1,
          x01 = x0 - x1,
          y01 = y0 - y1,
          l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.

      if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).

      if (this._x1 === null) {
        this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
      } // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
      else if (!(l01_2 > epsilon$4)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        // Equivalently, is (x1,y1) coincident with (x2,y2)?
        // Or, is the radius zero? Line to (x1,y1).
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$4) || !r) {
            this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
          } // Otherwise, draw an arc!
          else {
              var x20 = x2 - x0,
                  y20 = y2 - y0,
                  l21_2 = x21 * x21 + y21 * y21,
                  l20_2 = x20 * x20 + y20 * y20,
                  l21 = Math.sqrt(l21_2),
                  l01 = Math.sqrt(l01_2),
                  l = r * Math.tan((pi$3 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
                  t01 = l / l01,
                  t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.

              if (Math.abs(t01 - 1) > epsilon$4) {
                this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
              }

              this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
            }
    },
    arc: function (x, y, r, a0, a1, ccw) {
      x = +x, y = +y, r = +r, ccw = !!ccw;
      var dx = r * Math.cos(a0),
          dy = r * Math.sin(a0),
          x0 = x + dx,
          y0 = y + dy,
          cw = 1 ^ ccw,
          da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.

      if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).

      if (this._x1 === null) {
        this._ += "M" + x0 + "," + y0;
      } // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
      else if (Math.abs(this._x1 - x0) > epsilon$4 || Math.abs(this._y1 - y0) > epsilon$4) {
          this._ += "L" + x0 + "," + y0;
        } // Is this arc empty? We’re done.


      if (!r) return; // Does the angle go the wrong way? Flip the direction.

      if (da < 0) da = da % tau$3 + tau$3; // Is this a complete circle? Draw two arcs to complete the circle.

      if (da > tauEpsilon) {
        this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
      } // Is this arc non-empty? Draw an arc!
      else if (da > epsilon$4) {
          this._ += "A" + r + "," + r + ",0," + +(da >= pi$3) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
        }
    },
    rect: function (x, y, w, h) {
      this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function () {
      return this._;
    }
  };

  function constant$3 (x) {
    return function constant() {
      return x;
    };
  }

  var abs$2 = Math.abs;
  var atan2$1 = Math.atan2;
  var cos$2 = Math.cos;
  var max$1 = Math.max;
  var min$1 = Math.min;
  var sin$2 = Math.sin;
  var sqrt$3 = Math.sqrt;
  var epsilon$3 = 1e-12;
  var pi$2 = Math.PI;
  var halfPi$2 = pi$2 / 2;
  var tau$2 = 2 * pi$2;
  function acos$1(x) {
    return x > 1 ? 0 : x < -1 ? pi$2 : Math.acos(x);
  }
  function asin$2(x) {
    return x >= 1 ? halfPi$2 : x <= -1 ? -halfPi$2 : Math.asin(x);
  }

  function arcInnerRadius(d) {
    return d.innerRadius;
  }

  function arcOuterRadius(d) {
    return d.outerRadius;
  }

  function arcStartAngle(d) {
    return d.startAngle;
  }

  function arcEndAngle(d) {
    return d.endAngle;
  }

  function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
  }

  function intersect$3(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0,
        y10 = y1 - y0,
        x32 = x3 - x2,
        y32 = y3 - y2,
        t = y32 * x10 - x32 * y10;
    if (t * t < epsilon$3) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [x0 + t * x10, y0 + t * y10];
  } // Compute perpendicular offset line of length rc.
  // http://mathworld.wolfram.com/Circle-LineIntersection.html


  function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1,
        y01 = y0 - y1,
        lo = (cw ? rc : -rc) / sqrt$3(x01 * x01 + y01 * y01),
        ox = lo * y01,
        oy = -lo * x01,
        x11 = x0 + ox,
        y11 = y0 + oy,
        x10 = x1 + ox,
        y10 = y1 + oy,
        x00 = (x11 + x10) / 2,
        y00 = (y11 + y10) / 2,
        dx = x10 - x11,
        dy = y10 - y11,
        d2 = dx * dx + dy * dy,
        r = r1 - rc,
        D = x11 * y10 - x10 * y11,
        d = (dy < 0 ? -1 : 1) * sqrt$3(max$1(0, r * r * d2 - D * D)),
        cx0 = (D * dy - dx * d) / d2,
        cy0 = (-D * dx - dy * d) / d2,
        cx1 = (D * dy + dx * d) / d2,
        cy1 = (-D * dx + dy * d) / d2,
        dx0 = cx0 - x00,
        dy0 = cy0 - y00,
        dx1 = cx1 - x00,
        dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?

    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
      cx: cx0,
      cy: cy0,
      x01: -ox,
      y01: -oy,
      x11: cx0 * (r1 / r - 1),
      y11: cy0 * (r1 / r - 1)
    };
  }

  function arc$2$1 () {
    var innerRadius = arcInnerRadius,
        outerRadius = arcOuterRadius,
        cornerRadius = constant$3(0),
        padRadius = null,
        startAngle = arcStartAngle,
        endAngle = arcEndAngle,
        padAngle = arcPadAngle,
        context = null;

    function arc() {
      var buffer,
          r,
          r0 = +innerRadius.apply(this, arguments),
          r1 = +outerRadius.apply(this, arguments),
          a0 = startAngle.apply(this, arguments) - halfPi$2,
          a1 = endAngle.apply(this, arguments) - halfPi$2,
          da = abs$2(a1 - a0),
          cw = a1 > a0;
      if (!context) context = buffer = path$3(); // Ensure that the outer radius is always larger than the inner radius.

      if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?

      if (!(r1 > epsilon$3)) context.moveTo(0, 0); // Or is it a circle or annulus?
      else if (da > tau$2 - epsilon$3) {
          context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
          context.arc(0, 0, r1, a0, a1, !cw);

          if (r0 > epsilon$3) {
            context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
            context.arc(0, 0, r0, a1, a0, cw);
          }
        } // Or is it a circular or annular sector?
        else {
            var a01 = a0,
                a11 = a1,
                a00 = a0,
                a10 = a1,
                da0 = da,
                da1 = da,
                ap = padAngle.apply(this, arguments) / 2,
                rp = ap > epsilon$3 && (padRadius ? +padRadius.apply(this, arguments) : sqrt$3(r0 * r0 + r1 * r1)),
                rc = min$1(abs$2(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
                rc0 = rc,
                rc1 = rc,
                t0,
                t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.

            if (rp > epsilon$3) {
              var p0 = asin$2(rp / r0 * sin$2(ap)),
                  p1 = asin$2(rp / r1 * sin$2(ap));
              if ((da0 -= p0 * 2) > epsilon$3) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;else da0 = 0, a00 = a10 = (a0 + a1) / 2;
              if ((da1 -= p1 * 2) > epsilon$3) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }

            var x01 = r1 * cos$2(a01),
                y01 = r1 * sin$2(a01),
                x10 = r0 * cos$2(a10),
                y10 = r0 * sin$2(a10); // Apply rounded corners?

            if (rc > epsilon$3) {
              var x11 = r1 * cos$2(a11),
                  y11 = r1 * sin$2(a11),
                  x00 = r0 * cos$2(a00),
                  y00 = r0 * sin$2(a00),
                  oc; // Restrict the corner radius according to the sector angle.

              if (da < pi$2 && (oc = intersect$3(x01, y01, x00, y00, x11, y11, x10, y10))) {
                var ax = x01 - oc[0],
                    ay = y01 - oc[1],
                    bx = x11 - oc[0],
                    by = y11 - oc[1],
                    kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$3(ax * ax + ay * ay) * sqrt$3(bx * bx + by * by))) / 2),
                    lc = sqrt$3(oc[0] * oc[0] + oc[1] * oc[1]);
                rc0 = min$1(rc, (r0 - lc) / (kc - 1));
                rc1 = min$1(rc, (r1 - lc) / (kc + 1));
              }
            } // Is the sector collapsed to a line?


            if (!(da1 > epsilon$3)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > epsilon$3) {
                t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?

                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
                  }
              } // Or is the outer ring just a circular arc?
              else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?

            if (!(r0 > epsilon$3) || !(da0 > epsilon$3)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > epsilon$3) {
                t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?

                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
                  }
              } // Or is the inner ring just a circular arc?
              else context.arc(0, 0, r0, a10, a00, cw);
          }
      context.closePath();
      if (buffer) return context = null, buffer + "" || null;
    }

    arc.centroid = function () {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
          a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$2 / 2;
      return [cos$2(a) * r, sin$2(a) * r];
    };

    arc.innerRadius = function (_) {
      return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : innerRadius;
    };

    arc.outerRadius = function (_) {
      return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : outerRadius;
    };

    arc.cornerRadius = function (_) {
      return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : cornerRadius;
    };

    arc.padRadius = function (_) {
      return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), arc) : padRadius;
    };

    arc.startAngle = function (_) {
      return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : startAngle;
    };

    arc.endAngle = function (_) {
      return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : endAngle;
    };

    arc.padAngle = function (_) {
      return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : padAngle;
    };

    arc.context = function (_) {
      return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };

    return arc;
  }

  function array$4 (x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
  }

  function Linear$1(context) {
    this._context = context;
  }

  Linear$1.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._point = 0;
    },
    lineEnd: function () {
      if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
          break;

        case 1:
          this._point = 2;
        // proceed

        default:
          this._context.lineTo(x, y);

          break;
      }
    }
  };
  function curveLinear (context) {
    return new Linear$1(context);
  }

  function x$3(p) {
    return p[0];
  }
  function y$3(p) {
    return p[1];
  }

  function line$2$1 (x, y) {
    var defined = constant$3(true),
        context = null,
        curve = curveLinear,
        output = null;
    x = typeof x === "function" ? x : x === undefined ? x$3 : constant$3(x);
    y = typeof y === "function" ? y : y === undefined ? y$3 : constant$3(y);

    function line(data) {
      var i,
          n = (data = array$4(data)).length,
          d,
          defined0 = false,
          buffer;
      if (context == null) output = curve(buffer = path$3());

      for (i = 0; i <= n; ++i) {
        if (!(i < n && defined(d = data[i], i, data)) === defined0) {
          if (defined0 = !defined0) output.lineStart();else output.lineEnd();
        }

        if (defined0) output.point(+x(d, i, data), +y(d, i, data));
      }

      if (buffer) return output = null, buffer + "" || null;
    }

    line.x = function (_) {
      return arguments.length ? (x = typeof _ === "function" ? _ : constant$3(+_), line) : x;
    };

    line.y = function (_) {
      return arguments.length ? (y = typeof _ === "function" ? _ : constant$3(+_), line) : y;
    };

    line.defined = function (_) {
      return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), line) : defined;
    };

    line.curve = function (_) {
      return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };

    line.context = function (_) {
      return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };

    return line;
  }

  function area$2$1 (x0, y0, y1) {
    var x1 = null,
        defined = constant$3(true),
        context = null,
        curve = curveLinear,
        output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? x$3 : constant$3(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? constant$3(0) : constant$3(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? y$3 : constant$3(+y1);

    function area(data) {
      var i,
          j,
          k,
          n = (data = array$4(data)).length,
          d,
          defined0 = false,
          buffer,
          x0z = new Array(n),
          y0z = new Array(n);
      if (context == null) output = curve(buffer = path$3());

      for (i = 0; i <= n; ++i) {
        if (!(i < n && defined(d = data[i], i, data)) === defined0) {
          if (defined0 = !defined0) {
            j = i;
            output.areaStart();
            output.lineStart();
          } else {
            output.lineEnd();
            output.lineStart();

            for (k = i - 1; k >= j; --k) {
              output.point(x0z[k], y0z[k]);
            }

            output.lineEnd();
            output.areaEnd();
          }
        }

        if (defined0) {
          x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
          output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
        }
      }

      if (buffer) return output = null, buffer + "" || null;
    }

    function arealine() {
      return line$2$1().defined(defined).curve(curve).context(context);
    }

    area.x = function (_) {
      return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), x1 = null, area) : x0;
    };

    area.x0 = function (_) {
      return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), area) : x0;
    };

    area.x1 = function (_) {
      return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : x1;
    };

    area.y = function (_) {
      return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), y1 = null, area) : y0;
    };

    area.y0 = function (_) {
      return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), area) : y0;
    };

    area.y1 = function (_) {
      return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : y1;
    };

    area.lineX0 = area.lineY0 = function () {
      return arealine().x(x0).y(y0);
    };

    area.lineY1 = function () {
      return arealine().x(x0).y(y1);
    };

    area.lineX1 = function () {
      return arealine().x(x1).y(y0);
    };

    area.defined = function (_) {
      return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), area) : defined;
    };

    area.curve = function (_) {
      return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };

    area.context = function (_) {
      return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };

    return area;
  }

  var circle$1 = {
    draw: function (context, size) {
      var r = Math.sqrt(size / pi$2);
      context.moveTo(r, 0);
      context.arc(0, 0, r, 0, tau$2);
    }
  };

  function symbol$2 (type, size) {
    var context = null;
    type = typeof type === "function" ? type : constant$3(type || circle$1);
    size = typeof size === "function" ? size : constant$3(size === undefined ? 64 : +size);

    function symbol() {
      var buffer;
      if (!context) context = buffer = path$3();
      type.apply(this, arguments).draw(context, +size.apply(this, arguments));
      if (buffer) return context = null, buffer + "" || null;
    }

    symbol.type = function (_) {
      return arguments.length ? (type = typeof _ === "function" ? _ : constant$3(_), symbol) : type;
    };

    symbol.size = function (_) {
      return arguments.length ? (size = typeof _ === "function" ? _ : constant$3(+_), symbol) : size;
    };

    symbol.context = function (_) {
      return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };

    return symbol;
  }

  function noop$3 () {}

  function point$5(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
  }
  function Basis(context) {
    this._context = context;
  }
  Basis.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      switch (this._point) {
        case 3:
          point$5(this, this._x1, this._y1);
        // proceed

        case 2:
          this._context.lineTo(this._x1, this._y1);

          break;
      }

      if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;

          this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

        // proceed

        default:
          point$5(this, x, y);
          break;
      }

      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
    }
  };
  function curveBasis (context) {
    return new Basis(context);
  }

  function BasisClosed(context) {
    this._context = context;
  }

  BasisClosed.prototype = {
    areaStart: noop$3,
    areaEnd: noop$3,
    lineStart: function () {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      switch (this._point) {
        case 1:
          {
            this._context.moveTo(this._x2, this._y2);

            this._context.closePath();

            break;
          }

        case 2:
          {
            this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);

            this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);

            this._context.closePath();

            break;
          }

        case 3:
          {
            this.point(this._x2, this._y2);
            this.point(this._x3, this._y3);
            this.point(this._x4, this._y4);
            break;
          }
      }
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          this._x2 = x, this._y2 = y;
          break;

        case 1:
          this._point = 2;
          this._x3 = x, this._y3 = y;
          break;

        case 2:
          this._point = 3;
          this._x4 = x, this._y4 = y;

          this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);

          break;

        default:
          point$5(this, x, y);
          break;
      }

      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
    }
  };
  function curveBasisClosed (context) {
    return new BasisClosed(context);
  }

  function BasisOpen(context) {
    this._context = context;
  }

  BasisOpen.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;
          var x0 = (this._x0 + 4 * this._x1 + x) / 6,
              y0 = (this._y0 + 4 * this._y1 + y) / 6;
          this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
          break;

        case 3:
          this._point = 4;
        // proceed

        default:
          point$5(this, x, y);
          break;
      }

      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
    }
  };
  function curveBasisOpen (context) {
    return new BasisOpen(context);
  }

  function Bundle(context, beta) {
    this._basis = new Basis(context);
    this._beta = beta;
  }

  Bundle.prototype = {
    lineStart: function () {
      this._x = [];
      this._y = [];

      this._basis.lineStart();
    },
    lineEnd: function () {
      var x = this._x,
          y = this._y,
          j = x.length - 1;

      if (j > 0) {
        var x0 = x[0],
            y0 = y[0],
            dx = x[j] - x0,
            dy = y[j] - y0,
            i = -1,
            t;

        while (++i <= j) {
          t = i / j;

          this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
        }
      }

      this._x = this._y = null;

      this._basis.lineEnd();
    },
    point: function (x, y) {
      this._x.push(+x);

      this._y.push(+y);
    }
  };
  var curveBundle = (function custom(beta) {
    function bundle(context) {
      return beta === 1 ? new Basis(context) : new Bundle(context, beta);
    }

    bundle.beta = function (beta) {
      return custom(+beta);
    };

    return bundle;
  })(0.85);

  function point$4(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
  }
  function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
  }
  Cardinal.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x2, this._y2);

          break;

        case 3:
          point$4(this, this._x1, this._y1);
          break;
      }

      if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
          break;

        case 1:
          this._point = 2;
          this._x1 = x, this._y1 = y;
          break;

        case 2:
          this._point = 3;
        // proceed

        default:
          point$4(this, x, y);
          break;
      }

      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  var curveCardinal = (function custom(tension) {
    function cardinal(context) {
      return new Cardinal(context, tension);
    }

    cardinal.tension = function (tension) {
      return custom(+tension);
    };

    return cardinal;
  })(0);

  function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
  }
  CardinalClosed.prototype = {
    areaStart: noop$3,
    areaEnd: noop$3,
    lineStart: function () {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      switch (this._point) {
        case 1:
          {
            this._context.moveTo(this._x3, this._y3);

            this._context.closePath();

            break;
          }

        case 2:
          {
            this._context.lineTo(this._x3, this._y3);

            this._context.closePath();

            break;
          }

        case 3:
          {
            this.point(this._x3, this._y3);
            this.point(this._x4, this._y4);
            this.point(this._x5, this._y5);
            break;
          }
      }
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          this._x3 = x, this._y3 = y;
          break;

        case 1:
          this._point = 2;

          this._context.moveTo(this._x4 = x, this._y4 = y);

          break;

        case 2:
          this._point = 3;
          this._x5 = x, this._y5 = y;
          break;

        default:
          point$4(this, x, y);
          break;
      }

      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  var curveCardinalClosed = (function custom(tension) {
    function cardinal(context) {
      return new CardinalClosed(context, tension);
    }

    cardinal.tension = function (tension) {
      return custom(+tension);
    };

    return cardinal;
  })(0);

  function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
  }
  CardinalOpen.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;
          this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
          break;

        case 3:
          this._point = 4;
        // proceed

        default:
          point$4(this, x, y);
          break;
      }

      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  var curveCardinalOpen = (function custom(tension) {
    function cardinal(context) {
      return new CardinalOpen(context, tension);
    }

    cardinal.tension = function (tension) {
      return custom(+tension);
    };

    return cardinal;
  })(0);

  function point$3(that, x, y) {
    var x1 = that._x1,
        y1 = that._y1,
        x2 = that._x2,
        y2 = that._y2;

    if (that._l01_a > epsilon$3) {
      var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
          n = 3 * that._l01_a * (that._l01_a + that._l12_a);
      x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
      y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }

    if (that._l23_a > epsilon$3) {
      var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
          m = 3 * that._l23_a * (that._l23_a + that._l12_a);
      x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
      y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }

    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
  }

  function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
  }

  CatmullRom.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
      this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function () {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x2, this._y2);

          break;

        case 3:
          this.point(this._x2, this._y2);
          break;
      }

      if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      if (this._point) {
        var x23 = this._x2 - x,
            y23 = this._y2 - y;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
      }

      switch (this._point) {
        case 0:
          this._point = 1;
          this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;
        // proceed

        default:
          point$3(this, x, y);
          break;
      }

      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  var curveCatmullRom = (function custom(alpha) {
    function catmullRom(context) {
      return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
    }

    catmullRom.alpha = function (alpha) {
      return custom(+alpha);
    };

    return catmullRom;
  })(0.5);

  function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
  }

  CatmullRomClosed.prototype = {
    areaStart: noop$3,
    areaEnd: noop$3,
    lineStart: function () {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
      this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function () {
      switch (this._point) {
        case 1:
          {
            this._context.moveTo(this._x3, this._y3);

            this._context.closePath();

            break;
          }

        case 2:
          {
            this._context.lineTo(this._x3, this._y3);

            this._context.closePath();

            break;
          }

        case 3:
          {
            this.point(this._x3, this._y3);
            this.point(this._x4, this._y4);
            this.point(this._x5, this._y5);
            break;
          }
      }
    },
    point: function (x, y) {
      x = +x, y = +y;

      if (this._point) {
        var x23 = this._x2 - x,
            y23 = this._y2 - y;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
      }

      switch (this._point) {
        case 0:
          this._point = 1;
          this._x3 = x, this._y3 = y;
          break;

        case 1:
          this._point = 2;

          this._context.moveTo(this._x4 = x, this._y4 = y);

          break;

        case 2:
          this._point = 3;
          this._x5 = x, this._y5 = y;
          break;

        default:
          point$3(this, x, y);
          break;
      }

      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  var curveCatmullRomClosed = (function custom(alpha) {
    function catmullRom(context) {
      return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
    }

    catmullRom.alpha = function (alpha) {
      return custom(+alpha);
    };

    return catmullRom;
  })(0.5);

  function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
  }

  CatmullRomOpen.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
      this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function () {
      if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      if (this._point) {
        var x23 = this._x2 - x,
            y23 = this._y2 - y;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
      }

      switch (this._point) {
        case 0:
          this._point = 1;
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;
          this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
          break;

        case 3:
          this._point = 4;
        // proceed

        default:
          point$3(this, x, y);
          break;
      }

      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  var curveCatmullRomOpen = (function custom(alpha) {
    function catmullRom(context) {
      return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
    }

    catmullRom.alpha = function (alpha) {
      return custom(+alpha);
    };

    return catmullRom;
  })(0.5);

  function LinearClosed(context) {
    this._context = context;
  }

  LinearClosed.prototype = {
    areaStart: noop$3,
    areaEnd: noop$3,
    lineStart: function () {
      this._point = 0;
    },
    lineEnd: function () {
      if (this._point) this._context.closePath();
    },
    point: function (x, y) {
      x = +x, y = +y;
      if (this._point) this._context.lineTo(x, y);else this._point = 1, this._context.moveTo(x, y);
    }
  };
  function curveLinearClosed (context) {
    return new LinearClosed(context);
  }

  function sign$1(x) {
    return x < 0 ? -1 : 1;
  } // Calculate the slopes of the tangents (Hermite-type interpolation) based on
  // the following paper: Steffen, M. 1990. A Simple Method for Monotonic
  // Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
  // NOV(II), P. 443, 1990.


  function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0,
        h1 = x2 - that._x1,
        s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
        s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
        p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
  } // Calculate a one-sided slope.


  function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
  } // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
  // "you can express cubic Hermite interpolation in terms of cubic Bézier curves
  // with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".


  function point$2(that, t0, t1) {
    var x0 = that._x0,
        y0 = that._y0,
        x1 = that._x1,
        y1 = that._y1,
        dx = (x1 - x0) / 3;

    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
  }

  function MonotoneX(context) {
    this._context = context;
  }

  MonotoneX.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x1, this._y1);

          break;

        case 3:
          point$2(this, this._t0, slope2(this, this._t0));
          break;
      }

      if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function (x, y) {
      var t1 = NaN;
      x = +x, y = +y;
      if (x === this._x1 && y === this._y1) return; // Ignore coincident points.

      switch (this._point) {
        case 0:
          this._point = 1;
          this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;
          point$2(this, slope2(this, t1 = slope3(this, x, y)), t1);
          break;

        default:
          point$2(this, this._t0, t1 = slope3(this, x, y));
          break;
      }

      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
      this._t0 = t1;
    }
  };

  function MonotoneY(context) {
    this._context = new ReflectContext(context);
  }

  (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (x, y) {
    MonotoneX.prototype.point.call(this, y, x);
  };

  function ReflectContext(context) {
    this._context = context;
  }

  ReflectContext.prototype = {
    moveTo: function (x, y) {
      this._context.moveTo(y, x);
    },
    closePath: function () {
      this._context.closePath();
    },
    lineTo: function (x, y) {
      this._context.lineTo(y, x);
    },
    bezierCurveTo: function (x1, y1, x2, y2, x, y) {
      this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
  };
  function monotoneX(context) {
    return new MonotoneX(context);
  }
  function monotoneY(context) {
    return new MonotoneY(context);
  }

  function Natural(context) {
    this._context = context;
  }

  Natural.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x = [];
      this._y = [];
    },
    lineEnd: function () {
      var x = this._x,
          y = this._y,
          n = x.length;

      if (n) {
        this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);

        if (n === 2) {
          this._context.lineTo(x[1], y[1]);
        } else {
          var px = controlPoints(x),
              py = controlPoints(y);

          for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
            this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
          }
        }
      }

      if (this._line || this._line !== 0 && n === 1) this._context.closePath();
      this._line = 1 - this._line;
      this._x = this._y = null;
    },
    point: function (x, y) {
      this._x.push(+x);

      this._y.push(+y);
    }
  }; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.

  function controlPoints(x) {
    var i,
        n = x.length - 1,
        m,
        a = new Array(n),
        b = new Array(n),
        r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];

    for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];

    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];

    for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];

    a[n - 1] = r[n - 1] / b[n - 1];

    for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];

    b[n - 1] = (x[n] + a[n - 1]) / 2;

    for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];

    return [a, b];
  }

  function curveNatural (context) {
    return new Natural(context);
  }

  function Step(context, t) {
    this._context = context;
    this._t = t;
  }

  Step.prototype = {
    areaStart: function () {
      this._line = 0;
    },
    areaEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._x = this._y = NaN;
      this._point = 0;
    },
    lineEnd: function () {
      if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
      if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
      if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function (x, y) {
      x = +x, y = +y;

      switch (this._point) {
        case 0:
          this._point = 1;
          this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
          break;

        case 1:
          this._point = 2;
        // proceed

        default:
          {
            if (this._t <= 0) {
              this._context.lineTo(this._x, y);

              this._context.lineTo(x, y);
            } else {
              var x1 = this._x * (1 - this._t) + x * this._t;

              this._context.lineTo(x1, this._y);

              this._context.lineTo(x1, y);
            }

            break;
          }
      }

      this._x = x, this._y = y;
    }
  };
  function curveStep (context) {
    return new Step(context, 0.5);
  }
  function stepBefore(context) {
    return new Step(context, 0);
  }
  function stepAfter(context) {
    return new Step(context, 1);
  }

  function domCanvas(w, h) {
    if (typeof document !== 'undefined' && document.createElement) {
      const c = document.createElement('canvas');

      if (c && c.getContext) {
        c.width = w;
        c.height = h;
        return c;
      }
    }

    return null;
  }

  const domImage = () => typeof Image !== 'undefined' ? Image : null;

  let NodeCanvas;

  try {
    // Allow projects to provide a reference to node-canvas directly via global.canvas
    if (global.canvas) NodeCanvas = global.canvas;else NodeCanvas = require('canvas');

    if (!(NodeCanvas && NodeCanvas.createCanvas)) {
      NodeCanvas = null;
    }
  } catch (error) {// do nothing
  }

  function nodeCanvas(w, h, type) {
    if (NodeCanvas) {
      try {
        return new NodeCanvas.Canvas(w, h, type); // bug: dankrusi: when rendering to SVG the type is is really important. this applies also to font measuring
      } catch (e) {// do nothing, return null on error
      }
    }

    return null;
  }

  const nodeImage = () => NodeCanvas && NodeCanvas.Image || null; //dankrusi: bmpi needs a universal package that can run both on node and browser, thus the vega-canvas index.browser.js is copied over from index.js


  function canvas(w, h, type) {
    var ret = domCanvas(w, h) || nodeCanvas(w, h, type) || null;
    if (ret != null) return ret;else throw "Could not get a canvas to draw onto. Are you on NodeJS? If so make sure the 'canvas' package is installed and accessible (npm install canvas)!";
  }

  function image$1() {
    var ret = domImage() || nodeImage() || null;
    if (ret != null) return ret;else throw "Could not get a image to draw onto. Are you on NodeJS? If so make sure the 'canvas' package is installed and accessible (npm install canvas)!";
  }

  function initRange(domain, range) {
    switch (arguments.length) {
      case 0:
        break;

      case 1:
        this.range(domain);
        break;

      default:
        this.range(range).domain(domain);
        break;
    }

    return this;
  }
  function initInterpolator(domain, interpolator) {
    switch (arguments.length) {
      case 0:
        break;

      case 1:
        {
          if (typeof domain === "function") this.interpolator(domain);else this.range(domain);
          break;
        }

      default:
        {
          this.domain(domain);
          if (typeof interpolator === "function") this.interpolator(interpolator);else this.range(interpolator);
          break;
        }
    }

    return this;
  }

  const implicit = Symbol("implicit");
  function ordinal() {
    var index = new Map(),
        domain = [],
        range = [],
        unknown = implicit;

    function scale(d) {
      var key = d + "",
          i = index.get(key);

      if (!i) {
        if (unknown !== implicit) return unknown;
        index.set(key, i = domain.push(d));
      }

      return range[(i - 1) % range.length];
    }

    scale.domain = function (_) {
      if (!arguments.length) return domain.slice();
      domain = [], index = new Map();

      for (const value of _) {
        const key = value + "";
        if (index.has(key)) continue;
        index.set(key, domain.push(value));
      }

      return scale;
    };

    scale.range = function (_) {
      return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : unknown;
    };

    scale.copy = function () {
      return ordinal(domain, range).unknown(unknown);
    };

    initRange.apply(scale, arguments);
    return scale;
  }

  function define (constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
  }
  function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);

    for (var key in definition) prototype[key] = definition[key];

    return prototype;
  }

  function Color() {}
  var darker = 0.7;
  var brighter = 1 / darker;
  var reI = "\\s*([+-]?\\d+)\\s*",
      reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
      reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
      reHex = /^#([0-9a-f]{3,8})$/,
      reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
      reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
      reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
      reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
      reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
      reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
  var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
  };
  define(Color, color$2, {
    copy: function (channels) {
      return Object.assign(new this.constructor(), this, channels);
    },
    displayable: function () {
      return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
  });

  function color_formatHex() {
    return this.rgb().formatHex();
  }

  function color_formatHsl() {
    return hslConvert(this).formatHsl();
  }

  function color_formatRgb() {
    return this.rgb().formatRgb();
  }

  function color$2(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
    : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
    : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
    : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
    : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
    : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
    : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
    : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
    : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
    : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
    : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
    : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
  }

  function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
  }

  function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
  }

  function rgbConvert(o) {
    if (!(o instanceof Color)) o = color$2(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
  }
  function rgb$1(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
  }
  function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
  }
  define(Rgb, rgb$1, extend(Color, {
    brighter: function (k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function (k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function () {
      return this;
    },
    displayable: function () {
      return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
  }));

  function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
  }

  function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
  }

  function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
  }

  function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
  }

  function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color$2(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        min = Math.min(r, g, b),
        max = Math.max(r, g, b),
        h = NaN,
        s = max - min,
        l = (max + min) / 2;

    if (s) {
      if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
      s /= l < 0.5 ? max + min : 2 - max - min;
      h *= 60;
    } else {
      s = l > 0 && l < 1 ? 0 : h;
    }

    return new Hsl(h, s, l, o.opacity);
  }
  function hsl$2(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
  }

  function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }

  define(Hsl, hsl$2, extend(Color, {
    brighter: function (k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function (k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function () {
      var h = this.h % 360 + (this.h < 0) * 360,
          s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
          l = this.l,
          m2 = l + (l < 0.5 ? l : 1 - l) * s,
          m1 = 2 * l - m2;
      return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function () {
      return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function () {
      var a = this.opacity;
      a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
      return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
  }));
  /* From FvD 13.37, CSS Color Module Level 3 */

  function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
  }

  const radians$1 = Math.PI / 180;
  const degrees$2 = 180 / Math.PI;

  const K = 18,
        Xn = 0.96422,
        Yn = 1,
        Zn = 0.82521,
        t0 = 4 / 29,
        t1 = 6 / 29,
        t2 = 3 * t1 * t1,
        t3 = t1 * t1 * t1;

  function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof Rgb)) o = rgbConvert(o);
    var r = rgb2lrgb(o.r),
        g = rgb2lrgb(o.g),
        b = rgb2lrgb(o.b),
        y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
        x,
        z;
    if (r === g && g === b) x = z = y;else {
      x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
      z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
  }
  function lab$1(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
  }
  function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
  }
  define(Lab, lab$1, extend(Color, {
    brighter: function (k) {
      return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function (k) {
      return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function () {
      var y = (this.l + 16) / 116,
          x = isNaN(this.a) ? y : y + this.a / 500,
          z = isNaN(this.b) ? y : y - this.b / 200;
      x = Xn * lab2xyz(x);
      y = Yn * lab2xyz(y);
      z = Zn * lab2xyz(z);
      return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
  }));

  function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
  }

  function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
  }

  function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
  }

  function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  }

  function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * degrees$2;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
  }
  function hcl$2(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
  }
  function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
  }

  function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * radians$1;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }

  define(Hcl, hcl$2, extend(Color, {
    brighter: function (k) {
      return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker: function (k) {
      return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function () {
      return hcl2lab(this).rgb();
    }
  }));

  var A = -0.14861,
      B = +1.78277,
      C$1 = -0.29227,
      D = -0.90649,
      E = +1.97294,
      ED = E * D,
      EB = E * B,
      BC_DA = B * C$1 - D * A;

  function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Rgb)) o = rgbConvert(o);
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
        bl = b - l,
        k = (E * (g - l) - C$1 * bl) / D,
        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
        // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
  }

  function cubehelix$2(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
  }
  function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }
  define(Cubehelix, cubehelix$2, extend(Color, {
    brighter: function (k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function (k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function () {
      var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1,
          l = +this.l,
          a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
          cosh = Math.cos(h),
          sinh = Math.sin(h);
      return new Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C$1 * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
  }));

  function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1,
        t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
  }
  function basis$1 (values) {
    var n = values.length - 1;
    return function (t) {
      var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
          v1 = values[i],
          v2 = values[i + 1],
          v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
          v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
      return basis((t - i / n) * n, v0, v1, v2, v3);
    };
  }

  function basisClosed (values) {
    var n = values.length;
    return function (t) {
      var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
          v0 = values[(i + n - 1) % n],
          v1 = values[i % n],
          v2 = values[(i + 1) % n],
          v3 = values[(i + 2) % n];
      return basis((t - i / n) * n, v0, v1, v2, v3);
    };
  }

  var constant$2 = (x => () => x);

  function linear$1(a, d) {
    return function (t) {
      return a + t * d;
    };
  }

  function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
      return Math.pow(a + t * b, y);
    };
  }

  function hue$1(a, b) {
    var d = b - a;
    return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$2(isNaN(a) ? b : a);
  }
  function gamma(y) {
    return (y = +y) === 1 ? nogamma : function (a, b) {
      return b - a ? exponential(a, b, y) : constant$2(isNaN(a) ? b : a);
    };
  }
  function nogamma(a, b) {
    var d = b - a;
    return d ? linear$1(a, d) : constant$2(isNaN(a) ? b : a);
  }

  var rgb = (function rgbGamma(y) {
    var color = gamma(y);

    function rgb(start, end) {
      var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
          g = color(start.g, end.g),
          b = color(start.b, end.b),
          opacity = nogamma(start.opacity, end.opacity);
      return function (t) {
        start.r = r(t);
        start.g = g(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
      };
    }

    rgb.gamma = rgbGamma;
    return rgb;
  })(1);

  function rgbSpline(spline) {
    return function (colors) {
      var n = colors.length,
          r = new Array(n),
          g = new Array(n),
          b = new Array(n),
          i,
          color;

      for (i = 0; i < n; ++i) {
        color = rgb$1(colors[i]);
        r[i] = color.r || 0;
        g[i] = color.g || 0;
        b[i] = color.b || 0;
      }

      r = spline(r);
      g = spline(g);
      b = spline(b);
      color.opacity = 1;
      return function (t) {
        color.r = r(t);
        color.g = g(t);
        color.b = b(t);
        return color + "";
      };
    };
  }

  var rgbBasis = rgbSpline(basis$1);
  var rgbBasisClosed = rgbSpline(basisClosed);

  function numberArray (a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0,
        c = b.slice(),
        i;
    return function (t) {
      for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;

      return c;
    };
  }
  function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
  }

  function array$3 (a, b) {
    return (isNumberArray(b) ? numberArray : genericArray)(a, b);
  }
  function genericArray(a, b) {
    var nb = b ? b.length : 0,
        na = a ? Math.min(nb, a.length) : 0,
        x = new Array(na),
        c = new Array(nb),
        i;

    for (i = 0; i < na; ++i) x[i] = interpolate$1(a[i], b[i]);

    for (; i < nb; ++i) c[i] = b[i];

    return function (t) {
      for (i = 0; i < na; ++i) c[i] = x[i](t);

      return c;
    };
  }

  function date$1 (a, b) {
    var d = new Date();
    return a = +a, b = +b, function (t) {
      return d.setTime(a * (1 - t) + b * t), d;
    };
  }

  function interpolateNumber (a, b) {
    return a = +a, b = +b, function (t) {
      return a * (1 - t) + b * t;
    };
  }

  function object (a, b) {
    var i = {},
        c = {},
        k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};

    for (k in b) {
      if (k in a) {
        i[k] = interpolate$1(a[k], b[k]);
      } else {
        c[k] = b[k];
      }
    }

    return function (t) {
      for (k in i) c[k] = i[k](t);

      return c;
    };
  }

  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
      reB = new RegExp(reA.source, "g");

  function zero$1(b) {
    return function () {
      return b;
    };
  }

  function one$1(b) {
    return function (t) {
      return b(t) + "";
    };
  }

  function string (a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0,
        // scan index for next number in b
    am,
        // current match in a
    bm,
        // current match in b
    bs,
        // string preceding current number in b, if any
    i = -1,
        // index in s
    s = [],
        // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.

    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.

    while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
      if ((bs = bm.index) > bi) {
        // a string precedes the next number in b
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
      }

      if ((am = am[0]) === (bm = bm[0])) {
        // numbers in a & b match
        if (s[i]) s[i] += bm; // coalesce with previous string
        else s[++i] = bm;
      } else {
        // interpolate non-matching numbers
        s[++i] = null;
        q.push({
          i: i,
          x: interpolateNumber(am, bm)
        });
      }

      bi = reB.lastIndex;
    } // Add remains of b.


    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.


    return s.length < 2 ? q[0] ? one$1(q[0].x) : zero$1(b) : (b = q.length, function (t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);

      return s.join("");
    });
  }

  function interpolate$1 (a, b) {
    var t = typeof b,
        c;
    return b == null || t === "boolean" ? constant$2(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color$2(b)) ? (b = c, rgb) : string : b instanceof color$2 ? rgb : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : interpolateNumber)(a, b);
  }

  function discrete$1 (range) {
    var n = range.length;
    return function (t) {
      return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
  }

  function hue (a, b) {
    var i = hue$1(+a, +b);
    return function (t) {
      var x = i(t);
      return x - 360 * Math.floor(x / 360);
    };
  }

  function interpolateRound (a, b) {
    return a = +a, b = +b, function (t) {
      return Math.round(a * (1 - t) + b * t);
    };
  }

  var degrees$1 = 180 / Math.PI;
  var identity$3 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
  };
  function decompose (a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
      translateX: e,
      translateY: f,
      rotate: Math.atan2(b, a) * degrees$1,
      skewX: Math.atan(skewX) * degrees$1,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var svgNode;
  /* eslint-disable no-undef */

  function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? identity$3 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
  }
  function parseSvg(value) {
    if (value == null) return identity$3;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return identity$3;
    value = value.matrix;
    return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
  }

  function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
      return s.length ? s.pop() + " " : "";
    }

    function translate(xa, ya, xb, yb, s, q) {
      if (xa !== xb || ya !== yb) {
        var i = s.push("translate(", null, pxComma, null, pxParen);
        q.push({
          i: i - 4,
          x: interpolateNumber(xa, xb)
        }, {
          i: i - 2,
          x: interpolateNumber(ya, yb)
        });
      } else if (xb || yb) {
        s.push("translate(" + xb + pxComma + yb + pxParen);
      }
    }

    function rotate(a, b, s, q) {
      if (a !== b) {
        if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path

        q.push({
          i: s.push(pop(s) + "rotate(", null, degParen) - 2,
          x: interpolateNumber(a, b)
        });
      } else if (b) {
        s.push(pop(s) + "rotate(" + b + degParen);
      }
    }

    function skewX(a, b, s, q) {
      if (a !== b) {
        q.push({
          i: s.push(pop(s) + "skewX(", null, degParen) - 2,
          x: interpolateNumber(a, b)
        });
      } else if (b) {
        s.push(pop(s) + "skewX(" + b + degParen);
      }
    }

    function scale(xa, ya, xb, yb, s, q) {
      if (xa !== xb || ya !== yb) {
        var i = s.push(pop(s) + "scale(", null, ",", null, ")");
        q.push({
          i: i - 4,
          x: interpolateNumber(xa, xb)
        }, {
          i: i - 2,
          x: interpolateNumber(ya, yb)
        });
      } else if (xb !== 1 || yb !== 1) {
        s.push(pop(s) + "scale(" + xb + "," + yb + ")");
      }
    }

    return function (a, b) {
      var s = [],
          // string constants and placeholders
      q = []; // number interpolators

      a = parse(a), b = parse(b);
      translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
      rotate(a.rotate, b.rotate, s, q);
      skewX(a.skewX, b.skewX, s, q);
      scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
      a = b = null; // gc

      return function (t) {
        var i = -1,
            n = q.length,
            o;

        while (++i < n) s[(o = q[i]).i] = o.x(t);

        return s.join("");
      };
    };
  }

  var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
  var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

  var epsilon2$1 = 1e-12;

  function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }

  function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }

  function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }

  var zoom = (function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
      var ux0 = p0[0],
          uy0 = p0[1],
          w0 = p0[2],
          ux1 = p1[0],
          uy1 = p1[1],
          w1 = p1[2],
          dx = ux1 - ux0,
          dy = uy1 - uy0,
          d2 = dx * dx + dy * dy,
          i,
          S; // Special case for u0 ≅ u1.

      if (d2 < epsilon2$1) {
        S = Math.log(w1 / w0) / rho;

        i = function (t) {
          return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
        };
      } // General case.
      else {
          var d1 = Math.sqrt(d2),
              b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
              b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
              r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
              r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
          S = (r1 - r0) / rho;

          i = function (t) {
            var s = t * S,
                coshr0 = cosh(r0),
                u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
            return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
          };
        }

      i.duration = S * 1000 * rho / Math.SQRT2;
      return i;
    }

    zoom.rho = function (_) {
      var _1 = Math.max(1e-3, +_),
          _2 = _1 * _1,
          _4 = _2 * _2;

      return zoomRho(_1, _2, _4);
    };

    return zoom;
  })(Math.SQRT2, 2, 4);

  function hsl(hue) {
    return function (start, end) {
      var h = hue((start = hsl$2(start)).h, (end = hsl$2(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(t);
        start.opacity = opacity(t);
        return start + "";
      };
    };
  }

  var hsl$1 = hsl(hue$1);
  var hslLong = hsl(nogamma);

  function lab(start, end) {
    var l = nogamma((start = lab$1(start)).l, (end = lab$1(end)).l),
        a = nogamma(start.a, end.a),
        b = nogamma(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function (t) {
      start.l = l(t);
      start.a = a(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  function hcl(hue) {
    return function (start, end) {
      var h = hue((start = hcl$2(start)).h, (end = hcl$2(end)).h),
          c = nogamma(start.c, end.c),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.c = c(t);
        start.l = l(t);
        start.opacity = opacity(t);
        return start + "";
      };
    };
  }

  var hcl$1 = hcl(hue$1);
  var hclLong = hcl(nogamma);

  function cubehelix(hue) {
    return function cubehelixGamma(y) {
      y = +y;

      function cubehelix(start, end) {
        var h = hue((start = cubehelix$2(start)).h, (end = cubehelix$2(end)).h),
            s = nogamma(start.s, end.s),
            l = nogamma(start.l, end.l),
            opacity = nogamma(start.opacity, end.opacity);
        return function (t) {
          start.h = h(t);
          start.s = s(t);
          start.l = l(Math.pow(t, y));
          start.opacity = opacity(t);
          return start + "";
        };
      }

      cubehelix.gamma = cubehelixGamma;
      return cubehelix;
    }(1);
  }

  var cubehelix$1 = cubehelix(hue$1);
  var cubehelixLong = cubehelix(nogamma);

  function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = interpolate$1;
    var i = 0,
        n = values.length - 1,
        v = values[0],
        I = new Array(n < 0 ? 0 : n);

    while (i < n) I[i] = interpolate(v, v = values[++i]);

    return function (t) {
      var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
      return I[i](t - i);
    };
  }

  function quantize$2 (interpolator, n) {
    var samples = new Array(n);

    for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));

    return samples;
  }

  var $$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    interpolate: interpolate$1,
    interpolateArray: array$3,
    interpolateBasis: basis$1,
    interpolateBasisClosed: basisClosed,
    interpolateDate: date$1,
    interpolateDiscrete: discrete$1,
    interpolateHue: hue,
    interpolateNumber: interpolateNumber,
    interpolateNumberArray: numberArray,
    interpolateObject: object,
    interpolateRound: interpolateRound,
    interpolateString: string,
    interpolateTransformCss: interpolateTransformCss,
    interpolateTransformSvg: interpolateTransformSvg,
    interpolateZoom: zoom,
    interpolateRgb: rgb,
    interpolateRgbBasis: rgbBasis,
    interpolateRgbBasisClosed: rgbBasisClosed,
    interpolateHsl: hsl$1,
    interpolateHslLong: hslLong,
    interpolateLab: lab,
    interpolateHcl: hcl$1,
    interpolateHclLong: hclLong,
    interpolateCubehelix: cubehelix$1,
    interpolateCubehelixLong: cubehelixLong,
    piecewise: piecewise,
    quantize: quantize$2
  });

  function constants(x) {
    return function () {
      return x;
    };
  }

  function number$5(x) {
    return +x;
  }

  var unit = [0, 1];
  function identity$2(x) {
    return x;
  }

  function normalize(a, b) {
    return (b -= a = +a) ? function (x) {
      return (x - a) / b;
    } : constants(isNaN(b) ? NaN : 0.5);
  }

  function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function (x) {
      return Math.max(a, Math.min(b, x));
    };
  } // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
  // interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].


  function bimap(domain, range, interpolate) {
    var d0 = domain[0],
        d1 = domain[1],
        r0 = range[0],
        r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function (x) {
      return r0(d0(x));
    };
  }

  function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1,
        d = new Array(j),
        r = new Array(j),
        i = -1; // Reverse descending domains.

    if (domain[j] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }

    while (++i < j) {
      d[i] = normalize(domain[i], domain[i + 1]);
      r[i] = interpolate(range[i], range[i + 1]);
    }

    return function (x) {
      var i = bisectRight$1(domain, x, 1, j) - 1;
      return r[i](d[i](x));
    };
  }

  function copy$2(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
  }
  function transformer$3() {
    var domain = unit,
        range = unit,
        interpolate = interpolate$1,
        transform,
        untransform,
        unknown,
        clamp = identity$2,
        piecewise,
        output,
        input;

    function rescale() {
      var n = Math.min(domain.length, range.length);
      if (clamp !== identity$2) clamp = clamper(domain[0], domain[n - 1]);
      piecewise = n > 2 ? polymap : bimap;
      output = input = null;
      return scale;
    }

    function scale(x) {
      return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }

    scale.invert = function (y) {
      return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
    };

    scale.domain = function (_) {
      return arguments.length ? (domain = Array.from(_, number$5), rescale()) : domain.slice();
    };

    scale.range = function (_) {
      return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };

    scale.rangeRound = function (_) {
      return range = Array.from(_), interpolate = interpolateRound, rescale();
    };

    scale.clamp = function (_) {
      return arguments.length ? (clamp = _ ? true : identity$2, rescale()) : clamp !== identity$2;
    };

    scale.interpolate = function (_) {
      return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : unknown;
    };

    return function (t, u) {
      transform = t, untransform = u;
      return rescale();
    };
  }
  function continuous$1() {
    return transformer$3()(identity$2, identity$2);
  }

  function tickFormat$1(start, stop, count, specifier) {
    var step = tickStep(start, stop, count),
        precision;
    specifier = formatSpecifier(specifier == null ? ",f" : specifier);

    switch (specifier.type) {
      case "s":
        {
          var value = Math.max(Math.abs(start), Math.abs(stop));
          if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
          return formatPrefix(specifier, value);
        }

      case "":
      case "e":
      case "g":
      case "p":
      case "r":
        {
          if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
          break;
        }

      case "f":
      case "%":
        {
          if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
          break;
        }
    }

    return format$3(specifier);
  }

  function linearish(scale) {
    var domain = scale.domain;

    scale.ticks = function (count) {
      var d = domain();
      return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
    };

    scale.tickFormat = function (count, specifier) {
      var d = domain();
      return tickFormat$1(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };

    scale.nice = function (count) {
      if (count == null) count = 10;
      var d = domain();
      var i0 = 0;
      var i1 = d.length - 1;
      var start = d[i0];
      var stop = d[i1];
      var prestep;
      var step;
      var maxIter = 10;

      if (stop < start) {
        step = start, start = stop, stop = step;
        step = i0, i0 = i1, i1 = step;
      }

      while (maxIter-- > 0) {
        step = tickIncrement(start, stop, count);

        if (step === prestep) {
          d[i0] = start;
          d[i1] = stop;
          return domain(d);
        } else if (step > 0) {
          start = Math.floor(start / step) * step;
          stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
          start = Math.ceil(start * step) / step;
          stop = Math.floor(stop * step) / step;
        } else {
          break;
        }

        prestep = step;
      }

      return scale;
    };

    return scale;
  }
  function linear() {
    var scale = continuous$1();

    scale.copy = function () {
      return copy$2(scale, linear());
    };

    initRange.apply(scale, arguments);
    return linearish(scale);
  }

  function identity$1(domain) {
    var unknown;

    function scale(x) {
      return x == null || isNaN(x = +x) ? unknown : x;
    }

    scale.invert = scale;

    scale.domain = scale.range = function (_) {
      return arguments.length ? (domain = Array.from(_, number$5), scale) : domain.slice();
    };

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : unknown;
    };

    scale.copy = function () {
      return identity$1(domain).unknown(unknown);
    };

    domain = arguments.length ? Array.from(domain, number$5) : [0, 1];
    return linearish(scale);
  }

  function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0,
        i1 = domain.length - 1,
        x0 = domain[i0],
        x1 = domain[i1],
        t;

    if (x1 < x0) {
      t = i0, i0 = i1, i1 = t;
      t = x0, x0 = x1, x1 = t;
    }

    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
  }

  function transformLog(x) {
    return Math.log(x);
  }

  function transformExp(x) {
    return Math.exp(x);
  }

  function transformLogn(x) {
    return -Math.log(-x);
  }

  function transformExpn(x) {
    return -Math.exp(-x);
  }

  function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
  }

  function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : function (x) {
      return Math.pow(base, x);
    };
  }

  function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function (x) {
      return Math.log(x) / base;
    });
  }

  function reflect(f) {
    return function (x) {
      return -f(-x);
    };
  }

  function loggish(transform) {
    var scale = transform(transformLog, transformExp),
        domain = scale.domain,
        base = 10,
        logs,
        pows;

    function rescale() {
      logs = logp(base), pows = powp(base);

      if (domain()[0] < 0) {
        logs = reflect(logs), pows = reflect(pows);
        transform(transformLogn, transformExpn);
      } else {
        transform(transformLog, transformExp);
      }

      return scale;
    }

    scale.base = function (_) {
      return arguments.length ? (base = +_, rescale()) : base;
    };

    scale.domain = function (_) {
      return arguments.length ? (domain(_), rescale()) : domain();
    };

    scale.ticks = function (count) {
      var d = domain(),
          u = d[0],
          v = d[d.length - 1],
          r;
      if (r = v < u) i = u, u = v, v = i;
      var i = logs(u),
          j = logs(v),
          p,
          k,
          t,
          n = count == null ? 10 : +count,
          z = [];

      if (!(base % 1) && j - i < n) {
        i = Math.floor(i), j = Math.ceil(j);
        if (u > 0) for (; i <= j; ++i) {
          for (k = 1, p = pows(i); k < base; ++k) {
            t = p * k;
            if (t < u) continue;
            if (t > v) break;
            z.push(t);
          }
        } else for (; i <= j; ++i) {
          for (k = base - 1, p = pows(i); k >= 1; --k) {
            t = p * k;
            if (t < u) continue;
            if (t > v) break;
            z.push(t);
          }
        }
        if (z.length * 2 < n) z = ticks(u, v, n);
      } else {
        z = ticks(i, j, Math.min(j - i, n)).map(pows);
      }

      return r ? z.reverse() : z;
    };

    scale.tickFormat = function (count, specifier) {
      if (specifier == null) specifier = base === 10 ? ".0e" : ",";
      if (typeof specifier !== "function") specifier = format$3(specifier);
      if (count === Infinity) return specifier;
      if (count == null) count = 10;
      var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?

      return function (d) {
        var i = d / pows(Math.round(logs(d)));
        if (i * base < base - 0.5) i *= base;
        return i <= k ? specifier(d) : "";
      };
    };

    scale.nice = function () {
      return domain(nice(domain(), {
        floor: function (x) {
          return pows(Math.floor(logs(x)));
        },
        ceil: function (x) {
          return pows(Math.ceil(logs(x)));
        }
      }));
    };

    return scale;
  }
  function log$2() {
    var scale = loggish(transformer$3()).domain([1, 10]);

    scale.copy = function () {
      return copy$2(scale, log$2()).base(scale.base());
    };

    initRange.apply(scale, arguments);
    return scale;
  }

  function transformSymlog(c) {
    return function (x) {
      return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
  }

  function transformSymexp(c) {
    return function (x) {
      return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
  }

  function symlogish(transform) {
    var c = 1,
        scale = transform(transformSymlog(c), transformSymexp(c));

    scale.constant = function (_) {
      return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };

    return linearish(scale);
  }
  function symlog() {
    var scale = symlogish(transformer$3());

    scale.copy = function () {
      return copy$2(scale, symlog()).constant(scale.constant());
    };

    return initRange.apply(scale, arguments);
  }

  function transformPow(exponent) {
    return function (x) {
      return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
  }

  function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
  }

  function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
  }

  function powish(transform) {
    var scale = transform(identity$2, identity$2),
        exponent = 1;

    function rescale() {
      return exponent === 1 ? transform(identity$2, identity$2) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }

    scale.exponent = function (_) {
      return arguments.length ? (exponent = +_, rescale()) : exponent;
    };

    return linearish(scale);
  }
  function pow$2() {
    var scale = powish(transformer$3());

    scale.copy = function () {
      return copy$2(scale, pow$2()).exponent(scale.exponent());
    };

    initRange.apply(scale, arguments);
    return scale;
  }
  function sqrt$2() {
    return pow$2.apply(null, arguments).exponent(0.5);
  }

  function quantile() {
    var domain = [],
        range = [],
        thresholds = [],
        unknown;

    function rescale() {
      var i = 0,
          n = Math.max(1, range.length);
      thresholds = new Array(n - 1);

      while (++i < n) thresholds[i - 1] = quantileSorted(domain, i / n);

      return scale;
    }

    function scale(x) {
      return x == null || isNaN(x = +x) ? unknown : range[bisectRight$1(thresholds, x)];
    }

    scale.invertExtent = function (y) {
      var i = range.indexOf(y);
      return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
    };

    scale.domain = function (_) {
      if (!arguments.length) return domain.slice();
      domain = [];

      for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);

      domain.sort(ascending$2);
      return rescale();
    };

    scale.range = function (_) {
      return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : unknown;
    };

    scale.quantiles = function () {
      return thresholds.slice();
    };

    scale.copy = function () {
      return quantile().domain(domain).range(range).unknown(unknown);
    };

    return initRange.apply(scale, arguments);
  }

  function quantize$1() {
    var x0 = 0,
        x1 = 1,
        n = 1,
        domain = [0.5],
        range = [0, 1],
        unknown;

    function scale(x) {
      return x != null && x <= x ? range[bisectRight$1(domain, x, 0, n)] : unknown;
    }

    function rescale() {
      var i = -1;
      domain = new Array(n);

      while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);

      return scale;
    }

    scale.domain = function (_) {
      return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
    };

    scale.range = function (_) {
      return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };

    scale.invertExtent = function (y) {
      var i = range.indexOf(y);
      return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
    };

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : scale;
    };

    scale.thresholds = function () {
      return domain.slice();
    };

    scale.copy = function () {
      return quantize$1().domain([x0, x1]).range(range).unknown(unknown);
    };

    return initRange.apply(linearish(scale), arguments);
  }

  function threshold() {
    var domain = [0.5],
        range = [0, 1],
        unknown,
        n = 1;

    function scale(x) {
      return x != null && x <= x ? range[bisectRight$1(domain, x, 0, n)] : unknown;
    }

    scale.domain = function (_) {
      return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };

    scale.range = function (_) {
      return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };

    scale.invertExtent = function (y) {
      var i = range.indexOf(y);
      return [domain[i - 1], domain[i]];
    };

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : unknown;
    };

    scale.copy = function () {
      return threshold().domain(domain).range(range).unknown(unknown);
    };

    return initRange.apply(scale, arguments);
  }

  var durationSecond = 1000,
      durationMinute = durationSecond * 60,
      durationHour = durationMinute * 60,
      durationDay = durationHour * 24,
      durationWeek = durationDay * 7,
      durationMonth = durationDay * 30,
      durationYear = durationDay * 365;

  function date(t) {
    return new Date(t);
  }

  function number$4(t) {
    return t instanceof Date ? +t : +new Date(+t);
  }

  function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = continuous$1(),
        invert = scale.invert,
        domain = scale.domain;
    var formatMillisecond = format(".%L"),
        formatSecond = format(":%S"),
        formatMinute = format("%I:%M"),
        formatHour = format("%I %p"),
        formatDay = format("%a %d"),
        formatWeek = format("%b %d"),
        formatMonth = format("%B"),
        formatYear = format("%Y");
    var tickIntervals = [[second, 1, durationSecond], [second, 5, 5 * durationSecond], [second, 15, 15 * durationSecond], [second, 30, 30 * durationSecond], [minute, 1, durationMinute], [minute, 5, 5 * durationMinute], [minute, 15, 15 * durationMinute], [minute, 30, 30 * durationMinute], [hour, 1, durationHour], [hour, 3, 3 * durationHour], [hour, 6, 6 * durationHour], [hour, 12, 12 * durationHour], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];

    function tickFormat(date) {
      return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }

    function tickInterval(interval, start, stop) {
      if (interval == null) interval = 10; // If a desired tick count is specified, pick a reasonable tick interval
      // based on the extent of the domain and a rough estimate of tick size.
      // Otherwise, assume interval is already a time interval and use it.

      if (typeof interval === "number") {
        var target = Math.abs(stop - start) / interval,
            i = bisector$1(function (i) {
          return i[2];
        }).right(tickIntervals, target),
            step;

        if (i === tickIntervals.length) {
          step = tickStep(start / durationYear, stop / durationYear, interval);
          interval = year;
        } else if (i) {
          i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
          step = i[1];
          interval = i[0];
        } else {
          step = Math.max(tickStep(start, stop, interval), 1);
          interval = millisecond;
        }

        return interval.every(step);
      }

      return interval;
    }

    scale.invert = function (y) {
      return new Date(invert(y));
    };

    scale.domain = function (_) {
      return arguments.length ? domain(Array.from(_, number$4)) : domain().map(date);
    };

    scale.ticks = function (interval) {
      var d = domain(),
          t0 = d[0],
          t1 = d[d.length - 1],
          r = t1 < t0,
          t;
      if (r) t = t0, t0 = t1, t1 = t;
      t = tickInterval(interval, t0, t1);
      t = t ? t.range(t0, t1 + 1) : []; // inclusive stop

      return r ? t.reverse() : t;
    };

    scale.tickFormat = function (count, specifier) {
      return specifier == null ? tickFormat : format(specifier);
    };

    scale.nice = function (interval) {
      var d = domain();
      return (interval = tickInterval(interval, d[0], d[d.length - 1])) ? domain(nice(d, interval)) : scale;
    };

    scale.copy = function () {
      return copy$2(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
    };

    return scale;
  }
  function time$1() {
    return initRange.apply(calendar(year, month, sunday, day, hour, minute, second, millisecond, timeFormat$1).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
  }

  function utcTime() {
    return initRange.apply(calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, utcFormat$1).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
  }

  function transformer$2() {
    var x0 = 0,
        x1 = 1,
        t0,
        t1,
        k10,
        transform,
        interpolator = identity$2,
        clamp = false,
        unknown;

    function scale(x) {
      return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }

    scale.domain = function (_) {
      return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
    };

    scale.clamp = function (_) {
      return arguments.length ? (clamp = !!_, scale) : clamp;
    };

    scale.interpolator = function (_) {
      return arguments.length ? (interpolator = _, scale) : interpolator;
    };

    function range(interpolate) {
      return function (_) {
        var r0, r1;
        return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [interpolator(0), interpolator(1)];
      };
    }

    scale.range = range(interpolate$1);
    scale.rangeRound = range(interpolateRound);

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : unknown;
    };

    return function (t) {
      transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
      return scale;
    };
  }

  function copy$1(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
  }
  function sequential() {
    var scale = linearish(transformer$2()(identity$2));

    scale.copy = function () {
      return copy$1(scale, sequential());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function sequentialLog() {
    var scale = loggish(transformer$2()).domain([1, 10]);

    scale.copy = function () {
      return copy$1(scale, sequentialLog()).base(scale.base());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function sequentialSymlog() {
    var scale = symlogish(transformer$2());

    scale.copy = function () {
      return copy$1(scale, sequentialSymlog()).constant(scale.constant());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function sequentialPow() {
    var scale = powish(transformer$2());

    scale.copy = function () {
      return copy$1(scale, sequentialPow()).exponent(scale.exponent());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
  }

  function transformer$1() {
    var x0 = 0,
        x1 = 0.5,
        x2 = 1,
        s = 1,
        t0,
        t1,
        t2,
        k10,
        k21,
        interpolator = identity$2,
        transform,
        clamp = false,
        unknown;

    function scale(x) {
      return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }

    scale.domain = function (_) {
      return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [x0, x1, x2];
    };

    scale.clamp = function (_) {
      return arguments.length ? (clamp = !!_, scale) : clamp;
    };

    scale.interpolator = function (_) {
      return arguments.length ? (interpolator = _, scale) : interpolator;
    };

    function range(interpolate) {
      return function (_) {
        var r0, r1, r2;
        return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
      };
    }

    scale.range = range(interpolate$1);
    scale.rangeRound = range(interpolateRound);

    scale.unknown = function (_) {
      return arguments.length ? (unknown = _, scale) : unknown;
    };

    return function (t) {
      transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
      return scale;
    };
  }

  function diverging() {
    var scale = linearish(transformer$1()(identity$2));

    scale.copy = function () {
      return copy$1(scale, diverging());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function divergingLog() {
    var scale = loggish(transformer$1()).domain([0.1, 1, 10]);

    scale.copy = function () {
      return copy$1(scale, divergingLog()).base(scale.base());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function divergingSymlog() {
    var scale = symlogish(transformer$1());

    scale.copy = function () {
      return copy$1(scale, divergingSymlog()).constant(scale.constant());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function divergingPow() {
    var scale = powish(transformer$1());

    scale.copy = function () {
      return copy$1(scale, divergingPow()).exponent(scale.exponent());
    };

    return initInterpolator.apply(scale, arguments);
  }
  function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
  }

  function bandSpace(count, paddingInner, paddingOuter) {
    const space = count - paddingInner + paddingOuter * 2;
    return count ? space > 0 ? space : 1 : 0;
  }

  const Identity = 'identity';
  const Linear = 'linear';
  const Log = 'log';
  const Pow = 'pow';
  const Sqrt = 'sqrt';
  const Symlog = 'symlog';
  const Time = 'time';
  const UTC = 'utc';
  const Sequential = 'sequential';
  const Diverging = 'diverging';
  const Quantile = 'quantile';
  const Quantize = 'quantize';
  const Threshold = 'threshold';
  const Ordinal = 'ordinal';
  const Point = 'point';
  const Band = 'band';
  const BinOrdinal = 'bin-ordinal'; // categories

  const Continuous = 'continuous';
  const Discrete$1 = 'discrete';
  const Discretizing = 'discretizing';
  const Interpolating = 'interpolating';
  const Temporal = 'temporal';

  function invertRange(scale) {
    return function (_) {
      let lo = _[0],
          hi = _[1],
          t;

      if (hi < lo) {
        t = lo;
        lo = hi;
        hi = t;
      }

      return [scale.invert(lo), scale.invert(hi)];
    };
  }

  function invertRangeExtent(scale) {
    return function (_) {
      const range = scale.range();
      let lo = _[0],
          hi = _[1],
          min = -1,
          max,
          t,
          i,
          n;

      if (hi < lo) {
        t = lo;
        lo = hi;
        hi = t;
      }

      for (i = 0, n = range.length; i < n; ++i) {
        if (range[i] >= lo && range[i] <= hi) {
          if (min < 0) min = i;
          max = i;
        }
      }

      if (min < 0) return undefined;
      lo = scale.invertExtent(range[min]);
      hi = scale.invertExtent(range[max]);
      return [lo[0] === undefined ? lo[1] : lo[0], hi[1] === undefined ? hi[0] : hi[1]];
    };
  }

  function band() {
    const scale = ordinal().unknown(undefined),
          domain = scale.domain,
          ordinalRange = scale.range;
    let range$1 = [0, 1],
        step,
        bandwidth,
        round = false,
        paddingInner = 0,
        paddingOuter = 0,
        align = 0.5;
    delete scale.unknown;

    function rescale() {
      const n = domain().length,
            reverse = range$1[1] < range$1[0],
            stop = range$1[1 - reverse],
            space = bandSpace(n, paddingInner, paddingOuter);
      let start = range$1[reverse - 0];
      step = (stop - start) / (space || 1);

      if (round) {
        step = Math.floor(step);
      }

      start += (stop - start - step * (n - paddingInner)) * align;
      bandwidth = step * (1 - paddingInner);

      if (round) {
        start = Math.round(start);
        bandwidth = Math.round(bandwidth);
      }

      const values = range$1$1(n).map(i => start + step * i);
      return ordinalRange(reverse ? values.reverse() : values);
    }

    scale.domain = function (_) {
      if (arguments.length) {
        domain(_);
        return rescale();
      } else {
        return domain();
      }
    };

    scale.range = function (_) {
      if (arguments.length) {
        range$1 = [+_[0], +_[1]];
        return rescale();
      } else {
        return range$1.slice();
      }
    };

    scale.rangeRound = function (_) {
      range$1 = [+_[0], +_[1]];
      round = true;
      return rescale();
    };

    scale.bandwidth = function () {
      return bandwidth;
    };

    scale.step = function () {
      return step;
    };

    scale.round = function (_) {
      if (arguments.length) {
        round = !!_;
        return rescale();
      } else {
        return round;
      }
    };

    scale.padding = function (_) {
      if (arguments.length) {
        paddingOuter = Math.max(0, Math.min(1, _));
        paddingInner = paddingOuter;
        return rescale();
      } else {
        return paddingInner;
      }
    };

    scale.paddingInner = function (_) {
      if (arguments.length) {
        paddingInner = Math.max(0, Math.min(1, _));
        return rescale();
      } else {
        return paddingInner;
      }
    };

    scale.paddingOuter = function (_) {
      if (arguments.length) {
        paddingOuter = Math.max(0, Math.min(1, _));
        return rescale();
      } else {
        return paddingOuter;
      }
    };

    scale.align = function (_) {
      if (arguments.length) {
        align = Math.max(0, Math.min(1, _));
        return rescale();
      } else {
        return align;
      }
    };

    scale.invertRange = function (_) {
      // bail if range has null or undefined values
      if (_[0] == null || _[1] == null) return;
      const reverse = range$1[1] < range$1[0],
            values = reverse ? ordinalRange().reverse() : ordinalRange(),
            n = values.length - 1;
      let lo = +_[0],
          hi = +_[1],
          a,
          b,
          t; // bail if either range endpoint is invalid

      if (lo !== lo || hi !== hi) return; // order range inputs, bail if outside of scale range

      if (hi < lo) {
        t = lo;
        lo = hi;
        hi = t;
      }

      if (hi < values[0] || lo > range$1[1 - reverse]) return; // binary search to index into scale range

      a = Math.max(0, bisectRight$1(values, lo) - 1);
      b = lo === hi ? a : bisectRight$1(values, hi) - 1; // increment index a if lo is within padding gap

      if (lo - values[a] > bandwidth + 1e-10) ++a;

      if (reverse) {
        // map + swap
        t = a;
        a = n - b;
        b = n - t;
      }

      return a > b ? undefined : domain().slice(a, b + 1);
    };

    scale.invert = function (_) {
      const value = scale.invertRange([_, _]);
      return value ? value[0] : value;
    };

    scale.copy = function () {
      return band().domain(domain()).range(range$1).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };

    return rescale();
  }

  function pointish(scale) {
    const copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;

    scale.copy = function () {
      return pointish(copy());
    };

    return scale;
  }

  function point$1() {
    return pointish(band().paddingInner(1));
  }

  var map = Array.prototype.map;

  function numbers(_) {
    return map.call(_, toNumber);
  }

  const slice$1 = Array.prototype.slice;

  function scaleBinOrdinal() {
    let domain = [],
        range = [];

    function scale(x) {
      return x == null || x !== x ? undefined : range[(bisectRight$1(domain, x) - 1) % range.length];
    }

    scale.domain = function (_) {
      if (arguments.length) {
        domain = numbers(_);
        return scale;
      } else {
        return domain.slice();
      }
    };

    scale.range = function (_) {
      if (arguments.length) {
        range = slice$1.call(_);
        return scale;
      } else {
        return range.slice();
      }
    };

    scale.tickFormat = function (count, specifier) {
      return tickFormat$1(domain[0], peek$1(domain), count == null ? 10 : count, specifier);
    };

    scale.copy = function () {
      return scaleBinOrdinal().domain(scale.domain()).range(scale.range());
    };

    return scale;
  }

  const scales = {};
  /**
   * Augment scales with their type and needed inverse methods.
   */

  function create$2(type, constructor, metadata) {
    const ctr = function scale() {
      const s = constructor();

      if (!s.invertRange) {
        s.invertRange = s.invert ? invertRange(s) : s.invertExtent ? invertRangeExtent(s) : undefined;
      }

      s.type = type;
      return s;
    };

    ctr.metadata = toSet(array$5(metadata));
    return ctr;
  }

  function scale$4(type, scale, metadata) {
    if (arguments.length > 1) {
      scales[type] = create$2(type, scale, metadata);
      return this;
    } else {
      return isValidScaleType(type) ? scales[type] : undefined;
    }
  } // identity scale


  scale$4(Identity, identity$1); // continuous scales

  scale$4(Linear, linear, Continuous);
  scale$4(Log, log$2, [Continuous, Log]);
  scale$4(Pow, pow$2, Continuous);
  scale$4(Sqrt, sqrt$2, Continuous);
  scale$4(Symlog, symlog, Continuous);
  scale$4(Time, time$1, [Continuous, Temporal]);
  scale$4(UTC, utcTime, [Continuous, Temporal]); // sequential scales

  scale$4(Sequential, sequential, [Continuous, Interpolating]); // backwards compat

  scale$4(`${Sequential}-${Linear}`, sequential, [Continuous, Interpolating]);
  scale$4(`${Sequential}-${Log}`, sequentialLog, [Continuous, Interpolating, Log]);
  scale$4(`${Sequential}-${Pow}`, sequentialPow, [Continuous, Interpolating]);
  scale$4(`${Sequential}-${Sqrt}`, sequentialSqrt, [Continuous, Interpolating]);
  scale$4(`${Sequential}-${Symlog}`, sequentialSymlog, [Continuous, Interpolating]); // diverging scales

  scale$4(`${Diverging}-${Linear}`, diverging, [Continuous, Interpolating]);
  scale$4(`${Diverging}-${Log}`, divergingLog, [Continuous, Interpolating, Log]);
  scale$4(`${Diverging}-${Pow}`, divergingPow, [Continuous, Interpolating]);
  scale$4(`${Diverging}-${Sqrt}`, divergingSqrt, [Continuous, Interpolating]);
  scale$4(`${Diverging}-${Symlog}`, divergingSymlog, [Continuous, Interpolating]); // discretizing scales

  scale$4(Quantile, quantile, [Discretizing, Quantile]);
  scale$4(Quantize, quantize$1, Discretizing);
  scale$4(Threshold, threshold, Discretizing); // discrete scales

  scale$4(BinOrdinal, scaleBinOrdinal, [Discrete$1, Discretizing]);
  scale$4(Ordinal, ordinal, Discrete$1);
  scale$4(Band, band, Discrete$1);
  scale$4(Point, point$1, Discrete$1);

  function isValidScaleType(type) {
    return has$1(scales, type);
  }

  function hasType(key, type) {
    const s = scales[key];
    return s && s.metadata[type];
  }

  function isContinuous(key) {
    return hasType(key, Continuous);
  }

  function isDiscrete(key) {
    return hasType(key, Discrete$1);
  }

  function isDiscretizing(key) {
    return hasType(key, Discretizing);
  }

  function isLogarithmic(key) {
    return hasType(key, Log);
  }

  function isTemporal(key) {
    return hasType(key, Temporal);
  }

  function isInterpolating(key) {
    return hasType(key, Interpolating);
  }

  function isQuantile(key) {
    return hasType(key, Quantile);
  }

  const scaleProps = ['clamp', 'base', 'constant', 'exponent'];

  function interpolateRange(interpolator, range) {
    const start = range[0],
          span = peek$1(range) - start;
    return function (i) {
      return interpolator(start + i * span);
    };
  }

  function interpolateColors(colors, type, gamma) {
    return piecewise(interpolate(type || 'rgb', gamma), colors);
  }

  function quantizeInterpolator(interpolator, count) {
    const samples = new Array(count),
          n = count + 1;

    for (let i = 0; i < count;) samples[i] = interpolator(++i / n);

    return samples;
  }

  function scaleFraction(scale$1, min, max) {
    const delta = max - min;
    let i, t, s;

    if (!delta || !Number.isFinite(delta)) {
      return constant$4(0.5);
    } else {
      i = (t = scale$1.type).indexOf('-');
      t = i < 0 ? t : t.slice(i + 1);
      s = scale$4(t)().domain([min, max]).range([0, 1]);
      scaleProps.forEach(m => scale$1[m] ? s[m](scale$1[m]()) : 0);
      return s;
    }
  }

  function interpolate(type, gamma) {
    const interp = $$1[method(type)];
    return gamma != null && interp && interp.gamma ? interp.gamma(gamma) : interp;
  }

  function method(type) {
    return 'interpolate' + type.toLowerCase().split('-').map(s => s[0].toUpperCase() + s.slice(1)).join('');
  }

  const continuous = {
    blues: 'cfe1f2bed8eca8cee58fc1de74b2d75ba3cf4592c63181bd206fb2125ca40a4a90',
    greens: 'd3eecdc0e6baabdda594d3917bc77d60ba6c46ab5e329a512089430e7735036429',
    greys: 'e2e2e2d4d4d4c4c4c4b1b1b19d9d9d8888887575756262624d4d4d3535351e1e1e',
    oranges: 'fdd8b3fdc998fdb87bfda55efc9244f87f2cf06b18e4580bd14904b93d029f3303',
    purples: 'e2e1efd4d4e8c4c5e0b4b3d6a3a0cc928ec3827cb97566ae684ea25c3696501f8c',
    reds: 'fdc9b4fcb49afc9e80fc8767fa7051f6573fec3f2fdc2a25c81b1db21218970b13',
    blueGreen: 'd5efedc1e8e0a7ddd18bd2be70c6a958ba9144ad77319c5d2089460e7736036429',
    bluePurple: 'ccddecbad0e4a8c2dd9ab0d4919cc98d85be8b6db28a55a6873c99822287730f71',
    greenBlue: 'd3eecec5e8c3b1e1bb9bd8bb82cec269c2ca51b2cd3c9fc7288abd1675b10b60a1',
    orangeRed: 'fddcaffdcf9bfdc18afdad77fb9562f67d53ee6545e24932d32d1ebf130da70403',
    purpleBlue: 'dbdaebc8cee4b1c3de97b7d87bacd15b9fc93a90c01e7fb70b70ab056199045281',
    purpleBlueGreen: 'dbd8eac8cee4b0c3de93b7d872acd1549fc83892bb1c88a3097f8702736b016353',
    purpleRed: 'dcc9e2d3b3d7ce9eccd186c0da6bb2e14da0e23189d91e6fc61159ab07498f023a',
    redPurple: 'fccfccfcbec0faa9b8f98faff571a5ec539ddb3695c41b8aa908808d0179700174',
    yellowGreen: 'e4f4acd1eca0b9e2949ed68880c97c62bb6e47aa5e3297502083440e723b036034',
    yellowOrangeBrown: 'feeaa1fedd84fecc63feb746fca031f68921eb7215db5e0bc54c05ab3d038f3204',
    yellowOrangeRed: 'fee087fed16ffebd59fea849fd903efc7335f9522bee3423de1b20ca0b22af0225',
    blueOrange: '134b852f78b35da2cb9dcae1d2e5eff2f0ebfce0bafbbf74e8932fc5690d994a07',
    brownBlueGreen: '704108a0651ac79548e3c78af3e6c6eef1eac9e9e48ed1c74da79e187a72025147',
    purpleGreen: '5b1667834792a67fb6c9aed3e6d6e8eff0efd9efd5aedda971bb75368e490e5e29',
    purpleOrange: '4114696647968f83b7b9b4d6dadbebf3eeeafce0bafbbf74e8932fc5690d994a07',
    redBlue: '8c0d25bf363adf745ef4ae91fbdbc9f2efeed2e5ef9dcae15da2cb2f78b3134b85',
    redGrey: '8c0d25bf363adf745ef4ae91fcdccbfaf4f1e2e2e2c0c0c0969696646464343434',
    yellowGreenBlue: 'eff9bddbf1b4bde5b594d5b969c5be45b4c22c9ec02182b82163aa23479c1c3185',
    redYellowBlue: 'a50026d4322cf16e43fcac64fedd90faf8c1dcf1ecabd6e875abd04a74b4313695',
    redYellowGreen: 'a50026d4322cf16e43fcac63fedd8df9f7aed7ee8ea4d86e64bc6122964f006837',
    pinkYellowGreen: '8e0152c0267edd72adf0b3d6faddedf5f3efe1f2cab6de8780bb474f9125276419',
    spectral: '9e0142d13c4bf0704afcac63fedd8dfbf8b0e0f3a1a9dda269bda94288b55e4fa2',
    viridis: '440154470e61481a6c482575472f7d443a834144873d4e8a39568c35608d31688e2d708e2a788e27818e23888e21918d1f988b1fa08822a8842ab07f35b77943bf7154c56866cc5d7ad1518fd744a5db36bcdf27d2e21be9e51afde725',
    magma: '0000040404130b0924150e3720114b2c11603b0f704a107957157e651a80721f817f24828c29819a2e80a8327db6377ac43c75d1426fde4968e95462f1605df76f5cfa7f5efc8f65fe9f6dfeaf78febf84fece91fddea0fcedaffcfdbf',
    inferno: '0000040403130c0826170c3b240c4f330a5f420a68500d6c5d126e6b176e781c6d86216b932667a12b62ae305cbb3755c73e4cd24644dd513ae65c30ed6925f3771af8850ffb9506fca50afcb519fac62df6d645f2e661f3f484fcffa4',
    plasma: '0d088723069033059742039d5002a25d01a66a00a87801a88405a7900da49c179ea72198b12a90ba3488c33d80cb4779d35171da5a69e16462e76e5bed7953f2834cf68f44fa9a3dfca636fdb32ffec029fcce25f9dc24f5ea27f0f921',
    cividis: '00205100235800265d002961012b65042e670831690d346b11366c16396d1c3c6e213f6e26426e2c456e31476e374a6e3c4d6e42506e47536d4c566d51586e555b6e5a5e6e5e616e62646f66676f6a6a706e6d717270717573727976737c79747f7c75827f758682768985778c8877908b78938e789691789a94789e9778a19b78a59e77a9a177aea575b2a874b6ab73bbaf71c0b26fc5b66dc9b96acebd68d3c065d8c462ddc85fe2cb5ce7cf58ebd355f0d652f3da4ff7de4cfae249fce647',
    rainbow: '6e40aa883eb1a43db3bf3cafd83fa4ee4395fe4b83ff576eff6659ff7847ff8c38f3a130e2b72fcfcc36bee044aff05b8ff4576ff65b52f6673af27828ea8d1ddfa319d0b81cbecb23abd82f96e03d82e14c6edb5a5dd0664dbf6e40aa',
    sinebow: 'ff4040fc582af47218e78d0bd5a703bfbf00a7d5038de70b72f41858fc2a40ff402afc5818f4720be78d03d5a700bfbf03a7d50b8de71872f42a58fc4040ff582afc7218f48d0be7a703d5bf00bfd503a7e70b8df41872fc2a58ff4040',
    turbo: '23171b32204a3e2a71453493493eae4b49c54a53d7485ee44569ee4074f53c7ff8378af93295f72e9ff42ba9ef28b3e926bce125c5d925cdcf27d5c629dcbc2de3b232e9a738ee9d3ff39347f68950f9805afc7765fd6e70fe667cfd5e88fc5795fb51a1f84badf545b9f140c5ec3cd0e637dae034e4d931ecd12ef4c92bfac029ffb626ffad24ffa223ff9821ff8d1fff821dff771cfd6c1af76118f05616e84b14df4111d5380fcb2f0dc0260ab61f07ac1805a313029b0f00950c00910b00',
    browns: 'eedbbdecca96e9b97ae4a865dc9856d18954c7784cc0673fb85536ad44339f3632',
    tealBlues: 'bce4d89dd3d181c3cb65b3c245a2b9368fae347da0306a932c5985',
    teals: 'bbdfdfa2d4d58ac9c975bcbb61b0af4da5a43799982b8b8c1e7f7f127273006667',
    warmGreys: 'dcd4d0cec5c1c0b8b4b3aaa7a59c9998908c8b827f7e7673726866665c5a59504e',
    goldGreen: 'f4d166d5ca60b6c35c98bb597cb25760a6564b9c533f8f4f33834a257740146c36',
    goldOrange: 'f4d166f8be5cf8aa4cf5983bf3852aef701be2621fd65322c54923b142239e3a26',
    goldRed: 'f4d166f6be59f9aa51fc964ef6834bee734ae56249db5247cf4244c43141b71d3e',
    lightGreyRed: 'efe9e6e1dad7d5cbc8c8bdb9bbaea9cd967ddc7b43e15f19df4011dc000b',
    lightGreyTeal: 'e4eaead6dcddc8ced2b7c2c7a6b4bc64b0bf22a6c32295c11f85be1876bc',
    lightMulti: 'e0f1f2c4e9d0b0de9fd0e181f6e072f6c053f3993ef77440ef4a3c',
    lightOrange: 'f2e7daf7d5baf9c499fab184fa9c73f68967ef7860e8645bde515bd43d5b',
    lightTealBlue: 'e3e9e0c0dccf9aceca7abfc859afc0389fb9328dad2f7ca0276b95255988',
    darkBlue: '3232322d46681a5c930074af008cbf05a7ce25c0dd38daed50f3faffffff',
    darkGold: '3c3c3c584b37725e348c7631ae8b2bcfa424ecc31ef9de30fff184ffffff',
    darkGreen: '3a3a3a215748006f4d048942489e4276b340a6c63dd2d836ffeb2cffffaa',
    darkMulti: '3737371f5287197d8c29a86995ce3fffe800ffffff',
    darkRed: '3434347036339e3c38cc4037e75d1eec8620eeab29f0ce32ffeb2c'
  };
  const discrete = {
    category10: '1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf',
    category20: '1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5',
    category20b: '393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6',
    category20c: '3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9',
    tableau10: '4c78a8f58518e4575672b7b254a24beeca3bb279a2ff9da69d755dbab0ac',
    tableau20: '4c78a89ecae9f58518ffbf7954a24b88d27ab79a20f2cf5b43989483bcb6e45756ff9d9879706ebab0acd67195fcbfd2b279a2d6a5c99e765fd8b5a5',
    accent: '7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666',
    dark2: '1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666',
    paired: 'a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928',
    pastel1: 'fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2',
    pastel2: 'b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc',
    set1: 'e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999',
    set2: '66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3',
    set3: '8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f'
  };

  function colors(palette) {
    const n = palette.length / 6 | 0,
          c = new Array(n);

    for (let i = 0; i < n;) {
      c[i] = '#' + palette.slice(i * 6, ++i * 6);
    }

    return c;
  }

  function apply(_, f) {
    for (const k in _) scheme(k, f(_[k]));
  }

  const schemes = {};
  apply(discrete, colors);
  apply(continuous, _ => interpolateColors(colors(_)));

  function scheme(name, scheme) {
    name = name && name.toLowerCase();

    if (arguments.length > 1) {
      schemes[name] = scheme;
      return this;
    } else {
      return schemes[name];
    }
  }

  const SymbolLegend = 'symbol';
  const DiscreteLegend = 'discrete';
  const GradientLegend = 'gradient';

  const defaultFormatter = value => isArray(value) ? value.map(v => String(v)) : String(value);

  const ascending$1 = (a, b) => a[1] - b[1];

  const descending = (a, b) => b[1] - a[1];
  /**
   * Determine the tick count or interval function.
   * @param {Scale} scale - The scale for which to generate tick values.
   * @param {*} count - The desired tick count or interval specifier.
   * @param {number} minStep - The desired minimum step between tick values.
   * @return {*} - The tick count or interval function.
   */


  function tickCount(scale, count, minStep) {
    let step;

    if (isNumber$1(count)) {
      if (scale.bins) {
        count = Math.max(count, scale.bins.length);
      }

      if (minStep != null) {
        count = Math.min(count, Math.floor(span(scale.domain()) / minStep || 1));
      }
    }

    if (isObject(count)) {
      step = count.step;
      count = count.interval;
    }

    if (isString(count)) {
      count = scale.type === Time ? timeInterval(count) : scale.type == UTC ? utcInterval(count) : error('Only time and utc scales accept interval strings.');
      if (step) count = count.every(step);
    }

    return count;
  }
  /**
   * Filter a set of candidate tick values, ensuring that only tick values
   * that lie within the scale range are included.
   * @param {Scale} scale - The scale for which to generate tick values.
   * @param {Array<*>} ticks - The candidate tick values.
   * @param {*} count - The tick count or interval function.
   * @return {Array<*>} - The filtered tick values.
   */


  function validTicks(scale, ticks, count) {
    let range = scale.range(),
        lo = range[0],
        hi = peek$1(range),
        cmp = ascending$1;

    if (lo > hi) {
      range = hi;
      hi = lo;
      lo = range;
      cmp = descending;
    }

    lo = Math.floor(lo);
    hi = Math.ceil(hi); // filter ticks to valid values within the range
    // additionally sort ticks in range order (#2579)

    ticks = ticks.map(v => [v, scale(v)]).filter(_ => lo <= _[1] && _[1] <= hi).sort(cmp).map(_ => _[0]);

    if (count > 0 && ticks.length > 1) {
      const endpoints = [ticks[0], peek$1(ticks)];

      while (ticks.length > count && ticks.length >= 3) {
        ticks = ticks.filter((_, i) => !(i % 2));
      }

      if (ticks.length < 3) {
        ticks = endpoints;
      }
    }

    return ticks;
  }
  /**
   * Generate tick values for the given scale and approximate tick count or
   * interval value. If the scale has a 'ticks' method, it will be used to
   * generate the ticks, with the count argument passed as a parameter. If the
   * scale lacks a 'ticks' method, the full scale domain will be returned.
   * @param {Scale} scale - The scale for which to generate tick values.
   * @param {*} [count] - The approximate number of desired ticks.
   * @return {Array<*>} - The generated tick values.
   */


  function tickValues(scale, count) {
    return scale.bins ? validTicks(scale, scale.bins) : scale.ticks ? scale.ticks(count) : scale.domain();
  }
  /**
   * Generate a label format function for a scale. If the scale has a
   * 'tickFormat' method, it will be used to generate the formatter, with the
   * count and specifier arguments passed as parameters. If the scale lacks a
   * 'tickFormat' method, the returned formatter performs simple string coercion.
   * If the input scale is a logarithmic scale and the format specifier does not
   * indicate a desired decimal precision, a special variable precision formatter
   * that automatically trims trailing zeroes will be generated.
   * @param {Scale} scale - The scale for which to generate the label formatter.
   * @param {*} [count] - The approximate number of desired ticks.
   * @param {string} [specifier] - The format specifier. Must be a legal d3
   *   specifier string (see https://github.com/d3/d3-format#formatSpecifier) or
   *   time multi-format specifier object.
   * @return {function(*):string} - The generated label formatter.
   */


  function tickFormat(locale, scale, count, specifier, formatType, noSkip) {
    const type = scale.type;
    let format = defaultFormatter;

    if (type === Time || formatType === Time) {
      format = locale.timeFormat(specifier);
    } else if (type === UTC || formatType === UTC) {
      format = locale.utcFormat(specifier);
    } else if (isLogarithmic(type)) {
      const varfmt = locale.formatFloat(specifier);

      if (noSkip || scale.bins) {
        format = varfmt;
      } else {
        const test = tickLog(scale, count, false);

        format = _ => test(_) ? varfmt(_) : '';
      }
    } else if (scale.tickFormat) {
      // if d3 scale has tickFormat, it must be continuous
      const d = scale.domain();
      format = locale.formatSpan(d[0], d[d.length - 1], count, specifier);
    } else if (specifier) {
      format = locale.format(specifier);
    }

    return format;
  }

  function tickLog(scale, count, values) {
    const ticks = tickValues(scale, count),
          base = scale.base(),
          logb = Math.log(base),
          k = Math.max(1, base * count / ticks.length); // apply d3-scale's log format filter criteria

    const test = d => {
      let i = d / Math.pow(base, Math.round(Math.log(d) / logb));
      if (i * base < base - 0.5) i *= base;
      return i <= k;
    };

    return values ? ticks.filter(test) : test;
  }

  const symbols$1 = {
    [Quantile]: 'quantiles',
    [Quantize]: 'thresholds',
    [Threshold]: 'domain'
  };
  const formats = {
    [Quantile]: 'quantiles',
    [Quantize]: 'domain'
  };

  function labelValues(scale, count) {
    return scale.bins ? binValues(scale.bins) : scale.type === Log ? tickLog(scale, count, true) : symbols$1[scale.type] ? thresholdValues(scale[symbols$1[scale.type]]()) : tickValues(scale, count);
  }

  function thresholdFormat(locale, scale, specifier) {
    const _ = scale[formats[scale.type]](),
          n = _.length;

    let d = n > 1 ? _[1] - _[0] : _[0],
        i;

    for (i = 1; i < n; ++i) {
      d = Math.min(d, _[i] - _[i - 1]);
    } // tickCount = 3 ticks times 10 for increased resolution


    return locale.formatSpan(0, d, 3 * 10, specifier);
  }

  function thresholdValues(thresholds) {
    const values = [-Infinity].concat(thresholds);
    values.max = +Infinity;
    return values;
  }

  function binValues(bins) {
    const values = bins.slice(0, -1);
    values.max = peek$1(bins);
    return values;
  }

  const isDiscreteRange = scale => symbols$1[scale.type] || scale.bins;

  function labelFormat(locale, scale, count, type, specifier, formatType, noSkip) {
    const format = formats[scale.type] && formatType !== Time && formatType !== UTC ? thresholdFormat(locale, scale, specifier) : tickFormat(locale, scale, count, specifier, formatType, noSkip);
    return type === SymbolLegend && isDiscreteRange(scale) ? formatRange(format) : type === DiscreteLegend ? formatDiscrete(format) : formatPoint(format);
  }

  const formatRange = format => (value, index, array) => {
    const limit = get$3(array[index + 1], get$3(array.max, +Infinity)),
          lo = formatValue$1(value, format),
          hi = formatValue$1(limit, format);
    return lo && hi ? lo + ' \u2013 ' + hi : hi ? '< ' + hi : '\u2265 ' + lo;
  };

  const get$3 = (value, dflt) => value != null ? value : dflt;

  const formatDiscrete = format => (value, index) => index ? format(value) : null;

  const formatPoint = format => value => format(value);

  const formatValue$1 = (value, format) => Number.isFinite(value) ? format(value) : null;

  function labelFraction(scale) {
    const domain = scale.domain(),
          count = domain.length - 1;
    let lo = +domain[0],
        hi = +peek$1(domain),
        span = hi - lo;

    if (scale.type === Threshold) {
      const adjust = count ? span / count : 0.1;
      lo -= adjust;
      hi += adjust;
      span = hi - lo;
    }

    return value => (value - lo) / span;
  }

  function format$1(locale, scale, specifier, formatType) {
    const type = formatType || scale.type; // replace abbreviated time specifiers to improve screen reader experience

    if (isString(specifier) && isTemporal(type)) {
      specifier = specifier.replace(/%a/g, '%A').replace(/%b/g, '%B');
    }

    return !specifier && type === Time ? locale.timeFormat('%A, %d %B %Y, %X') : !specifier && type === UTC ? locale.utcFormat('%A, %d %B %Y, %X UTC') : labelFormat(locale, scale, 5, null, specifier, formatType, true);
  }

  function domainCaption(locale, scale, opt) {
    opt = opt || {};
    const max = Math.max(3, opt.maxlen || 7),
          fmt = format$1(locale, scale, opt.format, opt.formatType); // if scale breaks domain into bins, describe boundaries

    if (isDiscretizing(scale.type)) {
      const v = labelValues(scale).slice(1).map(fmt),
            n = v.length;
      return `${n} boundar${n === 1 ? 'y' : 'ies'}: ${v.join(', ')}`;
    } // if scale domain is discrete, list values
    else if (isDiscrete(scale.type)) {
        const d = scale.domain(),
              n = d.length,
              v = n > max ? d.slice(0, max - 2).map(fmt).join(', ') + ', ending with ' + d.slice(-1).map(fmt) : d.map(fmt).join(', ');
        return `${n} value${n === 1 ? '' : 's'}: ${v}`;
      } // if scale domain is continuous, describe value range
      else {
          const d = scale.domain();
          return `values from ${fmt(d[0])} to ${fmt(peek$1(d))}`;
        }
  }

  let gradient_id = 0;

  function resetSVGGradientId() {
    gradient_id = 0;
  }

  const patternPrefix = 'p_';

  function isGradient(value) {
    return value && value.gradient;
  }

  function gradientRef(g, defs, base) {
    const type = g.gradient;
    let id = g.id,
        prefix = type === 'radial' ? patternPrefix : ''; // check id, assign default values as needed

    if (!id) {
      id = g.id = 'gradient_' + gradient_id++;

      if (type === 'radial') {
        g.x1 = get$2(g.x1, 0.5);
        g.y1 = get$2(g.y1, 0.5);
        g.r1 = get$2(g.r1, 0);
        g.x2 = get$2(g.x2, 0.5);
        g.y2 = get$2(g.y2, 0.5);
        g.r2 = get$2(g.r2, 0.5);
        prefix = patternPrefix;
      } else {
        g.x1 = get$2(g.x1, 0);
        g.y1 = get$2(g.y1, 0);
        g.x2 = get$2(g.x2, 1);
        g.y2 = get$2(g.y2, 0);
      }
    } // register definition


    defs[id] = g; // return url reference

    return 'url(' + (base || '') + '#' + prefix + id + ')';
  }

  function get$2(val, def) {
    return val != null ? val : def;
  }

  function Gradient$1(p0, p1) {
    var stops = [],
        gradient;
    return gradient = {
      gradient: 'linear',
      x1: p0 ? p0[0] : 0,
      y1: p0 ? p0[1] : 0,
      x2: p1 ? p1[0] : 1,
      y2: p1 ? p1[1] : 0,
      stops: stops,
      stop: function (offset, color) {
        stops.push({
          offset: offset,
          color: color
        });
        return gradient;
      }
    };
  }

  const lookup$4 = {
    'basis': {
      curve: curveBasis
    },
    'basis-closed': {
      curve: curveBasisClosed
    },
    'basis-open': {
      curve: curveBasisOpen
    },
    'bundle': {
      curve: curveBundle,
      tension: 'beta',
      value: 0.85
    },
    'cardinal': {
      curve: curveCardinal,
      tension: 'tension',
      value: 0
    },
    'cardinal-open': {
      curve: curveCardinalOpen,
      tension: 'tension',
      value: 0
    },
    'cardinal-closed': {
      curve: curveCardinalClosed,
      tension: 'tension',
      value: 0
    },
    'catmull-rom': {
      curve: curveCatmullRom,
      tension: 'alpha',
      value: 0.5
    },
    'catmull-rom-closed': {
      curve: curveCatmullRomClosed,
      tension: 'alpha',
      value: 0.5
    },
    'catmull-rom-open': {
      curve: curveCatmullRomOpen,
      tension: 'alpha',
      value: 0.5
    },
    'linear': {
      curve: curveLinear
    },
    'linear-closed': {
      curve: curveLinearClosed
    },
    'monotone': {
      horizontal: monotoneY,
      vertical: monotoneX
    },
    'natural': {
      curve: curveNatural
    },
    'step': {
      curve: curveStep
    },
    'step-after': {
      curve: stepAfter
    },
    'step-before': {
      curve: stepBefore
    }
  };

  function curves(type, orientation, tension) {
    var entry = has$1(lookup$4, type) && lookup$4[type],
        curve = null;

    if (entry) {
      curve = entry.curve || entry[orientation || 'vertical'];

      if (entry.tension && tension != null) {
        curve = curve[entry.tension](tension);
      }
    }

    return curve;
  } // Path parsing and rendering code adapted from fabric.js -- Thanks!


  const cmdlen = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
  },
        regexp = [/([MLHVCSQTAZmlhvcsqtaz])/g, /###/, /(\.\d+)(\.\d)/g, /(\d)([-+])/g, /\s|,|###/];

  function pathParse(pathstr) {
    const result = [];
    let curr, chunks, parsed, param, cmd, len, i, j, n, m; // First, break path into command sequence

    const path = pathstr.slice().replace(regexp[0], '###$1').split(regexp[1]).slice(1); // Next, parse each command in turn

    for (i = 0, n = path.length; i < n; ++i) {
      curr = path[i];
      chunks = curr.slice(1).trim().replace(regexp[2], '$1###$2').replace(regexp[3], '$1###$2').split(regexp[4]);
      cmd = curr.charAt(0);
      parsed = [cmd];

      for (j = 0, m = chunks.length; j < m; ++j) {
        if ((param = +chunks[j]) === param) {
          // not NaN
          parsed.push(param);
        }
      }

      len = cmdlen[cmd.toLowerCase()];

      if (parsed.length - 1 > len) {
        const m = parsed.length;
        j = 1;
        result.push([cmd].concat(parsed.slice(j, j += len))); // handle implicit lineTo (#2803)

        cmd = cmd === 'M' ? 'L' : cmd === 'm' ? 'l' : cmd;

        for (; j < m; j += len) {
          result.push([cmd].concat(parsed.slice(j, j + len)));
        }
      } else {
        result.push(parsed);
      }
    }

    return result;
  }

  const DegToRad = Math.PI / 180;
  const Epsilon = 1e-14;
  const HalfPi = Math.PI / 2;
  const Tau = Math.PI * 2;
  const HalfSqrt3 = Math.sqrt(3) / 2;
  var segmentCache = {};
  var bezierCache = {};
  var join$1 = [].join; // Copied from Inkscape svgtopdf, thanks!

  function segments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    const key = join$1.call(arguments);

    if (segmentCache[key]) {
      return segmentCache[key];
    }

    const th = rotateX * DegToRad;
    const sin_th = Math.sin(th);
    const cos_th = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
    const py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
    let pl = px * px / (rx * rx) + py * py / (ry * ry);

    if (pl > 1) {
      pl = Math.sqrt(pl);
      rx *= pl;
      ry *= pl;
    }

    const a00 = cos_th / rx;
    const a01 = sin_th / rx;
    const a10 = -sin_th / ry;
    const a11 = cos_th / ry;
    const x0 = a00 * ox + a01 * oy;
    const y0 = a10 * ox + a11 * oy;
    const x1 = a00 * x + a01 * y;
    const y1 = a10 * x + a11 * y;
    const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    let sfactor_sq = 1 / d - 0.25;
    if (sfactor_sq < 0) sfactor_sq = 0;
    let sfactor = Math.sqrt(sfactor_sq);
    if (sweep == large) sfactor = -sfactor;
    const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    const th0 = Math.atan2(y0 - yc, x0 - xc);
    const th1 = Math.atan2(y1 - yc, x1 - xc);
    let th_arc = th1 - th0;

    if (th_arc < 0 && sweep === 1) {
      th_arc += Tau;
    } else if (th_arc > 0 && sweep === 0) {
      th_arc -= Tau;
    }

    const segs = Math.ceil(Math.abs(th_arc / (HalfPi + 0.001)));
    const result = [];

    for (let i = 0; i < segs; ++i) {
      const th2 = th0 + i * th_arc / segs;
      const th3 = th0 + (i + 1) * th_arc / segs;
      result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
    }

    return segmentCache[key] = result;
  }

  function bezier(params) {
    const key = join$1.call(params);

    if (bezierCache[key]) {
      return bezierCache[key];
    }

    var cx = params[0],
        cy = params[1],
        th0 = params[2],
        th1 = params[3],
        rx = params[4],
        ry = params[5],
        sin_th = params[6],
        cos_th = params[7];
    const a00 = cos_th * rx;
    const a01 = -sin_th * ry;
    const a10 = sin_th * rx;
    const a11 = cos_th * ry;
    const cos_th0 = Math.cos(th0);
    const sin_th0 = Math.sin(th0);
    const cos_th1 = Math.cos(th1);
    const sin_th1 = Math.sin(th1);
    const th_half = 0.5 * (th1 - th0);
    const sin_th_h2 = Math.sin(th_half * 0.5);
    const t = 8 / 3 * sin_th_h2 * sin_th_h2 / Math.sin(th_half);
    const x1 = cx + cos_th0 - t * sin_th0;
    const y1 = cy + sin_th0 + t * cos_th0;
    const x3 = cx + cos_th1;
    const y3 = cy + sin_th1;
    const x2 = x3 + t * sin_th1;
    const y2 = y3 - t * cos_th1;
    return bezierCache[key] = [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
  }

  const temp = ['l', 0, 0, 0, 0, 0, 0, 0];

  function scale$1$1(current, sX, sY) {
    const c = temp[0] = current[0];

    if (c === 'a' || c === 'A') {
      temp[1] = sX * current[1];
      temp[2] = sY * current[2];
      temp[3] = current[3];
      temp[4] = current[4];
      temp[5] = current[5];
      temp[6] = sX * current[6];
      temp[7] = sY * current[7];
    } else if (c === 'h' || c === 'H') {
      temp[1] = sX * current[1];
    } else if (c === 'v' || c === 'V') {
      temp[1] = sY * current[1];
    } else {
      for (var i = 1, n = current.length; i < n; ++i) {
        temp[i] = (i % 2 == 1 ? sX : sY) * current[i];
      }
    }

    return temp;
  }

  function pathRender(context, path, l, t, sX, sY) {
    var current,
        // current instruction
    previous = null,
        x = 0,
        // current x
    y = 0,
        // current y
    controlX = 0,
        // current control point x
    controlY = 0,
        // current control point y
    tempX,
        tempY,
        tempControlX,
        tempControlY;
    if (l == null) l = 0;
    if (t == null) t = 0;
    if (sX == null) sX = 1;
    if (sY == null) sY = sX;
    if (context.beginPath) context.beginPath();

    for (var i = 0, len = path.length; i < len; ++i) {
      current = path[i];

      if (sX !== 1 || sY !== 1) {
        current = scale$1$1(current, sX, sY);
      }

      switch (current[0]) {
        // first letter
        case 'l':
          // lineto, relative
          x += current[1];
          y += current[2];
          context.lineTo(x + l, y + t);
          break;

        case 'L':
          // lineto, absolute
          x = current[1];
          y = current[2];
          context.lineTo(x + l, y + t);
          break;

        case 'h':
          // horizontal lineto, relative
          x += current[1];
          context.lineTo(x + l, y + t);
          break;

        case 'H':
          // horizontal lineto, absolute
          x = current[1];
          context.lineTo(x + l, y + t);
          break;

        case 'v':
          // vertical lineto, relative
          y += current[1];
          context.lineTo(x + l, y + t);
          break;

        case 'V':
          // verical lineto, absolute
          y = current[1];
          context.lineTo(x + l, y + t);
          break;

        case 'm':
          // moveTo, relative
          x += current[1];
          y += current[2];
          context.moveTo(x + l, y + t);
          break;

        case 'M':
          // moveTo, absolute
          x = current[1];
          y = current[2];
          context.moveTo(x + l, y + t);
          break;

        case 'c':
          // bezierCurveTo, relative
          tempX = x + current[5];
          tempY = y + current[6];
          controlX = x + current[3];
          controlY = y + current[4];
          context.bezierCurveTo(x + current[1] + l, // x1
          y + current[2] + t, // y1
          controlX + l, // x2
          controlY + t, // y2
          tempX + l, tempY + t);
          x = tempX;
          y = tempY;
          break;

        case 'C':
          // bezierCurveTo, absolute
          x = current[5];
          y = current[6];
          controlX = current[3];
          controlY = current[4];
          context.bezierCurveTo(current[1] + l, current[2] + t, controlX + l, controlY + t, x + l, y + t);
          break;

        case 's':
          // shorthand cubic bezierCurveTo, relative
          // transform to absolute x,y
          tempX = x + current[3];
          tempY = y + current[4]; // calculate reflection of previous control points

          controlX = 2 * x - controlX;
          controlY = 2 * y - controlY;
          context.bezierCurveTo(controlX + l, controlY + t, x + current[1] + l, y + current[2] + t, tempX + l, tempY + t); // set control point to 2nd one of this command
          // the first control point is assumed to be the reflection of
          // the second control point on the previous command relative
          // to the current point.

          controlX = x + current[1];
          controlY = y + current[2];
          x = tempX;
          y = tempY;
          break;

        case 'S':
          // shorthand cubic bezierCurveTo, absolute
          tempX = current[3];
          tempY = current[4]; // calculate reflection of previous control points

          controlX = 2 * x - controlX;
          controlY = 2 * y - controlY;
          context.bezierCurveTo(controlX + l, controlY + t, current[1] + l, current[2] + t, tempX + l, tempY + t);
          x = tempX;
          y = tempY; // set control point to 2nd one of this command
          // the first control point is assumed to be the reflection of
          // the second control point on the previous command relative
          // to the current point.

          controlX = current[1];
          controlY = current[2];
          break;

        case 'q':
          // quadraticCurveTo, relative
          // transform to absolute x,y
          tempX = x + current[3];
          tempY = y + current[4];
          controlX = x + current[1];
          controlY = y + current[2];
          context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
          x = tempX;
          y = tempY;
          break;

        case 'Q':
          // quadraticCurveTo, absolute
          tempX = current[3];
          tempY = current[4];
          context.quadraticCurveTo(current[1] + l, current[2] + t, tempX + l, tempY + t);
          x = tempX;
          y = tempY;
          controlX = current[1];
          controlY = current[2];
          break;

        case 't':
          // shorthand quadraticCurveTo, relative
          // transform to absolute x,y
          tempX = x + current[1];
          tempY = y + current[2];

          if (previous[0].match(/[QqTt]/) === null) {
            // If there is no previous command or if the previous command was not a Q, q, T or t,
            // assume the control point is coincident with the current point
            controlX = x;
            controlY = y;
          } else if (previous[0] === 't') {
            // calculate reflection of previous control points for t
            controlX = 2 * x - tempControlX;
            controlY = 2 * y - tempControlY;
          } else if (previous[0] === 'q') {
            // calculate reflection of previous control points for q
            controlX = 2 * x - controlX;
            controlY = 2 * y - controlY;
          }

          tempControlX = controlX;
          tempControlY = controlY;
          context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
          x = tempX;
          y = tempY;
          controlX = x + current[1];
          controlY = y + current[2];
          break;

        case 'T':
          tempX = current[1];
          tempY = current[2]; // calculate reflection of previous control points

          controlX = 2 * x - controlX;
          controlY = 2 * y - controlY;
          context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
          x = tempX;
          y = tempY;
          break;

        case 'a':
          drawArc(context, x + l, y + t, [current[1], current[2], current[3], current[4], current[5], current[6] + x + l, current[7] + y + t]);
          x += current[6];
          y += current[7];
          break;

        case 'A':
          drawArc(context, x + l, y + t, [current[1], current[2], current[3], current[4], current[5], current[6] + l, current[7] + t]);
          x = current[6];
          y = current[7];
          break;

        case 'z':
        case 'Z':
          context.closePath();
          break;
      }

      previous = current;
    }
  }

  function drawArc(context, x, y, coords) {
    const seg = segments(coords[5], // end x
    coords[6], // end y
    coords[0], // radius x
    coords[1], // radius y
    coords[3], // large flag
    coords[4], // sweep flag
    coords[2], // rotation
    x, y);

    for (let i = 0; i < seg.length; ++i) {
      const bez = bezier(seg[i]);
      context.bezierCurveTo(bez[0], bez[1], bez[2], bez[3], bez[4], bez[5]);
    }
  }

  const Tan30 = 0.5773502691896257;
  const builtins = {
    'circle': {
      draw: function (context, size) {
        const r = Math.sqrt(size) / 2;
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, Tau);
      }
    },
    'cross': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            s = r / 2.5;
        context.moveTo(-r, -s);
        context.lineTo(-r, s);
        context.lineTo(-s, s);
        context.lineTo(-s, r);
        context.lineTo(s, r);
        context.lineTo(s, s);
        context.lineTo(r, s);
        context.lineTo(r, -s);
        context.lineTo(s, -s);
        context.lineTo(s, -r);
        context.lineTo(-s, -r);
        context.lineTo(-s, -s);
        context.closePath();
      }
    },
    'diamond': {
      draw: function (context, size) {
        const r = Math.sqrt(size) / 2;
        context.moveTo(-r, 0);
        context.lineTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.closePath();
      }
    },
    'square': {
      draw: function (context, size) {
        var w = Math.sqrt(size),
            x = -w / 2;
        context.rect(x, x, w, w);
      }
    },
    'arrow': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            s = r / 7,
            t = r / 2.5,
            v = r / 8;
        context.moveTo(-s, r);
        context.lineTo(s, r);
        context.lineTo(s, -v);
        context.lineTo(t, -v);
        context.lineTo(0, -r);
        context.lineTo(-t, -v);
        context.lineTo(-s, -v);
        context.closePath();
      }
    },
    'wedge': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            h = HalfSqrt3 * r,
            o = h - r * Tan30,
            b = r / 4;
        context.moveTo(0, -h - o);
        context.lineTo(-b, h - o);
        context.lineTo(b, h - o);
        context.closePath();
      }
    },
    'triangle': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            h = HalfSqrt3 * r,
            o = h - r * Tan30;
        context.moveTo(0, -h - o);
        context.lineTo(-r, h - o);
        context.lineTo(r, h - o);
        context.closePath();
      }
    },
    'triangle-up': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            h = HalfSqrt3 * r;
        context.moveTo(0, -h);
        context.lineTo(-r, h);
        context.lineTo(r, h);
        context.closePath();
      }
    },
    'triangle-down': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            h = HalfSqrt3 * r;
        context.moveTo(0, h);
        context.lineTo(-r, -h);
        context.lineTo(r, -h);
        context.closePath();
      }
    },
    'triangle-right': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            h = HalfSqrt3 * r;
        context.moveTo(h, 0);
        context.lineTo(-h, -r);
        context.lineTo(-h, r);
        context.closePath();
      }
    },
    'triangle-left': {
      draw: function (context, size) {
        var r = Math.sqrt(size) / 2,
            h = HalfSqrt3 * r;
        context.moveTo(-h, 0);
        context.lineTo(h, -r);
        context.lineTo(h, r);
        context.closePath();
      }
    },
    'stroke': {
      draw: function (context, size) {
        const r = Math.sqrt(size) / 2;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
      }
    }
  };

  function symbols(_) {
    return has$1(builtins, _) ? builtins[_] : customSymbol(_);
  }

  var custom = {};

  function customSymbol(path) {
    if (!has$1(custom, path)) {
      const parsed = pathParse(path);
      custom[path] = {
        draw: function (context, size) {
          pathRender(context, parsed, 0, 0, Math.sqrt(size) / 2);
        }
      };
    }

    return custom[path];
  }

  const C = 0.448084975506; // C = 1 - c

  function rectangleX(d) {
    return d.x;
  }

  function rectangleY(d) {
    return d.y;
  }

  function rectangleWidth(d) {
    return d.width;
  }

  function rectangleHeight(d) {
    return d.height;
  }

  function number$3(_) {
    return typeof _ === 'function' ? _ : () => +_;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function vg_rect() {
    var x = rectangleX,
        y = rectangleY,
        width = rectangleWidth,
        height = rectangleHeight,
        crTL = number$3(0),
        crTR = crTL,
        crBL = crTL,
        crBR = crTL,
        context = null;

    function rectangle(_, x0, y0) {
      var buffer,
          x1 = x0 != null ? x0 : +x.call(this, _),
          y1 = y0 != null ? y0 : +y.call(this, _),
          w = +width.call(this, _),
          h = +height.call(this, _),
          s = Math.min(w, h) / 2,
          tl = clamp(+crTL.call(this, _), 0, s),
          tr = clamp(+crTR.call(this, _), 0, s),
          bl = clamp(+crBL.call(this, _), 0, s),
          br = clamp(+crBR.call(this, _), 0, s);
      if (!context) context = buffer = path$3();

      if (tl <= 0 && tr <= 0 && bl <= 0 && br <= 0) {
        context.rect(x1, y1, w, h);
      } else {
        var x2 = x1 + w,
            y2 = y1 + h;
        context.moveTo(x1 + tl, y1);
        context.lineTo(x2 - tr, y1);
        context.bezierCurveTo(x2 - C * tr, y1, x2, y1 + C * tr, x2, y1 + tr);
        context.lineTo(x2, y2 - br);
        context.bezierCurveTo(x2, y2 - C * br, x2 - C * br, y2, x2 - br, y2);
        context.lineTo(x1 + bl, y2);
        context.bezierCurveTo(x1 + C * bl, y2, x1, y2 - C * bl, x1, y2 - bl);
        context.lineTo(x1, y1 + tl);
        context.bezierCurveTo(x1, y1 + C * tl, x1 + C * tl, y1, x1 + tl, y1);
        context.closePath();
      }

      if (buffer) {
        context = null;
        return buffer + '' || null;
      }
    }

    rectangle.x = function (_) {
      if (arguments.length) {
        x = number$3(_);
        return rectangle;
      } else {
        return x;
      }
    };

    rectangle.y = function (_) {
      if (arguments.length) {
        y = number$3(_);
        return rectangle;
      } else {
        return y;
      }
    };

    rectangle.width = function (_) {
      if (arguments.length) {
        width = number$3(_);
        return rectangle;
      } else {
        return width;
      }
    };

    rectangle.height = function (_) {
      if (arguments.length) {
        height = number$3(_);
        return rectangle;
      } else {
        return height;
      }
    };

    rectangle.cornerRadius = function (tl, tr, br, bl) {
      if (arguments.length) {
        crTL = number$3(tl);
        crTR = tr != null ? number$3(tr) : crTL;
        crBR = br != null ? number$3(br) : crTL;
        crBL = bl != null ? number$3(bl) : crTR;
        return rectangle;
      } else {
        return crTL;
      }
    };

    rectangle.context = function (_) {
      if (arguments.length) {
        context = _ == null ? null : _;
        return rectangle;
      } else {
        return context;
      }
    };

    return rectangle;
  }

  function vg_trail() {
    var x,
        y,
        size,
        defined,
        context = null,
        ready,
        x1,
        y1,
        r1;

    function point(x2, y2, w2) {
      const r2 = w2 / 2;

      if (ready) {
        var ux = y1 - y2,
            uy = x2 - x1;

        if (ux || uy) {
          // get normal vector
          var ud = Math.sqrt(ux * ux + uy * uy),
              rx = (ux /= ud) * r1,
              ry = (uy /= ud) * r1,
              t = Math.atan2(uy, ux); // draw segment

          context.moveTo(x1 - rx, y1 - ry);
          context.lineTo(x2 - ux * r2, y2 - uy * r2);
          context.arc(x2, y2, r2, t - Math.PI, t);
          context.lineTo(x1 + rx, y1 + ry);
          context.arc(x1, y1, r1, t, t + Math.PI);
        } else {
          context.arc(x2, y2, r2, 0, Tau);
        }

        context.closePath();
      } else {
        ready = 1;
      }

      x1 = x2;
      y1 = y2;
      r1 = r2;
    }

    function trail(data) {
      var i,
          n = data.length,
          d,
          defined0 = false,
          buffer;
      if (context == null) context = buffer = path$3();

      for (i = 0; i <= n; ++i) {
        if (!(i < n && defined(d = data[i], i, data)) === defined0) {
          if (defined0 = !defined0) ready = 0;
        }

        if (defined0) point(+x(d, i, data), +y(d, i, data), +size(d, i, data));
      }

      if (buffer) {
        context = null;
        return buffer + '' || null;
      }
    }

    trail.x = function (_) {
      if (arguments.length) {
        x = _;
        return trail;
      } else {
        return x;
      }
    };

    trail.y = function (_) {
      if (arguments.length) {
        y = _;
        return trail;
      } else {
        return y;
      }
    };

    trail.size = function (_) {
      if (arguments.length) {
        size = _;
        return trail;
      } else {
        return size;
      }
    };

    trail.defined = function (_) {
      if (arguments.length) {
        defined = _;
        return trail;
      } else {
        return defined;
      }
    };

    trail.context = function (_) {
      if (arguments.length) {
        if (_ == null) {
          context = null;
        } else {
          context = _;
        }

        return trail;
      } else {
        return context;
      }
    };

    return trail;
  }

  function value$1(a, b) {
    return a != null ? a : b;
  }

  const x$2 = item => item.x || 0,
        y$2 = item => item.y || 0,
        w = item => item.width || 0,
        h = item => item.height || 0,
        xw = item => (item.x || 0) + (item.width || 0),
        yh = item => (item.y || 0) + (item.height || 0),
        sa = item => item.startAngle || 0,
        ea = item => item.endAngle || 0,
        pa = item => item.padAngle || 0,
        ir = item => item.innerRadius || 0,
        or = item => item.outerRadius || 0,
        cr = item => item.cornerRadius || 0,
        tl = item => value$1(item.cornerRadiusTopLeft, item.cornerRadius) || 0,
        tr = item => value$1(item.cornerRadiusTopRight, item.cornerRadius) || 0,
        br = item => value$1(item.cornerRadiusBottomRight, item.cornerRadius) || 0,
        bl = item => value$1(item.cornerRadiusBottomLeft, item.cornerRadius) || 0,
        sz = item => value$1(item.size, 64),
        ts = item => item.size || 1,
        def = item => !(item.defined === false),
        type = item => symbols(item.shape || 'circle');

  const arcShape = arc$2$1().startAngle(sa).endAngle(ea).padAngle(pa).innerRadius(ir).outerRadius(or).cornerRadius(cr),
        areavShape = area$2$1().x(x$2).y1(y$2).y0(yh).defined(def),
        areahShape = area$2$1().y(y$2).x1(x$2).x0(xw).defined(def),
        lineShape = line$2$1().x(x$2).y(y$2).defined(def),
        rectShape = vg_rect().x(x$2).y(y$2).width(w).height(h).cornerRadius(tl, tr, br, bl),
        symbolShape = symbol$2().type(type).size(sz),
        trailShape = vg_trail().x(x$2).y(y$2).defined(def).size(ts);

  function hasCornerRadius(item) {
    return item.cornerRadius || item.cornerRadiusTopLeft || item.cornerRadiusTopRight || item.cornerRadiusBottomRight || item.cornerRadiusBottomLeft;
  }

  function arc$1(context, item) {
    return arcShape.context(context)(item);
  }

  function area$1(context, items) {
    const item = items[0],
          interp = item.interpolate || 'linear';
    return (item.orient === 'horizontal' ? areahShape : areavShape).curve(curves(interp, item.orient, item.tension)).context(context)(items);
  }

  function line$1(context, items) {
    const item = items[0],
          interp = item.interpolate || 'linear';
    return lineShape.curve(curves(interp, item.orient, item.tension)).context(context)(items);
  }

  function rectangle(context, item, x, y) {
    return rectShape.context(context)(item, x, y);
  }

  function shape$1(context, item) {
    return (item.mark.shape || item.shape).context(context)(item);
  }

  function symbol$1(context, item) {
    return symbolShape.context(context)(item);
  }

  function trail$1(context, items) {
    return trailShape.context(context)(items);
  }

  var clip_id = 1;

  function resetSVGClipId() {
    clip_id = 1;
  }

  function clip$1$1(renderer, item, size) {
    var clip = item.clip,
        defs = renderer._defs,
        id = item.clip_id || (item.clip_id = 'clip' + clip_id++),
        c = defs.clipping[id] || (defs.clipping[id] = {
      id: id
    });

    if (isFunction(clip)) {
      c.path = clip(null);
    } else if (hasCornerRadius(size)) {
      c.path = rectangle(null, size, 0, 0);
    } else {
      c.width = size.width || 0;
      c.height = size.height || 0;
    }

    return 'url(#' + id + ')';
  }

  function Bounds(b) {
    this.clear();
    if (b) this.union(b);
  }

  Bounds.prototype = {
    clone() {
      return new Bounds(this);
    },

    clear() {
      this.x1 = +Number.MAX_VALUE;
      this.y1 = +Number.MAX_VALUE;
      this.x2 = -Number.MAX_VALUE;
      this.y2 = -Number.MAX_VALUE;
      return this;
    },

    empty() {
      return this.x1 === +Number.MAX_VALUE && this.y1 === +Number.MAX_VALUE && this.x2 === -Number.MAX_VALUE && this.y2 === -Number.MAX_VALUE;
    },

    equals(b) {
      return this.x1 === b.x1 && this.y1 === b.y1 && this.x2 === b.x2 && this.y2 === b.y2;
    },

    set(x1, y1, x2, y2) {
      if (x2 < x1) {
        this.x2 = x1;
        this.x1 = x2;
      } else {
        this.x1 = x1;
        this.x2 = x2;
      }

      if (y2 < y1) {
        this.y2 = y1;
        this.y1 = y2;
      } else {
        this.y1 = y1;
        this.y2 = y2;
      }

      return this;
    },

    add(x, y) {
      if (x < this.x1) this.x1 = x;
      if (y < this.y1) this.y1 = y;
      if (x > this.x2) this.x2 = x;
      if (y > this.y2) this.y2 = y;
      return this;
    },

    expand(d) {
      this.x1 -= d;
      this.y1 -= d;
      this.x2 += d;
      this.y2 += d;
      return this;
    },

    round() {
      this.x1 = Math.floor(this.x1);
      this.y1 = Math.floor(this.y1);
      this.x2 = Math.ceil(this.x2);
      this.y2 = Math.ceil(this.y2);
      return this;
    },

    scale(s) {
      this.x1 *= s;
      this.y1 *= s;
      this.x2 *= s;
      this.y2 *= s;
      return this;
    },

    translate(dx, dy) {
      this.x1 += dx;
      this.x2 += dx;
      this.y1 += dy;
      this.y2 += dy;
      return this;
    },

    rotate(angle, x, y) {
      const p = this.rotatedPoints(angle, x, y);
      return this.clear().add(p[0], p[1]).add(p[2], p[3]).add(p[4], p[5]).add(p[6], p[7]);
    },

    rotatedPoints(angle, x, y) {
      var {
        x1,
        y1,
        x2,
        y2
      } = this,
          cos = Math.cos(angle),
          sin = Math.sin(angle),
          cx = x - x * cos + y * sin,
          cy = y - x * sin - y * cos;
      return [cos * x1 - sin * y1 + cx, sin * x1 + cos * y1 + cy, cos * x1 - sin * y2 + cx, sin * x1 + cos * y2 + cy, cos * x2 - sin * y1 + cx, sin * x2 + cos * y1 + cy, cos * x2 - sin * y2 + cx, sin * x2 + cos * y2 + cy];
    },

    union(b) {
      if (b.x1 < this.x1) this.x1 = b.x1;
      if (b.y1 < this.y1) this.y1 = b.y1;
      if (b.x2 > this.x2) this.x2 = b.x2;
      if (b.y2 > this.y2) this.y2 = b.y2;
      return this;
    },

    intersect(b) {
      if (b.x1 > this.x1) this.x1 = b.x1;
      if (b.y1 > this.y1) this.y1 = b.y1;
      if (b.x2 < this.x2) this.x2 = b.x2;
      if (b.y2 < this.y2) this.y2 = b.y2;
      return this;
    },

    encloses(b) {
      return b && this.x1 <= b.x1 && this.x2 >= b.x2 && this.y1 <= b.y1 && this.y2 >= b.y2;
    },

    alignsWith(b) {
      return b && (this.x1 == b.x1 || this.x2 == b.x2 || this.y1 == b.y1 || this.y2 == b.y2);
    },

    intersects(b) {
      return b && !(this.x2 < b.x1 || this.x1 > b.x2 || this.y2 < b.y1 || this.y1 > b.y2);
    },

    contains(x, y) {
      return !(x < this.x1 || x > this.x2 || y < this.y1 || y > this.y2);
    },

    width() {
      return this.x2 - this.x1;
    },

    height() {
      return this.y2 - this.y1;
    }

  };

  function Item(mark) {
    this.mark = mark;
    this.bounds = this.bounds || new Bounds();
  }

  function GroupItem(mark) {
    Item.call(this, mark);
    this.items = this.items || [];
  }

  inherits(GroupItem, Item);

  function ResourceLoader(customLoader) {
    this._pending = 0;
    this._loader = customLoader || loader();
  }

  function increment(loader) {
    loader._pending += 1;
  }

  function decrement(loader) {
    loader._pending -= 1;
  }

  ResourceLoader.prototype = {
    pending() {
      return this._pending;
    },

    sanitizeURL(uri) {
      const loader = this;
      increment(loader);
      return loader._loader.sanitize(uri, {
        context: 'href'
      }).then(opt => {
        decrement(loader);
        return opt;
      }).catch(() => {
        decrement(loader);
        return null;
      });
    },

    loadImage(uri) {
      const loader = this,
            Image = image$1();
      increment(loader);
      return loader._loader.sanitize(uri, {
        context: 'image'
      }).then(opt => {
        const url = opt.href;
        if (!url || !Image) throw {
          url: url
        };
        const img = new Image(); // set crossOrigin only if cors is defined; empty string sets anonymous mode
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/crossOrigin

        const cors = has$1(opt, 'crossOrigin') ? opt.crossOrigin : 'anonymous';
        if (cors != null) img.crossOrigin = cors; // attempt to load image resource

        img.onload = () => decrement(loader);

        img.onerror = () => decrement(loader);

        img.src = url;
        return img;
      }).catch(e => {
        decrement(loader);
        return {
          complete: false,
          width: 0,
          height: 0,
          src: e && e.url || ''
        };
      });
    },

    ready() {
      const loader = this;
      return new Promise(accept => {
        function poll(value) {
          if (!loader.pending()) accept(value);else setTimeout(() => {
            poll(true);
          }, 10);
        }

        poll(false);
      });
    }

  };

  function boundStroke(bounds, item, miter) {
    if (item.stroke && item.opacity !== 0 && item.strokeOpacity !== 0) {
      const sw = item.strokeWidth != null ? +item.strokeWidth : 1;
      bounds.expand(sw + (miter ? miterAdjustment(item, sw) : 0));
    }

    return bounds;
  }

  function miterAdjustment(item, strokeWidth) {
    // TODO: more sophisticated adjustment? Or miter support in boundContext?
    return item.strokeJoin && item.strokeJoin !== 'miter' ? 0 : strokeWidth;
  }

  const circleThreshold = Tau - 1e-8;
  let bounds, lx, ly, rot, ma, mb, mc, md;

  const add$1 = (x, y) => bounds.add(x, y);

  const addL = (x, y) => add$1(lx = x, ly = y);

  const addX = x => add$1(x, bounds.y1);

  const addY = y => add$1(bounds.x1, y);

  const px = (x, y) => ma * x + mc * y;

  const py = (x, y) => mb * x + md * y;

  const addp = (x, y) => add$1(px(x, y), py(x, y));

  const addpL = (x, y) => addL(px(x, y), py(x, y));

  function boundContext(_, deg) {
    bounds = _;

    if (deg) {
      rot = deg * DegToRad;
      ma = md = Math.cos(rot);
      mb = Math.sin(rot);
      mc = -mb;
    } else {
      ma = md = 1;
      rot = mb = mc = 0;
    }

    return context$1;
  }

  const context$1 = {
    beginPath() {},

    closePath() {},

    moveTo: addpL,
    lineTo: addpL,

    rect(x, y, w, h) {
      if (rot) {
        addp(x + w, y);
        addp(x + w, y + h);
        addp(x, y + h);
        addpL(x, y);
      } else {
        add$1(x + w, y + h);
        addL(x, y);
      }
    },

    quadraticCurveTo(x1, y1, x2, y2) {
      const px1 = px(x1, y1),
            py1 = py(x1, y1),
            px2 = px(x2, y2),
            py2 = py(x2, y2);
      quadExtrema(lx, px1, px2, addX);
      quadExtrema(ly, py1, py2, addY);
      addL(px2, py2);
    },

    bezierCurveTo(x1, y1, x2, y2, x3, y3) {
      const px1 = px(x1, y1),
            py1 = py(x1, y1),
            px2 = px(x2, y2),
            py2 = py(x2, y2),
            px3 = px(x3, y3),
            py3 = py(x3, y3);
      cubicExtrema(lx, px1, px2, px3, addX);
      cubicExtrema(ly, py1, py2, py3, addY);
      addL(px3, py3);
    },

    arc(cx, cy, r, sa, ea, ccw) {
      sa += rot;
      ea += rot; // store last point on path

      lx = r * Math.cos(ea) + cx;
      ly = r * Math.sin(ea) + cy;

      if (Math.abs(ea - sa) > circleThreshold) {
        // treat as full circle
        add$1(cx - r, cy - r);
        add$1(cx + r, cy + r);
      } else {
        const update = a => add$1(r * Math.cos(a) + cx, r * Math.sin(a) + cy);

        let s, i; // sample end points

        update(sa);
        update(ea); // sample interior points aligned with 90 degrees

        if (ea !== sa) {
          sa = sa % Tau;
          if (sa < 0) sa += Tau;
          ea = ea % Tau;
          if (ea < 0) ea += Tau;

          if (ea < sa) {
            ccw = !ccw; // flip direction

            s = sa;
            sa = ea;
            ea = s; // swap end-points
          }

          if (ccw) {
            ea -= Tau;
            s = sa - sa % HalfPi;

            for (i = 0; i < 4 && s > ea; ++i, s -= HalfPi) update(s);
          } else {
            s = sa - sa % HalfPi + HalfPi;

            for (i = 0; i < 4 && s < ea; ++i, s = s + HalfPi) update(s);
          }
        }
      }
    }

  };

  function quadExtrema(x0, x1, x2, cb) {
    const t = (x0 - x1) / (x0 + x2 - 2 * x1);
    if (0 < t && t < 1) cb(x0 + (x1 - x0) * t);
  }

  function cubicExtrema(x0, x1, x2, x3, cb) {
    const a = x3 - x0 + 3 * x1 - 3 * x2,
          b = x0 + x2 - 2 * x1,
          c = x0 - x1;
    let t0 = 0,
        t1 = 0,
        r; // solve for parameter t

    if (Math.abs(a) > Epsilon) {
      // quadratic equation
      r = b * b + c * a;

      if (r >= 0) {
        r = Math.sqrt(r);
        t0 = (-b + r) / a;
        t1 = (-b - r) / a;
      }
    } else {
      // linear equation
      t0 = 0.5 * c / b;
    } // calculate position


    if (0 < t0 && t0 < 1) cb(cubic(t0, x0, x1, x2, x3));
    if (0 < t1 && t1 < 1) cb(cubic(t1, x0, x1, x2, x3));
  }

  function cubic(t, x0, x1, x2, x3) {
    const s = 1 - t,
          s2 = s * s,
          t2 = t * t;
    return s2 * s * x0 + 3 * s2 * t * x1 + 3 * s * t2 * x2 + t2 * t * x3;
  }

  var context$2 = (context$2 = canvas(1, 1)) ? context$2.getContext('2d') : null;
  const b = new Bounds();

  function intersectPath(draw) {
    return function (item, brush) {
      // rely on (inaccurate) bounds intersection if no context
      if (!context$2) return true; // add path to offscreen graphics context

      draw(context$2, item); // get bounds intersection region

      b.clear().union(item.bounds).intersect(brush).round();
      const {
        x1,
        y1,
        x2,
        y2
      } = b; // iterate over intersection region
      // perform fine grained inclusion test

      for (let y = y1; y <= y2; ++y) {
        for (let x = x1; x <= x2; ++x) {
          if (context$2.isPointInPath(x, y)) {
            return true;
          }
        }
      } // false if no hits in intersection region


      return false;
    };
  }

  function intersectPoint(item, box) {
    return box.contains(item.x || 0, item.y || 0);
  }

  function intersectRect(item, box) {
    const x = item.x || 0,
          y = item.y || 0,
          w = item.width || 0,
          h = item.height || 0;
    return box.intersects(b.set(x, y, x + w, y + h));
  }

  function intersectRule(item, box) {
    const x = item.x || 0,
          y = item.y || 0,
          x2 = item.x2 != null ? item.x2 : x,
          y2 = item.y2 != null ? item.y2 : y;
    return intersectBoxLine(box, x, y, x2, y2);
  }

  function intersectBoxLine(box, x, y, u, v) {
    const {
      x1,
      y1,
      x2,
      y2
    } = box,
          dx = u - x,
          dy = v - y;
    let t0 = 0,
        t1 = 1,
        p,
        q,
        r,
        e;

    for (e = 0; e < 4; ++e) {
      if (e === 0) {
        p = -dx;
        q = -(x1 - x);
      }

      if (e === 1) {
        p = dx;
        q = x2 - x;
      }

      if (e === 2) {
        p = -dy;
        q = -(y1 - y);
      }

      if (e === 3) {
        p = dy;
        q = y2 - y;
      }

      if (Math.abs(p) < 1e-10 && q < 0) return false;
      r = q / p;

      if (p < 0) {
        if (r > t1) return false;else if (r > t0) t0 = r;
      } else if (p > 0) {
        if (r < t0) return false;else if (r < t1) t1 = r;
      }
    }

    return true;
  }

  function blend(context, item) {
    context.globalCompositeOperation = item.blend || 'source-over';
  }

  function value$2(value, dflt) {
    return value == null ? dflt : value;
  }

  function addStops(gradient, stops) {
    const n = stops.length;

    for (let i = 0; i < n; ++i) {
      gradient.addColorStop(stops[i].offset, stops[i].color);
    }

    return gradient;
  }

  function gradient$1(context, spec, bounds) {
    const w = bounds.width(),
          h = bounds.height();
    let gradient;

    if (spec.gradient === 'radial') {
      gradient = context.createRadialGradient(bounds.x1 + value$2(spec.x1, 0.5) * w, bounds.y1 + value$2(spec.y1, 0.5) * h, Math.max(w, h) * value$2(spec.r1, 0), bounds.x1 + value$2(spec.x2, 0.5) * w, bounds.y1 + value$2(spec.y2, 0.5) * h, Math.max(w, h) * value$2(spec.r2, 0.5));
    } else {
      // linear gradient
      const x1 = value$2(spec.x1, 0),
            y1 = value$2(spec.y1, 0),
            x2 = value$2(spec.x2, 1),
            y2 = value$2(spec.y2, 0);

      if (x1 === x2 || y1 === y2 || w === h) {
        // axis aligned: use normal gradient
        gradient = context.createLinearGradient(bounds.x1 + x1 * w, bounds.y1 + y1 * h, bounds.x1 + x2 * w, bounds.y1 + y2 * h);
      } else {
        // not axis aligned: render gradient into a pattern (#2365)
        // this allows us to use normalized bounding box coordinates
        const image = canvas(Math.ceil(w), Math.ceil(h)),
              ictx = image.getContext('2d');
        ictx.scale(w, h);
        ictx.fillStyle = addStops(ictx.createLinearGradient(x1, y1, x2, y2), spec.stops);
        ictx.fillRect(0, 0, w, h);
        return context.createPattern(image, 'no-repeat');
      }
    }

    return addStops(gradient, spec.stops);
  }

  function color$1(context, item, value) {
    return isGradient(value) ? gradient$1(context, value, item.bounds) : value;
  }

  function fill(context, item, opacity) {
    opacity *= item.fillOpacity == null ? 1 : item.fillOpacity;

    if (opacity > 0) {
      context.globalAlpha = opacity;
      context.fillStyle = color$1(context, item, item.fill);
      return true;
    } else {
      return false;
    }
  }

  var Empty = [];

  function stroke(context, item, opacity) {
    var lw = (lw = item.strokeWidth) != null ? lw : 1;
    if (lw <= 0) return false;
    opacity *= item.strokeOpacity == null ? 1 : item.strokeOpacity;

    if (opacity > 0) {
      context.globalAlpha = opacity;
      context.strokeStyle = color$1(context, item, item.stroke);
      context.lineWidth = lw;
      context.lineCap = item.strokeCap || 'butt';
      context.lineJoin = item.strokeJoin || 'miter';
      context.miterLimit = item.strokeMiterLimit || 10;

      if (context.setLineDash) {
        context.setLineDash(item.strokeDash || Empty);
        context.lineDashOffset = item.strokeDashOffset || 0;
      }

      return true;
    } else {
      return false;
    }
  }

  function compare(a, b) {
    return a.zindex - b.zindex || a.index - b.index;
  }

  function zorder(scene) {
    if (!scene.zdirty) return scene.zitems;
    var items = scene.items,
        output = [],
        item,
        i,
        n;

    for (i = 0, n = items.length; i < n; ++i) {
      item = items[i];
      item.index = i;
      if (item.zindex) output.push(item);
    }

    scene.zdirty = false;
    return scene.zitems = output.sort(compare);
  }

  function visit(scene, visitor) {
    var items = scene.items,
        i,
        n;
    if (!items || !items.length) return;
    const zitems = zorder(scene);

    if (zitems && zitems.length) {
      for (i = 0, n = items.length; i < n; ++i) {
        if (!items[i].zindex) visitor(items[i]);
      }

      items = zitems;
    }

    for (i = 0, n = items.length; i < n; ++i) {
      visitor(items[i]);
    }
  }

  function pickVisit(scene, visitor) {
    var items = scene.items,
        hit,
        i;
    if (!items || !items.length) return null;
    const zitems = zorder(scene);
    if (zitems && zitems.length) items = zitems;

    for (i = items.length; --i >= 0;) {
      if (hit = visitor(items[i])) return hit;
    }

    if (items === zitems) {
      for (items = scene.items, i = items.length; --i >= 0;) {
        if (!items[i].zindex) {
          if (hit = visitor(items[i])) return hit;
        }
      }
    }

    return null;
  }

  function drawAll(path) {
    return function (context, scene, bounds) {
      visit(scene, item => {
        if (!bounds || bounds.intersects(item.bounds)) {
          drawPath(path, context, item, item);
        }
      });
    };
  }

  function drawOne(path) {
    return function (context, scene, bounds) {
      if (scene.items.length && (!bounds || bounds.intersects(scene.bounds))) {
        drawPath(path, context, scene.items[0], scene.items);
      }
    };
  }

  function drawPath(path, context, item, items) {
    var opacity = item.opacity == null ? 1 : item.opacity;
    if (opacity === 0) return;
    if (path(context, items)) return;
    blend(context, item);

    if (item.fill && fill(context, item, opacity)) {
      context.fill();
    }

    if (item.stroke && stroke(context, item, opacity)) {
      context.stroke();
    }
  }

  function pick$1(test) {
    test = test || truthy;
    return function (context, scene, x, y, gx, gy) {
      x *= context.pixelRatio;
      y *= context.pixelRatio;
      return pickVisit(scene, item => {
        const b = item.bounds; // first hit test against bounding box

        if (b && !b.contains(gx, gy) || !b) return; // if in bounding box, perform more careful test

        if (test(context, item, x, y, gx, gy)) return item;
      });
    };
  }

  function hitPath(path, filled) {
    return function (context, o, x, y) {
      var item = Array.isArray(o) ? o[0] : o,
          fill = filled == null ? item.fill : filled,
          stroke = item.stroke && context.isPointInStroke,
          lw,
          lc;

      if (stroke) {
        lw = item.strokeWidth;
        lc = item.strokeCap;
        context.lineWidth = lw != null ? lw : 1;
        context.lineCap = lc != null ? lc : 'butt';
      }

      return path(context, o) ? false : fill && context.isPointInPath(x, y) || stroke && context.isPointInStroke(x, y);
    };
  }

  function pickPath(path) {
    return pick$1(hitPath(path));
  }

  function translate$1(x, y) {
    return 'translate(' + x + ',' + y + ')';
  }

  function rotate(a) {
    return 'rotate(' + a + ')';
  }

  function scale$3(scaleX, scaleY) {
    return 'scale(' + scaleX + ',' + scaleY + ')';
  }

  function translateItem(item) {
    return translate$1(item.x || 0, item.y || 0);
  }

  function rotateItem(item) {
    return translate$1(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '');
  }

  function transformItem(item) {
    return translate$1(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '') + (item.scaleX || item.scaleY ? ' ' + scale$3(item.scaleX || 1, item.scaleY || 1) : '');
  }

  function markItemPath(type, shape, isect) {
    function attr(emit, item) {
      emit('transform', rotateItem(item));
      emit('d', shape(null, item));
    }

    function bound(bounds, item) {
      shape(boundContext(bounds, item.angle), item);
      return boundStroke(bounds, item).translate(item.x || 0, item.y || 0);
    }

    function draw(context, item) {
      var x = item.x || 0,
          y = item.y || 0,
          a = item.angle || 0;
      context.translate(x, y);
      if (a) context.rotate(a *= DegToRad);
      context.beginPath();
      shape(context, item);
      if (a) context.rotate(-a);
      context.translate(-x, -y);
    }

    return {
      type: type,
      tag: 'path',
      nested: false,
      attr: attr,
      bound: bound,
      draw: drawAll(draw),
      pick: pickPath(draw),
      isect: isect || intersectPath(draw)
    };
  }

  var arc$2 = markItemPath('arc', arc$1);

  function pickArea(a, p) {
    var v = a[0].orient === 'horizontal' ? p[1] : p[0],
        z = a[0].orient === 'horizontal' ? 'y' : 'x',
        i = a.length,
        min = +Infinity,
        hit,
        d;

    while (--i >= 0) {
      if (a[i].defined === false) continue;
      d = Math.abs(a[i][z] - v);

      if (d < min) {
        min = d;
        hit = a[i];
      }
    }

    return hit;
  }

  function pickLine(a, p) {
    var t = Math.pow(a[0].strokeWidth || 1, 2),
        i = a.length,
        dx,
        dy,
        dd;

    while (--i >= 0) {
      if (a[i].defined === false) continue;
      dx = a[i].x - p[0];
      dy = a[i].y - p[1];
      dd = dx * dx + dy * dy;
      if (dd < t) return a[i];
    }

    return null;
  }

  function pickTrail(a, p) {
    var i = a.length,
        dx,
        dy,
        dd;

    while (--i >= 0) {
      if (a[i].defined === false) continue;
      dx = a[i].x - p[0];
      dy = a[i].y - p[1];
      dd = dx * dx + dy * dy;
      dx = a[i].size || 1;
      if (dd < dx * dx) return a[i];
    }

    return null;
  }

  function markMultiItemPath(type, shape, tip) {
    function attr(emit, item) {
      var items = item.mark.items;
      if (items.length) emit('d', shape(null, items));
    }

    function bound(bounds, mark) {
      var items = mark.items;

      if (items.length === 0) {
        return bounds;
      } else {
        shape(boundContext(bounds), items);
        return boundStroke(bounds, items[0]);
      }
    }

    function draw(context, items) {
      context.beginPath();
      shape(context, items);
    }

    const hit = hitPath(draw);

    function pick(context, scene, x, y, gx, gy) {
      var items = scene.items,
          b = scene.bounds;

      if (!items || !items.length || b && !b.contains(gx, gy)) {
        return null;
      }

      x *= context.pixelRatio;
      y *= context.pixelRatio;
      return hit(context, items, x, y) ? items[0] : null;
    }

    return {
      type: type,
      tag: 'path',
      nested: true,
      attr: attr,
      bound: bound,
      draw: drawOne(draw),
      pick: pick,
      isect: intersectPoint,
      tip: tip
    };
  }

  var area$2 = markMultiItemPath('area', area$1, pickArea);

  function clip$2(context, scene) {
    var clip = scene.clip;
    context.save();

    if (isFunction(clip)) {
      context.beginPath();
      clip(context);
      context.clip();
    } else {
      clipGroup(context, scene.group);
    }
  }

  function clipGroup(context, group) {
    context.beginPath();
    hasCornerRadius(group) ? rectangle(context, group, 0, 0) : context.rect(0, 0, group.width || 0, group.height || 0);
    context.clip();
  }

  function offset$1(item) {
    const sw = value$2(item.strokeWidth, 1);
    return item.strokeOffset != null ? item.strokeOffset : item.stroke && sw > 0.5 && sw < 1.5 ? 0.5 - Math.abs(sw - 1) : 0;
  }

  function attr$5(emit, item) {
    emit('transform', translateItem(item));
  }

  function emitRectangle(emit, item) {
    const off = offset$1(item);
    emit('d', rectangle(null, item, off, off));
  }

  function background$1(emit, item) {
    emit('class', 'background');
    emit('aria-hidden', true);
    emitRectangle(emit, item);
  }

  function foreground(emit, item) {
    emit('class', 'foreground');
    emit('aria-hidden', true);

    if (item.strokeForeground) {
      emitRectangle(emit, item);
    } else {
      emit('d', '');
    }
  }

  function content(emit, item, renderer) {
    const url = item.clip ? clip$1$1(renderer, item, item) : null;
    emit('clip-path', url);
  }

  function bound$5(bounds, group) {
    if (!group.clip && group.items) {
      const items = group.items,
            m = items.length;

      for (let j = 0; j < m; ++j) {
        bounds.union(items[j].bounds);
      }
    }

    if ((group.clip || group.width || group.height) && !group.noBound) {
      bounds.add(0, 0).add(group.width || 0, group.height || 0);
    }

    boundStroke(bounds, group);
    return bounds.translate(group.x || 0, group.y || 0);
  }

  function rectanglePath(context, group, x, y) {
    const off = offset$1(group);
    context.beginPath();
    rectangle(context, group, (x || 0) + off, (y || 0) + off);
  }

  const hitBackground = hitPath(rectanglePath);
  const hitForeground = hitPath(rectanglePath, false);
  const hitCorner = hitPath(rectanglePath, true);

  function draw$4(context, scene, bounds) {
    visit(scene, group => {
      const gx = group.x || 0,
            gy = group.y || 0,
            fore = group.strokeForeground,
            opacity = group.opacity == null ? 1 : group.opacity; // draw group background

      if ((group.stroke || group.fill) && opacity) {
        rectanglePath(context, group, gx, gy);
        blend(context, group);

        if (group.fill && fill(context, group, opacity)) {
          context.fill();
        }

        if (group.stroke && !fore && stroke(context, group, opacity)) {
          context.stroke();
        }
      } // setup graphics context, set clip and bounds


      context.save();
      context.translate(gx, gy);
      if (group.clip) clipGroup(context, group);
      if (bounds) bounds.translate(-gx, -gy); // draw group contents

      visit(group, item => {
        this.draw(context, item, bounds);
      }); // restore graphics context

      if (bounds) bounds.translate(gx, gy);
      context.restore(); // draw group foreground

      if (fore && group.stroke && opacity) {
        rectanglePath(context, group, gx, gy);
        blend(context, group);

        if (stroke(context, group, opacity)) {
          context.stroke();
        }
      }
    });
  }

  function pick(context, scene, x, y, gx, gy) {
    if (scene.bounds && !scene.bounds.contains(gx, gy) || !scene.items) {
      return null;
    }

    const cx = x * context.pixelRatio,
          cy = y * context.pixelRatio;
    return pickVisit(scene, group => {
      let hit, dx, dy; // first hit test bounding box

      const b = group.bounds;
      if (b && !b.contains(gx, gy)) return; // passed bounds check, test rectangular clip

      dx = group.x || 0;
      dy = group.y || 0;
      const dw = dx + (group.width || 0),
            dh = dy + (group.height || 0),
            c = group.clip;
      if (c && (gx < dx || gx > dw || gy < dy || gy > dh)) return; // adjust coordinate system

      context.save();
      context.translate(dx, dy);
      dx = gx - dx;
      dy = gy - dy; // test background for rounded corner clip

      if (c && hasCornerRadius(group) && !hitCorner(context, group, cx, cy)) {
        context.restore();
        return null;
      }

      const fore = group.strokeForeground,
            ix = scene.interactive !== false; // hit test against group foreground

      if (ix && fore && group.stroke && hitForeground(context, group, cx, cy)) {
        context.restore();
        return group;
      } // hit test against contained marks


      hit = pickVisit(group, mark => pickMark(mark, dx, dy) ? this.pick(mark, x, y, dx, dy) : null); // hit test against group background

      if (!hit && ix && (group.fill || !fore && group.stroke) && hitBackground(context, group, cx, cy)) {
        hit = group;
      } // restore state and return


      context.restore();
      return hit || null;
    });
  }

  function pickMark(mark, x, y) {
    return (mark.interactive !== false || mark.marktype === 'group') && mark.bounds && mark.bounds.contains(x, y);
  }

  var group = {
    type: 'group',
    tag: 'g',
    nested: false,
    attr: attr$5,
    bound: bound$5,
    draw: draw$4,
    pick: pick,
    isect: intersectRect,
    content: content,
    background: background$1,
    foreground: foreground
  };
  var metadata = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlns:xlink': 'http://www.w3.org/1999/xlink',
    'version': '1.1'
  };

  function getImage(item, renderer) {
    var image = item.image;

    if (!image || item.url && item.url !== image.url) {
      image = {
        complete: false,
        width: 0,
        height: 0
      };
      renderer.loadImage(item.url).then(image => {
        item.image = image;
        item.image.url = item.url;
      });
    }

    return image;
  }

  function imageWidth(item, image) {
    return item.width != null ? item.width : !image || !image.width ? 0 : item.aspect !== false && item.height ? item.height * image.width / image.height : image.width;
  }

  function imageHeight(item, image) {
    return item.height != null ? item.height : !image || !image.height ? 0 : item.aspect !== false && item.width ? item.width * image.height / image.width : image.height;
  }

  function imageXOffset(align, w) {
    return align === 'center' ? w / 2 : align === 'right' ? w : 0;
  }

  function imageYOffset(baseline, h) {
    return baseline === 'middle' ? h / 2 : baseline === 'bottom' ? h : 0;
  }

  function attr$4(emit, item, renderer) {
    const img = getImage(item, renderer),
          w = imageWidth(item, img),
          h = imageHeight(item, img),
          x = (item.x || 0) - imageXOffset(item.align, w),
          y = (item.y || 0) - imageYOffset(item.baseline, h),
          i = !img.src && img.toDataURL ? img.toDataURL() : img.src || '';
    emit('href', i, metadata['xmlns:xlink'], 'xlink:href');
    emit('transform', translate$1(x, y));
    emit('width', w);
    emit('height', h);
    emit('preserveAspectRatio', item.aspect === false ? 'none' : 'xMidYMid');
  }

  function bound$4(bounds, item) {
    const img = item.image,
          w = imageWidth(item, img),
          h = imageHeight(item, img),
          x = (item.x || 0) - imageXOffset(item.align, w),
          y = (item.y || 0) - imageYOffset(item.baseline, h);
    return bounds.set(x, y, x + w, y + h);
  }

  function draw$3(context, scene, bounds) {
    visit(scene, item => {
      if (bounds && !bounds.intersects(item.bounds)) return; // bounds check

      const img = getImage(item, this);
      let w = imageWidth(item, img);
      let h = imageHeight(item, img);
      if (w === 0 || h === 0) return; // early exit

      let x = (item.x || 0) - imageXOffset(item.align, w),
          y = (item.y || 0) - imageYOffset(item.baseline, h),
          opacity,
          ar0,
          ar1,
          t;

      if (item.aspect !== false) {
        ar0 = img.width / img.height;
        ar1 = item.width / item.height;

        if (ar0 === ar0 && ar1 === ar1 && ar0 !== ar1) {
          if (ar1 < ar0) {
            t = w / ar0;
            y += (h - t) / 2;
            h = t;
          } else {
            t = h * ar0;
            x += (w - t) / 2;
            w = t;
          }
        }
      }

      if (img.complete || img.toDataURL) {
        blend(context, item);
        context.globalAlpha = (opacity = item.opacity) != null ? opacity : 1;
        context.imageSmoothingEnabled = item.smooth !== false;
        context.drawImage(img, x, y, w, h);
      }
    });
  }

  var image = {
    type: 'image',
    tag: 'image',
    nested: false,
    attr: attr$4,
    bound: bound$4,
    draw: draw$3,
    pick: pick$1(),
    isect: truthy,
    // bounds check is sufficient
    get: getImage,
    xOffset: imageXOffset,
    yOffset: imageYOffset
  };
  var line$2 = markMultiItemPath('line', line$1, pickLine);

  function attr$3(emit, item) {
    var sx = item.scaleX || 1,
        sy = item.scaleY || 1;

    if (sx !== 1 || sy !== 1) {
      emit('vector-effect', 'non-scaling-stroke');
    }

    emit('transform', transformItem(item));
    emit('d', item.path);
  }

  function path$1(context, item) {
    var path = item.path;
    if (path == null) return true;
    var x = item.x || 0,
        y = item.y || 0,
        sx = item.scaleX || 1,
        sy = item.scaleY || 1,
        a = (item.angle || 0) * DegToRad,
        cache = item.pathCache;

    if (!cache || cache.path !== path) {
      (item.pathCache = cache = pathParse(path)).path = path;
    }

    if (a && context.rotate && context.translate) {
      context.translate(x, y);
      context.rotate(a);
      pathRender(context, cache, 0, 0, sx, sy);
      context.rotate(-a);
      context.translate(-x, -y);
    } else {
      pathRender(context, cache, x, y, sx, sy);
    }
  }

  function bound$3(bounds, item) {
    return path$1(boundContext(bounds, item.angle), item) ? bounds.set(0, 0, 0, 0) : boundStroke(bounds, item, true);
  }

  var path$2 = {
    type: 'path',
    tag: 'path',
    nested: false,
    attr: attr$3,
    bound: bound$3,
    draw: drawAll(path$1),
    pick: pickPath(path$1),
    isect: intersectPath(path$1)
  };

  function attr$2(emit, item) {
    emit('d', rectangle(null, item));
  }

  function bound$2(bounds, item) {
    var x, y;
    return boundStroke(bounds.set(x = item.x || 0, y = item.y || 0, x + item.width || 0, y + item.height || 0), item);
  }

  function draw$2(context, item) {
    context.beginPath();
    rectangle(context, item);
  }

  var rect = {
    type: 'rect',
    tag: 'path',
    nested: false,
    attr: attr$2,
    bound: bound$2,
    draw: drawAll(draw$2),
    pick: pickPath(draw$2),
    isect: intersectRect
  };

  function attr$1(emit, item) {
    emit('transform', translateItem(item));
    emit('x2', item.x2 != null ? item.x2 - (item.x || 0) : 0);
    emit('y2', item.y2 != null ? item.y2 - (item.y || 0) : 0);
  }

  function bound$1(bounds, item) {
    var x1, y1;
    return boundStroke(bounds.set(x1 = item.x || 0, y1 = item.y || 0, item.x2 != null ? item.x2 : x1, item.y2 != null ? item.y2 : y1), item);
  }

  function path(context, item, opacity) {
    var x1, y1, x2, y2;

    if (item.stroke && stroke(context, item, opacity)) {
      x1 = item.x || 0;
      y1 = item.y || 0;
      x2 = item.x2 != null ? item.x2 : x1;
      y2 = item.y2 != null ? item.y2 : y1;
      context.beginPath();
      context.moveTo(x1, y1);
      context.lineTo(x2, y2);
      return true;
    }

    return false;
  }

  function draw$1(context, scene, bounds) {
    visit(scene, item => {
      if (bounds && !bounds.intersects(item.bounds)) return; // bounds check

      var opacity = item.opacity == null ? 1 : item.opacity;

      if (opacity && path(context, item, opacity)) {
        blend(context, item);
        context.stroke();
      }
    });
  }

  function hit$1(context, item, x, y) {
    if (!context.isPointInStroke) return false;
    return path(context, item, 1) && context.isPointInStroke(x, y);
  }

  var rule$1 = {
    type: 'rule',
    tag: 'line',
    nested: false,
    attr: attr$1,
    bound: bound$1,
    draw: draw$1,
    pick: pick$1(hit$1),
    isect: intersectRule
  };
  var shape = markItemPath('shape', shape$1);
  var symbol = markItemPath('symbol', symbol$1, intersectPoint);
  const widthCache = lruCache();
  var textMetrics = {
    height: fontSize,
    measureWidth: measureWidth,
    estimateWidth: estimateWidth,
    width: estimateWidth,
    canvas: useCanvas
  };
  useCanvas(true);

  function useCanvas(use) {
    textMetrics.width = use && context$2 ? measureWidth : estimateWidth;
  } // make simple estimate if no canvas is available


  function estimateWidth(item, text) {
    return _estimateWidth(textValue(item, text), fontSize(item));
  }

  function _estimateWidth(text, item) {
    const currentFontHeight = fontSize(item);
    console.warn("***WARNING: _estimateWidth is being used - this is not recommended (this means you don't have canvas package installed)");
    return ~~(0.8 * text.length * currentFontHeight);
  } // measure text width if canvas is available


  function measureWidth(item, text) {
    return fontSize(item) <= 0 || !(text = textValue(item, text)) ? 0 : _measureWidth(text, item);
  }

  function _getMeasureWidthAdjustmentForSize(text, size) {
    // Size is in pixels
    // For very small fonts, we get a small adjustment
    // This compensates for issues with differences between different SVG text renderers
    const minFontSizeToAdjust = 6;
    const maxFontSizeToAdjust = 20;
    const maxSizeAdjustment = 4;

    if (size >= minFontSizeToAdjust && size <= maxFontSizeToAdjust) {
      var adjustmentInPercent = 1.0 - (size - minFontSizeToAdjust) / (maxFontSizeToAdjust - minFontSizeToAdjust);
      var adjustment = Math.ceil(maxSizeAdjustment * adjustmentInPercent);
      return adjustment;
    } else {
      return 0;
    }
  }

  function _getMeasureWidthAdjustmentForItem(text, item) {
    return _getMeasureWidthAdjustmentForSize(text, fontSize(item));
  }

  function _measureWidth(text, item) {
    const currentFont = font(item);
    const key = `(${currentFont}) ${text}`;
    let width = widthCache.get(key);

    if (width === undefined) {
      context$2.font = currentFont;
      width = context$2.measureText(text).width + _getMeasureWidthAdjustmentForItem(text, item);
      widthCache.set(key, width);
    }

    return width;
  }

  function fontSize(item) {
    return item.fontSize != null ? +item.fontSize || 0 : 11;
  }

  function lineHeight(item) {
    return item.lineHeight != null ? item.lineHeight : fontSize(item) + 2;
  }

  function lineArray(_) {
    return isArray(_) ? _.length > 1 ? _ : _[0] : _;
  }

  function textLines(item) {
    return lineArray(item.lineBreak && item.text && !isArray(item.text) ? item.text.split(item.lineBreak) : item.text);
  }

  function multiLineOffset(item) {
    const tl = textLines(item);
    return (isArray(tl) ? tl.length - 1 : 0) * lineHeight(item);
  }

  function textValue(item, line) {
    const text = line == null ? '' : (line + '').trim();
    return item.limit > 0 && text.length ? truncate(item, text) : text;
  }

  function widthGetter(item) {
    if (textMetrics.width === measureWidth) {
      // we are using canvas
      return text => _measureWidth(text, item);
    } else {
      // we are relying on estimates
      return text => _estimateWidth(text, item);
    }
  }

  function truncate(item, text) {
    var limit = +item.limit,
        width = widthGetter(item);
    if (width(text) < limit) return text;
    var ellipsis = item.ellipsis || '\u2026',
        rtl = item.dir === 'rtl',
        lo = 0,
        hi = text.length,
        mid;
    limit -= width(ellipsis);

    if (rtl) {
      while (lo < hi) {
        mid = lo + hi >>> 1;
        if (width(text.slice(mid)) > limit) lo = mid + 1;else hi = mid;
      }

      return ellipsis + text.slice(lo);
    } else {
      while (lo < hi) {
        mid = 1 + (lo + hi >>> 1);
        if (width(text.slice(0, mid)) < limit) lo = mid;else hi = mid - 1;
      }

      return text.slice(0, lo) + ellipsis;
    }
  }

  function fontFamily(item, quote) {
    var font = item.font;
    return (quote && font ? String(font).replace(/"/g, '\'') : font) || 'sans-serif';
  }

  function font(item, quote) {
    return '' + (item.fontStyle ? item.fontStyle + ' ' : '') + (item.fontVariant ? item.fontVariant + ' ' : '') + (item.fontWeight ? item.fontWeight + ' ' : '') + fontSize(item) + 'px ' + fontFamily(item, quote);
  }

  function offset$2(item) {
    // perform our own font baseline calculation
    // why? not all browsers support SVG 1.1 'alignment-baseline' :(
    // this also ensures consistent layout across renderers
    var baseline = item.baseline,
        h = fontSize(item);
    return Math.round(baseline === 'top' ? 0.79 * h : baseline === 'middle' ? 0.30 * h : baseline === 'bottom' ? -0.21 * h : baseline === 'line-top' ? 0.29 * h + 0.5 * lineHeight(item) : baseline === 'line-bottom' ? 0.29 * h - 0.5 * lineHeight(item) : 0);
  }

  const textAlign = {
    'left': 'start',
    'center': 'middle',
    'right': 'end'
  };
  const tempBounds$1 = new Bounds();

  function anchorPoint(item) {
    var x = item.x || 0,
        y = item.y || 0,
        r = item.radius || 0,
        t;

    if (r) {
      t = (item.theta || 0) - HalfPi;
      x += r * Math.cos(t);
      y += r * Math.sin(t);
    }

    tempBounds$1.x1 = x;
    tempBounds$1.y1 = y;
    return tempBounds$1;
  }

  function attr(emit, item) {
    var dx = item.dx || 0,
        dy = (item.dy || 0) + offset$2(item),
        p = anchorPoint(item),
        x = p.x1,
        y = p.y1,
        a = item.angle || 0,
        t;
    emit('text-anchor', textAlign[item.align] || 'start');

    if (a) {
      t = translate$1(x, y) + ' ' + rotate(a);
      if (dx || dy) t += ' ' + translate$1(dx, dy);
    } else {
      t = translate$1(x + dx, y + dy);
    }

    emit('transform', t);
  }

  function bound(bounds, item, mode) {
    var h = textMetrics.height(item),
        a = item.align,
        p = anchorPoint(item),
        x = p.x1,
        y = p.y1,
        dx = item.dx || 0,
        dy = (item.dy || 0) + offset$2(item) - Math.round(0.8 * h),
        // use 4/5 offset
    tl = textLines(item),
        w; // get dimensions

    if (isArray(tl)) {
      // multi-line text
      h += lineHeight(item) * (tl.length - 1);
      w = tl.reduce((w, t) => Math.max(w, textMetrics.width(item, t)), 0);
    } else {
      // single-line text
      w = textMetrics.width(item, tl);
    } // horizontal alignment


    if (a === 'center') {
      dx -= w / 2;
    } else if (a === 'right') {
      dx -= w;
    } else ;

    bounds.set(dx += x, dy += y, dx + w, dy + h);

    if (item.angle && !mode) {
      bounds.rotate(item.angle * DegToRad, x, y);
    } else if (mode === 2) {
      return bounds.rotatedPoints(item.angle * DegToRad, x, y);
    }

    return bounds;
  }

  function draw$5(context, scene, bounds) {
    visit(scene, item => {
      var opacity = item.opacity == null ? 1 : item.opacity,
          p,
          x,
          y,
          i,
          lh,
          tl,
          str;
      if (bounds && !bounds.intersects(item.bounds) || // bounds check
      opacity === 0 || item.fontSize <= 0 || item.text == null || item.text.length === 0) return;
      context.font = font(item);
      context.textAlign = item.align || 'left';
      p = anchorPoint(item);
      x = p.x1, y = p.y1;

      if (item.angle) {
        context.save();
        context.translate(x, y);
        context.rotate(item.angle * DegToRad);
        x = y = 0; // reset x, y
      }

      x += item.dx || 0;
      y += (item.dy || 0) + offset$2(item);
      tl = textLines(item);
      blend(context, item);

      if (isArray(tl)) {
        lh = lineHeight(item);

        for (i = 0; i < tl.length; ++i) {
          str = textValue(item, tl[i]);

          if (item.fill && fill(context, item, opacity)) {
            context.fillText(str, x, y);
          }

          if (item.stroke && stroke(context, item, opacity)) {
            context.strokeText(str, x, y);
          }

          y += lh;
        }
      } else {
        str = textValue(item, tl);

        if (item.fill && fill(context, item, opacity)) {
          context.fillText(str, x, y);
        }

        if (item.stroke && stroke(context, item, opacity)) {
          context.strokeText(str, x, y);
        }
      }

      if (item.angle) context.restore();
    });
  }

  function hit(context, item, x, y, gx, gy) {
    if (item.fontSize <= 0) return false;
    if (!item.angle) return true; // bounds sufficient if no rotation
    // project point into space of unrotated bounds

    var p = anchorPoint(item),
        ax = p.x1,
        ay = p.y1,
        b = bound(tempBounds$1, item, 1),
        a = -item.angle * DegToRad,
        cos = Math.cos(a),
        sin = Math.sin(a),
        px = cos * gx - sin * gy + (ax - cos * ax + sin * ay),
        py = sin * gx + cos * gy + (ay - sin * ax - cos * ay);
    return b.contains(px, py);
  }

  function intersectText(item, box) {
    const p = bound(tempBounds$1, item, 2);
    return intersectBoxLine(box, p[0], p[1], p[2], p[3]) || intersectBoxLine(box, p[0], p[1], p[4], p[5]) || intersectBoxLine(box, p[4], p[5], p[6], p[7]) || intersectBoxLine(box, p[2], p[3], p[6], p[7]);
  }

  var text = {
    type: 'text',
    tag: 'text',
    nested: false,
    attr: attr,
    bound: bound,
    draw: draw$5,
    pick: pick$1(hit),
    isect: intersectText
  };
  var trail = markMultiItemPath('trail', trail$1, pickTrail);
  var Marks = {
    arc: arc$2,
    area: area$2,
    group: group,
    image: image,
    line: line$2,
    path: path$2,
    rect: rect,
    rule: rule$1,
    shape: shape,
    symbol: symbol,
    text: text,
    trail: trail
  };

  function boundItem$1(item, func, opt) {
    var type = Marks[item.mark.marktype],
        bound = func || type.bound;
    if (type.nested) item = item.mark;
    return bound(item.bounds || (item.bounds = new Bounds()), item, opt);
  }

  var DUMMY = {
    mark: null
  };

  function boundMark(mark, bounds, opt) {
    var type = Marks[mark.marktype],
        bound = type.bound,
        items = mark.items,
        hasItems = items && items.length,
        i,
        n,
        item,
        b;

    if (type.nested) {
      if (hasItems) {
        item = items[0];
      } else {
        // no items, fake it
        DUMMY.mark = mark;
        item = DUMMY;
      }

      b = boundItem$1(item, bound, opt);
      bounds = bounds && bounds.union(b) || b;
      return bounds;
    }

    bounds = bounds || mark.bounds && mark.bounds.clear() || new Bounds();

    if (hasItems) {
      for (i = 0, n = items.length; i < n; ++i) {
        bounds.union(boundItem$1(items[i], bound, opt));
      }
    }

    return mark.bounds = bounds;
  }

  const keys$1 = ['marktype', 'name', 'role', 'interactive', 'clip', 'items', 'zindex', 'x', 'y', 'width', 'height', 'align', 'baseline', // layout
  'fill', 'fillOpacity', 'opacity', 'blend', // fill
  'stroke', 'strokeOpacity', 'strokeWidth', 'strokeCap', // stroke
  'strokeDash', 'strokeDashOffset', // stroke dash
  'strokeForeground', 'strokeOffset', // group
  'startAngle', 'endAngle', 'innerRadius', 'outerRadius', // arc
  'cornerRadius', 'padAngle', // arc, rect
  'cornerRadiusTopLeft', 'cornerRadiusTopRight', // rect, group
  'cornerRadiusBottomLeft', 'cornerRadiusBottomRight', 'interpolate', 'tension', 'orient', 'defined', // area, line
  'url', 'aspect', 'smooth', // image
  'path', 'scaleX', 'scaleY', // path
  'x2', 'y2', // rule
  'size', 'shape', // symbol
  'text', 'angle', 'theta', 'radius', 'dir', 'dx', 'dy', // text
  'ellipsis', 'limit', 'lineBreak', 'lineHeight', 'font', 'fontSize', 'fontWeight', 'fontStyle', 'fontVariant', // font
  'description', 'aria', 'ariaRole', 'ariaRoleDescription' // aria
  ];

  function sceneToJSON(scene, indent) {
    return JSON.stringify(scene, keys$1, indent);
  }

  function sceneFromJSON(json) {
    const scene = typeof json === 'string' ? JSON.parse(json) : json;
    return initialize$1(scene);
  }

  function initialize$1(scene) {
    var type = scene.marktype,
        items = scene.items,
        parent,
        i,
        n;

    if (items) {
      for (i = 0, n = items.length; i < n; ++i) {
        parent = type ? 'mark' : 'group';
        items[i][parent] = scene;
        if (items[i].zindex) items[i][parent].zdirty = true;
        if ('group' === (type || parent)) initialize$1(items[i]);
      }
    }

    if (type) boundMark(scene);
    return scene;
  }

  function Scenegraph(scene) {
    if (arguments.length) {
      this.root = sceneFromJSON(scene);
    } else {
      this.root = createMark({
        marktype: 'group',
        name: 'root',
        role: 'frame'
      });
      this.root.items = [new GroupItem(this.root)];
    }
  }

  Scenegraph.prototype = {
    toJSON(indent) {
      return sceneToJSON(this.root, indent || 0);
    },

    mark(markdef, group, index) {
      group = group || this.root.items[0];
      const mark = createMark(markdef, group);
      group.items[index] = mark;
      if (mark.zindex) mark.group.zdirty = true;
      return mark;
    }

  };

  function createMark(def, group) {
    const mark = {
      bounds: new Bounds(),
      clip: !!def.clip,
      group: group,
      interactive: def.interactive === false ? false : true,
      items: [],
      marktype: def.marktype,
      name: def.name || undefined,
      role: def.role || undefined,
      zindex: def.zindex || 0
    }; // add accessibility properties if defined

    if (def.aria != null) {
      mark.aria = def.aria;
    }

    if (def.description) {
      mark.description = def.description;
    }

    return mark;
  } // create a new DOM element


  function domCreate(doc, tag, ns) {
    if (!doc && typeof document !== 'undefined' && document.createElement) {
      doc = document;
    }

    return doc ? ns ? doc.createElementNS(ns, tag) : doc.createElement(tag) : null;
  } // find first child element with matching tag


  function domFind(el, tag) {
    tag = tag.toLowerCase();
    var nodes = el.childNodes,
        i = 0,
        n = nodes.length;

    for (; i < n; ++i) if (nodes[i].tagName.toLowerCase() === tag) {
      return nodes[i];
    }
  } // retrieve child element at given index
  // create & insert if doesn't exist or if tags do not match


  function domChild(el, index, tag, ns) {
    var a = el.childNodes[index],
        b;

    if (!a || a.tagName.toLowerCase() !== tag.toLowerCase()) {
      b = a || null;
      a = domCreate(el.ownerDocument, tag, ns);
      el.insertBefore(a, b);
    }

    return a;
  } // remove all child elements at or above the given index


  function domClear(el, index) {
    var nodes = el.childNodes,
        curr = nodes.length;

    while (curr > index) el.removeChild(nodes[--curr]);

    return el;
  } // generate css class name for mark


  function cssClass(mark) {
    return 'mark-' + mark.marktype + (mark.role ? ' role-' + mark.role : '') + (mark.name ? ' ' + mark.name : '');
  }

  function point(event, el) {
    const rect = el.getBoundingClientRect();
    return [event.clientX - rect.left - (el.clientLeft || 0), event.clientY - rect.top - (el.clientTop || 0)];
  }

  function resolveItem(item, event, el, origin) {
    var mark = item && item.mark,
        mdef,
        p;

    if (mark && (mdef = Marks[mark.marktype]).tip) {
      p = point(event, el);
      p[0] -= origin[0];
      p[1] -= origin[1];

      while (item = item.mark.group) {
        p[0] -= item.x || 0;
        p[1] -= item.y || 0;
      }

      item = mdef.tip(mark.items, p);
    }

    return item;
  }
  /**
   * Create a new Handler instance.
   * @param {object} [customLoader] - Optional loader instance for
   *   href URL sanitization. If not specified, a standard loader
   *   instance will be generated.
   * @param {function} [customTooltip] - Optional tooltip handler
   *   function for custom tooltip display.
   * @constructor
   */


  function Handler(customLoader, customTooltip) {
    this._active = null;
    this._handlers = {};
    this._loader = customLoader || loader();
    this._tooltip = customTooltip || defaultTooltip$1;
  } // The default tooltip display handler.
  // Sets the HTML title attribute on the visualization container.


  function defaultTooltip$1(handler, event, item, value) {
    handler.element().setAttribute('title', value || '');
  }

  Handler.prototype = {
    /**
     * Initialize a new Handler instance.
     * @param {DOMElement} el - The containing DOM element for the display.
     * @param {Array<number>} origin - The origin of the display, in pixels.
     *   The coordinate system will be translated to this point.
     * @param {object} [obj] - Optional context object that should serve as
     *   the "this" context for event callbacks.
     * @return {Handler} - This handler instance.
     */
    initialize(el, origin, obj) {
      this._el = el;
      this._obj = obj || null;
      return this.origin(origin);
    },

    /**
     * Returns the parent container element for a visualization.
     * @return {DOMElement} - The containing DOM element.
     */
    element() {
      return this._el;
    },

    /**
     * Returns the scene element (e.g., canvas or SVG) of the visualization
     * Subclasses must override if the first child is not the scene element.
     * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
     */
    canvas() {
      return this._el && this._el.firstChild;
    },

    /**
     * Get / set the origin coordinates of the visualization.
     */
    origin(origin) {
      if (arguments.length) {
        this._origin = origin || [0, 0];
        return this;
      } else {
        return this._origin.slice();
      }
    },

    /**
     * Get / set the scenegraph root.
     */
    scene(scene) {
      if (!arguments.length) return this._scene;
      this._scene = scene;
      return this;
    },

    /**
     * Add an event handler. Subclasses should override this method.
     */
    on()
    /*type, handler*/
    {},

    /**
     * Remove an event handler. Subclasses should override this method.
     */
    off()
    /*type, handler*/
    {},

    /**
     * Utility method for finding the array index of an event handler.
     * @param {Array} h - An array of registered event handlers.
     * @param {string} type - The event type.
     * @param {function} handler - The event handler instance to find.
     * @return {number} - The handler's array index or -1 if not registered.
     */
    _handlerIndex(h, type, handler) {
      for (let i = h ? h.length : 0; --i >= 0;) {
        if (h[i].type === type && (!handler || h[i].handler === handler)) {
          return i;
        }
      }

      return -1;
    },

    /**
     * Returns an array with registered event handlers.
     * @param {string} [type] - The event type to query. Any annotations
     *   are ignored; for example, for the argument "click.foo", ".foo" will
     *   be ignored and the method returns all "click" handlers. If type is
     *   null or unspecified, this method returns handlers for all types.
     * @return {Array} - A new array containing all registered event handlers.
     */
    handlers(type) {
      const h = this._handlers,
            a = [];

      if (type) {
        a.push(...h[this.eventName(type)]);
      } else {
        for (const k in h) {
          a.push(...h[k]);
        }
      }

      return a;
    },

    /**
     * Parses an event name string to return the specific event type.
     * For example, given "click.foo" returns "click"
     * @param {string} name - The input event type string.
     * @return {string} - A string with the event type only.
     */
    eventName(name) {
      const i = name.indexOf('.');
      return i < 0 ? name : name.slice(0, i);
    },

    /**
     * Handle hyperlink navigation in response to an item.href value.
     * @param {Event} event - The event triggering hyperlink navigation.
     * @param {Item} item - The scenegraph item.
     * @param {string} href - The URL to navigate to.
     */
    handleHref(event, item, href) {
      this._loader.sanitize(href, {
        context: 'href'
      }).then(opt => {
        const e = new MouseEvent(event.type, event),
              a = domCreate(null, 'a');

        for (const name in opt) a.setAttribute(name, opt[name]);

        a.dispatchEvent(e);
      }).catch(() => {
        /* do nothing */
      });
    },

    /**
     * Handle tooltip display in response to an item.tooltip value.
     * @param {Event} event - The event triggering tooltip display.
     * @param {Item} item - The scenegraph item.
     * @param {boolean} show - A boolean flag indicating whether
     *   to show or hide a tooltip for the given item.
     */
    handleTooltip(event, item, show) {
      if (item && item.tooltip != null) {
        item = resolveItem(item, event, this.canvas(), this._origin);
        const value = show && item && item.tooltip || null;

        this._tooltip.call(this._obj, this, event, item, value);
      }
    },

    /**
     * Returns the size of a scenegraph item and its position relative
     * to the viewport.
     * @param {Item} item - The scenegraph item.
     * @return {object} - A bounding box object (compatible with the
     *   DOMRect type) consisting of x, y, width, heigh, top, left,
     *   right, and bottom properties.
     */
    getItemBoundingClientRect(item) {
      const el = this.canvas();
      if (!el) return;
      const rect = el.getBoundingClientRect(),
            origin = this._origin,
            bounds = item.bounds,
            width = bounds.width(),
            height = bounds.height();
      let x = bounds.x1 + origin[0] + rect.left,
          y = bounds.y1 + origin[1] + rect.top; // translate coordinate for each parent group

      while (item.mark && (item = item.mark.group)) {
        x += item.x || 0;
        y += item.y || 0;
      } // return DOMRect-compatible bounding box


      return {
        x,
        y,
        width,
        height,
        left: x,
        top: y,
        right: x + width,
        bottom: y + height
      };
    }

  };
  /**
   * Create a new Renderer instance.
   * @param {object} [loader] - Optional loader instance for
   *   image and href URL sanitization. If not specified, a
   *   standard loader instance will be generated.
   * @constructor
   */

  function Renderer(loader) {
    this._el = null;
    this._bgcolor = null;
    this._loader = new ResourceLoader(loader);
  }

  Renderer.prototype = {
    /**
     * Initialize a new Renderer instance.
     * @param {DOMElement} el - The containing DOM element for the display.
     * @param {number} width - The coordinate width of the display, in pixels.
     * @param {number} height - The coordinate height of the display, in pixels.
     * @param {Array<number>} origin - The origin of the display, in pixels.
     *   The coordinate system will be translated to this point.
     * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
     *   the width and height to determine the final pixel size.
     * @return {Renderer} - This renderer instance.
     */
    initialize(el, width, height, origin, scaleFactor) {
      this._el = el;
      return this.resize(width, height, origin, scaleFactor);
    },

    /**
     * Returns the parent container element for a visualization.
     * @return {DOMElement} - The containing DOM element.
     */
    element() {
      return this._el;
    },

    /**
     * Returns the scene element (e.g., canvas or SVG) of the visualization
     * Subclasses must override if the first child is not the scene element.
     * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
     */
    canvas() {
      return this._el && this._el.firstChild;
    },

    /**
     * Get / set the background color.
     */
    background(bgcolor) {
      if (arguments.length === 0) return this._bgcolor;
      this._bgcolor = bgcolor;
      return this;
    },

    /**
     * Resize the display.
     * @param {number} width - The new coordinate width of the display, in pixels.
     * @param {number} height - The new coordinate height of the display, in pixels.
     * @param {Array<number>} origin - The new origin of the display, in pixels.
     *   The coordinate system will be translated to this point.
     * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
     *   the width and height to determine the final pixel size.
     * @return {Renderer} - This renderer instance;
     */
    resize(width, height, origin, scaleFactor) {
      this._width = width;
      this._height = height;
      this._origin = origin || [0, 0];
      this._scale = scaleFactor || 1;
      return this;
    },

    /**
     * Report a dirty item whose bounds should be redrawn.
     * This base class method does nothing. Subclasses that perform
     * incremental should implement this method.
     * @param {Item} item - The dirty item whose bounds should be redrawn.
     */
    dirty()
    /*item*/
    {},

    /**
     * Render an input scenegraph, potentially with a set of dirty items.
     * This method will perform an immediate rendering with available resources.
     * The renderer may also need to perform image loading to perform a complete
     * render. This process can lead to asynchronous re-rendering of the scene
     * after this method returns. To receive notification when rendering is
     * complete, use the renderAsync method instead.
     * @param {object} scene - The root mark of a scenegraph to render.
     * @return {Renderer} - This renderer instance.
     */
    render(scene) {
      const r = this; // bind arguments into a render call, and cache it
      // this function may be subsequently called for async redraw

      r._call = function () {
        r._render(scene);
      }; // invoke the renderer


      r._call(); // clear the cached call for garbage collection
      // async redraws will stash their own copy


      r._call = null;
      return r;
    },

    /**
     * Internal rendering method. Renderer subclasses should override this
     * method to actually perform rendering.
     * @param {object} scene - The root mark of a scenegraph to render.
     */
    _render()
    /*scene*/
    {// subclasses to override
    },

    /**
     * Asynchronous rendering method. Similar to render, but returns a Promise
     * that resolves when all rendering is completed. Sometimes a renderer must
     * perform image loading to get a complete rendering. The returned
     * Promise will not resolve until this process completes.
     * @param {object} scene - The root mark of a scenegraph to render.
     * @return {Promise} - A Promise that resolves when rendering is complete.
     */
    renderAsync(scene) {
      const r = this.render(scene);
      return this._ready ? this._ready.then(() => r) : Promise.resolve(r);
    },

    /**
     * Internal method for asynchronous resource loading.
     * Proxies method calls to the ImageLoader, and tracks loading
     * progress to invoke a re-render once complete.
     * @param {string} method - The method name to invoke on the ImageLoader.
     * @param {string} uri - The URI for the requested resource.
     * @return {Promise} - A Promise that resolves to the requested resource.
     */
    _load(method, uri) {
      var r = this,
          p = r._loader[method](uri);

      if (!r._ready) {
        // re-render the scene when loading completes
        const call = r._call;
        r._ready = r._loader.ready().then(redraw => {
          if (redraw) call();
          r._ready = null;
        });
      }

      return p;
    },

    /**
     * Sanitize a URL to include as a hyperlink in the rendered scene.
     * This method proxies a call to ImageLoader.sanitizeURL, but also tracks
     * image loading progress and invokes a re-render once complete.
     * @param {string} uri - The URI string to sanitize.
     * @return {Promise} - A Promise that resolves to the sanitized URL.
     */
    sanitizeURL(uri) {
      return this._load('sanitizeURL', uri);
    },

    /**
     * Requests an image to include in the rendered scene.
     * This method proxies a call to ImageLoader.loadImage, but also tracks
     * image loading progress and invokes a re-render once complete.
     * @param {string} uri - The URI string of the image.
     * @return {Promise} - A Promise that resolves to the loaded Image.
     */
    loadImage(uri) {
      return this._load('loadImage', uri);
    }

  };
  const KeyDownEvent = 'keydown';
  const KeyPressEvent = 'keypress';
  const KeyUpEvent = 'keyup';
  const DragEnterEvent = 'dragenter';
  const DragLeaveEvent = 'dragleave';
  const DragOverEvent = 'dragover';
  const MouseDownEvent = 'mousedown';
  const MouseUpEvent = 'mouseup';
  const MouseMoveEvent = 'mousemove';
  const MouseOutEvent = 'mouseout';
  const MouseOverEvent = 'mouseover';
  const ClickEvent = 'click';
  const DoubleClickEvent = 'dblclick';
  const WheelEvent = 'wheel';
  const MouseWheelEvent = 'mousewheel';
  const TouchStartEvent = 'touchstart';
  const TouchMoveEvent = 'touchmove';
  const TouchEndEvent = 'touchend';
  const Events = [KeyDownEvent, KeyPressEvent, KeyUpEvent, DragEnterEvent, DragLeaveEvent, DragOverEvent, MouseDownEvent, MouseUpEvent, MouseMoveEvent, MouseOutEvent, MouseOverEvent, ClickEvent, DoubleClickEvent, WheelEvent, MouseWheelEvent, TouchStartEvent, TouchMoveEvent, TouchEndEvent];
  const TooltipShowEvent = MouseMoveEvent;
  const TooltipHideEvent = MouseOutEvent;
  const HrefEvent = ClickEvent;

  function CanvasHandler(loader, tooltip) {
    Handler.call(this, loader, tooltip);
    this._down = null;
    this._touch = null;
    this._first = true;
    this._events = {};
  }

  const eventBundle = type => type === TouchStartEvent || type === TouchMoveEvent || type === TouchEndEvent ? [TouchStartEvent, TouchMoveEvent, TouchEndEvent] : [type]; // lazily add listeners to the canvas as needed


  function eventListenerCheck(handler, type) {
    eventBundle(type).forEach(_ => addEventListener(handler, _));
  }

  function addEventListener(handler, type) {
    const canvas = handler.canvas();

    if (canvas && !handler._events[type]) {
      handler._events[type] = 1;
      canvas.addEventListener(type, handler[type] ? evt => handler[type](evt) : evt => handler.fire(type, evt));
    }
  }

  function move(moveEvent, overEvent, outEvent) {
    return function (evt) {
      const a = this._active,
            p = this.pickEvent(evt);

      if (p === a) {
        // active item and picked item are the same
        this.fire(moveEvent, evt); // fire move
      } else {
        // active item and picked item are different
        if (!a || !a.exit) {
          // fire out for prior active item
          // suppress if active item was removed from scene
          this.fire(outEvent, evt);
        }

        this._active = p; // set new active item

        this.fire(overEvent, evt); // fire over for new active item

        this.fire(moveEvent, evt); // fire move for new active item
      }
    };
  }

  function inactive(type) {
    return function (evt) {
      this.fire(type, evt);
      this._active = null;
    };
  }

  inherits(CanvasHandler, Handler, {
    initialize(el, origin, obj) {
      this._canvas = el && domFind(el, 'canvas'); // add minimal events required for proper state management

      [ClickEvent, MouseDownEvent, MouseMoveEvent, MouseOutEvent, DragLeaveEvent].forEach(type => eventListenerCheck(this, type));
      return Handler.prototype.initialize.call(this, el, origin, obj);
    },

    // return the backing canvas instance
    canvas() {
      return this._canvas;
    },

    // retrieve the current canvas context
    context() {
      return this._canvas.getContext('2d');
    },

    // supported events
    events: Events,

    // to keep old versions of firefox happy
    DOMMouseScroll(evt) {
      this.fire(MouseWheelEvent, evt);
    },

    mousemove: move(MouseMoveEvent, MouseOverEvent, MouseOutEvent),
    dragover: move(DragOverEvent, DragEnterEvent, DragLeaveEvent),
    mouseout: inactive(MouseOutEvent),
    dragleave: inactive(DragLeaveEvent),

    mousedown(evt) {
      this._down = this._active;
      this.fire(MouseDownEvent, evt);
    },

    click(evt) {
      if (this._down === this._active) {
        this.fire(ClickEvent, evt);
        this._down = null;
      }
    },

    touchstart(evt) {
      this._touch = this.pickEvent(evt.changedTouches[0]);

      if (this._first) {
        this._active = this._touch;
        this._first = false;
      }

      this.fire(TouchStartEvent, evt, true);
    },

    touchmove(evt) {
      this.fire(TouchMoveEvent, evt, true);
    },

    touchend(evt) {
      this.fire(TouchEndEvent, evt, true);
      this._touch = null;
    },

    // fire an event
    fire(type, evt, touch) {
      const a = touch ? this._touch : this._active,
            h = this._handlers[type]; // set event type relative to scenegraph items

      evt.vegaType = type; // handle hyperlinks and tooltips first

      if (type === HrefEvent && a && a.href) {
        this.handleHref(evt, a, a.href);
      } else if (type === TooltipShowEvent || type === TooltipHideEvent) {
        this.handleTooltip(evt, a, type !== TooltipHideEvent);
      } // invoke all registered handlers


      if (h) {
        for (let i = 0, len = h.length; i < len; ++i) {
          h[i].handler.call(this._obj, evt, a);
        }
      }
    },

    // add an event handler
    on(type, handler) {
      const name = this.eventName(type),
            h = this._handlers,
            i = this._handlerIndex(h[name], type, handler);

      if (i < 0) {
        eventListenerCheck(this, type);
        (h[name] || (h[name] = [])).push({
          type: type,
          handler: handler
        });
      }

      return this;
    },

    // remove an event handler
    off(type, handler) {
      const name = this.eventName(type),
            h = this._handlers[name],
            i = this._handlerIndex(h, type, handler);

      if (i >= 0) {
        h.splice(i, 1);
      }

      return this;
    },

    pickEvent(evt) {
      const p = point(evt, this._canvas),
            o = this._origin;
      return this.pick(this._scene, p[0], p[1], p[0] - o[0], p[1] - o[1]);
    },

    // find the scenegraph item at the current mouse position
    // x, y -- the absolute x, y mouse coordinates on the canvas element
    // gx, gy -- the relative coordinates within the current group
    pick(scene, x, y, gx, gy) {
      const g = this.context(),
            mark = Marks[scene.marktype];
      return mark.pick.call(this, g, scene, x, y, gx, gy);
    }

  });

  function devicePixelRatio() {
    return typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
  }

  var pixelRatio = devicePixelRatio();

  function resize(canvas, width, height, origin, scaleFactor, opt) {
    const inDOM = typeof HTMLElement !== 'undefined' && canvas instanceof HTMLElement && canvas.parentNode != null,
          context = canvas.getContext('2d'),
          ratio = inDOM ? pixelRatio : scaleFactor;
    canvas.width = width * ratio;
    canvas.height = height * ratio;

    for (const key in opt) {
      context[key] = opt[key];
    }

    if (inDOM && ratio !== 1) {
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
    }

    context.pixelRatio = ratio;
    context.setTransform(ratio, 0, 0, ratio, ratio * origin[0], ratio * origin[1]);
    return canvas;
  }

  function CanvasRenderer(loader) {
    Renderer.call(this, loader);
    this._options = {};
    this._redraw = false;
    this._dirty = new Bounds();
    this._tempb = new Bounds();
  }

  const base$1 = Renderer.prototype;

  const viewBounds = (origin, width, height) => new Bounds().set(0, 0, width, height).translate(-origin[0], -origin[1]);

  function clipToBounds(g, b, origin) {
    // expand bounds by 1 pixel, then round to pixel boundaries
    b.expand(1).round(); // align to base pixel grid in case of non-integer scaling (#2425)

    if (g.pixelRatio % 1) {
      b.scale(g.pixelRatio).round().scale(1 / g.pixelRatio);
    } // to avoid artifacts translate if origin has fractional pixels


    b.translate(-(origin[0] % 1), -(origin[1] % 1)); // set clip path

    g.beginPath();
    g.rect(b.x1, b.y1, b.width(), b.height());
    g.clip();
    return b;
  }

  inherits(CanvasRenderer, Renderer, {
    initialize(el, width, height, origin, scaleFactor, options) {
      this._options = options || {};
      this._canvas = this._options.externalContext ? null : canvas(1, 1, this._options.type); // instantiate a small canvas

      if (el && this._canvas) {
        domClear(el, 0).appendChild(this._canvas);

        this._canvas.setAttribute('class', 'marks');
      } // this method will invoke resize to size the canvas appropriately


      return base$1.initialize.call(this, el, width, height, origin, scaleFactor);
    },

    resize(width, height, origin, scaleFactor) {
      base$1.resize.call(this, width, height, origin, scaleFactor);

      if (this._canvas) {
        // configure canvas size and transform
        resize(this._canvas, this._width, this._height, this._origin, this._scale, this._options.context);
      } else {
        // external context needs to be scaled and positioned to origin
        const ctx = this._options.externalContext;
        if (!ctx) error('CanvasRenderer is missing a valid canvas or context');
        ctx.scale(this._scale, this._scale);
        ctx.translate(this._origin[0], this._origin[1]);
      }

      this._redraw = true;
      return this;
    },

    canvas() {
      return this._canvas;
    },

    context() {
      return this._options.externalContext || (this._canvas ? this._canvas.getContext('2d') : null);
    },

    dirty(item) {
      const b = this._tempb.clear().union(item.bounds);

      let g = item.mark.group;

      while (g) {
        b.translate(g.x || 0, g.y || 0);
        g = g.mark.group;
      }

      this._dirty.union(b);
    },

    _render(scene) {
      const g = this.context(),
            o = this._origin,
            w = this._width,
            h = this._height,
            db = this._dirty,
            vb = viewBounds(o, w, h); // setup

      g.save();
      const b = this._redraw || db.empty() ? (this._redraw = false, vb.expand(1)) : clipToBounds(g, vb.intersect(db), o);
      this.clear(-o[0], -o[1], w, h); // render

      this.draw(g, scene, b); // takedown

      g.restore();
      db.clear();
      return this;
    },

    draw(ctx, scene, bounds) {
      const mark = Marks[scene.marktype];
      if (scene.clip) clip$2(ctx, scene);
      mark.draw.call(this, ctx, scene, bounds);
      if (scene.clip) ctx.restore();
    },

    clear(x, y, w, h) {
      const opt = this._options,
            g = this.context();

      if (opt.type !== 'pdf' && !opt.externalContext) {
        // calling clear rect voids vector output in pdf mode
        // and could remove external context content (#2615)
        g.clearRect(x, y, w, h);
      }

      if (this._bgcolor != null) {
        g.fillStyle = this._bgcolor;
        g.fillRect(x, y, w, h);
      }
    }

  });

  function SVGHandler(loader, tooltip) {
    Handler.call(this, loader, tooltip);
    const h = this;
    h._hrefHandler = listener(h, (evt, item) => {
      if (item && item.href) h.handleHref(evt, item, item.href);
    });
    h._tooltipHandler = listener(h, (evt, item) => {
      h.handleTooltip(evt, item, evt.type !== TooltipHideEvent);
    });
  } // wrap an event listener for the SVG DOM


  const listener = (context, handler) => evt => {
    let item = evt.target.__data__;
    item = Array.isArray(item) ? item[0] : item;
    evt.vegaType = evt.type;
    handler.call(context._obj, evt, item);
  };

  inherits(SVGHandler, Handler, {
    initialize(el, origin, obj) {
      let svg = this._svg;

      if (svg) {
        svg.removeEventListener(HrefEvent, this._hrefHandler);
        svg.removeEventListener(TooltipShowEvent, this._tooltipHandler);
        svg.removeEventListener(TooltipHideEvent, this._tooltipHandler);
      }

      this._svg = svg = el && domFind(el, 'svg');

      if (svg) {
        svg.addEventListener(HrefEvent, this._hrefHandler);
        svg.addEventListener(TooltipShowEvent, this._tooltipHandler);
        svg.addEventListener(TooltipHideEvent, this._tooltipHandler);
      }

      return Handler.prototype.initialize.call(this, el, origin, obj);
    },

    canvas() {
      return this._svg;
    },

    // add an event handler
    on(type, handler) {
      const name = this.eventName(type),
            h = this._handlers,
            i = this._handlerIndex(h[name], type, handler);

      if (i < 0) {
        const x = {
          type,
          handler,
          listener: listener(this, handler)
        };
        (h[name] || (h[name] = [])).push(x);

        if (this._svg) {
          this._svg.addEventListener(name, x.listener);
        }
      }

      return this;
    },

    // remove an event handler
    off(type, handler) {
      const name = this.eventName(type),
            h = this._handlers[name],
            i = this._handlerIndex(h, type, handler);

      if (i >= 0) {
        if (this._svg) {
          this._svg.removeEventListener(name, h[i].listener);
        }

        h.splice(i, 1);
      }

      return this;
    }

  });
  const ARIA_HIDDEN = 'aria-hidden';
  const ARIA_LABEL = 'aria-label';
  const ARIA_ROLE = 'role';
  const ARIA_ROLEDESCRIPTION = 'aria-roledescription';
  const GRAPHICS_OBJECT = 'graphics-object';
  const GRAPHICS_SYMBOL = 'graphics-symbol';

  const bundle = (role, roledesc, label) => ({
    [ARIA_ROLE]: role,
    [ARIA_ROLEDESCRIPTION]: roledesc,
    [ARIA_LABEL]: label || undefined
  }); // these roles are covered by related roles
  // we can ignore them, no need to generate attributes


  const AriaIgnore = toSet(['axis-domain', 'axis-grid', 'axis-label', 'axis-tick', 'axis-title', 'legend-band', 'legend-entry', 'legend-gradient', 'legend-label', 'legend-title', 'legend-symbol', 'title']); // aria attribute generators for guide roles

  const AriaGuides = {
    'axis': {
      desc: 'axis',
      caption: axisCaption
    },
    'legend': {
      desc: 'legend',
      caption: legendCaption
    },
    'title-text': {
      desc: 'title',
      caption: item => `Title text '${titleCaption(item)}'`
    },
    'title-subtitle': {
      desc: 'subtitle',
      caption: item => `Subtitle text '${titleCaption(item)}'`
    }
  }; // aria properties generated for mark item encoding channels

  const AriaEncode = {
    ariaRole: ARIA_ROLE,
    ariaRoleDescription: ARIA_ROLEDESCRIPTION,
    description: ARIA_LABEL
  };

  function ariaItemAttributes(emit, item) {
    const hide = item.aria === false;
    emit(ARIA_HIDDEN, hide || undefined);

    if (hide || item.description == null) {
      for (const prop in AriaEncode) {
        emit(AriaEncode[prop], undefined);
      }
    } else {
      const type = item.mark.marktype;
      emit(ARIA_LABEL, item.description);
      emit(ARIA_ROLE, item.ariaRole || (type === 'group' ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL));
      emit(ARIA_ROLEDESCRIPTION, item.ariaRoleDescription || `${type} mark`);
    }
  }

  function ariaMarkAttributes(mark) {
    return mark.aria === false ? {
      [ARIA_HIDDEN]: true
    } : AriaIgnore[mark.role] ? null : AriaGuides[mark.role] ? ariaGuide(mark, AriaGuides[mark.role]) : ariaMark(mark);
  }

  function ariaMark(mark) {
    const type = mark.marktype;
    const recurse = type === 'group' || type === 'text' || mark.items.some(_ => _.description != null && _.aria !== false);
    return bundle(recurse ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL, `${type} mark container`, mark.description);
  }

  function ariaGuide(mark, opt) {
    try {
      const item = mark.items[0],
            caption = opt.caption || (() => '');

      return bundle(opt.role || GRAPHICS_SYMBOL, opt.desc, item.description || caption(item));
    } catch (err) {
      return null;
    }
  }

  function titleCaption(item) {
    return array$5(item.text).join(' ');
  }

  function axisCaption(item) {
    const datum = item.datum,
          orient = item.orient,
          title = datum.title ? extractTitle(item) : null,
          ctx = item.context,
          scale = ctx.scales[datum.scale].value,
          locale = ctx.dataflow.locale(),
          type = scale.type,
          xy = orient === 'left' || orient === 'right' ? 'Y' : 'X';
    return `${xy}-axis` + (title ? ` titled '${title}'` : '') + ` for a ${isDiscrete(type) ? 'discrete' : type} scale` + ` with ${domainCaption(locale, scale, item)}`;
  }

  function legendCaption(item) {
    const datum = item.datum,
          title = datum.title ? extractTitle(item) : null,
          type = `${datum.type || ''} legend`.trim(),
          scales = datum.scales,
          props = Object.keys(scales),
          ctx = item.context,
          scale = ctx.scales[scales[props[0]]].value,
          locale = ctx.dataflow.locale();
    return capitalize(type) + (title ? ` titled '${title}'` : '') + ` for ${channelCaption(props)}` + ` with ${domainCaption(locale, scale, item)}`;
  }

  function extractTitle(item) {
    try {
      return array$5(peek$1(item.items).items[0].text).join(' ');
    } catch (err) {
      return null;
    }
  }

  function channelCaption(props) {
    props = props.map(p => p + (p === 'fill' || p === 'stroke' ? ' color' : ''));
    return props.length < 2 ? props[0] : props.slice(0, -1).join(', ') + ' and ' + peek$1(props);
  }

  function capitalize(s) {
    return s.length ? s[0].toUpperCase() + s.slice(1) : s;
  }

  const innerText = val => (val + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const attrText = val => innerText(val).replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');

  function markup() {
    let buf = '',
        outer = '',
        inner = '';

    const stack = [],
          clear = () => outer = inner = '',
          push = tag => {
      if (outer) {
        buf += `${outer}>${inner}`;
        clear();
      }

      stack.push(tag);
    },
          attr = (name, value) => {
      if (value != null) outer += ` ${name}="${attrText(value)}"`;
      return m;
    },
          m = {
      open(tag, ...attrs) {
        push(tag);
        outer = '<' + tag;

        for (const set of attrs) {
          for (const key in set) attr(key, set[key]);
        }

        return m;
      },

      close() {
        const tag = stack.pop();

        if (outer) {
          buf += outer + (inner ? `>${inner}</${tag}>` : '/>');
        } else {
          buf += `</${tag}>`;
        }

        clear();
        return m;
      },

      attr,
      text: t => (inner += innerText(t), m),
      toString: () => buf
    };

    return m;
  }

  const serializeXML = node => _serialize(markup(), node) + '';

  function _serialize(m, node) {
    m.open(node.tagName);

    if (node.hasAttributes()) {
      const attrs = node.attributes,
            n = attrs.length;

      for (let i = 0; i < n; ++i) {
        m.attr(attrs[i].name, attrs[i].value);
      }
    }

    if (node.hasChildNodes()) {
      const children = node.childNodes,
            n = children.length;

      for (let i = 0; i < n; i++) {
        const child = children[i];
        child.nodeType === 3 // text node
        ? m.text(child.nodeValue) : _serialize(m, child);
      }
    }

    return m.close();
  }

  const styles = {
    fill: 'fill',
    fillOpacity: 'fill-opacity',
    stroke: 'stroke',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    strokeCap: 'stroke-linecap',
    strokeJoin: 'stroke-linejoin',
    strokeDash: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeMiterLimit: 'stroke-miterlimit',
    opacity: 'opacity',
    blend: 'mix-blend-mode'
  }; // ensure miter limit default is consistent with canvas (#2498)

  const rootAttributes = {
    'fill': 'none',
    'stroke-miterlimit': 10
  };
  const RootIndex = 0,
        xmlns = 'http://www.w3.org/2000/xmlns/',
        svgns = metadata.xmlns;

  function SVGRenderer(loader) {
    Renderer.call(this, loader);
    this._dirtyID = 0;
    this._dirty = [];
    this._svg = null;
    this._root = null;
    this._defs = null;
  }

  const base = Renderer.prototype;
  inherits(SVGRenderer, Renderer, {
    /**
     * Initialize a new SVGRenderer instance.
     * @param {DOMElement} el - The containing DOM element for the display.
     * @param {number} width - The coordinate width of the display, in pixels.
     * @param {number} height - The coordinate height of the display, in pixels.
     * @param {Array<number>} origin - The origin of the display, in pixels.
     *   The coordinate system will be translated to this point.
     * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
     *   the width and height to determine the final pixel size.
     * @return {SVGRenderer} - This renderer instance.
     */
    initialize(el, width, height, origin, scaleFactor) {
      // create the svg definitions cache
      this._defs = {};

      this._clearDefs();

      if (el) {
        this._svg = domChild(el, 0, 'svg', svgns);

        this._svg.setAttributeNS(xmlns, 'xmlns', svgns);

        this._svg.setAttributeNS(xmlns, 'xmlns:xlink', metadata['xmlns:xlink']);

        this._svg.setAttribute('version', metadata['version']);

        this._svg.setAttribute('class', 'marks');

        domClear(el, 1); // set the svg root group

        this._root = domChild(this._svg, RootIndex, 'g', svgns);
        setAttributes(this._root, rootAttributes); // ensure no additional child elements

        domClear(this._svg, RootIndex + 1);
      } // set background color if defined


      this.background(this._bgcolor);
      return base.initialize.call(this, el, width, height, origin, scaleFactor);
    },

    /**
     * Get / set the background color.
     */
    background(bgcolor) {
      if (arguments.length && this._svg) {
        this._svg.style.setProperty('background-color', bgcolor);
      }

      return base.background.apply(this, arguments);
    },

    /**
     * Resize the display.
     * @param {number} width - The new coordinate width of the display, in pixels.
     * @param {number} height - The new coordinate height of the display, in pixels.
     * @param {Array<number>} origin - The new origin of the display, in pixels.
     *   The coordinate system will be translated to this point.
     * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
     *   the width and height to determine the final pixel size.
     * @return {SVGRenderer} - This renderer instance;
     */
    resize(width, height, origin, scaleFactor) {
      base.resize.call(this, width, height, origin, scaleFactor);

      if (this._svg) {
        setAttributes(this._svg, {
          width: this._width * this._scale,
          height: this._height * this._scale,
          viewBox: `0 0 ${this._width} ${this._height}`
        });

        this._root.setAttribute('transform', `translate(${this._origin})`);
      }

      this._dirty = [];
      return this;
    },

    /**
     * Returns the SVG element of the visualization.
     * @return {DOMElement} - The SVG element.
     */
    canvas() {
      return this._svg;
    },

    /**
     * Returns an SVG text string for the rendered content,
     * or null if this renderer is currently headless.
     */
    svg() {
      const svg = this._svg,
            bg = this._bgcolor;
      if (!svg) return null;
      let node;

      if (bg) {
        svg.removeAttribute('style');
        node = domChild(svg, RootIndex, 'rect', svgns);
        setAttributes(node, {
          width: this._width,
          height: this._height,
          fill: bg
        });
      }

      const text = serializeXML(svg);

      if (bg) {
        svg.removeChild(node);

        this._svg.style.setProperty('background-color', bg);
      }

      return text;
    },

    /**
     * Internal rendering method.
     * @param {object} scene - The root mark of a scenegraph to render.
     */
    _render(scene) {
      // perform spot updates and re-render markup
      if (this._dirtyCheck()) {
        if (this._dirtyAll) this._clearDefs();
        this.mark(this._root, scene);
        domClear(this._root, 1);
      }

      this.defs();
      this._dirty = [];
      ++this._dirtyID;
      return this;
    },

    // -- Manage rendering of items marked as dirty --

    /**
     * Flag a mark item as dirty.
     * @param {Item} item - The mark item.
     */
    dirty(item) {
      if (item.dirty !== this._dirtyID) {
        item.dirty = this._dirtyID;

        this._dirty.push(item);
      }
    },

    /**
     * Check if a mark item is considered dirty.
     * @param {Item} item - The mark item.
     */
    isDirty(item) {
      return this._dirtyAll || !item._svg || item.dirty === this._dirtyID;
    },

    /**
     * Internal method to check dirty status and, if possible,
     * make targetted updates without a full rendering pass.
     */
    _dirtyCheck() {
      this._dirtyAll = true;
      const items = this._dirty;
      if (!items.length || !this._dirtyID) return true;
      const id = ++this._dirtyID;
      let item, mark, type, mdef, i, n, o;

      for (i = 0, n = items.length; i < n; ++i) {
        item = items[i];
        mark = item.mark;

        if (mark.marktype !== type) {
          // memoize mark instance lookup
          type = mark.marktype;
          mdef = Marks[type];
        }

        if (mark.zdirty && mark.dirty !== id) {
          this._dirtyAll = false;
          dirtyParents(item, id);
          mark.items.forEach(i => {
            i.dirty = id;
          });
        }

        if (mark.zdirty) continue; // handle in standard drawing pass

        if (item.exit) {
          // EXIT
          if (mdef.nested && mark.items.length) {
            // if nested mark with remaining points, update instead
            o = mark.items[0];
            if (o._svg) this._update(mdef, o._svg, o);
          } else if (item._svg) {
            // otherwise remove from DOM
            o = item._svg.parentNode;
            if (o) o.removeChild(item._svg);
          }

          item._svg = null;
          continue;
        }

        item = mdef.nested ? mark.items[0] : item;
        if (item._update === id) continue; // already visited

        if (!item._svg || !item._svg.ownerSVGElement) {
          // ENTER
          this._dirtyAll = false;
          dirtyParents(item, id);
        } else {
          // IN-PLACE UPDATE
          this._update(mdef, item._svg, item);
        }

        item._update = id;
      }

      return !this._dirtyAll;
    },

    // -- Construct & maintain scenegraph to SVG mapping ---

    /**
     * Render a set of mark items.
     * @param {SVGElement} el - The parent element in the SVG tree.
     * @param {object} scene - The mark parent to render.
     * @param {SVGElement} prev - The previous sibling in the SVG tree.
     */
    mark(el, scene, prev) {
      if (!this.isDirty(scene)) return scene._svg;
      const svg = this._svg,
            mdef = Marks[scene.marktype],
            events = scene.interactive === false ? 'none' : null,
            isGroup = mdef.tag === 'g';
      let sibling = null,
          i = 0;
      const parent = bind$1(scene, el, prev, 'g', svg);
      parent.setAttribute('class', cssClass(scene)); // apply aria attributes to parent container element

      const aria = ariaMarkAttributes(scene);

      for (const key in aria) setAttribute(parent, key, aria[key]);

      if (!isGroup) {
        setAttribute(parent, 'pointer-events', events);
      }

      setAttribute(parent, 'clip-path', scene.clip ? clip$1$1(this, scene, scene.group) : null);

      const process = item => {
        const dirty = this.isDirty(item),
              node = bind$1(item, parent, sibling, mdef.tag, svg);

        if (dirty) {
          this._update(mdef, node, item);

          if (isGroup) recurse(this, node, item);
        }

        sibling = node;
        ++i;
      };

      if (mdef.nested) {
        if (scene.items.length) process(scene.items[0]);
      } else {
        visit(scene, process);
      }

      domClear(parent, i);
      return parent;
    },

    /**
     * Update the attributes of an SVG element for a mark item.
     * @param {object} mdef - The mark definition object
     * @param {SVGElement} el - The SVG element.
     * @param {Item} item - The mark item.
     */
    _update(mdef, el, item) {
      // set dom element and values cache
      // provides access to emit method
      element$1 = el;
      values = el.__values__; // apply aria-specific properties

      ariaItemAttributes(emit, item); // apply svg attributes

      mdef.attr(emit, item, this); // some marks need special treatment

      const extra = mark_extras[mdef.type];
      if (extra) extra.call(this, mdef, el, item); // apply svg style attributes
      // note: element state may have been modified by 'extra' method

      if (element$1) this.style(element$1, item);
    },

    /**
     * Update the presentation attributes of an SVG element for a mark item.
     * @param {SVGElement} el - The SVG element.
     * @param {Item} item - The mark item.
     */
    style(el, item) {
      if (item == null) return;

      for (const prop in styles) {
        let value = prop === 'font' ? fontFamily(item) : item[prop];
        if (value === values[prop]) continue;
        const name = styles[prop];

        if (value == null) {
          el.removeAttribute(name);
        } else {
          if (isGradient(value)) {
            value = gradientRef(value, this._defs.gradient, href());
          }

          el.setAttribute(name, value + '');
        }

        values[prop] = value;
      }
    },

    /**
     * Render SVG defs, as needed.
     * Must be called *after* marks have been processed to ensure the
     * collected state is current and accurate.
     */
    defs() {
      const svg = this._svg,
            defs = this._defs;
      let el = defs.el,
          index = 0;

      for (const id in defs.gradient) {
        if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
        index = updateGradient(el, defs.gradient[id], index);
      }

      for (const id in defs.clipping) {
        if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
        index = updateClipping(el, defs.clipping[id], index);
      } // clean-up


      if (el) {
        index === 0 ? (svg.removeChild(el), defs.el = null) : domClear(el, index);
      }
    },

    /**
     * Clear defs caches.
     */
    _clearDefs() {
      const def = this._defs;
      def.gradient = {};
      def.clipping = {};
    }

  }); // mark ancestor chain with a dirty id

  function dirtyParents(item, id) {
    for (; item && item.dirty !== id; item = item.mark.group) {
      item.dirty = id;

      if (item.mark && item.mark.dirty !== id) {
        item.mark.dirty = id;
      } else return;
    }
  } // update gradient definitions


  function updateGradient(el, grad, index) {
    let i, n, stop;

    if (grad.gradient === 'radial') {
      // SVG radial gradients automatically transform to normalized bbox
      // coordinates, in a way that is cumbersome to replicate in canvas.
      // We wrap the radial gradient in a pattern element, allowing us to
      // maintain a circular gradient that matches what canvas provides.
      let pt = domChild(el, index++, 'pattern', svgns);
      setAttributes(pt, {
        id: patternPrefix + grad.id,
        viewBox: '0,0,1,1',
        width: '100%',
        height: '100%',
        preserveAspectRatio: 'xMidYMid slice'
      });
      pt = domChild(pt, 0, 'rect', svgns);
      setAttributes(pt, {
        width: 1,
        height: 1,
        fill: `url(${href()}#${grad.id})`
      });
      el = domChild(el, index++, 'radialGradient', svgns);
      setAttributes(el, {
        id: grad.id,
        fx: grad.x1,
        fy: grad.y1,
        fr: grad.r1,
        cx: grad.x2,
        cy: grad.y2,
        r: grad.r2
      });
    } else {
      el = domChild(el, index++, 'linearGradient', svgns);
      setAttributes(el, {
        id: grad.id,
        x1: grad.x1,
        x2: grad.x2,
        y1: grad.y1,
        y2: grad.y2
      });
    }

    for (i = 0, n = grad.stops.length; i < n; ++i) {
      stop = domChild(el, i, 'stop', svgns);
      stop.setAttribute('offset', grad.stops[i].offset);
      stop.setAttribute('stop-color', grad.stops[i].color);
    }

    domClear(el, i);
    return index;
  } // update clipping path definitions


  function updateClipping(el, clip, index) {
    let mask;
    el = domChild(el, index, 'clipPath', svgns);
    el.setAttribute('id', clip.id);

    if (clip.path) {
      mask = domChild(el, 0, 'path', svgns);
      mask.setAttribute('d', clip.path);
    } else {
      mask = domChild(el, 0, 'rect', svgns);
      setAttributes(mask, {
        x: 0,
        y: 0,
        width: clip.width,
        height: clip.height
      });
    }

    domClear(el, 1);
    return index + 1;
  } // Recursively process group contents.


  function recurse(renderer, el, group) {
    el = el.lastChild.previousSibling;
    let prev,
        idx = 0;
    visit(group, item => {
      prev = renderer.mark(el, item, prev);
      ++idx;
    }); // remove any extraneous DOM elements

    domClear(el, 1 + idx);
  } // Bind a scenegraph item to an SVG DOM element.
  // Create new SVG elements as needed.


  function bind$1(item, el, sibling, tag, svg) {
    let node = item._svg,
        doc; // create a new dom node if needed

    if (!node) {
      doc = el.ownerDocument;
      node = domCreate(doc, tag, svgns);
      item._svg = node;

      if (item.mark) {
        node.__data__ = item;
        node.__values__ = {
          fill: 'default'
        }; // if group, create background, content, and foreground elements

        if (tag === 'g') {
          const bg = domCreate(doc, 'path', svgns);
          node.appendChild(bg);
          bg.__data__ = item;
          const cg = domCreate(doc, 'g', svgns);
          node.appendChild(cg);
          cg.__data__ = item;
          const fg = domCreate(doc, 'path', svgns);
          node.appendChild(fg);
          fg.__data__ = item;
          fg.__values__ = {
            fill: 'default'
          };
        }
      }
    } // (re-)insert if (a) not contained in SVG or (b) sibling order has changed


    if (node.ownerSVGElement !== svg || siblingCheck(node, sibling)) {
      el.insertBefore(node, sibling ? sibling.nextSibling : el.firstChild);
    }

    return node;
  } // check if two nodes are ordered siblings


  function siblingCheck(node, sibling) {
    return node.parentNode && node.parentNode.childNodes.length > 1 && node.previousSibling != sibling; // treat null/undefined the same
  } // -- Set attributes & styles on SVG elements ---


  let element$1 = null,
      // temp var for current SVG element
  values = null; // temp var for current values hash
  // Extra configuration for certain mark types

  const mark_extras = {
    group(mdef, el, item) {
      const fg = element$1 = el.childNodes[2];
      values = fg.__values__;
      mdef.foreground(emit, item, this);
      values = el.__values__; // use parent's values hash

      element$1 = el.childNodes[1];
      mdef.content(emit, item, this);
      const bg = element$1 = el.childNodes[0];
      mdef.background(emit, item, this);
      const value = item.mark.interactive === false ? 'none' : null;

      if (value !== values.events) {
        setAttribute(fg, 'pointer-events', value);
        setAttribute(bg, 'pointer-events', value);
        values.events = value;
      }

      if (item.strokeForeground && item.stroke) {
        const fill = item.fill;
        setAttribute(fg, 'display', null); // set style of background

        this.style(bg, item);
        setAttribute(bg, 'stroke', null); // set style of foreground

        if (fill) item.fill = null;
        values = fg.__values__;
        this.style(fg, item);
        if (fill) item.fill = fill; // leave element null to prevent downstream styling

        element$1 = null;
      } else {
        // ensure foreground is ignored
        setAttribute(fg, 'display', 'none');
      }
    },

    image(mdef, el, item) {
      if (item.smooth === false) {
        setStyle(el, 'image-rendering', 'optimizeSpeed');
        setStyle(el, 'image-rendering', 'pixelated');
      } else {
        setStyle(el, 'image-rendering', null);
      }
    },

    text(mdef, el, item) {
      const tl = textLines(item);
      let key, value, doc, lh;

      if (isArray(tl)) {
        // multi-line text
        value = tl.map(_ => textValue(item, _));
        key = value.join('\n'); // content cache key

        if (key !== values.text) {
          domClear(el, 0);
          doc = el.ownerDocument;
          lh = lineHeight(item);
          value.forEach((t, i) => {
            const ts = domCreate(doc, 'tspan', svgns);
            ts.__data__ = item; // data binding

            ts.textContent = t;

            if (i) {
              ts.setAttribute('x', 0);
              ts.setAttribute('dy', lh);
            }

            el.appendChild(ts);
          });
          values.text = key;
        }
      } else {
        // single-line text
        value = textValue(item, tl);

        if (value !== values.text) {
          el.textContent = value;
          values.text = value;
        }
      }

      setAttribute(el, 'font-family', fontFamily(item));
      setAttribute(el, 'font-size', fontSize(item) + 'px');
      setAttribute(el, 'font-style', item.fontStyle);
      setAttribute(el, 'font-variant', item.fontVariant);
      setAttribute(el, 'font-weight', item.fontWeight);
    }

  };

  function emit(name, value, ns) {
    // early exit if value is unchanged
    if (value === values[name]) return; // use appropriate method given namespace (ns)

    if (ns) {
      setAttributeNS(element$1, name, value, ns);
    } else {
      setAttribute(element$1, name, value);
    } // note current value for future comparison


    values[name] = value;
  }

  function setStyle(el, name, value) {
    if (value !== values[name]) {
      if (value == null) {
        el.style.removeProperty(name);
      } else {
        el.style.setProperty(name, value + '');
      }

      values[name] = value;
    }
  }

  function setAttributes(el, attrs) {
    for (const key in attrs) {
      setAttribute(el, key, attrs[key]);
    }
  }

  function setAttribute(el, name, value) {
    if (value != null) {
      // if value is provided, update DOM attribute
      el.setAttribute(name, value);
    } else {
      // else remove DOM attribute
      el.removeAttribute(name);
    }
  }

  function setAttributeNS(el, name, value, ns) {
    if (value != null) {
      // if value is provided, update DOM attribute
      el.setAttributeNS(ns, name, value);
    } else {
      // else remove DOM attribute
      el.removeAttributeNS(ns, name);
    }
  }

  function href() {
    let loc;
    return typeof window === 'undefined' ? '' : (loc = window.location).hash ? loc.href.slice(0, -loc.hash.length) : loc.href;
  }

  function SVGStringRenderer(loader) {
    Renderer.call(this, loader);
    this._text = null;
    this._defs = {
      gradient: {},
      clipping: {}
    };
  }

  inherits(SVGStringRenderer, Renderer, {
    /**
     * Returns the rendered SVG text string,
     * or null if rendering has not yet occurred.
     */
    svg() {
      return this._text;
    },

    /**
     * Internal rendering method.
     * @param {object} scene - The root mark of a scenegraph to render.
     */
    _render(scene) {
      const m = markup(); // svg tag

      m.open('svg', extend$1({}, metadata, {
        class: 'marks',
        width: this._width * this._scale,
        height: this._height * this._scale,
        viewBox: `0 0 ${this._width} ${this._height}`
      })); // background, if defined

      const bg = this._bgcolor;

      if (bg && bg !== 'transparent' && bg !== 'none') {
        m.open('rect', {
          width: this._width,
          height: this._height,
          fill: bg
        }).close();
      } // root content group


      m.open('g', rootAttributes, {
        transform: 'translate(' + this._origin + ')'
      });
      this.mark(m, scene);
      m.close(); // </g>
      // defs

      this.defs(m); // get SVG text string

      this._text = m.close() + '';
      return this;
    },

    /**
     * Render a set of mark items.
     * @param {object} m - The markup context.
     * @param {object} scene - The mark parent to render.
     */
    mark(m, scene) {
      const mdef = Marks[scene.marktype],
            tag = mdef.tag,
            attrList = [ariaItemAttributes, mdef.attr]; // render opening group tag

      m.open('g', {
        'class': cssClass(scene),
        'clip-path': scene.clip ? clip$1$1(this, scene, scene.group) : null
      }, ariaMarkAttributes(scene), {
        'pointer-events': tag !== 'g' && scene.interactive === false ? 'none' : null
      }); // render contained elements

      const process = item => {
        const href = this.href(item);
        if (href) m.open('a', href);
        m.open(tag, this.attr(scene, item, attrList, tag !== 'g' ? tag : null));

        if (tag === 'text') {
          const tl = textLines(item);

          if (isArray(tl)) {
            // multi-line text
            const attrs = {
              x: 0,
              dy: lineHeight(item)
            };

            for (let i = 0; i < tl.length; ++i) {
              m.open('tspan', i ? attrs : null).text(textValue(item, tl[i])).close();
            }
          } else {
            // single-line text
            m.text(textValue(item, tl));
          }
        } else if (tag === 'g') {
          const fore = item.strokeForeground,
                fill = item.fill,
                stroke = item.stroke;

          if (fore && stroke) {
            item.stroke = null;
          }

          m.open('path', this.attr(scene, item, mdef.background, 'bgrect')).close(); // recurse for group content

          m.open('g', this.attr(scene, item, mdef.content));
          visit(item, scene => this.mark(m, scene));
          m.close();

          if (fore && stroke) {
            if (fill) item.fill = null;
            item.stroke = stroke;
            m.open('path', this.attr(scene, item, mdef.foreground, 'bgrect')).close();
            if (fill) item.fill = fill;
          } else {
            m.open('path', this.attr(scene, item, mdef.foreground, 'bgfore')).close();
          }
        }

        m.close(); // </tag>

        if (href) m.close(); // </a>
      };

      if (mdef.nested) {
        if (scene.items && scene.items.length) process(scene.items[0]);
      } else {
        visit(scene, process);
      } // render closing group tag


      return m.close(); // </g>
    },

    /**
     * Get href attributes for a hyperlinked mark item.
     * @param {Item} item - The mark item.
     */
    href(item) {
      const href = item.href;
      let attr;

      if (href) {
        if (attr = this._hrefs && this._hrefs[href]) {
          return attr;
        } else {
          this.sanitizeURL(href).then(attr => {
            // rewrite to use xlink namespace
            attr['xlink:href'] = attr.href;
            attr.href = null;
            (this._hrefs || (this._hrefs = {}))[href] = attr;
          });
        }
      }

      return null;
    },

    /**
     * Get an object of SVG attributes for a mark item.
     * @param {object} scene - The mark parent.
     * @param {Item} item - The mark item.
     * @param {array|function} attrs - One or more attribute emitters.
     * @param {string} tag - The tag being rendered.
     */
    attr(scene, item, attrs, tag) {
      const object = {},
            emit = (name, value, ns, prefixed) => {
        object[prefixed || name] = value;
      }; // apply mark specific attributes


      if (Array.isArray(attrs)) {
        attrs.forEach(fn => fn(emit, item, this));
      } else {
        attrs(emit, item, this);
      } // apply style attributes


      if (tag) {
        style(object, item, scene, tag, this._defs);
      }

      return object;
    },

    /**
     * Render SVG defs, as needed.
     * Must be called *after* marks have been processed to ensure the
     * collected state is current and accurate.
     * @param {object} m - The markup context.
     */
    defs(m) {
      const gradient = this._defs.gradient,
            clipping = this._defs.clipping,
            count = Object.keys(gradient).length + Object.keys(clipping).length;
      if (count === 0) return; // nothing to do

      m.open('defs');

      for (const id in gradient) {
        const def = gradient[id],
              stops = def.stops;

        if (def.gradient === 'radial') {
          // SVG radial gradients automatically transform to normalized bbox
          // coordinates, in a way that is cumbersome to replicate in canvas.
          // We wrap the radial gradient in a pattern element, allowing us to
          // maintain a circular gradient that matches what canvas provides.
          m.open('pattern', {
            id: patternPrefix + id,
            viewBox: '0,0,1,1',
            width: '100%',
            height: '100%',
            preserveAspectRatio: 'xMidYMid slice'
          });
          m.open('rect', {
            width: '1',
            height: '1',
            fill: 'url(#' + id + ')'
          }).close();
          m.close(); // </pattern>

          m.open('radialGradient', {
            id: id,
            fx: def.x1,
            fy: def.y1,
            fr: def.r1,
            cx: def.x2,
            cy: def.y2,
            r: def.r2
          });
        } else {
          m.open('linearGradient', {
            id: id,
            x1: def.x1,
            x2: def.x2,
            y1: def.y1,
            y2: def.y2
          });
        }

        for (let i = 0; i < stops.length; ++i) {
          m.open('stop', {
            offset: stops[i].offset,
            'stop-color': stops[i].color
          }).close();
        }

        m.close();
      }

      for (const id in clipping) {
        const def = clipping[id];
        m.open('clipPath', {
          id: id
        });

        if (def.path) {
          m.open('path', {
            d: def.path
          }).close();
        } else {
          m.open('rect', {
            x: 0,
            y: 0,
            width: def.width,
            height: def.height
          }).close();
        }

        m.close();
      }

      m.close();
    }

  }); // Helper function for attr for style presentation attributes

  function style(s, item, scene, tag, defs) {
    if (item == null) return s;

    if (tag === 'bgrect' && scene.interactive === false) {
      s['pointer-events'] = 'none';
    }

    if (tag === 'bgfore') {
      if (scene.interactive === false) {
        s['pointer-events'] = 'none';
      }

      s.display = 'none';
      if (item.fill !== null) return s;
    }

    if (tag === 'image' && item.smooth === false) {
      s.style = 'image-rendering: optimizeSpeed; image-rendering: pixelated;';
    }

    if (tag === 'text') {
      s['font-family'] = fontFamily(item);
      s['font-size'] = fontSize(item) + 'px';
      s['font-style'] = item.fontStyle;
      s['font-variant'] = item.fontVariant;
      s['font-weight'] = item.fontWeight;
    }

    for (const prop in styles) {
      let value = item[prop];
      const name = styles[prop];
      if (value === 'transparent' && (name === 'fill' || name === 'stroke')) ;else if (value != null) {
        if (isGradient(value)) {
          value = gradientRef(value, defs.gradient, '');
        }

        s[name] = value;
      }
    }

    return s;
  }

  const Canvas = 'canvas';
  const PNG = 'png';
  const SVG = 'svg';
  const None$1 = 'none';
  const RenderType = {
    Canvas: Canvas,
    PNG: PNG,
    SVG: SVG,
    None: None$1
  };
  const modules = {};
  modules[Canvas] = modules[PNG] = {
    renderer: CanvasRenderer,
    headless: CanvasRenderer,
    handler: CanvasHandler
  };
  modules[SVG] = {
    renderer: SVGRenderer,
    headless: SVGStringRenderer,
    handler: SVGHandler
  };
  modules[None$1] = {};

  function renderModule(name, _) {
    name = String(name || '').toLowerCase();

    if (arguments.length > 1) {
      modules[name] = _;
      return this;
    } else {
      return modules[name];
    }
  }

  function intersect$2(scene, bounds, filter) {
    const hits = [],
          // intersection results
    box = new Bounds().union(bounds),
          // defensive copy
    type = scene.marktype;
    return type ? intersectMark(scene, box, filter, hits) : type === 'group' ? intersectGroup(scene, box, filter, hits) : error('Intersect scene must be mark node or group item.');
  }

  function intersectMark(mark, box, filter, hits) {
    if (visitMark(mark, box, filter)) {
      const items = mark.items,
            type = mark.marktype,
            n = items.length;
      let i = 0;

      if (type === 'group') {
        for (; i < n; ++i) {
          intersectGroup(items[i], box, filter, hits);
        }
      } else {
        for (const test = Marks[type].isect; i < n; ++i) {
          const item = items[i];
          if (intersectItem(item, box, test)) hits.push(item);
        }
      }
    }

    return hits;
  }

  function visitMark(mark, box, filter) {
    // process if bounds intersect and if
    // (1) mark is a group mark (so we must recurse), or
    // (2) mark is interactive and passes filter
    return mark.bounds && box.intersects(mark.bounds) && (mark.marktype === 'group' || mark.interactive !== false && (!filter || filter(mark)));
  }

  function intersectGroup(group, box, filter, hits) {
    // test intersect against group
    // skip groups by default unless filter says otherwise
    if (filter && filter(group.mark) && intersectItem(group, box, Marks.group.isect)) {
      hits.push(group);
    } // recursively test children marks
    // translate box to group coordinate space


    const marks = group.items,
          n = marks && marks.length;

    if (n) {
      const x = group.x || 0,
            y = group.y || 0;
      box.translate(-x, -y);

      for (let i = 0; i < n; ++i) {
        intersectMark(marks[i], box, filter, hits);
      }

      box.translate(x, y);
    }

    return hits;
  }

  function intersectItem(item, box, test) {
    // test bounds enclosure, bounds intersection, then detailed test
    const bounds = item.bounds;
    return box.encloses(bounds) || box.intersects(bounds) && test(item, box);
  }

  const clipBounds = new Bounds();

  function boundClip(mark) {
    const clip = mark.clip;

    if (isFunction(clip)) {
      clip(boundContext(clipBounds.clear()));
    } else if (clip) {
      clipBounds.set(0, 0, mark.group.width, mark.group.height);
    } else return;

    mark.bounds.intersect(clipBounds);
  }

  const TOLERANCE = 1e-9;

  function sceneEqual(a, b, key) {
    return a === b ? true : key === 'path' ? pathEqual(a, b) : a instanceof Date && b instanceof Date ? +a === +b : isNumber$1(a) && isNumber$1(b) ? Math.abs(a - b) <= TOLERANCE : !a || !b || !isObject(a) && !isObject(b) ? a == b : objectEqual(a, b);
  }

  function pathEqual(a, b) {
    return sceneEqual(pathParse(a), pathParse(b));
  }

  function objectEqual(a, b) {
    var ka = Object.keys(a),
        kb = Object.keys(b),
        key,
        i;
    if (ka.length !== kb.length) return false;
    ka.sort();
    kb.sort();

    for (i = ka.length - 1; i >= 0; i--) {
      if (ka[i] != kb[i]) return false;
    }

    for (i = ka.length - 1; i >= 0; i--) {
      key = ka[i];
      if (!sceneEqual(a[key], b[key], key)) return false;
    }

    return typeof a === typeof b;
  }

  function resetSVGDefIds() {
    resetSVGClipId();
    resetSVGGradientId();
  }

  const Top$1 = 'top';
  const Left$1 = 'left';
  const Right$1 = 'right';
  const Bottom$1 = 'bottom';
  const TopLeft = 'top-left';
  const TopRight = 'top-right';
  const BottomLeft = 'bottom-left';
  const BottomRight = 'bottom-right';
  const Start$1 = 'start';
  const Middle$1 = 'middle';
  const End$1 = 'end';
  const X = 'x';
  const Y = 'y';
  const Group = 'group';
  const AxisRole$1 = 'axis';
  const TitleRole$1 = 'title';
  const FrameRole$1 = 'frame';
  const ScopeRole$1 = 'scope';
  const LegendRole$1 = 'legend';
  const RowHeader = 'row-header';
  const RowFooter = 'row-footer';
  const RowTitle = 'row-title';
  const ColHeader = 'column-header';
  const ColFooter = 'column-footer';
  const ColTitle = 'column-title';
  const Padding$1 = 'padding';
  const Symbols$1 = 'symbol';
  const Fit = 'fit';
  const FitX = 'fit-x';
  const FitY = 'fit-y';
  const Pad = 'pad';
  const None = 'none';
  const All = 'all';
  const Each = 'each';
  const Flush = 'flush';
  const Column = 'column';
  const Row = 'row';
  /**
   * Calculate bounding boxes for scenegraph items.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {object} params.mark - The scenegraph mark instance to bound.
   */

  function Bound$1(params) {
    Transform.call(this, null, params);
  }

  inherits(Bound$1, Transform, {
    transform(_, pulse) {
      const view = pulse.dataflow,
            mark = _.mark,
            type = mark.marktype,
            entry = Marks[type],
            bound = entry.bound;
      let markBounds = mark.bounds,
          rebound;

      if (entry.nested) {
        // multi-item marks have a single bounds instance
        if (mark.items.length) view.dirty(mark.items[0]);
        markBounds = boundItem(mark, bound);
        mark.items.forEach(item => {
          item.bounds.clear().union(markBounds);
        });
      } else if (type === Group || _.modified()) {
        // operator parameters modified -> re-bound all items
        // updates group bounds in response to modified group content
        pulse.visit(pulse.MOD, item => view.dirty(item));
        markBounds.clear();
        mark.items.forEach(item => markBounds.union(boundItem(item, bound))); // force reflow for axes/legends/titles to propagate any layout changes

        switch (mark.role) {
          case AxisRole$1:
          case LegendRole$1:
          case TitleRole$1:
            pulse.reflow();
        }
      } else {
        // incrementally update bounds, re-bound mark as needed
        rebound = pulse.changed(pulse.REM);
        pulse.visit(pulse.ADD, item => {
          markBounds.union(boundItem(item, bound));
        });
        pulse.visit(pulse.MOD, item => {
          rebound = rebound || markBounds.alignsWith(item.bounds);
          view.dirty(item);
          markBounds.union(boundItem(item, bound));
        });

        if (rebound) {
          markBounds.clear();
          mark.items.forEach(item => markBounds.union(item.bounds));
        }
      } // ensure mark bounds do not exceed any clipping region


      boundClip(mark);
      return pulse.modifies('bounds');
    }

  });

  function boundItem(item, bound, opt) {
    return bound(item.bounds.clear(), item, opt);
  }

  const COUNTER_NAME = ':vega_identifier:';
  /**
   * Adds a unique identifier to all added tuples.
   * This transform creates a new signal that serves as an id counter.
   * As a result, the id counter is shared across all instances of this
   * transform, generating unique ids across multiple data streams. In
   * addition, this signal value can be included in a snapshot of the
   * dataflow state, enabling correct resumption of id allocation.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {string} params.as - The field name for the generated identifier.
   */

  function Identifier$1(params) {
    Transform.call(this, 0, params);
  }

  Identifier$1.Definition = {
    'type': 'Identifier',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'as',
      'type': 'string',
      'required': true
    }]
  };
  inherits(Identifier$1, Transform, {
    transform(_, pulse) {
      const counter = getCounter(pulse.dataflow),
            as = _.as;
      let id = counter.value;
      pulse.visit(pulse.ADD, t => t[as] = t[as] || ++id);
      counter.set(this.value = id);
      return pulse;
    }

  });

  function getCounter(view) {
    return view._signals[COUNTER_NAME] || (view._signals[COUNTER_NAME] = view.add(0));
  }
  /**
   * Bind scenegraph items to a scenegraph mark instance.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {object} params.markdef - The mark definition for creating the mark.
   *   This is an object of legal scenegraph mark properties which *must* include
   *   the 'marktype' property.
   */


  function Mark$1(params) {
    Transform.call(this, null, params);
  }

  inherits(Mark$1, Transform, {
    transform(_, pulse) {
      let mark = this.value; // acquire mark on first invocation, bind context and group

      if (!mark) {
        mark = pulse.dataflow.scenegraph().mark(_.markdef, lookup$1$1(_), _.index);
        mark.group.context = _.context;
        if (!_.context.group) _.context.group = mark.group;
        mark.source = this.source; // point to upstream collector

        mark.clip = _.clip;
        mark.interactive = _.interactive;
        this.value = mark;
      } // initialize entering items


      const Init = mark.marktype === Group ? GroupItem : Item;
      pulse.visit(pulse.ADD, item => Init.call(item, mark)); // update clipping and/or interactive status

      if (_.modified('clip') || _.modified('interactive')) {
        mark.clip = _.clip;
        mark.interactive = !!_.interactive;
        mark.zdirty = true; // force scenegraph re-eval

        pulse.reflow();
      } // bind items array to scenegraph mark


      mark.items = pulse.source;
      return pulse;
    }

  });

  function lookup$1$1(_) {
    const g = _.groups,
          p = _.parent;
    return g && g.size === 1 ? g.get(Object.keys(g.object)[0]) : g && p ? g.lookup(p) : null;
  }
  /**
   * Analyze items for overlap, changing opacity to hide items with
   * overlapping bounding boxes. This transform will preserve at least
   * two items (e.g., first and last) even if overlap persists.
   * @param {object} params - The parameters for this operator.
   * @param {function(*,*): number} [params.sort] - A comparator
   *   function for sorting items.
   * @param {object} [params.method] - The overlap removal method to apply.
   *   One of 'parity' (default, hide every other item until there is no
   *   more overlap) or 'greedy' (sequentially scan and hide and items that
   *   overlap with the last visible item).
   * @param {object} [params.boundScale] - A scale whose range should be used
   *   to bound the items. Items exceeding the bounds of the scale range
   *   will be treated as overlapping. If null or undefined, no bounds check
   *   will be applied.
   * @param {object} [params.boundOrient] - The orientation of the scale
   *   (top, bottom, left, or right) used to bound items. This parameter is
   *   ignored if boundScale is null or undefined.
   * @param {object} [params.boundTolerance] - The tolerance in pixels for
   *   bound inclusion testing (default 1). This specifies by how many pixels
   *   an item's bounds may exceed the scale range bounds and not be culled.
   * @constructor
   */


  function Overlap$1(params) {
    Transform.call(this, null, params);
  }

  const methods = {
    parity: items => items.filter((item, i) => i % 2 ? item.opacity = 0 : 1),
    greedy: (items, sep) => {
      let a;
      return items.filter((b, i) => !i || !intersect$1(a.bounds, b.bounds, sep) ? (a = b, 1) : b.opacity = 0);
    }
  }; // compute bounding box intersection
  // including padding pixels of separation

  const intersect$1 = (a, b, sep) => sep > Math.max(b.x1 - a.x2, a.x1 - b.x2, b.y1 - a.y2, a.y1 - b.y2);

  const hasOverlap = (items, pad) => {
    for (var i = 1, n = items.length, a = items[0].bounds, b; i < n; a = b, ++i) {
      if (intersect$1(a, b = items[i].bounds, pad)) return true;
    }
  };

  const hasBounds = item => {
    const b = item.bounds;
    return b.width() > 1 && b.height() > 1;
  };

  const boundTest = (scale, orient, tolerance) => {
    var range = scale.range(),
        b = new Bounds();

    if (orient === Top$1 || orient === Bottom$1) {
      b.set(range[0], -Infinity, range[1], +Infinity);
    } else {
      b.set(-Infinity, range[0], +Infinity, range[1]);
    }

    b.expand(tolerance || 1);
    return item => b.encloses(item.bounds);
  }; // reset all items to be fully opaque


  const reset = source => {
    source.forEach(item => item.opacity = 1);
    return source;
  }; // add all tuples to mod, fork pulse if parameters were modified
  // fork prevents cross-stream tuple pollution (e.g., pulse from scale)


  const reflow = (pulse, _) => pulse.reflow(_.modified()).modifies('opacity');

  inherits(Overlap$1, Transform, {
    transform(_, pulse) {
      const reduce = methods[_.method] || methods.parity,
            sep = _.separation || 0;
      let source = pulse.materialize(pulse.SOURCE).source,
          items,
          test;
      if (!source || !source.length) return;

      if (!_.method) {
        // early exit if method is falsy
        if (_.modified('method')) {
          reset(source);
          pulse = reflow(pulse, _);
        }

        return pulse;
      } // skip labels with no content


      source = source.filter(hasBounds); // early exit, nothing to do

      if (!source.length) return;

      if (_.sort) {
        source = source.slice().sort(_.sort);
      }

      items = reset(source);
      pulse = reflow(pulse, _);

      if (items.length >= 3 && hasOverlap(items, sep)) {
        do {
          items = reduce(items, sep);
        } while (items.length >= 3 && hasOverlap(items, sep));

        if (items.length < 3 && !peek$1(source).opacity) {
          if (items.length > 1) peek$1(items).opacity = 0;
          peek$1(source).opacity = 1;
        }
      }

      if (_.boundScale && _.boundTolerance >= 0) {
        test = boundTest(_.boundScale, _.boundOrient, +_.boundTolerance);
        source.forEach(item => {
          if (!test(item)) item.opacity = 0;
        });
      } // re-calculate mark bounds


      const bounds = items[0].mark.bounds.clear();
      source.forEach(item => {
        if (item.opacity) bounds.union(item.bounds);
      });
      return pulse;
    }

  });
  /**
   * Queue modified scenegraph items for rendering.
   * @constructor
   */

  function Render$1(params) {
    Transform.call(this, null, params);
  }

  inherits(Render$1, Transform, {
    transform(_, pulse) {
      const view = pulse.dataflow;
      pulse.visit(pulse.ALL, item => view.dirty(item)); // set z-index dirty flag as needed

      if (pulse.fields && pulse.fields['zindex']) {
        const item = pulse.source && pulse.source[0];
        if (item) item.mark.zdirty = true;
      }
    }

  });
  const tempBounds = new Bounds();

  function set$2(item, property, value) {
    return item[property] === value ? 0 : (item[property] = value, 1);
  }

  function isYAxis(mark) {
    var orient = mark.items[0].orient;
    return orient === Left$1 || orient === Right$1;
  }

  function axisIndices(datum) {
    let index = +datum.grid;
    return [datum.ticks ? index++ : -1, // ticks index
    datum.labels ? index++ : -1, // labels index
    index + +datum.domain // title index
    ];
  }

  function axisLayout(view, axis, width, height) {
    var item = axis.items[0],
        datum = item.datum,
        delta = item.translate != null ? item.translate : 0.5,
        orient = item.orient,
        indices = axisIndices(datum),
        range = item.range,
        offset = item.offset,
        position = item.position,
        minExtent = item.minExtent,
        maxExtent = item.maxExtent,
        title = datum.title && item.items[indices[2]].items[0],
        titlePadding = item.titlePadding,
        bounds = item.bounds,
        dl = title && multiLineOffset(title),
        x = 0,
        y = 0,
        i,
        s;
    tempBounds.clear().union(bounds);
    bounds.clear();
    if ((i = indices[0]) > -1) bounds.union(item.items[i].bounds);
    if ((i = indices[1]) > -1) bounds.union(item.items[i].bounds); // position axis group and title

    switch (orient) {
      case Top$1:
        x = position || 0;
        y = -offset;
        s = Math.max(minExtent, Math.min(maxExtent, -bounds.y1));
        bounds.add(0, -s).add(range, 0);
        if (title) axisTitleLayout(view, title, s, titlePadding, dl, 0, -1, bounds);
        break;

      case Left$1:
        x = -offset;
        y = position || 0;
        s = Math.max(minExtent, Math.min(maxExtent, -bounds.x1));
        bounds.add(-s, 0).add(0, range);
        if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, -1, bounds);
        break;

      case Right$1:
        x = width + offset;
        y = position || 0;
        s = Math.max(minExtent, Math.min(maxExtent, bounds.x2));
        bounds.add(0, 0).add(s, range);
        if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, 1, bounds);
        break;

      case Bottom$1:
        x = position || 0;
        y = height + offset;
        s = Math.max(minExtent, Math.min(maxExtent, bounds.y2));
        bounds.add(0, 0).add(range, s);
        if (title) axisTitleLayout(view, title, s, titlePadding, 0, 0, 1, bounds);
        break;

      default:
        x = item.x;
        y = item.y;
    } // update bounds


    boundStroke(bounds.translate(x, y), item);

    if (set$2(item, 'x', x + delta) | set$2(item, 'y', y + delta)) {
      item.bounds = tempBounds;
      view.dirty(item);
      item.bounds = bounds;
      view.dirty(item);
    }

    return item.mark.bounds.clear().union(bounds);
  }

  function axisTitleLayout(view, title, offset, pad, dl, isYAxis, sign, bounds) {
    const b = title.bounds;

    if (title.auto) {
      const v = sign * (offset + dl + pad);
      let dx = 0,
          dy = 0;
      view.dirty(title);
      isYAxis ? dx = (title.x || 0) - (title.x = v) : dy = (title.y || 0) - (title.y = v);
      title.mark.bounds.clear().union(b.translate(-dx, -dy));
      view.dirty(title);
    }

    bounds.union(b);
  }

  const min = (a, b) => Math.floor(Math.min(a, b));

  const max = (a, b) => Math.ceil(Math.max(a, b));

  function gridLayoutGroups(group) {
    var groups = group.items,
        n = groups.length,
        i = 0,
        mark,
        items;
    const views = {
      marks: [],
      rowheaders: [],
      rowfooters: [],
      colheaders: [],
      colfooters: [],
      rowtitle: null,
      coltitle: null
    }; // layout axes, gather legends, collect bounds

    for (; i < n; ++i) {
      mark = groups[i];
      items = mark.items;

      if (mark.marktype === Group) {
        switch (mark.role) {
          case AxisRole$1:
          case LegendRole$1:
          case TitleRole$1:
            break;

          case RowHeader:
            views.rowheaders.push(...items);
            break;

          case RowFooter:
            views.rowfooters.push(...items);
            break;

          case ColHeader:
            views.colheaders.push(...items);
            break;

          case ColFooter:
            views.colfooters.push(...items);
            break;

          case RowTitle:
            views.rowtitle = items[0];
            break;

          case ColTitle:
            views.coltitle = items[0];
            break;

          default:
            views.marks.push(...items);
        }
      }
    }

    return views;
  }

  function bboxFlush(item) {
    return new Bounds().set(0, 0, item.width || 0, item.height || 0);
  }

  function bboxFull(item) {
    const b = item.bounds.clone();
    return b.empty() ? b.set(0, 0, 0, 0) : b.translate(-(item.x || 0), -(item.y || 0));
  }

  function get$1(opt, key, d) {
    const v = isObject(opt) ? opt[key] : opt;
    return v != null ? v : d !== undefined ? d : 0;
  }

  function offsetValue$1(v) {
    return v < 0 ? Math.ceil(-v) : 0;
  }

  function gridLayout(view, groups, opt) {
    var dirty = !opt.nodirty,
        bbox = opt.bounds === Flush ? bboxFlush : bboxFull,
        bounds = tempBounds.set(0, 0, 0, 0),
        alignCol = get$1(opt.align, Column),
        alignRow = get$1(opt.align, Row),
        padCol = get$1(opt.padding, Column),
        padRow = get$1(opt.padding, Row),
        ncols = opt.columns || groups.length,
        nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols),
        n = groups.length,
        xOffset = Array(n),
        xExtent = Array(ncols),
        xMax = 0,
        yOffset = Array(n),
        yExtent = Array(nrows),
        yMax = 0,
        dx = Array(n),
        dy = Array(n),
        boxes = Array(n),
        m,
        i,
        c,
        r,
        b,
        g,
        px,
        py,
        x,
        y,
        offset;

    for (i = 0; i < ncols; ++i) xExtent[i] = 0;

    for (i = 0; i < nrows; ++i) yExtent[i] = 0; // determine offsets for each group


    for (i = 0; i < n; ++i) {
      g = groups[i];
      b = boxes[i] = bbox(g);
      g.x = g.x || 0;
      dx[i] = 0;
      g.y = g.y || 0;
      dy[i] = 0;
      c = i % ncols;
      r = ~~(i / ncols);
      xMax = Math.max(xMax, px = Math.ceil(b.x2));
      yMax = Math.max(yMax, py = Math.ceil(b.y2));
      xExtent[c] = Math.max(xExtent[c], px);
      yExtent[r] = Math.max(yExtent[r], py);
      xOffset[i] = padCol + offsetValue$1(b.x1);
      yOffset[i] = padRow + offsetValue$1(b.y1);
      if (dirty) view.dirty(groups[i]);
    } // set initial alignment offsets


    for (i = 0; i < n; ++i) {
      if (i % ncols === 0) xOffset[i] = 0;
      if (i < ncols) yOffset[i] = 0;
    } // enforce column alignment constraints


    if (alignCol === Each) {
      for (c = 1; c < ncols; ++c) {
        for (offset = 0, i = c; i < n; i += ncols) {
          if (offset < xOffset[i]) offset = xOffset[i];
        }

        for (i = c; i < n; i += ncols) {
          xOffset[i] = offset + xExtent[c - 1];
        }
      }
    } else if (alignCol === All) {
      for (offset = 0, i = 0; i < n; ++i) {
        if (i % ncols && offset < xOffset[i]) offset = xOffset[i];
      }

      for (i = 0; i < n; ++i) {
        if (i % ncols) xOffset[i] = offset + xMax;
      }
    } else {
      for (alignCol = false, c = 1; c < ncols; ++c) {
        for (i = c; i < n; i += ncols) {
          xOffset[i] += xExtent[c - 1];
        }
      }
    } // enforce row alignment constraints


    if (alignRow === Each) {
      for (r = 1; r < nrows; ++r) {
        for (offset = 0, i = r * ncols, m = i + ncols; i < m; ++i) {
          if (offset < yOffset[i]) offset = yOffset[i];
        }

        for (i = r * ncols; i < m; ++i) {
          yOffset[i] = offset + yExtent[r - 1];
        }
      }
    } else if (alignRow === All) {
      for (offset = 0, i = ncols; i < n; ++i) {
        if (offset < yOffset[i]) offset = yOffset[i];
      }

      for (i = ncols; i < n; ++i) {
        yOffset[i] = offset + yMax;
      }
    } else {
      for (alignRow = false, r = 1; r < nrows; ++r) {
        for (i = r * ncols, m = i + ncols; i < m; ++i) {
          yOffset[i] += yExtent[r - 1];
        }
      }
    } // perform horizontal grid layout


    for (x = 0, i = 0; i < n; ++i) {
      x = xOffset[i] + (i % ncols ? x : 0);
      dx[i] += x - groups[i].x;
    } // perform vertical grid layout


    for (c = 0; c < ncols; ++c) {
      for (y = 0, i = c; i < n; i += ncols) {
        y += yOffset[i];
        dy[i] += y - groups[i].y;
      }
    } // perform horizontal centering


    if (alignCol && get$1(opt.center, Column) && nrows > 1) {
      for (i = 0; i < n; ++i) {
        b = alignCol === All ? xMax : xExtent[i % ncols];
        x = b - boxes[i].x2 - groups[i].x - dx[i];
        if (x > 0) dx[i] += x / 2;
      }
    } // perform vertical centering


    if (alignRow && get$1(opt.center, Row) && ncols !== 1) {
      for (i = 0; i < n; ++i) {
        b = alignRow === All ? yMax : yExtent[~~(i / ncols)];
        y = b - boxes[i].y2 - groups[i].y - dy[i];
        if (y > 0) dy[i] += y / 2;
      }
    } // position grid relative to anchor


    for (i = 0; i < n; ++i) {
      bounds.union(boxes[i].translate(dx[i], dy[i]));
    }

    x = get$1(opt.anchor, X);
    y = get$1(opt.anchor, Y);

    switch (get$1(opt.anchor, Column)) {
      case End$1:
        x -= bounds.width();
        break;

      case Middle$1:
        x -= bounds.width() / 2;
    }

    switch (get$1(opt.anchor, Row)) {
      case End$1:
        y -= bounds.height();
        break;

      case Middle$1:
        y -= bounds.height() / 2;
    }

    x = Math.round(x);
    y = Math.round(y); // update mark positions, bounds, dirty

    bounds.clear();

    for (i = 0; i < n; ++i) {
      groups[i].mark.bounds.clear();
    }

    for (i = 0; i < n; ++i) {
      g = groups[i];
      g.x += dx[i] += x;
      g.y += dy[i] += y;
      bounds.union(g.mark.bounds.union(g.bounds.translate(dx[i], dy[i])));
      if (dirty) view.dirty(g);
    }

    return bounds;
  }

  function trellisLayout(view, group, opt) {
    var views = gridLayoutGroups(group),
        groups = views.marks,
        bbox = opt.bounds === Flush ? boundFlush : boundFull,
        off = opt.offset,
        ncols = opt.columns || groups.length,
        nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols),
        cells = nrows * ncols,
        x,
        y,
        x2,
        y2,
        anchor,
        band,
        offset; // -- initial grid layout

    const bounds = gridLayout(view, groups, opt);
    if (bounds.empty()) bounds.set(0, 0, 0, 0); // empty grid
    // -- layout grid headers and footers --
    // perform row header layout

    if (views.rowheaders) {
      band = get$1(opt.headerBand, Row, null);
      x = layoutHeaders(view, views.rowheaders, groups, ncols, nrows, -get$1(off, 'rowHeader'), min, 0, bbox, 'x1', 0, ncols, 1, band);
    } // perform column header layout


    if (views.colheaders) {
      band = get$1(opt.headerBand, Column, null);
      y = layoutHeaders(view, views.colheaders, groups, ncols, ncols, -get$1(off, 'columnHeader'), min, 1, bbox, 'y1', 0, 1, ncols, band);
    } // perform row footer layout


    if (views.rowfooters) {
      band = get$1(opt.footerBand, Row, null);
      x2 = layoutHeaders(view, views.rowfooters, groups, ncols, nrows, get$1(off, 'rowFooter'), max, 0, bbox, 'x2', ncols - 1, ncols, 1, band);
    } // perform column footer layout


    if (views.colfooters) {
      band = get$1(opt.footerBand, Column, null);
      y2 = layoutHeaders(view, views.colfooters, groups, ncols, ncols, get$1(off, 'columnFooter'), max, 1, bbox, 'y2', cells - ncols, 1, ncols, band);
    } // perform row title layout


    if (views.rowtitle) {
      anchor = get$1(opt.titleAnchor, Row);
      offset = get$1(off, 'rowTitle');
      offset = anchor === End$1 ? x2 + offset : x - offset;
      band = get$1(opt.titleBand, Row, 0.5);
      layoutTitle(view, views.rowtitle, offset, 0, bounds, band);
    } // perform column title layout


    if (views.coltitle) {
      anchor = get$1(opt.titleAnchor, Column);
      offset = get$1(off, 'columnTitle');
      offset = anchor === End$1 ? y2 + offset : y - offset;
      band = get$1(opt.titleBand, Column, 0.5);
      layoutTitle(view, views.coltitle, offset, 1, bounds, band);
    }
  }

  function boundFlush(item, field) {
    return field === 'x1' ? item.x || 0 : field === 'y1' ? item.y || 0 : field === 'x2' ? (item.x || 0) + (item.width || 0) : field === 'y2' ? (item.y || 0) + (item.height || 0) : undefined;
  }

  function boundFull(item, field) {
    return item.bounds[field];
  }

  function layoutHeaders(view, headers, groups, ncols, limit, offset, agg, isX, bound, bf, start, stride, back, band) {
    var n = groups.length,
        init = 0,
        edge = 0,
        i,
        j,
        k,
        m,
        b,
        h,
        g,
        x,
        y; // if no groups, early exit and return 0

    if (!n) return init; // compute margin

    for (i = start; i < n; i += stride) {
      if (groups[i]) init = agg(init, bound(groups[i], bf));
    } // if no headers, return margin calculation


    if (!headers.length) return init; // check if number of headers exceeds number of rows or columns

    if (headers.length > limit) {
      view.warn('Grid headers exceed limit: ' + limit);
      headers = headers.slice(0, limit);
    } // apply offset


    init += offset; // clear mark bounds for all headers

    for (j = 0, m = headers.length; j < m; ++j) {
      view.dirty(headers[j]);
      headers[j].mark.bounds.clear();
    } // layout each header


    for (i = start, j = 0, m = headers.length; j < m; ++j, i += stride) {
      h = headers[j];
      b = h.mark.bounds; // search for nearest group to align to
      // necessary if table has empty cells

      for (k = i; k >= 0 && (g = groups[k]) == null; k -= back); // assign coordinates and update bounds


      if (isX) {
        x = band == null ? g.x : Math.round(g.bounds.x1 + band * g.bounds.width());
        y = init;
      } else {
        x = init;
        y = band == null ? g.y : Math.round(g.bounds.y1 + band * g.bounds.height());
      }

      b.union(h.bounds.translate(x - (h.x || 0), y - (h.y || 0)));
      h.x = x;
      h.y = y;
      view.dirty(h); // update current edge of layout bounds

      edge = agg(edge, b[bf]);
    }

    return edge;
  }

  function layoutTitle(view, g, offset, isX, bounds, band) {
    if (!g) return;
    view.dirty(g); // compute title coordinates

    var x = offset,
        y = offset;
    isX ? x = Math.round(bounds.x1 + band * bounds.width()) : y = Math.round(bounds.y1 + band * bounds.height()); // assign coordinates and update bounds

    g.bounds.translate(x - (g.x || 0), y - (g.y || 0));
    g.mark.bounds.clear().union(g.bounds);
    g.x = x;
    g.y = y; // queue title for redraw

    view.dirty(g);
  }

  function lookup$3(config, orient) {
    const opt = config[orient] || {};
    return (key, d) => opt[key] != null ? opt[key] : config[key] != null ? config[key] : d;
  } // if legends specify offset directly, use the maximum specified value


  function offsets(legends, value) {
    let max = -Infinity;
    legends.forEach(item => {
      if (item.offset != null) max = Math.max(max, item.offset);
    });
    return max > -Infinity ? max : value;
  }

  function legendParams(g, orient, config, xb, yb, w, h) {
    const _ = lookup$3(config, orient),
          offset = offsets(g, _('offset', 0)),
          anchor = _('anchor', Start$1),
          mult = anchor === End$1 ? 1 : anchor === Middle$1 ? 0.5 : 0;

    const p = {
      align: Each,
      bounds: _('bounds', Flush),
      columns: _('direction') === 'vertical' ? 1 : g.length,
      padding: _('margin', 8),
      center: _('center'),
      nodirty: true
    };

    switch (orient) {
      case Left$1:
        p.anchor = {
          x: Math.floor(xb.x1) - offset,
          column: End$1,
          y: mult * (h || xb.height() + 2 * xb.y1),
          row: anchor
        };
        break;

      case Right$1:
        p.anchor = {
          x: Math.ceil(xb.x2) + offset,
          y: mult * (h || xb.height() + 2 * xb.y1),
          row: anchor
        };
        break;

      case Top$1:
        p.anchor = {
          y: Math.floor(yb.y1) - offset,
          row: End$1,
          x: mult * (w || yb.width() + 2 * yb.x1),
          column: anchor
        };
        break;

      case Bottom$1:
        p.anchor = {
          y: Math.ceil(yb.y2) + offset,
          x: mult * (w || yb.width() + 2 * yb.x1) + xb.x1,
          column: anchor // dankrusi: +xb.x1 will make the legend stick to the bottom left most corner

        };
        break;

      case TopLeft:
        p.anchor = {
          x: offset,
          y: offset
        };
        break;

      case TopRight:
        p.anchor = {
          x: w - offset,
          y: offset,
          column: End$1
        };
        break;

      case BottomLeft:
        p.anchor = {
          x: offset,
          y: h - offset,
          row: End$1
        };
        break;

      case BottomRight:
        p.anchor = {
          x: w - offset,
          y: h - offset,
          column: End$1,
          row: End$1
        };
        break;
    }

    return p;
  }

  function legendLayout(view, legend) {
    var item = legend.items[0],
        datum = item.datum,
        orient = item.orient,
        bounds = item.bounds,
        x = item.x,
        y = item.y,
        w,
        h; // cache current bounds for later comparison

    item._bounds ? item._bounds.clear().union(bounds) : item._bounds = bounds.clone();
    bounds.clear(); // adjust legend to accommodate padding and title

    legendGroupLayout(view, item, item.items[0].items[0]); // aggregate bounds to determine size, and include origin

    bounds = legendBounds(item, bounds);
    w = 2 * item.padding;
    h = 2 * item.padding;

    if (!bounds.empty()) {
      w = Math.ceil(bounds.width() + w);
      h = Math.ceil(bounds.height() + h);
    }

    if (datum.type === Symbols$1) {
      legendEntryLayout(item.items[0].items[0].items[0].items);
    }

    if (orient !== None) {
      item.x = x = 0;
      item.y = y = 0;
    }

    item.width = w;
    item.height = h;
    boundStroke(bounds.set(x, y, x + w, y + h), item);
    item.mark.bounds.clear().union(bounds);
    return item;
  }

  function legendBounds(item, b) {
    // aggregate item bounds
    item.items.forEach(_ => b.union(_.bounds)); // anchor to legend origin

    b.x1 = item.padding;
    b.y1 = item.padding;
    return b;
  }

  function legendGroupLayout(view, item, entry) {
    var pad = item.padding,
        ex = pad - entry.x,
        ey = pad - entry.y;

    if (!item.datum.title) {
      if (ex || ey) translate(view, entry, ex, ey);
    } else {
      var title = item.items[1].items[0],
          anchor = title.anchor,
          tpad = item.titlePadding || 0,
          tx = pad - title.x,
          ty = pad - title.y;

      switch (title.orient) {
        case Left$1:
          ex += Math.ceil(title.bounds.width()) + tpad;
          break;

        case Right$1:
        case Bottom$1:
          break;

        default:
          ey += title.bounds.height() + tpad;
      }

      if (ex || ey) translate(view, entry, ex, ey);

      switch (title.orient) {
        case Left$1:
          ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
          break;

        case Right$1:
          tx += legendTitleOffset(item, entry, title, End$1, 0, 0) + tpad;
          ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
          break;

        case Bottom$1:
          tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
          ty += legendTitleOffset(item, entry, title, End$1, -1, 0, 1) + tpad;
          break;

        default:
          tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
      }

      if (tx || ty) translate(view, title, tx, ty); // translate legend if title pushes into negative coordinates

      if ((tx = Math.round(title.bounds.x1 - pad)) < 0) {
        translate(view, entry, -tx, 0);
        translate(view, title, -tx, 0);
      }
    }
  }

  function legendTitleOffset(item, entry, title, anchor, y, lr, noBar) {
    const grad = item.datum.type !== 'symbol',
          vgrad = title.datum.vgrad,
          e = grad && (lr || !vgrad) && !noBar ? entry.items[0] : entry,
          s = e.bounds[y ? 'y2' : 'x2'] - item.padding,
          u = vgrad && lr ? s : 0,
          v = vgrad && lr ? 0 : s,
          o = y <= 0 ? 0 : multiLineOffset(title);
    return Math.round(anchor === Start$1 ? u : anchor === End$1 ? v - o : 0.5 * (s - o));
  }

  function translate(view, item, dx, dy) {
    item.x += dx;
    item.y += dy;
    item.bounds.translate(dx, dy);
    item.mark.bounds.translate(dx, dy);
    view.dirty(item);
  }

  function legendEntryLayout(entries) {
    // get max widths for each column
    const widths = entries.reduce((w, g) => {
      w[g.column] = Math.max(g.bounds.x2 - g.x, w[g.column] || 0);
      return w;
    }, {}); // set dimensions of legend entry groups

    entries.forEach(g => {
      g.width = widths[g.column];
      g.height = g.bounds.y2 - g.y;
    });
  }

  function titleLayout(view, mark, width, height, viewBounds) {
    var group = mark.items[0],
        frame = group.frame,
        orient = group.orient,
        anchor = group.anchor,
        offset = group.offset,
        padding = group.padding,
        title = group.items[0].items[0],
        subtitle = group.items[1] && group.items[1].items[0],
        end = orient === Left$1 || orient === Right$1 ? height : width,
        start = 0,
        x = 0,
        y = 0,
        sx = 0,
        sy = 0,
        pos;

    if (frame !== Group) {
      orient === Left$1 ? (start = viewBounds.y2, end = viewBounds.y1) : orient === Right$1 ? (start = viewBounds.y1, end = viewBounds.y2) : (start = viewBounds.x1, end = viewBounds.x2);
    } else if (orient === Left$1) {
      start = height, end = 0;
    }

    pos = anchor === Start$1 ? start : anchor === End$1 ? end : (start + end) / 2;

    if (subtitle && subtitle.text) {
      // position subtitle
      switch (orient) {
        case Top$1:
        case Bottom$1:
          sy = title.bounds.height() + padding;
          break;

        case Left$1:
          sx = title.bounds.width() + padding;
          break;

        case Right$1:
          sx = -title.bounds.width() - padding;
          break;
      }

      tempBounds.clear().union(subtitle.bounds);
      tempBounds.translate(sx - (subtitle.x || 0), sy - (subtitle.y || 0));

      if (set$2(subtitle, 'x', sx) | set$2(subtitle, 'y', sy)) {
        view.dirty(subtitle);
        subtitle.bounds.clear().union(tempBounds);
        subtitle.mark.bounds.clear().union(tempBounds);
        view.dirty(subtitle);
      }

      tempBounds.clear().union(subtitle.bounds);
    } else {
      tempBounds.clear();
    }

    tempBounds.union(title.bounds); // position title group

    switch (orient) {
      case Top$1:
        x = pos;
        y = viewBounds.y1 - tempBounds.height() - offset;
        break;

      case Left$1:
        x = viewBounds.x1 - tempBounds.width() - offset;
        y = pos;
        break;

      case Right$1:
        x = viewBounds.x2 + tempBounds.width() + offset;
        y = pos;
        break;

      case Bottom$1:
        x = pos;
        y = viewBounds.y2 + offset;
        break;

      default:
        x = group.x;
        y = group.y;
    }

    if (set$2(group, 'x', x) | set$2(group, 'y', y)) {
      tempBounds.translate(x, y);
      view.dirty(group);
      group.bounds.clear().union(tempBounds);
      mark.bounds.clear().union(tempBounds);
      view.dirty(group);
    }

    return group.bounds;
  }
  /**
   * Layout view elements such as axes and legends.
   * Also performs size adjustments.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {object} params.mark - Scenegraph mark of groups to layout.
   */


  function ViewLayout$1(params) {
    Transform.call(this, null, params);
  }

  inherits(ViewLayout$1, Transform, {
    transform(_, pulse) {
      const view = pulse.dataflow;

      _.mark.items.forEach(group => {
        if (_.layout) trellisLayout(view, group, _.layout);
        layoutGroup(view, group, _);
      });

      return shouldReflow(_.mark.group) ? pulse.reflow() : pulse;
    }

  });

  function shouldReflow(group) {
    // We typically should reflow if layout is invoked (#2568), as child items
    // may have resized and reflow ensures group bounds are re-calculated.
    // However, legend entries have a special exception to avoid instability.
    // For example, if a selected legend symbol gains a stroke on hover,
    // we don't want to re-position subsequent elements in the legend.
    return group && group.mark.role !== 'legend-entry';
  }

  function layoutGroup(view, group, _) {
    var items = group.items,
        width = Math.max(0, group.width || 0),
        height = Math.max(0, group.height || 0),
        viewBounds = new Bounds().set(0, 0, width, height),
        xBounds = viewBounds.clone(),
        yBounds = viewBounds.clone(),
        legends = [],
        title,
        mark,
        orient,
        b,
        i,
        n; // layout axes, gather legends, collect bounds

    for (i = 0, n = items.length; i < n; ++i) {
      mark = items[i];

      switch (mark.role) {
        case AxisRole$1:
          b = isYAxis(mark) ? xBounds : yBounds;
          b.union(axisLayout(view, mark, width, height));
          break;

        case TitleRole$1:
          title = mark;
          break;

        case LegendRole$1:
          legends.push(legendLayout(view, mark));
          break;

        case FrameRole$1:
        case ScopeRole$1:
        case RowHeader:
        case RowFooter:
        case RowTitle:
        case ColHeader:
        case ColFooter:
        case ColTitle:
          xBounds.union(mark.bounds);
          yBounds.union(mark.bounds);
          break;

        default:
          viewBounds.union(mark.bounds);
      }
    } // layout legends, adjust viewBounds


    if (legends.length) {
      // group legends by orient
      const l = {};
      legends.forEach(item => {
        orient = item.orient || Right$1;
        if (orient !== None) (l[orient] || (l[orient] = [])).push(item);
      }); // perform grid layout for each orient group

      for (const orient in l) {
        const g = l[orient];
        gridLayout(view, g, legendParams(g, orient, _.legends, xBounds, yBounds, width, height));
      } // update view bounds


      legends.forEach(item => {
        const b = item.bounds;

        if (!b.equals(item._bounds)) {
          item.bounds = item._bounds;
          view.dirty(item); // dirty previous location

          item.bounds = b;
          view.dirty(item);
        }

        if (_.autosize && _.autosize.type === Fit) {
          // For autosize fit, incorporate the orthogonal dimension only.
          // Legends that overrun the chart area will then be clipped;
          // otherwise the chart area gets reduced to nothing!
          switch (item.orient) {
            case Left$1:
            case Right$1:
              viewBounds.add(b.x1, 0).add(b.x2, 0);
              break;

            case Top$1:
            case Bottom$1:
              viewBounds.add(0, b.y1).add(0, b.y2);
          }
        } else {
          viewBounds.union(b);
        }
      });
    } // combine bounding boxes


    viewBounds.union(xBounds).union(yBounds); // layout title, adjust bounds

    if (title) {
      viewBounds.union(titleLayout(view, title, width, height, viewBounds));
    } // override aggregated view bounds if content is clipped


    if (group.clip) {
      viewBounds.set(0, 0, group.width || 0, group.height || 0);
    } // perform size adjustment


    viewSizeLayout(view, group, viewBounds, _);
  }

  function viewSizeLayout(view, group, viewBounds, _) {
    const auto = _.autosize || {},
          type = auto.type;
    if (view._autosize < 1 || !type) return;
    let viewWidth = view._width,
        viewHeight = view._height,
        width = Math.max(0, group.width || 0),
        left = Math.max(0, Math.ceil(-viewBounds.x1)),
        height = Math.max(0, group.height || 0),
        top = Math.max(0, Math.ceil(-viewBounds.y1));
    const right = Math.max(0, Math.ceil(viewBounds.x2 - width)),
          bottom = Math.max(0, Math.ceil(viewBounds.y2 - height));

    if (auto.contains === Padding$1) {
      const padding = view.padding();
      viewWidth -= padding.left + padding.right;
      viewHeight -= padding.top + padding.bottom;
    }

    if (type === None) {
      left = 0;
      top = 0;
      width = viewWidth;
      height = viewHeight;
    } else if (type === Fit) {
      width = Math.max(0, viewWidth - left - right);
      height = Math.max(0, viewHeight - top - bottom);
    } else if (type === FitX) {
      width = Math.max(0, viewWidth - left - right);
      viewHeight = height + top + bottom;
    } else if (type === FitY) {
      viewWidth = width + left + right;
      height = Math.max(0, viewHeight - top - bottom);
    } else if (type === Pad) {
      viewWidth = width + left + right;
      viewHeight = height + top + bottom;
    }

    view._resizeView(viewWidth, viewHeight, width, height, [left, top], auto.resize);
  }

  var vtx = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bound: Bound$1,
    identifier: Identifier$1,
    mark: Mark$1,
    overlap: Overlap$1,
    render: Render$1,
    viewlayout: ViewLayout$1
  });

  /**
   * Generates axis ticks for visualizing a spatial scale.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Scale} params.scale - The scale to generate ticks for.
   * @param {*} [params.count=10] - The approximate number of ticks, or
   *   desired tick interval, to use.
   * @param {Array<*>} [params.values] - The exact tick values to use.
   *   These must be legal domain values for the provided scale.
   *   If provided, the count argument is ignored.
   * @param {function(*):string} [params.formatSpecifier] - A format specifier
   *   to use in conjunction with scale.tickFormat. Legal values are
   *   any valid d3 4.0 format specifier.
   * @param {function(*):string} [params.format] - The format function to use.
   *   If provided, the formatSpecifier argument is ignored.
   */

  function AxisTicks$1(params) {
    Transform.call(this, null, params);
  }

  inherits(AxisTicks$1, Transform, {
    transform(_, pulse) {
      if (this.value && !_.modified()) {
        return pulse.StopPropagation;
      }

      var locale = pulse.dataflow.locale(),
          out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
          ticks = this.value,
          scale = _.scale,
          tally = _.count == null ? _.values ? _.values.length : 10 : _.count,
          count = tickCount(scale, tally, _.minstep),
          format = _.format || tickFormat(locale, scale, count, _.formatSpecifier, _.formatType, !!_.values),
          values = _.values ? validTicks(scale, _.values, count) : tickValues(scale, count);
      if (ticks) out.rem = ticks;
      ticks = values.map((value, i) => ingest$1({
        index: i / (values.length - 1 || 1),
        value: value,
        label: format(value)
      }));

      if (_.extra && ticks.length) {
        // add an extra tick pegged to the initial domain value
        // this is used to generate axes with 'binned' domains
        ticks.push(ingest$1({
          index: -1,
          extra: {
            value: ticks[0].value
          },
          label: ''
        }));
      }

      out.source = ticks;
      out.add = ticks;
      this.value = ticks;
      return out;
    }

  });
  /**
   * Joins a set of data elements against a set of visual items.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): object} [params.item] - An item generator function.
   * @param {function(object): *} [params.key] - The key field associating data and visual items.
   */

  function DataJoin$1(params) {
    Transform.call(this, null, params);
  }

  function defaultItemCreate() {
    return ingest$1({});
  }

  function newMap(key) {
    const map = fastmap().test(t => t.exit);

    map.lookup = t => map.get(key(t));

    return map;
  }

  inherits(DataJoin$1, Transform, {
    transform(_, pulse) {
      var df = pulse.dataflow,
          out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
          item = _.item || defaultItemCreate,
          key = _.key || tupleid,
          map = this.value; // prevent transient (e.g., hover) requests from
      // cascading across marks derived from marks

      if (isArray(out.encode)) {
        out.encode = null;
      }

      if (map && (_.modified('key') || pulse.modified(key))) {
        error('DataJoin does not support modified key function or fields.');
      }

      if (!map) {
        pulse = pulse.addAll();
        this.value = map = newMap(key);
      }

      pulse.visit(pulse.ADD, t => {
        const k = key(t);
        let x = map.get(k);

        if (x) {
          if (x.exit) {
            map.empty--;
            out.add.push(x);
          } else {
            out.mod.push(x);
          }
        } else {
          x = item(t);
          map.set(k, x);
          out.add.push(x);
        }

        x.datum = t;
        x.exit = false;
      });
      pulse.visit(pulse.MOD, t => {
        const k = key(t),
              x = map.get(k);

        if (x) {
          x.datum = t;
          out.mod.push(x);
        }
      });
      pulse.visit(pulse.REM, t => {
        const k = key(t),
              x = map.get(k);

        if (t === x.datum && !x.exit) {
          out.rem.push(x);
          x.exit = true;
          ++map.empty;
        }
      });
      if (pulse.changed(pulse.ADD_MOD)) out.modifies('datum');

      if (pulse.clean() || _.clean && map.empty > df.cleanThreshold) {
        df.runAfter(map.clean);
      }

      return out;
    }

  });
  /**
   * Invokes encoding functions for visual items.
   * @constructor
   * @param {object} params - The parameters to the encoding functions. This
   *   parameter object will be passed through to all invoked encoding functions.
   * @param {object} [params.mod=false] - Flag indicating if tuples in the input
   *   mod set that are unmodified by encoders should be included in the output.
   * @param {object} param.encoders - The encoding functions
   * @param {function(object, object): boolean} [param.encoders.update] - Update encoding set
   * @param {function(object, object): boolean} [param.encoders.enter] - Enter encoding set
   * @param {function(object, object): boolean} [param.encoders.exit] - Exit encoding set
   */

  function Encode$1(params) {
    Transform.call(this, null, params);
  }

  inherits(Encode$1, Transform, {
    transform(_, pulse) {
      var out = pulse.fork(pulse.ADD_REM),
          fmod = _.mod || false,
          encoders = _.encoders,
          encode = pulse.encode; // if an array, the encode directive includes additional sets
      // that must be defined in order for the primary set to be invoked
      // e.g., only run the update set if the hover set is defined

      if (isArray(encode)) {
        if (out.changed() || encode.every(e => encoders[e])) {
          encode = encode[0];
          out.encode = null; // consume targeted encode directive
        } else {
          return pulse.StopPropagation;
        }
      } // marshall encoder functions


      var reenter = encode === 'enter',
          update = encoders.update || falsy,
          enter = encoders.enter || falsy,
          exit = encoders.exit || falsy,
          set = (encode && !reenter ? encoders[encode] : update) || falsy;

      if (pulse.changed(pulse.ADD)) {
        pulse.visit(pulse.ADD, t => {
          enter(t, _);
          update(t, _);
        });
        out.modifies(enter.output);
        out.modifies(update.output);

        if (set !== falsy && set !== update) {
          pulse.visit(pulse.ADD, t => {
            set(t, _);
          });
          out.modifies(set.output);
        }
      }

      if (pulse.changed(pulse.REM) && exit !== falsy) {
        pulse.visit(pulse.REM, t => {
          exit(t, _);
        });
        out.modifies(exit.output);
      }

      if (reenter || set !== falsy) {
        const flag = pulse.MOD | (_.modified() ? pulse.REFLOW : 0);

        if (reenter) {
          pulse.visit(flag, t => {
            const mod = enter(t, _) || fmod;
            if (set(t, _) || mod) out.mod.push(t);
          });
          if (out.mod.length) out.modifies(enter.output);
        } else {
          pulse.visit(flag, t => {
            if (set(t, _) || fmod) out.mod.push(t);
          });
        }

        if (out.mod.length) out.modifies(set.output);
      }

      return out.changed() ? out : pulse.StopPropagation;
    }

  });
  /**
   * Generates legend entries for visualizing a scale.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Scale} params.scale - The scale to generate items for.
   * @param {*} [params.count=5] - The approximate number of items, or
   *   desired tick interval, to use.
   * @param {*} [params.limit] - The maximum number of entries to
   *   include in a symbol legend.
   * @param {Array<*>} [params.values] - The exact tick values to use.
   *   These must be legal domain values for the provided scale.
   *   If provided, the count argument is ignored.
   * @param {string} [params.formatSpecifier] - A format specifier
   *   to use in conjunction with scale.tickFormat. Legal values are
   *   any valid D3 format specifier string.
   * @param {function(*):string} [params.format] - The format function to use.
   *   If provided, the formatSpecifier argument is ignored.
   */

  function LegendEntries$1(params) {
    Transform.call(this, [], params);
  }

  inherits(LegendEntries$1, Transform, {
    transform(_, pulse) {
      if (this.value != null && !_.modified()) {
        return pulse.StopPropagation;
      }

      var locale = pulse.dataflow.locale(),
          out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
          items = this.value,
          type = _.type || SymbolLegend,
          scale = _.scale,
          limit = +_.limit,
          count = tickCount(scale, _.count == null ? 5 : _.count, _.minstep),
          lskip = !!_.values || type === SymbolLegend,
          format = _.format || labelFormat(locale, scale, count, type, _.formatSpecifier, _.formatType, lskip),
          values = _.values || labelValues(scale, count),
          domain,
          fraction,
          size,
          offset,
          ellipsis;
      if (items) out.rem = items;

      if (type === SymbolLegend) {
        if (limit && values.length > limit) {
          pulse.dataflow.warn('Symbol legend count exceeds limit, filtering items.');
          items = values.slice(0, limit - 1);
          ellipsis = true;
        } else {
          items = values;
        }

        if (isFunction(size = _.size)) {
          // if first value maps to size zero, remove from list (vega#717)
          if (!_.values && scale(items[0]) === 0) {
            items = items.slice(1);
          } // compute size offset for legend entries


          offset = items.reduce((max, value) => Math.max(max, size(value, _)), 0);
        } else {
          size = constant$4(offset = size || 8);
        }

        items = items.map((value, index) => ingest$1({
          index: index,
          label: format(value, index, items),
          value: value,
          offset: offset,
          size: size(value, _)
        }));

        if (ellipsis) {
          ellipsis = values[items.length];
          items.push(ingest$1({
            index: items.length,
            label: `\u2026${values.length - items.length} entries`,
            value: ellipsis,
            offset: offset,
            size: size(ellipsis, _)
          }));
        }
      } else if (type === GradientLegend) {
        domain = scale.domain(), fraction = scaleFraction(scale, domain[0], peek$1(domain)); // if automatic label generation produces 2 or fewer values,
        // use the domain end points instead (fixes vega/vega#1364)

        if (values.length < 3 && !_.values && domain[0] !== peek$1(domain)) {
          values = [domain[0], peek$1(domain)];
        }

        items = values.map((value, index) => ingest$1({
          index: index,
          label: format(value, index, values),
          value: value,
          perc: fraction(value)
        }));
      } else {
        size = values.length - 1;
        fraction = labelFraction(scale);
        items = values.map((value, index) => ingest$1({
          index: index,
          label: format(value, index, values),
          value: value,
          perc: index ? fraction(value) : 0,
          perc2: index === size ? 1 : fraction(values[index + 1])
        }));
      }

      out.source = items;
      out.add = items;
      this.value = items;
      return out;
    }

  });

  const sourceX = t => t.source.x;

  const sourceY = t => t.source.y;

  const targetX = t => t.target.x;

  const targetY = t => t.target.y;
  /**
   * Layout paths linking source and target elements.
   * @constructor
   * @param {object} params - The parameters for this operator.
   */


  function LinkPath(params) {
    Transform.call(this, {}, params);
  }

  LinkPath.Definition = {
    'type': 'LinkPath',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'sourceX',
      'type': 'field',
      'default': 'source.x'
    }, {
      'name': 'sourceY',
      'type': 'field',
      'default': 'source.y'
    }, {
      'name': 'targetX',
      'type': 'field',
      'default': 'target.x'
    }, {
      'name': 'targetY',
      'type': 'field',
      'default': 'target.y'
    }, {
      'name': 'orient',
      'type': 'enum',
      'default': 'vertical',
      'values': ['horizontal', 'vertical', 'radial']
    }, {
      'name': 'shape',
      'type': 'enum',
      'default': 'line',
      'values': ['line', 'arc', 'curve', 'diagonal', 'orthogonal']
    }, {
      'name': 'require',
      'type': 'signal'
    }, {
      'name': 'as',
      'type': 'string',
      'default': 'path'
    }]
  };
  inherits(LinkPath, Transform, {
    transform(_, pulse) {
      var sx = _.sourceX || sourceX,
          sy = _.sourceY || sourceY,
          tx = _.targetX || targetX,
          ty = _.targetY || targetY,
          as = _.as || 'path',
          orient = _.orient || 'vertical',
          shape = _.shape || 'line',
          path = Paths.get(shape + '-' + orient) || Paths.get(shape);

      if (!path) {
        error('LinkPath unsupported type: ' + _.shape + (_.orient ? '-' + _.orient : ''));
      }

      pulse.visit(pulse.SOURCE, t => {
        t[as] = path(sx(t), sy(t), tx(t), ty(t));
      });
      return pulse.reflow(_.modified()).modifies(as);
    }

  });

  const line = (sx, sy, tx, ty) => 'M' + sx + ',' + sy + 'L' + tx + ',' + ty;

  const lineR = (sa, sr, ta, tr) => line(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));

  const arc = (sx, sy, tx, ty) => {
    var dx = tx - sx,
        dy = ty - sy,
        rr = Math.sqrt(dx * dx + dy * dy) / 2,
        ra = 180 * Math.atan2(dy, dx) / Math.PI;
    return 'M' + sx + ',' + sy + 'A' + rr + ',' + rr + ' ' + ra + ' 0 1' + ' ' + tx + ',' + ty;
  };

  const arcR = (sa, sr, ta, tr) => arc(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));

  const curve = (sx, sy, tx, ty) => {
    const dx = tx - sx,
          dy = ty - sy,
          ix = 0.2 * (dx + dy),
          iy = 0.2 * (dy - dx);
    return 'M' + sx + ',' + sy + 'C' + (sx + ix) + ',' + (sy + iy) + ' ' + (tx + iy) + ',' + (ty - ix) + ' ' + tx + ',' + ty;
  };

  const curveR = (sa, sr, ta, tr) => curve(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));

  const orthoX = (sx, sy, tx, ty) => 'M' + sx + ',' + sy + 'V' + ty + 'H' + tx;

  const orthoY = (sx, sy, tx, ty) => 'M' + sx + ',' + sy + 'H' + tx + 'V' + ty;

  const orthoR = (sa, sr, ta, tr) => {
    const sc = Math.cos(sa),
          ss = Math.sin(sa),
          tc = Math.cos(ta),
          ts = Math.sin(ta),
          sf = Math.abs(ta - sa) > Math.PI ? ta <= sa : ta > sa;
    return 'M' + sr * sc + ',' + sr * ss + 'A' + sr + ',' + sr + ' 0 0,' + (sf ? 1 : 0) + ' ' + sr * tc + ',' + sr * ts + 'L' + tr * tc + ',' + tr * ts;
  };

  const diagonalX = (sx, sy, tx, ty) => {
    const m = (sx + tx) / 2;
    return 'M' + sx + ',' + sy + 'C' + m + ',' + sy + ' ' + m + ',' + ty + ' ' + tx + ',' + ty;
  };

  const diagonalY = (sx, sy, tx, ty) => {
    const m = (sy + ty) / 2;
    return 'M' + sx + ',' + sy + 'C' + sx + ',' + m + ' ' + tx + ',' + m + ' ' + tx + ',' + ty;
  };

  const diagonalR = (sa, sr, ta, tr) => {
    const sc = Math.cos(sa),
          ss = Math.sin(sa),
          tc = Math.cos(ta),
          ts = Math.sin(ta),
          mr = (sr + tr) / 2;
    return 'M' + sr * sc + ',' + sr * ss + 'C' + mr * sc + ',' + mr * ss + ' ' + mr * tc + ',' + mr * ts + ' ' + tr * tc + ',' + tr * ts;
  };

  const Paths = fastmap({
    'line': line,
    'line-radial': lineR,
    'arc': arc,
    'arc-radial': arcR,
    'curve': curve,
    'curve-radial': curveR,
    'orthogonal-horizontal': orthoX,
    'orthogonal-vertical': orthoY,
    'orthogonal-radial': orthoR,
    'diagonal-horizontal': diagonalX,
    'diagonal-vertical': diagonalY,
    'diagonal-radial': diagonalR
  });
  /**
   * Pie and donut chart layout.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The value field to size pie segments.
   * @param {number} [params.startAngle=0] - The start angle (in radians) of the layout.
   * @param {number} [params.endAngle=2π] - The end angle (in radians) of the layout.
   * @param {boolean} [params.sort] - Boolean flag for sorting sectors by value.
   */

  function Pie(params) {
    Transform.call(this, null, params);
  }

  Pie.Definition = {
    'type': 'Pie',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'startAngle',
      'type': 'number',
      'default': 0
    }, {
      'name': 'endAngle',
      'type': 'number',
      'default': 6.283185307179586
    }, {
      'name': 'sort',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': ['startAngle', 'endAngle']
    }]
  };
  inherits(Pie, Transform, {
    transform(_, pulse) {
      var as = _.as || ['startAngle', 'endAngle'],
          startAngle = as[0],
          endAngle = as[1],
          field = _.field || one$2,
          start = _.startAngle || 0,
          stop = _.endAngle != null ? _.endAngle : 2 * Math.PI,
          data = pulse.source,
          values = data.map(field),
          n = values.length,
          a = start,
          k = (stop - start) / sum(values),
          index = range$1$1(n),
          i,
          t,
          v;

      if (_.sort) {
        index.sort((a, b) => values[a] - values[b]);
      }

      for (i = 0; i < n; ++i) {
        v = values[index[i]];
        t = data[index[i]];
        t[startAngle] = a;
        t[endAngle] = a += v * k;
      }

      this.value = values;
      return pulse.reflow(_.modified()).modifies(as);
    }

  });
  const DEFAULT_COUNT = 5;

  function includeZero(scale) {
    const type = scale.type;
    return !scale.bins && (type === Linear || type === Pow || type === Sqrt);
  }

  function includePad(type) {
    return isContinuous(type) && type !== Sequential;
  }

  const SKIP$1 = toSet(['set', 'modified', 'clear', 'type', 'scheme', 'schemeExtent', 'schemeCount', 'domain', 'domainMin', 'domainMid', 'domainMax', 'domainRaw', 'domainImplicit', 'nice', 'zero', 'bins', 'range', 'rangeStep', 'round', 'reverse', 'interpolate', 'interpolateGamma']);
  /**
   * Maintains a scale function mapping data values to visual channels.
   * @constructor
   * @param {object} params - The parameters for this operator.
   */

  function Scale$1(params) {
    Transform.call(this, null, params);
    this.modified(true); // always treat as modified
  }

  inherits(Scale$1, Transform, {
    transform(_, pulse) {
      var df = pulse.dataflow,
          scale$1 = this.value,
          key = scaleKey(_);

      if (!scale$1 || key !== scale$1.type) {
        this.value = scale$1 = scale$4(key)();
      }

      for (key in _) if (!SKIP$1[key]) {
        // padding is a scale property for band/point but not others
        if (key === 'padding' && includePad(scale$1.type)) continue; // invoke scale property setter, raise warning if not found

        isFunction(scale$1[key]) ? scale$1[key](_[key]) : df.warn('Unsupported scale property: ' + key);
      }

      configureRange(scale$1, _, configureBins(scale$1, _, configureDomain(scale$1, _, df)));
      return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    }

  });

  function scaleKey(_) {
    var t = _.type,
        d = '',
        n; // backwards compatibility pre Vega 5.

    if (t === Sequential) return Sequential + '-' + Linear;

    if (isContinuousColor(_)) {
      n = _.rawDomain ? _.rawDomain.length : _.domain ? _.domain.length + +(_.domainMid != null) : 0;
      d = n === 2 ? Sequential + '-' : n === 3 ? Diverging + '-' : '';
    }

    return (d + t || Linear).toLowerCase();
  }

  function isContinuousColor(_) {
    const t = _.type;
    return isContinuous(t) && t !== Time && t !== UTC && (_.scheme || _.range && _.range.length && _.range.every(isString));
  }

  function configureDomain(scale, _, df) {
    // check raw domain, if provided use that and exit early
    const raw = rawDomain(scale, _.domainRaw, df);
    if (raw > -1) return raw;
    var domain = _.domain,
        type = scale.type,
        zero = _.zero || _.zero === undefined && includeZero(scale),
        n,
        mid;
    if (!domain) return 0; // adjust continuous domain for minimum pixel padding

    if (includePad(type) && _.padding && domain[0] !== peek$1(domain)) {
      domain = padDomain(type, domain, _.range, _.padding, _.exponent, _.constant);
    } // adjust domain based on zero, min, max settings


    if (zero || _.domainMin != null || _.domainMax != null || _.domainMid != null) {
      n = (domain = domain.slice()).length - 1 || 1;

      if (zero) {
        if (domain[0] > 0) domain[0] = 0;
        if (domain[n] < 0) domain[n] = 0;
      }

      if (_.domainMin != null) domain[0] = _.domainMin;
      if (_.domainMax != null) domain[n] = _.domainMax;

      if (_.domainMid != null) {
        mid = _.domainMid;
        const i = mid > domain[n] ? n + 1 : mid < domain[0] ? 0 : n;
        if (i !== n) df.warn('Scale domainMid exceeds domain min or max.', mid);
        domain.splice(i, 0, mid);
      }
    } // set the scale domain


    scale.domain(domainCheck(type, domain, df)); // if ordinal scale domain is defined, prevent implicit
    // domain construction as side-effect of scale lookup

    if (type === Ordinal) {
      scale.unknown(_.domainImplicit ? implicit : undefined);
    } // perform 'nice' adjustment as requested


    if (_.nice && scale.nice) {
      scale.nice(_.nice !== true && tickCount(scale, _.nice) || null);
    } // return the cardinality of the domain


    return domain.length;
  }

  function rawDomain(scale, raw, df) {
    if (raw) {
      scale.domain(domainCheck(scale.type, raw, df));
      return raw.length;
    } else {
      return -1;
    }
  }

  function padDomain(type, domain, range, pad, exponent, constant) {
    var span = Math.abs(peek$1(range) - range[0]),
        frac = span / (span - 2 * pad),
        d = type === Log ? zoomLog(domain, null, frac) : type === Sqrt ? zoomPow(domain, null, frac, 0.5) : type === Pow ? zoomPow(domain, null, frac, exponent || 1) : type === Symlog ? zoomSymlog(domain, null, frac, constant || 1) : zoomLinear(domain, null, frac);
    domain = domain.slice();
    domain[0] = d[0];
    domain[domain.length - 1] = d[1];
    return domain;
  }

  function domainCheck(type, domain, df) {
    if (isLogarithmic(type)) {
      // sum signs of domain values
      // if all pos or all neg, abs(sum) === domain.length
      var s = Math.abs(domain.reduce((s, v) => s + (v < 0 ? -1 : v > 0 ? 1 : 0), 0));

      if (s !== domain.length) {
        df.warn('Log scale domain includes zero: ' + $(domain));
      }
    }

    return domain;
  }

  function configureBins(scale, _, count) {
    let bins = _.bins;

    if (bins && !isArray(bins)) {
      // generate bin boundary array
      const domain = scale.domain(),
            lo = domain[0],
            hi = peek$1(domain),
            step = bins.step;
      let start = bins.start == null ? lo : bins.start,
          stop = bins.stop == null ? hi : bins.stop;
      if (!step) error('Scale bins parameter missing step property.');
      if (start < lo) start = step * Math.ceil(lo / step);
      if (stop > hi) stop = step * Math.floor(hi / step);
      bins = range$1$1(start, stop + step / 2, step);
    }

    if (bins) {
      // assign bin boundaries to scale instance
      scale.bins = bins;
    } else if (scale.bins) {
      // no current bins, remove bins if previously set
      delete scale.bins;
    } // special handling for bin-ordinal scales


    if (scale.type === BinOrdinal) {
      if (!bins) {
        // the domain specifies the bins
        scale.bins = scale.domain();
      } else if (!_.domain && !_.domainRaw) {
        // the bins specify the domain
        scale.domain(bins);
        count = bins.length;
      }
    } // return domain cardinality


    return count;
  }

  function configureRange(scale, _, count) {
    var type = scale.type,
        round = _.round || false,
        range = _.range; // if range step specified, calculate full range extent

    if (_.rangeStep != null) {
      range = configureRangeStep(type, _, count);
    } // else if a range scheme is defined, use that
    else if (_.scheme) {
        range = configureScheme(type, _, count);

        if (isFunction(range)) {
          if (scale.interpolator) {
            return scale.interpolator(range);
          } else {
            error(`Scale type ${type} does not support interpolating color schemes.`);
          }
        }
      } // given a range array for an interpolating scale, convert to interpolator


    if (range && isInterpolating(type)) {
      return scale.interpolator(interpolateColors(flip(range, _.reverse), _.interpolate, _.interpolateGamma));
    } // configure rounding / interpolation


    if (range && _.interpolate && scale.interpolate) {
      scale.interpolate(interpolate(_.interpolate, _.interpolateGamma));
    } else if (isFunction(scale.round)) {
      scale.round(round);
    } else if (isFunction(scale.rangeRound)) {
      scale.interpolate(round ? interpolateRound : interpolate$1);
    }

    if (range) scale.range(flip(range, _.reverse));
  }

  function configureRangeStep(type, _, count) {
    if (type !== Band && type !== Point) {
      error('Only band and point scales support rangeStep.');
    } // calculate full range based on requested step size and padding


    var outer = (_.paddingOuter != null ? _.paddingOuter : _.padding) || 0,
        inner = type === Point ? 1 : (_.paddingInner != null ? _.paddingInner : _.padding) || 0;
    return [0, _.rangeStep * bandSpace(count, inner, outer)];
  }

  function configureScheme(type, _, count) {
    var extent = _.schemeExtent,
        name,
        scheme$1;

    if (isArray(_.scheme)) {
      scheme$1 = interpolateColors(_.scheme, _.interpolate, _.interpolateGamma);
    } else {
      name = _.scheme.toLowerCase();
      scheme$1 = scheme(name);
      if (!scheme$1) error(`Unrecognized scheme name: ${_.scheme}`);
    } // determine size for potential discrete range


    count = type === Threshold ? count + 1 : type === BinOrdinal ? count - 1 : type === Quantile || type === Quantize ? +_.schemeCount || DEFAULT_COUNT : count; // adjust and/or quantize scheme as appropriate

    return isInterpolating(type) ? adjustScheme(scheme$1, extent, _.reverse) : isFunction(scheme$1) ? quantizeInterpolator(adjustScheme(scheme$1, extent), count) : type === Ordinal ? scheme$1 : scheme$1.slice(0, count);
  }

  function adjustScheme(scheme, extent, reverse) {
    return isFunction(scheme) && (extent || reverse) ? interpolateRange(scheme, flip(extent || [0, 1], reverse)) : scheme;
  }

  function flip(array, reverse) {
    return reverse ? array.slice().reverse() : array;
  }
  /**
   * Sorts scenegraph items in the pulse source array.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(*,*): number} [params.sort] - A comparator
   *   function for sorting tuples.
   */


  function SortItems$1(params) {
    Transform.call(this, null, params);
  }

  inherits(SortItems$1, Transform, {
    transform(_, pulse) {
      const mod = _.modified('sort') || pulse.changed(pulse.ADD) || pulse.modified(_.sort.fields) || pulse.modified('datum');
      if (mod) pulse.source.sort(stableCompare(_.sort));
      this.modified(mod);
      return pulse;
    }

  });
  const Zero = 'zero',
        Center$1 = 'center',
        Normalize = 'normalize',
        DefOutput = ['y0', 'y1'];
  /**
   * Stack layout for visualization elements.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The value field to stack.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
   * @param {function(object,object): number} [params.sort] - A comparator for stack sorting.
   * @param {string} [offset='zero'] - Stack baseline offset. One of 'zero', 'center', 'normalize'.
   */

  function Stack(params) {
    Transform.call(this, null, params);
  }

  Stack.Definition = {
    'type': 'Stack',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'sort',
      'type': 'compare'
    }, {
      'name': 'offset',
      'type': 'enum',
      'default': Zero,
      'values': [Zero, Center$1, Normalize]
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': DefOutput
    }]
  };
  inherits(Stack, Transform, {
    transform(_, pulse) {
      var as = _.as || DefOutput,
          y0 = as[0],
          y1 = as[1],
          sort = stableCompare(_.sort),
          field = _.field || one$2,
          stack = _.offset === Center$1 ? stackCenter : _.offset === Normalize ? stackNormalize : stackZero,
          groups,
          i,
          n,
          max; // partition, sum, and sort the stack groups

      groups = partition$3(pulse.source, _.groupby, sort, field); // compute stack layouts per group

      for (i = 0, n = groups.length, max = groups.max; i < n; ++i) {
        stack(groups[i], max, field, y0, y1);
      }

      return pulse.reflow(_.modified()).modifies(as);
    }

  });

  function stackCenter(group, max, field, y0, y1) {
    var last = (max - group.sum) / 2,
        m = group.length,
        j = 0,
        t;

    for (; j < m; ++j) {
      t = group[j];
      t[y0] = last;
      t[y1] = last += Math.abs(field(t));
    }
  }

  function stackNormalize(group, max, field, y0, y1) {
    var scale = 1 / group.sum,
        last = 0,
        m = group.length,
        j = 0,
        v = 0,
        t;

    for (; j < m; ++j) {
      t = group[j];
      t[y0] = last;
      t[y1] = last = scale * (v += Math.abs(field(t)));
    }
  }

  function stackZero(group, max, field, y0, y1) {
    var lastPos = 0,
        lastNeg = 0,
        m = group.length,
        j = 0,
        v,
        t;

    for (; j < m; ++j) {
      t = group[j];
      v = +field(t);

      if (v < 0) {
        t[y0] = lastNeg;
        t[y1] = lastNeg += v;
      } else {
        t[y0] = lastPos;
        t[y1] = lastPos += v;
      }
    }
  }

  function partition$3(data, groupby, sort, field) {
    var groups = [],
        get = f => f(t),
        map,
        i,
        n,
        m,
        t,
        k,
        g,
        s,
        max; // partition data points into stack groups


    if (groupby == null) {
      groups.push(data.slice());
    } else {
      for (map = {}, i = 0, n = data.length; i < n; ++i) {
        t = data[i];
        k = groupby.map(get);
        g = map[k];

        if (!g) {
          map[k] = g = [];
          groups.push(g);
        }

        g.push(t);
      }
    } // compute sums of groups, sort groups as needed


    for (k = 0, max = 0, m = groups.length; k < m; ++k) {
      g = groups[k];

      for (i = 0, s = 0, n = g.length; i < n; ++i) {
        s += Math.abs(field(g[i]));
      }

      g.sum = s;
      if (s > max) max = s;
      if (sort) g.sort(sort);
    }

    groups.max = max;
    return groups;
  }

  var encode$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    axisticks: AxisTicks$1,
    datajoin: DataJoin$1,
    encode: Encode$1,
    legendentries: LegendEntries$1,
    linkpath: LinkPath,
    pie: Pie,
    scale: Scale$1,
    sortitems: SortItems$1,
    stack: Stack
  });

  var epsilon$2 = 1e-6;
  var epsilon2 = 1e-12;
  var pi$1 = Math.PI;
  var halfPi$1 = pi$1 / 2;
  var quarterPi = pi$1 / 4;
  var tau$1 = pi$1 * 2;
  var degrees = 180 / pi$1;
  var radians = pi$1 / 180;
  var abs$1 = Math.abs;
  var atan = Math.atan;
  var atan2 = Math.atan2;
  var cos$1 = Math.cos;
  var ceil = Math.ceil;
  var exp = Math.exp;
  var hypot = Math.hypot;
  var log$1 = Math.log;
  var pow$1 = Math.pow;
  var sin$1 = Math.sin;
  var sign = Math.sign || function (x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  };
  var sqrt$1 = Math.sqrt;
  var tan = Math.tan;
  function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi$1 : Math.acos(x);
  }
  function asin$1(x) {
    return x > 1 ? halfPi$1 : x < -1 ? -halfPi$1 : Math.asin(x);
  }

  function noop$2() {}

  function streamGeometry(geometry, stream) {
    if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
      streamGeometryType[geometry.type](geometry, stream);
    }
  }

  var streamObjectType = {
    Feature: function (object, stream) {
      streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function (object, stream) {
      var features = object.features,
          i = -1,
          n = features.length;

      while (++i < n) streamGeometry(features[i].geometry, stream);
    }
  };
  var streamGeometryType = {
    Sphere: function (object, stream) {
      stream.sphere();
    },
    Point: function (object, stream) {
      object = object.coordinates;
      stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function (object, stream) {
      var coordinates = object.coordinates,
          i = -1,
          n = coordinates.length;

      while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function (object, stream) {
      streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function (object, stream) {
      var coordinates = object.coordinates,
          i = -1,
          n = coordinates.length;

      while (++i < n) streamLine(coordinates[i], stream, 0);
    },
    Polygon: function (object, stream) {
      streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function (object, stream) {
      var coordinates = object.coordinates,
          i = -1,
          n = coordinates.length;

      while (++i < n) streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function (object, stream) {
      var geometries = object.geometries,
          i = -1,
          n = geometries.length;

      while (++i < n) streamGeometry(geometries[i], stream);
    }
  };

  function streamLine(coordinates, stream, closed) {
    var i = -1,
        n = coordinates.length - closed,
        coordinate;
    stream.lineStart();

    while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);

    stream.lineEnd();
  }

  function streamPolygon(coordinates, stream) {
    var i = -1,
        n = coordinates.length;
    stream.polygonStart();

    while (++i < n) streamLine(coordinates[i], stream, 1);

    stream.polygonEnd();
  }

  function geoStream (object, stream) {
    if (object && streamObjectType.hasOwnProperty(object.type)) {
      streamObjectType[object.type](object, stream);
    } else {
      streamGeometry(object, stream);
    }
  }

  var areaRingSum$1 = new Adder(); // hello?

  var areaSum$1 = new Adder(),
      lambda00$2,
      phi00$2,
      lambda0$1,
      cosPhi0,
      sinPhi0;
  var areaStream$1 = {
    point: noop$2,
    lineStart: noop$2,
    lineEnd: noop$2,
    polygonStart: function () {
      areaRingSum$1 = new Adder();
      areaStream$1.lineStart = areaRingStart$1;
      areaStream$1.lineEnd = areaRingEnd$1;
    },
    polygonEnd: function () {
      var areaRing = +areaRingSum$1;
      areaSum$1.add(areaRing < 0 ? tau$1 + areaRing : areaRing);
      this.lineStart = this.lineEnd = this.point = noop$2;
    },
    sphere: function () {
      areaSum$1.add(tau$1);
    }
  };

  function areaRingStart$1() {
    areaStream$1.point = areaPointFirst$1;
  }

  function areaRingEnd$1() {
    areaPoint$1(lambda00$2, phi00$2);
  }

  function areaPointFirst$1(lambda, phi) {
    areaStream$1.point = areaPoint$1;
    lambda00$2 = lambda, phi00$2 = phi;
    lambda *= radians, phi *= radians;
    lambda0$1 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
  }

  function areaPoint$1(lambda, phi) {
    lambda *= radians, phi *= radians;
    phi = phi / 2 + quarterPi; // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).

    var dLambda = lambda - lambda0$1,
        sdLambda = dLambda >= 0 ? 1 : -1,
        adLambda = sdLambda * dLambda,
        cosPhi = cos$1(phi),
        sinPhi = sin$1(phi),
        k = sinPhi0 * sinPhi,
        u = cosPhi0 * cosPhi + k * cos$1(adLambda),
        v = k * sdLambda * sin$1(adLambda);
    areaRingSum$1.add(atan2(v, u)); // Advance the previous points.

    lambda0$1 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
  }

  function geoArea$1 (object) {
    areaSum$1 = new Adder();
    geoStream(object, areaStream$1);
    return areaSum$1 * 2;
  }

  function spherical(cartesian) {
    return [atan2(cartesian[1], cartesian[0]), asin$1(cartesian[2])];
  }
  function cartesian(spherical) {
    var lambda = spherical[0],
        phi = spherical[1],
        cosPhi = cos$1(phi);
    return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
  }
  function cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function cartesianCross(a, b) {
    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
  } // TODO return a

  function cartesianAddInPlace(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
  }
  function cartesianScale(vector, k) {
    return [vector[0] * k, vector[1] * k, vector[2] * k];
  } // TODO return d

  function cartesianNormalizeInPlace(d) {
    var l = sqrt$1(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
  }

  var lambda0, phi0, lambda1, phi1, // bounds
  lambda2, // previous lambda-coordinate
  lambda00$1, phi00$1, // first point
  p0, // previous 3D point
  deltaSum, ranges, range$2;
  var boundsStream$1 = {
    point: boundsPoint$1,
    lineStart: boundsLineStart,
    lineEnd: boundsLineEnd,
    polygonStart: function () {
      boundsStream$1.point = boundsRingPoint;
      boundsStream$1.lineStart = boundsRingStart;
      boundsStream$1.lineEnd = boundsRingEnd;
      deltaSum = new Adder();
      areaStream$1.polygonStart();
    },
    polygonEnd: function () {
      areaStream$1.polygonEnd();
      boundsStream$1.point = boundsPoint$1;
      boundsStream$1.lineStart = boundsLineStart;
      boundsStream$1.lineEnd = boundsLineEnd;
      if (areaRingSum$1 < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);else if (deltaSum > epsilon$2) phi1 = 90;else if (deltaSum < -epsilon$2) phi0 = -90;
      range$2[0] = lambda0, range$2[1] = lambda1;
    },
    sphere: function () {
      lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    }
  };

  function boundsPoint$1(lambda, phi) {
    ranges.push(range$2 = [lambda0 = lambda, lambda1 = lambda]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
  }

  function linePoint(lambda, phi) {
    var p = cartesian([lambda * radians, phi * radians]);

    if (p0) {
      var normal = cartesianCross(p0, p),
          equatorial = [normal[1], -normal[0], 0],
          inflection = cartesianCross(equatorial, normal);
      cartesianNormalizeInPlace(inflection);
      inflection = spherical(inflection);
      var delta = lambda - lambda2,
          sign = delta > 0 ? 1 : -1,
          lambdai = inflection[0] * degrees * sign,
          phii,
          antimeridian = abs$1(delta) > 180;

      if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
        phii = inflection[1] * degrees;
        if (phii > phi1) phi1 = phii;
      } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
        phii = -inflection[1] * degrees;
        if (phii < phi0) phi0 = phii;
      } else {
        if (phi < phi0) phi0 = phi;
        if (phi > phi1) phi1 = phi;
      }

      if (antimeridian) {
        if (lambda < lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      } else {
        if (lambda1 >= lambda0) {
          if (lambda < lambda0) lambda0 = lambda;
          if (lambda > lambda1) lambda1 = lambda;
        } else {
          if (lambda > lambda2) {
            if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
          } else {
            if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
          }
        }
      }
    } else {
      ranges.push(range$2 = [lambda0 = lambda, lambda1 = lambda]);
    }

    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
    p0 = p, lambda2 = lambda;
  }

  function boundsLineStart() {
    boundsStream$1.point = linePoint;
  }

  function boundsLineEnd() {
    range$2[0] = lambda0, range$2[1] = lambda1;
    boundsStream$1.point = boundsPoint$1;
    p0 = null;
  }

  function boundsRingPoint(lambda, phi) {
    if (p0) {
      var delta = lambda - lambda2;
      deltaSum.add(abs$1(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else {
      lambda00$1 = lambda, phi00$1 = phi;
    }

    areaStream$1.point(lambda, phi);
    linePoint(lambda, phi);
  }

  function boundsRingStart() {
    areaStream$1.lineStart();
  }

  function boundsRingEnd() {
    boundsRingPoint(lambda00$1, phi00$1);
    areaStream$1.lineEnd();
    if (abs$1(deltaSum) > epsilon$2) lambda0 = -(lambda1 = 180);
    range$2[0] = lambda0, range$2[1] = lambda1;
    p0 = null;
  } // Finds the left-right distance between two longitudes.
  // This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
  // the distance between ±180° to be 360°.


  function angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
  }

  function rangeCompare(a, b) {
    return a[0] - b[0];
  }

  function rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
  }

  function geoBounds$1 (feature) {
    var i, n, a, b, merged, deltaMax, delta;
    phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
    ranges = [];
    geoStream(feature, boundsStream$1); // First, sort ranges by their minimum longitudes.

    if (n = ranges.length) {
      ranges.sort(rangeCompare); // Then, merge any ranges that overlap.

      for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
        b = ranges[i];

        if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
          if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
          if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
        } else {
          merged.push(a = b);
        }
      } // Finally, find the largest gap between the merged ranges.
      // The final bounding box will be the inverse of this gap.


      for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
        b = merged[i];
        if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
      }
    }

    ranges = range$2 = null;
    return lambda0 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda0, phi0], [lambda1, phi1]];
  }

  var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, // first point
  x0$4, y0$4, z0; // previous point

  var centroidStream$1 = {
    sphere: noop$2,
    point: centroidPoint$1,
    lineStart: centroidLineStart$1,
    lineEnd: centroidLineEnd$1,
    polygonStart: function () {
      centroidStream$1.lineStart = centroidRingStart$1;
      centroidStream$1.lineEnd = centroidRingEnd$1;
    },
    polygonEnd: function () {
      centroidStream$1.lineStart = centroidLineStart$1;
      centroidStream$1.lineEnd = centroidLineEnd$1;
    }
  }; // Arithmetic mean of Cartesian vectors.

  function centroidPoint$1(lambda, phi) {
    lambda *= radians, phi *= radians;
    var cosPhi = cos$1(phi);
    centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
  }

  function centroidPointCartesian(x, y, z) {
    ++W0;
    X0$1 += (x - X0$1) / W0;
    Y0$1 += (y - Y0$1) / W0;
    Z0$1 += (z - Z0$1) / W0;
  }

  function centroidLineStart$1() {
    centroidStream$1.point = centroidLinePointFirst;
  }

  function centroidLinePointFirst(lambda, phi) {
    lambda *= radians, phi *= radians;
    var cosPhi = cos$1(phi);
    x0$4 = cosPhi * cos$1(lambda);
    y0$4 = cosPhi * sin$1(lambda);
    z0 = sin$1(phi);
    centroidStream$1.point = centroidLinePoint;
    centroidPointCartesian(x0$4, y0$4, z0);
  }

  function centroidLinePoint(lambda, phi) {
    lambda *= radians, phi *= radians;
    var cosPhi = cos$1(phi),
        x = cosPhi * cos$1(lambda),
        y = cosPhi * sin$1(lambda),
        z = sin$1(phi),
        w = atan2(sqrt$1((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
    W1 += w;
    X1$1 += w * (x0$4 + (x0$4 = x));
    Y1$1 += w * (y0$4 + (y0$4 = y));
    Z1$1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0$4, y0$4, z0);
  }

  function centroidLineEnd$1() {
    centroidStream$1.point = centroidPoint$1;
  } // See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
  // J. Applied Mechanics 42, 239 (1975).


  function centroidRingStart$1() {
    centroidStream$1.point = centroidRingPointFirst;
  }

  function centroidRingEnd$1() {
    centroidRingPoint(lambda00, phi00);
    centroidStream$1.point = centroidPoint$1;
  }

  function centroidRingPointFirst(lambda, phi) {
    lambda00 = lambda, phi00 = phi;
    lambda *= radians, phi *= radians;
    centroidStream$1.point = centroidRingPoint;
    var cosPhi = cos$1(phi);
    x0$4 = cosPhi * cos$1(lambda);
    y0$4 = cosPhi * sin$1(lambda);
    z0 = sin$1(phi);
    centroidPointCartesian(x0$4, y0$4, z0);
  }

  function centroidRingPoint(lambda, phi) {
    lambda *= radians, phi *= radians;
    var cosPhi = cos$1(phi),
        x = cosPhi * cos$1(lambda),
        y = cosPhi * sin$1(lambda),
        z = sin$1(phi),
        cx = y0$4 * z - z0 * y,
        cy = z0 * x - x0$4 * z,
        cz = x0$4 * y - y0$4 * x,
        m = hypot(cx, cy, cz),
        w = asin$1(m),
        // line weight = angle
    v = m && -w / m; // area weight multiplier

    X2$1.add(v * cx);
    Y2$1.add(v * cy);
    Z2$1.add(v * cz);
    W1 += w;
    X1$1 += w * (x0$4 + (x0$4 = x));
    Y1$1 += w * (y0$4 + (y0$4 = y));
    Z1$1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0$4, y0$4, z0);
  }

  function geoCentroid$1 (object) {
    W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
    X2$1 = new Adder();
    Y2$1 = new Adder();
    Z2$1 = new Adder();
    geoStream(object, centroidStream$1);
    var x = +X2$1,
        y = +Y2$1,
        z = +Z2$1,
        m = hypot(x, y, z); // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.

    if (m < epsilon2) {
      x = X1$1, y = Y1$1, z = Z1$1; // If the feature has zero length, fall back to arithmetic mean of point vectors.

      if (W1 < epsilon$2) x = X0$1, y = Y0$1, z = Z0$1;
      m = hypot(x, y, z); // If the feature still has an undefined ccentroid, then return.

      if (m < epsilon2) return [NaN, NaN];
    }

    return [atan2(y, x) * degrees, asin$1(z / m) * degrees];
  }

  function compose (a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }

    if (a.invert && b.invert) compose.invert = function (x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }

  function rotationIdentity(lambda, phi) {
    return [abs$1(lambda) > pi$1 ? lambda + Math.round(-lambda / tau$1) * tau$1 : lambda, phi];
  }

  rotationIdentity.invert = rotationIdentity;
  function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= tau$1) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
  }

  function forwardRotationLambda(deltaLambda) {
    return function (lambda, phi) {
      return lambda += deltaLambda, [lambda > pi$1 ? lambda - tau$1 : lambda < -pi$1 ? lambda + tau$1 : lambda, phi];
    };
  }

  function rotationLambda(deltaLambda) {
    var rotation = forwardRotationLambda(deltaLambda);
    rotation.invert = forwardRotationLambda(-deltaLambda);
    return rotation;
  }

  function rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = cos$1(deltaPhi),
        sinDeltaPhi = sin$1(deltaPhi),
        cosDeltaGamma = cos$1(deltaGamma),
        sinDeltaGamma = sin$1(deltaGamma);

    function rotation(lambda, phi) {
      var cosPhi = cos$1(phi),
          x = cos$1(lambda) * cosPhi,
          y = sin$1(lambda) * cosPhi,
          z = sin$1(phi),
          k = z * cosDeltaPhi + x * sinDeltaPhi;
      return [atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi), asin$1(k * cosDeltaGamma + y * sinDeltaGamma)];
    }

    rotation.invert = function (lambda, phi) {
      var cosPhi = cos$1(phi),
          x = cos$1(lambda) * cosPhi,
          y = sin$1(lambda) * cosPhi,
          z = sin$1(phi),
          k = z * cosDeltaGamma - y * sinDeltaGamma;
      return [atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi), asin$1(k * cosDeltaPhi - x * sinDeltaPhi)];
    };

    return rotation;
  }

  function rotation (rotate) {
    rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);

    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
      return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
    }

    forward.invert = function (coordinates) {
      coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
      return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
    };

    return forward;
  }

  function circleStream(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = cos$1(radius),
        sinRadius = sin$1(radius),
        step = direction * delta;

    if (t0 == null) {
      t0 = radius + direction * tau$1;
      t1 = radius - step / 2;
    } else {
      t0 = circleRadius(cosRadius, t0);
      t1 = circleRadius(cosRadius, t1);
      if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$1;
    }

    for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
      point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
      stream.point(point[0], point[1]);
    }
  } // Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].

  function circleRadius(cosRadius, point) {
    point = cartesian(point), point[0] -= cosRadius;
    cartesianNormalizeInPlace(point);
    var radius = acos(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + tau$1 - epsilon$2) % tau$1;
  }

  function clipBuffer () {
    var lines = [],
        line;
    return {
      point: function (x, y, m) {
        line.push([x, y, m]);
      },
      lineStart: function () {
        lines.push(line = []);
      },
      lineEnd: noop$2,
      rejoin: function () {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      },
      result: function () {
        var result = lines;
        lines = [];
        line = null;
        return result;
      }
    };
  }

  function pointEqual (a, b) {
    return abs$1(a[0] - b[0]) < epsilon$2 && abs$1(a[1] - b[1]) < epsilon$2;
  }

  function Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection

    this.e = entry; // is an entry?

    this.v = false; // visited

    this.n = this.p = null; // next & previous
  } // A generalized polygon clipping algorithm: given a polygon that has been cut
  // into its visible line segments, and rejoins the segments by interpolating
  // along the clip edge.


  function clipRejoin (segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [],
        clip = [],
        i,
        n;
    segments.forEach(function (segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n,
          p0 = segment[0],
          p1 = segment[n],
          x;

      if (pointEqual(p0, p1)) {
        if (!p0[2] && !p1[2]) {
          stream.lineStart();

          for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);

          stream.lineEnd();
          return;
        } // handle degenerate cases by moving the point


        p1[0] += 2 * epsilon$2;
      }

      subject.push(x = new Intersection(p0, segment, null, true));
      clip.push(x.o = new Intersection(p0, null, x, false));
      subject.push(x = new Intersection(p1, segment, null, false));
      clip.push(x.o = new Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    link(subject);
    link(clip);

    for (i = 0, n = clip.length; i < n; ++i) {
      clip[i].e = startInside = !startInside;
    }

    var start = subject[0],
        points,
        point;

    while (1) {
      // Find first unvisited intersection.
      var current = start,
          isSubject = true;

      while (current.v) if ((current = current.n) === start) return;

      points = current.z;
      stream.lineStart();

      do {
        current.v = current.o.v = true;

        if (current.e) {
          if (isSubject) {
            for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, stream);
          }

          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;

            for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, stream);
          }

          current = current.p;
        }

        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);

      stream.lineEnd();
    }
  }

  function link(array) {
    if (!(n = array.length)) return;
    var n,
        i = 0,
        a = array[0],
        b;

    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }

    a.n = b = array[0];
    b.p = a;
  }

  function longitude(point) {
    if (abs$1(point[0]) <= pi$1) return point[0];else return sign(point[0]) * ((abs$1(point[0]) + pi$1) % tau$1 - pi$1);
  }

  function polygonContains (polygon, point) {
    var lambda = longitude(point),
        phi = point[1],
        sinPhi = sin$1(phi),
        normal = [sin$1(lambda), -cos$1(lambda), 0],
        angle = 0,
        winding = 0;
    var sum = new Adder();
    if (sinPhi === 1) phi = halfPi$1 + epsilon$2;else if (sinPhi === -1) phi = -halfPi$1 - epsilon$2;

    for (var i = 0, n = polygon.length; i < n; ++i) {
      if (!(m = (ring = polygon[i]).length)) continue;
      var ring,
          m,
          point0 = ring[m - 1],
          lambda0 = longitude(point0),
          phi0 = point0[1] / 2 + quarterPi,
          sinPhi0 = sin$1(phi0),
          cosPhi0 = cos$1(phi0);

      for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
        var point1 = ring[j],
            lambda1 = longitude(point1),
            phi1 = point1[1] / 2 + quarterPi,
            sinPhi1 = sin$1(phi1),
            cosPhi1 = cos$1(phi1),
            delta = lambda1 - lambda0,
            sign = delta >= 0 ? 1 : -1,
            absDelta = sign * delta,
            antimeridian = absDelta > pi$1,
            k = sinPhi0 * sinPhi1;
        sum.add(atan2(k * sign * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
        angle += antimeridian ? delta + sign * tau$1 : delta; // Are the longitudes either side of the point’s meridian (lambda),
        // and are the latitudes smaller than the parallel (phi)?

        if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
          var arc = cartesianCross(cartesian(point0), cartesian(point1));
          cartesianNormalizeInPlace(arc);
          var intersection = cartesianCross(normal, arc);
          cartesianNormalizeInPlace(intersection);
          var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);

          if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
            winding += antimeridian ^ delta >= 0 ? 1 : -1;
          }
        }
      }
    } // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.


    return (angle < -epsilon$2 || angle < epsilon$2 && sum < -epsilon2) ^ winding & 1;
  }

  function clip$1 (pointVisible, clipLine, interpolate, start) {
    return function (sink) {
      var line = clipLine(sink),
          ringBuffer = clipBuffer(),
          ringSink = clipLine(ringBuffer),
          polygonStarted = false,
          polygon,
          segments,
          ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function () {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function () {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = merge$2(segments);
          var startInside = polygonContains(polygon, start);

          if (segments.length) {
            if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
            clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
          } else if (startInside) {
            if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
            sink.lineStart();
            interpolate(null, null, 1, sink);
            sink.lineEnd();
          }

          if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function () {
          sink.polygonStart();
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
          sink.polygonEnd();
        }
      };

      function point(lambda, phi) {
        if (pointVisible(lambda, phi)) sink.point(lambda, phi);
      }

      function pointLine(lambda, phi) {
        line.point(lambda, phi);
      }

      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }

      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }

      function pointRing(lambda, phi) {
        ring.push([lambda, phi]);
        ringSink.point(lambda, phi);
      }

      function ringStart() {
        ringSink.lineStart();
        ring = [];
      }

      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringSink.lineEnd();
        var clean = ringSink.clean(),
            ringSegments = ringBuffer.result(),
            i,
            n = ringSegments.length,
            m,
            segment,
            point;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return; // No intersections.

        if (clean & 1) {
          segment = ringSegments[0];

          if ((m = segment.length - 1) > 0) {
            if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
            sink.lineStart();

            for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);

            sink.lineEnd();
          }

          return;
        } // Rejoin connected segments.
        // TODO reuse ringBuffer.rejoin()?


        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(validSegment));
      }

      return clip;
    };
  }

  function validSegment(segment) {
    return segment.length > 1;
  } // Intersections are sorted along the clip edge. For both antimeridian cutting
  // and circle clipping, the same comparison is used.


  function compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfPi$1 - epsilon$2 : halfPi$1 - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi$1 - epsilon$2 : halfPi$1 - b[1]);
  }

  var clipAntimeridian = clip$1(function () {
    return true;
  }, clipAntimeridianLine, clipAntimeridianInterpolate, [-pi$1, -halfPi$1]); // Takes a line and cuts into visible segments. Return values: 0 - there were
  // intersections or the line was empty; 1 - no intersections; 2 - there were
  // intersections, and the first and last segments should be rejoined.

  function clipAntimeridianLine(stream) {
    var lambda0 = NaN,
        phi0 = NaN,
        sign0 = NaN,
        clean; // no intersections

    return {
      lineStart: function () {
        stream.lineStart();
        clean = 1;
      },
      point: function (lambda1, phi1) {
        var sign1 = lambda1 > 0 ? pi$1 : -pi$1,
            delta = abs$1(lambda1 - lambda0);

        if (abs$1(delta - pi$1) < epsilon$2) {
          // line crosses a pole
          stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$1 : -halfPi$1);
          stream.point(sign0, phi0);
          stream.lineEnd();
          stream.lineStart();
          stream.point(sign1, phi0);
          stream.point(lambda1, phi0);
          clean = 0;
        } else if (sign0 !== sign1 && delta >= pi$1) {
          // line crosses antimeridian
          if (abs$1(lambda0 - sign0) < epsilon$2) lambda0 -= sign0 * epsilon$2; // handle degeneracies

          if (abs$1(lambda1 - sign1) < epsilon$2) lambda1 -= sign1 * epsilon$2;
          phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
          stream.point(sign0, phi0);
          stream.lineEnd();
          stream.lineStart();
          stream.point(sign1, phi0);
          clean = 0;
        }

        stream.point(lambda0 = lambda1, phi0 = phi1);
        sign0 = sign1;
      },
      lineEnd: function () {
        stream.lineEnd();
        lambda0 = phi0 = NaN;
      },
      clean: function () {
        return 2 - clean; // if intersections, rejoin first and last segments
      }
    };
  }

  function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0,
        cosPhi1,
        sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
    return abs$1(sinLambda0Lambda1) > epsilon$2 ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1) - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
  }

  function clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;

    if (from == null) {
      phi = direction * halfPi$1;
      stream.point(-pi$1, phi);
      stream.point(0, phi);
      stream.point(pi$1, phi);
      stream.point(pi$1, 0);
      stream.point(pi$1, -phi);
      stream.point(0, -phi);
      stream.point(-pi$1, -phi);
      stream.point(-pi$1, 0);
      stream.point(-pi$1, phi);
    } else if (abs$1(from[0] - to[0]) > epsilon$2) {
      var lambda = from[0] < to[0] ? pi$1 : -pi$1;
      phi = direction * lambda / 2;
      stream.point(-lambda, phi);
      stream.point(0, phi);
      stream.point(lambda, phi);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function clipCircle (radius) {
    var cr = cos$1(radius),
        delta = 6 * radians,
        smallRadius = cr > 0,
        notHemisphere = abs$1(cr) > epsilon$2; // TODO optimise for this common case

    function interpolate(from, to, direction, stream) {
      circleStream(stream, radius, delta, direction, from, to);
    }

    function visible(lambda, phi) {
      return cos$1(lambda) * cos$1(phi) > cr;
    } // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.


    function clipLine(stream) {
      var point0, // previous point
      c0, // code for previous point
      v0, // visibility of previous point
      v00, // visibility of first point
      clean; // no intersections

      return {
        lineStart: function () {
          v00 = v0 = false;
          clean = 1;
        },
        point: function (lambda, phi) {
          var point1 = [lambda, phi],
              point2,
              v = visible(lambda, phi),
              c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? pi$1 : -pi$1), phi) : 0;
          if (!point0 && (v00 = v0 = v)) stream.lineStart();

          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
          }

          if (v !== v0) {
            clean = 0;

            if (v) {
              // outside going in
              stream.lineStart();
              point2 = intersect(point1, point0);
              stream.point(point2[0], point2[1]);
            } else {
              // inside going out
              point2 = intersect(point0, point1);
              stream.point(point2[0], point2[1], 2);
              stream.lineEnd();
            }

            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t; // If the codes for two points are different, or are both zero,
            // and there this segment intersects with the small circle.

            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;

              if (smallRadius) {
                stream.lineStart();
                stream.point(t[0][0], t[0][1]);
                stream.point(t[1][0], t[1][1]);
                stream.lineEnd();
              } else {
                stream.point(t[1][0], t[1][1]);
                stream.lineEnd();
                stream.lineStart();
                stream.point(t[0][0], t[0][1], 3);
              }
            }
          }

          if (v && (!point0 || !pointEqual(point0, point1))) {
            stream.point(point1[0], point1[1]);
          }

          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function () {
          if (v0) stream.lineEnd();
          point0 = null;
        },
        // Rejoin first and last segments if there were intersections and the first
        // and last points were visible.
        clean: function () {
          return clean | (v00 && v0) << 1;
        }
      };
    } // Intersects the great circle between a and b with the clip circle.


    function intersect(a, b, two) {
      var pa = cartesian(a),
          pb = cartesian(b); // We have two planes, n1.p = d1 and n2.p = d2.
      // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).

      var n1 = [1, 0, 0],
          // normal
      n2 = cartesianCross(pa, pb),
          n2n2 = cartesianDot(n2, n2),
          n1n2 = n2[0],
          // cartesianDot(n1, n2),
      determinant = n2n2 - n1n2 * n1n2; // Two polar points.

      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant,
          c2 = -cr * n1n2 / determinant,
          n1xn2 = cartesianCross(n1, n2),
          A = cartesianScale(n1, c1),
          B = cartesianScale(n2, c2);
      cartesianAddInPlace(A, B); // Solve |p(t)|^2 = 1.

      var u = n1xn2,
          w = cartesianDot(A, u),
          uu = cartesianDot(u, u),
          t2 = w * w - uu * (cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = sqrt$1(t2),
          q = cartesianScale(u, (-w - t) / uu);
      cartesianAddInPlace(q, A);
      q = spherical(q);
      if (!two) return q; // Two intersection points.

      var lambda0 = a[0],
          lambda1 = b[0],
          phi0 = a[1],
          phi1 = b[1],
          z;
      if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
      var delta = lambda1 - lambda0,
          polar = abs$1(delta - pi$1) < epsilon$2,
          meridian = polar || delta < epsilon$2;
      if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z; // Check that the first point is between a and b.

      if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < (abs$1(q[0] - lambda0) < epsilon$2 ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > pi$1 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
        var q1 = cartesianScale(u, (-w + t) / uu);
        cartesianAddInPlace(q1, A);
        return [q, spherical(q1)];
      }
    } // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.


    function code(lambda, phi) {
      var r = smallRadius ? radius : pi$1 - radius,
          code = 0;
      if (lambda < -r) code |= 1; // left
      else if (lambda > r) code |= 2; // right

      if (phi < -r) code |= 4; // below
      else if (phi > r) code |= 8; // above

      return code;
    }

    return clip$1(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$1, radius - pi$1]);
  }

  function clipLine (a, b, x0, y0, x1, y1) {
    var ax = a[0],
        ay = a[1],
        bx = b[0],
        by = b[1],
        t0 = 0,
        t1 = 1,
        dx = bx - ax,
        dy = by - ay,
        r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;

    if (dx < 0) {
      if (r < t0) return;
      if (r < t1) t1 = r;
    } else if (dx > 0) {
      if (r > t1) return;
      if (r > t0) t0 = r;
    }

    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;

    if (dx < 0) {
      if (r > t1) return;
      if (r > t0) t0 = r;
    } else if (dx > 0) {
      if (r < t0) return;
      if (r < t1) t1 = r;
    }

    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;

    if (dy < 0) {
      if (r < t0) return;
      if (r < t1) t1 = r;
    } else if (dy > 0) {
      if (r > t1) return;
      if (r > t0) t0 = r;
    }

    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;

    if (dy < 0) {
      if (r > t1) return;
      if (r > t0) t0 = r;
    } else if (dy > 0) {
      if (r < t0) return;
      if (r < t1) t1 = r;
    }

    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
  }

  var clipMax = 1e9,
      clipMin = -clipMax; // TODO Use d3-polygon’s polygonContains here for the ring check?
  // TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

  function clipRectangle(x0, y0, x1, y1) {
    function visible(x, y) {
      return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }

    function interpolate(from, to, direction, stream) {
      var a = 0,
          a1 = 0;

      if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
        do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0); while ((a = (a + direction + 4) % 4) !== a1);
      } else {
        stream.point(to[0], to[1]);
      }
    }

    function corner(p, direction) {
      return abs$1(p[0] - x0) < epsilon$2 ? direction > 0 ? 0 : 3 : abs$1(p[0] - x1) < epsilon$2 ? direction > 0 ? 2 : 1 : abs$1(p[1] - y0) < epsilon$2 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }

    function compareIntersection(a, b) {
      return comparePoint(a.x, b.x);
    }

    function comparePoint(a, b) {
      var ca = corner(a, 1),
          cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }

    return function (stream) {
      var activeStream = stream,
          bufferStream = clipBuffer(),
          segments,
          polygon,
          ring,
          x__,
          y__,
          v__,
          // first point
      x_,
          y_,
          v_,
          // previous point
      first,
          clean;
      var clipStream = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: polygonStart,
        polygonEnd: polygonEnd
      };

      function point(x, y) {
        if (visible(x, y)) activeStream.point(x, y);
      }

      function polygonInside() {
        var winding = 0;

        for (var i = 0, n = polygon.length; i < n; ++i) {
          for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
            a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];

            if (a1 <= y1) {
              if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
            } else {
              if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
          }
        }

        return winding;
      } // Buffer geometry within a polygon and then clip it en masse.


      function polygonStart() {
        activeStream = bufferStream, segments = [], polygon = [], clean = true;
      }

      function polygonEnd() {
        var startInside = polygonInside(),
            cleanInside = clean && startInside,
            visible = (segments = merge$2(segments)).length;

        if (cleanInside || visible) {
          stream.polygonStart();

          if (cleanInside) {
            stream.lineStart();
            interpolate(null, null, 1, stream);
            stream.lineEnd();
          }

          if (visible) {
            clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
          }

          stream.polygonEnd();
        }

        activeStream = stream, segments = polygon = ring = null;
      }

      function lineStart() {
        clipStream.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      } // TODO rather than special-case polygons, simply handle them separately.
      // Ideally, coincident intersection points should be jittered to avoid
      // clipping issues.


      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferStream.rejoin();
          segments.push(bufferStream.result());
        }

        clipStream.point = point;
        if (v_) activeStream.lineEnd();
      }

      function linePoint(x, y) {
        var v = visible(x, y);
        if (polygon) ring.push([x, y]);

        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;

          if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
          }
        } else {
          if (v && v_) activeStream.point(x, y);else {
            var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
                b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];

            if (clipLine(a, b, x0, y0, x1, y1)) {
              if (!v_) {
                activeStream.lineStart();
                activeStream.point(a[0], a[1]);
              }

              activeStream.point(b[0], b[1]);
              if (!v) activeStream.lineEnd();
              clean = false;
            } else if (v) {
              activeStream.lineStart();
              activeStream.point(x, y);
              clean = false;
            }
          }
        }

        x_ = x, y_ = y, v_ = v;
      }

      return clipStream;
    };
  }

  function graticuleX(y0, y1, dy) {
    var y = range$1$1(y0, y1 - epsilon$2, dy).concat(y1);
    return function (x) {
      return y.map(function (y) {
        return [x, y];
      });
    };
  }

  function graticuleY(x0, x1, dx) {
    var x = range$1$1(x0, x1 - epsilon$2, dx).concat(x1);
    return function (y) {
      return x.map(function (x) {
        return [x, y];
      });
    };
  }

  function graticule() {
    var x1,
        x0,
        X1,
        X0,
        y1,
        y0,
        Y1,
        Y0,
        dx = 10,
        dy = dx,
        DX = 90,
        DY = 360,
        x,
        y,
        X,
        Y,
        precision = 2.5;

    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }

    function lines() {
      return range$1$1(ceil(X0 / DX) * DX, X1, DX).map(X).concat(range$1$1(ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(range$1$1(ceil(x0 / dx) * dx, x1, dx).filter(function (x) {
        return abs$1(x % DX) > epsilon$2;
      }).map(x)).concat(range$1$1(ceil(y0 / dy) * dy, y1, dy).filter(function (y) {
        return abs$1(y % DY) > epsilon$2;
      }).map(y));
    }

    graticule.lines = function () {
      return lines().map(function (coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };

    graticule.outline = function () {
      return {
        type: "Polygon",
        coordinates: [X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))]
      };
    };

    graticule.extent = function (_) {
      if (!arguments.length) return graticule.extentMinor();
      return graticule.extentMajor(_).extentMinor(_);
    };

    graticule.extentMajor = function (_) {
      if (!arguments.length) return [[X0, Y0], [X1, Y1]];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };

    graticule.extentMinor = function (_) {
      if (!arguments.length) return [[x0, y0], [x1, y1]];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };

    graticule.step = function (_) {
      if (!arguments.length) return graticule.stepMinor();
      return graticule.stepMajor(_).stepMinor(_);
    };

    graticule.stepMajor = function (_) {
      if (!arguments.length) return [DX, DY];
      DX = +_[0], DY = +_[1];
      return graticule;
    };

    graticule.stepMinor = function (_) {
      if (!arguments.length) return [dx, dy];
      dx = +_[0], dy = +_[1];
      return graticule;
    };

    graticule.precision = function (_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = graticuleX(y0, y1, 90);
      y = graticuleY(x0, x1, precision);
      X = graticuleX(Y0, Y1, 90);
      Y = graticuleY(X0, X1, precision);
      return graticule;
    };

    return graticule.extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]]).extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
  }

  var identity = (x => x);

  var areaSum = new Adder(),
      areaRingSum = new Adder(),
      x00$2,
      y00$2,
      x0$3,
      y0$3;
  var areaStream = {
    point: noop$2,
    lineStart: noop$2,
    lineEnd: noop$2,
    polygonStart: function () {
      areaStream.lineStart = areaRingStart;
      areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function () {
      areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$2;
      areaSum.add(abs$1(areaRingSum));
      areaRingSum = new Adder();
    },
    result: function () {
      var area = areaSum / 2;
      areaSum = new Adder();
      return area;
    }
  };

  function areaRingStart() {
    areaStream.point = areaPointFirst;
  }

  function areaPointFirst(x, y) {
    areaStream.point = areaPoint;
    x00$2 = x0$3 = x, y00$2 = y0$3 = y;
  }

  function areaPoint(x, y) {
    areaRingSum.add(y0$3 * x - x0$3 * y);
    x0$3 = x, y0$3 = y;
  }

  function areaRingEnd() {
    areaPoint(x00$2, y00$2);
  }

  var x0$2 = Infinity,
      y0$2 = x0$2,
      x1 = -x0$2,
      y1 = x1;
  var boundsStream = {
    point: boundsPoint,
    lineStart: noop$2,
    lineEnd: noop$2,
    polygonStart: noop$2,
    polygonEnd: noop$2,
    result: function () {
      var bounds = [[x0$2, y0$2], [x1, y1]];
      x1 = y1 = -(y0$2 = x0$2 = Infinity);
      return bounds;
    }
  };

  function boundsPoint(x, y) {
    if (x < x0$2) x0$2 = x;
    if (x > x1) x1 = x;
    if (y < y0$2) y0$2 = y;
    if (y > y1) y1 = y;
  }

  var X0 = 0,
      Y0 = 0,
      Z0 = 0,
      X1 = 0,
      Y1 = 0,
      Z1 = 0,
      X2 = 0,
      Y2 = 0,
      Z2 = 0,
      x00$1,
      y00$1,
      x0$1,
      y0$1;
  var centroidStream = {
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function () {
      centroidStream.lineStart = centroidRingStart;
      centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function () {
      centroidStream.point = centroidPoint;
      centroidStream.lineStart = centroidLineStart;
      centroidStream.lineEnd = centroidLineEnd;
    },
    result: function () {
      var centroid = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
      X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
      return centroid;
    }
  };

  function centroidPoint(x, y) {
    X0 += x;
    Y0 += y;
    ++Z0;
  }

  function centroidLineStart() {
    centroidStream.point = centroidPointFirstLine;
  }

  function centroidPointFirstLine(x, y) {
    centroidStream.point = centroidPointLine;
    centroidPoint(x0$1 = x, y0$1 = y);
  }

  function centroidPointLine(x, y) {
    var dx = x - x0$1,
        dy = y - y0$1,
        z = sqrt$1(dx * dx + dy * dy);
    X1 += z * (x0$1 + x) / 2;
    Y1 += z * (y0$1 + y) / 2;
    Z1 += z;
    centroidPoint(x0$1 = x, y0$1 = y);
  }

  function centroidLineEnd() {
    centroidStream.point = centroidPoint;
  }

  function centroidRingStart() {
    centroidStream.point = centroidPointFirstRing;
  }

  function centroidRingEnd() {
    centroidPointRing(x00$1, y00$1);
  }

  function centroidPointFirstRing(x, y) {
    centroidStream.point = centroidPointRing;
    centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
  }

  function centroidPointRing(x, y) {
    var dx = x - x0$1,
        dy = y - y0$1,
        z = sqrt$1(dx * dx + dy * dy);
    X1 += z * (x0$1 + x) / 2;
    Y1 += z * (y0$1 + y) / 2;
    Z1 += z;
    z = y0$1 * x - x0$1 * y;
    X2 += z * (x0$1 + x);
    Y2 += z * (y0$1 + y);
    Z2 += z * 3;
    centroidPoint(x0$1 = x, y0$1 = y);
  }

  function PathContext(context) {
    this._context = context;
  }
  PathContext.prototype = {
    _radius: 4.5,
    pointRadius: function (_) {
      return this._radius = _, this;
    },
    polygonStart: function () {
      this._line = 0;
    },
    polygonEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._point = 0;
    },
    lineEnd: function () {
      if (this._line === 0) this._context.closePath();
      this._point = NaN;
    },
    point: function (x, y) {
      switch (this._point) {
        case 0:
          {
            this._context.moveTo(x, y);

            this._point = 1;
            break;
          }

        case 1:
          {
            this._context.lineTo(x, y);

            break;
          }

        default:
          {
            this._context.moveTo(x + this._radius, y);

            this._context.arc(x, y, this._radius, 0, tau$1);

            break;
          }
      }
    },
    result: noop$2
  };

  var lengthSum = new Adder(),
      lengthRing,
      x00,
      y00,
      x0,
      y0;
  var lengthStream = {
    point: noop$2,
    lineStart: function () {
      lengthStream.point = lengthPointFirst;
    },
    lineEnd: function () {
      if (lengthRing) lengthPoint(x00, y00);
      lengthStream.point = noop$2;
    },
    polygonStart: function () {
      lengthRing = true;
    },
    polygonEnd: function () {
      lengthRing = null;
    },
    result: function () {
      var length = +lengthSum;
      lengthSum = new Adder();
      return length;
    }
  };

  function lengthPointFirst(x, y) {
    lengthStream.point = lengthPoint;
    x00 = x0 = x, y00 = y0 = y;
  }

  function lengthPoint(x, y) {
    x0 -= x, y0 -= y;
    lengthSum.add(sqrt$1(x0 * x0 + y0 * y0));
    x0 = x, y0 = y;
  }

  function PathString() {
    this._string = [];
  }
  PathString.prototype = {
    _radius: 4.5,
    _circle: circle(4.5),
    pointRadius: function (_) {
      if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
      return this;
    },
    polygonStart: function () {
      this._line = 0;
    },
    polygonEnd: function () {
      this._line = NaN;
    },
    lineStart: function () {
      this._point = 0;
    },
    lineEnd: function () {
      if (this._line === 0) this._string.push("Z");
      this._point = NaN;
    },
    point: function (x, y) {
      switch (this._point) {
        case 0:
          {
            this._string.push("M", x, ",", y);

            this._point = 1;
            break;
          }

        case 1:
          {
            this._string.push("L", x, ",", y);

            break;
          }

        default:
          {
            if (this._circle == null) this._circle = circle(this._radius);

            this._string.push("M", x, ",", y, this._circle);

            break;
          }
      }
    },
    result: function () {
      if (this._string.length) {
        var result = this._string.join("");

        this._string = [];
        return result;
      } else {
        return null;
      }
    }
  };

  function circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }

  function geoPath (projection, context) {
    var pointRadius = 4.5,
        projectionStream,
        contextStream;

    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        geoStream(object, projectionStream(contextStream));
      }

      return contextStream.result();
    }

    path.area = function (object) {
      geoStream(object, projectionStream(areaStream));
      return areaStream.result();
    };

    path.measure = function (object) {
      geoStream(object, projectionStream(lengthStream));
      return lengthStream.result();
    };

    path.bounds = function (object) {
      geoStream(object, projectionStream(boundsStream));
      return boundsStream.result();
    };

    path.centroid = function (object) {
      geoStream(object, projectionStream(centroidStream));
      return centroidStream.result();
    };

    path.projection = function (_) {
      return arguments.length ? (projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream, path) : projection;
    };

    path.context = function (_) {
      if (!arguments.length) return context;
      contextStream = _ == null ? (context = null, new PathString()) : new PathContext(context = _);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return path;
    };

    path.pointRadius = function (_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };

    return path.projection(projection).context(context);
  }

  function transformer(methods) {
    return function (stream) {
      var s = new TransformStream();

      for (var key in methods) s[key] = methods[key];

      s.stream = stream;
      return s;
    };
  }

  function TransformStream() {}

  TransformStream.prototype = {
    constructor: TransformStream,
    point: function (x, y) {
      this.stream.point(x, y);
    },
    sphere: function () {
      this.stream.sphere();
    },
    lineStart: function () {
      this.stream.lineStart();
    },
    lineEnd: function () {
      this.stream.lineEnd();
    },
    polygonStart: function () {
      this.stream.polygonStart();
    },
    polygonEnd: function () {
      this.stream.polygonEnd();
    }
  };

  function fit$1(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([0, 0]);
    if (clip != null) projection.clipExtent(null);
    geoStream(object, projection.stream(boundsStream));
    fitBounds(boundsStream.result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
  }

  function fitExtent(projection, extent, object) {
    return fit$1(projection, function (b) {
      var w = extent[1][0] - extent[0][0],
          h = extent[1][1] - extent[0][1],
          k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
          x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
          y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
      projection.scale(150 * k).translate([x, y]);
    }, object);
  }
  function fitSize(projection, size, object) {
    return fitExtent(projection, [[0, 0], size], object);
  }
  function fitWidth(projection, width, object) {
    return fit$1(projection, function (b) {
      var w = +width,
          k = w / (b[1][0] - b[0][0]),
          x = (w - k * (b[1][0] + b[0][0])) / 2,
          y = -k * b[0][1];
      projection.scale(150 * k).translate([x, y]);
    }, object);
  }
  function fitHeight(projection, height, object) {
    return fit$1(projection, function (b) {
      var h = +height,
          k = h / (b[1][1] - b[0][1]),
          x = -k * b[0][0],
          y = (h - k * (b[1][1] + b[0][1])) / 2;
      projection.scale(150 * k).translate([x, y]);
    }, object);
  }

  var maxDepth = 16,
      // maximum depth of subdivision
  cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)

  function resample (project, delta2) {
    return +delta2 ? resample$1(project, delta2) : resampleNone(project);
  }

  function resampleNone(project) {
    return transformer({
      point: function (x, y) {
        x = project(x, y);
        this.stream.point(x[0], x[1]);
      }
    });
  }

  function resample$1(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0,
          dy = y1 - y0,
          d2 = dx * dx + dy * dy;

      if (d2 > 4 * delta2 && depth--) {
        var a = a0 + a1,
            b = b0 + b1,
            c = c0 + c1,
            m = sqrt$1(a * a + b * b + c * c),
            phi2 = asin$1(c /= m),
            lambda2 = abs$1(abs$1(c) - 1) < epsilon$2 || abs$1(lambda0 - lambda1) < epsilon$2 ? (lambda0 + lambda1) / 2 : atan2(b, a),
            p = project(lambda2, phi2),
            x2 = p[0],
            y2 = p[1],
            dx2 = x2 - x0,
            dy2 = y2 - y0,
            dz = dy * dx2 - dx * dy2;

        if (dz * dz / d2 > delta2 // perpendicular projected distance
        || abs$1((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
        || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          // angular distance
          resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
        }
      }
    }

    return function (stream) {
      var lambda00, x00, y00, a00, b00, c00, // first point
      lambda0, x0, y0, a0, b0, c0; // previous point

      var resampleStream = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function () {
          stream.polygonStart();
          resampleStream.lineStart = ringStart;
        },
        polygonEnd: function () {
          stream.polygonEnd();
          resampleStream.lineStart = lineStart;
        }
      };

      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }

      function lineStart() {
        x0 = NaN;
        resampleStream.point = linePoint;
        stream.lineStart();
      }

      function linePoint(lambda, phi) {
        var c = cartesian([lambda, phi]),
            p = project(lambda, phi);
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }

      function lineEnd() {
        resampleStream.point = point;
        stream.lineEnd();
      }

      function ringStart() {
        lineStart();
        resampleStream.point = ringPoint;
        resampleStream.lineEnd = ringEnd;
      }

      function ringPoint(lambda, phi) {
        linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resampleStream.point = linePoint;
      }

      function ringEnd() {
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
        resampleStream.lineEnd = lineEnd;
        lineEnd();
      }

      return resampleStream;
    };
  }

  var transformRadians = transformer({
    point: function (x, y) {
      this.stream.point(x * radians, y * radians);
    }
  });

  function transformRotate(rotate) {
    return transformer({
      point: function (x, y) {
        var r = rotate(x, y);
        return this.stream.point(r[0], r[1]);
      }
    });
  }

  function scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
      x *= sx;
      y *= sy;
      return [dx + k * x, dy - k * y];
    }

    transform.invert = function (x, y) {
      return [(x - dx) / k * sx, (dy - y) / k * sy];
    };

    return transform;
  }

  function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = cos$1(alpha),
        sinAlpha = sin$1(alpha),
        a = cosAlpha * k,
        b = sinAlpha * k,
        ai = cosAlpha / k,
        bi = sinAlpha / k,
        ci = (sinAlpha * dy - cosAlpha * dx) / k,
        fi = (sinAlpha * dx + cosAlpha * dy) / k;

    function transform(x, y) {
      x *= sx;
      y *= sy;
      return [a * x - b * y + dx, dy - b * x - a * y];
    }

    transform.invert = function (x, y) {
      return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
    };

    return transform;
  }

  function projection$1(project) {
    return projectionMutator(function () {
      return project;
    })();
  }
  function projectionMutator(projectAt) {
    var project,
        k = 150,
        // scale
    x = 480,
        y = 250,
        // translate
    lambda = 0,
        phi = 0,
        // center
    deltaLambda = 0,
        deltaPhi = 0,
        deltaGamma = 0,
        rotate,
        // pre-rotate
    alpha = 0,
        // post-rotate angle
    sx = 1,
        // reflectX
    sy = 1,
        // reflectX
    theta = null,
        preclip = clipAntimeridian,
        // pre-clip angle
    x0 = null,
        y0,
        x1,
        y1,
        postclip = identity,
        // post-clip extent
    delta2 = 0.5,
        // precision
    projectResample,
        projectTransform,
        projectRotateTransform,
        cache,
        cacheStream;

    function projection(point) {
      return projectRotateTransform(point[0] * radians, point[1] * radians);
    }

    function invert(point) {
      point = projectRotateTransform.invert(point[0], point[1]);
      return point && [point[0] * degrees, point[1] * degrees];
    }

    projection.stream = function (stream) {
      return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };

    projection.preclip = function (_) {
      return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };

    projection.postclip = function (_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };

    projection.clipAngle = function (_) {
      return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
    };

    projection.clipExtent = function (_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    };

    projection.scale = function (_) {
      return arguments.length ? (k = +_, recenter()) : k;
    };

    projection.translate = function (_) {
      return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
    };

    projection.center = function (_) {
      return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
    };

    projection.rotate = function (_) {
      return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
    };

    projection.angle = function (_) {
      return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
    };

    projection.reflectX = function (_) {
      return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };

    projection.reflectY = function (_) {
      return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };

    projection.precision = function (_) {
      return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$1(delta2);
    };

    projection.fitExtent = function (extent, object) {
      return fitExtent(projection, extent, object);
    };

    projection.fitSize = function (size, object) {
      return fitSize(projection, size, object);
    };

    projection.fitWidth = function (width, object) {
      return fitWidth(projection, width, object);
    };

    projection.fitHeight = function (height, object) {
      return fitHeight(projection, height, object);
    };

    function recenter() {
      var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)),
          transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
      rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
      projectTransform = compose(project, transform);
      projectRotateTransform = compose(rotate, projectTransform);
      projectResample = resample(projectTransform, delta2);
      return reset();
    }

    function reset() {
      cache = cacheStream = null;
      return projection;
    }

    return function () {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return recenter();
    };
  }

  function conicProjection(projectAt) {
    var phi0 = 0,
        phi1 = pi$1 / 3,
        m = projectionMutator(projectAt),
        p = m(phi0, phi1);

    p.parallels = function (_) {
      return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
    };

    return p;
  }

  function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = cos$1(phi0);

    function forward(lambda, phi) {
      return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
    }

    forward.invert = function (x, y) {
      return [x / cosPhi0, asin$1(y * cosPhi0)];
    };

    return forward;
  }

  function conicEqualAreaRaw(y0, y1) {
    var sy0 = sin$1(y0),
        n = (sy0 + sin$1(y1)) / 2; // Are the parallels symmetrical around the Equator?

    if (abs$1(n) < epsilon$2) return cylindricalEqualAreaRaw(y0);
    var c = 1 + sy0 * (2 * n - sy0),
        r0 = sqrt$1(c) / n;

    function project(x, y) {
      var r = sqrt$1(c - 2 * n * sin$1(y)) / n;
      return [r * sin$1(x *= n), r0 - r * cos$1(x)];
    }

    project.invert = function (x, y) {
      var r0y = r0 - y,
          l = atan2(x, abs$1(r0y)) * sign(r0y);
      if (r0y * n < 0) l -= pi$1 * sign(x) * sign(r0y);
      return [l / n, asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
    };

    return project;
  }
  function geoConicEqualArea () {
    return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
  }

  function geoAlbers () {
    return geoConicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
  }

  // as this will avoid emitting interleaving lines and polygons.

  function multiplex(streams) {
    var n = streams.length;
    return {
      point: function (x, y) {
        var i = -1;

        while (++i < n) streams[i].point(x, y);
      },
      sphere: function () {
        var i = -1;

        while (++i < n) streams[i].sphere();
      },
      lineStart: function () {
        var i = -1;

        while (++i < n) streams[i].lineStart();
      },
      lineEnd: function () {
        var i = -1;

        while (++i < n) streams[i].lineEnd();
      },
      polygonStart: function () {
        var i = -1;

        while (++i < n) streams[i].polygonStart();
      },
      polygonEnd: function () {
        var i = -1;

        while (++i < n) streams[i].polygonEnd();
      }
    };
  } // A composite projection for the United States, configured by default for
  // 960×500. The projection also works quite well at 960×600 if you change the
  // scale to 1285 and adjust the translate accordingly. The set of standard
  // parallels for each region comes from USGS, which is published here:
  // http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers


  function geoAlbersUsa () {
    var cache,
        cacheStream,
        lower48 = geoAlbers(),
        lower48Point,
        alaska = geoConicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
        alaskaPoint,
        // EPSG:3338
    hawaii = geoConicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
        hawaiiPoint,
        // ESRI:102007
    point,
        pointStream = {
      point: function (x, y) {
        point = [x, y];
      }
    };

    function albersUsa(coordinates) {
      var x = coordinates[0],
          y = coordinates[1];
      return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }

    albersUsa.invert = function (coordinates) {
      var k = lower48.scale(),
          t = lower48.translate(),
          x = (coordinates[0] - t[0]) / k,
          y = (coordinates[1] - t[1]) / k;
      return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };

    albersUsa.stream = function (stream) {
      return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
    };

    albersUsa.precision = function (_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_), alaska.precision(_), hawaii.precision(_);
      return reset();
    };

    albersUsa.scale = function (_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };

    albersUsa.translate = function (_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(),
          x = +_[0],
          y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
      alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + epsilon$2, y + 0.120 * k + epsilon$2], [x - 0.214 * k - epsilon$2, y + 0.234 * k - epsilon$2]]).stream(pointStream);
      hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + epsilon$2, y + 0.166 * k + epsilon$2], [x - 0.115 * k - epsilon$2, y + 0.234 * k - epsilon$2]]).stream(pointStream);
      return reset();
    };

    albersUsa.fitExtent = function (extent, object) {
      return fitExtent(albersUsa, extent, object);
    };

    albersUsa.fitSize = function (size, object) {
      return fitSize(albersUsa, size, object);
    };

    albersUsa.fitWidth = function (width, object) {
      return fitWidth(albersUsa, width, object);
    };

    albersUsa.fitHeight = function (height, object) {
      return fitHeight(albersUsa, height, object);
    };

    function reset() {
      cache = cacheStream = null;
      return albersUsa;
    }

    return albersUsa.scale(1070);
  }

  function azimuthalRaw(scale) {
    return function (x, y) {
      var cx = cos$1(x),
          cy = cos$1(y),
          k = scale(cx * cy);
      if (k === Infinity) return [2, 0];
      return [k * cy * sin$1(x), k * sin$1(y)];
    };
  }
  function azimuthalInvert(angle) {
    return function (x, y) {
      var z = sqrt$1(x * x + y * y),
          c = angle(z),
          sc = sin$1(c),
          cc = cos$1(c);
      return [atan2(x * sc, z * cc), asin$1(z && y * sc / z)];
    };
  }

  var azimuthalEqualAreaRaw = azimuthalRaw(function (cxcy) {
    return sqrt$1(2 / (1 + cxcy));
  });
  azimuthalEqualAreaRaw.invert = azimuthalInvert(function (z) {
    return 2 * asin$1(z / 2);
  });
  function geoAzimuthalEqualArea () {
    return projection$1(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
  }

  var azimuthalEquidistantRaw = azimuthalRaw(function (c) {
    return (c = acos(c)) && c / sin$1(c);
  });
  azimuthalEquidistantRaw.invert = azimuthalInvert(function (z) {
    return z;
  });
  function geoAzimuthalEquidistant () {
    return projection$1(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
  }

  function mercatorRaw(lambda, phi) {
    return [lambda, log$1(tan((halfPi$1 + phi) / 2))];
  }

  mercatorRaw.invert = function (x, y) {
    return [x, 2 * atan(exp(y)) - halfPi$1];
  };

  function geoMercator () {
    return mercatorProjection(mercatorRaw).scale(961 / tau$1);
  }
  function mercatorProjection(project) {
    var m = projection$1(project),
        center = m.center,
        scale = m.scale,
        translate = m.translate,
        clipExtent = m.clipExtent,
        x0 = null,
        y0,
        x1,
        y1; // clip extent

    m.scale = function (_) {
      return arguments.length ? (scale(_), reclip()) : scale();
    };

    m.translate = function (_) {
      return arguments.length ? (translate(_), reclip()) : translate();
    };

    m.center = function (_) {
      return arguments.length ? (center(_), reclip()) : center();
    };

    m.clipExtent = function (_) {
      return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    };

    function reclip() {
      var k = pi$1 * scale(),
          t = m(rotation(m.rotate()).invert([0, 0]));
      return clipExtent(x0 == null ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]] : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
    }

    return reclip();
  }

  function tany(y) {
    return tan((halfPi$1 + y) / 2);
  }

  function conicConformalRaw(y0, y1) {
    var cy0 = cos$1(y0),
        n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)),
        f = cy0 * pow$1(tany(y0), n) / n;
    if (!n) return mercatorRaw;

    function project(x, y) {
      if (f > 0) {
        if (y < -halfPi$1 + epsilon$2) y = -halfPi$1 + epsilon$2;
      } else {
        if (y > halfPi$1 - epsilon$2) y = halfPi$1 - epsilon$2;
      }

      var r = f / pow$1(tany(y), n);
      return [r * sin$1(n * x), f - r * cos$1(n * x)];
    }

    project.invert = function (x, y) {
      var fy = f - y,
          r = sign(n) * sqrt$1(x * x + fy * fy),
          l = atan2(x, abs$1(fy)) * sign(fy);
      if (fy * n < 0) l -= pi$1 * sign(x) * sign(fy);
      return [l / n, 2 * atan(pow$1(f / r, 1 / n)) - halfPi$1];
    };

    return project;
  }
  function geoConicConformal () {
    return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
  }

  function equirectangularRaw(lambda, phi) {
    return [lambda, phi];
  }
  equirectangularRaw.invert = equirectangularRaw;
  function geoEquirectangular () {
    return projection$1(equirectangularRaw).scale(152.63);
  }

  function conicEquidistantRaw(y0, y1) {
    var cy0 = cos$1(y0),
        n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
        g = cy0 / n + y0;
    if (abs$1(n) < epsilon$2) return equirectangularRaw;

    function project(x, y) {
      var gy = g - y,
          nx = n * x;
      return [gy * sin$1(nx), g - gy * cos$1(nx)];
    }

    project.invert = function (x, y) {
      var gy = g - y,
          l = atan2(x, abs$1(gy)) * sign(gy);
      if (gy * n < 0) l -= pi$1 * sign(x) * sign(gy);
      return [l / n, g - sign(n) * sqrt$1(x * x + gy * gy)];
    };

    return project;
  }
  function geoConicEquidistant () {
    return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
  }

  var A1 = 1.340264,
      A2 = -0.081106,
      A3 = 0.000893,
      A4 = 0.003796,
      M = sqrt$1(3) / 2,
      iterations = 12;
  function equalEarthRaw(lambda, phi) {
    var l = asin$1(M * sin$1(phi)),
        l2 = l * l,
        l6 = l2 * l2 * l2;
    return [lambda * cos$1(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))), l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))];
  }

  equalEarthRaw.invert = function (x, y) {
    var l = y,
        l2 = l * l,
        l6 = l2 * l2 * l2;

    for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
      fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
      fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
      l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
      if (abs$1(delta) < epsilon2) break;
    }

    return [M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos$1(l), asin$1(sin$1(l) / M)];
  };

  function geoEqualEarth () {
    return projection$1(equalEarthRaw).scale(177.158);
  }

  function gnomonicRaw(x, y) {
    var cy = cos$1(y),
        k = cos$1(x) * cy;
    return [cy * sin$1(x) / k, sin$1(y) / k];
  }
  gnomonicRaw.invert = azimuthalInvert(atan);
  function geoGnomonic () {
    return projection$1(gnomonicRaw).scale(144.049).clipAngle(60);
  }

  function geoIdentity () {
    var k = 1,
        tx = 0,
        ty = 0,
        sx = 1,
        sy = 1,
        // scale, translate and reflect
    alpha = 0,
        ca,
        sa,
        // angle
    x0 = null,
        y0,
        x1,
        y1,
        // clip extent
    kx = 1,
        ky = 1,
        transform = transformer({
      point: function (x, y) {
        var p = projection([x, y]);
        this.stream.point(p[0], p[1]);
      }
    }),
        postclip = identity,
        cache,
        cacheStream;

    function reset() {
      kx = k * sx;
      ky = k * sy;
      cache = cacheStream = null;
      return projection;
    }

    function projection(p) {
      var x = p[0] * kx,
          y = p[1] * ky;

      if (alpha) {
        var t = y * ca - x * sa;
        x = x * ca + y * sa;
        y = t;
      }

      return [x + tx, y + ty];
    }

    projection.invert = function (p) {
      var x = p[0] - tx,
          y = p[1] - ty;

      if (alpha) {
        var t = y * ca + x * sa;
        x = x * ca - y * sa;
        y = t;
      }

      return [x / kx, y / ky];
    };

    projection.stream = function (stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    };

    projection.postclip = function (_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };

    projection.clipExtent = function (_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    };

    projection.scale = function (_) {
      return arguments.length ? (k = +_, reset()) : k;
    };

    projection.translate = function (_) {
      return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
    };

    projection.angle = function (_) {
      return arguments.length ? (alpha = _ % 360 * radians, sa = sin$1(alpha), ca = cos$1(alpha), reset()) : alpha * degrees;
    };

    projection.reflectX = function (_) {
      return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
    };

    projection.reflectY = function (_) {
      return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
    };

    projection.fitExtent = function (extent, object) {
      return fitExtent(projection, extent, object);
    };

    projection.fitSize = function (size, object) {
      return fitSize(projection, size, object);
    };

    projection.fitWidth = function (width, object) {
      return fitWidth(projection, width, object);
    };

    projection.fitHeight = function (height, object) {
      return fitHeight(projection, height, object);
    };

    return projection;
  }

  function naturalEarth1Raw(lambda, phi) {
    var phi2 = phi * phi,
        phi4 = phi2 * phi2;
    return [lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))), phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))];
  }

  naturalEarth1Raw.invert = function (x, y) {
    var phi = y,
        i = 25,
        delta;

    do {
      var phi2 = phi * phi,
          phi4 = phi2 * phi2;
      phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
    } while (abs$1(delta) > epsilon$2 && --i > 0);

    return [x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))), phi];
  };

  function geoNaturalEarth1 () {
    return projection$1(naturalEarth1Raw).scale(175.295);
  }

  function orthographicRaw(x, y) {
    return [cos$1(y) * sin$1(x), sin$1(y)];
  }
  orthographicRaw.invert = azimuthalInvert(asin$1);
  function geoOrthographic () {
    return projection$1(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$2);
  }

  function stereographicRaw(x, y) {
    var cy = cos$1(y),
        k = 1 + cos$1(x) * cy;
    return [cy * sin$1(x) / k, sin$1(y) / k];
  }
  stereographicRaw.invert = azimuthalInvert(function (z) {
    return 2 * atan(z);
  });
  function geoStereographic () {
    return projection$1(stereographicRaw).scale(250).clipAngle(142);
  }

  function transverseMercatorRaw(lambda, phi) {
    return [log$1(tan((halfPi$1 + phi) / 2)), -lambda];
  }

  transverseMercatorRaw.invert = function (x, y) {
    return [-y, 2 * atan(exp(x)) - halfPi$1];
  };

  function geoTransverseMercator () {
    var m = mercatorProjection(transverseMercatorRaw),
        center = m.center,
        rotate = m.rotate;

    m.center = function (_) {
      return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
    };

    m.rotate = function (_) {
      return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
    };

    return rotate([0, 0, 90]).scale(159.155);
  }

  var abs = Math.abs;
  var cos = Math.cos;
  var sin = Math.sin;
  var epsilon$1 = 1e-6;
  var pi = Math.PI;
  var halfPi = pi / 2;
  var sqrt2 = sqrt(2);
  function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
  }
  function sqrt(x) {
    return x > 0 ? Math.sqrt(x) : 0;
  }

  function mollweideBromleyTheta(cp, phi) {
    var cpsinPhi = cp * sin(phi),
        i = 30,
        delta;

    do phi -= delta = (phi + sin(phi) - cpsinPhi) / (1 + cos(phi)); while (abs(delta) > epsilon$1 && --i > 0);

    return phi / 2;
  }
  function mollweideBromleyRaw(cx, cy, cp) {
    function forward(lambda, phi) {
      return [cx * lambda * cos(phi = mollweideBromleyTheta(cp, phi)), cy * sin(phi)];
    }

    forward.invert = function (x, y) {
      return y = asin(y / cy), [x / (cx * cos(y)), asin((2 * y + sin(2 * y)) / cp)];
    };

    return forward;
  }
  var mollweideRaw = mollweideBromleyRaw(sqrt2 / halfPi, sqrt2, pi);
  function geoMollweide () {
    return projection$1(mollweideRaw).scale(169.529);
  }

  const defaultPath = geoPath();
  const projectionProperties = [// standard properties in d3-geo
  'clipAngle', 'clipExtent', 'scale', 'translate', 'center', 'rotate', 'parallels', 'precision', 'reflectX', 'reflectY', // extended properties in d3-geo-projections
  'coefficient', 'distance', 'fraction', 'lobes', 'parallel', 'radius', 'ratio', 'spacing', 'tilt'];
  /**
   * Augment projections with their type and a copy method.
   */

  function create$1(type, constructor) {
    return function projection() {
      const p = constructor();
      p.type = type;
      p.path = geoPath().projection(p);

      p.copy = p.copy || function () {
        const c = projection();
        projectionProperties.forEach(prop => {
          if (p[prop]) c[prop](p[prop]());
        });
        c.path.pointRadius(p.path.pointRadius());
        return c;
      };

      return p;
    };
  }

  function projection(type, proj) {
    if (!type || typeof type !== 'string') {
      throw new Error('Projection type must be a name string.');
    }

    type = type.toLowerCase();

    if (arguments.length > 1) {
      projections[type] = create$1(type, proj);
      return this;
    } else {
      return projections[type] || null;
    }
  }

  function getProjectionPath(proj) {
    return proj && proj.path || defaultPath;
  }

  const projections = {
    // base d3-geo projection types
    albers: geoAlbers,
    albersusa: geoAlbersUsa,
    azimuthalequalarea: geoAzimuthalEqualArea,
    azimuthalequidistant: geoAzimuthalEquidistant,
    conicconformal: geoConicConformal,
    conicequalarea: geoConicEqualArea,
    conicequidistant: geoConicEquidistant,
    equalEarth: geoEqualEarth,
    equirectangular: geoEquirectangular,
    gnomonic: geoGnomonic,
    identity: geoIdentity,
    mercator: geoMercator,
    mollweide: geoMollweide,
    naturalEarth1: geoNaturalEarth1,
    orthographic: geoOrthographic,
    stereographic: geoStereographic,
    transversemercator: geoTransverseMercator
  };

  for (const key in projections) {
    projection(key, projections[key]);
  }

  function noop$1() {}

  const cases = [[], [[[1.0, 1.5], [0.5, 1.0]]], [[[1.5, 1.0], [1.0, 1.5]]], [[[1.5, 1.0], [0.5, 1.0]]], [[[1.0, 0.5], [1.5, 1.0]]], [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]], [[[1.0, 0.5], [1.0, 1.5]]], [[[1.0, 0.5], [0.5, 1.0]]], [[[0.5, 1.0], [1.0, 0.5]]], [[[1.0, 1.5], [1.0, 0.5]]], [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]], [[[1.5, 1.0], [1.0, 0.5]]], [[[0.5, 1.0], [1.5, 1.0]]], [[[1.0, 1.5], [1.5, 1.0]]], [[[0.5, 1.0], [1.0, 1.5]]], []]; // Implementation adapted from d3/d3-contour. Thanks!

  function contours() {
    var dx = 1,
        dy = 1,
        smooth = smoothLinear;

    function contours(values, tz) {
      return tz.map(value => contour(values, value));
    } // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js


    function contour(values, value) {
      var polygons = [],
          holes = [];
      isorings(values, value, ring => {
        smooth(ring, values, value);
        if (area(ring) > 0) polygons.push([ring]);else holes.push(ring);
      });
      holes.forEach(hole => {
        for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
          if (contains((polygon = polygons[i])[0], hole) !== -1) {
            polygon.push(hole);
            return;
          }
        }
      });
      return {
        type: 'MultiPolygon',
        value: value,
        coordinates: polygons
      };
    } // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js


    function isorings(values, value, callback) {
      var fragmentByStart = new Array(),
          fragmentByEnd = new Array(),
          x,
          y,
          t0,
          t1,
          t2,
          t3; // Special case for the first row (y = -1, t2 = t3 = 0).

      x = y = -1;
      t1 = values[0] >= value;
      cases[t1 << 1].forEach(stitch);

      while (++x < dx - 1) {
        t0 = t1, t1 = values[x + 1] >= value;
        cases[t0 | t1 << 1].forEach(stitch);
      }

      cases[t1 << 0].forEach(stitch); // General case for the intermediate rows.

      while (++y < dy - 1) {
        x = -1;
        t1 = values[y * dx + dx] >= value;
        t2 = values[y * dx] >= value;
        cases[t1 << 1 | t2 << 2].forEach(stitch);

        while (++x < dx - 1) {
          t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
          t3 = t2, t2 = values[y * dx + x + 1] >= value;
          cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
        }

        cases[t1 | t2 << 3].forEach(stitch);
      } // Special case for the last row (y = dy - 1, t0 = t1 = 0).


      x = -1;
      t2 = values[y * dx] >= value;
      cases[t2 << 2].forEach(stitch);

      while (++x < dx - 1) {
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t2 << 2 | t3 << 3].forEach(stitch);
      }

      cases[t2 << 3].forEach(stitch);

      function stitch(line) {
        var start = [line[0][0] + x, line[0][1] + y],
            end = [line[1][0] + x, line[1][1] + y],
            startIndex = index(start),
            endIndex = index(end),
            f,
            g;

        if (f = fragmentByEnd[startIndex]) {
          if (g = fragmentByStart[endIndex]) {
            delete fragmentByEnd[f.end];
            delete fragmentByStart[g.start];

            if (f === g) {
              f.ring.push(end);
              callback(f.ring);
            } else {
              fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                start: f.start,
                end: g.end,
                ring: f.ring.concat(g.ring)
              };
            }
          } else {
            delete fragmentByEnd[f.end];
            f.ring.push(end);
            fragmentByEnd[f.end = endIndex] = f;
          }
        } else if (f = fragmentByStart[endIndex]) {
          if (g = fragmentByEnd[startIndex]) {
            delete fragmentByStart[f.start];
            delete fragmentByEnd[g.end];

            if (f === g) {
              f.ring.push(end);
              callback(f.ring);
            } else {
              fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                start: g.start,
                end: f.end,
                ring: g.ring.concat(f.ring)
              };
            }
          } else {
            delete fragmentByStart[f.start];
            f.ring.unshift(start);
            fragmentByStart[f.start = startIndex] = f;
          }
        } else {
          fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
            start: startIndex,
            end: endIndex,
            ring: [start, end]
          };
        }
      }
    }

    function index(point) {
      return point[0] * 2 + point[1] * (dx + 1) * 4;
    }

    function smoothLinear(ring, values, value) {
      ring.forEach(point => {
        var x = point[0],
            y = point[1],
            xt = x | 0,
            yt = y | 0,
            v0,
            v1 = values[yt * dx + xt];

        if (x > 0 && x < dx && xt === x) {
          v0 = values[yt * dx + xt - 1];
          point[0] = x + (value - v0) / (v1 - v0) - 0.5;
        }

        if (y > 0 && y < dy && yt === y) {
          v0 = values[(yt - 1) * dx + xt];
          point[1] = y + (value - v0) / (v1 - v0) - 0.5;
        }
      });
    }

    contours.contour = contour;

    contours.size = function (_) {
      if (!arguments.length) return [dx, dy];

      var _0 = Math.floor(_[0]),
          _1 = Math.floor(_[1]);

      if (!(_0 >= 0 && _1 >= 0)) error('invalid size');
      return dx = _0, dy = _1, contours;
    };

    contours.smooth = function (_) {
      return arguments.length ? (smooth = _ ? smoothLinear : noop$1, contours) : smooth === smoothLinear;
    };

    return contours;
  }

  function area(ring) {
    var i = 0,
        n = ring.length,
        area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];

    while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];

    return area;
  }

  function contains(ring, hole) {
    var i = -1,
        n = hole.length,
        c;

    while (++i < n) if (c = ringContains(ring, hole[i])) return c;

    return 0;
  }

  function ringContains(ring, point) {
    var x = point[0],
        y = point[1],
        contains = -1;

    for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
      var pi = ring[i],
          xi = pi[0],
          yi = pi[1],
          pj = ring[j],
          xj = pj[0],
          yj = pj[1];
      if (segmentContains(pi, pj, point)) return 0;
      if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }

    return contains;
  }

  function segmentContains(a, b, c) {
    var i;
    return collinear$1(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
  }

  function collinear$1(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
  }

  function within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
  }

  function quantize(k, nice, zero) {
    return function (values) {
      var ex = extent(values),
          start = zero ? Math.min(ex[0], 0) : ex[0],
          stop = ex[1],
          span = stop - start,
          step = nice ? tickStep(start, stop, k) : span / (k + 1);
      return range$1$1(start + step, stop, step);
    };
  }
  /**
   * Generate isocontours (level sets) based on input raster grid data.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} [params.field] - The field with raster grid
   *   data. If unspecified, the tuple itself is interpreted as a raster grid.
   * @param {Array<number>} [params.thresholds] - Contour threshold array. If
   *   specified, the levels, nice, resolve, and zero parameters are ignored.
   * @param {number} [params.levels] - The desired number of contour levels.
   * @param {boolean} [params.nice] - Boolean flag indicating if the contour
   *   threshold values should be automatically aligned to "nice"
   *   human-friendly values. Setting this flag may cause the number of
   *   thresholds to deviate from the specified levels.
   * @param {string} [params.resolve] - The method for resolving thresholds
   *   across multiple input grids. If 'independent' (the default), threshold
   *   calculation will be performed separately for each grid. If 'shared', a
   *   single set of threshold values will be used for all input grids.
   * @param {boolean} [params.zero] - Boolean flag indicating if the contour
   *   threshold values should include zero.
   * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
   *   polygons should be smoothed using linear interpolation. The default is
   *   true. The parameter is ignored when using density estimation.
   * @param {boolean} [params.scale] - Optional numerical value by which to
   *   scale the output isocontour coordinates. This parameter can be useful
   *   to scale the contours to match a desired output resolution.
   * @param {string} [params.as='contour'] - The output field in which to store
   *   the generated isocontour data (default 'contour').
   */


  function Isocontour(params) {
    Transform.call(this, null, params);
  }

  Isocontour.Definition = {
    'type': 'Isocontour',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'thresholds',
      'type': 'number',
      'array': true
    }, {
      'name': 'levels',
      'type': 'number'
    }, {
      'name': 'nice',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'resolve',
      'type': 'enum',
      'values': ['shared', 'independent'],
      'default': 'independent'
    }, {
      'name': 'zero',
      'type': 'boolean',
      'default': true
    }, {
      'name': 'smooth',
      'type': 'boolean',
      'default': true
    }, {
      'name': 'scale',
      'type': 'number',
      'expr': true
    }, {
      'name': 'translate',
      'type': 'number',
      'array': true,
      'expr': true
    }, {
      'name': 'as',
      'type': 'string',
      'null': true,
      'default': 'contour'
    }]
  };
  inherits(Isocontour, Transform, {
    transform(_, pulse) {
      if (this.value && !pulse.changed() && !_.modified()) {
        return pulse.StopPropagation;
      }

      var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
          source = pulse.materialize(pulse.SOURCE).source,
          field = _.field || identity$6,
          contour = contours().smooth(_.smooth !== false),
          tz = _.thresholds || levels(source, field, _),
          as = _.as === null ? null : _.as || 'contour',
          values = [];
      source.forEach(t => {
        const grid = field(t); // generate contour paths in GeoJSON format

        const paths = contour.size([grid.width, grid.height])(grid.values, isArray(tz) ? tz : tz(grid.values)); // adjust contour path coordinates as needed

        transformPaths(paths, grid, t, _); // ingest; copy source data properties to output

        paths.forEach(p => {
          values.push(rederive(t, ingest$1(as != null ? {
            [as]: p
          } : p)));
        });
      });
      if (this.value) out.rem = this.value;
      this.value = out.source = out.add = values;
      return out;
    }

  });

  function levels(values, f, _) {
    const q = quantize(_.levels || 10, _.nice, _.zero !== false);
    return _.resolve !== 'shared' ? q : q(values.map(t => max$2(f(t).values)));
  }

  function transformPaths(paths, grid, datum, _) {
    let s = _.scale || grid.scale,
        t = _.translate || grid.translate;
    if (isFunction(s)) s = s(datum, _);
    if (isFunction(t)) t = t(datum, _);
    if ((s === 1 || s == null) && !t) return;
    const sx = (isNumber$1(s) ? s : s[0]) || 1,
          sy = (isNumber$1(s) ? s : s[1]) || 1,
          tx = t && t[0] || 0,
          ty = t && t[1] || 0;
    paths.forEach(transform$1(grid, sx, sy, tx, ty));
  }

  function transform$1(grid, sx, sy, tx, ty) {
    const x1 = grid.x1 || 0,
          y1 = grid.y1 || 0,
          flip = sx * sy < 0;

    function transformPolygon(coordinates) {
      coordinates.forEach(transformRing);
    }

    function transformRing(coordinates) {
      if (flip) coordinates.reverse(); // maintain winding order

      coordinates.forEach(transformPoint);
    }

    function transformPoint(coordinates) {
      coordinates[0] = (coordinates[0] - x1) * sx + tx;
      coordinates[1] = (coordinates[1] - y1) * sy + ty;
    }

    return function (geometry) {
      geometry.coordinates.forEach(transformPolygon);
      return geometry;
    };
  }

  function radius(bw, data, f) {
    const v = bw >= 0 ? bw : estimateBandwidth(data, f);
    return Math.round((Math.sqrt(4 * v * v + 1) - 1) / 2);
  }

  function number$2(_) {
    return isFunction(_) ? _ : constant$4(+_);
  } // Implementation adapted from d3/d3-contour. Thanks!


  function density2D() {
    var x = d => d[0],
        y = d => d[1],
        weight = one$2,
        bandwidth = [-1, -1],
        dx = 960,
        dy = 500,
        k = 2; // log2(cellSize)


    function density(data, counts) {
      const rx = radius(bandwidth[0], data, x) >> k,
            // blur x-radius
      ry = radius(bandwidth[1], data, y) >> k,
            // blur y-radius
      ox = rx ? rx + 2 : 0,
            // x-offset padding for blur
      oy = ry ? ry + 2 : 0,
            // y-offset padding for blur
      n = 2 * ox + (dx >> k),
            // grid width
      m = 2 * oy + (dy >> k),
            // grid height
      values0 = new Float32Array(n * m),
            values1 = new Float32Array(n * m);
      let values = values0;
      data.forEach(d => {
        const xi = ox + (+x(d) >> k),
              yi = oy + (+y(d) >> k);

        if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
          values0[xi + yi * n] += +weight(d);
        }
      });

      if (rx > 0 && ry > 0) {
        blurX(n, m, values0, values1, rx);
        blurY(n, m, values1, values0, ry);
        blurX(n, m, values0, values1, rx);
        blurY(n, m, values1, values0, ry);
        blurX(n, m, values0, values1, rx);
        blurY(n, m, values1, values0, ry);
      } else if (rx > 0) {
        blurX(n, m, values0, values1, rx);
        blurX(n, m, values1, values0, rx);
        blurX(n, m, values0, values1, rx);
        values = values1;
      } else if (ry > 0) {
        blurY(n, m, values0, values1, ry);
        blurY(n, m, values1, values0, ry);
        blurY(n, m, values0, values1, ry);
        values = values1;
      } // scale density estimates
      // density in points per square pixel or probability density


      const s = counts ? Math.pow(2, -2 * k) : 1 / sum(values);

      for (let i = 0, sz = n * m; i < sz; ++i) values[i] *= s;

      return {
        values: values,
        scale: 1 << k,
        width: n,
        height: m,
        x1: ox,
        y1: oy,
        x2: ox + (dx >> k),
        y2: oy + (dy >> k)
      };
    }

    density.x = function (_) {
      return arguments.length ? (x = number$2(_), density) : x;
    };

    density.y = function (_) {
      return arguments.length ? (y = number$2(_), density) : y;
    };

    density.weight = function (_) {
      return arguments.length ? (weight = number$2(_), density) : weight;
    };

    density.size = function (_) {
      if (!arguments.length) return [dx, dy];

      var _0 = +_[0],
          _1 = +_[1];

      if (!(_0 >= 0 && _1 >= 0)) error('invalid size');
      return dx = _0, dy = _1, density;
    };

    density.cellSize = function (_) {
      if (!arguments.length) return 1 << k;
      if (!((_ = +_) >= 1)) error('invalid cell size');
      k = Math.floor(Math.log(_) / Math.LN2);
      return density;
    };

    density.bandwidth = function (_) {
      if (!arguments.length) return bandwidth;
      _ = array$5(_);
      if (_.length === 1) _ = [+_[0], +_[0]];
      if (_.length !== 2) error('invalid bandwidth');
      return bandwidth = _, density;
    };

    return density;
  }

  function blurX(n, m, source, target, r) {
    const w = (r << 1) + 1;

    for (let j = 0; j < m; ++j) {
      for (let i = 0, sr = 0; i < n + r; ++i) {
        if (i < n) {
          sr += source[i + j * n];
        }

        if (i >= r) {
          if (i >= w) {
            sr -= source[i - w + j * n];
          }

          target[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
      }
    }
  }

  function blurY(n, m, source, target, r) {
    const w = (r << 1) + 1;

    for (let i = 0; i < n; ++i) {
      for (let j = 0, sr = 0; j < m + r; ++j) {
        if (j < m) {
          sr += source[i + j * n];
        }

        if (j >= r) {
          if (j >= w) {
            sr -= source[i + (j - w) * n];
          }

          target[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
      }
    }
  }
  /**
   * Perform 2D kernel-density estimation of point data.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<number>} params.size - The [width, height] extent (in
   *   units of input pixels) over which to perform density estimation.
   * @param {function(object): number} params.x - The x-coordinate accessor.
   * @param {function(object): number} params.y - The y-coordinate accessor.
   * @param {function(object): number} [params.weight] - The weight accessor.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors
   *   to groupby.
   * @param {number} [params.cellSize] - Contour density calculation cell size.
   *   This parameter determines the level of spatial approximation. For example,
   *   the default value of 4 maps to 2x reductions in both x- and y- dimensions.
   *   A value of 1 will result in an output raster grid whose dimensions exactly
   *   matches the size parameter.
   * @param {Array<number>} [params.bandwidth] - The KDE kernel bandwidths,
   *   in pixels. The input can be a two-element array specifying separate
   *   x and y bandwidths, or a single-element array specifying both. If the
   *   bandwidth is unspecified or less than zero, the bandwidth will be
   *   automatically determined.
   * @param {boolean} [params.counts=false] - A boolean flag indicating if the
   *   output values should be probability estimates (false, default) or
   *   smoothed counts (true).
   * @param {string} [params.as='grid'] - The output field in which to store
   *   the generated raster grid (default 'grid').
   */


  function KDE2D(params) {
    Transform.call(this, null, params);
  }

  KDE2D.Definition = {
    'type': 'KDE2D',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2,
      'required': true
    }, {
      'name': 'x',
      'type': 'field',
      'required': true
    }, {
      'name': 'y',
      'type': 'field',
      'required': true
    }, {
      'name': 'weight',
      'type': 'field'
    }, {
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'cellSize',
      'type': 'number'
    }, {
      'name': 'bandwidth',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'counts',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'as',
      'type': 'string',
      'default': 'grid'
    }]
  };
  const PARAMS = ['x', 'y', 'weight', 'size', 'cellSize', 'bandwidth'];

  function params(obj, _) {
    PARAMS.forEach(param => _[param] != null ? obj[param](_[param]) : 0);
    return obj;
  }

  inherits(KDE2D, Transform, {
    transform(_, pulse) {
      if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
      var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
          source = pulse.materialize(pulse.SOURCE).source,
          groups = partition$2(source, _.groupby),
          names = (_.groupby || []).map(accessorName),
          kde = params(density2D(), _),
          as = _.as || 'grid',
          values = [];

      function set(t, vals) {
        for (let i = 0; i < names.length; ++i) t[names[i]] = vals[i];

        return t;
      } // generate density raster grids


      values = groups.map(g => ingest$1(set({
        [as]: kde(g, _.counts)
      }, g.dims)));
      if (this.value) out.rem = this.value;
      this.value = out.source = out.add = values;
      return out;
    }

  });

  function partition$2(data, groupby) {
    var groups = [],
        get = f => f(t),
        map,
        i,
        n,
        t,
        k,
        g; // partition data points into groups


    if (groupby == null) {
      groups.push(data);
    } else {
      for (map = {}, i = 0, n = data.length; i < n; ++i) {
        t = data[i];
        k = groupby.map(get);
        g = map[k];

        if (!g) {
          map[k] = g = [];
          g.dims = k;
          groups.push(g);
        }

        g.push(t);
      }
    }

    return groups;
  }
  /**
   * Generate contours based on kernel-density estimation of point data.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<number>} params.size - The dimensions [width, height] over which to compute contours.
   *  If the values parameter is provided, this must be the dimensions of the input data.
   *  If density estimation is performed, this is the output view dimensions in pixels.
   * @param {Array<number>} [params.values] - An array of numeric values representing an
   *  width x height grid of values over which to compute contours. If unspecified, this
   *  transform will instead attempt to compute contours for the kernel density estimate
   *  using values drawn from data tuples in the input pulse.
   * @param {function(object): number} [params.x] - The pixel x-coordinate accessor for density estimation.
   * @param {function(object): number} [params.y] - The pixel y-coordinate accessor for density estimation.
   * @param {function(object): number} [params.weight] - The data point weight accessor for density estimation.
   * @param {number} [params.cellSize] - Contour density calculation cell size.
   * @param {number} [params.bandwidth] - Kernel density estimation bandwidth.
   * @param {Array<number>} [params.thresholds] - Contour threshold array. If
   *   this parameter is set, the count and nice parameters will be ignored.
   * @param {number} [params.count] - The desired number of contours.
   * @param {boolean} [params.nice] - Boolean flag indicating if the contour
   *   threshold values should be automatically aligned to "nice"
   *   human-friendly values. Setting this flag may cause the number of
   *   thresholds to deviate from the specified count.
   * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
   *   polygons should be smoothed using linear interpolation. The default is
   *   true. The parameter is ignored when using density estimation.
   */


  function Contour(params) {
    Transform.call(this, null, params);
  }

  Contour.Definition = {
    'type': 'Contour',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2,
      'required': true
    }, {
      'name': 'values',
      'type': 'number',
      'array': true
    }, {
      'name': 'x',
      'type': 'field'
    }, {
      'name': 'y',
      'type': 'field'
    }, {
      'name': 'weight',
      'type': 'field'
    }, {
      'name': 'cellSize',
      'type': 'number'
    }, {
      'name': 'bandwidth',
      'type': 'number'
    }, {
      'name': 'count',
      'type': 'number'
    }, {
      'name': 'nice',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'thresholds',
      'type': 'number',
      'array': true
    }, {
      'name': 'smooth',
      'type': 'boolean',
      'default': true
    }]
  };
  inherits(Contour, Transform, {
    transform(_, pulse) {
      if (this.value && !pulse.changed() && !_.modified()) {
        return pulse.StopPropagation;
      }

      var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
          contour = contours().smooth(_.smooth !== false),
          values = _.values,
          thresh = _.thresholds || quantize(_.count || 10, _.nice, !!values),
          size = _.size,
          grid,
          post;

      if (!values) {
        values = pulse.materialize(pulse.SOURCE).source;
        grid = params(density2D(), _)(values, true);
        post = transform$1(grid, grid.scale || 1, grid.scale || 1, 0, 0);
        size = [grid.width, grid.height];
        values = grid.values;
      }

      thresh = isArray(thresh) ? thresh : thresh(values);
      values = contour.size(size)(values, thresh);
      if (post) values.forEach(post);
      if (this.value) out.rem = this.value;
      this.value = out.source = out.add = (values || []).map(ingest$1);
      return out;
    }

  });
  const Feature = 'Feature';
  const FeatureCollection = 'FeatureCollection';
  const MultiPoint = 'MultiPoint';
  /**
   * Consolidate an array of [longitude, latitude] points or GeoJSON features
   * into a combined GeoJSON object. This transform is particularly useful for
   * combining geo data for a Projection's fit argument. The resulting GeoJSON
   * data is available as this transform's value. Input pulses are unchanged.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<function(object): *>} [params.fields] - A two-element array
   *   of field accessors for the longitude and latitude values.
   * @param {function(object): *} params.geojson - A field accessor for
   *   retrieving GeoJSON feature data.
   */

  function GeoJSON(params) {
    Transform.call(this, null, params);
  }

  GeoJSON.Definition = {
    'type': 'GeoJSON',
    'metadata': {},
    'params': [{
      'name': 'fields',
      'type': 'field',
      'array': true,
      'length': 2
    }, {
      'name': 'geojson',
      'type': 'field'
    }]
  };
  inherits(GeoJSON, Transform, {
    transform(_, pulse) {
      var features = this._features,
          points = this._points,
          fields = _.fields,
          lon = fields && fields[0],
          lat = fields && fields[1],
          geojson = _.geojson || !fields && identity$6,
          flag = pulse.ADD,
          mod;
      mod = _.modified() || pulse.changed(pulse.REM) || pulse.modified(accessorFields(geojson)) || lon && pulse.modified(accessorFields(lon)) || lat && pulse.modified(accessorFields(lat));

      if (!this.value || mod) {
        flag = pulse.SOURCE;
        this._features = features = [];
        this._points = points = [];
      }

      if (geojson) {
        pulse.visit(flag, t => features.push(geojson(t)));
      }

      if (lon && lat) {
        pulse.visit(flag, t => {
          var x = lon(t),
              y = lat(t);

          if (x != null && y != null && (x = +x) === x && (y = +y) === y) {
            points.push([x, y]);
          }
        });
        features = features.concat({
          type: Feature,
          geometry: {
            type: MultiPoint,
            coordinates: points
          }
        });
      }

      this.value = {
        type: FeatureCollection,
        features: features
      };
    }

  });
  /**
   * Map GeoJSON data to an SVG path string.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(number, number): *} params.projection - The cartographic
   *   projection to apply.
   * @param {function(object): *} [params.field] - The field with GeoJSON data,
   *   or null if the tuple itself is a GeoJSON feature.
   * @param {string} [params.as='path'] - The output field in which to store
   *   the generated path data (default 'path').
   */

  function GeoPath(params) {
    Transform.call(this, null, params);
  }

  GeoPath.Definition = {
    'type': 'GeoPath',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'projection',
      'type': 'projection'
    }, {
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'pointRadius',
      'type': 'number',
      'expr': true
    }, {
      'name': 'as',
      'type': 'string',
      'default': 'path'
    }]
  };
  inherits(GeoPath, Transform, {
    transform(_, pulse) {
      var out = pulse.fork(pulse.ALL),
          path = this.value,
          field = _.field || identity$6,
          as = _.as || 'path',
          flag = out.SOURCE;

      if (!path || _.modified()) {
        // parameters updated, reset and reflow
        this.value = path = getProjectionPath(_.projection);
        out.materialize().reflow();
      } else {
        flag = field === identity$6 || pulse.modified(field.fields) ? out.ADD_MOD : out.ADD;
      }

      const prev = initPath(path, _.pointRadius);
      out.visit(flag, t => t[as] = path(field(t)));
      path.pointRadius(prev);
      return out.modifies(as);
    }

  });

  function initPath(path, pointRadius) {
    const prev = path.pointRadius();
    path.context(null);

    if (pointRadius != null) {
      path.pointRadius(pointRadius);
    }

    return prev;
  }
  /**
   * Geo-code a longitude/latitude point to an x/y coordinate.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(number, number): *} params.projection - The cartographic
   *   projection to apply.
   * @param {Array<function(object): *>} params.fields - A two-element array of
   *   field accessors for the longitude and latitude values.
   * @param {Array<string>} [params.as] - A two-element array of field names
   *   under which to store the result. Defaults to ['x','y'].
   */


  function GeoPoint(params) {
    Transform.call(this, null, params);
  }

  GeoPoint.Definition = {
    'type': 'GeoPoint',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'projection',
      'type': 'projection',
      'required': true
    }, {
      'name': 'fields',
      'type': 'field',
      'array': true,
      'required': true,
      'length': 2
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 2,
      'default': ['x', 'y']
    }]
  };
  inherits(GeoPoint, Transform, {
    transform(_, pulse) {
      var proj = _.projection,
          lon = _.fields[0],
          lat = _.fields[1],
          as = _.as || ['x', 'y'],
          x = as[0],
          y = as[1],
          mod;

      function set(t) {
        const xy = proj([lon(t), lat(t)]);

        if (xy) {
          t[x] = xy[0];
          t[y] = xy[1];
        } else {
          t[x] = undefined;
          t[y] = undefined;
        }
      }

      if (_.modified()) {
        // parameters updated, reflow
        pulse = pulse.materialize().reflow(true).visit(pulse.SOURCE, set);
      } else {
        mod = pulse.modified(lon.fields) || pulse.modified(lat.fields);
        pulse.visit(mod ? pulse.ADD_MOD : pulse.ADD, set);
      }

      return pulse.modifies(as);
    }

  });
  /**
   * Annotate items with a geopath shape generator.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(number, number): *} params.projection - The cartographic
   *   projection to apply.
   * @param {function(object): *} [params.field] - The field with GeoJSON data,
   *   or null if the tuple itself is a GeoJSON feature.
   * @param {string} [params.as='shape'] - The output field in which to store
   *   the generated path data (default 'shape').
   */

  function GeoShape(params) {
    Transform.call(this, null, params);
  }

  GeoShape.Definition = {
    'type': 'GeoShape',
    'metadata': {
      'modifies': true,
      'nomod': true
    },
    'params': [{
      'name': 'projection',
      'type': 'projection'
    }, {
      'name': 'field',
      'type': 'field',
      'default': 'datum'
    }, {
      'name': 'pointRadius',
      'type': 'number',
      'expr': true
    }, {
      'name': 'as',
      'type': 'string',
      'default': 'shape'
    }]
  };
  inherits(GeoShape, Transform, {
    transform(_, pulse) {
      var out = pulse.fork(pulse.ALL),
          shape = this.value,
          as = _.as || 'shape',
          flag = out.ADD;

      if (!shape || _.modified()) {
        // parameters updated, reset and reflow
        this.value = shape = shapeGenerator(getProjectionPath(_.projection), _.field || field$1('datum'), _.pointRadius);
        out.materialize().reflow();
        flag = out.SOURCE;
      }

      out.visit(flag, t => t[as] = shape);
      return out.modifies(as);
    }

  });

  function shapeGenerator(path, field, pointRadius) {
    const shape = pointRadius == null ? _ => path(field(_)) : _ => {
      var prev = path.pointRadius(),
          value = path.pointRadius(pointRadius)(field(_));
      path.pointRadius(prev);
      return value;
    };

    shape.context = _ => {
      path.context(_);
      return shape;
    };

    return shape;
  }
  /**
   * GeoJSON feature generator for creating graticules.
   * @constructor
   */


  function Graticule(params) {
    Transform.call(this, [], params);
    this.generator = graticule();
  }

  Graticule.Definition = {
    'type': 'Graticule',
    'metadata': {
      'changes': true,
      'generates': true
    },
    'params': [{
      'name': 'extent',
      'type': 'array',
      'array': true,
      'length': 2,
      'content': {
        'type': 'number',
        'array': true,
        'length': 2
      }
    }, {
      'name': 'extentMajor',
      'type': 'array',
      'array': true,
      'length': 2,
      'content': {
        'type': 'number',
        'array': true,
        'length': 2
      }
    }, {
      'name': 'extentMinor',
      'type': 'array',
      'array': true,
      'length': 2,
      'content': {
        'type': 'number',
        'array': true,
        'length': 2
      }
    }, {
      'name': 'step',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'stepMajor',
      'type': 'number',
      'array': true,
      'length': 2,
      'default': [90, 360]
    }, {
      'name': 'stepMinor',
      'type': 'number',
      'array': true,
      'length': 2,
      'default': [10, 10]
    }, {
      'name': 'precision',
      'type': 'number',
      'default': 2.5
    }]
  };
  inherits(Graticule, Transform, {
    transform(_, pulse) {
      var src = this.value,
          gen = this.generator,
          t;

      if (!src.length || _.modified()) {
        for (const prop in _) {
          if (isFunction(gen[prop])) {
            gen[prop](_[prop]);
          }
        }
      }

      t = gen();

      if (src.length) {
        pulse.mod.push(replace$1(src[0], t));
      } else {
        pulse.add.push(ingest$1(t));
      }

      src[0] = t;
      return pulse;
    }

  });
  /**
   * Render a heatmap image for input raster grid data.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} [params.field] - The field with raster grid
   *   data. If unspecified, the tuple itself is interpreted as a raster grid.
   * @param {string} [params.color] - A constant color value or function for
   *   individual pixel color. If a function, it will be invoked with an input
   *   object that includes $x, $y, $value, and $max fields for the grid.
   * @param {number} [params.opacity] - A constant opacity value or function for
   *   individual pixel opacity. If a function, it will be invoked with an input
   *   object that includes $x, $y, $value, and $max fields for the grid.
   * @param {string} [params.resolve] - The method for resolving maximum values
   *   across multiple input grids. If 'independent' (the default), maximum
   *   calculation will be performed separately for each grid. If 'shared',
   *   a single global maximum will be used for all input grids.
   * @param {string} [params.as='image'] - The output field in which to store
   *   the generated bitmap canvas images (default 'image').
   */

  function Heatmap(params) {
    Transform.call(this, null, params);
  }

  Heatmap.Definition = {
    'type': 'heatmap',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'color',
      'type': 'string',
      'expr': true
    }, {
      'name': 'opacity',
      'type': 'number',
      'expr': true
    }, {
      'name': 'resolve',
      'type': 'enum',
      'values': ['shared', 'independent'],
      'default': 'independent'
    }, {
      'name': 'as',
      'type': 'string',
      'default': 'image'
    }]
  };
  inherits(Heatmap, Transform, {
    transform(_, pulse) {
      if (!pulse.changed() && !_.modified()) {
        return pulse.StopPropagation;
      }

      var source = pulse.materialize(pulse.SOURCE).source,
          shared = _.resolve === 'shared',
          field = _.field || identity$6,
          opacity = opacity_(_.opacity, _),
          color = color_(_.color, _),
          as = _.as || 'image',
          obj = {
        $x: 0,
        $y: 0,
        $value: 0,
        $max: shared ? max$2(source.map(t => max$2(field(t).values))) : 0
      };
      source.forEach(t => {
        const v = field(t); // build proxy data object

        const o = extend$1({}, t, obj); // set maximum value if not globally shared

        if (!shared) o.$max = max$2(v.values || []); // generate canvas image
        // optimize color/opacity if not pixel-dependent

        t[as] = toCanvas(v, o, color.dep ? color : constant$4(color(o)), opacity.dep ? opacity : constant$4(opacity(o)));
      });
      return pulse.reflow(true).modifies(as);
    }

  }); // get image color function

  function color_(color, _) {
    let f;

    if (isFunction(color)) {
      f = obj => rgb$1(color(obj, _));

      f.dep = dependency(color);
    } else {
      // default to mid-grey
      f = constant$4(rgb$1(color || '#888'));
    }

    return f;
  } // get image opacity function


  function opacity_(opacity, _) {
    let f;

    if (isFunction(opacity)) {
      f = obj => opacity(obj, _);

      f.dep = dependency(opacity);
    } else if (opacity) {
      f = constant$4(opacity);
    } else {
      // default to [0, max] opacity gradient
      f = obj => obj.$value / obj.$max || 0;

      f.dep = true;
    }

    return f;
  } // check if function depends on individual pixel data


  function dependency(f) {
    if (!isFunction(f)) return false;
    const set = toSet(accessorFields(f));
    return set.$x || set.$y || set.$value || set.$max;
  } // render raster grid to canvas


  function toCanvas(grid, obj, color, opacity) {
    const n = grid.width,
          m = grid.height,
          x1 = grid.x1 || 0,
          y1 = grid.y1 || 0,
          x2 = grid.x2 || n,
          y2 = grid.y2 || m,
          val = grid.values,
          value = val ? i => val[i] : zero$2,
          can = canvas(x2 - x1, y2 - y1),
          ctx = can.getContext('2d'),
          img = ctx.getImageData(0, 0, x2 - x1, y2 - y1),
          pix = img.data;

    for (let j = y1, k = 0; j < y2; ++j) {
      obj.$y = j - y1;

      for (let i = x1, r = j * n; i < x2; ++i, k += 4) {
        obj.$x = i - x1;
        obj.$value = value(i + r);
        const v = color(obj);
        pix[k + 0] = v.r;
        pix[k + 1] = v.g;
        pix[k + 2] = v.b;
        pix[k + 3] = ~~(255 * opacity(obj));
      }
    }

    ctx.putImageData(img, 0, 0);
    return can;
  }
  /**
   * Maintains a cartographic projection.
   * @constructor
   * @param {object} params - The parameters for this operator.
   */


  function Projection$1(params) {
    Transform.call(this, null, params);
    this.modified(true); // always treat as modified
  }

  inherits(Projection$1, Transform, {
    transform(_, pulse) {
      let proj = this.value;

      if (!proj || _.modified('type')) {
        this.value = proj = create(_.type);
        projectionProperties.forEach(prop => {
          if (_[prop] != null) set$1(proj, prop, _[prop]);
        });
      } else {
        projectionProperties.forEach(prop => {
          if (_.modified(prop)) set$1(proj, prop, _[prop]);
        });
      }

      if (_.pointRadius != null) proj.path.pointRadius(_.pointRadius);
      if (_.fit) fit(proj, _);
      return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    }

  });

  function fit(proj, _) {
    const data = collectGeoJSON(_.fit);
    _.extent ? proj.fitExtent(_.extent, data) : _.size ? proj.fitSize(_.size, data) : 0;
  }

  function create(type) {
    const constructor = projection((type || 'mercator').toLowerCase());
    if (!constructor) error('Unrecognized projection type: ' + type);
    return constructor();
  }

  function set$1(proj, key, value) {
    if (isFunction(proj[key])) proj[key](value);
  }

  function collectGeoJSON(data) {
    data = array$5(data);
    return data.length === 1 ? data[0] : {
      type: FeatureCollection,
      features: data.reduce((a, f) => a.concat(featurize(f)), [])
    };
  }

  function featurize(f) {
    return f.type === FeatureCollection ? f.features : array$5(f).filter(d => d != null).map(d => d.type === Feature ? d : {
      type: Feature,
      geometry: d
    });
  }

  var geo = /*#__PURE__*/Object.freeze({
    __proto__: null,
    contour: Contour,
    geojson: GeoJSON,
    geopath: GeoPath,
    geopoint: GeoPoint,
    geoshape: GeoShape,
    graticule: Graticule,
    heatmap: Heatmap,
    isocontour: Isocontour,
    kde2d: KDE2D,
    projection: Projection$1
  });

  function forceCenter (x, y) {
    var nodes,
        strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;

    function force() {
      var i,
          n = nodes.length,
          node,
          sx = 0,
          sy = 0;

      for (i = 0; i < n; ++i) {
        node = nodes[i], sx += node.x, sy += node.y;
      }

      for (sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i) {
        node = nodes[i], node.x -= sx, node.y -= sy;
      }
    }

    force.initialize = function (_) {
      nodes = _;
    };

    force.x = function (_) {
      return arguments.length ? (x = +_, force) : x;
    };

    force.y = function (_) {
      return arguments.length ? (y = +_, force) : y;
    };

    force.strength = function (_) {
      return arguments.length ? (strength = +_, force) : strength;
    };

    return force;
  }

  function tree_add (d) {
    const x = +this._x.call(null, d),
          y = +this._y.call(null, d);
    return add(this.cover(x, y), x, y, d);
  }

  function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

    var parent,
        node = tree._root,
        leaf = {
      data: d
    },
        x0 = tree._x0,
        y0 = tree._y0,
        x1 = tree._x1,
        y1 = tree._y1,
        xm,
        ym,
        xp,
        yp,
        right,
        bottom,
        i,
        j; // If the tree is empty, initialize the root as a leaf.

    if (!node) return tree._root = leaf, tree; // Find the existing leaf for the new point, or add it.

    while (node.length) {
      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
      if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    } // Is the new point is exactly coincident with the existing point?


    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree; // Otherwise, split the leaf node until the old and new point are separated.

    do {
      parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
    } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));

    return parent[j] = node, parent[i] = leaf, tree;
  }

  function addAll(data) {
    var d,
        i,
        n = data.length,
        x,
        y,
        xz = new Array(n),
        yz = new Array(n),
        x0 = Infinity,
        y0 = Infinity,
        x1 = -Infinity,
        y1 = -Infinity; // Compute the points and their extent.

    for (i = 0; i < n; ++i) {
      if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
      xz[i] = x;
      yz[i] = y;
      if (x < x0) x0 = x;
      if (x > x1) x1 = x;
      if (y < y0) y0 = y;
      if (y > y1) y1 = y;
    } // If there were no (valid) points, abort.


    if (x0 > x1 || y0 > y1) return this; // Expand the tree to cover the new points.

    this.cover(x0, y0).cover(x1, y1); // Add the new points.

    for (i = 0; i < n; ++i) {
      add(this, xz[i], yz[i], data[i]);
    }

    return this;
  }

  function tree_cover (x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

    var x0 = this._x0,
        y0 = this._y0,
        x1 = this._x1,
        y1 = this._y1; // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!

    if (isNaN(x0)) {
      x1 = (x0 = Math.floor(x)) + 1;
      y1 = (y0 = Math.floor(y)) + 1;
    } // Otherwise, double repeatedly to cover.
    else {
        var z = x1 - x0 || 1,
            node = this._root,
            parent,
            i;

        while (x0 > x || x >= x1 || y0 > y || y >= y1) {
          i = (y < y0) << 1 | x < x0;
          parent = new Array(4), parent[i] = node, node = parent, z *= 2;

          switch (i) {
            case 0:
              x1 = x0 + z, y1 = y0 + z;
              break;

            case 1:
              x0 = x1 - z, y1 = y0 + z;
              break;

            case 2:
              x1 = x0 + z, y0 = y1 - z;
              break;

            case 3:
              x0 = x1 - z, y0 = y1 - z;
              break;
          }
        }

        if (this._root && this._root.length) this._root = node;
      }

    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
  }

  function tree_data () {
    var data = [];
    this.visit(function (node) {
      if (!node.length) do data.push(node.data); while (node = node.next);
    });
    return data;
  }

  function tree_extent (_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
  }

  function Quad (node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
  }

  function tree_find (x, y, radius) {
    var data,
        x0 = this._x0,
        y0 = this._y0,
        x1,
        y1,
        x2,
        y2,
        x3 = this._x1,
        y3 = this._y1,
        quads = [],
        node = this._root,
        q,
        i;
    if (node) quads.push(new Quad(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;else {
      x0 = x - radius, y0 = y - radius;
      x3 = x + radius, y3 = y + radius;
      radius *= radius;
    }

    while (q = quads.pop()) {
      // Stop searching if this quadrant can’t contain a closer node.
      if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue; // Bisect the current quadrant.

      if (node.length) {
        var xm = (x1 + x2) / 2,
            ym = (y1 + y2) / 2;
        quads.push(new Quad(node[3], xm, ym, x2, y2), new Quad(node[2], x1, ym, xm, y2), new Quad(node[1], xm, y1, x2, ym), new Quad(node[0], x1, y1, xm, ym)); // Visit the closest quadrant first.

        if (i = (y >= ym) << 1 | x >= xm) {
          q = quads[quads.length - 1];
          quads[quads.length - 1] = quads[quads.length - 1 - i];
          quads[quads.length - 1 - i] = q;
        }
      } // Visit this point. (Visiting coincident points isn’t necessary!)
      else {
          var dx = x - +this._x.call(null, node.data),
              dy = y - +this._y.call(null, node.data),
              d2 = dx * dx + dy * dy;

          if (d2 < radius) {
            var d = Math.sqrt(radius = d2);
            x0 = x - d, y0 = y - d;
            x3 = x + d, y3 = y + d;
            data = node.data;
          }
        }
    }

    return data;
  }

  function tree_remove (d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

    var parent,
        node = this._root,
        retainer,
        previous,
        next,
        x0 = this._x0,
        y0 = this._y0,
        x1 = this._x1,
        y1 = this._y1,
        x,
        y,
        xm,
        ym,
        right,
        bottom,
        i,
        j; // If the tree is empty, initialize the root as a leaf.

    if (!node) return this; // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.

    if (node.length) while (true) {
      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
      if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
      if (!node.length) break;
      if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    } // Find the point to remove.

    while (node.data !== d) if (!(previous = node, node = node.next)) return this;

    if (next = node.next) delete node.next; // If there are multiple coincident points, remove just the point.

    if (previous) return next ? previous.next = next : delete previous.next, this; // If this is the root point, remove it.

    if (!parent) return this._root = next, this; // Remove this leaf.

    next ? parent[i] = next : delete parent[i]; // If the parent now contains exactly one leaf, collapse superfluous parents.

    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
      if (retainer) retainer[j] = node;else this._root = node;
    }

    return this;
  }
  function removeAll(data) {
    for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);

    return this;
  }

  function tree_root () {
    return this._root;
  }

  function tree_size () {
    var size = 0;
    this.visit(function (node) {
      if (!node.length) do ++size; while (node = node.next);
    });
    return size;
  }

  function tree_visit (callback) {
    var quads = [],
        q,
        node = this._root,
        child,
        x0,
        y0,
        x1,
        y1;
    if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));

    while (q = quads.pop()) {
      if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2,
            ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      }
    }

    return this;
  }

  function tree_visitAfter (callback) {
    var quads = [],
        next = [],
        q;
    if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));

    while (q = quads.pop()) {
      var node = q.node;

      if (node.length) {
        var child,
            x0 = q.x0,
            y0 = q.y0,
            x1 = q.x1,
            y1 = q.y1,
            xm = (x0 + x1) / 2,
            ym = (y0 + y1) / 2;
        if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
        if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
        if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
        if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      }

      next.push(q);
    }

    while (q = next.pop()) {
      callback(q.node, q.x0, q.y0, q.x1, q.y1);
    }

    return this;
  }

  function defaultX(d) {
    return d[0];
  }
  function tree_x (_) {
    return arguments.length ? (this._x = _, this) : this._x;
  }

  function defaultY(d) {
    return d[1];
  }
  function tree_y (_) {
    return arguments.length ? (this._y = _, this) : this._y;
  }

  function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
  }

  function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
  }

  function leaf_copy(leaf) {
    var copy = {
      data: leaf.data
    },
        next = copy;

    while (leaf = leaf.next) next = next.next = {
      data: leaf.data
    };

    return copy;
  }

  var treeProto = quadtree.prototype = Quadtree.prototype;

  treeProto.copy = function () {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
        node = this._root,
        nodes,
        child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [{
      source: node,
      target: copy._root = new Array(4)
    }];

    while (node = nodes.pop()) {
      for (var i = 0; i < 4; ++i) {
        if (child = node.source[i]) {
          if (child.length) nodes.push({
            source: child,
            target: node.target[i] = new Array(4)
          });else node.target[i] = leaf_copy(child);
        }
      }
    }

    return copy;
  };

  treeProto.add = tree_add;
  treeProto.addAll = addAll;
  treeProto.cover = tree_cover;
  treeProto.data = tree_data;
  treeProto.extent = tree_extent;
  treeProto.find = tree_find;
  treeProto.remove = tree_remove;
  treeProto.removeAll = removeAll;
  treeProto.root = tree_root;
  treeProto.size = tree_size;
  treeProto.visit = tree_visit;
  treeProto.visitAfter = tree_visitAfter;
  treeProto.x = tree_x;
  treeProto.y = tree_y;

  function constant$1 (x) {
    return function () {
      return x;
    };
  }

  function jiggle (random) {
    return (random() - 0.5) * 1e-6;
  }

  function x$1(d) {
    return d.x + d.vx;
  }

  function y$1(d) {
    return d.y + d.vy;
  }

  function forceCollide (radius) {
    var nodes,
        radii,
        random,
        strength = 1,
        iterations = 1;
    if (typeof radius !== "function") radius = constant$1(radius == null ? 1 : +radius);

    function force() {
      var i,
          n = nodes.length,
          tree,
          node,
          xi,
          yi,
          ri,
          ri2;

      for (var k = 0; k < iterations; ++k) {
        tree = quadtree(nodes, x$1, y$1).visitAfter(prepare);

        for (i = 0; i < n; ++i) {
          node = nodes[i];
          ri = radii[node.index], ri2 = ri * ri;
          xi = node.x + node.vx;
          yi = node.y + node.vy;
          tree.visit(apply);
        }
      }

      function apply(quad, x0, y0, x1, y1) {
        var data = quad.data,
            rj = quad.r,
            r = ri + rj;

        if (data) {
          if (data.index > node.index) {
            var x = xi - data.x - data.vx,
                y = yi - data.y - data.vy,
                l = x * x + y * y;

            if (l < r * r) {
              if (x === 0) x = jiggle(random), l += x * x;
              if (y === 0) y = jiggle(random), l += y * y;
              l = (r - (l = Math.sqrt(l))) / l * strength;
              node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
              node.vy += (y *= l) * r;
              data.vx -= x * (r = 1 - r);
              data.vy -= y * r;
            }
          }

          return;
        }

        return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
      }
    }

    function prepare(quad) {
      if (quad.data) return quad.r = radii[quad.data.index];

      for (var i = quad.r = 0; i < 4; ++i) {
        if (quad[i] && quad[i].r > quad.r) {
          quad.r = quad[i].r;
        }
      }
    }

    function initialize() {
      if (!nodes) return;
      var i,
          n = nodes.length,
          node;
      radii = new Array(n);

      for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }

    force.initialize = function (_nodes, _random) {
      nodes = _nodes;
      random = _random;
      initialize();
    };

    force.iterations = function (_) {
      return arguments.length ? (iterations = +_, force) : iterations;
    };

    force.strength = function (_) {
      return arguments.length ? (strength = +_, force) : strength;
    };

    force.radius = function (_) {
      return arguments.length ? (radius = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : radius;
    };

    return force;
  }

  function index$1(d) {
    return d.index;
  }

  function find$1(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
  }

  function forceLink (links) {
    var id = index$1,
        strength = defaultStrength,
        strengths,
        distance = constant$1(30),
        distances,
        nodes,
        count,
        bias,
        random,
        iterations = 1;
    if (links == null) links = [];

    function defaultStrength(link) {
      return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }

    function force(alpha) {
      for (var k = 0, n = links.length; k < iterations; ++k) {
        for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
          link = links[i], source = link.source, target = link.target;
          x = target.x + target.vx - source.x - source.vx || jiggle(random);
          y = target.y + target.vy - source.y - source.vy || jiggle(random);
          l = Math.sqrt(x * x + y * y);
          l = (l - distances[i]) / l * alpha * strengths[i];
          x *= l, y *= l;
          target.vx -= x * (b = bias[i]);
          target.vy -= y * b;
          source.vx += x * (b = 1 - b);
          source.vy += y * b;
        }
      }
    }

    function initialize() {
      if (!nodes) return;
      var i,
          n = nodes.length,
          m = links.length,
          nodeById = new Map(nodes.map((d, i) => [id(d, i, nodes), d])),
          link;

      for (i = 0, count = new Array(n); i < m; ++i) {
        link = links[i], link.index = i;
        if (typeof link.source !== "object") link.source = find$1(nodeById, link.source);
        if (typeof link.target !== "object") link.target = find$1(nodeById, link.target);
        count[link.source.index] = (count[link.source.index] || 0) + 1;
        count[link.target.index] = (count[link.target.index] || 0) + 1;
      }

      for (i = 0, bias = new Array(m); i < m; ++i) {
        link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
      }

      strengths = new Array(m), initializeStrength();
      distances = new Array(m), initializeDistance();
    }

    function initializeStrength() {
      if (!nodes) return;

      for (var i = 0, n = links.length; i < n; ++i) {
        strengths[i] = +strength(links[i], i, links);
      }
    }

    function initializeDistance() {
      if (!nodes) return;

      for (var i = 0, n = links.length; i < n; ++i) {
        distances[i] = +distance(links[i], i, links);
      }
    }

    force.initialize = function (_nodes, _random) {
      nodes = _nodes;
      random = _random;
      initialize();
    };

    force.links = function (_) {
      return arguments.length ? (links = _, initialize(), force) : links;
    };

    force.id = function (_) {
      return arguments.length ? (id = _, force) : id;
    };

    force.iterations = function (_) {
      return arguments.length ? (iterations = +_, force) : iterations;
    };

    force.strength = function (_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initializeStrength(), force) : strength;
    };

    force.distance = function (_) {
      return arguments.length ? (distance = typeof _ === "function" ? _ : constant$1(+_), initializeDistance(), force) : distance;
    };

    return force;
  }

  var noop = {
    value: () => {}
  };

  function dispatch() {
    for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
      if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
      _[t] = [];
    }

    return new Dispatch(_);
  }

  function Dispatch(_) {
    this._ = _;
  }

  function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function (t) {
      var name = "",
          i = t.indexOf(".");
      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
      if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
      return {
        type: t,
        name: name
      };
    });
  }

  Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function (typename, callback) {
      var _ = this._,
          T = parseTypenames(typename + "", _),
          t,
          i = -1,
          n = T.length; // If no callback was specified, return the callback of the given type and name.

      if (arguments.length < 2) {
        while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;

        return;
      } // If a type was specified, set the callback for the given type and name.
      // Otherwise, if a null callback was specified, remove callbacks of the given name.


      if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);

      while (++i < n) {
        if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
      }

      return this;
    },
    copy: function () {
      var copy = {},
          _ = this._;

      for (var t in _) copy[t] = _[t].slice();

      return new Dispatch(copy);
    },
    call: function (type, that) {
      if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);

      for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
    },
    apply: function (type, that, args) {
      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);

      for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
    }
  };

  function get(type, name) {
    for (var i = 0, n = type.length, c; i < n; ++i) {
      if ((c = type[i]).name === name) {
        return c.value;
      }
    }
  }

  function set(type, name, callback) {
    for (var i = 0, n = type.length; i < n; ++i) {
      if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
      }
    }

    if (callback != null) type.push({
      name: name,
      value: callback
    });
    return type;
  }

  var frame = 0,
      // is an animation frame pending?
  timeout = 0,
      // is a timeout pending?
  interval$1 = 0,
      // are any timers active?
  pokeDelay = 1000,
      // how frequently we check for clock skew
  taskHead,
      taskTail,
      clockLast = 0,
      clockNow = 0,
      clockSkew = 0,
      clock = typeof performance === "object" && performance.now ? performance : Date,
      setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) {
    setTimeout(f, 17);
  };
  function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
  }

  function clearNow() {
    clockNow = 0;
  }

  function Timer$1() {
    this._call = this._time = this._next = null;
  }
  Timer$1.prototype = timer$1.prototype = {
    constructor: Timer$1,
    restart: function (callback, delay, time) {
      if (typeof callback !== "function") throw new TypeError("callback is not a function");
      time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);

      if (!this._next && taskTail !== this) {
        if (taskTail) taskTail._next = this;else taskHead = this;
        taskTail = this;
      }

      this._call = callback;
      this._time = time;
      sleep();
    },
    stop: function () {
      if (this._call) {
        this._call = null;
        this._time = Infinity;
        sleep();
      }
    }
  };
  function timer$1(callback, delay, time) {
    var t = new Timer$1();
    t.restart(callback, delay, time);
    return t;
  }
  function timerFlush() {
    now(); // Get the current time, if not already set.

    ++frame; // Pretend we’ve set an alarm, if we haven’t already.

    var t = taskHead,
        e;

    while (t) {
      if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
      t = t._next;
    }

    --frame;
  }

  function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;

    try {
      timerFlush();
    } finally {
      frame = 0;
      nap();
      clockNow = 0;
    }
  }

  function poke() {
    var now = clock.now(),
        delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
  }

  function nap() {
    var t0,
        t1 = taskHead,
        t2,
        time = Infinity;

    while (t1) {
      if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
      } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
      }
    }

    taskTail = t0;
    sleep(time);
  }

  function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.

    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.

    if (delay > 24) {
      if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
      if (interval$1) interval$1 = clearInterval(interval$1);
    } else {
      if (!interval$1) clockLast = clock.now(), interval$1 = setInterval(poke, pokeDelay);
      frame = 1, setFrame(wake);
    }
  }

  function interval (callback, delay, time) {
    var t = new Timer$1(),
        total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    t._restart = t.restart;

    t.restart = function (callback, delay, time) {
      delay = +delay, time = time == null ? now() : +time;

      t._restart(function tick(elapsed) {
        elapsed += total;

        t._restart(tick, total += delay, time);

        callback(elapsed);
      }, delay, time);
    };

    t.restart(callback, delay, time);
    return t;
  }

  // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
  const a = 1664525;
  const c = 1013904223;
  const m = 4294967296; // 2^32

  function lcg () {
    let s = 1;
    return () => (s = (a * s + c) % m) / m;
  }

  function x(d) {
    return d.x;
  }
  function y(d) {
    return d.y;
  }
  var initialRadius = 10,
      initialAngle = Math.PI * (3 - Math.sqrt(5));
  function forceSimulation (nodes) {
    var simulation,
        alpha = 1,
        alphaMin = 0.001,
        alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
        alphaTarget = 0,
        velocityDecay = 0.6,
        forces = new Map(),
        stepper = timer$1(step),
        event = dispatch("tick", "end"),
        random = lcg();
    if (nodes == null) nodes = [];

    function step() {
      tick();
      event.call("tick", simulation);

      if (alpha < alphaMin) {
        stepper.stop();
        event.call("end", simulation);
      }
    }

    function tick(iterations) {
      var i,
          n = nodes.length,
          node;
      if (iterations === undefined) iterations = 1;

      for (var k = 0; k < iterations; ++k) {
        alpha += (alphaTarget - alpha) * alphaDecay;
        forces.forEach(function (force) {
          force(alpha);
        });

        for (i = 0; i < n; ++i) {
          node = nodes[i];
          if (node.fx == null) node.x += node.vx *= velocityDecay;else node.x = node.fx, node.vx = 0;
          if (node.fy == null) node.y += node.vy *= velocityDecay;else node.y = node.fy, node.vy = 0;
        }
      }

      return simulation;
    }

    function initializeNodes() {
      for (var i = 0, n = nodes.length, node; i < n; ++i) {
        node = nodes[i], node.index = i;
        if (node.fx != null) node.x = node.fx;
        if (node.fy != null) node.y = node.fy;

        if (isNaN(node.x) || isNaN(node.y)) {
          var radius = initialRadius * Math.sqrt(0.5 + i),
              angle = i * initialAngle;
          node.x = radius * Math.cos(angle);
          node.y = radius * Math.sin(angle);
        }

        if (isNaN(node.vx) || isNaN(node.vy)) {
          node.vx = node.vy = 0;
        }
      }
    }

    function initializeForce(force) {
      if (force.initialize) force.initialize(nodes, random);
      return force;
    }

    initializeNodes();
    return simulation = {
      tick: tick,
      restart: function () {
        return stepper.restart(step), simulation;
      },
      stop: function () {
        return stepper.stop(), simulation;
      },
      nodes: function (_) {
        return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
      },
      alpha: function (_) {
        return arguments.length ? (alpha = +_, simulation) : alpha;
      },
      alphaMin: function (_) {
        return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
      },
      alphaDecay: function (_) {
        return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
      },
      alphaTarget: function (_) {
        return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
      },
      velocityDecay: function (_) {
        return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
      },
      randomSource: function (_) {
        return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
      },
      force: function (name, _) {
        return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
      },
      find: function (x, y, radius) {
        var i = 0,
            n = nodes.length,
            dx,
            dy,
            d2,
            node,
            closest;
        if (radius == null) radius = Infinity;else radius *= radius;

        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dx = x - node.x;
          dy = y - node.y;
          d2 = dx * dx + dy * dy;
          if (d2 < radius) closest = node, radius = d2;
        }

        return closest;
      },
      on: function (name, _) {
        return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
      }
    };
  }

  function forceManyBody () {
    var nodes,
        node,
        random,
        alpha,
        strength = constant$1(-30),
        strengths,
        distanceMin2 = 1,
        distanceMax2 = Infinity,
        theta2 = 0.81;

    function force(_) {
      var i,
          n = nodes.length,
          tree = quadtree(nodes, x, y).visitAfter(accumulate);

      for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
    }

    function initialize() {
      if (!nodes) return;
      var i,
          n = nodes.length,
          node;
      strengths = new Array(n);

      for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }

    function accumulate(quad) {
      var strength = 0,
          q,
          c,
          weight = 0,
          x,
          y,
          i; // For internal nodes, accumulate forces from child quadrants.

      if (quad.length) {
        for (x = y = i = 0; i < 4; ++i) {
          if ((q = quad[i]) && (c = Math.abs(q.value))) {
            strength += q.value, weight += c, x += c * q.x, y += c * q.y;
          }
        }

        quad.x = x / weight;
        quad.y = y / weight;
      } // For leaf nodes, accumulate forces from coincident quadrants.
      else {
          q = quad;
          q.x = q.data.x;
          q.y = q.data.y;

          do strength += strengths[q.data.index]; while (q = q.next);
        }

      quad.value = strength;
    }

    function apply(quad, x1, _, x2) {
      if (!quad.value) return true;
      var x = quad.x - node.x,
          y = quad.y - node.y,
          w = x2 - x1,
          l = x * x + y * y; // Apply the Barnes-Hut approximation if possible.
      // Limit forces for very close nodes; randomize direction if coincident.

      if (w * w / theta2 < l) {
        if (l < distanceMax2) {
          if (x === 0) x = jiggle(random), l += x * x;
          if (y === 0) y = jiggle(random), l += y * y;
          if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
          node.vx += x * quad.value * alpha / l;
          node.vy += y * quad.value * alpha / l;
        }

        return true;
      } // Otherwise, process points directly.
      else if (quad.length || l >= distanceMax2) return; // Limit forces for very close nodes; randomize direction if coincident.


      if (quad.data !== node || quad.next) {
        if (x === 0) x = jiggle(random), l += x * x;
        if (y === 0) y = jiggle(random), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
      }

      do if (quad.data !== node) {
        w = strengths[quad.data.index] * alpha / l;
        node.vx += x * w;
        node.vy += y * w;
      } while (quad = quad.next);
    }

    force.initialize = function (_nodes, _random) {
      nodes = _nodes;
      random = _random;
      initialize();
    };

    force.strength = function (_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : strength;
    };

    force.distanceMin = function (_) {
      return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };

    force.distanceMax = function (_) {
      return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };

    force.theta = function (_) {
      return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };

    return force;
  }

  function forceX (x) {
    var strength = constant$1(0.1),
        nodes,
        strengths,
        xz;
    if (typeof x !== "function") x = constant$1(x == null ? 0 : +x);

    function force(alpha) {
      for (var i = 0, n = nodes.length, node; i < n; ++i) {
        node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
      }
    }

    function initialize() {
      if (!nodes) return;
      var i,
          n = nodes.length;
      strengths = new Array(n);
      xz = new Array(n);

      for (i = 0; i < n; ++i) {
        strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
      }
    }

    force.initialize = function (_) {
      nodes = _;
      initialize();
    };

    force.strength = function (_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : strength;
    };

    force.x = function (_) {
      return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : x;
    };

    return force;
  }

  function forceY (y) {
    var strength = constant$1(0.1),
        nodes,
        strengths,
        yz;
    if (typeof y !== "function") y = constant$1(y == null ? 0 : +y);

    function force(alpha) {
      for (var i = 0, n = nodes.length, node; i < n; ++i) {
        node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
      }
    }

    function initialize() {
      if (!nodes) return;
      var i,
          n = nodes.length;
      strengths = new Array(n);
      yz = new Array(n);

      for (i = 0; i < n; ++i) {
        strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
      }
    }

    force.initialize = function (_) {
      nodes = _;
      initialize();
    };

    force.strength = function (_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : strength;
    };

    force.y = function (_) {
      return arguments.length ? (y = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : y;
    };

    return force;
  }

  const ForceMap = {
    center: forceCenter,
    collide: forceCollide,
    nbody: forceManyBody,
    link: forceLink,
    x: forceX,
    y: forceY
  };
  const Forces = 'forces',
        ForceParams = ['alpha', 'alphaMin', 'alphaTarget', 'velocityDecay', 'forces'],
        ForceConfig = ['static', 'iterations'],
        ForceOutput = ['x', 'y', 'vx', 'vy'];
  /**
   * Force simulation layout.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<object>} params.forces - The forces to apply.
   */

  function Force(params) {
    Transform.call(this, null, params);
  }

  Force.Definition = {
    'type': 'Force',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'static',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'restart',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'iterations',
      'type': 'number',
      'default': 300
    }, {
      'name': 'alpha',
      'type': 'number',
      'default': 1
    }, {
      'name': 'alphaMin',
      'type': 'number',
      'default': 0.001
    }, {
      'name': 'alphaTarget',
      'type': 'number',
      'default': 0
    }, {
      'name': 'velocityDecay',
      'type': 'number',
      'default': 0.4
    }, {
      'name': 'forces',
      'type': 'param',
      'array': true,
      'params': [{
        'key': {
          'force': 'center'
        },
        'params': [{
          'name': 'x',
          'type': 'number',
          'default': 0
        }, {
          'name': 'y',
          'type': 'number',
          'default': 0
        }]
      }, {
        'key': {
          'force': 'collide'
        },
        'params': [{
          'name': 'radius',
          'type': 'number',
          'expr': true
        }, {
          'name': 'strength',
          'type': 'number',
          'default': 0.7
        }, {
          'name': 'iterations',
          'type': 'number',
          'default': 1
        }]
      }, {
        'key': {
          'force': 'nbody'
        },
        'params': [{
          'name': 'strength',
          'type': 'number',
          'default': -30
        }, {
          'name': 'theta',
          'type': 'number',
          'default': 0.9
        }, {
          'name': 'distanceMin',
          'type': 'number',
          'default': 1
        }, {
          'name': 'distanceMax',
          'type': 'number'
        }]
      }, {
        'key': {
          'force': 'link'
        },
        'params': [{
          'name': 'links',
          'type': 'data'
        }, {
          'name': 'id',
          'type': 'field'
        }, {
          'name': 'distance',
          'type': 'number',
          'default': 30,
          'expr': true
        }, {
          'name': 'strength',
          'type': 'number',
          'expr': true
        }, {
          'name': 'iterations',
          'type': 'number',
          'default': 1
        }]
      }, {
        'key': {
          'force': 'x'
        },
        'params': [{
          'name': 'strength',
          'type': 'number',
          'default': 0.1
        }, {
          'name': 'x',
          'type': 'field'
        }]
      }, {
        'key': {
          'force': 'y'
        },
        'params': [{
          'name': 'strength',
          'type': 'number',
          'default': 0.1
        }, {
          'name': 'y',
          'type': 'field'
        }]
      }]
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'modify': false,
      'default': ForceOutput
    }]
  };
  inherits(Force, Transform, {
    transform(_, pulse) {
      var sim = this.value,
          change = pulse.changed(pulse.ADD_REM),
          params = _.modified(ForceParams),
          iters = _.iterations || 300; // configure simulation


      if (!sim) {
        this.value = sim = simulation(pulse.source, _);
        sim.on('tick', rerun(pulse.dataflow, this));

        if (!_.static) {
          change = true;
          sim.tick(); // ensure we run on init
        }

        pulse.modifies('index');
      } else {
        if (change) {
          pulse.modifies('index');
          sim.nodes(pulse.source);
        }

        if (params || pulse.changed(pulse.MOD)) {
          setup(sim, _, 0, pulse);
        }
      } // run simulation


      if (params || change || _.modified(ForceConfig) || pulse.changed() && _.restart) {
        sim.alpha(Math.max(sim.alpha(), _.alpha || 1)).alphaDecay(1 - Math.pow(sim.alphaMin(), 1 / iters));

        if (_.static) {
          for (sim.stop(); --iters >= 0;) sim.tick();
        } else {
          if (sim.stopped()) sim.restart();
          if (!change) return pulse.StopPropagation; // defer to sim ticks
        }
      }

      return this.finish(_, pulse);
    },

    finish(_, pulse) {
      const dataflow = pulse.dataflow; // inspect dependencies, touch link source data

      for (let args = this._argops, j = 0, m = args.length, arg; j < m; ++j) {
        arg = args[j];

        if (arg.name !== Forces || arg.op._argval.force !== 'link') {
          continue;
        }

        for (var ops = arg.op._argops, i = 0, n = ops.length, op; i < n; ++i) {
          if (ops[i].name === 'links' && (op = ops[i].op.source)) {
            dataflow.pulse(op, dataflow.changeset().reflow());
            break;
          }
        }
      } // reflow all nodes


      return pulse.reflow(_.modified()).modifies(ForceOutput);
    }

  });

  function rerun(df, op) {
    return () => df.touch(op).run();
  }

  function simulation(nodes, _) {
    const sim = forceSimulation(nodes),
          stop = sim.stop,
          restart = sim.restart;
    let stopped = false;

    sim.stopped = () => stopped;

    sim.restart = () => (stopped = false, restart());

    sim.stop = () => (stopped = true, stop());

    return setup(sim, _, true).on('end', () => stopped = true);
  }

  function setup(sim, _, init, pulse) {
    var f = array$5(_.forces),
        i,
        n,
        p,
        name;

    for (i = 0, n = ForceParams.length; i < n; ++i) {
      p = ForceParams[i];
      if (p !== Forces && _.modified(p)) sim[p](_[p]);
    }

    for (i = 0, n = f.length; i < n; ++i) {
      name = Forces + i;
      p = init || _.modified(Forces, i) ? getForce(f[i]) : pulse && modified(f[i], pulse) ? sim.force(name) : null;
      if (p) sim.force(name, p);
    }

    for (n = sim.numForces || 0; i < n; ++i) {
      sim.force(Forces + i, null); // remove
    }

    sim.numForces = f.length;
    return sim;
  }

  function modified(f, pulse) {
    var k, v;

    for (k in f) {
      if (isFunction(v = f[k]) && pulse.modified(accessorFields(v))) return 1;
    }

    return 0;
  }

  function getForce(_) {
    var f, p;

    if (!has$1(ForceMap, _.force)) {
      error('Unrecognized force: ' + _.force);
    }

    f = ForceMap[_.force]();

    for (p in _) {
      if (isFunction(f[p])) setForceParam(f[p], _[p], _);
    }

    return f;
  }

  function setForceParam(f, v, _) {
    f(isFunction(v) ? d => v(d, _) : v);
  }

  var force = /*#__PURE__*/Object.freeze({
    __proto__: null,
    force: Force
  });

  function defaultSeparation$2(a, b) {
    return a.parent === b.parent ? 1 : 2;
  }

  function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
  }

  function meanXReduce(x, c) {
    return x + c.x;
  }

  function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
  }

  function maxYReduce(y, c) {
    return Math.max(y, c.y);
  }

  function leafLeft(node) {
    var children;

    while (children = node.children) node = children[0];

    return node;
  }

  function leafRight(node) {
    var children;

    while (children = node.children) node = children[children.length - 1];

    return node;
  }

  function cluster () {
    var separation = defaultSeparation$2,
        dx = 1,
        dy = 1,
        nodeSize = false;

    function cluster(root) {
      var previousNode,
          x = 0; // First walk, computing the initial x & y values.

      root.eachAfter(function (node) {
        var children = node.children;

        if (children) {
          node.x = meanX(children);
          node.y = maxY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = leafLeft(root),
          right = leafRight(root),
          x0 = left.x - separation(left, right) / 2,
          x1 = right.x + separation(right, left) / 2; // Second walk, normalizing x & y to the desired size.

      return root.eachAfter(nodeSize ? function (node) {
        node.x = (node.x - root.x) * dx;
        node.y = (root.y - node.y) * dy;
      } : function (node) {
        node.x = (node.x - x0) / (x1 - x0) * dx;
        node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
      });
    }

    cluster.separation = function (x) {
      return arguments.length ? (separation = x, cluster) : separation;
    };

    cluster.size = function (x) {
      return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [dx, dy];
    };

    cluster.nodeSize = function (x) {
      return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [dx, dy] : null;
    };

    return cluster;
  }

  function count(node) {
    var sum = 0,
        children = node.children,
        i = children && children.length;
    if (!i) sum = 1;else while (--i >= 0) sum += children[i].value;
    node.value = sum;
  }

  function node_count () {
    return this.eachAfter(count);
  }

  function node_each (callback, that) {
    let index = -1;

    for (const node of this) {
      callback.call(that, node, ++index, this);
    }

    return this;
  }

  function node_eachBefore (callback, that) {
    var node = this,
        nodes = [node],
        children,
        i,
        index = -1;

    while (node = nodes.pop()) {
      callback.call(that, node, ++index, this);

      if (children = node.children) {
        for (i = children.length - 1; i >= 0; --i) {
          nodes.push(children[i]);
        }
      }
    }

    return this;
  }

  function node_eachAfter (callback, that) {
    var node = this,
        nodes = [node],
        next = [],
        children,
        i,
        n,
        index = -1;

    while (node = nodes.pop()) {
      next.push(node);

      if (children = node.children) {
        for (i = 0, n = children.length; i < n; ++i) {
          nodes.push(children[i]);
        }
      }
    }

    while (node = next.pop()) {
      callback.call(that, node, ++index, this);
    }

    return this;
  }

  function node_find (callback, that) {
    let index = -1;

    for (const node of this) {
      if (callback.call(that, node, ++index, this)) {
        return node;
      }
    }
  }

  function node_sum (value) {
    return this.eachAfter(function (node) {
      var sum = +value(node.data) || 0,
          children = node.children,
          i = children && children.length;

      while (--i >= 0) sum += children[i].value;

      node.value = sum;
    });
  }

  function node_sort (compare) {
    return this.eachBefore(function (node) {
      if (node.children) {
        node.children.sort(compare);
      }
    });
  }

  function node_path (end) {
    var start = this,
        ancestor = leastCommonAncestor(start, end),
        nodes = [start];

    while (start !== ancestor) {
      start = start.parent;
      nodes.push(start);
    }

    var k = nodes.length;

    while (end !== ancestor) {
      nodes.splice(k, 0, end);
      end = end.parent;
    }

    return nodes;
  }

  function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(),
        bNodes = b.ancestors(),
        c = null;
    a = aNodes.pop();
    b = bNodes.pop();

    while (a === b) {
      c = a;
      a = aNodes.pop();
      b = bNodes.pop();
    }

    return c;
  }

  function node_ancestors () {
    var node = this,
        nodes = [node];

    while (node = node.parent) {
      nodes.push(node);
    }

    return nodes;
  }

  function node_descendants () {
    return Array.from(this);
  }

  function node_leaves () {
    var leaves = [];
    this.eachBefore(function (node) {
      if (!node.children) {
        leaves.push(node);
      }
    });
    return leaves;
  }

  function node_links () {
    var root = this,
        links = [];
    root.each(function (node) {
      if (node !== root) {
        // Don’t include the root’s parent, if any.
        links.push({
          source: node.parent,
          target: node
        });
      }
    });
    return links;
  }

  function* node_iterator () {
    var node = this,
        current,
        next = [node],
        children,
        i,
        n;

    do {
      current = next.reverse(), next = [];

      while (node = current.pop()) {
        yield node;

        if (children = node.children) {
          for (i = 0, n = children.length; i < n; ++i) {
            next.push(children[i]);
          }
        }
      }
    } while (next.length);
  }

  function hierarchy(data, children) {
    if (data instanceof Map) {
      data = [undefined, data];
      if (children === undefined) children = mapChildren;
    } else if (children === undefined) {
      children = objectChildren;
    }

    var root = new Node$1(data),
        node,
        nodes = [root],
        child,
        childs,
        i,
        n;

    while (node = nodes.pop()) {
      if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;

        for (i = n - 1; i >= 0; --i) {
          nodes.push(child = childs[i] = new Node$1(childs[i]));
          child.parent = node;
          child.depth = node.depth + 1;
        }
      }
    }

    return root.eachBefore(computeHeight);
  }

  function node_copy() {
    return hierarchy(this).eachBefore(copyData);
  }

  function objectChildren(d) {
    return d.children;
  }

  function mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
  }

  function copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
  }

  function computeHeight(node) {
    var height = 0;

    do node.height = height; while ((node = node.parent) && node.height < ++height);
  }
  function Node$1(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
  }
  Node$1.prototype = hierarchy.prototype = {
    constructor: Node$1,
    count: node_count,
    each: node_each,
    eachAfter: node_eachAfter,
    eachBefore: node_eachBefore,
    find: node_find,
    sum: node_sum,
    sort: node_sort,
    path: node_path,
    ancestors: node_ancestors,
    descendants: node_descendants,
    leaves: node_leaves,
    links: node_links,
    copy: node_copy,
    [Symbol.iterator]: node_iterator
  };

  function array$2 (x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
  }
  function shuffle(array) {
    var m = array.length,
        t,
        i;

    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }

    return array;
  }

  function enclose (circles) {
    var i = 0,
        n = (circles = shuffle(Array.from(circles))).length,
        B = [],
        p,
        e;

    while (i < n) {
      p = circles[i];
      if (e && enclosesWeak(e, p)) ++i;else e = encloseBasis(B = extendBasis(B, p)), i = 0;
    }

    return e;
  }

  function extendBasis(B, p) {
    var i, j;
    if (enclosesWeakAll(p, B)) return [p]; // If we get here then B must have at least one element.

    for (i = 0; i < B.length; ++i) {
      if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
        return [B[i], p];
      }
    } // If we get here then B must have at least two elements.


    for (i = 0; i < B.length - 1; ++i) {
      for (j = i + 1; j < B.length; ++j) {
        if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
          return [B[i], B[j], p];
        }
      }
    } // If we get here then something is very wrong.


    throw new Error();
  }

  function enclosesNot(a, b) {
    var dr = a.r - b.r,
        dx = b.x - a.x,
        dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
  }

  function enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9,
        dx = b.x - a.x,
        dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
  }

  function enclosesWeakAll(a, B) {
    for (var i = 0; i < B.length; ++i) {
      if (!enclosesWeak(a, B[i])) {
        return false;
      }
    }

    return true;
  }

  function encloseBasis(B) {
    switch (B.length) {
      case 1:
        return encloseBasis1(B[0]);

      case 2:
        return encloseBasis2(B[0], B[1]);

      case 3:
        return encloseBasis3(B[0], B[1], B[2]);
    }
  }

  function encloseBasis1(a) {
    return {
      x: a.x,
      y: a.y,
      r: a.r
    };
  }

  function encloseBasis2(a, b) {
    var x1 = a.x,
        y1 = a.y,
        r1 = a.r,
        x2 = b.x,
        y2 = b.y,
        r2 = b.r,
        x21 = x2 - x1,
        y21 = y2 - y1,
        r21 = r2 - r1,
        l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
      x: (x1 + x2 + x21 / l * r21) / 2,
      y: (y1 + y2 + y21 / l * r21) / 2,
      r: (l + r1 + r2) / 2
    };
  }

  function encloseBasis3(a, b, c) {
    var x1 = a.x,
        y1 = a.y,
        r1 = a.r,
        x2 = b.x,
        y2 = b.y,
        r2 = b.r,
        x3 = c.x,
        y3 = c.y,
        r3 = c.r,
        a2 = x1 - x2,
        a3 = x1 - x3,
        b2 = y1 - y2,
        b3 = y1 - y3,
        c2 = r2 - r1,
        c3 = r3 - r1,
        d1 = x1 * x1 + y1 * y1 - r1 * r1,
        d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
        d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
        ab = a3 * b2 - a2 * b3,
        xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
        xb = (b3 * c2 - b2 * c3) / ab,
        ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
        yb = (a2 * c3 - a3 * c2) / ab,
        A = xb * xb + yb * yb - 1,
        B = 2 * (r1 + xa * xb + ya * yb),
        C = xa * xa + ya * ya - r1 * r1,
        r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
      x: x1 + xa + xb * r,
      y: y1 + ya + yb * r,
      r: r
    };
  }

  function place(b, a, c) {
    var dx = b.x - a.x,
        x,
        a2,
        dy = b.y - a.y,
        y,
        b2,
        d2 = dx * dx + dy * dy;

    if (d2) {
      a2 = a.r + c.r, a2 *= a2;
      b2 = b.r + c.r, b2 *= b2;

      if (a2 > b2) {
        x = (d2 + b2 - a2) / (2 * d2);
        y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
        c.x = b.x - x * dx - y * dy;
        c.y = b.y - x * dy + y * dx;
      } else {
        x = (d2 + a2 - b2) / (2 * d2);
        y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
        c.x = a.x + x * dx - y * dy;
        c.y = a.y + x * dy + y * dx;
      }
    } else {
      c.x = a.x + c.r;
      c.y = a.y;
    }
  }

  function intersects(a, b) {
    var dr = a.r + b.r - 1e-6,
        dx = b.x - a.x,
        dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
  }

  function score(node) {
    var a = node._,
        b = node.next._,
        ab = a.r + b.r,
        dx = (a.x * b.r + b.x * a.r) / ab,
        dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
  }

  function Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
  }

  function packEnclose(circles) {
    if (!(n = (circles = array$2(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk; // Place the first circle.

    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r; // Place the second circle.

    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r; // Place the third circle.

    place(b, a, c = circles[2]); // Initialize the front-chain using the first three circles a, b and c.

    a = new Node(a), b = new Node(b), c = new Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a; // Attempt to place each remaining circle…

    pack: for (i = 3; i < n; ++i) {
      place(a._, b._, c = circles[i]), c = new Node(c); // Find the closest intersecting circle on the front-chain, if any.
      // “Closeness” is determined by linear distance along the front-chain.
      // “Ahead” or “behind” is likewise determined by linear distance.

      j = b.next, k = a.previous, sj = b._.r, sk = a._.r;

      do {
        if (sj <= sk) {
          if (intersects(j._, c._)) {
            b = j, a.next = b, b.previous = a, --i;
            continue pack;
          }

          sj += j._.r, j = j.next;
        } else {
          if (intersects(k._, c._)) {
            a = k, a.next = b, b.previous = a, --i;
            continue pack;
          }

          sk += k._.r, k = k.previous;
        }
      } while (j !== k.next); // Success! Insert the new circle c between a and b.


      c.previous = a, c.next = b, a.next = b.previous = b = c; // Compute the new closest circle pair to the centroid.

      aa = score(a);

      while ((c = c.next) !== b) {
        if ((ca = score(c)) < aa) {
          a = c, aa = ca;
        }
      }

      b = a.next;
    } // Compute the enclosing circle of the front chain.


    a = [b._], c = b;

    while ((c = c.next) !== b) a.push(c._);

    c = enclose(a); // Translate the circles to put the enclosing circle around the origin.

    for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

    return c.r;
  }

  function optional(f) {
    return f == null ? null : required(f);
  }
  function required(f) {
    if (typeof f !== "function") throw new Error();
    return f;
  }

  function constantZero() {
    return 0;
  }
  function constant (x) {
    return function () {
      return x;
    };
  }

  function defaultRadius(d) {
    return Math.sqrt(d.value);
  }

  function pack () {
    var radius = null,
        dx = 1,
        dy = 1,
        padding = constantZero;

    function pack(root) {
      root.x = dx / 2, root.y = dy / 2;

      if (radius) {
        root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, 0.5)).eachBefore(translateChild(1));
      } else {
        root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren(constantZero, 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
      }

      return root;
    }

    pack.radius = function (x) {
      return arguments.length ? (radius = optional(x), pack) : radius;
    };

    pack.size = function (x) {
      return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
    };

    pack.padding = function (x) {
      return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
    };

    return pack;
  }

  function radiusLeaf(radius) {
    return function (node) {
      if (!node.children) {
        node.r = Math.max(0, +radius(node) || 0);
      }
    };
  }

  function packChildren(padding, k) {
    return function (node) {
      if (children = node.children) {
        var children,
            i,
            n = children.length,
            r = padding(node) * k || 0,
            e;
        if (r) for (i = 0; i < n; ++i) children[i].r += r;
        e = packEnclose(children);
        if (r) for (i = 0; i < n; ++i) children[i].r -= r;
        node.r = e + r;
      }
    };
  }

  function translateChild(k) {
    return function (node) {
      var parent = node.parent;
      node.r *= k;

      if (parent) {
        node.x = parent.x + k * node.x;
        node.y = parent.y + k * node.y;
      }
    };
  }

  function roundNode (node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
  }

  function treemapDice (parent, x0, y0, x1, y1) {
    var nodes = parent.children,
        node,
        i = -1,
        n = nodes.length,
        k = parent.value && (x1 - x0) / parent.value;

    while (++i < n) {
      node = nodes[i], node.y0 = y0, node.y1 = y1;
      node.x0 = x0, node.x1 = x0 += node.value * k;
    }
  }

  function partition$1 () {
    var dx = 1,
        dy = 1,
        padding = 0,
        round = false;

    function partition(root) {
      var n = root.height + 1;
      root.x0 = root.y0 = padding;
      root.x1 = dx;
      root.y1 = dy / n;
      root.eachBefore(positionNode(dy, n));
      if (round) root.eachBefore(roundNode);
      return root;
    }

    function positionNode(dy, n) {
      return function (node) {
        if (node.children) {
          treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
        }

        var x0 = node.x0,
            y0 = node.y0,
            x1 = node.x1 - padding,
            y1 = node.y1 - padding;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
      };
    }

    partition.round = function (x) {
      return arguments.length ? (round = !!x, partition) : round;
    };

    partition.size = function (x) {
      return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
    };

    partition.padding = function (x) {
      return arguments.length ? (padding = +x, partition) : padding;
    };

    return partition;
  }

  var preroot = {
    depth: -1
  },
      ambiguous = {};

  function defaultId(d) {
    return d.id;
  }

  function defaultParentId(d) {
    return d.parentId;
  }

  function stratify () {
    var id = defaultId,
        parentId = defaultParentId;

    function stratify(data) {
      var nodes = Array.from(data),
          n = nodes.length,
          d,
          i,
          root,
          parent,
          node,
          nodeId,
          nodeKey,
          nodeByKey = new Map();

      for (i = 0; i < n; ++i) {
        d = nodes[i], node = nodes[i] = new Node$1(d);

        if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
          nodeKey = node.id = nodeId;
          nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
        }

        if ((nodeId = parentId(d, i, data)) != null && (nodeId += "")) {
          node.parent = nodeId;
        }
      }

      for (i = 0; i < n; ++i) {
        node = nodes[i];

        if (nodeId = node.parent) {
          parent = nodeByKey.get(nodeId);
          if (!parent) throw new Error("missing: " + nodeId);
          if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
          if (parent.children) parent.children.push(node);else parent.children = [node];
          node.parent = parent;
        } else {
          if (root) throw new Error("multiple roots");
          root = node;
        }
      }

      if (!root) throw new Error("no root");
      root.parent = preroot;
      root.eachBefore(function (node) {
        node.depth = node.parent.depth + 1;
        --n;
      }).eachBefore(computeHeight);
      root.parent = null;
      if (n > 0) throw new Error("cycle");
      return root;
    }

    stratify.id = function (x) {
      return arguments.length ? (id = required(x), stratify) : id;
    };

    stratify.parentId = function (x) {
      return arguments.length ? (parentId = required(x), stratify) : parentId;
    };

    return stratify;
  }

  function defaultSeparation$1(a, b) {
    return a.parent === b.parent ? 1 : 2;
  } // function radialSeparation(a, b) {
  //   return (a.parent === b.parent ? 1 : 2) / a.depth;
  // }
  // This function is used to traverse the left contour of a subtree (or
  // subforest). It returns the successor of v on this contour. This successor is
  // either given by the leftmost child of v or by the thread of v. The function
  // returns null if and only if v is on the highest level of its subtree.


  function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
  } // This function works analogously to nextLeft.


  function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
  } // Shifts the current subtree rooted at w+. This is done by increasing
  // prelim(w+) and mod(w+) by shift.


  function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  } // All other shifts, applied to the smaller subtrees between w- and w+, are
  // performed by this function. To prepare the shifts, we have to adjust
  // change(w+), shift(w+), and change(w-).


  function executeShifts(v) {
    var shift = 0,
        change = 0,
        children = v.children,
        i = children.length,
        w;

    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  } // If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
  // returns the specified (default) ancestor.


  function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }

  function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor

    this.a = this; // ancestor

    this.z = 0; // prelim

    this.m = 0; // mod

    this.c = 0; // change

    this.s = 0; // shift

    this.t = null; // thread

    this.i = i; // number
  }

  TreeNode.prototype = Object.create(Node$1.prototype);

  function treeRoot(root) {
    var tree = new TreeNode(root, 0),
        node,
        nodes = [tree],
        child,
        children,
        i,
        n;

    while (node = nodes.pop()) {
      if (children = node._.children) {
        node.children = new Array(n = children.length);

        for (i = n - 1; i >= 0; --i) {
          nodes.push(child = node.children[i] = new TreeNode(children[i], i));
          child.parent = node;
        }
      }
    }

    (tree.parent = new TreeNode(null, 0)).children = [tree];
    return tree;
  } // Node-link tree diagram using the Reingold-Tilford "tidy" algorithm


  function tree$1 () {
    var separation = defaultSeparation$1,
        dx = 1,
        dy = 1,
        nodeSize = null;

    function tree(root) {
      var t = treeRoot(root); // Compute the layout using Buchheim et al.’s algorithm.

      t.eachAfter(firstWalk), t.parent.m = -t.z;
      t.eachBefore(secondWalk); // If a fixed node size is specified, scale x and y.

      if (nodeSize) root.eachBefore(sizeNode); // If a fixed tree size is specified, scale x and y based on the extent.
      // Compute the left-most, right-most, and depth-most nodes for extents.
      else {
          var left = root,
              right = root,
              bottom = root;
          root.eachBefore(function (node) {
            if (node.x < left.x) left = node;
            if (node.x > right.x) right = node;
            if (node.depth > bottom.depth) bottom = node;
          });
          var s = left === right ? 1 : separation(left, right) / 2,
              tx = s - left.x,
              kx = dx / (right.x + s + tx),
              ky = dy / (bottom.depth || 1);
          root.eachBefore(function (node) {
            node.x = (node.x + tx) * kx;
            node.y = node.depth * ky;
          });
        }
      return root;
    } // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.


    function firstWalk(v) {
      var children = v.children,
          siblings = v.parent.children,
          w = v.i ? siblings[v.i - 1] : null;

      if (children) {
        executeShifts(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;

        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }

      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    } // Computes all real x-coordinates by summing up the modifiers recursively.


    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    } // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).


    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v,
            vop = v,
            vim = w,
            vom = vip.parent.children[0],
            sip = vip.m,
            sop = vop.m,
            sim = vim.m,
            som = vom.m,
            shift;

        while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
          vom = nextLeft(vom);
          vop = nextRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);

          if (shift > 0) {
            moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }

          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }

        if (vim && !nextRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }

        if (vip && !nextLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }

      return ancestor;
    }

    function sizeNode(node) {
      node.x *= dx;
      node.y = node.depth * dy;
    }

    tree.separation = function (x) {
      return arguments.length ? (separation = x, tree) : separation;
    };

    tree.size = function (x) {
      return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [dx, dy];
    };

    tree.nodeSize = function (x) {
      return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [dx, dy] : null;
    };

    return tree;
  }

  function treemapSlice (parent, x0, y0, x1, y1) {
    var nodes = parent.children,
        node,
        i = -1,
        n = nodes.length,
        k = parent.value && (y1 - y0) / parent.value;

    while (++i < n) {
      node = nodes[i], node.x0 = x0, node.x1 = x1;
      node.y0 = y0, node.y1 = y0 += node.value * k;
    }
  }

  var phi = (1 + Math.sqrt(5)) / 2;
  function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [],
        nodes = parent.children,
        row,
        nodeValue,
        i0 = 0,
        i1 = 0,
        n = nodes.length,
        dx,
        dy,
        value = parent.value,
        sumValue,
        minValue,
        maxValue,
        newRatio,
        minRatio,
        alpha,
        beta;

    while (i0 < n) {
      dx = x1 - x0, dy = y1 - y0; // Find the next non-empty node.

      do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);

      minValue = maxValue = sumValue;
      alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
      beta = sumValue * sumValue * alpha;
      minRatio = Math.max(maxValue / beta, beta / minValue); // Keep adding nodes while the aspect ratio maintains or improves.

      for (; i1 < n; ++i1) {
        sumValue += nodeValue = nodes[i1].value;
        if (nodeValue < minValue) minValue = nodeValue;
        if (nodeValue > maxValue) maxValue = nodeValue;
        beta = sumValue * sumValue * alpha;
        newRatio = Math.max(maxValue / beta, beta / minValue);

        if (newRatio > minRatio) {
          sumValue -= nodeValue;
          break;
        }

        minRatio = newRatio;
      } // Position and record the row orientation.


      rows.push(row = {
        value: sumValue,
        dice: dx < dy,
        children: nodes.slice(i0, i1)
      });
      if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
      value -= sumValue, i0 = i1;
    }

    return rows;
  }
  var treemapSquarify = (function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
      squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }

    squarify.ratio = function (x) {
      return custom((x = +x) > 1 ? x : 1);
    };

    return squarify;
  })(phi);

  function treemap () {
    var tile = treemapSquarify,
        round = false,
        dx = 1,
        dy = 1,
        paddingStack = [0],
        paddingInner = constantZero,
        paddingTop = constantZero,
        paddingRight = constantZero,
        paddingBottom = constantZero,
        paddingLeft = constantZero;

    function treemap(root) {
      root.x0 = root.y0 = 0;
      root.x1 = dx;
      root.y1 = dy;
      root.eachBefore(positionNode);
      paddingStack = [0];
      if (round) root.eachBefore(roundNode);
      return root;
    }

    function positionNode(node) {
      var p = paddingStack[node.depth],
          x0 = node.x0 + p,
          y0 = node.y0 + p,
          x1 = node.x1 - p,
          y1 = node.y1 - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;

      if (node.children) {
        p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
        x0 += paddingLeft(node) - p;
        y0 += paddingTop(node) - p;
        x1 -= paddingRight(node) - p;
        y1 -= paddingBottom(node) - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        tile(node, x0, y0, x1, y1);
      }
    }

    treemap.round = function (x) {
      return arguments.length ? (round = !!x, treemap) : round;
    };

    treemap.size = function (x) {
      return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
    };

    treemap.tile = function (x) {
      return arguments.length ? (tile = required(x), treemap) : tile;
    };

    treemap.padding = function (x) {
      return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };

    treemap.paddingInner = function (x) {
      return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
    };

    treemap.paddingOuter = function (x) {
      return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };

    treemap.paddingTop = function (x) {
      return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
    };

    treemap.paddingRight = function (x) {
      return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
    };

    treemap.paddingBottom = function (x) {
      return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
    };

    treemap.paddingLeft = function (x) {
      return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
    };

    return treemap;
  }

  function treemapBinary (parent, x0, y0, x1, y1) {
    var nodes = parent.children,
        i,
        n = nodes.length,
        sum,
        sums = new Array(n + 1);

    for (sums[0] = sum = i = 0; i < n; ++i) {
      sums[i + 1] = sum += nodes[i].value;
    }

    partition(0, n, parent.value, x0, y0, x1, y1);

    function partition(i, j, value, x0, y0, x1, y1) {
      if (i >= j - 1) {
        var node = nodes[i];
        node.x0 = x0, node.y0 = y0;
        node.x1 = x1, node.y1 = y1;
        return;
      }

      var valueOffset = sums[i],
          valueTarget = value / 2 + valueOffset,
          k = i + 1,
          hi = j - 1;

      while (k < hi) {
        var mid = k + hi >>> 1;
        if (sums[mid] < valueTarget) k = mid + 1;else hi = mid;
      }

      if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
      var valueLeft = sums[k] - valueOffset,
          valueRight = value - valueLeft;

      if (x1 - x0 > y1 - y0) {
        var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
        partition(i, k, valueLeft, x0, y0, xk, y1);
        partition(k, j, valueRight, xk, y0, x1, y1);
      } else {
        var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
        partition(i, k, valueLeft, x0, y0, x1, yk);
        partition(k, j, valueRight, x0, yk, x1, y1);
      }
    }
  }

  function treemapSliceDice (parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
  }

  var treemapResquarify = (function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
      if ((rows = parent._squarify) && rows.ratio === ratio) {
        var rows,
            row,
            nodes,
            i,
            j = -1,
            n,
            m = rows.length,
            value = parent.value;

        while (++j < m) {
          row = rows[j], nodes = row.children;

          for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;

          if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);else treemapSlice(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
          value -= row.value;
        }
      } else {
        parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
        rows.ratio = ratio;
      }
    }

    resquarify.ratio = function (x) {
      return custom((x = +x) > 1 ? x : 1);
    };

    return resquarify;
  })(phi);

  function lookup$2(tree, key, filter) {
    const map = {};
    tree.each(node => {
      const t = node.data;
      if (filter(t)) map[key(t)] = node;
    });
    tree.lookup = map;
    return tree;
  }
  /**
   * Nest tuples into a tree structure, grouped by key values.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<function(object): *>} params.keys - The key fields to nest by, in order.
   * @param {boolean} [params.generate=false] - A boolean flag indicating if
   *   non-leaf nodes generated by this transform should be included in the
   *   output. The default (false) includes only the input data (leaf nodes)
   *   in the data stream.
   */


  function Nest(params) {
    Transform.call(this, null, params);
  }

  Nest.Definition = {
    'type': 'Nest',
    'metadata': {
      'treesource': true,
      'changes': true
    },
    'params': [{
      'name': 'keys',
      'type': 'field',
      'array': true
    }, {
      'name': 'generate',
      'type': 'boolean'
    }]
  };

  const children$1 = n => n.values;

  inherits(Nest, Transform, {
    transform(_, pulse) {
      if (!pulse.source) {
        error('Nest transform requires an upstream data source.');
      }

      var gen = _.generate,
          mod = _.modified(),
          out = pulse.clone(),
          tree = this.value;

      if (!tree || mod || pulse.changed()) {
        // collect nodes to remove
        if (tree) {
          tree.each(node => {
            if (node.children && isTuple(node.data)) {
              out.rem.push(node.data);
            }
          });
        } // generate new tree structure


        this.value = tree = hierarchy({
          values: array$5(_.keys).reduce((n, k) => {
            n.key(k);
            return n;
          }, nest()).entries(out.source)
        }, children$1); // collect nodes to add

        if (gen) {
          tree.each(node => {
            if (node.children) {
              node = ingest$1(node.data);
              out.add.push(node);
              out.source.push(node);
            }
          });
        } // build lookup table


        lookup$2(tree, tupleid, tupleid);
      }

      out.source.root = tree;
      return out;
    }

  });

  function nest() {
    const keys = [],
          nest = {
      entries: array => entries(apply(array, 0), 0),
      key: d => (keys.push(d), nest)
    };

    function apply(array, depth) {
      if (depth >= keys.length) {
        return array;
      }

      const n = array.length,
            key = keys[depth++],
            valuesByKey = {},
            result = {};
      let i = -1,
          keyValue,
          value,
          values;

      while (++i < n) {
        keyValue = key(value = array[i]) + '';

        if (values = valuesByKey[keyValue]) {
          values.push(value);
        } else {
          valuesByKey[keyValue] = [value];
        }
      }

      for (keyValue in valuesByKey) {
        result[keyValue] = apply(valuesByKey[keyValue], depth);
      }

      return result;
    }

    function entries(map, depth) {
      if (++depth > keys.length) return map;
      const array = [];

      for (const key in map) {
        array.push({
          key,
          values: entries(map[key], depth)
        });
      }

      return array;
    }

    return nest;
  }
  /**
   * Abstract class for tree layout.
   * @constructor
   * @param {object} params - The parameters for this operator.
   */


  function HierarchyLayout(params) {
    Transform.call(this, null, params);
  }

  const defaultSeparation = (a, b) => a.parent === b.parent ? 1 : 2;

  inherits(HierarchyLayout, Transform, {
    transform(_, pulse) {
      if (!pulse.source || !pulse.source.root) {
        error(this.constructor.name + ' transform requires a backing tree data source.');
      }

      const layout = this.layout(_.method),
            fields = this.fields,
            root = pulse.source.root,
            as = _.as || fields;
      if (_.field) root.sum(_.field);else root.count();
      if (_.sort) root.sort(stableCompare(_.sort, d => d.data));
      setParams(layout, this.params, _);

      if (layout.separation) {
        layout.separation(_.separation !== false ? defaultSeparation : one$2);
      }

      try {
        this.value = layout(root);
      } catch (err) {
        error(err);
      }

      root.each(node => setFields(node, fields, as));
      return pulse.reflow(_.modified()).modifies(as).modifies('leaf');
    }

  });

  function setParams(layout, params, _) {
    for (let p, i = 0, n = params.length; i < n; ++i) {
      p = params[i];
      if (p in _) layout[p](_[p]);
    }
  }

  function setFields(node, fields, as) {
    const t = node.data,
          n = fields.length - 1;

    for (let i = 0; i < n; ++i) {
      t[as[i]] = node[fields[i]];
    }

    t[as[n]] = node.children ? node.children.length : 0;
  }

  const Output$3 = ['x', 'y', 'r', 'depth', 'children'];
  /**
   * Packed circle tree layout.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The value field to size nodes.
   */

  function Pack(params) {
    HierarchyLayout.call(this, params);
  }

  Pack.Definition = {
    'type': 'Pack',
    'metadata': {
      'tree': true,
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'sort',
      'type': 'compare'
    }, {
      'name': 'padding',
      'type': 'number',
      'default': 0
    }, {
      'name': 'radius',
      'type': 'field',
      'default': null
    }, {
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': Output$3.length,
      'default': Output$3
    }]
  };
  inherits(Pack, HierarchyLayout, {
    layout: pack,
    params: ['radius', 'size', 'padding'],
    fields: Output$3
  });
  const Output$2 = ['x0', 'y0', 'x1', 'y1', 'depth', 'children'];
  /**
   * Partition tree layout.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The value field to size nodes.
   */

  function Partition(params) {
    HierarchyLayout.call(this, params);
  }

  Partition.Definition = {
    'type': 'Partition',
    'metadata': {
      'tree': true,
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'sort',
      'type': 'compare'
    }, {
      'name': 'padding',
      'type': 'number',
      'default': 0
    }, {
      'name': 'round',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': Output$2.length,
      'default': Output$2
    }]
  };
  inherits(Partition, HierarchyLayout, {
    layout: partition$1,
    params: ['size', 'round', 'padding'],
    fields: Output$2
  });
  /**
   * Stratify a collection of tuples into a tree structure based on
   * id and parent id fields.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.key - Unique key field for each tuple.
   * @param {function(object): *} params.parentKey - Field with key for parent tuple.
   */

  function Stratify(params) {
    Transform.call(this, null, params);
  }

  Stratify.Definition = {
    'type': 'Stratify',
    'metadata': {
      'treesource': true
    },
    'params': [{
      'name': 'key',
      'type': 'field',
      'required': true
    }, {
      'name': 'parentKey',
      'type': 'field',
      'required': true
    }]
  };
  inherits(Stratify, Transform, {
    transform(_, pulse) {
      if (!pulse.source) {
        error('Stratify transform requires an upstream data source.');
      }

      let tree = this.value;

      const mod = _.modified(),
            out = pulse.fork(pulse.ALL).materialize(pulse.SOURCE),
            run = !tree || mod || pulse.changed(pulse.ADD_REM) || pulse.modified(_.key.fields) || pulse.modified(_.parentKey.fields); // prevent upstream source pollution


      out.source = out.source.slice();

      if (run) {
        tree = out.source.length ? lookup$2(stratify().id(_.key).parentId(_.parentKey)(out.source), _.key, truthy) : lookup$2(stratify()([{}]), _.key, _.key);
      }

      out.source.root = this.value = tree;
      return out;
    }

  });
  const Layouts = {
    tidy: tree$1,
    cluster: cluster
  };
  const Output$1$1 = ['x', 'y', 'depth', 'children'];
  /**
   * Tree layout. Depending on the method parameter, performs either
   * Reingold-Tilford 'tidy' layout or dendrogram 'cluster' layout.
   * @constructor
   * @param {object} params - The parameters for this operator.
   */

  function Tree(params) {
    HierarchyLayout.call(this, params);
  }

  Tree.Definition = {
    'type': 'Tree',
    'metadata': {
      'tree': true,
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'sort',
      'type': 'compare'
    }, {
      'name': 'method',
      'type': 'enum',
      'default': 'tidy',
      'values': ['tidy', 'cluster']
    }, {
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'nodeSize',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'separation',
      'type': 'boolean',
      'default': true
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': Output$1$1.length,
      'default': Output$1$1
    }]
  };
  inherits(Tree, HierarchyLayout, {
    /**
     * Tree layout generator. Supports both 'tidy' and 'cluster' layouts.
     */
    layout(method) {
      const m = method || 'tidy';
      if (has$1(Layouts, m)) return Layouts[m]();else error('Unrecognized Tree layout method: ' + m);
    },

    params: ['size', 'nodeSize'],
    fields: Output$1$1
  });
  /**
   * Generate tuples representing links between tree nodes.
   * The resulting tuples will contain 'source' and 'target' fields,
   * which point to parent and child node tuples, respectively.
   * @constructor
   * @param {object} params - The parameters for this operator.
   */

  function TreeLinks(params) {
    Transform.call(this, [], params);
  }

  TreeLinks.Definition = {
    'type': 'TreeLinks',
    'metadata': {
      'tree': true,
      'generates': true,
      'changes': true
    },
    'params': []
  };
  inherits(TreeLinks, Transform, {
    transform(_, pulse) {
      const links = this.value,
            tree = pulse.source && pulse.source.root,
            out = pulse.fork(pulse.NO_SOURCE),
            lut = {};
      if (!tree) error('TreeLinks transform requires a tree data source.');

      if (pulse.changed(pulse.ADD_REM)) {
        // remove previous links
        out.rem = links; // build lookup table of valid tuples

        pulse.visit(pulse.SOURCE, t => lut[tupleid(t)] = 1); // generate links for all edges incident on valid tuples

        tree.each(node => {
          const t = node.data,
                p = node.parent && node.parent.data;

          if (p && lut[tupleid(t)] && lut[tupleid(p)]) {
            out.add.push(ingest$1({
              source: p,
              target: t
            }));
          }
        });
        this.value = out.add;
      } else if (pulse.changed(pulse.MOD)) {
        // build lookup table of modified tuples
        pulse.visit(pulse.MOD, t => lut[tupleid(t)] = 1); // gather links incident on modified tuples

        links.forEach(link => {
          if (lut[tupleid(link.source)] || lut[tupleid(link.target)]) {
            out.mod.push(link);
          }
        });
      }

      return out;
    }

  });
  const Tiles = {
    binary: treemapBinary,
    dice: treemapDice,
    slice: treemapSlice,
    slicedice: treemapSliceDice,
    squarify: treemapSquarify,
    resquarify: treemapResquarify
  };
  const Output$4 = ['x0', 'y0', 'x1', 'y1', 'depth', 'children'];
  /**
   * Treemap layout.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.field - The value field to size nodes.
   */

  function Treemap(params) {
    HierarchyLayout.call(this, params);
  }

  Treemap.Definition = {
    'type': 'Treemap',
    'metadata': {
      'tree': true,
      'modifies': true
    },
    'params': [{
      'name': 'field',
      'type': 'field'
    }, {
      'name': 'sort',
      'type': 'compare'
    }, {
      'name': 'method',
      'type': 'enum',
      'default': 'squarify',
      'values': ['squarify', 'resquarify', 'binary', 'dice', 'slice', 'slicedice']
    }, {
      'name': 'padding',
      'type': 'number',
      'default': 0
    }, {
      'name': 'paddingInner',
      'type': 'number',
      'default': 0
    }, {
      'name': 'paddingOuter',
      'type': 'number',
      'default': 0
    }, {
      'name': 'paddingTop',
      'type': 'number',
      'default': 0
    }, {
      'name': 'paddingRight',
      'type': 'number',
      'default': 0
    }, {
      'name': 'paddingBottom',
      'type': 'number',
      'default': 0
    }, {
      'name': 'paddingLeft',
      'type': 'number',
      'default': 0
    }, {
      'name': 'ratio',
      'type': 'number',
      'default': 1.618033988749895
    }, {
      'name': 'round',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': Output$4.length,
      'default': Output$4
    }]
  };
  inherits(Treemap, HierarchyLayout, {
    /**
     * Treemap layout generator. Adds 'method' and 'ratio' parameters
     * to configure the underlying tile method.
     */
    layout() {
      const x = treemap();

      x.ratio = _ => {
        const t = x.tile();
        if (t.ratio) x.tile(t.ratio(_));
      };

      x.method = _ => {
        if (has$1(Tiles, _)) x.tile(Tiles[_]);else error('Unrecognized Treemap layout method: ' + _);
      };

      return x;
    },

    params: ['method', 'ratio', 'size', 'round', 'padding', 'paddingInner', 'paddingOuter', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
    fields: Output$4
  });

  var tree = /*#__PURE__*/Object.freeze({
    __proto__: null,
    nest: Nest,
    pack: Pack,
    partition: Partition,
    stratify: Stratify,
    tree: Tree,
    treelinks: TreeLinks,
    treemap: Treemap
  });

  const ALPHA_MASK = 0xff000000; // alpha value equivalent to opacity 0.0625

  const INSIDE_OPACITY_IN_ALPHA = 0x10000000;
  const INSIDE_OPACITY = 0.0625;

  function baseBitmaps($, data) {
    const bitmap = $.bitmap(); // when there is no base mark but data points are to be avoided

    (data || []).forEach(d => bitmap.set($(d.boundary[0]), $(d.boundary[3])));
    return [bitmap, undefined];
  }

  function markBitmaps($, avoidMarks, labelInside, isGroupArea) {
    // create canvas
    const width = $.width,
          height = $.height,
          border = labelInside || isGroupArea,
          context = canvas(width, height).getContext('2d'); // render all marks to be avoided into canvas

    avoidMarks.forEach(items => draw(context, items, border)); // get canvas buffer, create bitmaps

    const buffer = new Uint32Array(context.getImageData(0, 0, width, height).data.buffer),
          layer1 = $.bitmap(),
          layer2 = border && $.bitmap(); // populate bitmap layers

    let x, y, u, v, alpha;

    for (y = 0; y < height; ++y) {
      for (x = 0; x < width; ++x) {
        alpha = buffer[y * width + x] & ALPHA_MASK;

        if (alpha) {
          u = $(x);
          v = $(y);
          if (!isGroupArea) layer1.set(u, v); // update interior bitmap

          if (border && alpha ^ INSIDE_OPACITY_IN_ALPHA) layer2.set(u, v); // update border bitmap
        }
      }
    }

    return [layer1, layer2];
  }

  function draw(context, items, interior) {
    if (!items.length) return;
    const type = items[0].mark.marktype;

    if (type === 'group') {
      items.forEach(group => {
        group.items.forEach(mark => draw(context, mark.items, interior));
      });
    } else {
      Marks[type].draw(context, {
        items: interior ? items.map(prepare) : items
      });
    }
  }
  /**
   * Prepare item before drawing into canvas (setting stroke and opacity)
   * @param {object} source item to be prepared
   * @returns prepared item
   */


  function prepare(source) {
    const item = rederive(source, {});

    if (item.stroke) {
      item.strokeOpacity = 1;
    }

    if (item.fill) {
      item.fillOpacity = INSIDE_OPACITY;
      item.stroke = '#000';
      item.strokeOpacity = 1;
      item.strokeWidth = 2;
    }

    return item;
  }

  const DIV = 5,
        // bit shift from x, y index to bit vector array index
  MOD = 31,
        // bit mask for index lookup within a bit vector
  SIZE = 32,
        // individual bit vector size
  RIGHT0 = new Uint32Array(SIZE + 1),
        // left-anchored bit vectors, full -> 0
  RIGHT1 = new Uint32Array(SIZE + 1); // right-anchored bit vectors, 0 -> full

  RIGHT1[0] = 0;
  RIGHT0[0] = ~RIGHT1[0];

  for (let i = 1; i <= SIZE; ++i) {
    RIGHT1[i] = RIGHT1[i - 1] << 1 | 1;
    RIGHT0[i] = ~RIGHT1[i];
  }

  function Bitmap(w, h) {
    const array = new Uint32Array(~~((w * h + SIZE) / SIZE));

    function _set(index, mask) {
      array[index] |= mask;
    }

    function _clear(index, mask) {
      array[index] &= mask;
    }

    return {
      array: array,
      get: (x, y) => {
        const index = y * w + x;
        return array[index >>> DIV] & 1 << (index & MOD);
      },
      set: (x, y) => {
        const index = y * w + x;

        _set(index >>> DIV, 1 << (index & MOD));
      },
      clear: (x, y) => {
        const index = y * w + x;

        _clear(index >>> DIV, ~(1 << (index & MOD)));
      },
      getRange: (x, y, x2, y2) => {
        let r = y2,
            start,
            end,
            indexStart,
            indexEnd;

        for (; r >= y; --r) {
          start = r * w + x;
          end = r * w + x2;
          indexStart = start >>> DIV;
          indexEnd = end >>> DIV;

          if (indexStart === indexEnd) {
            if (array[indexStart] & RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]) {
              return true;
            }
          } else {
            if (array[indexStart] & RIGHT0[start & MOD]) return true;
            if (array[indexEnd] & RIGHT1[(end & MOD) + 1]) return true;

            for (let i = indexStart + 1; i < indexEnd; ++i) {
              if (array[i]) return true;
            }
          }
        }

        return false;
      },
      setRange: (x, y, x2, y2) => {
        let start, end, indexStart, indexEnd, i;

        for (; y <= y2; ++y) {
          start = y * w + x;
          end = y * w + x2;
          indexStart = start >>> DIV;
          indexEnd = end >>> DIV;

          if (indexStart === indexEnd) {
            _set(indexStart, RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]);
          } else {
            _set(indexStart, RIGHT0[start & MOD]);

            _set(indexEnd, RIGHT1[(end & MOD) + 1]);

            for (i = indexStart + 1; i < indexEnd; ++i) _set(i, 0xffffffff);
          }
        }
      },
      clearRange: (x, y, x2, y2) => {
        let start, end, indexStart, indexEnd, i;

        for (; y <= y2; ++y) {
          start = y * w + x;
          end = y * w + x2;
          indexStart = start >>> DIV;
          indexEnd = end >>> DIV;

          if (indexStart === indexEnd) {
            _clear(indexStart, RIGHT1[start & MOD] | RIGHT0[(end & MOD) + 1]);
          } else {
            _clear(indexStart, RIGHT1[start & MOD]);

            _clear(indexEnd, RIGHT0[(end & MOD) + 1]);

            for (i = indexStart + 1; i < indexEnd; ++i) _clear(i, 0);
          }
        }
      },
      outOfBounds: (x, y, x2, y2) => x < 0 || y < 0 || y2 >= h || x2 >= w
    };
  }

  function scaler(width, height, padding) {
    const ratio = Math.max(1, Math.sqrt(width * height / 1e6)),
          w = ~~((width + 2 * padding + ratio) / ratio),
          h = ~~((height + 2 * padding + ratio) / ratio),
          scale = _ => ~~((_ + padding) / ratio);

    scale.invert = _ => _ * ratio - padding;

    scale.bitmap = () => Bitmap(w, h);

    scale.ratio = ratio;
    scale.padding = padding;
    scale.width = width;
    scale.height = height;
    return scale;
  }

  function placeAreaLabelNaive($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width,
          height = $.height; // try to place a label within an input area mark

    return function (d) {
      const items = d.datum.datum.items[markIndex].items,
            // area points
      n = items.length,
            // number of points
      textHeight = d.datum.fontSize,
            // label width
      textWidth = textMetrics.width(d.datum, d.datum.text); // label height

      let maxAreaWidth = 0,
          x1,
          x2,
          y1,
          y2,
          x,
          y,
          areaWidth; // for each area sample point

      for (let i = 0; i < n; ++i) {
        x1 = items[i].x;
        y1 = items[i].y;
        x2 = items[i].x2 === undefined ? x1 : items[i].x2;
        y2 = items[i].y2 === undefined ? y1 : items[i].y2;
        x = (x1 + x2) / 2;
        y = (y1 + y2) / 2;
        areaWidth = Math.abs(x2 - x1 + y2 - y1);

        if (areaWidth >= maxAreaWidth) {
          maxAreaWidth = areaWidth;
          d.x = x;
          d.y = y;
        }
      }

      x = textWidth / 2;
      y = textHeight / 2;
      x1 = d.x - x;
      x2 = d.x + x;
      y1 = d.y - y;
      y2 = d.y + y;
      d.align = 'center';

      if (x1 < 0 && x2 <= width) {
        d.align = 'left';
      } else if (0 <= x1 && width < x2) {
        d.align = 'right';
      }

      d.baseline = 'middle';

      if (y1 < 0 && y2 <= height) {
        d.baseline = 'top';
      } else if (0 <= y1 && height < y2) {
        d.baseline = 'bottom';
      }

      return true;
    };
  }

  function outOfBounds(x, y, textWidth, textHeight, width, height) {
    let r = textWidth / 2;
    return x - r < 0 || x + r > width || y - (r = textHeight / 2) < 0 || y + r > height;
  }

  function collision($, x, y, textHeight, textWidth, h, bm0, bm1) {
    const w = textWidth * h / (textHeight * 2),
          x1 = $(x - w),
          x2 = $(x + w),
          y1 = $(y - (h = h / 2)),
          y2 = $(y + h);
    return bm0.outOfBounds(x1, y1, x2, y2) || bm0.getRange(x1, y1, x2, y2) || bm1 && bm1.getRange(x1, y1, x2, y2);
  }

  function placeAreaLabelReducedSearch($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width,
          height = $.height,
          bm0 = bitmaps[0],
          // where labels have been placed
    bm1 = bitmaps[1]; // area outlines

    function tryLabel(_x, _y, maxSize, textWidth, textHeight) {
      const x = $.invert(_x),
            y = $.invert(_y);
      let lo = maxSize,
          hi = height,
          mid;

      if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
        // if the label fits at the current sample point,
        // perform binary search to find the largest font size that fits
        while (hi - lo >= 1) {
          mid = (lo + hi) / 2;

          if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) {
            hi = mid;
          } else {
            lo = mid;
          }
        } // place label if current lower bound exceeds prior max font size


        if (lo > maxSize) {
          return [x, y, lo, true];
        }
      }
    } // try to place a label within an input area mark


    return function (d) {
      const items = d.datum.datum.items[markIndex].items,
            // area points
      n = items.length,
            // number of points
      textHeight = d.datum.fontSize,
            // label width
      textWidth = textMetrics.width(d.datum, d.datum.text); // label height

      let maxSize = avoidBaseMark ? textHeight : 0,
          labelPlaced = false,
          labelPlaced2 = false,
          maxAreaWidth = 0,
          x1,
          x2,
          y1,
          y2,
          x,
          y,
          _x,
          _y,
          _x1,
          _xMid,
          _x2,
          _y1,
          _yMid,
          _y2,
          areaWidth,
          result,
          swapTmp; // for each area sample point


      for (let i = 0; i < n; ++i) {
        x1 = items[i].x;
        y1 = items[i].y;
        x2 = items[i].x2 === undefined ? x1 : items[i].x2;
        y2 = items[i].y2 === undefined ? y1 : items[i].y2;

        if (x1 > x2) {
          swapTmp = x1;
          x1 = x2;
          x2 = swapTmp;
        }

        if (y1 > y2) {
          swapTmp = y1;
          y1 = y2;
          y2 = swapTmp;
        }

        _x1 = $(x1);
        _x2 = $(x2);
        _xMid = ~~((_x1 + _x2) / 2);
        _y1 = $(y1);
        _y2 = $(y2);
        _yMid = ~~((_y1 + _y2) / 2); // search along the line from mid point between the 2 border to lower border

        for (_x = _xMid; _x >= _x1; --_x) {
          for (_y = _yMid; _y >= _y1; --_y) {
            result = tryLabel(_x, _y, maxSize, textWidth, textHeight);

            if (result) {
              [d.x, d.y, maxSize, labelPlaced] = result;
            }
          }
        } // search along the line from mid point between the 2 border to upper border


        for (_x = _xMid; _x <= _x2; ++_x) {
          for (_y = _yMid; _y <= _y2; ++_y) {
            result = tryLabel(_x, _y, maxSize, textWidth, textHeight);

            if (result) {
              [d.x, d.y, maxSize, labelPlaced] = result;
            }
          }
        } // place label at slice center if not placed through other means
        // and if we're not avoiding overlap with other areas


        if (!labelPlaced && !avoidBaseMark) {
          // one span is zero, hence we can add
          areaWidth = Math.abs(x2 - x1 + y2 - y1);
          x = (x1 + x2) / 2;
          y = (y1 + y2) / 2; // place label if it fits and improves the max area width

          if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
            maxAreaWidth = areaWidth;
            d.x = x;
            d.y = y;
            labelPlaced2 = true;
          }
        }
      } // record current label placement information, update label bitmap


      if (labelPlaced || labelPlaced2) {
        x = textWidth / 2;
        y = textHeight / 2;
        bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
        d.align = 'center';
        d.baseline = 'middle';
        return true;
      } else {
        return false;
      }
    };
  }

  const X_DIR = [-1, -1, 1, 1];
  const Y_DIR = [-1, 1, -1, 1];

  function placeAreaLabelFloodFill($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width,
          height = $.height,
          bm0 = bitmaps[0],
          // where labels have been placed
    bm1 = bitmaps[1],
          // area outlines
    bm2 = $.bitmap(); // flood-fill visitations
    // try to place a label within an input area mark

    return function (d) {
      const items = d.datum.datum.items[markIndex].items,
            // area points
      n = items.length,
            // number of points
      textHeight = d.datum.fontSize,
            // label width
      textWidth = textMetrics.width(d.datum, d.datum.text),
            // label height
      stack = []; // flood fill stack

      let maxSize = avoidBaseMark ? textHeight : 0,
          labelPlaced = false,
          labelPlaced2 = false,
          maxAreaWidth = 0,
          x1,
          x2,
          y1,
          y2,
          x,
          y,
          _x,
          _y,
          lo,
          hi,
          mid,
          areaWidth; // for each area sample point


      for (let i = 0; i < n; ++i) {
        x1 = items[i].x;
        y1 = items[i].y;
        x2 = items[i].x2 === undefined ? x1 : items[i].x2;
        y2 = items[i].y2 === undefined ? y1 : items[i].y2; // add scaled center point to stack

        stack.push([$((x1 + x2) / 2), $((y1 + y2) / 2)]); // perform flood fill, visit points

        while (stack.length) {
          [_x, _y] = stack.pop(); // exit if point already marked

          if (bm0.get(_x, _y) || bm1.get(_x, _y) || bm2.get(_x, _y)) continue; // mark point in flood fill bitmap
          // add search points for all (in bound) directions

          bm2.set(_x, _y);

          for (let j = 0; j < 4; ++j) {
            x = _x + X_DIR[j];
            y = _y + Y_DIR[j];
            if (!bm2.outOfBounds(x, y, x, y)) stack.push([x, y]);
          } // unscale point back to x, y space


          x = $.invert(_x);
          y = $.invert(_y);
          lo = maxSize;
          hi = height; // TODO: make this bound smaller

          if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
            // if the label fits at the current sample point,
            // perform binary search to find the largest font size that fits
            while (hi - lo >= 1) {
              mid = (lo + hi) / 2;

              if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) {
                hi = mid;
              } else {
                lo = mid;
              }
            } // place label if current lower bound exceeds prior max font size


            if (lo > maxSize) {
              d.x = x;
              d.y = y;
              maxSize = lo;
              labelPlaced = true;
            }
          }
        } // place label at slice center if not placed through other means
        // and if we're not avoiding overlap with other areas


        if (!labelPlaced && !avoidBaseMark) {
          // one span is zero, hence we can add
          areaWidth = Math.abs(x2 - x1 + y2 - y1);
          x = (x1 + x2) / 2;
          y = (y1 + y2) / 2; // place label if it fits and improves the max area width

          if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
            maxAreaWidth = areaWidth;
            d.x = x;
            d.y = y;
            labelPlaced2 = true;
          }
        }
      } // record current label placement information, update label bitmap


      if (labelPlaced || labelPlaced2) {
        x = textWidth / 2;
        y = textHeight / 2;
        bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
        d.align = 'center';
        d.baseline = 'middle';
        return true;
      } else {
        return false;
      }
    };
  }

  const Aligns = ['right', 'center', 'left'],
        Baselines = ['bottom', 'middle', 'top'];

  function placeMarkLabel($, bitmaps, anchors, offsets) {
    const width = $.width,
          height = $.height,
          bm0 = bitmaps[0],
          bm1 = bitmaps[1],
          n = offsets.length;
    return function (d) {
      const boundary = d.boundary,
            textHeight = d.datum.fontSize; // can not be placed if the mark is not visible in the graph bound

      if (boundary[2] < 0 || boundary[5] < 0 || boundary[0] > width || boundary[3] > height) {
        return false;
      }

      let textWidth = 0,
          dx,
          dy,
          isInside,
          sizeFactor,
          insideFactor,
          x1,
          x2,
          y1,
          y2,
          xc,
          yc,
          _x1,
          _x2,
          _y1,
          _y2; // for each anchor and offset


      for (let i = 0; i < n; ++i) {
        dx = (anchors[i] & 0x3) - 1;
        dy = (anchors[i] >>> 0x2 & 0x3) - 1;
        isInside = dx === 0 && dy === 0 || offsets[i] < 0;
        sizeFactor = dx && dy ? Math.SQRT1_2 : 1;
        insideFactor = offsets[i] < 0 ? -1 : 1;
        x1 = boundary[1 + dx] + offsets[i] * dx * sizeFactor;
        yc = boundary[4 + dy] + insideFactor * textHeight * dy / 2 + offsets[i] * dy * sizeFactor;
        y1 = yc - textHeight / 2;
        y2 = yc + textHeight / 2;
        _x1 = $(x1);
        _y1 = $(y1);
        _y2 = $(y2);

        if (!textWidth) {
          // to avoid finding width of text label,
          if (!test(_x1, _x1, _y1, _y2, bm0, bm1, x1, x1, y1, y2, boundary, isInside)) {
            // skip this anchor/offset option if we fail to place a label with 1px width
            continue;
          } else {
            // Otherwise, find the label width
            textWidth = textMetrics.width(d.datum, d.datum.text);
          }
        }

        xc = x1 + insideFactor * textWidth * dx / 2;
        x1 = xc - textWidth / 2;
        x2 = xc + textWidth / 2;
        _x1 = $(x1);
        _x2 = $(x2);

        if (test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside)) {
          // place label if the position is placeable
          d.x = !dx ? xc : dx * insideFactor < 0 ? x2 : x1;
          d.y = !dy ? yc : dy * insideFactor < 0 ? y2 : y1;
          d.align = Aligns[dx * insideFactor + 1];
          d.baseline = Baselines[dy * insideFactor + 1];
          bm0.setRange(_x1, _y1, _x2, _y2);
          return true;
        }
      }

      return false;
    };
  } // Test if a label with the given dimensions can be added without overlap


  function test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside) {
    return !(bm0.outOfBounds(_x1, _y1, _x2, _y2) || (isInside && bm1 ? bm1.getRange(_x1, _y1, _x2, _y2) || !isInMarkBound(x1, y1, x2, y2, boundary) : bm0.getRange(_x1, _y1, _x2, _y2)));
  }

  function isInMarkBound(x1, y1, x2, y2, boundary) {
    return boundary[0] <= x1 && x2 <= boundary[2] && boundary[3] <= y1 && y2 <= boundary[5];
  }

  const TOP = 0x0,
        MIDDLE = 0x4,
        BOTTOM = 0x8,
        LEFT = 0x0,
        CENTER = 0x1,
        RIGHT = 0x2; // Mapping from text anchor to number representation

  const anchorCode = {
    'top-left': TOP + LEFT,
    'top': TOP + CENTER,
    'top-right': TOP + RIGHT,
    'left': MIDDLE + LEFT,
    'middle': MIDDLE + CENTER,
    'right': MIDDLE + RIGHT,
    'bottom-left': BOTTOM + LEFT,
    'bottom': BOTTOM + CENTER,
    'bottom-right': BOTTOM + RIGHT
  };
  const placeAreaLabel = {
    'naive': placeAreaLabelNaive,
    'reduced-search': placeAreaLabelReducedSearch,
    'floodfill': placeAreaLabelFloodFill
  };

  function labelLayout(texts, size, compare, offset, anchor, avoidMarks, avoidBaseMark, lineAnchor, markIndex, padding, method) {
    // early exit for empty data
    if (!texts.length) return texts;
    const positions = Math.max(offset.length, anchor.length),
          offsets = getOffsets(offset, positions),
          anchors = getAnchors(anchor, positions),
          marktype = markType(texts[0].datum),
          grouptype = marktype === 'group' && texts[0].datum.items[markIndex].marktype,
          isGroupArea = grouptype === 'area',
          boundary = markBoundary(marktype, grouptype, lineAnchor, markIndex),
          $ = scaler(size[0], size[1], padding),
          isNaiveGroupArea = isGroupArea && method === 'naive'; // prepare text mark data for placing

    const data = texts.map(d => ({
      datum: d,
      opacity: 0,
      x: undefined,
      y: undefined,
      align: undefined,
      baseline: undefined,
      boundary: boundary(d)
    }));
    let bitmaps;

    if (!isNaiveGroupArea) {
      // sort labels in priority order, if comparator is provided
      if (compare) {
        data.sort((a, b) => compare(a.datum, b.datum));
      } // flag indicating if label can be placed inside its base mark


      let labelInside = false;

      for (let i = 0; i < anchors.length && !labelInside; ++i) {
        // label inside if anchor is at center
        // label inside if offset to be inside the mark bound
        labelInside = anchors[i] === 0x5 || offsets[i] < 0;
      } // extract data information from base mark when base mark is to be avoided
      // base mark is implicitly avoided if it is a group area


      if (marktype && (avoidBaseMark || isGroupArea)) {
        avoidMarks = [texts.map(d => d.datum)].concat(avoidMarks);
      } // generate bitmaps for layout calculation


      bitmaps = avoidMarks.length ? markBitmaps($, avoidMarks, labelInside, isGroupArea) : baseBitmaps($, avoidBaseMark && data);
    } // generate label placement function


    const place = isGroupArea ? placeAreaLabel[method]($, bitmaps, avoidBaseMark, markIndex) : placeMarkLabel($, bitmaps, anchors, offsets); // place all labels

    data.forEach(d => d.opacity = +place(d));
    return data;
  }

  function getOffsets(_, count) {
    const offsets = new Float64Array(count),
          n = _.length;

    for (let i = 0; i < n; ++i) offsets[i] = _[i] || 0;

    for (let i = n; i < count; ++i) offsets[i] = offsets[n - 1];

    return offsets;
  }

  function getAnchors(_, count) {
    const anchors = new Int8Array(count),
          n = _.length;

    for (let i = 0; i < n; ++i) anchors[i] |= anchorCode[_[i]];

    for (let i = n; i < count; ++i) anchors[i] = anchors[n - 1];

    return anchors;
  }

  function markType(item) {
    return item && item.mark && item.mark.marktype;
  }
  /**
   * Factory function for function for getting base mark boundary, depending
   * on mark and group type. When mark type is undefined, line or area: boundary
   * is the coordinate of each data point. When base mark is grouped line,
   * boundary is either at the beginning or end of the line depending on the
   * value of lineAnchor. Otherwise, use bounds of base mark.
   */


  function markBoundary(marktype, grouptype, lineAnchor, markIndex) {
    const xy = d => [d.x, d.x, d.x, d.y, d.y, d.y];

    if (!marktype) {
      return xy; // no reactive geometry
    } else if (marktype === 'line' || marktype === 'area') {
      return d => xy(d.datum);
    } else if (grouptype === 'line') {
      return d => {
        const items = d.datum.items[markIndex].items;
        return xy(items.length ? items[lineAnchor === 'start' ? 0 : items.length - 1] : {
          x: NaN,
          y: NaN
        });
      };
    } else {
      return d => {
        const b = d.datum.bounds;
        return [b.x1, (b.x1 + b.x2) / 2, b.x2, b.y1, (b.y1 + b.y2) / 2, b.y2];
      };
    }
  }

  const Output$1 = ['x', 'y', 'opacity', 'align', 'baseline'];
  const Anchors = ['top-left', 'left', 'bottom-left', 'top', 'bottom', 'top-right', 'right', 'bottom-right'];
  /**
   * Compute text label layout to annotate marks.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<number>} params.size - The size of the layout, provided as a [width, height] array.
   * @param {function(*,*): number} [params.sort] - An optional
   *   comparator function for sorting label data in priority order.
   * @param {Array<string>} [params.anchor] - Label anchor points relative to the base mark bounding box.
   *   The available options are 'top-left', 'left', 'bottom-left', 'top',
   *   'bottom', 'top-right', 'right', 'bottom-right', 'middle'.
   * @param {Array<number>} [params.offset] - Label offsets (in pixels) from the base mark bounding box.
   *   This parameter  is parallel to the list of anchor points.
   * @param {number} [params.padding=0] - The amount (in pixels) that a label may exceed the layout size.
   * @param {string} [params.lineAnchor='end'] - For group line mark labels only, indicates the anchor
   *   position for labels. One of 'start' or 'end'.
   * @param {string} [params.markIndex=0] - For group mark labels only, an index indicating
   *   which mark within the group should be labeled.
   * @param {Array<number>} [params.avoidMarks] - A list of additional mark names for which the label
   *   layout should avoid overlap.
   * @param {boolean} [params.avoidBaseMark=true] - Boolean flag indicating if labels should avoid
   *   overlap with the underlying base mark being labeled.
   * @param {string} [params.method='naive'] - For area make labels only, a method for
   *   place labels. One of 'naive', 'reduced-search', or 'floodfill'.
   * @param {Array<string>} [params.as] - The output fields written by the transform.
   *   The default is ['x', 'y', 'opacity', 'align', 'baseline'].
   */

  function Label$1(params) {
    Transform.call(this, null, params);
  }

  Label$1.Definition = {
    type: 'Label',
    metadata: {
      modifies: true
    },
    params: [{
      name: 'size',
      type: 'number',
      array: true,
      length: 2,
      required: true
    }, {
      name: 'sort',
      type: 'compare'
    }, {
      name: 'anchor',
      type: 'string',
      array: true,
      default: Anchors
    }, {
      name: 'offset',
      type: 'number',
      array: true,
      default: [1]
    }, {
      name: 'padding',
      type: 'number',
      default: 0
    }, {
      name: 'lineAnchor',
      type: 'string',
      values: ['start', 'end'],
      default: 'end'
    }, {
      name: 'markIndex',
      type: 'number',
      default: 0
    }, {
      name: 'avoidBaseMark',
      type: 'boolean',
      default: true
    }, {
      name: 'avoidMarks',
      type: 'data',
      array: true
    }, {
      name: 'method',
      type: 'string',
      default: 'naive'
    }, {
      name: 'as',
      type: 'string',
      array: true,
      length: Output$1.length,
      default: Output$1
    }]
  };
  inherits(Label$1, Transform, {
    transform(_, pulse) {
      function modp(param) {
        const p = _[param];
        return isFunction(p) && pulse.modified(p.fields);
      }

      const mod = _.modified();

      if (!(mod || pulse.changed(pulse.ADD_REM) || modp('sort'))) return;

      if (!_.size || _.size.length !== 2) {
        error('Size parameter should be specified as a [width, height] array.');
      }

      const as = _.as || Output$1; // run label layout

      labelLayout(pulse.materialize(pulse.SOURCE).source || [], _.size, _.sort, array$5(_.offset == null ? 1 : _.offset), array$5(_.anchor || Anchors), _.avoidMarks || [], _.avoidBaseMark !== false, _.lineAnchor || 'end', _.markIndex || 0, _.padding || 0, _.method || 'naive').forEach(l => {
        // write layout results to data stream
        const t = l.datum;
        t[as[0]] = l.x;
        t[as[1]] = l.y;
        t[as[2]] = l.opacity;
        t[as[3]] = l.align;
        t[as[4]] = l.baseline;
      });
      return pulse.reflow(mod).modifies(as);
    }

  });

  var label = /*#__PURE__*/Object.freeze({
    __proto__: null,
    label: Label$1
  });

  function partition(data, groupby) {
    var groups = [],
        get = function (f) {
      return f(t);
    },
        map,
        i,
        n,
        t,
        k,
        g; // partition data points into stack groups


    if (groupby == null) {
      groups.push(data);
    } else {
      for (map = {}, i = 0, n = data.length; i < n; ++i) {
        t = data[i];
        k = groupby.map(get);
        g = map[k];

        if (!g) {
          map[k] = g = [];
          g.dims = k;
          groups.push(g);
        }

        g.push(t);
      }
    }

    return groups;
  }
  /**
   * Compute locally-weighted regression fits for one or more data groups.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.x - An accessor for the predictor data field.
   * @param {function(object): *} params.y - An accessor for the predicted data field.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
   * @param {number} [params.bandwidth=0.3] - The loess bandwidth.
   */


  function Loess(params) {
    Transform.call(this, null, params);
  }

  Loess.Definition = {
    'type': 'Loess',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'x',
      'type': 'field',
      'required': true
    }, {
      'name': 'y',
      'type': 'field',
      'required': true
    }, {
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'bandwidth',
      'type': 'number',
      'default': 0.3
    }, {
      'name': 'as',
      'type': 'string',
      'array': true
    }]
  };
  inherits(Loess, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);

      if (!this.value || pulse.changed() || _.modified()) {
        const source = pulse.materialize(pulse.SOURCE).source,
              groups = partition(source, _.groupby),
              names = (_.groupby || []).map(accessorName),
              m = names.length,
              as = _.as || [accessorName(_.x), accessorName(_.y)],
              values = [];
        groups.forEach(g => {
          loess(g, _.x, _.y, _.bandwidth || 0.3).forEach(p => {
            const t = {};

            for (let i = 0; i < m; ++i) {
              t[names[i]] = g.dims[i];
            }

            t[as[0]] = p[0];
            t[as[1]] = p[1];
            values.push(ingest$1(t));
          });
        });
        if (this.value) out.rem = this.value;
        this.value = out.add = out.source = values;
      }

      return out;
    }

  });
  const Methods = {
    linear: linear$2,
    log: log$3,
    exp: exp$1,
    pow: pow$3,
    quad: quad,
    poly: poly
  };

  const degreesOfFreedom = (method, order) => method === 'poly' ? order : method === 'quad' ? 2 : 1;
  /**
   * Compute regression fits for one or more data groups.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {function(object): *} params.x - An accessor for the predictor data field.
   * @param {function(object): *} params.y - An accessor for the predicted data field.
   * @param {string} [params.method='linear'] - The regression method to apply.
   * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
   * @param {Array<number>} [params.extent] - The domain extent over which to plot the regression line.
   * @param {number} [params.order=3] - The polynomial order. Only applies to the 'poly' method.
   */


  function Regression(params) {
    Transform.call(this, null, params);
  }

  Regression.Definition = {
    'type': 'Regression',
    'metadata': {
      'generates': true
    },
    'params': [{
      'name': 'x',
      'type': 'field',
      'required': true
    }, {
      'name': 'y',
      'type': 'field',
      'required': true
    }, {
      'name': 'groupby',
      'type': 'field',
      'array': true
    }, {
      'name': 'method',
      'type': 'string',
      'default': 'linear',
      'values': Object.keys(Methods)
    }, {
      'name': 'order',
      'type': 'number',
      'default': 3
    }, {
      'name': 'extent',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'params',
      'type': 'boolean',
      'default': false
    }, {
      'name': 'as',
      'type': 'string',
      'array': true
    }]
  };
  inherits(Regression, Transform, {
    transform(_, pulse) {
      const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);

      if (!this.value || pulse.changed() || _.modified()) {
        const source = pulse.materialize(pulse.SOURCE).source,
              groups = partition(source, _.groupby),
              names = (_.groupby || []).map(accessorName),
              method = _.method || 'linear',
              order = _.order || 3,
              dof = degreesOfFreedom(method, order),
              as = _.as || [accessorName(_.x), accessorName(_.y)],
              fit = Methods[method],
              values = [];
        let domain = _.extent;

        if (!has$1(Methods, method)) {
          error('Invalid regression method: ' + method);
        }

        if (domain != null) {
          if (method === 'log' && domain[0] <= 0) {
            pulse.dataflow.warn('Ignoring extent with values <= 0 for log regression.');
            domain = null;
          }
        }

        groups.forEach(g => {
          const n = g.length;

          if (n <= dof) {
            pulse.dataflow.warn('Skipping regression with more parameters than data points.');
            return;
          }

          const model = fit(g, _.x, _.y, order);

          if (_.params) {
            // if parameter vectors requested return those
            values.push(ingest$1({
              keys: g.dims,
              coef: model.coef,
              rSquared: model.rSquared
            }));
            return;
          }

          const dom = domain || extent(g, _.x),
                add = p => {
            const t = {};

            for (let i = 0; i < names.length; ++i) {
              t[names[i]] = g.dims[i];
            }

            t[as[0]] = p[0];
            t[as[1]] = p[1];
            values.push(ingest$1(t));
          };

          if (method === 'linear') {
            // for linear regression we only need the end points
            dom.forEach(x => add([x, model.predict(x)]));
          } else {
            // otherwise return trend line sample points
            sampleCurve(model.predict, dom, 25, 200).forEach(add);
          }
        });
        if (this.value) out.rem = this.value;
        this.value = out.add = out.source = values;
      }

      return out;
    }

  });

  var reg = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loess: Loess,
    regression: Regression
  });

  const EPSILON = Math.pow(2, -52);
  const EDGE_STACK = new Uint32Array(512);
  class Delaunator {
    static from(points, getX = defaultGetX, getY = defaultGetY) {
      const n = points.length;
      const coords = new Float64Array(n * 2);

      for (let i = 0; i < n; i++) {
        const p = points[i];
        coords[2 * i] = getX(p);
        coords[2 * i + 1] = getY(p);
      }

      return new Delaunator(coords);
    }

    constructor(coords) {
      const n = coords.length >> 1;
      if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
      this.coords = coords; // arrays that will store the triangulation graph

      const maxTriangles = Math.max(2 * n - 5, 0);
      this._triangles = new Uint32Array(maxTriangles * 3);
      this._halfedges = new Int32Array(maxTriangles * 3); // temporary arrays for tracking the edges of the advancing convex hull

      this._hashSize = Math.ceil(Math.sqrt(n));
      this._hullPrev = new Uint32Array(n); // edge to prev edge

      this._hullNext = new Uint32Array(n); // edge to next edge

      this._hullTri = new Uint32Array(n); // edge to adjacent triangle

      this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
      // temporary arrays for sorting points

      this._ids = new Uint32Array(n);
      this._dists = new Float64Array(n);
      this.update();
    }

    update() {
      const {
        coords,
        _hullPrev: hullPrev,
        _hullNext: hullNext,
        _hullTri: hullTri,
        _hullHash: hullHash
      } = this;
      const n = coords.length >> 1; // populate an array of point indices; calculate input data bbox

      let minX = Infinity;
      let minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;

      for (let i = 0; i < n; i++) {
        const x = coords[2 * i];
        const y = coords[2 * i + 1];
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this._ids[i] = i;
      }

      const cx = (minX + maxX) / 2;
      const cy = (minY + maxY) / 2;
      let minDist = Infinity;
      let i0, i1, i2; // pick a seed point close to the center

      for (let i = 0; i < n; i++) {
        const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);

        if (d < minDist) {
          i0 = i;
          minDist = d;
        }
      }

      const i0x = coords[2 * i0];
      const i0y = coords[2 * i0 + 1];
      minDist = Infinity; // find the point closest to the seed

      for (let i = 0; i < n; i++) {
        if (i === i0) continue;
        const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);

        if (d < minDist && d > 0) {
          i1 = i;
          minDist = d;
        }
      }

      let i1x = coords[2 * i1];
      let i1y = coords[2 * i1 + 1];
      let minRadius = Infinity; // find the third point which forms the smallest circumcircle with the first two

      for (let i = 0; i < n; i++) {
        if (i === i0 || i === i1) continue;
        const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);

        if (r < minRadius) {
          i2 = i;
          minRadius = r;
        }
      }

      let i2x = coords[2 * i2];
      let i2y = coords[2 * i2 + 1];

      if (minRadius === Infinity) {
        // order collinear points by dx (or dy if all x are identical)
        // and return the list as a hull
        for (let i = 0; i < n; i++) {
          this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
        }

        quicksort(this._ids, this._dists, 0, n - 1);
        const hull = new Uint32Array(n);
        let j = 0;

        for (let i = 0, d0 = -Infinity; i < n; i++) {
          const id = this._ids[i];

          if (this._dists[id] > d0) {
            hull[j++] = id;
            d0 = this._dists[id];
          }
        }

        this.hull = hull.subarray(0, j);
        this.triangles = new Uint32Array(0);
        this.halfedges = new Uint32Array(0);
        return;
      } // swap the order of the seed points for counter-clockwise orientation


      if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
        const i = i1;
        const x = i1x;
        const y = i1y;
        i1 = i2;
        i1x = i2x;
        i1y = i2y;
        i2 = i;
        i2x = x;
        i2y = y;
      }

      const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
      this._cx = center.x;
      this._cy = center.y;

      for (let i = 0; i < n; i++) {
        this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
      } // sort the points by distance from the seed triangle circumcenter


      quicksort(this._ids, this._dists, 0, n - 1); // set up the seed triangle as the starting hull

      this._hullStart = i0;
      let hullSize = 3;
      hullNext[i0] = hullPrev[i2] = i1;
      hullNext[i1] = hullPrev[i0] = i2;
      hullNext[i2] = hullPrev[i1] = i0;
      hullTri[i0] = 0;
      hullTri[i1] = 1;
      hullTri[i2] = 2;
      hullHash.fill(-1);
      hullHash[this._hashKey(i0x, i0y)] = i0;
      hullHash[this._hashKey(i1x, i1y)] = i1;
      hullHash[this._hashKey(i2x, i2y)] = i2;
      this.trianglesLen = 0;

      this._addTriangle(i0, i1, i2, -1, -1, -1);

      for (let k = 0, xp, yp; k < this._ids.length; k++) {
        const i = this._ids[k];
        const x = coords[2 * i];
        const y = coords[2 * i + 1]; // skip near-duplicate points

        if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
        xp = x;
        yp = y; // skip seed triangle points

        if (i === i0 || i === i1 || i === i2) continue; // find a visible edge on the convex hull using edge hash

        let start = 0;

        for (let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++) {
          start = hullHash[(key + j) % this._hashSize];
          if (start !== -1 && start !== hullNext[start]) break;
        }

        start = hullPrev[start];
        let e = start,
            q;

        while (q = hullNext[e], !orient(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])) {
          e = q;

          if (e === start) {
            e = -1;
            break;
          }
        }

        if (e === -1) continue; // likely a near-duplicate point; skip it
        // add the first triangle from the point

        let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]); // recursively flip triangles from the point until they satisfy the Delaunay condition


        hullTri[i] = this._legalize(t + 2);
        hullTri[e] = t; // keep track of boundary triangles on the hull

        hullSize++; // walk forward through the hull, adding more triangles and flipping recursively

        let n = hullNext[e];

        while (q = hullNext[n], orient(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1])) {
          t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
          hullTri[i] = this._legalize(t + 2);
          hullNext[n] = n; // mark as removed

          hullSize--;
          n = q;
        } // walk backward from the other side, adding more triangles and flipping


        if (e === start) {
          while (q = hullPrev[e], orient(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])) {
            t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);

            this._legalize(t + 2);

            hullTri[q] = t;
            hullNext[e] = e; // mark as removed

            hullSize--;
            e = q;
          }
        } // update the hull indices


        this._hullStart = hullPrev[i] = e;
        hullNext[e] = hullPrev[n] = i;
        hullNext[i] = n; // save the two new edges in the hash table

        hullHash[this._hashKey(x, y)] = i;
        hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
      }

      this.hull = new Uint32Array(hullSize);

      for (let i = 0, e = this._hullStart; i < hullSize; i++) {
        this.hull[i] = e;
        e = hullNext[e];
      } // trim typed triangle mesh arrays


      this.triangles = this._triangles.subarray(0, this.trianglesLen);
      this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }

    _hashKey(x, y) {
      return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }

    _legalize(a) {
      const {
        _triangles: triangles,
        _halfedges: halfedges,
        coords
      } = this;
      let i = 0;
      let ar = 0; // recursion eliminated with a fixed-size stack

      while (true) {
        const b = halfedges[a];
        /* if the pair of triangles doesn't satisfy the Delaunay condition
         * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
         * then do the same check/flip recursively for the new pair of triangles
         *
         *           pl                    pl
         *          /||\                  /  \
         *       al/ || \bl            al/    \a
         *        /  ||  \              /      \
         *       /  a||b  \    flip    /___ar___\
         *     p0\   ||   /p1   =>   p0\---bl---/p1
         *        \  ||  /              \      /
         *       ar\ || /br             b\    /br
         *          \||/                  \  /
         *           pr                    pr
         */

        const a0 = a - a % 3;
        ar = a0 + (a + 2) % 3;

        if (b === -1) {
          // convex hull edge
          if (i === 0) break;
          a = EDGE_STACK[--i];
          continue;
        }

        const b0 = b - b % 3;
        const al = a0 + (a + 1) % 3;
        const bl = b0 + (b + 2) % 3;
        const p0 = triangles[ar];
        const pr = triangles[a];
        const pl = triangles[al];
        const p1 = triangles[bl];
        const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);

        if (illegal) {
          triangles[a] = p1;
          triangles[b] = p0;
          const hbl = halfedges[bl]; // edge swapped on the other side of the hull (rare); fix the halfedge reference

          if (hbl === -1) {
            let e = this._hullStart;

            do {
              if (this._hullTri[e] === bl) {
                this._hullTri[e] = a;
                break;
              }

              e = this._hullPrev[e];
            } while (e !== this._hullStart);
          }

          this._link(a, hbl);

          this._link(b, halfedges[ar]);

          this._link(ar, bl);

          const br = b0 + (b + 1) % 3; // don't worry about hitting the cap: it can only happen on extremely degenerate input

          if (i < EDGE_STACK.length) {
            EDGE_STACK[i++] = br;
          }
        } else {
          if (i === 0) break;
          a = EDGE_STACK[--i];
        }
      }

      return ar;
    }

    _link(a, b) {
      this._halfedges[a] = b;
      if (b !== -1) this._halfedges[b] = a;
    } // add a new triangle given vertex indices and adjacent half-edge ids


    _addTriangle(i0, i1, i2, a, b, c) {
      const t = this.trianglesLen;
      this._triangles[t] = i0;
      this._triangles[t + 1] = i1;
      this._triangles[t + 2] = i2;

      this._link(t, a);

      this._link(t + 1, b);

      this._link(t + 2, c);

      this.trianglesLen += 3;
      return t;
    }

  } // monotonically increases with real angle, but doesn't need expensive trigonometry

  function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
  }

  function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
  } // return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check


  function orientIfSure(px, py, rx, ry, qx, qy) {
    const l = (ry - py) * (qx - px);
    const r = (rx - px) * (qy - py);
    return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
  } // a more robust orientation test that's stable in a given triangle (to fix robustness issues)


  function orient(rx, ry, qx, qy, px, py) {
    const sign = orientIfSure(px, py, rx, ry, qx, qy) || orientIfSure(rx, ry, qx, qy, px, py) || orientIfSure(qx, qy, px, py, rx, ry);
    return sign < 0;
  }

  function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
  }

  function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
  }

  function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
      x,
      y
    };
  }

  function quicksort(ids, dists, left, right) {
    if (right - left <= 20) {
      for (let i = left + 1; i <= right; i++) {
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;

        while (j >= left && dists[ids[j]] > tempDist) ids[j + 1] = ids[j--];

        ids[j + 1] = temp;
      }
    } else {
      const median = left + right >> 1;
      let i = left + 1;
      let j = right;
      swap(ids, median, i);
      if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
      if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
      if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
      const temp = ids[i];
      const tempDist = dists[temp];

      while (true) {
        do i++; while (dists[ids[i]] < tempDist);

        do j--; while (dists[ids[j]] > tempDist);

        if (j < i) break;
        swap(ids, i, j);
      }

      ids[left + 1] = ids[j];
      ids[j] = temp;

      if (right - i + 1 >= j - left) {
        quicksort(ids, dists, i, right);
        quicksort(ids, dists, left, j - 1);
      } else {
        quicksort(ids, dists, left, j - 1);
        quicksort(ids, dists, i, right);
      }
    }
  }

  function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
  }

  function defaultGetX(p) {
    return p[0];
  }

  function defaultGetY(p) {
    return p[1];
  }

  const epsilon = 1e-6;
  class Path {
    constructor() {
      this._x0 = this._y0 = // start of current subpath
      this._x1 = this._y1 = null; // end of current subpath

      this._ = "";
    }

    moveTo(x, y) {
      this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }

    closePath() {
      if (this._x1 !== null) {
        this._x1 = this._x0, this._y1 = this._y0;
        this._ += "Z";
      }
    }

    lineTo(x, y) {
      this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }

    arc(x, y, r) {
      x = +x, y = +y, r = +r;
      const x0 = x + r;
      const y0 = y;
      if (r < 0) throw new Error("negative radius");
      if (this._x1 === null) this._ += `M${x0},${y0}`;else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
      if (!r) return;
      this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }

    rect(x, y, w, h) {
      this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }

    value() {
      return this._ || null;
    }

  }

  class Polygon {
    constructor() {
      this._ = [];
    }

    moveTo(x, y) {
      this._.push([x, y]);
    }

    closePath() {
      this._.push(this._[0].slice());
    }

    lineTo(x, y) {
      this._.push([x, y]);
    }

    value() {
      return this._.length ? this._ : null;
    }

  }

  class Voronoi$1 {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [0, 0, 960, 500]) {
      if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
      this.delaunay = delaunay;
      this._circumcenters = new Float64Array(delaunay.points.length * 2);
      this.vectors = new Float64Array(delaunay.points.length * 2);
      this.xmax = xmax, this.xmin = xmin;
      this.ymax = ymax, this.ymin = ymin;

      this._init();
    }

    update() {
      this.delaunay.update();

      this._init();

      return this;
    }

    _init() {
      const {
        delaunay: {
          points,
          hull,
          triangles
        },
        vectors
      } = this; // Compute circumcenters.

      const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);

      for (let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2) {
        const t1 = triangles[i] * 2;
        const t2 = triangles[i + 1] * 2;
        const t3 = triangles[i + 2] * 2;
        const x1 = points[t1];
        const y1 = points[t1 + 1];
        const x2 = points[t2];
        const y2 = points[t2 + 1];
        const x3 = points[t3];
        const y3 = points[t3 + 1];
        const dx = x2 - x1;
        const dy = y2 - y1;
        const ex = x3 - x1;
        const ey = y3 - y1;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        const ab = (dx * ey - dy * ex) * 2;

        if (!ab) {
          // degenerate case (collinear diagram)
          x = (x1 + x3) / 2 - 1e8 * ey;
          y = (y1 + y3) / 2 + 1e8 * ex;
        } else if (Math.abs(ab) < 1e-8) {
          // almost equal points (degenerate triangle)
          x = (x1 + x3) / 2;
          y = (y1 + y3) / 2;
        } else {
          const d = 1 / ab;
          x = x1 + (ey * bl - dy * cl) * d;
          y = y1 + (dx * cl - ex * bl) * d;
        }

        circumcenters[j] = x;
        circumcenters[j + 1] = y;
      } // Compute exterior cell rays.


      let h = hull[hull.length - 1];
      let p0,
          p1 = h * 4;
      let x0,
          x1 = points[2 * h];
      let y0,
          y1 = points[2 * h + 1];
      vectors.fill(0);

      for (let i = 0; i < hull.length; ++i) {
        h = hull[i];
        p0 = p1, x0 = x1, y0 = y1;
        p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
        vectors[p0 + 2] = vectors[p1] = y0 - y1;
        vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
      }
    }

    render(context) {
      const buffer = context == null ? context = new Path() : undefined;
      const {
        delaunay: {
          halfedges,
          inedges,
          hull
        },
        circumcenters,
        vectors
      } = this;
      if (hull.length <= 1) return null;

      for (let i = 0, n = halfedges.length; i < n; ++i) {
        const j = halfedges[i];
        if (j < i) continue;
        const ti = Math.floor(i / 3) * 2;
        const tj = Math.floor(j / 3) * 2;
        const xi = circumcenters[ti];
        const yi = circumcenters[ti + 1];
        const xj = circumcenters[tj];
        const yj = circumcenters[tj + 1];

        this._renderSegment(xi, yi, xj, yj, context);
      }

      let h0,
          h1 = hull[hull.length - 1];

      for (let i = 0; i < hull.length; ++i) {
        h0 = h1, h1 = hull[i];
        const t = Math.floor(inedges[h1] / 3) * 2;
        const x = circumcenters[t];
        const y = circumcenters[t + 1];
        const v = h0 * 4;

        const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);

        if (p) this._renderSegment(x, y, p[0], p[1], context);
      }

      return buffer && buffer.value();
    }

    renderBounds(context) {
      const buffer = context == null ? context = new Path() : undefined;
      context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
      return buffer && buffer.value();
    }

    renderCell(i, context) {
      const buffer = context == null ? context = new Path() : undefined;

      const points = this._clip(i);

      if (points === null || !points.length) return;
      context.moveTo(points[0], points[1]);
      let n = points.length;

      while (points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1) n -= 2;

      for (let i = 2; i < n; i += 2) {
        if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
      }

      context.closePath();
      return buffer && buffer.value();
    }

    *cellPolygons() {
      const {
        delaunay: {
          points
        }
      } = this;

      for (let i = 0, n = points.length / 2; i < n; ++i) {
        const cell = this.cellPolygon(i);
        if (cell) cell.index = i, yield cell;
      }
    }

    cellPolygon(i) {
      const polygon = new Polygon();
      this.renderCell(i, polygon);
      return polygon.value();
    }

    _renderSegment(x0, y0, x1, y1, context) {
      let S;

      const c0 = this._regioncode(x0, y0);

      const c1 = this._regioncode(x1, y1);

      if (c0 === 0 && c1 === 0) {
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
      } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
        context.moveTo(S[0], S[1]);
        context.lineTo(S[2], S[3]);
      }
    }

    contains(i, x, y) {
      if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
      return this.delaunay._step(i, x, y) === i;
    }

    *neighbors(i) {
      const ci = this._clip(i);

      if (ci) for (const j of this.delaunay.neighbors(i)) {
        const cj = this._clip(j); // find the common edge


        if (cj) loop: for (let ai = 0, li = ci.length; ai < li; ai += 2) {
          for (let aj = 0, lj = cj.length; aj < lj; aj += 2) {
            if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
              yield j;
              break loop;
            }
          }
        }
      }
    }

    _cell(i) {
      const {
        circumcenters,
        delaunay: {
          inedges,
          halfedges,
          triangles
        }
      } = this;
      const e0 = inedges[i];
      if (e0 === -1) return null; // coincident point

      const points = [];
      let e = e0;

      do {
        const t = Math.floor(e / 3);
        points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
        e = e % 3 === 2 ? e - 2 : e + 1;
        if (triangles[e] !== i) break; // bad triangulation

        e = halfedges[e];
      } while (e !== e0 && e !== -1);

      return points;
    }

    _clip(i) {
      // degenerate case (1 valid point: return the box)
      if (i === 0 && this.delaunay.hull.length === 1) {
        return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
      }

      const points = this._cell(i);

      if (points === null) return null;
      const {
        vectors: V
      } = this;
      const v = i * 4;
      return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
    }

    _clipFinite(i, points) {
      const n = points.length;
      let P = null;
      let x0,
          y0,
          x1 = points[n - 2],
          y1 = points[n - 1];

      let c0,
          c1 = this._regioncode(x1, y1);

      let e0, e1;

      for (let j = 0; j < n; j += 2) {
        x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
        c0 = c1, c1 = this._regioncode(x1, y1);

        if (c0 === 0 && c1 === 0) {
          e0 = e1, e1 = 0;
          if (P) P.push(x1, y1);else P = [x1, y1];
        } else {
          let S, sx0, sy0, sx1, sy1;

          if (c0 === 0) {
            if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
            [sx0, sy0, sx1, sy1] = S;
          } else {
            if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
            [sx1, sy1, sx0, sy0] = S;
            e0 = e1, e1 = this._edgecode(sx0, sy0);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
            if (P) P.push(sx0, sy0);else P = [sx0, sy0];
          }

          e0 = e1, e1 = this._edgecode(sx1, sy1);
          if (e0 && e1) this._edge(i, e0, e1, P, P.length);
          if (P) P.push(sx1, sy1);else P = [sx1, sy1];
        }
      }

      if (P) {
        e0 = e1, e1 = this._edgecode(P[0], P[1]);
        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
      } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
        return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
      }

      return P;
    }

    _clipSegment(x0, y0, x1, y1, c0, c1) {
      while (true) {
        if (c0 === 0 && c1 === 0) return [x0, y0, x1, y1];
        if (c0 & c1) return null;
        let x,
            y,
            c = c0 || c1;
        if (c & 0b1000) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;else if (c & 0b0100) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;else if (c & 0b0010) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
        if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
      }
    }

    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
      let P = Array.from(points),
          p;
      if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
      if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);

      if (P = this._clipFinite(i, P)) {
        for (let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2) {
          c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
          if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
      } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
        P = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax];
      }

      return P;
    }

    _edge(i, e0, e1, P, j) {
      while (e0 !== e1) {
        let x, y;

        switch (e0) {
          case 0b0101:
            e0 = 0b0100;
            continue;
          // top-left

          case 0b0100:
            e0 = 0b0110, x = this.xmax, y = this.ymin;
            break;
          // top

          case 0b0110:
            e0 = 0b0010;
            continue;
          // top-right

          case 0b0010:
            e0 = 0b1010, x = this.xmax, y = this.ymax;
            break;
          // right

          case 0b1010:
            e0 = 0b1000;
            continue;
          // bottom-right

          case 0b1000:
            e0 = 0b1001, x = this.xmin, y = this.ymax;
            break;
          // bottom

          case 0b1001:
            e0 = 0b0001;
            continue;
          // bottom-left

          case 0b0001:
            e0 = 0b0101, x = this.xmin, y = this.ymin;
            break;
          // left
        }

        if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) {
          P.splice(j, 0, x, y), j += 2;
        }
      }

      if (P.length > 4) {
        for (let i = 0; i < P.length; i += 2) {
          const j = (i + 2) % P.length,
                k = (i + 4) % P.length;
          if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
        }
      }

      return j;
    }

    _project(x0, y0, vx, vy) {
      let t = Infinity,
          c,
          x,
          y;

      if (vy < 0) {
        // top
        if (y0 <= this.ymin) return null;
        if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
      } else if (vy > 0) {
        // bottom
        if (y0 >= this.ymax) return null;
        if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
      }

      if (vx > 0) {
        // right
        if (x0 >= this.xmax) return null;
        if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
      } else if (vx < 0) {
        // left
        if (x0 <= this.xmin) return null;
        if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
      }

      return [x, y];
    }

    _edgecode(x, y) {
      return (x === this.xmin ? 0b0001 : x === this.xmax ? 0b0010 : 0b0000) | (y === this.ymin ? 0b0100 : y === this.ymax ? 0b1000 : 0b0000);
    }

    _regioncode(x, y) {
      return (x < this.xmin ? 0b0001 : x > this.xmax ? 0b0010 : 0b0000) | (y < this.ymin ? 0b0100 : y > this.ymax ? 0b1000 : 0b0000);
    }

  }

  const tau = 2 * Math.PI,
        pow = Math.pow;

  function pointX(p) {
    return p[0];
  }

  function pointY(p) {
    return p[1];
  } // A triangulation is collinear if all its triangles have a non-null area


  function collinear(d) {
    const {
      triangles,
      coords
    } = d;

    for (let i = 0; i < triangles.length; i += 3) {
      const a = 2 * triangles[i],
            b = 2 * triangles[i + 1],
            c = 2 * triangles[i + 2],
            cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
      if (cross > 1e-10) return false;
    }

    return true;
  }

  function jitter(x, y, r) {
    return [x + Math.sin(x + y) * r, y + Math.cos(x - y) * r];
  }

  class Delaunay {
    static from(points, fx = pointX, fy = pointY, that) {
      return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }

    constructor(points) {
      this._delaunator = new Delaunator(points);
      this.inedges = new Int32Array(points.length / 2);
      this._hullIndex = new Int32Array(points.length / 2);
      this.points = this._delaunator.coords;

      this._init();
    }

    update() {
      this._delaunator.update();

      this._init();

      return this;
    }

    _init() {
      const d = this._delaunator,
            points = this.points; // check for collinear

      if (d.hull && d.hull.length > 2 && collinear(d)) {
        this.collinear = Int32Array.from({
          length: points.length / 2
        }, (_, i) => i).sort((i, j) => points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors

        const e = this.collinear[0],
              f = this.collinear[this.collinear.length - 1],
              bounds = [points[2 * e], points[2 * e + 1], points[2 * f], points[2 * f + 1]],
              r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);

        for (let i = 0, n = points.length / 2; i < n; ++i) {
          const p = jitter(points[2 * i], points[2 * i + 1], r);
          points[2 * i] = p[0];
          points[2 * i + 1] = p[1];
        }

        this._delaunator = new Delaunator(points);
      } else {
        delete this.collinear;
      }

      const halfedges = this.halfedges = this._delaunator.halfedges;
      const hull = this.hull = this._delaunator.hull;
      const triangles = this.triangles = this._delaunator.triangles;
      const inedges = this.inedges.fill(-1);

      const hullIndex = this._hullIndex.fill(-1); // Compute an index from each point to an (arbitrary) incoming halfedge
      // Used to give the first neighbor of each point; for this reason,
      // on the hull we give priority to exterior halfedges


      for (let e = 0, n = halfedges.length; e < n; ++e) {
        const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
        if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
      }

      for (let i = 0, n = hull.length; i < n; ++i) {
        hullIndex[hull[i]] = i;
      } // degenerate case: 1 or 2 (distinct) points


      if (hull.length <= 2 && hull.length > 0) {
        this.triangles = new Int32Array(3).fill(-1);
        this.halfedges = new Int32Array(3).fill(-1);
        this.triangles[0] = hull[0];
        this.triangles[1] = hull[1];
        this.triangles[2] = hull[1];
        inedges[hull[0]] = 1;
        if (hull.length === 2) inedges[hull[1]] = 0;
      }
    }

    voronoi(bounds) {
      return new Voronoi$1(this, bounds);
    }

    *neighbors(i) {
      const {
        inedges,
        hull,
        _hullIndex,
        halfedges,
        triangles,
        collinear
      } = this; // degenerate case with several collinear points

      if (collinear) {
        const l = collinear.indexOf(i);
        if (l > 0) yield collinear[l - 1];
        if (l < collinear.length - 1) yield collinear[l + 1];
        return;
      }

      const e0 = inedges[i];
      if (e0 === -1) return; // coincident point

      let e = e0,
          p0 = -1;

      do {
        yield p0 = triangles[e];
        e = e % 3 === 2 ? e - 2 : e + 1;
        if (triangles[e] !== i) return; // bad triangulation

        e = halfedges[e];

        if (e === -1) {
          const p = hull[(_hullIndex[i] + 1) % hull.length];
          if (p !== p0) yield p;
          return;
        }
      } while (e !== e0);
    }

    find(x, y, i = 0) {
      if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
      const i0 = i;
      let c;

      while ((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0) i = c;

      return c;
    }

    _step(i, x, y) {
      const {
        inedges,
        hull,
        _hullIndex,
        halfedges,
        triangles,
        points
      } = this;
      if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
      let c = i;
      let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
      const e0 = inedges[i];
      let e = e0;

      do {
        let t = triangles[e];
        const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
        if (dt < dc) dc = dt, c = t;
        e = e % 3 === 2 ? e - 2 : e + 1;
        if (triangles[e] !== i) break; // bad triangulation

        e = halfedges[e];

        if (e === -1) {
          e = hull[(_hullIndex[i] + 1) % hull.length];

          if (e !== t) {
            if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
          }

          break;
        }
      } while (e !== e0);

      return c;
    }

    render(context) {
      const buffer = context == null ? context = new Path() : undefined;
      const {
        points,
        halfedges,
        triangles
      } = this;

      for (let i = 0, n = halfedges.length; i < n; ++i) {
        const j = halfedges[i];
        if (j < i) continue;
        const ti = triangles[i] * 2;
        const tj = triangles[j] * 2;
        context.moveTo(points[ti], points[ti + 1]);
        context.lineTo(points[tj], points[tj + 1]);
      }

      this.renderHull(context);
      return buffer && buffer.value();
    }

    renderPoints(context, r = 2) {
      const buffer = context == null ? context = new Path() : undefined;
      const {
        points
      } = this;

      for (let i = 0, n = points.length; i < n; i += 2) {
        const x = points[i],
              y = points[i + 1];
        context.moveTo(x + r, y);
        context.arc(x, y, r, 0, tau);
      }

      return buffer && buffer.value();
    }

    renderHull(context) {
      const buffer = context == null ? context = new Path() : undefined;
      const {
        hull,
        points
      } = this;
      const h = hull[0] * 2,
            n = hull.length;
      context.moveTo(points[h], points[h + 1]);

      for (let i = 1; i < n; ++i) {
        const h = 2 * hull[i];
        context.lineTo(points[h], points[h + 1]);
      }

      context.closePath();
      return buffer && buffer.value();
    }

    hullPolygon() {
      const polygon = new Polygon();
      this.renderHull(polygon);
      return polygon.value();
    }

    renderTriangle(i, context) {
      const buffer = context == null ? context = new Path() : undefined;
      const {
        points,
        triangles
      } = this;
      const t0 = triangles[i *= 3] * 2;
      const t1 = triangles[i + 1] * 2;
      const t2 = triangles[i + 2] * 2;
      context.moveTo(points[t0], points[t0 + 1]);
      context.lineTo(points[t1], points[t1 + 1]);
      context.lineTo(points[t2], points[t2 + 1]);
      context.closePath();
      return buffer && buffer.value();
    }

    *trianglePolygons() {
      const {
        triangles
      } = this;

      for (let i = 0, n = triangles.length / 3; i < n; ++i) {
        yield this.trianglePolygon(i);
      }
    }

    trianglePolygon(i) {
      const polygon = new Polygon();
      this.renderTriangle(i, polygon);
      return polygon.value();
    }

  }

  function flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);

    for (let i = 0; i < n; ++i) {
      const p = points[i];
      array[i * 2] = fx.call(that, p, i, points);
      array[i * 2 + 1] = fy.call(that, p, i, points);
    }

    return array;
  }

  function* flatIterable(points, fx, fy, that) {
    let i = 0;

    for (const p of points) {
      yield fx.call(that, p, i, points);
      yield fy.call(that, p, i, points);
      ++i;
    }
  }

  function Voronoi(params) {
    Transform.call(this, null, params);
  }

  Voronoi.Definition = {
    'type': 'Voronoi',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'x',
      'type': 'field',
      'required': true
    }, {
      'name': 'y',
      'type': 'field',
      'required': true
    }, {
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'extent',
      'type': 'array',
      'array': true,
      'length': 2,
      'default': [[-1e5, -1e5], [1e5, 1e5]],
      'content': {
        'type': 'number',
        'array': true,
        'length': 2
      }
    }, {
      'name': 'as',
      'type': 'string',
      'default': 'path'
    }]
  };
  const defaultExtent = [-1e5, -1e5, 1e5, 1e5];
  inherits(Voronoi, Transform, {
    transform(_, pulse) {
      const as = _.as || 'path',
            data = pulse.source; // nothing to do if no data

      if (!data || !data.length) return pulse; // configure and construct voronoi diagram

      let s = _.size;
      s = s ? [0, 0, s[0], s[1]] : (s = _.extent) ? [s[0][0], s[0][1], s[1][0], s[1][1]] : defaultExtent;
      const voronoi = this.value = Delaunay.from(data, _.x, _.y).voronoi(s); // map polygons to paths

      for (let i = 0, n = data.length; i < n; ++i) {
        const polygon = voronoi.cellPolygon(i);
        data[i][as] = polygon ? toPathString(polygon) : null;
      }

      return pulse.reflow(_.modified()).modifies(as);
    }

  }); // suppress duplicated end point vertices

  function toPathString(p) {
    const x = p[0][0],
          y = p[0][1];
    let n = p.length - 1;

    for (; p[n][0] === x && p[n][1] === y; --n);

    return 'M' + p.slice(0, n + 1).join('L') + 'Z';
  }

  var voronoi = /*#__PURE__*/Object.freeze({
    __proto__: null,
    voronoi: Voronoi
  });

  /*
  Copyright (c) 2013, Jason Davies.
  All rights reserved.

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright notice, this
      list of conditions and the following disclaimer.

    * Redistributions in binary form must reproduce the above copyright notice,
      this list of conditions and the following disclaimer in the documentation
      and/or other materials provided with the distribution.

    * The name Jason Davies may not be used to endorse or promote products
      derived from this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
  ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
  DISCLAIMED. IN NO EVENT SHALL JASON DAVIES BE LIABLE FOR ANY DIRECT, INDIRECT,
  INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
  LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
  OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
  ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
  // Word cloud layout by Jason Davies, https://www.jasondavies.com/wordcloud/
  // Algorithm due to Jonathan Feinberg, http://static.mrfeinberg.com/bv_ch03.pdf

  var cloudRadians = Math.PI / 180,
      cw = 1 << 11 >> 5,
      ch = 1 << 11;

  function cloud() {
    var size = [256, 256],
        text,
        font,
        fontSize,
        fontStyle,
        fontWeight,
        rotate,
        padding,
        spiral = archimedeanSpiral,
        words = [],
        random = Math.random,
        cloud = {};

    cloud.layout = function () {
      var contextAndRatio = getContext(canvas()),
          board = zeroArray((size[0] >> 5) * size[1]),
          bounds = null,
          n = words.length,
          i = -1,
          tags = [],
          data = words.map(d => ({
        text: text(d),
        font: font(d),
        style: fontStyle(d),
        weight: fontWeight(d),
        rotate: rotate(d),
        size: ~~(fontSize(d) + 1e-14),
        padding: padding(d),
        xoff: 0,
        yoff: 0,
        x1: 0,
        y1: 0,
        x0: 0,
        y0: 0,
        hasText: false,
        sprite: null,
        datum: d
      })).sort((a, b) => b.size - a.size);

      while (++i < n) {
        var d = data[i];
        d.x = size[0] * (random() + .5) >> 1;
        d.y = size[1] * (random() + .5) >> 1;
        cloudSprite(contextAndRatio, d, data, i);

        if (d.hasText && place(board, d, bounds)) {
          tags.push(d);
          if (bounds) cloudBounds(bounds, d);else bounds = [{
            x: d.x + d.x0,
            y: d.y + d.y0
          }, {
            x: d.x + d.x1,
            y: d.y + d.y1
          }]; // Temporary hack

          d.x -= size[0] >> 1;
          d.y -= size[1] >> 1;
        }
      }

      return tags;
    };

    function getContext(canvas) {
      canvas.width = canvas.height = 1;
      var ratio = Math.sqrt(canvas.getContext('2d').getImageData(0, 0, 1, 1).data.length >> 2);
      canvas.width = (cw << 5) / ratio;
      canvas.height = ch / ratio;
      var context = canvas.getContext('2d');
      context.fillStyle = context.strokeStyle = 'red';
      context.textAlign = 'center';
      return {
        context: context,
        ratio: ratio
      };
    }

    function place(board, tag, bounds) {
      var startX = tag.x,
          startY = tag.y,
          maxDelta = Math.sqrt(size[0] * size[0] + size[1] * size[1]),
          s = spiral(size),
          dt = random() < .5 ? 1 : -1,
          t = -dt,
          dxdy,
          dx,
          dy;

      while (dxdy = s(t += dt)) {
        dx = ~~dxdy[0];
        dy = ~~dxdy[1];
        if (Math.min(Math.abs(dx), Math.abs(dy)) >= maxDelta) break;
        tag.x = startX + dx;
        tag.y = startY + dy;
        if (tag.x + tag.x0 < 0 || tag.y + tag.y0 < 0 || tag.x + tag.x1 > size[0] || tag.y + tag.y1 > size[1]) continue; // TODO only check for collisions within current bounds.

        if (!bounds || !cloudCollide(tag, board, size[0])) {
          if (!bounds || collideRects(tag, bounds)) {
            var sprite = tag.sprite,
                w = tag.width >> 5,
                sw = size[0] >> 5,
                lx = tag.x - (w << 4),
                sx = lx & 0x7f,
                msx = 32 - sx,
                h = tag.y1 - tag.y0,
                x = (tag.y + tag.y0) * sw + (lx >> 5),
                last;

            for (var j = 0; j < h; j++) {
              last = 0;

              for (var i = 0; i <= w; i++) {
                board[x + i] |= last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0);
              }

              x += sw;
            }

            tag.sprite = null;
            return true;
          }
        }
      }

      return false;
    }

    cloud.words = function (_) {
      if (arguments.length) {
        words = _;
        return cloud;
      } else {
        return words;
      }
    };

    cloud.size = function (_) {
      if (arguments.length) {
        size = [+_[0], +_[1]];
        return cloud;
      } else {
        return size;
      }
    };

    cloud.font = function (_) {
      if (arguments.length) {
        font = functor(_);
        return cloud;
      } else {
        return font;
      }
    };

    cloud.fontStyle = function (_) {
      if (arguments.length) {
        fontStyle = functor(_);
        return cloud;
      } else {
        return fontStyle;
      }
    };

    cloud.fontWeight = function (_) {
      if (arguments.length) {
        fontWeight = functor(_);
        return cloud;
      } else {
        return fontWeight;
      }
    };

    cloud.rotate = function (_) {
      if (arguments.length) {
        rotate = functor(_);
        return cloud;
      } else {
        return rotate;
      }
    };

    cloud.text = function (_) {
      if (arguments.length) {
        text = functor(_);
        return cloud;
      } else {
        return text;
      }
    };

    cloud.spiral = function (_) {
      if (arguments.length) {
        spiral = spirals[_] || _;
        return cloud;
      } else {
        return spiral;
      }
    };

    cloud.fontSize = function (_) {
      if (arguments.length) {
        fontSize = functor(_);
        return cloud;
      } else {
        return fontSize;
      }
    };

    cloud.padding = function (_) {
      if (arguments.length) {
        padding = functor(_);
        return cloud;
      } else {
        return padding;
      }
    };

    cloud.random = function (_) {
      if (arguments.length) {
        random = _;
        return cloud;
      } else {
        return random;
      }
    };

    return cloud;
  } // Fetches a monochrome sprite bitmap for the specified text.
  // Load in batches for speed.


  function cloudSprite(contextAndRatio, d, data, di) {
    if (d.sprite) return;
    var c = contextAndRatio.context,
        ratio = contextAndRatio.ratio;
    c.clearRect(0, 0, (cw << 5) / ratio, ch / ratio);
    var x = 0,
        y = 0,
        maxh = 0,
        n = data.length,
        w,
        w32,
        h,
        i,
        j;
    --di;

    while (++di < n) {
      d = data[di];
      c.save();
      c.font = d.style + ' ' + d.weight + ' ' + ~~((d.size + 1) / ratio) + 'px ' + d.font;
      w = c.measureText(d.text + 'm').width * ratio;
      h = d.size << 1;

      if (d.rotate) {
        var sr = Math.sin(d.rotate * cloudRadians),
            cr = Math.cos(d.rotate * cloudRadians),
            wcr = w * cr,
            wsr = w * sr,
            hcr = h * cr,
            hsr = h * sr;
        w = Math.max(Math.abs(wcr + hsr), Math.abs(wcr - hsr)) + 0x1f >> 5 << 5;
        h = ~~Math.max(Math.abs(wsr + hcr), Math.abs(wsr - hcr));
      } else {
        w = w + 0x1f >> 5 << 5;
      }

      if (h > maxh) maxh = h;

      if (x + w >= cw << 5) {
        x = 0;
        y += maxh;
        maxh = 0;
      }

      if (y + h >= ch) break;
      c.translate((x + (w >> 1)) / ratio, (y + (h >> 1)) / ratio);
      if (d.rotate) c.rotate(d.rotate * cloudRadians);
      c.fillText(d.text, 0, 0);

      if (d.padding) {
        c.lineWidth = 2 * d.padding;
        c.strokeText(d.text, 0, 0);
      }

      c.restore();
      d.width = w;
      d.height = h;
      d.xoff = x;
      d.yoff = y;
      d.x1 = w >> 1;
      d.y1 = h >> 1;
      d.x0 = -d.x1;
      d.y0 = -d.y1;
      d.hasText = true;
      x += w;
    }

    var pixels = c.getImageData(0, 0, (cw << 5) / ratio, ch / ratio).data,
        sprite = [];

    while (--di >= 0) {
      d = data[di];
      if (!d.hasText) continue;
      w = d.width;
      w32 = w >> 5;
      h = d.y1 - d.y0; // Zero the buffer

      for (i = 0; i < h * w32; i++) sprite[i] = 0;

      x = d.xoff;
      if (x == null) return;
      y = d.yoff;
      var seen = 0,
          seenRow = -1;

      for (j = 0; j < h; j++) {
        for (i = 0; i < w; i++) {
          var k = w32 * j + (i >> 5),
              m = pixels[(y + j) * (cw << 5) + (x + i) << 2] ? 1 << 31 - i % 32 : 0;
          sprite[k] |= m;
          seen |= m;
        }

        if (seen) seenRow = j;else {
          d.y0++;
          h--;
          j--;
          y++;
        }
      }

      d.y1 = d.y0 + seenRow;
      d.sprite = sprite.slice(0, (d.y1 - d.y0) * w32);
    }
  } // Use mask-based collision detection.


  function cloudCollide(tag, board, sw) {
    sw >>= 5;
    var sprite = tag.sprite,
        w = tag.width >> 5,
        lx = tag.x - (w << 4),
        sx = lx & 0x7f,
        msx = 32 - sx,
        h = tag.y1 - tag.y0,
        x = (tag.y + tag.y0) * sw + (lx >> 5),
        last;

    for (var j = 0; j < h; j++) {
      last = 0;

      for (var i = 0; i <= w; i++) {
        if ((last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0)) & board[x + i]) return true;
      }

      x += sw;
    }

    return false;
  }

  function cloudBounds(bounds, d) {
    var b0 = bounds[0],
        b1 = bounds[1];
    if (d.x + d.x0 < b0.x) b0.x = d.x + d.x0;
    if (d.y + d.y0 < b0.y) b0.y = d.y + d.y0;
    if (d.x + d.x1 > b1.x) b1.x = d.x + d.x1;
    if (d.y + d.y1 > b1.y) b1.y = d.y + d.y1;
  }

  function collideRects(a, b) {
    return a.x + a.x1 > b[0].x && a.x + a.x0 < b[1].x && a.y + a.y1 > b[0].y && a.y + a.y0 < b[1].y;
  }

  function archimedeanSpiral(size) {
    var e = size[0] / size[1];
    return function (t) {
      return [e * (t *= .1) * Math.cos(t), t * Math.sin(t)];
    };
  }

  function rectangularSpiral(size) {
    var dy = 4,
        dx = dy * size[0] / size[1],
        x = 0,
        y = 0;
    return function (t) {
      var sign = t < 0 ? -1 : 1; // See triangular numbers: T_n = n * (n + 1) / 2.

      switch (Math.sqrt(1 + 4 * sign * t) - sign & 3) {
        case 0:
          x += dx;
          break;

        case 1:
          y += dy;
          break;

        case 2:
          x -= dx;
          break;

        default:
          y -= dy;
          break;
      }

      return [x, y];
    };
  } // TODO reuse arrays?


  function zeroArray(n) {
    var a = [],
        i = -1;

    while (++i < n) a[i] = 0;

    return a;
  }

  function functor(d) {
    return typeof d === 'function' ? d : function () {
      return d;
    };
  }

  var spirals = {
    archimedean: archimedeanSpiral,
    rectangular: rectangularSpiral
  };
  const Output = ['x', 'y', 'font', 'fontSize', 'fontStyle', 'fontWeight', 'angle'];
  const Params$1 = ['text', 'font', 'rotate', 'fontSize', 'fontStyle', 'fontWeight'];

  function Wordcloud(params) {
    Transform.call(this, cloud(), params);
  }

  Wordcloud.Definition = {
    'type': 'Wordcloud',
    'metadata': {
      'modifies': true
    },
    'params': [{
      'name': 'size',
      'type': 'number',
      'array': true,
      'length': 2
    }, {
      'name': 'font',
      'type': 'string',
      'expr': true,
      'default': 'sans-serif'
    }, {
      'name': 'fontStyle',
      'type': 'string',
      'expr': true,
      'default': 'normal'
    }, {
      'name': 'fontWeight',
      'type': 'string',
      'expr': true,
      'default': 'normal'
    }, {
      'name': 'fontSize',
      'type': 'number',
      'expr': true,
      'default': 14
    }, {
      'name': 'fontSizeRange',
      'type': 'number',
      'array': 'nullable',
      'default': [10, 50]
    }, {
      'name': 'rotate',
      'type': 'number',
      'expr': true,
      'default': 0
    }, {
      'name': 'text',
      'type': 'field'
    }, {
      'name': 'spiral',
      'type': 'string',
      'values': ['archimedean', 'rectangular']
    }, {
      'name': 'padding',
      'type': 'number',
      'expr': true
    }, {
      'name': 'as',
      'type': 'string',
      'array': true,
      'length': 7,
      'default': Output
    }]
  };
  inherits(Wordcloud, Transform, {
    transform(_, pulse) {
      if (_.size && !(_.size[0] && _.size[1])) {
        error('Wordcloud size dimensions must be non-zero.');
      }

      function modp(param) {
        const p = _[param];
        return isFunction(p) && pulse.modified(p.fields);
      }

      const mod = _.modified();

      if (!(mod || pulse.changed(pulse.ADD_REM) || Params$1.some(modp))) return;
      const data = pulse.materialize(pulse.SOURCE).source,
            layout = this.value,
            as = _.as || Output;
      let fontSize = _.fontSize || 14,
          range;
      isFunction(fontSize) ? range = _.fontSizeRange : fontSize = constant$4(fontSize); // create font size scaling function as needed

      if (range) {
        const fsize = fontSize,
              sizeScale = scale$4('sqrt')().domain(extent(data, fsize)).range(range);

        fontSize = x => sizeScale(fsize(x));
      }

      data.forEach(t => {
        t[as[0]] = NaN;
        t[as[1]] = NaN;
        t[as[3]] = 0;
      }); // configure layout

      const words = layout.words(data).text(_.text).size(_.size || [500, 500]).padding(_.padding || 1).spiral(_.spiral || 'archimedean').rotate(_.rotate || 0).font(_.font || 'sans-serif').fontStyle(_.fontStyle || 'normal').fontWeight(_.fontWeight || 'normal').fontSize(fontSize).random(exports.random).layout();
      const size = layout.size(),
            dx = size[0] >> 1,
            dy = size[1] >> 1,
            n = words.length;

      for (let i = 0, w, t; i < n; ++i) {
        w = words[i];
        t = w.datum;
        t[as[0]] = w.x + dx;
        t[as[1]] = w.y + dy;
        t[as[2]] = w.font;
        t[as[3]] = w.size;
        t[as[4]] = w.style;
        t[as[5]] = w.weight;
        t[as[6]] = w.rotate;
      }

      return pulse.reflow(mod).modifies(as);
    }

  });

  var wordcloud = /*#__PURE__*/Object.freeze({
    __proto__: null,
    wordcloud: Wordcloud
  });

  const array8 = n => new Uint8Array(n);

  const array16 = n => new Uint16Array(n);

  const array32 = n => new Uint32Array(n);
  /**
   * Maintains CrossFilter state.
   */


  function Bitmaps() {
    let width = 8,
        data = [],
        seen = array32(0),
        curr = array$1(0, width),
        prev = array$1(0, width);
    return {
      data: () => data,
      seen: () => seen = lengthen(seen, data.length),

      add(array) {
        for (let i = 0, j = data.length, n = array.length, t; i < n; ++i) {
          t = array[i];
          t._index = j++;
          data.push(t);
        }
      },

      remove(num, map) {
        // map: index -> boolean (true => remove)
        const n = data.length,
              copy = Array(n - num),
              reindex = data; // reuse old data array for index map

        let t, i, j; // seek forward to first removal

        for (i = 0; !map[i] && i < n; ++i) {
          copy[i] = data[i];
          reindex[i] = i;
        } // condense arrays


        for (j = i; i < n; ++i) {
          t = data[i];

          if (!map[i]) {
            reindex[i] = j;
            curr[j] = curr[i];
            prev[j] = prev[i];
            copy[j] = t;
            t._index = j++;
          } else {
            reindex[i] = -1;
          }

          curr[i] = 0; // clear unused bits
        }

        data = copy;
        return reindex;
      },

      size: () => data.length,
      curr: () => curr,
      prev: () => prev,
      reset: k => prev[k] = curr[k],
      all: () => width < 0x101 ? 0xff : width < 0x10001 ? 0xffff : 0xffffffff,

      set(k, one) {
        curr[k] |= one;
      },

      clear(k, one) {
        curr[k] &= ~one;
      },

      resize(n, m) {
        const k = curr.length;

        if (n > k || m > width) {
          width = Math.max(m, width);
          curr = array$1(n, width, curr);
          prev = array$1(n, width);
        }
      }

    };
  }

  function lengthen(array, length, copy) {
    if (array.length >= length) return array;
    copy = copy || new array.constructor(length);
    copy.set(array);
    return copy;
  }

  function array$1(n, m, array) {
    const copy = (m < 0x101 ? array8 : m < 0x10001 ? array16 : array32)(n);
    if (array) copy.set(array);
    return copy;
  }

  function Dimension(index, i, query) {
    const bit = 1 << i;
    return {
      one: bit,
      zero: ~bit,
      range: query.slice(),
      bisect: index.bisect,
      index: index.index,
      size: index.size,

      onAdd(added, curr) {
        const dim = this,
              range = dim.bisect(dim.range, added.value),
              idx = added.index,
              lo = range[0],
              hi = range[1],
              n1 = idx.length;
        let i;

        for (i = 0; i < lo; ++i) curr[idx[i]] |= bit;

        for (i = hi; i < n1; ++i) curr[idx[i]] |= bit;

        return dim;
      }

    };
  }
  /**
   * Maintains a list of values, sorted by key.
   */


  function SortedIndex() {
    let index = array32(0),
        value = [],
        size = 0;

    function insert(key, data, base) {
      if (!data.length) return [];
      const n0 = size,
            n1 = data.length,
            addi = array32(n1);
      let addv = Array(n1),
          oldv,
          oldi,
          i;

      for (i = 0; i < n1; ++i) {
        addv[i] = key(data[i]);
        addi[i] = i;
      }

      addv = sort(addv, addi);

      if (n0) {
        oldv = value;
        oldi = index;
        value = Array(n0 + n1);
        index = array32(n0 + n1);
        merge$1(base, oldv, oldi, n0, addv, addi, n1, value, index);
      } else {
        if (base > 0) for (i = 0; i < n1; ++i) {
          addi[i] += base;
        }
        value = addv;
        index = addi;
      }

      size = n0 + n1;
      return {
        index: addi,
        value: addv
      };
    }

    function remove(num, map) {
      // map: index -> remove
      const n = size;
      let idx, i, j; // seek forward to first removal

      for (i = 0; !map[index[i]] && i < n; ++i); // condense index and value arrays


      for (j = i; i < n; ++i) {
        if (!map[idx = index[i]]) {
          index[j] = idx;
          value[j] = value[i];
          ++j;
        }
      }

      size = n - num;
    }

    function reindex(map) {
      for (let i = 0, n = size; i < n; ++i) {
        index[i] = map[index[i]];
      }
    }

    function bisect(range, array) {
      let n;

      if (array) {
        n = array.length;
      } else {
        array = value;
        n = size;
      }

      return [bisectLeft$1(array, range[0], 0, n), bisectRight$1(array, range[1], 0, n)];
    }

    return {
      insert: insert,
      remove: remove,
      bisect: bisect,
      reindex: reindex,
      index: () => index,
      size: () => size
    };
  }

  function sort(values, index) {
    values.sort.call(index, (a, b) => {
      const x = values[a],
            y = values[b];
      return x < y ? -1 : x > y ? 1 : 0;
    });
    return permute(values, index);
  }

  function merge$1(base, value0, index0, n0, value1, index1, n1, value, index) {
    let i0 = 0,
        i1 = 0,
        i;

    for (i = 0; i0 < n0 && i1 < n1; ++i) {
      if (value0[i0] < value1[i1]) {
        value[i] = value0[i0];
        index[i] = index0[i0++];
      } else {
        value[i] = value1[i1];
        index[i] = index1[i1++] + base;
      }
    }

    for (; i0 < n0; ++i0, ++i) {
      value[i] = value0[i0];
      index[i] = index0[i0];
    }

    for (; i1 < n1; ++i1, ++i) {
      value[i] = value1[i1];
      index[i] = index1[i1] + base;
    }
  }
  /**
   * An indexed multi-dimensional filter.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {Array<function(object): *>} params.fields - An array of dimension accessors to filter.
   * @param {Array} params.query - An array of per-dimension range queries.
   */


  function CrossFilter(params) {
    Transform.call(this, Bitmaps(), params);
    this._indices = null;
    this._dims = null;
  }

  CrossFilter.Definition = {
    'type': 'CrossFilter',
    'metadata': {},
    'params': [{
      'name': 'fields',
      'type': 'field',
      'array': true,
      'required': true
    }, {
      'name': 'query',
      'type': 'array',
      'array': true,
      'required': true,
      'content': {
        'type': 'number',
        'array': true,
        'length': 2
      }
    }]
  };
  inherits(CrossFilter, Transform, {
    transform(_, pulse) {
      if (!this._dims) {
        return this.init(_, pulse);
      } else {
        var init = _.modified('fields') || _.fields.some(f => pulse.modified(f.fields));

        return init ? this.reinit(_, pulse) : this.eval(_, pulse);
      }
    },

    init(_, pulse) {
      const fields = _.fields,
            query = _.query,
            indices = this._indices = {},
            dims = this._dims = [],
            m = query.length;
      let i = 0,
          key,
          index; // instantiate indices and dimensions

      for (; i < m; ++i) {
        key = fields[i].fname;
        index = indices[key] || (indices[key] = SortedIndex());
        dims.push(Dimension(index, i, query[i]));
      }

      return this.eval(_, pulse);
    },

    reinit(_, pulse) {
      const output = pulse.materialize().fork(),
            fields = _.fields,
            query = _.query,
            indices = this._indices,
            dims = this._dims,
            bits = this.value,
            curr = bits.curr(),
            prev = bits.prev(),
            all = bits.all(),
            out = output.rem = output.add,
            mod = output.mod,
            m = query.length,
            adds = {};
      let add, index, key, mods, remMap, modMap, i, n, f; // set prev to current state

      prev.set(curr); // if pulse has remove tuples, process them first

      if (pulse.rem.length) {
        remMap = this.remove(_, pulse, output);
      } // if pulse has added tuples, add them to state


      if (pulse.add.length) {
        bits.add(pulse.add);
      } // if pulse has modified tuples, create an index map


      if (pulse.mod.length) {
        modMap = {};

        for (mods = pulse.mod, i = 0, n = mods.length; i < n; ++i) {
          modMap[mods[i]._index] = 1;
        }
      } // re-initialize indices as needed, update curr bitmap


      for (i = 0; i < m; ++i) {
        f = fields[i];

        if (!dims[i] || _.modified('fields', i) || pulse.modified(f.fields)) {
          key = f.fname;

          if (!(add = adds[key])) {
            indices[key] = index = SortedIndex();
            adds[key] = add = index.insert(f, pulse.source, 0);
          }

          dims[i] = Dimension(index, i, query[i]).onAdd(add, curr);
        }
      } // visit each tuple
      // if filter state changed, push index to add/rem
      // else if in mod and passes a filter, push index to mod


      for (i = 0, n = bits.data().length; i < n; ++i) {
        if (remMap[i]) {
          // skip if removed tuple
          continue;
        } else if (prev[i] !== curr[i]) {
          // add if state changed
          out.push(i);
        } else if (modMap[i] && curr[i] !== all) {
          // otherwise, pass mods through
          mod.push(i);
        }
      }

      bits.mask = (1 << m) - 1;
      return output;
    },

    eval(_, pulse) {
      const output = pulse.materialize().fork(),
            m = this._dims.length;
      let mask = 0;

      if (pulse.rem.length) {
        this.remove(_, pulse, output);
        mask |= (1 << m) - 1;
      }

      if (_.modified('query') && !_.modified('fields')) {
        mask |= this.update(_, pulse, output);
      }

      if (pulse.add.length) {
        this.insert(_, pulse, output);
        mask |= (1 << m) - 1;
      }

      if (pulse.mod.length) {
        this.modify(pulse, output);
        mask |= (1 << m) - 1;
      }

      this.value.mask = mask;
      return output;
    },

    insert(_, pulse, output) {
      const tuples = pulse.add,
            bits = this.value,
            dims = this._dims,
            indices = this._indices,
            fields = _.fields,
            adds = {},
            out = output.add,
            n = bits.size() + tuples.length,
            m = dims.length;
      let k = bits.size(),
          j,
          key,
          add; // resize bitmaps and add tuples as needed

      bits.resize(n, m);
      bits.add(tuples);
      const curr = bits.curr(),
            prev = bits.prev(),
            all = bits.all(); // add to dimensional indices

      for (j = 0; j < m; ++j) {
        key = fields[j].fname;
        add = adds[key] || (adds[key] = indices[key].insert(fields[j], tuples, k));
        dims[j].onAdd(add, curr);
      } // set previous filters, output if passes at least one filter


      for (; k < n; ++k) {
        prev[k] = all;
        if (curr[k] !== all) out.push(k);
      }
    },

    modify(pulse, output) {
      const out = output.mod,
            bits = this.value,
            curr = bits.curr(),
            all = bits.all(),
            tuples = pulse.mod;
      let i, n, k;

      for (i = 0, n = tuples.length; i < n; ++i) {
        k = tuples[i]._index;
        if (curr[k] !== all) out.push(k);
      }
    },

    remove(_, pulse, output) {
      const indices = this._indices,
            bits = this.value,
            curr = bits.curr(),
            prev = bits.prev(),
            all = bits.all(),
            map = {},
            out = output.rem,
            tuples = pulse.rem;
      let i, n, k, f; // process tuples, output if passes at least one filter

      for (i = 0, n = tuples.length; i < n; ++i) {
        k = tuples[i]._index;
        map[k] = 1; // build index map

        prev[k] = f = curr[k];
        curr[k] = all;
        if (f !== all) out.push(k);
      } // remove from dimensional indices


      for (k in indices) {
        indices[k].remove(n, map);
      }

      this.reindex(pulse, n, map);
      return map;
    },

    // reindex filters and indices after propagation completes
    reindex(pulse, num, map) {
      const indices = this._indices,
            bits = this.value;
      pulse.runAfter(() => {
        const indexMap = bits.remove(num, map);

        for (const key in indices) indices[key].reindex(indexMap);
      });
    },

    update(_, pulse, output) {
      const dims = this._dims,
            query = _.query,
            stamp = pulse.stamp,
            m = dims.length;
      let mask = 0,
          i,
          q; // survey how many queries have changed

      output.filters = 0;

      for (q = 0; q < m; ++q) {
        if (_.modified('query', q)) {
          i = q;
          ++mask;
        }
      }

      if (mask === 1) {
        // only one query changed, use more efficient update
        mask = dims[i].one;
        this.incrementOne(dims[i], query[i], output.add, output.rem);
      } else {
        // multiple queries changed, perform full record keeping
        for (q = 0, mask = 0; q < m; ++q) {
          if (!_.modified('query', q)) continue;
          mask |= dims[q].one;
          this.incrementAll(dims[q], query[q], stamp, output.add);
          output.rem = output.add; // duplicate add/rem for downstream resolve
        }
      }

      return mask;
    },

    incrementAll(dim, query, stamp, out) {
      const bits = this.value,
            seen = bits.seen(),
            curr = bits.curr(),
            prev = bits.prev(),
            index = dim.index(),
            old = dim.bisect(dim.range),
            range = dim.bisect(query),
            lo1 = range[0],
            hi1 = range[1],
            lo0 = old[0],
            hi0 = old[1],
            one = dim.one;
      let i, j, k; // Fast incremental update based on previous lo index.

      if (lo1 < lo0) {
        for (i = lo1, j = Math.min(lo0, hi1); i < j; ++i) {
          k = index[i];

          if (seen[k] !== stamp) {
            prev[k] = curr[k];
            seen[k] = stamp;
            out.push(k);
          }

          curr[k] ^= one;
        }
      } else if (lo1 > lo0) {
        for (i = lo0, j = Math.min(lo1, hi0); i < j; ++i) {
          k = index[i];

          if (seen[k] !== stamp) {
            prev[k] = curr[k];
            seen[k] = stamp;
            out.push(k);
          }

          curr[k] ^= one;
        }
      } // Fast incremental update based on previous hi index.


      if (hi1 > hi0) {
        for (i = Math.max(lo1, hi0), j = hi1; i < j; ++i) {
          k = index[i];

          if (seen[k] !== stamp) {
            prev[k] = curr[k];
            seen[k] = stamp;
            out.push(k);
          }

          curr[k] ^= one;
        }
      } else if (hi1 < hi0) {
        for (i = Math.max(lo0, hi1), j = hi0; i < j; ++i) {
          k = index[i];

          if (seen[k] !== stamp) {
            prev[k] = curr[k];
            seen[k] = stamp;
            out.push(k);
          }

          curr[k] ^= one;
        }
      }

      dim.range = query.slice();
    },

    incrementOne(dim, query, add, rem) {
      const bits = this.value,
            curr = bits.curr(),
            index = dim.index(),
            old = dim.bisect(dim.range),
            range = dim.bisect(query),
            lo1 = range[0],
            hi1 = range[1],
            lo0 = old[0],
            hi0 = old[1],
            one = dim.one;
      let i, j, k; // Fast incremental update based on previous lo index.

      if (lo1 < lo0) {
        for (i = lo1, j = Math.min(lo0, hi1); i < j; ++i) {
          k = index[i];
          curr[k] ^= one;
          add.push(k);
        }
      } else if (lo1 > lo0) {
        for (i = lo0, j = Math.min(lo1, hi0); i < j; ++i) {
          k = index[i];
          curr[k] ^= one;
          rem.push(k);
        }
      } // Fast incremental update based on previous hi index.


      if (hi1 > hi0) {
        for (i = Math.max(lo1, hi0), j = hi1; i < j; ++i) {
          k = index[i];
          curr[k] ^= one;
          add.push(k);
        }
      } else if (hi1 < hi0) {
        for (i = Math.max(lo0, hi1), j = hi0; i < j; ++i) {
          k = index[i];
          curr[k] ^= one;
          rem.push(k);
        }
      }

      dim.range = query.slice();
    }

  });
  /**
   * Selectively filters tuples by resolving against a filter bitmap.
   * Useful for processing the output of a cross-filter transform.
   * @constructor
   * @param {object} params - The parameters for this operator.
   * @param {object} params.ignore - A bit mask indicating which filters to ignore.
   * @param {object} params.filter - The per-tuple filter bitmaps. Typically this
   *   parameter value is a reference to a {@link CrossFilter} transform.
   */

  function ResolveFilter(params) {
    Transform.call(this, null, params);
  }

  ResolveFilter.Definition = {
    'type': 'ResolveFilter',
    'metadata': {},
    'params': [{
      'name': 'ignore',
      'type': 'number',
      'required': true,
      'description': 'A bit mask indicating which filters to ignore.'
    }, {
      'name': 'filter',
      'type': 'object',
      'required': true,
      'description': 'Per-tuple filter bitmaps from a CrossFilter transform.'
    }]
  };
  inherits(ResolveFilter, Transform, {
    transform(_, pulse) {
      const ignore = ~(_.ignore || 0),
            // bit mask where zeros -> dims to ignore
      bitmap = _.filter,
            mask = bitmap.mask; // exit early if no relevant filter changes

      if ((mask & ignore) === 0) return pulse.StopPropagation;

      const output = pulse.fork(pulse.ALL),
            data = bitmap.data(),
            curr = bitmap.curr(),
            prev = bitmap.prev(),
            pass = k => !(curr[k] & ignore) ? data[k] : null; // propagate all mod tuples that pass the filter


      output.filter(output.MOD, pass); // determine add & rem tuples via filter functions
      // for efficiency, we do *not* populate new arrays,
      // instead we add filter functions applied downstream

      if (!(mask & mask - 1)) {
        // only one filter changed
        output.filter(output.ADD, pass);
        output.filter(output.REM, k => (curr[k] & ignore) === mask ? data[k] : null);
      } else {
        // multiple filters changed
        output.filter(output.ADD, k => {
          const c = curr[k] & ignore,
                f = !c && c ^ prev[k] & ignore;
          return f ? data[k] : null;
        });
        output.filter(output.REM, k => {
          const c = curr[k] & ignore,
                f = c && !(c ^ (c ^ prev[k] & ignore));
          return f ? data[k] : null;
        });
      } // add filter to source data in case of reflow...


      return output.filter(output.SOURCE, t => pass(t._index));
    }

  });

  var xf = /*#__PURE__*/Object.freeze({
    __proto__: null,
    crossfilter: CrossFilter,
    resolvefilter: ResolveFilter
  });

  const RawCode = 'RawCode';
  const Literal = 'Literal';
  const Property = 'Property';
  const Identifier = 'Identifier';
  const ArrayExpression = 'ArrayExpression';
  const BinaryExpression = 'BinaryExpression';
  const CallExpression = 'CallExpression';
  const ConditionalExpression = 'ConditionalExpression';
  const LogicalExpression = 'LogicalExpression';
  const MemberExpression = 'MemberExpression';
  const ObjectExpression = 'ObjectExpression';
  const UnaryExpression = 'UnaryExpression';

  function ASTNode(type) {
    this.type = type;
  }

  ASTNode.prototype.visit = function (visitor) {
    let c, i, n;
    if (visitor(this)) return 1;

    for (c = children(this), i = 0, n = c.length; i < n; ++i) {
      if (c[i].visit(visitor)) return 1;
    }
  };

  function children(node) {
    switch (node.type) {
      case ArrayExpression:
        return node.elements;

      case BinaryExpression:
      case LogicalExpression:
        return [node.left, node.right];

      case CallExpression:
        return [node.callee].concat(node.arguments);

      case ConditionalExpression:
        return [node.test, node.consequent, node.alternate];

      case MemberExpression:
        return [node.object, node.property];

      case ObjectExpression:
        return node.properties;

      case Property:
        return [node.key, node.value];

      case UnaryExpression:
        return [node.argument];

      case Identifier:
      case Literal:
      case RawCode:
      default:
        return [];
    }
  }
  /*
    The following expression parser is based on Esprima (http://esprima.org/).
    Original header comment and license for Esprima is included here:

    Copyright (C) 2013 Ariya Hidayat <ariya.hidayat@gmail.com>
    Copyright (C) 2013 Thaddee Tyl <thaddee.tyl@gmail.com>
    Copyright (C) 2013 Mathias Bynens <mathias@qiwi.be>
    Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>
    Copyright (C) 2012 Mathias Bynens <mathias@qiwi.be>
    Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
    Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
    Copyright (C) 2012 Yusuke Suzuki <utatane.tea@gmail.com>
    Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>
    Copyright (C) 2011 Ariya Hidayat <ariya.hidayat@gmail.com>

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are met:

      * Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
      * Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
    AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
    IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
    ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
    DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
    (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
    LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
    ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
    THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */


  var TokenName, source, index, length, lookahead;
  var TokenBooleanLiteral = 1,
      TokenEOF = 2,
      TokenIdentifier = 3,
      TokenKeyword = 4,
      TokenNullLiteral = 5,
      TokenNumericLiteral = 6,
      TokenPunctuator = 7,
      TokenStringLiteral = 8,
      TokenRegularExpression = 9;
  TokenName = {};
  TokenName[TokenBooleanLiteral] = 'Boolean';
  TokenName[TokenEOF] = '<end>';
  TokenName[TokenIdentifier] = 'Identifier';
  TokenName[TokenKeyword] = 'Keyword';
  TokenName[TokenNullLiteral] = 'Null';
  TokenName[TokenNumericLiteral] = 'Numeric';
  TokenName[TokenPunctuator] = 'Punctuator';
  TokenName[TokenStringLiteral] = 'String';
  TokenName[TokenRegularExpression] = 'RegularExpression';
  var SyntaxArrayExpression = 'ArrayExpression',
      SyntaxBinaryExpression = 'BinaryExpression',
      SyntaxCallExpression = 'CallExpression',
      SyntaxConditionalExpression = 'ConditionalExpression',
      SyntaxIdentifier = 'Identifier',
      SyntaxLiteral = 'Literal',
      SyntaxLogicalExpression = 'LogicalExpression',
      SyntaxMemberExpression = 'MemberExpression',
      SyntaxObjectExpression = 'ObjectExpression',
      SyntaxProperty = 'Property',
      SyntaxUnaryExpression = 'UnaryExpression'; // Error messages should be identical to V8.

  var MessageUnexpectedToken = 'Unexpected token %0',
      MessageUnexpectedNumber = 'Unexpected number',
      MessageUnexpectedString = 'Unexpected string',
      MessageUnexpectedIdentifier = 'Unexpected identifier',
      MessageUnexpectedReserved = 'Unexpected reserved word',
      MessageUnexpectedEOS = 'Unexpected end of input',
      MessageInvalidRegExp = 'Invalid regular expression',
      MessageUnterminatedRegExp = 'Invalid regular expression: missing /',
      MessageStrictOctalLiteral = 'Octal literals are not allowed in strict mode.',
      MessageStrictDuplicateProperty = 'Duplicate data property in object literal not allowed in strict mode';
  var ILLEGAL$1 = 'ILLEGAL',
      DISABLED = 'Disabled.'; // See also tools/generate-unicode-regex.py.

  var RegexNonAsciiIdentifierStart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]'),
      // eslint-disable-next-line no-misleading-character-class
  RegexNonAsciiIdentifierPart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]'); // Ensure the condition is true, otherwise throw an error.
  // This is only to have a better contract semantic, i.e. another safety net
  // to catch a logic error. The condition shall be fulfilled in normal case.
  // Do NOT use this to enforce a certain condition on any user input.

  function assert(condition, message) {
    /* istanbul ignore next */
    if (!condition) {
      throw new Error('ASSERT: ' + message);
    }
  }

  function isDecimalDigit(ch) {
    return ch >= 0x30 && ch <= 0x39; // 0..9
  }

  function isHexDigit(ch) {
    return '0123456789abcdefABCDEF'.indexOf(ch) >= 0;
  }

  function isOctalDigit(ch) {
    return '01234567'.indexOf(ch) >= 0;
  } // 7.2 White Space


  function isWhiteSpace(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && [0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF].indexOf(ch) >= 0;
  } // 7.3 Line Terminators


  function isLineTerminator(ch) {
    return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
  } // 7.6 Identifier Names and Identifiers


  function isIdentifierStart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierStart.test(String.fromCharCode(ch));
  }

  function isIdentifierPart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch >= 0x30 && ch <= 0x39 || // 0..9
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierPart.test(String.fromCharCode(ch));
  } // 7.6.1.1 Keywords


  const keywords = {
    'if': 1,
    'in': 1,
    'do': 1,
    'var': 1,
    'for': 1,
    'new': 1,
    'try': 1,
    'let': 1,
    'this': 1,
    'else': 1,
    'case': 1,
    'void': 1,
    'with': 1,
    'enum': 1,
    'while': 1,
    'break': 1,
    'catch': 1,
    'throw': 1,
    'const': 1,
    'yield': 1,
    'class': 1,
    'super': 1,
    'return': 1,
    'typeof': 1,
    'delete': 1,
    'switch': 1,
    'export': 1,
    'import': 1,
    'public': 1,
    'static': 1,
    'default': 1,
    'finally': 1,
    'extends': 1,
    'package': 1,
    'private': 1,
    'function': 1,
    'continue': 1,
    'debugger': 1,
    'interface': 1,
    'protected': 1,
    'instanceof': 1,
    'implements': 1
  };

  function skipComment() {
    while (index < length) {
      const ch = source.charCodeAt(index);

      if (isWhiteSpace(ch) || isLineTerminator(ch)) {
        ++index;
      } else {
        break;
      }
    }
  }

  function scanHexEscape(prefix) {
    var i,
        len,
        ch,
        code = 0;
    len = prefix === 'u' ? 4 : 2;

    for (i = 0; i < len; ++i) {
      if (index < length && isHexDigit(source[index])) {
        ch = source[index++];
        code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
      } else {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      }
    }

    return String.fromCharCode(code);
  }

  function scanUnicodeCodePointEscape() {
    var ch, code, cu1, cu2;
    ch = source[index];
    code = 0; // At least, one hex digit is required.

    if (ch === '}') {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }

    while (index < length) {
      ch = source[index++];

      if (!isHexDigit(ch)) {
        break;
      }

      code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    }

    if (code > 0x10FFFF || ch !== '}') {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    } // UTF-16 Encoding


    if (code <= 0xFFFF) {
      return String.fromCharCode(code);
    }

    cu1 = (code - 0x10000 >> 10) + 0xD800;
    cu2 = (code - 0x10000 & 1023) + 0xDC00;
    return String.fromCharCode(cu1, cu2);
  }

  function getEscapedIdentifier() {
    var ch, id;
    ch = source.charCodeAt(index++);
    id = String.fromCharCode(ch); // '\u' (U+005C, U+0075) denotes an escaped character.

    if (ch === 0x5C) {
      if (source.charCodeAt(index) !== 0x75) {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      }

      ++index;
      ch = scanHexEscape('u');

      if (!ch || ch === '\\' || !isIdentifierStart(ch.charCodeAt(0))) {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      }

      id = ch;
    }

    while (index < length) {
      ch = source.charCodeAt(index);

      if (!isIdentifierPart(ch)) {
        break;
      }

      ++index;
      id += String.fromCharCode(ch); // '\u' (U+005C, U+0075) denotes an escaped character.

      if (ch === 0x5C) {
        id = id.substr(0, id.length - 1);

        if (source.charCodeAt(index) !== 0x75) {
          throwError({}, MessageUnexpectedToken, ILLEGAL$1);
        }

        ++index;
        ch = scanHexEscape('u');

        if (!ch || ch === '\\' || !isIdentifierPart(ch.charCodeAt(0))) {
          throwError({}, MessageUnexpectedToken, ILLEGAL$1);
        }

        id += ch;
      }
    }

    return id;
  }

  function getIdentifier() {
    var start, ch;
    start = index++;

    while (index < length) {
      ch = source.charCodeAt(index);

      if (ch === 0x5C) {
        // Blackslash (U+005C) marks Unicode escape sequence.
        index = start;
        return getEscapedIdentifier();
      }

      if (isIdentifierPart(ch)) {
        ++index;
      } else {
        break;
      }
    }

    return source.slice(start, index);
  }

  function scanIdentifier() {
    var start, id, type;
    start = index; // Backslash (U+005C) starts an escaped character.

    id = source.charCodeAt(index) === 0x5C ? getEscapedIdentifier() : getIdentifier(); // There is no keyword or literal with only one character.
    // Thus, it must be an identifier.

    if (id.length === 1) {
      type = TokenIdentifier;
    } else if (keywords.hasOwnProperty(id)) {
      // eslint-disable-line no-prototype-builtins
      type = TokenKeyword;
    } else if (id === 'null') {
      type = TokenNullLiteral;
    } else if (id === 'true' || id === 'false') {
      type = TokenBooleanLiteral;
    } else {
      type = TokenIdentifier;
    }

    return {
      type: type,
      value: id,
      start: start,
      end: index
    };
  } // 7.7 Punctuators


  function scanPunctuator() {
    var start = index,
        code = source.charCodeAt(index),
        code2,
        ch1 = source[index],
        ch2,
        ch3,
        ch4;

    switch (code) {
      // Check for most common single-character punctuators.
      case 0x2E: // . dot

      case 0x28: // ( open bracket

      case 0x29: // ) close bracket

      case 0x3B: // ; semicolon

      case 0x2C: // , comma

      case 0x7B: // { open curly brace

      case 0x7D: // } close curly brace

      case 0x5B: // [

      case 0x5D: // ]

      case 0x3A: // :

      case 0x3F: // ?

      case 0x7E:
        // ~
        ++index;
        return {
          type: TokenPunctuator,
          value: String.fromCharCode(code),
          start: start,
          end: index
        };

      default:
        code2 = source.charCodeAt(index + 1); // '=' (U+003D) marks an assignment or comparison operator.

        if (code2 === 0x3D) {
          switch (code) {
            case 0x2B: // +

            case 0x2D: // -

            case 0x2F: // /

            case 0x3C: // <

            case 0x3E: // >

            case 0x5E: // ^

            case 0x7C: // |

            case 0x25: // %

            case 0x26: // &

            case 0x2A:
              // *
              index += 2;
              return {
                type: TokenPunctuator,
                value: String.fromCharCode(code) + String.fromCharCode(code2),
                start: start,
                end: index
              };

            case 0x21: // !

            case 0x3D:
              // =
              index += 2; // !== and ===

              if (source.charCodeAt(index) === 0x3D) {
                ++index;
              }

              return {
                type: TokenPunctuator,
                value: source.slice(start, index),
                start: start,
                end: index
              };
          }
        }

    } // 4-character punctuator: >>>=


    ch4 = source.substr(index, 4);

    if (ch4 === '>>>=') {
      index += 4;
      return {
        type: TokenPunctuator,
        value: ch4,
        start: start,
        end: index
      };
    } // 3-character punctuators: === !== >>> <<= >>=


    ch3 = ch4.substr(0, 3);

    if (ch3 === '>>>' || ch3 === '<<=' || ch3 === '>>=') {
      index += 3;
      return {
        type: TokenPunctuator,
        value: ch3,
        start: start,
        end: index
      };
    } // Other 2-character punctuators: ++ -- << >> && ||


    ch2 = ch3.substr(0, 2);

    if (ch1 === ch2[1] && '+-<>&|'.indexOf(ch1) >= 0 || ch2 === '=>') {
      index += 2;
      return {
        type: TokenPunctuator,
        value: ch2,
        start: start,
        end: index
      };
    }

    if (ch2 === '//') {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    } // 1-character punctuators: < > = ! + - * % & | ^ /


    if ('<>=!+-*%&|^/'.indexOf(ch1) >= 0) {
      ++index;
      return {
        type: TokenPunctuator,
        value: ch1,
        start: start,
        end: index
      };
    }

    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  } // 7.8.3 Numeric Literals


  function scanHexLiteral(start) {
    let number = '';

    while (index < length) {
      if (!isHexDigit(source[index])) {
        break;
      }

      number += source[index++];
    }

    if (number.length === 0) {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }

    if (isIdentifierStart(source.charCodeAt(index))) {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }

    return {
      type: TokenNumericLiteral,
      value: parseInt('0x' + number, 16),
      start: start,
      end: index
    };
  }

  function scanOctalLiteral(start) {
    let number = '0' + source[index++];

    while (index < length) {
      if (!isOctalDigit(source[index])) {
        break;
      }

      number += source[index++];
    }

    if (isIdentifierStart(source.charCodeAt(index)) || isDecimalDigit(source.charCodeAt(index))) {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }

    return {
      type: TokenNumericLiteral,
      value: parseInt(number, 8),
      octal: true,
      start: start,
      end: index
    };
  }

  function scanNumericLiteral() {
    var number, start, ch;
    ch = source[index];
    assert(isDecimalDigit(ch.charCodeAt(0)) || ch === '.', 'Numeric literal must start with a decimal digit or a decimal point');
    start = index;
    number = '';

    if (ch !== '.') {
      number = source[index++];
      ch = source[index]; // Hex number starts with '0x'.
      // Octal number starts with '0'.

      if (number === '0') {
        if (ch === 'x' || ch === 'X') {
          ++index;
          return scanHexLiteral(start);
        }

        if (isOctalDigit(ch)) {
          return scanOctalLiteral(start);
        } // decimal number starts with '0' such as '09' is illegal.


        if (ch && isDecimalDigit(ch.charCodeAt(0))) {
          throwError({}, MessageUnexpectedToken, ILLEGAL$1);
        }
      }

      while (isDecimalDigit(source.charCodeAt(index))) {
        number += source[index++];
      }

      ch = source[index];
    }

    if (ch === '.') {
      number += source[index++];

      while (isDecimalDigit(source.charCodeAt(index))) {
        number += source[index++];
      }

      ch = source[index];
    }

    if (ch === 'e' || ch === 'E') {
      number += source[index++];
      ch = source[index];

      if (ch === '+' || ch === '-') {
        number += source[index++];
      }

      if (isDecimalDigit(source.charCodeAt(index))) {
        while (isDecimalDigit(source.charCodeAt(index))) {
          number += source[index++];
        }
      } else {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      }
    }

    if (isIdentifierStart(source.charCodeAt(index))) {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }

    return {
      type: TokenNumericLiteral,
      value: parseFloat(number),
      start: start,
      end: index
    };
  } // 7.8.4 String Literals


  function scanStringLiteral() {
    var str = '',
        quote,
        start,
        ch,
        code,
        octal = false;
    quote = source[index];
    assert(quote === '\'' || quote === '"', 'String literal must starts with a quote');
    start = index;
    ++index;

    while (index < length) {
      ch = source[index++];

      if (ch === quote) {
        quote = '';
        break;
      } else if (ch === '\\') {
        ch = source[index++];

        if (!ch || !isLineTerminator(ch.charCodeAt(0))) {
          switch (ch) {
            case 'u':
            case 'x':
              if (source[index] === '{') {
                ++index;
                str += scanUnicodeCodePointEscape();
              } else {
                str += scanHexEscape(ch);
              }

              break;

            case 'n':
              str += '\n';
              break;

            case 'r':
              str += '\r';
              break;

            case 't':
              str += '\t';
              break;

            case 'b':
              str += '\b';
              break;

            case 'f':
              str += '\f';
              break;

            case 'v':
              str += '\x0B';
              break;

            default:
              if (isOctalDigit(ch)) {
                code = '01234567'.indexOf(ch); // \0 is not octal escape sequence

                if (code !== 0) {
                  octal = true;
                }

                if (index < length && isOctalDigit(source[index])) {
                  octal = true;
                  code = code * 8 + '01234567'.indexOf(source[index++]); // 3 digits are only allowed when string starts
                  // with 0, 1, 2, 3

                  if ('0123'.indexOf(ch) >= 0 && index < length && isOctalDigit(source[index])) {
                    code = code * 8 + '01234567'.indexOf(source[index++]);
                  }
                }

                str += String.fromCharCode(code);
              } else {
                str += ch;
              }

              break;
          }
        } else {
          if (ch === '\r' && source[index] === '\n') {
            ++index;
          }
        }
      } else if (isLineTerminator(ch.charCodeAt(0))) {
        break;
      } else {
        str += ch;
      }
    }

    if (quote !== '') {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }

    return {
      type: TokenStringLiteral,
      value: str,
      octal: octal,
      start: start,
      end: index
    };
  }

  function testRegExp(pattern, flags) {
    let tmp = pattern;

    if (flags.indexOf('u') >= 0) {
      // Replace each astral symbol and every Unicode code point
      // escape sequence with a single ASCII symbol to avoid throwing on
      // regular expressions that are only valid in combination with the
      // `/u` flag.
      // Note: replacing with the ASCII symbol `x` might cause false
      // negatives in unlikely scenarios. For example, `[\u{61}-b]` is a
      // perfectly valid pattern that is equivalent to `[a-b]`, but it
      // would be replaced by `[x-b]` which throws an error.
      tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}/g, ($0, $1) => {
        if (parseInt($1, 16) <= 0x10FFFF) {
          return 'x';
        }

        throwError({}, MessageInvalidRegExp);
      }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, 'x');
    } // First, detect invalid regular expressions.


    try {
      new RegExp(tmp);
    } catch (e) {
      throwError({}, MessageInvalidRegExp);
    } // Return a regular expression object for this pattern-flag pair, or
    // `null` in case the current environment doesn't support the flags it
    // uses.


    try {
      return new RegExp(pattern, flags);
    } catch (exception) {
      return null;
    }
  }

  function scanRegExpBody() {
    var ch, str, classMarker, terminated, body;
    ch = source[index];
    assert(ch === '/', 'Regular expression literal must start with a slash');
    str = source[index++];
    classMarker = false;
    terminated = false;

    while (index < length) {
      ch = source[index++];
      str += ch;

      if (ch === '\\') {
        ch = source[index++]; // ECMA-262 7.8.5

        if (isLineTerminator(ch.charCodeAt(0))) {
          throwError({}, MessageUnterminatedRegExp);
        }

        str += ch;
      } else if (isLineTerminator(ch.charCodeAt(0))) {
        throwError({}, MessageUnterminatedRegExp);
      } else if (classMarker) {
        if (ch === ']') {
          classMarker = false;
        }
      } else {
        if (ch === '/') {
          terminated = true;
          break;
        } else if (ch === '[') {
          classMarker = true;
        }
      }
    }

    if (!terminated) {
      throwError({}, MessageUnterminatedRegExp);
    } // Exclude leading and trailing slash.


    body = str.substr(1, str.length - 2);
    return {
      value: body,
      literal: str
    };
  }

  function scanRegExpFlags() {
    var ch, str, flags;
    str = '';
    flags = '';

    while (index < length) {
      ch = source[index];

      if (!isIdentifierPart(ch.charCodeAt(0))) {
        break;
      }

      ++index;

      if (ch === '\\' && index < length) {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      } else {
        flags += ch;
        str += ch;
      }
    }

    if (flags.search(/[^gimuy]/g) >= 0) {
      throwError({}, MessageInvalidRegExp, flags);
    }

    return {
      value: flags,
      literal: str
    };
  }

  function scanRegExp() {
    var start, body, flags, value;
    lookahead = null;
    skipComment();
    start = index;
    body = scanRegExpBody();
    flags = scanRegExpFlags();
    value = testRegExp(body.value, flags.value);
    return {
      literal: body.literal + flags.literal,
      value: value,
      regex: {
        pattern: body.value,
        flags: flags.value
      },
      start: start,
      end: index
    };
  }

  function isIdentifierName(token) {
    return token.type === TokenIdentifier || token.type === TokenKeyword || token.type === TokenBooleanLiteral || token.type === TokenNullLiteral;
  }

  function advance() {
    skipComment();

    if (index >= length) {
      return {
        type: TokenEOF,
        start: index,
        end: index
      };
    }

    const ch = source.charCodeAt(index);

    if (isIdentifierStart(ch)) {
      return scanIdentifier();
    } // Very common: ( and ) and ;


    if (ch === 0x28 || ch === 0x29 || ch === 0x3B) {
      return scanPunctuator();
    } // String literal starts with single quote (U+0027) or double quote (U+0022).


    if (ch === 0x27 || ch === 0x22) {
      return scanStringLiteral();
    } // Dot (.) U+002E can also start a floating-point number, hence the need
    // to check the next character.


    if (ch === 0x2E) {
      if (isDecimalDigit(source.charCodeAt(index + 1))) {
        return scanNumericLiteral();
      }

      return scanPunctuator();
    }

    if (isDecimalDigit(ch)) {
      return scanNumericLiteral();
    }

    return scanPunctuator();
  }

  function lex() {
    const token = lookahead;
    index = token.end;
    lookahead = advance();
    index = token.end;
    return token;
  }

  function peek() {
    const pos = index;
    lookahead = advance();
    index = pos;
  }

  function finishArrayExpression(elements) {
    const node = new ASTNode(SyntaxArrayExpression);
    node.elements = elements;
    return node;
  }

  function finishBinaryExpression(operator, left, right) {
    const node = new ASTNode(operator === '||' || operator === '&&' ? SyntaxLogicalExpression : SyntaxBinaryExpression);
    node.operator = operator;
    node.left = left;
    node.right = right;
    return node;
  }

  function finishCallExpression(callee, args) {
    const node = new ASTNode(SyntaxCallExpression);
    node.callee = callee;
    node.arguments = args;
    return node;
  }

  function finishConditionalExpression(test, consequent, alternate) {
    const node = new ASTNode(SyntaxConditionalExpression);
    node.test = test;
    node.consequent = consequent;
    node.alternate = alternate;
    return node;
  }

  function finishIdentifier(name) {
    const node = new ASTNode(SyntaxIdentifier);
    node.name = name;
    return node;
  }

  function finishLiteral(token) {
    const node = new ASTNode(SyntaxLiteral);
    node.value = token.value;
    node.raw = source.slice(token.start, token.end);

    if (token.regex) {
      if (node.raw === '//') {
        node.raw = '/(?:)/';
      }

      node.regex = token.regex;
    }

    return node;
  }

  function finishMemberExpression(accessor, object, property) {
    const node = new ASTNode(SyntaxMemberExpression);
    node.computed = accessor === '[';
    node.object = object;
    node.property = property;
    if (!node.computed) property.member = true;
    return node;
  }

  function finishObjectExpression(properties) {
    const node = new ASTNode(SyntaxObjectExpression);
    node.properties = properties;
    return node;
  }

  function finishProperty(kind, key, value) {
    const node = new ASTNode(SyntaxProperty);
    node.key = key;
    node.value = value;
    node.kind = kind;
    return node;
  }

  function finishUnaryExpression(operator, argument) {
    const node = new ASTNode(SyntaxUnaryExpression);
    node.operator = operator;
    node.argument = argument;
    node.prefix = true;
    return node;
  } // Throw an exception


  function throwError(token, messageFormat) {
    var error,
        args = Array.prototype.slice.call(arguments, 2),
        msg = messageFormat.replace(/%(\d)/g, (whole, index) => {
      assert(index < args.length, 'Message reference must be in range');
      return args[index];
    });
    error = new Error(msg);
    error.index = index;
    error.description = msg;
    throw error;
  } // Throw an exception because of the token.


  function throwUnexpected(token) {
    if (token.type === TokenEOF) {
      throwError(token, MessageUnexpectedEOS);
    }

    if (token.type === TokenNumericLiteral) {
      throwError(token, MessageUnexpectedNumber);
    }

    if (token.type === TokenStringLiteral) {
      throwError(token, MessageUnexpectedString);
    }

    if (token.type === TokenIdentifier) {
      throwError(token, MessageUnexpectedIdentifier);
    }

    if (token.type === TokenKeyword) {
      throwError(token, MessageUnexpectedReserved);
    } // BooleanLiteral, NullLiteral, or Punctuator.


    throwError(token, MessageUnexpectedToken, token.value);
  } // Expect the next token to match the specified punctuator.
  // If not, an exception will be thrown.


  function expect(value) {
    const token = lex();

    if (token.type !== TokenPunctuator || token.value !== value) {
      throwUnexpected(token);
    }
  } // Return true if the next token matches the specified punctuator.


  function match(value) {
    return lookahead.type === TokenPunctuator && lookahead.value === value;
  } // Return true if the next token matches the specified keyword


  function matchKeyword(keyword) {
    return lookahead.type === TokenKeyword && lookahead.value === keyword;
  } // 11.1.4 Array Initialiser


  function parseArrayInitialiser() {
    const elements = [];
    index = lookahead.start;
    expect('[');

    while (!match(']')) {
      if (match(',')) {
        lex();
        elements.push(null);
      } else {
        elements.push(parseConditionalExpression());

        if (!match(']')) {
          expect(',');
        }
      }
    }

    lex();
    return finishArrayExpression(elements);
  } // 11.1.5 Object Initialiser


  function parseObjectPropertyKey() {
    index = lookahead.start;
    const token = lex(); // Note: This function is called only from parseObjectProperty(), where
    // EOF and Punctuator tokens are already filtered out.

    if (token.type === TokenStringLiteral || token.type === TokenNumericLiteral) {
      if (token.octal) {
        throwError(token, MessageStrictOctalLiteral);
      }

      return finishLiteral(token);
    }

    return finishIdentifier(token.value);
  }

  function parseObjectProperty() {
    var token, key, id, value;
    index = lookahead.start;
    token = lookahead;

    if (token.type === TokenIdentifier) {
      id = parseObjectPropertyKey();
      expect(':');
      value = parseConditionalExpression();
      return finishProperty('init', id, value);
    }

    if (token.type === TokenEOF || token.type === TokenPunctuator) {
      throwUnexpected(token);
    } else {
      key = parseObjectPropertyKey();
      expect(':');
      value = parseConditionalExpression();
      return finishProperty('init', key, value);
    }
  }

  function parseObjectInitialiser() {
    var properties = [],
        property,
        name,
        key,
        map = {},
        toString = String;
    index = lookahead.start;
    expect('{');

    while (!match('}')) {
      property = parseObjectProperty();

      if (property.key.type === SyntaxIdentifier) {
        name = property.key.name;
      } else {
        name = toString(property.key.value);
      }

      key = '$' + name;

      if (Object.prototype.hasOwnProperty.call(map, key)) {
        throwError({}, MessageStrictDuplicateProperty);
      } else {
        map[key] = true;
      }

      properties.push(property);

      if (!match('}')) {
        expect(',');
      }
    }

    expect('}');
    return finishObjectExpression(properties);
  } // 11.1.6 The Grouping Operator


  function parseGroupExpression() {
    expect('(');
    const expr = parseExpression();
    expect(')');
    return expr;
  } // 11.1 Primary Expressions


  const legalKeywords = {
    'if': 1
  };

  function parsePrimaryExpression() {
    var type, token, expr;

    if (match('(')) {
      return parseGroupExpression();
    }

    if (match('[')) {
      return parseArrayInitialiser();
    }

    if (match('{')) {
      return parseObjectInitialiser();
    }

    type = lookahead.type;
    index = lookahead.start;

    if (type === TokenIdentifier || legalKeywords[lookahead.value]) {
      expr = finishIdentifier(lex().value);
    } else if (type === TokenStringLiteral || type === TokenNumericLiteral) {
      if (lookahead.octal) {
        throwError(lookahead, MessageStrictOctalLiteral);
      }

      expr = finishLiteral(lex());
    } else if (type === TokenKeyword) {
      throw new Error(DISABLED);
    } else if (type === TokenBooleanLiteral) {
      token = lex();
      token.value = token.value === 'true';
      expr = finishLiteral(token);
    } else if (type === TokenNullLiteral) {
      token = lex();
      token.value = null;
      expr = finishLiteral(token);
    } else if (match('/') || match('/=')) {
      expr = finishLiteral(scanRegExp());
      peek();
    } else {
      throwUnexpected(lex());
    }

    return expr;
  } // 11.2 Left-Hand-Side Expressions


  function parseArguments() {
    const args = [];
    expect('(');

    if (!match(')')) {
      while (index < length) {
        args.push(parseConditionalExpression());

        if (match(')')) {
          break;
        }

        expect(',');
      }
    }

    expect(')');
    return args;
  }

  function parseNonComputedProperty() {
    index = lookahead.start;
    const token = lex();

    if (!isIdentifierName(token)) {
      throwUnexpected(token);
    }

    return finishIdentifier(token.value);
  }

  function parseNonComputedMember() {
    expect('.');
    return parseNonComputedProperty();
  }

  function parseComputedMember() {
    expect('[');
    const expr = parseExpression();
    expect(']');
    return expr;
  }

  function parseLeftHandSideExpressionAllowCall() {
    var expr, args, property;
    expr = parsePrimaryExpression();

    for (;;) {
      if (match('.')) {
        property = parseNonComputedMember();
        expr = finishMemberExpression('.', expr, property);
      } else if (match('(')) {
        args = parseArguments();
        expr = finishCallExpression(expr, args);
      } else if (match('[')) {
        property = parseComputedMember();
        expr = finishMemberExpression('[', expr, property);
      } else {
        break;
      }
    }

    return expr;
  } // 11.3 Postfix Expressions


  function parsePostfixExpression() {
    const expr = parseLeftHandSideExpressionAllowCall();

    if (lookahead.type === TokenPunctuator) {
      if (match('++') || match('--')) {
        throw new Error(DISABLED);
      }
    }

    return expr;
  } // 11.4 Unary Operators


  function parseUnaryExpression() {
    var token, expr;

    if (lookahead.type !== TokenPunctuator && lookahead.type !== TokenKeyword) {
      expr = parsePostfixExpression();
    } else if (match('++') || match('--')) {
      throw new Error(DISABLED);
    } else if (match('+') || match('-') || match('~') || match('!')) {
      token = lex();
      expr = parseUnaryExpression();
      expr = finishUnaryExpression(token.value, expr);
    } else if (matchKeyword('delete') || matchKeyword('void') || matchKeyword('typeof')) {
      throw new Error(DISABLED);
    } else {
      expr = parsePostfixExpression();
    }

    return expr;
  }

  function binaryPrecedence(token) {
    let prec = 0;

    if (token.type !== TokenPunctuator && token.type !== TokenKeyword) {
      return 0;
    }

    switch (token.value) {
      case '||':
        prec = 1;
        break;

      case '&&':
        prec = 2;
        break;

      case '|':
        prec = 3;
        break;

      case '^':
        prec = 4;
        break;

      case '&':
        prec = 5;
        break;

      case '==':
      case '!=':
      case '===':
      case '!==':
        prec = 6;
        break;

      case '<':
      case '>':
      case '<=':
      case '>=':
      case 'instanceof':
      case 'in':
        prec = 7;
        break;

      case '<<':
      case '>>':
      case '>>>':
        prec = 8;
        break;

      case '+':
      case '-':
        prec = 9;
        break;

      case '*':
      case '/':
      case '%':
        prec = 11;
        break;
    }

    return prec;
  } // 11.5 Multiplicative Operators
  // 11.6 Additive Operators
  // 11.7 Bitwise Shift Operators
  // 11.8 Relational Operators
  // 11.9 Equality Operators
  // 11.10 Binary Bitwise Operators
  // 11.11 Binary Logical Operators


  function parseBinaryExpression() {
    var marker, markers, expr, token, prec, stack, right, operator, left, i;
    marker = lookahead;
    left = parseUnaryExpression();
    token = lookahead;
    prec = binaryPrecedence(token);

    if (prec === 0) {
      return left;
    }

    token.prec = prec;
    lex();
    markers = [marker, lookahead];
    right = parseUnaryExpression();
    stack = [left, token, right];

    while ((prec = binaryPrecedence(lookahead)) > 0) {
      // Reduce: make a binary expression from the three topmost entries.
      while (stack.length > 2 && prec <= stack[stack.length - 2].prec) {
        right = stack.pop();
        operator = stack.pop().value;
        left = stack.pop();
        markers.pop();
        expr = finishBinaryExpression(operator, left, right);
        stack.push(expr);
      } // Shift.


      token = lex();
      token.prec = prec;
      stack.push(token);
      markers.push(lookahead);
      expr = parseUnaryExpression();
      stack.push(expr);
    } // Final reduce to clean-up the stack.


    i = stack.length - 1;
    expr = stack[i];
    markers.pop();

    while (i > 1) {
      markers.pop();
      expr = finishBinaryExpression(stack[i - 1].value, stack[i - 2], expr);
      i -= 2;
    }

    return expr;
  } // 11.12 Conditional Operator


  function parseConditionalExpression() {
    var expr, consequent, alternate;
    expr = parseBinaryExpression();

    if (match('?')) {
      lex();
      consequent = parseConditionalExpression();
      expect(':');
      alternate = parseConditionalExpression();
      expr = finishConditionalExpression(expr, consequent, alternate);
    }

    return expr;
  } // 11.14 Comma Operator


  function parseExpression() {
    const expr = parseConditionalExpression();

    if (match(',')) {
      throw new Error(DISABLED); // no sequence expressions
    }

    return expr;
  }

  function parser$1(code) {
    source = code;
    index = 0;
    length = source.length;
    lookahead = null;
    peek();
    const expr = parseExpression();

    if (lookahead.type !== TokenEOF) {
      throw new Error('Unexpect token after expression.');
    }

    return expr;
  }

  var Constants = {
    NaN: 'NaN',
    E: 'Math.E',
    LN2: 'Math.LN2',
    LN10: 'Math.LN10',
    LOG2E: 'Math.LOG2E',
    LOG10E: 'Math.LOG10E',
    PI: 'Math.PI',
    SQRT1_2: 'Math.SQRT1_2',
    SQRT2: 'Math.SQRT2',
    MIN_VALUE: 'Number.MIN_VALUE',
    MAX_VALUE: 'Number.MAX_VALUE'
  };

  function Functions(codegen) {
    function fncall(name, args, cast, type) {
      let obj = codegen(args[0]);

      if (cast) {
        obj = cast + '(' + obj + ')';
        if (cast.lastIndexOf('new ', 0) === 0) obj = '(' + obj + ')';
      }

      return obj + '.' + name + (type < 0 ? '' : type === 0 ? '()' : '(' + args.slice(1).map(codegen).join(',') + ')');
    }

    function fn(name, cast, type) {
      return args => fncall(name, args, cast, type);
    }

    const DATE = 'new Date',
          STRING = 'String',
          REGEXP = 'RegExp';
    return {
      // MATH functions
      isNaN: 'Number.isNaN',
      isFinite: 'Number.isFinite',
      abs: 'Math.abs',
      acos: 'Math.acos',
      asin: 'Math.asin',
      atan: 'Math.atan',
      atan2: 'Math.atan2',
      ceil: 'Math.ceil',
      cos: 'Math.cos',
      exp: 'Math.exp',
      floor: 'Math.floor',
      log: 'Math.log',
      max: 'Math.max',
      min: 'Math.min',
      pow: 'Math.pow',
      random: 'Math.random',
      round: 'Math.round',
      sin: 'Math.sin',
      sqrt: 'Math.sqrt',
      tan: 'Math.tan',
      clamp: function (args) {
        if (args.length < 3) error('Missing arguments to clamp function.');
        if (args.length > 3) error('Too many arguments to clamp function.');
        const a = args.map(codegen);
        return 'Math.max(' + a[1] + ', Math.min(' + a[2] + ',' + a[0] + '))';
      },
      // DATE functions
      now: 'Date.now',
      utc: 'Date.UTC',
      datetime: DATE,
      date: fn('getDate', DATE, 0),
      day: fn('getDay', DATE, 0),
      year: fn('getFullYear', DATE, 0),
      month: fn('getMonth', DATE, 0),
      hours: fn('getHours', DATE, 0),
      minutes: fn('getMinutes', DATE, 0),
      seconds: fn('getSeconds', DATE, 0),
      milliseconds: fn('getMilliseconds', DATE, 0),
      time: fn('getTime', DATE, 0),
      timezoneoffset: fn('getTimezoneOffset', DATE, 0),
      utcdate: fn('getUTCDate', DATE, 0),
      utcday: fn('getUTCDay', DATE, 0),
      utcyear: fn('getUTCFullYear', DATE, 0),
      utcmonth: fn('getUTCMonth', DATE, 0),
      utchours: fn('getUTCHours', DATE, 0),
      utcminutes: fn('getUTCMinutes', DATE, 0),
      utcseconds: fn('getUTCSeconds', DATE, 0),
      utcmilliseconds: fn('getUTCMilliseconds', DATE, 0),
      // sequence functions
      length: fn('length', null, -1),
      // STRING functions
      parseFloat: 'parseFloat',
      parseInt: 'parseInt',
      upper: fn('toUpperCase', STRING, 0),
      lower: fn('toLowerCase', STRING, 0),
      substring: fn('substring', STRING),
      split: fn('split', STRING),
      trim: fn('trim', STRING, 0),
      // REGEXP functions
      regexp: REGEXP,
      test: fn('test', REGEXP),
      // Control Flow functions
      if: function (args) {
        if (args.length < 3) error('Missing arguments to if function.');
        if (args.length > 3) error('Too many arguments to if function.');
        const a = args.map(codegen);
        return '(' + a[0] + '?' + a[1] + ':' + a[2] + ')';
      }
    };
  }

  function stripQuotes(s) {
    const n = s && s.length - 1;
    return n && (s[0] === '"' && s[n] === '"' || s[0] === '\'' && s[n] === '\'') ? s.slice(1, -1) : s;
  }

  function codegen(opt) {
    opt = opt || {};
    const allowed = opt.allowed ? toSet(opt.allowed) : {},
          forbidden = opt.forbidden ? toSet(opt.forbidden) : {},
          constants = opt.constants || Constants,
          functions = (opt.functions || Functions)(visit),
          globalvar = opt.globalvar,
          fieldvar = opt.fieldvar,
          outputGlobal = isFunction(globalvar) ? globalvar : id => `${globalvar}["${id}"]`;
    let globals = {},
        fields = {},
        memberDepth = 0;

    function visit(ast) {
      if (isString(ast)) return ast;
      const generator = Generators[ast.type];
      if (generator == null) error('Unsupported type: ' + ast.type);
      return generator(ast);
    }

    const Generators = {
      Literal: n => n.raw,
      Identifier: n => {
        const id = n.name;

        if (memberDepth > 0) {
          return id;
        } else if (has$1(forbidden, id)) {
          return error('Illegal identifier: ' + id);
        } else if (has$1(constants, id)) {
          return constants[id];
        } else if (has$1(allowed, id)) {
          return id;
        } else {
          globals[id] = 1;
          return outputGlobal(id);
        }
      },
      MemberExpression: n => {
        const d = !n.computed,
              o = visit(n.object);
        if (d) memberDepth += 1;
        const p = visit(n.property);

        if (o === fieldvar) {
          // strip quotes to sanitize field name (#1653)
          fields[stripQuotes(p)] = 1;
        }

        if (d) memberDepth -= 1;
        return o + (d ? '.' + p : '[' + p + ']');
      },
      CallExpression: n => {
        if (n.callee.type !== 'Identifier') {
          error('Illegal callee type: ' + n.callee.type);
        }

        const callee = n.callee.name,
              args = n.arguments,
              fn = has$1(functions, callee) && functions[callee];
        if (!fn) error('Unrecognized function: ' + callee);
        return isFunction(fn) ? fn(args) : fn + '(' + args.map(visit).join(',') + ')';
      },
      ArrayExpression: n => '[' + n.elements.map(visit).join(',') + ']',
      BinaryExpression: n => '(' + visit(n.left) + ' ' + n.operator + ' ' + visit(n.right) + ')',
      UnaryExpression: n => '(' + n.operator + visit(n.argument) + ')',
      ConditionalExpression: n => '(' + visit(n.test) + '?' + visit(n.consequent) + ':' + visit(n.alternate) + ')',
      LogicalExpression: n => '(' + visit(n.left) + n.operator + visit(n.right) + ')',
      ObjectExpression: n => '{' + n.properties.map(visit).join(',') + '}',
      Property: n => {
        memberDepth += 1;
        const k = visit(n.key);
        memberDepth -= 1;
        return k + ':' + visit(n.value);
      }
    };

    function codegen(ast) {
      const result = {
        code: visit(ast),
        globals: Object.keys(globals),
        fields: Object.keys(fields)
      };
      globals = {};
      fields = {};
      return result;
    }

    codegen.functions = functions;
    codegen.constants = constants;
    return codegen;
  }

  function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }

  function bisector(f) {
    let delta = f;
    let compare = f;

    if (f.length === 1) {
      delta = (d, x) => f(d) - x;

      compare = ascendingComparator(f);
    }

    function left(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;

      while (lo < hi) {
        const mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
      }

      return lo;
    }

    function right(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;

      while (lo < hi) {
        const mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
      }

      return lo;
    }

    function center(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      const i = left(a, x, lo, hi - 1);
      return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }

    return {
      left,
      center,
      right
    };
  }

  function ascendingComparator(f) {
    return (d, x) => ascending(f(d), x);
  }

  const Intersect = 'intersect';
  const Union = 'union';
  const VlMulti = 'vlMulti';
  const VlPoint = 'vlPoint';
  const Or = 'or';
  const And = 'and';
  const SELECTION_ID = '_vgsid_',
        TYPE_ENUM = 'E',
        TYPE_RANGE_INC = 'R',
        TYPE_RANGE_EXC = 'R-E',
        TYPE_RANGE_LE = 'R-LE',
        TYPE_RANGE_RE = 'R-RE',
        UNIT_INDEX = 'index:unit'; // TODO: revisit date coercion?

  function testPoint(datum, entry) {
    var fields = entry.fields,
        values = entry.values,
        n = fields.length,
        i = 0,
        dval,
        f;

    for (; i < n; ++i) {
      f = fields[i];
      f.getter = field$1.getter || field$1(f.field);
      dval = f.getter(datum);
      if (isDate$1(dval)) dval = toNumber(dval);
      if (isDate$1(values[i])) values[i] = toNumber(values[i]);
      if (isDate$1(values[i][0])) values[i] = values[i].map(toNumber);

      if (f.type === TYPE_ENUM) {
        // Enumerated fields can either specify individual values (single/multi selections)
        // or an array of values (interval selections).
        if (isArray(values[i]) ? values[i].indexOf(dval) < 0 : dval !== values[i]) {
          return false;
        }
      } else {
        if (f.type === TYPE_RANGE_INC) {
          if (!inrange(dval, values[i])) return false;
        } else if (f.type === TYPE_RANGE_RE) {
          // Discrete selection of bins test within the range [bin_start, bin_end).
          if (!inrange(dval, values[i], true, false)) return false;
        } else if (f.type === TYPE_RANGE_EXC) {
          // 'R-E'/'R-LE' included for completeness.
          if (!inrange(dval, values[i], false, false)) return false;
        } else if (f.type === TYPE_RANGE_LE) {
          if (!inrange(dval, values[i], false, true)) return false;
        }
      }
    }

    return true;
  }
  /**
   * Tests if a tuple is contained within an interactive selection.
   * @param {string} name - The name of the data set representing the selection.
   *  Tuples in the dataset are of the form
   *  {unit: string, fields: array<fielddef>, values: array<*>}.
   *  Fielddef is of the form
   *  {field: string, channel: string, type: 'E' | 'R'} where
   *  'type' identifies whether tuples in the dataset enumerate
   *  values for the field, or specify a continuous range.
   * @param {object} datum - The tuple to test for inclusion.
   * @param {string} op - The set operation for combining selections.
   *   One of 'intersect' or 'union' (default).
   * @return {boolean} - True if the datum is in the selection, false otherwise.
   */


  function selectionTest(name, datum, op) {
    var data = this.context.data[name],
        entries = data ? data.values.value : [],
        unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined,
        intersect = op === Intersect,
        n = entries.length,
        i = 0,
        entry,
        miss,
        count,
        unit,
        b;

    for (; i < n; ++i) {
      entry = entries[i];

      if (unitIdx && intersect) {
        // multi selections union within the same unit and intersect across units.
        miss = miss || {};
        count = miss[unit = entry.unit] || 0; // if we've already matched this unit, skip.

        if (count === -1) continue;
        b = testPoint(datum, entry);
        miss[unit] = b ? -1 : ++count; // if we match and there are no other units return true
        // if we've missed against all tuples in this unit return false

        if (b && unitIdx.size === 1) return true;
        if (!b && count === unitIdx.get(unit).count) return false;
      } else {
        b = testPoint(datum, entry); // if we find a miss and we do require intersection return false
        // if we find a match and we don't require intersection return true

        if (intersect ^ b) return b;
      }
    } // if intersecting and we made it here, then we saw no misses
    // if not intersecting, then we saw no matches
    // if no active selections, return false


    return n && intersect;
  }

  const selectionId = field$1(SELECTION_ID),
        bisect = bisector(selectionId),
        bisectLeft = bisect.left,
        bisectRight = bisect.right;

  function selectionIdTest(name, datum, op) {
    const data = this.context.data[name],
          entries = data ? data.values.value : [],
          unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined,
          intersect = op === Intersect,
          value = selectionId(datum),
          index = bisectLeft(entries, value);
    if (index === entries.length) return false;
    if (selectionId(entries[index]) !== value) return false;

    if (unitIdx && intersect) {
      if (unitIdx.size === 1) return true;
      if (bisectRight(entries, value) - index < unitIdx.size) return false;
    }

    return true;
  }
  /**
   * Maps an array of scene graph items to an array of selection tuples.
   * @param {string} name  - The name of the dataset representing the selection.
   * @param {string} unit  - The name of the unit view.
   *
   * @returns {array} An array of selection entries for the given unit.
   */


  function selectionTuples(array, base) {
    return array.map(x => extend$1({
      values: base.fields.map(f => (f.getter || (f.getter = field$1(f.field)))(x.datum))
    }, base));
  }
  /**
   * Resolves selection for use as a scale domain or reads via the API.
   * @param {string} name - The name of the dataset representing the selection
   * @param {string} [op='union'] - The set operation for combining selections.
   *                 One of 'intersect' or 'union' (default).
   * @param {boolean} isMulti - Identifies a "multi" selection to perform more
   *                 expensive resolution computation.
   * @param {boolean} vl5 - With Vega-Lite v5, "multi" selections are now called "point"
   *                 selections, and thus the resolved tuple should reflect this name.
   *                 This parameter allows us to reflect this change without triggering
   *                 a major version bump for Vega.
   * @returns {object} An object of selected fields and values.
   */


  function selectionResolve(name, op, isMulti, vl5) {
    var data = this.context.data[name],
        entries = data ? data.values.value : [],
        resolved = {},
        multiRes = {},
        types = {},
        entry,
        fields,
        values,
        unit,
        field,
        res,
        resUnit,
        type,
        union,
        n = entries.length,
        i = 0,
        j,
        m; // First union all entries within the same unit.

    for (; i < n; ++i) {
      entry = entries[i];
      unit = entry.unit;
      fields = entry.fields;
      values = entry.values;

      for (j = 0, m = fields.length; j < m; ++j) {
        field = fields[j];
        res = resolved[field.field] || (resolved[field.field] = {});
        resUnit = res[unit] || (res[unit] = []);
        types[field.field] = type = field.type.charAt(0);
        union = ops[type + '_union'];
        res[unit] = union(resUnit, array$5(values[j]));
      } // If the same multi-selection is repeated over views and projected over
      // an encoding, it may operate over different fields making it especially
      // tricky to reliably resolve it. At best, we can de-dupe identical entries
      // but doing so may be more computationally expensive than it is worth.
      // Instead, for now, we simply transform our store representation into
      // a more human-friendly one.


      if (isMulti) {
        resUnit = multiRes[unit] || (multiRes[unit] = []);
        resUnit.push(array$5(values).reduce((obj, curr, j) => (obj[fields[j].field] = curr, obj), {}));
      }
    } // Then resolve fields across units as per the op.


    op = op || Union;
    Object.keys(resolved).forEach(field => {
      resolved[field] = Object.keys(resolved[field]).map(unit => resolved[field][unit]).reduce((acc, curr) => acc === undefined ? curr : ops[types[field] + '_' + op](acc, curr));
    });
    entries = Object.keys(multiRes);

    if (isMulti && entries.length) {
      const key = vl5 ? VlPoint : VlMulti;
      resolved[key] = op === Union ? {
        [Or]: entries.reduce((acc, k) => (acc.push(...multiRes[k]), acc), [])
      } : {
        [And]: entries.map(k => ({
          [Or]: multiRes[k]
        }))
      };
    }

    return resolved;
  }

  var ops = {
    E_union: function (base, value) {
      if (!base.length) return value;
      var i = 0,
          n = value.length;

      for (; i < n; ++i) if (base.indexOf(value[i]) < 0) base.push(value[i]);

      return base;
    },
    E_intersect: function (base, value) {
      return !base.length ? value : base.filter(v => value.indexOf(v) >= 0);
    },
    R_union: function (base, value) {
      var lo = toNumber(value[0]),
          hi = toNumber(value[1]);

      if (lo > hi) {
        lo = value[1];
        hi = value[0];
      }

      if (!base.length) return [lo, hi];
      if (base[0] > lo) base[0] = lo;
      if (base[1] < hi) base[1] = hi;
      return base;
    },
    R_intersect: function (base, value) {
      var lo = toNumber(value[0]),
          hi = toNumber(value[1]);

      if (lo > hi) {
        lo = value[1];
        hi = value[0];
      }

      if (!base.length) return [lo, hi];

      if (hi < base[0] || base[1] < lo) {
        return [];
      } else {
        if (base[0] < lo) base[0] = lo;
        if (base[1] > hi) base[1] = hi;
      }

      return base;
    }
  };
  const DataPrefix$1 = ':',
        IndexPrefix$1 = '@';

  function selectionVisitor(name, args, scope, params) {
    if (args[0].type !== Literal) error('First argument to selection functions must be a string literal.');
    const data = args[0].value,
          op = args.length >= 2 && peek$1(args).value,
          field = 'unit',
          indexName = IndexPrefix$1 + field,
          dataName = DataPrefix$1 + data; // eslint-disable-next-line no-prototype-builtins

    if (op === Intersect && !has$1(params, indexName)) {
      params[indexName] = scope.getData(data).indataRef(scope, field);
    } // eslint-disable-next-line no-prototype-builtins


    if (!has$1(params, dataName)) {
      params[dataName] = scope.getData(data).tuplesRef();
    }
  }

  function data$1(name) {
    const data = this.context.data[name];
    return data ? data.values.value : [];
  }

  function indata(name, field, value) {
    const index = this.context.data[name]['index:' + field],
          entry = index ? index.value.get(value) : undefined;
    return entry ? entry.count : entry;
  }

  function setdata(name, tuples) {
    const df = this.context.dataflow,
          data = this.context.data[name],
          input = data.input;
    df.pulse(input, df.changeset().remove(truthy).insert(tuples));
    return 1;
  }

  function encode(item, name, retval) {
    if (item) {
      const df = this.context.dataflow,
            target = item.mark.source;
      df.pulse(target, df.changeset().encode(item, name));
    }

    return retval !== undefined ? retval : item;
  }

  const wrap = method => function (value, spec) {
    const locale = this.context.dataflow.locale();
    return locale[method](spec)(value);
  };

  const format = wrap('format');
  const timeFormat = wrap('timeFormat');
  const utcFormat = wrap('utcFormat');
  const timeParse = wrap('timeParse');
  const utcParse = wrap('utcParse');
  const dateObj = new Date(2000, 0, 1);

  function time(month, day, specifier) {
    if (!Number.isInteger(month) || !Number.isInteger(day)) return '';
    dateObj.setYear(2000);
    dateObj.setMonth(month);
    dateObj.setDate(day);
    return timeFormat.call(this, dateObj, specifier);
  }

  function monthFormat(month) {
    return time.call(this, month, 1, '%B');
  }

  function monthAbbrevFormat(month) {
    return time.call(this, month, 1, '%b');
  }

  function dayFormat(day) {
    return time.call(this, 0, 2 + day, '%A');
  }

  function dayAbbrevFormat(day) {
    return time.call(this, 0, 2 + day, '%a');
  }

  const DataPrefix = ':';
  const IndexPrefix = '@';
  const ScalePrefix = '%';
  const SignalPrefix = '$';

  function dataVisitor(name, args, scope, params) {
    if (args[0].type !== Literal) {
      error('First argument to data functions must be a string literal.');
    }

    const data = args[0].value,
          dataName = DataPrefix + data;

    if (!has$1(dataName, params)) {
      try {
        params[dataName] = scope.getData(data).tuplesRef();
      } catch (err) {// if data set does not exist, there's nothing to track
      }
    }
  }

  function indataVisitor(name, args, scope, params) {
    if (args[0].type !== Literal) error('First argument to indata must be a string literal.');
    if (args[1].type !== Literal) error('Second argument to indata must be a string literal.');
    const data = args[0].value,
          field = args[1].value,
          indexName = IndexPrefix + field;

    if (!has$1(indexName, params)) {
      params[indexName] = scope.getData(data).indataRef(scope, field);
    }
  }

  function scaleVisitor(name, args, scope, params) {
    if (args[0].type === Literal) {
      // add scale dependency
      addScaleDependency(scope, params, args[0].value);
    } else {
      // indirect scale lookup; add all scales as parameters
      for (name in scope.scales) {
        addScaleDependency(scope, params, name);
      }
    }
  }

  function addScaleDependency(scope, params, name) {
    const scaleName = ScalePrefix + name;

    if (!has$1(params, scaleName)) {
      try {
        params[scaleName] = scope.scaleRef(name);
      } catch (err) {// TODO: error handling? warning?
      }
    }
  }

  function getScale(name, ctx) {
    let s;
    return isFunction(name) ? name : isString(name) ? (s = ctx.scales[name]) && s.value : undefined;
  }

  function internalScaleFunctions(codegen, fnctx, visitors) {
    // add helper method to the 'this' expression function context
    fnctx.__bandwidth = s => s && s.bandwidth ? s.bandwidth() : 0; // register AST visitors for internal scale functions


    visitors._bandwidth = scaleVisitor;
    visitors._range = scaleVisitor;
    visitors._scale = scaleVisitor; // resolve scale reference directly to the signal hash argument

    const ref = arg => '_[' + (arg.type === Literal ? $(ScalePrefix + arg.value) : $(ScalePrefix) + '+' + codegen(arg)) + ']'; // define and return internal scale function code generators
    // these internal functions are called by mark encoders


    return {
      _bandwidth: args => `this.__bandwidth(${ref(args[0])})`,
      _range: args => `${ref(args[0])}.range()`,
      _scale: args => `${ref(args[0])}(${codegen(args[1])})`
    };
  }

  function geoMethod(methodName, globalMethod) {
    return function (projection, geojson, group) {
      if (projection) {
        // projection defined, use it
        const p = getScale(projection, (group || this).context);
        return p && p.path[methodName](geojson);
      } else {
        // projection undefined, use global method
        return globalMethod(geojson);
      }
    };
  }

  const geoArea = geoMethod('area', geoArea$1);
  const geoBounds = geoMethod('bounds', geoBounds$1);
  const geoCentroid = geoMethod('centroid', geoCentroid$1);

  function inScope(item) {
    const group = this.context.group;
    let value = false;
    if (group) while (item) {
      if (item === group) {
        value = true;
        break;
      }

      item = item.mark.group;
    }
    return value;
  }

  function log(df, method, args) {
    try {
      df[method].apply(df, ['EXPRESSION'].concat([].slice.call(args)));
    } catch (err) {
      df.warn(err);
    }

    return args[args.length - 1];
  }

  function warn() {
    return log(this.context.dataflow, 'warn', arguments);
  }

  function info() {
    return log(this.context.dataflow, 'info', arguments);
  }

  function debug() {
    return log(this.context.dataflow, 'debug', arguments);
  }

  function channel_luminance_value(channelValue) {
    const val = channelValue / 255;

    if (val <= 0.03928) {
      return val / 12.92;
    }

    return Math.pow((val + 0.055) / 1.055, 2.4);
  }

  function luminance(color) {
    const c = rgb$1(color),
          r = channel_luminance_value(c.r),
          g = channel_luminance_value(c.g),
          b = channel_luminance_value(c.b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  } // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef


  function contrast(color1, color2) {
    const lum1 = luminance(color1),
          lum2 = luminance(color2),
          lumL = Math.max(lum1, lum2),
          lumD = Math.min(lum1, lum2);
    return (lumL + 0.05) / (lumD + 0.05);
  }

  function merge() {
    const args = [].slice.call(arguments);
    args.unshift({});
    return extend$1(...args);
  }

  function equal(a, b) {
    return a === b || a !== a && b !== b ? true : isArray(a) ? isArray(b) && a.length === b.length ? equalArray(a, b) : false : isObject(a) && isObject(b) ? equalObject(a, b) : false;
  }

  function equalArray(a, b) {
    for (let i = 0, n = a.length; i < n; ++i) {
      if (!equal(a[i], b[i])) return false;
    }

    return true;
  }

  function equalObject(a, b) {
    for (const key in a) {
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  function removePredicate(props) {
    return _ => equalObject(props, _);
  }

  function modify(name, insert, remove, toggle, modify, values) {
    const df = this.context.dataflow,
          data = this.context.data[name],
          input = data.input,
          stamp = df.stamp();
    let changes = data.changes,
        predicate,
        key;

    if (df._trigger === false || !(input.value.length || insert || toggle)) {
      // nothing to do!
      return 0;
    }

    if (!changes || changes.stamp < stamp) {
      data.changes = changes = df.changeset();
      changes.stamp = stamp;
      df.runAfter(() => {
        data.modified = true;
        df.pulse(input, changes).run();
      }, true, 1);
    }

    if (remove) {
      predicate = remove === true ? truthy : isArray(remove) || isTuple(remove) ? remove : removePredicate(remove);
      changes.remove(predicate);
    }

    if (insert) {
      changes.insert(insert);
    }

    if (toggle) {
      predicate = removePredicate(toggle);

      if (input.value.some(predicate)) {
        changes.remove(predicate);
      } else {
        changes.insert(toggle);
      }
    }

    if (modify) {
      for (key in values) {
        changes.modify(modify, key, values[key]);
      }
    }

    return 1;
  }

  function pinchDistance(event) {
    const t = event.touches,
          dx = t[0].clientX - t[1].clientX,
          dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function pinchAngle(event) {
    const t = event.touches;
    return Math.atan2(t[0].clientY - t[1].clientY, t[0].clientX - t[1].clientX);
  }

  const accessors = {};

  function pluck(data, name) {
    const accessor = accessors[name] || (accessors[name] = field$1(name));
    return isArray(data) ? data.map(accessor) : accessor(data);
  }

  function array(seq) {
    return isArray(seq) || ArrayBuffer.isView(seq) ? seq : null;
  }

  function sequence(seq) {
    return array(seq) || (isString(seq) ? seq : null);
  }

  function join(seq, ...args) {
    return array(seq).join(...args);
  }

  function indexof(seq, ...args) {
    return sequence(seq).indexOf(...args);
  }

  function lastindexof(seq, ...args) {
    return sequence(seq).lastIndexOf(...args);
  }

  function slice(seq, ...args) {
    return sequence(seq).slice(...args);
  }

  function replace(str, pattern, repl) {
    if (isFunction(repl)) error('Function argument passed to replace.');
    return String(str).replace(pattern, repl);
  }

  function reverse(seq) {
    return array(seq).slice().reverse();
  }

  function bandspace(count, paddingInner, paddingOuter) {
    return bandSpace(count || 0, paddingInner || 0, paddingOuter || 0);
  }

  function bandwidth(name, group) {
    const s = getScale(name, (group || this).context);
    return s && s.bandwidth ? s.bandwidth() : 0;
  }

  function copy(name, group) {
    const s = getScale(name, (group || this).context);
    return s ? s.copy() : undefined;
  }

  function domain(name, group) {
    const s = getScale(name, (group || this).context);
    return s ? s.domain() : [];
  }

  function invert(name, range, group) {
    const s = getScale(name, (group || this).context);
    return !s ? undefined : isArray(range) ? (s.invertRange || s.invert)(range) : (s.invert || s.invertExtent)(range);
  }

  function range$1(name, group) {
    const s = getScale(name, (group || this).context);
    return s && s.range ? s.range() : [];
  }

  function scale$2(name, value, group) {
    const s = getScale(name, (group || this).context);
    return s ? s(value) : undefined;
  }

  function scaleGradient(scale, p0, p1, count, group) {
    scale = getScale(scale, (group || this).context);
    const gradient = Gradient$1(p0, p1);
    let stops = scale.domain(),
        min = stops[0],
        max = peek$1(stops),
        fraction = identity$6;

    if (!(max - min)) {
      // expand scale if domain has zero span, fix #1479
      scale = (scale.interpolator ? scale$4('sequential')().interpolator(scale.interpolator()) : scale$4('linear')().interpolate(scale.interpolate()).range(scale.range())).domain([min = 0, max = 1]);
    } else {
      fraction = scaleFraction(scale, min, max);
    }

    if (scale.ticks) {
      stops = scale.ticks(+count || 15);
      if (min !== stops[0]) stops.unshift(min);
      if (max !== peek$1(stops)) stops.push(max);
    }

    stops.forEach(_ => gradient.stop(fraction(_), scale(_)));
    return gradient;
  }

  function geoShape(projection, geojson, group) {
    const p = getScale(projection, (group || this).context);
    return function (context) {
      return p ? p.path.context(context)(geojson) : '';
    };
  }

  function pathShape(path) {
    let p = null;
    return function (context) {
      return context ? pathRender(context, p = p || pathParse(path)) : path;
    };
  }

  const datum = d => d.data;

  function treeNodes(name, context) {
    const tree = data$1.call(context, name);
    return tree.root && tree.root.lookup || {};
  }

  function treePath(name, source, target) {
    const nodes = treeNodes(name, this),
          s = nodes[source],
          t = nodes[target];
    return s && t ? s.path(t).map(datum) : undefined;
  }

  function treeAncestors(name, node) {
    const n = treeNodes(name, this)[node];
    return n ? n.ancestors().map(datum) : undefined;
  }

  const _window = () => typeof window !== 'undefined' && window || null;

  function screen() {
    const w = _window();

    return w ? w.screen : {};
  }

  function windowSize() {
    const w = _window();

    return w ? [w.innerWidth, w.innerHeight] : [undefined, undefined];
  }

  function containerSize() {
    const view = this.context.dataflow,
          el = view.container && view.container();
    return el ? [el.clientWidth, el.clientHeight] : [undefined, undefined];
  }

  function intersect(b, opt, group) {
    if (!b) return [];
    const [u, v] = b,
          box = new Bounds().set(u[0], u[1], v[0], v[1]),
          scene = group || this.context.dataflow.scenegraph().root;
    return intersect$2(scene, box, filter(opt));
  }

  function filter(opt) {
    let p = null;

    if (opt) {
      const types = array$5(opt.marktype),
            names = array$5(opt.markname);

      p = _ => (!types.length || types.some(t => _.marktype === t)) && (!names.length || names.some(s => _.name === s));
    }

    return p;
  }

  const functionContext = {
    random() {
      return exports.random();
    },

    // override default
    cumulativeNormal,
    cumulativeLogNormal,
    cumulativeUniform,
    densityNormal,
    densityLogNormal,
    densityUniform,
    quantileNormal,
    quantileLogNormal,
    quantileUniform,
    sampleNormal,
    sampleLogNormal,
    sampleUniform,
    isArray,
    isBoolean: isBoolean$1,
    isDate: isDate$1,

    isDefined(_) {
      return _ !== undefined;
    },

    isNumber: isNumber$1,
    isObject,
    isRegExp,
    isString,
    isTuple,

    isValid(_) {
      return _ != null && _ === _;
    },

    toBoolean,
    toDate,
    toNumber,
    toString,
    indexof,
    join,
    lastindexof,
    replace,
    reverse,
    slice,
    flush,
    lerp,
    merge,
    pad: pad$2,
    peek: peek$1,
    pluck,
    span,
    inrange,
    truncate: truncate$1,
    rgb: rgb$1,
    lab: lab$1,
    hcl: hcl$2,
    hsl: hsl$2,
    luminance,
    contrast,
    sequence: range$1$1,
    format,
    utcFormat,
    utcParse,
    utcOffset,
    utcSequence,
    timeFormat,
    timeParse,
    timeOffset,
    timeSequence,
    timeUnitSpecifier,
    monthFormat,
    monthAbbrevFormat,
    dayFormat,
    dayAbbrevFormat,
    quarter,
    utcquarter,
    week,
    utcweek,
    dayofyear,
    utcdayofyear,
    warn,
    info,
    debug,
    extent,
    inScope,
    intersect,
    clampRange,
    pinchDistance,
    pinchAngle,
    screen,
    containerSize,
    windowSize,
    bandspace,
    setdata,
    pathShape,
    panLinear,
    panLog,
    panPow,
    panSymlog,
    zoomLinear,
    zoomLog,
    zoomPow,
    zoomSymlog,
    encode,
    modify
  };
  const eventFunctions = ['view', 'item', 'group', 'xy', 'x', 'y'],
        // event functions
  eventPrefix = 'event.vega.',
        // event function prefix
  thisPrefix = 'this.',
        // function context prefix
  astVisitors = {}; // AST visitors for dependency analysis
  // export code generator parameters

  const codegenParams = {
    forbidden: ['_'],
    allowed: ['datum', 'event', 'item'],
    fieldvar: 'datum',
    globalvar: id => `_[${$(SignalPrefix + id)}]`,
    functions: buildFunctions,
    constants: Constants,
    visitors: astVisitors
  }; // export code generator

  const codeGenerator = codegen(codegenParams); // Build expression function registry

  function buildFunctions(codegen) {
    const fn = Functions(codegen);
    eventFunctions.forEach(name => fn[name] = eventPrefix + name);

    for (const name in functionContext) {
      fn[name] = thisPrefix + name;
    }

    extend$1(fn, internalScaleFunctions(codegen, functionContext, astVisitors));
    return fn;
  } // Register an expression function


  function expressionFunction(name, fn, visitor) {
    if (arguments.length === 1) {
      return functionContext[name];
    } // register with the functionContext


    functionContext[name] = fn; // if there is an astVisitor register that, too

    if (visitor) astVisitors[name] = visitor; // if the code generator has already been initialized,
    // we need to also register the function with it

    if (codeGenerator) codeGenerator.functions[name] = thisPrefix + name;
    return this;
  } // register expression functions with ast visitors


  expressionFunction('bandwidth', bandwidth, scaleVisitor);
  expressionFunction('copy', copy, scaleVisitor);
  expressionFunction('domain', domain, scaleVisitor);
  expressionFunction('range', range$1, scaleVisitor);
  expressionFunction('invert', invert, scaleVisitor);
  expressionFunction('scale', scale$2, scaleVisitor);
  expressionFunction('gradient', scaleGradient, scaleVisitor);
  expressionFunction('geoArea', geoArea, scaleVisitor);
  expressionFunction('geoBounds', geoBounds, scaleVisitor);
  expressionFunction('geoCentroid', geoCentroid, scaleVisitor);
  expressionFunction('geoShape', geoShape, scaleVisitor);
  expressionFunction('indata', indata, indataVisitor);
  expressionFunction('data', data$1, dataVisitor);
  expressionFunction('treePath', treePath, dataVisitor);
  expressionFunction('treeAncestors', treeAncestors, dataVisitor); // register Vega-Lite selection functions

  expressionFunction('vlSelectionTest', selectionTest, selectionVisitor);
  expressionFunction('vlSelectionIdTest', selectionIdTest, selectionVisitor);
  expressionFunction('vlSelectionResolve', selectionResolve, selectionVisitor);
  expressionFunction('vlSelectionTuples', selectionTuples);

  function parser(expr, scope) {
    const params = {}; // parse the expression to an abstract syntax tree (ast)

    let ast;

    try {
      expr = isString(expr) ? expr : $(expr) + '';
      ast = parser$1(expr);
    } catch (err) {
      error('Expression parse error: ' + expr);
    } // analyze ast function calls for dependencies


    ast.visit(node => {
      if (node.type !== CallExpression) return;
      const name = node.callee.name,
            visit = codegenParams.visitors[name];
      if (visit) visit(name, node.arguments, scope, params);
    }); // perform code generation

    const gen = codeGenerator(ast); // collect signal dependencies

    gen.globals.forEach(name => {
      const signalName = SignalPrefix + name;

      if (!has$1(params, signalName) && scope.getSignal(name)) {
        params[signalName] = scope.signalRef(name);
      }
    }); // return generated expression code and dependencies

    return {
      $expr: extend$1({
        code: gen.code
      }, scope.options.ast ? {
        ast
      } : null),
      $fields: gen.fields,
      $params: params
    };
  }

  /**
   * Parse a serialized dataflow specification.
   */

  function parse$2(spec) {
    const ctx = this,
          operators = spec.operators || []; // parse background

    if (spec.background) {
      ctx.background = spec.background;
    } // parse event configuration


    if (spec.eventConfig) {
      ctx.eventConfig = spec.eventConfig;
    } // parse locale configuration


    if (spec.locale) {
      ctx.locale = spec.locale;
    } // parse operators


    operators.forEach(entry => ctx.parseOperator(entry)); // parse operator parameters

    operators.forEach(entry => ctx.parseOperatorParameters(entry)); // parse streams

    (spec.streams || []).forEach(entry => ctx.parseStream(entry)); // parse updates

    (spec.updates || []).forEach(entry => ctx.parseUpdate(entry));
    return ctx.resolve();
  }

  const Skip$2 = toSet(['rule']),
        Swap = toSet(['group', 'image', 'rect']);

  function adjustSpatial(encode, marktype) {
    let code = '';
    if (Skip$2[marktype]) return code;

    if (encode.x2) {
      if (encode.x) {
        if (Swap[marktype]) {
          code += 'if(o.x>o.x2)$=o.x,o.x=o.x2,o.x2=$;';
        }

        code += 'o.width=o.x2-o.x;';
      } else {
        code += 'o.x=o.x2-(o.width||0);';
      }
    }

    if (encode.xc) {
      code += 'o.x=o.xc-(o.width||0)/2;';
    }

    if (encode.y2) {
      if (encode.y) {
        if (Swap[marktype]) {
          code += 'if(o.y>o.y2)$=o.y,o.y=o.y2,o.y2=$;';
        }

        code += 'o.height=o.y2-o.y;';
      } else {
        code += 'o.y=o.y2-(o.height||0);';
      }
    }

    if (encode.yc) {
      code += 'o.y=o.yc-(o.height||0)/2;';
    }

    return code;
  }

  function canonicalType(type) {
    return (type + '').toLowerCase();
  }

  function isOperator(type) {
    return canonicalType(type) === 'operator';
  }

  function isCollect(type) {
    return canonicalType(type) === 'collect';
  }

  function expression(ctx, args, code) {
    // wrap code in return statement if expression does not terminate
    if (code[code.length - 1] !== ';') {
      code = 'return(' + code + ');';
    }

    const fn = Function(...args.concat(code));
    return ctx && ctx.functions ? fn.bind(ctx.functions) : fn;
  } // generate code for comparing a single field


  function _compare(u, v, lt, gt) {
    return `((u = ${u}) < (v = ${v}) || u == null) && v != null ? ${lt}
  : (u > v || v == null) && u != null ? ${gt}
  : ((v = v instanceof Date ? +v : v), (u = u instanceof Date ? +u : u)) !== u && v === v ? ${lt}
  : v !== v && u === u ? ${gt} : `;
  }

  var expressionCodegen = {
    /**
     * Parse an expression used to update an operator value.
     */
    operator: (ctx, expr) => expression(ctx, ['_'], expr.code),

    /**
     * Parse an expression provided as an operator parameter value.
     */
    parameter: (ctx, expr) => expression(ctx, ['datum', '_'], expr.code),

    /**
     * Parse an expression applied to an event stream.
     */
    event: (ctx, expr) => expression(ctx, ['event'], expr.code),

    /**
     * Parse an expression used to handle an event-driven operator update.
     */
    handler: (ctx, expr) => {
      const code = `var datum=event.item&&event.item.datum;return ${expr.code};`;
      return expression(ctx, ['_', 'event'], code);
    },

    /**
     * Parse an expression that performs visual encoding.
     */
    encode: (ctx, encode) => {
      const {
        marktype,
        channels
      } = encode;
      let code = 'var o=item,datum=o.datum,m=0,$;';

      for (const name in channels) {
        const o = 'o[' + $(name) + ']';
        code += `$=${channels[name].code};if(${o}!==$)${o}=$,m=1;`;
      }

      code += adjustSpatial(channels, marktype);
      code += 'return m;';
      return expression(ctx, ['item', '_'], code);
    },

    /**
     * Optimized code generators for access and comparison.
     */
    codegen: {
      get(path) {
        const ref = `[${path.map($).join('][')}]`;
        const get = Function('_', `return _${ref};`);
        get.path = ref;
        return get;
      },

      comparator(fields, orders) {
        let t;

        const map = (f, i) => {
          const o = orders[i];
          let u, v;

          if (f.path) {
            u = `a${f.path}`;
            v = `b${f.path}`;
          } else {
            (t = t || {})['f' + i] = f;
            u = `this.f${i}(a)`;
            v = `this.f${i}(b)`;
          }

          return _compare(u, v, -o, o);
        };

        const fn = Function('a', 'b', 'var u, v; return ' + fields.map(map).join('') + '0;');
        return t ? fn.bind(t) : fn;
      }

    }
  };
  /**
   * Parse a dataflow operator.
   */

  function parseOperator(spec) {
    const ctx = this;

    if (isOperator(spec.type) || !spec.type) {
      ctx.operator(spec, spec.update ? ctx.operatorExpression(spec.update) : null);
    } else {
      ctx.transform(spec, spec.type);
    }
  }
  /**
   * Parse and assign operator parameters.
   */


  function parseOperatorParameters(spec) {
    const ctx = this;

    if (spec.params) {
      const op = ctx.get(spec.id);
      if (!op) error('Invalid operator id: ' + spec.id);
      ctx.dataflow.connect(op, op.parameters(ctx.parseParameters(spec.params), spec.react, spec.initonly));
    }
  }
  /**
   * Parse a set of operator parameters.
   */


  function parseParameters$1(spec, params) {
    params = params || {};
    const ctx = this;

    for (const key in spec) {
      const value = spec[key];
      params[key] = isArray(value) ? value.map(v => parseParameter$2(v, ctx, params)) : parseParameter$2(value, ctx, params);
    }

    return params;
  }
  /**
   * Parse a single parameter.
   */


  function parseParameter$2(spec, ctx, params) {
    if (!spec || !isObject(spec)) return spec;

    for (let i = 0, n = PARSERS.length, p; i < n; ++i) {
      p = PARSERS[i];

      if (has$1(spec, p.key)) {
        return p.parse(spec, ctx, params);
      }
    }

    return spec;
  }
  /** Reference parsers. */


  var PARSERS = [{
    key: '$ref',
    parse: getOperator
  }, {
    key: '$key',
    parse: getKey
  }, {
    key: '$expr',
    parse: getExpression
  }, {
    key: '$field',
    parse: getField
  }, {
    key: '$encode',
    parse: getEncode
  }, {
    key: '$compare',
    parse: getCompare
  }, {
    key: '$context',
    parse: getContext
  }, {
    key: '$subflow',
    parse: getSubflow
  }, {
    key: '$tupleid',
    parse: getTupleId
  }];
  /**
   * Resolve an operator reference.
   */

  function getOperator(_, ctx) {
    return ctx.get(_.$ref) || error('Operator not defined: ' + _.$ref);
  }
  /**
   * Resolve an expression reference.
   */


  function getExpression(_, ctx, params) {
    if (_.$params) {
      // parse expression parameters
      ctx.parseParameters(_.$params, params);
    }

    const k = 'e:' + _.$expr.code + '_' + _.$name;
    return ctx.fn[k] || (ctx.fn[k] = accessor(ctx.parameterExpression(_.$expr), _.$fields, _.$name));
  }
  /**
   * Resolve a key accessor reference.
   */


  function getKey(_, ctx) {
    const k = 'k:' + _.$key + '_' + !!_.$flat;
    return ctx.fn[k] || (ctx.fn[k] = key(_.$key, _.$flat, ctx.expr.codegen));
  }
  /**
   * Resolve a field accessor reference.
   */


  function getField(_, ctx) {
    if (!_.$field) return null;
    const k = 'f:' + _.$field + '_' + _.$name;
    return ctx.fn[k] || (ctx.fn[k] = field$1(_.$field, _.$name, ctx.expr.codegen));
  }
  /**
   * Resolve a comparator function reference.
   */


  function getCompare(_, ctx) {
    // As of Vega 5.5.3, $tupleid sort is no longer used.
    // Keep here for now for backwards compatibility.
    const k = 'c:' + _.$compare + '_' + _.$order,
          c = array$5(_.$compare).map(_ => _ && _.$tupleid ? tupleid : _);
    return ctx.fn[k] || (ctx.fn[k] = compare$1(c, _.$order, ctx.expr.codegen));
  }
  /**
   * Resolve an encode operator reference.
   */


  function getEncode(_, ctx) {
    const spec = _.$encode,
          encode = {};

    for (const name in spec) {
      const enc = spec[name];
      encode[name] = accessor(ctx.encodeExpression(enc.$expr), enc.$fields);
      encode[name].output = enc.$output;
    }

    return encode;
  }
  /**
   * Resolve a context reference.
   */


  function getContext(_, ctx) {
    return ctx;
  }
  /**
   * Resolve a recursive subflow specification.
   */


  function getSubflow(_, ctx) {
    const spec = _.$subflow;
    return function (dataflow, key, parent) {
      const subctx = ctx.fork().parse(spec),
            op = subctx.get(spec.operators[0].id),
            p = subctx.signals.parent;
      if (p) p.set(parent);

      op.detachSubflow = () => ctx.detach(subctx);

      return op;
    };
  }
  /**
   * Resolve a tuple id reference.
   */


  function getTupleId() {
    return tupleid;
  }
  /**
   * Parse an event stream specification.
   */


  function parseStream$2(spec) {
    var ctx = this,
        filter = spec.filter != null ? ctx.eventExpression(spec.filter) : undefined,
        stream = spec.stream != null ? ctx.get(spec.stream) : undefined,
        args;

    if (spec.source) {
      stream = ctx.events(spec.source, spec.type, filter);
    } else if (spec.merge) {
      args = spec.merge.map(_ => ctx.get(_));
      stream = args[0].merge.apply(args[0], args.slice(1));
    }

    if (spec.between) {
      args = spec.between.map(_ => ctx.get(_));
      stream = stream.between(args[0], args[1]);
    }

    if (spec.filter) {
      stream = stream.filter(filter);
    }

    if (spec.throttle != null) {
      stream = stream.throttle(+spec.throttle);
    }

    if (spec.debounce != null) {
      stream = stream.debounce(+spec.debounce);
    }

    if (stream == null) {
      error('Invalid stream definition: ' + JSON.stringify(spec));
    }

    if (spec.consume) stream.consume(true);
    ctx.stream(spec, stream);
  }
  /**
   * Parse an event-driven operator update.
   */


  function parseUpdate$1(spec) {
    var ctx = this,
        srcid = isObject(srcid = spec.source) ? srcid.$ref : srcid,
        source = ctx.get(srcid),
        target = null,
        update = spec.update,
        params = undefined;
    if (!source) error('Source not defined: ' + spec.source);
    target = spec.target && spec.target.$expr ? ctx.eventExpression(spec.target.$expr) : ctx.get(spec.target);

    if (update && update.$expr) {
      if (update.$params) {
        params = ctx.parseParameters(update.$params);
      }

      update = ctx.handlerExpression(update.$expr);
    }

    ctx.update(spec, source, target, update, params);
  }

  const SKIP = {
    skip: true
  };

  function getState$1(options) {
    var ctx = this,
        state = {};

    if (options.signals) {
      var signals = state.signals = {};
      Object.keys(ctx.signals).forEach(key => {
        const op = ctx.signals[key];

        if (options.signals(key, op)) {
          signals[key] = op.value;
        }
      });
    }

    if (options.data) {
      var data = state.data = {};
      Object.keys(ctx.data).forEach(key => {
        const dataset = ctx.data[key];

        if (options.data(key, dataset)) {
          data[key] = dataset.input.value;
        }
      });
    }

    if (ctx.subcontext && options.recurse !== false) {
      state.subcontext = ctx.subcontext.map(ctx => ctx.getState(options));
    }

    return state;
  }

  function setState$1(state) {
    var ctx = this,
        df = ctx.dataflow,
        data = state.data,
        signals = state.signals;
    Object.keys(signals || {}).forEach(key => {
      df.update(ctx.signals[key], signals[key], SKIP);
    });
    Object.keys(data || {}).forEach(key => {
      df.pulse(ctx.data[key].input, df.changeset().remove(truthy).insert(data[key]));
    });
    (state.subcontext || []).forEach((substate, i) => {
      const subctx = ctx.subcontext[i];
      if (subctx) subctx.setState(substate);
    });
  }
  /**
   * Context objects store the current parse state.
   * Enables lookup of parsed operators, event streams, accessors, etc.
   * Provides a 'fork' method for creating child contexts for subflows.
   */


  function context(df, transforms, functions, expr) {
    return new Context(df, transforms, functions, expr);
  }

  function Context(df, transforms, functions, expr) {
    this.dataflow = df;
    this.transforms = transforms;
    this.events = df.events.bind(df);
    this.expr = expr || expressionCodegen, this.signals = {};
    this.scales = {};
    this.nodes = {};
    this.data = {};
    this.fn = {};

    if (functions) {
      this.functions = Object.create(functions);
      this.functions.context = this;
    }
  }

  function Subcontext(ctx) {
    this.dataflow = ctx.dataflow;
    this.transforms = ctx.transforms;
    this.events = ctx.events;
    this.expr = ctx.expr;
    this.signals = Object.create(ctx.signals);
    this.scales = Object.create(ctx.scales);
    this.nodes = Object.create(ctx.nodes);
    this.data = Object.create(ctx.data);
    this.fn = Object.create(ctx.fn);

    if (ctx.functions) {
      this.functions = Object.create(ctx.functions);
      this.functions.context = this;
    }
  }

  Context.prototype = Subcontext.prototype = {
    fork() {
      const ctx = new Subcontext(this);
      (this.subcontext || (this.subcontext = [])).push(ctx);
      return ctx;
    },

    detach(ctx) {
      this.subcontext = this.subcontext.filter(c => c !== ctx); // disconnect all nodes in the subcontext
      // wipe out targets first for better efficiency

      const keys = Object.keys(ctx.nodes);

      for (const key of keys) ctx.nodes[key]._targets = null;

      for (const key of keys) ctx.nodes[key].detach();

      ctx.nodes = null;
    },

    get(id) {
      return this.nodes[id];
    },

    set(id, node) {
      return this.nodes[id] = node;
    },

    add(spec, op) {
      const ctx = this,
            df = ctx.dataflow,
            data = spec.value;
      ctx.set(spec.id, op);

      if (isCollect(spec.type) && data) {
        if (data.$ingest) {
          df.ingest(op, data.$ingest, data.$format);
        } else if (data.$request) {
          df.preload(op, data.$request, data.$format);
        } else {
          df.pulse(op, df.changeset().insert(data));
        }
      }

      if (spec.root) {
        ctx.root = op;
      }

      if (spec.parent) {
        let p = ctx.get(spec.parent.$ref);

        if (p) {
          df.connect(p, [op]);
          op.targets().add(p);
        } else {
          (ctx.unresolved = ctx.unresolved || []).push(() => {
            p = ctx.get(spec.parent.$ref);
            df.connect(p, [op]);
            op.targets().add(p);
          });
        }
      }

      if (spec.signal) {
        ctx.signals[spec.signal] = op;
      }

      if (spec.scale) {
        ctx.scales[spec.scale] = op;
      }

      if (spec.data) {
        for (const name in spec.data) {
          const data = ctx.data[name] || (ctx.data[name] = {});
          spec.data[name].forEach(role => data[role] = op);
        }
      }
    },

    resolve() {
      (this.unresolved || []).forEach(fn => fn());
      delete this.unresolved;
      return this;
    },

    operator(spec, update) {
      this.add(spec, this.dataflow.add(spec.value, update));
    },

    transform(spec, type) {
      this.add(spec, this.dataflow.add(this.transforms[canonicalType(type)]));
    },

    stream(spec, stream) {
      this.set(spec.id, stream);
    },

    update(spec, stream, target, update, params) {
      this.dataflow.on(stream, target, update, params, spec.options);
    },

    // expression parsing
    operatorExpression(expr) {
      return this.expr.operator(this, expr);
    },

    parameterExpression(expr) {
      return this.expr.parameter(this, expr);
    },

    eventExpression(expr) {
      return this.expr.event(this, expr);
    },

    handlerExpression(expr) {
      return this.expr.handler(this, expr);
    },

    encodeExpression(encode) {
      return this.expr.encode(this, encode);
    },

    // parse methods
    parse: parse$2,
    parseOperator,
    parseOperatorParameters,
    parseParameters: parseParameters$1,
    parseStream: parseStream$2,
    parseUpdate: parseUpdate$1,
    // state methods
    getState: getState$1,
    setState: setState$1
  };

  function initializeAria(view) {
    const el = view.container();

    if (el) {
      el.setAttribute('role', 'graphics-document');
      el.setAttribute('aria-roleDescription', 'visualization');
      ariaLabel(el, view.description());
    }
  } // update aria-label if we have a DOM container element


  function ariaLabel(el, desc) {
    if (el) desc == null ? el.removeAttribute('aria-label') : el.setAttribute('aria-label', desc);
  }

  function background(view) {
    // respond to background signal
    view.add(null, _ => {
      view._background = _.bg;
      view._resize = 1;
      return _.bg;
    }, {
      bg: view._signals.background
    });
  }

  const Default = 'default';

  function cursor(view) {
    // get cursor signal, add to dataflow if needed
    const cursor = view._signals.cursor || (view._signals.cursor = view.add({
      user: Default,
      item: null
    })); // evaluate cursor on each mousemove event

    view.on(view.events('view', 'mousemove'), cursor, (_, event) => {
      const value = cursor.value,
            user = value ? isString(value) ? value : value.user : Default,
            item = event.item && event.item.cursor || null;
      return value && user === value.user && item == value.item ? value : {
        user: user,
        item: item
      };
    }); // when cursor signal updates, set visible cursor

    view.add(null, function (_) {
      let user = _.cursor,
          item = this.value;

      if (!isString(user)) {
        item = user.item;
        user = user.user;
      }

      setCursor(view, user && user !== Default ? user : item || user);
      return item;
    }, {
      cursor: cursor
    });
  }

  function setCursor(view, cursor) {
    const el = view.globalCursor() ? typeof document !== 'undefined' && document.body : view.container();

    if (el) {
      return cursor == null ? el.style.removeProperty('cursor') : el.style.cursor = cursor;
    }
  }

  function dataref(view, name) {
    var data = view._runtime.data;

    if (!has$1(data, name)) {
      error('Unrecognized data set: ' + name);
    }

    return data[name];
  }

  function data(name, values) {
    return arguments.length < 2 ? dataref(this, name).values.value : change.call(this, name, changeset().remove(truthy).insert(values));
  }

  function change(name, changes) {
    if (!isChangeSet(changes)) {
      error('Second argument to changes must be a changeset.');
    }

    const dataset = dataref(this, name);
    dataset.modified = true;
    return this.pulse(dataset.input, changes);
  }

  function insert(name, _) {
    return change.call(this, name, changeset().insert(_));
  }

  function remove(name, _) {
    return change.call(this, name, changeset().remove(_));
  }

  function width(view) {
    var padding = view.padding();
    return Math.max(0, view._viewWidth + padding.left + padding.right);
  }

  function height(view) {
    var padding = view.padding();
    return Math.max(0, view._viewHeight + padding.top + padding.bottom);
  }

  function offset(view) {
    var padding = view.padding(),
        origin = view._origin;
    return [padding.left + origin[0], padding.top + origin[1]];
  }

  function resizeRenderer(view) {
    var origin = offset(view),
        w = width(view),
        h = height(view);

    view._renderer.background(view.background());

    view._renderer.resize(w, h, origin);

    view._handler.origin(origin);

    view._resizeListeners.forEach(handler => {
      try {
        handler(w, h);
      } catch (error) {
        view.error(error);
      }
    });
  }
  /**
   * Extend an event with additional view-specific methods.
   * Adds a new property ('vega') to an event that provides a number
   * of methods for querying information about the current interaction.
   * The vega object provides the following methods:
   *   view - Returns the backing View instance.
   *   item - Returns the currently active scenegraph item (if any).
   *   group - Returns the currently active scenegraph group (if any).
   *     This method accepts a single string-typed argument indicating the name
   *     of the desired parent group. The scenegraph will be traversed from
   *     the item up towards the root to search for a matching group. If no
   *     argument is provided the enclosing group for the active item is
   *     returned, unless the item it itself a group, in which case it is
   *     returned directly.
   *   xy - Returns a two-element array containing the x and y coordinates for
   *     mouse or touch events. For touch events, this is based on the first
   *     elements in the changedTouches array. This method accepts a single
   *     argument: either an item instance or mark name that should serve as
   *     the reference coordinate system. If no argument is provided the
   *     top-level view coordinate system is assumed.
   *   x - Returns the current x-coordinate, accepts the same arguments as xy.
   *   y - Returns the current y-coordinate, accepts the same arguments as xy.
   * @param {Event} event - The input event to extend.
   * @param {Item} item - The currently active scenegraph item (if any).
   * @return {Event} - The extended input event.
   */


  function eventExtend(view, event, item) {
    var r = view._renderer,
        el = r && r.canvas(),
        p,
        e,
        translate;

    if (el) {
      translate = offset(view);
      e = event.changedTouches ? event.changedTouches[0] : event;
      p = point(e, el);
      p[0] -= translate[0];
      p[1] -= translate[1];
    }

    event.dataflow = view;
    event.item = item;
    event.vega = extension(view, item, p);
    return event;
  }

  function extension(view, item, point) {
    const itemGroup = item ? item.mark.marktype === 'group' ? item : item.mark.group : null;

    function group(name) {
      var g = itemGroup,
          i;
      if (name) for (i = item; i; i = i.mark.group) {
        if (i.mark.name === name) {
          g = i;
          break;
        }
      }
      return g && g.mark && g.mark.interactive ? g : {};
    }

    function xy(item) {
      if (!item) return point;
      if (isString(item)) item = group(item);
      const p = point.slice();

      while (item) {
        p[0] -= item.x || 0;
        p[1] -= item.y || 0;
        item = item.mark && item.mark.group;
      }

      return p;
    }

    return {
      view: constant$4(view),
      item: constant$4(item || {}),
      group: group,
      xy: xy,
      x: item => xy(item)[0],
      y: item => xy(item)[1]
    };
  }

  const VIEW$1 = 'view',
        TIMER = 'timer',
        WINDOW = 'window',
        NO_TRAP = {
    trap: false
  };
  /**
   * Initialize event handling configuration.
   * @param {object} config - The configuration settings.
   * @return {object}
   */

  function initializeEventConfig(config) {
    const events = extend$1({
      defaults: {}
    }, config);

    const unpack = (obj, keys) => {
      keys.forEach(k => {
        if (isArray(obj[k])) obj[k] = toSet(obj[k]);
      });
    };

    unpack(events.defaults, ['prevent', 'allow']);
    unpack(events, ['view', 'window', 'selector']);
    return events;
  }

  function trackEventListener(view, sources, type, handler) {
    view._eventListeners.push({
      type: type,
      sources: array$5(sources),
      handler: handler
    });
  }

  function prevent(view, type) {
    var def = view._eventConfig.defaults,
        prevent = def.prevent,
        allow = def.allow;
    return prevent === false || allow === true ? false : prevent === true || allow === false ? true : prevent ? prevent[type] : allow ? !allow[type] : view.preventDefault();
  }

  function permit(view, key, type) {
    const rule = view._eventConfig && view._eventConfig[key];

    if (rule === false || isObject(rule) && !rule[type]) {
      view.warn(`Blocked ${key} ${type} event listener.`);
      return false;
    }

    return true;
  }
  /**
   * Create a new event stream from an event source.
   * @param {object} source - The event source to monitor.
   * @param {string} type - The event type.
   * @param {function(object): boolean} [filter] - Event filter function.
   * @return {EventStream}
   */


  function events(source, type, filter) {
    var view = this,
        s = new EventStream(filter),
        send = function (e, item) {
      view.runAsync(null, () => {
        if (source === VIEW$1 && prevent(view, type)) {
          e.preventDefault();
        }

        s.receive(eventExtend(view, e, item));
      });
    },
        sources;

    if (source === TIMER) {
      if (permit(view, 'timer', type)) {
        view.timer(send, type);
      }
    } else if (source === VIEW$1) {
      if (permit(view, 'view', type)) {
        // send traps errors, so use {trap: false} option
        view.addEventListener(type, send, NO_TRAP);
      }
    } else {
      if (source === WINDOW) {
        if (permit(view, 'window', type) && typeof window !== 'undefined') {
          sources = [window];
        }
      } else if (typeof document !== 'undefined') {
        if (permit(view, 'selector', type)) {
          sources = document.querySelectorAll(source);
        }
      }

      if (!sources) {
        view.warn('Can not resolve event source: ' + source);
      } else {
        for (var i = 0, n = sources.length; i < n; ++i) {
          sources[i].addEventListener(type, send);
        }

        trackEventListener(view, sources, type, send);
      }
    }

    return s;
  }

  function itemFilter(event) {
    return event.item;
  }

  function markTarget(event) {
    // grab upstream collector feeding the mark operator
    return event.item.mark.source;
  }

  function invoke(name) {
    return function (_, event) {
      return event.vega.view().changeset().encode(event.item, name);
    };
  }

  function hover(hoverSet, leaveSet) {
    hoverSet = [hoverSet || 'hover'];
    leaveSet = [leaveSet || 'update', hoverSet[0]]; // invoke hover set upon mouseover

    this.on(this.events('view', 'mouseover', itemFilter), markTarget, invoke(hoverSet)); // invoke leave set upon mouseout

    this.on(this.events('view', 'mouseout', itemFilter), markTarget, invoke(leaveSet));
    return this;
  }
  /**
   * Finalize a View instance that is being removed.
   * Cancel any running timers.
   * Remove all external event listeners.
   * Remove any currently displayed tooltip.
   */


  function finalize() {
    var tooltip = this._tooltip,
        timers = this._timers,
        listeners = this._eventListeners,
        n,
        m,
        e;
    n = timers.length;

    while (--n >= 0) {
      timers[n].stop();
    }

    n = listeners.length;

    while (--n >= 0) {
      e = listeners[n];
      m = e.sources.length;

      while (--m >= 0) {
        e.sources[m].removeEventListener(e.type, e.handler);
      }
    }

    if (tooltip) {
      tooltip.call(this, this._handler, null, null, null);
    }

    return this;
  }

  function element(tag, attr, text) {
    const el = document.createElement(tag);

    for (const key in attr) el.setAttribute(key, attr[key]);

    if (text != null) el.textContent = text;
    return el;
  }

  const BindClass = 'vega-bind',
        NameClass = 'vega-bind-name',
        RadioClass = 'vega-bind-radio';
  /**
   * Bind a signal to an external HTML input element. The resulting two-way
   * binding will propagate input changes to signals, and propagate signal
   * changes to the input element state. If this view instance has no parent
   * element, we assume the view is headless and no bindings are created.
   * @param {Element|string} el - The parent DOM element to which the input
   *   element should be appended as a child. If string-valued, this argument
   *   will be treated as a CSS selector. If null or undefined, the parent
   *   element of this view will be used as the element.
   * @param {object} param - The binding parameters which specify the signal
   *   to bind to, the input element type, and type-specific configuration.
   * @return {View} - This view instance.
   */

  function bind(view, el, binding) {
    if (!el) return;
    const param = binding.param;
    let bind = binding.state;

    if (!bind) {
      bind = binding.state = {
        elements: null,
        active: false,
        set: null,
        update: value => {
          if (value != view.signal(param.signal)) {
            view.runAsync(null, () => {
              bind.source = true;
              view.signal(param.signal, value);
            });
          }
        }
      };

      if (param.debounce) {
        bind.update = debounce(param.debounce, bind.update);
      }
    }

    const create = param.input == null && param.element ? target : generate;
    create(bind, el, param, view);

    if (!bind.active) {
      view.on(view._signals[param.signal], null, () => {
        bind.source ? bind.source = false : bind.set(view.signal(param.signal));
      });
      bind.active = true;
    }

    return bind;
  }
  /**
   * Bind the signal to an external EventTarget.
   */


  function target(bind, node, param, view) {
    const type = param.event || 'input';

    const handler = () => bind.update(node.value); // initialize signal value to external input value


    view.signal(param.signal, node.value); // listen for changes on the element

    node.addEventListener(type, handler); // register with view, so we can remove it upon finalization

    trackEventListener(view, node, type, handler); // propagate change to element

    bind.set = value => {
      node.value = value;
      node.dispatchEvent(event(type));
    };
  }

  function event(type) {
    return typeof Event !== 'undefined' ? new Event(type) : {
      type
    };
  }
  /**
   * Generate an HTML input form element and bind it to a signal.
   */


  function generate(bind, el, param, view) {
    const value = view.signal(param.signal);
    const div = element('div', {
      'class': BindClass
    });
    const wrapper = param.input === 'radio' ? div : div.appendChild(element('label'));
    wrapper.appendChild(element('span', {
      'class': NameClass
    }, param.name || param.signal));
    el.appendChild(div);
    let input = form;

    switch (param.input) {
      case 'checkbox':
        input = checkbox;
        break;

      case 'select':
        input = select;
        break;

      case 'radio':
        input = radio;
        break;

      case 'range':
        input = range;
        break;
    }

    input(bind, wrapper, param, value);
  }
  /**
   * Generates an arbitrary input form element.
   * The input type is controlled via user-provided parameters.
   */


  function form(bind, el, param, value) {
    const node = element('input');

    for (const key in param) {
      if (key !== 'signal' && key !== 'element') {
        node.setAttribute(key === 'input' ? 'type' : key, param[key]);
      }
    }

    node.setAttribute('name', param.signal);
    node.value = value;
    el.appendChild(node);
    node.addEventListener('input', () => bind.update(node.value));
    bind.elements = [node];

    bind.set = value => node.value = value;
  }
  /**
   * Generates a checkbox input element.
   */


  function checkbox(bind, el, param, value) {
    const attr = {
      type: 'checkbox',
      name: param.signal
    };
    if (value) attr.checked = true;
    const node = element('input', attr);
    el.appendChild(node);
    node.addEventListener('change', () => bind.update(node.checked));
    bind.elements = [node];

    bind.set = value => node.checked = !!value || null;
  }
  /**
   * Generates a selection list input element.
   */


  function select(bind, el, param, value) {
    const node = element('select', {
      name: param.signal
    }),
          labels = param.labels || [];
    param.options.forEach((option, i) => {
      const attr = {
        value: option
      };
      if (valuesEqual(option, value)) attr.selected = true;
      node.appendChild(element('option', attr, (labels[i] || option) + ''));
    });
    el.appendChild(node);
    node.addEventListener('change', () => {
      bind.update(param.options[node.selectedIndex]);
    });
    bind.elements = [node];

    bind.set = value => {
      for (let i = 0, n = param.options.length; i < n; ++i) {
        if (valuesEqual(param.options[i], value)) {
          node.selectedIndex = i;
          return;
        }
      }
    };
  }
  /**
   * Generates a radio button group.
   */


  function radio(bind, el, param, value) {
    const group = element('span', {
      'class': RadioClass
    }),
          labels = param.labels || [];
    el.appendChild(group);
    bind.elements = param.options.map((option, i) => {
      const attr = {
        type: 'radio',
        name: param.signal,
        value: option
      };
      if (valuesEqual(option, value)) attr.checked = true;
      const input = element('input', attr);
      input.addEventListener('change', () => bind.update(option));
      const label = element('label', {}, (labels[i] || option) + '');
      label.prepend(input);
      group.appendChild(label);
      return input;
    });

    bind.set = value => {
      const nodes = bind.elements,
            n = nodes.length;

      for (let i = 0; i < n; ++i) {
        if (valuesEqual(nodes[i].value, value)) nodes[i].checked = true;
      }
    };
  }
  /**
   * Generates a slider input element.
   */


  function range(bind, el, param, value) {
    value = value !== undefined ? value : (+param.max + +param.min) / 2;
    const max = param.max != null ? param.max : Math.max(100, +value) || 100,
          min = param.min || Math.min(0, max, +value) || 0,
          step = param.step || tickStep(min, max, 100);
    const node = element('input', {
      type: 'range',
      name: param.signal,
      min: min,
      max: max,
      step: step
    });
    node.value = value;
    const span = element('span', {}, +value);
    el.appendChild(node);
    el.appendChild(span);

    const update = () => {
      span.textContent = node.value;
      bind.update(+node.value);
    }; // subscribe to both input and change


    node.addEventListener('input', update);
    node.addEventListener('change', update);
    bind.elements = [node];

    bind.set = value => {
      node.value = value;
      span.textContent = value;
    };
  }

  function valuesEqual(a, b) {
    return a === b || a + '' === b + '';
  }

  function initializeRenderer(view, r, el, constructor, scaleFactor, opt) {
    r = r || new constructor(view.loader());
    return r.initialize(el, width(view), height(view), offset(view), scaleFactor, opt).background(view.background());
  }

  function trap(view, fn) {
    return !fn ? null : function () {
      try {
        fn.apply(this, arguments);
      } catch (error) {
        view.error(error);
      }
    };
  }

  function initializeHandler(view, prevHandler, el, constructor) {
    // instantiate scenegraph handler
    const handler = new constructor(view.loader(), trap(view, view.tooltip())).scene(view.scenegraph().root).initialize(el, offset(view), view); // transfer event handlers

    if (prevHandler) {
      prevHandler.handlers().forEach(h => {
        handler.on(h.type, h.handler);
      });
    }

    return handler;
  }

  function initialize(el, elBind) {
    const view = this,
          type = view._renderType,
          config = view._eventConfig.bind,
          module = renderModule(type); // containing dom element

    el = view._el = el ? lookup$1(view, el, true) : null; // initialize aria attributes

    initializeAria(view); // select appropriate renderer & handler

    if (!module) view.error('Unrecognized renderer type: ' + type);
    const Handler = module.handler || CanvasHandler,
          Renderer = el ? module.renderer : module.headless; // initialize renderer and input handler

    view._renderer = !Renderer ? null : initializeRenderer(view, view._renderer, el, Renderer);
    view._handler = initializeHandler(view, view._handler, el, Handler);
    view._redraw = true; // initialize signal bindings

    if (el && config !== 'none') {
      elBind = elBind ? view._elBind = lookup$1(view, elBind, true) : el.appendChild(element('form', {
        'class': 'vega-bindings'
      }));

      view._bind.forEach(_ => {
        if (_.param.element && config !== 'container') {
          _.element = lookup$1(view, _.param.element, !!_.param.input);
        }
      });

      view._bind.forEach(_ => {
        bind(view, _.element || elBind, _);
      });
    }

    return view;
  }

  function lookup$1(view, el, clear) {
    if (typeof el === 'string') {
      if (typeof document !== 'undefined') {
        el = document.querySelector(el);

        if (!el) {
          view.error('Signal bind element not found: ' + el);
          return null;
        }
      } else {
        view.error('DOM document instance not found.');
        return null;
      }
    }

    if (el && clear) {
      try {
        el.innerHTML = '';
      } catch (e) {
        el = null;
        view.error(e);
      }
    }

    return el;
  }

  const number$1 = _ => +_ || 0;

  const paddingObject$1 = _ => ({
    top: _,
    bottom: _,
    left: _,
    right: _
  });

  function padding(_) {
    return isObject(_) ? {
      top: number$1(_.top),
      bottom: number$1(_.bottom),
      left: number$1(_.left),
      right: number$1(_.right)
    } : paddingObject$1(number$1(_));
  }
  /**
   * Render the current scene in a headless fashion.
   * This method is asynchronous, returning a Promise instance.
   * @return {Promise} - A Promise that resolves to a renderer.
   */


  async function renderHeadless(view, type, scaleFactor, opt) {
    const module = renderModule(type),
          ctr = module && module.headless;
    if (!ctr) error('Unrecognized renderer type: ' + type);
    await view.runAsync();
    return initializeRenderer(view, null, null, ctr, scaleFactor, opt).renderAsync(view._scenegraph.root);
  }
  /**
   * Produce an image URL for the visualization. Depending on the type
   * parameter, the generated URL contains data for either a PNG or SVG image.
   * The URL can be used (for example) to download images of the visualization.
   * This method is asynchronous, returning a Promise instance.
   * @param {string} type - The image type. One of 'svg', 'png' or 'canvas'.
   *   The 'canvas' and 'png' types are synonyms for a PNG image.
   * @return {Promise} - A promise that resolves to an image URL.
   */


  async function renderToImageURL(type, scaleFactor) {
    if (type !== RenderType.Canvas && type !== RenderType.SVG && type !== RenderType.PNG) {
      error('Unrecognized image type: ' + type);
    }

    const r = await renderHeadless(this, type, scaleFactor);
    return type === RenderType.SVG ? toBlobURL(r.svg(), 'image/svg+xml') : r.canvas().toDataURL('image/png');
  }

  function toBlobURL(data, mime) {
    const blob = new Blob([data], {
      type: mime
    });
    return window.URL.createObjectURL(blob);
  }
  /**
   * Produce a Canvas instance containing a rendered visualization.
   * This method is asynchronous, returning a Promise instance.
   * @return {Promise} - A promise that resolves to a Canvas instance.
   */


  async function renderToCanvas(scaleFactor, opt) {
    const r = await renderHeadless(this, RenderType.Canvas, scaleFactor, opt);
    return r.canvas();
  }
  /**
   * Produce a rendered SVG string of the visualization.
   * This method is asynchronous, returning a Promise instance.
   * @return {Promise} - A promise that resolves to an SVG string.
   */


  async function renderToSVG(scaleFactor) {
    const r = await renderHeadless(this, RenderType.SVG, scaleFactor);
    return r.svg();
  }

  function runtime(view, spec, expr) {
    return context(view, transforms, functionContext, expr).parse(spec);
  }

  function scale$1(name) {
    var scales = this._runtime.scales;

    if (!has$1(scales, name)) {
      error('Unrecognized scale or projection: ' + name);
    }

    return scales[name].value;
  }

  var Width = 'width',
      Height = 'height',
      Padding = 'padding',
      Skip$1 = {
    skip: true
  };

  function viewWidth(view, width) {
    var a = view.autosize(),
        p = view.padding();
    return width - (a && a.contains === Padding ? p.left + p.right : 0);
  }

  function viewHeight(view, height) {
    var a = view.autosize(),
        p = view.padding();
    return height - (a && a.contains === Padding ? p.top + p.bottom : 0);
  }

  function initializeResize(view) {
    var s = view._signals,
        w = s[Width],
        h = s[Height],
        p = s[Padding];

    function resetSize() {
      view._autosize = view._resize = 1;
    } // respond to width signal


    view._resizeWidth = view.add(null, _ => {
      view._width = _.size;
      view._viewWidth = viewWidth(view, _.size);
      resetSize();
    }, {
      size: w
    }); // respond to height signal

    view._resizeHeight = view.add(null, _ => {
      view._height = _.size;
      view._viewHeight = viewHeight(view, _.size);
      resetSize();
    }, {
      size: h
    }); // respond to padding signal

    const resizePadding = view.add(null, resetSize, {
      pad: p
    }); // set rank to run immediately after source signal

    view._resizeWidth.rank = w.rank + 1;
    view._resizeHeight.rank = h.rank + 1;
    resizePadding.rank = p.rank + 1;
  }

  function resizeView(viewWidth, viewHeight, width, height, origin, auto) {
    this.runAfter(view => {
      let rerun = 0; // reset autosize flag

      view._autosize = 0; // width value changed: update signal, skip resize op

      if (view.width() !== width) {
        rerun = 1;
        view.signal(Width, width, Skip$1); // set width, skip update calc

        view._resizeWidth.skip(true); // skip width resize handler

      } // height value changed: update signal, skip resize op


      if (view.height() !== height) {
        rerun = 1;
        view.signal(Height, height, Skip$1); // set height, skip update calc

        view._resizeHeight.skip(true); // skip height resize handler

      } // view width changed: update view property, set resize flag


      if (view._viewWidth !== viewWidth) {
        view._resize = 1;
        view._viewWidth = viewWidth;
      } // view height changed: update view property, set resize flag


      if (view._viewHeight !== viewHeight) {
        view._resize = 1;
        view._viewHeight = viewHeight;
      } // origin changed: update view property, set resize flag


      if (view._origin[0] !== origin[0] || view._origin[1] !== origin[1]) {
        view._resize = 1;
        view._origin = origin;
      } // run dataflow on width/height signal change


      if (rerun) view.run('enter');
      if (auto) view.runAfter(v => v.resize());
    }, false, 1);
  }
  /**
   * Get the current view state, consisting of signal values and/or data sets.
   * @param {object} [options] - Options flags indicating which state to export.
   *   If unspecified, all signals and data sets will be exported.
   * @param {function(string, Operator):boolean} [options.signals] - Optional
   *   predicate function for testing if a signal should be included in the
   *   exported state. If unspecified, all signals will be included, except for
   *   those named 'parent' or those which refer to a Transform value.
   * @param {function(string, object):boolean} [options.data] - Optional
   *   predicate function for testing if a data set's input should be included
   *   in the exported state. If unspecified, all data sets that have been
   *   explicitly modified will be included.
   * @param {boolean} [options.recurse=true] - Flag indicating if the exported
   *   state should recursively include state from group mark sub-contexts.
   * @return {object} - An object containing the exported state values.
   */


  function getState(options) {
    return this._runtime.getState(options || {
      data: dataTest,
      signals: signalTest,
      recurse: true
    });
  }

  function dataTest(name, data) {
    return data.modified && isArray(data.input.value) && name.indexOf('_:vega:_');
  }

  function signalTest(name, op) {
    return !(name === 'parent' || op instanceof transforms.proxy);
  }
  /**
   * Sets the current view state and updates the view by invoking run.
   * @param {object} state - A state object containing signal and/or
   *   data set values, following the format used by the getState method.
   * @return {View} - This view instance.
   */


  function setState(state) {
    this.runAsync(null, v => {
      v._trigger = false;

      v._runtime.setState(state);
    }, v => {
      v._trigger = true;
    });
    return this;
  }

  function timer(callback, delay) {
    function tick(elapsed) {
      callback({
        timestamp: Date.now(),
        elapsed: elapsed
      });
    }

    this._timers.push(interval(tick, delay));
  }

  function defaultTooltip(handler, event, item, value) {
    const el = handler.element();
    if (el) el.setAttribute('title', formatTooltip(value));
  }

  function formatTooltip(value) {
    return value == null ? '' : isArray(value) ? formatArray(value) : isObject(value) && !isDate$1(value) ? formatObject(value) : value + '';
  }

  function formatObject(obj) {
    return Object.keys(obj).map(key => {
      const v = obj[key];
      return key + ': ' + (isArray(v) ? formatArray(v) : formatValue(v));
    }).join('\n');
  }

  function formatArray(value) {
    return '[' + value.map(formatValue).join(', ') + ']';
  }

  function formatValue(value) {
    return isArray(value) ? '[\u2026]' : isObject(value) && !isDate$1(value) ? '{\u2026}' : value;
  }
  /**
   * Create a new View instance from a Vega dataflow runtime specification.
   * The generated View will not immediately be ready for display. Callers
   * should also invoke the initialize method (e.g., to set the parent
   * DOM element in browser-based deployment) and then invoke the run
   * method to evaluate the dataflow graph. Rendering will automatically
   * be performed upon dataflow runs.
   * @constructor
   * @param {object} spec - The Vega dataflow runtime specification.
   */


  function View$1(spec, options) {
    const view = this;
    options = options || {};
    Dataflow.call(view);
    if (options.loader) view.loader(options.loader);
    if (options.logger) view.logger(options.logger);
    if (options.logLevel != null) view.logLevel(options.logLevel);

    if (options.locale || spec.locale) {
      const loc = extend$1({}, spec.locale, options.locale);
      view.locale(locale(loc.number, loc.time));
    }

    view._el = null;
    view._elBind = null;
    view._renderType = options.renderer || RenderType.Canvas;
    view._scenegraph = new Scenegraph();
    const root = view._scenegraph.root; // initialize renderer, handler and event management

    view._renderer = null;
    view._tooltip = options.tooltip || defaultTooltip, view._redraw = true;
    view._handler = new CanvasHandler().scene(root);
    view._globalCursor = false;
    view._preventDefault = false;
    view._timers = [];
    view._eventListeners = [];
    view._resizeListeners = []; // initialize event configuration

    view._eventConfig = initializeEventConfig(spec.eventConfig);
    view.globalCursor(view._eventConfig.globalCursor); // initialize dataflow graph

    const ctx = runtime(view, spec, options.expr);
    view._runtime = ctx;
    view._signals = ctx.signals;
    view._bind = (spec.bindings || []).map(_ => ({
      state: null,
      param: extend$1({}, _)
    })); // initialize scenegraph

    if (ctx.root) ctx.root.set(root);
    root.source = ctx.data.root.input;
    view.pulse(ctx.data.root.input, view.changeset().insert(root.items)); // initialize view size

    view._width = view.width();
    view._height = view.height();
    view._viewWidth = viewWidth(view, view._width);
    view._viewHeight = viewHeight(view, view._height);
    view._origin = [0, 0];
    view._resize = 0;
    view._autosize = 1;
    initializeResize(view); // initialize background color

    background(view); // initialize cursor

    cursor(view); // initialize view description

    view.description(spec.description); // initialize hover proessing, if requested

    if (options.hover) view.hover(); // initialize DOM container(s) and renderer

    if (options.container) view.initialize(options.container, options.bind);
  }

  function lookupSignal(view, name) {
    return has$1(view._signals, name) ? view._signals[name] : error('Unrecognized signal name: ' + $(name));
  }

  function findOperatorHandler(op, handler) {
    const h = (op._targets || []).filter(op => op._update && op._update.handler === handler);
    return h.length ? h[0] : null;
  }

  function addOperatorListener(view, name, op, handler) {
    let h = findOperatorHandler(op, handler);

    if (!h) {
      h = trap(view, () => handler(name, op.value));
      h.handler = handler;
      view.on(op, null, h);
    }

    return view;
  }

  function removeOperatorListener(view, op, handler) {
    const h = findOperatorHandler(op, handler);
    if (h) op._targets.remove(h);
    return view;
  }

  inherits(View$1, Dataflow, {
    // -- DATAFLOW / RENDERING ----
    async evaluate(encode, prerun, postrun) {
      // evaluate dataflow and prerun
      await Dataflow.prototype.evaluate.call(this, encode, prerun); // render as needed

      if (this._redraw || this._resize) {
        try {
          if (this._renderer) {
            if (this._resize) {
              this._resize = 0;
              resizeRenderer(this);
            }

            await this._renderer.renderAsync(this._scenegraph.root);
          }

          this._redraw = false;
        } catch (e) {
          this.error(e);
        }
      } // evaluate postrun


      if (postrun) asyncCallback(this, postrun);
      return this;
    },

    dirty(item) {
      this._redraw = true;
      this._renderer && this._renderer.dirty(item);
    },

    // -- GET / SET ----
    description(text) {
      if (arguments.length) {
        const desc = text != null ? text + '' : null;
        if (desc !== this._desc) ariaLabel(this._el, this._desc = desc);
        return this;
      }

      return this._desc;
    },

    container() {
      return this._el;
    },

    scenegraph() {
      return this._scenegraph;
    },

    origin() {
      return this._origin.slice();
    },

    signal(name, value, options) {
      const op = lookupSignal(this, name);
      return arguments.length === 1 ? op.value : this.update(op, value, options);
    },

    width(_) {
      return arguments.length ? this.signal('width', _) : this.signal('width');
    },

    height(_) {
      return arguments.length ? this.signal('height', _) : this.signal('height');
    },

    padding(_) {
      return arguments.length ? this.signal('padding', padding(_)) : padding(this.signal('padding'));
    },

    autosize(_) {
      return arguments.length ? this.signal('autosize', _) : this.signal('autosize');
    },

    background(_) {
      return arguments.length ? this.signal('background', _) : this.signal('background');
    },

    renderer(type) {
      if (!arguments.length) return this._renderType;
      if (!renderModule(type)) error('Unrecognized renderer type: ' + type);

      if (type !== this._renderType) {
        this._renderType = type;

        this._resetRenderer();
      }

      return this;
    },

    tooltip(handler) {
      if (!arguments.length) return this._tooltip;

      if (handler !== this._tooltip) {
        this._tooltip = handler;

        this._resetRenderer();
      }

      return this;
    },

    loader(loader) {
      if (!arguments.length) return this._loader;

      if (loader !== this._loader) {
        Dataflow.prototype.loader.call(this, loader);

        this._resetRenderer();
      }

      return this;
    },

    resize() {
      // set flag to perform autosize
      this._autosize = 1; // touch autosize signal to ensure top-level ViewLayout runs

      return this.touch(lookupSignal(this, 'autosize'));
    },

    _resetRenderer() {
      if (this._renderer) {
        this._renderer = null;
        this.initialize(this._el, this._elBind);
      }
    },

    // -- SIZING ----
    _resizeView: resizeView,

    // -- EVENT HANDLING ----
    addEventListener(type, handler, options) {
      let callback = handler;

      if (!(options && options.trap === false)) {
        // wrap callback in error handler
        callback = trap(this, handler);
        callback.raw = handler;
      }

      this._handler.on(type, callback);

      return this;
    },

    removeEventListener(type, handler) {
      var handlers = this._handler.handlers(type),
          i = handlers.length,
          h,
          t; // search registered handlers, remove if match found


      while (--i >= 0) {
        t = handlers[i].type;
        h = handlers[i].handler;

        if (type === t && (handler === h || handler === h.raw)) {
          this._handler.off(t, h);

          break;
        }
      }

      return this;
    },

    addResizeListener(handler) {
      const l = this._resizeListeners;

      if (l.indexOf(handler) < 0) {
        // add handler if it isn't already registered
        // note: error trapping handled elsewhere, so
        // no need to wrap handlers here
        l.push(handler);
      }

      return this;
    },

    removeResizeListener(handler) {
      var l = this._resizeListeners,
          i = l.indexOf(handler);

      if (i >= 0) {
        l.splice(i, 1);
      }

      return this;
    },

    addSignalListener(name, handler) {
      return addOperatorListener(this, name, lookupSignal(this, name), handler);
    },

    removeSignalListener(name, handler) {
      return removeOperatorListener(this, lookupSignal(this, name), handler);
    },

    addDataListener(name, handler) {
      return addOperatorListener(this, name, dataref(this, name).values, handler);
    },

    removeDataListener(name, handler) {
      return removeOperatorListener(this, dataref(this, name).values, handler);
    },

    globalCursor(_) {
      if (arguments.length) {
        if (this._globalCursor !== !!_) {
          const prev = setCursor(this, null); // clear previous cursor

          this._globalCursor = !!_;
          if (prev) setCursor(this, prev); // swap cursor
        }

        return this;
      } else {
        return this._globalCursor;
      }
    },

    preventDefault(_) {
      if (arguments.length) {
        this._preventDefault = _;
        return this;
      } else {
        return this._preventDefault;
      }
    },

    timer,
    events,
    finalize,
    hover,
    // -- DATA ----
    data,
    change,
    insert,
    remove,
    // -- SCALES --
    scale: scale$1,
    // -- INITIALIZATION ----
    initialize,
    // -- HEADLESS RENDERING ----
    toImageURL: renderToImageURL,
    toCanvas: renderToCanvas,
    toSVG: renderToSVG,
    // -- SAVE / RESTORE STATE ----
    getState,
    setState
  });

  const VIEW = 'view',
        LBRACK = '[',
        RBRACK = ']',
        LBRACE = '{',
        RBRACE = '}',
        COLON = ':',
        COMMA = ',',
        NAME = '@',
        GT = '>',
        ILLEGAL = /[[\]{}]/,
        DEFAULT_MARKS = {
    '*': 1,
    arc: 1,
    area: 1,
    group: 1,
    image: 1,
    line: 1,
    path: 1,
    rect: 1,
    rule: 1,
    shape: 1,
    symbol: 1,
    text: 1,
    trail: 1
  };
  let DEFAULT_SOURCE, MARKS;
  /**
   * Parse an event selector string.
   * Returns an array of event stream definitions.
   */

  function eventSelector(selector, source, marks) {
    DEFAULT_SOURCE = source || VIEW;
    MARKS = marks || DEFAULT_MARKS;
    return parseMerge(selector.trim()).map(parseSelector);
  }

  function isMarkType(type) {
    return MARKS[type];
  }

  function find(s, i, endChar, pushChar, popChar) {
    const n = s.length;
    let count = 0,
        c;

    for (; i < n; ++i) {
      c = s[i];
      if (!count && c === endChar) return i;else if (popChar && popChar.indexOf(c) >= 0) --count;else if (pushChar && pushChar.indexOf(c) >= 0) ++count;
    }

    return i;
  }

  function parseMerge(s) {
    const output = [],
          n = s.length;
    let start = 0,
        i = 0;

    while (i < n) {
      i = find(s, i, COMMA, LBRACK + LBRACE, RBRACK + RBRACE);
      output.push(s.substring(start, i).trim());
      start = ++i;
    }

    if (output.length === 0) {
      throw 'Empty event selector: ' + s;
    }

    return output;
  }

  function parseSelector(s) {
    return s[0] === '[' ? parseBetween(s) : parseStream$1(s);
  }

  function parseBetween(s) {
    const n = s.length;
    let i = 1,
        b;
    i = find(s, i, RBRACK, LBRACK, RBRACK);

    if (i === n) {
      throw 'Empty between selector: ' + s;
    }

    b = parseMerge(s.substring(1, i));

    if (b.length !== 2) {
      throw 'Between selector must have two elements: ' + s;
    }

    s = s.slice(i + 1).trim();

    if (s[0] !== GT) {
      throw 'Expected \'>\' after between selector: ' + s;
    }

    b = b.map(parseSelector);
    const stream = parseSelector(s.slice(1).trim());

    if (stream.between) {
      return {
        between: b,
        stream: stream
      };
    } else {
      stream.between = b;
    }

    return stream;
  }

  function parseStream$1(s) {
    const stream = {
      source: DEFAULT_SOURCE
    },
          source = [];
    let throttle = [0, 0],
        markname = 0,
        start = 0,
        n = s.length,
        i = 0,
        j,
        filter; // extract throttle from end

    if (s[n - 1] === RBRACE) {
      i = s.lastIndexOf(LBRACE);

      if (i >= 0) {
        try {
          throttle = parseThrottle(s.substring(i + 1, n - 1));
        } catch (e) {
          throw 'Invalid throttle specification: ' + s;
        }

        s = s.slice(0, i).trim();
        n = s.length;
      } else throw 'Unmatched right brace: ' + s;

      i = 0;
    }

    if (!n) throw s; // set name flag based on first char

    if (s[0] === NAME) markname = ++i; // extract first part of multi-part stream selector

    j = find(s, i, COLON);

    if (j < n) {
      source.push(s.substring(start, j).trim());
      start = i = ++j;
    } // extract remaining part of stream selector


    i = find(s, i, LBRACK);

    if (i === n) {
      source.push(s.substring(start, n).trim());
    } else {
      source.push(s.substring(start, i).trim());
      filter = [];
      start = ++i;
      if (start === n) throw 'Unmatched left bracket: ' + s;
    } // extract filters


    while (i < n) {
      i = find(s, i, RBRACK);
      if (i === n) throw 'Unmatched left bracket: ' + s;
      filter.push(s.substring(start, i).trim());
      if (i < n - 1 && s[++i] !== LBRACK) throw 'Expected left bracket: ' + s;
      start = ++i;
    } // marshall event stream specification


    if (!(n = source.length) || ILLEGAL.test(source[n - 1])) {
      throw 'Invalid event selector: ' + s;
    }

    if (n > 1) {
      stream.type = source[1];

      if (markname) {
        stream.markname = source[0].slice(1);
      } else if (isMarkType(source[0])) {
        stream.marktype = source[0];
      } else {
        stream.source = source[0];
      }
    } else {
      stream.type = source[0];
    }

    if (stream.type.slice(-1) === '!') {
      stream.consume = true;
      stream.type = stream.type.slice(0, -1);
    }

    if (filter != null) stream.filter = filter;
    if (throttle[0]) stream.throttle = throttle[0];
    if (throttle[1]) stream.debounce = throttle[1];
    return stream;
  }

  function parseThrottle(s) {
    const a = s.split(COMMA);
    if (!s.length || a.length > 2) throw s;
    return a.map(_ => {
      const x = +_;
      if (x !== x) throw s;
      return x;
    });
  }

  function parseAutosize(spec) {
    return isObject(spec) ? spec : {
      type: spec || 'pad'
    };
  }

  const number = _ => +_ || 0;

  const paddingObject = _ => ({
    top: _,
    bottom: _,
    left: _,
    right: _
  });

  function parsePadding(spec) {
    return !isObject(spec) ? paddingObject(number(spec)) : spec.signal ? spec : {
      top: number(spec.top),
      bottom: number(spec.bottom),
      left: number(spec.left),
      right: number(spec.right)
    };
  }

  const encoder = _ => isObject(_) && !isArray(_) ? extend$1({}, _) : {
    value: _
  };

  function addEncode(object, name, value, set) {
    if (value != null) {
      const isEncoder = isObject(value) && !isArray(value) || isArray(value) && value.length && isObject(value[0]); // Always assign signal to update, even if the signal is from the enter block

      if (isEncoder) {
        object.update[name] = value;
      } else {
        object[set || 'enter'][name] = {
          value: value
        };
      }

      return 1;
    } else {
      return 0;
    }
  }

  function addEncoders(object, enter, update) {
    for (const name in enter) {
      addEncode(object, name, enter[name]);
    }

    for (const name in update) {
      addEncode(object, name, update[name], 'update');
    }
  }

  function extendEncode(encode, extra, skip) {
    for (const name in extra) {
      if (skip && has$1(skip, name)) continue;
      encode[name] = extend$1(encode[name] || {}, extra[name]);
    }

    return encode;
  }

  function has(key, encode) {
    return encode && (encode.enter && encode.enter[key] || encode.update && encode.update[key]);
  }

  const MarkRole = 'mark';
  const FrameRole = 'frame';
  const ScopeRole = 'scope';
  const AxisRole = 'axis';
  const AxisDomainRole = 'axis-domain';
  const AxisGridRole = 'axis-grid';
  const AxisLabelRole = 'axis-label';
  const AxisTickRole = 'axis-tick';
  const AxisTitleRole = 'axis-title';
  const LegendRole = 'legend';
  const LegendBandRole = 'legend-band';
  const LegendEntryRole = 'legend-entry';
  const LegendGradientRole = 'legend-gradient';
  const LegendLabelRole = 'legend-label';
  const LegendSymbolRole = 'legend-symbol';
  const LegendTitleRole = 'legend-title';
  const TitleRole = 'title';
  const TitleTextRole = 'title-text';
  const TitleSubtitleRole = 'title-subtitle';

  function applyDefaults(encode, type, role, style, config) {
    const defaults = {},
          enter = {};
    let update, key, skip, props; // if text mark, apply global lineBreak settings (#2370)

    key = 'lineBreak';

    if (type === 'text' && config[key] != null && !has(key, encode)) {
      applyDefault(defaults, key, config[key]);
    } // ignore legend and axis roles


    if (role == 'legend' || String(role).startsWith('axis')) {
      role = null;
    } // resolve mark config


    props = role === FrameRole ? config.group : role === MarkRole ? extend$1({}, config.mark, config[type]) : null;

    for (key in props) {
      // do not apply defaults if relevant fields are defined
      skip = has(key, encode) || (key === 'fill' || key === 'stroke') && (has('fill', encode) || has('stroke', encode));
      if (!skip) applyDefault(defaults, key, props[key]);
    } // resolve styles, apply with increasing precedence


    array$5(style).forEach(name => {
      const props = config.style && config.style[name];

      for (const key in props) {
        if (!has(key, encode)) {
          applyDefault(defaults, key, props[key]);
        }
      }
    });
    encode = extend$1({}, encode); // defensive copy

    for (key in defaults) {
      props = defaults[key];

      if (props.signal) {
        (update = update || {})[key] = props;
      } else {
        enter[key] = props;
      }
    }

    encode.enter = extend$1(enter, encode.enter);
    if (update) encode.update = extend$1(update, encode.update);
    return encode;
  }

  function applyDefault(defaults, key, value) {
    defaults[key] = value && value.signal ? {
      signal: value.signal
    } : {
      value: value
    };
  }

  const scaleRef = scale => isString(scale) ? $(scale) : scale.signal ? `(${scale.signal})` : field(scale);

  function entry$1(enc) {
    if (enc.gradient != null) {
      return gradient(enc);
    }

    let value = enc.signal ? `(${enc.signal})` : enc.color ? color(enc.color) : enc.field != null ? field(enc.field) : enc.value !== undefined ? $(enc.value) : undefined;

    if (enc.scale != null) {
      value = scale(enc, value);
    }

    if (value === undefined) {
      value = null;
    }

    if (enc.exponent != null) {
      value = `pow(${value},${property(enc.exponent)})`;
    }

    if (enc.mult != null) {
      value += `*${property(enc.mult)}`;
    }

    if (enc.offset != null) {
      value += `+${property(enc.offset)}`;
    }

    if (enc.round) {
      value = `round(${value})`;
    }

    return value;
  }

  const _color = (type, x, y, z) => `(${type}(${[x, y, z].map(entry$1).join(',')})+'')`;

  function color(enc) {
    return enc.c ? _color('hcl', enc.h, enc.c, enc.l) : enc.h || enc.s ? _color('hsl', enc.h, enc.s, enc.l) : enc.l || enc.a ? _color('lab', enc.l, enc.a, enc.b) : enc.r || enc.g || enc.b ? _color('rgb', enc.r, enc.g, enc.b) : null;
  }

  function gradient(enc) {
    // map undefined to null; expression lang does not allow undefined
    const args = [enc.start, enc.stop, enc.count].map(_ => _ == null ? null : $(_)); // trim null inputs from the end

    while (args.length && peek$1(args) == null) args.pop();

    args.unshift(scaleRef(enc.gradient));
    return `gradient(${args.join(',')})`;
  }

  function property(property) {
    return isObject(property) ? '(' + entry$1(property) + ')' : property;
  }

  function field(ref) {
    return resolveField(isObject(ref) ? ref : {
      datum: ref
    });
  }

  function resolveField(ref) {
    let object, level, field;

    if (ref.signal) {
      object = 'datum';
      field = ref.signal;
    } else if (ref.group || ref.parent) {
      level = Math.max(1, ref.level || 1);
      object = 'item';

      while (level-- > 0) {
        object += '.mark.group';
      }

      if (ref.parent) {
        field = ref.parent;
        object += '.datum';
      } else {
        field = ref.group;
      }
    } else if (ref.datum) {
      object = 'datum';
      field = ref.datum;
    } else {
      error('Invalid field reference: ' + $(ref));
    }

    if (!ref.signal) {
      field = isString(field) ? splitAccessPath(field).map($).join('][') : resolveField(field);
    }

    return object + '[' + field + ']';
  }

  function scale(enc, value) {
    const scale = scaleRef(enc.scale);

    if (enc.range != null) {
      // pull value from scale range
      value = `lerp(_range(${scale}), ${+enc.range})`;
    } else {
      // run value through scale and/or pull scale bandwidth
      if (value !== undefined) value = `_scale(${scale}, ${value})`;

      if (enc.band) {
        value = (value ? value + '+' : '') + `_bandwidth(${scale})` + (+enc.band === 1 ? '' : '*' + property(enc.band));

        if (enc.extra) {
          // include logic to handle extraneous elements
          value = `(datum.extra ? _scale(${scale}, datum.extra.value) : ${value})`;
        }
      }

      if (value == null) value = '0';
    }

    return value;
  }

  function rule(enc) {
    let code = '';
    enc.forEach(rule => {
      const value = entry$1(rule);
      code += rule.test ? `(${rule.test})?${value}:` : value;
    }); // if no else clause, terminate with null (#1366)

    if (peek$1(code) === ':') {
      code += 'null';
    }

    return code;
  }

  function parseEncode(encode, type, role, style, scope, params) {
    const enc = {};
    params = params || {};
    params.encoders = {
      $encode: enc
    };
    encode = applyDefaults(encode, type, role, style, scope.config);

    for (const key in encode) {
      enc[key] = parseBlock(encode[key], type, params, scope);
    }

    return params;
  }

  function parseBlock(block, marktype, params, scope) {
    const channels = {},
          fields = {};

    for (const name in block) {
      if (block[name] != null) {
        // skip any null entries
        channels[name] = parse$1(expr(block[name]), scope, params, fields);
      }
    }

    return {
      $expr: {
        marktype,
        channels
      },
      $fields: Object.keys(fields),
      $output: Object.keys(block)
    };
  }

  function expr(enc) {
    return isArray(enc) ? rule(enc) : entry$1(enc);
  }

  function parse$1(code, scope, params, fields) {
    const expr = parser(code, scope);
    expr.$fields.forEach(name => fields[name] = 1);
    extend$1(params, expr.$params);
    return expr.$expr;
  }

  const OUTER = 'outer',
        OUTER_INVALID = ['value', 'update', 'init', 'react', 'bind'];

  function outerError(prefix, name) {
    error(prefix + ' for "outer" push: ' + $(name));
  }

  function parseSignal(signal, scope) {
    const name = signal.name;

    if (signal.push === OUTER) {
      // signal must already be defined, raise error if not
      if (!scope.signals[name]) outerError('No prior signal definition', name); // signal push must not use properties reserved for standard definition

      OUTER_INVALID.forEach(prop => {
        if (signal[prop] !== undefined) outerError('Invalid property ', prop);
      });
    } else {
      // define a new signal in the current scope
      const op = scope.addSignal(name, signal.value);
      if (signal.react === false) op.react = false;
      if (signal.bind) scope.addBinding(name, signal.bind);
    }
  }

  function Entry(type, value, params, parent) {
    this.id = -1;
    this.type = type;
    this.value = value;
    this.params = params;
    if (parent) this.parent = parent;
  }

  function entry(type, value, params, parent) {
    return new Entry(type, value, params, parent);
  }

  function operator(value, params) {
    return entry('operator', value, params);
  } // -----


  function ref(op) {
    const ref = {
      $ref: op.id
    }; // if operator not yet registered, cache ref to resolve later

    if (op.id < 0) (op.refs = op.refs || []).push(ref);
    return ref;
  }

  function fieldRef$1(field, name) {
    return name ? {
      $field: field,
      $name: name
    } : {
      $field: field
    };
  }

  const keyFieldRef = fieldRef$1('key');

  function compareRef(fields, orders) {
    return {
      $compare: fields,
      $order: orders
    };
  }

  function keyRef(fields, flat) {
    const ref = {
      $key: fields
    };
    if (flat) ref.$flat = true;
    return ref;
  } // -----


  const Ascending = 'ascending';
  const Descending = 'descending';

  function sortKey(sort) {
    return !isObject(sort) ? '' : (sort.order === Descending ? '-' : '+') + aggrField(sort.op, sort.field);
  }

  function aggrField(op, field) {
    return (op && op.signal ? '$' + op.signal : op || '') + (op && field ? '_' : '') + (field && field.signal ? '$' + field.signal : field || '');
  } // -----


  const Scope$1 = 'scope';
  const View = 'view';

  function isSignal(_) {
    return _ && _.signal;
  }

  function isExpr$1(_) {
    return _ && _.expr;
  }

  function hasSignal(_) {
    if (isSignal(_)) return true;
    if (isObject(_)) for (const key in _) {
      if (hasSignal(_[key])) return true;
    }
    return false;
  }

  function value(specValue, defaultValue) {
    return specValue != null ? specValue : defaultValue;
  }

  function deref(v) {
    return v && v.signal || v;
  }

  const Timer = 'timer';

  function parseStream(stream, scope) {
    const method = stream.merge ? mergeStream : stream.stream ? nestedStream : stream.type ? eventStream : error('Invalid stream specification: ' + $(stream));
    return method(stream, scope);
  }

  function eventSource(source) {
    return source === Scope$1 ? View : source || View;
  }

  function mergeStream(stream, scope) {
    const list = stream.merge.map(s => parseStream(s, scope)),
          entry = streamParameters({
      merge: list
    }, stream, scope);
    return scope.addStream(entry).id;
  }

  function nestedStream(stream, scope) {
    const id = parseStream(stream.stream, scope),
          entry = streamParameters({
      stream: id
    }, stream, scope);
    return scope.addStream(entry).id;
  }

  function eventStream(stream, scope) {
    let id;

    if (stream.type === Timer) {
      id = scope.event(Timer, stream.throttle);
      stream = {
        between: stream.between,
        filter: stream.filter
      };
    } else {
      id = scope.event(eventSource(stream.source), stream.type);
    }

    const entry = streamParameters({
      stream: id
    }, stream, scope);
    return Object.keys(entry).length === 1 ? id : scope.addStream(entry).id;
  }

  function streamParameters(entry, stream, scope) {
    let param = stream.between;

    if (param) {
      if (param.length !== 2) {
        error('Stream "between" parameter must have 2 entries: ' + $(stream));
      }

      entry.between = [parseStream(param[0], scope), parseStream(param[1], scope)];
    }

    param = stream.filter ? [].concat(stream.filter) : [];

    if (stream.marktype || stream.markname || stream.markrole) {
      // add filter for mark type, name and/or role
      param.push(filterMark(stream.marktype, stream.markname, stream.markrole));
    }

    if (stream.source === Scope$1) {
      // add filter to limit events from sub-scope only
      param.push('inScope(event.item)');
    }

    if (param.length) {
      entry.filter = parser('(' + param.join(')&&(') + ')', scope).$expr;
    }

    if ((param = stream.throttle) != null) {
      entry.throttle = +param;
    }

    if ((param = stream.debounce) != null) {
      entry.debounce = +param;
    }

    if (stream.consume) {
      entry.consume = true;
    }

    return entry;
  }

  function filterMark(type, name, role) {
    const item = 'event.item';
    return item + (type && type !== '*' ? '&&' + item + '.mark.marktype===\'' + type + '\'' : '') + (role ? '&&' + item + '.mark.role===\'' + role + '\'' : '') + (name ? '&&' + item + '.mark.name===\'' + name + '\'' : '');
  }

  const OP_VALUE_EXPR = {
    code: '_.$value',
    ast: {
      type: 'Identifier',
      value: 'value'
    }
  };

  function parseUpdate(spec, scope, target) {
    const encode = spec.encode,
          entry = {
      target: target
    };
    let events = spec.events,
        update = spec.update,
        sources = [];

    if (!events) {
      error('Signal update missing events specification.');
    } // interpret as an event selector string


    if (isString(events)) {
      events = eventSelector(events, scope.isSubscope() ? Scope$1 : View);
    } // separate event streams from signal updates


    events = array$5(events).filter(s => s.signal || s.scale ? (sources.push(s), 0) : 1); // merge internal operator listeners

    if (sources.length > 1) {
      sources = [mergeSources(sources)];
    } // merge event streams, include as source


    if (events.length) {
      sources.push(events.length > 1 ? {
        merge: events
      } : events[0]);
    }

    if (encode != null) {
      if (update) error('Signal encode and update are mutually exclusive.');
      update = 'encode(item(),' + $(encode) + ')';
    } // resolve update value


    entry.update = isString(update) ? parser(update, scope) : update.expr != null ? parser(update.expr, scope) : update.value != null ? update.value : update.signal != null ? {
      $expr: OP_VALUE_EXPR,
      $params: {
        $value: scope.signalRef(update.signal)
      }
    } : error('Invalid signal update specification.');

    if (spec.force) {
      entry.options = {
        force: true
      };
    }

    sources.forEach(source => scope.addUpdate(extend$1(streamSource(source, scope), entry)));
  }

  function streamSource(stream, scope) {
    return {
      source: stream.signal ? scope.signalRef(stream.signal) : stream.scale ? scope.scaleRef(stream.scale) : parseStream(stream, scope)
    };
  }

  function mergeSources(sources) {
    return {
      signal: '[' + sources.map(s => s.scale ? 'scale("' + s.scale + '")' : s.signal) + ']'
    };
  }

  function parseSignalUpdates(signal, scope) {
    const op = scope.getSignal(signal.name);
    let expr = signal.update;

    if (signal.init) {
      if (expr) {
        error('Signals can not include both init and update expressions.');
      } else {
        expr = signal.init;
        op.initonly = true;
      }
    }

    if (expr) {
      expr = parser(expr, scope);
      op.update = expr.$expr;
      op.params = expr.$params;
    }

    if (signal.on) {
      signal.on.forEach(_ => parseUpdate(_, scope, op.id));
    }
  }

  const transform = name => (params, value, parent) => entry(name, value, params || undefined, parent);

  const Aggregate = transform('aggregate');
  const AxisTicks = transform('axisticks');
  const Bound = transform('bound');
  const Collect = transform('collect');
  const Compare = transform('compare');
  const DataJoin = transform('datajoin');
  const Encode = transform('encode');
  const Expression = transform('expression');
  const Facet = transform('facet');
  const Field = transform('field');
  const Key = transform('key');
  const LegendEntries = transform('legendentries');
  const Load = transform('load');
  const Mark = transform('mark');
  const MultiExtent = transform('multiextent');
  const MultiValues = transform('multivalues');
  const Overlap = transform('overlap');
  const Params = transform('params');
  const PreFacet = transform('prefacet');
  const Projection = transform('projection');
  const Proxy = transform('proxy');
  const Relay = transform('relay');
  const Render = transform('render');
  const Scale = transform('scale');
  const Sieve = transform('sieve');
  const SortItems = transform('sortitems');
  const ViewLayout = transform('viewlayout');
  const Values = transform('values');
  let FIELD_REF_ID = 0;
  const MULTIDOMAIN_SORT_OPS = {
    min: 'min',
    max: 'max',
    count: 'sum'
  };

  function initScale(spec, scope) {
    const type = spec.type || 'linear';

    if (!isValidScaleType(type)) {
      error('Unrecognized scale type: ' + $(type));
    }

    scope.addScale(spec.name, {
      type,
      domain: undefined
    });
  }

  function parseScale(spec, scope) {
    const params = scope.getScale(spec.name).params;
    let key;
    params.domain = parseScaleDomain(spec.domain, spec, scope);

    if (spec.range != null) {
      params.range = parseScaleRange(spec, scope, params);
    }

    if (spec.interpolate != null) {
      parseScaleInterpolate(spec.interpolate, params);
    }

    if (spec.nice != null) {
      params.nice = parseScaleNice(spec.nice);
    }

    if (spec.bins != null) {
      params.bins = parseScaleBins(spec.bins, scope);
    }

    for (key in spec) {
      if (has$1(params, key) || key === 'name') continue;
      params[key] = parseLiteral(spec[key], scope);
    }
  }

  function parseLiteral(v, scope) {
    return !isObject(v) ? v : v.signal ? scope.signalRef(v.signal) : error('Unsupported object: ' + $(v));
  }

  function parseArray(v, scope) {
    return v.signal ? scope.signalRef(v.signal) : v.map(v => parseLiteral(v, scope));
  }

  function dataLookupError(name) {
    error('Can not find data set: ' + $(name));
  } // -- SCALE DOMAIN ----


  function parseScaleDomain(domain, spec, scope) {
    if (!domain) {
      if (spec.domainMin != null || spec.domainMax != null) {
        error('No scale domain defined for domainMin/domainMax to override.');
      }

      return; // default domain
    }

    return domain.signal ? scope.signalRef(domain.signal) : (isArray(domain) ? explicitDomain : domain.fields ? multipleDomain : singularDomain)(domain, spec, scope);
  }

  function explicitDomain(domain, spec, scope) {
    return domain.map(v => parseLiteral(v, scope));
  }

  function singularDomain(domain, spec, scope) {
    const data = scope.getData(domain.data);
    if (!data) dataLookupError(domain.data);
    return isDiscrete(spec.type) ? data.valuesRef(scope, domain.field, parseSort(domain.sort, false)) : isQuantile(spec.type) ? data.domainRef(scope, domain.field) : data.extentRef(scope, domain.field);
  }

  function multipleDomain(domain, spec, scope) {
    const data = domain.data,
          fields = domain.fields.reduce((dom, d) => {
      d = isString(d) ? {
        data: data,
        field: d
      } : isArray(d) || d.signal ? fieldRef(d, scope) : d;
      dom.push(d);
      return dom;
    }, []);
    return (isDiscrete(spec.type) ? ordinalMultipleDomain : isQuantile(spec.type) ? quantileMultipleDomain : numericMultipleDomain)(domain, scope, fields);
  }

  function fieldRef(data, scope) {
    const name = '_:vega:_' + FIELD_REF_ID++,
          coll = Collect({});

    if (isArray(data)) {
      coll.value = {
        $ingest: data
      };
    } else if (data.signal) {
      const code = 'setdata(' + $(name) + ',' + data.signal + ')';
      coll.params.input = scope.signalRef(code);
    }

    scope.addDataPipeline(name, [coll, Sieve({})]);
    return {
      data: name,
      field: 'data'
    };
  }

  function ordinalMultipleDomain(domain, scope, fields) {
    const sort = parseSort(domain.sort, true);
    let a, v; // get value counts for each domain field

    const counts = fields.map(f => {
      const data = scope.getData(f.data);
      if (!data) dataLookupError(f.data);
      return data.countsRef(scope, f.field, sort);
    }); // aggregate the results from each domain field

    const p = {
      groupby: keyFieldRef,
      pulse: counts
    };

    if (sort) {
      a = sort.op || 'count';
      v = sort.field ? aggrField(a, sort.field) : 'count';
      p.ops = [MULTIDOMAIN_SORT_OPS[a]];
      p.fields = [scope.fieldRef(v)];
      p.as = [v];
    }

    a = scope.add(Aggregate(p)); // collect aggregate output

    const c = scope.add(Collect({
      pulse: ref(a)
    })); // extract values for combined domain

    v = scope.add(Values({
      field: keyFieldRef,
      sort: scope.sortRef(sort),
      pulse: ref(c)
    }));
    return ref(v);
  }

  function parseSort(sort, multidomain) {
    if (sort) {
      if (!sort.field && !sort.op) {
        if (isObject(sort)) sort.field = 'key';else sort = {
          field: 'key'
        };
      } else if (!sort.field && sort.op !== 'count') {
        error('No field provided for sort aggregate op: ' + sort.op);
      } else if (multidomain && sort.field) {
        if (sort.op && !MULTIDOMAIN_SORT_OPS[sort.op]) {
          error('Multiple domain scales can not be sorted using ' + sort.op);
        }
      }
    }

    return sort;
  }

  function quantileMultipleDomain(domain, scope, fields) {
    // get value arrays for each domain field
    const values = fields.map(f => {
      const data = scope.getData(f.data);
      if (!data) dataLookupError(f.data);
      return data.domainRef(scope, f.field);
    }); // combine value arrays

    return ref(scope.add(MultiValues({
      values: values
    })));
  }

  function numericMultipleDomain(domain, scope, fields) {
    // get extents for each domain field
    const extents = fields.map(f => {
      const data = scope.getData(f.data);
      if (!data) dataLookupError(f.data);
      return data.extentRef(scope, f.field);
    }); // combine extents

    return ref(scope.add(MultiExtent({
      extents: extents
    })));
  } // -- SCALE BINS -----


  function parseScaleBins(v, scope) {
    return v.signal || isArray(v) ? parseArray(v, scope) : scope.objectProperty(v);
  } // -- SCALE NICE -----


  function parseScaleNice(nice) {
    return isObject(nice) ? {
      interval: parseLiteral(nice.interval),
      step: parseLiteral(nice.step)
    } : parseLiteral(nice);
  } // -- SCALE INTERPOLATION -----


  function parseScaleInterpolate(interpolate, params) {
    params.interpolate = parseLiteral(interpolate.type || interpolate);

    if (interpolate.gamma != null) {
      params.interpolateGamma = parseLiteral(interpolate.gamma);
    }
  } // -- SCALE RANGE -----


  function parseScaleRange(spec, scope, params) {
    const config = scope.config.range;
    let range = spec.range;

    if (range.signal) {
      return scope.signalRef(range.signal);
    } else if (isString(range)) {
      if (config && has$1(config, range)) {
        spec = extend$1({}, spec, {
          range: config[range]
        });
        return parseScaleRange(spec, scope, params);
      } else if (range === 'width') {
        range = [0, {
          signal: 'width'
        }];
      } else if (range === 'height') {
        range = isDiscrete(spec.type) ? [0, {
          signal: 'height'
        }] : [{
          signal: 'height'
        }, 0];
      } else {
        error('Unrecognized scale range value: ' + $(range));
      }
    } else if (range.scheme) {
      params.scheme = isArray(range.scheme) ? parseArray(range.scheme, scope) : parseLiteral(range.scheme, scope);
      if (range.extent) params.schemeExtent = parseArray(range.extent, scope);
      if (range.count) params.schemeCount = parseLiteral(range.count, scope);
      return;
    } else if (range.step) {
      params.rangeStep = parseLiteral(range.step, scope);
      return;
    } else if (isDiscrete(spec.type) && !isArray(range)) {
      return parseScaleDomain(range, spec, scope);
    } else if (!isArray(range)) {
      error('Unsupported range type: ' + $(range));
    }

    return range.map(v => (isArray(v) ? parseArray : parseLiteral)(v, scope));
  }

  function parseProjection(proj, scope) {
    const config = scope.config.projection || {},
          params = {};

    for (const name in proj) {
      if (name === 'name') continue;
      params[name] = parseParameter$1(proj[name], name, scope);
    } // apply projection defaults from config


    for (const name in config) {
      if (params[name] == null) {
        params[name] = parseParameter$1(config[name], name, scope);
      }
    }

    scope.addProjection(proj.name, params);
  }

  function parseParameter$1(_, name, scope) {
    return isArray(_) ? _.map(_ => parseParameter$1(_, name, scope)) : !isObject(_) ? _ : _.signal ? scope.signalRef(_.signal) : name === 'fit' ? _ : error('Unsupported parameter object: ' + $(_));
  }

  const Top = 'top';
  const Left = 'left';
  const Right = 'right';
  const Bottom = 'bottom';
  const Center = 'center';
  const Vertical = 'vertical';
  const Start = 'start';
  const Middle = 'middle';
  const End = 'end';
  const Index = 'index';
  const Label = 'label';
  const Offset = 'offset';
  const Perc = 'perc';
  const Perc2 = 'perc2';
  const Value = 'value';
  const GuideLabelStyle = 'guide-label';
  const GuideTitleStyle = 'guide-title';
  const GroupTitleStyle = 'group-title';
  const GroupSubtitleStyle = 'group-subtitle';
  const Symbols = 'symbol';
  const Gradient = 'gradient';
  const Discrete = 'discrete';
  const Size = 'size';
  const Shape = 'shape';
  const Fill = 'fill';
  const Stroke = 'stroke';
  const StrokeWidth = 'strokeWidth';
  const StrokeDash = 'strokeDash';
  const Opacity = 'opacity'; // Encoding channels supported by legends
  // In priority order of 'canonical' scale

  const LegendScales = [Size, Shape, Fill, Stroke, StrokeWidth, StrokeDash, Opacity];
  const Skip = {
    name: 1,
    style: 1,
    interactive: 1
  };
  const zero = {
    value: 0
  };
  const one = {
    value: 1
  };
  const GroupMark = 'group';
  const RectMark = 'rect';
  const RuleMark = 'rule';
  const SymbolMark = 'symbol';
  const TextMark = 'text';

  function guideGroup(mark) {
    mark.type = GroupMark;
    mark.interactive = mark.interactive || false;
    return mark;
  }

  function lookup(spec, config) {
    const _ = (name, dflt) => value(spec[name], value(config[name], dflt));

    _.isVertical = s => Vertical === value(spec.direction, config.direction || (s ? config.symbolDirection : config.gradientDirection));

    _.gradientLength = () => value(spec.gradientLength, config.gradientLength || config.gradientWidth);

    _.gradientThickness = () => value(spec.gradientThickness, config.gradientThickness || config.gradientHeight);

    _.entryColumns = () => value(spec.columns, value(config.columns, +_.isVertical(true)));

    return _;
  }

  function getEncoding(name, encode) {
    const v = encode && (encode.update && encode.update[name] || encode.enter && encode.enter[name]);
    return v && v.signal ? v : v ? v.value : null;
  }

  function getStyle(name, scope, style) {
    const s = scope.config.style[style];
    return s && s[name];
  }

  function anchorExpr(s, e, m) {
    return `item.anchor === '${Start}' ? ${s} : item.anchor === '${End}' ? ${e} : ${m}`;
  }

  const alignExpr$1 = anchorExpr($(Left), $(Right), $(Center));

  function tickBand(_) {
    const v = _('tickBand');

    let offset = _('tickOffset'),
        band,
        extra;

    if (!v) {
      // if no tick band entry, fall back on other properties
      band = _('bandPosition');
      extra = _('tickExtra');
    } else if (v.signal) {
      // if signal, augment code to interpret values
      band = {
        signal: `(${v.signal}) === 'extent' ? 1 : 0.5`
      };
      extra = {
        signal: `(${v.signal}) === 'extent'`
      };

      if (!isObject(offset)) {
        offset = {
          signal: `(${v.signal}) === 'extent' ? 0 : ${offset}`
        };
      }
    } else if (v === 'extent') {
      // if constant, simply set values
      band = 1;
      extra = true;
      offset = 0;
    } else {
      band = 0.5;
      extra = false;
    }

    return {
      extra,
      band,
      offset
    };
  }

  function extendOffset(value, offset) {
    return !offset ? value : !value ? offset : !isObject(value) ? {
      value,
      offset
    } : Object.assign({}, value, {
      offset: extendOffset(value.offset, offset)
    });
  }

  function guideMark(mark, extras) {
    if (extras) {
      mark.name = extras.name;
      mark.style = extras.style || mark.style;
      mark.interactive = !!extras.interactive;
      mark.encode = extendEncode(mark.encode, extras, Skip);
    } else {
      mark.interactive = false;
    }

    return mark;
  }

  function legendGradient(spec, scale, config, userEncode) {
    const _ = lookup(spec, config),
          vertical = _.isVertical(),
          thickness = _.gradientThickness(),
          length = _.gradientLength();

    let enter, start, stop, width, height;

    if (vertical) {
      start = [0, 1];
      stop = [0, 0];
      width = thickness;
      height = length;
    } else {
      start = [0, 0];
      stop = [1, 0];
      width = length;
      height = thickness;
    }

    const encode = {
      enter: enter = {
        opacity: zero,
        x: zero,
        y: zero,
        width: encoder(width),
        height: encoder(height)
      },
      update: extend$1({}, enter, {
        opacity: one,
        fill: {
          gradient: scale,
          start: start,
          stop: stop
        }
      }),
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      stroke: _('gradientStrokeColor'),
      strokeWidth: _('gradientStrokeWidth')
    }, {
      // update
      opacity: _('gradientOpacity')
    });
    return guideMark({
      type: RectMark,
      role: LegendGradientRole,
      encode
    }, userEncode);
  }

  function legendGradientDiscrete(spec, scale, config, userEncode, dataRef) {
    const _ = lookup(spec, config),
          vertical = _.isVertical(),
          thickness = _.gradientThickness(),
          length = _.gradientLength();

    let u,
        v,
        uu,
        vv,
        adjust = '';
    vertical ? (u = 'y', uu = 'y2', v = 'x', vv = 'width', adjust = '1-') : (u = 'x', uu = 'x2', v = 'y', vv = 'height');
    const enter = {
      opacity: zero,
      fill: {
        scale: scale,
        field: Value
      }
    };
    enter[u] = {
      signal: adjust + 'datum.' + Perc,
      mult: length
    };
    enter[v] = zero;
    enter[uu] = {
      signal: adjust + 'datum.' + Perc2,
      mult: length
    };
    enter[vv] = encoder(thickness);
    const encode = {
      enter: enter,
      update: extend$1({}, enter, {
        opacity: one
      }),
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      stroke: _('gradientStrokeColor'),
      strokeWidth: _('gradientStrokeWidth')
    }, {
      // update
      opacity: _('gradientOpacity')
    });
    return guideMark({
      type: RectMark,
      role: LegendBandRole,
      key: Value,
      from: dataRef,
      encode
    }, userEncode);
  }

  const alignExpr = `datum.${Perc}<=0?"${Left}":datum.${Perc}>=1?"${Right}":"${Center}"`,
        baselineExpr = `datum.${Perc}<=0?"${Bottom}":datum.${Perc}>=1?"${Top}":"${Middle}"`;

  function legendGradientLabels(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config),
          vertical = _.isVertical(),
          thickness = encoder(_.gradientThickness()),
          length = _.gradientLength();

    let overlap = _('labelOverlap'),
        enter,
        update,
        u,
        v,
        adjust = '';

    const encode = {
      enter: enter = {
        opacity: zero
      },
      update: update = {
        opacity: one,
        text: {
          field: Label
        }
      },
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      fill: _('labelColor'),
      fillOpacity: _('labelOpacity'),
      font: _('labelFont'),
      fontSize: _('labelFontSize'),
      fontStyle: _('labelFontStyle'),
      fontWeight: _('labelFontWeight'),
      limit: value(spec.labelLimit, config.gradientLabelLimit)
    });

    if (vertical) {
      enter.align = {
        value: 'left'
      };
      enter.baseline = update.baseline = {
        signal: baselineExpr
      };
      u = 'y';
      v = 'x';
      adjust = '1-';
    } else {
      enter.align = update.align = {
        signal: alignExpr
      };
      enter.baseline = {
        value: 'top'
      };
      u = 'x';
      v = 'y';
    }

    enter[u] = update[u] = {
      signal: adjust + 'datum.' + Perc,
      mult: length
    };
    enter[v] = update[v] = thickness;
    thickness.offset = value(spec.labelOffset, config.gradientLabelOffset) || 0;
    overlap = overlap ? {
      separation: _('labelSeparation'),
      method: overlap,
      order: 'datum.' + Index
    } : undefined; // type, role, style, key, dataRef, encode, extras

    return guideMark({
      type: TextMark,
      role: LegendLabelRole,
      style: GuideLabelStyle,
      key: Value,
      from: dataRef,
      encode,
      overlap
    }, userEncode);
  }

  function legendSymbolGroups(spec, config, userEncode, dataRef, columns) {
    const _ = lookup(spec, config),
          entries = userEncode.entries,
          interactive = !!(entries && entries.interactive),
          name = entries ? entries.name : undefined,
          height = _('clipHeight'),
          symbolOffset = _('symbolOffset'),
          valueRef = {
      data: 'value'
    },
          xSignal = `(${columns}) ? datum.${Offset} : datum.${Size}`,
          yEncode = height ? encoder(height) : {
      field: Size
    },
          index = `datum.${Index}`,
          ncols = `max(1, ${columns})`;

    let encode, enter, update, nrows, sort;
    yEncode.mult = 0.5; // -- LEGEND SYMBOLS --

    encode = {
      enter: enter = {
        opacity: zero,
        x: {
          signal: xSignal,
          mult: 0.5,
          offset: symbolOffset
        },
        y: yEncode
      },
      update: update = {
        opacity: one,
        x: enter.x,
        y: enter.y
      },
      exit: {
        opacity: zero
      }
    };
    let baseFill = null,
        baseStroke = null;

    if (!spec.fill) {
      baseFill = config.symbolBaseFillColor;
      baseStroke = config.symbolBaseStrokeColor;
    }

    addEncoders(encode, {
      fill: _('symbolFillColor', baseFill),
      shape: _('symbolType'),
      size: _('symbolSize'),
      stroke: _('symbolStrokeColor', baseStroke),
      strokeDash: _('symbolDash'),
      strokeDashOffset: _('symbolDashOffset'),
      strokeWidth: _('symbolStrokeWidth')
    }, {
      // update
      opacity: _('symbolOpacity')
    });
    LegendScales.forEach(scale => {
      if (spec[scale]) {
        update[scale] = enter[scale] = {
          scale: spec[scale],
          field: Value
        };
      }
    });
    const symbols = guideMark({
      type: SymbolMark,
      role: LegendSymbolRole,
      key: Value,
      from: valueRef,
      clip: height ? true : undefined,
      encode
    }, userEncode.symbols); // -- LEGEND LABELS --

    const labelOffset = encoder(symbolOffset);
    labelOffset.offset = _('labelOffset');
    encode = {
      enter: enter = {
        opacity: zero,
        x: {
          signal: xSignal,
          offset: labelOffset
        },
        y: yEncode
      },
      update: update = {
        opacity: one,
        text: {
          field: Label
        },
        x: enter.x,
        y: enter.y
      },
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      align: _('labelAlign'),
      baseline: _('labelBaseline'),
      fill: _('labelColor'),
      fillOpacity: _('labelOpacity'),
      font: _('labelFont'),
      fontSize: _('labelFontSize'),
      fontStyle: _('labelFontStyle'),
      fontWeight: _('labelFontWeight'),
      limit: _('labelLimit')
    });
    const labels = guideMark({
      type: TextMark,
      role: LegendLabelRole,
      style: GuideLabelStyle,
      key: Value,
      from: valueRef,
      encode
    }, userEncode.labels); // -- LEGEND ENTRY GROUPS --

    encode = {
      enter: {
        noBound: {
          value: !height
        },
        // ignore width/height in bounds calc
        width: zero,
        height: height ? encoder(height) : zero,
        opacity: zero
      },
      exit: {
        opacity: zero
      },
      update: update = {
        opacity: one,
        row: {
          signal: null
        },
        column: {
          signal: null
        }
      }
    }; // annotate and sort groups to ensure correct ordering

    if (_.isVertical(true)) {
      nrows = `ceil(item.mark.items.length / ${ncols})`;
      update.row.signal = `${index}%${nrows}`;
      update.column.signal = `floor(${index} / ${nrows})`;
      sort = {
        field: ['row', index]
      };
    } else {
      update.row.signal = `floor(${index} / ${ncols})`;
      update.column.signal = `${index} % ${ncols}`;
      sort = {
        field: index
      };
    } // handle zero column case (implies infinite columns)


    update.column.signal = `(${columns})?${update.column.signal}:${index}`; // facet legend entries into sub-groups

    dataRef = {
      facet: {
        data: dataRef,
        name: 'value',
        groupby: Index
      }
    };
    return guideGroup({
      role: ScopeRole,
      from: dataRef,
      encode: extendEncode(encode, entries, Skip),
      marks: [symbols, labels],
      name,
      interactive,
      sort
    });
  }

  function legendSymbolLayout(spec, config) {
    const _ = lookup(spec, config); // layout parameters for legend entries


    return {
      align: _('gridAlign'),
      columns: _.entryColumns(),
      center: {
        row: true,
        column: false
      },
      padding: {
        row: _('rowPadding'),
        column: _('columnPadding')
      }
    };
  }

  const isL = 'item.orient === "left"',
        isR = 'item.orient === "right"',
        isLR = `(${isL} || ${isR})`,
        isVG = `datum.vgrad && ${isLR}`,
        baseline = anchorExpr('"top"', '"bottom"', '"middle"'),
        alignFlip = anchorExpr('"right"', '"left"', '"center"'),
        exprAlign = `datum.vgrad && ${isR} ? (${alignFlip}) : (${isLR} && !(datum.vgrad && ${isL})) ? "left" : ${alignExpr$1}`,
        exprAnchor = `item._anchor || (${isLR} ? "middle" : "start")`,
        exprAngle = `${isVG} ? (${isL} ? -90 : 90) : 0`,
        exprBaseline = `${isLR} ? (datum.vgrad ? (${isR} ? "bottom" : "top") : ${baseline}) : "top"`;

  function legendTitle(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config);

    const encode = {
      enter: {
        opacity: zero
      },
      update: {
        opacity: one,
        x: {
          field: {
            group: 'padding'
          }
        },
        y: {
          field: {
            group: 'padding'
          }
        }
      },
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      orient: _('titleOrient'),
      _anchor: _('titleAnchor'),
      anchor: {
        signal: exprAnchor
      },
      angle: {
        signal: exprAngle
      },
      align: {
        signal: exprAlign
      },
      baseline: {
        signal: exprBaseline
      },
      text: spec.title,
      fill: _('titleColor'),
      fillOpacity: _('titleOpacity'),
      font: _('titleFont'),
      fontSize: _('titleFontSize'),
      fontStyle: _('titleFontStyle'),
      fontWeight: _('titleFontWeight'),
      limit: _('titleLimit'),
      lineHeight: _('titleLineHeight')
    }, {
      // require update
      align: _('titleAlign'),
      baseline: _('titleBaseline')
    });
    return guideMark({
      type: TextMark,
      role: LegendTitleRole,
      style: GuideTitleStyle,
      from: dataRef,
      encode
    }, userEncode);
  }

  function clip(clip, scope) {
    let expr;

    if (isObject(clip)) {
      if (clip.signal) {
        expr = clip.signal;
      } else if (clip.path) {
        expr = 'pathShape(' + param(clip.path) + ')';
      } else if (clip.sphere) {
        expr = 'geoShape(' + param(clip.sphere) + ', {type: "Sphere"})';
      }
    }

    return expr ? scope.signalRef(expr) : !!clip;
  }

  function param(value) {
    return isObject(value) && value.signal ? value.signal : $(value);
  }

  function getRole(spec) {
    const role = spec.role || '';
    return !role.indexOf('axis') || !role.indexOf('legend') || !role.indexOf('title') ? role : spec.type === GroupMark ? ScopeRole : role || MarkRole;
  }

  function definition(spec) {
    return {
      marktype: spec.type,
      name: spec.name || undefined,
      role: spec.role || getRole(spec),
      zindex: +spec.zindex || undefined,
      aria: spec.aria,
      description: spec.description
    };
  }

  function interactive(spec, scope) {
    return spec && spec.signal ? scope.signalRef(spec.signal) : spec === false ? false : true;
  }
  /**
   * Parse a data transform specification.
   */


  function parseTransform(spec, scope) {
    const def = definition$1(spec.type);
    if (!def) error('Unrecognized transform type: ' + $(spec.type));
    const t = entry(def.type.toLowerCase(), null, parseParameters(def, spec, scope));
    if (spec.signal) scope.addSignal(spec.signal, scope.proxy(t));
    t.metadata = def.metadata || {};
    return t;
  }
  /**
   * Parse all parameters of a data transform.
   */


  function parseParameters(def, spec, scope) {
    const params = {},
          n = def.params.length;

    for (let i = 0; i < n; ++i) {
      const pdef = def.params[i];
      params[pdef.name] = parseParameter(pdef, spec, scope);
    }

    return params;
  }
  /**
   * Parse a data transform parameter.
   */


  function parseParameter(def, spec, scope) {
    const type = def.type,
          value = spec[def.name];

    if (type === 'index') {
      return parseIndexParameter(def, spec, scope);
    } else if (value === undefined) {
      if (def.required) {
        error('Missing required ' + $(spec.type) + ' parameter: ' + $(def.name));
      }

      return;
    } else if (type === 'param') {
      return parseSubParameters(def, spec, scope);
    } else if (type === 'projection') {
      return scope.projectionRef(spec[def.name]);
    }

    return def.array && !isSignal(value) ? value.map(v => parameterValue(def, v, scope)) : parameterValue(def, value, scope);
  }
  /**
   * Parse a single parameter value.
   */


  function parameterValue(def, value, scope) {
    const type = def.type;

    if (isSignal(value)) {
      return isExpr(type) ? error('Expression references can not be signals.') : isField(type) ? scope.fieldRef(value) : isCompare(type) ? scope.compareRef(value) : scope.signalRef(value.signal);
    } else {
      const expr = def.expr || isField(type);
      return expr && outerExpr(value) ? scope.exprRef(value.expr, value.as) : expr && outerField(value) ? fieldRef$1(value.field, value.as) : isExpr(type) ? parser(value, scope) : isData(type) ? ref(scope.getData(value).values) : isField(type) ? fieldRef$1(value) : isCompare(type) ? scope.compareRef(value) : value;
    }
  }
  /**
   * Parse parameter for accessing an index of another data set.
   */


  function parseIndexParameter(def, spec, scope) {
    if (!isString(spec.from)) {
      error('Lookup "from" parameter must be a string literal.');
    }

    return scope.getData(spec.from).lookupRef(scope, spec.key);
  }
  /**
   * Parse a parameter that contains one or more sub-parameter objects.
   */


  function parseSubParameters(def, spec, scope) {
    const value = spec[def.name];

    if (def.array) {
      if (!isArray(value)) {
        // signals not allowed!
        error('Expected an array of sub-parameters. Instead: ' + $(value));
      }

      return value.map(v => parseSubParameter(def, v, scope));
    } else {
      return parseSubParameter(def, value, scope);
    }
  }
  /**
   * Parse a sub-parameter object.
   */


  function parseSubParameter(def, value, scope) {
    const n = def.params.length;
    let pdef; // loop over defs to find matching key

    for (let i = 0; i < n; ++i) {
      pdef = def.params[i];

      for (const k in pdef.key) {
        if (pdef.key[k] !== value[k]) {
          pdef = null;
          break;
        }
      }

      if (pdef) break;
    } // raise error if matching key not found


    if (!pdef) error('Unsupported parameter: ' + $(value)); // parse params, create Params transform, return ref

    const params = extend$1(parseParameters(pdef, value, scope), pdef.key);
    return ref(scope.add(Params(params)));
  } // -- Utilities -----


  const outerExpr = _ => _ && _.expr;

  const outerField = _ => _ && _.field;

  const isData = _ => _ === 'data';

  const isExpr = _ => _ === 'expr';

  const isField = _ => _ === 'field';

  const isCompare = _ => _ === 'compare';

  function parseData$1(from, group, scope) {
    let facet, key, op, dataRef, parent; // if no source data, generate singleton datum

    if (!from) {
      dataRef = ref(scope.add(Collect(null, [{}])));
    } // if faceted, process facet specification
    else if (facet = from.facet) {
        if (!group) error('Only group marks can be faceted.'); // use pre-faceted source data, if available

        if (facet.field != null) {
          dataRef = parent = getDataRef(facet, scope);
        } else {
          // generate facet aggregates if no direct data specification
          if (!from.data) {
            op = parseTransform(extend$1({
              type: 'aggregate',
              groupby: array$5(facet.groupby)
            }, facet.aggregate), scope);
            op.params.key = scope.keyRef(facet.groupby);
            op.params.pulse = getDataRef(facet, scope);
            dataRef = parent = ref(scope.add(op));
          } else {
            parent = ref(scope.getData(from.data).aggregate);
          }

          key = scope.keyRef(facet.groupby, true);
        }
      } // if not yet defined, get source data reference


    if (!dataRef) {
      dataRef = getDataRef(from, scope);
    }

    return {
      key: key,
      pulse: dataRef,
      parent: parent
    };
  }

  function getDataRef(from, scope) {
    return from.$ref ? from : from.data && from.data.$ref ? from.data : ref(scope.getData(from.data).output);
  }

  function DataScope(scope, input, output, values, aggr) {
    this.scope = scope; // parent scope object

    this.input = input; // first operator in pipeline (tuple input)

    this.output = output; // last operator in pipeline (tuple output)

    this.values = values; // operator for accessing tuples (but not tuple flow)
    // last aggregate in transform pipeline

    this.aggregate = aggr; // lookup table of field indices

    this.index = {};
  }

  DataScope.fromEntries = function (scope, entries) {
    const n = entries.length,
          values = entries[n - 1],
          output = entries[n - 2];
    let input = entries[0],
        aggr = null,
        i = 1;

    if (input && input.type === 'load') {
      input = entries[1];
    } // add operator entries to this scope, wire up pulse chain


    scope.add(entries[0]);

    for (; i < n; ++i) {
      entries[i].params.pulse = ref(entries[i - 1]);
      scope.add(entries[i]);
      if (entries[i].type === 'aggregate') aggr = entries[i];
    }

    return new DataScope(scope, input, output, values, aggr);
  };

  function fieldKey(field) {
    return isString(field) ? field : null;
  }

  function addSortField(scope, p, sort) {
    const as = aggrField(sort.op, sort.field);
    let s;

    if (p.ops) {
      for (let i = 0, n = p.as.length; i < n; ++i) {
        if (p.as[i] === as) return;
      }
    } else {
      p.ops = ['count'];
      p.fields = [null];
      p.as = ['count'];
    }

    if (sort.op) {
      p.ops.push((s = sort.op.signal) ? scope.signalRef(s) : sort.op);
      p.fields.push(scope.fieldRef(sort.field));
      p.as.push(as);
    }
  }

  function cache(scope, ds, name, optype, field, counts, index) {
    const cache = ds[name] || (ds[name] = {}),
          sort = sortKey(counts);
    let k = fieldKey(field),
        v,
        op;

    if (k != null) {
      scope = ds.scope;
      k = k + (sort ? '|' + sort : '');
      v = cache[k];
    }

    if (!v) {
      const params = counts ? {
        field: keyFieldRef,
        pulse: ds.countsRef(scope, field, counts)
      } : {
        field: scope.fieldRef(field),
        pulse: ref(ds.output)
      };
      if (sort) params.sort = scope.sortRef(counts);
      op = scope.add(entry(optype, undefined, params));
      if (index) ds.index[field] = op;
      v = ref(op);
      if (k != null) cache[k] = v;
    }

    return v;
  }

  DataScope.prototype = {
    countsRef(scope, field, sort) {
      const ds = this,
            cache = ds.counts || (ds.counts = {}),
            k = fieldKey(field);
      let v, a, p;

      if (k != null) {
        scope = ds.scope;
        v = cache[k];
      }

      if (!v) {
        p = {
          groupby: scope.fieldRef(field, 'key'),
          pulse: ref(ds.output)
        };
        if (sort && sort.field) addSortField(scope, p, sort);
        a = scope.add(Aggregate(p));
        v = scope.add(Collect({
          pulse: ref(a)
        }));
        v = {
          agg: a,
          ref: ref(v)
        };
        if (k != null) cache[k] = v;
      } else if (sort && sort.field) {
        addSortField(scope, v.agg.params, sort);
      }

      return v.ref;
    },

    tuplesRef() {
      return ref(this.values);
    },

    extentRef(scope, field) {
      return cache(scope, this, 'extent', 'extent', field, false);
    },

    domainRef(scope, field) {
      return cache(scope, this, 'domain', 'values', field, false);
    },

    valuesRef(scope, field, sort) {
      return cache(scope, this, 'vals', 'values', field, sort || true);
    },

    lookupRef(scope, field) {
      return cache(scope, this, 'lookup', 'tupleindex', field, false);
    },

    indataRef(scope, field) {
      return cache(scope, this, 'indata', 'tupleindex', field, true, true);
    }

  };

  function parseFacet(spec, scope, group) {
    const facet = spec.from.facet,
          name = facet.name,
          data = getDataRef(facet, scope);
    let op;

    if (!facet.name) {
      error('Facet must have a name: ' + $(facet));
    }

    if (!facet.data) {
      error('Facet must reference a data set: ' + $(facet));
    }

    if (facet.field) {
      op = scope.add(PreFacet({
        field: scope.fieldRef(facet.field),
        pulse: data
      }));
    } else if (facet.groupby) {
      op = scope.add(Facet({
        key: scope.keyRef(facet.groupby),
        group: ref(scope.proxy(group.parent)),
        pulse: data
      }));
    } else {
      error('Facet must specify groupby or field: ' + $(facet));
    } // initialize facet subscope


    const subscope = scope.fork(),
          source = subscope.add(Collect()),
          values = subscope.add(Sieve({
      pulse: ref(source)
    }));
    subscope.addData(name, new DataScope(subscope, source, source, values));
    subscope.addSignal('parent', null); // parse faceted subflow

    op.params.subflow = {
      $subflow: subscope.parse(spec).toRuntime()
    };
  }

  function parseSubflow(spec, scope, input) {
    const op = scope.add(PreFacet({
      pulse: input.pulse
    })),
          subscope = scope.fork();
    subscope.add(Sieve());
    subscope.addSignal('parent', null); // parse group mark subflow

    op.params.subflow = {
      $subflow: subscope.parse(spec).toRuntime()
    };
  }

  function parseTrigger(spec, scope, name) {
    const remove = spec.remove,
          insert = spec.insert,
          toggle = spec.toggle,
          modify = spec.modify,
          values = spec.values,
          op = scope.add(operator());
    const update = 'if(' + spec.trigger + ',modify("' + name + '",' + [insert, remove, toggle, modify, values].map(_ => _ == null ? 'null' : _).join(',') + '),0)';
    const expr = parser(update, scope);
    op.update = expr.$expr;
    op.params = expr.$params;
  }

  function parseMark(spec, scope) {
    const role = getRole(spec),
          group = spec.type === GroupMark,
          facet = spec.from && spec.from.facet,
          overlap = spec.overlap;
    let layout = spec.layout || role === ScopeRole || role === FrameRole,
        ops,
        op,
        store,
        enc,
        name,
        layoutRef,
        boundRef;
    const nested = role === MarkRole || layout || facet; // resolve input data

    const input = parseData$1(spec.from, group, scope); // data join to map tuples to visual items

    op = scope.add(DataJoin({
      key: input.key || (spec.key ? fieldRef$1(spec.key) : undefined),
      pulse: input.pulse,
      clean: !group
    }));
    const joinRef = ref(op); // collect visual items

    op = store = scope.add(Collect({
      pulse: joinRef
    })); // connect visual items to scenegraph

    op = scope.add(Mark({
      markdef: definition(spec),
      interactive: interactive(spec.interactive, scope),
      clip: clip(spec.clip, scope),
      context: {
        $context: true
      },
      groups: scope.lookup(),
      parent: scope.signals.parent ? scope.signalRef('parent') : null,
      index: scope.markpath(),
      pulse: ref(op)
    }));
    const markRef = ref(op); // add visual encoders

    op = enc = scope.add(Encode(parseEncode(spec.encode, spec.type, role, spec.style, scope, {
      mod: false,
      pulse: markRef
    }))); // monitor parent marks to propagate changes

    op.params.parent = scope.encode(); // add post-encoding transforms, if defined

    if (spec.transform) {
      spec.transform.forEach(_ => {
        const tx = parseTransform(_, scope),
              md = tx.metadata;

        if (md.generates || md.changes) {
          error('Mark transforms should not generate new data.');
        }

        if (!md.nomod) enc.params.mod = true; // update encode mod handling

        tx.params.pulse = ref(op);
        scope.add(op = tx);
      });
    } // if item sort specified, perform post-encoding


    if (spec.sort) {
      op = scope.add(SortItems({
        sort: scope.compareRef(spec.sort),
        pulse: ref(op)
      }));
    }

    const encodeRef = ref(op); // add view layout operator if needed

    if (facet || layout) {
      layout = scope.add(ViewLayout({
        layout: scope.objectProperty(spec.layout),
        legends: scope.legends,
        mark: markRef,
        pulse: encodeRef
      }));
      layoutRef = ref(layout);
    } // compute bounding boxes


    const bound = scope.add(Bound({
      mark: markRef,
      pulse: layoutRef || encodeRef
    }));
    boundRef = ref(bound); // if group mark, recurse to parse nested content

    if (group) {
      // juggle layout & bounds to ensure they run *after* any faceting transforms
      if (nested) {
        ops = scope.operators;
        ops.pop();
        if (layout) ops.pop();
      }

      scope.pushState(encodeRef, layoutRef || boundRef, joinRef);
      facet ? parseFacet(spec, scope, input) // explicit facet
      : nested ? parseSubflow(spec, scope, input) // standard mark group
      : scope.parse(spec); // guide group, we can avoid nested scopes

      scope.popState();

      if (nested) {
        if (layout) ops.push(layout);
        ops.push(bound);
      }
    } // if requested, add overlap removal transform


    if (overlap) {
      boundRef = parseOverlap(overlap, boundRef, scope);
    } // render / sieve items


    const render = scope.add(Render({
      pulse: boundRef
    })),
          sieve = scope.add(Sieve({
      pulse: ref(render)
    }, undefined, scope.parent())); // if mark is named, make accessible as reactive geometry
    // add trigger updates if defined

    if (spec.name != null) {
      name = spec.name;
      scope.addData(name, new DataScope(scope, store, render, sieve));
      if (spec.on) spec.on.forEach(on => {
        if (on.insert || on.remove || on.toggle) {
          error('Marks only support modify triggers.');
        }

        parseTrigger(on, scope, name);
      });
    }
  }

  function parseOverlap(overlap, source, scope) {
    const method = overlap.method,
          bound = overlap.bound,
          sep = overlap.separation;
    const params = {
      separation: isSignal(sep) ? scope.signalRef(sep.signal) : sep,
      method: isSignal(method) ? scope.signalRef(method.signal) : method,
      pulse: source
    };

    if (overlap.order) {
      params.sort = scope.compareRef({
        field: overlap.order
      });
    }

    if (bound) {
      const tol = bound.tolerance;
      params.boundTolerance = isSignal(tol) ? scope.signalRef(tol.signal) : +tol;
      params.boundScale = scope.scaleRef(bound.scale);
      params.boundOrient = bound.orient;
    }

    return ref(scope.add(Overlap(params)));
  }

  function parseLegend(spec, scope) {
    const config = scope.config.legend,
          encode = spec.encode || {},
          _ = lookup(spec, config),
          legendEncode = encode.legend || {},
          name = legendEncode.name || undefined,
          interactive = legendEncode.interactive,
          style = legendEncode.style,
          scales = {};

    let scale = 0,
        entryLayout,
        params,
        children; // resolve scales and 'canonical' scale name

    LegendScales.forEach(s => spec[s] ? (scales[s] = spec[s], scale = scale || spec[s]) : 0);
    if (!scale) error('Missing valid scale for legend.'); // resolve legend type (symbol, gradient, or discrete gradient)

    const type = legendType(spec, scope.scaleType(scale)); // single-element data source for legend group

    const datum = {
      title: spec.title != null,
      scales: scales,
      type: type,
      vgrad: type !== 'symbol' && _.isVertical()
    };
    const dataRef = ref(scope.add(Collect(null, [datum]))); // encoding properties for legend entry sub-group

    const entryEncode = {
      enter: {
        x: {
          value: 0
        },
        y: {
          value: 0
        }
      }
    }; // data source for legend values

    const entryRef = ref(scope.add(LegendEntries(params = {
      type: type,
      scale: scope.scaleRef(scale),
      count: scope.objectProperty(_('tickCount')),
      limit: scope.property(_('symbolLimit')),
      values: scope.objectProperty(spec.values),
      minstep: scope.property(spec.tickMinStep),
      formatType: scope.property(spec.formatType),
      formatSpecifier: scope.property(spec.format)
    }))); // continuous gradient legend

    if (type === Gradient) {
      children = [legendGradient(spec, scale, config, encode.gradient), legendGradientLabels(spec, config, encode.labels, entryRef)]; // adjust default tick count based on the gradient length

      params.count = params.count || scope.signalRef(`max(2,2*floor((${deref(_.gradientLength())})/100))`);
    } // discrete gradient legend
    else if (type === Discrete) {
        children = [legendGradientDiscrete(spec, scale, config, encode.gradient, entryRef), legendGradientLabels(spec, config, encode.labels, entryRef)];
      } // symbol legend
      else {
          // determine legend symbol group layout
          entryLayout = legendSymbolLayout(spec, config);
          children = [legendSymbolGroups(spec, config, encode, entryRef, deref(entryLayout.columns))]; // pass symbol size information to legend entry generator

          params.size = sizeExpression(spec, scope, children[0].marks);
        } // generate legend marks


    children = [guideGroup({
      role: LegendEntryRole,
      from: dataRef,
      encode: entryEncode,
      marks: children,
      layout: entryLayout,
      interactive
    })]; // include legend title if defined

    if (datum.title) {
      children.push(legendTitle(spec, config, encode.title, dataRef));
    } // parse legend specification


    return parseMark(guideGroup({
      role: LegendRole,
      from: dataRef,
      encode: extendEncode(buildLegendEncode(_, spec, config), legendEncode, Skip),
      marks: children,
      aria: _('aria'),
      description: _('description'),
      zindex: _('zindex'),
      name,
      interactive,
      style
    }), scope);
  }

  function legendType(spec, scaleType) {
    let type = spec.type || Symbols;

    if (!spec.type && scaleCount(spec) === 1 && (spec.fill || spec.stroke)) {
      type = isContinuous(scaleType) ? Gradient : isDiscretizing(scaleType) ? Discrete : Symbols;
    }

    return type !== Gradient ? type : isDiscretizing(scaleType) ? Discrete : Gradient;
  }

  function scaleCount(spec) {
    return LegendScales.reduce((count, type) => count + (spec[type] ? 1 : 0), 0);
  }

  function buildLegendEncode(_, spec, config) {
    const encode = {
      enter: {},
      update: {}
    };
    addEncoders(encode, {
      orient: _('orient'),
      offset: _('offset'),
      padding: _('padding'),
      titlePadding: _('titlePadding'),
      cornerRadius: _('cornerRadius'),
      fill: _('fillColor'),
      stroke: _('strokeColor'),
      strokeWidth: config.strokeWidth,
      strokeDash: config.strokeDash,
      x: _('legendX'),
      y: _('legendY'),
      // accessibility support
      format: spec.format,
      formatType: spec.formatType
    });
    return encode;
  }

  function sizeExpression(spec, scope, marks) {
    const size = deref(getChannel('size', spec, marks)),
          strokeWidth = deref(getChannel('strokeWidth', spec, marks)),
          fontSize = deref(getFontSize(marks[1].encode, scope, GuideLabelStyle));
    return parser(`max(ceil(sqrt(${size})+${strokeWidth}),${fontSize})`, scope);
  }

  function getChannel(name, spec, marks) {
    return spec[name] ? `scale("${spec[name]}",datum)` : getEncoding(name, marks[0].encode);
  }

  function getFontSize(encode, scope, style) {
    return getEncoding('fontSize', encode) || getStyle('fontSize', scope, style);
  }

  const angleExpr = `item.orient==="${Left}"?-90:item.orient==="${Right}"?90:0`;

  function parseTitle(spec, scope) {
    spec = isString(spec) ? {
      text: spec
    } : spec;

    const _ = lookup(spec, scope.config.title),
          encode = spec.encode || {},
          userEncode = encode.group || {},
          name = userEncode.name || undefined,
          interactive = userEncode.interactive,
          style = userEncode.style,
          children = []; // single-element data source for group title


    const datum = {},
          dataRef = ref(scope.add(Collect(null, [datum]))); // include title text

    children.push(buildTitle(spec, _, titleEncode(spec), dataRef)); // include subtitle text

    if (spec.subtitle) {
      children.push(buildSubTitle(spec, _, encode.subtitle, dataRef));
    } // parse title specification


    return parseMark(guideGroup({
      role: TitleRole,
      from: dataRef,
      encode: groupEncode(_, userEncode),
      marks: children,
      aria: _('aria'),
      description: _('description'),
      zindex: _('zindex'),
      name,
      interactive,
      style
    }), scope);
  } // provide backwards-compatibility for title custom encode;
  // the top-level encode block has been *deprecated*.


  function titleEncode(spec) {
    const encode = spec.encode;
    return encode && encode.title || extend$1({
      name: spec.name,
      interactive: spec.interactive,
      style: spec.style
    }, encode);
  }

  function groupEncode(_, userEncode) {
    const encode = {
      enter: {},
      update: {}
    };
    addEncoders(encode, {
      orient: _('orient'),
      anchor: _('anchor'),
      align: {
        signal: alignExpr$1
      },
      angle: {
        signal: angleExpr
      },
      limit: _('limit'),
      frame: _('frame'),
      offset: _('offset') || 0,
      padding: _('subtitlePadding')
    });
    return extendEncode(encode, userEncode, Skip);
  }

  function buildTitle(spec, _, userEncode, dataRef) {
    const zero = {
      value: 0
    },
          text = spec.text,
          encode = {
      enter: {
        opacity: zero
      },
      update: {
        opacity: {
          value: 1
        }
      },
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      text: text,
      align: {
        signal: 'item.mark.group.align'
      },
      angle: {
        signal: 'item.mark.group.angle'
      },
      limit: {
        signal: 'item.mark.group.limit'
      },
      baseline: 'top',
      dx: _('dx'),
      dy: _('dy'),
      fill: _('color'),
      font: _('font'),
      fontSize: _('fontSize'),
      fontStyle: _('fontStyle'),
      fontWeight: _('fontWeight'),
      lineHeight: _('lineHeight')
    }, {
      // update
      align: _('align'),
      angle: _('angle'),
      baseline: _('baseline')
    });
    return guideMark({
      type: TextMark,
      role: TitleTextRole,
      style: GroupTitleStyle,
      from: dataRef,
      encode
    }, userEncode);
  }

  function buildSubTitle(spec, _, userEncode, dataRef) {
    const zero = {
      value: 0
    },
          text = spec.subtitle,
          encode = {
      enter: {
        opacity: zero
      },
      update: {
        opacity: {
          value: 1
        }
      },
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      text: text,
      align: {
        signal: 'item.mark.group.align'
      },
      angle: {
        signal: 'item.mark.group.angle'
      },
      limit: {
        signal: 'item.mark.group.limit'
      },
      baseline: 'top',
      dx: _('dx'),
      dy: _('dy'),
      fill: _('subtitleColor'),
      font: _('subtitleFont'),
      fontSize: _('subtitleFontSize'),
      fontStyle: _('subtitleFontStyle'),
      fontWeight: _('subtitleFontWeight'),
      lineHeight: _('subtitleLineHeight')
    }, {
      // update
      align: _('align'),
      angle: _('angle'),
      baseline: _('baseline')
    });
    return guideMark({
      type: TextMark,
      role: TitleSubtitleRole,
      style: GroupSubtitleStyle,
      from: dataRef,
      encode
    }, userEncode);
  }

  function parseData(data, scope) {
    const transforms = [];

    if (data.transform) {
      data.transform.forEach(tx => {
        transforms.push(parseTransform(tx, scope));
      });
    }

    if (data.on) {
      data.on.forEach(on => {
        parseTrigger(on, scope, data.name);
      });
    }

    scope.addDataPipeline(data.name, analyze(data, scope, transforms));
  }
  /**
   * Analyze a data pipeline, add needed operators.
   */


  function analyze(data, scope, ops) {
    const output = [];
    let source = null,
        modify = false,
        generate = false,
        upstream,
        i,
        n,
        t,
        m;

    if (data.values) {
      // hard-wired input data set
      if (isSignal(data.values) || hasSignal(data.format)) {
        // if either values is signal or format has signal, use dynamic loader
        output.push(load(scope, data));
        output.push(source = collect());
      } else {
        // otherwise, ingest upon dataflow init
        output.push(source = collect({
          $ingest: data.values,
          $format: data.format
        }));
      }
    } else if (data.url) {
      // load data from external source
      if (hasSignal(data.url) || hasSignal(data.format)) {
        // if either url or format has signal, use dynamic loader
        output.push(load(scope, data));
        output.push(source = collect());
      } else {
        // otherwise, request load upon dataflow init
        output.push(source = collect({
          $request: data.url,
          $format: data.format
        }));
      }
    } else if (data.source) {
      // derives from one or more other data sets
      source = upstream = array$5(data.source).map(d => ref(scope.getData(d).output));
      output.push(null); // populate later
    } // scan data transforms, add collectors as needed


    for (i = 0, n = ops.length; i < n; ++i) {
      t = ops[i];
      m = t.metadata;

      if (!source && !m.source) {
        output.push(source = collect());
      }

      output.push(t);
      if (m.generates) generate = true;
      if (m.modifies && !generate) modify = true;
      if (m.source) source = t;else if (m.changes) source = null;
    }

    if (upstream) {
      n = upstream.length - 1;
      output[0] = Relay({
        derive: modify,
        pulse: n ? upstream : upstream[0]
      });

      if (modify || n) {
        // collect derived and multi-pulse tuples
        output.splice(1, 0, collect());
      }
    }

    if (!source) output.push(collect());
    output.push(Sieve({}));
    return output;
  }

  function collect(values) {
    const s = Collect({}, values);
    s.metadata = {
      source: true
    };
    return s;
  }

  function load(scope, data) {
    return Load({
      url: data.url ? scope.property(data.url) : undefined,
      async: data.async ? scope.property(data.async) : undefined,
      values: data.values ? scope.property(data.values) : undefined,
      format: scope.objectProperty(data.format)
    });
  }

  const isX = orient => orient === Bottom || orient === Top; // get sign coefficient based on axis orient


  const getSign = (orient, a, b) => isSignal(orient) ? ifLeftTopExpr(orient.signal, a, b) : orient === Left || orient === Top ? a : b; // condition on axis x-direction


  const ifX = (orient, a, b) => isSignal(orient) ? ifXEnc(orient.signal, a, b) : isX(orient) ? a : b; // condition on axis y-direction


  const ifY = (orient, a, b) => isSignal(orient) ? ifYEnc(orient.signal, a, b) : isX(orient) ? b : a;

  const ifTop = (orient, a, b) => isSignal(orient) ? ifTopExpr(orient.signal, a, b) : orient === Top ? {
    value: a
  } : {
    value: b
  };

  const ifRight = (orient, a, b) => isSignal(orient) ? ifRightExpr(orient.signal, a, b) : orient === Right ? {
    value: a
  } : {
    value: b
  };

  const ifXEnc = ($orient, a, b) => ifEnc(`${$orient} === '${Top}' || ${$orient} === '${Bottom}'`, a, b);

  const ifYEnc = ($orient, a, b) => ifEnc(`${$orient} !== '${Top}' && ${$orient} !== '${Bottom}'`, a, b);

  const ifLeftTopExpr = ($orient, a, b) => ifExpr(`${$orient} === '${Left}' || ${$orient} === '${Top}'`, a, b);

  const ifTopExpr = ($orient, a, b) => ifExpr(`${$orient} === '${Top}'`, a, b);

  const ifRightExpr = ($orient, a, b) => ifExpr(`${$orient} === '${Right}'`, a, b);

  const ifEnc = (test, a, b) => {
    // ensure inputs are encoder objects (or null)
    a = a != null ? encoder(a) : a;
    b = b != null ? encoder(b) : b;

    if (isSimple(a) && isSimple(b)) {
      // if possible generate simple signal expression
      a = a ? a.signal || $(a.value) : null;
      b = b ? b.signal || $(b.value) : null;
      return {
        signal: `${test} ? (${a}) : (${b})`
      };
    } else {
      // otherwise generate rule set
      return [extend$1({
        test
      }, a)].concat(b || []);
    }
  };

  const isSimple = enc => enc == null || Object.keys(enc).length === 1;

  const ifExpr = (test, a, b) => ({
    signal: `${test} ? (${toExpr(a)}) : (${toExpr(b)})`
  });

  const ifOrient = ($orient, t, b, l, r) => ({
    signal: (l != null ? `${$orient} === '${Left}' ? (${toExpr(l)}) : ` : '') + (b != null ? `${$orient} === '${Bottom}' ? (${toExpr(b)}) : ` : '') + (r != null ? `${$orient} === '${Right}' ? (${toExpr(r)}) : ` : '') + (t != null ? `${$orient} === '${Top}' ? (${toExpr(t)}) : ` : '') + '(null)'
  });

  const toExpr = v => isSignal(v) ? v.signal : v == null ? null : $(v);

  const mult = (sign, value) => value === 0 ? 0 : isSignal(sign) ? {
    signal: `(${sign.signal}) * ${value}`
  } : {
    value: sign * value
  };

  const patch = (value, base) => {
    const s = value.signal;
    return s && s.endsWith('(null)') ? {
      signal: s.slice(0, -6) + base.signal
    } : value;
  };

  function fallback(prop, config, axisConfig, style) {
    let styleProp;

    if (config && has$1(config, prop)) {
      return config[prop];
    } else if (has$1(axisConfig, prop)) {
      return axisConfig[prop];
    } else if (prop.startsWith('title')) {
      switch (prop) {
        case 'titleColor':
          styleProp = 'fill';
          break;

        case 'titleFont':
        case 'titleFontSize':
        case 'titleFontWeight':
          styleProp = prop[5].toLowerCase() + prop.slice(6);
      }

      return style[GuideTitleStyle][styleProp];
    } else if (prop.startsWith('label')) {
      switch (prop) {
        case 'labelColor':
          styleProp = 'fill';
          break;

        case 'labelFont':
        case 'labelFontSize':
          styleProp = prop[5].toLowerCase() + prop.slice(6);
      }

      return style[GuideLabelStyle][styleProp];
    }

    return null;
  }

  function keys(objects) {
    const map = {};

    for (const obj of objects) {
      if (!obj) continue;

      for (const key in obj) map[key] = 1;
    }

    return Object.keys(map);
  }

  function axisConfig(spec, scope) {
    var config = scope.config,
        style = config.style,
        axis = config.axis,
        band = scope.scaleType(spec.scale) === 'band' && config.axisBand,
        orient = spec.orient,
        xy,
        or,
        key;

    if (isSignal(orient)) {
      const xyKeys = keys([config.axisX, config.axisY]),
            orientKeys = keys([config.axisTop, config.axisBottom, config.axisLeft, config.axisRight]);
      xy = {};

      for (key of xyKeys) {
        xy[key] = ifX(orient, fallback(key, config.axisX, axis, style), fallback(key, config.axisY, axis, style));
      }

      or = {};

      for (key of orientKeys) {
        or[key] = ifOrient(orient.signal, fallback(key, config.axisTop, axis, style), fallback(key, config.axisBottom, axis, style), fallback(key, config.axisLeft, axis, style), fallback(key, config.axisRight, axis, style));
      }
    } else {
      xy = orient === Top || orient === Bottom ? config.axisX : config.axisY;
      or = config['axis' + orient[0].toUpperCase() + orient.slice(1)];
    }

    const result = xy || or || band ? extend$1({}, axis, xy, or, band) : axis;
    return result;
  }

  function axisDomain(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config),
          orient = spec.orient;

    let enter, update;
    const encode = {
      enter: enter = {
        opacity: zero
      },
      update: update = {
        opacity: one
      },
      exit: {
        opacity: zero
      }
    };
    addEncoders(encode, {
      stroke: _('domainColor'),
      strokeCap: _('domainCap'),
      strokeDash: _('domainDash'),
      strokeDashOffset: _('domainDashOffset'),
      strokeWidth: _('domainWidth'),
      strokeOpacity: _('domainOpacity')
    });
    const pos0 = position(spec, 0);
    const pos1 = position(spec, 1);
    enter.x = update.x = ifX(orient, pos0, zero);
    enter.x2 = update.x2 = ifX(orient, pos1);
    enter.y = update.y = ifY(orient, pos0, zero);
    enter.y2 = update.y2 = ifY(orient, pos1);
    return guideMark({
      type: RuleMark,
      role: AxisDomainRole,
      from: dataRef,
      encode
    }, userEncode);
  }

  function position(spec, pos) {
    return {
      scale: spec.scale,
      range: pos
    };
  }

  function axisGrid(spec, config, userEncode, dataRef, band) {
    const _ = lookup(spec, config),
          orient = spec.orient,
          vscale = spec.gridScale,
          sign = getSign(orient, 1, -1),
          offset = offsetValue(spec.offset, sign);

    let enter, exit, update;
    const encode = {
      enter: enter = {
        opacity: zero
      },
      update: update = {
        opacity: one
      },
      exit: exit = {
        opacity: zero
      }
    };
    addEncoders(encode, {
      stroke: _('gridColor'),
      strokeCap: _('gridCap'),
      strokeDash: _('gridDash'),
      strokeDashOffset: _('gridDashOffset'),
      strokeOpacity: _('gridOpacity'),
      strokeWidth: _('gridWidth')
    });
    const tickPos = {
      scale: spec.scale,
      field: Value,
      band: band.band,
      extra: band.extra,
      offset: band.offset,
      round: _('tickRound')
    };
    const sz = ifX(orient, {
      signal: 'height'
    }, {
      signal: 'width'
    });
    const gridStart = vscale ? {
      scale: vscale,
      range: 0,
      mult: sign,
      offset: offset
    } : {
      value: 0,
      offset: offset
    };
    const gridEnd = vscale ? {
      scale: vscale,
      range: 1,
      mult: sign,
      offset: offset
    } : extend$1(sz, {
      mult: sign,
      offset: offset
    });
    enter.x = update.x = ifX(orient, tickPos, gridStart);
    enter.y = update.y = ifY(orient, tickPos, gridStart);
    enter.x2 = update.x2 = ifY(orient, gridEnd);
    enter.y2 = update.y2 = ifX(orient, gridEnd);
    exit.x = ifX(orient, tickPos);
    exit.y = ifY(orient, tickPos);
    return guideMark({
      type: RuleMark,
      role: AxisGridRole,
      key: Value,
      from: dataRef,
      encode
    }, userEncode);
  }

  function offsetValue(offset, sign) {
    if (sign === 1) ;else if (!isObject(offset)) {
      offset = isSignal(sign) ? {
        signal: `(${sign.signal}) * (${offset || 0})`
      } : sign * (offset || 0);
    } else {
      let entry = offset = extend$1({}, offset);

      while (entry.mult != null) {
        if (!isObject(entry.mult)) {
          entry.mult = isSignal(sign) // no offset if sign === 1
          ? {
            signal: `(${entry.mult}) * (${sign.signal})`
          } : entry.mult * sign;
          return offset;
        } else {
          entry = entry.mult = extend$1({}, entry.mult);
        }
      }

      entry.mult = sign;
    }
    return offset;
  }

  function axisTicks(spec, config, userEncode, dataRef, size, band) {
    const _ = lookup(spec, config),
          orient = spec.orient,
          sign = getSign(orient, -1, 1);

    let enter, exit, update;
    const encode = {
      enter: enter = {
        opacity: zero
      },
      update: update = {
        opacity: one
      },
      exit: exit = {
        opacity: zero
      }
    };
    addEncoders(encode, {
      stroke: _('tickColor'),
      strokeCap: _('tickCap'),
      strokeDash: _('tickDash'),
      strokeDashOffset: _('tickDashOffset'),
      strokeOpacity: _('tickOpacity'),
      strokeWidth: _('tickWidth')
    });
    const tickSize = encoder(size);
    tickSize.mult = sign;
    const tickPos = {
      scale: spec.scale,
      field: Value,
      band: band.band,
      extra: band.extra,
      offset: band.offset,
      round: _('tickRound')
    };
    update.y = enter.y = ifX(orient, zero, tickPos);
    update.y2 = enter.y2 = ifX(orient, tickSize);
    exit.x = ifX(orient, tickPos);
    update.x = enter.x = ifY(orient, zero, tickPos);
    update.x2 = enter.x2 = ifY(orient, tickSize);
    exit.y = ifY(orient, tickPos);
    return guideMark({
      type: RuleMark,
      role: AxisTickRole,
      key: Value,
      from: dataRef,
      encode
    }, userEncode);
  }

  function flushExpr(scale, threshold, a, b, c) {
    return {
      signal: 'flush(range("' + scale + '"), ' + 'scale("' + scale + '", datum.value), ' + threshold + ',' + a + ',' + b + ',' + c + ')'
    };
  }

  function axisLabels(spec, config, userEncode, dataRef, size, band) {
    const _ = lookup(spec, config),
          orient = spec.orient,
          scale = spec.scale,
          sign = getSign(orient, -1, 1),
          flush = deref(_('labelFlush')),
          flushOffset = deref(_('labelFlushOffset')),
          labelAlign = _('labelAlign'),
          labelBaseline = _('labelBaseline');

    let flushOn = flush === 0 || !!flush,
        update;
    const tickSize = encoder(size);
    tickSize.mult = sign;
    tickSize.offset = encoder(_('labelPadding') || 0);
    tickSize.offset.mult = sign;
    const tickPos = {
      scale: scale,
      field: Value,
      band: 0.5,
      offset: extendOffset(band.offset, _('labelOffset'))
    };
    const align = ifX(orient, flushOn ? flushExpr(scale, flush, '"left"', '"right"', '"center"') : {
      value: 'center'
    }, ifRight(orient, 'left', 'right'));
    const baseline = ifX(orient, ifTop(orient, 'bottom', 'top'), flushOn ? flushExpr(scale, flush, '"top"', '"bottom"', '"middle"') : {
      value: 'middle'
    });
    const offsetExpr = flushExpr(scale, flush, `-(${flushOffset})`, flushOffset, 0);
    flushOn = flushOn && flushOffset;
    const enter = {
      opacity: zero,
      x: ifX(orient, tickPos, tickSize),
      y: ifY(orient, tickPos, tickSize)
    };
    const encode = {
      enter: enter,
      update: update = {
        opacity: one,
        text: {
          field: Label
        },
        x: enter.x,
        y: enter.y,
        align,
        baseline
      },
      exit: {
        opacity: zero,
        x: enter.x,
        y: enter.y
      }
    };
    addEncoders(encode, {
      dx: !labelAlign && flushOn ? ifX(orient, offsetExpr) : null,
      dy: !labelBaseline && flushOn ? ifY(orient, offsetExpr) : null
    });
    addEncoders(encode, {
      angle: _('labelAngle'),
      fill: _('labelColor'),
      fillOpacity: _('labelOpacity'),
      font: _('labelFont'),
      fontSize: _('labelFontSize'),
      fontWeight: _('labelFontWeight'),
      fontStyle: _('labelFontStyle'),
      limit: _('labelLimit'),
      lineHeight: _('labelLineHeight')
    }, {
      align: labelAlign,
      baseline: labelBaseline
    });

    const bound = _('labelBound');

    let overlap = _('labelOverlap'); // if overlap method or bound defined, request label overlap removal


    overlap = overlap || bound ? {
      separation: _('labelSeparation'),
      method: overlap,
      order: 'datum.index',
      bound: bound ? {
        scale,
        orient,
        tolerance: bound
      } : null
    } : undefined;

    if (update.align !== align) {
      update.align = patch(update.align, align);
    }

    if (update.baseline !== baseline) {
      update.baseline = patch(update.baseline, baseline);
    }

    return guideMark({
      type: TextMark,
      role: AxisLabelRole,
      style: GuideLabelStyle,
      key: Value,
      from: dataRef,
      encode,
      overlap
    }, userEncode);
  }

  function axisTitle(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config),
          orient = spec.orient,
          sign = getSign(orient, -1, 1);

    let enter, update;
    const encode = {
      enter: enter = {
        opacity: zero,
        anchor: encoder(_('titleAnchor', null)),
        align: {
          signal: alignExpr$1
        }
      },
      update: update = extend$1({}, enter, {
        opacity: one,
        text: encoder(spec.title)
      }),
      exit: {
        opacity: zero
      }
    };
    const titlePos = {
      signal: `lerp(range("${spec.scale}"), ${anchorExpr(0, 1, 0.5)})`
    };
    update.x = ifX(orient, titlePos);
    update.y = ifY(orient, titlePos);
    enter.angle = ifX(orient, zero, mult(sign, 90));
    enter.baseline = ifX(orient, ifTop(orient, Bottom, Top), {
      value: Bottom
    });
    update.angle = enter.angle;
    update.baseline = enter.baseline;
    addEncoders(encode, {
      fill: _('titleColor'),
      fillOpacity: _('titleOpacity'),
      font: _('titleFont'),
      fontSize: _('titleFontSize'),
      fontStyle: _('titleFontStyle'),
      fontWeight: _('titleFontWeight'),
      limit: _('titleLimit'),
      lineHeight: _('titleLineHeight')
    }, {
      // require update
      align: _('titleAlign'),
      angle: _('titleAngle'),
      baseline: _('titleBaseline')
    });
    autoLayout(_, orient, encode, userEncode);
    encode.update.align = patch(encode.update.align, enter.align);
    encode.update.angle = patch(encode.update.angle, enter.angle);
    encode.update.baseline = patch(encode.update.baseline, enter.baseline);
    return guideMark({
      type: TextMark,
      role: AxisTitleRole,
      style: GuideTitleStyle,
      from: dataRef,
      encode
    }, userEncode);
  }

  function autoLayout(_, orient, encode, userEncode) {
    const auto = (value, dim) => value != null ? (encode.update[dim] = patch(encoder(value), encode.update[dim]), false) : !has(dim, userEncode) ? true : false;

    const autoY = auto(_('titleX'), 'x'),
          autoX = auto(_('titleY'), 'y');
    encode.enter.auto = autoX === autoY ? encoder(autoX) : ifX(orient, encoder(autoX), encoder(autoY));
  }

  function parseAxis(spec, scope) {
    const config = axisConfig(spec, scope),
          encode = spec.encode || {},
          axisEncode = encode.axis || {},
          name = axisEncode.name || undefined,
          interactive = axisEncode.interactive,
          style = axisEncode.style,
          _ = lookup(spec, config),
          band = tickBand(_); // single-element data source for axis group


    const datum = {
      scale: spec.scale,
      ticks: !!_('ticks'),
      labels: !!_('labels'),
      grid: !!_('grid'),
      domain: !!_('domain'),
      title: spec.title != null
    };
    const dataRef = ref(scope.add(Collect({}, [datum]))); // data source for axis ticks

    const ticksRef = ref(scope.add(AxisTicks({
      scale: scope.scaleRef(spec.scale),
      extra: scope.property(band.extra),
      count: scope.objectProperty(spec.tickCount),
      values: scope.objectProperty(spec.values),
      minstep: scope.property(spec.tickMinStep),
      formatType: scope.property(spec.formatType),
      formatSpecifier: scope.property(spec.format)
    }))); // generate axis marks

    const children = [];
    let size; // include axis gridlines if requested

    if (datum.grid) {
      children.push(axisGrid(spec, config, encode.grid, ticksRef, band));
    } // include axis ticks if requested


    if (datum.ticks) {
      size = _('tickSize');
      children.push(axisTicks(spec, config, encode.ticks, ticksRef, size, band));
    } // include axis labels if requested


    if (datum.labels) {
      size = datum.ticks ? size : 0;
      children.push(axisLabels(spec, config, encode.labels, ticksRef, size, band));
    } // include axis domain path if requested


    if (datum.domain) {
      children.push(axisDomain(spec, config, encode.domain, dataRef));
    } // include axis title if defined


    if (datum.title) {
      children.push(axisTitle(spec, config, encode.title, dataRef));
    } // parse axis specification


    return parseMark(guideGroup({
      role: AxisRole,
      from: dataRef,
      encode: extendEncode(buildAxisEncode(_, spec), axisEncode, Skip),
      marks: children,
      aria: _('aria'),
      description: _('description'),
      zindex: _('zindex'),
      name,
      interactive,
      style
    }), scope);
  }

  function buildAxisEncode(_, spec) {
    const encode = {
      enter: {},
      update: {}
    };
    addEncoders(encode, {
      orient: _('orient'),
      offset: _('offset') || 0,
      position: value(spec.position, 0),
      titlePadding: _('titlePadding'),
      minExtent: _('minExtent'),
      maxExtent: _('maxExtent'),
      range: {
        signal: `abs(span(range("${spec.scale}")))`
      },
      translate: _('translate'),
      // accessibility support
      format: spec.format,
      formatType: spec.formatType
    });
    return encode;
  }

  function parseScope(spec, scope, preprocessed) {
    const signals = array$5(spec.signals),
          scales = array$5(spec.scales); // parse signal definitions, if not already preprocessed

    if (!preprocessed) signals.forEach(_ => parseSignal(_, scope)); // parse cartographic projection definitions

    array$5(spec.projections).forEach(_ => parseProjection(_, scope)); // initialize scale references

    scales.forEach(_ => initScale(_, scope)); // parse data sources

    array$5(spec.data).forEach(_ => parseData(_, scope)); // parse scale definitions

    scales.forEach(_ => parseScale(_, scope)); // parse signal updates

    (preprocessed || signals).forEach(_ => parseSignalUpdates(_, scope)); // parse axis definitions

    array$5(spec.axes).forEach(_ => parseAxis(_, scope)); // parse mark definitions

    array$5(spec.marks).forEach(_ => parseMark(_, scope)); // parse legend definitions

    array$5(spec.legends).forEach(_ => parseLegend(_, scope)); // parse title, if defined

    if (spec.title) parseTitle(spec.title, scope); // parse collected lambda (anonymous) expressions

    scope.parseLambdas();
    return scope;
  }

  const rootEncode = spec => extendEncode({
    enter: {
      x: {
        value: 0
      },
      y: {
        value: 0
      }
    },
    update: {
      width: {
        signal: 'width'
      },
      height: {
        signal: 'height'
      }
    }
  }, spec);

  function parseView(spec, scope) {
    const config = scope.config; // add scenegraph root

    const root = ref(scope.root = scope.add(operator())); // parse top-level signal definitions

    const signals = collectSignals(spec, config);
    signals.forEach(_ => parseSignal(_, scope)); // assign description, event, legend, and locale configuration

    scope.description = spec.description || config.description;
    scope.eventConfig = config.events;
    scope.legends = scope.objectProperty(config.legend && config.legend.layout);
    scope.locale = config.locale; // store root group item

    const input = scope.add(Collect()); // encode root group item

    const encode = scope.add(Encode(parseEncode(rootEncode(spec.encode), GroupMark, FrameRole, spec.style, scope, {
      pulse: ref(input)
    }))); // perform view layout

    const parent = scope.add(ViewLayout({
      layout: scope.objectProperty(spec.layout),
      legends: scope.legends,
      autosize: scope.signalRef('autosize'),
      mark: root,
      pulse: ref(encode)
    }));
    scope.operators.pop(); // parse remainder of specification

    scope.pushState(ref(encode), ref(parent), null);
    parseScope(spec, scope, signals);
    scope.operators.push(parent); // bound / render / sieve root item

    let op = scope.add(Bound({
      mark: root,
      pulse: ref(parent)
    }));
    op = scope.add(Render({
      pulse: ref(op)
    }));
    op = scope.add(Sieve({
      pulse: ref(op)
    })); // track metadata for root item

    scope.addData('root', new DataScope(scope, input, input, op));
    return scope;
  }

  function signalObject(name, value) {
    return value && value.signal ? {
      name,
      update: value.signal
    } : {
      name,
      value
    };
  }
  /**
   * Collect top-level signals, merging values as needed. Signals
   * defined in the config signals arrays are added only if that
   * signal is not explicitly defined in the specification.
   * Built-in signals (autosize, background, padding, width, height)
   * receive special treatment. They are initialized using the
   * top-level spec property, or, if undefined in the spec, using
   * the corresponding top-level config property. If this property
   * is a signal reference object, the signal expression maps to the
   * signal 'update' property. If the spec's top-level signal array
   * contains an entry that matches a built-in signal, that entry
   * will be merged with the built-in specification, potentially
   * overwriting existing 'value' or 'update' properties.
   */


  function collectSignals(spec, config) {
    const _ = name => value(spec[name], config[name]),
          signals = [signalObject('background', _('background')), signalObject('autosize', parseAutosize(_('autosize'))), signalObject('padding', parsePadding(_('padding'))), signalObject('width', _('width') || 0), signalObject('height', _('height') || 0)],
          pre = signals.reduce((p, s) => (p[s.name] = s, p), {}),
          map = {}; // add spec signal array


    array$5(spec.signals).forEach(s => {
      if (has$1(pre, s.name)) {
        // merge if built-in signal
        s = extend$1(pre[s.name], s);
      } else {
        // otherwise add to signal list
        signals.push(s);
      }

      map[s.name] = s;
    }); // add config signal array

    array$5(config.signals).forEach(s => {
      if (!has$1(map, s.name) && !has$1(pre, s.name)) {
        // add to signal list if not already defined
        signals.push(s);
      }
    });
    return signals;
  }

  function Scope(config, options) {
    this.config = config || {};
    this.options = options || {};
    this.bindings = [];
    this.field = {};
    this.signals = {};
    this.lambdas = {};
    this.scales = {};
    this.events = {};
    this.data = {};
    this.streams = [];
    this.updates = [];
    this.operators = [];
    this.eventConfig = null;
    this.locale = null;
    this._id = 0;
    this._subid = 0;
    this._nextsub = [0];
    this._parent = [];
    this._encode = [];
    this._lookup = [];
    this._markpath = [];
  }

  function Subscope(scope) {
    this.config = scope.config;
    this.options = scope.options;
    this.legends = scope.legends;
    this.field = Object.create(scope.field);
    this.signals = Object.create(scope.signals);
    this.lambdas = Object.create(scope.lambdas);
    this.scales = Object.create(scope.scales);
    this.events = Object.create(scope.events);
    this.data = Object.create(scope.data);
    this.streams = [];
    this.updates = [];
    this.operators = [];
    this._id = 0;
    this._subid = ++scope._nextsub[0];
    this._nextsub = scope._nextsub;
    this._parent = scope._parent.slice();
    this._encode = scope._encode.slice();
    this._lookup = scope._lookup.slice();
    this._markpath = scope._markpath;
  }

  Scope.prototype = Subscope.prototype = {
    parse(spec) {
      return parseScope(spec, this);
    },

    fork() {
      return new Subscope(this);
    },

    isSubscope() {
      return this._subid > 0;
    },

    toRuntime() {
      this.finish();
      return {
        description: this.description,
        operators: this.operators,
        streams: this.streams,
        updates: this.updates,
        bindings: this.bindings,
        eventConfig: this.eventConfig,
        locale: this.locale
      };
    },

    id() {
      return (this._subid ? this._subid + ':' : 0) + this._id++;
    },

    add(op) {
      this.operators.push(op);
      op.id = this.id(); // if pre-registration references exist, resolve them now

      if (op.refs) {
        op.refs.forEach(ref => {
          ref.$ref = op.id;
        });
        op.refs = null;
      }

      return op;
    },

    proxy(op) {
      const vref = op instanceof Entry ? ref(op) : op;
      return this.add(Proxy({
        value: vref
      }));
    },

    addStream(stream) {
      this.streams.push(stream);
      stream.id = this.id();
      return stream;
    },

    addUpdate(update) {
      this.updates.push(update);
      return update;
    },

    // Apply metadata
    finish() {
      let name, ds; // annotate root

      if (this.root) this.root.root = true; // annotate signals

      for (name in this.signals) {
        this.signals[name].signal = name;
      } // annotate scales


      for (name in this.scales) {
        this.scales[name].scale = name;
      } // annotate data sets


      function annotate(op, name, type) {
        let data, list;

        if (op) {
          data = op.data || (op.data = {});
          list = data[name] || (data[name] = []);
          list.push(type);
        }
      }

      for (name in this.data) {
        ds = this.data[name];
        annotate(ds.input, name, 'input');
        annotate(ds.output, name, 'output');
        annotate(ds.values, name, 'values');

        for (const field in ds.index) {
          annotate(ds.index[field], name, 'index:' + field);
        }
      }

      return this;
    },

    // ----
    pushState(encode, parent, lookup) {
      this._encode.push(ref(this.add(Sieve({
        pulse: encode
      }))));

      this._parent.push(parent);

      this._lookup.push(lookup ? ref(this.proxy(lookup)) : null);

      this._markpath.push(-1);
    },

    popState() {
      this._encode.pop();

      this._parent.pop();

      this._lookup.pop();

      this._markpath.pop();
    },

    parent() {
      return peek$1(this._parent);
    },

    encode() {
      return peek$1(this._encode);
    },

    lookup() {
      return peek$1(this._lookup);
    },

    markpath() {
      const p = this._markpath;
      return ++p[p.length - 1];
    },

    // ----
    fieldRef(field, name) {
      if (isString(field)) return fieldRef$1(field, name);

      if (!field.signal) {
        error('Unsupported field reference: ' + $(field));
      }

      const s = field.signal;
      let f = this.field[s];

      if (!f) {
        const params = {
          name: this.signalRef(s)
        };
        if (name) params.as = name;
        this.field[s] = f = ref(this.add(Field(params)));
      }

      return f;
    },

    compareRef(cmp) {
      let signal = false;

      const check = _ => isSignal(_) ? (signal = true, this.signalRef(_.signal)) : isExpr$1(_) ? (signal = true, this.exprRef(_.expr)) : _;

      const fields = array$5(cmp.field).map(check),
            orders = array$5(cmp.order).map(check);
      return signal ? ref(this.add(Compare({
        fields: fields,
        orders: orders
      }))) : compareRef(fields, orders);
    },

    keyRef(fields, flat) {
      let signal = false;

      const check = _ => isSignal(_) ? (signal = true, ref(sig[_.signal])) : _;

      const sig = this.signals;
      fields = array$5(fields).map(check);
      return signal ? ref(this.add(Key({
        fields: fields,
        flat: flat
      }))) : keyRef(fields, flat);
    },

    sortRef(sort) {
      if (!sort) return sort; // including id ensures stable sorting

      const a = aggrField(sort.op, sort.field),
            o = sort.order || Ascending;
      return o.signal ? ref(this.add(Compare({
        fields: a,
        orders: this.signalRef(o.signal)
      }))) : compareRef(a, o);
    },

    // ----
    event(source, type) {
      const key = source + ':' + type;

      if (!this.events[key]) {
        const id = this.id();
        this.streams.push({
          id: id,
          source: source,
          type: type
        });
        this.events[key] = id;
      }

      return this.events[key];
    },

    // ----
    hasOwnSignal(name) {
      return has$1(this.signals, name);
    },

    addSignal(name, value) {
      if (this.hasOwnSignal(name)) {
        error('Duplicate signal name: ' + $(name));
      }

      const op = value instanceof Entry ? value : this.add(operator(value));
      return this.signals[name] = op;
    },

    getSignal(name) {
      if (!this.signals[name]) {
        error('Unrecognized signal name: ' + $(name));
      }

      return this.signals[name];
    },

    signalRef(s) {
      if (this.signals[s]) {
        return ref(this.signals[s]);
      } else if (!has$1(this.lambdas, s)) {
        this.lambdas[s] = this.add(operator(null));
      }

      return ref(this.lambdas[s]);
    },

    parseLambdas() {
      const code = Object.keys(this.lambdas);

      for (let i = 0, n = code.length; i < n; ++i) {
        const s = code[i],
              e = parser(s, this),
              op = this.lambdas[s];
        op.params = e.$params;
        op.update = e.$expr;
      }
    },

    property(spec) {
      return spec && spec.signal ? this.signalRef(spec.signal) : spec;
    },

    objectProperty(spec) {
      return !spec || !isObject(spec) ? spec : this.signalRef(spec.signal || propertyLambda(spec));
    },

    exprRef(code, name) {
      const params = {
        expr: parser(code, this)
      };
      if (name) params.expr.$name = name;
      return ref(this.add(Expression(params)));
    },

    addBinding(name, bind) {
      if (!this.bindings) {
        error('Nested signals do not support binding: ' + $(name));
      }

      this.bindings.push(extend$1({
        signal: name
      }, bind));
    },

    // ----
    addScaleProj(name, transform) {
      if (has$1(this.scales, name)) {
        error('Duplicate scale or projection name: ' + $(name));
      }

      this.scales[name] = this.add(transform);
    },

    addScale(name, params) {
      this.addScaleProj(name, Scale(params));
    },

    addProjection(name, params) {
      this.addScaleProj(name, Projection(params));
    },

    getScale(name) {
      if (!this.scales[name]) {
        error('Unrecognized scale name: ' + $(name));
      }

      return this.scales[name];
    },

    scaleRef(name) {
      return ref(this.getScale(name));
    },

    scaleType(name) {
      return this.getScale(name).params.type;
    },

    projectionRef(name) {
      return this.scaleRef(name);
    },

    projectionType(name) {
      return this.scaleType(name);
    },

    // ----
    addData(name, dataScope) {
      if (has$1(this.data, name)) {
        error('Duplicate data set name: ' + $(name));
      }

      return this.data[name] = dataScope;
    },

    getData(name) {
      if (!this.data[name]) {
        error('Undefined data set name: ' + $(name));
      }

      return this.data[name];
    },

    addDataPipeline(name, entries) {
      if (has$1(this.data, name)) {
        error('Duplicate data set name: ' + $(name));
      }

      return this.addData(name, DataScope.fromEntries(this, entries));
    }

  };

  function propertyLambda(spec) {
    return (isArray(spec) ? arrayLambda : objectLambda)(spec);
  }

  function arrayLambda(array) {
    const n = array.length;
    let code = '[';

    for (let i = 0; i < n; ++i) {
      const value = array[i];
      code += (i > 0 ? ',' : '') + (isObject(value) ? value.signal || propertyLambda(value) : $(value));
    }

    return code + ']';
  }

  function objectLambda(obj) {
    let code = '{',
        i = 0,
        key,
        value;

    for (key in obj) {
      value = obj[key];
      code += (++i > 1 ? ',' : '') + $(key) + ':' + (isObject(value) ? value.signal || propertyLambda(value) : $(value));
    }

    return code + '}';
  }
  /**
   * Standard configuration defaults for Vega specification parsing.
   * Users can provide their own (sub-)set of these default values
   * by passing in a config object to the top-level parse method.
   */


  function defaults() {
    const defaultFont = 'sans-serif',
          defaultSymbolSize = 30,
          defaultStrokeWidth = 2,
          defaultColor = '#4c78a8',
          black = '#000',
          gray = '#888',
          lightGray = '#ddd';
    return {
      // default visualization description
      description: 'Vega visualization',
      // default padding around visualization
      padding: 0,
      // default for automatic sizing; options: 'none', 'pad', 'fit'
      // or provide an object (e.g., {'type': 'pad', 'resize': true})
      autosize: 'pad',
      // default view background color
      // covers the entire view component
      background: null,
      // default event handling configuration
      // preventDefault for view-sourced event types except 'wheel'
      events: {
        defaults: {
          allow: ['wheel']
        }
      },
      // defaults for top-level group marks
      // accepts mark properties (fill, stroke, etc)
      // covers the data rectangle within group width/height
      group: null,
      // defaults for basic mark types
      // each subset accepts mark properties (fill, stroke, etc)
      mark: null,
      arc: {
        fill: defaultColor
      },
      area: {
        fill: defaultColor
      },
      image: null,
      line: {
        stroke: defaultColor,
        strokeWidth: defaultStrokeWidth
      },
      path: {
        stroke: defaultColor
      },
      rect: {
        fill: defaultColor
      },
      rule: {
        stroke: black
      },
      shape: {
        stroke: defaultColor
      },
      symbol: {
        fill: defaultColor,
        size: 64
      },
      text: {
        fill: black,
        font: defaultFont,
        fontSize: 11
      },
      trail: {
        fill: defaultColor,
        size: defaultStrokeWidth
      },
      // style definitions
      style: {
        // axis & legend labels
        'guide-label': {
          fill: black,
          font: defaultFont,
          fontSize: 10
        },
        // axis & legend titles
        'guide-title': {
          fill: black,
          font: defaultFont,
          fontSize: 11,
          fontWeight: 'bold'
        },
        // headers, including chart title
        'group-title': {
          fill: black,
          font: defaultFont,
          fontSize: 13,
          fontWeight: 'bold'
        },
        // chart subtitle
        'group-subtitle': {
          fill: black,
          font: defaultFont,
          fontSize: 12
        },
        // defaults for styled point marks in Vega-Lite
        point: {
          size: defaultSymbolSize,
          strokeWidth: defaultStrokeWidth,
          shape: 'circle'
        },
        circle: {
          size: defaultSymbolSize,
          strokeWidth: defaultStrokeWidth
        },
        square: {
          size: defaultSymbolSize,
          strokeWidth: defaultStrokeWidth,
          shape: 'square'
        },
        // defaults for styled group marks in Vega-Lite
        cell: {
          fill: 'transparent',
          stroke: lightGray
        }
      },
      // defaults for title
      title: {
        orient: 'top',
        anchor: 'middle',
        offset: 4,
        subtitlePadding: 3
      },
      // defaults for axes
      axis: {
        minExtent: 0,
        maxExtent: 200,
        bandPosition: 0.5,
        domain: true,
        domainWidth: 1,
        domainColor: gray,
        grid: false,
        gridWidth: 1,
        gridColor: lightGray,
        labels: true,
        labelAngle: 0,
        labelLimit: 180,
        labelOffset: 0,
        labelPadding: 2,
        ticks: true,
        tickColor: gray,
        tickOffset: 0,
        tickRound: true,
        tickSize: 5,
        tickWidth: 1,
        titlePadding: 4
      },
      // correction for centering bias
      axisBand: {
        tickOffset: -0.5
      },
      // defaults for cartographic projection
      projection: {
        type: 'mercator'
      },
      // defaults for legends
      legend: {
        orient: 'right',
        padding: 0,
        gridAlign: 'each',
        columnPadding: 10,
        rowPadding: 2,
        symbolDirection: 'vertical',
        gradientDirection: 'vertical',
        gradientLength: 200,
        gradientThickness: 16,
        gradientStrokeColor: lightGray,
        gradientStrokeWidth: 0,
        gradientLabelOffset: 2,
        labelAlign: 'left',
        labelBaseline: 'middle',
        labelLimit: 160,
        labelOffset: 4,
        labelOverlap: true,
        symbolLimit: 30,
        symbolType: 'circle',
        symbolSize: 100,
        symbolOffset: 0,
        symbolStrokeWidth: 1.5,
        symbolBaseFillColor: 'transparent',
        symbolBaseStrokeColor: gray,
        titleLimit: 180,
        titleOrient: 'top',
        titlePadding: 5,
        layout: {
          offset: 18,
          direction: 'horizontal',
          left: {
            direction: 'vertical'
          },
          right: {
            direction: 'vertical'
          }
        }
      },
      // defaults for scale ranges
      range: {
        category: {
          scheme: 'tableau10'
        },
        ordinal: {
          scheme: 'blues'
        },
        heatmap: {
          scheme: 'yellowgreenblue'
        },
        ramp: {
          scheme: 'blues'
        },
        diverging: {
          scheme: 'blueorange',
          extent: [1, 0]
        },
        symbol: ['circle', 'square', 'triangle-up', 'cross', 'diamond', 'triangle-right', 'triangle-down', 'triangle-left']
      }
    };
  }

  function parse(spec, config, options) {
    if (!isObject(spec)) {
      error('Input Vega specification must be an object.');
    }

    config = mergeConfig(defaults(), config, spec.config);
    return parseView(spec, new Scope(config, options)).toRuntime();
  }

  // -- Transforms -----
  extend$1(transforms, tx, vtx, encode$1, geo, force, label, tree, reg, voronoi, wordcloud, xf); // -- Exports -----

  const version = pkg.version;

  exports.Bounds = Bounds;
  exports.CanvasHandler = CanvasHandler;
  exports.CanvasRenderer = CanvasRenderer;
  exports.DATE = DATE;
  exports.DAY = DAY;
  exports.DAYOFYEAR = DAYOFYEAR;
  exports.Dataflow = Dataflow;
  exports.Debug = Debug;
  exports.Error = Error$1;
  exports.EventStream = EventStream;
  exports.Gradient = Gradient$1;
  exports.GroupItem = GroupItem;
  exports.HOURS = HOURS;
  exports.Handler = Handler;
  exports.Info = Info;
  exports.Item = Item;
  exports.MILLISECONDS = MILLISECONDS;
  exports.MINUTES = MINUTES;
  exports.MONTH = MONTH;
  exports.Marks = Marks;
  exports.MultiPulse = MultiPulse;
  exports.None = None$2;
  exports.Operator = Operator;
  exports.Parameters = Parameters;
  exports.Pulse = Pulse;
  exports.QUARTER = QUARTER;
  exports.RenderType = RenderType;
  exports.Renderer = Renderer;
  exports.ResourceLoader = ResourceLoader;
  exports.SECONDS = SECONDS;
  exports.SVGHandler = SVGHandler;
  exports.SVGRenderer = SVGRenderer;
  exports.SVGStringRenderer = SVGStringRenderer;
  exports.Scenegraph = Scenegraph;
  exports.TIME_UNITS = TIME_UNITS;
  exports.Transform = Transform;
  exports.View = View$1;
  exports.WEEK = WEEK;
  exports.Warn = Warn;
  exports.YEAR = YEAR;
  exports.accessor = accessor;
  exports.accessorFields = accessorFields;
  exports.accessorName = accessorName;
  exports.array = array$5;
  exports.ascending = ascending$3;
  exports.bandwidthNRD = estimateBandwidth;
  exports.bin = bin;
  exports.bootstrapCI = bootstrapCI;
  exports.boundClip = boundClip;
  exports.boundContext = boundContext;
  exports.boundItem = boundItem$1;
  exports.boundMark = boundMark;
  exports.boundStroke = boundStroke;
  exports.changeset = changeset;
  exports.clampRange = clampRange;
  exports.codegenExpression = codegen;
  exports.compare = compare$1;
  exports.constant = constant$4;
  exports.cumulativeLogNormal = cumulativeLogNormal;
  exports.cumulativeNormal = cumulativeNormal;
  exports.cumulativeUniform = cumulativeUniform;
  exports.dayofyear = dayofyear;
  exports.debounce = debounce;
  exports.defaultLocale = defaultLocale;
  exports.definition = definition$1;
  exports.densityLogNormal = densityLogNormal;
  exports.densityNormal = densityNormal;
  exports.densityUniform = densityUniform;
  exports.domChild = domChild;
  exports.domClear = domClear;
  exports.domCreate = domCreate;
  exports.domFind = domFind;
  exports.dotbin = dotbin;
  exports.error = error;
  exports.expressionFunction = expressionFunction;
  exports.extend = extend$1;
  exports.extent = extent;
  exports.extentIndex = extentIndex;
  exports.falsy = falsy;
  exports.fastmap = fastmap;
  exports.field = field$1;
  exports.flush = flush;
  exports.font = font;
  exports.fontFamily = fontFamily;
  exports.fontSize = fontSize;
  exports.format = format$2;
  exports.formatLocale = numberFormatDefaultLocale;
  exports.formats = formats$1;
  exports.hasOwnProperty = has$1;
  exports.id = id;
  exports.identity = identity$6;
  exports.inferType = inferType;
  exports.inferTypes = inferTypes;
  exports.ingest = ingest$1;
  exports.inherits = inherits;
  exports.inrange = inrange;
  exports.interpolate = interpolate;
  exports.interpolateColors = interpolateColors;
  exports.interpolateRange = interpolateRange;
  exports.intersect = intersect$2;
  exports.intersectBoxLine = intersectBoxLine;
  exports.intersectPath = intersectPath;
  exports.intersectPoint = intersectPoint;
  exports.intersectRule = intersectRule;
  exports.isArray = isArray;
  exports.isBoolean = isBoolean$1;
  exports.isDate = isDate$1;
  exports.isFunction = isFunction;
  exports.isIterable = isIterable;
  exports.isNumber = isNumber$1;
  exports.isObject = isObject;
  exports.isRegExp = isRegExp;
  exports.isString = isString;
  exports.isTuple = isTuple;
  exports.key = key;
  exports.lerp = lerp;
  exports.lineHeight = lineHeight;
  exports.loader = loader;
  exports.locale = locale;
  exports.logger = logger;
  exports.lruCache = lruCache;
  exports.markup = markup;
  exports.merge = merge$3;
  exports.mergeConfig = mergeConfig;
  exports.multiLineOffset = multiLineOffset;
  exports.one = one$2;
  exports.pad = pad$2;
  exports.panLinear = panLinear;
  exports.panLog = panLog;
  exports.panPow = panPow;
  exports.panSymlog = panSymlog;
  exports.parse = parse;
  exports.parseExpression = parser$1;
  exports.parseSelector = eventSelector;
  exports.pathCurves = curves;
  exports.pathEqual = pathEqual;
  exports.pathParse = pathParse;
  exports.pathRectangle = vg_rect;
  exports.pathRender = pathRender;
  exports.pathSymbols = symbols;
  exports.pathTrail = vg_trail;
  exports.peek = peek$1;
  exports.point = point;
  exports.projection = projection;
  exports.quantileLogNormal = quantileLogNormal;
  exports.quantileNormal = quantileNormal;
  exports.quantileUniform = quantileUniform;
  exports.quantiles = quantiles;
  exports.quantizeInterpolator = quantizeInterpolator;
  exports.quarter = quarter;
  exports.quartiles = quartiles;
  exports.randomInteger = integer;
  exports.randomKDE = kde;
  exports.randomLCG = lcg$1;
  exports.randomLogNormal = lognormal;
  exports.randomMixture = mixture$1;
  exports.randomNormal = gaussian;
  exports.randomUniform = uniform;
  exports.read = read;
  exports.regressionExp = exp$1;
  exports.regressionLinear = linear$2;
  exports.regressionLoess = loess;
  exports.regressionLog = log$3;
  exports.regressionPoly = poly;
  exports.regressionPow = pow$3;
  exports.regressionQuad = quad;
  exports.renderModule = renderModule;
  exports.repeat = repeat;
  exports.resetDefaultLocale = resetDefaultLocale;
  exports.resetSVGClipId = resetSVGClipId;
  exports.resetSVGDefIds = resetSVGDefIds;
  exports.responseType = responseType;
  exports.runtimeContext = context;
  exports.sampleCurve = sampleCurve;
  exports.sampleLogNormal = sampleLogNormal;
  exports.sampleNormal = sampleNormal;
  exports.sampleUniform = sampleUniform;
  exports.scale = scale$4;
  exports.sceneEqual = sceneEqual;
  exports.sceneFromJSON = sceneFromJSON;
  exports.scenePickVisit = pickVisit;
  exports.sceneToJSON = sceneToJSON;
  exports.sceneVisit = visit;
  exports.sceneZOrder = zorder;
  exports.scheme = scheme;
  exports.serializeXML = serializeXML;
  exports.setRandom = setRandom;
  exports.span = span;
  exports.splitAccessPath = splitAccessPath;
  exports.stringValue = $;
  exports.textMetrics = textMetrics;
  exports.timeBin = bin$1;
  exports.timeFloor = timeFloor;
  exports.timeFormatLocale = timeFormatDefaultLocale;
  exports.timeInterval = timeInterval;
  exports.timeOffset = timeOffset;
  exports.timeSequence = timeSequence;
  exports.timeUnitSpecifier = timeUnitSpecifier;
  exports.timeUnits = timeUnits;
  exports.toBoolean = toBoolean;
  exports.toDate = toDate;
  exports.toNumber = toNumber;
  exports.toSet = toSet;
  exports.toString = toString;
  exports.transform = transform$2;
  exports.transforms = transforms;
  exports.truncate = truncate$1;
  exports.truthy = truthy;
  exports.tupleid = tupleid;
  exports.typeParsers = typeParsers;
  exports.utcFloor = utcFloor;
  exports.utcInterval = utcInterval;
  exports.utcOffset = utcOffset;
  exports.utcSequence = utcSequence;
  exports.utcdayofyear = utcdayofyear;
  exports.utcquarter = utcquarter;
  exports.utcweek = utcweek;
  exports.version = version;
  exports.visitArray = visitArray;
  exports.week = week;
  exports.writeConfig = writeConfig;
  exports.zero = zero$2;
  exports.zoomLinear = zoomLinear;
  exports.zoomLog = zoomLog;
  exports.zoomPow = zoomPow;
  exports.zoomSymlog = zoomSymlog;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/* -------------------------------------------------------------------------------------------------- */
/* vega-tooltip.js */
/* Link: https://cdn.jsdelivr.net/npm/vega-tooltip@0.25.1/build/vega-tooltip.js */
/* File: js/machinata-reporting-bundle.js/vega-tooltip.js */
/* -------------------------------------------------------------------------------------------------- */

(function (global, factory) {
  false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof exports === 'object' */ && typeof module !== 'undefined' ? factory(exports, require('vega-util')) :
  typeof define === 'function' && define.amd ? define(['exports', 'vega-util'], factory) :
  (global =  /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof globalThis !== 'undefined' ? globalThis :  */global || self, factory(global.vegaTooltip = {}, global.vega));
}(((typeof global !== 'undefined') ? global : window), (function (exports, vegaUtil) { 'use strict'; /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: }(this, (function (exports, vegaUtil) { 'use strict'; */

  var name = "vega-tooltip";
  var version = "0.25.1";
  var description = "A tooltip plugin for Vega-Lite and Vega visualizations.";
  var keywords = [
  	"vega-lite",
  	"vega",
  	"tooltip"
  ];
  var repository = {
  	type: "git",
  	url: "https://github.com/vega/vega-tooltip.git"
  };
  var author = {
  	name: "UW Interactive Data Lab",
  	url: "https://idl.cs.washington.edu"
  };
  var collaborators = [
  	"Dominik Moritz",
  	"Sira Horradarn",
  	"Zening Qu",
  	"Kanit Wongsuphasawat",
  	"Yuri Astrakhan",
  	"Jeffrey Heer"
  ];
  var license = "BSD-3-Clause";
  var bugs = {
  	url: "https://github.com/vega/vega-tooltip/issues"
  };
  var homepage = "https://github.com/vega/vega-tooltip#readme";
  var main = "build/vega-tooltip.js";
  var module = "build/vega-tooltip.module.js";
  var unpkg = "build/vega-tooltip.min.js";
  var jsdelivr = "build/vega-tooltip.min.js";
  var types = "build/vega-tooltip.module.d.ts";
  var files = [
  	"src",
  	"build",
  	"types"
  ];
  var scripts = {
  	prebuild: "yarn clean && yarn build:style",
  	build: "rollup -c",
  	"build:style": "./build-style.sh",
  	clean: "rimraf build && rimraf src/style.ts",
  	"copy:data": "rsync -r node_modules/vega-datasets/data/* examples/data",
  	"copy:build": "rsync -r build/* examples/build",
  	"deploy:gh": "yarn build && yarn copy:build && gh-pages -d examples && yarn clean",
  	prepublishOnly: "yarn clean && yarn build",
  	preversion: "yarn lint && yarn test",
  	serve: "browser-sync start -s -f build examples --serveStatic examples",
  	start: "yarn build && concurrently --kill-others -n Server,Rollup 'yarn serve' 'rollup -c -w'",
  	pretest: "yarn build:style",
  	test: "beemo jest",
  	"test:inspect": "node --inspect-brk ./node_modules/.bin/jest --runInBand",
  	prepare: "beemo create-config && yarn copy:data",
  	prettierbase: "beemo prettier '*.{css,scss,html}'",
  	eslintbase: "beemo eslint .",
  	format: "yarn eslintbase --fix && yarn prettierbase --write",
  	lint: "yarn eslintbase && yarn prettierbase --check"
  };
  var devDependencies = {
  	"@rollup/plugin-json": "^4.1.0",
  	"@rollup/plugin-node-resolve": "^11.2.0",
  	"@wessberg/rollup-plugin-ts": "^1.3.8",
  	"browser-sync": "^2.26.14",
  	concurrently: "^6.0.0",
  	"gh-pages": "^3.1.0",
  	"node-sass": "^5.0.0",
  	path: "^0.12.7",
  	rollup: "^2.39.1",
  	"rollup-plugin-bundle-size": "^1.0.3",
  	"rollup-plugin-terser": "^7.0.2",
  	typescript: "~4.2.2",
  	"vega-datasets": "^2.2.0",
  	"vega-lite-dev-config": "^0.16.1",
  	"vega-typings": "^0.19.2"
  };
  var dependencies = {
  	"vega-util": "^1.16.0"
  };
  var pkg = {
  	name: name,
  	version: version,
  	description: description,
  	keywords: keywords,
  	repository: repository,
  	author: author,
  	collaborators: collaborators,
  	license: license,
  	bugs: bugs,
  	homepage: homepage,
  	main: main,
  	module: module,
  	unpkg: unpkg,
  	jsdelivr: jsdelivr,
  	types: types,
  	files: files,
  	scripts: scripts,
  	devDependencies: devDependencies,
  	dependencies: dependencies
  };

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                  t[p[i]] = s[p[i]];
          }
      return t;
  }

  // generated with build-style.sh
  var defaultStyle = "#vg-tooltip-element {\n  visibility: hidden;\n  padding: 8px;\n  position: fixed;\n  z-index: 1000;\n  font-family: sans-serif;\n  font-size: 11px;\n  border-radius: 3px;\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  /* The default theme is the light theme. */\n  background-color: rgba(255, 255, 255, 0.95);\n  border: 1px solid #d9d9d9;\n  color: black; }\n  #vg-tooltip-element.visible {\n    visibility: visible; }\n  #vg-tooltip-element h2 {\n    margin-top: 0;\n    margin-bottom: 10px;\n    font-size: 13px; }\n  #vg-tooltip-element img {\n    max-width: 200px;\n    max-height: 200px; }\n  #vg-tooltip-element table {\n    border-spacing: 0; }\n    #vg-tooltip-element table tr {\n      border: none; }\n      #vg-tooltip-element table tr td {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-top: 2px;\n        padding-bottom: 2px; }\n        #vg-tooltip-element table tr td.key {\n          color: #808080;\n          max-width: 150px;\n          text-align: right;\n          padding-right: 4px; }\n        #vg-tooltip-element table tr td.value {\n          display: block;\n          max-width: 300px;\n          max-height: 7em;\n          text-align: left; }\n  #vg-tooltip-element.dark-theme {\n    background-color: rgba(32, 32, 32, 0.9);\n    border: 1px solid #f5f5f5;\n    color: white; }\n    #vg-tooltip-element.dark-theme td.key {\n      color: #bfbfbf; }\n";

  var EL_ID = 'vg-tooltip-element';
  var DEFAULT_OPTIONS = {
      /**
       * X offset.
       */
      offsetX: 10,
      /**
       * Y offset.
       */
      offsetY: 10,
      /**
       * ID of the tooltip element.
       */
      id: EL_ID,
      /**
       * ID of the tooltip CSS style.
       */
      styleId: 'vega-tooltip-style',
      /**
       * The name of the theme. You can use the CSS class called [THEME]-theme to style the tooltips.
       *
       * There are two predefined themes: "light" (default) and "dark".
       */
      theme: 'light',
      /**
       * Do not use the default styles provided by Vega Tooltip. If you enable this option, you need to use your own styles. It is not necessary to disable the default style when using a custom theme.
       */
      disableDefaultStyle: false,
      /**
       * HTML sanitizer function that removes dangerous HTML to prevent XSS.
       *
       * This should be a function from string to string. You may replace it with a formatter such as a markdown formatter.
       */
      sanitize: escapeHTML,
      /**
       * The maximum recursion depth when printing objects in the tooltip.
       */
      maxDepth: 2
  };
  /**
   * Escape special HTML characters.
   *
   * @param value A value to convert to string and HTML-escape.
   */
  function escapeHTML(value) {
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;');
  }
  function createDefaultStyle(id) {
      // Just in case this id comes from a user, ensure these is no security issues
      if (!/^[A-Za-z]+[-:.\w]*$/.test(id)) {
          throw new Error('Invalid HTML ID');
      }
      return defaultStyle.toString().replace(EL_ID, id);
  }

  /**
   * Format the value to be shown in the tooltip.
   *
   * @param value The value to show in the tooltip.
   * @param valueToHtml Function to convert a single cell value to an HTML string
   */
  function formatValue(value, valueToHtml, maxDepth) {
      if (vegaUtil.isArray(value)) {
          return "[" + value.map(function (v) { return valueToHtml(vegaUtil.isString(v) ? v : stringify(v, maxDepth)); }).join(', ') + "]";
      }
      if (vegaUtil.isObject(value)) {
          var content = '';
          var _a = value, title = _a.title, image = _a.image, rest = __rest(_a, ["title", "image"]);
          if (title) {
              content += "<h2>" + valueToHtml(title) + "</h2>";
          }
          if (image) {
              content += "<img src=\"" + valueToHtml(image) + "\">";
          }
          var keys = Object.keys(rest);
          if (keys.length > 0) {
              content += '<table>';
              for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                  var key = keys_1[_i];
                  var val = rest[key];
                  // ignore undefined properties
                  if (val === undefined) {
                      continue;
                  }
                  if (vegaUtil.isObject(val)) {
                      val = stringify(val, maxDepth);
                  }
                  content += "<tr><td class=\"key\">" + valueToHtml(key) + ":</td><td class=\"value\">" + valueToHtml(val) + "</td></tr>";
              }
              content += "</table>";
          }
          return content || '{}'; // show empty object if there are no properties
      }
      return valueToHtml(value);
  }
  function replacer(maxDepth) {
      var stack = [];
      return function (key, value) {
          if (typeof value !== 'object' || value === null) {
              return value;
          }
          var pos = stack.indexOf(this) + 1;
          stack.length = pos;
          if (stack.length > maxDepth) {
              return '[Object]';
          }
          if (stack.indexOf(value) >= 0) {
              return '[Circular]';
          }
          stack.push(value);
          return value;
      };
  }
  /**
   * Stringify any JS object to valid JSON
   */
  function stringify(obj, maxDepth) {
      return JSON.stringify(obj, replacer(maxDepth));
  }

  /**
   * Position the tooltip
   *
   * @param event The mouse event.
   * @param tooltipBox
   * @param offsetX Horizontal offset.
   * @param offsetY Vertical offset.
   */
  function calculatePosition(event, tooltipBox, offsetX, offsetY) {
      var x = event.clientX + offsetX;
      if (x + tooltipBox.width > window.innerWidth) {
          x = +event.clientX - offsetX - tooltipBox.width;
      }
      var y = event.clientY + offsetY;
      if (y + tooltipBox.height > window.innerHeight) {
          y = +event.clientY - offsetY - tooltipBox.height;
      }
      return { x: x, y: y };
  }

  /**
   * The tooltip handler class.
   */
  var Handler = /** @class */ (function () {
      /**
       * Create the tooltip handler and initialize the element and style.
       *
       * @param options Tooltip Options
       */
      function Handler(options) {
          this.options = __assign(__assign({}, DEFAULT_OPTIONS), options);
          var elementId = this.options.id;
          this.el = null;
          // bind this to call
          this.call = this.tooltipHandler.bind(this);
          // prepend a default stylesheet for tooltips to the head
          if (!this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
              var style = document.createElement('style');
              style.setAttribute('id', this.options.styleId);
              style.innerHTML = createDefaultStyle(elementId);
              var head = document.head;
              if (head.childNodes.length > 0) {
                  head.insertBefore(style, head.childNodes[0]);
              }
              else {
                  head.appendChild(style);
              }
          }
      }
      /**
       * The tooltip handler function.
       */
      Handler.prototype.tooltipHandler = function (handler, event, item, value) {
          // console.log(handler, event, item, value);
          // append a div element that we use as a tooltip unless it already exists
          this.el = document.getElementById(this.options.id);
          if (!this.el) {
              this.el = document.createElement('div');
              this.el.setAttribute('id', this.options.id);
              this.el.classList.add('vg-tooltip');
              document.body.appendChild(this.el);
          }
          var tooltipContainer = document.fullscreenElement != null ? document.fullscreenElement : document.body;
          tooltipContainer.appendChild(this.el);
          // hide tooltip for null, undefined, or empty string values
          if (value == null || value === '') {
              this.el.classList.remove('visible', this.options.theme + "-theme");
              return;
          }
          // set the tooltip content
          this.el.innerHTML = formatValue(value, this.options.sanitize, this.options.maxDepth);
          // make the tooltip visible
          this.el.classList.add('visible', this.options.theme + "-theme");
          var _a = calculatePosition(event, this.el.getBoundingClientRect(), this.options.offsetX, this.options.offsetY), x = _a.x, y = _a.y;
          this.el.setAttribute('style', "top: " + y + "px; left: " + x + "px");
      };
      return Handler;
  }());

  var version$1 = pkg.version;
  /**
   * Create a tooltip handler and register it with the provided view.
   *
   * @param view The Vega view.
   * @param opt Tooltip options.
   */
  function index (view, opt) {
      var handler = new Handler(opt);
      view.tooltip(handler.call).run();
      return handler;
  }

  exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
  exports.Handler = Handler;
  exports.calculatePosition = calculatePosition;
  exports.createDefaultStyle = createDefaultStyle;
  exports.default = index;
  exports.escapeHTML = escapeHTML;
  exports.formatValue = formatValue;
  exports.replacer = replacer;
  exports.stringify = stringify;
  exports.version = version$1;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/* -------------------------------------------------------------------------------------------------- */
/* vega-interpreter.js */
/* File: js/machinata-reporting-bundle.js/vega-interpreter.js */
/* -------------------------------------------------------------------------------------------------- */

(function (global, factory) {
  false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof exports === 'object' */ && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global =  /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof globalThis !== 'undefined' ? globalThis :  */global || self, factory(global.vega = global.vega || {}));
}(((typeof global !== 'undefined') ? global : window), (function (exports) { 'use strict'; /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: }(this, (function (exports) { 'use strict'; */

  function adjustSpatial (item, encode, swap) {
    let t;

    if (encode.x2) {
      if (encode.x) {
        if (swap && item.x > item.x2) {
          t = item.x;
          item.x = item.x2;
          item.x2 = t;
        }

        item.width = item.x2 - item.x;
      } else {
        item.x = item.x2 - (item.width || 0);
      }
    }

    if (encode.xc) {
      item.x = item.xc - (item.width || 0) / 2;
    }

    if (encode.y2) {
      if (encode.y) {
        if (swap && item.y > item.y2) {
          t = item.y;
          item.y = item.y2;
          item.y2 = t;
        }

        item.height = item.y2 - item.y;
      } else {
        item.y = item.y2 - (item.height || 0);
      }
    }

    if (encode.yc) {
      item.y = item.yc - (item.height || 0) / 2;
    }
  }

  var Constants = {
    NaN: NaN,
    E: Math.E,
    LN2: Math.LN2,
    LN10: Math.LN10,
    LOG2E: Math.LOG2E,
    LOG10E: Math.LOG10E,
    PI: Math.PI,
    SQRT1_2: Math.SQRT1_2,
    SQRT2: Math.SQRT2,
    MIN_VALUE: Number.MIN_VALUE,
    MAX_VALUE: Number.MAX_VALUE
  };

  var Ops = {
    '*': (a, b) => a * b,
    '+': (a, b) => a + b,
    '-': (a, b) => a - b,
    '/': (a, b) => a / b,
    '%': (a, b) => a % b,
    '>': (a, b) => a > b,
    '<': (a, b) => a < b,
    '<=': (a, b) => a <= b,
    '>=': (a, b) => a >= b,
    '==': (a, b) => a == b,
    '!=': (a, b) => a != b,
    '===': (a, b) => a === b,
    '!==': (a, b) => a !== b,
    '&': (a, b) => a & b,
    '|': (a, b) => a | b,
    '^': (a, b) => a ^ b,
    '<<': (a, b) => a << b,
    '>>': (a, b) => a >> b,
    '>>>': (a, b) => a >>> b
  };

  var Unary = {
    '+': a => +a,
    '-': a => -a,
    '~': a => ~a,
    '!': a => !a
  };

  const slice = Array.prototype.slice;

  const apply = (m, args, cast) => {
    const obj = cast ? cast(args[0]) : args[0];
    return obj[m].apply(obj, slice.call(args, 1));
  };

  const datetime = (y, m, d, H, M, S, ms) => new Date(y, m || 0, d != null ? d : 1, H || 0, M || 0, S || 0, ms || 0);

  var Functions = {
    // math functions
    isNaN: Number.isNaN,
    isFinite: Number.isFinite,
    abs: Math.abs,
    acos: Math.acos,
    asin: Math.asin,
    atan: Math.atan,
    atan2: Math.atan2,
    ceil: Math.ceil,
    cos: Math.cos,
    exp: Math.exp,
    floor: Math.floor,
    log: Math.log,
    max: Math.max,
    min: Math.min,
    pow: Math.pow,
    random: Math.random,
    round: Math.round,
    sin: Math.sin,
    sqrt: Math.sqrt,
    tan: Math.tan,
    clamp: (a, b, c) => Math.max(b, Math.min(c, a)),
    // date functions
    now: Date.now,
    utc: Date.UTC,
    datetime: datetime,
    date: d => new Date(d).getDate(),
    day: d => new Date(d).getDay(),
    year: d => new Date(d).getFullYear(),
    month: d => new Date(d).getMonth(),
    hours: d => new Date(d).getHours(),
    minutes: d => new Date(d).getMinutes(),
    seconds: d => new Date(d).getSeconds(),
    milliseconds: d => new Date(d).getMilliseconds(),
    time: d => new Date(d).getTime(),
    timezoneoffset: d => new Date(d).getTimezoneOffset(),
    utcdate: d => new Date(d).getUTCDate(),
    utcday: d => new Date(d).getUTCDay(),
    utcyear: d => new Date(d).getUTCFullYear(),
    utcmonth: d => new Date(d).getUTCMonth(),
    utchours: d => new Date(d).getUTCHours(),
    utcminutes: d => new Date(d).getUTCMinutes(),
    utcseconds: d => new Date(d).getUTCSeconds(),
    utcmilliseconds: d => new Date(d).getUTCMilliseconds(),
    // sequence functions
    length: x => x.length,
    join: function () {
      return apply('join', arguments);
    },
    indexof: function () {
      return apply('indexOf', arguments);
    },
    lastindexof: function () {
      return apply('lastIndexOf', arguments);
    },
    slice: function () {
      return apply('slice', arguments);
    },
    reverse: x => x.slice().reverse(),
    // string functions
    parseFloat: parseFloat,
    parseInt: parseInt,
    upper: x => String(x).toUpperCase(),
    lower: x => String(x).toLowerCase(),
    substring: function () {
      return apply('substring', arguments, String);
    },
    split: function () {
      return apply('split', arguments, String);
    },
    replace: function () {
      return apply('replace', arguments, String);
    },
    trim: x => String(x).trim(),
    // regexp functions
    regexp: RegExp,
    test: (r, t) => RegExp(r).test(t)
  };

  const EventFunctions = ['view', 'item', 'group', 'xy', 'x', 'y'];
  const Visitors = {
    Literal: ($, n) => n.value,
    Identifier: ($, n) => {
      const id = n.name;
      return $.memberDepth > 0 ? id : id === 'datum' ? $.datum : id === 'event' ? $.event : id === 'item' ? $.item : Constants[id] || $.params['$' + id];
    },
    MemberExpression: ($, n) => {
      const d = !n.computed,
            o = $(n.object);
      if (d) $.memberDepth += 1;
      const p = $(n.property);
      if (d) $.memberDepth -= 1;
      return o[p];
    },
    CallExpression: ($, n) => {
      const args = n.arguments;
      let name = n.callee.name; // handle special internal functions used by encoders
      // re-route to corresponding standard function

      if (name.startsWith('_')) {
        name = name.slice(1);
      } // special case "if" due to conditional evaluation of branches


      return name === 'if' ? $(args[0]) ? $(args[1]) : $(args[2]) : ($.fn[name] || Functions[name]).apply($.fn, args.map($));
    },
    ArrayExpression: ($, n) => n.elements.map($),
    BinaryExpression: ($, n) => Ops[n.operator]($(n.left), $(n.right)),
    UnaryExpression: ($, n) => Unary[n.operator]($(n.argument)),
    ConditionalExpression: ($, n) => $(n.test) ? $(n.consequent) : $(n.alternate),
    LogicalExpression: ($, n) => n.operator === '&&' ? $(n.left) && $(n.right) : $(n.left) || $(n.right),
    ObjectExpression: ($, n) => n.properties.reduce((o, p) => {
      $.memberDepth += 1;
      const k = $(p.key);
      $.memberDepth -= 1;
      o[k] = $(p.value);
      return o;
    }, {})
  };
  function interpret (ast, fn, params, datum, event, item) {
    const $ = n => Visitors[n.type]($, n);

    $.memberDepth = 0;
    $.fn = Object.create(fn);
    $.params = params;
    $.datum = datum;
    $.event = event;
    $.item = item; // route event functions to annotated vega event context

    EventFunctions.forEach(f => $.fn[f] = (...args) => event.vega[f](...args));
    return $(ast);
  }

  var expression = {
    /**
     * Parse an expression used to update an operator value.
     */
    operator(ctx, expr) {
      const ast = expr.ast,
            fn = ctx.functions;
      return _ => interpret(ast, fn, _);
    },

    /**
     * Parse an expression provided as an operator parameter value.
     */
    parameter(ctx, expr) {
      const ast = expr.ast,
            fn = ctx.functions;
      return (datum, _) => interpret(ast, fn, _, datum);
    },

    /**
     * Parse an expression applied to an event stream.
     */
    event(ctx, expr) {
      const ast = expr.ast,
            fn = ctx.functions;
      return event => interpret(ast, fn, undefined, undefined, event);
    },

    /**
     * Parse an expression used to handle an event-driven operator update.
     */
    handler(ctx, expr) {
      const ast = expr.ast,
            fn = ctx.functions;
      return (_, event) => {
        const datum = event.item && event.item.datum;
        return interpret(ast, fn, _, datum, event);
      };
    },

    /**
     * Parse an expression that performs visual encoding.
     */
    encode(ctx, encode) {
      const {
        marktype,
        channels
      } = encode,
            fn = ctx.functions,
            swap = marktype === 'group' || marktype === 'image' || marktype === 'rect';
      return (item, _) => {
        const datum = item.datum;
        let m = 0,
            v;

        for (const name in channels) {
          v = interpret(channels[name].ast, fn, _, datum, undefined, item);

          if (item[name] !== v) {
            item[name] = v;
            m = 1;
          }
        }

        if (marktype !== 'rule') {
          adjustSpatial(item, channels, swap);
        }

        return m;
      };
    }

  };

  exports.expressionInterpreter = expression;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/* -------------------------------------------------------------------------------------------------- */
/* xlsx.mini.min.js */
/* Link: https://github.com/SheetJS/sheetjs */
/* File: js/machinata-reporting-bundle.js/xlsx.mini.min.js */
/* -------------------------------------------------------------------------------------------------- */

/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var DO_NOT_EXPORT_CODEPAGE=true;var DO_NOT_EXPORT_JSZIP=true;var XLSX={};function make_xlsx_lib(e){e.version="0.17.0";var r=1200,t=1252;var a=[874,932,936,949,950];for(var n=0;n<=8;++n)a.push(1250+n);var i={0:1252,1:65001,2:65001,77:1e4,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969};var s=function(e){if(a.indexOf(e)==-1)return;t=i[0]=e};function l(){s(1252)}var o=function(e){r=e;s(e)};function c(){o(1200);l()}function f(e){var r=[];for(var t=0,a=e.length;t<a;++t)r[t]=e.charCodeAt(t);return r}function u(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t)+(e.charCodeAt(2*t+1)<<8));return r.join("")}function h(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t+1)+(e.charCodeAt(2*t)<<8));return r.join("")}var d=function(e){var r=e.charCodeAt(0),t=e.charCodeAt(1);if(r==255&&t==254)return u(e.slice(2));if(r==254&&t==255)return h(e.slice(2));if(r==65279)return e.slice(1);return e};var p=function $l(e){return String.fromCharCode(e)};var m=function Ul(e){return String.fromCharCode(e)};var v=null;var g=true;var b=function jl(){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return{encode:function(r){var t="";var a=0,n=0,i=0,s=0,l=0,o=0,c=0;for(var f=0;f<r.length;){a=r.charCodeAt(f++);s=a>>2;n=r.charCodeAt(f++);l=(a&3)<<4|n>>4;i=r.charCodeAt(f++);o=(n&15)<<2|i>>6;c=i&63;if(isNaN(n)){o=c=64}else if(isNaN(i)){c=64}t+=e.charAt(s)+e.charAt(l)+e.charAt(o)+e.charAt(c)}return t},decode:function r(t){var a="";var n=0,i=0,s=0,l=0,o=0,c=0,f=0;t=t.replace(/[^\w\+\/\=]/g,"");for(var u=0;u<t.length;){l=e.indexOf(t.charAt(u++));o=e.indexOf(t.charAt(u++));n=l<<2|o>>4;a+=String.fromCharCode(n);c=e.indexOf(t.charAt(u++));i=(o&15)<<4|c>>2;if(c!==64){a+=String.fromCharCode(i)}f=e.indexOf(t.charAt(u++));s=(c&3)<<6|f;if(f!==64){a+=String.fromCharCode(s)}}return a}}}();var w=typeof Buffer!=="undefined"&&typeof process!=="undefined"&&typeof process.versions!=="undefined"&&!!process.versions.node;var k=function(){};if(typeof Buffer!=="undefined"){var y=!Buffer.from;if(!y)try{Buffer.from("foo","utf8")}catch(x){y=true}k=y?function(e,r){return r?new Buffer(e,r):new Buffer(e)}:Buffer.from.bind(Buffer);if(!Buffer.alloc)Buffer.alloc=function(e){return new Buffer(e)};if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(e){return new Buffer(e)}}function _(e){return w?Buffer.alloc(e):new Array(e)}function S(e){return w?Buffer.allocUnsafe(e):new Array(e)}var C=function Hl(e){if(w)return k(e,"binary");return e.split("").map(function(e){return e.charCodeAt(0)&255})};function A(e){if(typeof ArrayBuffer==="undefined")return C(e);var r=new ArrayBuffer(e.length),t=new Uint8Array(r);for(var a=0;a!=e.length;++a)t[a]=e.charCodeAt(a)&255;return r}function E(e){if(Array.isArray(e))return e.map(function(e){return String.fromCharCode(e)}).join("");var r=[];for(var t=0;t<e.length;++t)r[t]=String.fromCharCode(e[t]);return r.join("")}function F(e){if(typeof Uint8Array==="undefined")throw new Error("Unsupported");return new Uint8Array(e)}function T(e){if(typeof ArrayBuffer=="undefined")throw new Error("Unsupported");if(e instanceof ArrayBuffer)return T(new Uint8Array(e));var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=e[t];return r}var O=function(e){return[].concat.apply([],e)};var D=/\u0000/g,M=/[\u0001-\u0006]/g;var N={};var R=function Vl(e){e.version="0.11.2";function r(e){var r="",t=e.length-1;while(t>=0)r+=e.charAt(t--);return r}function t(e,r){var t="";while(t.length<r)t+=e;return t}function a(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}function n(e,r){var a=""+e;return a.length>=r?a:t(" ",r-a.length)+a}function i(e,r){var a=""+e;return a.length>=r?a:a+t(" ",r-a.length)}function s(e,r){var a=""+Math.round(e);return a.length>=r?a:t("0",r-a.length)+a}function l(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}var o=Math.pow(2,32);function c(e,r){if(e>o||e<-o)return s(e,r);var t=Math.round(e);return l(t,r)}function f(e,r){r=r||0;return e.length>=7+r&&(e.charCodeAt(r)|32)===103&&(e.charCodeAt(r+1)|32)===101&&(e.charCodeAt(r+2)|32)===110&&(e.charCodeAt(r+3)|32)===101&&(e.charCodeAt(r+4)|32)===114&&(e.charCodeAt(r+5)|32)===97&&(e.charCodeAt(r+6)|32)===108}var u=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]];var h=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];function d(e){e[0]="General";e[1]="0";e[2]="0.00";e[3]="#,##0";e[4]="#,##0.00";e[9]="0%";e[10]="0.00%";e[11]="0.00E+00";e[12]="# ?/?";e[13]="# ??/??";e[14]="m/d/yy";e[15]="d-mmm-yy";e[16]="d-mmm";e[17]="mmm-yy";e[18]="h:mm AM/PM";e[19]="h:mm:ss AM/PM";e[20]="h:mm";e[21]="h:mm:ss";e[22]="m/d/yy h:mm";e[37]="#,##0 ;(#,##0)";e[38]="#,##0 ;[Red](#,##0)";e[39]="#,##0.00;(#,##0.00)";e[40]="#,##0.00;[Red](#,##0.00)";e[45]="mm:ss";e[46]="[h]:mm:ss";e[47]="mmss.0";e[48]="##0.0E+0";e[49]="@";e[56]='"上午/下午 "hh"時"mm"分"ss"秒 "'}var p={};d(p);var m=[];var v=0;for(v=5;v<=8;++v)m[v]=32+v;for(v=23;v<=26;++v)m[v]=0;for(v=27;v<=31;++v)m[v]=14;for(v=50;v<=58;++v)m[v]=14;for(v=59;v<=62;++v)m[v]=v-58;for(v=67;v<=68;++v)m[v]=v-58;for(v=72;v<=75;++v)m[v]=v-58;for(v=67;v<=68;++v)m[v]=v-57;for(v=76;v<=78;++v)m[v]=v-56;for(v=79;v<=81;++v)m[v]=v-34;var g=[];g[5]=g[63]='"$"#,##0_);\\("$"#,##0\\)';g[6]=g[64]='"$"#,##0_);[Red]\\("$"#,##0\\)';g[7]=g[65]='"$"#,##0.00_);\\("$"#,##0.00\\)';g[8]=g[66]='"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';g[41]='_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';g[42]='_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';g[43]='_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';g[44]='_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';function b(e,r,t){var a=e<0?-1:1;var n=e*a;var i=0,s=1,l=0;var o=1,c=0,f=0;var u=Math.floor(n);while(c<r){u=Math.floor(n);l=u*s+i;f=u*c+o;if(n-u<5e-8)break;n=1/(n-u);i=s;s=l;o=c;c=f}if(f>r){if(c>r){f=o;l=i}else{f=c;l=s}}if(!t)return[0,a*l,f];var h=Math.floor(a*l/f);return[h,a*l-h*f,f]}function w(e,r,t){if(e>2958465||e<0)return null;var a=e|0,n=Math.floor(86400*(e-a)),i=0;var s=[];var l={D:a,T:n,u:86400*(e-a)-n,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(l.u)<1e-6)l.u=0;if(r&&r.date1904)a+=1462;if(l.u>.9999){l.u=0;if(++n==86400){l.T=n=0;++a;++l.D}}if(a===60){s=t?[1317,10,29]:[1900,2,29];i=3}else if(a===0){s=t?[1317,8,29]:[1900,1,0];i=6}else{if(a>60)--a;var o=new Date(1900,0,1);o.setDate(o.getDate()+a-1);s=[o.getFullYear(),o.getMonth()+1,o.getDate()];i=o.getDay();if(a<60)i=(i+6)%7;if(t)i=E(o,s)}l.y=s[0];l.m=s[1];l.d=s[2];l.S=n%60;n=Math.floor(n/60);l.M=n%60;n=Math.floor(n/60);l.H=n;l.q=i;return l}e.parse_date_code=w;var k=new Date(1899,11,31,0,0,0);var y=k.getTime();var x=new Date(1900,2,1,0,0,0);function _(e,r){var t=e.getTime();if(r)t-=1461*24*60*60*1e3;else if(e>=x)t+=24*60*60*1e3;return(t-(y+(e.getTimezoneOffset()-k.getTimezoneOffset())*6e4))/(24*60*60*1e3)}function S(e){return e.toString(10)}e._general_int=S;var C=function $(){var e=/(?:\.0*|(\.\d*[1-9])0+)$/;function r(r){return r.indexOf(".")==-1?r:r.replace(e,"$1")}var t=/(?:\.0*|(\.\d*[1-9])0+)[Ee]/;var a=/(E[+-])(\d)$/;function n(e){if(e.indexOf("E")==-1)return e;return e.replace(t,"$1E").replace(a,"$10$2")}function i(e){var t=e<0?12:11;var a=r(e.toFixed(12));if(a.length<=t)return a;a=e.toPrecision(10);if(a.length<=t)return a;return e.toExponential(5)}function s(e){var t=r(e.toFixed(11));return t.length>(e<0?12:11)||t==="0"||t==="-0"?e.toPrecision(6):t}function l(e){var t=Math.floor(Math.log(Math.abs(e))*Math.LOG10E),a;if(t>=-4&&t<=-1)a=e.toPrecision(10+t);else if(Math.abs(t)<=9)a=i(e);else if(t===10)a=e.toFixed(10).substr(0,12);else a=s(e);return r(n(a.toUpperCase()))}return l}();e._general_num=C;function A(e,r){switch(typeof e){case"string":return e;case"boolean":return e?"TRUE":"FALSE";case"number":return(e|0)===e?e.toString(10):C(e);case"undefined":return"";case"object":if(e==null)return"";if(e instanceof Date)return B(14,_(e,r&&r.date1904),r);}throw new Error("unsupported value in General format: "+e)}e._general=A;function E(e,r){r[0]-=581;var t=e.getDay();if(e<60)t=(t+6)%7;return t}function F(e,r,t,n){var i="",s=0,l=0,o=t.y,c,f=0;switch(e){case 98:o=t.y+543;case 121:switch(r.length){case 1:;case 2:c=o%100;f=2;break;default:c=o%1e4;f=4;break;}break;case 109:switch(r.length){case 1:;case 2:c=t.m;f=r.length;break;case 3:return h[t.m-1][1];case 5:return h[t.m-1][0];default:return h[t.m-1][2];}break;case 100:switch(r.length){case 1:;case 2:c=t.d;f=r.length;break;case 3:return u[t.q][0];default:return u[t.q][1];}break;case 104:switch(r.length){case 1:;case 2:c=1+(t.H+11)%12;f=r.length;break;default:throw"bad hour format: "+r;}break;case 72:switch(r.length){case 1:;case 2:c=t.H;f=r.length;break;default:throw"bad hour format: "+r;}break;case 77:switch(r.length){case 1:;case 2:c=t.M;f=r.length;break;default:throw"bad minute format: "+r;}break;case 115:if(r!="s"&&r!="ss"&&r!=".0"&&r!=".00"&&r!=".000")throw"bad second format: "+r;if(t.u===0&&(r=="s"||r=="ss"))return a(t.S,r.length);if(n>=2)l=n===3?1e3:100;else l=n===1?10:1;s=Math.round(l*(t.S+t.u));if(s>=60*l)s=0;if(r==="s")return s===0?"0":""+s/l;i=a(s,2+n);if(r==="ss")return i.substr(0,2);return"."+i.substr(2,r.length-1);case 90:switch(r){case"[h]":;case"[hh]":c=t.D*24+t.H;break;case"[m]":;case"[mm]":c=(t.D*24+t.H)*60+t.M;break;case"[s]":;case"[ss]":c=((t.D*24+t.H)*60+t.M)*60+Math.round(t.S+t.u);break;default:throw"bad abstime format: "+r;}f=r.length===3?1:2;break;case 101:c=o;f=1;break;}var d=f>0?a(c,f):"";return d}function T(e){var r=3;if(e.length<=r)return e;var t=e.length%r,a=e.substr(0,t);for(;t!=e.length;t+=r)a+=(a.length>0?",":"")+e.substr(t,r);return a}var O=function U(){var e=/%/g;function s(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return O(r,i,n*Math.pow(10,2*s))+t("%",s)}function l(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return O(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function o(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+o(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(t.indexOf("e")===-1){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);while(t.substr(0,2)==="0."){t=t.charAt(0)+t.substr(2,n)+"."+t.substr(2+n);t=t.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.")}t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}var f=/# (\?+)( ?)\/( ?)(\d+)/;function u(e,r,i){var s=parseInt(e[4],10),l=Math.round(r*s),o=Math.floor(l/s);var c=l-o*s,f=s;return i+(o===0?"":""+o)+" "+(c===0?t(" ",e[1].length+1+e[4].length):n(c,e[1].length)+e[2]+"/"+e[3]+a(f,e[4].length))}function h(e,r,a){return a+(r===0?"":""+r)+t(" ",e[1].length+2+e[4].length)}var d=/^#*0*\.([0#]+)/;var p=/\).*[0#]/;var m=/\(###\) ###\\?-####/;function v(e){var r="",t;for(var a=0;a!=e.length;++a)switch(t=e.charCodeAt(a)){case 35:break;case 63:r+=" ";break;case 48:r+="0";break;default:r+=String.fromCharCode(t);}return r}function g(e,r){var t=Math.pow(10,r);return""+Math.round(e*t)/t}function w(e,r){var t=e-Math.floor(e),a=Math.pow(10,r);if(r<(""+Math.round(t*a)).length)return 0;return Math.round(t*a)}function k(e,r){if(r<(""+Math.round((e-Math.floor(e))*Math.pow(10,r))).length){return 1}return 0}function y(e){if(e<2147483647&&e>-2147483648)return""+(e>=0?e|0:e-1|0);return""+Math.floor(e)}function x(e,h,_){if(e.charCodeAt(0)===40&&!h.match(p)){var S=h.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(_>=0)return x("n",S,_);return"("+x("n",S,-_)+")"}if(h.charCodeAt(h.length-1)===44)return l(e,h,_);if(h.indexOf("%")!==-1)return s(e,h,_);if(h.indexOf("E")!==-1)return o(h,_);if(h.charCodeAt(0)===36)return"$"+x(e,h.substr(h.charAt(1)==" "?2:1),_);var C;var A,E,F,D=Math.abs(_),M=_<0?"-":"";if(h.match(/^00+$/))return M+c(D,h.length);if(h.match(/^[#?]+$/)){C=c(_,0);if(C==="0")C="";return C.length>h.length?C:v(h.substr(0,h.length-C.length))+C}if(A=h.match(f))return u(A,D,M);if(h.match(/^#+0+$/))return M+c(D,h.length-h.indexOf("0"));if(A=h.match(d)){C=g(_,A[1].length).replace(/^([^\.]+)$/,"$1."+v(A[1])).replace(/\.$/,"."+v(A[1])).replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",v(A[1]).length-r.length)});return h.indexOf("0.")!==-1?C:C.replace(/^0\./,".")}h=h.replace(/^#+([0.])/,"$1");if(A=h.match(/^(0*)\.(#*)$/)){return M+g(D,A[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,A[1].length?"0.":".")}if(A=h.match(/^#{1,3},##0(\.?)$/))return M+T(c(D,0));if(A=h.match(/^#,##0\.([#0]*0)$/)){return _<0?"-"+x(e,h,-_):T(""+(Math.floor(_)+k(_,A[1].length)))+"."+a(w(_,A[1].length),A[1].length)}if(A=h.match(/^#,#*,#0/))return x(e,h.replace(/^#,#*,/,""),_);if(A=h.match(/^([0#]+)(\\?-([0#]+))+$/)){C=r(x(e,h.replace(/[\\-]/g,""),_));E=0;return r(r(h.replace(/\\/g,"")).replace(/[0#]/g,function(e){return E<C.length?C.charAt(E++):e==="0"?"0":""}))}if(h.match(m)){C=x(e,"##########",_);return"("+C.substr(0,3)+") "+C.substr(3,3)+"-"+C.substr(6)}var N="";if(A=h.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){E=Math.min(A[4].length,7);F=b(D,Math.pow(10,E)-1,false);C=""+M;N=O("n",A[1],F[1]);if(N.charAt(N.length-1)==" ")N=N.substr(0,N.length-1)+"0";C+=N+A[2]+"/"+A[3];N=i(F[2],E);if(N.length<A[4].length)N=v(A[4].substr(A[4].length-N.length))+N;C+=N;return C}if(A=h.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){E=Math.min(Math.max(A[1].length,A[4].length),7);F=b(D,Math.pow(10,E)-1,true);return M+(F[0]||(F[1]?"":"0"))+" "+(F[1]?n(F[1],E)+A[2]+"/"+A[3]+i(F[2],E):t(" ",2*E+1+A[2].length+A[3].length))}if(A=h.match(/^[#0?]+$/)){C=c(_,0);if(h.length<=C.length)return C;return v(h.substr(0,h.length-C.length))+C}if(A=h.match(/^([#0?]+)\.([#0]+)$/)){C=""+_.toFixed(Math.min(A[2].length,10)).replace(/([^0])0+$/,"$1");E=C.indexOf(".");var R=h.indexOf(".")-E,P=h.length-C.length-R;return v(h.substr(0,R)+C+h.substr(h.length-P))}if(A=h.match(/^00,000\.([#0]*0)$/)){E=w(_,A[1].length);return _<0?"-"+x(e,h,-_):T(y(_)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(E,A[1].length)}switch(h){case"###,##0.00":return x(e,"#,##0.00",_);case"###,###":;case"##,###":;case"#,###":var I=T(c(D,0));return I!=="0"?M+I:"";case"###,###.00":return x(e,"###,##0.00",_).replace(/^0\./,".");case"#,###.00":return x(e,"#,##0.00",_).replace(/^0\./,".");default:;}throw new Error("unsupported format |"+h+"|")}function _(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return O(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function S(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return O(r,i,n*Math.pow(10,2*s))+t("%",s)}function C(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+C(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(!t.match(/[Ee]/)){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}function A(e,s,l){if(e.charCodeAt(0)===40&&!s.match(p)){var o=s.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(l>=0)return A("n",o,l);return"("+A("n",o,-l)+")"}if(s.charCodeAt(s.length-1)===44)return _(e,s,l);if(s.indexOf("%")!==-1)return S(e,s,l);if(s.indexOf("E")!==-1)return C(s,l);if(s.charCodeAt(0)===36)return"$"+A(e,s.substr(s.charAt(1)==" "?2:1),l);var c;var u,g,w,k=Math.abs(l),y=l<0?"-":"";if(s.match(/^00+$/))return y+a(k,s.length);if(s.match(/^[#?]+$/)){c=""+l;if(l===0)c="";return c.length>s.length?c:v(s.substr(0,s.length-c.length))+c}if(u=s.match(f))return h(u,k,y);if(s.match(/^#+0+$/))return y+a(k,s.length-s.indexOf("0"));if(u=s.match(d)){c=(""+l).replace(/^([^\.]+)$/,"$1."+v(u[1])).replace(/\.$/,"."+v(u[1]));c=c.replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",v(u[1]).length-r.length)});return s.indexOf("0.")!==-1?c:c.replace(/^0\./,".")}s=s.replace(/^#+([0.])/,"$1");if(u=s.match(/^(0*)\.(#*)$/)){return y+(""+k).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,u[1].length?"0.":".")}if(u=s.match(/^#{1,3},##0(\.?)$/))return y+T(""+k);if(u=s.match(/^#,##0\.([#0]*0)$/)){return l<0?"-"+A(e,s,-l):T(""+l)+"."+t("0",u[1].length)}if(u=s.match(/^#,#*,#0/))return A(e,s.replace(/^#,#*,/,""),l);if(u=s.match(/^([0#]+)(\\?-([0#]+))+$/)){c=r(A(e,s.replace(/[\\-]/g,""),l));g=0;return r(r(s.replace(/\\/g,"")).replace(/[0#]/g,function(e){return g<c.length?c.charAt(g++):e==="0"?"0":""}))}if(s.match(m)){c=A(e,"##########",l);return"("+c.substr(0,3)+") "+c.substr(3,3)+"-"+c.substr(6)}var x="";if(u=s.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){g=Math.min(u[4].length,7);w=b(k,Math.pow(10,g)-1,false);c=""+y;x=O("n",u[1],w[1]);if(x.charAt(x.length-1)==" ")x=x.substr(0,x.length-1)+"0";c+=x+u[2]+"/"+u[3];x=i(w[2],g);if(x.length<u[4].length)x=v(u[4].substr(u[4].length-x.length))+x;c+=x;return c}if(u=s.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){g=Math.min(Math.max(u[1].length,u[4].length),7);w=b(k,Math.pow(10,g)-1,true);return y+(w[0]||(w[1]?"":"0"))+" "+(w[1]?n(w[1],g)+u[2]+"/"+u[3]+i(w[2],g):t(" ",2*g+1+u[2].length+u[3].length))}if(u=s.match(/^[#0?]+$/)){c=""+l;if(s.length<=c.length)return c;return v(s.substr(0,s.length-c.length))+c}if(u=s.match(/^([#0]+)\.([#0]+)$/)){c=""+l.toFixed(Math.min(u[2].length,10)).replace(/([^0])0+$/,"$1");g=c.indexOf(".");var E=s.indexOf(".")-g,F=s.length-c.length-E;return v(s.substr(0,E)+c+s.substr(s.length-F))}if(u=s.match(/^00,000\.([#0]*0)$/)){return l<0?"-"+A(e,s,-l):T(""+l).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(0,u[1].length)}switch(s){case"###,###":;case"##,###":;case"#,###":var D=T(""+k);return D!=="0"?y+D:"";default:if(s.match(/\.[0#?]*$/))return A(e,s.slice(0,s.lastIndexOf(".")),l)+v(s.slice(s.lastIndexOf(".")));}throw new Error("unsupported format |"+s+"|")}return function E(e,r,t){return(t|0)===t?A(e,r,t):x(e,r,t)}}();function D(e){var r=[];var t=false;for(var a=0,n=0;a<e.length;++a)switch(e.charCodeAt(a)){case 34:t=!t;break;case 95:;case 42:;case 92:++a;break;case 59:r[r.length]=e.substr(n,a-n);n=a+1;}r[r.length]=e.substr(n);if(t===true)throw new Error("Format |"+e+"| unterminated string ");return r}e._split=D;var M=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function N(e){var r=0,t="",a="";while(r<e.length){switch(t=e.charAt(r)){case"G":if(f(e,r))r+=6;r++;break;case'"':for(;e.charCodeAt(++r)!==34&&r<e.length;){}++r;break;case"\\":r+=2;break;case"_":r+=2;break;case"@":++r;break;case"B":;case"b":if(e.charAt(r+1)==="1"||e.charAt(r+1)==="2")return true;case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":;case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":return true;case"A":;case"a":;case"上":if(e.substr(r,3).toUpperCase()==="A/P")return true;if(e.substr(r,5).toUpperCase()==="AM/PM")return true;if(e.substr(r,5).toUpperCase()==="上午/下午")return true;++r;break;case"[":a=t;while(e.charAt(r++)!=="]"&&r<e.length)a+=e.charAt(r);if(a.match(M))return true;break;case".":;case"0":;case"#":while(r<e.length&&("0#?.,E+-%".indexOf(t=e.charAt(++r))>-1||t=="\\"&&e.charAt(r+1)=="-"&&"0#".indexOf(e.charAt(r+2))>-1)){}break;case"?":while(e.charAt(++r)===t){}break;case"*":++r;if(e.charAt(r)==" "||e.charAt(r)=="*")++r;break;case"(":;case")":++r;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":while(r<e.length&&"0123456789".indexOf(e.charAt(++r))>-1){}break;case" ":++r;break;default:++r;break;}}return false}e.is_date=N;function R(e,r,t,a){var n=[],i="",s=0,l="",o="t",c,u,h;var d="H";while(s<e.length){switch(l=e.charAt(s)){case"G":if(!f(e,s))throw new Error("unrecognized character "+l+" in "+e);n[n.length]={t:"G",v:"General"};s+=7;break;case'"':for(i="";(h=e.charCodeAt(++s))!==34&&s<e.length;)i+=String.fromCharCode(h);n[n.length]={t:"t",v:i};++s;break;case"\\":var p=e.charAt(++s),m=p==="("||p===")"?p:"t";n[n.length]={t:m,v:p};++s;break;case"_":n[n.length]={t:"t",v:" "};s+=2;break;case"@":n[n.length]={t:"T",v:r};++s;break;case"B":;case"b":if(e.charAt(s+1)==="1"||e.charAt(s+1)==="2"){if(c==null){c=w(r,t,e.charAt(s+1)==="2");if(c==null)return""}n[n.length]={t:"X",v:e.substr(s,2)};o=l;s+=2;break};case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":l=l.toLowerCase();case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":if(r<0)return"";if(c==null){c=w(r,t);if(c==null)return""}i=l;while(++s<e.length&&e.charAt(s).toLowerCase()===l)i+=l;if(l==="m"&&o.toLowerCase()==="h")l="M";if(l==="h")l=d;n[n.length]={t:l,v:i};o=l;break;case"A":;case"a":;case"上":var v={t:l,v:l};if(c==null)c=w(r,t);if(e.substr(s,3).toUpperCase()==="A/P"){if(c!=null)v.v=c.H>=12?"P":"A";v.t="T";d="h";s+=3}else if(e.substr(s,5).toUpperCase()==="AM/PM"){if(c!=null)v.v=c.H>=12?"PM":"AM";v.t="T";s+=5;d="h"}else if(e.substr(s,5).toUpperCase()==="上午/下午"){if(c!=null)v.v=c.H>=12?"下午":"上午";v.t="T";s+=5;d="h"}else{v.t="t";++s}if(c==null&&v.t==="T")return"";n[n.length]=v;o=l;break;case"[":i=l;while(e.charAt(s++)!=="]"&&s<e.length)i+=e.charAt(s);if(i.slice(-1)!=="]")throw'unterminated "[" block: |'+i+"|";if(i.match(M)){if(c==null){c=w(r,t);if(c==null)return""}n[n.length]={t:"Z",v:i.toLowerCase()};o=i.charAt(1)}else if(i.indexOf("$")>-1){i=(i.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!N(e))n[n.length]={t:"t",v:i}}break;case".":if(c!=null){i=l;while(++s<e.length&&(l=e.charAt(s))==="0")i+=l;n[n.length]={t:"s",v:i};break};case"0":;case"#":i=l;while(++s<e.length&&"0#?.,E+-%".indexOf(l=e.charAt(s))>-1)i+=l;n[n.length]={t:"n",v:i};break;case"?":i=l;while(e.charAt(++s)===l)i+=l;n[n.length]={t:l,v:i};o=l;break;case"*":++s;if(e.charAt(s)==" "||e.charAt(s)=="*")++s;break;case"(":;case")":n[n.length]={t:a===1?"t":l,v:l};++s;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":i=l;while(s<e.length&&"0123456789".indexOf(e.charAt(++s))>-1)i+=e.charAt(s);n[n.length]={t:"D",v:i};break;case" ":n[n.length]={t:l,v:l};++s;break;case"$":n[n.length]={t:"t",v:"$"};++s;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(l)===-1)throw new Error("unrecognized character "+l+" in "+e);n[n.length]={t:"t",v:l};++s;break;}}var g=0,b=0,k;for(s=n.length-1,o="t";s>=0;--s){switch(n[s].t){case"h":;case"H":n[s].t=d;o="h";if(g<1)g=1;break;case"s":if(k=n[s].v.match(/\.0+$/))b=Math.max(b,k[0].length-1);if(g<3)g=3;case"d":;case"y":;case"M":;case"e":o=n[s].t;break;case"m":if(o==="s"){n[s].t="M";if(g<2)g=2}break;case"X":break;case"Z":if(g<1&&n[s].v.match(/[Hh]/))g=1;if(g<2&&n[s].v.match(/[Mm]/))g=2;if(g<3&&n[s].v.match(/[Ss]/))g=3;}}switch(g){case 0:break;case 1:if(c.u>=.5){c.u=0;++c.S}if(c.S>=60){c.S=0;++c.M}if(c.M>=60){c.M=0;++c.H}break;case 2:if(c.u>=.5){c.u=0;++c.S}if(c.S>=60){c.S=0;++c.M}break;}var y="",x;for(s=0;s<n.length;++s){switch(n[s].t){case"t":;case"T":;case" ":;case"D":break;case"X":n[s].v="";n[s].t=";";break;case"d":;case"m":;case"y":;case"h":;case"H":;case"M":;case"s":;case"e":;case"b":;case"Z":n[s].v=F(n[s].t.charCodeAt(0),n[s].v,c,b);n[s].t="t";break;case"n":;case"?":x=s+1;while(n[x]!=null&&((l=n[x].t)==="?"||l==="D"||(l===" "||l==="t")&&n[x+1]!=null&&(n[x+1].t==="?"||n[x+1].t==="t"&&n[x+1].v==="/")||n[s].t==="("&&(l===" "||l==="n"||l===")")||l==="t"&&(n[x].v==="/"||n[x].v===" "&&n[x+1]!=null&&n[x+1].t=="?"))){n[s].v+=n[x].v;n[x]={v:"",t:";"};++x}y+=n[s].v;s=x-1;break;case"G":n[s].t="t";n[s].v=A(r,t);break;}}var _="",S,C;if(y.length>0){if(y.charCodeAt(0)==40){S=r<0&&y.charCodeAt(0)===45?-r:r;C=O("n",y,S)}else{S=r<0&&a>1?-r:r;C=O("n",y,S);if(S<0&&n[0]&&n[0].t=="t"){C=C.substr(1);n[0].v="-"+n[0].v}}x=C.length-1;var E=n.length;for(s=0;s<n.length;++s)if(n[s]!=null&&n[s].t!="t"&&n[s].v.indexOf(".")>-1){E=s;break}var T=n.length;if(E===n.length&&C.indexOf("E")===-1){for(s=n.length-1;s>=0;--s){if(n[s]==null||"n?".indexOf(n[s].t)===-1)continue;if(x>=n[s].v.length-1){x-=n[s].v.length;n[s].v=C.substr(x+1,n[s].v.length)}else if(x<0)n[s].v="";else{n[s].v=C.substr(0,x+1);x=-1}n[s].t="t";T=s}if(x>=0&&T<n.length)n[T].v=C.substr(0,x+1)+n[T].v}else if(E!==n.length&&C.indexOf("E")===-1){x=C.indexOf(".")-1;for(s=E;s>=0;--s){if(n[s]==null||"n?".indexOf(n[s].t)===-1)continue;u=n[s].v.indexOf(".")>-1&&s===E?n[s].v.indexOf(".")-1:n[s].v.length-1;_=n[s].v.substr(u+1);for(;u>=0;--u){if(x>=0&&(n[s].v.charAt(u)==="0"||n[s].v.charAt(u)==="#"))_=C.charAt(x--)+_}n[s].v=_;n[s].t="t";T=s}if(x>=0&&T<n.length)n[T].v=C.substr(0,x+1)+n[T].v;x=C.indexOf(".")+1;for(s=E;s<n.length;++s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1&&s!==E)continue;u=n[s].v.indexOf(".")>-1&&s===E?n[s].v.indexOf(".")+1:0;_=n[s].v.substr(0,u);for(;u<n[s].v.length;++u){if(x<C.length)_+=C.charAt(x++)}n[s].v=_;n[s].t="t";T=s}}}for(s=0;s<n.length;++s)if(n[s]!=null&&"n?".indexOf(n[s].t)>-1){S=a>1&&r<0&&s>0&&n[s-1].v==="-"?-r:r;n[s].v=O(n[s].t,n[s].v,S);n[s].t="t"}var D="";for(s=0;s!==n.length;++s)if(n[s]!=null)D+=n[s].v;return D}e._eval=R;var P=/\[[=<>]/;var I=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function L(e,r){if(r==null)return false;var t=parseFloat(r[2]);switch(r[1]){case"=":if(e==t)return true;break;case">":if(e>t)return true;break;case"<":if(e<t)return true;break;case"<>":if(e!=t)return true;break;case">=":if(e>=t)return true;break;case"<=":if(e<=t)return true;break;}return false}function z(e,r){var t=D(e);var a=t.length,n=t[a-1].indexOf("@");if(a<4&&n>-1)--a;if(t.length>4)throw new Error("cannot find right format for |"+t.join("|")+"|");if(typeof r!=="number")return[4,t.length===4||n>-1?t[t.length-1]:"@"];switch(t.length){case 1:t=n>-1?["General","General","General",t[0]]:[t[0],t[0],t[0],"@"];break;case 2:t=n>-1?[t[0],t[0],t[0],t[1]]:[t[0],t[1],t[0],"@"];break;case 3:t=n>-1?[t[0],t[1],t[0],t[2]]:[t[0],t[1],t[2],"@"];break;case 4:break;}var i=r>0?t[0]:r<0?t[1]:t[2];if(t[0].indexOf("[")===-1&&t[1].indexOf("[")===-1)return[a,i];if(t[0].match(P)!=null||t[1].match(P)!=null){var s=t[0].match(I);var l=t[1].match(I);return L(r,s)?[a,t[0]]:L(r,l)?[a,t[1]]:[a,t[s!=null&&l!=null?2:1]]}return[a,i]}function B(e,r,t){if(t==null)t={};var a="";switch(typeof e){case"string":if(e=="m/d/yy"&&t.dateNF)a=t.dateNF;else a=e;break;case"number":if(e==14&&t.dateNF)a=t.dateNF;else a=(t.table!=null?t.table:p)[e];if(a==null)a=t.table&&t.table[m[e]]||p[m[e]];if(a==null)a=g[e]||"General";break;}if(f(a,0))return A(r,t);if(r instanceof Date)r=_(r,t.date1904);var n=z(a,r);if(f(n[1]))return A(r,t);if(r===true)r="TRUE";else if(r===false)r="FALSE";else if(r===""||r==null)return"";return R(n[1],r,t,n[0])}function W(e,r){if(typeof r!="number"){r=+r||-1;for(var t=0;t<392;++t){if(p[t]==undefined){if(r<0)r=t;continue}if(p[t]==e){r=t;break}}if(r<0)r=391}p[r]=e;return r}e.load=W;e._table=p;e.get_table=function j(){return p};e.load_table=function H(e){for(var r=0;r!=392;++r)if(e[r]!==undefined)W(e[r],r)};e.init_table=d;e.format=B};R(N);var P={"General Number":"General","General Date":N._table[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":N._table[15],"Short Date":N._table[14],"Long Time":N._table[19],"Medium Time":N._table[18],"Short Time":N._table[20],Currency:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',Fixed:N._table[2],Standard:N._table[4],Percent:N._table[10],Scientific:N._table[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var I={5:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',23:"General",24:"General",25:"General",26:"General",27:"m/d/yy",28:"m/d/yy",29:"m/d/yy",30:"m/d/yy",31:"m/d/yy",32:"h:mm:ss",33:"h:mm:ss",34:"h:mm:ss",35:"h:mm:ss",36:"m/d/yy",41:'_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',50:"m/d/yy",51:"m/d/yy",52:"m/d/yy",53:"m/d/yy",54:"m/d/yy",55:"m/d/yy",56:"m/d/yy",57:"m/d/yy",58:"m/d/yy",59:"0",60:"0.00",61:"#,##0",62:"#,##0.00",63:'"$"#,##0_);\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',67:"0%",68:"0.00%",69:"# ?/?",70:"# ??/??",71:"m/d/yy",72:"m/d/yy",73:"d-mmm-yy",74:"d-mmm",75:"mmm-yy",76:"h:mm",77:"h:mm:ss",78:"m/d/yy h:mm",79:"mm:ss",80:"[h]:mm:ss",81:"mmss.0"};var L=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function z(e){var r=typeof e=="number"?N._table[e]:e;r=r.replace(L,"(\\d+)");return new RegExp("^"+r+"$")}function B(e,r,t){var a=-1,n=-1,i=-1,s=-1,l=-1,o=-1;(r.match(L)||[]).forEach(function(e,r){var c=parseInt(t[r+1],10);switch(e.toLowerCase().charAt(0)){case"y":a=c;break;case"d":i=c;break;case"h":s=c;break;case"s":o=c;break;case"m":if(s>=0)l=c;else n=c;break;}});if(o>=0&&l==-1&&n>=0){l=n;n=-1}var c=(""+(a>=0?a:(new Date).getFullYear())).slice(-4)+"-"+("00"+(n>=1?n:1)).slice(-2)+"-"+("00"+(i>=1?i:1)).slice(-2);if(c.length==7)c="0"+c;if(c.length==8)c="20"+c;var f=("00"+(s>=0?s:0)).slice(-2)+":"+("00"+(l>=0?l:0)).slice(-2)+":"+("00"+(o>=0?o:0)).slice(-2);if(s==-1&&l==-1&&o==-1)return c;if(a==-1&&n==-1&&i==-1)return f;return c+"T"+f}var W=true;var U;(function(e){e(U={})})(function(e){e.version="1.2.0";function r(){var e=0,r=new Array(256);for(var t=0;t!=256;++t){e=t;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;r[t]=e}return typeof Int32Array!=="undefined"?new Int32Array(r):r}var t=r();function a(e,r){var a=r^-1,n=e.length-1;for(var i=0;i<n;){a=a>>>8^t[(a^e.charCodeAt(i++))&255];a=a>>>8^t[(a^e.charCodeAt(i++))&255]}if(i===n)a=a>>>8^t[(a^e.charCodeAt(i))&255];return a^-1}function n(e,r){if(e.length>1e4)return i(e,r);var a=r^-1,n=e.length-3;for(var s=0;s<n;){a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255]}while(s<n+3)a=a>>>8^t[(a^e[s++])&255];return a^-1}function i(e,r){var a=r^-1,n=e.length-7;for(var i=0;i<n;){a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255]}while(i<n+7)a=a>>>8^t[(a^e[i++])&255];return a^-1}function s(e,r){var a=r^-1;for(var n=0,i=e.length,s,l;n<i;){s=e.charCodeAt(n++);if(s<128){a=a>>>8^t[(a^s)&255]}else if(s<2048){a=a>>>8^t[(a^(192|s>>6&31))&255];a=a>>>8^t[(a^(128|s&63))&255]}else if(s>=55296&&s<57344){s=(s&1023)+64;l=e.charCodeAt(n++)&1023;a=a>>>8^t[(a^(240|s>>8&7))&255];a=a>>>8^t[(a^(128|s>>2&63))&255];a=a>>>8^t[(a^(128|l>>6&15|(s&3)<<4))&255];a=a>>>8^t[(a^(128|l&63))&255]}else{a=a>>>8^t[(a^(224|s>>12&15))&255];a=a>>>8^t[(a^(128|s>>6&63))&255];a=a>>>8^t[(a^(128|s&63))&255]}}return a^-1}e.table=t;e.bstr=a;e.buf=n;e.str=s});var j=function Xl(){var e={};e.version="1.1.4";function r(e,r){var t=e.split("/"),a=r.split("/");for(var n=0,i=0,s=Math.min(t.length,a.length);n<s;++n){if(i=t[n].length-a[n].length)return i;if(t[n]!=a[n])return t[n]<a[n]?-1:1}return t.length-a.length}function t(e){if(e.charAt(e.length-1)=="/")return e.slice(0,-1).indexOf("/")===-1?e:t(e.slice(0,-1));var r=e.lastIndexOf("/");
return r===-1?e:e.slice(0,r+1)}function a(e){if(e.charAt(e.length-1)=="/")return a(e.slice(0,-1));var r=e.lastIndexOf("/");return r===-1?e:e.slice(r+1)}function n(e,r){if(typeof r==="string")r=new Date(r);var t=r.getHours();t=t<<6|r.getMinutes();t=t<<5|r.getSeconds()>>>1;e._W(2,t);var a=r.getFullYear()-1980;a=a<<4|r.getMonth()+1;a=a<<5|r.getDate();e._W(2,a)}function i(e){var r=e._R(2)&65535;var t=e._R(2)&65535;var a=new Date;var n=t&31;t>>>=5;var i=t&15;t>>>=4;a.setMilliseconds(0);a.setFullYear(t+1980);a.setMonth(i-1);a.setDate(n);var s=r&31;r>>>=5;var l=r&63;r>>>=6;a.setHours(r);a.setMinutes(l);a.setSeconds(s<<1);return a}function s(e){Yr(e,0);var r={};var t=0;while(e.l<=e.length-4){var a=e._R(2);var n=e._R(2),i=e.l+n;var s={};switch(a){case 21589:{t=e._R(1);if(t&1)s.mtime=e._R(4);if(n>5){if(t&2)s.atime=e._R(4);if(t&4)s.ctime=e._R(4)}if(s.mtime)s.mt=new Date(s.mtime*1e3)}break;}e.l=i;r[a]=s}return r}var l;function o(){return l||(l=require("fs"))}function c(e,r){if(e[0]==80&&e[1]==75)return Ae(e,r);if(e.length<512)throw new Error("CFB file size "+e.length+" < 512");var t=3;var a=512;var n=0;var i=0;var s=0;var l=0;var o=0;var c=[];var p=e.slice(0,512);Yr(p,0);var v=f(p);t=v[0];switch(t){case 3:a=512;break;case 4:a=4096;break;case 0:if(v[1]==0)return Ae(e,r);default:throw new Error("Major Version: Expected 3 or 4 saw "+t);}if(a!==512){p=e.slice(0,a);Yr(p,28)}var b=e.slice(0,a);u(p,t);var w=p._R(4,"i");if(t===3&&w!==0)throw new Error("# Directory Sectors: Expected 0 saw "+w);p.l+=4;s=p._R(4,"i");p.l+=4;p.chk("00100000","Mini Stream Cutoff Size: ");l=p._R(4,"i");n=p._R(4,"i");o=p._R(4,"i");i=p._R(4,"i");for(var y=-1,x=0;x<109;++x){y=p._R(4,"i");if(y<0)break;c[x]=y}var _=h(e,a);m(o,i,_,a,c);var S=g(_,s,c,a);S[s].name="!Directory";if(n>0&&l!==I)S[l].name="!MiniFAT";S[c[0]].name="!FAT";S.fat_addrs=c;S.ssz=a;var C={},A=[],E=[],F=[];k(s,S,_,A,n,C,E,l);d(E,F,A);A.shift();var T={FileIndex:E,FullPaths:F};if(r&&r.raw)T.raw={header:b,sectors:_};return T}function f(e){if(e[e.l]==80&&e[e.l+1]==75)return[0,0];e.chk(L,"Header Signature: ");e.l+=16;var r=e._R(2,"u");return[e._R(2,"u"),r]}function u(e,r){var t=9;e.l+=2;switch(t=e._R(2)){case 9:if(r!=3)throw new Error("Sector Shift: Expected 9 saw "+t);break;case 12:if(r!=4)throw new Error("Sector Shift: Expected 12 saw "+t);break;default:throw new Error("Sector Shift: Expected 9 or 12 saw "+t);}e.chk("0600","Mini Sector Shift: ");e.chk("000000000000","Reserved: ")}function h(e,r){var t=Math.ceil(e.length/r)-1;var a=[];for(var n=1;n<t;++n)a[n-1]=e.slice(n*r,(n+1)*r);a[t-1]=e.slice(t*r);return a}function d(e,r,t){var a=0,n=0,i=0,s=0,l=0,o=t.length;var c=[],f=[];for(;a<o;++a){c[a]=f[a]=a;r[a]=t[a]}for(;l<f.length;++l){a=f[l];n=e[a].L;i=e[a].R;s=e[a].C;if(c[a]===a){if(n!==-1&&c[n]!==n)c[a]=c[n];if(i!==-1&&c[i]!==i)c[a]=c[i]}if(s!==-1)c[s]=a;if(n!==-1&&a!=c[a]){c[n]=c[a];if(f.lastIndexOf(n)<l)f.push(n)}if(i!==-1&&a!=c[a]){c[i]=c[a];if(f.lastIndexOf(i)<l)f.push(i)}}for(a=1;a<o;++a)if(c[a]===a){if(i!==-1&&c[i]!==i)c[a]=c[i];else if(n!==-1&&c[n]!==n)c[a]=c[n]}for(a=1;a<o;++a){if(e[a].type===0)continue;l=a;if(l!=c[l])do{l=c[l];r[a]=r[l]+"/"+r[a]}while(l!==0&&-1!==c[l]&&l!=c[l]);c[a]=-1}r[0]+="/";for(a=1;a<o;++a){if(e[a].type!==2)r[a]+="/"}}function p(e,r,t){var a=e.start,n=e.size;var i=[];var s=a;while(t&&n>0&&s>=0){i.push(r.slice(s*P,s*P+P));n-=P;s=Wr(t,s*4)}if(i.length===0)return qr(0);return O(i).slice(0,e.size)}function m(e,r,t,a,n){var i=I;if(e===I){if(r!==0)throw new Error("DIFAT chain shorter than expected")}else if(e!==-1){var s=t[e],l=(a>>>2)-1;if(!s)return;for(var o=0;o<l;++o){if((i=Wr(s,o*4))===I)break;n.push(i)}m(Wr(s,a-4),r-1,t,a,n)}}function v(e,r,t,a,n){var i=[],s=[];if(!n)n=[];var l=a-1,o=0,c=0;for(o=r;o>=0;){n[o]=true;i[i.length]=o;s.push(e[o]);var f=t[Math.floor(o*4/a)];c=o*4&l;if(a<4+c)throw new Error("FAT boundary crossed: "+o+" 4 "+a);if(!e[f])break;o=Wr(e[f],c)}return{nodes:i,data:mr([s])}}function g(e,r,t,a){var n=e.length,i=[];var s=[],l=[],o=[];var c=a-1,f=0,u=0,h=0,d=0;for(f=0;f<n;++f){l=[];h=f+r;if(h>=n)h-=n;if(s[h])continue;o=[];var p=[];for(u=h;u>=0;){p[u]=true;s[u]=true;l[l.length]=u;o.push(e[u]);var m=t[Math.floor(u*4/a)];d=u*4&c;if(a<4+d)throw new Error("FAT boundary crossed: "+u+" 4 "+a);if(!e[m])break;u=Wr(e[m],d);if(p[u])break}i[h]={nodes:l,data:mr([o])}}return i}function k(e,r,t,a,n,i,s,l){var o=0,c=a.length?2:0;var f=r[e].data;var u=0,h=0,d;for(;u<f.length;u+=128){var m=f.slice(u,u+128);Yr(m,64);h=m._R(2);d=gr(m,0,h-c);a.push(d);var g={name:d,type:m._R(1),color:m._R(1),L:m._R(4,"i"),R:m._R(4,"i"),C:m._R(4,"i"),clsid:m._R(16),state:m._R(4,"i"),start:0,size:0};var b=m._R(2)+m._R(2)+m._R(2)+m._R(2);if(b!==0)g.ct=y(m,m.l-8);var w=m._R(2)+m._R(2)+m._R(2)+m._R(2);if(w!==0)g.mt=y(m,m.l-8);g.start=m._R(4,"i");g.size=m._R(4,"i");if(g.size<0&&g.start<0){g.size=g.type=0;g.start=I;g.name=""}if(g.type===5){o=g.start;if(n>0&&o!==I)r[o].name="!StreamData"}else if(g.size>=4096){g.storage="fat";if(r[g.start]===undefined)r[g.start]=v(t,g.start,r.fat_addrs,r.ssz);r[g.start].name=g.name;g.content=r[g.start].data.slice(0,g.size)}else{g.storage="minifat";if(g.size<0)g.size=0;else if(o!==I&&g.start!==I&&r[o]){g.content=p(g,r[o].data,(r[l]||{}).data)}}if(g.content)Yr(g.content,0);i[d]=g;s.push(g)}}function y(e,r){return new Date((Br(e,r+4)/1e7*Math.pow(2,32)+Br(e,r)/1e7-11644473600)*1e3)}function x(e,r){o();return c(l.readFileSync(e),r)}function A(e,r){switch(r&&r.type||"base64"){case"file":return x(e,r);case"base64":return c(C(b.decode(e)),r);case"binary":return c(C(e),r);}return c(e,r)}function E(e,r){var t=r||{},a=t.root||"Root Entry";if(!e.FullPaths)e.FullPaths=[];if(!e.FileIndex)e.FileIndex=[];if(e.FullPaths.length!==e.FileIndex.length)throw new Error("inconsistent CFB structure");if(e.FullPaths.length===0){e.FullPaths[0]=a+"/";e.FileIndex[0]={name:a,type:5}}if(t.CLSID)e.FileIndex[0].clsid=t.CLSID;F(e)}function F(e){var r="Sh33tJ5";if(j.find(e,"/"+r))return;var t=qr(4);t[0]=55;t[1]=t[3]=50;t[2]=54;e.FileIndex.push({name:r,type:2,content:t,size:4,L:69,R:69,C:69});e.FullPaths.push(e.FullPaths[0]+r);T(e)}function T(e,n){E(e);var i=false,s=false;for(var l=e.FullPaths.length-1;l>=0;--l){var o=e.FileIndex[l];switch(o.type){case 0:if(s)i=true;else{e.FileIndex.pop();e.FullPaths.pop()}break;case 1:;case 2:;case 5:s=true;if(isNaN(o.R*o.L*o.C))i=true;if(o.R>-1&&o.L>-1&&o.R==o.L)i=true;break;default:i=true;break;}}if(!i&&!n)return;var c=new Date(1987,1,19),f=0;var u=[];for(l=0;l<e.FullPaths.length;++l){if(e.FileIndex[l].type===0)continue;u.push([e.FullPaths[l],e.FileIndex[l]])}for(l=0;l<u.length;++l){var h=t(u[l][0]);s=false;for(f=0;f<u.length;++f)if(u[f][0]===h)s=true;if(!s)u.push([h,{name:a(h).replace("/",""),type:1,clsid:B,ct:c,mt:c,content:null}])}u.sort(function(e,t){return r(e[0],t[0])});e.FullPaths=[];e.FileIndex=[];for(l=0;l<u.length;++l){e.FullPaths[l]=u[l][0];e.FileIndex[l]=u[l][1]}for(l=0;l<u.length;++l){var d=e.FileIndex[l];var p=e.FullPaths[l];d.name=a(p).replace("/","");d.L=d.R=d.C=-(d.color=1);d.size=d.content?d.content.length:0;d.start=0;d.clsid=d.clsid||B;if(l===0){d.C=u.length>1?1:-1;d.size=0;d.type=5}else if(p.slice(-1)=="/"){for(f=l+1;f<u.length;++f)if(t(e.FullPaths[f])==p)break;d.C=f>=u.length?-1:f;for(f=l+1;f<u.length;++f)if(t(e.FullPaths[f])==t(p))break;d.R=f>=u.length?-1:f;d.type=1}else{if(t(e.FullPaths[l+1]||"")==t(p))d.R=l+1;d.type=2}}}function N(e,r){var t=r||{};T(e);if(t.fileType=="zip")return Fe(e,t);var a=function(e){var r=0,t=0;for(var a=0;a<e.FileIndex.length;++a){var n=e.FileIndex[a];if(!n.content)continue;var i=n.content.length;if(i>0){if(i<4096)r+=i+63>>6;else t+=i+511>>9}}var s=e.FullPaths.length+3>>2;var l=r+7>>3;var o=r+127>>7;var c=l+t+s+o;var f=c+127>>7;var u=f<=109?0:Math.ceil((f-109)/127);while(c+f+u+127>>7>f)u=++f<=109?0:Math.ceil((f-109)/127);var h=[1,u,f,o,s,t,r,0];e.FileIndex[0].size=r<<6;h[7]=(e.FileIndex[0].start=h[0]+h[1]+h[2]+h[3]+h[4]+h[5])+(h[6]+7>>3);return h}(e);var n=qr(a[7]<<9);var i=0,s=0;{for(i=0;i<8;++i)n._W(1,z[i]);for(i=0;i<8;++i)n._W(2,0);n._W(2,62);n._W(2,3);n._W(2,65534);n._W(2,9);n._W(2,6);for(i=0;i<3;++i)n._W(2,0);n._W(4,0);n._W(4,a[2]);n._W(4,a[0]+a[1]+a[2]+a[3]-1);n._W(4,0);n._W(4,1<<12);n._W(4,a[3]?a[0]+a[1]+a[2]-1:I);n._W(4,a[3]);n._W(-4,a[1]?a[0]-1:I);n._W(4,a[1]);for(i=0;i<109;++i)n._W(-4,i<a[2]?a[1]+i:-1)}if(a[1]){for(s=0;s<a[1];++s){for(;i<236+s*127;++i)n._W(-4,i<a[2]?a[1]+i:-1);n._W(-4,s===a[1]-1?I:s+1)}}var l=function(e){for(s+=e;i<s-1;++i)n._W(-4,i+1);if(e){++i;n._W(-4,I)}};s=i=0;for(s+=a[1];i<s;++i)n._W(-4,W.DIFSECT);for(s+=a[2];i<s;++i)n._W(-4,W.FATSECT);l(a[3]);l(a[4]);var o=0,c=0;var f=e.FileIndex[0];for(;o<e.FileIndex.length;++o){f=e.FileIndex[o];if(!f.content)continue;c=f.content.length;if(c<4096)continue;f.start=s;l(c+511>>9)}l(a[6]+7>>3);while(n.l&511)n._W(-4,W.ENDOFCHAIN);s=i=0;for(o=0;o<e.FileIndex.length;++o){f=e.FileIndex[o];if(!f.content)continue;c=f.content.length;if(!c||c>=4096)continue;f.start=s;l(c+63>>6)}while(n.l&511)n._W(-4,W.ENDOFCHAIN);for(i=0;i<a[4]<<2;++i){var u=e.FullPaths[i];if(!u||u.length===0){for(o=0;o<17;++o)n._W(4,0);for(o=0;o<3;++o)n._W(4,-1);for(o=0;o<12;++o)n._W(4,0);continue}f=e.FileIndex[i];if(i===0)f.start=f.size?f.start-1:I;var h=i===0&&t.root||f.name;c=2*(h.length+1);n._W(64,h,"utf16le");n._W(2,c);n._W(1,f.type);n._W(1,f.color);n._W(-4,f.L);n._W(-4,f.R);n._W(-4,f.C);if(!f.clsid)for(o=0;o<4;++o)n._W(4,0);else n._W(16,f.clsid,"hex");n._W(4,f.state||0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,f.start);n._W(4,f.size);n._W(4,0)}for(i=1;i<e.FileIndex.length;++i){f=e.FileIndex[i];if(f.size>=4096){n.l=f.start+1<<9;for(o=0;o<f.size;++o)n._W(1,f.content[o]);for(;o&511;++o)n._W(1,0)}}for(i=1;i<e.FileIndex.length;++i){f=e.FileIndex[i];if(f.size>0&&f.size<4096){for(o=0;o<f.size;++o)n._W(1,f.content[o]);for(;o&63;++o)n._W(1,0)}}while(n.l<n.length)n._W(1,0);return n}function R(e,r){var t=e.FullPaths.map(function(e){return e.toUpperCase()});var a=t.map(function(e){var r=e.split("/");return r[r.length-(e.slice(-1)=="/"?2:1)]});var n=false;if(r.charCodeAt(0)===47){n=true;r=t[0].slice(0,-1)+r}else n=r.indexOf("/")!==-1;var i=r.toUpperCase();var s=n===true?t.indexOf(i):a.indexOf(i);if(s!==-1)return e.FileIndex[s];var l=!i.match(M);i=i.replace(D,"");if(l)i=i.replace(M,"!");for(s=0;s<t.length;++s){if((l?t[s].replace(M,"!"):t[s]).replace(D,"")==i)return e.FileIndex[s];if((l?a[s].replace(M,"!"):a[s]).replace(D,"")==i)return e.FileIndex[s]}return null}var P=64;var I=-2;var L="d0cf11e0a1b11ae1";var z=[208,207,17,224,161,177,26,225];var B="00000000000000000000000000000000";var W={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:I,FREESECT:-1,HEADER_SIGNATURE:L,HEADER_MINOR_VERSION:"3e00",MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:B,EntryTypes:["unknown","storage","stream","lockbytes","property","root"]};function $(e,r,t){o();var a=N(e,t);l.writeFileSync(r,a)}function H(e){var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=String.fromCharCode(e[t]);return r.join("")}function V(e,r){var t=N(e,r);switch(r&&r.type){case"file":o();l.writeFileSync(r.filename,t);return t;case"binary":return H(t);case"base64":return b.encode(H(t));}return t}var X;function G(e){try{var r=e.InflateRaw;var t=new r;t._processChunk(new Uint8Array([3,0]),t._finishFlushFlag);if(t.bytesRead)X=e;else throw new Error("zlib does not expose bytesRead")}catch(a){console.error("cannot use native zlib: "+(a.message||a))}}function Y(e,r){if(!X)return Se(e,r);var t=X.InflateRaw;var a=new t;var n=a._processChunk(e.slice(e.l),a._finishFlushFlag);e.l+=a.bytesRead;return n}function J(e){return X?X.deflateRawSync(e):he(e)}var q=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var K=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];var Z=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function Q(e){var r=(e<<1|e<<11)&139536|(e<<5|e<<15)&558144;return(r>>16|r>>8|r)&255}var ee=typeof Uint8Array!=="undefined";var re=ee?new Uint8Array(1<<8):[];for(var te=0;te<1<<8;++te)re[te]=Q(te);function ae(e,r){var t=re[e&255];if(r<=8)return t>>>8-r;t=t<<8|re[e>>8&255];if(r<=16)return t>>>16-r;t=t<<8|re[e>>16&255];return t>>>24-r}function ne(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=6?0:e[a+1]<<8))>>>t&3}function ie(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=5?0:e[a+1]<<8))>>>t&7}function se(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=4?0:e[a+1]<<8))>>>t&15}function le(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=3?0:e[a+1]<<8))>>>t&31}function oe(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=1?0:e[a+1]<<8))>>>t&127}function ce(e,r,t){var a=r&7,n=r>>>3,i=(1<<t)-1;var s=e[n]>>>a;if(t<8-a)return s&i;s|=e[n+1]<<8-a;if(t<16-a)return s&i;s|=e[n+2]<<16-a;if(t<24-a)return s&i;s|=e[n+3]<<24-a;return s&i}function fe(e,r){var t=e.length,a=2*t>r?2*t:r+5,n=0;if(t>=r)return e;if(w){var i=S(a);if(e.copy)e.copy(i);else for(;n<e.length;++n)i[n]=e[n];return i}else if(ee){var s=new Uint8Array(a);if(s.set)s.set(e);else for(;n<e.length;++n)s[n]=e[n];return s}e.length=a;return e}function ue(e){var r=new Array(e);for(var t=0;t<e;++t)r[t]=0;return r}var he=function(){var e=function(){return function e(r,t){var a=0;while(a<r.length){var n=Math.min(65535,r.length-a);var i=a+n==r.length;t._W(1,+i);t._W(2,n);t._W(2,~n&65535);while(n-- >0)t[t.l++]=r[a++]}return t.l}}();return function(r){var t=qr(50+Math.floor(r.length*1.1));var a=e(r,t);return t.slice(0,a)}}();function de(e,r,t){var a=1,n=0,i=0,s=0,l=0,o=e.length;var c=ee?new Uint16Array(32):ue(32);for(i=0;i<32;++i)c[i]=0;for(i=o;i<t;++i)e[i]=0;o=e.length;var f=ee?new Uint16Array(o):ue(o);for(i=0;i<o;++i){c[n=e[i]]++;if(a<n)a=n;f[i]=0}c[0]=0;for(i=1;i<=a;++i)c[i+16]=l=l+c[i-1]<<1;for(i=0;i<o;++i){l=e[i];if(l!=0)f[i]=c[l+16]++}var u=0;for(i=0;i<o;++i){u=e[i];if(u!=0){l=ae(f[i],a)>>a-u;for(s=(1<<a+4-u)-1;s>=0;--s)r[l|s<<u]=u&15|i<<4}}return a}var pe=ee?new Uint16Array(512):ue(512);var me=ee?new Uint16Array(32):ue(32);if(!ee){for(var ve=0;ve<512;++ve)pe[ve]=0;for(ve=0;ve<32;++ve)me[ve]=0}(function(){var e=[];var r=0;for(;r<32;r++)e.push(5);de(e,me,32);var t=[];r=0;for(;r<=143;r++)t.push(8);for(;r<=255;r++)t.push(9);for(;r<=279;r++)t.push(7);for(;r<=287;r++)t.push(8);de(t,pe,288)})();var ge=ee?new Uint16Array(32768):ue(32768);var be=ee?new Uint16Array(32768):ue(32768);var we=ee?new Uint16Array(128):ue(128);var ke=1,ye=1;function xe(e,r){var t=le(e,r)+257;r+=5;var a=le(e,r)+1;r+=5;var n=se(e,r)+4;r+=4;var i=0;var s=ee?new Uint8Array(19):ue(19);var l=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var o=1;var c=ee?new Uint8Array(8):ue(8);var f=ee?new Uint8Array(8):ue(8);var u=s.length;for(var h=0;h<n;++h){s[q[h]]=i=ie(e,r);if(o<i)o=i;c[i]++;r+=3}var d=0;c[0]=0;for(h=1;h<=o;++h)f[h]=d=d+c[h-1]<<1;for(h=0;h<u;++h)if((d=s[h])!=0)l[h]=f[d]++;var p=0;for(h=0;h<u;++h){p=s[h];if(p!=0){d=re[l[h]]>>8-p;for(var m=(1<<7-p)-1;m>=0;--m)we[d|m<<p]=p&7|h<<3}}var v=[];o=1;for(;v.length<t+a;){d=we[oe(e,r)];r+=d&7;switch(d>>>=3){case 16:i=3+ne(e,r);r+=2;d=v[v.length-1];while(i-- >0)v.push(d);break;case 17:i=3+ie(e,r);r+=3;while(i-- >0)v.push(0);break;case 18:i=11+oe(e,r);r+=7;while(i-- >0)v.push(0);break;default:v.push(d);if(o<d)o=d;break;}}var g=v.slice(0,t),b=v.slice(t);for(h=t;h<286;++h)g[h]=0;for(h=a;h<30;++h)b[h]=0;ke=de(g,ge,286);ye=de(b,be,30);return r}function _e(e,r){if(e[0]==3&&!(e[1]&3)){return[_(r),2]}var t=0;var a=0;var n=S(r?r:1<<18);var i=0;var s=n.length>>>0;var l=0,o=0;while((a&1)==0){a=ie(e,t);t+=3;if(a>>>1==0){if(t&7)t+=8-(t&7);var c=e[t>>>3]|e[(t>>>3)+1]<<8;t+=32;if(!r&&s<i+c){n=fe(n,i+c);s=n.length}if(typeof e.copy==="function"){e.copy(n,i,t>>>3,(t>>>3)+c);i+=c;t+=8*c}else while(c-- >0){n[i++]=e[t>>>3];t+=8}continue}else if(a>>>1==1){l=9;o=5}else{t=xe(e,t);l=ke;o=ye}if(!r&&s<i+32767){n=fe(n,i+32767);s=n.length}for(;;){var f=ce(e,t,l);var u=a>>>1==1?pe[f]:ge[f];t+=u&15;u>>>=4;if((u>>>8&255)===0)n[i++]=u;else if(u==256)break;else{u-=257;var h=u<8?0:u-4>>2;if(h>5)h=0;var d=i+K[u];if(h>0){d+=ce(e,t,h);t+=h}f=ce(e,t,o);u=a>>>1==1?me[f]:be[f];t+=u&15;u>>>=4;var p=u<4?0:u-2>>1;var m=Z[u];if(p>0){m+=ce(e,t,p);t+=p}if(!r&&s<d){n=fe(n,d);s=n.length}while(i<d){n[i]=n[i-m];++i}}}}return[r?n:n.slice(0,i),t+7>>>3]}function Se(e,r){var t=e.slice(e.l||0);var a=_e(t,r);e.l+=a[1];return a[0]}function Ce(e,r){if(e){if(typeof console!=="undefined")console.error(r)}else throw new Error(r)}function Ae(e,r){var t=e;Yr(t,0);var a=[],n=[];var i={FileIndex:a,FullPaths:n};E(i,{root:r.root});var l=t.length-4;while((t[l]!=80||t[l+1]!=75||t[l+2]!=5||t[l+3]!=6)&&l>=0)--l;t.l=l+4;t.l+=4;var o=t._R(2);t.l+=6;var c=t._R(4);t.l=c;for(l=0;l<o;++l){t.l+=20;var f=t._R(4);var u=t._R(4);var h=t._R(2);var d=t._R(2);var p=t._R(2);t.l+=8;var m=t._R(4);var v=s(t.slice(t.l+h,t.l+h+d));t.l+=h+d+p;var g=t.l;t.l=m+4;Ee(t,f,u,i,v);t.l=g}return i}function Ee(e,r,t,a,n){e.l+=2;var l=e._R(2);var o=e._R(2);var c=i(e);if(l&8257)throw new Error("Unsupported ZIP encryption");var f=e._R(4);var u=e._R(4);var h=e._R(4);var d=e._R(2);var p=e._R(2);var m="";for(var v=0;v<d;++v)m+=String.fromCharCode(e[e.l++]);if(p){var g=s(e.slice(e.l,e.l+p));if((g[21589]||{}).mt)c=g[21589].mt;if(((n||{})[21589]||{}).mt)c=n[21589].mt}e.l+=p;var b=e.slice(e.l,e.l+u);switch(o){case 8:b=Y(e,h);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+o);}var w=false;if(l&8){f=e._R(4);if(f==134695760){f=e._R(4);w=true}u=e._R(4);h=e._R(4)}if(u!=r)Ce(w,"Bad compressed size: "+r+" != "+u);if(h!=t)Ce(w,"Bad uncompressed size: "+t+" != "+h);var k=U.buf(b,0);if(f>>0!=k>>0)Ce(w,"Bad CRC32 checksum: "+f+" != "+k);Oe(a,m,b,{unsafe:true,mt:c})}function Fe(e,r){var t=r||{};var a=[],i=[];var s=qr(1);var l=t.compression?8:0,o=0;var c=false;if(c)o|=8;var f=0,u=0;var h=0,d=0;var p=e.FullPaths[0],m=p,v=e.FileIndex[0];var g=[];var b=0;for(f=1;f<e.FullPaths.length;++f){m=e.FullPaths[f].slice(p.length);v=e.FileIndex[f];if(!v.size||!v.content||m=="Sh33tJ5")continue;var w=h;var k=qr(m.length);for(u=0;u<m.length;++u)k._W(1,m.charCodeAt(u)&127);k=k.slice(0,k.l);g[d]=U.buf(v.content,0);var y=v.content;if(l==8)y=J(y);s=qr(30);s._W(4,67324752);s._W(2,20);s._W(2,o);s._W(2,l);if(v.mt)n(s,v.mt);else s._W(4,0);s._W(-4,o&8?0:g[d]);s._W(4,o&8?0:y.length);s._W(4,o&8?0:v.content.length);s._W(2,k.length);s._W(2,0);h+=s.length;a.push(s);h+=k.length;a.push(k);h+=y.length;a.push(y);if(o&8){s=qr(12);s._W(-4,g[d]);s._W(4,y.length);s._W(4,v.content.length);h+=s.l;a.push(s)}s=qr(46);s._W(4,33639248);s._W(2,0);s._W(2,20);s._W(2,o);s._W(2,l);s._W(4,0);s._W(-4,g[d]);s._W(4,y.length);s._W(4,v.content.length);s._W(2,k.length);s._W(2,0);s._W(2,0);s._W(2,0);s._W(2,0);s._W(4,0);s._W(4,w);b+=s.l;i.push(s);b+=k.length;i.push(k);++d}s=qr(22);s._W(4,101010256);s._W(2,0);s._W(2,0);s._W(2,d);s._W(2,d);s._W(4,b);s._W(4,h);s._W(2,0);return O([O(a),O(i),s])}function Te(e){var r={};E(r,e);return r}function Oe(e,r,t,n){var i=n&&n.unsafe;if(!i)E(e);var s=!i&&j.find(e,r);if(!s){var l=e.FullPaths[0];if(r.slice(0,l.length)==l)l=r;else{if(l.slice(-1)!="/")l+="/";l=(l+r).replace("//","/")}s={name:a(r),type:2};e.FileIndex.push(s);e.FullPaths.push(l);if(!i)j.utils.cfb_gc(e)}s.content=t;s.size=t?t.length:0;if(n){if(n.CLSID)s.clsid=n.CLSID;if(n.mt)s.mt=n.mt;if(n.ct)s.ct=n.ct}return s}function De(e,r){E(e);var t=j.find(e,r);if(t)for(var a=0;a<e.FileIndex.length;++a)if(e.FileIndex[a]==t){e.FileIndex.splice(a,1);e.FullPaths.splice(a,1);return true}return false}function Me(e,r,t){E(e);var n=j.find(e,r);if(n)for(var i=0;i<e.FileIndex.length;++i)if(e.FileIndex[i]==n){e.FileIndex[i].name=a(t);e.FullPaths[i]=t;return true}return false}function Ne(e){T(e,true)}e.find=R;e.read=A;e.parse=c;e.write=V;e.writeFile=$;e.utils={cfb_new:Te,cfb_add:Oe,cfb_del:De,cfb_mov:Me,cfb_gc:Ne,ReadShift:Ur,CheckField:Gr,prep_blob:Yr,bconcat:O,use_zlib:G,_deflateRaw:he,_inflateRaw:Se,consts:W};return e}();if(typeof require!=="undefined"&&typeof module!=="undefined"&&typeof W==="undefined"){module.exports=j}var H;if(typeof require!=="undefined")try{H=require("fs")}catch(x){}function V(e){if(typeof e==="string")return A(e);if(Array.isArray(e))return F(e);return e}function X(e,r,t){if(typeof H!=="undefined"&&H.writeFileSync)return t?H.writeFileSync(e,r,t):H.writeFileSync(e,r);var a=t=="utf8"?Je(r):r;if(typeof IE_SaveFile!=="undefined")return IE_SaveFile(a,e);if(typeof Blob!=="undefined"){var n=new Blob([V(a)],{type:"application/octet-stream"});if(typeof navigator!=="undefined"&&navigator.msSaveBlob)return navigator.msSaveBlob(n,e);if(typeof saveAs!=="undefined")return saveAs(n,e);if(typeof URL!=="undefined"&&typeof document!=="undefined"&&document.createElement&&URL.createObjectURL){var i=URL.createObjectURL(n);if(typeof chrome==="object"&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return chrome.downloads.download({url:i,filename:e,saveAs:true})}var s=document.createElement("a");if(s.download!=null){s.download=e;s.href=i;document.body.appendChild(s);s.click();document.body.removeChild(s);if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return i}}}if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var l=File(e);l.open("w");l.encoding="binary";if(Array.isArray(r))r=E(r);l.write(r);l.close();return r}catch(o){if(!o.message||!o.message.match(/onstruct/))throw o}throw new Error("cannot save file "+e)}function G(e){if(typeof H!=="undefined")return H.readFileSync(e);if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var r=File(e);r.open("r");r.encoding="binary";var t=r.read();r.close();return t}catch(a){if(!a.message||!a.message.match(/onstruct/))throw a}throw new Error("Cannot access file "+e)}function Y(e){var r=Object.keys(e),t=[];for(var a=0;a<r.length;++a)if(Object.prototype.hasOwnProperty.call(e,r[a]))t.push(r[a]);return t}function J(e,r){var t=[],a=Y(e);for(var n=0;n!==a.length;++n)if(t[e[a[n]][r]]==null)t[e[a[n]][r]]=a[n];return t}function q(e){var r=[],t=Y(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=t[a];return r}function K(e){var r=[],t=Y(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=parseInt(t[a],10);return r}function Z(e){var r=[],t=Y(e);for(var a=0;a!==t.length;++a){if(r[e[t[a]]]==null)r[e[t[a]]]=[];r[e[t[a]]].push(t[a])}return r}var Q=new Date(1899,11,30,0,0,0);function ee(e,r){var t=e.getTime();if(r)t-=1462*24*60*60*1e3;var a=Q.getTime()+(e.getTimezoneOffset()-Q.getTimezoneOffset())*6e4;return(t-a)/(24*60*60*1e3)}var re=new Date;var te=Q.getTime()+(re.getTimezoneOffset()-Q.getTimezoneOffset())*6e4;var ae=re.getTimezoneOffset();function ne(e){var r=new Date;r.setTime(e*24*60*60*1e3+te);if(r.getTimezoneOffset()!==ae){r.setTime(r.getTime()+(r.getTimezoneOffset()-ae)*6e4)}return r}function ie(e){var r=0,t=0,a=false;var n=e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!n)throw new Error("|"+e+"| is not an ISO8601 Duration");for(var i=1;i!=n.length;++i){if(!n[i])continue;t=1;if(i>3)a=true;switch(n[i].slice(n[i].length-1)){case"Y":throw new Error("Unsupported ISO Duration Field: "+n[i].slice(n[i].length-1));case"D":t*=24;case"H":t*=60;case"M":if(!a)throw new Error("Unsupported ISO Duration Field: M");else t*=60;case"S":break;}r+=t*parseInt(n[i],10)}return r}var se=new Date("2017-02-19T19:06:09.000Z");if(isNaN(se.getFullYear()))se=new Date("2/19/17");var le=se.getFullYear()==2017;function oe(e,r){var t=new Date(e);if(le){if(r>0)t.setTime(t.getTime()+t.getTimezoneOffset()*60*1e3);else if(r<0)t.setTime(t.getTime()-t.getTimezoneOffset()*60*1e3);return t}if(e instanceof Date)return e;if(se.getFullYear()==1917&&!isNaN(t.getFullYear())){var a=t.getFullYear();if(e.indexOf(""+a)>-1)return t;t.setFullYear(t.getFullYear()+100);return t}var n=e.match(/\d+/g)||["2017","2","19","0","0","0"];var i=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(e.indexOf("Z")>-1)i=new Date(i.getTime()-i.getTimezoneOffset()*60*1e3);return i}function ce(e){var r="";for(var t=0;t!=e.length;++t)r+=String.fromCharCode(e[t]);return r}function fe(e){if(typeof JSON!="undefined"&&!Array.isArray(e))return JSON.parse(JSON.stringify(e));if(typeof e!="object"||e==null)return e;if(e instanceof Date)return new Date(e.getTime());var r={};for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))r[t]=fe(e[t]);return r}function ue(e,r){var t="";while(t.length<r)t+=e;return t}function he(e){var r=Number(e);if(!isNaN(r))return r;if(!/\d/.test(e))return r;var t=1;var a=e.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){t*=100;return""});if(!isNaN(r=Number(a)))return r/t;a=a.replace(/[(](.*)[)]/,function(e,r){t=-t;return r});if(!isNaN(r=Number(a)))return r/t;return r}function de(e){var r=new Date(e),t=new Date(NaN);var a=r.getYear(),n=r.getMonth(),i=r.getDate();if(isNaN(i))return t;if(a<0||a>8099)return t;if((n>0||i>1)&&a!=101)return r;if(e.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/))return r;if(e.match(/[^-0-9:,\/\\]/))return t;return r}var pe="abacaba".split(/(:?b)/i).length==5;function me(e,r,t){if(pe||typeof r=="string")return e.split(r);var a=e.split(r),n=[a[0]];for(var i=1;i<a.length;++i){n.push(t);n.push(a[i])}return n}function ve(e){if(!e)return null;if(e.data)return d(e.data);if(e.asNodeBuffer&&w)return d(e.asNodeBuffer().toString("binary"));if(e.asBinary)return d(e.asBinary());if(e._data&&e._data.getContent)return d(ce(Array.prototype.slice.call(e._data.getContent(),0)));if(e.content&&e.type)return d(ce(e.content));return null}function ge(e){if(!e)return null;if(e.data)return f(e.data);if(e.asNodeBuffer&&w)return e.asNodeBuffer();if(e._data&&e._data.getContent){var r=e._data.getContent();if(typeof r=="string")return f(r);return Array.prototype.slice.call(r)}if(e.content&&e.type)return e.content;return null}function be(e){return e&&e.name.slice(-4)===".bin"?ge(e):ve(e)}function we(e,r){var t=e.FullPaths||Y(e.files);var a=r.toLowerCase(),n=a.replace(/\\/g,"/");for(var i=0;i<t.length;++i){var s=t[i].replace(/^Root Entry[\/]/,"").toLowerCase();if(a==s||n==s)return e.FileIndex[i]}return null}function ke(e,r){var t=we(e,r);if(t==null)throw new Error("Cannot find file "+r+" in zip");return t}function ye(e,r,t){if(!t)return be(ke(e,r));if(!r)return null;try{return ye(e,r)}catch(a){return null}}function xe(e,r,t){if(!t)return ve(ke(e,r));if(!r)return null;try{return xe(e,r)}catch(a){return null}}function _e(e){var r=e.FullPaths||Y(e.files),t=[];for(var a=0;a<r.length;++a)if(r[a].slice(-1)!="/")t.push(r[a].replace(/^Root Entry[\/]/,""));return t.sort()}function Se(e,r,t){if(e.FullPaths)j.utils.cfb_add(e,r,typeof t=="string"?w?k(t):C(Je(t)):t);else e.file(r,t)}function Ce(){return j.utils.cfb_new()}function Ae(e,r){var t;switch(r.type){case"base64":t=j.read(e,{type:"base64"});break;case"binary":t=j.read(e,{type:"binary"});break;case"buffer":;case"array":t=j.read(e,{type:"buffer"});break;default:throw new Error("Unrecognized type "+r.type);}return t}function Ee(e,r){if(e.charAt(0)=="/")return e.slice(1);var t=r.split("/");if(r.slice(-1)!="/")t.pop();var a=e.split("/");while(a.length!==0){var n=a.shift();if(n==="..")t.pop();else if(n!==".")t.push(n)}return t.join("/")}var Fe='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var Te=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var Oe=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/gm;if(!Fe.match(Oe))Oe=/<[^>]*>/g;var De=/<\w*:/,Me=/<(\/?)\w+:/;function Ne(e,r,t){var a={};var n=0,i=0;for(;n!==e.length;++n)if((i=e.charCodeAt(n))===32||i===10||i===13)break;if(!r)a[0]=e.slice(0,n);if(n===e.length)return a;var s=e.match(Te),l=0,o="",c=0,f="",u="",h=1;if(s)for(c=0;c!=s.length;++c){u=s[c];for(i=0;i!=u.length;++i)if(u.charCodeAt(i)===61)break;f=u.slice(0,i).trim();while(u.charCodeAt(i+1)==32)++i;h=(n=u.charCodeAt(i+1))==34||n==39?1:0;o=u.slice(i+1+h,u.length-h);for(l=0;l!=f.length;++l)if(f.charCodeAt(l)===58)break;if(l===f.length){if(f.indexOf("_")>0)f=f.slice(0,f.indexOf("_"));a[f]=o;if(!t)a[f.toLowerCase()]=o}else{var d=(l===5&&f.slice(0,5)==="xmlns"?"xmlns":"")+f.slice(l+1);if(a[d]&&f.slice(l-3,l)=="ext")continue;a[d]=o;if(!t)a[d.toLowerCase()]=o}}return a}function Re(e){return e.replace(Me,"<$1")}var Pe={"&quot;":'"',"&apos;":"'","&gt;":">","&lt;":"<","&amp;":"&"};var Ie=q(Pe);var Le=function(){var e=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/gi,r=/_x([\da-fA-F]{4})_/gi;return function t(a){var n=a+"",i=n.indexOf("<![CDATA[");if(i==-1)return n.replace(e,function(e,r){return Pe[e]||String.fromCharCode(parseInt(r,e.indexOf("x")>-1?16:10))||e}).replace(r,function(e,r){return String.fromCharCode(parseInt(r,16))});var s=n.indexOf("]]>");return t(n.slice(0,i))+n.slice(i+9,s)+t(n.slice(s+3))}}();var ze=/[&<>'"]/g,Be=/[\u0000-\u0008\u000b-\u001f]/g;function We(e){var r=e+"";return r.replace(ze,function(e){return Ie[e]}).replace(Be,function(e){return"_x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+"_"})}function $e(e){return We(e).replace(/ /g,"_x0020_")}var Ue=/[\u0000-\u001f]/g;function je(e){var r=e+"";return r.replace(ze,function(e){return Ie[e]}).replace(/\n/g,"<br/>").replace(Ue,function(e){return"&#x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+";"})}function He(e){var r=e+"";return r.replace(ze,function(e){return Ie[e]}).replace(Ue,function(e){return"&#x"+e.charCodeAt(0).toString(16).toUpperCase()+";"})}var Ve=function(){var e=/&#(\d+);/g;function r(e,r){return String.fromCharCode(parseInt(r,10))}return function t(a){return a.replace(e,r)}}();var Xe=function(){return function e(r){return r.replace(/(\r\n|[\r\n])/g,"&#10;")}}();function Ge(e){switch(e){case 1:;case true:;case"1":;case"true":;case"TRUE":return true;default:return false;}}var Ye=function Gl(e){var r="",t=0,a=0,n=0,i=0,s=0,l=0;while(t<e.length){a=e.charCodeAt(t++);if(a<128){r+=String.fromCharCode(a);continue}n=e.charCodeAt(t++);if(a>191&&a<224){s=(a&31)<<6;s|=n&63;r+=String.fromCharCode(s);continue}i=e.charCodeAt(t++);if(a<240){r+=String.fromCharCode((a&15)<<12|(n&63)<<6|i&63);continue}s=e.charCodeAt(t++);l=((a&7)<<18|(n&63)<<12|(i&63)<<6|s&63)-65536;r+=String.fromCharCode(55296+(l>>>10&1023));r+=String.fromCharCode(56320+(l&1023))}return r};var Je=function(e){var r=[],t=0,a=0,n=0;while(t<e.length){a=e.charCodeAt(t++);switch(true){case a<128:r.push(String.fromCharCode(a));break;case a<2048:r.push(String.fromCharCode(192+(a>>6)));r.push(String.fromCharCode(128+(a&63)));break;case a>=55296&&a<57344:a-=55296;n=e.charCodeAt(t++)-56320+(a<<10);r.push(String.fromCharCode(240+(n>>18&7)));r.push(String.fromCharCode(144+(n>>12&63)));r.push(String.fromCharCode(128+(n>>6&63)));r.push(String.fromCharCode(128+(n&63)));break;default:r.push(String.fromCharCode(224+(a>>12)));r.push(String.fromCharCode(128+(a>>6&63)));r.push(String.fromCharCode(128+(a&63)));}}
return r.join("")};if(w){var qe=function Yl(e){var r=Buffer.alloc(2*e.length),t,a,n=1,i=0,s=0,l;for(a=0;a<e.length;a+=n){n=1;if((l=e.charCodeAt(a))<128)t=l;else if(l<224){t=(l&31)*64+(e.charCodeAt(a+1)&63);n=2}else if(l<240){t=(l&15)*4096+(e.charCodeAt(a+1)&63)*64+(e.charCodeAt(a+2)&63);n=3}else{n=4;t=(l&7)*262144+(e.charCodeAt(a+1)&63)*4096+(e.charCodeAt(a+2)&63)*64+(e.charCodeAt(a+3)&63);t-=65536;s=55296+(t>>>10&1023);t=56320+(t&1023)}if(s!==0){r[i++]=s&255;r[i++]=s>>>8;s=0}r[i++]=t%256;r[i++]=t>>>8}return r.slice(0,i).toString("ucs2")};var Ke="foo bar bazâð£";if(Ye(Ke)==qe(Ke))Ye=qe;var Ze=function Jl(e){return k(e,"binary").toString("utf8")};if(Ye(Ke)==Ze(Ke))Ye=Ze;Je=function(e){return k(e,"utf8").toString("binary")}}var Qe=function(){var e={};return function r(t,a){var n=t+"|"+(a||"");if(e[n])return e[n];return e[n]=new RegExp("<(?:\\w+:)?"+t+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+t+">",a||"")}}();var er=function(){var e=[["nbsp"," "],["middot","·"],["quot",'"'],["apos","'"],["gt",">"],["lt","<"],["amp","&"]].map(function(e){return[new RegExp("&"+e[0]+";","ig"),e[1]]});return function r(t){var a=t.replace(/^[\t\n\r ]+/,"").replace(/[\t\n\r ]+$/,"").replace(/>\s+/g,">").replace(/\s+</g,"<").replace(/[\t\n\r ]+/g," ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");for(var n=0;n<e.length;++n)a=a.replace(e[n][0],e[n][1]);return a}}();var rr=function(){var e={};return function r(t){if(e[t]!==undefined)return e[t];return e[t]=new RegExp("<(?:vt:)?"+t+">([\\s\\S]*?)</(?:vt:)?"+t+">","g")}}();var tr=/<\/?(?:vt:)?variant>/g,ar=/<(?:vt:)([^>]*)>([\s\S]*)</;function nr(e,r){var t=Ne(e);var a=e.match(rr(t.baseType))||[];var n=[];if(a.length!=t.size){if(r.WTF)throw new Error("unexpected vector length "+a.length+" != "+t.size);return n}a.forEach(function(e){var r=e.replace(tr,"").match(ar);if(r)n.push({v:Ye(r[2]),t:r[1]})});return n}var ir=/(^\s|\s$|\n)/;function sr(e,r){return"<"+e+(r.match(ir)?' xml:space="preserve"':"")+">"+r+"</"+e+">"}function lr(e){return Y(e).map(function(r){return" "+r+'="'+e[r]+'"'}).join("")}function or(e,r,t){return"<"+e+(t!=null?lr(t):"")+(r!=null?(r.match(ir)?' xml:space="preserve"':"")+">"+r+"</"+e:"/")+">"}function cr(e,r){try{return e.toISOString().replace(/\.\d*/,"")}catch(t){if(r)throw t}return""}function fr(e,r){switch(typeof e){case"string":var t=or("vt:lpwstr",We(e));if(r)t=t.replace(/&quot;/g,"_x0022_");return t;case"number":return or((e|0)==e?"vt:i4":"vt:r8",We(String(e)));case"boolean":return or("vt:bool",e?"true":"false");}if(e instanceof Date)return or("vt:filetime",cr(e));throw new Error("Unable to serialize "+e)}var ur={dc:"http://purl.org/dc/elements/1.1/",dcterms:"http://purl.org/dc/terms/",dcmitype:"http://purl.org/dc/dcmitype/",mx:"http://schemas.microsoft.com/office/mac/excel/2008/main",r:"http://schemas.openxmlformats.org/officeDocument/2006/relationships",sjs:"http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",vt:"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",xsi:"http://www.w3.org/2001/XMLSchema-instance",xsd:"http://www.w3.org/2001/XMLSchema"};ur.main=["http://schemas.openxmlformats.org/spreadsheetml/2006/main","http://purl.oclc.org/ooxml/spreadsheetml/main","http://schemas.microsoft.com/office/excel/2006/main","http://schemas.microsoft.com/office/excel/2006/2"];var hr={o:"urn:schemas-microsoft-com:office:office",x:"urn:schemas-microsoft-com:office:excel",ss:"urn:schemas-microsoft-com:office:spreadsheet",dt:"uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",mv:"http://macVmlSchemaUri",v:"urn:schemas-microsoft-com:vml",html:"http://www.w3.org/TR/REC-html40"};function dr(e,r){var t=1-2*(e[r+7]>>>7);var a=((e[r+7]&127)<<4)+(e[r+6]>>>4&15);var n=e[r+6]&15;for(var i=5;i>=0;--i)n=n*256+e[r+i];if(a==2047)return n==0?t*Infinity:NaN;if(a==0)a=-1022;else{a-=1023;n+=Math.pow(2,52)}return t*Math.pow(2,a-52)*n}function pr(e,r,t){var a=(r<0||1/r==-Infinity?1:0)<<7,n=0,i=0;var s=a?-r:r;if(!isFinite(s)){n=2047;i=isNaN(r)?26985:0}else if(s==0)n=i=0;else{n=Math.floor(Math.log(s)/Math.LN2);i=s*Math.pow(2,52-n);if(n<=-1023&&(!isFinite(i)||i<Math.pow(2,52))){n=-1022}else{i-=Math.pow(2,52);n+=1023}}for(var l=0;l<=5;++l,i/=256)e[t+l]=i&255;e[t+6]=(n&15)<<4|i&15;e[t+7]=n>>4|a}var mr=function(e){var r=[],t=10240;for(var a=0;a<e[0].length;++a)if(e[0][a])for(var n=0,i=e[0][a].length;n<i;n+=t)r.push.apply(r,e[0][a].slice(n,n+t));return r};var vr=mr;var gr=function(e,r,t){var a=[];for(var n=r;n<t;n+=2)a.push(String.fromCharCode(Lr(e,n)));return a.join("").replace(D,"")};var br=gr;var wr=function(e,r,t){var a=[];for(var n=r;n<r+t;++n)a.push(("0"+e[n].toString(16)).slice(-2));return a.join("")};var kr=wr;var yr=function(e,r,t){var a=[];for(var n=r;n<t;n++)a.push(String.fromCharCode(Ir(e,n)));return a.join("")};var xr=yr;var _r=function(e,r){var t=Br(e,r);return t>0?yr(e,r+4,r+4+t-1):""};var Sr=_r;var Cr=function(e,r){var t=Br(e,r);return t>0?yr(e,r+4,r+4+t-1):""};var Ar=Cr;var Er=function(e,r){var t=2*Br(e,r);return t>0?yr(e,r+4,r+4+t-1):""};var Fr=Er;var Tr,Or;Tr=Or=function ql(e,r){var t=Br(e,r);return t>0?gr(e,r+4,r+4+t):""};var Dr=function(e,r){var t=Br(e,r);return t>0?yr(e,r+4,r+4+t):""};var Mr=Dr;var Nr,Rr;Nr=Rr=function(e,r){return dr(e,r)};var Pr=function Kl(e){return Array.isArray(e)};if(w){gr=function(e,r,t){if(!Buffer.isBuffer(e))return br(e,r,t);return e.toString("utf16le",r,t).replace(D,"")};wr=function(e,r,t){return Buffer.isBuffer(e)?e.toString("hex",r,r+t):kr(e,r,t)};_r=function Zl(e,r){if(!Buffer.isBuffer(e))return Sr(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};Cr=function Ql(e,r){if(!Buffer.isBuffer(e))return Ar(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};Er=function eo(e,r){if(!Buffer.isBuffer(e))return Fr(e,r);var t=2*e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t-1)};Tr=function ro(e,r){if(!Buffer.isBuffer(e))return Or(e,r);var t=e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t)};Dr=function to(e,r){if(!Buffer.isBuffer(e))return Mr(e,r);var t=e.readUInt32LE(r);return e.toString("utf8",r+4,r+4+t)};yr=function ao(e,r,t){return Buffer.isBuffer(e)?e.toString("utf8",r,t):xr(e,r,t)};mr=function(e){return e[0].length>0&&Buffer.isBuffer(e[0][0])?Buffer.concat(e[0]):vr(e)};O=function(e){return Buffer.isBuffer(e[0])?Buffer.concat(e):[].concat.apply([],e)};Nr=function no(e,r){if(Buffer.isBuffer(e))return e.readDoubleLE(r);return Rr(e,r)};Pr=function io(e){return Buffer.isBuffer(e)||Array.isArray(e)}}if(typeof cptable!=="undefined"){gr=function(e,r,t){return cptable.utils.decode(1200,e.slice(r,t)).replace(D,"")};yr=function(e,r,t){return cptable.utils.decode(65001,e.slice(r,t))};_r=function(e,r){var a=Br(e,r);return a>0?cptable.utils.decode(t,e.slice(r+4,r+4+a-1)):""};Cr=function(e,t){var a=Br(e,t);return a>0?cptable.utils.decode(r,e.slice(t+4,t+4+a-1)):""};Er=function(e,r){var t=2*Br(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t-1)):""};Tr=function(e,r){var t=Br(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t)):""};Dr=function(e,r){var t=Br(e,r);return t>0?cptable.utils.decode(65001,e.slice(r+4,r+4+t)):""}}var Ir=function(e,r){return e[r]};var Lr=function(e,r){return e[r+1]*(1<<8)+e[r]};var zr=function(e,r){var t=e[r+1]*(1<<8)+e[r];return t<32768?t:(65535-t+1)*-1};var Br=function(e,r){return e[r+3]*(1<<24)+(e[r+2]<<16)+(e[r+1]<<8)+e[r]};var Wr=function(e,r){return e[r+3]<<24|e[r+2]<<16|e[r+1]<<8|e[r]};var $r=function(e,r){return e[r]<<24|e[r+1]<<16|e[r+2]<<8|e[r+3]};function Ur(e,t){var a="",n,i,s=[],l,o,c,f;switch(t){case"dbcs":f=this.l;if(w&&Buffer.isBuffer(this))a=this.slice(this.l,this.l+2*e).toString("utf16le");else for(c=0;c<e;++c){a+=String.fromCharCode(Lr(this,f));f+=2}e*=2;break;case"utf8":a=yr(this,this.l,this.l+e);break;case"utf16le":e*=2;a=gr(this,this.l,this.l+e);break;case"wstr":if(typeof cptable!=="undefined")a=cptable.utils.decode(r,this.slice(this.l,this.l+2*e));else return Ur.call(this,e,"dbcs");e=2*e;break;case"lpstr-ansi":a=_r(this,this.l);e=4+Br(this,this.l);break;case"lpstr-cp":a=Cr(this,this.l);e=4+Br(this,this.l);break;case"lpwstr":a=Er(this,this.l);e=4+2*Br(this,this.l);break;case"lpp4":e=4+Br(this,this.l);a=Tr(this,this.l);if(e&2)e+=2;break;case"8lpp4":e=4+Br(this,this.l);a=Dr(this,this.l);if(e&3)e+=4-(e&3);break;case"cstr":e=0;a="";while((l=Ir(this,this.l+e++))!==0)s.push(p(l));a=s.join("");break;case"_wstr":e=0;a="";while((l=Lr(this,this.l+e))!==0){s.push(p(l));e+=2}e+=2;a=s.join("");break;case"dbcs-cont":a="";f=this.l;for(c=0;c<e;++c){if(this.lens&&this.lens.indexOf(f)!==-1){l=Ir(this,f);this.l=f+1;o=Ur.call(this,e-c,l?"dbcs-cont":"sbcs-cont");return s.join("")+o}s.push(p(Lr(this,f)));f+=2}a=s.join("");e*=2;break;case"cpstr":if(typeof cptable!=="undefined"){a=cptable.utils.decode(r,this.slice(this.l,this.l+e));break};case"sbcs-cont":a="";f=this.l;for(c=0;c!=e;++c){if(this.lens&&this.lens.indexOf(f)!==-1){l=Ir(this,f);this.l=f+1;o=Ur.call(this,e-c,l?"dbcs-cont":"sbcs-cont");return s.join("")+o}s.push(p(Ir(this,f)));f+=1}a=s.join("");break;default:switch(e){case 1:n=Ir(this,this.l);this.l++;return n;case 2:n=(t==="i"?zr:Lr)(this,this.l);this.l+=2;return n;case 4:;case-4:if(t==="i"||(this[this.l+3]&128)===0){n=(e>0?Wr:$r)(this,this.l);this.l+=4;return n}else{i=Br(this,this.l);this.l+=4}return i;case 8:;case-8:if(t==="f"){if(e==8)i=Nr(this,this.l);else i=Nr([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return i}else e=8;case 16:a=wr(this,this.l,e);break;};}this.l+=e;return a}var jr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255;e[t+2]=r>>>16&255;e[t+3]=r>>>24&255};var Hr=function(e,r,t){e[t]=r&255;e[t+1]=r>>8&255;e[t+2]=r>>16&255;e[t+3]=r>>24&255};var Vr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255};function Xr(e,r,a){var n=0,i=0;if(a==="dbcs"){for(i=0;i!=r.length;++i)Vr(this,r.charCodeAt(i),this.l+2*i);n=2*r.length}else if(a==="sbcs"){if(typeof cptable!=="undefined"&&t==874){for(i=0;i!=r.length;++i){var s=cptable.utils.encode(t,r.charAt(i));this[this.l+i]=s[0]}}else{r=r.replace(/[^\x00-\x7F]/g,"_");for(i=0;i!=r.length;++i)this[this.l+i]=r.charCodeAt(i)&255}n=r.length}else if(a==="hex"){for(;i<e;++i){this[this.l++]=parseInt(r.slice(2*i,2*i+2),16)||0}return this}else if(a==="utf16le"){var l=Math.min(this.l+e,this.length);for(i=0;i<Math.min(r.length,e);++i){var o=r.charCodeAt(i);this[this.l++]=o&255;this[this.l++]=o>>8}while(this.l<l)this[this.l++]=0;return this}else switch(e){case 1:n=1;this[this.l]=r&255;break;case 2:n=2;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;break;case 3:n=3;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;r>>>=8;this[this.l+2]=r&255;break;case 4:n=4;jr(this,r,this.l);break;case 8:n=8;if(a==="f"){pr(this,r,this.l);break};case 16:break;case-4:n=4;Hr(this,r,this.l);break;}this.l+=n;return this}function Gr(e,r){var t=wr(this,this.l,e.length>>1);if(t!==e)throw new Error(r+"Expected "+e+" saw "+t);this.l+=e.length>>1}function Yr(e,r){e.l=r;e._R=Ur;e.chk=Gr;e._W=Xr}function Jr(e,r){e.l+=r}function qr(e){var r=_(e);Yr(r,0);return r}function Kr(e,r,t){if(!e)return;var a,n,i;Yr(e,e.l||0);var s=e.length,l=0,o=0;while(e.l<s){l=e._R(1);if(l&128)l=(l&127)+((e._R(1)&127)<<7);var c=XLSBRecordEnum[l]||XLSBRecordEnum[65535];a=e._R(1);i=a&127;for(n=1;n<4&&a&128;++n)i+=((a=e._R(1))&127)<<7*n;o=e.l+i;var f=(c.f||Jr)(e,i,t);e.l=o;if(r(f,c.n,l))return}}function Zr(){var e=[],r=w?256:2048;var t=function o(e){var r=qr(e);Yr(r,0);return r};var a=t(r);var n=function c(){if(!a)return;if(a.length>a.l){a=a.slice(0,a.l);a.l=a.length}if(a.length>0)e.push(a);a=null};var i=function f(e){if(a&&e<a.length-a.l)return a;n();return a=t(Math.max(e+1,r))};var s=function u(){n();return mr([e])};var l=function h(e){n();a=e;if(a.l==null)a.l=a.length;i(r)};return{next:i,push:l,end:s,_bufs:e}}function Qr(e,r,t,a){var n=+XLSBRE[r],i;if(isNaN(n))return;if(!a)a=XLSBRecordEnum[n].p||(t||[]).length||0;i=1+(n>=128?1:0)+1;if(a>=128)++i;if(a>=16384)++i;if(a>=2097152)++i;var s=e.next(i);if(n<=127)s._W(1,n);else{s._W(1,(n&127)+128);s._W(1,n>>7)}for(var l=0;l!=4;++l){if(a>=128){s._W(1,(a&127)+128);a>>=7}else{s._W(1,a);break}}if(a>0&&Pr(t))e.push(t)}function et(e,r,t){var a=fe(e);if(r.s){if(a.cRel)a.c+=r.s.c;if(a.rRel)a.r+=r.s.r}else{if(a.cRel)a.c+=r.c;if(a.rRel)a.r+=r.r}if(!t||t.biff<12){while(a.c>=256)a.c-=256;while(a.r>=65536)a.r-=65536}return a}function rt(e,r,t){var a=fe(e);a.s=et(a.s,r.s,t);a.e=et(a.e,r.s,t);return a}function tt(e,r){if(e.cRel&&e.c<0){e=fe(e);while(e.c<0)e.c+=r>8?16384:256}if(e.rRel&&e.r<0){e=fe(e);while(e.r<0)e.r+=r>8?1048576:r>5?65536:16384}var t=pt(e);if(!e.cRel&&e.cRel!=null)t=ft(t);if(!e.rRel&&e.rRel!=null)t=st(t);return t}function at(e,r){if(e.s.r==0&&!e.s.rRel){if(e.e.r==(r.biff>=12?1048575:r.biff>=8?65536:16384)&&!e.e.rRel){return(e.s.cRel?"":"$")+ct(e.s.c)+":"+(e.e.cRel?"":"$")+ct(e.e.c)}}if(e.s.c==0&&!e.s.cRel){if(e.e.c==(r.biff>=12?16383:255)&&!e.e.cRel){return(e.s.rRel?"":"$")+it(e.s.r)+":"+(e.e.rRel?"":"$")+it(e.e.r)}}return tt(e.s,r.biff)+":"+tt(e.e,r.biff)}function nt(e){return parseInt(lt(e),10)-1}function it(e){return""+(e+1)}function st(e){return e.replace(/([A-Z]|^)(\d+)$/,"$1$$$2")}function lt(e){return e.replace(/\$(\d+)$/,"$1")}function ot(e){var r=ut(e),t=0,a=0;for(;a!==r.length;++a)t=26*t+r.charCodeAt(a)-64;return t-1}function ct(e){if(e<0)throw new Error("invalid column "+e);var r="";for(++e;e;e=Math.floor((e-1)/26))r=String.fromCharCode((e-1)%26+65)+r;return r}function ft(e){return e.replace(/^([A-Z])/,"$$$1")}function ut(e){return e.replace(/^\$([A-Z])/,"$1")}function ht(e){return e.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",")}function dt(e){var r=0,t=0;for(var a=0;a<e.length;++a){var n=e.charCodeAt(a);if(n>=48&&n<=57)r=10*r+(n-48);else if(n>=65&&n<=90)t=26*t+(n-64)}return{c:t-1,r:r-1}}function pt(e){var r=e.c+1;var t="";for(;r;r=(r-1)/26|0)t=String.fromCharCode((r-1)%26+65)+t;return t+(e.r+1)}function mt(e){var r=e.indexOf(":");if(r==-1)return{s:dt(e),e:dt(e)};return{s:dt(e.slice(0,r)),e:dt(e.slice(r+1))}}function vt(e,r){if(typeof r==="undefined"||typeof r==="number"){return vt(e.s,e.e)}if(typeof e!=="string")e=pt(e);if(typeof r!=="string")r=pt(r);return e==r?e:e+":"+r}function gt(e){var r={s:{c:0,r:0},e:{c:0,r:0}};var t=0,a=0,n=0;var i=e.length;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.s.c=--t;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.s.r=--t;if(a===i||e.charCodeAt(++a)===58){r.e.c=r.s.c;r.e.r=r.s.r;return r}for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.e.c=--t;for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.e.r=--t;return r}function bt(e,r){var t=e.t=="d"&&r instanceof Date;if(e.z!=null)try{return e.w=N.format(e.z,t?ee(r):r)}catch(a){}try{return e.w=N.format((e.XF||{}).numFmtId||(t?14:0),t?ee(r):r)}catch(a){return""+r}}function wt(e,r,t){if(e==null||e.t==null||e.t=="z")return"";if(e.w!==undefined)return e.w;if(e.t=="d"&&!e.z&&t&&t.dateNF)e.z=t.dateNF;if(r==undefined)return bt(e,e.v);return bt(e,r)}function kt(e,r){var t=r&&r.sheet?r.sheet:"Sheet1";var a={};a[t]=e;return{SheetNames:[t],Sheets:a}}function yt(e,r,t){var a=t||{};var n=e?Array.isArray(e):a.dense;if(v!=null&&n==null)n=v;var i=e||(n?[]:{});var s=0,l=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var o=typeof a.origin=="string"?dt(a.origin):a.origin;s=o.r;l=o.c}if(!i["!ref"])i["!ref"]="A1:A1"}var c={s:{c:1e7,r:1e7},e:{c:0,r:0}};if(i["!ref"]){var f=gt(i["!ref"]);c.s.c=f.s.c;c.s.r=f.s.r;c.e.c=Math.max(c.e.c,f.e.c);c.e.r=Math.max(c.e.r,f.e.r);if(s==-1)c.e.r=s=f.e.r+1}for(var u=0;u!=r.length;++u){if(!r[u])continue;if(!Array.isArray(r[u]))throw new Error("aoa_to_sheet expects an array of arrays");for(var h=0;h!=r[u].length;++h){if(typeof r[u][h]==="undefined")continue;var d={v:r[u][h]};var p=s+u,m=l+h;if(c.s.r>p)c.s.r=p;if(c.s.c>m)c.s.c=m;if(c.e.r<p)c.e.r=p;if(c.e.c<m)c.e.c=m;if(r[u][h]&&typeof r[u][h]==="object"&&!Array.isArray(r[u][h])&&!(r[u][h]instanceof Date))d=r[u][h];else{if(Array.isArray(d.v)){d.f=r[u][h][1];d.v=d.v[0]}if(d.v===null){if(d.f)d.t="n";else if(!a.sheetStubs)continue;else d.t="z"}else if(typeof d.v==="number")d.t="n";else if(typeof d.v==="boolean")d.t="b";else if(d.v instanceof Date){d.z=a.dateNF||N._table[14];if(a.cellDates){d.t="d";d.w=N.format(d.z,ee(d.v))}else{d.t="n";d.v=ee(d.v);d.w=N.format(d.z,d.v)}}else d.t="s"}if(n){if(!i[p])i[p]=[];if(i[p][m]&&i[p][m].z)d.z=i[p][m].z;i[p][m]=d}else{var g=pt({c:m,r:p});if(i[g]&&i[g].z)d.z=i[g].z;i[g]=d}}}if(c.s.c<1e7)i["!ref"]=vt(c);return i}function xt(e,r){return yt(null,e,r)}var _t=2;var St=3;var Ct=11;var At=12;var Et=19;var Ft=30;var Tt=64;var Ot=65;var Dt=71;var Mt=4096;var Nt=80;var Rt=81;var Pt=[Nt,Rt];var It={1:{n:"CodePage",t:_t},2:{n:"Category",t:Nt},3:{n:"PresentationFormat",t:Nt},4:{n:"ByteCount",t:St},5:{n:"LineCount",t:St},6:{n:"ParagraphCount",t:St},7:{n:"SlideCount",t:St},8:{n:"NoteCount",t:St},9:{n:"HiddenCount",t:St},10:{n:"MultimediaClipCount",t:St},11:{n:"ScaleCrop",t:Ct},12:{n:"HeadingPairs",t:Mt|At},13:{n:"TitlesOfParts",t:Mt|Ft},14:{n:"Manager",t:Nt},15:{n:"Company",t:Nt},16:{n:"LinksUpToDate",t:Ct},17:{n:"CharacterCount",t:St},19:{n:"SharedDoc",t:Ct},22:{n:"HyperlinksChanged",t:Ct},23:{n:"AppVersion",t:St,p:"version"},24:{n:"DigSig",t:Ot},26:{n:"ContentType",t:Nt},27:{n:"ContentStatus",t:Nt},28:{n:"Language",t:Nt},29:{n:"Version",t:Nt},255:{}};var Lt={1:{n:"CodePage",t:_t},2:{n:"Title",t:Nt},3:{n:"Subject",t:Nt},4:{n:"Author",t:Nt},5:{n:"Keywords",t:Nt},6:{n:"Comments",t:Nt},7:{n:"Template",t:Nt},8:{n:"LastAuthor",t:Nt},9:{n:"RevNumber",t:Nt},10:{n:"EditTime",t:Tt},11:{n:"LastPrinted",t:Tt},12:{n:"CreatedDate",t:Tt},13:{n:"ModifiedDate",t:Tt},14:{n:"PageCount",t:St},15:{n:"WordCount",t:St},16:{n:"CharCount",t:St},17:{n:"Thumbnail",t:Dt},18:{n:"Application",t:Nt},19:{n:"DocSecurity",t:St},255:{}};var zt={2147483648:{n:"Locale",t:Et},2147483651:{n:"Behavior",t:Et},1919054434:{}};(function(){for(var e in zt)if(Object.prototype.hasOwnProperty.call(zt,e))It[e]=Lt[e]=zt[e]})();var Bt=J(It,"n");var Wt=J(Lt,"n");var $t={1:"US",2:"CA",3:"",7:"RU",20:"EG",30:"GR",31:"NL",32:"BE",33:"FR",34:"ES",36:"HU",39:"IT",41:"CH",43:"AT",44:"GB",45:"DK",46:"SE",47:"NO",48:"PL",49:"DE",52:"MX",55:"BR",61:"AU",64:"NZ",66:"TH",81:"JP",82:"KR",84:"VN",86:"CN",90:"TR",105:"JS",213:"DZ",216:"MA",218:"LY",351:"PT",354:"IS",358:"FI",420:"CZ",886:"TW",961:"LB",962:"JO",963:"SY",964:"IQ",965:"KW",966:"SA",971:"AE",972:"IL",974:"QA",981:"IR",65535:"US"};var Ut=[null,"solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];function jt(e){return e.map(function(e){return[e>>16&255,e>>8&255,e&255]})}var Ht=jt([0,16777215,16711680,65280,255,16776960,16711935,65535,0,16777215,16711680,65280,255,16776960,16711935,65535,8388608,32768,128,8421376,8388736,32896,12632256,8421504,10066431,10040166,16777164,13434879,6684774,16744576,26316,13421823,128,16711935,16776960,65535,8388736,8388608,32896,255,52479,13434879,13434828,16777113,10079487,16751052,13408767,16764057,3368703,3394764,10079232,16763904,16750848,16737792,6710937,9868950,13158,3381606,13056,3355392,10040064,10040166,3355545,3355443,16777215,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);var Vt=fe(Ht);var Xt={0:"#NULL!",7:"#DIV/0!",15:"#VALUE!",23:"#REF!",29:"#NAME?",36:"#NUM!",42:"#N/A",43:"#GETTING_DATA",255:"#WTF?"};var Gt=K(Xt);var Yt={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.ms-office.chartcolorstyle+xml":"TODO","application/vnd.ms-office.chartstyle+xml":"TODO","application/vnd.ms-office.chartex+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links","application/vnd.ms-excel.sheetMetadata":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"TODO","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"vba","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO","image/png":"TODO",sheet:"js"};var Jt=function(){var e={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};Y(e).forEach(function(r){["xlsm","xlam"].forEach(function(t){if(!e[r][t])e[r][t]=e[r].xlsx})});Y(e).forEach(function(r){Y(e[r]).forEach(function(t){Yt[e[r][t]]=r})});return e}();var qt=Z(Yt);ur.CT="http://schemas.openxmlformats.org/package/2006/content-types";function Kt(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],TODO:[],xmlns:""}}function Zt(e){var r=Kt();if(!e||!e.match)return r;var t={};(e.match(Oe)||[]).forEach(function(e){var a=Ne(e);switch(a[0].replace(De,"<")){case"<?xml":break;case"<Types":r.xmlns=a["xmlns"+(a[0].match(/<(\w+):/)||["",""])[1]];break;case"<Default":t[a.Extension]=a.ContentType;break;case"<Override":if(r[Yt[a.ContentType]]!==undefined)r[Yt[a.ContentType]].push(a.PartName);break;}});if(r.xmlns!==ur.CT)throw new Error("Unknown Namespace: "+r.xmlns);r.calcchain=r.calcchains.length>0?r.calcchains[0]:"";r.sst=r.strs.length>0?r.strs[0]:"";r.style=r.styles.length>0?r.styles[0]:"";r.defaults=t;delete r.calcchains;return r}var Qt=or("Types",null,{xmlns:ur.CT,"xmlns:xsd":ur.xsd,"xmlns:xsi":ur.xsi});var ea=[["xml","application/xml"],["bin","application/vnd.ms-excel.sheet.binary.macroEnabled.main"],["vml","application/vnd.openxmlformats-officedocument.vmlDrawing"],["data","application/vnd.openxmlformats-officedocument.model+data"],["bmp","image/bmp"],["png","image/png"],["gif","image/gif"],["emf","image/x-emf"],["wmf","image/x-wmf"],["jpg","image/jpeg"],["jpeg","image/jpeg"],["tif","image/tiff"],["tiff","image/tiff"],["pdf","application/pdf"],["rels",qt.rels[0]]].map(function(e){return or("Default",null,{Extension:e[0],ContentType:e[1]})});function ra(e,r){var t=[],a;t[t.length]=Fe;t[t.length]=Qt;t=t.concat(ea);var n=function(n){if(e[n]&&e[n].length>0){a=e[n][0];t[t.length]=or("Override",null,{PartName:(a[0]=="/"?"":"/")+a,ContentType:Jt[n][r.bookType||"xlsx"]})}};var i=function(a){(e[a]||[]).forEach(function(e){t[t.length]=or("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:Jt[a][r.bookType||"xlsx"]})})};var s=function(r){(e[r]||[]).forEach(function(e){t[t.length]=or("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:qt[r][0]})})};n("workbooks");i("sheets");i("charts");s("themes");["strs","styles"].forEach(n);["coreprops","extprops","custprops"].forEach(s);s("vba");s("comments");s("drawings");if(t.length>2){t[t.length]="</Types>";t[1]=t[1].replace("/>",">")}return t.join("")}var ta={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};function aa(e){var r=e.lastIndexOf("/");return e.slice(0,r+1)+"_rels/"+e.slice(r+1)+".rels"}function na(e,r){var t={"!id":{}};if(!e)return t;if(r.charAt(0)!=="/"){r="/"+r}var a={};(e.match(Oe)||[]).forEach(function(e){var n=Ne(e);if(n[0]==="<Relationship"){var i={};i.Type=n.Type;i.Target=n.Target;i.Id=n.Id;i.TargetMode=n.TargetMode;var s=n.TargetMode==="External"?n.Target:Ee(n.Target,r);t[s]=i;a[n.Id]=i}});t["!id"]=a;return t}ur.RELS="http://schemas.openxmlformats.org/package/2006/relationships";var ia=or("Relationships",null,{xmlns:ur.RELS});function sa(e){var r=[Fe,ia];Y(e["!id"]).forEach(function(t){r[r.length]=or("Relationship",null,e["!id"][t])});if(r.length>2){r[r.length]="</Relationships>";r[1]=r[1].replace("/>",">")}return r.join("")}var la=[ta.HLINK,ta.XPATH,ta.XMISS];function oa(e,r,t,a,n,i){if(!n)n={};if(!e["!id"])e["!id"]={};if(r<0)for(r=1;e["!id"]["rId"+r];++r){}n.Id="rId"+r;n.Type=a;n.Target=t;if(i)n.TargetMode=i;else if(la.indexOf(n.Type)>-1)n.TargetMode="External";if(e["!id"][n.Id])throw new Error("Cannot rewrite rId "+r);e["!id"][n.Id]=n;e[("/"+n.Target).replace("//","/")]=n;return r}var ca=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate","date"],["dcterms:modified","ModifiedDate","date"]];ur.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/metadata/core-properties";ta.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";var fa=function(){var e=new Array(ca.length);for(var r=0;r<ca.length;++r){var t=ca[r];var a="(?:"+t[0].slice(0,t[0].indexOf(":"))+":)"+t[0].slice(t[0].indexOf(":")+1);e[r]=new RegExp("<"+a+"[^>]*>([\\s\\S]*?)</"+a+">")}return e}();function ua(e){var r={};e=Ye(e);for(var t=0;t<ca.length;++t){var a=ca[t],n=e.match(fa[t]);if(n!=null&&n.length>0)r[a[1]]=Le(n[1]);if(a[2]==="date"&&r[a[1]])r[a[1]]=oe(r[a[1]])}return r}var ha=or("cp:coreProperties",null,{"xmlns:cp":ur.CORE_PROPS,"xmlns:dc":ur.dc,"xmlns:dcterms":ur.dcterms,"xmlns:dcmitype":ur.dcmitype,"xmlns:xsi":ur.xsi});function da(e,r,t,a,n){if(n[e]!=null||r==null||r==="")return;n[e]=r;r=We(r);a[a.length]=t?or(e,r,t):sr(e,r)}function pa(e,r){var t=r||{};var a=[Fe,ha],n={};if(!e&&!t.Props)return a.join("");if(e){if(e.CreatedDate!=null)da("dcterms:created",typeof e.CreatedDate==="string"?e.CreatedDate:cr(e.CreatedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n);if(e.ModifiedDate!=null)da("dcterms:modified",typeof e.ModifiedDate==="string"?e.ModifiedDate:cr(e.ModifiedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n)}for(var i=0;i!=ca.length;++i){var s=ca[i];var l=t.Props&&t.Props[s[1]]!=null?t.Props[s[1]]:e?e[s[1]]:null;if(l===true)l="1";else if(l===false)l="0";else if(typeof l=="number")l=String(l);if(l!=null)da(s[0],l,null,a,n)}if(a.length>2){a[a.length]="</cp:coreProperties>";a[1]=a[1].replace("/>",">")}return a.join("")}var ma=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];
ur.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";ta.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";var va=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function ga(e,r,t,a){var n=[];if(typeof e=="string")n=nr(e,a);else for(var i=0;i<e.length;++i)n=n.concat(e[i].map(function(e){return{v:e}}));var s=typeof r=="string"?nr(r,a).map(function(e){return e.v}):r;var l=0,o=0;if(s.length>0)for(var c=0;c!==n.length;c+=2){o=+n[c+1].v;switch(n[c].v){case"Worksheets":;case"工作表":;case"Листы":;case"أوراق العمل":;case"ワークシート":;case"גליונות עבודה":;case"Arbeitsblätter":;case"Çalışma Sayfaları":;case"Feuilles de calcul":;case"Fogli di lavoro":;case"Folhas de cálculo":;case"Planilhas":;case"Regneark":;case"Hojas de cálculo":;case"Werkbladen":t.Worksheets=o;t.SheetNames=s.slice(l,l+o);break;case"Named Ranges":;case"Rangos con nombre":;case"名前付き一覧":;case"Benannte Bereiche":;case"Navngivne områder":t.NamedRanges=o;t.DefinedNames=s.slice(l,l+o);break;case"Charts":;case"Diagramme":t.Chartsheets=o;t.ChartNames=s.slice(l,l+o);break;}l+=o}}function ba(e,r,t){var a={};if(!r)r={};e=Ye(e);ma.forEach(function(t){var n=(e.match(Qe(t[0]))||[])[1];switch(t[2]){case"string":if(n)r[t[1]]=Le(n);break;case"bool":r[t[1]]=n==="true";break;case"raw":var i=e.match(new RegExp("<"+t[0]+"[^>]*>([\\s\\S]*?)</"+t[0]+">"));if(i&&i.length>0)a[t[1]]=i[1];break;}});if(a.HeadingPairs&&a.TitlesOfParts)ga(a.HeadingPairs,a.TitlesOfParts,r,t);return r}var wa=or("Properties",null,{xmlns:ur.EXT_PROPS,"xmlns:vt":ur.vt});function ka(e){var r=[],t=or;if(!e)e={};e.Application="SheetJS";r[r.length]=Fe;r[r.length]=wa;ma.forEach(function(a){if(e[a[1]]===undefined)return;var n;switch(a[2]){case"string":n=We(String(e[a[1]]));break;case"bool":n=e[a[1]]?"true":"false";break;}if(n!==undefined)r[r.length]=t(a[0],n)});r[r.length]=t("HeadingPairs",t("vt:vector",t("vt:variant","<vt:lpstr>Worksheets</vt:lpstr>")+t("vt:variant",t("vt:i4",String(e.Worksheets))),{size:2,baseType:"variant"}));r[r.length]=t("TitlesOfParts",t("vt:vector",e.SheetNames.map(function(e){return"<vt:lpstr>"+We(e)+"</vt:lpstr>"}).join(""),{size:e.Worksheets,baseType:"lpstr"}));if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}ur.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";ta.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";var ya=/<[^>]+>[^<]*/g;function xa(e,r){var t={},a="";var n=e.match(ya);if(n)for(var i=0;i!=n.length;++i){var s=n[i],l=Ne(s);switch(l[0]){case"<?xml":break;case"<Properties":break;case"<property":a=Le(l.name);break;case"</property>":a=null;break;default:if(s.indexOf("<vt:")===0){var o=s.split(">");var c=o[0].slice(4),f=o[1];switch(c){case"lpstr":;case"bstr":;case"lpwstr":t[a]=Le(f);break;case"bool":t[a]=Ge(f);break;case"i1":;case"i2":;case"i4":;case"i8":;case"int":;case"uint":t[a]=parseInt(f,10);break;case"r4":;case"r8":;case"decimal":t[a]=parseFloat(f);break;case"filetime":;case"date":t[a]=oe(f);break;case"cy":;case"error":t[a]=Le(f);break;default:if(c.slice(-1)=="/")break;if(r.WTF&&typeof console!=="undefined")console.warn("Unexpected",s,c,o);}}else if(s.slice(0,2)==="</"){}else if(r.WTF)throw new Error(s);}}return t}var _a=or("Properties",null,{xmlns:ur.CUST_PROPS,"xmlns:vt":ur.vt});function Sa(e){var r=[Fe,_a];if(!e)return r.join("");var t=1;Y(e).forEach(function a(n){++t;r[r.length]=or("property",fr(e[n],true),{fmtid:"{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",pid:t,name:We(n)})});if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}var Ca=function(){var e={1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127,8:865,9:437,10:850,11:437,13:437,14:850,15:437,16:850,17:437,18:850,19:932,20:850,21:437,22:850,23:865,24:437,25:437,26:850,27:437,28:863,29:850,31:852,34:852,35:852,36:860,37:850,38:866,55:850,64:852,77:936,78:949,79:950,80:874,87:1252,88:1252,89:1252,255:16969};var r=q({1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127});var a=[2,3,48,49,131,139,140,245];function n(r,t){var a=[];var n=_(1);switch(t.type){case"base64":n=C(b.decode(r));break;case"binary":n=C(r);break;case"buffer":;case"array":n=r;break;}Yr(n,0);var i=n._R(1);var s=false;var l=false,o=false;switch(i){case 2:;case 3:break;case 48:l=true;s=true;break;case 49:l=true;break;case 131:s=true;break;case 139:s=true;break;case 140:s=true;o=true;break;case 245:s=true;break;default:throw new Error("DBF Unsupported Version: "+i.toString(16));}var c=0,f=0;if(i==2)c=n._R(2);n.l+=3;if(i!=2)c=n._R(4);if(c>1048576)c=1e6;if(i!=2)f=n._R(2);var u=n._R(2);var h=1252;if(i!=2){n.l+=16;n._R(1);if(n[n.l]!==0)h=e[n[n.l]];n.l+=1;n.l+=2}if(o)n.l+=36;var d=[],p={};var m=f-10-(l?264:0),v=o?32:11;while(i==2?n.l<n.length&&n[n.l]!=13:n.l<m){p={};p.name=cptable.utils.decode(h,n.slice(n.l,n.l+v)).replace(/[\u0000\r\n].*$/g,"");n.l+=v;p.type=String.fromCharCode(n._R(1));if(i!=2&&!o)p.offset=n._R(4);p.len=n._R(1);if(i==2)p.offset=n._R(2);p.dec=n._R(1);if(p.name.length)d.push(p);if(i!=2)n.l+=o?13:14;switch(p.type){case"B":if((!l||p.len!=8)&&t.WTF)console.log("Skipping "+p.name+":"+p.type);break;case"G":;case"P":if(t.WTF)console.log("Skipping "+p.name+":"+p.type);break;case"C":;case"D":;case"F":;case"I":;case"L":;case"M":;case"N":;case"O":;case"T":;case"Y":;case"0":;case"@":;case"+":break;default:throw new Error("Unknown Field Type: "+p.type);}}if(n[n.l]!==13)n.l=f-1;else if(i==2)n.l=521;if(i!=2){if(n._R(1)!==13)throw new Error("DBF Terminator not found "+n.l+" "+n[n.l]);n.l=f}var g=0,w=0;a[0]=[];for(w=0;w!=d.length;++w)a[0][w]=d[w].name;while(c-- >0){if(n[n.l]===42){n.l+=u;continue}++n.l;a[++g]=[];w=0;for(w=0;w!=d.length;++w){var k=n.slice(n.l,n.l+d[w].len);n.l+=d[w].len;Yr(k,0);var y=cptable.utils.decode(h,k);switch(d[w].type){case"C":a[g][w]=cptable.utils.decode(h,k);a[g][w]=a[g][w].trim();break;case"D":if(y.length===8)a[g][w]=new Date(+y.slice(0,4),+y.slice(4,6)-1,+y.slice(6,8));else a[g][w]=y;break;case"F":a[g][w]=parseFloat(y.trim());break;case"+":;case"I":a[g][w]=o?k._R(-4,"i")^2147483648:k._R(4,"i");break;case"L":switch(y.toUpperCase()){case"Y":;case"T":a[g][w]=true;break;case"N":;case"F":a[g][w]=false;break;case" ":;case"?":a[g][w]=false;break;default:throw new Error("DBF Unrecognized L:|"+y+"|");}break;case"M":if(!s)throw new Error("DBF Unexpected MEMO for type "+i.toString(16));a[g][w]="##MEMO##"+(o?parseInt(y.trim(),10):k._R(4));break;case"N":a[g][w]=+y.replace(/\u0000/g,"").trim();break;case"@":a[g][w]=new Date(k._R(-8,"f")-621356832e5);break;case"T":a[g][w]=new Date((k._R(4)-2440588)*864e5+k._R(4));break;case"Y":a[g][w]=k._R(4,"i")/1e4;break;case"O":a[g][w]=-k._R(-8,"f");break;case"B":if(l&&d[w].len==8){a[g][w]=k._R(8,"f");break};case"G":;case"P":k.l+=d[w].len;break;case"0":if(d[w].name==="_NullFlags")break;default:throw new Error("DBF Unsupported data type "+d[w].type);}}}if(i!=2)if(n.l<n.length&&n[n.l++]!=26)throw new Error("DBF EOF Marker missing "+(n.l-1)+" of "+n.length+" "+n[n.l-1].toString(16));if(t&&t.sheetRows)a=a.slice(0,t.sheetRows);return a}function i(e,r){var t=r||{};if(!t.dateNF)t.dateNF="yyyymmdd";return xt(n(e,t),t)}function s(e,r){try{return kt(i(e,r),r)}catch(t){if(r&&r.WTF)throw t}return{SheetNames:[],Sheets:{}}}var l={B:8,C:250,L:1,D:8,"?":0,"":0};function c(e,a){var n=a||{};if(+n.codepage>=0)o(+n.codepage);if(n.type=="string")throw new Error("Cannot write DBF to JS string");var i=Zr();var s=Ml(e,{header:1,raw:true,cellDates:true});var c=s[0],f=s.slice(1);var u=0,h=0,d=0,p=1;for(u=0;u<c.length;++u){if(u==null)continue;++d;if(typeof c[u]==="number")c[u]=c[u].toString(10);if(typeof c[u]!=="string")throw new Error("DBF Invalid column name "+c[u]+" |"+typeof c[u]+"|");if(c.indexOf(c[u])!==u)for(h=0;h<1024;++h)if(c.indexOf(c[u]+"_"+h)==-1){c[u]+="_"+h;break}}var m=gt(e["!ref"]);var v=[];for(u=0;u<=m.e.c-m.s.c;++u){var g=[];for(h=0;h<f.length;++h){if(f[h][u]!=null)g.push(f[h][u])}if(g.length==0||c[u]==null){v[u]="?";continue}var b="",w="";for(h=0;h<g.length;++h){switch(typeof g[h]){case"number":w="B";break;case"string":w="C";break;case"boolean":w="L";break;case"object":w=g[h]instanceof Date?"D":"C";break;default:w="C";}b=b&&b!=w?"C":w;if(b=="C")break}p+=l[b]||0;v[u]=b}var k=i.next(32);k._W(4,318902576);k._W(4,f.length);k._W(2,296+32*d);k._W(2,p);for(u=0;u<4;++u)k._W(4,0);k._W(4,0|(+r[t]||3)<<8);for(u=0,h=0;u<c.length;++u){if(c[u]==null)continue;var y=i.next(32);var x=(c[u].slice(-10)+"\0\0\0\0\0\0\0\0\0\0\0").slice(0,11);y._W(1,x,"sbcs");y._W(1,v[u]=="?"?"C":v[u],"sbcs");y._W(4,h);y._W(1,l[v[u]]||0);y._W(1,0);y._W(1,2);y._W(4,0);y._W(1,0);y._W(4,0);y._W(4,0);h+=l[v[u]]||0}var _=i.next(264);_._W(4,13);for(u=0;u<65;++u)_._W(4,0);for(u=0;u<f.length;++u){var S=i.next(p);S._W(1,0);for(h=0;h<c.length;++h){if(c[h]==null)continue;switch(v[h]){case"L":S._W(1,f[u][h]==null?63:f[u][h]?84:70);break;case"B":S._W(8,f[u][h]||0,"f");break;case"D":if(!f[u][h])S._W(8,"00000000","sbcs");else{S._W(4,("0000"+f[u][h].getFullYear()).slice(-4),"sbcs");S._W(2,("00"+(f[u][h].getMonth()+1)).slice(-2),"sbcs");S._W(2,("00"+f[u][h].getDate()).slice(-2),"sbcs")}break;case"C":var C=String(f[u][h]||"");S._W(1,C,"sbcs");for(d=0;d<250-C.length;++d)S._W(1,32);break;}}}i.next(1)._W(1,26);return i.end()}return{versions:a,to_workbook:s,to_sheet:i,from_sheet:c}}();var Aa=function(){var e={AA:"À",BA:"Á",CA:"Â",DA:195,HA:"Ä",JA:197,AE:"È",BE:"É",CE:"Ê",HE:"Ë",AI:"Ì",BI:"Í",CI:"Î",HI:"Ï",AO:"Ò",BO:"Ó",CO:"Ô",DO:213,HO:"Ö",AU:"Ù",BU:"Ú",CU:"Û",HU:"Ü",Aa:"à",Ba:"á",Ca:"â",Da:227,Ha:"ä",Ja:229,Ae:"è",Be:"é",Ce:"ê",He:"ë",Ai:"ì",Bi:"í",Ci:"î",Hi:"ï",Ao:"ò",Bo:"ó",Co:"ô",Do:245,Ho:"ö",Au:"ù",Bu:"ú",Cu:"û",Hu:"ü",KC:"Ç",Kc:"ç",q:"æ",z:"œ",a:"Æ",j:"Œ",DN:209,Dn:241,Hy:255,S:169,c:170,R:174,B:180,0:176,1:177,2:178,3:179,5:181,6:182,7:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223};var r=new RegExp("N("+Y(e).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm");var t=function(r,t){var a=e[t];return typeof a=="number"?m(a):a};var a=function(e,r,t){var a=r.charCodeAt(0)-32<<4|t.charCodeAt(0)-48;return a==59?e:m(a)};e["|"]=254;function n(e,r){switch(r.type){case"base64":return i(b.decode(e),r);case"binary":return i(e,r);case"buffer":return i(e.toString("binary"),r);case"array":return i(ce(e),r);}throw new Error("Unrecognized type "+r.type)}function i(e,n){var i=e.split(/[\n\r]+/),s=-1,l=-1,c=0,f=0,u=[];var h=[];var d=null;var p={},m=[],v=[],g=[];var b=0,w;if(+n.codepage>=0)o(+n.codepage);for(;c!==i.length;++c){b=0;var k=i[c].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,a).replace(r,t);var y=k.replace(/;;/g,"\0").split(";").map(function(e){return e.replace(/\u0000/g,";")});var x=y[0],_;if(k.length>0)switch(x){case"ID":break;case"E":break;case"B":break;case"O":break;case"P":if(y[1].charAt(0)=="P")h.push(k.slice(3).replace(/;;/g,";"));break;case"C":var S=false,C=false;for(f=1;f<y.length;++f)switch(y[f].charAt(0)){case"X":l=parseInt(y[f].slice(1))-1;C=true;break;case"Y":s=parseInt(y[f].slice(1))-1;if(!C)l=0;for(w=u.length;w<=s;++w)u[w]=[];break;case"K":_=y[f].slice(1);if(_.charAt(0)==='"')_=_.slice(1,_.length-1);else if(_==="TRUE")_=true;else if(_==="FALSE")_=false;else if(!isNaN(he(_))){_=he(_);if(d!==null&&N.is_date(d))_=ne(_)}else if(!isNaN(de(_).getDate())){_=oe(_)}if(typeof cptable!=="undefined"&&typeof _=="string"&&(n||{}).type!="string"&&(n||{}).codepage)_=cptable.utils.decode(n.codepage,_);S=true;break;case"E":var A=Kn(y[f].slice(1),{r:s,c:l});u[s][l]=[u[s][l],A];break;default:if(n&&n.WTF)throw new Error("SYLK bad record "+k);}if(S){u[s][l]=_;d=null}break;case"F":var E=0;for(f=1;f<y.length;++f)switch(y[f].charAt(0)){case"X":l=parseInt(y[f].slice(1))-1;++E;break;case"Y":s=parseInt(y[f].slice(1))-1;for(w=u.length;w<=s;++w)u[w]=[];break;case"M":b=parseInt(y[f].slice(1))/20;break;case"F":break;case"G":break;case"P":d=h[parseInt(y[f].slice(1))];break;case"S":break;case"D":break;case"N":break;case"W":g=y[f].slice(1).split(" ");for(w=parseInt(g[0],10);w<=parseInt(g[1],10);++w){b=parseInt(g[2],10);v[w-1]=b===0?{hidden:true}:{wch:b};nn(v[w-1])}break;case"C":l=parseInt(y[f].slice(1))-1;if(!v[l])v[l]={};break;case"R":s=parseInt(y[f].slice(1))-1;if(!m[s])m[s]={};if(b>0){m[s].hpt=b;m[s].hpx=cn(b)}else if(b===0)m[s].hidden=true;break;default:if(n&&n.WTF)throw new Error("SYLK bad record "+k);}if(E<1)d=null;break;default:if(n&&n.WTF)throw new Error("SYLK bad record "+k);}}if(m.length>0)p["!rows"]=m;if(v.length>0)p["!cols"]=v;if(n&&n.sheetRows)u=u.slice(0,n.sheetRows);return[u,p]}function s(e,r){var t=n(e,r);var a=t[0],i=t[1];var s=xt(a,r);Y(i).forEach(function(e){s[e]=i[e]});return s}function l(e,r){return kt(s(e,r),r)}function c(e,r,t,a){var n="C;Y"+(t+1)+";X"+(a+1)+";K";switch(e.t){case"n":n+=e.v||0;if(e.f&&!e.F)n+=";E"+Qn(e.f,{r:t,c:a});break;case"b":n+=e.v?"TRUE":"FALSE";break;case"e":n+=e.w||e.v;break;case"d":n+='"'+(e.w||e.v)+'"';break;case"s":n+='"'+e.v.replace(/"/g,"")+'"';break;}return n}function f(e,r){r.forEach(function(r,t){var a="F;W"+(t+1)+" "+(t+1)+" ";if(r.hidden)a+="0";else{if(typeof r.width=="number")r.wpx=Qa(r.width);if(typeof r.wpx=="number")r.wch=en(r.wpx);if(typeof r.wch=="number")a+=Math.round(r.wch)}if(a.charAt(a.length-1)!=" ")e.push(a)})}function u(e,r){r.forEach(function(r,t){var a="F;";if(r.hidden)a+="M0;";else if(r.hpt)a+="M"+20*r.hpt+";";else if(r.hpx)a+="M"+20*on(r.hpx)+";";if(a.length>2)e.push(a+"R"+(t+1))})}function h(e,r){var t=["ID;PWXL;N;E"],a=[];var n=gt(e["!ref"]),i;var s=Array.isArray(e);var l="\r\n";t.push("P;PGeneral");t.push("F;P0;DG0G8;M255");if(e["!cols"])f(t,e["!cols"]);if(e["!rows"])u(t,e["!rows"]);t.push("B;Y"+(n.e.r-n.s.r+1)+";X"+(n.e.c-n.s.c+1)+";D"+[n.s.c,n.s.r,n.e.c,n.e.r].join(" "));for(var o=n.s.r;o<=n.e.r;++o){for(var h=n.s.c;h<=n.e.c;++h){var d=pt({r:o,c:h});i=s?(e[o]||[])[h]:e[d];if(!i||i.v==null&&(!i.f||i.F))continue;a.push(c(i,e,o,h,r))}}return t.join(l)+l+a.join(l)+l+"E"+l}return{to_workbook:l,to_sheet:s,from_sheet:h}}();var Ea=function(){function e(e,t){switch(t.type){case"base64":return r(b.decode(e),t);case"binary":return r(e,t);case"buffer":return r(e.toString("binary"),t);case"array":return r(ce(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=e.split("\n"),a=-1,n=-1,i=0,s=[];for(;i!==t.length;++i){if(t[i].trim()==="BOT"){s[++a]=[];n=0;continue}if(a<0)continue;var l=t[i].trim().split(",");var o=l[0],c=l[1];++i;var f=t[i].trim();switch(+o){case-1:if(f==="BOT"){s[++a]=[];n=0;continue}else if(f!=="EOD")throw new Error("Unrecognized DIF special command "+f);break;case 0:if(f==="TRUE")s[a][n]=true;else if(f==="FALSE")s[a][n]=false;else if(!isNaN(he(c)))s[a][n]=he(c);else if(!isNaN(de(c).getDate()))s[a][n]=oe(c);else s[a][n]=c;++n;break;case 1:f=f.slice(1,f.length-1);s[a][n++]=f!==""?f:null;break;}if(f==="EOD")break}if(r&&r.sheetRows)s=s.slice(0,r.sheetRows);return s}function t(r,t){return xt(e(r,t),t)}function a(e,r){return kt(t(e,r),r)}var n=function(){var e=function t(e,r,a,n,i){e.push(r);e.push(a+","+n);e.push('"'+i.replace(/"/g,'""')+'"')};var r=function a(e,r,t,n){e.push(r+","+t);e.push(r==1?'"'+n.replace(/"/g,'""')+'"':n)};return function n(t){var a=[];var n=gt(t["!ref"]),i;var s=Array.isArray(t);e(a,"TABLE",0,1,"sheetjs");e(a,"VECTORS",0,n.e.r-n.s.r+1,"");e(a,"TUPLES",0,n.e.c-n.s.c+1,"");e(a,"DATA",0,0,"");for(var l=n.s.r;l<=n.e.r;++l){r(a,-1,0,"BOT");for(var o=n.s.c;o<=n.e.c;++o){var c=pt({r:l,c:o});i=s?(t[l]||[])[o]:t[c];if(!i){r(a,1,0,"");continue}switch(i.t){case"n":var f=g?i.w:i.v;if(!f&&i.v!=null)f=i.v;if(f==null){if(g&&i.f&&!i.F)r(a,1,0,"="+i.f);else r(a,1,0,"")}else r(a,0,f,"V");break;case"b":r(a,0,i.v?1:0,i.v?"TRUE":"FALSE");break;case"s":r(a,1,0,!g||isNaN(i.v)?i.v:'="'+i.v+'"');break;case"d":if(!i.w)i.w=N.format(i.z||N._table[14],ee(oe(i.v)));if(g)r(a,0,i.w,"V");else r(a,1,0,i.w);break;default:r(a,1,0,"");}}}r(a,-1,0,"EOD");var u="\r\n";var h=a.join(u);return h}}();return{to_workbook:a,to_sheet:t,from_sheet:n}}();var Fa=function(){function e(e){return e.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n")}function r(e){return e.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n")}function t(r,t){var a=r.split("\n"),n=-1,i=-1,s=0,l=[];for(;s!==a.length;++s){var o=a[s].trim().split(":");if(o[0]!=="cell")continue;var c=dt(o[1]);if(l.length<=c.r)for(n=l.length;n<=c.r;++n)if(!l[n])l[n]=[];n=c.r;i=c.c;switch(o[2]){case"t":l[n][i]=e(o[3]);break;case"v":l[n][i]=+o[3];break;case"vtf":var f=o[o.length-1];case"vtc":switch(o[3]){case"nl":l[n][i]=+o[4]?true:false;break;default:l[n][i]=+o[4];break;}if(o[2]=="vtf")l[n][i]=[l[n][i],f];}}if(t&&t.sheetRows)l=l.slice(0,t.sheetRows);return l}function a(e,r){return xt(t(e,r),r)}function n(e,r){return kt(a(e,r),r)}var i=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var s=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";var l=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var o="--SocialCalcSpreadsheetControlSave--";function c(e){if(!e||!e["!ref"])return"";var t=[],a=[],n,i="";var s=mt(e["!ref"]);var l=Array.isArray(e);for(var o=s.s.r;o<=s.e.r;++o){for(var c=s.s.c;c<=s.e.c;++c){i=pt({r:o,c:c});n=l?(e[o]||[])[c]:e[i];if(!n||n.v==null||n.t==="z")continue;a=["cell",i,"t"];switch(n.t){case"s":;case"str":a.push(r(n.v));break;case"n":if(!n.f){a[2]="v";a[3]=n.v}else{a[2]="vtf";a[3]="n";a[4]=n.v;a[5]=r(n.f)}break;case"b":a[2]="vt"+(n.f?"f":"c");a[3]="nl";a[4]=n.v?"1":"0";a[5]=r(n.f||(n.v?"TRUE":"FALSE"));break;case"d":var f=ee(oe(n.v));a[2]="vtc";a[3]="nd";a[4]=""+f;a[5]=n.w||N.format(n.z||N._table[14],f);break;case"e":continue;}t.push(a.join(":"))}}t.push("sheet:c:"+(s.e.c-s.s.c+1)+":r:"+(s.e.r-s.s.r+1)+":tvf:1");t.push("valueformat:1:text-wiki");return t.join("\n")}function f(e){return[i,s,l,s,c(e),o].join("\n")}return{to_workbook:n,to_sheet:a,from_sheet:f}}();var Ta=function(){function e(e,r,t,a,n){if(n.raw)r[t][a]=e;else if(e==="TRUE")r[t][a]=true;else if(e==="FALSE")r[t][a]=false;else if(e===""){}else if(!isNaN(he(e)))r[t][a]=he(e);else if(!isNaN(de(e).getDate()))r[t][a]=oe(e);else r[t][a]=e}function r(r,t){var a=t||{};var n=[];if(!r||r.length===0)return n;var i=r.split(/[\r\n]/);var s=i.length-1;while(s>=0&&i[s].length===0)--s;var l=10,o=0;var c=0;for(;c<=s;++c){o=i[c].indexOf(" ");if(o==-1)o=i[c].length;else o++;l=Math.max(l,o)}for(c=0;c<=s;++c){n[c]=[];var f=0;e(i[c].slice(0,l).trim(),n,c,f,a);for(f=1;f<=(i[c].length-l)/10+1;++f)e(i[c].slice(l+(f-1)*10,l+f*10).trim(),n,c,f,a)}if(a.sheetRows)n=n.slice(0,a.sheetRows);return n}var t={44:",",9:"\t",59:";"};var a={44:3,9:2,59:1};function n(e){var r={},n=false,i=0,s=0;for(;i<e.length;++i){if((s=e.charCodeAt(i))==34)n=!n;else if(!n&&s in t)r[s]=(r[s]||0)+1}s=[];for(i in r)if(Object.prototype.hasOwnProperty.call(r,i)){s.push([r[i],i])}if(!s.length){r=a;for(i in r)if(Object.prototype.hasOwnProperty.call(r,i)){s.push([r[i],i])}}s.sort(function(e,r){return e[0]-r[0]||a[e[1]]-a[r[1]]});return t[s.pop()[1]]}function i(e,r){var t=r||{};var a="";if(v!=null&&t.dense==null)t.dense=v;var i=t.dense?[]:{};var s={s:{c:0,r:0},e:{c:0,r:0}};if(e.slice(0,4)=="sep="){if(e.charCodeAt(5)==13&&e.charCodeAt(6)==10){a=e.charAt(4);e=e.slice(7)}else if(e.charCodeAt(5)==13||e.charCodeAt(5)==10){a=e.charAt(4);e=e.slice(6)}}else a=n(e.slice(0,1024));var l=0,o=0,c=0;var f=0,u=0,h=a.charCodeAt(0),d=false,p=0;e=e.replace(/\r\n/gm,"\n");var m=t.dateNF!=null?z(t.dateNF):null;function g(){var r=e.slice(f,u);var a={};if(r.charAt(0)=='"'&&r.charAt(r.length-1)=='"')r=r.slice(1,-1).replace(/""/g,'"');if(r.length===0)a.t="z";else if(t.raw){a.t="s";a.v=r}else if(r.trim().length===0){a.t="s";a.v=r}else if(r.charCodeAt(0)==61){if(r.charCodeAt(1)==34&&r.charCodeAt(r.length-1)==34){a.t="s";a.v=r.slice(2,-1).replace(/""/g,'"')}else if(ti(r)){a.t="n";a.f=r.slice(1)}else{a.t="s";a.v=r}}else if(r=="TRUE"){a.t="b";a.v=true}else if(r=="FALSE"){a.t="b";a.v=false}else if(!isNaN(c=he(r))){a.t="n";if(t.cellText!==false)a.w=r;a.v=c}else if(!isNaN(de(r).getDate())||m&&r.match(m)){a.z=t.dateNF||N._table[14];var n=0;if(m&&r.match(m)){r=B(r,t.dateNF,r.match(m)||[]);n=1}if(t.cellDates){a.t="d";a.v=oe(r,n)}else{a.t="n";a.v=ee(oe(r,n))}if(t.cellText!==false)a.w=N.format(a.z,a.v instanceof Date?ee(a.v):a.v);if(!t.cellNF)delete a.z}else{a.t="s";a.v=r}if(a.t=="z"){}else if(t.dense){if(!i[l])i[l]=[];i[l][o]=a}else i[pt({c:o,r:l})]=a;f=u+1;if(s.e.c<o)s.e.c=o;if(s.e.r<l)s.e.r=l;if(p==h)++o;else{o=0;++l;if(t.sheetRows&&t.sheetRows<=l)return true}}e:for(;u<e.length;++u)switch(p=e.charCodeAt(u)){case 34:d=!d;break;case h:;case 10:;case 13:if(!d&&g())break e;break;default:break;}if(u-f>0)g();i["!ref"]=vt(s);return i}function s(e,t){if(!(t&&t.PRN))return i(e,t);if(e.slice(0,4)=="sep=")return i(e,t);if(e.indexOf("\t")>=0||e.indexOf(",")>=0||e.indexOf(";")>=0)return i(e,t);return xt(r(e,t),t)}function l(e,r){var t="",a=r.type=="string"?[0,0,0,0]:ul(e,r);switch(r.type){case"base64":t=b.decode(e);break;case"binary":t=e;break;case"buffer":if(r.codepage==65001)t=e.toString("utf8");else if(r.codepage&&typeof cptable!=="undefined")t=cptable.utils.decode(r.codepage,e);else t=e.toString("binary");break;case"array":t=ce(e);break;case"string":t=e;break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=Ye(t.slice(3));else if(r.type=="binary"&&typeof cptable!=="undefined"&&r.codepage)t=cptable.utils.decode(r.codepage,cptable.utils.encode(1252,t));if(t.slice(0,19)=="socialcalc:version:")return Fa.to_sheet(r.type=="string"?t:Ye(t),r);return s(t,r)}function o(e,r){return kt(l(e,r),r)}function c(e){var r=[];var t=gt(e["!ref"]),a;var n=Array.isArray(e);for(var i=t.s.r;i<=t.e.r;++i){var s=[];for(var l=t.s.c;l<=t.e.c;++l){var o=pt({r:i,c:l});a=n?(e[i]||[])[l]:e[o];if(!a||a.v==null){s.push("          ");continue}var c=(a.w||(wt(a),a.w)||"").slice(0,10);while(c.length<10)c+=" ";s.push(c+(l===0?" ":""))}r.push(s.join(""))}return r.join("\n")}return{to_workbook:o,to_sheet:l,from_sheet:c}}();function Oa(e,r){var t=r||{},a=!!t.WTF;t.WTF=true;try{var n=Aa.to_workbook(e,t);t.WTF=a;return n}catch(i){t.WTF=a;if(!i.message.match(/SYLK bad record ID/)&&a)throw i;return Ta.to_workbook(e,r)}}function Da(e){var r={},t=e.match(Oe),a=0;var n=false;if(t)for(;a!=t.length;++a){var s=Ne(t[a]);switch(s[0].replace(/\w*:/g,"")){case"<condense":break;case"<extend":break;case"<shadow":if(!s.val)break;case"<shadow>":;case"<shadow/>":r.shadow=1;break;case"</shadow>":break;case"<charset":if(s.val=="1")break;r.cp=i[parseInt(s.val,10)];break;case"<outline":if(!s.val)break;case"<outline>":;case"<outline/>":r.outline=1;break;case"</outline>":break;case"<rFont":r.name=s.val;break;case"<sz":r.sz=s.val;break;case"<strike":if(!s.val)break;case"<strike>":;case"<strike/>":r.strike=1;break;case"</strike>":break;case"<u":if(!s.val)break;switch(s.val){case"double":r.uval="double";break;case"singleAccounting":r.uval="single-accounting";break;case"doubleAccounting":r.uval="double-accounting";break;};case"<u>":;case"<u/>":r.u=1;break;case"</u>":break;case"<b":if(s.val=="0")break;case"<b>":;case"<b/>":r.b=1;break;case"</b>":break;case"<i":if(s.val=="0")break;case"<i>":;case"<i/>":r.i=1;break;case"</i>":break;case"<color":if(s.rgb)r.color=s.rgb.slice(2,8);break;case"<family":r.family=s.val;break;case"<vertAlign":r.valign=s.val;break;case"<scheme":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":n=true;break;case"</ext>":n=false;break;default:if(s[0].charCodeAt(1)!==47&&!n)throw new Error("Unrecognized rich format "+s[0]);}}return r}var Ma=function(){var e=Qe("t"),r=Qe("rPr");function t(t){var a=t.match(e);if(!a)return{t:"s",v:""};var n={t:"s",v:Le(a[1])};var i=t.match(r);if(i)n.s=Da(i[1]);return n}var a=/<(?:\w+:)?r>/g,n=/<\/(?:\w+:)?r>/;return function i(e){return e.replace(a,"").split(n).map(t).filter(function(e){return e.v})}}();var Na=function so(){var e=/(\r\n|\n)/g;function r(e,r,t){var a=[];if(e.u)a.push("text-decoration: underline;");if(e.uval)a.push("text-underline-style:"+e.uval+";");if(e.sz)a.push("font-size:"+e.sz+"pt;");if(e.outline)a.push("text-effect: outline;");if(e.shadow)a.push("text-shadow: auto;");r.push('<span style="'+a.join("")+'">');if(e.b){r.push("<b>");t.push("</b>")}if(e.i){r.push("<i>");t.push("</i>")}if(e.strike){r.push("<s>");t.push("</s>")}var n=e.valign||"";if(n=="superscript"||n=="super")n="sup";else if(n=="subscript")n="sub";if(n!=""){r.push("<"+n+">");t.push("</"+n+">")}t.push("</span>");return e}function t(t){var a=[[],t.v,[]];if(!t.v)return"";if(t.s)r(t.s,a[0],a[2]);return a[0].join("")+a[1].replace(e,"<br/>")+a[2].join("")}return function a(e){return e.map(t).join("")}}();var Ra=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,Pa=/<(?:\w+:)?r>/;var Ia=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function La(e,r){var t=r?r.cellHTML:true;var a={};if(!e)return{t:""};if(e.match(/^\s*<(?:\w+:)?t[^>]*>/)){a.t=Le(Ye(e.slice(e.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));a.r=Ye(e);if(t)a.h=je(a.t)}else if(e.match(Pa)){a.r=Ye(e);a.t=Le(Ye((e.replace(Ia,"").match(Ra)||[]).join("").replace(Oe,"")));if(t)a.h=Na(Ma(a.r))}return a}var za=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var Ba=/<(?:\w+:)?(?:si|sstItem)>/g;var Wa=/<\/(?:\w+:)?(?:si|sstItem)>/;function $a(e,r){var t=[],a="";if(!e)return t;var n=e.match(za);if(n){a=n[2].replace(Ba,"").split(Wa);for(var i=0;i!=a.length;++i){var s=La(a[i].trim(),r);if(s!=null)t[t.length]=s}n=Ne(n[1]);t.Count=n.count;t.Unique=n.uniqueCount}return t}ta.SST="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";var Ua=/^\s|\s$|[\t\n\r]/;function ja(e,r){if(!r.bookSST)return"";var t=[Fe];t[t.length]=or("sst",null,{xmlns:ur.main[0],count:e.Count,uniqueCount:e.Unique});for(var a=0;a!=e.length;++a){if(e[a]==null)continue;var n=e[a];var i="<si>";if(n.r)i+=n.r;else{i+="<t";if(!n.t)n.t="";if(n.t.match(Ua))i+=' xml:space="preserve"';i+=">"+We(n.t)+"</t>"}i+="</si>";t[t.length]=i}if(t.length>2){t[t.length]="</sst>";t[1]=t[1].replace("/>",">")}return t.join("")}function Ha(e){var r=e.slice(e[0]==="#"?1:0).slice(0,6);return[parseInt(r.slice(0,2),16),parseInt(r.slice(2,4),16),parseInt(r.slice(4,6),16)]}function Va(e){for(var r=0,t=1;r!=3;++r)t=t*256+(e[r]>255?255:e[r]<0?0:e[r]);return t.toString(16).toUpperCase().slice(1)}function Xa(e){var r=e[0]/255,t=e[1]/255,a=e[2]/255;var n=Math.max(r,t,a),i=Math.min(r,t,a),s=n-i;if(s===0)return[0,0,r];var l=0,o=0,c=n+i;o=s/(c>1?2-c:c);switch(n){case r:l=((t-a)/s+6)%6;break;case t:l=(a-r)/s+2;break;case a:l=(r-t)/s+4;break;}return[l/6,o,c/2]}function Ga(e){var r=e[0],t=e[1],a=e[2];var n=t*2*(a<.5?a:1-a),i=a-n/2;var s=[i,i,i],l=6*r;var o;if(t!==0)switch(l|0){case 0:;case 6:o=n*l;s[0]+=n;s[1]+=o;break;case 1:o=n*(2-l);s[0]+=o;s[1]+=n;break;case 2:o=n*(l-2);s[1]+=n;s[2]+=o;break;case 3:o=n*(4-l);s[1]+=o;s[2]+=n;break;case 4:o=n*(l-4);s[2]+=n;s[0]+=o;break;case 5:o=n*(6-l);s[2]+=o;s[0]+=n;break;}for(var c=0;c!=3;++c)s[c]=Math.round(s[c]*255);return s}function Ya(e,r){if(r===0)return e;var t=Xa(Ha(e));if(r<0)t[2]=t[2]*(1+r);else t[2]=1-(1-t[2])*(1-r);return Va(Ga(t))}var Ja=6,qa=15,Ka=1,Za=Ja;function Qa(e){return Math.floor((e+Math.round(128/Za)/256)*Za)}function en(e){return Math.floor((e-5)/Za*100+.5)/100}function rn(e){return Math.round((e*Za+5)/Za*256)/256}function tn(e){return rn(en(Qa(e)))}function an(e){var r=Math.abs(e-tn(e)),t=Za;if(r>.005)for(Za=Ka;Za<qa;++Za)if(Math.abs(e-tn(e))<=r){r=Math.abs(e-tn(e));t=Za}Za=t}function nn(e){if(e.width){e.wpx=Qa(e.width);e.wch=en(e.wpx);e.MDW=Za}else if(e.wpx){e.wch=en(e.wpx);e.width=rn(e.wch);e.MDW=Za}else if(typeof e.wch=="number"){e.width=rn(e.wch);e.wpx=Qa(e.width);e.MDW=Za}if(e.customWidth)delete e.customWidth}var sn=96,ln=sn;function on(e){return e*96/ln}function cn(e){return e*ln/96}var fn={None:"none",Solid:"solid",Gray50:"mediumGray",Gray75:"darkGray",Gray25:"lightGray",HorzStripe:"darkHorizontal",VertStripe:"darkVertical",ReverseDiagStripe:"darkDown",DiagStripe:"darkUp",DiagCross:"darkGrid",ThickDiagCross:"darkTrellis",ThinHorzStripe:"lightHorizontal",ThinVertStripe:"lightVertical",ThinReverseDiagStripe:"lightDown",ThinHorzCross:"lightGrid"};function un(e,r,t,a){r.Borders=[];var n={};var i=false;(e[0].match(Oe)||[]).forEach(function(e){var t=Ne(e);switch(Re(t[0])){case"<borders":;case"<borders>":;case"</borders>":break;case"<border":;case"<border>":;case"<border/>":n={};if(t.diagonalUp)n.diagonalUp=Ge(t.diagonalUp);if(t.diagonalDown)n.diagonalDown=Ge(t.diagonalDown);r.Borders.push(n);break;case"</border>":break;case"<left/>":break;case"<left":;case"<left>":break;case"</left>":break;case"<right/>":break;case"<right":;case"<right>":break;case"</right>":break;case"<top/>":break;case"<top":;case"<top>":break;case"</top>":break;case"<bottom/>":break;case"<bottom":;case"<bottom>":break;case"</bottom>":break;case"<diagonal":;case"<diagonal>":;case"<diagonal/>":break;case"</diagonal>":break;case"<horizontal":;case"<horizontal>":;case"<horizontal/>":break;case"</horizontal>":break;case"<vertical":;case"<vertical>":;case"<vertical/>":break;case"</vertical>":break;case"<start":;case"<start>":;case"<start/>":break;case"</start>":break;case"<end":;case"<end>":;case"<end/>":break;case"</end>":break;case"<color":;case"<color>":break;case"<color/>":;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in borders")};}})}function hn(e,r,t,a){r.Fills=[];var n={};var i=false;(e[0].match(Oe)||[]).forEach(function(e){var t=Ne(e);switch(Re(t[0])){case"<fills":;case"<fills>":;case"</fills>":break;case"<fill>":;case"<fill":;case"<fill/>":n={};r.Fills.push(n);break;case"</fill>":break;case"<gradientFill>":break;case"<gradientFill":;case"</gradientFill>":r.Fills.push(n);n={};break;case"<patternFill":;case"<patternFill>":if(t.patternType)n.patternType=t.patternType;break;case"<patternFill/>":;case"</patternFill>":break;case"<bgColor":if(!n.bgColor)n.bgColor={};if(t.indexed)n.bgColor.indexed=parseInt(t.indexed,10);if(t.theme)n.bgColor.theme=parseInt(t.theme,10);if(t.tint)n.bgColor.tint=parseFloat(t.tint);if(t.rgb)n.bgColor.rgb=t.rgb.slice(-6);break;case"<bgColor/>":;case"</bgColor>":break;case"<fgColor":if(!n.fgColor)n.fgColor={};if(t.theme)n.fgColor.theme=parseInt(t.theme,10);if(t.tint)n.fgColor.tint=parseFloat(t.tint);if(t.rgb!=null)n.fgColor.rgb=t.rgb.slice(-6);break;case"<fgColor/>":;case"</fgColor>":break;case"<stop":;case"<stop/>":break;case"</stop>":break;case"<color":;case"<color/>":break;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in fills")};}})}function dn(e,r,t,a){r.Fonts=[];var n={};var s=false;(e[0].match(Oe)||[]).forEach(function(e){var l=Ne(e);switch(Re(l[0])){case"<fonts":;case"<fonts>":;case"</fonts>":break;case"<font":;case"<font>":break;case"</font>":;case"<font/>":r.Fonts.push(n);n={};break;case"<name":if(l.val)n.name=Ye(l.val);break;case"<name/>":;case"</name>":break;case"<b":n.bold=l.val?Ge(l.val):1;
break;case"<b/>":n.bold=1;break;case"<i":n.italic=l.val?Ge(l.val):1;break;case"<i/>":n.italic=1;break;case"<u":switch(l.val){case"none":n.underline=0;break;case"single":n.underline=1;break;case"double":n.underline=2;break;case"singleAccounting":n.underline=33;break;case"doubleAccounting":n.underline=34;break;}break;case"<u/>":n.underline=1;break;case"<strike":n.strike=l.val?Ge(l.val):1;break;case"<strike/>":n.strike=1;break;case"<outline":n.outline=l.val?Ge(l.val):1;break;case"<outline/>":n.outline=1;break;case"<shadow":n.shadow=l.val?Ge(l.val):1;break;case"<shadow/>":n.shadow=1;break;case"<condense":n.condense=l.val?Ge(l.val):1;break;case"<condense/>":n.condense=1;break;case"<extend":n.extend=l.val?Ge(l.val):1;break;case"<extend/>":n.extend=1;break;case"<sz":if(l.val)n.sz=+l.val;break;case"<sz/>":;case"</sz>":break;case"<vertAlign":if(l.val)n.vertAlign=l.val;break;case"<vertAlign/>":;case"</vertAlign>":break;case"<family":if(l.val)n.family=parseInt(l.val,10);break;case"<family/>":;case"</family>":break;case"<scheme":if(l.val)n.scheme=l.val;break;case"<scheme/>":;case"</scheme>":break;case"<charset":if(l.val=="1")break;l.codepage=i[parseInt(l.val,10)];break;case"<color":if(!n.color)n.color={};if(l.auto)n.color.auto=Ge(l.auto);if(l.rgb)n.color.rgb=l.rgb.slice(-6);else if(l.indexed){n.color.index=parseInt(l.indexed,10);var o=Vt[n.color.index];if(n.color.index==81)o=Vt[1];if(!o)throw new Error(e);n.color.rgb=o[0].toString(16)+o[1].toString(16)+o[2].toString(16)}else if(l.theme){n.color.theme=parseInt(l.theme,10);if(l.tint)n.color.tint=parseFloat(l.tint);if(l.theme&&t.themeElements&&t.themeElements.clrScheme){n.color.rgb=Ya(t.themeElements.clrScheme[n.color.theme].rgb,n.color.tint||0)}}break;case"<color/>":;case"</color>":break;case"<AlternateContent":s=true;break;case"</AlternateContent>":s=false;break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":s=true;break;case"</ext>":s=false;break;default:if(a&&a.WTF){if(!s)throw new Error("unrecognized "+l[0]+" in fonts")};}})}function pn(e,r,t){r.NumberFmt=[];var a=Y(N._table);for(var n=0;n<a.length;++n)r.NumberFmt[a[n]]=N._table[a[n]];var i=e[0].match(Oe);if(!i)return;for(n=0;n<i.length;++n){var s=Ne(i[n]);switch(Re(s[0])){case"<numFmts":;case"</numFmts>":;case"<numFmts/>":;case"<numFmts>":break;case"<numFmt":{var l=Le(Ye(s.formatCode)),o=parseInt(s.numFmtId,10);r.NumberFmt[o]=l;if(o>0){if(o>392){for(o=392;o>60;--o)if(r.NumberFmt[o]==null)break;r.NumberFmt[o]=l}N.load(l,o)}}break;case"</numFmt>":break;default:if(t.WTF)throw new Error("unrecognized "+s[0]+" in numFmts");}}}function mn(e){var r=["<numFmts>"];[[5,8],[23,26],[41,44],[50,392]].forEach(function(t){for(var a=t[0];a<=t[1];++a)if(e[a]!=null)r[r.length]=or("numFmt",null,{numFmtId:a,formatCode:We(e[a])})});if(r.length===1)return"";r[r.length]="</numFmts>";r[0]=or("numFmts",null,{count:r.length-2}).replace("/>",">");return r.join("")}var vn=["numFmtId","fillId","fontId","borderId","xfId"];var gn=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function bn(e,r,t){r.CellXf=[];var a;var n=false;(e[0].match(Oe)||[]).forEach(function(e){var i=Ne(e),s=0;switch(Re(i[0])){case"<cellXfs":;case"<cellXfs>":;case"<cellXfs/>":;case"</cellXfs>":break;case"<xf":;case"<xf/>":a=i;delete a[0];for(s=0;s<vn.length;++s)if(a[vn[s]])a[vn[s]]=parseInt(a[vn[s]],10);for(s=0;s<gn.length;++s)if(a[gn[s]])a[gn[s]]=Ge(a[gn[s]]);if(a.numFmtId>392){for(s=392;s>60;--s)if(r.NumberFmt[a.numFmtId]==r.NumberFmt[s]){a.numFmtId=s;break}}r.CellXf.push(a);break;case"</xf>":break;case"<alignment":;case"<alignment/>":var l={};if(i.vertical)l.vertical=i.vertical;if(i.horizontal)l.horizontal=i.horizontal;if(i.textRotation!=null)l.textRotation=i.textRotation;if(i.indent)l.indent=i.indent;if(i.wrapText)l.wrapText=Ge(i.wrapText);a.alignment=l;break;case"</alignment>":break;case"<protection":break;case"</protection>":;case"<protection/>":break;case"<AlternateContent":n=true;break;case"</AlternateContent>":n=false;break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":n=true;break;case"</ext>":n=false;break;default:if(t&&t.WTF){if(!n)throw new Error("unrecognized "+i[0]+" in cellXfs")};}})}function wn(e){var r=[];r[r.length]=or("cellXfs",null);e.forEach(function(e){r[r.length]=or("xf",null,e)});r[r.length]="</cellXfs>";if(r.length===2)return"";r[0]=or("cellXfs",null,{count:r.length-2}).replace("/>",">");return r.join("")}var kn=function lo(){var e=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var r=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var t=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var a=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var n=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function i(s,l,o){var c={};if(!s)return c;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");var f;if(f=s.match(e))pn(f,c,o);if(f=s.match(a))dn(f,c,l,o);if(f=s.match(t))hn(f,c,l,o);if(f=s.match(n))un(f,c,l,o);if(f=s.match(r))bn(f,c,o);return c}}();var yn=or("styleSheet",null,{xmlns:ur.main[0],"xmlns:vt":ur.vt});ta.STY="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";function xn(e,r){var t=[Fe,yn],a;if(e.SSF&&(a=mn(e.SSF))!=null)t[t.length]=a;t[t.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';t[t.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';t[t.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';t[t.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(a=wn(r.cellXfs))t[t.length]=a;t[t.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';t[t.length]='<dxfs count="0"/>';t[t.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(t.length>2){t[t.length]="</styleSheet>";t[1]=t[1].replace("/>",">")}return t.join("")}ta.THEME="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";var _n=["</a:lt1>","</a:dk1>","</a:lt2>","</a:dk2>","</a:accent1>","</a:accent2>","</a:accent3>","</a:accent4>","</a:accent5>","</a:accent6>","</a:hlink>","</a:folHlink>"];function Sn(e,r,t){r.themeElements.clrScheme=[];var a={};(e[0].match(Oe)||[]).forEach(function(e){var n=Ne(e);switch(n[0]){case"<a:clrScheme":;case"</a:clrScheme>":break;case"<a:srgbClr":a.rgb=n.val;break;case"<a:sysClr":a.rgb=n.lastClr;break;case"<a:dk1>":;case"</a:dk1>":;case"<a:lt1>":;case"</a:lt1>":;case"<a:dk2>":;case"</a:dk2>":;case"<a:lt2>":;case"</a:lt2>":;case"<a:accent1>":;case"</a:accent1>":;case"<a:accent2>":;case"</a:accent2>":;case"<a:accent3>":;case"</a:accent3>":;case"<a:accent4>":;case"</a:accent4>":;case"<a:accent5>":;case"</a:accent5>":;case"<a:accent6>":;case"</a:accent6>":;case"<a:hlink>":;case"</a:hlink>":;case"<a:folHlink>":;case"</a:folHlink>":if(n[0].charAt(1)==="/"){r.themeElements.clrScheme[_n.indexOf(n[0])]=a;a={}}else{a.name=n[0].slice(3,n[0].length-1)}break;default:if(t&&t.WTF)throw new Error("Unrecognized "+n[0]+" in clrScheme");}})}function Cn(){}function An(){}var En=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var Fn=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var Tn=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;function On(e,r,t){r.themeElements={};var a;[["clrScheme",En,Sn],["fontScheme",Fn,Cn],["fmtScheme",Tn,An]].forEach(function(n){if(!(a=e.match(n[1])))throw new Error(n[0]+" not found in themeElements");n[2](a,r,t)})}var Dn=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;function Mn(e,r){if(!e||e.length===0)return Mn(Nn());var t;var a={};if(!(t=e.match(Dn)))throw new Error("themeElements not found in theme");On(t[0],a,r);a.raw=e;return a}function Nn(e,r){if(r&&r.themeXLSX)return r.themeXLSX;if(e&&typeof e.raw=="string")return e.raw;var t=[Fe];t[t.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';t[t.length]="<a:themeElements>";t[t.length]='<a:clrScheme name="Office">';t[t.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';t[t.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';t[t.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';t[t.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';t[t.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';t[t.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';t[t.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';t[t.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';t[t.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';t[t.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';t[t.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';t[t.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';t[t.length]="</a:clrScheme>";t[t.length]='<a:fontScheme name="Office">';t[t.length]="<a:majorFont>";t[t.length]='<a:latin typeface="Cambria"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Times New Roman"/>';t[t.length]='<a:font script="Hebr" typeface="Times New Roman"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="MoolBoran"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Times New Roman"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:majorFont>";t[t.length]="<a:minorFont>";t[t.length]='<a:latin typeface="Calibri"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Arial"/>';t[t.length]='<a:font script="Hebr" typeface="Arial"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="DaunPenh"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Arial"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:minorFont>";t[t.length]="</a:fontScheme>";t[t.length]='<a:fmtScheme name="Office">';t[t.length]="<a:fillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="1"/>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="0"/>';t[t.length]="</a:gradFill>";t[t.length]="</a:fillStyleLst>";t[t.length]="<a:lnStyleLst>";t[t.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]="</a:lnStyleLst>";t[t.length]="<a:effectStyleLst>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';t[t.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';t[t.length]="</a:effectStyle>";t[t.length]="</a:effectStyleLst>";t[t.length]="<a:bgFillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]="</a:bgFillStyleLst>";t[t.length]="</a:fmtScheme>";t[t.length]="</a:themeElements>";t[t.length]="<a:objectDefaults>";t[t.length]="<a:spDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';t[t.length]="</a:spDef>";t[t.length]="<a:lnDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';t[t.length]="</a:lnDef>";t[t.length]="</a:objectDefaults>";t[t.length]="<a:extraClrSchemeLst/>";t[t.length]="</a:theme>";return t.join("")}function Rn(){}function Pn(e,r,t,a){if(!e)return e;var n=a||{};var i=false,s=false;Kr(e,function l(e,r,t){if(s)return;switch(t){case 359:;case 363:;case 364:;case 366:;case 367:;case 368:;case 369:;case 370:;case 371:;case 472:;case 577:;case 578:;case 579:;case 580:;case 581:;case 582:;case 583:;case 584:;case 585:;case 586:;case 587:break;case 35:i=true;break;case 36:i=false;break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!i||n.WTF)throw new Error("Unexpected record "+t.toString(16)+" "+r);}},n)}ta.IMG="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";ta.DRAW="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";function In(e,r){if(!e)return"??";var t=(e.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return r["!id"][t].Target}var Ln=1024;function zn(e,r){var t=[21600,21600];var a=["m0,0l0",t[1],t[0],t[1],t[0],"0xe"].join(",");var n=[or("xml",null,{"xmlns:v":hr.v,"xmlns:o":hr.o,"xmlns:x":hr.x,"xmlns:mv":hr.mv}).replace(/\/>/,">"),or("o:shapelayout",or("o:idmap",null,{"v:ext":"edit",data:e}),{"v:ext":"edit"}),or("v:shapetype",[or("v:stroke",null,{joinstyle:"miter"}),or("v:path",null,{gradientshapeok:"t","o:connecttype":"rect"})].join(""),{id:"_x0000_t202","o:spt":202,coordsize:t.join(","),path:a})];while(Ln<e*1e3)Ln+=1e3;r.forEach(function(e){var r=dt(e[0]);var t={color2:"#BEFF82",type:"gradient"};if(t.type=="gradient")t.angle="-180";var a=t.type=="gradient"?or("o:fill",null,{type:"gradientUnscaled","v:ext":"view"}):null;var i=or("v:fill",a,t);var s={on:"t",obscured:"t"};++Ln;n=n.concat(["<v:shape"+lr({id:"_x0000_s"+Ln,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(e[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+">",i,or("v:shadow",null,s),or("v:path",null,{"o:connecttype":"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">',"<x:MoveWithCells/>","<x:SizeWithCells/>",sr("x:Anchor",[r.c+1,0,r.r+1,0,r.c+3,20,r.r+5,20].join(",")),sr("x:AutoFill","False"),sr("x:Row",String(r.r)),sr("x:Column",String(r.c)),e[1].hidden?"":"<x:Visible/>","</x:ClientData>","</v:shape>"])});n.push("</xml>");return n.join("")}ta.CMNT="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";function Bn(e,r){var t=Array.isArray(e);var a;r.forEach(function(r){var n=dt(r.ref);if(t){if(!e[n.r])e[n.r]=[];a=e[n.r][n.c]}else a=e[r.ref];if(!a){a={t:"z"};if(t)e[n.r][n.c]=a;else e[r.ref]=a;var i=gt(e["!ref"]||"BDWGO1000001:A1");if(i.s.r>n.r)i.s.r=n.r;if(i.e.r<n.r)i.e.r=n.r;if(i.s.c>n.c)i.s.c=n.c;if(i.e.c<n.c)i.e.c=n.c;var s=vt(i);if(s!==e["!ref"])e["!ref"]=s}if(!a.c)a.c=[];var l={a:r.author,t:r.t,r:r.r};if(r.h)l.h=r.h;a.c.push(l)})}function Wn(e,r){if(e.match(/<(?:\w+:)?comments *\/>/))return[];var t=[];var a=[];var n=e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(n&&n[1])n[1].split(/<\/\w*:?author>/).forEach(function(e){if(e===""||e.trim()==="")return;var r=e.match(/<(?:\w+:)?author[^>]*>(.*)/);if(r)t.push(r[1])});var i=e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(i&&i[1])i[1].split(/<\/\w*:?comment>/).forEach(function(e){if(e===""||e.trim()==="")return;var n=e.match(/<(?:\w+:)?comment[^>]*>/);if(!n)return;var i=Ne(n[0]);var s={author:i.authorId&&t[i.authorId]||"sheetjsghost",ref:i.ref,guid:i.guid};var l=dt(i.ref);if(r.sheetRows&&r.sheetRows<=l.r)return;var o=e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var c=!!o&&!!o[1]&&La(o[1])||{r:"",t:"",h:""};s.r=c.r;if(c.r=="<t></t>")c.t=c.h="";s.t=c.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(r.cellHTML)s.h=c.h;a.push(s)});return a}var $n=or("comments",null,{xmlns:ur.main[0]});function Un(e){var r=[Fe,$n];var t=[];r.push("<authors>");e.forEach(function(e){e[1].forEach(function(e){var a=We(e.a);if(t.indexOf(a)>-1)return;t.push(a);r.push("<author>"+a+"</author>")})});r.push("</authors>");r.push("<commentList>");e.forEach(function(e){e[1].forEach(function(a){r.push('<comment ref="'+e[0]+'" authorId="'+t.indexOf(We(a.a))+'"><text>');r.push(sr("t",a.t==null?"":We(a.t)));r.push("</text></comment>")})});r.push("</commentList>");if(r.length>2){r[r.length]="</comments>";r[1]=r[1].replace("/>",">")}return r.join("")}var jn="application/vnd.ms-office.vbaProject";function Hn(e){var r=j.utils.cfb_new({root:"R"});e.FullPaths.forEach(function(t,a){if(t.slice(-1)==="/"||!t.match(/_VBA_PROJECT_CUR/))return;var n=t.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");j.utils.cfb_add(r,n,e.FileIndex[a].content)});return j.write(r)}function Vn(e,r){r.FullPaths.forEach(function(t,a){if(a==0)return;var n=t.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(n.slice(-1)!=="/")j.utils.cfb_add(e,n,r.FileIndex[a].content)})}var Xn=["xlsb","xlsm","xlam","biff8","xla"];ta.DS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";ta.MS="http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";function Gn(){return{"!type":"dialog"}}function Yn(){return{"!type":"dialog"}}function Jn(){return{"!type":"macro"}}function qn(){return{"!type":"macro"}}var Kn=function(){var e=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;var r={r:0,c:0};function t(e,t,a,n){var i=false,s=false;if(a.length==0)s=true;else if(a.charAt(0)=="["){s=true;a=a.slice(1,-1)}if(n.length==0)i=true;else if(n.charAt(0)=="["){i=true;n=n.slice(1,-1)}var l=a.length>0?parseInt(a,10)|0:0,o=n.length>0?parseInt(n,10)|0:0;if(i)o+=r.c;else--o;if(s)l+=r.r;else--l;return t+(i?"":"$")+ct(o)+(s?"":"$")+it(l)}return function a(n,i){r=i;return n.replace(e,t)}}();var Zn=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;var Qn=function(){return function e(r,t){return r.replace(Zn,function(e,r,a,n,i,s){var l=ot(n)-(a?0:t.c);var o=nt(s)-(i?0:t.r);var c=o==0?"":!i?"["+o+"]":o+1;var f=l==0?"":!a?"["+l+"]":l+1;return r+"R"+c+"C"+f})}}();function ei(e,r){return e.replace(Zn,function(e,t,a,n,i,s){return t+(a=="$"?a+n:ct(ot(n)+r.c))+(i=="$"?i+s:it(nt(s)+r.r))})}function ri(e,r,t){var a=mt(r),n=a.s,i=dt(t);var s={r:i.r-n.r,c:i.c-n.c};return ei(e,s)}function ti(e){if(e.length==1)return false;return true}function ai(e){return e.replace(/_xlfn\./g,"")}var ni={};var ii={};ta.WS=["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"];var si=typeof Map!=="undefined";function li(e,r,t){var a=0,n=e.length;if(t){if(si?t.has(r):Object.prototype.hasOwnProperty.call(t,r)){var i=si?t.get(r):t[r];for(;a<i.length;++a){if(e[i[a]].t===r){e.Count++;return i[a]}}}}else for(;a<n;++a){if(e[a].t===r){e.Count++;return a}}e[n]={t:r};e.Count++;e.Unique++;if(t){if(si){if(!t.has(r))t.set(r,[]);t.get(r).push(n)}else{if(!Object.prototype.hasOwnProperty.call(t,r))t[r]=[];t[r].push(n)}}return n}function oi(e,r){var t={min:e+1,max:e+1};var a=-1;if(r.MDW)Za=r.MDW;if(r.width!=null)t.customWidth=1;else if(r.wpx!=null)a=en(r.wpx);else if(r.wch!=null)a=r.wch;if(a>-1){t.width=rn(a);t.customWidth=1}else if(r.width!=null)t.width=r.width;if(r.hidden)t.hidden=true;return t}function ci(e,r){if(!e)return;var t=[.7,.7,.75,.75,.3,.3];if(r=="xlml")t=[1,1,1,1,.5,.5];if(e.left==null)e.left=t[0];if(e.right==null)e.right=t[1];if(e.top==null)e.top=t[2];if(e.bottom==null)e.bottom=t[3];if(e.header==null)e.header=t[4];if(e.footer==null)e.footer=t[5]}function fi(e,r,t){var a=t.revssf[r.z!=null?r.z:"General"];var n=60,i=e.length;if(a==null&&t.ssf){for(;n<392;++n)if(t.ssf[n]==null){N.load(r.z,n);t.ssf[n]=r.z;t.revssf[r.z]=a=n;break}}for(n=0;n!=i;++n)if(e[n].numFmtId===a)return n;e[i]={numFmtId:a,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return i}function ui(e,r,t,a,n,i){try{if(a.cellNF)e.z=N._table[r]}catch(s){if(a.WTF)throw s}if(e.t==="z")return;if(e.t==="d"&&typeof e.v==="string")e.v=oe(e.v);if(!a||a.cellText!==false)try{if(N._table[r]==null)N.load(I[r]||"General",r);if(e.t==="e")e.w=e.w||Xt[e.v];else if(r===0){if(e.t==="n"){if((e.v|0)===e.v)e.w=N._general_int(e.v);else e.w=N._general_num(e.v)}else if(e.t==="d"){var l=ee(e.v);if((l|0)===l)e.w=N._general_int(l);else e.w=N._general_num(l)}else if(e.v===undefined)return"";else e.w=N._general(e.v,ii)}else if(e.t==="d")e.w=N.format(r,ee(e.v),ii);else e.w=N.format(r,e.v,ii)}catch(s){if(a.WTF)throw s}if(!a.cellStyles)return;if(t!=null)try{e.s=i.Fills[t];if(e.s.fgColor&&e.s.fgColor.theme&&!e.s.fgColor.rgb){e.s.fgColor.rgb=Ya(n.themeElements.clrScheme[e.s.fgColor.theme].rgb,e.s.fgColor.tint||0);if(a.WTF)e.s.fgColor.raw_rgb=n.themeElements.clrScheme[e.s.fgColor.theme].rgb}if(e.s.bgColor&&e.s.bgColor.theme){e.s.bgColor.rgb=Ya(n.themeElements.clrScheme[e.s.bgColor.theme].rgb,e.s.bgColor.tint||0);if(a.WTF)e.s.bgColor.raw_rgb=n.themeElements.clrScheme[e.s.bgColor.theme].rgb}}catch(s){if(a.WTF&&i.Fills)throw s}}function hi(e,r,t){if(e&&e["!ref"]){var a=gt(e["!ref"]);if(a.e.c<a.s.c||a.e.r<a.s.r)throw new Error("Bad range ("+t+"): "+e["!ref"])}}function di(e,r){var t=gt(r);if(t.s.r<=t.e.r&&t.s.c<=t.e.c&&t.s.r>=0&&t.s.c>=0)e["!ref"]=vt(t)}var pi=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var mi=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;var vi=/<(?:\w:)?hyperlink [^>]*>/gm;var gi=/"(\w*:\w*)"/;var bi=/<(?:\w:)?col\b[^>]*[\/]?>/g;var wi=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var ki=/<(?:\w:)?pageMargins[^>]*\/>/g;var yi=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;var xi=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;function _i(e,r,t,a,n,i,s){if(!e)return e;if(!a)a={"!id":{}};if(v!=null&&r.dense==null)r.dense=v;var l=r.dense?[]:{};var o={s:{r:2e6,c:2e6},e:{r:0,c:0}};var c="",f="";var u=e.match(mi);if(u){c=e.slice(0,u.index);f=e.slice(u.index+u[0].length)}else c=f=e;var h=c.match(yi);if(h)Ci(h[0],l,n,t);var d=(c.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(d>0){var p=c.slice(d,d+50).match(gi);if(p)di(l,p[1])}var m=c.match(xi);if(m&&m[1])zi(m[1],n);var g=[];if(r.cellStyles){var b=c.match(bi);if(b)Ni(g,b)}if(u)$i(u[1],l,r,o,i,s);var w=f.match(wi);if(w)l["!autofilter"]=Pi(w[0]);var k=[];var y=f.match(pi);if(y)for(d=0;d!=y.length;++d)k[d]=gt(y[d].slice(y[d].indexOf('"')+1));var x=f.match(vi);if(x)Oi(l,x,a);var _=f.match(ki);if(_)l["!margins"]=Di(Ne(_[0]));if(!l["!ref"]&&o.e.c>=o.s.c&&o.e.r>=o.s.r)l["!ref"]=vt(o);if(r.sheetRows>0&&l["!ref"]){var S=gt(l["!ref"]);if(r.sheetRows<=+S.e.r){S.e.r=r.sheetRows-1;if(S.e.r>o.e.r)S.e.r=o.e.r;if(S.e.r<S.s.r)S.s.r=S.e.r;if(S.e.c>o.e.c)S.e.c=o.e.c;if(S.e.c<S.s.c)S.s.c=S.e.c;l["!fullref"]=l["!ref"];l["!ref"]=vt(S)}}if(g.length>0)l["!cols"]=g;if(k.length>0)l["!merges"]=k;return l}function Si(e){if(e.length===0)return"";var r='<mergeCells count="'+e.length+'">';for(var t=0;t!=e.length;++t)r+='<mergeCell ref="'+vt(e[t])+'"/>';return r+"</mergeCells>"}function Ci(e,r,t,a){var n=Ne(e);if(!t.Sheets[a])t.Sheets[a]={};if(n.codeName)t.Sheets[a].CodeName=Le(Ye(n.codeName))}function Ai(e,r,t,a,n){var i=false;var s={},l=null;if(a.bookType!=="xlsx"&&r.vbaraw){var o=r.SheetNames[t];try{if(r.Workbook)o=r.Workbook.Sheets[t].CodeName||o}catch(c){}i=true;s.codeName=Je(We(o))}if(e&&e["!outline"]){var f={summaryBelow:1,summaryRight:1};if(e["!outline"].above)f.summaryBelow=0;if(e["!outline"].left)f.summaryRight=0;l=(l||"")+or("outlinePr",null,f)}if(!i&&!l)return;n[n.length]=or("sheetPr",l,s)}var Ei=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var Fi=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];function Ti(e){var r={sheet:1};Ei.forEach(function(t){if(e[t]!=null&&e[t])r[t]="1"});Fi.forEach(function(t){if(e[t]!=null&&!e[t])r[t]="0"});if(e.password)r.password=crypto_CreatePasswordVerifier_Method1(e.password).toString(16).toUpperCase();return or("sheetProtection",null,r)}function Oi(e,r,t){var a=Array.isArray(e);for(var n=0;n!=r.length;++n){var i=Ne(Ye(r[n]),true);if(!i.ref)return;var s=((t||{})["!id"]||[])[i.id];if(s){i.Target=s.Target;if(i.location)i.Target+="#"+i.location}else{i.Target="#"+i.location;s={Target:i.Target,TargetMode:"Internal"}}i.Rel=s;if(i.tooltip){i.Tooltip=i.tooltip;delete i.tooltip}var l=gt(i.ref);for(var o=l.s.r;o<=l.e.r;++o)for(var c=l.s.c;c<=l.e.c;++c){var f=pt({c:c,r:o});if(a){if(!e[o])e[o]=[];if(!e[o][c])e[o][c]={t:"z",v:undefined};e[o][c].l=i}else{if(!e[f])e[f]={t:"z",v:undefined};e[f].l=i}}}}function Di(e){var r={};["left","right","top","bottom","header","footer"].forEach(function(t){if(e[t])r[t]=parseFloat(e[t])});return r}function Mi(e){ci(e);return or("pageMargins",null,e)}function Ni(e,r){var t=false;for(var a=0;a!=r.length;++a){var n=Ne(r[a],true);if(n.hidden)n.hidden=Ge(n.hidden);var i=parseInt(n.min,10)-1,s=parseInt(n.max,10)-1;delete n.min;delete n.max;n.width=+n.width;if(!t&&n.width){t=true;an(n.width)}nn(n);while(i<=s)e[i++]=fe(n)}}function Ri(e,r){var t=["<cols>"],a;for(var n=0;n!=r.length;++n){if(!(a=r[n]))continue;t[t.length]=or("col",null,oi(n,a))}t[t.length]="</cols>";return t.join("")}function Pi(e){var r={ref:(e.match(/ref="([^"]*)"/)||[])[1]};return r}function Ii(e,r,t,a){var n=typeof e.ref=="string"?e.ref:vt(e.ref);if(!t.Workbook)t.Workbook={Sheets:[]};if(!t.Workbook.Names)t.Workbook.Names=[];var i=t.Workbook.Names;var s=mt(n);if(s.s.r==s.e.r){s.e.r=mt(r["!ref"]).e.r;n=vt(s)}for(var l=0;l<i.length;++l){var o=i[l];if(o.Name!="_xlnm._FilterDatabase")continue;if(o.Sheet!=a)continue;o.Ref="'"+t.SheetNames[a]+"'!"+n;break}if(l==i.length)i.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+t.SheetNames[a]+"'!"+n});return or("autoFilter",null,{ref:n})}var Li=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;function zi(e,r){if(!r.Views)r.Views=[{}];(e.match(Li)||[]).forEach(function(e,t){var a=Ne(e);if(!r.Views[t])r.Views[t]={};if(+a.zoomScale)r.Views[t].zoom=+a.zoomScale;if(Ge(a.rightToLeft))r.Views[t].RTL=true})}function Bi(e,r,t,a){
var n={workbookViewId:"0"};if((((a||{}).Workbook||{}).Views||[])[0])n.rightToLeft=a.Workbook.Views[0].RTL?"1":"0";return or("sheetViews",or("sheetView",null,n),{})}function Wi(e,r,t,a){if(e.v===undefined&&typeof e.f!=="string"||e.t==="z")return"";var n="";var i=e.t,s=e.v;if(e.t!=="z")switch(e.t){case"b":n=e.v?"1":"0";break;case"n":n=""+e.v;break;case"e":n=Xt[e.v];break;case"d":if(a&&a.cellDates)n=oe(e.v,-1).toISOString();else{e=fe(e);e.t="n";n=""+(e.v=ee(oe(e.v)))}if(typeof e.z==="undefined")e.z=N._table[14];break;default:n=e.v;break;}var l=sr("v",We(n)),o={r:r};var c=fi(a.cellXfs,e,a);if(c!==0)o.s=c;switch(e.t){case"n":break;case"d":o.t="d";break;case"b":o.t="b";break;case"e":o.t="e";break;case"z":break;default:if(e.v==null){delete e.t;break}if(a&&a.bookSST){l=sr("v",""+li(a.Strings,e.v,a.revStrings));o.t="s";break}o.t="str";break;}if(e.t!=i){e.t=i;e.v=s}if(typeof e.f=="string"&&e.f){var f=e.F&&e.F.slice(0,r.length)==r?{t:"array",ref:e.F}:null;l=or("f",We(e.f),f)+(e.v!=null?l:"")}if(e.l)t["!links"].push([r,e.l]);if(e.c)t["!comments"].push([r,e.c]);return or("c",l,o)}var $i=function(){var e=/<(?:\w+:)?c[ \/>]/,r=/<\/(?:\w+:)?row>/;var t=/r=["']([^"']*)["']/,a=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var n=/ref=["']([^"']*)["']/;var i=Qe("v"),s=Qe("f");return function l(o,c,f,u,h,d){var p=0,m="",v=[],g=[],b=0,w=0,k=0,y="",x;var _,S=0,C=0;var A,E;var F=0,T=0;var O=Array.isArray(d.CellXf),D;var M=[];var R=[];var P=Array.isArray(c);var I=[],L={},z=false;var B=!!f.sheetStubs;for(var W=o.split(r),$=0,U=W.length;$!=U;++$){m=W[$].trim();var j=m.length;if(j===0)continue;for(p=0;p<j;++p)if(m.charCodeAt(p)===62)break;++p;_=Ne(m.slice(0,p),true);S=_.r!=null?parseInt(_.r,10):S+1;C=-1;if(f.sheetRows&&f.sheetRows<S)continue;if(u.s.r>S-1)u.s.r=S-1;if(u.e.r<S-1)u.e.r=S-1;if(f&&f.cellStyles){L={};z=false;if(_.ht){z=true;L.hpt=parseFloat(_.ht);L.hpx=cn(L.hpt)}if(_.hidden=="1"){z=true;L.hidden=true}if(_.outlineLevel!=null){z=true;L.level=+_.outlineLevel}if(z)I[S-1]=L}v=m.slice(p).split(e);for(var H=0;H!=v.length;++H)if(v[H].trim().charAt(0)!="<")break;v=v.slice(H);for(p=0;p!=v.length;++p){m=v[p].trim();if(m.length===0)continue;g=m.match(t);b=p;w=0;k=0;m="<c "+(m.slice(0,1)=="<"?">":"")+m;if(g!=null&&g.length===2){b=0;y=g[1];for(w=0;w!=y.length;++w){if((k=y.charCodeAt(w)-64)<1||k>26)break;b=26*b+k}--b;C=b}else++C;for(w=0;w!=m.length;++w)if(m.charCodeAt(w)===62)break;++w;_=Ne(m.slice(0,w),true);if(!_.r)_.r=pt({r:S-1,c:C});y=m.slice(w);x={t:""};if((g=y.match(i))!=null&&g[1]!=="")x.v=Le(g[1]);if(f.cellFormula){if((g=y.match(s))!=null&&g[1]!==""){x.f=Le(Ye(g[1])).replace(/\r\n/g,"\n");if(!f.xlfn)x.f=ai(x.f);if(g[0].indexOf('t="array"')>-1){x.F=(y.match(n)||[])[1];if(x.F.indexOf(":")>-1)M.push([gt(x.F),x.F])}else if(g[0].indexOf('t="shared"')>-1){E=Ne(g[0]);var V=Le(Ye(g[1]));if(!f.xlfn)V=ai(V);R[parseInt(E.si,10)]=[E,V,_.r]}}else if(g=y.match(/<f[^>]*\/>/)){E=Ne(g[0]);if(R[E.si])x.f=ri(R[E.si][1],R[E.si][2],_.r)}var X=dt(_.r);for(w=0;w<M.length;++w)if(X.r>=M[w][0].s.r&&X.r<=M[w][0].e.r)if(X.c>=M[w][0].s.c&&X.c<=M[w][0].e.c)x.F=M[w][1]}if(_.t==null&&x.v===undefined){if(x.f||x.F){x.v=0;x.t="n"}else if(!B)continue;else x.t="z"}else x.t=_.t||"n";if(u.s.c>C)u.s.c=C;if(u.e.c<C)u.e.c=C;switch(x.t){case"n":if(x.v==""||x.v==null){if(!B)continue;x.t="z"}else x.v=parseFloat(x.v);break;case"s":if(typeof x.v=="undefined"){if(!B)continue;x.t="z"}else{A=ni[parseInt(x.v,10)];x.v=A.t;x.r=A.r;if(f.cellHTML)x.h=A.h}break;case"str":x.t="s";x.v=x.v!=null?Ye(x.v):"";if(f.cellHTML)x.h=je(x.v);break;case"inlineStr":g=y.match(a);x.t="s";if(g!=null&&(A=La(g[1]))){x.v=A.t;if(f.cellHTML)x.h=A.h}else x.v="";break;case"b":x.v=Ge(x.v);break;case"d":if(f.cellDates)x.v=oe(x.v,1);else{x.v=ee(oe(x.v,1));x.t="n"}break;case"e":if(!f||f.cellText!==false)x.w=x.v;x.v=Gt[x.v];break;}F=T=0;D=null;if(O&&_.s!==undefined){D=d.CellXf[_.s];if(D!=null){if(D.numFmtId!=null)F=D.numFmtId;if(f.cellStyles){if(D.fillId!=null)T=D.fillId}}}ui(x,F,T,f,h,d);if(f.cellDates&&O&&x.t=="n"&&N.is_date(N._table[F])){x.t="d";x.v=ne(x.v)}if(P){var G=dt(_.r);if(!c[G.r])c[G.r]=[];c[G.r][G.c]=x}else c[_.r]=x}}if(I.length>0)c["!rows"]=I}}();function Ui(e,r,t,a){var n=[],i=[],s=gt(e["!ref"]),l="",o,c="",f=[],u=0,h=0,d=e["!rows"];var p=Array.isArray(e);var m={r:c},v,g=-1;for(h=s.s.c;h<=s.e.c;++h)f[h]=ct(h);for(u=s.s.r;u<=s.e.r;++u){i=[];c=it(u);for(h=s.s.c;h<=s.e.c;++h){o=f[h]+c;var b=p?(e[u]||[])[h]:e[o];if(b===undefined)continue;if((l=Wi(b,o,e,r,t,a))!=null)i.push(l)}if(i.length>0||d&&d[u]){m={r:c};if(d&&d[u]){v=d[u];if(v.hidden)m.hidden=1;g=-1;if(v.hpx)g=on(v.hpx);else if(v.hpt)g=v.hpt;if(g>-1){m.ht=g;m.customHeight=1}if(v.level){m.outlineLevel=v.level}}n[n.length]=or("row",i.join(""),m)}}if(d)for(;u<d.length;++u){if(d&&d[u]){m={r:u+1};v=d[u];if(v.hidden)m.hidden=1;g=-1;if(v.hpx)g=on(v.hpx);else if(v.hpt)g=v.hpt;if(g>-1){m.ht=g;m.customHeight=1}if(v.level){m.outlineLevel=v.level}n[n.length]=or("row","",m)}}return n.join("")}var ji=or("worksheet",null,{xmlns:ur.main[0],"xmlns:r":ur.r});function Hi(e,r,t,a){var n=[Fe,ji];var i=t.SheetNames[e],s=0,l="";var o=t.Sheets[i];if(o==null)o={};var c=o["!ref"]||"A1";var f=gt(c);if(f.e.c>16383||f.e.r>1048575){if(r.WTF)throw new Error("Range "+c+" exceeds format limit A1:XFD1048576");f.e.c=Math.min(f.e.c,16383);f.e.r=Math.min(f.e.c,1048575);c=vt(f)}if(!a)a={};o["!comments"]=[];var u=[];Ai(o,t,e,r,n);n[n.length]=or("dimension",null,{ref:c});n[n.length]=Bi(o,r,e,t);if(r.sheetFormat)n[n.length]=or("sheetFormatPr",null,{defaultRowHeight:r.sheetFormat.defaultRowHeight||"16",baseColWidth:r.sheetFormat.baseColWidth||"10",outlineLevelRow:r.sheetFormat.outlineLevelRow||"7"});if(o["!cols"]!=null&&o["!cols"].length>0)n[n.length]=Ri(o,o["!cols"]);n[s=n.length]="<sheetData/>";o["!links"]=[];if(o["!ref"]!=null){l=Ui(o,r,e,t,a);if(l.length>0)n[n.length]=l}if(n.length>s+1){n[n.length]="</sheetData>";n[s]=n[s].replace("/>",">")}if(o["!protect"]!=null)n[n.length]=Ti(o["!protect"]);if(o["!autofilter"]!=null)n[n.length]=Ii(o["!autofilter"],o,t,e);if(o["!merges"]!=null&&o["!merges"].length>0)n[n.length]=Si(o["!merges"]);var h=-1,d,p=-1;if(o["!links"].length>0){n[n.length]="<hyperlinks>";o["!links"].forEach(function(e){if(!e[1].Target)return;d={ref:e[0]};if(e[1].Target.charAt(0)!="#"){p=oa(a,-1,We(e[1].Target).replace(/#.*$/,""),ta.HLINK);d["r:id"]="rId"+p}if((h=e[1].Target.indexOf("#"))>-1)d.location=We(e[1].Target.slice(h+1));if(e[1].Tooltip)d.tooltip=We(e[1].Tooltip);n[n.length]=or("hyperlink",null,d)});n[n.length]="</hyperlinks>"}delete o["!links"];if(o["!margins"]!=null)n[n.length]=Mi(o["!margins"]);if(!r||r.ignoreEC||r.ignoreEC==void 0)n[n.length]=sr("ignoredErrors",or("ignoredError",null,{numberStoredAsText:1,sqref:c}));if(u.length>0){p=oa(a,-1,"../drawings/drawing"+(e+1)+".xml",ta.DRAW);n[n.length]=or("drawing",null,{"r:id":"rId"+p});o["!drawing"]=u}if(o["!comments"].length>0){p=oa(a,-1,"../drawings/vmlDrawing"+(e+1)+".vml",ta.VML);n[n.length]=or("legacyDrawing",null,{"r:id":"rId"+p});o["!legacy"]=p}if(n.length>1){n[n.length]="</worksheet>";n[1]=n[1].replace("/>",">")}return n.join("")}ta.CHART="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";ta.CHARTEX="http://schemas.microsoft.com/office/2014/relationships/chartEx";function Vi(e){var r=[];var t=e.match(/^<c:numCache>/);var a;(e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm)||[]).forEach(function(e){var a=e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!a)return;r[+a[1]]=t?+a[2]:a[2]});var n=Le((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);(e.match(/<c:f>(.*?)<\/c:f>/gm)||[]).forEach(function(e){a=e.replace(/<.*?>/g,"")});return[r,n,a]}function Xi(e,r,t,a,n,i){var s=i||{"!type":"chart"};if(!e)return i;var l=0,o=0,c="A";var f={s:{r:2e6,c:2e6},e:{r:0,c:0}};(e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(e){var r=Vi(e);f.s.r=f.s.c=0;f.e.c=l;c=ct(l);r[0].forEach(function(e,t){s[c+it(t)]={t:"n",v:e,z:r[1]};o=t});if(f.e.r<o)f.e.r=o;++l});if(l>0)s["!ref"]=vt(f);return s}ta.CS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";var Gi=or("chartsheet",null,{xmlns:ur.main[0],"xmlns:r":ur.r});function Yi(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!drawel":null,"!rel":""};var s;var l=e.match(yi);if(l)Ci(l[0],i,n,t);if(s=e.match(/drawing r:id="(.*?)"/))i["!rel"]=s[1];if(a["!id"][i["!rel"]])i["!drawel"]=a["!id"][i["!rel"]];return i}function Ji(e,r,t,a){var n=[Fe,Gi];n[n.length]=or("drawing",null,{"r:id":"rId1"});oa(a,-1,"../drawings/drawing"+(e+1)+".xml",ta.DRAW);if(n.length>2){n[n.length]="</chartsheet>";n[1]=n[1].replace("/>",">")}return n.join("")}function qi(e,r){e.l+=10;var t=parse_XLWideString(e,r-10);return{name:t}}function Ki(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!drawel":null,"!rel":""};var s=[];var l=false;Kr(e,function o(e,a,c){switch(c){case 550:i["!rel"]=e;break;case 651:if(!n.Sheets[t])n.Sheets[t]={};if(e.name)n.Sheets[t].CodeName=e.name;break;case 562:;case 652:;case 669:;case 679:;case 551:;case 552:;case 476:;case 3072:break;case 35:l=true;break;case 36:l=false;break;case 37:s.push(a);break;case 38:s.pop();break;default:if((a||"").indexOf("Begin")>0)s.push(a);else if((a||"").indexOf("End")>0)s.pop();else if(!l||r.WTF)throw new Error("Unexpected record "+c+" "+a);}},r);if(a["!id"][i["!rel"]])i["!drawel"]=a["!id"][i["!rel"]];return i}function Zi(){var e=Zr();Qr(e,"BrtBeginSheet");Qr(e,"BrtEndSheet");return e.end()}var Qi=[["allowRefreshQuery",false,"bool"],["autoCompressPictures",true,"bool"],["backupFile",false,"bool"],["checkCompatibility",false,"bool"],["CodeName",""],["date1904",false,"bool"],["defaultThemeVersion",0,"int"],["filterPrivacy",false,"bool"],["hidePivotFieldList",false,"bool"],["promptedSolutions",false,"bool"],["publishItems",false,"bool"],["refreshAllConnections",false,"bool"],["saveExternalLinkValues",true,"bool"],["showBorderUnselectedTables",true,"bool"],["showInkAnnotation",true,"bool"],["showObjects","all"],["showPivotChartFilter",false,"bool"],["updateLinks","userSet"]];var es=[["activeTab",0,"int"],["autoFilterDateGrouping",true,"bool"],["firstSheet",0,"int"],["minimized",false,"bool"],["showHorizontalScroll",true,"bool"],["showSheetTabs",true,"bool"],["showVerticalScroll",true,"bool"],["tabRatio",600,"int"],["visibility","visible"]];var rs=[];var ts=[["calcCompleted","true"],["calcMode","auto"],["calcOnSave","true"],["concurrentCalc","true"],["fullCalcOnLoad","false"],["fullPrecision","true"],["iterate","false"],["iterateCount","100"],["iterateDelta","0.001"],["refMode","A1"]];function as(e,r){for(var t=0;t!=e.length;++t){var a=e[t];for(var n=0;n!=r.length;++n){var i=r[n];if(a[i[0]]==null)a[i[0]]=i[1];else switch(i[2]){case"bool":if(typeof a[i[0]]=="string")a[i[0]]=Ge(a[i[0]]);break;case"int":if(typeof a[i[0]]=="string")a[i[0]]=parseInt(a[i[0]],10);break;}}}}function ns(e,r){for(var t=0;t!=r.length;++t){var a=r[t];if(e[a[0]]==null)e[a[0]]=a[1];else switch(a[2]){case"bool":if(typeof e[a[0]]=="string")e[a[0]]=Ge(e[a[0]]);break;case"int":if(typeof e[a[0]]=="string")e[a[0]]=parseInt(e[a[0]],10);break;}}}function is(e){ns(e.WBProps,Qi);ns(e.CalcPr,ts);as(e.WBView,es);as(e.Sheets,rs);ii.date1904=Ge(e.WBProps.date1904)}function ss(e){if(!e.Workbook)return"false";if(!e.Workbook.WBProps)return"false";return Ge(e.Workbook.WBProps.date1904)?"true":"false"}var ls="][*?/\\".split("");function os(e,r){if(e.length>31){if(r)return false;throw new Error("Sheet names cannot exceed 31 chars")}var t=true;ls.forEach(function(a){if(e.indexOf(a)==-1)return;if(!r)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");t=false});return t}function cs(e,r,t){e.forEach(function(a,n){os(a);for(var i=0;i<n;++i)if(a==e[i])throw new Error("Duplicate Sheet Name: "+a);if(t){var s=r&&r[n]&&r[n].CodeName||a;if(s.charCodeAt(0)==95&&s.length>22)throw new Error("Bad Code Name: Worksheet"+s)}})}function fs(e){if(!e||!e.SheetNames||!e.Sheets)throw new Error("Invalid Workbook");if(!e.SheetNames.length)throw new Error("Workbook is empty");var r=e.Workbook&&e.Workbook.Sheets||[];cs(e.SheetNames,r,!!e.vbaraw);for(var t=0;t<e.SheetNames.length;++t)hi(e.Sheets[e.SheetNames[t]],e.SheetNames[t],t)}var us=/<\w+:workbook/;function hs(e,r){if(!e)throw new Error("Could not find file");var t={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""};var a=false,n="xmlns";var i={},s=0;e.replace(Oe,function l(o,c){var f=Ne(o);switch(Re(f[0])){case"<?xml":break;case"<workbook":if(o.match(us))n="xmlns"+o.match(/<(\w+):/)[1];t.xmlns=f[n];break;case"</workbook>":break;case"<fileVersion":delete f[0];t.AppVersion=f;break;case"<fileVersion/>":;case"</fileVersion>":break;case"<fileSharing":break;case"<fileSharing/>":break;case"<workbookPr":;case"<workbookPr/>":Qi.forEach(function(e){if(f[e[0]]==null)return;switch(e[2]){case"bool":t.WBProps[e[0]]=Ge(f[e[0]]);break;case"int":t.WBProps[e[0]]=parseInt(f[e[0]],10);break;default:t.WBProps[e[0]]=f[e[0]];}});if(f.codeName)t.WBProps.CodeName=Ye(f.codeName);break;case"</workbookPr>":break;case"<workbookProtection":break;case"<workbookProtection/>":break;case"<bookViews":;case"<bookViews>":;case"</bookViews>":break;case"<workbookView":;case"<workbookView/>":delete f[0];t.WBView.push(f);break;case"</workbookView>":break;case"<sheets":;case"<sheets>":;case"</sheets>":break;case"<sheet":switch(f.state){case"hidden":f.Hidden=1;break;case"veryHidden":f.Hidden=2;break;default:f.Hidden=0;}delete f.state;f.name=Le(Ye(f.name));delete f[0];t.Sheets.push(f);break;case"</sheet>":break;case"<functionGroups":;case"<functionGroups/>":break;case"<functionGroup":break;case"<externalReferences":;case"</externalReferences>":;case"<externalReferences>":break;case"<externalReference":break;case"<definedNames/>":break;case"<definedNames>":;case"<definedNames":a=true;break;case"</definedNames>":a=false;break;case"<definedName":{i={};i.Name=Ye(f.name);if(f.comment)i.Comment=f.comment;if(f.localSheetId)i.Sheet=+f.localSheetId;if(Ge(f.hidden||"0"))i.Hidden=true;s=c+o.length}break;case"</definedName>":{i.Ref=Le(Ye(e.slice(s,c)));t.Names.push(i)}break;case"<definedName/>":break;case"<calcPr":delete f[0];t.CalcPr=f;break;case"<calcPr/>":delete f[0];t.CalcPr=f;break;case"</calcPr>":break;case"<oleSize":break;case"<customWorkbookViews>":;case"</customWorkbookViews>":;case"<customWorkbookViews":break;case"<customWorkbookView":;case"</customWorkbookView>":break;case"<pivotCaches>":;case"</pivotCaches>":;case"<pivotCaches":break;case"<pivotCache":break;case"<smartTagPr":;case"<smartTagPr/>":break;case"<smartTagTypes":;case"<smartTagTypes>":;case"</smartTagTypes>":break;case"<smartTagType":break;case"<webPublishing":;case"<webPublishing/>":break;case"<fileRecoveryPr":;case"<fileRecoveryPr/>":break;case"<webPublishObjects>":;case"<webPublishObjects":;case"</webPublishObjects>":break;case"<webPublishObject":break;case"<extLst":;case"<extLst>":;case"</extLst>":;case"<extLst/>":break;case"<ext":a=true;break;case"</ext>":a=false;break;case"<ArchID":break;case"<AlternateContent":;case"<AlternateContent>":a=true;break;case"</AlternateContent>":a=false;break;case"<revisionPtr":break;default:if(!a&&r.WTF)throw new Error("unrecognized "+f[0]+" in workbook");}return o});if(ur.main.indexOf(t.xmlns)===-1)throw new Error("Unknown Namespace: "+t.xmlns);is(t);return t}var ds=or("workbook",null,{xmlns:ur.main[0],"xmlns:r":ur.r});function ps(e){var r=[Fe];r[r.length]=ds;var t=e.Workbook&&(e.Workbook.Names||[]).length>0;var a={codeName:"ThisWorkbook"};if(e.Workbook&&e.Workbook.WBProps){Qi.forEach(function(r){if(e.Workbook.WBProps[r[0]]==null)return;if(e.Workbook.WBProps[r[0]]==r[1])return;a[r[0]]=e.Workbook.WBProps[r[0]]});if(e.Workbook.WBProps.CodeName){a.codeName=e.Workbook.WBProps.CodeName;delete a.CodeName}}r[r.length]=or("workbookPr",null,a);var n=e.Workbook&&e.Workbook.Sheets||[];var i=0;if(n&&n[0]&&!!n[0].Hidden){r[r.length]="<bookViews>";for(i=0;i!=e.SheetNames.length;++i){if(!n[i])break;if(!n[i].Hidden)break}if(i==e.SheetNames.length)i=0;r[r.length]='<workbookView firstSheet="'+i+'" activeTab="'+i+'"/>';r[r.length]="</bookViews>"}r[r.length]="<sheets>";for(i=0;i!=e.SheetNames.length;++i){var s={name:We(e.SheetNames[i].slice(0,31))};s.sheetId=""+(i+1);s["r:id"]="rId"+(i+1);if(n[i])switch(n[i].Hidden){case 1:s.state="hidden";break;case 2:s.state="veryHidden";break;}r[r.length]=or("sheet",null,s)}r[r.length]="</sheets>";if(t){r[r.length]="<definedNames>";if(e.Workbook&&e.Workbook.Names)e.Workbook.Names.forEach(function(e){var t={name:e.Name};if(e.Comment)t.comment=e.Comment;if(e.Sheet!=null)t.localSheetId=""+e.Sheet;if(e.Hidden)t.hidden="1";if(!e.Ref)return;r[r.length]=or("definedName",We(e.Ref),t)});r[r.length]="</definedNames>"}if(r.length>2){r[r.length]="</workbook>";r[1]=r[1].replace("/>",">")}return r.join("")}function ms(e,r,t){if(r.slice(-4)===".bin")return parse_wb_bin(e,t);return hs(e,t)}function vs(e,r,t,a,n,i,s,l){if(r.slice(-4)===".bin")return parse_ws_bin(e,a,t,n,i,s,l);return _i(e,a,t,n,i,s,l)}function gs(e,r,t,a,n,i,s,l){if(r.slice(-4)===".bin")return Ki(e,a,t,n,i,s,l);return Yi(e,a,t,n,i,s,l)}function bs(e,r,t,a,n,i,s,l){if(r.slice(-4)===".bin")return Jn(e,a,t,n,i,s,l);return qn(e,a,t,n,i,s,l)}function ws(e,r,t,a,n,i,s,l){if(r.slice(-4)===".bin")return Gn(e,a,t,n,i,s,l);return Yn(e,a,t,n,i,s,l)}function ks(e,r,t,a){if(r.slice(-4)===".bin")return parse_sty_bin(e,t,a);return kn(e,t,a)}function ys(e,r,t){return Mn(e,t)}function xs(e,r,t){if(r.slice(-4)===".bin")return parse_sst_bin(e,t);return $a(e,t)}function _s(e,r,t){if(r.slice(-4)===".bin")return parse_comments_bin(e,t);return Wn(e,t)}function Ss(e,r,t){if(r.slice(-4)===".bin")return parse_cc_bin(e,r,t);return parse_cc_xml(e,r,t)}function Cs(e,r,t,a){if(t.slice(-4)===".bin")return Pn(e,r,t,a);return Rn(e,r,t,a)}function As(e,r,t){return(r.slice(-4)===".bin"?write_wb_bin:ps)(e,t)}function Es(e,r,t,a,n){return(r.slice(-4)===".bin"?write_ws_bin:Hi)(e,t,a,n)}function Fs(e,r,t,a,n){return(r.slice(-4)===".bin"?Zi:Ji)(e,t,a,n)}function Ts(e,r,t){return(r.slice(-4)===".bin"?write_sty_bin:xn)(e,t)}function Os(e,r,t){return(r.slice(-4)===".bin"?write_sst_bin:ja)(e,t)}function Ds(e,r,t){return(r.slice(-4)===".bin"?write_comments_bin:Un)(e,t)}var Ms=function(){function e(e,r){var t=r||{};if(v!=null&&t.dense==null)t.dense=v;var a=t.dense?[]:{};e=e.replace(/<!--.*?-->/g,"");var n=e.match(/<table/i);if(!n)throw new Error("Invalid HTML: could not find <table>");var i=e.match(/<\/table/i);var s=n.index,l=i&&i.index||e.length;var o=me(e.slice(s,l),/(:?<tr[^>]*>)/i,"<tr>");var c=-1,f=0,u=0,h=0;var d={s:{r:1e7,c:1e7},e:{r:0,c:0}};var p=[];for(s=0;s<o.length;++s){var m=o[s].trim();var g=m.slice(0,3).toLowerCase();if(g=="<tr"){++c;if(t.sheetRows&&t.sheetRows<=c){--c;break}f=0;continue}if(g!="<td"&&g!="<th")continue;var b=m.split(/<\/t[dh]>/i);for(l=0;l<b.length;++l){var w=b[l].trim();if(!w.match(/<t[dh]/i))continue;var k=w,y=0;while(k.charAt(0)=="<"&&(y=k.indexOf(">"))>-1)k=k.slice(y+1);for(var x=0;x<p.length;++x){var _=p[x];if(_.s.c==f&&_.s.r<c&&c<=_.e.r){f=_.e.c+1;x=-1}}var S=Ne(w.slice(0,w.indexOf(">")));h=S.colspan?+S.colspan:1;if((u=+S.rowspan)>1||h>1)p.push({s:{r:c,c:f},e:{r:c+(u||1)-1,c:f+h-1}});var C=S.t||"";if(!k.length){f+=h;continue}k=er(k);if(d.s.r>c)d.s.r=c;if(d.e.r<c)d.e.r=c;if(d.s.c>f)d.s.c=f;if(d.e.c<f)d.e.c=f;if(!k.length)continue;var A={t:"s",v:k};if(t.raw||!k.trim().length||C=="s"){}else if(k==="TRUE")A={t:"b",v:true};else if(k==="FALSE")A={t:"b",v:false};else if(!isNaN(he(k)))A={t:"n",v:he(k)};else if(!isNaN(de(k).getDate())){A={t:"d",v:oe(k)};if(!t.cellDates)A={t:"n",v:ee(A.v)};A.z=t.dateNF||N._table[14]}if(t.dense){if(!a[c])a[c]=[];a[c][f]=A}else a[pt({r:c,c:f})]=A;f+=h}}a["!ref"]=vt(d);if(p.length)a["!merges"]=p;return a}function r(r,t){return kt(e(r,t),t)}function t(e,r,t,a){var n=e["!merges"]||[];var i=[];for(var s=r.s.c;s<=r.e.c;++s){var l=0,o=0;for(var c=0;c<n.length;++c){if(n[c].s.r>t||n[c].s.c>s)continue;if(n[c].e.r<t||n[c].e.c<s)continue;if(n[c].s.r<t||n[c].s.c<s){l=-1;break}l=n[c].e.r-n[c].s.r+1;o=n[c].e.c-n[c].s.c+1;break}if(l<0)continue;var f=pt({r:t,c:s});var u=a.dense?(e[t]||[])[s]:e[f];var h=u&&u.v!=null&&(u.h||je(u.w||(wt(u),u.w)||""))||"";var d={};if(l>1)d.rowspan=l;if(o>1)d.colspan=o;d.t=u&&u.t||"z";if(a.editable)h='<span contenteditable="true">'+h+"</span>";d.id=(a.id||"sjs")+"-"+f;if(d.t!="z"){d.v=u.v;if(u.z!=null)d.z=u.z}i.push(or("td",h,d))}var p="<tr>";return p+i.join("")+"</tr>"}function a(e,r,t){var a=[];return a.join("")+"<table"+(t&&t.id?' id="'+t.id+'"':"")+">"}var n='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var i="</body></html>";function s(e,r){var s=r||{};var l=s.header!=null?s.header:n;var o=s.footer!=null?s.footer:i;var c=[l];var f=mt(e["!ref"]);s.dense=Array.isArray(e);c.push(a(e,f,s));for(var u=f.s.r;u<=f.e.r;++u)c.push(t(e,f,u,s));c.push("</table>"+o);return c.join("")}return{to_workbook:r,to_sheet:e,_row:t,BEGIN:n,END:i,_preamble:a,from_sheet:s}}();function Ns(e,r,t){var a=t||{};if(v!=null)a.dense=v;var n=0,i=0;if(a.origin!=null){if(typeof a.origin=="number")n=a.origin;else{var s=typeof a.origin=="string"?dt(a.origin):a.origin;n=s.r;i=s.c}}var l=r.getElementsByTagName("tr");var o=Math.min(a.sheetRows||1e7,l.length);var c={s:{r:0,c:0},e:{r:n,c:i}};if(e["!ref"]){var f=mt(e["!ref"]);c.s.r=Math.min(c.s.r,f.s.r);c.s.c=Math.min(c.s.c,f.s.c);c.e.r=Math.max(c.e.r,f.e.r);c.e.c=Math.max(c.e.c,f.e.c);if(n==-1)c.e.r=n=f.e.r+1}var u=[],h=0;var d=e["!rows"]||(e["!rows"]=[]);var p=0,m=0,g=0,b=0,w=0,k=0;if(!e["!cols"])e["!cols"]=[];for(;p<l.length&&m<o;++p){var y=l[p];if(Is(y)){if(a.display)continue;d[m]={hidden:true}}var x=y.children;for(g=b=0;g<x.length;++g){var _=x[g];if(a.display&&Is(_))continue;var S=_.hasAttribute("v")?_.getAttribute("v"):er(_.innerHTML);var C=_.getAttribute("z");for(h=0;h<u.length;++h){var A=u[h];if(A.s.c==b+i&&A.s.r<m+n&&m+n<=A.e.r){b=A.e.c+1-i;h=-1}}k=+_.getAttribute("colspan")||1;if((w=+_.getAttribute("rowspan")||1)>1||k>1)u.push({s:{r:m+n,c:b+i},e:{r:m+n+(w||1)-1,c:b+i+(k||1)-1}});var E={t:"s",v:S};var F=_.getAttribute("t")||"";if(S!=null){if(S.length==0)E.t=F||"z";else if(a.raw||S.trim().length==0||F=="s"){}else if(S==="TRUE")E={t:"b",v:true};else if(S==="FALSE")E={t:"b",v:false};else if(!isNaN(he(S)))E={t:"n",v:he(S)};else if(!isNaN(de(S).getDate())){E={t:"d",v:oe(S)};if(!a.cellDates)E={t:"n",v:ee(E.v)};E.z=a.dateNF||N._table[14]}}if(E.z===undefined&&C!=null)E.z=C;if(a.dense){if(!e[m+n])e[m+n]=[];e[m+n][b+i]=E}else e[pt({c:b+i,r:m+n})]=E;if(c.e.c<b+i)c.e.c=b+i;b+=k}++m}if(u.length)e["!merges"]=(e["!merges"]||[]).concat(u);c.e.r=Math.max(c.e.r,m-1+n);e["!ref"]=vt(c);if(m>=o)e["!fullref"]=vt((c.e.r=l.length-p+m-1+n,c));return e}function Rs(e,r){var t=r||{};var a=t.dense?[]:{};return Ns(a,e,r)}function Ps(e,r){return kt(Rs(e,r),r)}function Is(e){var r="";var t=Ls(e);if(t)r=t(e).getPropertyValue("display");if(!r)r=e.style.display;return r==="none"}function Ls(e){if(e.ownerDocument.defaultView&&typeof e.ownerDocument.defaultView.getComputedStyle==="function")return e.ownerDocument.defaultView.getComputedStyle;if(typeof getComputedStyle==="function")return getComputedStyle;return null}var zs=function(){var e=function(e){var r=e.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function(e,r){return Array(parseInt(r,10)+1).join(" ")}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n");var t=Le(r.replace(/<[^>]*>/g,""));return[t]};var r={day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],quarter:["\\Qm",'m\\"th quarter"']};return function t(a,n){var i=n||{};if(v!=null&&i.dense==null)i.dense=v;var s=xlml_normalize(a);var l=[],o;var c;var f={name:""},u="",h=0;var d;var p;var m={},g=[];var b=i.dense?[]:{};var w,k;var y={value:""};var x="",_=0,S;var C=[];var A=-1,E=-1,F={s:{r:1e6,c:1e7},e:{r:0,c:0}};var T=0;var O={};var D=[],M={},N=0,R=0;var P=[],I=1,L=1;var z=[];var B={Names:[]};var W={};var $=["",""];var U=[],j={};var H="",V=0;var X=false,G=false;var Y=0;xlmlregex.lastIndex=0;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(w=xlmlregex.exec(s))switch(w[3]=w[3].replace(/_.*$/,"")){case"table":;case"工作表":if(w[1]==="/"){if(F.e.c>=F.s.c&&F.e.r>=F.s.r)b["!ref"]=vt(F);else b["!ref"]="A1:A1";if(i.sheetRows>0&&i.sheetRows<=F.e.r){b["!fullref"]=b["!ref"];F.e.r=i.sheetRows-1;b["!ref"]=vt(F)}if(D.length)b["!merges"]=D;if(P.length)b["!rows"]=P;d.name=d["名称"]||d.name;if(typeof JSON!=="undefined")JSON.stringify(d);g.push(d.name);m[d.name]=b;G=false}else if(w[0].charAt(w[0].length-2)!=="/"){d=Ne(w[0],false);A=E=-1;F.s.r=F.s.c=1e7;F.e.r=F.e.c=0;b=i.dense?[]:{};D=[];P=[];G=true}break;case"table-row-group":if(w[1]==="/")--T;else++T;break;case"table-row":;case"行":if(w[1]==="/"){A+=I;I=1;break}p=Ne(w[0],false);if(p["行号"])A=p["行号"]-1;else if(A==-1)A=0;I=+p["number-rows-repeated"]||1;if(I<10)for(Y=0;Y<I;++Y)if(T>0)P[A+Y]={level:T};E=-1;break;case"covered-table-cell":if(w[1]!=="/")++E;if(i.sheetStubs){if(i.dense){if(!b[A])b[A]=[];b[A][E]={t:"z"}}else b[pt({r:A,c:E})]={t:"z"}}x="";C=[];break;case"table-cell":;case"数据":if(w[0].charAt(w[0].length-2)==="/"){++E;y=Ne(w[0],false);L=parseInt(y["number-columns-repeated"]||"1",10);k={t:"z",v:null};if(y.formula&&i.cellFormula!=false)k.f=ods_to_csf_formula(Le(y.formula));if((y["数据类型"]||y["value-type"])=="string"){k.t="s";k.v=Le(y["string-value"]||"");if(i.dense){if(!b[A])b[A]=[];b[A][E]=k}else{b[pt({r:A,c:E})]=k}}E+=L-1}else if(w[1]!=="/"){++E;L=1;var J=I?A+I-1:A;if(E>F.e.c)F.e.c=E;if(E<F.s.c)F.s.c=E;if(A<F.s.r)F.s.r=A;if(J>F.e.r)F.e.r=J;y=Ne(w[0],false);U=[];j={};k={t:y["数据类型"]||y["value-type"],v:null};if(i.cellFormula){if(y.formula)y.formula=Le(y.formula);if(y["number-matrix-columns-spanned"]&&y["number-matrix-rows-spanned"]){N=parseInt(y["number-matrix-rows-spanned"],10)||0;R=parseInt(y["number-matrix-columns-spanned"],10)||0;M={s:{r:A,c:E},e:{r:A+N-1,c:E+R-1}};k.F=vt(M);z.push([M,k.F])}if(y.formula)k.f=ods_to_csf_formula(y.formula);else for(Y=0;Y<z.length;++Y)if(A>=z[Y][0].s.r&&A<=z[Y][0].e.r)if(E>=z[Y][0].s.c&&E<=z[Y][0].e.c)k.F=z[Y][1]}if(y["number-columns-spanned"]||y["number-rows-spanned"]){N=parseInt(y["number-rows-spanned"],10)||0;R=parseInt(y["number-columns-spanned"],10)||0;M={s:{r:A,c:E},e:{r:A+N-1,c:E+R-1}};D.push(M)}if(y["number-columns-repeated"])L=parseInt(y["number-columns-repeated"],10);switch(k.t){case"boolean":k.t="b";k.v=Ge(y["boolean-value"]);break;case"float":k.t="n";k.v=parseFloat(y.value);break;case"percentage":k.t="n";k.v=parseFloat(y.value);break;case"currency":k.t="n";k.v=parseFloat(y.value);break;case"date":k.t="d";k.v=oe(y["date-value"]);if(!i.cellDates){k.t="n";k.v=ee(k.v)}k.z="m/d/yy";break;case"time":k.t="n";k.v=ie(y["time-value"])/86400;break;case"number":k.t="n";k.v=parseFloat(y["数据数值"]);break;default:if(k.t==="string"||k.t==="text"||!k.t){k.t="s";if(y["string-value"]!=null){x=Le(y["string-value"]);C=[]}}else throw new Error("Unsupported value type "+k.t);}}else{X=false;if(k.t==="s"){k.v=x||"";if(C.length)k.R=C;X=_==0}if(W.Target)k.l=W;if(U.length>0){k.c=U;U=[]}if(x&&i.cellText!==false)k.w=x;if(X){k.t="z";delete k.v}if(!X||i.sheetStubs){if(!(i.sheetRows&&i.sheetRows<=A)){for(var q=0;q<I;++q){L=parseInt(y["number-columns-repeated"]||"1",10);if(i.dense){if(!b[A+q])b[A+q]=[];b[A+q][E]=q==0?k:fe(k);while(--L>0)b[A+q][E+L]=fe(k)}else{b[pt({r:A+q,c:E})]=k;while(--L>0)b[pt({r:A+q,c:E+L})]=fe(k)}if(F.e.c<=E)F.e.c=E}}}L=parseInt(y["number-columns-repeated"]||"1",10);E+=L-1;L=0;k={};x="";C=[]}W={};break;case"document":;case"document-content":;case"电子表格文档":;case"spreadsheet":;case"主体":;case"scripts":;case"styles":;case"font-face-decls":;case"master-styles":if(w[1]==="/"){if((o=l.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/")l.push([w[3],true]);break;case"annotation":if(w[1]==="/"){if((o=l.pop())[0]!==w[3])throw"Bad state: "+o;j.t=x;if(C.length)j.R=C;j.a=H;U.push(j)}else if(w[0].charAt(w[0].length-2)!=="/"){l.push([w[3],false])}H="";V=0;x="";_=0;C=[];break;case"creator":if(w[1]==="/"){H=s.slice(V,w.index)}else V=w.index+w[0].length;break;case"meta":;case"元数据":;case"settings":;case"config-item-set":;case"config-item-map-indexed":;case"config-item-map-entry":;case"config-item-map-named":;case"shapes":;case"frame":;case"text-box":;case"image":;case"data-pilot-tables":;case"list-style":;case"form":;case"dde-links":;case"event-listeners":;case"chart":if(w[1]==="/"){if((o=l.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/")l.push([w[3],false]);x="";_=0;C=[];break;case"scientific-number":break;case"currency-symbol":break;case"currency-style":break;case"number-style":;case"percentage-style":;case"date-style":;case"time-style":if(w[1]==="/"){O[f.name]=u;if((o=l.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/"){u="";f=Ne(w[0],false);l.push([w[3],true])}break;case"script":break;case"libraries":break;case"automatic-styles":break;case"default-style":;case"page-layout":break;case"style":break;case"map":break;case"font-face":break;case"paragraph-properties":break;case"table-properties":break;case"table-column-properties":break;case"table-row-properties":break;case"table-cell-properties":break;case"number":switch(l[l.length-1][0]){case"time-style":;case"date-style":c=Ne(w[0],false);u+=r[w[3]][c.style==="long"?1:0];break;}break;case"fraction":break;case"day":;case"month":;case"year":;case"era":;case"day-of-week":;case"week-of-year":;case"quarter":;case"hours":;case"minutes":;case"seconds":;case"am-pm":switch(l[l.length-1][0]){case"time-style":;case"date-style":c=Ne(w[0],false);u+=r[w[3]][c.style==="long"?1:0];break;}break;case"boolean-style":break;case"boolean":break;case"text-style":break;case"text":if(w[0].slice(-2)==="/>")break;else if(w[1]==="/")switch(l[l.length-1][0]){case"number-style":;case"date-style":;case"time-style":u+=s.slice(h,w.index);break;}else h=w.index+w[0].length;break;case"named-range":c=Ne(w[0],false);$=ods_to_csf_3D(c["cell-range-address"]);var K={Name:c.name,Ref:$[0]+"!"+$[1]};if(G)K.Sheet=g.length;B.Names.push(K);break;case"text-content":break;case"text-properties":break;case"embedded-text":break;case"body":;case"电子表格":break;case"forms":break;case"table-column":break;case"table-header-rows":break;case"table-rows":break;case"table-column-group":break;case"table-header-columns":break;case"table-columns":break;case"null-date":break;case"graphic-properties":break;case"calculation-settings":break;case"named-expressions":break;case"label-range":break;case"label-ranges":break;case"named-expression":break;case"sort":break;case"sort-by":break;case"sort-groups":break;case"tab":break;case"line-break":break;case"span":break;case"p":;case"文本串":if(["master-styles"].indexOf(l[l.length-1][0])>-1)break;if(w[1]==="/"&&(!y||!y["string-value"])){var Z=e(s.slice(_,w.index),S);x=(x.length>0?x+"\n":"")+Z[0]}else{S=Ne(w[0],false);_=w.index+w[0].length}break;case"s":break;case"database-range":if(w[1]==="/")break;try{$=ods_to_csf_3D(Ne(w[0])["target-range-address"]);m[$[0]]["!autofilter"]={ref:$[1]}}catch(Q){}break;case"date":break;case"object":break;case"title":;case"标题":break;case"desc":break;case"binary-data":break;case"table-source":break;case"scenario":break;case"iteration":break;case"content-validations":break;case"content-validation":break;case"help-message":break;case"error-message":break;case"database-ranges":break;case"filter":break;case"filter-and":break;case"filter-or":break;case"filter-condition":break;case"list-level-style-bullet":break;case"list-level-style-number":break;case"list-level-properties":break;case"sender-firstname":;case"sender-lastname":;case"sender-initials":;case"sender-title":;case"sender-position":;case"sender-email":;case"sender-phone-private":;case"sender-fax":;case"sender-company":;case"sender-phone-work":;case"sender-street":;case"sender-city":;case"sender-postal-code":;case"sender-country":;case"sender-state-or-province":;case"author-name":;case"author-initials":;case"chapter":;case"file-name":;case"template-name":;case"sheet-name":
break;case"event-listener":break;case"initial-creator":;case"creation-date":;case"print-date":;case"generator":;case"document-statistic":;case"user-defined":;case"editing-duration":;case"editing-cycles":break;case"config-item":break;case"page-number":break;case"page-count":break;case"time":break;case"cell-range-source":break;case"detective":break;case"operation":break;case"highlighted-range":break;case"data-pilot-table":;case"source-cell-range":;case"source-service":;case"data-pilot-field":;case"data-pilot-level":;case"data-pilot-subtotals":;case"data-pilot-subtotal":;case"data-pilot-members":;case"data-pilot-member":;case"data-pilot-display-info":;case"data-pilot-sort-info":;case"data-pilot-layout-info":;case"data-pilot-field-reference":;case"data-pilot-groups":;case"data-pilot-group":;case"data-pilot-group-member":break;case"rect":break;case"dde-connection-decls":;case"dde-connection-decl":;case"dde-link":;case"dde-source":break;case"properties":break;case"property":break;case"a":if(w[1]!=="/"){W=Ne(w[0],false);if(!W.href)break;W.Target=W.href;delete W.href;if(W.Target.charAt(0)=="#"&&W.Target.indexOf(".")>-1){$=ods_to_csf_3D(W.Target.slice(1));W.Target="#"+$[0]+"!"+$[1]}}break;case"table-protection":break;case"data-pilot-grand-total":break;case"office-document-common-attrs":break;default:switch(w[2]){case"dc:":;case"calcext:":;case"loext:":;case"ooo:":;case"chartooo:":;case"draw:":;case"style:":;case"chart:":;case"form:":;case"uof:":;case"表:":;case"字:":break;default:if(i.WTF)throw new Error(w);};}var re={Sheets:m,SheetNames:g,Workbook:B};if(i.bookSheets)delete re.Sheets;return re}}();function Bs(e,r){r=r||{};var t=!!we(e,"objectdata");if(t)parse_manifest(ye(e,"META-INF/manifest.xml"),r);var a=xe(e,"content.xml");if(!a)throw new Error("Missing content.xml in "+(t?"ODS":"UOF")+" file");var n=zs(t?a:Ye(a),r);if(we(e,"meta.xml"))n.Props=ua(ye(e,"meta.xml"));return n}function Ws(e,r){return zs(e,r)}var $s=function(){var e="<office:document-styles "+lr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","office:version":"1.2"})+"></office:document-styles>";return function r(){return Fe+e}}();var Us=function(){var e=function(e){return We(e).replace(/  +/g,function(e){return'<text:s text:c="'+e.length+'"/>'}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"<text:line-break/>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>")};var r="          <table:table-cell />\n";var t="          <table:covered-table-cell/>\n";var a=function(a,n,i){var s=[];s.push('      <table:table table:name="'+We(n.SheetNames[i])+'" table:style-name="ta1">\n');var l=0,o=0,c=mt(a["!ref"]);var f=a["!merges"]||[],u=0;var h=Array.isArray(a);for(l=0;l<c.s.r;++l)s.push("        <table:table-row></table:table-row>\n");for(;l<=c.e.r;++l){s.push("        <table:table-row>\n");for(o=0;o<c.s.c;++o)s.push(r);for(;o<=c.e.c;++o){var d=false,p={},m="";for(u=0;u!=f.length;++u){if(f[u].s.c>o)continue;if(f[u].s.r>l)continue;if(f[u].e.c<o)continue;if(f[u].e.r<l)continue;if(f[u].s.c!=o||f[u].s.r!=l)d=true;p["table:number-columns-spanned"]=f[u].e.c-f[u].s.c+1;p["table:number-rows-spanned"]=f[u].e.r-f[u].s.r+1;break}if(d){s.push(t);continue}var v=pt({r:l,c:o}),g=h?(a[l]||[])[o]:a[v];if(g&&g.f){p["table:formula"]=We(csf_to_ods_formula(g.f));if(g.F){if(g.F.slice(0,v.length)==v){var b=mt(g.F);p["table:number-matrix-columns-spanned"]=b.e.c-b.s.c+1;p["table:number-matrix-rows-spanned"]=b.e.r-b.s.r+1}}}if(!g){s.push(r);continue}switch(g.t){case"b":m=g.v?"TRUE":"FALSE";p["office:value-type"]="boolean";p["office:boolean-value"]=g.v?"true":"false";break;case"n":m=g.w||String(g.v||0);p["office:value-type"]="float";p["office:value"]=g.v||0;break;case"s":;case"str":m=g.v==null?"":g.v;p["office:value-type"]="string";break;case"d":m=g.w||oe(g.v).toISOString();p["office:value-type"]="date";p["office:date-value"]=oe(g.v).toISOString();p["table:style-name"]="ce1";break;default:s.push(r);continue;}var w=e(m);if(g.l&&g.l.Target){var k=g.l.Target;k=k.charAt(0)=="#"?"#"+csf_to_ods_3D(k.slice(1)):k;w=or("text:a",w,{"xlink:href":k})}s.push("          "+or("table:table-cell",or("text:p",w,{}),p)+"\n")}s.push("        </table:table-row>\n")}s.push("      </table:table>\n");return s.join("")};var n=function(e){e.push(" <office:automatic-styles>\n");e.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');e.push('   <number:month number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push('   <number:day number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push("   <number:year/>\n");e.push("  </number:date-style>\n");e.push('  <style:style style:name="ta1" style:family="table">\n');e.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');e.push("  </style:style>\n");e.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');e.push(" </office:automatic-styles>\n")};return function i(e,r){var t=[Fe];var i=lr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:meta":"urn:oasis:names:tc:opendocument:xmlns:meta:1.0","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:presentation":"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:chart":"urn:oasis:names:tc:opendocument:xmlns:chart:1.0","xmlns:dr3d":"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0","xmlns:math":"http://www.w3.org/1998/Math/MathML","xmlns:form":"urn:oasis:names:tc:opendocument:xmlns:form:1.0","xmlns:script":"urn:oasis:names:tc:opendocument:xmlns:script:1.0","xmlns:ooo":"http://openoffice.org/2004/office","xmlns:ooow":"http://openoffice.org/2004/writer","xmlns:oooc":"http://openoffice.org/2004/calc","xmlns:dom":"http://www.w3.org/2001/xml-events","xmlns:xforms":"http://www.w3.org/2002/xforms","xmlns:xsd":"http://www.w3.org/2001/XMLSchema","xmlns:xsi":"http://www.w3.org/2001/XMLSchema-instance","xmlns:sheet":"urn:oasis:names:tc:opendocument:sh33tjs:1.0","xmlns:rpt":"http://openoffice.org/2005/report","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","xmlns:xhtml":"http://www.w3.org/1999/xhtml","xmlns:grddl":"http://www.w3.org/2003/g/data-view#","xmlns:tableooo":"http://openoffice.org/2009/table","xmlns:drawooo":"http://openoffice.org/2010/draw","xmlns:calcext":"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0","xmlns:loext":"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0","xmlns:field":"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0","xmlns:formx":"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0","xmlns:css3t":"http://www.w3.org/TR/css3-text/","office:version":"1.2"});var s=lr({"xmlns:config":"urn:oasis:names:tc:opendocument:xmlns:config:1.0","office:mimetype":"application/vnd.oasis.opendocument.spreadsheet"});if(r.bookType=="fods")t.push("<office:document"+i+s+">\n");else t.push("<office:document-content"+i+">\n");n(t);t.push("  <office:body>\n");t.push("    <office:spreadsheet>\n");for(var l=0;l!=e.SheetNames.length;++l)t.push(a(e.Sheets[e.SheetNames[l]],e,l,r));t.push("    </office:spreadsheet>\n");t.push("  </office:body>\n");if(r.bookType=="fods")t.push("</office:document>");else t.push("</office:document-content>");return t.join("")}}();function js(e,r){if(r.bookType=="fods")return Us(e,r);var t=Ce();var a="";var n=[];var i=[];a="mimetype";Se(t,a,"application/vnd.oasis.opendocument.spreadsheet");a="content.xml";Se(t,a,Us(e,r));n.push([a,"text/xml"]);i.push([a,"ContentFile"]);a="styles.xml";Se(t,a,$s(e,r));n.push([a,"text/xml"]);i.push([a,"StylesFile"]);a="meta.xml";Se(t,a,write_meta_ods());n.push([a,"text/xml"]);i.push([a,"MetadataFile"]);a="manifest.rdf";Se(t,a,write_rdf(i));n.push([a,"application/rdf+xml"]);a="META-INF/manifest.xml";Se(t,a,write_manifest(n));return t}function Hs(e,r){if(!r)return 0;var t=e.SheetNames.indexOf(r);if(t==-1)throw new Error("Sheet not found: "+r);return t}function Vs(e){return function r(t,a){var n=Hs(t,a.sheet);return e.from_sheet(t.Sheets[t.SheetNames[n]],a,t)}}var Xs=Vs(Ms);var Gs=Vs({from_sheet:Pl});var Ys=Vs(typeof Aa!=="undefined"?Aa:{});var Js=Vs(typeof Ea!=="undefined"?Ea:{});var qs=Vs(typeof Ta!=="undefined"?Ta:{});var Ks=Vs(typeof RTF!=="undefined"?RTF:{});var Zs=Vs({from_sheet:Il});var Qs=Vs(typeof Ca!=="undefined"?Ca:{});var el=Vs(typeof Fa!=="undefined"?Fa:{});function rl(e){return function r(t){for(var a=0;a!=e.length;++a){var n=e[a];if(t[n[0]]===undefined)t[n[0]]=n[1];if(n[2]==="n")t[n[0]]=Number(t[n[0]])}}}var tl=function(e){rl([["cellNF",false],["cellHTML",true],["cellFormula",true],["cellStyles",false],["cellText",true],["cellDates",false],["sheetStubs",false],["sheetRows",0,"n"],["bookDeps",false],["bookSheets",false],["bookProps",false],["bookFiles",false],["bookVBA",false],["password",""],["WTF",false]])(e)};var al=rl([["cellDates",false],["bookSST",false],["bookType","xlsx"],["compression",false],["WTF",false]]);function nl(e){if(ta.WS.indexOf(e)>-1)return"sheet";if(ta.CS&&e==ta.CS)return"chart";if(ta.DS&&e==ta.DS)return"dialog";if(ta.MS&&e==ta.MS)return"macro";return e&&e.length?e:"sheet"}function il(e,r){if(!e)return 0;try{e=r.map(function a(r){if(!r.id)r.id=r.strRelID;return[r.name,e["!id"][r.id].Target,nl(e["!id"][r.id].Type)]})}catch(t){return null}return!e||e.length===0?null:e}function sl(e,r,t,a,n,i,s,l,o,c,f,u){try{i[a]=na(xe(e,t,true),r);var h=ye(e,r);var d;switch(l){case"sheet":d=vs(h,r,n,o,i[a],c,f,u);break;case"chart":d=gs(h,r,n,o,i[a],c,f,u);if(!d||!d["!drawel"])break;var p=Ee(d["!drawel"].Target,r);var m=aa(p);var v=In(xe(e,p,true),na(xe(e,m,true),p));var g=Ee(v,p);var b=aa(g);d=Xi(xe(e,g,true),g,o,na(xe(e,b,true),g),c,d);break;case"macro":d=bs(h,r,n,o,i[a],c,f,u);break;case"dialog":d=ws(h,r,n,o,i[a],c,f,u);break;default:throw new Error("Unrecognized sheet type "+l);}s[a]=d;var w=[];if(i&&i[a])Y(i[a]).forEach(function(t){if(i[a][t].Type==ta.CMNT){var n=Ee(i[a][t].Target,r);w=_s(ye(e,n,true),n,o);if(!w||!w.length)return;Bn(d,w)}})}catch(k){if(o.WTF)throw k}}function ll(e){return e.charAt(0)=="/"?e.slice(1):e}function ol(e,r){R(N);r=r||{};tl(r);if(we(e,"META-INF/manifest.xml"))return Bs(e,r);if(we(e,"objectdata.xml"))return Bs(e,r);if(we(e,"Index/Document.iwa"))throw new Error("Unsupported NUMBERS file");var t=_e(e);var a=Zt(xe(e,"[Content_Types].xml"));var n=false;var i,s;if(a.workbooks.length===0){s="xl/workbook.xml";if(ye(e,s,true))a.workbooks.push(s)}if(a.workbooks.length===0){s="xl/workbook.bin";if(!ye(e,s,true))throw new Error("Could not find workbook");a.workbooks.push(s);n=true}if(a.workbooks[0].slice(-3)=="bin")n=true;var l={};var o={};if(!r.bookSheets&&!r.bookProps){ni=[];if(a.sst)try{ni=xs(ye(e,ll(a.sst)),a.sst,r)}catch(c){if(r.WTF)throw c}if(r.cellStyles&&a.themes.length)l=ys(xe(e,a.themes[0].replace(/^\//,""),true)||"",a.themes[0],r);if(a.style)o=ks(ye(e,ll(a.style)),a.style,l,r)}a.links.map(function(t){try{var a=na(xe(e,aa(ll(t))),t);return Cs(ye(e,ll(t)),a,t,r)}catch(n){}});var f=ms(ye(e,ll(a.workbooks[0])),a.workbooks[0],r);var u={},h="";if(a.coreprops.length){h=ye(e,ll(a.coreprops[0]),true);if(h)u=ua(h);if(a.extprops.length!==0){h=ye(e,ll(a.extprops[0]),true);if(h)ba(h,u,r)}}var d={};if(!r.bookSheets||r.bookProps){if(a.custprops.length!==0){h=xe(e,ll(a.custprops[0]),true);if(h)d=xa(h,r)}}var p={};if(r.bookSheets||r.bookProps){if(f.Sheets)i=f.Sheets.map(function O(e){return e.name});else if(u.Worksheets&&u.SheetNames.length>0)i=u.SheetNames;if(r.bookProps){p.Props=u;p.Custprops=d}if(r.bookSheets&&typeof i!=="undefined")p.SheetNames=i;if(r.bookSheets?p.SheetNames:r.bookProps)return p}i={};var m={};if(r.bookDeps&&a.calcchain)m=Ss(ye(e,ll(a.calcchain)),a.calcchain,r);var v=0;var g={};var b,w;{var k=f.Sheets;u.Worksheets=k.length;u.SheetNames=[];for(var y=0;y!=k.length;++y){u.SheetNames[y]=k[y].name}}var x=n?"bin":"xml";var _=a.workbooks[0].lastIndexOf("/");var S=(a.workbooks[0].slice(0,_+1)+"_rels/"+a.workbooks[0].slice(_+1)+".rels").replace(/^\//,"");if(!we(e,S))S="xl/_rels/workbook."+x+".rels";var C=na(xe(e,S,true),S);if(C)C=il(C,f.Sheets);var A=ye(e,"xl/worksheets/sheet.xml",true)?1:0;e:for(v=0;v!=u.Worksheets;++v){var E="sheet";if(C&&C[v]){b="xl/"+C[v][1].replace(/[\/]?xl\//,"");if(!we(e,b))b=C[v][1];if(!we(e,b))b=S.replace(/_rels\/.*$/,"")+C[v][1];E=C[v][2]}else{b="xl/worksheets/sheet"+(v+1-A)+"."+x;b=b.replace(/sheet0\./,"sheet.")}w=b.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");if(r&&r.sheets!=null)switch(typeof r.sheets){case"number":if(v!=r.sheets)continue e;break;case"string":if(u.SheetNames[v].toLowerCase()!=r.sheets.toLowerCase())continue e;break;default:if(Array.isArray&&Array.isArray(r.sheets)){var F=false;for(var T=0;T!=r.sheets.length;++T){if(typeof r.sheets[T]=="number"&&r.sheets[T]==v)F=1;if(typeof r.sheets[T]=="string"&&r.sheets[T].toLowerCase()==u.SheetNames[v].toLowerCase())F=1}if(!F)continue e};}sl(e,b,w,u.SheetNames[v],v,g,i,E,r,f,l,o)}p={Directory:a,Workbook:f,Props:u,Custprops:d,Deps:m,Sheets:i,SheetNames:u.SheetNames,Strings:ni,Styles:o,Themes:l,SSF:N.get_table()};if(r&&r.bookFiles){p.keys=t;p.files=e.files}if(r&&r.bookVBA){if(a.vba.length>0)p.vbaraw=ye(e,ll(a.vba[0]),true);else if(a.defaults&&a.defaults.bin===jn)p.vbaraw=ye(e,"xl/vbaProject.bin",true)}return p}function cl(e,r){var t=r||{};var a="Workbook",n=j.find(e,a);try{a="/!DataSpaces/Version";n=j.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);parse_DataSpaceVersionInfo(n.content);a="/!DataSpaces/DataSpaceMap";n=j.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var i=parse_DataSpaceMap(n.content);if(i.length!==1||i[0].comps.length!==1||i[0].comps[0].t!==0||i[0].name!=="StrongEncryptionDataSpace"||i[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";n=j.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var s=parse_DataSpaceDefinition(n.content);if(s.length!=1||s[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";n=j.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);parse_Primary(n.content)}catch(l){}a="/EncryptionInfo";n=j.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var o=parse_EncryptionInfo(n.content);a="/EncryptedPackage";n=j.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);if(o[0]==4&&typeof decrypt_agile!=="undefined")return decrypt_agile(o[1],n.content,t.password||"",t);if(o[0]==2&&typeof decrypt_std76!=="undefined")return decrypt_std76(o[1],n.content,t.password||"",t);throw new Error("File is password-protected")}function fl(e,r){Ln=1024;if(r.bookType=="ods")return js(e,r);if(e&&!e.SSF){e.SSF=N.get_table()}if(e&&e.SSF){R(N);N.load_table(e.SSF);r.revssf=K(e.SSF);r.revssf[e.SSF[65535]]=0;r.ssf=e.SSF}r.rels={};r.wbrels={};r.Strings=[];r.Strings.Count=0;r.Strings.Unique=0;if(si)r.revStrings=new Map;else{r.revStrings={};r.revStrings.foo=[];delete r.revStrings.foo}var t=r.bookType=="xlsb"?"bin":"xml";var a=Xn.indexOf(r.bookType)>-1;var n=Kt();al(r=r||{});var i=Ce();var s="",l=0;r.cellXfs=[];fi(r.cellXfs,{},{revssf:{General:0}});if(!e.Props)e.Props={};s="docProps/core.xml";Se(i,s,pa(e.Props,r));n.coreprops.push(s);oa(r.rels,2,s,ta.CORE_PROPS);s="docProps/app.xml";if(e.Props&&e.Props.SheetNames){}else if(!e.Workbook||!e.Workbook.Sheets)e.Props.SheetNames=e.SheetNames;else{var o=[];for(var c=0;c<e.SheetNames.length;++c)if((e.Workbook.Sheets[c]||{}).Hidden!=2)o.push(e.SheetNames[c]);e.Props.SheetNames=o}e.Props.Worksheets=e.Props.SheetNames.length;Se(i,s,ka(e.Props,r));n.extprops.push(s);oa(r.rels,3,s,ta.EXT_PROPS);if(e.Custprops!==e.Props&&Y(e.Custprops||{}).length>0){s="docProps/custom.xml";Se(i,s,Sa(e.Custprops,r));n.custprops.push(s);oa(r.rels,4,s,ta.CUST_PROPS)}for(l=1;l<=e.SheetNames.length;++l){var f={"!id":{}};var u=e.Sheets[e.SheetNames[l-1]];var h=(u||{})["!type"]||"sheet";switch(h){case"chart":;default:s="xl/worksheets/sheet"+l+"."+t;Se(i,s,Es(l-1,s,r,e,f));n.sheets.push(s);oa(r.wbrels,-1,"worksheets/sheet"+l+"."+t,ta.WS[0]);}if(u){var d=u["!comments"];var p=false;if(d&&d.length>0){var m="xl/comments"+l+"."+t;Se(i,m,Ds(d,m,r));n.comments.push(m);oa(f,-1,"../comments"+l+"."+t,ta.CMNT);p=true}if(u["!legacy"]){if(p)Se(i,"xl/drawings/vmlDrawing"+l+".vml",zn(l,u["!comments"]))}delete u["!comments"];delete u["!legacy"]}if(f["!id"].rId1)Se(i,aa(s),sa(f))}if(r.Strings!=null&&r.Strings.length>0){s="xl/sharedStrings."+t;Se(i,s,Os(r.Strings,s,r));n.strs.push(s);oa(r.wbrels,-1,"sharedStrings."+t,ta.SST)}s="xl/workbook."+t;Se(i,s,As(e,s,r));n.workbooks.push(s);oa(r.rels,1,s,ta.WB);s="xl/theme/theme1.xml";Se(i,s,Nn(e.Themes,r));n.themes.push(s);oa(r.wbrels,-1,"theme/theme1.xml",ta.THEME);s="xl/styles."+t;Se(i,s,Ts(e,s,r));n.styles.push(s);oa(r.wbrels,-1,"styles."+t,ta.STY);if(e.vbaraw&&a){s="xl/vbaProject.bin";Se(i,s,e.vbaraw);n.vba.push(s);oa(r.wbrels,-1,"vbaProject.bin",ta.VBA)}Se(i,"[Content_Types].xml",ra(n,r));Se(i,"_rels/.rels",sa(r.rels));Se(i,"xl/_rels/workbook."+t+".rels",sa(r.wbrels));delete r.revssf;delete r.ssf;return i}function ul(e,r){var t="";switch((r||{}).type||"base64"){case"buffer":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];case"base64":t=b.decode(e.slice(0,12));break;case"binary":t=e;break;case"array":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];default:throw new Error("Unrecognized type "+(r&&r.type||"undefined"));}return[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3),t.charCodeAt(4),t.charCodeAt(5),t.charCodeAt(6),t.charCodeAt(7)]}function hl(e,r){if(j.find(e,"EncryptedPackage"))return cl(e,r);return parse_xlscfb(e,r)}function dl(e,r){var t,a=e;var n=r||{};if(!n.type)n.type=w&&Buffer.isBuffer(e)?"buffer":"base64";t=Ae(a,n);return ol(t,n)}function pl(e,r){var t=0;e:while(t<e.length)switch(e.charCodeAt(t)){case 10:;case 13:;case 32:++t;break;case 60:return parse_xlml(e.slice(t),r);default:break e;}return Ta.to_workbook(e,r)}function ml(e,r){var t="",a=ul(e,r);switch(r.type){case"base64":t=b.decode(e);break;case"binary":t=e;break;case"buffer":t=e.toString("binary");break;case"array":t=ce(e);break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=Ye(t);return pl(t,r)}function vl(e,r){var t=e;if(r.type=="base64")t=b.decode(t);t=cptable.utils.decode(1200,t.slice(2),"str");r.type="binary";return pl(t,r)}function gl(e){return!e.match(/[^\x00-\x7F]/)?e:Je(e)}function bl(e,r,t,a){if(a){t.type="string";return Ta.to_workbook(e,t)}return Ta.to_workbook(r,t)}function wl(e,r){c();if(typeof ArrayBuffer!=="undefined"&&e instanceof ArrayBuffer)return wl(new Uint8Array(e),r);var t=e,a=[0,0,0,0],n=false;var i=r||{};if(i.cellStyles){i.cellNF=true;i.sheetStubs=true}ii={};if(i.dateNF)ii.dateNF=i.dateNF;if(!i.type)i.type=w&&Buffer.isBuffer(e)?"buffer":"base64";if(i.type=="file"){i.type=w?"buffer":"binary";t=G(e)}if(i.type=="string"){n=true;i.type="binary";i.codepage=65001;t=gl(e)}if(i.type=="array"&&typeof Uint8Array!=="undefined"&&e instanceof Uint8Array&&typeof ArrayBuffer!=="undefined"){var s=new ArrayBuffer(3),l=new Uint8Array(s);l.foo="bar";if(!l.foo){i=fe(i);i.type="array";return wl(T(t),i)}}switch((a=ul(t,i))[0]){case 208:if(a[1]===207&&a[2]===17&&a[3]===224&&a[4]===161&&a[5]===177&&a[6]===26&&a[7]===225)return hl(j.read(t,i),i);break;case 9:if(a[1]<=4)return parse_xlscfb(t,i);break;case 60:return parse_xlml(t,i);case 73:if(a[1]===68)return Oa(t,i);break;case 84:if(a[1]===65&&a[2]===66&&a[3]===76)return Ea.to_workbook(t,i);break;case 80:return a[1]===75&&a[2]<9&&a[3]<9?dl(t,i):bl(e,t,i,n);case 239:return a[3]===60?parse_xlml(t,i):bl(e,t,i,n);case 255:if(a[1]===254){return vl(t,i)}break;case 0:if(a[1]===0&&a[2]>=2&&a[3]===0)return WK_.to_workbook(t,i);break;case 3:;case 131:;case 139:;case 140:return Ca.to_workbook(t,i);case 123:if(a[1]===92&&a[2]===114&&a[3]===116)return RTF.to_workbook(t,i);break;case 10:;case 13:;case 32:return ml(t,i);}if(Ca.versions.indexOf(a[0])>-1&&a[2]<=12&&a[3]<=31)return Ca.to_workbook(t,i);return bl(e,t,i,n)}function kl(e,r){var t=r||{};t.type="file";return wl(e,t)}function yl(e,r){switch(r.type){case"base64":;case"binary":break;case"buffer":;case"array":r.type="";break;case"file":return X(r.file,j.write(e,{type:w?"buffer":""}));case"string":throw new Error("'string' output type invalid for '"+r.bookType+"' files");default:throw new Error("Unrecognized type "+r.type);}return j.write(e,r)}function xl(e,r){var t=r||{};var a=fl(e,t);var n={};if(t.compression)n.compression="DEFLATE";if(t.password)n.type=w?"nodebuffer":"string";else switch(t.type){case"base64":n.type="base64";break;case"binary":n.type="string";break;case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");case"buffer":;case"file":n.type=w?"nodebuffer":"string";break;default:throw new Error("Unrecognized type "+t.type);}var i=a.FullPaths?j.write(a,{fileType:"zip",type:{nodebuffer:"buffer",string:"binary"}[n.type]||n.type}):a.generate(n);if(t.password&&typeof encrypt_agile!=="undefined")return yl(encrypt_agile(i,t.password),t);if(t.type==="file")return X(t.file,i);return t.type=="string"?Ye(i):i}function _l(e,r){var t=r||{};var a=write_xlscfb(e,t);return yl(a,t)}function Sl(e,r,t){if(!t)t="";var a=t+e;switch(r.type){case"base64":return b.encode(Je(a));case"binary":return Je(a);case"string":return e;case"file":return X(r.file,a,"utf8");case"buffer":{if(w)return k(a,"utf8");else return Sl(a,{type:"binary"}).split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function Cl(e,r){switch(r.type){case"base64":return b.encode(e);case"binary":return e;case"string":return e;case"file":return X(r.file,e,"binary");case"buffer":{if(w)return k(e,"binary");else return e.split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function Al(e,r){switch(r.type){case"string":;case"base64":;case"binary":var t="";for(var a=0;a<e.length;++a)t+=String.fromCharCode(e[a]);return r.type=="base64"?b.encode(t):r.type=="string"?Ye(t):t;case"file":return X(r.file,e);case"buffer":return e;default:throw new Error("Unrecognized type "+r.type);}}function El(e,r){c();fs(e);var t=r||{};if(t.cellStyles){t.cellNF=true;t.sheetStubs=true}if(t.type=="array"){t.type="binary";var a=El(e,t);t.type="array";return A(a)}switch(t.bookType||"xlsb"){case"xml":;case"xlml":return Sl(write_xlml(e,t),t);case"slk":;case"sylk":return Sl(Ys(e,t),t);case"htm":;case"html":return Sl(Xs(e,t),t);case"txt":return Cl(Zs(e,t),t);case"csv":return Sl(Gs(e,t),t,"\ufeff");case"dif":return Sl(Js(e,t),t);case"dbf":return Al(Qs(e,t),t);case"prn":return Sl(qs(e,t),t);case"rtf":return Sl(Ks(e,t),t);case"eth":return Sl(el(e,t),t);case"fods":return Sl(js(e,t),t);case"biff2":if(!t.biff)t.biff=2;case"biff3":if(!t.biff)t.biff=3;case"biff4":if(!t.biff)t.biff=4;return Al(write_biff_buf(e,t),t);case"biff5":if(!t.biff)t.biff=5;case"biff8":;case"xla":;case"xls":if(!t.biff)t.biff=8;return _l(e,t);case"xlsx":;case"xlsm":;case"xlam":;case"xlsb":;case"ods":return xl(e,t);default:throw new Error("Unrecognized bookType |"+t.bookType+"|");}}function Fl(e){if(e.bookType)return;var r={xls:"biff8",htm:"html",slk:"sylk",socialcalc:"eth",Sh33tJS:"WTF"};var t=e.file.slice(e.file.lastIndexOf(".")).toLowerCase();if(t.match(/^\.[a-z]+$/))e.bookType=t.slice(1);e.bookType=r[e.bookType]||e.bookType}function Tl(e,r,t){var a=t||{};a.type="file";a.file=r;Fl(a);return El(e,a)}function Ol(e,r,t,a){var n=t||{};n.type="file";n.file=e;Fl(n);n.type="buffer";var i=a;if(!(i instanceof Function))i=t;return H.writeFile(e,El(r,n),i)}function Dl(e,r,t,a,n,i,s,l){var o=it(t);var c=l.defval,f=l.raw||!Object.prototype.hasOwnProperty.call(l,"raw");var u=true;var h=n===1?[]:{};if(n!==1){if(Object.defineProperty)try{Object.defineProperty(h,"__rowNum__",{value:t,enumerable:false})}catch(d){h.__rowNum__=t}else h.__rowNum__=t}if(!s||e[t])for(var p=r.s.c;p<=r.e.c;++p){var m=s?e[t][p]:e[a[p]+o];if(m===undefined||m.t===undefined){if(c===undefined)continue;if(i[p]!=null){h[i[p]]=c}continue}var v=m.v;switch(m.t){case"z":if(v==null)break;continue;case"e":v=void 0;break;case"s":;case"d":;case"b":;case"n":break;default:throw new Error("unrecognized type "+m.t);}if(i[p]!=null){if(v==null){if(c!==undefined)h[i[p]]=c;else if(f&&v===null)h[i[p]]=null;else continue}else{h[i[p]]=f||l.rawNumbers&&m.t=="n"?v:wt(m,v,l)}if(v!=null)u=false}}return{row:h,isempty:u}}function Ml(e,r){if(e==null||e["!ref"]==null)return[];var t={t:"n",v:0},a=0,n=1,i=[],s=0,l="";var o={s:{r:0,c:0},e:{r:0,c:0}};var c=r||{};var f=c.range!=null?c.range:e["!ref"];if(c.header===1)a=1;else if(c.header==="A")a=2;else if(Array.isArray(c.header))a=3;else if(c.header==null)a=0;switch(typeof f){case"string":o=gt(f);break;case"number":o=gt(e["!ref"]);o.s.r=f;break;default:o=f;}if(a>0)n=0;var u=it(o.s.r);var h=[];var d=[];var p=0,m=0;var v=Array.isArray(e);var g=o.s.r,b=0,w=0;if(v&&!e[g])e[g]=[];for(b=o.s.c;b<=o.e.c;++b){h[b]=ct(b);t=v?e[g][b]:e[h[b]+u];switch(a){case 1:i[b]=b-o.s.c;break;case 2:i[b]=h[b];break;case 3:i[b]=c.header[b-o.s.c];break;default:if(t==null)t={w:"__EMPTY",t:"s"};l=s=wt(t,null,c);m=0;for(w=0;w<i.length;++w)if(i[w]==l)l=s+"_"+ ++m;i[b]=l;}}for(g=o.s.r+n;g<=o.e.r;++g){var k=Dl(e,o,g,h,a,i,v,c);if(k.isempty===false||(a===1?c.blankrows!==false:!!c.blankrows))d[p++]=k.row}d.length=p;return d}var Nl=/"/g;function Rl(e,r,t,a,n,i,s,l){var o=true;var c=[],f="",u=it(t);for(var h=r.s.c;h<=r.e.c;++h){if(!a[h])continue;var d=l.dense?(e[t]||[])[h]:e[a[h]+u];if(d==null)f="";else if(d.v!=null){o=false;f=""+(l.rawNumbers&&d.t=="n"?d.v:wt(d,null,l));for(var p=0,m=0;p!==f.length;++p)if((m=f.charCodeAt(p))===n||m===i||m===34||l.forceQuotes){f='"'+f.replace(Nl,'""')+'"';break}if(f=="ID")f='"ID"'}else if(d.f!=null&&!d.F){o=false;f="="+d.f;if(f.indexOf(",")>=0)f='"'+f.replace(Nl,'""')+'"'}else f="";c.push(f)}if(l.blankrows===false&&o)return null;return c.join(s)}function Pl(e,r){var t=[];var a=r==null?{}:r;if(e==null||e["!ref"]==null)return"";var n=gt(e["!ref"]);var i=a.FS!==undefined?a.FS:",",s=i.charCodeAt(0);var l=a.RS!==undefined?a.RS:"\n",o=l.charCodeAt(0);var c=new RegExp((i=="|"?"\\|":i)+"+$");var f="",u=[];a.dense=Array.isArray(e);var h=a.skipHidden&&e["!cols"]||[];var d=a.skipHidden&&e["!rows"]||[];for(var p=n.s.c;p<=n.e.c;++p)if(!(h[p]||{}).hidden)u[p]=ct(p);for(var m=n.s.r;m<=n.e.r;++m){if((d[m]||{}).hidden)continue;f=Rl(e,n,m,u,s,o,i,a);if(f==null){continue}if(a.strip)f=f.replace(c,"");t.push(f+l)}delete a.dense;return t.join("")}function Il(e,r){if(!r)r={};r.FS="\t";r.RS="\n";var t=Pl(e,r);if(typeof cptable=="undefined"||r.type=="string")return t;var a=cptable.utils.encode(1200,t,"str");return String.fromCharCode(255)+String.fromCharCode(254)+a}function Ll(e){var r="",t,a="";if(e==null||e["!ref"]==null)return[];var n=gt(e["!ref"]),i="",s=[],l;var o=[];var c=Array.isArray(e);for(l=n.s.c;l<=n.e.c;++l)s[l]=ct(l);for(var f=n.s.r;f<=n.e.r;++f){i=it(f);for(l=n.s.c;l<=n.e.c;++l){r=s[l]+i;t=c?(e[f]||[])[l]:e[r];a="";if(t===undefined)continue;else if(t.F!=null){r=t.F;if(!t.f)continue;a=t.f;if(r.indexOf(":")==-1)r=r+":"+r}if(t.f!=null)a=t.f;else if(t.t=="z")continue;else if(t.t=="n"&&t.v!=null)a=""+t.v;else if(t.t=="b")a=t.v?"TRUE":"FALSE";else if(t.w!==undefined)a="'"+t.w;else if(t.v===undefined)continue;else if(t.t=="s")a="'"+t.v;else a=""+t.v;o[o.length]=r+"="+a}}return o}function zl(e,r,t){var a=t||{};var n=+!a.skipHeader;var i=e||{};var s=0,l=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var o=typeof a.origin=="string"?dt(a.origin):a.origin;s=o.r;l=o.c}}var c;var f={s:{c:0,r:0},e:{c:l,r:s+r.length-1+n}};if(i["!ref"]){var u=gt(i["!ref"]);f.e.c=Math.max(f.e.c,u.e.c);f.e.r=Math.max(f.e.r,u.e.r);if(s==-1){s=u.e.r+1;f.e.r=s+r.length-1+n}}else{if(s==-1){s=0;f.e.r=r.length-1+n}}var h=a.header||[],d=0;r.forEach(function(e,r){Y(e).forEach(function(t){if((d=h.indexOf(t))==-1)h[d=h.length]=t;var o=e[t];var f="z";var u="";var p=pt({c:l+d,r:s+r+n});c=Wl.sheet_get_cell(i,p);if(o&&typeof o==="object"&&!(o instanceof Date)){i[p]=o}else{if(typeof o=="number")f="n";else if(typeof o=="boolean")f="b";else if(typeof o=="string")f="s";else if(o instanceof Date){f="d";if(!a.cellDates){f="n";o=ee(o)}u=a.dateNF||N._table[14]}if(!c)i[p]=c={t:f,v:o};else{c.t=f;c.v=o;delete c.w;delete c.R;if(u)c.z=u}if(u)c.z=u}})});f.e.c=Math.max(f.e.c,l+h.length-1);var p=it(s);if(n)for(d=0;d<h.length;++d)i[ct(d+l)+p]={t:"s",v:h[d]};i["!ref"]=vt(f);return i}function Bl(e,r){return zl(null,e,r)}var Wl={encode_col:ct,encode_row:it,encode_cell:pt,encode_range:vt,decode_col:ot,decode_row:nt,split_cell:ht,decode_cell:dt,decode_range:mt,format_cell:wt,get_formulae:Ll,make_csv:Pl,make_json:Ml,make_formulae:Ll,sheet_add_aoa:yt,sheet_add_json:zl,sheet_add_dom:Ns,aoa_to_sheet:xt,json_to_sheet:Bl,table_to_sheet:Rs,table_to_book:Ps,sheet_to_csv:Pl,sheet_to_txt:Il,sheet_to_json:Ml,sheet_to_html:Ms.from_sheet,sheet_to_formulae:Ll,sheet_to_row_object_array:Ml};(function(e){e.consts=e.consts||{};function r(r){r.forEach(function(r){e.consts[r[0]]=r[1]})}function t(e,r,t){return e[r]!=null?e[r]:e[r]=t}function a(e,r,t){if(typeof r=="string"){if(Array.isArray(e)){var n=dt(r);if(!e[n.r])e[n.r]=[];return e[n.r][n.c]||(e[n.r][n.c]={t:"z"})}return e[r]||(e[r]={t:"z"})}if(typeof r!="number")return a(e,pt(r));return a(e,pt({r:r,c:t||0}))}e.sheet_get_cell=a;function n(e,r){if(typeof r=="number"){if(r>=0&&e.SheetNames.length>r)return r;throw new Error("Cannot find sheet # "+r)}else if(typeof r=="string"){var t=e.SheetNames.indexOf(r);if(t>-1)return t;throw new Error("Cannot find sheet name |"+r+"|")}else throw new Error("Cannot find sheet |"+r+"|")}e.book_new=function(){return{SheetNames:[],Sheets:{}}};e.book_append_sheet=function(e,r,t){if(!t)for(var a=1;a<=65535;++a,t=undefined)if(e.SheetNames.indexOf(t="Sheet"+a)==-1)break;if(!t||e.SheetNames.length>=65535)throw new Error("Too many worksheets");os(t);if(e.SheetNames.indexOf(t)>=0)throw new Error("Worksheet with name |"+t+"| already exists!");e.SheetNames.push(t);e.Sheets[t]=r};e.book_set_sheet_visibility=function(e,r,a){t(e,"Workbook",{});t(e.Workbook,"Sheets",[]);var i=n(e,r);t(e.Workbook.Sheets,i,{});switch(a){case 0:;case 1:;case 2:break;default:throw new Error("Bad sheet visibility setting "+a);}e.Workbook.Sheets[i].Hidden=a};r([["SHEET_VISIBLE",0],["SHEET_HIDDEN",1],["SHEET_VERY_HIDDEN",2]]);e.cell_set_number_format=function(e,r){e.z=r;return e};e.cell_set_hyperlink=function(e,r,t){if(!r){delete e.l}else{e.l={Target:r};if(t)e.l.Tooltip=t}return e};e.cell_set_internal_link=function(r,t,a){return e.cell_set_hyperlink(r,"#"+t,a)};e.cell_add_comment=function(e,r,t){if(!e.c)e.c=[];e.c.push({t:r,a:t||"SheetJS"})};e.sheet_set_array_formula=function(e,r,t){var n=typeof r!="string"?r:gt(r);var i=typeof r=="string"?r:vt(r);for(var s=n.s.r;s<=n.e.r;++s)for(var l=n.s.c;l<=n.e.c;++l){
var o=a(e,s,l);o.t="n";o.F=i;delete o.v;if(s==n.s.r&&l==n.s.c)o.f=t}return e};return e})(Wl);if(typeof parse_xlscfb!=="undefined")e.parse_xlscfb=parse_xlscfb;e.parse_zip=ol;e.read=wl;e.readFile=kl;e.readFileSync=kl;e.write=El;e.writeFile=Tl;e.writeFileSync=Tl;e.writeFileAsync=Ol;e.utils=Wl;e.SSF=N;if(typeof j!=="undefined")e.CFB=j}if(typeof exports!=="undefined")make_xlsx_lib(exports);else if(typeof module!=="undefined"&&module.exports)make_xlsx_lib(module.exports);else if(typeof define==="function"&&define.amd)define(function(){if(!XLSX.version)make_xlsx_lib(XLSX);return XLSX});else make_xlsx_lib(XLSX);var XLS=XLSX,ODS=XLSX;


/* -------------------------------------------------------------------------------------------------- */
/* jquery-namespace-preprocess.js */
/* File: js/machinata-reporting-bundle.js/jquery-namespace-preprocess.js */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Shortcut multi-platform handle for the namespace for globals.
/// </summary>
/// <hidden/>
var MACHINATA_GLOBAL = (typeof global !== 'undefined') ? global : window;


(function ($, jQuery) { 


/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting.js */
/* Copyright 2018 Dan Krusi / Nerves GmbH */
/* License: Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) */
/* Link: https://nerves.ch */
/* File: js/machinata-reporting-bundle.js/machinata-reporting.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// This package is part of the Machinata Core JS library.
/// </summary>
/// <namespace></namespace>
/// <name>Machinata</name>
/// <type>namespace</type>
if (typeof Machinata === "undefined") throw "Machinata Core JS (machinata-core-bundle.js) must be loaded."


/// <summary>
/// Library for dynamically building interactive online reports including powerfull charting framework.
/// 
/// ## Documentation
/// This JS library is completely documented inline. This means you can read the documentation directly
/// within the source code. Alternatively, you can browse the online version at 
/// https://nerves.ch/documentation/machinata-reporting-bundle.js
///
/// ## Dependencies
/// This library has the following dependencies: 
///  - machinata-core-bundle.js
/// 
/// ## Structure
/// Reporting is split into these main blocks:
/// 
///  1. Configuration
///  2. Data
///  3. Index and Building
///  4. Nodes
/// 
/// ## Configuration
/// System for configuring the reporting engine.
/// 
/// ## Data
/// Tools for loading data from different sources, definition of common data format for layouting reports and providing chart data.
/// 
/// ## Index and Building
/// System for automatically compiling the desired and configured report or sub-report based on the full report.
/// 
/// ## Nodes
/// Building blocks that make up a report, including everything from tables to paragraphs to charts.
/// 
/// ## Catalogs and Content
/// The reporting framework not only will display a report, but can also manage the interface and display of catalogs of reports. 
/// These modes can even be combined to create a self-sustainable reporting UI based off of JSON files.
///
/// ## Report Lifecycle
/// Typically the routine cycle of a report should look like this:
/// - Machinata.Reporting.init()
///    - Machinata.Reporting.Data.loadData() >> Load Catalog JSON (if any)
///    - Machinata.Reporting.Data.loadData() >> Load Report JSON
///    - Machinata.Reporting.buildIndex() >> Recursively called
///        - Machinata.Reporting.buildIndex()
///            - Machinata.Reporting.buildIndex()
///                - ...
///    - Machinata.Reporting.buildContents() >> Recursively called
///        - Machinata.Reporting.Node.build()
///            - Machinata.Reporting.Node.ImplementationXYZ.preBuild()
///            - Machinata.Reporting.Node.ImplementationXYZ.init()
///            - Machinata.Reporting.Node.ImplementationXYZ.postBuild()
///        - Machinata.Reporting.buildContents()
///            - Machinata.Reporting.Node.build()
///                - Machinata.Reporting.Node.ImplementationXYZ.preBuild()
///                - Machinata.Reporting.Node.ImplementationXYZ.init()
///                - Machinata.Reporting.Node.ImplementationXYZ.postBuild()
///        - ...
///    - Machinata.Reporting.Node.ImplementationXYZ.draw() >> Draw is called stacked when everything is built
///    - Machinata.Reporting.Node.ImplementationXYZ.draw()
///    - Machinata.Reporting.Node.ImplementationXYZ.draw()
///    - Machinata.Reporting.Node.ImplementationXYZ.draw()
///    - ...
///
/// ## Required HTML
/// To get a report injected into your page, you must include the following element and call the init() routine:
/// ```
/// <div class="machinata-reporting-report">
/// </div>
/// <script>
///     var config = {
///         // Your config...
///     };
///     Machinata.ready(function () {
///         Machinata.Reporting.init(config);
///     });
/// </script>
/// ```
/// </summary>
/// <namespace>Machinata</namespace>
/// <name>Machinata.Reporting</name>
/// <type>namespace</type>




/* ======== Variables ========================================================== */



/// <summary>
/// Indicates that a cold start is about to happen.
/// This allows some processes to be skipped on either a cold or warm start to increase performance.
/// </summary>
Machinata.Reporting._coldStart = true;

/// <summary>
/// The UID tracker for reporting nodes. This gets automatically increment as a UID is consumed.
/// </summary>
Machinata.Reporting._uid = 0;

/// <summary>
/// Stores the currently available and registered themes.
/// A mapping from theme key/id to array of colors.
/// </summary>
Machinata.Reporting._themes = {};

/// <summary>
/// Stores the currently available and registered layouts.
/// A mapping from layout key/id to the layout JSON definition.
/// </summary>
Machinata.Reporting._layouts = {};








/* ======== Helper Functions ========================================================== */


/// <summary>
/// Generate a new (unique) reporting UID.
/// </summary>
Machinata.Reporting.uid = function() {
    Machinata.Reporting._uid++;
    return "machinata_reporting_autoid_"+Machinata.Reporting._uid;
};



/* ========  Functions ========================================================== */


/// <summary>
/// Automaticall merges in the given config parameters together with the default configs and the profile configs.
/// This method will also automatically then load the config, thus it should be your final stop for setting up a configuration.
/// </summary>
Machinata.Reporting.mergeAndLoadConfigWithDefaults = function (config, profile) {

    // Load the branding defaults configuration, if any
    if (config != null && config["brandingConfiguration"] != null) {
        Machinata.Reporting.Branding.loadBrandingConfiguration(config["brandingConfiguration"]);
    }

    // Create a new config
    var ret = null;
    var profileConfig = Machinata.Reporting.Profiles.Configs[profile];
    if (profileConfig != null) {
        Machinata.debug("Machinata.Reporting.mergeAndLoadConfigWithDefaults: " + profile);
        ret = Machinata.Util.extend({}, Machinata.Reporting.Config, profileConfig, config);
    } else {
        ret = Machinata.Util.extend({}, Machinata.Reporting.Config, config);
    }
    ret["profile"] = profile;

    // Load the config
    Machinata.Reporting.loadConfig(config);

    // Return the newly loaded and merged config...
    return ret;
};


/// <summary>
/// Applies any of the needed configuration parameters that are not used on-the-fly. If 
/// the configuration has changed for any reason, you should call this method again to ensure
/// the new configuration is properly applied.
/// </summary>
Machinata.Reporting.loadConfig = function (config) {
    Machinata.debug("Machinata.Reporting.loadConfig");
    // Set locales
    if (config.numberFormatLocaleDefinition != null) {
        Machinata.debug("  " + "setting custom numberFormatLocaleDefinition");
        vega.formatLocale(config.numberFormatLocaleDefinition);
        d3.formatLocale(config.numberFormatLocaleDefinition);
    }
    if (config.timeFormatLocaleDefinition != null) {
        Machinata.debug("  " + "setting custom timeFormatLocaleDefinition");
        vega.timeFormatLocale(config.timeFormatLocaleDefinition);
        d3.timeFormatLocale(config.timeFormatLocaleDefinition);
    }
};

/// <summary>
/// Creates empty instance object with all the empty handles needed to represent a instance of a report.
/// </summary>
/// <hidden/>
Machinata.Reporting._createEmptyInstance = function() {
    var instance = {
        uid: Machinata.Reporting.uid(),
        config: null, // Holds the currently merged and applied config JSON.
        catalogData: null, // Holds the currently compiled catalog data (if any).
        reportData: null, // Holds the currently compiled report data (if any).
        rootNode: null, // Holds the current root node of the report.
        catalogCurrentMandate: null, // If using a catalog, stores the currently selected mandate JSON.
        catalogCurrentReport: null, // If using a catalog, stores the currently selected report JSON.
        idToNodeElementLookupTable: {}, // A map from node id to node DOM element.
        idToNodeJSONLookupTable: {}, // A map from node id to node JSON.
        screensToShow: null, // The screens to be displayed. int array
        screens: [], // The discovered screens in the report. Node JSON array
        chapters: [], // The discovered chapters in the report. Node JSON array
        currentScreen: null, // The currently displayed screen (if set)
        totalScreens: null, // The total number of screens.
        focusKey: null, // Parameter from query string (key) which defines a node or section to focus on.
        elems: {
            content: null, // The main report content nodes (root of all reporting content).
            catalog: null, // The catalog UI, if any.
            header: null, // The header of the page, if any. This can be set once globally at any time the DOM is loaded.
            navigation: null, // The navigation of the page, if any. This can be set once globally at any time the DOM is loaded.
            fullscreen: null, // The current fullscreen container for a sub-report, if any
        }
    };
    return instance;
};

/// <summary>
/// Initialize a report, build its toc and content, and create all underlying content and nodes.
/// This will return a instance object with all the relavant handles.
/// </summary>
Machinata.Reporting.init = function (config, onSuccess) {

    // Init and reset
    Machinata.Debugging.startTimer("report-init");

    // Instance object for all relavant handles...
    var instance = Machinata.Reporting._createEmptyInstance();

    // Cold start registration
    var thisInitIsColdStart = Machinata.Reporting._coldStart;
    Machinata.Reporting._coldStart = false;

    // Machinata core settings
    Machinata.Dialogs.MAX_DIALOG_WIDTH = 480;
    Machinata.Dialogs.DIALOG_ADDITIONAL_CLASSES = "machinata-reporting-dialog";

    // Resolve the profile
    var profileName = config.profile || "web";
    if (Machinata.hasQueryParameter("profile")) {
        profileName = Machinata.queryParameter("profile");
    }

    // Create merged config
    instance.initConfig = Machinata.Util.cloneJSON(config);
    config = Machinata.Reporting.mergeAndLoadConfigWithDefaults(config, profileName);
    instance.config = config;

    // Apply some config values from query string...
    if (Machinata.queryParameter("prevent-caching") == "true") {
        config.preventDataCaching = true;
    }

    // Cache some selectors
    instance.elems.header = $(config.headerSelector);
    instance.elems.navigation = $(config.navigationSelector);
    instance.elems.content = $(config.contentSelector);
    instance.elems.catalog = $(config.catalogSelector);

    // Allow dom context to get the instance via the content node (machinata-reporting-report)
    instance.elems.content.data("instance", instance);

    // Register the report class
    instance.elems.content.addClass("machinata-reporting-report");

    // Clear DOM
    // Note: migrated to buildReport
    //if (thisInitIsColdStart == false) {
    //    instance.elems.content.children().filter(".machinata-reporting-node").remove();
    //}

    // Initial layout
    Machinata.Reporting.Responsive.updateReportLayout(instance);

    // Url?
    if (config.url == null) {
        config.url = window.location.href;
        config.url = Machinata.removeQueryParameter("chapter", config.url);
        config.url = Machinata.removeQueryParameter("focus", config.url);
        config.url = Machinata.removeQueryParameter("ui", config.url);
    }

    // Profile?
    if (Machinata.Reporting.Handler.setupForProfile != null) Machinata.Reporting.Handler.setupForProfile(config.profile);
    instance.elems.content.addClass("machinata-reporting-profile-"+config.profile);
    // Note: the body classes are still needed by webprint...
    if ($("body").attr("data-machinata-reporting-profile") == null) {
        $("body").addClass("machinata-reporting-profile-" + config.profile);
        $("body").attr("data-machinata-reporting-profile", config.profile);
    }

    // Cache some parameters
    instance.focusKey = Machinata.queryParameter("focus");
    if (instance.focusKey == "") instance.focusKey = null;

    // Show loading in nav
    var rootNavItemElem = null;
    if (config.automaticallyInsertChapterNavigation == true && Machinata.Reporting.Handler.addNavigationItem != null) rootNavItemElem = Machinata.Reporting.Handler.addNavigationItem(instance, "Loading...", "");
    else rootNavItemElem = $("<div/>");

    // Debugging
    Machinata.debug("Machinata.Reporting.init:");

    // Injected CSS
    if (config.injectThemeCSSIntoPage == true) {
        // Already injected?
        var cssElem = $("#machinata-reporting-css");
        if (cssElem.length == 0) {
            // Add a inline stylesheet into page
            cssElem = $("<style id='machinata-reporting-css'>" + Machinata.Reporting.Tools.generateThemeCode(config,"css")+"</style>");
            cssElem.appendTo($("head"));
        }
    }

    // Build UI: register the container and styles to reporting
    instance.elems.content.addClass("machinata-reporting-styling");
    instance.elems.content.addClass("machinata-reporting-container");

    

    // Init screen selector
    if (config.screens == "auto") {
        Machinata.debug("    screens is auto:");
        var screensQueryString = Machinata.queryParameter("screen"); 
        if (screensQueryString == null || screensQueryString == "") {
            instance.screensToShow = null;
            Machinata.debug("        no screens in query, fallback to all");
        } else if (screensQueryString == "printcomposer") {
            Machinata.debug("        screens from printcomposer");
            config.screens = "printcomposer";
            // Note: we now have to do this later since we need the report data
            //instance.screensToShow = Machinata.Reporting.PrintComposer.getScreensAsIntArray(instance);
        } else {
            Machinata.debug("        screens from query: " + screensQueryString);
            var screenSegsString = screensQueryString.split(",");
            instance.screensToShow = [];
            for (var i = 0; i < screenSegsString.length; i++) {
                instance.screensToShow.push(parseInt(screenSegsString[i]));
            }
        }
    } else if (config.screens == "printcomposer") {
        // We have to wait until all data is loaded...?
        //instance.screensToShow = Machinata.Reporting.PrintComposer.getScreensAsIntArray(instance);
    } else if (config.screens == "*") {
        // Just show all...
        instance.screensToShow = null;
    } else if (config.screens != null && Array.isArray(config.screens)) {
        // Array of screen numbers
        instance.screensToShow = config.screens;
    } else if (config.screens != null && !isNaN(config.screens)) {
        // Single screen number
        instance.screensToShow = [parseInt(config.screens)];
    } else if (config.screens != null && Machinata.Util.isString(config.screens) && config.screens.indexOf(",") != -1) {
        // Comma separated list
        var screenSegsString = config.screens.split(",");
        instance.screensToShow = [];
        for (var i = 0; i < screenSegsString.length; i++) {
            instance.screensToShow.push(parseInt(screenSegsString[i]));
        }
    }
    if (instance.screensToShow != null) instance.currentScreen = instance.screensToShow[0];

    // Debugging
    Machinata.debug("    chapters: " + config.chapters);
    Machinata.debug("    screensToShow: " + instance.screensToShow);
    Machinata.debug("    currentScreen: " + instance.currentScreen);
    Machinata.debug("    initialChapter: " + config.initialChapter);

    // Cache some attributes needed by other modules
    //instance.elems.content.attr("data-title", json.title);
    //instance.elems.content.attr("data-subtitle", json.subtitle);

    //TODO: build and show loader, expose common loading routines...

    // Figure out catalog source
    if (config.catalogSource == "auto") {
        config.catalogSource = Machinata.queryParameter("catalog");
        if (config.catalogSource == "") config.catalogSource = null;
    }

    Machinata.Debugging.stopTimer("report-init");
    
    // Load catalog data
    Machinata.Debugging.startTimer("catalog-download");
    if (config.loadCatalog == false) config.catalogSource = null;
    Machinata.Reporting.Data.loadData(instance, config.catalogSource, function (catalogData) {
        // Success - catalog loaded
        Machinata.Debugging.stopTimer("catalog-download");

        // Register data singleton instance
        instance.catalogData = catalogData;

        // Compile catalog and it's UI
        if (catalogData != null) {
            Machinata.Reporting.Catalog.processCatalog(instance, config, catalogData);
        }
        if (config.automaticallyBuildCatalogUI == true && catalogData != null) {
            Machinata.Reporting.Catalog.compileCatalogUI(instance, config, catalogData);
        }

        // Set dataSource if missing
        if (config.dataSource == "auto") {
            config.dataSource = Machinata.queryParameter("data");
            if (config.dataSource == "") config.dataSource = Machinata.Reporting.Config.dataSource;
        }

        // Add chapter in nav
        var chapterNavItemElem = null;
        if (config.automaticallyInsertChapterNavigation == true && Machinata.Reporting.Handler.addNavigationItem != null) chapterNavItemElem = Machinata.Reporting.Handler.addNavigationItem(instance, "Loading...", "");
        else chapterNavItemElem = $("<div/>");

        // Load report data - at this point we can't proceed without the index and meta data
        if (config.loadReport == false) config.dataSource = null;
        Machinata.Debugging.startTimer("report-download");
        Machinata.Reporting.Data.loadData(instance, config.dataSource, function (reportData) {
            // Success - data loaded
            Machinata.Debugging.stopTimer("report-download");
            Machinata.Debugging.startTimer("report-preinit");

            // Register data singleton instance
            instance.reportData = reportData;

            // Validate we even have anything
            if (reportData == null) {
                // Rollback the navigation loader...
                var sepElem = rootNavItemElem.prev().prev();
                var posElem = rootNavItemElem.prev();
                sepElem.remove();
                posElem.remove();
                rootNavItemElem.remove();
                return;
            }

            // If we want printcomposer screen, we can get them now since we now know the reportid
            if (config.screens == "printcomposer") {
                instance.screensToShow = Machinata.Reporting.PrintComposer.getScreensAsIntArray(instance);
            }

            // Apply custom config from data
            if (reportData["config"] != null) {
                config = Machinata.Util.extend({}, config, reportData["config"]);
                instance.config = config;
                Machinata.Reporting.loadConfig(config); // we unfortunately need to reload the config...
            }

            // Cache some common attributes
            config.reportName = Machinata.Reporting.Text.resolve(instance,reportData["reportName"]);
            if (reportData.reportTitle != null) config.reportTitle = Machinata.Reporting.Text.resolve(instance,reportData.reportTitle);
            if (reportData.reportSubtitle != null) config.reportSubtitle = Machinata.Reporting.Text.resolve(instance,reportData.reportSubtitle);
            if (reportData.reportBadge != null) config.reportBadge = reportData.reportBadge;
            Machinata.debug("    reportName: " + config.reportName);
            Machinata.debug("    reportTitle: " + config.reportTitle);
            Machinata.debug("    reportSubtitle: " + config.reportSubtitle);

            // Debug dom elem?
            if (Machinata.DebugEnabled == true) {
                //TODO: re-enable debug features
                //instance.elems.content.append(Machinata.UI.createDebugPanel("Build", Machinata.buildInfo()));
                //instance.elems.content.append(Machinata.UI.createDebugPanel("Report", config));
            }

            // Initial UI update (for report meta data)
            $(".machinata-reporting-attribute-report-title").text(config.reportTitle);
            $(".machinata-reporting-attribute-report-subtitle").text(config.reportSubtitle);
            window.document.title = window.document.title.replace("Loading...", config.reportTitle);
            rootNavItemElem.find(".link").text(config.reportTitle);
            if (instance.catalogCurrentMandate != null) {
                rootNavItemElem.find(".link").attr("href", instance.catalogCurrentMandate.catalogURLResolved);
            } else {
                rootNavItemElem.find(".link").attr("href", config.url);
            }

            // UI update for data status
            if (config.reportBadge != null) {
                var badgeElem = $(".machinata-reporting-attribute-report-badge");
                if (config.reportBadge.color != null) badgeElem.addClass("option-" + config.reportBadge.color);
                badgeElem.text(Machinata.Reporting.Text.resolve(instance,config.reportBadge.label));
                if (config.reportBadge.tooltip != null) badgeElem.attr("title", Machinata.Reporting.Text.resolve(instance,config.reportBadge.tooltip));
                badgeElem.addClass("has-content");
            } else {
                $(".machinata-reporting-attribute-report-badge").remove();
            }

            // Set window title
            // Here we use the config reportWindowTitle, unless we are in webprint, in which case we try to use the filename...
            if (config.reportWindowTitle != null) {
                var windowTitleTemplateString = config.reportWindowTitle;
                if (config.profile == Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY && reportData != null && reportData.fileName != null) {
                    windowTitleTemplateString = reportData.fileName;
                }
                var windowTitle = Machinata.Reporting.Tools.createTitleString(instance, config, windowTitleTemplateString);
                if (windowTitle != null) window.document.title = windowTitle;
            }
            
            // Build index recursively
            Machinata.Debugging.stopTimer("report-preinit");
            Machinata.Debugging.startTimer("report-buildindex");
            instance.rootNode = reportData["body"];
            Machinata.debug("Machinata.Reporting.buildIndex:");
            Machinata.Reporting.buildIndex(instance, config, instance.rootNode, null);
            Machinata.Debugging.stopTimer("report-buildindex");

            // Validate we have at least one chapter
            //if (instance.chapters.length == 0) {
            //    Machinata.debug("   **Setting default chapter");
            //    instance.chapters.push(rootNode.children[0]);
            //}

            // Show what happend
            Machinata.debug("    index complete!");
            Machinata.debug("    totalScreens: " + instance.totalScreens);
            Machinata.debug("    totalChapters: " + instance.chapters.length);

            // Page tools
            if (config.automaticallyAddPageTools == true) {
                Machinata.Reporting.initPageTools(instance);
            }

            // Auto-chapter?
            if (config.chapters == "auto") {
                config.chapters = [];
                // Do we have from query param?
                if (Machinata.hasQueryParameter("chapter")) {
                    config.chapters.push(Machinata.queryParameter("chapter"));
                } else if (config.initialChapter != null) {
                    if (typeof config.initialChapter == 'number') {
                        config.chapters.push(instance.chapters[config.initialChapter - 1].id);
                    } else {
                        config.chapters.push(config.initialChapter);
                    }
                } else {
                    if (instance.chapters.length > 0) {
                        config.chapters.push(instance.chapters[0].id);
                    }
                }
            }

            // Load the chapter title, if we have selected only a single chapter
            if (config.chapters != null && config.chapters.length == 1) {
                Machinata.Util.each(instance.chapters, function (index, chapterJSON) {
                    if (config.chapters[0] == chapterJSON.id) {
                        if (config.reportChapter == null) {
                            config.reportChapter = Machinata.Reporting.Text.resolve(instance,chapterJSON.mainTitle);
                        }
                    }
                });
            }
            if (config.reportChapter == null) {
                config.reportChapter == ""; //fallback
            }

            // Update some attributes that might have only come up after build index
            $(".machinata-reporting-attribute-report-disclaimer").text(config.reportDisclaimer);
            $(".machinata-reporting-attribute-report-legal-entity").text(config.reportLegalEntity);
            $(".machinata-reporting-attribute-report-chapter").text(config.reportChapter);
            $(".machinata-reporting-attribute-catalog-url").attr("href", config.catalogURL);


            // Create chapters UI
            if (config.automaticallyFoldChaptersIntoPages == true) {
                $(config.chapterSelector).each(function () {
                    var chapterTabsElem = $(this);
                    var numChapters = 0;
                    var selectedChapterNumber = 0;
                    Machinata.Util.each(instance.chapters, function (index, chapterJSON) {
                        if (config.chapters != null && config.chapters.length == 1) {
                            if (config.chapters[0] == chapterJSON.id) {
                                selectedChapterNumber = index;
                            }
                        }
                        numChapters++;
                    });
                    Machinata.Util.each(instance.chapters, function (index, chapterJSON) {
                        var chapterTitle = Machinata.Reporting.Text.resolve(instance,chapterJSON.mainTitle);
                        // Create chapter button
                        var chapterButtonElem = $("<li></li>").attr("data-chapter", chapterJSON.chapterId);
                        chapterButtonElem.append($("<a></a>").text(chapterTitle));
                        chapterButtonElem.find("a").attr("href", chapterJSON.chapterURL);
                        // Manage selection
                        if (config.chapters != null && config.chapters.length == 1) {
                            if (config.chapters[0] == chapterJSON.id) {
                                chapterButtonElem.find("a").addClass("is-active");
                            }
                        }
                        // Add chapter elem
                        var addChapterToUI = true;
                        if (chapterTabsElem.hasClass("option-prev-next-only")) {
                            // Toggle usage
                            if (index < selectedChapterNumber - 1 || index > selectedChapterNumber + 1) addChapterToUI = false;
                            // Add icon
                            if (index < selectedChapterNumber) {
                                chapterButtonElem.find("a").prepend(Machinata.Reporting.buildIcon(instance, "chevron-left"));
                            } else if(index > selectedChapterNumber) {
                                chapterButtonElem.find("a").append(Machinata.Reporting.buildIcon(instance, "chevron-right"));
                            }
                        }
                        if (addChapterToUI == true) {
                            chapterTabsElem.append(chapterButtonElem);
                        }
                    });
                    if (numChapters <= 1) chapterTabsElem.hide();
                    // Autobalance the tabs
                    chapterTabsElem.find("li").css("width", (100 / chapterTabsElem.find("li").length) + "%");
                });
            }

            if (config.automaticallyInsertChapterNavigation && chapterNavItemElem != null) {
                Machinata.Util.each(instance.chapters, function (index, chapterJSON) {
                    var chapterTitle = Machinata.Reporting.Text.resolve(instance,chapterJSON.mainTitle);
                    // Manage selection
                    if (config.chapters != null && config.chapters.length == 1) {
                        if (config.chapters[0] == chapterJSON.id) {
                            chapterNavItemElem.find(".link").text(chapterTitle);
                        }
                    }
                    // Register sibling
                    if (instance.chapters.length == 1) return;
                    if (Machinata.Reporting.Handler.addNavigationSibling != null) {
                        var siblingNavItemElem = Machinata.Reporting.Handler.addNavigationSibling(instance, chapterTitle, chapterJSON.chapterURL);
                    }
                });
                if (instance.chapters != null && instance.chapters.length == 0) {
                    chapterNavItemElem.remove(); //TODO: what about the slash in CS?
                }
            } else {
                //TODO: handle alternative?
            }

            // Build report content

            // Build content recursively
            if (config.buildContents == true) {
                Machinata.Debugging.startTimer("report-buildcontents");
                Machinata.Reporting.buildReport(instance, config);
                Machinata.Debugging.stopTimer("report-buildcontents");
            }


            Machinata.Debugging.startTimer("report-postinit");

            // Initial focus?
            if (instance.focusKey != null) {
                var linkJSON = {
                    nodeId: instance.focusKey
                };
                Machinata.Reporting.Tools.drilldownOnNode(instance,linkJSON);
            }

            // Fullscreen profile?
            if (config.profile == Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY) {
                // Bind arrow keys (only for fullscreen)
                $(document).keydown(function (e) {
                    if (e.which == 37) {
                        // LEFT
                        e.preventDefault();
                        Machinata.Reporting.Tools.prevScreen(instance);
                    } else if (e.which == 39) {
                        // RIGHT
                        e.preventDefault();
                        Machinata.Reporting.Tools.nextScreen(instance);
                    }

                });
            }

            // Webprint profile?
            if (config.profile == Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY) {
                if (config.automaticallyOpenBrowserPrintDialog == true || Machinata.queryParameter("print-dialog") == "true") {
                    setTimeout(function () {
                        Machinata.Reporting.Tools.openBrowserPrintDialog(instance);
                    }, 300); // seems the browser needs some breathing room so that it can properly detect the margins etc...
                }
            }

            // Insert a dom element for headless and automated systems to detect (like screenshot services)
            instance.elems.content.append("<div class='machinata-reporting-init-complete'/>");

            // Success
            if (onSuccess) onSuccess(instance,config);
            
            Machinata.Debugging.stopTimer("report-postinit");

            // Insert stats?
            if (Machinata.queryParameter("stats") == "true") {
                instance.elems.content.prepend(Machinata.Debugging.createTimersDebugPanel("Stats").addClass("machinata-reporting-debug-panel"));
            }

            // Notice?
            if (reportData != null && reportData["reportNotice"] != null) {
                var key = "noticeshowed_" + reportData.reportId;
                if (Machinata.getCache(key) == null) {
                    setTimeout(function () {
                        Machinata.setCache(key, true);
                        Machinata.messageDialog(Machinata.Reporting.Text.translate(instance, "reporting.notice"), Machinata.Reporting.Text.resolve(instance,reportData["reportNotice"])).show();

                    }, 600);
                }
            }

        });

    });

    // Cold start UI bindings
    // These happend immediately and must remain valid throughout multiple inits
    if (thisInitIsColdStart == true) {

        // Bind tooltips via handler, if any
        if (Machinata.Reporting.Handler.bindTooltipsUI != null) {
            Machinata.Reporting.Handler.bindTooltipsUI(instance, $(".machinata-reporting-styling")); // bind to root of document
        }

        // Register window resize events
        $(window).resize(function () {
            $(".machinata-reporting-report").each(function () {
                Machinata.Reporting.Responsive.updateForContainerSize($(this).data("instance"));
            });
        });

        // Bind resizes
        /*
        Machinata.Responsive.onResize(function () {
            // Note: this is called before onResize
            // Update all report sizes
            $(".machinata-reporting-report").each(function () {
                Machinata.Reporting.Responsive.updateReportLayout($(this).data("instance"));
            });
        });
        Machinata.Responsive.onResized(function () {
            // Note: this is called after onResize
            // Update all nodes
            TODO: should we cache this selector?
            EXPENSIVE:
            $(".machinata-reporting-node").trigger("machinata-reporting-redraw-node");
        });*/

        // Readprogress
        $(".machinata-reporting-readprogress.option-autoscroll").each(function () {
            var elem = $(this);
            var progressElem = elem.find(".progress");
            var subtract = 0;
            if ($("#footer").length != 0) subtract += $("#footer").height();
            if ($("#legal").length != 0) subtract += $("#legal").height();
            $(window).scroll(function () {
                var h = document.documentElement,
                    b = document.body,
                    st = 'scrollTop',
                    sh = 'scrollHeight';
                var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight - subtract) * 100;
                if (percent == 0) elem.addClass("is-zero");
                else elem.removeClass("is-zero");
                progressElem.css("width", percent + "%");
            });
        });

        // IE 11 support
        if (config.compatibilityIE11Support == true) {
            Machinata.Compatibility.addIESupport();
        }

    }


    return instance;

};

/// <summary>
/// This function updates and binds all the page tools that reside outside of the machinata-reporting main container.
/// </summary>
Machinata.Reporting.initPageTools = function (instance) {
    // General page tools
    // Fullscreen
    if (Machinata.Reporting.Handler.addPageTool != null && instance.totalScreens > 0) {
        Machinata.Reporting.Handler.addPageTool(instance, "View fullscreen", "fullscreen", function () {
            Machinata.Reporting.Tools.openFullscreenReport(instance);
        });
    }
    
    // Resources
    if (instance.reportData != null && instance.reportData.reportResources != null && Machinata.Reporting.Handler.addPageTool != null) {
        Machinata.Util.each(instance.reportData.reportResources, function (index, resourceJSON) {
            Machinata.Reporting.Handler.addPageTool(
                instance,
                Machinata.Reporting.Text.resolve(instance,resourceJSON.tooltip),
                resourceJSON.icon,
                function () {
                    if (resourceJSON.link != null) {
                        // Link
                        Machinata.Reporting.Tools.openLink(instance,resourceJSON.link);
                    } else if (resourceJSON.attachment != null) {
                        // Attachment
                        if (resourceJSON.downloadAttachmentToBrowser == true) {
                            Machinata.Data.exportDataAsBlob(
                                resourceJSON.attachment.data,
                                resourceJSON.attachment.mimeType,
                                resourceJSON.attachment.filename
                            );
                        } else {
                            Machinata.Data.openDataInNewWindow(
                                resourceJSON.attachment.data,
                                resourceJSON.attachment.mimeType,
                                resourceJSON.attachment.filename
                            );
                        }
                    }
            });
        });
    }
    // Printing (only if we have screens)
    if (Machinata.Reporting.Handler.addPageTool != null && instance.screens != null && instance.screens.length > 0) {
        if (Machinata.Reporting.Handler.printReport != null) {
            Machinata.Reporting.Handler.addPageTool(instance, Machinata.Reporting.Text.translate(instance, "reporting.printing.print"), "print", function () {
                Machinata.Reporting.Handler.printReport(instance);
            });
        }
    }
    // Change date
    // NOTE: The calendar change date tool must be the last tool to be added!
    if (Machinata.Reporting.Handler.addPageTool != null && instance.catalogCurrentMandate != null && Machinata.Reporting.Handler.changeReportingDate != null) {
        // Add the calendar tool
        Machinata.Reporting.Handler.addPageTool(instance, Machinata.Reporting.Text.translate(instance, "reporting.change-date"), "calendar", function () {
            Machinata.Reporting.Handler.changeReportingDate(instance, instance.catalogData, instance.catalogCurrentMandate, instance.catalogCurrentReport);
        });
        // Add subtitle as text tool
        if (instance.config.insertReportSubtitleAsPageTool == true && instance.reportData != null && instance.reportData.reportSubtitle != null) {
            var subtitle = Machinata.Reporting.Text.resolve(instance, instance.reportData.reportSubtitle);
            Machinata.Reporting.Handler.addPageTool(instance, subtitle, null, function () {
                Machinata.Reporting.Handler.changeReportingDate(instance, instance.catalogData, instance.catalogCurrentMandate, instance.catalogCurrentReport);
            }, Machinata.Reporting.Text.translate(instance, "reporting.change-date"),false);
        }
    }
    
};


/// <summary>
/// Recursivley builds the index of the report. This especially has to do with figuring
/// out the logical screen numbers for a report, which allows one to seperate
/// the chapters out in regular display, but still speak of univeral screen numbers
/// across the entire report.
/// </summary>
Machinata.Reporting.buildIndex = function (instance, config, json, parent) {
    // Re-init
    instance.screens = [];

    // Recursively build index
    Machinata.Reporting._buildIndexRecursively(instance, config, json, parent);

    // Register num screens
    instance.totalScreens = instance.screens.length;

    return json;
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting._buildIndexRecursively = function (instance, config, json, parent) {

    if (json == null) json = instance.rootNode;

    if (json.enabled == false) return;

    // ID
    if (json.id == null) json.id = Machinata.Reporting.uid();
    instance.idToNodeJSONLookupTable[json.id] = json;

    // Tags?
    if (json.tags != null) {
        for (var i = 0; i < json.tags.length; i++) {
            var tag = json.tags[i];
            if (tag == config.tagDisclaimer) {
                json.exclude = true;
                Machinata.debug("    Report_Disclaimer tag, excluding");
                config.reportDisclaimer = Machinata.Reporting.Text.resolve(instance,json.content);
            } else if (tag == config.tagLegalEntity) {
                json.exclude = true;
                Machinata.debug("    Report_LegalEntity tag, excluding");
                config.reportLegalEntity = Machinata.Reporting.Text.resolve(instance,json.content);
            } else if (tag == config.tagScreen) {
                Machinata.debug("    Screen tag, marking as screen");
                json.screen = true;
            } else if (tag == config.tagDarkChrome) {
                Machinata.debug("    Dark tag, setting chrome to dark");
                json.chrome = "dark";
            } else if (tag == config.tagLightChrome) {
                Machinata.debug("    Light tag, setting chrome to dark");
                json.chrome = "light";
            } else if (tag == config.tagSolidChrome) {
                Machinata.debug("    Solid tag, setting chrome to solid");
                json.chrome = "solid";
            } else if (tag == config.tagWebPrintOnly) {
                if (config.profile != Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY) json.exclude = true;
            } else if (tag == config.tagWebOnly) {
                if (config.profile != Machinata.Reporting.Profiles.PROFILE_WEB_KEY) json.exclude = true;
            } else if (tag == config.tagPrintOnly) {
                if (config.profile != Machinata.Reporting.Profiles.PROFILE_PRINT_KEY) json.exclude = true;
            } else if (tag == config.tagFullscreenOnly) {
                if (config.profile != Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY) json.exclude = true;
            }
        }
    }

    // Level
    if (parent == null) {
        json.level = 0;
        json.screenNumber = null;
        json.chapterId = null;
    } else {
        json.level = parent.level + 1;
        json.screenNumber = parent.screenNumber;
        json.chapterId = parent.chapterId;
    }

    // Chapter book keeping
    if (json.level == config.chapterLevel && json.nodeType == "SectionNode") {
        if(json.mainTitle != null) {
            json.chapterId = json.id;
            json.chapter = true; // helper marker
            if (config.headless == false) {
                json.chapterURL = Machinata.updateQueryString("chapter", json.chapterId, config.url);
                json.chapterURL = Machinata.removeQueryParameter("focus", json.chapterURL);
                json.chapterURL = Machinata.removeQueryParameter("screen", json.chapterURL);
                json.chapterURL = Machinata.removeQueryParameter("ui", json.chapterURL);
            }
            instance.chapters.push(json);
            Machinata.debug("    new chapter: " + json.chapterId);
            if (Machinata.Reporting.Handler.addChapterNavigation != null) {
                var infos = {};
                infos.chapterURL = json.chapterURL;
                infos.chapterId = json.chapterId;
                infos.chapterTitle = Machinata.Reporting.Text.resolve(instance,json.mainTitle);
                Machinata.Reporting.Handler.addChapterNavigation(instance, infos, json);
            }
        }
    }


    // Screen number book keeping
    if (json.level == config.screenLevel && config.automaticallyGenerateScreenNumbers == true) {
        json.screenNumber = instance.screens.length;
        instance.screens.push(json);
        Machinata.debug("    new screen: " + json.screenNumber);
    } else if(json.screen == true) {
        json.screenNumber = instance.screens.length;
        instance.screens.push(json);
        Machinata.debug("    new screen: " + json.screenNumber);
    }

    // Inherit theme
    if (json.theme == null && parent != null) json.theme = parent.theme;

    // Validate theme
    if (json.theme != null && Machinata.Reporting.getTheme(json.theme) == null) {
        console.warn("The theme '"+json.theme+"' for node "+json.id+" is not valid.");
        json.theme = "default";
    }

    // URL
    if (config.headless == false && json.url == null) {
        json.url = Machinata.updateQueryString("focus", json.id, config.url);
        json.url = Machinata.updateQueryString("chapter", json.chapterId, json.url);
    }

    // Debug
    Machinata.debug("    id: " + json.id);
    Machinata.debug("        level: " + json.level);
    Machinata.debug("        screen: " + json.screenNumber);

    
    //TODO: fullscreen API: migrate to buildContent
    /*
    // Matches?
    if (instance.screensToShow != null) {
        var matches = false;
        for (var i = 0; i < instance.screensToShow.length; i++) {
            if (json.screenNumber == instance.screensToShow[i]) {
                matches = true;
                Machinata.debug("    ***matches " + instance.screensToShow[i]);
                break;
            }
        }
        if (matches == false) {
            json.exclude = true;
            Machinata.debug("    no match, excluded");
        } else {
            json.exclude = false;
            Machinata.debug("    ***match!");
        }
    }
    */

    // Children
    Machinata.Util.each(json.children, function (index, childJSON) {
        Machinata.Reporting._buildIndexRecursively(instance, config, childJSON, json);
        // Inherit child exclude to make sure titles trickle up on screen matching
        //TODO: fullscreen API: migrate to buildContent
        //if (instance.screensToShow != null && childJSON.exclude == false) {
        //    json.exclude = false;
        //}
    });
};

/// <summary>
/// Builds a report for the configuration
/// </summary>
Machinata.Reporting.buildReport = function (instance, config, onSuccess) {

    //var reportData = Machinata.Util.cloneJSON(instance.rootNode);
    var reportData = instance.rootNode;

    // Recursive routine to update the screen inclusion
    // Note: this is not as straight forward as one might think, as the screen
    // flag will trickle back up to the root node to allow a screen to include a section title
    // (ie setting screen=true on a subnode will automatically select all the parent nodes to ensure the subnode is included)
    function _updateScreenInclusion(instance, config, json, parent) {
        if (instance.screensToShow != null) {
            // Matches?
            var matches = false;
            for (var i = 0; i < instance.screensToShow.length; i++) {
                if (json.screenNumber == instance.screensToShow[i]) {
                    matches = true;
                    Machinata.debug("    ***matches " + instance.screensToShow[i]);
                    break;
                }
            }
            if (matches == false) {
                json.exclude = true;
                Machinata.debug("    no match, excluded");
            } else {
                json.exclude = false;
                Machinata.debug("    ***match!");
            }
        } else {
            json.exclude = false;
        }
        // Recursively update each child, based on the same logic
        Machinata.Util.each(json.children, function (index, childJSON) {
            // Inherit child exclude to make sure titles trickle up on screen matching
            _updateScreenInclusion(instance, config, childJSON, json);
            // If the child was marked as include, mark self as include as well
            if (childJSON.exclude == false) {
                json.exclude = false;
            }
        });
    };
    _updateScreenInclusion(instance, config, reportData, null);
    
    // Remove all existing within content selector
    instance.elems.content.children().filter(".machinata-reporting-node").remove();

    // Build content recursively
    if (config.buildContents == true) {
        Machinata.Debugging.startTimer("report-buildcontents");
        Machinata.Reporting.buildContents(instance, config, reportData, null);
        Machinata.Debugging.stopTimer("report-buildcontents");
    }

    // Bind tooltips via handler, if any
    if (Machinata.Reporting.Handler.bindTooltipsUI != null) {
        Machinata.Reporting.Handler.bindTooltipsUI(instance, $(".machinata-reporting-styling")); 
    }

    // Bind new responsive elements
    //Machinata.Debugging.startTimer("report-responsive");
    //Machinata.Responsive.detectNewResponsiveElements();
    //Machinata.Responsive.updateResponsiveElements();
    //Machinata.Debugging.stopTimer("report-responsive");

    // Trigger initial redraw
    //EXPENSIVE:
    Machinata.Debugging.startTimer("report-firstdraw");
    //instance.elems.content.find(".machinata-reporting-node").trigger("machinata-reporting-redraw-node");
    Machinata.Reporting.Responsive.updateForContainerSize(instance);
    Machinata.Debugging.stopTimer("report-firstdraw");

    // On success callback
    if (onSuccess) {
        // Allow browser to schedule a frame update inbetween
        setTimeout(function () {
            onSuccess(instance, config);
        }, 10);
    }
};

/// <summary>
/// Recursivley builds the actual contents of the report, making sure
/// to respect any configuration regarding screen or chapter selection.
/// </summary>
Machinata.Reporting.buildContents = function (instance, config, json, parent, insertionElem) {

    // Disabled? If so, skip
    if (json.enabled == false) return;
    if (json.exclude == true) return;

    //json = Machinata.Util.cloneJSON(json); // <<< very expensive

    // ID sanity - not all nodes come from a built index, some are built on the fly, so we 
    // assign an id if not already
    if (json.id == null) {
        json.id = Machinata.Reporting.uid();
    }
    instance.idToNodeJSONLookupTable[json.id] = json;

    Machinata.debug("Machinata.Reporting.buildContents:");
    Machinata.debug("    type: " + json.nodeType);
    Machinata.debug("    id: " + json.id);
    Machinata.debug("    level: " + json.level);

    // Include via chapters param?
    // Note: we only exclude if we are past the chapters level (since we need the root node for a chapter)
    var include = true;
    if (json.level >= config.chapterLevel && config.chapters != null && config.chapters != "*" && config.chapters.length != 0) {
        include = false;
        for (var i = 0; i < config.chapters.length; i++) {
            if (config.chapters[i] == json.chapterId) {
                include = true;
                Machinata.debug("    excluding due to chapter mismatch!");
                break;
            }
        }
    }
    if (include == false) {
        return;
    }

    // Parent elem
    // If we dont specify the insertion point, we get the childrens elem from the parent json dom elem
    var parentElem = null;
    if (insertionElem != null) parentElem = insertionElem;
    if (parent != null && parentElem == null) {
        if (parent._domElem != null && parent._domElem.data("children") != null) {
            parentElem = parent._domElem.data("children");
        } else {
            parentElem = parent._domElem;
        }
    }
    
    if (parentElem == null) parentElem = instance.elems.content;

    // Create node elem
    var sizerElem = null;
    var nodeElem = null;
    if (config.useSizerParentElemForNodes == true) {
        sizerElem = $("<div class='machinata-reporting-node-sizer'></div>").appendTo(parentElem);
        nodeElem = Machinata.Reporting.Node.build(instance, config, json, sizerElem);
    } else {
        nodeElem = Machinata.Reporting.Node.build(instance, config, json, parentElem);
    }
    json._domElem = nodeElem;

    // Children...
    if (json.processChildren != false) { // could be null
        Machinata.Util.each(json.children, function (index, childJSON) {
            if (childJSON.nodeType == "StopProcessNode") return false; // For debugging only, special node type that stops the tree from resolving...
            Machinata.Reporting.buildContents(instance, config, childJSON, json);
        });
    }

    // Post build?
    var impl = Machinata.Reporting.Node[json.nodeType];
    if (impl != null && impl.postBuild != null) {
        impl.postBuild(instance, config, json, nodeElem);
    }

    // Clearer
    //$("<div class='machinata-reporting-section-end'></div>").addClass("level-" + level).appendTo(sectionElem);

    // Focus target?
    //TODO
    //if (instance.focusKey != null && json.key != null && instance.focusKey == json.key) {
    //    Machinata.Reporting.Elems.focusElement = sectionElem;
    //    Machinata.debug("***found focus element (section): " + json.key);
    //};

    return nodeElem;
};

/// <summary>
/// Registers multiple layouts at the same time by providing an key value map of layouts
/// where each key is the layout name and the value is the layout JSON.
/// See ```Machinata.Reporting.registerLayout```
/// </summary>
Machinata.Reporting.registerLayouts = function (layoutsJSON) {
    Machinata.debug("Machinata.Reporting.registerLayouts:");
    Machinata.Util.each(layoutsJSON, function (key, val) {
        Machinata.debug("  "+key);
        Machinata.Reporting.registerLayout(key, val);
    });
};


/// <summary>
/// Registers a new layout with the layouting system. Layouts registered here
/// a primarily used by the LayoutNode, though any component in the reporting system
/// may make use of layouts.
/// 
/// The layoutJSON contains an array of children definitions called ```children```. This
/// property is used to define (extend, overwrite) each slot child's properties according. Typically this
/// achieved by defining the ```style``` and ```chrome``` of each child slot. Each slot definition must also
/// contain the ```slotKey``` property that defines the name of the slot.
/// </summary>
/// <example>
/// ```
/// ### Layout JSON (definition)
/// var layoutJSON = {
///     "style": "CS_CustomStyleToAddToLayout",
///     "children": [
///         {
///             "slotKey": "{left}",
///             "style": "CS_W_Block1x1"
///         },
///         {
///             "slotKey": "{center}",
///             "style": "CS_W_Block2x1"
///         },
///         {
///             "slotKey": "{right}",
///             "style": "CS_W_Block1x1"
///         }
///     ]
/// };
/// Machinata.Reporting.registerLayout("CS_W_Overview_PanelTrailerSmall",layoutJSON);
/// ```
///
/// ### Layout Node (usage)
/// ```
/// {
///     "nodeType": "LayoutNode",
///     "style": "CS_W_Overview_PanelTrailerSmall",
///     "slotChildren": {
///         "{left}": 0,
///         "{center}": 1,
///         "{right}": 2
///     },
///     "children": [
///         {
///             "nodeType": "PlaceholderNode",
///             "mainTitle": {
///                 "resolved": "Left node"
///             }
///         },
///         {
///             "nodeType": "PlaceholderNode",
///             "mainTitle": {
///                 "resolved": "Center node"
///             }
///         },
///         {
///             "nodeType": "PlaceholderNode",
///             "mainTitle": {
///                 "resolved": "Right node"
///             }
///         }
///     ]
/// }
/// ```
/// </example>
Machinata.Reporting.registerLayout = function (name, layoutJSON) {
    // Register
    layoutJSON.name = name;
    Machinata.Reporting._layouts[name] = layoutJSON;
};

/// <summary>
/// </summary>
Machinata.Reporting.getLayout = function (name) {
    return Machinata.Reporting._layouts[name];
};



/// <summary>
/// Register a new global theme for the report. This should be called before the ```init()``` method.
/// Each theme used by the node property ```theme``` should be registered here so that
/// charting libraries can access the themes.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.registerTheme('blue', ['#003868', '#004c97', '#0072ce', '#adc8e9', '#dadada', '#a8a8a7']); // dark,mid,bright,light,gray3,gray4 
/// ```
/// </example>
Machinata.Reporting.registerTheme = function (name, colors) {
    // Register
    Machinata.Reporting._themes[name] = colors;
    // Register with Vega
    vega.scheme(name, colors);
};

/// <summary>
/// </summary>
Machinata.Reporting.getTheme = function (name) {
    return Machinata.Reporting._themes[name];
};

/// <summary>
/// </summary>
Machinata.Reporting.getThemeColorByIndex = function (name, index) {
    var theme = Machinata.Reporting._themes[name];
    var c = theme[(index % theme.length)];
    return c;
};

/// <summary>
/// </summary>
Machinata.Reporting.getThemeTextColorByShade = function (config, name, shade) {
    if (name == null) name = "default";
    name = "text-on-" + name;
    return Machinata.Reporting.getThemeColorByShade(config, name, shade);
};

/// <summary>
/// </summary>
Machinata.Reporting.getThemeColorByShade = function (config, name, shade) {
    if (name == null) name = "default";
    var theme = Machinata.Reporting.getTheme(name);
    if (theme == null) return null; // sanity

    // Translate positive negative to shade?
    if (shade == "positive") shade = config.themeNegativePositiveShadeNames[1];
    else if (shade == "negative") shade = config.themeNegativePositiveShadeNames[0];

    var index = -1;
    for (var i = 0; i < config.themeColorShadeNames.length; i++) {
        if (config.themeColorShadeNames[i] == shade) {
            index = i;
            break;
        }
    }
    if (index == -1 || index >= theme.length) {
        console.warn("Machinata.Reporting.getThemeColorByShade: could not get theme shade " + shade);
        return null;
    }

    return theme[index];
};



/// <summary>
/// Get a full icon class through the standardized icon key.
/// Currently the following standard icons exist:
///  - ```alert```
///  - ```info```
///  - ```trend-up```
///  - ```trend-down```
///  - ```fullscreen```
///  - ```print```
///  - ```check```
///  - ```copy```
///  - ```filter```
///  - ```export```
///  - ```download```
///  - ```report```
///  - ```arrow-left```
///  - ```arrow-right```
/// </summary>
Machinata.Reporting.icon = function (instance,key) {
    if (Machinata.Reporting.Handler.getIconByKey == null) return null;
    return Machinata.Reporting.Handler.getIconByKey(instance,key);
};

/// <summary>
/// </summary>
Machinata.Reporting.buildIcon = function (instance, key) {
    if (instance.config.iconsBundle == null) throw "Machinata.Reporting.buildIcon: iconsBundle cannot be null";
    var iconsBundle = instance.config.iconsBundle.replace("{" + "assets-path" + "}", instance.config.assetsPath);
    var iconName = Machinata.Reporting.Handler.getIconByKey(instance,key);
    var iconURL = iconsBundle + "#" + iconName;
    return Machinata.UI.buildSVGIcon(iconName, iconURL).addClass("icon-"+key);
};

/// <summary>
/// </summary>
Machinata.Reporting.buildCheckbox = function (instance, title, enabled, type, name, value) {
    if (type == null) type = "checkbox";
    var checkboxId = Machinata.Reporting.uid();
    if (name == null) name = checkboxId;
    var checkboxUIElem = $('<div class="machinata-reporting-checkbox"><input type="' + type +'" name="' + name+ '"/><label></label></div>');
    if (name != null) checkboxUIElem.find("input").attr("value", value);
    checkboxUIElem.find("label").append(Machinata.Reporting.buildIcon(instance, "check"));
    checkboxUIElem.find("label")
        .attr("for", checkboxId)
        .append(title);
    checkboxUIElem.find("input")
        .attr("id", checkboxId);
    if (enabled != false) checkboxUIElem.find("input").attr("checked", "checked");
    return checkboxUIElem;
};

/// <summary>
/// Creates a toolbar and returns the element.
/// </summary>
Machinata.Reporting.buildToolbar = function (instance, title, subtitle) {
    var toolbarElem = $('<div class="machinata-reporting-toolbar DEPRECATED_ui-toolbar">');
    //if (config.chrome != null) toolbarElem.addClass("option-" + config.chrome);
    if (title != null) {
        var titleLabelElem = $('<label class="title theme-headline-font"></label>').text(title);
        toolbarElem.append(titleLabelElem);
        Machinata.UI.autoShowTextAsTooltipOnTruncated(titleLabelElem);
    }
    if (subtitle != null) {
        var subtitleLabelElem = $('<label class="subtitle"></label>').text(subtitle);
        toolbarElem.append(subtitleLabelElem);
        Machinata.UI.autoShowTextAsTooltipOnTruncated(subtitleLabelElem);
    }
    toolbarElem.append($('<div class="tabs"></div>'));
    toolbarElem.append($('<div class="tools"></div>'));
    return toolbarElem;
};


/// <summary>
/// Creates a toolbar and returns the element.
/// </summary>
Machinata.Reporting.buildMenubar = function (instance, options) {
    if (options == null) options = {};
    var menubarElem = $('<div class="machinata-reporting-menubar"><ul class="tabs"></ul></div>');
    if (options.softMenuBar == true) menubarElem.addClass("option-soft");
    else menubarElem.addClass("option-hard");
    return menubarElem;
};


/// <summary>
/// Creates a subtoolbar and returns the element.
/// </summary>
/// <deprecated/>
Machinata.Reporting.buildSubToolbar = function (instance, options) {
    var toolbarElem = $('<div class="machinata-reporting-subtoolbar DEPRECATED_ui-toolbar option-small">');
    //if (config.chrome != null) toolbarElem.addClass("option-" + config.chrome);
    toolbarElem.append($('<div class="tabs"></div>'));
    toolbarElem.append($('<label class="hint"></label>'));
    toolbarElem.append($('<div class="tools"></div>'));
    return toolbarElem;
};

/// <summary>
/// </summary>
Machinata.Reporting.showToolbarToolsAsModalDialog = function (instance, toolbarElem, title) {
    // Build a options dialog with all the tools that are hidden
    var opts = {};
    toolbarElem.find(".tool").not(".all-tools").each(function () {
        opts[$(this).attr("data-tool-id")] = $(this).attr("title");
    });
    Machinata.optionsDialog(title, "", opts)
        .okay(function (id, val) {
            $("[data-tool-id='" + id + "']").trigger("click");
        })
        .show();
};

/// <summary>
/// </summary>
Machinata.Reporting.addMenubarButton = function (instance, elem, title, action, options) {
    
    if (elem == null) return; //TODO: handle better?
    if (options == null) options = {};

    var additionalClasses = null;
    if (!elem.hasClass("machinata-reporting-node")) elem = elem.closest(".machinata-reporting-node");
    
    // Get the nodes menubar
    var menubarElem = elem.data("menubar");
    if (menubarElem == null) {
        // Create a new menubar
        menubarElem = Machinata.Reporting.buildMenubar(instance,options);
        elem.data("menubar", menubarElem); 
    }
    if (menubarElem != null) {
        // Create new button
        var buttonElem = $("<li><a></a></li>");
        buttonElem.click(function () { action(buttonElem); });
        buttonElem.find("a").text(title);
        // Add to menubar
        menubarElem.find(".tabs").append(buttonElem);
        return buttonElem;
    } else {
        return null;
    }
};


/// <summary>
/// Adds a tool to the node toolbar.
///     action: click handler
///     options: space seperated string of options (classes)
/// </summary>
Machinata.Reporting.addTool = function (instance, elem, title, icon, action, options) {
    //if (instance.config["suppress-tools"] == true) return; // DEPRECATED: seems unused
    if (elem == null) return; //TODO: handle better?

    var additionalClasses = null;
    if (!elem.hasClass("machinata-reporting-node")) elem = elem.closest(".machinata-reporting-node");
    var ownerId = elem.attr("id");
    if (elem.hasClass("option-parent-toolbar")) {
        elem = elem.parent().closest(".machinata-reporting-node");
        additionalClasses = "belongs-to-child-node";
    }
    var toolbarElem = elem.data("toolbar");
    if (toolbarElem != null) {
        var toolElem = Machinata.Reporting.addToolToToolbar(instance, elem, toolbarElem, title, icon, action, options);
        toolElem.attr("data-owner-id", ownerId);
        toolElem.addClass(additionalClasses);
        return toolElem;
    } else {
        return null;
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.addSubTool = function (instance, elem, title, icon, action, options) {
    if (!elem.hasClass("machinata-reporting-node")) elem = elem.closest(".machinata-reporting-node");
    var toolbarElem = elem.data("subtoolbar");
    if (toolbarElem != null) {
        return Machinata.Reporting.addToolToToolbar(instance, elem, toolbarElem, title, icon, action, options);
    } else {
        return null;
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.addSubTab = function (instance, elem, title, icon, action, options) {
    if (!elem.hasClass("machinata-reporting-node")) elem = elem.closest(".machinata-reporting-node");
    var toolbarElem = elem.data("subtoolbar");
    if (toolbarElem == null) {
        // Not yet created, create it
        alert("no toolbar yet");
    }
    if (toolbarElem != null) {
        return Machinata.Reporting.addTabToToolbar(instance, elem, toolbarElem, title, icon, action, options);
    } else {
        return null;
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.addToolToToolbar = function (instance, elem, toolbarElem, title, icon, action, options) {
    function createToolElem(icon, action, options) {
        var toolElem = $("<div class='tool'></div>").appendTo(toolbarElem.find(".tools"));
        toolElem.append(Machinata.Reporting.buildIcon(instance, icon));
        toolElem.click(function () { action(toolElem); });
        toolElem.addClass("tool-" + icon);
        toolElem.attr("data-tool-id", Machinata.Reporting.uid());
        toolbarElem.addClass("option-has-tool");
        if (options != null) toolElem.addClass(options);
        return toolElem;
    }
    // Icon
    var toolElem = createToolElem(icon, action, options);
    if (toolbarElem == elem.data("toolbar")) elem.addClass("option-has-tool");
    if (toolbarElem == elem.data("subtoolbar")) elem.addClass("option-has-subtool");
    // Title interaction
    if (title != null) {
        toolElem.attr("title", title);
    }
    // Bookkeeping
    var numTools = toolbarElem.find(".tools .tool").not(".all-tools").length;
    if (numTools > 1) {
        toolElem.addClass("option-desktop-only");
    }
    if (numTools > 1 && toolbarElem.find(".tools .tool.all-tools").length == 0) {
        var allToolsElem = createToolElem("more", function (toolElem) { }, "all-tools option-mobile-tablet-only");
        allToolsElem.click(function () {
            Machinata.Reporting.showToolbarToolsAsModalDialog(instance, $(this).closest(".machinata-reporting-toolbar"));
        });
    }
    var numToolsDesktop = toolbarElem.find(".tools .tool").not(".option-mobile-tablet-only").length;
    var numToolsMobile = toolbarElem.find(".tools .tool").not(".option-desktop-only").length;
    toolbarElem.attr("data-num-tools", numTools);
    toolbarElem.attr("data-num-tools-desktop", numToolsDesktop);
    toolbarElem.attr("data-num-tools-mobile", numToolsMobile);
    toolbarElem.attr("data-num-tools-tablet", numToolsMobile);
    return toolElem;
};

/// <summary>
/// </summary>
Machinata.Reporting.addTabToToolbar = function (instance, elem, toolbarElem, title, icon, action, options) {
    // Icon
    var tabElem = $("<div class='tab'></div>").text(title).appendTo(toolbarElem.find(".tabs"));
    tabElem.click(function () { action(tabElem); });
    if (options != null) tabElem.addClass(options);
    toolbarElem.addClass("option-has-tab");
    if (toolbarElem == elem.data("toolbar")) elem.addClass("option-has-tab");
    if (toolbarElem == elem.data("subtoolbar")) elem.addClass("option-has-subtab");
    return tabElem;
};





/// <summary>
/// 
/// </summary>
Machinata.Reporting.cleanup = function (instance) {
    // Tell all nodes to cleanup
    instance.elems.content.find(".machinata-reporting-node").trigger(Machinata.Reporting.Events.CLEANUP_NODE_SIGNAL);

    // Tell all nodes to remove
    instance.elems.content.find(".machinata-reporting-node").trigger(Machinata.Reporting.Events.REMOVE_NODE_SIGNAL);

    // Flush dom
    if (instance.elems.content != null) instance.elems.content.remove();
    if (instance.elems.catalog != null) instance.elems.catalog.remove();

    // Flush instance references
    instance.catalogData = null;
    instance.reportData = null;
    instance.rootNode = null;
    instance.catalogCurrentMandate = null;
    instance.catalogCurrentReport = null;
    instance.idToNodeElementLookupTable = null;
    instance.screensToShow = null;
    instance.chapters = null;
    instance.currentScreen = null;
    instance.totalScreens = null;
    instance.focusKey = null;

}













/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-events.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-events.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// 
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Events = {};


/* ======== Signals ========================================================== */

/// <summary>
/// </summary>
Machinata.Reporting.Events.REDRAW_NODE_SIGNAL = "machinata-reporting-redraw-node";

/// <summary>
/// </summary>
Machinata.Reporting.Events.REDRAW_NODE_AND_CHILDREN_SIGNAL = "machinata-reporting-redraw-node-and-children";

/// <summary>
/// </summary>
Machinata.Reporting.Events.CLEANUP_NODE_SIGNAL = "machinata-reporting-cleanup-node";

/// <summary>
/// </summary>
Machinata.Reporting.Events.REMOVE_NODE_SIGNAL = "machinata-reporting-remove-node";

/// <summary>
/// </summary>
Machinata.Reporting.Events.REBUILD_TABLE_SIGNAL = "machinata-reporting-rebuild-table";


/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-catalog.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-catalog.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Catalog namespace. 
/// Utilities for displaying catalogs of reports dynamically.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Catalog = {};


/// <summary>
/// </summary>
Machinata.Reporting.Catalog.processCatalog = function (instance, config, catalogData) {

    Machinata.Debugging.startTimer("catalog-process");

    // Pre-process
    var catalogDateParser = d3.timeParse(config.catalogDateFormat);
    var catalogDateFormatter = d3.timeFormat(config.catalogDateDisplayFormat);
    Machinata.Util.each(catalogData.mandates, function (index, mandateJSON) {
        // Process the mandate
        mandateJSON.titleResolved = Machinata.Reporting.Text.resolve(instance, mandateJSON.title);
        mandateJSON.dateToReportMap = {};
        mandateJSON.publishedDateRaw = mandateJSON.publishedDate;
        mandateJSON.publishedDateResolved = mandateJSON.publishedDateRaw;
        if (mandateJSON.publishedDateRaw != null) {
            mandateJSON.publishedDate = catalogDateParser(mandateJSON.publishedDateRaw);
            mandateJSON.publishedDateResolved = catalogDateFormatter(mandateJSON.publishedDate);
        }
        var mandateURL = null;
        Machinata.Util.each(mandateJSON.reports, function (index, reportJSON) {
            // Process the report
            reportJSON.dateRaw = reportJSON.parameters.reportingDate;
            reportJSON.dateResolved = reportJSON.dateRaw;
            reportJSON.date = null;
            if (reportJSON.dateRaw != null) {
                reportJSON.date = catalogDateParser(reportJSON.dateRaw);
                reportJSON.dateResolved = catalogDateFormatter(reportJSON.date);
            }
            if (reportJSON.date != null) {
                mandateJSON.dateToReportMap[reportJSON.date] = reportJSON;
            }
            if (config.dataSource == null || config.dataSource == "auto") {
                config.dataSource = reportJSON.dataSource;
                if (instance.catalogCurrentMandate == null) instance.catalogCurrentMandate = mandateJSON;
                if (instance.catalogCurrentReport == null) instance.catalogCurrentReport = reportJSON;
            }
            if (Machinata.queryParameter("report") == reportJSON.id) {
                config.dataSource = reportJSON.dataSource;
                instance.catalogCurrentMandate = mandateJSON;
                instance.catalogCurrentReport = reportJSON;
                config.reportTitle = Machinata.Reporting.Text.resolve(instance, mandateJSON.title);
                //config.reportSubtitle = reportJSON.dateResolved; //TODO: @dan @bmpi 
            }
            // Create proper urls
            var reportURL = Machinata.updateQueryString("report", reportJSON.id, config.reportURL);
            reportURL = Machinata.removeQueryParameter("chapter", reportURL);
            reportURL = Machinata.removeQueryParameter("focus", reportURL);
            reportURL = Machinata.removeQueryParameter("ui", reportURL);
            reportJSON.urlResolved = reportURL;
            if (mandateURL == null) {
                mandateURL = Machinata.updateQueryString("report", reportJSON.id, config.reportURL);
                mandateURL = Machinata.removeQueryParameter("chapter", mandateURL);
                mandateURL = Machinata.removeQueryParameter("focus", mandateURL);
            }
        });
        mandateJSON.urlResolved = mandateURL;
        // Create a url to list all mandate reports
        var mandateCatalogURL = Machinata.updateQueryString("mandate", mandateJSON.id, config.catalogURL);
        var mandateCatalogURL = Machinata.updateQueryString("reports", "true", mandateCatalogURL);
        mandateJSON.catalogURLResolved = mandateCatalogURL;
    });

    Machinata.Debugging.stopTimer("catalog-process");
};

/// <summary>
/// </summary>
Machinata.Reporting.Catalog.compileCatalogUI = function (instance, config, catalogData) {

    Machinata.Debugging.startTimer("catalog-compile");

    // Set window title
    // Here we use the config reportWindowTitle, unless we are in webprint, in which case we try to use the filename...
    if (config.catalogWindowTitle != null) {
        var windowTitle = Machinata.Reporting.Tools.createTitleString(instance, config, config.catalogWindowTitle);
        if (windowTitle != null) window.document.title = windowTitle;
    }

    // Attributes
    $(".machinata-reporting-attribute-catalog-title").text(Machinata.Reporting.Text.resolve(instance,catalogData["catalogTitle"]));

    // Add all mandate siblings for catalog navigation
    if (config.automaticallyInsertCatalogNavigation == true && Machinata.Reporting.Handler.addNavigationSibling != null) {
        Machinata.Util.each(catalogData.mandates, function (index, mandateJSON) {
            if (index >= config.navigationMaxSiblings) return;
            var siblingNavItemElem = Machinata.Reporting.Handler.addNavigationSibling(instance, mandateJSON.titleResolved, mandateJSON.urlResolved);
        });
        var siblingNavItemElem = Machinata.Reporting.Handler.addNavigationSibling(instance, Machinata.Reporting.Text.translate(instance, "reporting.view-all"), config.catalogURL);
    }
    // Add all date siblings for report date navigation
    //NOTE: disabled due to UX overcomplication
    if (false) {
        if (instance.catalogCurrentMandate != null && instance.catalogCurrentReport != null) {
            var dateNavItemElem = Machinata.Reporting.Handler.addNavigationItem(instance, instance.catalogCurrentReport.dateResolved, instance.catalogCurrentReport.urlResolved);
            Machinata.Util.each(instance.catalogCurrentMandate.reports, function (index, reportJSON) {
                if (index >= config.navigationMaxSiblings) return;
                if (instance.catalogCurrentMandate.reports.length == 1) return;
                var siblingNavItemElem = Machinata.Reporting.Handler.addNavigationSibling(instance, reportJSON.dateResolved, reportJSON.urlResolved);
            });
            if (instance.catalogCurrentMandate != null) {
                var siblingNavItemElem = Machinata.Reporting.Handler.addNavigationSibling(instance, Machinata.Reporting.Text.translate(instance, "reporting.view-all"), instance.catalogCurrentMandate.catalogURLResolved);
            }
        }
    }

    // Compile a table/listing UI of catalog/report items 
    if (instance.elems.catalog != null && instance.elems.catalog.length > 0) {
        // Init
        var tableElem = instance.elems.catalog.closest("table");
        var showReports = Machinata.queryParameter("reports") == "true";
        var mandateFilter = Machinata.queryParameter("mandate");
        if (mandateFilter == "") mandateFilter = null;
        if (showReports == true) {
            tableElem.addClass("option-show-reports");
        }
        // Get the template
        var templateMandateElem = $(config.catalogItemMandateTemplateSelector);
        var templateReportElem = $(config.catalogItemReportTemplateSelector);
        // Add a row for each mandate
        Machinata.Util.each(catalogData.mandates, function (index, mandateJSON) {
            // Filter out?
            if (mandateFilter != null && mandateJSON.id != mandateFilter) {
                return;
            } else if (mandateFilter != null && mandateJSON.id == mandateFilter) {
                $(".machinata-reporting-attribute-catalogs-title").hide();
                $(".machinata-reporting-attribute-reports-title").show();
                $(".machinata-reporting-attribute-catalog-title").text(mandateJSON.titleResolved);
                Machinata.Reporting.Handler.addNavigationItem(instance, mandateJSON.titleResolved, "");
            }
            // Compile mandate item
            var itemElem = templateMandateElem.clone();
            itemElem.find(".attribute-link").attr("href", mandateJSON.urlResolved);
            if (itemElem.hasClass("attribute-link")) itemElem.attr("href", mandateJSON.urlResolved);
            itemElem.find(".attribute-title").text(mandateJSON.titleResolved);
            var mandateDate = null;
            var mandateDateResolved = null;
            if (mandateJSON.reports != null && mandateJSON.reports.length > 0) {
                mandateDateResolved = mandateJSON.reports[0].dateResolved; // latest report
                mandateDate = mandateJSON.reports[0].date; // latest report
            }
            itemElem.find(".attribute-reporting-date").text(mandateDateResolved);
            if (mandateJSON.investor != null) itemElem.find(".attribute-investor-name").text(mandateJSON.investor.name);
            if (mandateJSON.custodyBank != null) itemElem.find(".attribute-custody-bank-name").text(mandateJSON.custodyBank.name);
            if (mandateJSON.custodyBank != null) itemElem.find(".attribute-custody-bank-account").text(mandateJSON.custodyBank.account);
            if (mandateJSON.portfolioManager != null) itemElem.find(".attribute-pm-name").text(mandateJSON.portfolioManager.firstName + " " + mandateJSON.portfolioManager.lastName);
            if (mandateJSON.portfolioManager != null) itemElem.find(".attribute-pm-email").text(mandateJSON.portfolioManager.email);
            if (mandateJSON.portfolioManager != null) itemElem.find(".attribute-pm-phone").text(mandateJSON.portfolioManager.phone);
            if (mandateJSON.clientPortfolioManager != null) itemElem.find(".attribute-cpm-name").text(mandateJSON.clientPortfolioManager.firstName + " " + mandateJSON.clientPortfolioManager.lastName);
            if (mandateJSON.clientPortfolioManager != null) itemElem.find(".attribute-cpm-email").text(mandateJSON.clientPortfolioManager.email);
            if (mandateJSON.clientPortfolioManager != null) itemElem.find(".attribute-cpm-phone").text(mandateJSON.clientPortfolioManager.phone);
            if (mandateJSON.relationshipManager != null) itemElem.find(".attribute-rm-name").text(mandateJSON.relationshipManager.firstName + " " + mandateJSON.relationshipManager.lastName);
            if (mandateJSON.relationshipManager != null) itemElem.find(".attribute-rm-email").text(mandateJSON.relationshipManager.email);
            if (mandateJSON.relationshipManager != null) itemElem.find(".attribute-rm-phone").text(mandateJSON.relationshipManager.phone);
            if (mandateJSON.totalAssets != null) itemElem.find(".attribute-total-assets-amount").text(mandateJSON.totalAssets.amount.resolved);
            if (mandateJSON.totalAssets != null) itemElem.find(".attribute-total-assets-amount-value").attr("data-text", mandateJSON.totalAssets.amount.value);
            if (mandateJSON.totalAssets != null) itemElem.find(".attribute-total-assets-currency").text(mandateJSON.totalAssets.currency);
            if (mandateJSON.publishedDateResolved != null) itemElem.find(".attribute-published-date").text(mandateJSON.publishedDateResolved);
            if (mandateJSON.id != null) itemElem.find(".attribute-id").text(mandateJSON.id);
            itemElem.find(".table-cell.type-tools").append(Machinata.Reporting.buildIcon(instance, "list").addClass("machinata-reporting-show-reports").attr("title", Machinata.Reporting.Text.translate(instance, "reporting.show-all-reports")));
            itemElem.find(".table-cell.type-tools").append(Machinata.Reporting.buildIcon(instance, "calendar").addClass("machinata-reporting-choose-report-date").attr("title", Machinata.Reporting.Text.translate(instance, "reporting.choose-date")));
            itemElem.find(".table-cell.type-tools").append(Machinata.Reporting.buildIcon(instance, "arrow-right").addClass("machinata-reporting-open-report").attr("title", Machinata.Reporting.Text.translate(instance, "reporting.view-latest-report")));
            itemElem.find(".attribute-type").text(Machinata.Reporting.Text.resolve(instance,mandateJSON.mandateType));
            itemElem.find(".machinata-reporting-choose-report-date").click(function (evt) {
                evt.stopPropagation();
                evt.preventDefault();
                Machinata.Reporting.Handler.changeReportingDate(instance, instance.catalogData, mandateJSON, null, mandateDate, Machinata.Reporting.Text.translate(instance, "reporting.choose-date"));
            });
            itemElem.find(".machinata-reporting-show-reports").click(function (evt) {
                evt.stopPropagation();
                evt.preventDefault();
                Machinata.goToPage(mandateJSON.catalogURLResolved);
            });
            var badgeElem = itemElem.find(".attribute-badge");
            if (mandateJSON.reportBadge != null) {
                if (mandateJSON.reportBadge.color != null) badgeElem.addClass("option-" + mandateJSON.reportBadge.color);
                badgeElem.text(Machinata.Reporting.Text.resolve(instance,mandateJSON.reportBadge.label));
                badgeElem.addClass("has-content")
                if (mandateJSON.reportBadge.tooltip != null) badgeElem.attr("title", Machinata.Reporting.Text.resolve(instance,mandateJSON.reportBadge.tooltip));
            } else {
                badgeElem.remove();
            }
            itemElem.removeClass(config.catalogItemMandateTemplateSelector.replace(".", ""));
            if (showReports) itemElem.addClass("static").attr("data-row-index", 0);
            instance.elems.catalog.append(itemElem);
            // Add all reports?
            if (showReports) {
                instance.elems.catalog.addClass("has-reports");
                var maxReportsToList = config.catalogMaxReportsToShow;
                Machinata.Util.each(mandateJSON.reports, function (index, reportJSON) {
                    // Compile report item
                    var itemElem = templateReportElem.clone();
                    if (maxReportsToList == null || index < maxReportsToList) {
                        // Report specifics
                        itemElem.find(".attribute-link").attr("href", reportJSON.urlResolved);
                        if (itemElem.hasClass("attribute-link")) itemElem.attr("href", reportJSON.urlResolved);
                        itemElem.find(".attribute-reporting-date").text(reportJSON.dateResolved).attr("data-sort", reportJSON.date.getTime());
                        // Mandate specifics
                        itemElem.find(".attribute-title").text(mandateJSON.titleResolved);
                        if (mandateJSON.investor != null) itemElem.find(".attribute-investor-name").text(mandateJSON.investor.name);
                        if (mandateJSON.custodyBank != null) itemElem.find(".attribute-custody-bank-name").text(mandateJSON.custodyBank.name);
                        if (mandateJSON.custodyBank != null) itemElem.find(".attribute-custody-bank-account").text(mandateJSON.custodyBank.account);
                        if (mandateJSON.portfolioManager != null) itemElem.find(".attribute-pm-name").text(mandateJSON.portfolioManager.firstName + " " + mandateJSON.portfolioManager.lastName);
                        if (mandateJSON.portfolioManager != null) itemElem.find(".attribute-pm-email").text(mandateJSON.portfolioManager.email);
                        if (mandateJSON.portfolioManager != null) itemElem.find(".attribute-pm-phone").text(mandateJSON.portfolioManager.phone);
                        if (mandateJSON.clientPortfolioManager != null) itemElem.find(".attribute-cpm-name").text(mandateJSON.clientPortfolioManager.firstName + " " + mandateJSON.clientPortfolioManager.lastName);
                        if (mandateJSON.clientPortfolioManager != null) itemElem.find(".attribute-cpm-email").text(mandateJSON.clientPortfolioManager.email);
                        if (mandateJSON.clientPortfolioManager != null) itemElem.find(".attribute-cpm-phone").text(mandateJSON.clientPortfolioManager.phone);
                        if (mandateJSON.relationshipManager != null) itemElem.find(".attribute-rm-name").text(mandateJSON.relationshipManager.firstName + " " + mandateJSON.relationshipManager.lastName);
                        if (mandateJSON.relationshipManager != null) itemElem.find(".attribute-rm-email").text(mandateJSON.relationshipManager.email);
                        if (mandateJSON.relationshipManager != null) itemElem.find(".attribute-rm-phone").text(mandateJSON.relationshipManager.phone);
                        if (mandateJSON.totalAssets != null) itemElem.find(".attribute-total-assets-amount").text(mandateJSON.totalAssets.amount.resolved);
                        if (mandateJSON.totalAssets != null) itemElem.find(".attribute-total-assets-amount-value").attr("data-text", mandateJSON.totalAssets.amount.value);
                        if (mandateJSON.totalAssets != null) itemElem.find(".attribute-total-assets-currency").text(mandateJSON.totalAssets.currency);
                        // Status
                        var badgeElem = itemElem.find(".attribute-badge");
                        if (reportJSON.reportBadge != null) {
                            if (reportJSON.reportBadge.color != null) badgeElem.addClass("option-" + reportJSON.reportBadge.color);
                            badgeElem.text(Machinata.Reporting.Text.resolve(instance,reportJSON.reportBadge.label));
                            if (reportJSON.reportBadge.tooltip != null) badgeElem.attr("title", Machinata.Reporting.Text.resolve(instance,reportJSON.reportBadge.tooltip));
                        } else {
                            badgeElem.remove();
                        }
                        itemElem.find(".table-cell.type-tools").append(Machinata.Reporting.buildIcon(instance, "arrow-right").addClass("machinata-reporting-open-report option-only-on-hover").attr("title", Machinata.Reporting.Text.translate(instance, "reporting.view-report")));
                        itemElem.find(".attribute-type").text(Machinata.Reporting.Text.resolve(instance,mandateJSON.mandateType));
                        itemElem.removeClass(config.catalogItemReportTemplateSelector.replace(".", ""));
                        instance.elems.catalog.append(itemElem);
                    } else if (index == maxReportsToList) {
                        itemElem.find(".attribute-reporting-date").text(Machinata.Reporting.Text.translate(instance, "reporting.view-all-dates"));
                        itemElem.click(function (evt) {
                            evt.stopPropagation();
                            evt.preventDefault();
                            Machinata.Reporting.Handler.changeReportingDate(instance, instance.catalogData, mandateJSON, null, mandateDate, Machinata.Reporting.Text.translate(instance, "reporting.choose-date"));
                        });
                        itemElem.removeClass(config.catalogItemReportTemplateSelector.replace(".", ""));
                        instance.elems.catalog.append(itemElem);
                    }
                });
            }

        });
        // Remove templates
        templateMandateElem.remove();
        templateReportElem.remove();
        // Table UI UX
        Machinata.Reporting.Handler.bindTableUI(instance,tableElem);
    }
    Machinata.Debugging.stopTimer("catalog-compile");
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-config.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-config.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Config namespace. 
/// These attributes define the default behaviour of the reporting package. 
/// To change them, use a custom config object when calling init(), or provide a report data file
/// with the root ```config``` object.
/// 
/// ## Defaults
/// Each config has a predefined default value. Furthermore, each profile may have their own custom defaults (see Machinata.Reporting.Config.profile).
///
/// ## Priority (lowest to highest)
///  - Machinata.Reporting.Config default values
///  - Profile default values
///  - init() config values
///  - Report JSON ```config``` default values
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Config = {};

/// <summary>
/// Defines the source of the configuration. Each product should make sure to define their own source, as this
/// allows quick test to ensure the custom config is being loaded correctly.
/// </summary>
Machinata.Reporting.Config.configSource = "DEFAULT";

/// <summary>
/// Defines the target medium. 
/// ## Known Mediums
///  - ```screen```
///  - ```print```
/// </summary>
Machinata.Reporting.Config.medium = "screen";

/// <summary>
/// Defines the default medium content size (full-width) for the profile (in pixels).
/// For example, on medium ```web```, this should be set to the width of the container in which the report
/// is loaded. On medium ```print```, this should be set to the main content area width of the page.
/// This configuration is used to give nodes a context of how large they are in relation to the content area.
/// </summary>
Machinata.Reporting.Config.mediumContentWidthSize = 1128;

/// <summary>
/// Which user settings provider to use. Changing this setting will
/// load a different implementation of the data provider.
/// Currently supported:
///   - ```WebStorage```: uses the browsers built in web storage
/// See Machinata.Reporting.Data.UserSettings for more information.
/// </summary>
Machinata.Reporting.Config.userSettingsProvider = "WebStorage";

/// <summary>
/// Which data provider to use. Changing this setting will
/// load a different implementation of the data provider.
/// Currently supported:
///   - ```HTTP```
///   - ```JSON```
/// See Machinata.Reporting.Data.Providers for more information.
/// </summary>
Machinata.Reporting.Config.dataProvider = "HTTP";

/// <summary>
/// Defines the data source (report JSON) to use. The dataProvider will know
/// how to handle this value.
/// You can override this setting using the query parameter ```data```.
/// </summary>
Machinata.Reporting.Config.dataSource = "report.json";

/// <summary>
/// Defines the catalog source (catalog JSON) to use. The dataProvider will know
/// how to handle this value.
/// You can override this setting using the query parameter ```catalog```.
/// </summary>
Machinata.Reporting.Config.catalogSource = "catalog.json";

/// <summary>
/// If ```true```, caching will of any data via the dataSource will be prevented.
/// You can enable this feature automatically using the query string parameter ```?prevent-caching=true```.
/// </summary>
Machinata.Reporting.Config.preventDataCaching = false;

/// <summary>
/// Defines the type of profile display mode and interface to use.
/// You can override this setting using the query parameter ```profile```.
/// Can be:
///  - ```web```
///  - ```fullscreen```
///  - ```webprint```
///  - ```print```
/// </summary>
Machinata.Reporting.Config.profile = "web";

/// <summary>
/// Defines the language to use for the report content. This especially affects all 
/// ```Machinata.Reporting.Text.resolve``` usages.
/// </summary>
Machinata.Reporting.Config.contentLanguage = "en";

/// <summary>
/// Defines the language to use for the reporting interface. This especially affects all 
/// ```Machinata.Reporting.Text.translate``` usages.
/// </summary>
Machinata.Reporting.Config.interfaceLanguage = "en";

/// <summary>
/// If ```true```, hints that this reporting instance is running headless.
/// </summary>
Machinata.Reporting.Config.headless = false;

/// <summary>
/// The toc level for which to build logical screens at.
/// </summary>
/// <deprecated>
/// This is no currently unsupported. Use screen = true on each node to define a screen
/// </deprecated>
Machinata.Reporting.Config.screenLevel = 3;

/// <summary>
/// </summary>
Machinata.Reporting.Config.chapterLevel = 1;

/// <summary>
/// Defines which chapters in the report to display.
/// ## Auto
/// If set to ```auto```, then the chapters is automatically derived from the query string, 
/// and if no chapter is given, the configuration ```initialChapter``` is used.
/// ## *
/// If set to ```*```, then all the chapters are displayed.
/// </summary>
Machinata.Reporting.Config.chapters = "auto";

/// <summary>
/// </summary>
Machinata.Reporting.Config.initialChapter = null;

/// <summary>
/// If set, defines which logical screens to show.
///
/// If set to ```auto``` (the default value), allows
/// query parameters and other behaviour to control the screens automatically.
///
/// If set to ```printcomposer```, the screens are automatically populated using the data
/// from the print composer for the currently loaded report.
///
/// If set to an array of integers, only those screen numbers are shown in the report.
///
/// Note: when a report is built, section titles are automatically included regardless whether they
/// are part of the screens or not. This ensures a consistent content navigation tree for the user.
/// </summary>
Machinata.Reporting.Config.screens = "auto";

/// <summary>
/// If true, the report contents will be built and shown.
/// </summary>
Machinata.Reporting.Config.buildContents = true;

/// <summary>
/// </summary>
Machinata.Reporting.Config.headerSelector = "#header";

/// <summary>
/// </summary>
Machinata.Reporting.Config.navigationSelector = "#navigation";

/// <summary>
/// </summary>
Machinata.Reporting.Config.contentSelector = ".machinata-reporting-report";

/// <summary>
/// </summary>
Machinata.Reporting.Config.chapterSelector = ".machinata-reporting-chapters";

/// <summary>
/// </summary>
Machinata.Reporting.Config.catalogSelector = ".machinata-reporting-catalog";

/// <summary>
/// </summary>
Machinata.Reporting.Config.printComposerSelector = ".machinata-printcomposer";

/// <summary>
/// </summary>
Machinata.Reporting.Config.catalogItemMandateTemplateSelector = ".machinata-reporting-catalog-mandate-template";

/// <summary>
/// </summary>
Machinata.Reporting.Config.catalogItemReportTemplateSelector = ".machinata-reporting-catalog-report-template";

/// <summary>
/// </summary>
Machinata.Reporting.Config.catalogDateFormat = "%Y-%m-%d";

/// <summary>
/// </summary>
Machinata.Reporting.Config.catalogDateDisplayFormat = "%d.%m.%Y";

/// <summary>
/// If not null, the expanded catalog view that lists all reports is limited to this number.
/// </summary>
Machinata.Reporting.Config.catalogMaxReportsToShow = 30;

/// <summary>
/// </summary>
Machinata.Reporting.Config.navigationMaxSiblings = 8;

/// <summary>
/// </summary>
Machinata.Reporting.Config.automaticallyAddPageTools = true;

/// <summary>
/// </summary>
Machinata.Reporting.Config.automaticallyGenerateScreenNumbers = false;

/// <summary>
/// </summary>
Machinata.Reporting.Config.automaticallyFoldChaptersIntoPages = true;

/// <summary>
/// </summary>
Machinata.Reporting.Config.automaticallyInsertCatalogNavigation = true;

/// <summary>
/// </summary>
Machinata.Reporting.Config.automaticallyInsertChapterNavigation = true;

/// <summary>
/// </summary>
Machinata.Reporting.Config.automaticallyBuildCatalogUI = true;

/// <summary>
/// </summary>
Machinata.Reporting.Config.loadReport = true;

/// <summary>
/// </summary>
Machinata.Reporting.Config.loadCatalog = true;

/// <summary>
/// The report URL. If this is not set, the URL is automatically derived from the browser window.
/// </summary>
Machinata.Reporting.Config.url = null;

/// <summary>
/// </summary>
Machinata.Reporting.Config.reportURL = null;

/// <summary>
/// </summary>
Machinata.Reporting.Config.catalogURL = null;

/// <summary>
/// The report fullscreen URL. ?screen=N is automatically appended if used.
/// </summary>
Machinata.Reporting.Config.fullscreenURL = null;

/// <summary>
/// A resolved report name (string). Is read out from the report JSON file if not defined.
/// TODO: @bmpi: this should be explicitly present in every report JSON file.
/// </summary>
Machinata.Reporting.Config.reportName = null;

/// <summary>
/// A resolved report title (string). Is read out from the report JSON file if not defined, or if present, from the
/// catalog JSON if not defined.
/// TODO: @bmpi: this should be explicitly present in every report JSON file.
/// </summary>
Machinata.Reporting.Config.reportTitle = null;

/// <summary>
/// A resolved report title (string). This can be, for example, the reporting date.
/// TODO: @bmpi: this should be explicitly present in every report JSON file.
/// </summary>
Machinata.Reporting.Config.reportSubtitle = null;

/// <summary>
/// A resolved chapter title (string). Is automatically set if a single chapter has been selected and not defined.
/// This is a helper variable so that it's easy to access this information at any time.
/// </summary>
Machinata.Reporting.Config.reportChapter = null;

/// <summary>
/// A resolved report disclaimer text (string). Is automatically loaded through a tag, if present and not defined.
/// See Machinata.Reporting.Config.tagDisclaimer
/// </summary>
Machinata.Reporting.Config.reportDisclaimer = null;

/// <summary>
/// A resolved report legal entity text (string). Is automatically loaded through a tag, if present and not defined.
/// See Machinata.Reporting.Config.tagLegalEntity
/// </summary>
Machinata.Reporting.Config.reportLegalEntity = null;

/// <summary>
/// The standard padding dimension, in pixels.
/// </summary>
Machinata.Reporting.Config.padding = 8;

/// <summary>
/// The default font size in pixels. This is the default size used the element doesn't specifiy a more specific.
/// </summary>
Machinata.Reporting.Config.textSize = 12;

/// <summary>
/// The font size in pixels for charts. This is the default size used the element doesn't specifiy a more specific.
/// </summary>
Machinata.Reporting.Config.chartTextSize = 14;

/// <summary>
/// Defines a global padding for charts. Typically this should be 0.
/// </summary>
Machinata.Reporting.Config.chartPadding = 0;

/// <summary>
/// The default font to use for charts.
/// </summary>
Machinata.Reporting.Config.textFont = "sans-serif";

/// <summary>
/// An approximate font-size to character width ratio used for very fast (and innaccurate) text string measurements.
/// See ```Machinata.Reporting.Tools.measureStringApproximately()```
/// </summary>
Machinata.Reporting.Config.fontSizeToCharacterWidthRatio = 0.65;

/// <summary>
/// The font size in pixels for chart labels.
/// </summary>
Machinata.Reporting.Config.labelSize = 12;

/// <summary>
/// The font name for chart labels.
/// </summary>
Machinata.Reporting.Config.labelFont = "sans-serif";

/// <summary>
/// The font size in pixels for chart axis labels.
/// </summary>
Machinata.Reporting.Config.axisSize = 12;

/// <summary>
/// The font name for chart axis labels.
/// </summary>
Machinata.Reporting.Config.axisFont = "sans-serif";

/// <summary>
/// </summary>
Machinata.Reporting.Config.axisLabelFontWeight = "normal";

/// <summary>
/// The strategy to use for resolving overlap of axis labels. 
/// If```false```, no overlap reduction is attempted.If set to```true``` or```parity```, a strategy of removing every other label is used(this works well for standard linear axes).If set to```greedy```, a linear scan of the labels is performed, removing any label that overlaps with the last visible label(this often works better for log - scaled axes).
/// By default ```parity```
/// </summary>
Machinata.Reporting.Config.axisLabelOverlap = "parity";

/// <summary>
/// The minimum separation that must be between label bounding boxes for them to be considered non-overlapping.
/// By default ```Machinata.Reporting.Config.padding / 2```
/// </summary>
Machinata.Reporting.Config.axisLabelSeparation = Machinata.Reporting.Config.padding / 2;


/// <summary>
/// The padding in pixels between labels and ticks.
/// By default ```Machinata.Reporting.Config.padding / 2```
/// </summary>
Machinata.Reporting.Config.axisLabelPadding = Machinata.Reporting.Config.padding / 2;

/// <summary>
/// The maximum allowed length in pixels of axis tick labels.
/// By default ```null``` (off)
/// </summary>
Machinata.Reporting.Config.axisLabelLimit = null;

/// <summary>
/// This defines a target number of ticks
/// for all value-axis's (typically the vertical axis). 
/// It is not gauranteed that axis's have exactly said number of ticks.
/// The closest human-friendly tick step and tick count will be used.
/// By default ```10```
/// </summary>
Machinata.Reporting.Config.axisTargetTickCount = 11;

/// <summary>
/// If ```true```, buttom axis's will show ticks next to labels.
/// By default ```false```
/// </summary>
Machinata.Reporting.Config.axisBottomShowTicks = true;

/// <summary>
/// If ```axisBottomShowTicks``` is enabled, defines the buttom axis's tick size.
/// By default ```20```
/// </summary>
Machinata.Reporting.Config.axisBottomTickSize = 20;

/// <summary>
/// If set, buttom axis's will have a slight offset (in pixels).
/// Only applies if ```axisBottomShowTicks``` is false.
/// By default ```2```
/// </summary>
Machinata.Reporting.Config.axisBottomOffset = 2;

/// <summary>
/// The font size in pixels for chart legends.
/// </summary>
Machinata.Reporting.Config.legendSize = 12;

/// <summary>
/// The font name for chart legends.
/// </summary>
Machinata.Reporting.Config.legendFont = "sans-serif";

/// <summary>
/// The size of the legend symbols, in pixels.
/// </summary>
Machinata.Reporting.Config.legendSymbolSize = 14;

/// <summary>
/// The stroke width of the legend symbols, in pixels.
/// Only lines have strokes.
/// </summary>
Machinata.Reporting.Config.legendSymbolStroke = 2;

/// <summary>
/// The legend box padding, in pixels.
/// </summary>
Machinata.Reporting.Config.legendPadding = 0;

/// <summary>
/// The horizontal padding between legend columns, in pixels.
/// </summary>
Machinata.Reporting.Config.legendColumnPadding = 12;

/// <summary>
/// The vertical padding between legend rows, in pixels.
/// </summary>
Machinata.Reporting.Config.legendRowPadding = 8;

/// <summary>
/// The maximum width a legend label can have, in pixels.
/// </summary>
Machinata.Reporting.Config.legendLabelMaxWidth = 300;

/// <summary>
/// For nodes that support legends, this property defines the position of the node legend.
/// Supported positions:
///  - ```left-top```: Place the legend to the top-left of the chart, in the top corner.
///  - ```right-top```: Place the legend to the right of the chart, in the top corner.
///  - ```top-left```: Place the legend above the top of the chart, on the left side.
///  - ```bottom-left```: Place the legend below the bottom of the chart, on the left side.
/// By default ```bottom-left``.
/// </summary>
Machinata.Reporting.Config.legendPosition = "bottom-left";

/// <summary>
/// Defines the type of symbol shape to use for the given symbol.
/// Symbols within chart data must be defined as one of the following:
///  - ```dot```
///  - ```diamond```
///  - ```bar```
///  - ```line```
/// Configuration value can be any symbol shape defined by vega (see https://vega.github.io/vega/docs/marks/symbol/).
/// By default ```circle``.
/// </summary>
Machinata.Reporting.Config.legendSymbolForDot = "circle";

/// <summary>
/// Defines the type of symbol shape to use for the given symbol.
/// Symbols within chart data must be defined as one of the following:
///  - ```dot```
///  - ```diamond```
///  - ```bar```
///  - ```line```
/// Configuration value can be any symbol shape defined by vega (see https://vega.github.io/vega/docs/marks/symbol/).
/// By default ```diamond``.
/// </summary>
Machinata.Reporting.Config.legendSymbolForDiamond = "diamond";

/// <summary>
/// Defines the type of symbol shape to use for the given symbol.
/// Symbols within chart data must be defined as one of the following:
///  - ```dot```
///  - ```diamond```
///  - ```bar```
///  - ```line```
/// Configuration value can be any symbol shape defined by vega (see https://vega.github.io/vega/docs/marks/symbol/).
/// By default ```square``.
/// </summary>
Machinata.Reporting.Config.legendSymbolForBar = "square";

/// <summary>
/// Defines the type of symbol shape to use for the given symbol.
/// Symbols within chart data must be defined as one of the following:
///  - ```dot```
///  - ```diamond```
///  - ```bar```
///  - ```line```
/// Configuration value can be any symbol shape defined by vega (see https://vega.github.io/vega/docs/marks/symbol/).
/// By default ```stroke``.
/// </summary>
Machinata.Reporting.Config.legendSymbolForLine = "stroke";

/// <summary>
/// Defines the type of symbol shape to use for a unknown symbol.
/// Symbols within chart data must be defined as one of the following:
///  - ```dot```
///  - ```diamond```
///  - ```bar```
///  - ```line```
/// Configuration value can be any symbol shape defined by vega (see https://vega.github.io/vega/docs/marks/symbol/).
/// By default ```square``.
/// </summary>
Machinata.Reporting.Config.legendSymbolForUnknown = "square";

/// <summary>
/// The font size in pixels for chart titles. Should be same as h1 size.
/// </summary>
Machinata.Reporting.Config.titleSize = 60;

/// <summary>
/// The font size in pixels for chart subtitles.
/// </summary>
Machinata.Reporting.Config.subtitleSize = 18;

/// <summary>
/// The font name chart subtitles.
/// </summary>
Machinata.Reporting.Config.subtitleFont = "sans-serif";

/// <summary>
/// The font name for chart numbers.
/// </summary>
Machinata.Reporting.Config.numberFont = "sans-serif";

/// <summary>
/// The grid color for charts (RGB/Hex).
/// </summary>
Machinata.Reporting.Config.gridColor = "#7c7c7b"; //gray5

/// <summary>
/// The solid color (object fill color) for charts (RGB/Hex).
/// </summary>
Machinata.Reporting.Config.solidColor = "#f1f2f2"; //gray1

/// <summary>
/// </summary>
Machinata.Reporting.Config.darkColor = "black";

/// <summary>
/// </summary>
Machinata.Reporting.Config.pageColor = "white";

/// <summary>
/// The general stroke thickness (in pixel) for a line.
/// </summary>
Machinata.Reporting.Config.lineSize = 1;

/// <summary>
/// The grid stroke thickness (in pixel) for a grid line.
/// </summary>
Machinata.Reporting.Config.gridLineSize = 1;

/// <summary>
/// The stroke thickness (in pixel) for a graph line (ie a line-chart line).
/// </summary>
Machinata.Reporting.Config.graphLineSize = 4;

/// <summary>
/// The width and height size (bounding box) for scatterplot symbols, in pixels, for a graph symbol.
/// </summary>
Machinata.Reporting.Config.graphSymbolSize = 16;

/// <summary>
/// The general stroke thickness (in pixel) for a domain (axis, zero) line.
/// </summary>
Machinata.Reporting.Config.domainLineSize = 2;

/// <summary>
/// The general color for a domain (axis, zero) line.
/// </summary>
Machinata.Reporting.Config.domainLineColor = "black";

/// <summary>
/// Defines an array of the standardized theme color shade names.
/// This can be used to force a specific theme color when using the default order
/// is insufficient.
/// </summary>
/// <example>
/// ```['dark', 'mid', 'bright', 'light', 'gray3', 'gray4']```
/// </example>
Machinata.Reporting.Config.themeColorShadeNames = ['dark', 'mid', 'bright', 'light', 'gray3', 'gray4'];

/// <summary>
/// Gray is always a special theme, since often it is combinded with other themes as a secondary color.
/// This defines an array of gray shades supported, that are linked to the ```gray``` theme.
/// </summary>
/// <example>
/// ```['gray6', 'gray5', 'gray4', 'gray3', 'gray2', 'gray1']```
/// </example>
Machinata.Reporting.Config.themeGrayShadeNames = ['gray6', 'gray5', 'gray4', 'gray3', 'gray2', 'gray1'];

/// <summary>
/// Defines which color shades represent negative numbers and positive numbers.
/// Array must contain exactly 2 values, the first being the negative shade and the second
/// being the positive shade name.
/// </summary>
/// <example>
/// ```
/// ['dark', 'bright']
///    ^         ^
///  negative    | 
///            positive
/// ```
/// </example>
Machinata.Reporting.Config.themeNegativePositiveShadeNames = ['dark', 'bright'];

/// <summary>
/// Similar to themeNegativePositiveShadeNames, but an alternative neutral color scheme for negative and positive.
/// </summary>
/// <example>
/// ```
/// ['dark', 'bright']
///    ^         ^
///  negative    | 
///            positive
/// ```
/// </example>
Machinata.Reporting.Config.themeNegativePositiveGrayShadeNames = ['gray4', 'gray3'];




/// <summary>
/// Defines the tag name to use to automatically extract the report disclaimer from a content node 
/// (such as a ParagraphNode).
/// Note: The node with this tag is excluded from the report.
/// </summary>
Machinata.Reporting.Config.tagDisclaimer = "Report_Disclaimer";

/// <summary>
/// Defines the tag name to use to automatically extract the report legal entity from a content node 
/// (such as a ParagraphNode).
/// Note: The node with this tag is excluded from the report.
/// </summary>
Machinata.Reporting.Config.tagLegalEntity = "Report_LegalEntity";

/// <summary>
/// Defines the tag name to use to automatically mark a node as a screen.
/// This is an alternate to setting the node's ```screen``` to ```true```.
/// </summary>
Machinata.Reporting.Config.tagScreen = "Screen";

/// <summary>
/// Defines the tag name to use for an alternative to setting a nodes chrome to ```dark```.
/// </summary>
Machinata.Reporting.Config.tagDarkChrome = "DarkChrome";

/// <summary>
/// Defines the tag name to use for an alternative to setting a nodes chrome to ```light```.
/// </summary>
Machinata.Reporting.Config.tagLightChrome = "LightChrome";

/// <summary>
/// Defines the tag name to use for an alternative to setting a nodes chrome to ```solid```.
/// </summary>
Machinata.Reporting.Config.tagSolidChrome = "SolidChrome";

/// <summary>
/// Defines the tag to use to allow a node to only appear on the asserted profile.
/// </summary>
Machinata.Reporting.Config.tagWebPrintOnly = "WebPrintOnly";

/// <summary>
/// Defines the tag to use to allow a node to only appear on the asserted profile.
/// </summary>
Machinata.Reporting.Config.tagWebOnly = "WebOnly";

/// <summary>
/// Defines the tag to use to allow a node to only appear on the asserted profile.
/// </summary>
Machinata.Reporting.Config.tagPrintOnly = "PrintOnly";

/// <summary>
/// Defines the tag to use to allow a node to only appear on the asserted profile.
/// </summary>
Machinata.Reporting.Config.tagFullscreenOnly = "FullscreenOnly";

/// <summary>
/// If defined, sets the default locale definition object for number formatting. 
/// This configuration is used for Vega and D3 number formatting, the formatting framework used. 
/// See https://github.com/d3/d3-format#formatDefaultLocale
/// See https://github.com/d3/d3-format/tree/master/locale
/// </summary>
/// <example>
/// ```
/// {
///     "decimal": ".",
///     "thousands": ",",
///     "grouping": [3],
///     "currency": ["$", ""]
/// }
/// ```
/// </example>
Machinata.Reporting.Config.numberFormatLocaleDefinition = null;

/// <summary>
/// If defined, sets the default locale definition object for time formatting. 
/// This configuration is used for Vega and D3 time formatting, the formatting framework used. 
/// See https://github.com/d3/d3-time-format#timeFormatDefaultLocale
/// See https://github.com/d3/d3-time-format/tree/master/locale
/// </summary>
/// <example>
/// ```
/// {
///     "dateTime": "%x, %X",
///     "date": "%-m/%-d/%Y",
///     "time": "%-I:%M:%S %p",
///     "periods": ["AM", "PM"],
///     "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
///     "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
///     "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
///     "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
/// }
/// ```
/// </example>
Machinata.Reporting.Config.timeFormatLocaleDefinition = null;

/// <summary>
/// If ```true```, table sorting on the column headers will be default allow a reset on a third click.
/// </summary>
Machinata.Reporting.Config.allowTableSortResets = true;


/// <summary>
/// If ```true```, calibration marks will be automatically added to all charts.
/// </summary>
Machinata.Reporting.Config.calibrationMarks = false;

/// <summary>
/// Defines the units to show on the calibration marks. Can be either ```px```, ```mm``` or ```in```.
/// </summary>
Machinata.Reporting.Config.calibrationUnits = "px";

/// <summary>
/// Defines the logical layouting DPI for the current medium. This means that this value should match
/// the drawing points DPI of the underlying drawing device or platform. For example, on an iPhone the
/// this value would be ```96``` (1x resolution), even though the devices display has a much higher
/// resolution. This is because the OS's drawing APIs are all aligned on points, regardless of the display
/// resolution.
/// In most circumstances this value will always be ```96```.
/// </summary>
Machinata.Reporting.Config.layoutingDPI = 96;

/// <summary>
/// If ```true```, drawing routines should try to round a full pixel before calling a drawing call. This
/// can be important if drawing on screen devices with low pixel density.
/// </summary>
Machinata.Reporting.Config.roundToNearestFullPixel = true;

/// <summary>
/// If ```true```, the report subtitle will be inserted as a text page-tool using the addPageTool handler.
/// </summary>
Machinata.Reporting.Config.insertReportSubtitleAsPageTool = true;

/// <summary>
/// Defines the max width for vertical bars in charts (in pixels).
/// </summary>
Machinata.Reporting.Config.verticalBarMaxSize = 22;

/// <summary>
/// Defines the max width for horizontal bars in charts (in pixels).
/// </summary>
Machinata.Reporting.Config.horizontalBarMaxSize = 22;

/// <summary>
/// Defines the default text truncation ellipsis.
/// Usually always ```...```
/// </summary>
Machinata.Reporting.Config.textTruncationEllipsis = "...";

/// <summary>
/// Defines the default text trailing info symbol, typically used to expose a underlying additional information.
/// Can be any valid chart font character or text, such as ```" \\uD83D\\uDEC8"``` (i) or ```" \\u24D8"``` (i).
/// To turn off this feature, you can set the symbol to ```''``` (empty string).
/// By default ```''``` (empty string)
/// </summary>
/// <deprecated/>
Machinata.Reporting.Config.textInfoSymbol = '';

/// <summary>
/// Defines the window title to set, if not null.
/// Uses ```Machinata.Reporting.Tools.createTitleString```, so you can use all the variables
/// aviable there.
/// </summary>
Machinata.Reporting.Config.reportWindowTitle = null;

/// <summary>
/// </summary>
Machinata.Reporting.Config.catalogWindowTitle = null;

/// <summary>
/// Defines the path separator to use when concatenating paths with files.
/// By default this is ```/```.
/// </summary>
Machinata.Reporting.Config.pathSeparator = "/";

/// <summary>
/// Defines the assets path root folder.
/// This is used to determine full or absolute paths to certain resources needed, specifically configuration values that 
/// support the path variables in them.
/// The typical layout for a assets folder for a reporting configuration will have the following structure:
/// - ```/[your-assets-path]/```
///   - ```css/```: CSS bundles needed specific to the configuration/customer
///   - ```fonts/```: font files needed specific to the configuration/customer
///   - ```images/```: image files needed specific to the configuration/customer
///   - ```js/```: frontend JS needed specific to the configuration/customer
///   - ```svg/```: SVG icon bundles needed specific to the configuration/customer
/// </summary>
Machinata.Reporting.Config.assetsPath = "/";

/// <summary>
/// Defines the location of the icons bundle. Must be absolute path, or relative to the document loading the report.
/// Typically this is defined by theme or customer configuration, and doesn't need to be set.
/// Supported variables:
///  - ```{assets-path}```
/// </summary>
/// <example>
/// ```{assets-path}/svg/csam-reporting-icons-bundle.svg```
/// </example>
Machinata.Reporting.Config.iconsBundle = null;

/// <summary>
/// </summary>
Machinata.Reporting.Config.iconNameToBundleIdMapping = {
    "alert": "error",
    "info": "info",
    "close": "delete",
    "trend-up": "up",
    "trend-down": "down-arrow",
    "fullscreen": "full-screen",
    "print": "print",
    "check": "checkmark",
    "copy": "copy-to-clipboard",
    "list": "bulleted-list",
    "filter": "filter",
    "search": "search",
    "report": "pie-chart-report",
    "export": "download",
    "download": "download",
    "arrow-left": "left",
    "arrow-right": "right",
    "configure": "tune",
    "cross": "delete",
    "glossary": "info",
    "calendar": "calendar",
    "chart": "pie-chart",
    "share": "connect",
    "expand": "forward",
    "collapse": "expand-arrow",
    "chevron-up": "collapse-arrow",
    "chevron-down": "expand-arrow",
    "chevron-left": "back",
    "chevron-right": "forward",
    "ask-question": "ask-question",
    "add-to-dashboard": "template",
    "add-to-presentation": "presentation",
    "debug": "maintenance",
    "more": "more",
    "studio": "wallpaper",
};

/// <summary>
/// </summary>
Machinata.Reporting.Config.injectThemeCSSIntoPage = true;


/// <summary>
/// </summary>
Machinata.Reporting.Config.askAQuestionViaEmailDefaultEmail = "support@nerves.ch";
Machinata.Reporting.Config.askAQuestionViaEmailDefaultName = "Nerves Support";
Machinata.Reporting.Config.askAQuestionViaEmailDefaultSubject = "Question regarding {report.title}, {report.subtitle}, {node.title}, {node.subtitle}";
Machinata.Reporting.Config.askAQuestionViaEmailDefaultBody = "Dear {to.name}, I have a question regarding the following:\n\nReport: {report.title}, {report.subtitle}\nURL: {report.url}\n\nSection: {node.title}, {node.subtitle}\nURL: {node.url}";

/// <summary>
/// Defines a branding configuration to load when first initializing a profiled configuration.
/// You can register branding configurations �sing ```Machinata.Reporting.Branding.registerBrandingConfiguration```
/// </summary>
Machinata.Reporting.Config.brandingConfiguration = null;

/// <summary>
/// If set, defines the report layout minimum width.
/// Typically this is done by the container (the report takes the full width), or CSS.
/// </summary>
Machinata.Reporting.Config.layoutMinWidth = null;

/// <summary>
/// If set, defines the report layout maximum width.
/// Typically this is done by the container (the report takes the full width), or CSS.
/// </summary>
Machinata.Reporting.Config.layoutMaxWidth = null;

/// <summary>
/// If true, reports will have their layout min/max dimensions automatically set
/// via the configurations ```layoutMinWidth``` and  ```layoutMaxWidth```.
/// </summary>
Machinata.Reporting.Config.automaticallySetLayoutMinMaxDimensions = false;

/// <summary>
/// If true, the current report layout name (ie tablet/mobile/desktop) will automatically be set on the 
/// body of the page.
/// </summary>
Machinata.Reporting.Config.automaticallySetReportLayoutClassOnBody = false;

/// <summary>
/// If true, the current page layout name (ie tablet/mobile/desktop) will automatically be set on the 
/// body of the page.
/// </summary>
Machinata.Reporting.Config.automaticallySetPageLayoutClassOnBody = false;

/// <summary>
/// If true, a browser print dialog will automatically be opened on init of a report.
/// Requires the profile to be set to Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY
/// </summary>
Machinata.Reporting.Config.automaticallyOpenBrowserPrintDialog = false;

/// <summary>
/// If true, additional support for IE11 will be injected into the page.
/// </summary>
Machinata.Reporting.Config.compatibilityIE11Support = true;

/// <summary>
/// Defines the minimum width of a node before it begins to compress (this is derived from two-column layout node at the lax report size (layoutMaxWidth))
/// </summary>
Machinata.Reporting.Config.nodeSizeMinWidthUncompressed = 580;



/// <summary>
/// Defines the size factor which can be used for title sizes on mobile layouts.
/// </summary>
Machinata.Reporting.Config.mobileTitleSizeFactor = 0.6;

/// <summary>
/// Defines the size factor which can be used for subtitle sizes on mobile layouts.
/// </summary>
Machinata.Reporting.Config.mobileSubtitleSizeFactor = 0.8;

/// <summary>
/// Defines the size factor which can be used for label sizes on mobile layouts.
/// </summary>
Machinata.Reporting.Config.mobileLabelSizeFactor = 0.9;

/// <summary>
/// If ```true```, CSP compliance is achieved via various methods such as using a custom vega expression parser compatible with 
/// all vega customizations in the VegaNode namespace.
/// Setting this mode to true can degrade performance and will have an impact on render times for charts.
/// By default ```false```.
/// </summary>
Machinata.Reporting.Config.cspCompliance = false;

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-branding.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-branding.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Allows the storage and retrieving of entire branding configurations (including handlers).
/// This is useful if you want to select a branding configuration at runtime.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Branding = {};

/// <summary>
/// Storage for all the registered configuraitons.
/// </summary>
/// <hidden/>
Machinata.Reporting.Branding._registeredBrandingConfigurations = {};

/// <summary>
/// Registeres a branding configuration routine by name. ```callback``` is a function which
/// will be executed when the branding configuration is requisted by ```loadBrandingConfiguration()```.
/// </summary>
Machinata.Reporting.Branding.registerBrandingConfiguration = function (name, callback) {
    Machinata.Reporting.Branding._registeredBrandingConfigurations[name] = callback;
};

/// <summary>
/// Loads a branding configuration routine by name.
/// </summary>
Machinata.Reporting.Branding.loadBrandingConfiguration = function (name) {
    var callback = Machinata.Reporting.Branding._registeredBrandingConfigurations[name];
    if (callback == null) throw "Cannot load the branding configuration '"+name+"' as it has not been registered. Are you sure the proper configruation file has been included or required?";
    callback();
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-profile.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-profile.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Provides infrastructure for loading different configuration profiles. Each profile can override the 
/// default configuration settings. Furthermore, the profile can be used to drive specific UI interactions.
/// When a profile is set, the report main DOM element and the body DOM element will have ```profile-xzy``` class
/// registered to it.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Profiles = {};

/// <summary>
/// Standardized ```web``` profile used for regular display on a website.
/// </summary>
/// <type>constant</type>
Machinata.Reporting.Profiles.PROFILE_WEB_KEY = "web";

/// <summary>
/// Standardized ```webprint``` profile used for printing a report within the website.
/// </summary>
/// <type>constant</type>
Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY = "webprint";

/// <summary>
/// Standardized ```print``` profile used for generating print-documents.
/// </summary>
/// <type>constant</type>
Machinata.Reporting.Profiles.PROFILE_PRINT_KEY = "print";

/// <summary>
/// Standardized ```fullscreen``` profile used for viewing a report in fullscreen.
/// </summary>
/// <type>constant</type>
Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY = "fullscreen";

/// <summary>
/// A dictionary of profile configurations. 
/// If registered, the profile configuration will override the default configuration.
/// </summary>
/// <type>variable</type>
Machinata.Reporting.Profiles.Configs = {};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_WEB_KEY] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_WEB_KEY]["nodeDefaults"] = {};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY]["nodeDefaults"] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY]["nodeDefaults"]["ToggleNode"] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_WEBPRINT_KEY]["nodeDefaults"]["ToggleNode"]["explodeChildren"] = true;


/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["graphicAlignment"] = "top";
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["titleSize"] = 20;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["titleLineHeight"] = 1.15;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["labelSize"] = 10;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["valueSize"] = 20;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["valueLargeSize"] = 20;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["symbolSize"] = 18;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["strokeDash"] = "3,3";
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["bucketFactHeight"] = 54;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["bucketFactPaddingMultiplier"] = 2;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY]["nodeDefaults"]["PCPCashFlowGraphicNode"]["chartBorderMultiplier"] = 1.0;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY].medium = "paper";
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY].calibrationUnits = "mm";
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY].roundToNearestFullPixel = true;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY].layoutingDPI = 96;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_PRINT_KEY].mediumContentWidthSize = 680;


/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY] = {};
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY]["automaticallyFoldChaptersIntoPages"] = false;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY]["automaticallyAddPageTools"] = false;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY]["automaticallyInsertCatalogNavigation"] = false;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY]["automaticallyInsertChapterNavigation"] = false;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY]["automaticallyBuildCatalogUI"] = false;
Machinata.Reporting.Profiles.Configs[Machinata.Reporting.Profiles.PROFILE_FULLSCREEN_KEY]["nodeDefaults"] = {};






/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-data.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-data.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Data loading abstraction layer.
/// Different provider implementations can be used.
/// The provider can be set using the configuration ```Machinata.Reporting.Config.dataProvider```.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Data = {};




/// <summary>
/// Gets a piece of data for a given source using the configured provider.
/// The ```dataSource``` is always a string, however the provider defines in what format. 
/// </summary>
Machinata.Reporting.Data.loadData = function (instance, dataSource, onSuccess) {

    // Init
    if (dataSource == null) {
        onSuccess(null);
        return;
    }

    // Get the provider implementaiton
    Machinata.debug("Machinata.Reporting.Data.loadData: ");
    Machinata.debug("   dataProvider: " + instance.config.dataProvider);
    Machinata.debug("   dataSource: " + dataSource);
    var impl = Machinata.Reporting.Data.Providers[instance.config.dataProvider];
    if (impl == null) throw "The data provider " + instance.config.dataProvider + " does not exist.";

    // Pass to implementation
    impl.loadData(instance, dataSource, onSuccess);
    
};





/// <summary>
/// Namespace for all data provider implementations.
/// 
/// Each provider must implement at least the following:
///  - ```loadData(instance, dataSource, onSuccess)```
/// 
/// Providers can be registered via a object set on ```Machinata.Reporting.Data.Providers```.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Data.Providers.MyProvider = {
///    loadData: function(instance, dataSource, onSuccess) {
///        // Load data...
///        // TODO
///        // Call success callback
///        onSuccess(data);
///    }
/// };
/// ```
/// </example>
/// <type>namespace</type>
Machinata.Reporting.Data.Providers = {};



/// <summary>
/// A very simple and lightweight data provider for retrieving JSON files via HTTP requests.
/// The ```dataSource``` is loaded directly from the browser as a URL, thus any ```dataSource```
/// while using this provider can either be a remote resource via a absolute URL, a local URL
/// absolute to the server or relative to the currently loaded HTML document.
/// </summary>
/// <example>
/// ### Absolute Remote URL
///  - Loaded URL: ```https://remote.server/view/report```
///  - dataSource: ```Machinata.Reporting.Data.loadData("https://other.server/data/report/abc-xyz.json?auth-token=ABCXYZ")```
/// ### Absolute URL to Loaded Page
///  - Loaded URL: ```https://remote.server/view/report```
///  - dataSource: ```Machinata.Reporting.Data.loadData("/data/report/abc-xyz.json?auth-token=ABCXYZ")```
/// ### Relative URL to Loaded Page
///  - Loaded URL: ```https://remote.server/view/report```
///  - dataSource: ```Machinata.Reporting.Data.loadData("../../data/report/abc-xyz.json?auth-token=ABCXYZ")```
/// </example>
/// <type>class</type>
Machinata.Reporting.Data.Providers.HTTP = {};

/// <summary>
/// </summary>
Machinata.Reporting.Data.Providers.HTTP.loadData = function (instance, dataSource, onSuccess) {
    // Cache bust
    if (instance.config != null && instance.config.preventDataCaching == true) {
        var guid = Machinata.guid();
        dataSource = Machinata.updateQueryString("cache-buster", guid, dataSource);
    }
    $.ajax({
        dataType: "json",
        url: dataSource,
        success: function (data, textStatus, jqXHR) {
            onSuccess(data);
        },
        error: function (xhr, status, errorThrown) {
            Machinata.apiError("load-data-failed", "Could not load data from "+dataSource+": "+errorThrown);
        }
    });
};







/// <summary>
/// A very simple data provider for retrieving JSON data via memory.
/// The ```dataSource``` is the JSON object that is already loaded in memory.
/// Note: This provider will create a copy of the incoming data, and has a performance hit because of this.
/// </summary>
/// <example>
/// ```Machinata.Reporting.Data.loadData({ ...your JSON data... })```
/// </example>
/// <type>class</type>
Machinata.Reporting.Data.Providers.Memory = {};

/// <summary>
/// </summary>
Machinata.Reporting.Data.Providers.Memory.loadData = function (instance, dataSource, onSuccess) {
    //var dataCopy = Machinata.Util.cloneJSON(dataSource);
    // Note: since the data is coming from in memory, to disable side-effects we need a clean copy so that the report in theory can be loaded several times in one DOM without a changed state
    //TODO: @dan is there a faster way we can do this?
    //WARNING: this is very expensive
    var dataCopy = JSON.parse(JSON.stringify(dataSource)); 
    onSuccess(dataCopy);
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-settings.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-settings.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// User settings abstraction layer.
/// Different provider implementations can be used.
/// The provider can be set using the configuration ```Machinata.Reporting.Config.userSettingsProvider```.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.UserSettings = {};


/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.UserSettings._getImpl = function (instance) {
    var impl = Machinata.Reporting.UserSettings.Providers[instance.config.userSettingsProvider];
    if (impl == null) throw "The user settings provider " + instance.config.userSettingsProvider + " does not exist.";
    return impl;
};

/// <summary>
/// Gets a global value for a user for the given key. Such global settings span all reports, nodes and alter the behaviour of the reporting
/// across all reports.
/// This method forwards to the currently configured providers implementation.
/// Recommended storage key: ```global_{key}```
/// </summary>
Machinata.Reporting.UserSettings.getGlobalValue = function (instance, key) {
    return Machinata.Reporting.UserSettings._getImpl(instance).getGlobalValue(instance, key);
};

/// <summary>
/// Sets a global value for a user for the given key. 
/// This method forwards to the currently configured providers implementation.
/// Values can be any object.
/// Recommended storage key: ```global_{key}```
/// </summary>
Machinata.Reporting.UserSettings.setGlobalValue = function (instance, key, val) {
    Machinata.Reporting.UserSettings._getImpl(instance).setGlobalValue(instance, key, val);
};

/// <summary>
/// Gets a report specific value for a user for the given key. 
/// This method forwards to the currently configured providers implementation.
/// Recommended storage key: ```report_{instance.reportData.reportId}_{key}```
/// Note: A loaded report can be assumed.
/// </summary>
Machinata.Reporting.UserSettings.getReportValue = function (instance, key) {
    if (instance.reportData == null || instance.reportData.reportId == null) throw "Machinata.Reporting.UserSettings.getGlobalValue: instance.reportData.reportId cannot be null!";
    return Machinata.Reporting.UserSettings._getImpl(instance).getReportValue(instance, key);
};

/// <summary>
/// sets a report specific value for a user for the given key. 
/// This method forwards to the currently configured providers implementation.
/// Values can be any object.
/// Recommended storage key: ```report_{instance.reportData.reportId}_{key}```
/// Note: A loaded report can be assumed.
/// </summary>
Machinata.Reporting.UserSettings.setReportValue = function (instance, key, val) {
    if (instance.reportData == null || instance.reportData.reportId == null) throw "Machinata.Reporting.UserSettings.setGlobalValue: instance.reportData.reportId cannot be null!";
    Machinata.Reporting.UserSettings._getImpl(instance).setReportValue(instance, key, val);
};

/// <summary>
/// Gets a node specific value for a user for the given key and nodeJSON.
/// This method forwards to the currently configured providers implementation.
/// Recommended storage key: ```node_{nodeJSON.id}_{key}```
/// Note: A loaded report cannot be assumed - it is possible that nodes are displayed without a report (containerless).
/// </summary>
Machinata.Reporting.UserSettings.getNodeValue = function (instance, nodeJSON, key) {
    if (nodeJSON == null || nodeJSON.id == null) throw "Machinata.Reporting.UserSettings.getNodeValue: nodeJSON.id cannot be null!";
    return Machinata.Reporting.UserSettings._getImpl(instance).getNodeValue(instance, key);
};

/// <summary>
/// Sets a node specific value for a user for the given key and nodeJSON.
/// This method forwards to the currently configured providers implementation.
/// Recommended storage key: ```node_{nodeJSON.id}_{key}```
/// Note: A loaded report cannot be assumed - it is possible that nodes are displayed without a report (containerless).
/// </summary>
Machinata.Reporting.UserSettings.setNodeValue = function (instance, nodeJSON, key, val) {
    if (nodeJSON == null || nodeJSON.id == null) throw "Machinata.Reporting.UserSettings.setNodeValue: nodeJSON.id cannot be null!";
    return Machinata.Reporting.UserSettings._getImpl(instance).setNodeValue(instance, key, val);
};


/// <summary>
/// Namespace for all data provider implementations.
/// 
/// Each provider must implement at least the following:
///  - ```setGlobalValue(instance, key, val)```
///  - ```getGlobalValue(instance, key)```
///  - ```setReportValue(instance, key, val)```
///  - ```getReportValue(instance, key)```
///  - ```setNodeValue(instance, key, val)```
///  - ```getNodeValue(instance, key)```
/// 
/// Providers can be registered via a object set on ```Machinata.Reporting.UserSettings.Providers```.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.UserSettings.Providers.MyProvider = {
///    setGlobalValue: function(instance, key, val) {
///        // TODO
///    }
///    getGlobalValue: function(instance, key) {
///        // TODO
///        return null;
///    }
///    ...
/// };
/// ```
/// </example>
/// <type>namespace</type>
Machinata.Reporting.UserSettings.Providers = {};



/// <summary>
/// A user settings storage impelementation using the browsers web storage API (via Machinata.setCache).
/// This provider can be used for basic functionality, but cannot be relied upon for saving critical data, as the 
/// data is stored to the user's browser session without any gaurantee.
/// Note that on most user environments, browser storage is not cross-device.
/// </summary>
/// <type>class</type>
Machinata.Reporting.UserSettings.Providers.WebStorage = {};

/// <summary>
/// </summary>
Machinata.Reporting.UserSettings.Providers.WebStorage.setGlobalValue = function (instance, key, val) {
    Machinata.setCache("reporting_"+key, val);
};

/// <summary>
/// </summary>
Machinata.Reporting.UserSettings.Providers.WebStorage.getGlobalValue = function (instance, key) {
    return Machinata.getCache("reporting_" + key);
};

/// <summary>
/// </summary>
Machinata.Reporting.UserSettings.Providers.WebStorage.setReportValue = function (instance, key, val) {
    Machinata.Reporting.UserSettings.Providers.WebStorage.setGlobalValue(instance, "report_" + instance.reportData.reportId+"_"+key, val);
};

/// <summary>
/// </summary>
Machinata.Reporting.UserSettings.Providers.WebStorage.getReportValue = function (instance, key) {
    return Machinata.Reporting.UserSettings.Providers.WebStorage.getGlobalValue(instance, "report_" + instance.reportData.reportId + "_" + key);
};

/// <summary>
/// </summary>
Machinata.Reporting.UserSettings.Providers.WebStorage.setNodeValue = function (instance, nodeJSON, key, val) {
    Machinata.Reporting.UserSettings.Providers.WebStorage.setGlobalValue(instance, "node_" + instance.reportData.reportId + "_" + key, val);
};

/// <summary>
/// </summary>
Machinata.Reporting.UserSettings.Providers.WebStorage.getNodeValue = function (instance, nodeJSON, key) {
    return Machinata.Reporting.UserSettings.Providers.WebStorage.getGlobalValue(instance, "node_" + instance.reportData.reportId + "_" + key);
};








/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-text.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-text.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Reporting text tools for resolving texts with formats and getting the proper translation.
/// Note: It is highly recommend to always provide reports JSON with fully resolved text.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Text = {};

/// <summary>
/// Get the resolved text for a JSON object.
/// It is highly recommend to always provide reports JSON with fully resolved text.
/// </summary>
/// <example>
/// Example JSON:
/// ```
/// "myResolvableText": {
///     "translations": {
///         "en": "View Page",
///         "de": "Seite Ansehen",
///         "*": "TRANS: View Page"
///     },
///     "resolved": "View Page"
/// }
/// ```
/// </summary>
Machinata.Reporting.Text.resolve = function (instance, json) {
    // Sanity
    if (instance == null) throw "Machinata.Reporting.Text.resolve: instance cannot be null";
    if (instance.config == null) throw "Machinata.Reporting.Text.resolve: instance.config cannot be null";

    // Get the language to use
    var language = instance.config.contentLanguage;

    // Get the resolved text
    if (json == null) return null;
    if (json["resolved"] != null) return json["resolved"];
    if (json["translations"] != null) {
        if (json["translations"][language] != null) return json["translations"][language];
        if (json["translations"]["*"] != null) return json["translations"]["*"];
    }
    if (json["text"] != null) return json["text"];
    return null;
};





/// <summary>
/// Looks up the translation for a given identifier for the 'instance.config.interfaceLanguage' 
/// Uses 'en' as a fallback
/// If no translation can be found this will return [TRANS:{translationId}.en]
/// </summary>
Machinata.Reporting.Text.translate = function (instance, translationId) {
    // Sanity
    if (instance == null) throw "Machinata.Reporting.Text.resolve: instance cannot be null";
    if (instance.config == null) throw "Machinata.Reporting.Text.resolve: instance.config cannot be null";

    // Get the language to use
    var language = instance.config.interfaceLanguage;
    var fallbackLanguage = "en";

    // Get the entry
    var translations = Machinata.Reporting.Text.TRANSLATIONS["categories"]["global"]["translations"];
    var entry = translations[translationId];

    // Get the translation 
    var translation = null;
    if (entry != null) {
        translation = entry[language];

        // Fallback Language
        if (translation == null || translation == "") {
            translation = entry[fallbackLanguage];
        }
    }

    // Nothing Found
    if (translation == null || translation == "") {

        translation = "[TRANS:" + translationId + "." + language + "]";
    }
    
    return translation;
};






/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-text-translations.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-text-translations.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// </summary>
Machinata.Reporting.Text.TRANSLATIONS = {
    "categories": {
        "global": {
            "translations": {
                "reporting.nodes.fullscreen": {
                    "en": "Enter fullscreen",
                    "de": "Vollbild anzeigen"
                },
                "reporting.nodes.print": {
                    "en": "Add to print composer",
                    "de": "Zum Print Composer hinzufügen"

                },
                "reporting.nodes.configure": {
                    "en": "Configure",
                    "de": "Konfigurieren"

                },
                "reporting.nodes.copy-to-clipboard": {
                    "en": "Copy to clipboard",
                    "de": "In die Zwischenablage kopieren"
                },
                "reporting.nodes.copied": {
                    "en": "Copied",
                    "de": "Kopiert"
                },
                "reporting.nodes.copied.text": {
                    "en": "The text has been copied to your clipboard. You can paste it into an Email, Word or Excel.",
                    "de": "Der Text wurde in Ihre Zwischenablage kopiert. Sie können ihn in eine E-Mail, Word oder Excel einfügen."
                },
                "reporting.nodes.copied.table": {
                    "en": "The table has been copied to your clipboard. You can paste it into an Email, Word or Excel.",
                    "de": "Die Tabelle wurde in Ihre Zwischenablage kopiert. Sie können sie in eine E-Mail, Word oder Excel einfügen."
                },
                "reporting.nodes.copied.grid": {
                    "en": "The grid has been copied to your clipboard. You can paste it into an Email, Word or Excel.",
                    "de": "Die Tabelle wurde in Ihre Zwischenablage kopiert. Sie können sie in eine E-Mail, Word oder Excel einfügen."
                },
                "reporting.nodes.search-filter": {
                    "en": "Search & filter",
                    "de": "Suchen & Filtern"
                },
                "reporting.nodes.remove-filter": {
                    "en": "Remove filter",
                    "de": "Filter entfernen"
                },
                "reporting.nodes.export": {
                    "en": "Export",
                    "de": "Export"
                },
                "reporting.nodes.export.what-format": {
                    "en": "What format would you like to export?",
                    "de": "Welches Format möchten Sie exportieren?"
                },
                "reporting.nodes.export.format-no-available": {
                    "en": "This data format is currently not available.",
                    "de": "Dieses Datenformat ist derzeit nicht verfügbar"
                },
                "reporting.nodes.export.error": {
                    "en": "There was an error exporting the chart:",
                    "de": "Beim Exportieren des Diagramms ist ein Fehler aufgetreten:"
                },
                "reporting.nodes.ask-question": {
                    "en": "Ask a question",
                    "de": "Eine Frage stellen"
                },

                "reporting.nodes.add-to-dashboard": {
                    "en": "Add to dashboard",
                    "de": "Zum Dashboard hinzufügen"
                },
                "reporting.nodes.add-to-presentation": {
                    "en": "Add to presentation",
                    "de": "Zur Präsentation hinzufügen"

                },
                "reporting.nodes.share": {
                    "en": "Copy link & share",
                    "de": "Link kopieren & freigeben"
                },
                "reporting.nodes.share.copy": {
                    "en": "Copy link",
                    "de": "Link kopieren"
                },
                "reporting.nodes.share.description": {
                    "en": "You can share a direct link to this part of the report using:",
                    "de": "Sie können einen direkten Link zu diesem Teil des Berichts teilen:"
                },
                "reporting.nodes.share.copied": {
                    "en": "Link copied",
                    "de": "Link kopiert"
                },
                "reporting.nodes.share.copied.text": {
                    "en": "The link has been copied to your clipboard",
                    "de": "Der Link wurde in Ihre Zwischenablage kopiert"
                },
                "reporting.exit-fullscreen": {
                    "en": "Exit Fullscreen",
                    "de": "Vollbild beenden"
                },
                "reporting.loading-text": {
                    "en": "Loading...",
                    "de": "Laden..."
                },
                "reporting.your-catalog": {
                    "en": "Your Portfolios",
                    "de": "Ihre Portfolios"
                },
                "reporting.your-reports": {
                    "en": "Reports",
                    "de": "Berichte"
                },
                "reporting.view-all": {
                    "en": "View all",
                    "de": "Alle anzeigen"
                },
                "reporting.view-all-dates": {
                    "en": "View all dates",
                    "de": "Alle Daten anzeigen"
                },
                "reporting.view-report": {
                    "en": "View report",
                    "de": "Bericht anzeigen"
                },
                "reporting.view-latest-report": {
                    "en": "View latest report",
                    "de": "Neuesten Bericht ansehen"
                },
                "reporting.show-all-reports": {
                    "en": "Show all reports",
                    "de": "Alle Berichte anzeigen"
                },
                "reporting.choose-date": {
                    "en": "Choose reporting date",
                    "de": "Berichtsdatum wählen"
                },
                "reporting.change-date": {
                    "en": "Change reporting date",
                    "de": "Berichtsdatum ändern"
                },
                "reporting.total-row": {
                    "en": "Total",
                    "de": "Total"
                },
                "reporting.notice": {
                    "en": "Notice",
                    "de": "Hinweis"
                },
                "reporting.filter-no-results": {
                    "en": "No results for filters.",
                    "de": "Keine Ergebnisse für Filter."
                },
                "reporting.filter-no-results.reset": {
                    "en": "Reset",
                    "de": "Zurücksetzen"
                },
                "reporting.filter-no-results.filter-info": {
                    "en": "Tips for filters",
                    "de": "Tipps für Filter"
                },
                "reporting.filter-no-results.filter-info.message": {
                    "en": "In addition to filtering for text, you can also use the following semantics:",
                    "de": "Zusätzlich zur Filterung nach Text können Sie auch die folgende Semantik verwenden:"
                },
                "reporting.filter-no-results.filter-info.tip-1": {
                    "en": "exact match: \"keyword\"",
                    "de": "exakter Treffer: \"keyword\""
                },
                "reporting.filter-no-results.filter-info.tip-2": {
                    "en": "not: !\"keyword\"",
                    "de": "nicht: !\"keyword\""
                },
                "reporting.filter-no-results.filter-info.tip-3": {
                    "en": "less than: <100 (also <=100)",
                    "de": "kleiner als: <100 (also <=100)"
                },
                "reporting.filter-no-results.filter-info.tip-4": {
                    "en": "greater than: >100, (also >=100)",
                    "de": "grösser als: >100, (also >=100)"
                },
                "reporting.filter-no-results.filter-info.tip-5": {
                    "en": "and: >100 and <102",
                    "de": "und: >100 and <102"
                },
                "reporting.filter-no-results.filter-info.tip-6": {
                    "en": "or: 'EUR' or 'USD'",
                    "de": "oder: 'EUR' or 'USD'"
                },
                "reporting.filter-no-results.filter-info.tip-7": {
                    "en": "range: 10 - 30",
                    "de": "Bereich: 10 - 30"
                },
                "reporting.filter-placeholder": {
                    "en": "Search",
                    "de": "Suche"
                },
                "reporting.printing.print": {
                    "en": "Print",
                    "de": "Drucken"
                },
                "reporting.printing.option-report": {
                    "en": "Print entire report",
                    "de": "Gesamten Bericht drucken"
                },
                "reporting.printing.option-chapter": {
                    "en": "Print current chapter",
                    "de": "Aktuelles Kapitel drucken"
                },
               
                "reporting.printing.option-view-composer": {
                    "en": "View print composer",
                    "de": "Print Composer anzeigen"
                },
                "reporting.printing.option-section": {
                    "en": "Print this section",
                    "de": "Diesen Abschnitt drucken"
                },
                "reporting.printing.option-add-composer": {
                    "en": "Add to print composer",
                    "de": "Zum Print Composer hinzufügen"
                },
                "reporting.printing.print-composer.added.title": {
                    "en": "Item added",
                    "de": "Element hinzugefügt"
                },
                "reporting.printing.print-composer.added.message": {
                    "en": "Would you like to go to the print composer now?",
                    "de": "Wollen Sie jetzt zu dem Print Composer gehen?"
                },
                "reporting.printing.print-composer.reset.title": {
                    "en": "Reset print composer",
                    "de": "Print Composer zurücksetzen"
                },
                "reporting.printing.print-composer.reset.message": {
                    "en": "Are you sure you want to reset the print composer?",
                    "de": "Sind Sie sicher, dass Sie den Print Composer zurücksetzen wollen?"
                },
                "reporting.printing.print-report.title": {
                    "en": "Print report",
                    "de": "Bericht drucken"
                },
                "reporting.printing.print-report.message": {
                    "en": "You can print an entire report or just the current chapter. What would you like to do?",
                    "de": "Sie können einen ganzen Bericht oder nur das aktuelle Kapitel ausdrucken. Was möchten Sie tun?"
                },
                "reporting.printing.print-node.title": {
                    "en": "Print section",
                    "de": "Abschnitt drucken"
                },
                "reporting.printing.print.node.message": {
                    "en": "You can print a single section in your browser or add it to the print composer to create a custom report. You can also print an entire report or just the current chapter. What would you like to do?",
                    "de": "Sie können einen einzelnen Abschnitt in Ihrem Browser ausdrucken oder ihn dem Print Composer hinzufügen, um einen benutzerdefinierten Bericht zu erstellen. Sie können auch einen ganzen Bericht oder nur das aktuelle Kapitel drucken. Was möchten Sie tun?"
                },
                "reporting.tables.select-columns": {
                    "en": "Select which columns you would like to see:",
                    "de": "Wählen Sie aus, welche Spalten Sie sehen möchten:"
                },
                "reporting.tables.drilldown-on": {
                    "en": "Drilldown on ",
                    "de": "Drilldown auf "
                },
                "reporting.tables.drilldown-on-total": {
                    "en": "Drilldown on Total",
                    "de": "Drilldown auf Total"
                },
                "reporting.nodes.select-columns": {
                    "en": "Select which columns you would like to see:",
                    "de": "Wählen Sie aus, welche Spalten Sie sehen möchten:"
                },
                "reporting.no-data-for-this-date": {
                    "en": "No data available for this date",
                    "de": "Keine Daten für dieses Datum verfügbar"
                },
                "reporting.unsupported-browser-feature": {
                    "en": "Sorry, your browser does not support this feature.",
                    "de": "Ihr Browser unterstützt diese Funktion leider nicht."
                },
                "reporting.nodes.debug": {
                    "en": "Debug",
                    "de": "Debug"
                },
                "reporting.nodes.debug.options": {
                    "en": "Please choose a debugging tool:",
                    "de": "Please choose a debugging tool:"
                }


            },

        }
    }
}


/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-layouts.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-layouts.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Reporting Layouts for nodes.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Layouts = {};

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.COLUMNS_2 = "COLUMNS_2";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.COLUMNS_4 = "COLUMNS_4";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.COLUMNS_1 = "COLUMNS_1";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.COLUMNS_3QUARTER = "COLUMNS_3/4";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.BLOCK_1x1 = "Block1x1";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.BLOCK_2x1 = "Block2x1";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.BLOCK_1x2 = "Block1x2";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.BLOCK_2x2 = "Block2x2";

/// <summary>
/// A more exotic size, used only on 1-column grid layouts for special nodes such as Metrics fact bar...
/// </summary>
Machinata.Reporting.Layouts.BLOCK_4x1 = "Block4x1";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.BLOCK_4x2 = "Block4x2";

/// <summary>
/// </summary>
Machinata.Reporting.Layouts.BLOCK_4x4 = "Block4x4";

/// <summary>
/// A more exotic size, used only on 1-column grid layouts such as mobile devices...
/// </summary>
Machinata.Reporting.Layouts.BLOCK_4x3 = "Block4x3";




/// <summary>
/// </summary>
Machinata.Reporting.Layouts.calculateSizeForBlockOrColumn = function (instance, config, blockOrColumnName, containerWidth, containerHeight) {
    // Init
    var ret = {width: null, height: null}; // number
    containerWidth = Machinata.Math.makeEven(containerWidth); // Make sure we have a nicely divisible number to start with
    containerHeight = Machinata.Math.makeEven(containerHeight); // Make sure we have a nicely divisible number to start with

    // Switch on block or column name
    if (blockOrColumnName == Machinata.Reporting.Layouts.COLUMNS_2) {
        ret.width = containerWidth / 2;
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.COLUMNS_4) {
        ret.width = containerWidth / 4;
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.COLUMNS_1) {
        ret.width = containerWidth;
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.COLUMNS_3QUARTER) {
        ret.width = (containerWidth / 4) * 3;
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_1x1) {
        ret.width = (containerWidth / 4) * 1; // blocks are always on the 4 column grid
        ret.height = ret.width;
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_1x2) {
        ret.width = (containerWidth / 4) * 1; // blocks are always on the 4 column grid
        ret.height = (containerWidth / 4) * 2; // blocks are always on the 4 column grid
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_2x1) {
        ret.width = (containerWidth / 4) * 2; // blocks are always on the 4 column grid
        ret.height = (containerWidth / 4) * 1; // blocks are always on the 4 column grid
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_2x2) {
        ret.width = (containerWidth / 4) * 2; // blocks are always on the 4 column grid
        ret.height = ret.width;
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_4x4) {
        ret.width = (containerWidth / 4) * 4; // blocks are always on the 4 column grid
        ret.height = ret.width;
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_2x1) {
        ret.width = (containerWidth / 4) * 2; // blocks are always on the 4 column grid
        ret.height = (containerWidth / 4) * 1; // blocks are always on the 4 column grid
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_4x1) {
        ret.width = (containerWidth / 4) * 4; // blocks are always on the 4 column grid
        ret.height = (containerWidth / 4) * 1; // blocks are always on the 4 column grid
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_4x2) {
        ret.width = (containerWidth / 4) * 4; // blocks are always on the 4 column grid
        ret.height = (containerWidth / 4) * 2; // blocks are always on the 4 column grid
    } else if (blockOrColumnName == Machinata.Reporting.Layouts.BLOCK_4x3) {
        ret.width = (containerWidth / 4) * 4; // blocks are always on the 4 column grid
        ret.height = (containerWidth / 4) * 3; // blocks are always on the 4 column grid
    } else if (blockOrColumnName == "100%") {
        ret.width = containerWidth;
        ret.height = containerHeight;
    } else if (isNaN(blockOrColumnName) == false) {
        // Its a number
        ret.width = blockOrColumnName;
        ret.height = blockOrColumnName;
    } else {
        console.warn("Machinata.Reporting.Layouts.calculateSizeForBlockOrColumn: the block or column name " + blockOrColumnName +" is not recognized. Please use a valid block or column name given by Machinata.Reporting.Layouts constants.");
    }
    return ret; 
};




/// <summary>
/// Default layouts shipped with the core reporting framework.
/// These are automatically registered.
/// </summary>
Machinata.Reporting.Layouts.DEFAULT_LAYOUTS = {
    "CS_W_Two_Columns": {
        "style": "CS_W_Two_Columns",
        "children": [
            {
                "slotKey": "{left}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_2"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{right}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_2"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            }
        ]
    },
    "CS_W_Four_Columns": {
        "style": "CS_W_Four_Columns",
        "children": [
            {
                "slotKey": "{a}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_2"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{b}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_2"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{c}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_2"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{d}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_2"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            }
        ]
    },
    "CS_W_Sidebar_Right": {
        "style": "CS_W_Sidebar_Right",
        "children": [
            {
                "slotKey": "{main}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_3/4"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{sidebar}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            }
        ]
    },
    "CS_W_Overview_PanelTopA": {
        "children": [
            {
                "slotKey": "{mandateInformation}",
                "style": "CS_W_Block2x2",
                "chrome": "dark",
                "addStandardTools": true,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block2x2"
                    },
                    "tablet": {
                        "size": "Block4x4"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            },
            {
                "slotKey": "{contact}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x3"
                    }
                },
            },
            {
                "slotKey": "{riskStatus}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x3"
                    }
                },
            },
            {
                "slotKey": "{performanceChart}",
                "style": "CS_W_Block2x1",
                "addStandardTools": false,
                "disableExport": true,
                "responsiveSize": {
                    "default": {
                        "size": "Block2x1"
                    },
                    "tablet": {
                        "size": "Block4x2"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            }
        ]
    },
    "CS_W_Overview_PanelTopB": {
        "children": [
            {
                "slotKey": "{mandateInformation}",
                "styles": ["CS_W_Block2x2", "CS_W_MetricsFirstItemDark"],
                "chrome": "solid",
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block2x2"
                    },
                    "tablet": {
                        "size": "Block4x4"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            },
            {
                "slotKey": "{contact}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x3"
                    }
                },
            },
            {
                "slotKey": "{riskStatus}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x3"
                    }
                },
            },
            {
                "slotKey": "{performanceChart}",
                "style": "CS_W_Block2x1",
                "addStandardTools": false,
                "disableExport": true,
                "responsiveSize": {
                    "default": {
                        "size": "Block2x1"
                    },
                    "tablet": {
                        "size": "Block4x2"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            }
        ]
    },
    "CS_W_Overview_PanelText": {
        "style": "CS_W_Overview_FullWidth",
        "children": [
            {
                "slotKey": "{text}",
                "style": "CS_W_RichText_Overview",
                "chrome": "light"
            }
        ]
    },
    "CS_W_Overview_PanelMap": {
        "style": "CS_W_Overview_FullWidth",
        "children": [
            {
                "slotKey": "{map}",
                "chrome": "light"
            }
        ]
    },
    "CS_W_Overview_PanelLargeBlocksA": {
        "children": [
            {
                "slotKey": "{left}",
                "style": "CS_W_Block2x2",
                "responsiveSize": {
                    "default": {
                        "size": "Block2x2"
                    },
                    "tablet": {
                        "size": "Block4x4"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            },
            {
                "slotKey": "{right}",
                "style": "CS_W_Block2x2",
                "responsiveSize": {
                    "default": {
                        "size": "Block2x2"
                    },
                    "tablet": {
                        "size": "Block4x4"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            }
        ]
    },
    "CS_W_Overview_PanelMixedBlocksA": {
        "children": [
            {
                "slotKey": "{left}",
                "style": "CS_W_Block2x2",
                "responsiveSize": {
                    "default": {
                        "size": "Block2x2"
                    },
                    "tablet": {
                        "size": "Block4x4"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            },
            {
                "slotKey": "{rightTop}",
                "style": "CS_W_Block2x1",
                "responsiveSize": {
                    "default": {
                        "size": "Block2x1"
                    },
                    "tablet": {
                        "size": "Block4x2"
                    },
                    "mobile": {
                        "size": "Block4x3"
                    }
                },
            },
            {
                "slotKey": "{rightBottom}",
                "style": "CS_W_Block2x1",
                "responsiveSize": {
                    "default": {
                        "size": "Block2x1"
                    },
                    "tablet": {
                        "size": "Block4x2"
                    },
                    "mobile": {
                        "size": "Block4x3"
                    }
                },
            }
        ]
    },
    "CS_W_Overview_PanelTrailerBlocksA": {
        "children": [
            {
                "slotKey": "{left}",
                "styles": ["CS_W_Block1x1"],
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            },
            {
                "slotKey": "{center}",
                "styles": ["CS_W_Block2x1"],
                "responsiveSize": {
                    "default": {
                        "size": "Block2x1"
                    },
                    "tablet": {
                        "size": "Block4x2"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            },
            {
                "slotKey": "{right}",
                "styles": ["CS_W_Block1x1"],
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x4"
                    }
                },
            }
        ]
    },
    "CS_W_Overview_PanelTrailerBlocksB": {
        "children": [
            {
                "slotKey": "{left1}",
                "styles": ["CS_W_Block1x1"],
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x2"
                    }
                },
            },
            {
                "slotKey": "{left2}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block4x2"
                    }
                },
            },
            {
                "slotKey": "{right}",
                "style": "CS_W_Block2x1",
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block2x1"
                    },
                    "tablet": {
                        "size": "Block4x2"
                    },
                    "mobile": {
                        "size": "Block4x3"
                    }
                },
            }
        ]
    },
    "CS_W_Overview_PanelTrailerBlocksC": {
        "children": [
            {
                "slotKey": "{left}",
                "styles": ["CS_W_Block1x1"],
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block2x2"
                    }
                },
            },
            {
                "slotKey": "{middleLeft}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block2x2"
                    }
                },
            },
            {
                "slotKey": "{middleRight}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block2x2"
                    }
                },
            },
            {
                "slotKey": "{right}",
                "style": "CS_W_Block1x1",
                "addStandardTools": false,
                "addCopyToClipboardTool": false,
                "responsiveSize": {
                    "default": {
                        "size": "Block1x1"
                    },
                    "tablet": {
                        "size": "Block2x2"
                    },
                    "mobile": {
                        "size": "Block2x2"
                    }
                },
            }
        ]
    },
    "CS_W_2-1-1": {
        "style": "CS_W_2-1-1",
        "children": [
            {
                "slotKey": "{a}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_2"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{b}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{c}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            }
        ]
    },
    "CS_W_1-1-2": {
        "style": "CS_W_1-1-2",
        "children": [
            {
                "slotKey": "{a}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{b}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_4"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            },
            {
                "slotKey": "{c}",
                "responsiveSize": {
                    "default": {
                        "width": "COLUMNS_2"
                    },
                    "tablet": {
                        "width": "COLUMNS_1"
                    },
                    "mobile": {
                        "width": "COLUMNS_1"
                    }
                },
            }
        ]
    }
};
Machinata.Reporting.registerLayouts(Machinata.Reporting.Layouts.DEFAULT_LAYOUTS);

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-asset.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-asset.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Reporting asset tools for resolving assets so that they are accessible within the report.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Asset = {};




/// <summary>
/// Get the resolved asset for a JSON object.
///
/// Note: assets that are encoded and embedded into the report JSON must adhere to the browsers limitations for blobs and data-URIs. 
/// In practice this means that files should not be larger than 2MB.
///
/// ## Images
/// Image assets can be directly encoded as a base64. This allows for image assets to be embedded in the
/// report JSON. Image assets can also be provided as a URL, either absolute (fully qualified) or relative.
/// </summary>
/// <example>
/// ### Example Embedded Asset:
/// ```
/// "photo": {
///     "filename": "QRCodeTest.png",
///     "mimeType": "image/png",
///     "encoding": "base64",
///     "data": "iVBORw0KGgoAAAANSUhEUgAAABUAAAAVAQMAAACT2TfVAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP//8i138cAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABcSURBVAiZY2Bcws5Qq/udwdVUnMF1LRCXijPUpn5nYAxhZ/jP/p9BZ44/g9De8wwHg58zXHvfzsBoGs/wn0+dgdHqPEPtI3sG1x52Btf8dgbX6+UMtZHxDIzu/AAr6RmSv9DdfQAAAABJRU5ErkJggg=="
/// }
/// ```
/// ### Example Downloadable Asset:
/// ```
/// "photo": {
///     "filename": "QRCodeTest.png",
///     "mimeType": "image/png",
///     "encoding": "base64",
///     "data": "iVBORw0KGgoAAAANSUhEUgAAABUAAAAVAQMAAACT2TfVAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP//8i138cAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABcSURBVAiZY2Bcws5Qq/udwdVUnMF1LRCXijPUpn5nYAxhZ/jP/p9BZ44/g9De8wwHg58zXHvfzsBoGs/wn0+dgdHqPEPtI3sG1x52Btf8dgbX6+UMtZHxDIzu/AAr6RmSv9DdfQAAAABJRU5ErkJggg=="
/// }
/// ```
/// ### Example Linked Asset:
/// ```
/// "photo": {
///     "filename": "QRCodeTest.png",
///     "mimeType": "image/png",
///     "encoding": "url",
///     "data": "https://nerves.ch/content/image/GYssOw/Nerves-New-Business-Card.jpg"
/// }
/// ```
/// </example>
Machinata.Reporting.Asset.resolve = function (json) {
    if (json == null) return null;
    
    // Special handling for encoding types?
    if (json.encoding == "url") {
        return json.data;
    } else if(json.encoding == "base64") {
        return "data:" + json.mimeType + ";base64," + encodeURIComponent(json.data);
    } else {
        return null;
    }

    // Fallback to resolved version
    return json.resolved;
};






/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-tools.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-tools.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Collection of tools that supplement a report.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Tools = {};

/// <summary>
/// Converts the given value to pixels using ```Machinata.Reporting.Config.layoutingDPI```.
/// </summary>
Machinata.Reporting.Tools.convertMillimetersToPixels = function (config,millimeters) {
    var inches = millimeters * (1.0 / 25.4);
    return Machinata.Reporting.Tools.convertInchesToPixels(config,inches);
};

/// <summary>
/// Converts the given value to pixels using ```Machinata.Reporting.Config.layoutingDPI```.
/// </summary>
Machinata.Reporting.Tools.convertInchesToPixels = function (config,inches) {
    if (config == null) throw ("Machinata.Reporting.Tools.convertInchesToPixels: config is null");
    if (config.layoutingDPI == null) throw ("Machinata.Reporting.Tools.convertInchesToPixels: config.layoutingDPI is null");
    var dpi = config.layoutingDPI;
    var px = inches * dpi;
    return px;
};

/// <summary>
/// Toggles fullscreen for a node by opening a fullscreen report for the nodes screen number.
/// </summary>
Machinata.Reporting.Tools.toggleFullscreenForNode = function (instance,nodeElem) {
    // Find screen number
    var screenNumber = nodeElem.attr("data-screen");
    if ($(document).fullScreen() == false) {
        if (screenNumber == "") screenNumber = null;
        if (screenNumber != null) screenNumber = parseInt(screenNumber);
        Machinata.Reporting.Tools.openFullscreenReport(instance,screenNumber);
    } else {
        Machinata.Reporting.Tools.exitFullscreenLayout(instance);
    }
};

/// <summary>
/// Opens a report in fullscreen using a fullscreen HTML node and an iframe.
/// A toolbar is automatically created for the report.
/// </summary>
Machinata.Reporting.Tools.openFullscreenReport = function (instance,screenNumber, title, subtitle) {
    //Machinata.Reporting.Tools.openFullscreenReportViaIframe(instance,screenNumber, title, subtitle);
    Machinata.Reporting.Tools.openFullscreenReportViaInlineElement(instance, screenNumber, title, subtitle);
};

/// <summary>
/// Opens a report in fullscreen using a fullscreen HTML node and an iframe.
/// A toolbar is automatically created for the report.
/// </summary>
Machinata.Reporting.Tools.openFullscreenReportViaInlineElement = function (instance, screenNumber, title, subtitle) {


    // Fallback title to report tile
    if (title == null) title = instance.config.reportTitle;

    // Find screen number
    if (screenNumber == null) screenNumber = 0;

    // Create fullscreen UI
    var fullscreenContainer = $("<div class='machinata-reporting-fullscreen-container machinata-reporting-styling'></div>");
    instance.elems.fullscreen = fullscreenContainer;

    // Read progress
    var reportContainer = $("<div class='machinata-reporting-report'></div>");
    var reportContainerId = Machinata.UI.autoUIDElem(reportContainer);
    fullscreenContainer.append(reportContainer);

    // Read progress
    var fullscreenReadProgress = $("<div class='machinata-reporting-readprogress'><div class='progress'></div></div>");
    fullscreenContainer.append(fullscreenReadProgress);

    // Toolbar
    var fullscreenToolbar = Machinata.Reporting.buildToolbar(instance, title, "");
    fullscreenToolbar.addClass("machinata-reporting-fullscreen-toolbar");
    Machinata.Reporting.addToolToToolbar(instance, fullscreenContainer, fullscreenToolbar, Machinata.Reporting.Text.translate(instance, "reporting.exit-fullscreen"), "close", function () {
        Machinata.Reporting.Tools.exitFullscreenLayout(instance);
    });
    fullscreenToolbar.addClass("machinata-reporting-fullscreen-toolbar");
    fullscreenToolbar.find(".title,.subtitle").css("user-select","none");
    fullscreenToolbar.find(".subtitle").addClass("machinata-reporting-attribute-currentscreen");
    fullscreenContainer.append(fullscreenToolbar);

    // Controls
    {
        var controlElem = $('<div class="machinata-reporting-screen-controls prev"></div>');
        controlElem.append(Machinata.Reporting.buildIcon(instance, "chevron-left"));
        controlElem.appendTo(fullscreenContainer);
    }
    {
        var controlElem = $('<div class="machinata-reporting-screen-controls next"></div>');
        controlElem.append(Machinata.Reporting.buildIcon(instance, "chevron-right"));
        controlElem.appendTo(fullscreenContainer);
    }

    // Register in body
    $("body").append(fullscreenContainer);

    // Init a fullscreen version of the report
    // This is a new clone from the initConfig of the calling report
    var fullScreenConfig = Machinata.Util.extend({}, instance.initConfig, {
        profile: "fullscreen",
        screens: [screenNumber],
        chapters: "*",
        contentSelector: "#" + reportContainerId
    });
    var fullscreenInstance = Machinata.Reporting.init(fullScreenConfig, function (instance, config) {
        // Success...
        // Initial UI update
        Machinata.Reporting.Tools._updateFullscreenUI(instance);
    });
    fullscreenContainer.data("report-instance", fullscreenInstance);

    // Bind some tools
    fullscreenContainer.find(".machinata-reporting-screen-controls.next").click(function () {
        Machinata.Reporting.Tools.nextScreen(fullscreenInstance);
    });
    fullscreenContainer.find(".machinata-reporting-screen-controls.prev").click(function () {
        Machinata.Reporting.Tools.prevScreen(fullscreenInstance);
    });

    // Bind some events
    $(document).bind("fullscreenchange", function () {
        if ($(document).fullScreen() == false) {
            Machinata.Reporting.Tools.exitFullscreenLayout(instance);
        }
    });

    // Enter fullscreen
    fullscreenContainer.fullScreen(true);

};

/// <summary>
/// Opens a report in fullscreen using a fullscreen HTML node and an iframe.
/// A toolbar is automatically created for the report.
/// </summary>
/// <deprecated/>
/// <hidden/>
Machinata.Reporting.Tools.openFullscreenReportViaIframe = function (instance,screenNumber, title, subtitle) {
    throw "Machinata.Reporting.Tools.openFullscreenReportViaIframe is no longer supported"

    /*
    // Fallback title to report tile
    if (title == null) title = instance.config.reportTitle;

    // Find screen number
    if (screenNumber == null) screenNumber = 0;

    // Create fullscreen UI
    var fullscreenContainer = $("<div class='machinata-reporting-fullscreen-container'><iframe></iframe></div>");
    var screenURL = instance.config.url;
    screenURL = Machinata.updateQueryString("screen", screenNumber, screenURL);
    screenURL = Machinata.updateQueryString("profile", "fullscreen", screenURL);
    screenURL = Machinata.updateQueryString("chapter", "*", screenURL);
    fullscreenContainer.find("iframe").attr("src", screenURL);

    // Read progress
    var fullscreenReadProgress = $("<div class='machinata-reporting-readprogress'><div class='progress'></div></div>");
    fullscreenContainer.append(fullscreenReadProgress);

    // Toolbar
    var fullscreenToolbar = Machinata.Reporting.buildToolbar(instance, title, "");
    var totalScreens = instance.totalScreens;
    if (totalScreens == 0) totalScreens = 1;
    fullscreenContainer.find("iframe").on("load", function () {
        var newURL = this.contentWindow.location.href;
        var newScreen = Machinata.queryParameterFromURL("screen", newURL);
        var currentScreen = parseInt(newScreen);
        currentScreen++;

        fullscreenToolbar.find(".subtitle").text(currentScreen + " / " + totalScreens);
        var progress = (currentScreen / totalScreens) * 100.0;
        fullscreenReadProgress.find(".progress").css("width", progress + "%");
    });
    Machinata.Reporting.addToolToToolbar(instance, fullscreenContainer, fullscreenToolbar, Machinata.Reporting.Text.translate(instance, "reporting.exit-fullscreen"), "close", function () {
        Machinata.Reporting.Tools.exitFullscreenLayout();
    });
    fullscreenToolbar.addClass("machinata-reporting-fullscreen-toolbar");
    fullscreenToolbar.find(".subtitle").text((screenNumber + 1) + " / " + totalScreens);
    fullscreenContainer.append(fullscreenToolbar);
    $("body").append(fullscreenContainer);

    // Enter fullscreen
    fullscreenContainer.fullScreen(true);

    // Set focus
    setTimeout(function () {
        fullscreenContainer.find("iframe").focus();
    }, 1000);*/
};


/// <summary>
/// Forces a exit of fullscreen mode
/// </summary>
Machinata.Reporting.Tools.exitFullscreenLayout = function (instance) {
    Machinata.debug("Machinata.Reporting.Tools.exitFullscreenLayout");
    if (instance != null && instance.elems.fullscreen != null) {
        var fullscreenContainer = instance.elems.fullscreen;

        // Cleanup report
        var fullscreenInstance = fullscreenContainer.data("report-instance");
        if (fullscreenInstance != null) {
            Machinata.Reporting.cleanup(fullscreenInstance);
        }

        // Close container fullscreen and remove
        fullscreenContainer.fullScreen(false);
        fullscreenContainer.remove();
        instance.elems.fullscreen = null;
    }
};

/// <summary>
/// Internal method for updating the fullscreen UI (when the report is opened in fullscreen)
/// </summary>
/// <hidden/>
Machinata.Reporting.Tools._updateFullscreenUI = function (instance) {
    // Init
    var fullscreenContainer = instance.elems.content.closest(".machinata-reporting-fullscreen-container");
    var totalScreens = instance.totalScreens;
    if (totalScreens == 0) totalScreens = 1;
    var progress = ((instance.currentScreen+1) / totalScreens) * 100.0;
    fullscreenContainer.find(".machinata-reporting-readprogress .progress").css("width", progress + "%");

    // Update screen number UI
    fullscreenContainer.find(".machinata-reporting-attribute-currentscreen")
        .text((instance.currentScreen + 1) + " / " + totalScreens);

    // Update next/prev buttons
    if (instance.currentScreen >= instance.totalScreens - 1) {
        fullscreenContainer.find(".machinata-reporting-screen-controls.next").hide();
    } else {
        fullscreenContainer.find(".machinata-reporting-screen-controls.next").show();
    }
    if (instance.currentScreen <= 0) {
        fullscreenContainer.find(".machinata-reporting-screen-controls.prev").hide();
    } else {
        fullscreenContainer.find(".machinata-reporting-screen-controls.prev").show();
    }
};

/// <summary>
/// Changes the report to the given screen number.
/// </summary>
Machinata.Reporting.Tools.changeScreen = function (instance, screenNumber) {
    Machinata.debug("Machinata.Reporting.Tools.changeScreen:", screenNumber);

    if (instance.screenNumber >= instance.totalScreens - 1) throw "Machinata.Reporting.Tools.changeScreen: screen " + screenNumber + " is not valid"; // sanity
    if (instance.screenNumber <= 0) throw "Machinata.Reporting.Tools.changeScreen: screen " + screenNumber + " is not valid"; // sanity

    // Update screen state to reflect the new screen number
    instance.currentScreen = screenNumber;
    instance.screensToShow = [screenNumber];
    
    // Update actual report to reflect the current screen state
    Machinata.Reporting.Tools._updateFullscreenUI(instance);
    Machinata.Reporting.buildReport(instance, instance.config);
}

/// <summary>
/// Moves to the next screen.
/// This is only supported in fullscreen mode.
/// </summary>
Machinata.Reporting.Tools.nextScreen = function (instance) {
    if (instance.currentScreen >= instance.totalScreens - 1) return; // sanity
    Machinata.Reporting.Tools.changeScreen(instance, instance.currentScreen + 1);
};

/// <summary>
/// Moves to the previous screen.
/// This is only supported in fullscreen mode.
/// </summary>
Machinata.Reporting.Tools.prevScreen = function (instance) {
    if (instance.currentScreen <= 0) return; // sanity
    Machinata.Reporting.Tools.changeScreen(instance, instance.currentScreen - 1);
};


/// <summary>
/// Scrolls to an element, automatically taking into account the header.
/// The header reference can be provided via ```Machinata.Reporting.Config.headerSelector```.
/// If an element is already on screen and on the top half of the viewport, the scroll is not performed.
/// </summary>
Machinata.Reporting.Tools.scrollTo = function (instance, elem, duration) {
    if (duration == null) duration = 0;
    // Compile options for scrollto
    var opts = {};
    if (instance.elems.header != null && instance.elems.header.length > 0) {
        opts.offset = { top: instance.elems.header.height() * -1.5, left: 0 };
    }
    // Validate that we even need to do a scroll, if the elem is close to the destination, then
    // we don't do the scroll, as it just annoys the user.
    opts.ignoreIfTargetIsCloseToDestination = true;
    // Do scroll
    Machinata.UI.scrollTo(elem, duration, opts);
};

/// <summary>
/// Scrolls to top of report, automatically taking into account the header.
/// See for more details ```Machinata.Reporting.Tools.scrollTo```.
/// </summary>
Machinata.Reporting.Tools.scrollToTop = function (instance, duration) {
    Machinata.Reporting.Tools.scrollTo(instance, instance.elems.content, duration);
};



/// <summary>
/// Opens/focuses/drilldowns using a link JSON object.
/// 
/// When linking to nodes within the same report, the browser will automatically scroll to the node (if it is already on the page).
/// If the given node happens to be a chapter, instead of a scroll to that node the chapter will be automatically selected.
///
/// ## Link JSON
/// The link object can have the following properties:
///  - ```tooltip```: resolvable JSON text which is used the mouse-hover tooltip or accessibility
///  - ```nodeId```: the id of a node within the same report to link to (string)
///  - ```chapterId```: the id of a chapter within the same report to link to (string)
///  - ```url```: fully qualified URL to an external page or report (string)
///  - ```target```: if defined, will open a new browser window (string)
///  - ```drilldown```: Drilldown on node information, for example invoking a table to focus on a very specific row (JSON object)
///
/// When performing drilldowns on tables, filters can be specified for the table at the same time in the drilldown
/// ```filters``` property. For more information on table filters, see ```Machinata.Reporting.Node.VerticalTableNode.defaults.filters```.
/// </summary>
/// <example>
/// ### Example with node focus
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "About SRRI risk profile"
///     },
///     "nodeId": "rep-20190710-152228-nodexyz"
/// }
/// ```
/// ### Example with chapter change
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "About SRRI risk profile"
///     },
///     "chapterId": "rep-20190710-chapterxyz"
/// }
/// ```
/// ### Example with external link
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "Go to Nerves.ch"
///     },
///     "url": "https://nerves.ch",
///     "target": "_blank"
/// }
/// ```
/// ### Example with drilldown for table with defined filters
/// Note: using this method filter strings are automatically escaped as needed.
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "Drilldown on rating AAA or BBB or A'A, but not maturity bucket A or B or C"
///     },
///     "nodeId": "rep-20190710-152228-nodexyz"
///     "drilldown": {
///         "filters": [
///             { 
///                 "columnId": "rating",
///                 "isAny": ["AAA","BBB","A'A"] // will generate the filter value "'AAA' or 'BBB' or 'A\'A'"
///             } ,
///             { 
///                 "columnId": "maturityBucket",
///                 "notAny": ["A","B","C"] // will generate the filter value "!'A' and !'B' and !'C'"
///             } 
///         ]
///     }
/// }
/// ```
/// ### Example with drilldown for table with custom filters
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "Drilldown on AAA >10 years"
///     },
///     "nodeId": "rep-20190710-152228-nodexyz"
///     "drilldown": {
///         "filters": [
///             { 
///                 "columnId": "rating",
///                 "expression": "'AAA' and !'BBB'"
///             },
///             { 
///                 "columnId": "maturityBucket",
///                 "expression": ">10 and <15"
///             },
///             { 
///                 "columnId": "type",
///                 "value": "Security"
///             } 
///         ]
///     }
/// }
/// ```
/// </example>
Machinata.Reporting.Tools.openLink = function (instance,linkJSON) {
    if (linkJSON == null) return;

    // Which mode?
    if (linkJSON.url != null) {
        // URL
        if (linkJSON.target != null) {
            window.open(linkJSON.url, linkJSON.target);
        } else {
            window.location = linkJSON.url;
        }
    } else if (linkJSON.elementId != null) {
        // HTML element drilldown
        Machinata.Reporting.Tools.drilldownOnElement(instance,linkJSON);
    } else if (linkJSON.nodeId != null) {
        // Node drilldown
        Machinata.Reporting.Tools.drilldownOnNode(instance,linkJSON);
    } else if (linkJSON.chapterId != null) {
        // Chapter
        Machinata.Reporting.Tools.changeChapter(instance,linkJSON.chapterId);
    }

};


/// <summary>
/// Changes to a ```chapterId``` in the current report via the default handler.
/// If no handler is provided, then a URL update is performed.
/// </summary>
Machinata.Reporting.Tools.changeChapter = function (instance, chapterId) {
    if (Machinata.Reporting.Handler.changeChapter != null) {
        // Handler provided
        Machinata.Reporting.Handler.changeChapter(instance, chapterId);
    } else {
        // URL update
        Machinata.Reporting.Tools.changeChapterViaURLUpdate(instance, chapterId); // default
    }
};

/// <summary>
/// Changes to a ```chapterId``` in the current report via the default handler.
/// If no handler is provided, then a URL update is performed.
/// </summary>
Machinata.Reporting.Tools.changeChapterAndFocusOnNode = function (instance, chapterId, nodeId) {
    if (Machinata.Reporting.Handler.changeChapterAndFocusOnNode != null) {
        // Handler provided
        Machinata.Reporting.Handler.changeChapterAndFocusOnNode(instance, chapterId, nodeId);
    } else {
        // URL Update
        var nodeJSON = Machinata.Reporting.Node.getJSONByID(instance, nodeId);
        Machinata.Reporting.Tools.openLink(instance, { url: nodeJSON.url });
    }
};

/// <summary>
/// Changes to a ```chapterId``` in the current report.
/// </summary>
Machinata.Reporting.Tools.changeChapterViaURLUpdate = function (instance,chapterId) {
    // Find matching chapter go to that url
    Machinata.Util.each(instance.chapters, function (index, chapterJSON) {
        if (chapterJSON.id == chapterId) {
            window.location = chapterJSON.chapterURL;
            return;
        }
    });
};

/// <summary>
/// Changes to a ```chapterId``` in the current report.
/// </summary>
Machinata.Reporting.Tools.changeChapterViaInlineUpdate = function (instance, chapterId, onSuccess) {
    // Just rebuild the report set to the new chapter
    instance.config.chapters = [chapterId];
    instance.config.initialChapter = chapterId;
    Machinata.Reporting.buildReport(instance, instance.config, onSuccess);
};

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.showReportDates = function (instance, catalog, mandate, report, defaultDate, title) {
    if (title == null) title = Machinata.Reporting.Text.translate(instance, 'reporting.change-date');
    var diag = Machinata.messageDialog(title, '');
    var datePickerElem = $("<div class='ui-datepicker'></div>");
    if (report != null && defaultDate == null) defaultDate = report.date;
    datePickerElem.datepicker({
        defaultDate: defaultDate,
        prevText: "",
        nextText: "",
        onSelect: function (dateText, inst) {
            var date = datePickerElem.datepicker("getDate");
            var report = mandate.dateToReportMap[date];
            Machinata.goToPage(report.urlResolved);
        },
        beforeShowDay: function (date) {
            // See https://api.jqueryui.com/datepicker/#option-beforeShowDay
            // Init
            var selectable = false;
            var classes = "";
            var tooltip = Machinata.Reporting.Text.translate(instance,"reporting.no-data-for-this-date"); 
            // Data available?
            if (mandate.dateToReportMap[date] != null) {
                selectable = true;
                //tooltip = mandate.dateToReportMap[date].dateResolved; //BUG: jquery ui bug
                tooltip = null;
            }
            return [selectable, classes, tooltip];
        }
    });
    diag.elem.append(datePickerElem);
    diag.cancelButton();
    diag.show();
};

/// <summary>
/// A universal routine to make any table sortable.
/// </summary>
Machinata.Reporting.Tools.makeTableSortable = function (instance, tableElem) {
    var allowReset = true;
    if (instance.config != null) allowReset = instance.config.allowTableSortResets;
    // See https://mottie.github.io/tablesorter/docs/example-widget-filter.html#filter-placeholder for more options
    tableElem.tablesorter({
        sortReset: allowReset, // third click on the header will reset column to default - unsorted
        widthFixed: true,
        widgets: ['staticRow'],
        widgetOptions: {
            
        }
    });

    //TODO: original this also invoked the filters... check all callers to see if this needs to be called sepeartaly
};

/// <summary>
/// A universal routine to make any table filterable.
/// </summary>
Machinata.Reporting.Tools.makeTableFilterable = function (instance, tableElem, filters) {
    // Init filter options
    var opts = {};
    opts.filters = filters; // optional, can be null
    opts.noResultsText = "";
    opts.buildFilterInputUI = function (tableElem, opts, textInputElem, filterHeaderColumnElem) {
        // No longer needed: tooltips are more annoying than useful
        //textInputElem.attr("data-tooltip-empty", Machinata.Reporting.Text.translate(instance, "reporting.nodes.search-filter") + " " + textInputElem.attr("data-column-title"));
    };
    opts.buildNamedFilterUI = function (tableElem, opts, namedFilterElem, filter) {
        var iconElem = Machinata.Reporting.buildIcon(instance, "cross");
        iconElem.addClass("action-remove-filter");
        iconElem.attr("title", Machinata.Reporting.Text.translate(instance, "reporting.nodes.remove-filter"));
        namedFilterElem.append(iconElem);
    };
    opts.buildNoResultsUI = function (tableElem, opts, noResultsRow) {
        // Create our own UI
        var noResultsUI = $('<div>' + Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results") + ' <a class="reset-action">' + Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.reset") + '</a><br/><br/><a class="info-action">' + Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info") + '</a>' + '</div>');
        // Bind actions
        noResultsUI.find("a.info-action").click(function () {
            var dialog = Machinata.messageDialog(
                Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info"),
                Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.message")
            );
            var listElem = $("<ul style='margin-left:2em;margin-bottom:2em;'></ul>");
            listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-1")));
            listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-2")));
            listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-3")));
            listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-4")));
            listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-5")));
            listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-6")));
            listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-7")));
            //listElem.append($("<li/>").text(Machinata.Reporting.Text.translate(instance, "reporting.filter-no-results.filter-info.tip-8")));
            dialog.elem.append(listElem);
            dialog.show();
        });
        // Add to no results row
        noResultsRow.find("td").append(noResultsUI);
    };
    // Make filterable
    Machinata.Filter.Tables.makeTableFilterable(tableElem, opts);


    //TODO: to port from old code:
    /*
    // Mark as disabled (where needed)
    tableElem.find(".tablesorter-filter-row .tablesorter-filter.disabled")
        .parent()
        .addClass("disabled");
    */
}

/// <summary>
/// Performs a drilldown operation on a table. Usually this is not called directly, but rather
/// indirectly using a drilldown on a node/element using a link JSON.
/// </summary>
Machinata.Reporting.Tools.drilldownOnTable = function (tableElem, drilldownJSON) {
    // Sanity
    if (drilldownJSON.filters == null) {
        drilldownJSON.filters = [];
    }

    // Do all the columns for the filter exist?
    var columnsNotExistingButWillBeFiltered = [];
    Machinata.Util.each(drilldownJSON.filters, function (index, filter) {
        // Does the column exist?
        var columnHeaderElem = tableElem.find("tr.header.columns th.column[data-col-id='" + filter.columnId +"']");
        if (columnHeaderElem.length == 0) {
            columnsNotExistingButWillBeFiltered.push(filter.columnId);
        }
    });
    if (columnsNotExistingButWillBeFiltered.length > 0) {
        // Manipulate and rebuild the table?
        var nodeElem = tableElem.data("node");
        if (nodeElem != null) {
            var nodeJSON = nodeElem.data("json");
            if (nodeJSON != null && nodeJSON.columnDimension != null && nodeJSON.columnDimension.dimensionGroups != null) {
                // Go through each column and see if it matches on in columnsNotExistingButWillBeFiltered
                // If so - set it to display = true
                Machinata.Util.each(nodeJSON.columnDimension.dimensionGroups, function (index, dimensionGroup) {
                    Machinata.Util.each(dimensionGroup.dimensionElements, function (index, dimensionElement) {
                        Machinata.Util.each(columnsNotExistingButWillBeFiltered, function (index, columnNotExistingButWillBeFiltered) {
                            if (columnNotExistingButWillBeFiltered == dimensionElement.id) {
                                dimensionElement.display = true; // force display
                                return false; // break each
                            }
                        });
                    });
                });
                // Alter the node json column dimensions to make sure they are shown
                nodeElem.trigger(Machinata.Reporting.Events.REBUILD_TABLE_SIGNAL);
                tableElem = nodeElem.data("table"); // get handle on new table
            } else {
                console.warn("Machinata.Reporting.Tools.drilldownOnTable(): some columns for the filter do not exist: " + JSON.stringify(columnsNotExistingButWillBeFiltered) + " (could not get node json for the table node)");
            }
        } else {
            console.warn("Machinata.Reporting.Tools.drilldownOnTable(): some columns for the filter do not exist: " + JSON.stringify(columnsNotExistingButWillBeFiltered) + " (could not get a node for the table)");

        }
    }

    // Apply filter
    var filters = drilldownJSON.filters;
    if (filters == null || filters.length == 0) {
        Machinata.Filter.Tables.resetFilters(tableElem);
    } else {
        Machinata.Filter.Tables.setFilters(tableElem, filters);
    }
    
    // Show
    tableElem.show();

};

/// <summary>
/// Scrolls to a html element, automatically taking into account the header
/// </summary>
Machinata.Reporting.Tools.drilldownOnElement = function (instance,linkJSON) {
    var targetElement = null;
    if (linkJSON.elementId != null) targetElement = $("#" + linkJSON.elementId);

    if (linkJSON.drilldown != null) {
        Machinata.Reporting.Tools.drilldownOnTable(targetElement, linkJSON.drilldown);
    }

    Machinata.Reporting.Tools.scrollTo(instance, targetElement, 1200);
};

/// <summary>
/// Scrolls to a node element, automatically taking into account the header
/// </summary>
Machinata.Reporting.Tools.drilldownOnNode = function (instance,linkJSON) {

    var targetNodeElem = null;
    if (linkJSON.nodeId != null) targetNodeElem = $("#" + linkJSON.nodeId);

    if (targetNodeElem.length == 0) {
        // Node is not on page, get its link
        //console.log(linkJSON);
        //console.log(instance.idToNodeJSONLookupTable);
        var nodeJSON = Machinata.Reporting.Node.getJSONByID(instance,linkJSON.nodeId);
        if (nodeJSON == null) {
            console.warn("Machinata.Reporting.Tools.drilldownOnNode: could not find a matching node (" + linkJSON.nodeId+") for this report!");
            return;
        }
        // Is this node actually a chapter?
        if (nodeJSON.chapter == true) {
            // Just change chapter - node is a chapter
            Machinata.Reporting.Tools.changeChapter(instance,linkJSON.nodeId);
        } else {
            // Node is not on page and not a chapter - we need to switch to the chapter and then focus...
            Machinata.Reporting.Tools.changeChapterAndFocusOnNode(instance, nodeJSON.chapterId, linkJSON.nodeId);
        }
    } else {
        // Node is on page, just scroll to it...
        if (linkJSON.drilldown != null) {
            var tableElem = targetNodeElem.find("table");
            if (tableElem.length == 1) {
                // Drilldown
                Machinata.Reporting.Tools.drilldownOnTable(tableElem, linkJSON.drilldown);
                // Show filters (if allowed)
                if (targetNodeElem.hasClass("option-allow-row-filtering")) {
                    Machinata.Reporting.Node.VerticalTableNode.showTableFilters(instance, targetNodeElem);
                }
            }
        }
        Machinata.Reporting.Tools.scrollTo(instance, targetNodeElem, 1200);
    }
};



/// <summary>
/// Opens the print composer built-in UI.
/// </summary>
Machinata.Reporting.Tools.openPrintComposer = function (instance) {
    Machinata.Reporting.PrintComposer.UI.open(instance);
}


/// <summary>
/// Opens the browser print dialog
/// </summary>
Machinata.Reporting.Tools.openBrowserPrintDialog = function (instance) {
    window.print();
}

/// <summary>
/// 
/// </summary>
/// <deprecated/>
Machinata.Reporting.Tools.openPrintPage = function (instance, nodeInfosOrChapter) {
    throw "Machinata.Reporting.Tools.openPrintPage is deprecated!";
}

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.openPrintPageForSection = function (instance,nodeInfos) {
    var screenNumber = nodeInfos.nodeScreen;
    var printURL = instance.config.url;
    printURL = Machinata.updateQueryString("screen", screenNumber, printURL);
    printURL = Machinata.updateQueryString("profile", "webprint", printURL);
    printURL = Machinata.updateQueryString("chapter", "*", printURL);
    printURL = Machinata.updateQueryString("print-dialog", "true", printURL);
    Machinata.openPage(printURL);
};

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.openPrintPageForChapter = function (instance, chapter) {
    var printURL = instance.config.url;
    printURL = Machinata.updateQueryString("screen", "", printURL);
    printURL = Machinata.updateQueryString("profile", "webprint", printURL);
    printURL = Machinata.updateQueryString("chapter", chapter, printURL);
    printURL = Machinata.updateQueryString("print-dialog", "true", printURL);
    Machinata.openPage(printURL);
};

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.openPrintPageForReport = function (instance, reportId) {
    var printURL = instance.config.url;
    printURL = Machinata.updateQueryString("screen", "", printURL);
    printURL = Machinata.updateQueryString("profile", "webprint", printURL);
    printURL = Machinata.updateQueryString("chapter", "*", printURL);
    printURL = Machinata.updateQueryString("print-dialog", "true", printURL);
    Machinata.openPage(printURL);
};


/// <summary>
/// For the given report, shows a menu of various printing options.
/// Typically such options include the following:
///  - Print entire report
///  - Print current chapter
///  - View print composer
/// </summary>
Machinata.Reporting.Tools.printReport = function (instance) {
    
    var opts = {};
    if (Machinata.Reporting.Handler.openPrintPageForReport != null) {
        opts["printreport"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-report");
    }
    if (Machinata.Reporting.Handler.openPrintPageForChapter != null && instance.chapters != null && instance.chapters.length > 1 && instance.config.automaticallyFoldChaptersIntoPages == true) {
        opts["printchapter"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-chapter");
    }
    if (Machinata.Reporting.Handler.openPrintComposer != null && Machinata.Reporting.PrintComposer.hasData(instance) == true) {
        opts["viewcomposer"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-view-composer");
    }
    if (Object.keys(opts).length == 0) console.warn("Machinata.Reporting.Tools.printReport: no handlers have been registered for printing. See Machinata.Reporting.Handler.printReport for more information.");
    Machinata.optionsDialog(Machinata.Reporting.Text.translate(instance, "reporting.printing.print-report.title"), Machinata.Reporting.Text.translate(instance, "reporting.printing.print-report.message"), opts)
        .okay(function (id, val) {
            if (id == "printchapter") {
                Machinata.Reporting.Handler.openPrintPageForChapter(instance,instance.config.chapters[0]);
            } else if (id == "viewcomposer") {
                Machinata.Reporting.Handler.openPrintComposer(instance);
            } else  {
                Machinata.Reporting.Handler.openPrintPageForReport(instance, instance.reportData == null ? null : instance.reportData.reportId);
            }
        })
        .show();
};

/// <summary>
/// For the given node, shows a menu of various printing options.
/// Typically such options include the following:
///  - Print entire report
///  - Print current chapter
///  - Print this section
///  - Add to print composer
///  - View print composer
/// </summary>
Machinata.Reporting.Tools.printNode = function (instance, infosJSON, nodeJSON) {

    var opts = {};
    // Report
    if (Machinata.Reporting.Handler.openPrintPageForReport != null) {
        opts["printreport"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-report");
    }
    // Chapter
    if (Machinata.Reporting.Handler.openPrintPageForChapter != null && instance.chapters != null && instance.chapters.length > 1) {
        opts["printchapter"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-chapter");
    }
    // Section
    if (Machinata.Reporting.Handler.openPrintPageForSection != null) {
        opts["printsection"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-section");
    }
    // Add to composer
    if (Machinata.Reporting.Handler.openPrintComposer != null) {
        opts["addtocomposer"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-add-composer");
    }
    // View composer
    if (Machinata.Reporting.Handler.openPrintComposer != null && Machinata.Reporting.PrintComposer.hasData(instance) == true) {
        opts["viewcomposer"] = Machinata.Reporting.Text.translate(instance, "reporting.printing.option-view-composer");
    }
    if (Object.keys(opts).length == 0) console.warn("Machinata.Reporting.Tools.printReport: no handlers have been registered for printing. See Machinata.Reporting.Handler.printNode for more information.");
    // Show dialog with all options
    Machinata.optionsDialog(Machinata.Reporting.Text.translate(instance, "reporting.printing.print-node.title"), Machinata.Reporting.Text.translate(instance, "reporting.printing.print.node.message"), opts)
        .okay(function (id, val) {
            if (id == "addtocomposer") {
                Machinata.Reporting.PrintComposer.addScreen(instance, infosJSON);
            } else if (id == "printsection") {
                Machinata.Reporting.Handler.openPrintPageForSection(instance, infosJSON);
            } else if (id == "printchapter") {
                Machinata.Reporting.Handler.openPrintPageForChapter(instance,nodeJSON.chapterId);
            } else if (id == "viewcomposer") {
                Machinata.Reporting.Handler.openPrintComposer(instance);
            } else {
                Machinata.Reporting.Handler.openPrintPageForReport(instance, instance.reportData == null ? null : instance.reportData.reportId);
            }
        })
        .show();
};


/// <summary>
/// </summary>
Machinata.Reporting.Tools.copyElementToClipboard = function (tempElem, title, message, useTemporaryDom) {
    if (useTemporaryDom == true) {
        Machinata.UI.copyElementToClipboardInTemporaryDOM(tempElem);
    } else {
        Machinata.UI.copyElementToClipboard(tempElem);
    }
    setTimeout(function () {
        Machinata.messageDialog(title, message).show();
    }, 100);
};


/// <summary>
/// </summary>
Machinata.Reporting.Tools.generateThemeCode = function (config, type) {
    var shades = config.themeColorShadeNames;
    var ret = "";
    ret += "// Machinata.Reporting.Tools.generateThemeCode(\"" + type + "\")\n";
    ret += "//   type: " + type + "\n";

    Machinata.Util.each(Machinata.Reporting._themes, function (key, val) {
        ret += "\n";
        for (var i = 0; i < shades.length; i++) {
            var shade = shades[i];
            var color = val[i];
            var textColor = null;
            var textOnTheme = Machinata.Reporting._themes["text-on-" + key];
            if (textOnTheme != null) textColor = textOnTheme[i];
            if (color == null) continue;
            ret += "/* Theme: " + key + ", Shade: " + shade + " */\n";
            ret += ".machinata-reporting-themable.theme-" + key + " .theme-fill-" + shade + " { fill: " + color + "; }  \n";
            ret += ".machinata-reporting-themable.theme-" + key + " .theme-stroke-" + shade + " { stroke: " + color + "; }  \n";
            ret += ".machinata-reporting-themable.theme-" + key + " .theme-bg-" + shade + " { background-color: " + color + "; }  \n";
            ret += ".machinata-reporting-themable.theme-" + key + " .theme-color-" + shade + " { color: " + color + "; }  \n";
            if (textColor != null) ret += ".machinata-reporting-themable.theme-" + key + " .theme-text-" + shade + " { color: " + textColor + "; }  \n";

        }
    });
    return ret;
};

/// <summary>
/// </summary>
Machinata.Reporting.Tools.lineBreakString = function (text, opts) {
    // Init
    if (opts == null) opts = {};
    if (opts.appendEllipsisOnLastLine == null) opts.appendEllipsisOnLastLine = true;
    if (opts.wordSeparator == null) opts.wordSeparator = " ";
    if (opts.lineSeparator == null) opts.lineSeparator = "\n";
    if (opts.ellipsis == null) opts.ellipsis = Machinata.Reporting.Config.textTruncationEllipsis;
    if (opts.returnArray == null) opts.returnArray = false;
    var words = text.split(opts.wordSeparator);
    var lines = [];
    var currentLine = null;
    // Sanity
    if (text == null) return null;
    if (text == "") return "";
    for (var w = 0; w < words.length; w++) {
        // Init
        var word = words[w];
        var newCurrentLine = null;
        // Create a new line
        if (currentLine == null) newCurrentLine = word;
        else newCurrentLine = currentLine + opts.wordSeparator + word;
        //alert("newCurrentLine: " + newCurrentLine);
        if (newCurrentLine.length > opts.maxCharsPerLine) {
            // Push current
            //alert("pushing: " + currentLine);
            if (currentLine != null) lines.push(currentLine);
            // New line with current word
            currentLine = word;
        } else {
            // Accept, continue...
            currentLine = newCurrentLine;
        }
    }
    // Push final line
    //alert("pushing: " + currentLine);
    lines.push(currentLine);
    // Rebuild
    var ret = null;
    for (var l = 0; l < lines.length; l++) {
        // Init
        var line = lines[l];
        // Validate
        if (opts.maxLines != null && l >= (opts.maxLines)) {
            if (opts.returnArray == true) {
                if (opts.appendEllipsisOnLastLine == true) {
                    ret[ret.length - 1] = ret[ret.length - 1] + opts.ellipsis;
                } else {
                    ret.push(opts.ellipsis);
                }
            } else {
                if (opts.appendEllipsisOnLastLine == true) {
                    ret = ret + opts.ellipsis;
                } else {
                    ret = ret + opts.lineSeparator + opts.ellipsis;
                }
            }
            break;
        }
        // Append
        if (opts.returnArray == true) {
            if (ret == null) ret = [];
            ret.push(line);
        } else {
            if (ret == null) ret = line;
            else ret = ret + opts.lineSeparator + line;
        }
        
    }
    return ret;
};


/// <summary>
/// Creates a title using the givens string with variables, using the avaiable data.
/// You can use the following variables:
/// - ```{mandate.id}```
/// - ```{mandate.title}```
/// - ```{report.id}```
/// - ```{report.title}```
/// - ```{report.subtitle}```
/// - ```{report.name}```
/// - ```{report.date-raw}```
/// - ```{report.date-resolved}```
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Tools.createTitleString(instance, config, "ACME AG Report {report.portfolio-id} {report.date-raw} {report.title}");
/// ```
/// </example>
Machinata.Reporting.Tools.createTitleString = function (instance, config, text) {
    // Grab template variables from various sources
    if (instance.catalogCurrentMandate != null) {
        text = text.replaceAll("{mandate.id}", instance.catalogCurrentMandate.id);
        text = text.replaceAll("{mandate.title}", instance.catalogCurrentMandate.title);
    }
    if (instance.catalogCurrentReport != null) {
        text = text.replaceAll("{report.id}", instance.catalogCurrentReport.id);
        text = text.replaceAll("{report.date-raw}", instance.catalogCurrentReport.dateRaw);
        text = text.replaceAll("{report.date-resolved}", instance.catalogCurrentReport.dateResolved);
        if (instance.catalogCurrentReport.parameters !=  null) text = text.replaceAll("{report.portfolio-id}", instance.catalogCurrentReport.parameters.portfolioId);
    }
    text = text.replaceAll("{report.title}", config.reportTitle);
    text = text.replaceAll("{report.subtitle}", config.reportSubtitle);
    text = text.replaceAll("{report.name}", config.reportName);
    // Cleanup
    text = text.replaceAll("{mandate.id}", "");
    text = text.replaceAll("{mandate.title}", "");
    text = text.replaceAll("{report.id}", "");
    text = text.replaceAll("{report.title}", "");
    text = text.replaceAll("{report.subtitle}", "");
    text = text.replaceAll("{report.name}", "");
    text = text.replaceAll("{report.date-resolved}", "");
    text = text.replaceAll("{report.date-raw}", "");
    text = text.replaceAll("{report.portfolio-id}", "");
    //TODO: trim out missing variables separators...
    text = text.replace(/  +/g, ' ');
    text = text.replace(/ - - +/g, ' ');
    return text;
};

/// <summary>
/// </summary>
Machinata.Reporting.Tools.measureStringApproximately = function (config, text, fontSize, fontName) {
    // Init
    if (text == null) return 0;
    if (fontSize == null) fontSize = config.textSize; // fallback


    var approxLen = text.length * fontSize * config.fontSizeToCharacterWidthRatio;
    return approxLen;
};

/// <summary>
/// </summary>
Machinata.Reporting.Tools.bindTableUI = function (instance,elements) {
    // Table filters/sorting
    elements.filter(".machinata-reporting-table.option-sort").each(function () {
        Machinata.Reporting.Tools.makeTableSortable(instance, tableElem);
    });
    elements.filter(".machinata-reporting-table.option-filter").each(function () {
        var tableElem = $(this);
        Machinata.Reporting.Tools.makeTableFilterable(instance, tableElem);
    });

    // Sticky table headers
    elements.filter(".machinata-reporting-table.option-auto-sticky").each(function () {
        var tableElem = $(this);
        if (tableElem.find(".table-row").length > 5) {
            tableElem.stickyTableHeaders({
                cacheHeaderHeight: true,
                fixedOffset: $('#header')
            });
            tableElem.on("enabledStickiness.stickyTableHeaders", function () {
                $(this).addClass("header-is-sticky");
            });
            tableElem.on("disabledStickiness.stickyTableHeaders", function () {
                $(this).removeClass("header-is-sticky");
            });
        }
    });

    // Jump to top
    elements.find(".table-header .icon-arrow.up").click(function () {
        var tableElem = $(this).closest(".ui-table");
        Machinata.UI.scrollTo(tableElem, 600, { offset: -60 });
    });

    // Clickable rows
    elements.find("tr.option-link").click(function () {
        var url = $(this).attr("href");
        if (url == null || url == "") return;
        Machinata.goToPage(url);
    });
};

/// <summary>
/// Binds a custom tooltips handler to the given elements (a JQuery selector).
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Tools.bindTooltipsUI(instance, $("body"))
/// ```
/// </example>
Machinata.Reporting.Tools.bindTooltipsUI = function (instance, elements) {
    elements.tooltip({
        classes: {
            "ui-tooltip": "machinata-reporting-tooltip"
        },
        track: true,
        show: {
            delay: 0,
            effect: "none"
        },
        hide: {
            delay: 0,
            effect: "none"
        },
        position: {
            my: "center bottom-40",
            at: "center top",
            using: function (position, feedback) {
                $(this).css(position);
                $("<div>").addClass("arrow").addClass(feedback.vertical).appendTo(this);
            }
        },
        open: function (e, ui) {
            if (document.fullscreenElement) {
                ui.tooltip.appendTo($(document.fullscreenElement));
            }
        }
    });
};



/// <summary>
/// </summary>
Machinata.Reporting.Tools.askAQuestionViaEmail = function (instance, infosJSON, nodeJSON) {
    var toEmail = instance.config.askAQuestionViaEmailDefaultEmail;
    var toName = instance.config.askAQuestionViaEmailDefaultName;
    var subject = instance.config.askAQuestionViaEmailDefaultSubject;
    var body = instance.config.askAQuestionViaEmailDefaultBody;
    function replaceVariables(str) {
        str = str.replace("{report.title}", infosJSON.reportTitle);
        str = str.replace("{report.subtitle}", infosJSON.reportSubtitle);
        str = str.replace("{report.url}", infosJSON.reportURL);
        str = str.replace("{node.title}", infosJSON.nodeTitle);
        str = str.replace("{node.subtitle}", infosJSON.nodeSubtitle);
        str = str.replace("{node.url}", infosJSON.nodeURL);
        str = str.replace("{to.email}", toEmail);
        str = str.replace("{to.name}", toName);
        return str;
    }
    subject = replaceVariables(subject);
    body = replaceVariables(body);
    window.open("mailto:" + toEmail + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body));
};



/// <summary>
/// </summary>
Machinata.Reporting.Tools.shareNodeByCopyingLink = function (instance, infosJSON, nodeJSON) {
    
    var diag = Machinata.messageDialog(Machinata.Reporting.Text.translate(instance, "reporting.nodes.share"), Machinata.Reporting.Text.translate(instance, "reporting.nodes.share.description"));
    diag.elem.append($("<p class='node-link' style='font-size:0.8em;word-break:break-all;'></p>").text(infosJSON.nodeURL));
    diag.button(Machinata.Reporting.Text.translate(instance, "reporting.nodes.share.copy"), "copy", function () {
        Machinata.Reporting.Tools.copyElementToClipboard(diag.elem.find(".node-link"), Machinata.Reporting.Text.translate(instance, 'reporting.nodes.share.copied'), Machinata.Reporting.Text.translate(instance, 'reporting.nodes.share.copied.text'));
        diag.close();
    },false,false);
    diag.okayButton();
    diag.show();

};


/// <summary>
/// </summary>
Machinata.Reporting.Tools.stringifyReportJSONWithoutCircularReferences = function (json) {
    var seen = new WeakSet();
    function getCircularReplacer(key, value) {
        if (key == "dataSource") return;
        if (key == "initConfig") return;
        if (key == "parent") return;
        if (key == "_domElem") return;
        if (key == "_state") return;
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    }
    return JSON.stringify(json, getCircularReplacer, 2);
};


/// <summary>
/// </summary>
Machinata.Reporting.Tools.getCalibrationJSONForFont = function (config, font) {

    // Relevant string measurement code in Vega:
    // https://github.com/vega/vega/blob/master/packages/vega-scenegraph/src/util/canvas/context.js
    // https://github.com/vega/vega/blob/master/packages/vega-canvas/index.js
    // https://github.com/vega/vega/tree/master/packages/vega-scenegraph/src/util
    // https://github.com/vega/vega/blob/master/packages/vega-scenegraph/src/util/text.js#L133
    // See also
    // https://github.com/vega/vega/issues/2396

    console.log("Machinata.Reporting.Tools.getCalibrationJSONForFont:");

    var fontString = "9px " + font;
    var measureString = "abcdefghijklmnopqstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    //measureString = "14,000,000";
    console.log("  "+"fontString: "+fontString);
    console.log("  " + "measureString: " + measureString);

    try {

        var canvas = Machinata.Imaging.createDrawingCanvas(1, 1);

        
        console.log(canvas);
        var context = canvas.getContext('2d');
        console.log(context);
        context.font = fontString;
        var measure = context.measureText(measureString);
        console.log("  " + "measured dims are:", measure);




    } catch (error) {
        console.error(error);
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.showInfoDialog = function (instance, config, infoJSON) {
    var title = Machinata.Reporting.Text.resolve(instance, infoJSON.title);
    var text = Machinata.Reporting.Text.resolve(instance, infoJSON.text);
    Machinata.messageDialog(title, text).show();
};


/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.openNodeInStudio = function (instance, config, nodeJSON) {
    var diag = Machinata.fullwindowDialog("Node Studio", []);
    diag.button("Close", "close", null, true);
    diag.show();
    Machinata.Reporting.Studio.initForNode(diag.elem.find(".dialog-contents"), nodeJSON);
};


/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.debugMenuForNode = function (instance, config, nodeJSON, nodeElem) {
    var opts = {
        "studio": "Open in studio",
        "view-json": "View Runtime JSON",
        "download-json": "Download Runtime JSON",
        "view-infos": "View Infos JSON",
        "download-infos": "Download Infos JSON",
    };
    var diag = Machinata.optionsDialog(Machinata.Reporting.Text.translate(instance, "reporting.nodes.debug"), Machinata.Reporting.Text.translate(instance, "reporting.nodes.debug.options"), opts);
    diag.okay(function (opt) {
        // Get implementation
        var impl = Machinata.Reporting.Node[nodeJSON.nodeType];
        var JSON_VIEW_ELEM_SOURCE = "<div style='font-size:0.8em; overflow-y:auto; max-height:600px; font-family:monospace; white-space:pre;'/>";
        if (opt == "studio") {
            Machinata.Reporting.Tools.openNodeInStudio(instance, config, nodeJSON);
        }
        if (opt == "view-infos") {
            var infos = Machinata.Reporting.Node.compileNodeInfos(instance, config, nodeJSON);
            var data = Machinata.Reporting.Tools.stringifyReportJSONWithoutCircularReferences(infos);
            console.log(data);
            var viewDiag = Machinata.messageDialog("Infos JSON", "");
            viewDiag.elem.find("p").append($(JSON_VIEW_ELEM_SOURCE).text(data));
            viewDiag.show();
        }
        if (opt == "download-infos") {
            var infos = Machinata.Reporting.Node.compileNodeInfos(instance, config, nodeJSON);
            var data = Machinata.Reporting.Tools.stringifyReportJSONWithoutCircularReferences(infos);
            console.log(data);
            Machinata.Data.exportDataAsBlob(btoa(data), "text/json", nodeJSON.id + ".infos.json");
        }
        if (opt == "view-json") {
            var data = Machinata.Reporting.Tools.stringifyReportJSONWithoutCircularReferences(nodeJSON);
            console.log(data);
            var viewDiag = Machinata.messageDialog("Runtime JSON", "");
            viewDiag.elem.find("p").append($(JSON_VIEW_ELEM_SOURCE).text(data));
            viewDiag.show();
        }
        if (opt == "download-json") {
            var data = Machinata.Reporting.Tools.stringifyReportJSONWithoutCircularReferences(nodeJSON);
            Machinata.Data.exportDataAsBlob(btoa(data), "text/json", nodeJSON.id+".runtime.json");
        }
    });
    diag.show();
};



/// <summary>
/// 
/// </summary>
Machinata.Reporting.Tools.applyMachinataBundleThemeToDefaultConfiguration = function (themeJSON) {

    // Web / default (from theme)
    Machinata.Reporting.Config.assetsPath = themeJSON["assets-path"];
    Machinata.Reporting.Config.iconsBundle = themeJSON["icons-bundle"];

    Machinata.Reporting.Config.padding = themeJSON["padding"];

    Machinata.Reporting.Config.lineSize = themeJSON["line-size"];
    Machinata.Reporting.Config.graphLineSize = themeJSON["graph-line-size"];
    Machinata.Reporting.Config.graphSymbolSize = themeJSON["graph-symbol-size"];
    Machinata.Reporting.Config.domainLineSize = themeJSON["domain-line-size"];
    Machinata.Reporting.Config.verticalBarMaxSize = themeJSON["vertical-bar-max-size"];
    Machinata.Reporting.Config.horizontalBarMaxSize = themeJSON["horizontal-bar-max-size"];
    Machinata.Reporting.Config.textTruncationEllipsis = themeJSON["text-truncation-ellipsis"];

    Machinata.Reporting.Config.textFont = themeJSON["text-font"];
    Machinata.Reporting.Config.labelFont = themeJSON["label-font"];
    Machinata.Reporting.Config.axisFont = themeJSON["axis-font"];
    Machinata.Reporting.Config.headlineFont = themeJSON["headline-font"];
    Machinata.Reporting.Config.legendFont = themeJSON["legend-font"];
    Machinata.Reporting.Config.subtitleFont = themeJSON["subtitle-font"];
    Machinata.Reporting.Config.numberFont = themeJSON["number-font"];

    Machinata.Reporting.Config.textSize = themeJSON["text-size"];
    Machinata.Reporting.Config.subtitleSize = themeJSON["subtitle-size"];
    Machinata.Reporting.Config.chartTextSize = themeJSON["chart-text-size"];
    Machinata.Reporting.Config.labelSize = themeJSON["label-size"];
    Machinata.Reporting.Config.axisSize = themeJSON["axis-size"];
    Machinata.Reporting.Config.titleSize = themeJSON["h1-size"]; // same as h1
    Machinata.Reporting.Config.h1Size = themeJSON["h1-size"];
    Machinata.Reporting.Config.h2Size = themeJSON["h2-size"];
    Machinata.Reporting.Config.h3Size = themeJSON["h3-size"];
    Machinata.Reporting.Config.h4Size = themeJSON["h4-size"];

    Machinata.Reporting.Config.legendSize = themeJSON["legend-size"];
    Machinata.Reporting.Config.legendPadding = themeJSON["legend-padding"];
    Machinata.Reporting.Config.legendSymbolSize = themeJSON["legend-symbol-size"];
    Machinata.Reporting.Config.legendSymbolStroke = themeJSON["legend-symbol-stroke"];
    Machinata.Reporting.Config.legendColumnPadding = themeJSON["legend-column-padding"];
    Machinata.Reporting.Config.legendRowPadding = themeJSON["legend-row-padding"];

    Machinata.Reporting.Config.gridColor = themeJSON["grid-color"];
    Machinata.Reporting.Config.solidColor = themeJSON["solid-color"];
    Machinata.Reporting.Config.darkColor = themeJSON["dark-color"];
    Machinata.Reporting.Config.pageColor = themeJSON["page-color"];
    Machinata.Reporting.Config.titleColor = themeJSON["title-color"];
    Machinata.Reporting.Config.highlightColor = themeJSON["highlight-color"];
    Machinata.Reporting.Config.domainLineColor = themeJSON["domain-line-color"];

    Machinata.Reporting.Config.mediumContentWidthSize = themeJSON["medium-content-width-size"];
    Machinata.Reporting.Config.fontSizeToCharacterWidthRatio = themeJSON["font-size-to-character-width-ratio"];

    Machinata.Reporting.Config.axisBottomShowTicks = themeJSON["axis-bottom-show-ticks"];
    Machinata.Reporting.Config.axisBottomTickSize = themeJSON["axis-bottom-tick-size"];

    Machinata.Reporting.Config.layoutMinWidth = themeJSON["reporting-layout-min-width"];
    Machinata.Reporting.Config.layoutMaxWidth = themeJSON["reporting-layout-max-width"];
    Machinata.Reporting.Config.nodeSizeMinWidthUncompressed = themeJSON["node-size-min-width-uncompressed"];

    Machinata.Reporting.Config.mobileTitleSizeFactor = themeJSON["mobile-title-size-factor"];
    Machinata.Reporting.Config.mobileSubtitleSizeFactor = themeJSON["mobile-subtitle-size-factor"];
    Machinata.Reporting.Config.mobileLabelSizeFactor = themeJSON["mobile-label-size-factor"];

    // Webprint profile
    Machinata.Reporting.Profiles.Configs["webprint"].layoutMinWidth = themeJSON["reporting-layout-min-width-webprint"];
    Machinata.Reporting.Profiles.Configs["webprint"].layoutMaxWidth = themeJSON["reporting-layout-max-width-webprint"];


    // Print profile (from theme)

    Machinata.Reporting.Profiles.Configs["print"].textFont = themeJSON["text-font-print"];
    Machinata.Reporting.Profiles.Configs["print"].labelFont = themeJSON["label-font-print"];
    Machinata.Reporting.Profiles.Configs["print"].axisFont = themeJSON["axis-font-print"];
    Machinata.Reporting.Profiles.Configs["print"].headlineFont = themeJSON["headline-font-print"];
    Machinata.Reporting.Profiles.Configs["print"].legendFont = themeJSON["legend-font-print"];
    Machinata.Reporting.Profiles.Configs["print"].subtitleFont = themeJSON["subtitle-font-print"];
    Machinata.Reporting.Profiles.Configs["print"].numberFont = themeJSON["number-font-print"];

    Machinata.Reporting.Profiles.Configs["print"].textSize = themeJSON["text-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].subtitleSize = themeJSON["subtitle-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].chartTextSize = themeJSON["chart-text-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].labelSize = themeJSON["label-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].axisSize = themeJSON["axis-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].titleSize = themeJSON["h1-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].h1Size = themeJSON["h1-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].h2Size = themeJSON["h2-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].h3Size = themeJSON["h3-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].h4Size = themeJSON["h4-size-print"];

    Machinata.Reporting.Profiles.Configs["print"].padding = themeJSON["padding-print"];
    Machinata.Reporting.Profiles.Configs["print"].fontSizeToCharacterWidthRatio = themeJSON["font-size-to-character-width-ratio-print"];
    Machinata.Reporting.Profiles.Configs["print"].lineSize = themeJSON["line-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].gridLineSize = themeJSON["grid-line-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].graphLineSize = themeJSON["graph-line-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].domainLineSize = themeJSON["domain-line-size-print"];
    

    Machinata.Reporting.Profiles.Configs["print"].axisLabelSeparation = themeJSON["padding-print"];
    Machinata.Reporting.Profiles.Configs["print"].axisLabelPadding = themeJSON["padding-print"] / 2;
    Machinata.Reporting.Profiles.Configs["print"].axisTargetTickCount = 6;
    Machinata.Reporting.Profiles.Configs["print"].verticalBarMaxSize = themeJSON["vertical-bar-max-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].horizontalBarMaxSize = themeJSON["horizontal-bar-max-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].graphSymbolSize = themeJSON["graph-symbol-size-print"];

    Machinata.Reporting.Profiles.Configs["print"].legendSize = themeJSON["legend-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].legendFont = themeJSON["legend-font-print"];
    Machinata.Reporting.Profiles.Configs["print"].legendPadding = themeJSON["legend-padding-print"];
    Machinata.Reporting.Profiles.Configs["print"].legendSymbolSize = themeJSON["legend-symbol-size-print"];
    Machinata.Reporting.Profiles.Configs["print"].legendSymbolStroke = themeJSON["legend-symbol-stroke-print"];
    Machinata.Reporting.Profiles.Configs["print"].legendColumnPadding = themeJSON["legend-column-padding-print"];
    Machinata.Reporting.Profiles.Configs["print"].legendRowPadding = themeJSON["legend-row-padding-print"];

    Machinata.Reporting.Profiles.Configs["print"].gridColor = themeJSON["grid-color-print"];
    Machinata.Reporting.Profiles.Configs["print"].solidColor = themeJSON["solid-color-print"];
    Machinata.Reporting.Profiles.Configs["print"].darkColor = themeJSON["dark-color-print"];
    Machinata.Reporting.Profiles.Configs["print"].pageColor = themeJSON["page-color-print"];
    Machinata.Reporting.Profiles.Configs["print"].titleColor = themeJSON["title-color-print"];
    Machinata.Reporting.Profiles.Configs["print"].highlightColor = themeJSON["highlight-color-print"];
    Machinata.Reporting.Profiles.Configs["print"].domainLineColor = themeJSON["domain-line-color-print"];

    Machinata.Reporting.Profiles.Configs["print"].axisBottomShowTicks = themeJSON["axis-bottom-show-ticks-print"];
    Machinata.Reporting.Profiles.Configs["print"].axisBottomTickSize = themeJSON["axis-bottom-tick-size-print"];

    // Print (generic customizations)
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["LineColumnNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["LineColumnNode"].barMaxSize = themeJSON["vertical-bar-max-size-print"];
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["ScatterPlotNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["ScatterPlotNode"]["scatterPlotSymbolSize"] = themeJSON["graph-symbol-size-print"];
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["CoreSatelliteNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["CoreSatelliteNode"].planetLabelLimitLines = 4;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["CoreSatelliteNode"].planetLabelLimitChars = 8;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["CoreSatelliteNode"].planetLabelAddSpaceBeforeValue = false;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["CoreSatelliteNode"].satelliteLabelLimitLines = 3;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["CoreSatelliteNode"].satelliteLabelLimitChars = 20;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["DonutNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["DonutNode"]["sliceLabelsSize"] = themeJSON["legend-size-print"];
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["DonutNode"]["legendPositionPortrait"] = "bottom-left";
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["DonutNode"]["legendPositionLandscape"] = "left-top";
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["PieNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["PieNode"]["sliceLabelsSize"] = themeJSON["legend-size-print"];
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["PieNode"]["legendPositionPortrait"] = "bottom-left";
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["PieNode"]["legendPositionLandscape"] = "left-top";
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["GaugeNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["GaugeNode"]["statusArcLineSize"] = 3;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["MultiGaugeNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["MultiGaugeNode"]["statusArcLineSize"] = 3;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["VBarNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["VBarNode"].barMaxSize = themeJSON["vertical-bar-max-size-print"];
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["HBarNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["HBarNode"].barMaxSize = themeJSON["horizontal-bar-max-size-print"];
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["HBarNode"].fillChartSpace = false;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["HBarNode"].autoSnapXAxisTickCount = 3;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["SymboledVBarNode"] = {};
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["SymboledVBarNode"].barMaxSize = themeJSON["vertical-bar-max-size-print"] * 2;
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["SymboledVBarNode"].symbolFactSize = themeJSON["graph-symbol-size-print"];
    Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["OfflineMapNode"] = {};

    // Register default chart themes
    Machinata.Reporting.registerTheme('default', themeJSON["theme-colors-default"].split(",")); 
    Machinata.Reporting.registerTheme('text-on-default', themeJSON["theme-colors-text-on-default"].split(","));
    Machinata.Reporting.registerTheme('gray', themeJSON["theme-colors-gray"].split(","));
    Machinata.Reporting.registerTheme('text-on-gray', themeJSON["theme-colors-text-on-gray"].split(","));
    Machinata.Reporting.registerTheme('infographic', themeJSON["theme-colors-infographic"].split(","));
    Machinata.Reporting.registerTheme('text-on-infographic', themeJSON["theme-colors-text-on-infographic"].split(","));

}

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-studio.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-studio.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// A user interface for dynamically manipulating and exporting nodes.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Studio = {};


/// <summary>
/// </summary>
Machinata.Reporting.Studio.init = function (containerElem) {
    var instance = {
        elems: {
            ui: null,
            tools: null,
            toolsMenubar: null,
            toolsCode: null,
            toolsSettings: null,
            toolsExport: null,
            preview: null,
            previewNode: null,
        },
        nodeReportingConfig: null,
        nodeReportingInstance: null,
        nodeJSON: null,
        nodeProfile: "web",
        nodeSize: "responsive",
        studioReportingInstance: null,
    };
    {
        // Create a reporting instance to work with
        instance.studioReportingInstance = Machinata.Reporting._createEmptyInstance();
        instance.studioReportingInstance.config = Machinata.Reporting.mergeAndLoadConfigWithDefaults({}, "web");
    }
    instance.containerElem = containerElem;
    instance.elems.ui = $("<div class='machinata-reporting-studio'/>");

    // Initial config
    Machinata.Reporting.Studio.updateConfig(instance); //TODO

    // Build UI elems
    instance.elems.tools = $("<div class='tools'/>").appendTo(instance.elems.ui);
    instance.elems.toolsSettings = $("<div class='settings tool-panel'></div>").appendTo(instance.elems.tools);
    instance.elems.toolsCode = $("<div class='code tool-panel'><textarea></textarea></div>").appendTo(instance.elems.tools);
    instance.elems.toolsExport = $("<div class='export tool-panel'></div>").appendTo(instance.elems.tools);
    instance.elems.preview = $("<div class='preview'/>").appendTo(instance.elems.ui);
    instance.elems.previewSizer = $("<div class='sizer'/>").appendTo(instance.elems.preview);
    if (instance.containerElem != null) instance.containerElem.append(instance.elems.ui);

    // Build tools toggle menubar
    instance.elems.toolsMenubar = $("<div class='menubar machinata-reporting-menubar'><ul></ul></div>").appendTo(instance.elems.tools);
    instance.elems.toolsMenubar.addClass("option-hard");
    instance.elems.toolsMenubar.addClass("option-wide");
    instance.elems.toolsMenubar.find("ul").append($("<li class='action-settings'><a>" + "Settings"+"</a></li>"));
    instance.elems.toolsMenubar.find("ul").append($("<li class='action-code'><a>" + "Code"+"</a></li>"));
    instance.elems.toolsMenubar.find("ul").append($("<li class='action-export'><a>" + "Export/Save"+"</a></li>"));

    // Build settings UI
    {
        // General
        var groupElem = $("<div class='group'/>").appendTo(instance.elems.toolsSettings);
        groupElem.append($("<h4/>").text("General"));
        instance.elems.toolsSettingsToolbarCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Toolbar", false).appendTo(groupElem);
    }
    {
        // Chrome
        var groupElem = $("<div class='group'/>").appendTo(instance.elems.toolsSettings);
        groupElem.append($("<h4/>").text("Chrome"));
        instance.elems.toolsSettingsChromeLightCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Light", false, "radio", "chrome", "light").appendTo(groupElem);
        instance.elems.toolsSettingsChromeSolidCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Solid", false, "radio", "chrome", "solid").appendTo(groupElem);
        instance.elems.toolsSettingsChromeDarkCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Dark", false, "radio", "chrome", "dark").appendTo(groupElem);
    }
    {
        // Profile
        var groupElem = $("<div class='group'/>").appendTo(instance.elems.toolsSettings);
        groupElem.append($("<h4/>").text("Profile"));
        instance.elems.toolsSettingsProfileWebCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Web", false, "radio", "profile", "web").appendTo(groupElem);
        instance.elems.toolsSettingsProfilePrintCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Print", false, "radio", "profile", "print").appendTo(groupElem);
    }
    {
        // Theme
        var groupElem = $("<div class='group'/>").appendTo(instance.elems.toolsSettings);
        groupElem.append($("<h4/>").text("Theme"));
        Machinata.Util.each(Machinata.Reporting._themes, function (key, val) {
            if (Machinata.String.startsWith(key, "text-on-")) return; // continue
            Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, key, false, "radio", "theme", key).appendTo(groupElem);
        });
    }
    {
        // Size
        var groupElem = $("<div class='group size'/>").appendTo(instance.elems.toolsSettings);
        groupElem.append($("<h4/>").text("Size"));
        instance.elems.toolsSettingsSizeResponsiveCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Responsive", false, "radio", "size", "responsive").appendTo(groupElem);
        instance.elems.toolsSettingsSizeCustomCheckbox = Machinata.Reporting.buildCheckbox(instance.studioReportingInstance, "Custom", false, "radio", "size", "custom").appendTo(groupElem);
        var customSizeGroupElem = $("<div class='custom-size'/>").appendTo(groupElem);
        instance.elems.toolsSettingsSizeCustomWidthInput = $("<input type='number' value='400'/>").appendTo(customSizeGroupElem);
        $("<span class='x'>x</span>").appendTo(customSizeGroupElem);
        instance.elems.toolsSettingsSizeCustomHeightInput = $("<input type='number' value='300'/>").appendTo(customSizeGroupElem);
        $("<span class='units'>px</span>").appendTo(customSizeGroupElem);
    }

    // Export UI
    instance.elems.toolsExportJSONButton = $("<button class='ui-button'/>").text("Save JSON").appendTo(instance.elems.toolsExport);
    instance.elems.toolsExport.append("<div/>");
    instance.elems.toolsExportSVGButton = $("<button class='ui-button'/>").text("Save SVG").appendTo(instance.elems.toolsExport);
    instance.elems.toolsExport.append("<div/>");
    instance.elems.toolsExportPNGButton = $("<button class='ui-button'/>").text("Save PNG").appendTo(instance.elems.toolsExport);

    // Helper functions
    function showSettings() {
        // Sync to settings UI
        if (instance.nodeJSON != null) {
            instance.elems.toolsSettingsToolbarCheckbox.find("input").prop("checked", instance.nodeJSON.supportsToolbar == true);
            instance.elems.toolsSettingsChromeLightCheckbox.find("input").prop("checked", instance.nodeJSON.chrome == "light");
            instance.elems.toolsSettingsChromeSolidCheckbox.find("input").prop("checked", instance.nodeJSON.chrome == "solid");
            instance.elems.toolsSettingsChromeDarkCheckbox.find("input").prop("checked", instance.nodeJSON.chrome == "dark");
            instance.elems.toolsSettings.find("input[name='theme'][value='" + instance.nodeJSON.theme + "']").prop("checked", true);
        }
        instance.elems.toolsSettingsProfileWebCheckbox.find("input").prop("checked", instance.nodeProfile == "web");
        instance.elems.toolsSettingsProfilePrintCheckbox.find("input").prop("checked", instance.nodeProfile == "print");
        instance.elems.toolsSettingsSizeResponsiveCheckbox.find("input").prop("checked", instance.nodeSize == "responsive");
        instance.elems.toolsSettingsSizeCustomCheckbox.find("input").prop("checked", instance.nodeSize == "custom");
        
        // Update UI
        instance.elems.toolsSettings.show();
        instance.elems.toolsCode.hide();
        instance.elems.toolsExport.hide();
        instance.elems.toolsMenubar.find(".action-settings").addClass("selected");
        instance.elems.toolsMenubar.find(".action-code").removeClass("selected");
        instance.elems.toolsMenubar.find(".action-export").removeClass("selected");
    }
    function showCode() {
        // Sync code
        instance.elems.toolsCode.find("textarea").val(JSON.stringify(instance.nodeJSON, null, 2));

        // Update UI
        instance.elems.toolsSettings.hide();
        instance.elems.toolsCode.show();
        instance.elems.toolsExport.hide();
        instance.elems.toolsMenubar.find(".action-settings").removeClass("selected");
        instance.elems.toolsMenubar.find(".action-code").addClass("selected");
        instance.elems.toolsMenubar.find(".action-export").removeClass("selected");
    }
    function showExport() {
        // Update UI
        instance.elems.toolsSettings.hide();
        instance.elems.toolsCode.hide();
        instance.elems.toolsExport.show();
        instance.elems.toolsMenubar.find(".action-settings").removeClass("selected");
        instance.elems.toolsMenubar.find(".action-code").removeClass("selected");
        instance.elems.toolsMenubar.find(".action-export").addClass("selected");
    }
    function updatePreview() {
        Machinata.Reporting.Studio.updatePreview(instance);
    }
    function updateConfig() {
        Machinata.Reporting.Studio.updateConfig(instance);
    }

    // Bind events
    instance.elems.toolsExportJSONButton.click(function () {
        Machinata.Data.exportDataAsBlob(btoa(JSON.stringify(instance.nodeJSON, null, 2)), "text/json", instance.nodeJSON.id + ".studio.json");
    });
    instance.elems.toolsExportSVGButton.click(function () {
        var impl = Machinata.Reporting.Node[instance.nodeJSON.nodeType];
        if (impl != null && impl.exportFormat != null) {
            impl.exportFormat(instance.nodeReportingInstance, instance.nodeReportingConfig, instance.elems.previewNode.data("json"), instance.elems.previewNode, "svg", instance.nodeJSON.id + ".studio.svg");
        } else {
            alert("This node type doesn't support this export format!");
        }
    });
    instance.elems.toolsExportPNGButton.click(function () {
        var impl = Machinata.Reporting.Node[instance.nodeJSON.nodeType];
        if (impl != null && impl.exportFormat != null) {
            impl.exportFormat(instance.nodeReportingInstance, instance.nodeReportingConfig, instance.elems.previewNode.data("json"), instance.elems.previewNode, "png", instance.nodeJSON.id + ".studio.png");
        } else {
            alert("This node type doesn't support this export format!");
        }
    });
    instance.elems.toolsMenubar.find(".action-settings").click(function () {
        showSettings();
    });
    instance.elems.toolsMenubar.find(".action-code").click(function () {
        showCode();
    });
    instance.elems.toolsMenubar.find(".action-export").click(function () {
        showExport();
    });
    $(window).resize(function () {
        if (instance.elems.previewNode != null) {
            Machinata.Reporting.Containerless.redrawNode(instance.elems.previewNode);
        }
    });
    instance.elems.toolsSettingsToolbarCheckbox.find("input").on("change", function () {
        if (instance.nodeJSON != null) {
            instance.nodeJSON.supportsToolbar = $(this).prop("checked");
            updatePreview();
        }
    });
    instance.elems.toolsSettings.find("input[name='chrome']").on("change", function () {
        if (instance.nodeJSON != null) {
            instance.nodeJSON.chrome = $(this).val();
            updatePreview();
        }
    });
    instance.elems.toolsSettings.find("input[name='theme']").on("change", function () {
        if (instance.nodeJSON != null) {
            instance.nodeJSON.theme = $(this).val();
            updatePreview();
        }
    });
    instance.elems.toolsSettings.find("input[name='size']").on("change", function () {
        instance.nodeSize = $(this).val();
        updatePreview();
    });
    instance.elems.toolsSettingsSizeCustomWidthInput.on("change", function () {
        updatePreview();
    });
    instance.elems.toolsSettingsSizeCustomHeightInput.on("change", function () {
        updatePreview();
    });
    instance.elems.toolsSettings.find("input[name='profile']").on("change", function () {
        instance.nodeProfile = $(this).val();
        if (instance.nodeProfile == "print") {
            instance.elems.toolsSettings.find(".group.size .units").text("mm");
        } else {
            instance.elems.toolsSettings.find(".group.size .units").text("px");
        }
        updateConfig();
        updatePreview();
    });
    instance.elems.toolsCode.find("textarea").on("keyup", function () {
        if (instance.codeChangeTimeout != null) clearTimeout(instance.codeChangeTimeout);
        instance.codeChangeTimeout = setTimeout(function () {
            instance.codeChangeTimeout = null;

            // Load JSON
            var rawJSONText = instance.elems.toolsCode.find("textarea").val();
            var newJSON = null;
            try {
                newJSON = JSON.parse(rawJSONText);
            } catch (e) {
                instance.elems.toolsCode.attr("title",e);
            }
            if (newJSON != null) {
                instance.elems.toolsCode.removeClass("has-error");
                instance.elems.toolsCode.attr("title", null);
                instance.nodeJSON = newJSON;
                updatePreview();
            } else {
                instance.elems.toolsCode.addClass("has-error");
            }
        }, 500);
    });

    // Bind helper functions
    instance.showSettings = function () {
        showSettings();
    };

    // Initial state
    showSettings();

    return instance;
};


/// <summary>
/// </summary>
Machinata.Reporting.Studio.initForNode = function (containerElem, nodeJSON) {
    var instance = Machinata.Reporting.Studio.init(containerElem);
    Machinata.Reporting.Studio.setNodeJSON(instance, nodeJSON);
    instance.showSettings(); // needed for resync...
    return instance;
};


/// <summary>
/// </summary>
Machinata.Reporting.Studio.setNodeJSON = function (instance, nodeJSON) {
    var filteredNodeJSON = JSON.parse(Machinata.Reporting.Tools.stringifyReportJSONWithoutCircularReferences(nodeJSON));
    filteredNodeJSON.level = null;
    filteredNodeJSON.enabled = true;
    filteredNodeJSON.exclude = false;
    filteredNodeJSON.responsiveSize = null;

    instance.nodeJSON = filteredNodeJSON;

    
    Machinata.Reporting.Studio.updatePreview(instance);
};

/// <summary>
/// </summary>
Machinata.Reporting.Studio.updateConfig = function (instance) {
    var configJSON = {}; //TODO
    instance.nodeReportingConfig = Machinata.Reporting.Containerless.getContainerlessConfigForProfile(instance.nodeProfile, configJSON);
};

/// <summary>
/// </summary>
Machinata.Reporting.Studio.updatePreview = function (instance) {

    // Destroy old
    if (instance.elems.previewNode != null) {
        Machinata.Reporting.Containerless.cleanupNode(instance.elems.previewNode);
        instance.elems.previewNode = null;
    }

    // Update size
    if (instance.nodeSize == "responsive") {
        instance.elems.preview.css("overflow", "hidden");
        instance.elems.previewSizer.css("width", "100%");
        instance.elems.previewSizer.css("height", "100%");
    } else {
        var wpx = parseInt(instance.elems.toolsSettingsSizeCustomWidthInput.val());
        var hpx = parseInt(instance.elems.toolsSettingsSizeCustomHeightInput.val());
        if (instance.nodeProfile == "print") {
            // Convert mm to px
            wpx = Machinata.Reporting.Tools.convertMillimetersToPixels(instance.nodeReportingConfig, wpx);
            hpx = Machinata.Reporting.Tools.convertMillimetersToPixels(instance.nodeReportingConfig, hpx);
        }
        instance.elems.preview.css("overflow", "auto");
        instance.elems.previewSizer.css("width", wpx+"px");
        instance.elems.previewSizer.css("height", hpx + "px");
    }

    // Get JSON

    instance.elems.previewNode = Machinata.Reporting.Containerless.buildNode(instance.nodeReportingConfig, instance.nodeJSON, instance.elems.previewSizer);
    instance.nodeReportingInstance = instance.elems.previewNode.data("reporting-instance");
    Machinata.Reporting.Containerless.redrawNode(instance.elems.previewNode);

};


/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-headless.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-headless.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Collection of tools specifically designed for operating the Reporting module
/// in a headless mode, such as server-side on NodeJS.
/// 
/// ## Headless Example on NodeJS
/// ```
/// // We need some global includes, since the Machinata NodeJS bundles purposefully don't include these
/// global.vega = require('vega');
/// global.fs = require('fs');
/// 
/// // Include the Machinata libraries
/// // Make sure these libraries have been exported/built using the 'nodejs' profile
/// require("./lib/machinata-core-bundle-en-debug.js");
/// require("./lib/machinata-reporting-bundle-en-debug.js");
/// 
/// // Include the reporting configuration
/// require("./lib/machinata-YOUR_REPORTING_CONFIG-bundle-en-debug.js");
/// 
/// // Show our build
/// console.log("Machinata Build: ");
/// console.log(Machinata.buildInfo());
/// 
/// // Our node to test
/// var gaugeJSON = {
///     "nodeType": "GaugeNode",
///     "theme": "magenta",
///     "width": 800,
///     "height": 600,
///     "theme": "magenta",
///     "status": {
///         "value": 1.6,
///         "title": { "resolved": "Moderate" },
///         "tooltip": { "resolved": "1.6 / 5" }
///     },
///     "segments": [
///         {
///             "active": true,
///             "title": { "resolved": "Low" }
///         },
///         {
///             "active": true,
///             "title": { "resolved": "Moderate" }
///         },
///         {
///             "active": false,
///             "title": { "resolved": "Medium" }
///         },
///         {
///             "active": false,
///             "title": { "resolved": "Enhanced" }
///         },
///         {
///             "active": false,
///             "title": { "resolved": "High" }
///         }
///     ]
/// };
/// 
/// // Create profiled config for `print`.
/// // Using Machinata.Reporting.Headless.getHeadlessConfigForProfile
/// // Note: this only needs to be called once per report
/// const config = Machinata.Reporting.Headless.getHeadlessConfigForProfile("print");
/// 
/// // Show our config
/// console.log("Machinata.Reporting Config: ");
/// console.log(config);
/// 
/// TODO: Update when API is finalized...
/// ```
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Headless = {};


/// <summary>
/// If ```true``` is passed, verbose debug output is enabled.
/// </summary>
Machinata.Reporting.Headless.enableVerboseOutput = function (enabled) {
    Machinata.DebugEnabled = enabled;
};

Machinata.Reporting.Headless.VerboseErrorsEnabled = false;

/// <summary>
/// If ```true``` is passed, VERY verbose error logging is enabled.
/// </summary>
Machinata.Reporting.Headless.enableVerboseErrors = function (enabled) {
    Machinata.Reporting.Headless.VerboseErrorsEnabled = enabled;
};

/// <summary>
/// Returns a merged (and loaded) configuration according to the specified ```profile```, with the 
/// config setting ```headless``` set to ```true```.
/// Any custom configuration must be bassed at this point to ensure that it loaded and applied properly.
/// </summary>
Machinata.Reporting.Headless.getHeadlessConfigForProfile = function (profile, config) {
    // Init config, with headless=true
    if (config == null) {
        config = {};
    }
    config["headless"] = true;

    // Create merged default version
    Machinata.debug("Machinata.Reporting.Headless.getHeadlessConfigForProfile: "+profile);
    config = Machinata.Reporting.mergeAndLoadConfigWithDefaults(config, profile); // here we merge in all the configs, including the profile
    return config;
};

/// <summary>
/// Returns a full Vega spec for a ```VegaNode```, including the spec data integrated.
/// The returned Vega specs can be used to generate a chart using a VegaView.
/// Note: the Vega spec is unparsed.
/// Note: you can only call this method on node's that implement VegaNode.
/// </summary>
Machinata.Reporting.Headless.getVegaSpecForNode = function (config, nodeJSON, instance) {
    if (Machinata.DebugEnabled) {
        Machinata.debug("Machinata.Reporting.Headless.getVegaSpecForNode:");
        Machinata.debug("Raw node (node " + nodeJSON.id + "):");
        Machinata.debug(JSON.stringify(nodeJSON));
    }

    // Reset the state
    nodeJSON._state = {};

    // Get a merged version of the node
    Machinata.Reporting.Node.mergeJSONWithDefaults(config, nodeJSON);
    if (Machinata.DebugEnabled) {
        Machinata.debug("Merged node (node " + nodeJSON.id + "):");
        Machinata.debug(JSON.stringify(nodeJSON));
    }

    // Create an instance to work with
    if (instance == null) {
        instance = Machinata.Reporting._createEmptyInstance();
        instance.config = config;
    }

    // Get the node implementation and call the init
    var impl = Machinata.Reporting.Node[nodeJSON.nodeType];
    impl.init(instance, config, nodeJSON, null);
    //TODO: validate this is a vega node?

    if (Machinata.DebugEnabled) {
        Machinata.debug("Initialized node (node " + nodeJSON.id + "):");
        Machinata.debug(JSON.stringify(nodeJSON));
    }

    // Get spec
    var spec = null;
    try{
        spec = Machinata.Reporting.Node.VegaNode.compileVegaSpec(instance, config, nodeJSON);
    } catch (error) {
        if (Machinata.Reporting.Headless.VerboseErrorsEnabled == true) {
            console.error("Machinata.Reporting.Headless.getVegaSpecForNode: Could not compile node spec for node JSON:");
            console.error(JSON.stringify(nodeJSON));
        }
        throw error;
    }
    if (Machinata.DebugEnabled) {
        Machinata.debug("Spec (node " + nodeJSON.id + "):");
        Machinata.debug(JSON.stringify(spec));
    }
    return spec;
};



/// <summary>
/// Writes a VegaNode's SVG chart output to the filepath specified.
/// You can specify the width and height of the SVG through the node's 
/// ```width``` and ```height``` property (pixels).
/// This method returns the Vega View ```toSVG()``` promise.
/// Note: you can only call this method on node's that implement VegaNode.
/// </summary>
Machinata.Reporting.Headless.writeVegaNodeSVGToFile = function (config, nodeJSON, filepath) {
    // Get the svg generation promise
    var svgPromise = Machinata.Reporting.Headless.getVegaNodeSVGAsPromise(config, nodeJSON);

    // Generate a static SVG image (promise)
    return svgPromise.then(function (svgStr) {
        fs.writeFile(filepath, svgStr, function (err) {
            if (err) throw err;
        });
    });
};



/// <summary>
/// Returns a a VegaView (https://vega.github.io/vega/docs/api/view/) for a VegaNode's generated specs.
/// You can specify the width and height of the SVG through the node's 
/// ```width``` and ```height``` property (pixels).
/// Note: you can only call this method on node's that implement VegaNode.
/// </summary>
Machinata.Reporting.Headless.getVegaNodeView = function (config, nodeJSON, instance) {
    // Get spec
    var spec = Machinata.Reporting.Headless.getVegaSpecForNode(config, nodeJSON, instance);

    // Get output dimensions
    var widthPixels = nodeJSON["width"];
    if (isNaN(widthPixels)) throw "Machinata.Reporting.Headless.getVegaNodeView: node width (nodeJSON.width) is NaN";
    if (widthPixels == null) widthPixels = 600; // default fallback
    var heightPixels = nodeJSON["height"];
    if (isNaN(heightPixels)) throw "Machinata.Reporting.Headless.getVegaNodeView: node height (nodeJSON.height) is NaN";
    if (heightPixels == null) heightPixels = 600; // default fallback

    // Parse the spec...
    var parsedSpec = null;
    var parserOptions = {};
    if (config.cspCompliance == true) parserOptions.ast = true;
    try {
        parsedSpec = vega.parse(spec, null, parserOptions);
    } catch (error) {
        if (Machinata.Reporting.Headless.VerboseErrorsEnabled == true) {
            console.error("Machinata.Reporting.Headless.getVegaNodeSVGAsPromise: Could not parse node spec:");
            console.error(JSON.stringify(spec));
            console.error("For node JSON:");
            console.error(JSON.stringify(nodeJSON));
        }
        throw error;
    }
    Machinata.debug("Parsed spec (node " + nodeJSON.id + "):");
    Machinata.debug(JSON.stringify(spec));

    // Create view
    try {
        var vegaView = new vega.View(parsedSpec, {
            expr: config.cspCompliance == true ? vega.expressionInterpreter : null, // https://vega.github.io/vega/usage/interpreter/
            renderer: 'svg',
            container: null,
            responsive: false,
            hover: false,
        });
    } catch (error) {
        if (Machinata.Reporting.Headless.VerboseErrorsEnabled == true) {
            console.error("Machinata.Reporting.Headless.getVegaNodeSVGAsPromise: Could not create vega view with parsed spec:");
            console.error(JSON.stringify(parsedSpec));
            console.error("For node JSON:");
            console.error(JSON.stringify(nodeJSON));
        }
        throw error;
    }
    vegaView.width(widthPixels);
    vegaView.height(heightPixels);

    // Return
    return vegaView;
};

/// <summary>
/// Returns a promise for a Chart Node's SVG chart output.
/// You can specify the width and height of the SVG through the node's 
/// ```width``` and ```height``` property (pixels).
/// </summary>
Machinata.Reporting.Headless.getChartNodeSVGAsPromise = function (config, nodeJSON) {
    // Get SVG (promise)
    //TODO: Create new mechanism for detecting vega implementation and switch on this...
    var vegaView = Machinata.Reporting.Headless.getVegaNodeView(config, nodeJSON);
    return vegaView.toSVG();
};

/// <summary>
/// Goes through a report and renderes all nodes (which support headless rendering).
/// </summary>
/// <returns>
/// A array of JSON objects in the format: 
/// ```
/// {
///     nodeType: node type (string),
///     id: node id (string),
///     svgData: svg XML data (string)
/// }
/// ```
/// </returns>
Machinata.Reporting.Headless.getAllChartNodesSVGsForReportAsPromise = async function (config, reportJSON, nodeIdFilter) {
    var results = [];
    var rootNode = reportJSON["body"];

    // Create an instance to work with
    var instance = Machinata.Reporting._createEmptyInstance();
    instance.config = config;

    // Build report index
    Machinata.Reporting.buildIndex(instance, config, rootNode, null);

    // Helper function to visit all nodes recursively
    async function parseChildren(parentJSON) {
        // Sanity
        if (parentJSON == null || parentJSON.children == null) return;
        // Get a merged version of the node
        for (var i = 0; i < parentJSON.children.length; i++) {
            var childNodeJSON = parentJSON.children[i];
            Machinata.Reporting.Node.mergeJSONWithDefaults(config, childNodeJSON);
            if (childNodeJSON.supportsHeadlessRendering == true && (nodeIdFilter == null || nodeIdFilter == childNodeJSON.id)) {
                // Compute size if not explicitly set
                if (childNodeJSON.width == null || childNodeJSON.height == null) {
                    if (childNodeJSON.supportedDashboardSizes != null && childNodeJSON.supportedDashboardSizes.length > 0) {
                        var dashboardSize = childNodeJSON.supportedDashboardSizes[0];
                        var unitSizeMM = 42;
                        if (dashboardSize == Machinata.Reporting.Layouts.BLOCK_2x2) {
                            childNodeJSON.width = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 2));
                            childNodeJSON.height = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 2));
                        } else if (dashboardSize == Machinata.Reporting.Layouts.BLOCK_2x1) {
                            childNodeJSON.width = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 2));
                            childNodeJSON.height = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 1));
                        } else if (dashboardSize == Machinata.Reporting.Layouts.BLOCK_1x1) {
                            childNodeJSON.width = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 1));
                            childNodeJSON.height = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 1));
                        } else if (dashboardSize == Machinata.Reporting.Layouts.BLOCK_4x2) {
                            childNodeJSON.width = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 4));
                            childNodeJSON.height = Math.ceil(Machinata.Reporting.Tools.convertMillimetersToPixels(config, unitSizeMM * 2));
                        }
                    } 
                }
                // Fix node if some things are empty
                if (childNodeJSON.width == null) childNodeJSON.width = 600;
                if (childNodeJSON.height == null) childNodeJSON.height = 600;
                // Create view and get svg
                var vegaView = Machinata.Reporting.Headless.getVegaNodeView(config, childNodeJSON, instance);
                await vegaView.toSVG().then(function (svg) {
                    results.push({
                        nodeType: childNodeJSON.nodeType,
                        id: childNodeJSON.id,
                        svgData: svg,
                        mainTitleResolved: Machinata.Reporting.Text.resolve(instance,childNodeJSON.mainTitle),
                        subTitleResolved: Machinata.Reporting.Text.resolve(instance,childNodeJSON.subTitle)
                    });
                });

            }
            // Recurse
            await parseChildren(childNodeJSON);
        }
    }
    await parseChildren(rootNode);

    return results;
};

/// <summary>
/// Returns a promise for a Chart Node's Canvas chart output.
/// You can specify the width and height of the SVG through the node's 
/// ```width``` and ```height``` property (pixels).
/// </summary>
Machinata.Reporting.Headless.getChartNodeCanvasAsPromise = function (config, nodeJSON) {
    // Get PNG (promise)
    //TODO: Create new mechanism for detecting vega implementation and switch on this...
    var vegaView = Machinata.Reporting.Headless.getVegaNodeView(config, nodeJSON);
    return vegaView.toCanvas();
};


/// <summary>
/// </summary>
/// <deprecated/>
Machinata.Reporting.Headless.getVegaNodeSVGAsPromise = function (config, nodeJSON) {
    console.warn("***Machinata.Reporting.Headless.getVegaNodeSVGAsPromise is deprecated, please use Machinata.Reporting.Headless.getChartNodeSVGAsPromise instead!");
    throw "Machinata.Reporting.Headless.getVegaNodeSVGAsPromise is deprecated, please use Machinata.Reporting.Headless.getChartNodeSVGAsPromise instead!";
};


/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-containerless.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-containerless.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Collection of tools specifically designed for operating the Reporting module
/// in a Containerless mode, where individual nodes are rendered very specifically to parts of
/// a page without the context of a report, thus "containerless".
///
/// The containerless APIs are designed to render a node in the most fast and efficient way possible.
/// This means that a single configuration for all the containerless nodes can be generated once,
/// and then the all logically grouped containerless nodes can be built and rendered.
///
/// Containerless nodes always fill the space given by their parent DOM element (their container).
/// 
/// Note: The Containerless API does not use the reporting data layer.
/// 
/// ## Containerless Example
/// ```
/// // Our node to test
/// var nodeJSON = {
///     "nodeType": "GaugeNode",
///     "theme": "magenta",
///     "width": 800,
///     "height": 600,
///     "theme": "magenta",
///     "status": {
///         "value": 1.6,
///         "title": { "resolved": "Moderate" },
///         "tooltip": { "resolved": "1.6 / 5" }
///     },
///     "segments": [
///         {
///             "active": true,
///             "title": { "resolved": "Low" }
///         },
///         {
///             "active": true,
///             "title": { "resolved": "Moderate" }
///         },
///         {
///             "active": false,
///             "title": { "resolved": "Medium" }
///         },
///         {
///             "active": false,
///             "title": { "resolved": "Enhanced" }
///         },
///         {
///             "active": false,
///             "title": { "resolved": "High" }
///         }
///     ]
/// };
/// 
/// // Create a configuration to your needs
/// // Note: you should only create a single configuration for all logically grouped containerless nodes
/// var reportingConfig = {
///     "brandingConfiguration": "acme", // Set the correct branding id so that the full brand configuration will be loaded
///     "iconsBundle": "/static/bundle/svg/csam-reporting-icons-bundle.svg", // Must be relative to the page (best to be absolute path, like most static resources)
///     "dataProvider": "Memory",
///     "catalogSource": null, // Containerless doesn't use a data source, each node is provided separately...
///     "dataSource": null, // Containerless doesn't use a data source, each node is provided separately...
///     "language": "de"
/// };
/// reportingConfig = Machinata.Reporting.Containerless.getContainerlessConfigForProfile("web", reportingConfig);
/// 
/// // Containerless nodes can be injected anywhere, this is up to the integrator.
/// var containerElem = $("#my-node-container");
/// 
/// // Call the Containerless buildNode helper function to initialize the node and all its UI
/// // Note: this will not actually redraw the node, you have full control over when you want to
/// // draw the nodes
/// var nodeElem = Machinata.Reporting.Containerless.buildNode(reportingConfig, nodeJSON, containerElem);
/// 
/// // Initial draw
/// // Whenever you want the node to redraw itself, you can call this method:
/// Machinata.Reporting.Containerless.redrawNode(nodeElem);
/// 
/// // Responsiveness: bind redraw on the window resize dummy method
/// // Do this however your ReactJS resizing works...
/// $(window).resize(function () {
///     Machinata.Reporting.Containerless.redrawNode(nodeElem);
/// });
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Containerless = {};


/// <summary>
/// If ```true``` is passed, verbose debug output is enabled.
/// </summary>
Machinata.Reporting.Containerless.enableVerboseOutput = function (enabled) {
    Machinata.DebugEnabled = enabled;
};


/// <summary>
/// Returns a merged (and loaded) configuration according to the specified ```profile```, with the 
/// config setting ```Containerless``` set to ```true```.
/// Any custom configuration must be bassed at this point to ensure that it loaded and applied properly.
/// </summary>
Machinata.Reporting.Containerless.getContainerlessConfigForProfile = function (profile, config) {
    // Init config, with containerless=true
    if (profile == null) profile = "web";
    if (config == null) {
        config = {};
    }
    config["containerless"] = true;

    // Create merged default version
    Machinata.debug("Machinata.Reporting.Containerless.getContainerlessConfigForProfile: "+profile);
    config = Machinata.Reporting.mergeAndLoadConfigWithDefaults(config, profile); // here we merge in all the configs, including the profile
    return config;
};

/// <summary>
/// Builds a node using the given configuration and node JSON.
/// Note: The ```nodeJSON``` is automatically cloned, thus a direct handle to a node within a report can be given.
/// </summary>
/// <returns>nodeElem: a jQuery selector to the build node</returns>
Machinata.Reporting.Containerless.buildNode = function (config, nodeJSON, containerElem) {
    // Sanity
    if (config == null) throw new "Machinata.Reporting.Containerless.buildNode: config is null, it must be initialized via Machinata.Reporting.Containerless.getContainerlessConfigForProfile().";
    if (nodeJSON == null) throw new "Machinata.Reporting.Containerless.buildNode: nodeJSON is null, it be a valid drawable node.";
    if (containerElem == null) throw new "Machinata.Reporting.Containerless.buildNode: containerElem is null, it be a valid jquery selector.";
    if (containerElem.length == 0) throw new "Machinata.Reporting.Containerless.buildNode: containerElem is an empty selector.";
    if (containerElem.parent().length == 0) throw new "Machinata.Reporting.Containerless.buildNode: containerElem appears to not be in the DOM (it has no parent node).";

    // Create clones
    nodeJSON = Machinata.Util.cloneJSON(nodeJSON);

    // Register the reporting css namespace to container
    containerElem.addClass("machinata-reporting-styling");

    // Create an instance to work with
    var instance = Machinata.Reporting._createEmptyInstance();
    instance.config = config;

    // Build the node and contents
    var nodeElem = Machinata.Reporting.buildContents(instance, config, nodeJSON, null, containerElem);
    nodeElem.addClass("container-fullsize");
    nodeElem.data("reporting-instance",instance);

    // Return the built node
    return nodeElem;
};

/// <summary>
/// Tells a node it should redraw itself. 
/// This is especially useful if the size of the container has changed.
/// </summary>
Machinata.Reporting.Containerless.redrawNode = function (nodeElem) {
    nodeElem.trigger(Machinata.Reporting.Events.REDRAW_NODE_SIGNAL);
};

/// <summary>
/// </summary>
Machinata.Reporting.Containerless.cleanupNode = function (nodeElem) {
    nodeElem.trigger(Machinata.Reporting.Events.CLEANUP_NODE_SIGNAL);
    nodeElem.trigger(Machinata.Reporting.Events.REMOVE_NODE_SIGNAL);
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-printcomposer.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-printcomposer.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Print Composer utility methods and data store.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.PrintComposer = {};


/// <summary>
/// Returns true if the user has added any screens for the current report.
/// </summary>
Machinata.Reporting.PrintComposer.hasData = function (instance) {
    var data = Machinata.Reporting.PrintComposer.getData(instance);
    if (data == null || data.screens == null || data.screens.length == 0) return false;
    return true;
}

/// <summary>
/// Gets the printcomposer data for the current report (if any).
/// </summary>
Machinata.Reporting.PrintComposer.getData = function (instance) {
    //var key = "printcomposer_" + instance.reportData.reportId;
    //return Machinata.getCache(key);
    return Machinata.Reporting.UserSettings.getReportValue(instance,"printcomposer");
};


/// <summary>
/// Sets the printcomposer data for the current report.
/// </summary>
Machinata.Reporting.PrintComposer.setData = function (instance,data) {
    //var key = "printcomposer_" + instance.reportData.reportId;
    //return Machinata.setCache(key, data);
    Machinata.Reporting.UserSettings.setReportValue(instance,"printcomposer",data);
};

/// <summary>
/// Resets all print composer data for the current report.
/// </summary>
Machinata.Reporting.PrintComposer.resetData = function (instance) {
    Machinata.Reporting.PrintComposer.setData(instance,null);
};

/// <summary>
/// Helper function for sorting arrays of screens (nodeInfos)
/// </summary>
/// <hidden/>
Machinata.Reporting.PrintComposer._sortByScreenNumber = function (a, b) {
    return ((a.nodeScreen < b.nodeScreen) ? -1 : ((a.nodeScreen > b.nodeScreen) ? 1 : 0));
};

/// <summary>
/// Adds a screen for the current report via a nodeInfos object.
/// If the screen is already added, the add is ignored.
/// </summary>
Machinata.Reporting.PrintComposer.addScreen = function (instance, nodeInfos) {
    // INit
    var data = Machinata.Reporting.PrintComposer.getData(instance);
    if (data == null) data = {
        title: instance.config.reportTitle
    };
    if (data.screens == null) data.screens = [];

    // Already added?
    var alreadyExists = false;
    $.each(data.screens, function (index, screenJSON) {
        if (screenJSON.nodeScreen == nodeInfos.nodeScreen) alreadyExists = true;
    });

    // Add screen (migrated to node infos format)
    if (alreadyExists == false) {
        data.screens.push(nodeInfos);
        data.screens.sort(Machinata.Reporting.PrintComposer._sortByScreenNumber);
        Machinata.Reporting.PrintComposer.setData(instance, data); // save
    }
    //data.screens.push({
    //    screen: json.screenNumber,
    //    title: Machinata.Reporting.Text.resolve(instance,json.mainTitle),
    //    subtitle: Machinata.Reporting.Text.resolve(instance,json.subTitle)
    //});

    // Browse to?
    Machinata.yesNoDialog(Machinata.Reporting.Text.translate(instance, "reporting.printing.print-composer.added.title"), Machinata.Reporting.Text.translate(instance, "reporting.printing.print-composer.added.message"))
        .okay(function () {
            Machinata.Reporting.Handler.openPrintComposer(instance);
        }).show();

    return data;
};


/// <summary>
/// Removes a screen via a screen number for the current report.
/// </summary>
Machinata.Reporting.PrintComposer.removeScreen = function (instance, screenNumber) {
    var data = Machinata.Reporting.PrintComposer.getData(instance);
    var newScreens = [];
    $.each(data.screens, function (index, screenJSON) {
        if (screenJSON.nodeScreen != screenNumber) newScreens.push(screenJSON);
    });
    data.screens = newScreens;
    // Save
    Machinata.Reporting.PrintComposer.setData(instance,data);
    return data;
};


/// <summary>
/// Returns all the screens as an array of nodeInfos for the current report.
/// </summary>
Machinata.Reporting.PrintComposer.getScreens = function (instance) {
    var data = Machinata.Reporting.PrintComposer.getData(instance);
    if (data == null) return null;
    return data.screens;
};

/// <summary>
/// Returns all the screens as an array of ints for the current report.
/// </summary>
Machinata.Reporting.PrintComposer.getScreensAsIntArray = function (instance) {
    var screens = Machinata.Reporting.PrintComposer.getScreens(instance);
    if (screens == null) return null;
    var intScreens = [];
    for (var i = 0; i < screens.length; i++) {
        intScreens.push(screens[i].nodeScreen);
    }
    return intScreens;
};


/// <summary>
/// A built-in basic UI for the print composer.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.PrintComposer.UI = {};

/// <summary>
/// </summary>
Machinata.Reporting.PrintComposer.UI.init = function (config) {

    // Patch config
    config.automaticallyFoldChaptersIntoPages = false;
    config.buildContents = false; // we don't need the report contents
    config.automaticallyInsertChapterNavigation = false; // we dont need the chapter nav


    // Init report
    Machinata.Reporting.init(config, function (instance, config) {

        // Add a nav item for print composer
        if (Machinata.Reporting.Handler.addNavigationItem != null) Machinata.Reporting.Handler.addNavigationItem(instance, "Print Composer", "");

        // Init print composer...
        var elem = $(instance.config.printComposerSelector);

        // Get data
        var data = Machinata.Reporting.PrintComposer.getData(instance);

        // Debug
        Machinata.debug("Machinata.Reporting.PrintComposer.init:");
        Machinata.debug(data);

        if (data == null || data.screens == null || data.screens.length == 0) {
            // No Screens
            elem.find(".machinata-printcomposer-nocontent").show();
            elem.find(".machinata-printcomposer-tools").hide();
            elem.find(".machinata-printcomposer-screens").hide();
        } else {
            // Have screens
            elem.find(".machinata-printcomposer-nocontent").hide();

            // Compile listing
            var previewsByScreenNumber = {};
            $.each(data.screens, function (index, screenJSON) {
                // Validate
                if (previewsByScreenNumber[screenJSON.nodeScreen] != null) return;
                // Init preview elem
                var previewElem = $("<div class='item machinata-reporting-toolbar option-gray'><label class='title theme-headline-font'></label><label class='subtitle'></label><div class='tools'><div class='tool tool-remove'/></div></div></div>");
                previewElem.attr("data-screen", screenJSON.nodeScreen);
                previewElem.find(".tool-remove").append(Machinata.Reporting.buildIcon(instance, "close")); // <div class='tool tool-remove icon-csam-fn-small-close' data-hint='Remove item'></div>
                previewElem.find(".title").text(screenJSON.nodeTitle);
                previewElem.find(".subtitle").text(screenJSON.nodeSubtitle);
                previewElem.find(".tool-remove").click(function () {
                    // Remove elem
                    var updatedData = Machinata.Reporting.PrintComposer.removeScreen(instance, screenJSON.nodeScreen);
                    // Update UI
                    previewElem.remove();
                    if (updatedData.screens.length == 0) {
                        Machinata.reload();
                    }
                });

                // Register
                previewsByScreenNumber[screenJSON.nodeScreen] = previewElem;
                elem.find(".machinata-printcomposer-screens").append(previewElem);
            });
            Machinata.UI.bind(elem.find(".machinata-printcomposer-screens"));
        }

        // Bind actions
        elem.find(".machinata-printcomposer-action-reset").click(function () {
            Machinata.confirmDialog(Machinata.Reporting.Text.translate(instance, "reporting.printing.print-composer.reset.title"), Machinata.Reporting.Text.translate(instance, "reporting.printing.print-composer.reset.message"))
                .okay(function () {
                    Machinata.Reporting.PrintComposer.resetData(instance);
                    Machinata.reload();
                })
                .show();
        });
        elem.find(".machinata-printcomposer-action-preview").click(function () {
            var reportURL = Machinata.updateQueryString("screen", "printcomposer", instance.config.url);
            reportURL = Machinata.updateQueryString("profile", "webprint", reportURL);
            reportURL = Machinata.updateQueryString("chapter", "*", reportURL);
            reportURL = Machinata.updateQueryString("print-dialog", "true", reportURL);
            Machinata.openPage(reportURL);
        });

    });


};

/// <summary>
/// </summary>
Machinata.Reporting.PrintComposer.UI.open = function (instance) {
    //TODO: is this really the best method in getting the report url?
    var reportURL = Machinata.updateQueryString("ui", "printcomposer", instance.config.url);
    Machinata.openPage(reportURL);
};


/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-handler.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-handler.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Handler namespace.
/// The handlers let you configure and bind a custom user interface
/// for different reporting functionality. Typically, these handlers
/// handle things happening outside of the report.
/// For example: a fullscreen button located at the top right of the page.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Handler = {};  

/// <summary>
/// A handler called when a specific profile is loaded.
/// This allows you to prepare a page specifically for the profile, if needed.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.setupForProfile = function(profile) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.setupForProfile = null;

/// <summary>
/// A handler for adding a page tool that has to do with the report being displayed.
/// For example, such tools may include report attachments, date change, print composer, etc....
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.addPageTool = function(instance, title, icon, action, tooltip, addSeparator) { 
///     // instance >> reporting instance
///     // title >> string, tool title
///     // icon >> string, icon id
///     // action >> click hander, called when tool is pressed - you must bind this handler to a press event of the tool
///     // tooltip >> string, tool tooltip
///     // addSeparator >> bool, true if a separator should be added
/// }
/// ```
/// </example>
Machinata.Reporting.Handler.addPageTool = null;

/// <summary>
/// A handler called when a user would like to change the reporting date.
/// You can use the default supplied version: 
/// ```Machinata.Reporting.Tools.showReportDates```
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.changeReportingDate = function(instance, catalogJSON, currentMandateJSON, currentReportJSON) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.changeReportingDate = null;

/// <summary>
/// A handler that is called whenever the user would like to change chapter. This allows you to customize the behaviour of a chapter
/// a chapter change, depending on the integration.
///
/// You can use the default supplied version: 
///  - ```Machinata.Reporting.Tools.changeChapterViaURLUpdate```
///  - ```Machinata.Reporting.Tools.changeChapterViaInlineUpdate```
///
/// Note: If you use a custom integration, you must make sure that absolute direct URL links are avialable on all nodes. These links are used
/// for various features, such as a Ask-A-Question and Sharing.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.changeChapter = function(instance, chapterId) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.changeChapter = null; 


/// <summary>
/// A handler that is called whenever the user would like to change chapter, and directly focus on a node. This allows you to customize the behaviour of a chapter
/// a chapter change, depending on the integration.
///
/// For custom integrations, you can use a combination of default supplied tools: 
///  - ```Machinata.Reporting.Tools.changeChapterViaInlineUpdate```
///  - ```Machinata.Reporting.Tools.drilldownOnNode```
///
/// Note: If you use a custom integration, you must make sure that absolute direct URL links are avialable on all nodes. These links are used
/// for various features, such as a Ask-A-Question and Sharing.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.changeChapterAndFocusOnNode = function(instance, chapterId, nodeId) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.changeChapterAndFocusOnNode = null; 

/// <summary>
/// A handler for when the user wishes to ask a question regarding a specifc node or section.
///
/// A summary of useful properties is supplied in the handler ```infosJSON``` parameter (see ```Machinata.Reporting.Node.compileNodeInfos```), 
/// and the entire node is passed via the ```nodeJSON``` parameter.
/// 
/// You can use the default supplied version: 
///  - ```Machinata.Reporting.Tools.askAQuestionViaEmail```
///
/// Note: If you use a custom integration, you must make sure that absolute URL links are avialable on all nodes. These links are used
/// for various features, such as a Ask-A-Question and Sharing.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.askAQuestion = function(instance,infosJSON,nodeJSON) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.askAQuestion = null;

/// <summary>
/// A handler for when the user wishes to add a specific node to their dashboard.
///
/// A summary of useful properties is supplied in the handler ```infosJSON``` parameter (see ```Machinata.Reporting.Node.compileNodeInfos```), 
/// and the entire node is passed via the ```nodeJSON``` parameter.
/// 
/// In the ```infosJSON``` of special interest are the properties ```nodeSupportedDashboardSizes``` (see ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```),
/// ```nodeCurrentPixelSize``` (see ```Machinata.Reporting.Node.compileNodeInfos```), and
/// ```nodeCurrentBlockSize``` (see ```Machinata.Reporting.Node.compileNodeInfos```).
/// 
/// Here it is best practice to add the node to the dashboard as one of the supported dashboard sizes that best matches the current block size.
/// This ensures that the user has the closest representation of the node on the dashboard as it was on the report when the user originally requested to add
/// it to the dashboard.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.addToDashboard = function(instance,infosJSON,nodeJSON) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.addToDashboard = null;

/// <summary>
/// A handler for when the user wishes to add a specific node to a presentation.
/// Typically, this will be the entire screen for the current node.
///
/// A summary of useful properties is supplied in the handler ```infosJSON``` parameter (see ```Machinata.Reporting.Node.compileNodeInfos```), 
/// and the entire node is passed via the ```nodeJSON``` parameter.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.addToPresentation = function(instance,infosJSON,nodeJSON) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.addToPresentation = null;

/// <summary>
/// A handler for sharing a specific node and it's URL.
///
/// A summary of useful properties is supplied in the handler ```infosJSON``` parameter (see ```Machinata.Reporting.Node.compileNodeInfos```), 
/// and the entire node is passed via the ```nodeJSON``` parameter.
/// 
/// You can use the default supplied version: 
///  - ```Machinata.Reporting.Tools.shareNodeByCopyingLink```
///
/// Note: If you use a custom integration, you must make sure that absolute URL links are avialable on all nodes. These links are used
/// for various features, such as a Ask-A-Question and Sharing.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.shareNode = function(instance,infosJSON,nodeJSON) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.shareNode = null;


/// <summary>
/// A handler for printing a specific report.
/// Typically, such a handler should display a list of common
/// printing options, such as:
///  - Print entire report
///  - Print current chapter
///  - View print composer
///
/// The options displayed depend on which of the following corresponding handlers are implemented:
///  - Machinata.Reporting.Handler.openPrintPageForChapter
///  - Machinata.Reporting.Handler.openPrintPageForReport
///  - Machinata.Reporting.Handler.openPrintComposer
///
/// A summary of useful properties is supplied in the handler ```infosJSON``` parameter (see ```Machinata.Reporting.Node.compileNodeInfos```), 
/// and the entire node is passed via the ```nodeJSON``` parameter.
/// 
/// You can use the default supplied version which automatically builds the UI and correct user options:
///  - ```Machinata.Reporting.Tools.printNode```
///
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.printNode = function(instance,infosJSON,nodeJSON) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.printReport = Machinata.Reporting.Tools.printReport;

/// <summary>
/// A handler for printing a specific node. 
/// Typically, such a handler should display a list of common
/// printing options, such as:
///  - Print entire report
///  - Print current chapter
///  - Print this section
///  - Add to print composer
///  - View print composer
///
/// The options displayed depend on which of the following corresponding handlers are implemented:
///  - Machinata.Reporting.Handler.openPrintPageForSection
///  - Machinata.Reporting.Handler.openPrintPageForChapter
///  - Machinata.Reporting.Handler.openPrintPageForReport
///  - Machinata.Reporting.Handler.openPrintComposer
/// 
/// You can use the default supplied version which automatically builds the UI and correct user options: 
///  - ```Machinata.Reporting.Tools.printReport```
///
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.printNode = function(instance, infosJSON, nodeJSON) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.printNode = Machinata.Reporting.Tools.printNode;

/// <summary>
/// A handler for printing a specific section (screen) via the nodeInfos screen number.
/// 
/// Typically such a handler will display a report on blank page with the profile set to 'webprint' (and appropriate chapter/screen settings).
/// The config setting ```Machinata.Reporting.Config.automaticallySetLayoutMinMaxDimensions``` 
/// can be used to ensure a fine - tuned dimension that helps chrome / firefox / safari / edge figure out the proper scaling in its print engine.
/// The config setting ```Machinata.Reporting.Config.automaticallyOpenBrowserPrintDialog```
/// can be used to automatically open the browsers print dialog after the report is rendered.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.openPrintPageForSection = function(instance,nodeInfos) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.openPrintPageForSection = null;

/// <summary>
/// A handler for printing a specific chapter via the chapterId (nodeId of the chapter).
/// 
/// Typically such a handler will display a report on blank page with the profile set to 'webprint' (and appropriate chapter/screen settings).
/// The config setting ```Machinata.Reporting.Config.automaticallySetLayoutMinMaxDimensions``` 
/// can be used to ensure a fine - tuned dimension that helps chrome / firefox / safari / edge figure out the proper scaling in its print engine.
/// The config setting ```Machinata.Reporting.Config.automaticallyOpenBrowserPrintDialog```
/// can be used to automatically open the browsers print dialog after the report is rendered.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.openPrintPageForChapter = function(instance,chapterId) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.openPrintPageForChapter = null;

/// <summary>
/// A handler for printing an entire report via a reportId. The reportId will always match the currently loaded report of the instance.
/// 
/// Typically such a handler will display a report on blank page with the profile set to 'webprint' (and appropriate chapter/screen settings).
/// The config setting ```Machinata.Reporting.Config.automaticallySetLayoutMinMaxDimensions``` 
/// can be used to ensure a fine - tuned dimension that helps chrome / firefox / safari / edge figure out the proper scaling in its print engine.
/// The config setting ```Machinata.Reporting.Config.automaticallyOpenBrowserPrintDialog```
/// can be used to automatically open the browsers print dialog after the report is rendered.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.openPrintPageForReport = function(instance,reportId) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.openPrintPageForReport = null;


/// <summary>
/// A handler for displaying the print composer and it's data to the user.
/// 
/// See ```Machinata.Reporting.PrintComposer``` for more details.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.openPrintPageForReport = function(instance,reportId) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.openPrintComposer = null;

/// <summary>
/// A handler that can change the default icon ids for icon keys. This allows one
/// to use a custom icon set (or icon library) with differing icon ids than the default
/// shipped version.
/// You must support the mapping as defined by dictionary ```Machinata.Reporting.Config.iconNameToBundleIdMapping```.
/// By default this handler is setup to use the current configuration ```iconNameToBundleIdMapping```.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.getIconByKey = function(instance,key) {
///    // return string
/// }
/// ```
/// </example>
Machinata.Reporting.Handler.getIconByKey = function (instance,key) {
    return instance.config.iconNameToBundleIdMapping[key];
};

/// <summary>
/// </summary>
Machinata.Reporting.Handler.addNavigationItem = null;

/// <summary>
/// </summary>
Machinata.Reporting.Handler.addNavigationSibling = null;

/// <summary>
/// A handler to allow customization of chapter navigation.
/// This is usefull if you want to provide a custom way for users to navigation chapters.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.addChapterNavigation = function(instance, infosJSON, chapterNodeJSON) {
///    // add your own UI using the infos and chapter JSON
/// }
/// ```
/// </example>
Machinata.Reporting.Handler.addChapterNavigation = null; 

/// <summary>
/// A handler to allow customization of table UI/UX. Typically the default supplied handler should be used.
/// You can use the default supplied version: 
///  - ```Machinata.Reporting.Tools.bindTableUI```
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.bindTableUI = function(instance,elements) {
///    // elements is a jquery selector of tables
/// }
/// ```
/// </example>
Machinata.Reporting.Handler.bindTableUI = null;

/// <summary>
/// A handler to allow customization of tooltips. Typically the default supplied handler should be used.
/// You can use the default supplied version: 
///  - ```Machinata.Reporting.Tools.bindTooltipsUI```
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.bindTooltipsUI = function(instance,elements) {
///    // elements is a jquery selector for elements (and their children) for which tooltips should be registered
/// }
/// ```
/// </example>
Machinata.Reporting.Handler.bindTooltipsUI = null;

/// <summary>
/// A handler called when a node is cleaned up.
/// This is called just after the node implementation cleanup routine runs, and just before
/// the actual DOM content is removed.
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.cleanupNode = function(instance,nodeJSON,nodeElem) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.cleanupNode = null;

/// <summary>
/// A handler called when a PortalNode is ready. This means that the node as a element in the
/// DOM is and is available for manipulation/appending.
/// 
/// The source reporting node is available as the ```nodeJSON``` parameter, and the element in the DOM
/// is provided by ```portalElem``` as a JQuery selector. Typically the exact type of content or node requested as a portal
/// can be derived from ```nodeJSON.portalElementId```, however any additional properties or parameters of the node can
/// be used, as long as they don't conflict with standard reporting node parameters...
///
/// To get a DOM element, juse use ```portalElem[0]```: returns the first (and only) DOM element
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.portalNodeReady = function(instance,nodeJSON,nodeElem,portalElem) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.portalNodeReady = null;

/// <summary>
/// A handler called when a PortalNode has been resized.
/// Reporting nodes are always first resized, then redrawn - meaning that ```portalNodeResize``` will be called just before ```portalNodeDraw```.
/// This allows for small (yet meaninful) optimizations that can differ between a DOM layout resize and a redraw of content.
/// 
/// The source reporting node is available as the ```nodeJSON``` parameter, and the element in the DOM
/// is provided by ```portalElem``` as a JQuery selector. Typically the exact type of content or node requested as a portal
/// can be derived from ```nodeJSON.portalElementId```, however any additional properties or parameters of the node can
/// be used, as long as they don't conflict with standard reporting node parameters...
///
/// To get a DOM element, juse use ```portalElem[0]```: returns the first (and only) DOM element
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.portalNodeResize = function(instance,nodeJSON,nodeElem,portalElem) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.portalNodeResize = null;

/// <summary>
/// A handler called when a PortalNode has been requested for drawing. Can be usefull
/// if a draw of the portal contents should be defferred or only done when needed.
/// Reporting nodes are always first resized, then redrawn - meaning that ```portalNodeResize``` will be called just before ```portalNodeDraw```.
/// This allows for small (yet meaninful) optimizations that can differ between a DOM layout resize and a redraw of content.
///
/// The source reporting node is available as the ```nodeJSON``` parameter, and the element in the DOM
/// is provided by ```portalElem``` as a JQuery selector. Typically the exact type of content or node requested as a portal
/// can be derived from ```nodeJSON.portalElementId```, however any additional properties or parameters of the node can
/// be used, as long as they don't conflict with standard reporting node parameters...
///
/// To get a DOM element, juse use ```portalElem[0]```: returns the first (and only) DOM element
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.portalNodeDraw = function(instance,nodeJSON,nodeElem,portalElem) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.portalNodeDraw = null;


/// <summary>
/// A handler called when a PortalNode will be cleaned up (and later removed). 
/// This allows an integration to perform their own cleanup.
///
/// Note that the cleanup operation happens without any guarantee of order or execution wait, and by the time
/// the cleanup signal reaches the handler the DOM element may already be flushed. Thus the task
/// of the handler is to cleanup any resources not explicitly bound by the DOM element.
/// 
/// The source reporting node is available as the ```nodeJSON``` parameter, and the element in the DOM
/// is provided by ```portalElem``` as a JQuery selector. Typically the exact type of content or node requested as a portal
/// can be derived from ```nodeJSON.portalElementId```, however any additional properties or parameters of the node can
/// be used, as long as they don't conflict with standard reporting node parameters...
///
/// To get a DOM element, juse use ```portalElem[0]```: returns the first (and only) DOM element
/// </summary>
/// <example>
/// ```
/// Machinata.Reporting.Handler.portalNodeCleanup = function(instance,nodeJSON,nodeElem,portalElem) { ... }
/// ```
/// </example>
Machinata.Reporting.Handler.portalNodeCleanup = null;


/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-export.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-export.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Utilities to export Charts and Tables to XLSX and CSV format.
///
/// Supported chart types:
/// - DonutNode
/// - PieNode
/// - HBarNode
/// - VBarNode
/// - SymboledVBarNode
/// - CoreSatelliteNode
/// - MultiGaugeNode
/// - OfflineMapNode
/// - VerticalTableNode
/// - PivotTableNode
///
/// Behaviour if Value type is set (CategoryFact, Tables.Fact, etc):
/// if the facts have a ValueType defined the ```fact.value``` will be exported as a number, text or date using the defined excel format and multiplied by the factor(if defined)
/// Behaviour if no ValueType set;
/// if the ValueType is null/undefined the Fact.Value is exported without any formatting.
///
/// Current mappings:
/// supported value types and their mappings and factor 
/// Note: thousands separators , will be changed to ’ in excel (based on localization settings of excel?)
///
/// | valueType | value               | Excel format      | Factor   | Excel Type |
/// | --------- | ------------------- | -----------       | -------  | -----------|
/// | text      | This is sample text |                   |          | text       |
/// | date	   | 31/03/2019	         | dd.mm.yyyy        |          | date       |
/// | year	   | 31/03/2019     	 | yyyy              |          | date       |
/// | month     | 31/03/2019	         | mm                |          | date       |
/// | percent   | 0.02305             | 0.00%             |          | number     |
/// | p-abs	   | 0.02305	         | 0.00	             | 100      | number     |
/// | p-rel	   | 0.00412	         | 0.00	             | 10000    | number     |
/// | bp	       | 0.00412	         | 0.0               | 10000    | number     |
/// | amount	   | 1234567.89	         | #,##0.00          | 1        | number     |
/// | count	   | 1234567.89	         | 0                 | 1        | number     |
/// | mv	       | 1234567.89	         | #,##0	         | 1        | number     |
/// | mv_t	   | 1234567.89	         | #,##0	         | 0.001    | number     |
/// | mv_m	   | 1234567.89	         | #,##0	         | 0.000001 | number     |
/// | mv_m2d	   | 1234567.89	         | #,##0.00          | 0.000001 | number     |
/// | pl	       | 1234567.89	         | #,##0.00          | 1        | number     |
/// | fxrate	   | 1.0345665	         | #,##0.0000        | 1        | number     |
///
/// ```
/// var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
/// workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook, format);
/// Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
/// ```
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Export = {};


/// <summary>
/// Creates a workbook, can be used for e.g. xlsx or csv exports
/// Sets the title from the reports mainTitle
/// </summary>
Machinata.Reporting.Export.createExcelWorkbook = function (instance, config, json) {
    // create a new blank workbook
    var workbook = XLSX.utils.book_new();

    if (!workbook.Props) workbook.Props = {};
    workbook.Props.Title = json.mainTitle.resolved;

    return workbook;

};

/// <summary>
/// helper method: Adds a text/string value to a specified cell (address)
/// </summary>
Machinata.Reporting.Export.addStringCell = function (sheet, address, value) {
    sheet[address] = { v: value, t: "s" };
};

/// <summary>
/// helper method: Adds a number value to a specified cell (address)
/// </summary>
Machinata.Reporting.Export.addNumberCell = function (sheet, address, value, formatString, format) {
    
    if (formatString != null && formatString != undefined && format != "csv") {
        sheet[address] = { v: value, t: "n", z: formatString };
    }
    else {
        sheet[address] = { v: value, t: "n" };
    }
};

/// <summary>
/// helper methods: Adds a date value to a specified cell (address)
/// </summary>
Machinata.Reporting.Export.addDateCell = function (sheet, address, value, formatString, format) {

    if (format != "csv") {
        sheet[address] = { v: value, t: "d", z: formatString };
    }
    else {
        sheet[address] = { v: value, t: "d" };
    }
};


/// <summary>
/// helper method: Adds a value without defining a type (let excel decide)
/// </summary>
Machinata.Reporting.Export.addGenericCell = function (sheet, address, value, format) {
    if (format == "csv") {
        // We have to assume t == "s" for csv otherwise it exports empty values
        sheet[address] = { v: value, t: "s" };
    } else {
        sheet[address] = { v: value };
    }
};



/// <summary>
/// Adds a value to specific cell in the sheet
/// each ValueType has to be mapped to a number format supported by excel 
/// The 'resolved' values cannot be used because there is no 'known' way the set the value and a custom display value other than using the number format string
/// https://ngr.vcaire.ch/typedoc/ngr-core/doc/classes/_ngr_core_api_src_model_values_.valuetype.html#date
/// https://customformats.com/
/// </summary>
Machinata.Reporting.Export.addTableCell = function (sheet, address, dataValue, valueType, format) {
    
    if (valueType == "text" || valueType == "string") {
        Machinata.Reporting.Export.addStringCell(sheet, address, dataValue);
    }
    else if (valueType == "date") {
        Machinata.Reporting.Export.addDateCell(sheet, address, dataValue, "dd.mm.yyyy", format);
    }
    else if (valueType == "year") {
        Machinata.Reporting.Export.addDateCell(sheet, address, dataValue, "yyyy", format);
    }
    else if (valueType == "month") {
        Machinata.Reporting.Export.addDateCell(sheet, address, dataValue, "mm", format);
    }
    else if (valueType == "percent") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue, "0.00%", format);
    }
    else if (valueType == "p-abs") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue * 100, "0.00", format);
    }
    else if (valueType == "p-rel") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue * 10000, "0.00", format);
    }
    else if (valueType == "bp") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue * 10000, "0.0", format);
    }
    else if (valueType == "amount") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue, "#,##0.00", format);
    }
    else if (valueType == "count") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue, "0", format);
    }
    else if ( valueType == "mv" ) {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue, "#,##0", format);
    }
    else if (valueType == "mv_t") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue * 0.001, "#,##0", format);
    }
    else if (valueType == "mv_m") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue * 0.000001, "#,##0", format);
    }
    else if (valueType == "mv_m2d") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue * 0.000001, "#,##0.00", format);
    }
    else if (valueType == "pl") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue, "#,##0.00", format);
    }
    else if (valueType == "fxrate") {
        Machinata.Reporting.Export.addNumberCell(sheet, address, dataValue, "#,##0.0000", format);
    }
    else if (valueType == null) {

        // No ValueType Set -> therefore we only take the raw value and save it to the specified cell
        Machinata.Reporting.Export.addGenericCell(sheet, address, dataValue, format);
    }
    else {
        // Unknown ValueType
        Machinata.Reporting.Export.addGenericCell(sheet, address, dataValue,  format);
        console.warn("The ValueType '" + valueType + "' is not supported by Machinata.Reporting.Export.addTableCell(). Please use a supported ValueType or update Machinata.Reporting.Export.addTableCell() to include support for this ValueType.");
    }
      

};


/// <summary>
/// Helper method to create a sheetname from a given title
/// Uses default "Sheet" if empty
/// Shortens the title to 31 characterss because of excel restriction
/// </summary>
Machinata.Reporting.Export.createExcelSheetName = function (title){

    if (title == null || title == "") {
        return "Sheet";
    }

    title = title.substring(0, 31);
    return title;
}

/// <summary>
/// Helper method for Machinata.Reporting.Export.createExcelDataForCategoryChart
/// </summary>
Machinata.Reporting.Export.addCategoryFactsToCells = function (sheet,  facts, currentRow, format) {
  
    for (var f = 0; f < facts.length; f++) {
        var fact = facts[f];

        var factCatAddr = { c: 0, r: currentRow };
        var factCatAddrRef = XLSX.utils.encode_cell(factCatAddr);

        var factAddr = { c: 1, r: currentRow };
        var factAddrRef = XLSX.utils.encode_cell(factAddr);

        // Symbol type
        var label = fact.category.resolved;
        if (fact.symbolType != null && fact.symbolType != "") {
            label += " (" + fact.symbolType + ")";
        }

        Machinata.Reporting.Export.addStringCell(sheet, factCatAddrRef, label)

        var dataValue = fact.val;
        var valueType = fact.valueType;

        Machinata.Reporting.Export.addTableCell(sheet, factAddrRef, dataValue, valueType, format);

        currentRow++;
    }

    return currentRow;

};


/// <summary>
/// Adds a sheet to the workbook with the values from CategoryFact type charts.
/// Currently tested with Pie and Donut
/// </summary>
Machinata.Reporting.Export.createExcelDataForCategoryChart = function (instance, config, json, workbook,format) {
    var row = 0; // keep track of current row

    var title = Machinata.Reporting.Export.createExcelSheetName(json.mainTitle.resolved);

    var sheet = {};
    for (var s = 0; s < json.series.length; s++) {

        var addr = { c: 1, r: row };
        var addRef = XLSX.utils.encode_cell(addr);

        sheet[addRef] = { v: json.series[s].title.resolved , t:"s" };
        row++;

        // Facts
        var facts = json.series[s].facts;

        row = Machinata.Reporting.Export.addCategoryFactsToCells(sheet, facts, row, format);
    }

    // Define range to be exported
    sheet['!ref'] = "A1:B" + row;

    // Add worksheet to workbook 
    XLSX.utils.book_append_sheet(workbook, sheet, title);

    return workbook;

};


/// <summary>
/// Adds a sheet to the workbook with the values from SeriesGroupsCharts type charts.
/// Currently tested with xyz
/// LineColumnNde
/// </summary>
Machinata.Reporting.Export.createExcelDataForSeriesGroupsChart = function (instance, config, json, workbook, format) {
    var row = 0; // keep track of current row

    var title = Machinata.Reporting.Export.createExcelSheetName(json.mainTitle.resolved);

    var sheet = {};

    for (var g = 0; g < json.seriesGroups.length; g++) {

        var series = json.seriesGroups[g].series;

        for (var s = 0; s < series.length; s++) {

            var addr = { c: 1, r: row };
            var addRef = XLSX.utils.encode_cell(addr);

            sheet[addRef] = { v: series[s].title.resolved, t: "s" };
            row++;

            // Facts
            var facts = series[s].facts;

            //row = Machinata.Reporting.Export.addCategoryFactsToCells(sheet, facts, row, format);


            for (var f = 0; f < facts.length; f++) {
                var fact = facts[f];

                var factCatAddr = { c: 0, r: row };
                var factCatAddrRef = XLSX.utils.encode_cell(factCatAddr);

                var factAddr = { c: 1, r: row };
                var factAddrRef = XLSX.utils.encode_cell(factAddr);
              

                Machinata.Reporting.Export.addStringCell(sheet, factCatAddrRef, "Series" + s);

                // only facts with value
                if (fact.y != null) {
                    var dataValue = fact.x + " : " + fact.y;
                    var valueType = fact.valueType;

                    if (valueType == null) {
                        valueType = "number";
                    }

                    Machinata.Reporting.Export.addTableCell(sheet, factAddrRef, dataValue, valueType, format);
                    row++;
                }

                
            }
        }

    }

    // Define range to be exported
    sheet['!ref'] = "A1:B" + row;

    // Add worksheet to workbook 
    XLSX.utils.book_append_sheet(workbook, sheet, title);

    return workbook;

};


/// <summary>
/// For MultiGaugeNode, OfflineMapNode
/// </summary>
Machinata.Reporting.Export.createExcelDataForCategoryFacts = function (instance, config, json, workbook, format) {
   
    var row = 0; // keep track of current row

    var title = Machinata.Reporting.Export.createExcelSheetName(json.mainTitle.resolved);

    var sheet = {};

    // Facts
    var facts = json.facts;

    for (var f = 0; f < facts.length; f++) {
        var fact = facts[f];

        var factCatAddr = { c: 0, r: row };
        var factCatAddrRef = XLSX.utils.encode_cell(factCatAddr);

        var factAddr = { c: 1, r: row };
        var factAddrRef = XLSX.utils.encode_cell(factAddr);

        Machinata.Reporting.Export.addStringCell(sheet, factCatAddrRef, fact.category.resolved)

        Machinata.Reporting.Export.addTableCell(sheet, factAddrRef, fact.val, fact.valueType, format);
        row++;
    }


    // Define range to be exported
    sheet['!ref'] = "A1:B" + row;

    // Add worksheet to workbook 
    XLSX.utils.book_append_sheet(workbook, sheet, title);

    return workbook;

};


/// <summary>
/// Adds a sheet to the workbook with the values from a html table
/// Use intermediate format tables generated by Machinata.Reporting.Node.VerticalTableNode.buildTable
/// </summary>
Machinata.Reporting.Export.createExcelDataForTable = function (instance, config, json, workbook, table, format) {

    var title = Machinata.Reporting.Export.createExcelSheetName(json.mainTitle.resolved);

    // excel sheet which holds the data
    var sheet = {};

    // Colspan/Merges of cells
    var merges = [];

    var rowElems = table.find("thead tr, tbody tr");

    var columnsMax = 0;
    var row = 0; // keep track of current row

    // Go through each row
    rowElems.each(function (index) {

        var rowElem = $(this);
        var columnElems = rowElem.find("th, td");
        var column = 0;
        var colspanOffset = 0;

        // Go through each colum
        columnElems.each(function (indexC) {

            var cell = $(this);

            var addr = { c: column + colspanOffset, r: row };
            var addrRef = XLSX.utils.encode_cell(addr);

            var colspan = parseInt(cell.attr("colspan"));
          
            // Colspan?
            if (colspan > 1) {

                //https://github.com/SheetJS/sheetjs/blob/3542d62fffc155dd505a23230ba182c4402a0e2c/dist/xlsx.js#L19509

                // Merges: an array of ranges which are merged into one
                var merge = { s: { r: row, c: column + colspanOffset }, e: { r: row , c: colspanOffset + column + colspan - 1 } };
                merges.push(merge);

                // how far we are off the actual column number because of colspans
                colspanOffset += (colspan - 1);
            }
                       
            // Header
            if (cell.is("th")) {
                Machinata.Reporting.Export.addStringCell(sheet, addrRef, cell.text());
            }

            // Body
            else if (cell.is("td")) {

                var dataValue = cell.attr("data-value")
                var dataType = cell.attr("data-type")
                var dataText = cell.attr("data-text");

               // Machinata.debug(dataValue, dataType, dataText);

                // We have a data value
                if (dataValue != null && dataType != undefined) {
                    Machinata.Reporting.Export.addTableCell(sheet, addrRef, dataValue, dataType, format);
                }
                else if (dataText != null && dataType != undefined) {
                    Machinata.Reporting.Export.addTableCell(sheet, addrRef, dataText, dataType, format);
                }
                else if (dataText != null) {
                    // Labels: just add a string cell
                    Machinata.Reporting.Export.addStringCell(sheet, addrRef, dataText);
                }
            }

            // Column count
            column++;

            // Max width
            if (columnsMax < column + colspanOffset) {
                columnsMax = column + colspanOffset;
            }

        });

        row++;
    });

    var maxColRef = XLSX.utils.encode_cell({ c: columnsMax, r: (row-1) });

    // Define range to be exported
    sheet['!ref'] = "A1:" + maxColRef;

    // Merges
    if (merges.length) sheet["!merges"] = merges;

    // Add worksheet to workbook 
    XLSX.utils.book_append_sheet(workbook, sheet, title);

    return workbook;

};

/// <summary>
/// Saves the workbook to a file and forces browser to download
/// automatically exports XLSX or CSV depending on the filename extension
/// </summary>
Machinata.Reporting.Export.saveExcelWorkbook = function (instance, config, json, workbook, filename) {
    XLSX.writeFile(workbook, filename);
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Provides a namespace for all node implementaions and common routines for building
/// and managine nodes and their tools.
/// 
/// Nodes are automatically created by the reporting layout, however you can
/// create node independently using the Machinata.Reporting.Node.build method.
///
/// ## JSON Data
/// Each node is driven by its JSON data-object. This extends (or overwrites) the node's implementation defaults.
/// 
/// ### Timestamps
/// In general, timestamps are always given as a Unix Epoch Milliseconds long.
///
/// ### Translatable (Resolvable) Texts
/// Texts which may be translated or parsed for arguments can be used instead of baked int strings.
/// It is highly recommend to always provide reports JSON with fully resolved text.
/// See ```Machinata.Reporting.Text.resolve``` for more details.
/// 
/// ## Barebones Implementation Example
/// A barebones node implementation looks like:
///
/// ```
/// Machinata.Reporting.Node.Example = {}; // Define new Node
/// Machinata.Reporting.Node.Example.defaults = {}; // Define any defaults your node needs
/// Machinata.Reporting.Node.Example.init = function (config, json, nodeElem) {}; // Your init routine, called only once on build
/// Machinata.Reporting.Node.Example.draw = function (config, json, nodeElem) {}, // Your draw routine, called when needed
/// ```
///
/// See the example implementation for more details.
///
/// ## Responsive and Redrawing
/// All nodes must be responsive, thus the init and draw methods are seperated. Whenever the report view
/// changes, your ```draw()``` method will be automatically called.
///
/// You can force a redraw of any node by calling the event ```machinata-reporting-redraw-node```:
/// 
/// ```
/// nodeElem.trigger("machinata-reporting-redraw-node");
/// ```
/// 
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Node = {};



/// <summary>
/// Node Defaults. 
/// Provides all the global node defaults that every node will inherit in its JSON.
/// Each node can extend or alter these defaults with its own defaults implementation.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Node.Defaults = {};

/// <summary>
/// If true, the node supports headless rendering without a DOM (browser) context.
/// Typically, all chart type nodes support headless rendering.
/// </summary>
Machinata.Reporting.Node.Defaults.supportsHeadlessRendering = false;

/// <summary>
/// If true, the node supports a toolbar and will automatically build a toolbar to accompany the node.
/// </summary>
Machinata.Reporting.Node.Defaults.supportsToolbar = true;

/// <summary>
/// If true, the node supports being added to a dashboard and the appropriate tool will be added to the nodes toolbar.
/// </summary>
Machinata.Reporting.Node.Defaults.supportsDashboard = false;

/// <summary>
/// Every node which supports the dashboard must return an array of strings which indicate which layout sizes for a dashboard the node supports, in order or preferered size.
/// Although every node is fully responsive, there are some design and practical limits which make sense for a node and its data.
///
/// See the layouts examples for more information on the grid layout standard sizes.
///
/// The default supported sizes are:
///  - ```Block1x1```: small square
///  - ```Block2x2```: large square
///  - ```Block2x1```: large square half horizontal
///  - ```Block4x2```: large full width
/// 
/// Atypical (not recommended) sizes, but technically possible:
///  - ```Block1x2```: large square half vertical
///  - ```Block4x1```: small full width
///  - ```Block4x4```: super large square
///
/// When possible, use the constants defined at ```Machinata.Reporting.Layouts.BLOCK_*```
///
/// The block sizes are easy to compute into hard values. For example, if your layout uses a 4-column grid layout (the standard),
/// then you can compute the size of any block using (not accounting for borders, padding, margins...):
///  - ```(containerWidth/4) * blockSize```
/// This means that a size of ```Block2x1``` will yield:
///  - width ```2```: ```(containerWidth/4) * 2 => (1200/4) * 2 = 600```
///  - height ```1```: ```(containerWidth/4) * 1 => (1200/4) * 1 = 300```
/// On mobile, the grid layout is usually halfed:
///  - width ```2```: ```(containerWidth/2) * 2 => (375/2) * 2 = 375```
///  - height ```1```: ```(containerWidth/2) * 1 => (375/2) * 1 = 187.5 = 187```
/// Note that you should always round fractions to avoid browsers from anti-aliasing off of the pixel grid (will cause bluriness in lines).
///
/// See also the ```nodeCurrentPixelSize``` in ```Machinata.Reporting.Node.compileNodeInfos()```.
/// See also the ```nodeCurrentBlockSize``` in ```Machinata.Reporting.Node.compileNodeInfos()```.
/// </summary>
/// <example>
/// The following example supports two sizes, with "Block2x1" the preffered size.
/// ```[Machinata.Reporting.Layouts.BLOCK_2x1,Machinata.Reporting.Layouts.BLOCK_4x2]```
/// </example>
Machinata.Reporting.Node.Defaults.supportedDashboardSizes = null;

/// <summary>
/// If true, the node has standard tools added to the main toolbar (supportsToolbar must be true as well).
/// </summary>
Machinata.Reporting.Node.Defaults.addStandardTools = true;

/// <summary>
/// When true, the node will automatically build all it's children. You can set this to false if you want to process your children by yourself.
/// </summary>
Machinata.Reporting.Node.Defaults.processChildren = true;

/// <summary>
/// Automatically add these classes (space seperated string) to the node element.
/// </summary>
Machinata.Reporting.Node.Defaults.additionalCSSClasses = null;

/// <summary>
/// If set, defines the main title for the node. 
/// Note: Setting this will add a node toolbar automatically, unless ```supportsToolbar```
/// has explicitly been set to ```false```.
/// </summary>
Machinata.Reporting.Node.Defaults.mainTitle = null;

/// <summary>
/// If set, defines the sub title for the node. 
/// Note: Without a ```mainTitle```, this is typically disregarded.
/// </summary>
Machinata.Reporting.Node.Defaults.subTitle = null;

/// <summary>
/// If set to ```true```, this node (and all it's children) are marked by the index builder as a single 
/// screen. This is important if you want to use fullscreen and print composer functionalities.
///
/// ## User Experience
/// For the UX, screens should always span a single layout row, and typically will include just a single 
/// Node with toolbar (like a chart, paragraph, image). It is recommended to keep screens on a single over-arching
/// node depth. A screen should mostly fit onto a Full-HD layout (browser in fullscreen), however some cases (like a long table node) will not fit
/// on a screen all at once causing a scroll functionality.
/// </summary>
Machinata.Reporting.Node.Defaults.screen = null;

/// <summary>
/// If defined, an automatic info icon is attached to the node's main toolbar. Pressing the info button
/// will invoke a popup dialog (unless there is a custom implementation).
///
/// ## Info JSON
/// The info object can have the following properties:
///  - ```tooltip```: resolvable JSON text which is used the mouse-hover tooltip or accessibility
///  - ```title```: resolvable JSON text which is used for the dialog box title
///  - ```text```: resolvable JSON text which is used for the dialog box text
/// </summary>
/// <example>
/// ```
/// "info": {
///     "tooltip": {
///        "resolved": "About SRRI risk profile"
///     },
///     "title": {
///         "resolved": "SRRI risk profile"
///     },
///     "text": {
///         "resolved": "The risk profile corresponds to the Synthetic Risk and Reward Indicator (SRRI). The SRRI is a measure of the overall risk and reward profile of a fund. Its calculation is based on the CESR 10-673 guidelines. Funds are categorised on a scale from 1 to 7, with 1 representing lowest risk and 7 representing highest risk. The fund�s position on this scale is a reasonably accurate reflection of the risk inherent in the fund under past market conditions. It does not reflect the risk inherent in any future circumstances or events that differ from what the fund has experienced in the past. Changes in the fund�s alignment within the boundaries set by its investment policy may also impact the fund�s risk."
///     }
/// }
/// ```
/// </example>
Machinata.Reporting.Node.Defaults.info = null;


/// <summary>
/// An optional string[] array that can define various tags (labels, markers) for a node.
/// 
/// Some tags are used to automatically extract information for a report, such as a disclaimer or legal entity.
/// Depending on the configuration, these nodes are excluded from the report index, since their content is used
/// in an overarching way (for example, the disclaimer is used across all chapters, not just at the end of the report).
/// 
/// Every tag is exposed to the CSS stack via ```tag-YOURTAG```.
/// 
/// ## Known Tags
///  - ```Report_Disclaimer```
///  - ```Report_LegalEntity```
///  - ```Screen```
///  - ```PageBreak```
///  - ```WebOnly```
///  - ```WebPrintOnly```
///  - ```PrintOnly```
///  - ```FullscreenOnly```
///  - ```DarkChrome```
///  - ```LightChrome```
///  - ```SolidChrome```
/// </summary>
/// <example>
/// ```
/// "tags": [ "Report_Disclaimer" ]
/// ```
/// </example>
Machinata.Reporting.Node.Defaults.tags = null;


/// <summary>
/// If defined, the node (and it's children) will accept take this theme to be used for graphics
/// and UI's such as charts. This property trickles down to the node's children until a child 
/// re-defines the theme.
///
/// ```theme``` defines color pallets and color scales for node contents, while ```chrome``` defines
/// the nodes user interface (typically the UI that encloses the nodes content). Thus a ```theme``` and a ```chrome``` can be combined.
/// 
/// Typically a theme is set for each chapter, though in some places a chapter might have mixed
/// themes - such as a overview.
///
/// Almost all nodes require a theme context (meaning either they set a theme or the theme is inherited from a parent node). Only NoOp Nodes do not need to have a theme (specifically the root node).
///
/// ## Registered Themes
/// Themes used by nodes should always be registered with ```Machinata.Reporting.registerTheme```,
/// ensuring that charting libraries have proper access to them.
/// 
/// ## Standard Themes
/// Each branding or project will have their own themes, however the following standard themes should exist:
///  - ```gray```: a standard gray color (or neutral color)
///  - ```infographic```: Used by charting frameworks, the solid color for infographics
/// </summary>
Machinata.Reporting.Node.Defaults.theme = null;


/// <summary>
/// If defined, the node will apply this specific style to the node. It should be avoided to use styles
/// within the node building runtime. Styles should generally only be used by the CSS stack.
///
/// The style is exposed to the CSS stack via ```style-YOURSTYLE```.
/// 
/// Note: it is not possible to define more than one style.
/// Note: the style ```NoStyle``` is reserved.
/// </summary>
Machinata.Reporting.Node.Defaults.style = null;


/// <summary>
/// If defined, the node will apply this specific style to the node. It should be avoided to use styles
/// within the node building runtime. Styles should generally only be used by the CSS stack.
///
/// The style is exposed to the CSS stack via ```style-YOURSTYLE```.
/// 
/// Note: it is not possible to define more than one style.
/// Note: the style ```NoStyle``` is reserved.
/// </summary>
Machinata.Reporting.Node.Defaults.styles = null;

/// <summary>
/// If defined, the node will apply this specific chrome-style to the nodes user interface.
///
/// ```theme``` defines color pallets and color scales for node contents, while ```chrome``` defines
/// the nodes user interface (typically the UI that encloses the nodes content). Thus a ```theme``` and a ```chrome``` can be combined.
/// 
/// Each node type typically defines it's own standard chrome it wants to use. For example, charts will define ```solid``` for their chrome,
/// while paragraphs will define ```light```.
///
/// The chrome is exposed to the CSS stack via ```chrome-YOURCHROME```.
///
/// ## Standard Chrome Styles
/// The following chrome styles are standardized, however each branding or project can provide their own chrome styles:
///  - ```solid```: a solid chrome with clear border and defined area. By default most Nodes will use this.
///  - ```dark```: Inverted chrome, or dark chrome. Used to make a node stand out.
///  - ```light```: a light and minimal interface, used especially for typography or infographics.
///
/// ## Using Tags
/// Instead of setting the chrome property explicitly, you can use the following tags instead:
///  - SolidChrome: ```solid```
///  - DarkChrome: ```dark```
///  - LightChrome: ```light```
/// </summary>
Machinata.Reporting.Node.Defaults.chrome = null;


/// <summary>
/// If defined, an automatic link (arrow) icon is attached to the node's main toolbar. Pressing the link button
/// will invoke either a drilldown to a specifc node or an external URL.
///
/// See Machinata.Reporting.Tools.openLink for more details.
/// </summary>
/// <example>
/// ### Example with node focus
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "About SRRI risk profile"
///     },
///     "nodeId": "rep-20190710-152228-nodexyz"
/// }
/// ```
/// ### Example with chapter change
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "About SRRI risk profile"
///     },
///     "chapterId": "rep-20190710-chapterxyz"
/// }
/// ```
/// ### Example with external link
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "Go to Nerves.ch"
///     },
///     "url": "https://nerves.ch",
///     "target": "_blank"
/// }
/// ```
/// ### Example with drilldown for table
/// ```
/// "link": {
///     "tooltip": {
///        "resolved": "Drilldown on AAA >10 years"
///     },
///     "nodeId": "rep-20190710-152228-nodexyz"
///     "drilldown": {
///         "filters": [
///             { 
///                 "columnId": "rating",
///                 "value": "AAA"
///             } ,
///             { 
///                 "columnId": "maturityBucket",
///                 "value": ">10 years"
///             } 
///         ]
///     }
/// }
/// ```
/// </example>
Machinata.Reporting.Node.Defaults.link = null;

/// <summary>
/// If ```true```, the export functionality (if any) is disabled and non-accessible.
/// </summary>
Machinata.Reporting.Node.Defaults.disableExport = null;










/// <summary>
/// Merges in the defaults from all sources (Machinata.Reporting.Node.Defaults, impl.defaults, profile defaults)
/// Note: this will modify your incomming ```json```.
/// </summary>
Machinata.Reporting.Node.mergeJSONWithDefaults = function (config,json) {
    // Create defaults and merge into json
    // The priority is as following (lowest least priority)
    //      1. Machinata.Reporting.Node.Defaults (universal node defaults)
    //      2. impl.defaults (node implementation defaults)
    //      2. profile defaults (defaults from profile.nodeDefaults)
    //      4. json (specific node json)
    // See https://codepen.io/dankrusi/pen/vqbKXm?editors=0011 for a jquery PoC
    // See https://api.jquery.com/jquery.extend/

    // Old method
    /*var defaults = Machinata.Reporting.Node.Defaults; // Global node defaults
    if (impl != null) defaults = $.extend(null, defaults, impl.defaults); // Implementation defaults
    json = $.extend(json, defaults, json);*/

    // New method

    // Get impl defaults
    var impl = Machinata.Reporting.Node[json.nodeType];
    var implementationDefaults = null;
    if (impl != null) implementationDefaults = impl.defaults;

    // Get profile defaults (Machinata.Reporting.Profiles.Configs["print"]["nodeDefaults"]["HBarNode"]);
    // We do this very safely since not everyone is providing profile node detaults...
    var profileDefaults = null;
    if (Machinata.Reporting.Profiles.Configs != null) {
        if (Machinata.Reporting.Profiles.Configs[config.profile] != null) {
            if (Machinata.Reporting.Profiles.Configs[config.profile]["nodeDefaults"] != null) {
                if (Machinata.Reporting.Profiles.Configs[config.profile]["nodeDefaults"][json.nodeType] != null) {
                    profileDefaults = Machinata.Reporting.Profiles.Configs[config.profile]["nodeDefaults"][json.nodeType];
                }
            }
        }
    }

    // Create merged json
    var jsonNew = {};
    Machinata.Util.extend(jsonNew, Machinata.Reporting.Node.Defaults); // 1
    if (implementationDefaults != null) Machinata.Util.extend(jsonNew, implementationDefaults); // 2
    if (profileDefaults != null) Machinata.Util.extend(jsonNew, profileDefaults); // 3

    Machinata.Util.extend(jsonNew, json); // 4
    Machinata.Util.extend(json, jsonNew); // Swap out: note this seems odd, but we must do this to ensure the correct priority as we want it. This final extend ensures that the object json has the correct new priority applied inline. This is important to ensure that future upstream methods see the same json
};

/// <summary>
/// Builds a node using the given config and node json.
/// The build method will automatically load the node implementation and call it's build sub-routines:
///  - ```preBuild```
///  - ```init```
///  - ```postBuild```
/// If a ```containerElem``` is given, then the node element is automatically appended to the container.
/// </summary>
Machinata.Reporting.Node.build = function (instance, config, json, containerElem) {

    // Load implememtnation
    var impl = Machinata.Reporting.Node[json.nodeType];


    // Create defaults and merge into json
    Machinata.Reporting.Node.mergeJSONWithDefaults(config, json);

    // Reset the state
    json._state = {};

    // Convert deprecated style to new format
    if (json.style != null) {
        if (json.styles == null) json.styles = [];
        json.styles.push(json.style);
    }

    // Create main DOM elements
    var nodeElem = $("<div class='machinata-reporting-node machinata-reporting-themable'></div>");
    nodeElem.attr("id", json.id);
    nodeElem.addClass("level-" + json.level);
    nodeElem.addClass("screen-" + json.screenNumber);
    nodeElem.addClass("type-" + json.nodeType);
    if (json.additionalCSSClasses != null) nodeElem.addClass(json.additionalCSSClasses);
    nodeElem.attr("data-node-id", json.id);
    nodeElem.attr("data-screen", json.screenNumber);
    nodeElem.attr("data-level", json.level);
    nodeElem.attr("data-type", json.nodeType);
    nodeElem.attr("data-chrome", json.chrome);
    nodeElem.data("json", json);
    // Register theme as css style
    if (json.theme != null) nodeElem.addClass("theme-" + json.theme);
    // Register layout as css style
    if (json.layout != null) nodeElem.addClass("layout-" + json.layout);
    // Register styles as css styles
    /*if (json.style != null) nodeElem.addClass("style-" + json.style);
    else nodeElem.addClass("style-NoStyle");*/
    if (json.styles == null || json.styles.length == 0) {
        nodeElem.addClass("style-NoStyle");
    } else {
        for (var i = 0; i < json.styles.length; i++) {
            nodeElem.addClass("style-" + json.styles[i]);
        }
    }
    // Register chrome as css style
    if (json.chrome != null) nodeElem.addClass("chrome-" + json.chrome);
    // Register tags as css tags
    if (json.tags != null) {
        for (var i = 0; i < json.tags.length; i++) {
            nodeElem.addClass("tag-" + json.tags[i]);
        }
    }

    // Toolbar
    if (json.supportsToolbar == true && impl != null) {
        // Validate we have the bare-minimum for a toolbar
        var title = Machinata.Reporting.Text.resolve(instance,json.mainTitle);
        var subtitle = Machinata.Reporting.Text.resolve(instance,json.subTitle);
        if (title != null) {

            // Create toolbar
            var toolbarElem = Machinata.Reporting.buildToolbar(instance, title, subtitle); // Note: sectional icons have been deprecated
            nodeElem.append(toolbarElem);
            nodeElem.addClass("option-toolbar");
            nodeElem.data("toolbar", toolbarElem);

            // Link
            if (json.link != null) {
                var tooltip = Machinata.Reporting.Text.resolve(instance,json.link.tooltip);
                Machinata.Reporting.addTool(instance, nodeElem, tooltip, "arrow-right", function () {
                    Machinata.Reporting.Tools.openLink(instance,json.link);
                });
            }

            // Standard tools
            if (json.addStandardTools != false) {

                // Fullscreen button (only if we have screens)
                if (instance.screens != null && instance.screens.length > 0) {
                    Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.fullscreen"), "fullscreen", function () {
                        Machinata.Reporting.Tools.toggleFullscreenForNode(instance,nodeElem);
                    });
                }
                // Print button (only if we have screens)
                if (instance.screens != null && instance.screens.length > 0) {
                    if (Machinata.Reporting.Handler.printNode != null) {
                        Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.print"), "print", function () {
                            var infos = Machinata.Reporting.Node.compileNodeInfos(instance, config, json);
                            Machinata.Reporting.Handler.printNode(instance, infos, json);
                        });
                    }
                }
                // Ask a question
                if (Machinata.Reporting.Handler.askAQuestion != null) {
                    Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.ask-question"), "ask-question", function () {
                        var infos = Machinata.Reporting.Node.compileNodeInfos(instance, config, json);
                        Machinata.Reporting.Handler.askAQuestion(instance, infos, json);
                    });
                }
                // Add to dashboard
                if (Machinata.Reporting.Handler.addToDashboard != null && json.supportsDashboard == true) {
                    Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.add-to-dashboard"), "add-to-dashboard", function () {
                        var infos = Machinata.Reporting.Node.compileNodeInfos(instance, config, json);
                        Machinata.Reporting.Handler.addToDashboard(instance, infos, json);
                    });
                }
                // Add to presentation
                if (Machinata.Reporting.Handler.addToPresentation != null) {
                    Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.add-to-presentation"), "add-to-presentation", function () {
                        var infos = Machinata.Reporting.Node.compileNodeInfos(instance, config, json);
                        Machinata.Reporting.Handler.addToPresentation(instance, infos, json);
                    });
                }
                // Share node
                if (Machinata.Reporting.Handler.shareNode != null) {
                    Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.share"), "share", function () {
                        var infos = Machinata.Reporting.Node.compileNodeInfos(instance, config, json);
                        Machinata.Reporting.Handler.shareNode(instance, infos, json);
                    });
                }
            }

            // Info?
            if (json.info != null) {
                var tooltip = Machinata.Reporting.Text.resolve(instance,json.info.tooltip);
                Machinata.Reporting.addTool(instance, nodeElem, tooltip, "info", function () {
                    Machinata.Reporting.Tools.showInfoDialog(instance, config, json.info);
                });
            }

            // Debug?
            if (Machinata.DebugEnabled == true) {
                Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.debug"), "debug", function () {
                    Machinata.Reporting.Tools.debugMenuForNode(instance, config, json, nodeElem);
                });
            }
        }
    }

    

    // Init node
    if (impl != null) impl.init(instance, config, json, nodeElem);



    // Bind redraw events
    var NODE_EVENT_PROPOGATION_DEBUGGING = false;
    {
        // Bind redraw self
        nodeElem.on(Machinata.Reporting.Events.REDRAW_NODE_SIGNAL, function (event) {
            // Stop event from bubbling up, we handle it here and for every node...
            event.stopPropagation();

            // Rebuild context
            var eventNodeElem = $(this);
            var eventNodeId = eventNodeElem.attr("id");
            var eventNodeJSON = Machinata.Reporting.Node.getJSONByID(instance,eventNodeId);
            var eventNodeImpl = Machinata.Reporting.Node[eventNodeJSON.nodeType];
            if (NODE_EVENT_PROPOGATION_DEBUGGING == true) Machinata.debug(Machinata.Reporting.Events.REDRAW_NODE_SIGNAL, eventNodeId, "(" + instance.uid + ")");

            // Resize
            Machinata.Reporting.Node.resize(instance, config, eventNodeJSON, eventNodeElem);

            // Call draw, if we have a implementation
            if (eventNodeImpl != null && eventNodeElem != null && eventNodeElem.is(":visible")) {
                // Debugging
                if (NODE_EVENT_PROPOGATION_DEBUGGING == true) console.log("REDRAW CMD " + eventNodeJSON.id + " " + eventNodeJSON.nodeType);
                // Implementation Resize
                if (eventNodeImpl.resize) eventNodeImpl.resize(instance, config, eventNodeJSON, eventNodeElem);
                // Implementation Redraw
                eventNodeImpl.draw(instance, config, eventNodeJSON, eventNodeElem);
            }

        });

        // Bind redraw self + children
        nodeElem.on(Machinata.Reporting.Events.REDRAW_NODE_AND_CHILDREN_SIGNAL, function (event) {

            // Stop event from bubbling up, we handle it here and for every node...
            // In this case, we actually want the reverse - we want to bubble down, not up...
            event.stopPropagation();

            // Rebuild context
            var eventNodeElem = $(this);
            var eventNodeId = eventNodeElem.attr("id");
            if (NODE_EVENT_PROPOGATION_DEBUGGING == true) Machinata.debug(Machinata.Reporting.Events.REDRAW_NODE_AND_CHILDREN_SIGNAL, eventNodeId,"(" + instance.uid + ")");
            var eventNodeJSON = Machinata.Reporting.Node.getJSONByID(instance,eventNodeId);
            var eventNodeImpl = Machinata.Reporting.Node[eventNodeJSON.nodeType];

            // Resize
            Machinata.Reporting.Node.resize(instance, config, eventNodeJSON, eventNodeElem);

            // Redraw ourselves
            if (NODE_EVENT_PROPOGATION_DEBUGGING == true) console.log("REDRAW EVT   " + eventNodeJSON.id + " " + eventNodeJSON.nodeType);
            if (eventNodeImpl != null && eventNodeElem != null && eventNodeElem.is(":visible")) {
                // Debugging
                if (NODE_EVENT_PROPOGATION_DEBUGGING == true) console.log("REDRAW CMD " + eventNodeJSON.id + " " + eventNodeJSON.nodeType);
                // Implementation Resize
                if (eventNodeImpl.resize) eventNodeImpl.resize(instance, config, eventNodeJSON, eventNodeElem);
                // Implementation Draw
                eventNodeImpl.draw(instance, config, eventNodeJSON, eventNodeElem);
            }

            // Pass event to children
            if (eventNodeElem != null) {
                // We search for nodes dynamically (instead of node.children) since some nodes
                // dynamically create nodes on-the-fly that are untracked in the index
                // This is actually also faster, oddly
                eventNodeElem.find(".machinata-reporting-node").each(function () {
                    $(this).trigger(Machinata.Reporting.Events.REDRAW_NODE_SIGNAL);
                });
            }
        });

        // Bind cleanup self
        nodeElem.on(Machinata.Reporting.Events.CLEANUP_NODE_SIGNAL, function (event) {
            // Stop event from bubbling up, we handle it here and for every node...
            event.stopPropagation();

            // Rebuild context
            var eventNodeElem = $(this);
            var eventNodeId = eventNodeElem.attr("id");
            var eventNodeJSON = Machinata.Reporting.Node.getJSONByID(instance, eventNodeId);
            var eventNodeImpl = Machinata.Reporting.Node[eventNodeJSON.nodeType];
            if (NODE_EVENT_PROPOGATION_DEBUGGING == true) Machinata.debug(Machinata.Reporting.Events.CLEANUP_NODE_SIGNAL, eventNodeId, "(" + instance.uid + ")");

            // Call draw, if we have a implementation
            if (eventNodeImpl != null && eventNodeElem != null) {
                // Implementation Cleanup
                if (eventNodeImpl.cleanup) eventNodeImpl.cleanup(instance, config, eventNodeJSON, eventNodeElem);
                // Handler
                if (Machinata.Reporting.Handler.cleanupNode != null) Machinata.Reporting.Handler.cleanupNode(instance, eventNodeJSON, eventNodeElem);
                // Note: actual remove from DOM is done later by REMOVE_NODE_SIGNAL
            }
        });

        // Bind remove self
        nodeElem.on(Machinata.Reporting.Events.REMOVE_NODE_SIGNAL, function (event) {
            // Stop event from bubbling up, we handle it here and for every node...
            event.stopPropagation();

            // Rebuild context
            var eventNodeElem = $(this);
            
            if (eventNodeElem != null) {
                // Actual remove from DOM
                eventNodeElem.remove();
            }
        });
    }

    // Register with responsive framework
    // Note: This is now handled at a later stage

    // Clearer
    //$("<div class='clear'></div>").appendTo(sectionElem);

    // Register in lookup tables
    instance.idToNodeElementLookupTable[json.id] = nodeElem;

    // Append to dom
    //TODO: can this be done later?
    nodeElem.appendTo(containerElem);

    // Initial draw
    // Note: this has been deprecated in favor of a single redraw at the end of reporting node build
    //if (impl != null) impl.draw(config, json, nodeElem);

    return nodeElem;
};


/// <summary>
/// Helper function for compiling some common useful infos for a specific node.
/// </summary>
/// <example>
/// ```
/// {
///     nodeId: "bb_rep_autoid_8",
///     nodeScreen: 22,
///     nodeSubtitle: "Commentary, 31.03.2019",
///     nodeTitle: "Market",
///     nodeURL: "https://domain.com/report/xyz/date/?focus=8392390294&chapter=chapter_overview",
///     nodeSupportedDashboardSizes: ["Block1x1","Block2x1"],
///     nodeCurrentPixelSize: {width: 580, height: 580}
///     nodeCurrentBlockSize: "Block4x1"
///     reportSubtitle: "31.12.2019",
///     reportTitle: "Investment Grade Global II",
///     reportURL: "https://domain.com/report/xyz/date/"
/// }
/// ```
/// </example>
Machinata.Reporting.Node.compileNodeInfos = function (instance, config, json) {
    // Infos based on generic node
    var infos = {};
    infos.nodeURL = json.url;
    infos.nodeId = json.id;
    infos.nodeScreen = json.screenNumber;
    infos.nodeTitle = Machinata.Reporting.Text.resolve(instance,json.mainTitle);
    infos.nodeSubtitle = Machinata.Reporting.Text.resolve(instance,json.subTitle);
    infos.nodeSupportedDashboardSizes = json.supportedDashboardSizes;
    infos.nodeCurrentPixelSize = Machinata.Reporting.Node.getSize(instance, config, json, Machinata.Reporting.Node.getElementByID(instance, json.id));
    infos.nodeCurrentBlockSize = Machinata.Reporting.Node.getBlockSize(instance, config, json, Machinata.Reporting.Node.getElementByID(instance, json.id));
    if (instance.reportData != null) infos.reportTitle = Machinata.Reporting.Text.resolve(instance, instance.reportData.reportTitle)
    if (instance.reportData != null) infos.reportSubtitle = Machinata.Reporting.Text.resolve(instance, instance.reportData.reportSubtitle)
    if (config != null) infos.reportURL = config.url;

    // Infos based on implementation
    // Not needed...
    //var impl = Machinata.Reporting.Node[json.nodeType];
    //if (impl != null) {
    //    
    //}

    return infos;
};



/// <summary>
/// Registers the export tool with the given options. 
/// Any export option will then call the export implementation method.
/// options: json key value.
/// </summary>
Machinata.Reporting.Node.registerExportOptions = function (instance, config, json, nodeElem, opts) {
    if (json.disableExport == true) return;

    Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.export"), "export", function () {


        Machinata.optionsDialog(Machinata.Reporting.Text.translate(instance, "reporting.nodes.export"), Machinata.Reporting.Text.translate(instance, "reporting.nodes.export.what-format"), opts)
            .okay(function (format) {
                // Get implementation
                var impl = Machinata.Reporting.Node[json.nodeType];

                // Create file title
                var title = Machinata.Reporting.Text.resolve(instance,json.mainTitle);
                var subtitle = Machinata.Reporting.Text.resolve(instance,json.subTitle);

                var filename = config.reportTitle;
                if (title != null) filename += " " + title;
                if (subtitle != null) filename += " " + subtitle;
                if (config.type != null) filename += " " + config.type;
                filename += "." + format;
                filename = filename.replaceAll(" ", "_");
                filename = filename.replaceAll("&", "-");
                filename = filename.replaceAll("/", "-");
                filename = filename.replaceAll(",", "");
                filename = filename.replaceAll("\\", "-");
                // Call implementation export
                var ret = impl.exportFormat(instance, config, json, nodeElem, format, filename);
                if (ret == false) {
                    Machinata.messageDialog(Machinata.Reporting.Text.translate(instance, "reporting.nodes.export"), Machinata.Reporting.Text.translate(instance, "reporting.nodes.export.format-no-available")).show()
                }
            })
            .show();
    });
};

/// <summary>
/// Destroyes a node by its id and removes it from the DOM, calling all appropriate handlers and cleanup routines (if any).
/// </summary>
Machinata.Reporting.Node.destoryByID = function (id) {
    // Find node
    var nodeElem = $("#" + id);

    // Call node-specific cleanup
    // ...nothing yet todo here

    // Remove
    nodeElem.remove();
};


/// <summary>
/// Gets a node JSON by its id.
/// </summary>
Machinata.Reporting.Node.getJSONByID = function (instance, id) {
    return instance.idToNodeJSONLookupTable[id];
};

/// <summary>
/// Gets a node element by its id.
/// </summary>
Machinata.Reporting.Node.getElementByID = function (instance, id) {
    return instance.idToNodeElementLookupTable[id];
};



/// <summary>
/// Gets a node's size. This is computed either via the actual DOM node element, or if existing, the pre-configured width/height in the node JSON.
/// The caller is responsible for calling this method at the correct time (ie when the DOM element is properly hooked into the document).
/// </summary>
Machinata.Reporting.Node.getSize = function (instance, config, json, nodeElem) {

    // Try via node element
    if (nodeElem != null && nodeElem.length == 1) return { width: nodeElem.width(), height: nodeElem.height() };

    // Try via the pre-configured size
    if (json.width != null && json.height != null) return { width: json.width, height: json.height() };

    // Return empty size
    return { width: null, height: null };
    //throw "Machinata.Reporting.Node.getSize doesnt work unless the node is being called via draw()";
    
};


/// <summary>
/// Gets a node's block size (or nearest matching block size). This is computed using the current
/// report width and calculating backwards the logical block size based on a 4-column grid for desktop and
/// 2-column grid for mobile.
/// Note: Block sizes reflect the actual block size, and may differ from a officially supported block size.
/// This especially applies to nodes that don't use a block layout.
/// </summary>
Machinata.Reporting.Node.getBlockSize = function (instance, config, json, nodeElem) {
    // Sanity
    if (nodeElem == null || nodeElem.length == 0) return null;

    var gridColumns = 4;
    var size = Machinata.Reporting.Node.getSize(instance, config, json, nodeElem);
    var reportWidth = nodeElem.closest(".machinata-reporting-report").width();
    if (reportWidth < Machinata.Reporting.Responsive.LAYOUT_WIDTH_MOBILE) gridColumns = 2; //TODO: refactor this out
    var gridColumnWidth = reportWidth / gridColumns;
    var nodeBlockWidth = size.width / gridColumnWidth;
    var nodeBlockHeight = size.height / gridColumnWidth;

    var blockSize = "Block" + Math.round(nodeBlockWidth) + "x" + Math.round(nodeBlockHeight);
    return blockSize;

};

/// <summary>
/// </summary>
Machinata.Reporting.Node.resize = function (instance, config, json, nodeElem) {
    
    var layout = Machinata.Reporting.Responsive.getReportLayout(instance);

    if (json.responsiveSize != null) {
        var responsiveDefinitionForLayout = null;
        if (json.responsiveSize[layout] != null) responsiveDefinitionForLayout = json.responsiveSize[layout];
        else responsiveDefinitionForLayout = json.responsiveSize["default"];
        if (responsiveDefinitionForLayout != null) {
            var containerElem = nodeElem.parent();
            if (responsiveDefinitionForLayout.width != null) {
                var newSize = Machinata.Reporting.Layouts.calculateSizeForBlockOrColumn(instance, config, responsiveDefinitionForLayout.width, containerElem.width(), containerElem.height());
                nodeElem.css("width",newSize.width+"px"); // you cannot use the logical .width() since this takes box model into account
            }
            if (responsiveDefinitionForLayout.height) {
                var newSize = Machinata.Reporting.Layouts.calculateSizeForBlockOrColumn(instance, config, responsiveDefinitionForLayout.height, containerElem.width(), containerElem.height());
                nodeElem.css("height", newSize.height + "px"); // you cannot use the logical .width() since this takes box model into account
            }
            if (responsiveDefinitionForLayout.size) {
                var newSize = Machinata.Reporting.Layouts.calculateSizeForBlockOrColumn(instance, config, responsiveDefinitionForLayout.size, containerElem.width(), containerElem.height());
                nodeElem.css("width", newSize.width + "px"); // you cannot use the logical .width() since this takes box model into account
                nodeElem.css("height", newSize.height + "px"); // you cannot use the logical .width() since this takes box model into account
            }
        } else {
            console.warn("Machinata.Reporting.Node.resize: node responsiveSize was set but no layout could be resolved for "+layout+". You should set a default.");
        }
    }


};

/// <summary>
/// NOT YET SUPPORTED
/// </summary>
Machinata.Reporting.Node.widthInPercentOfContainer = function (config, json, nodeElem) {
    throw "This doesnt work unless the node is being called via draw()";
    //TODO
};



/// <summary>
/// NOT YET SUPPORTED
/// </summary>
Machinata.Reporting.Node.redrawChildren = function (config, json, nodeElem) {
    throw "NOT SUPPORTED";
    //TODO
};


/// <summary>
/// </summary>
/// <example>
/// ## Legend Data
/// ```
/// [
///    {
///       "title": {"resolved":"Aligned"},
///       "symbol": "square",
///       "colorShade": "positive-bg"
///    }
/// ]
/// ```
/// </example>
Machinata.Reporting.Node.createHTMLLegendElem = function (instance, config, nodeJSON, legendData, opts) {
    // Init
    if (opts == null) opts = {};

    // Legend
    var legendElem = $("<div class='legend'/>");
    for (var i = 0; i < legendData.length; i++) {
        var legendItem = legendData[i];
        var itemElem = $("<div class='legend-item'><div class='legend-symbol'></div><div class='legend-title'></div></div>").appendTo(legendElem);
        var color = legendItem.colorShade != null ?
            Machinata.Reporting.getThemeColorByShade(config, nodeJSON.theme || "default", legendItem.colorShade)
             :
            Machinata.Reporting.getThemeColorByIndex(nodeJSON.theme || "default", i);
        itemElem.find(".legend-title").text(Machinata.Reporting.Text.resolve(instance, legendItem.title));
        itemElem.find(".legend-symbol")
            .css("background-color", color)
            .addClass("symbol-" + legendItem.symbol)
            .addClass("shade-" + legendItem.colorShade);
    }
    return legendElem;
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-error.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-error.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Displays an error to the user. This should only be used if the report (or a part) 
/// has failed and should only reach the end user on  staging/testing environment.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.ErrorNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ErrorNode.defaults = {};

/// <summary>
/// No toolbar needed. By default ```false```.
/// </summary>
Machinata.Reporting.Node.ErrorNode.defaults.supportsToolbar = false;

/// <summary>
/// The error message to display.
/// </summary>
Machinata.Reporting.Node.ErrorNode.defaults.error = null;

/// <summary>
/// The error code to include (optional).
/// </summary>
Machinata.Reporting.Node.ErrorNode.defaults.code = null;

/// <summary>
/// The message to display to the sure (optional).
/// This is a resolved text.
/// </summary>
Machinata.Reporting.Node.ErrorNode.defaults.message = null;

/// <summary>
/// The style of the error node to use. If ```null``` (the default), a general
/// styled error node is created to ensure visibility (using a standard debug panel),
/// otherwise the style drives the design of the error node.
/// </summary>
Machinata.Reporting.Node.ErrorNode.defaults.style = null;

/// <summary>
/// </summary>
Machinata.Reporting.Node.ErrorNode.init = function (instance, config, json, nodeElem) {
    // We have two types of errors, plain generated debug panel nodes, and styled error nodes
    if (json.styles == null || json.styles.length == 0) {
        // No style - build a standard debug panel
        var errorOpts = {};
        if (json.code != null) errorOpts["Code"] = json.code;
        if (json.error != null) errorOpts["Error"] = json.error;
        var msgToShow = "Error: " + json.error;
        if (json.message != null) msgToShow = Machinata.Reporting.Text.resolve(instance,json.message);
        var errorElem = Machinata.UI.createDebugPanel(msgToShow, errorOpts).addClass("option-error");
        nodeElem.append(errorElem);
    } else {
        // With style - build a simple dom to be styled via css...
        var bgElem = $("<div class='node-bg'></div>").appendTo(nodeElem);
        var messageElem = $("<div class='message'></div>").text(Machinata.Reporting.Text.resolve(instance,json.message)).appendTo(bgElem);
        if (json.code != null) var codeElem = $("<div class='code'></div>").text(json.code).appendTo(bgElem);
        if (json.error != null) var errorElem = $("<div class='error'></div>").text(json.error).appendTo(bgElem);
    }

};
Machinata.Reporting.Node.ErrorNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-debug.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-debug.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// A very simple node that displays a debug message when ```Machinata.DebugEnabled``` is ```true```.
/// To enable this mode, use ```debug=true``` in the query string for any report URL.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.DebugNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.DebugNode.defaults = {};

Machinata.Reporting.Node.DebugNode.defaults.supportsToolbar = false;

/// <summary>
/// The debug message to show (string).
/// </summary>
Machinata.Reporting.Node.DebugNode.defaults.message = false;

Machinata.Reporting.Node.DebugNode.init = function (instance, config, json, nodeElem) {

    if (Machinata.DebugEnabled == true) {
        var errorElem = Machinata.UI.createDebugPanel(json.message, {}).addClass("option-warning");
        nodeElem.append(errorElem);
    }

};
Machinata.Reporting.Node.DebugNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-info.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-info.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// A very simple node that displays a info message for testing and demonstration
/// purposes. A user on a production system should not see this.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.InfoNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.InfoNode.defaults = {};

/// <summary>
/// This node does not support a toolbar.
/// </summary>
Machinata.Reporting.Node.InfoNode.defaults.supportsToolbar = false;

/// <summary>
/// Defines the type of info. Can either be ```'info'``` or ```'warning'```.
/// </summary>
Machinata.Reporting.Node.InfoNode.defaults.infoType = "info";

/// <summary>
/// The info message to show (string).
/// </summary>
Machinata.Reporting.Node.InfoNode.defaults.message = null;

/// <summary>
/// </summary>
Machinata.Reporting.Node.InfoNode.defaults.chrome = "solid";


Machinata.Reporting.Node.InfoNode.init = function (instance, config, json, nodeElem) {

    var msg = json.message;
    //msg = Machinata.Reporting.Text.resolve(instance,msg);

    var bgElem = $("<div class='node-bg'></div>").appendTo(nodeElem);
    var messageElem = $("<div class='message'></div>").text(msg).appendTo(bgElem);
    if (json.infoType == "warning") messageElem.prepend(Machinata.Reporting.buildIcon(instance,"alert"));
    else messageElem.prepend(Machinata.Reporting.buildIcon(instance,"info"));

};
Machinata.Reporting.Node.InfoNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-parser-test.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-parser-test.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.ParserTestNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ParserTestNode.defaults = {};

/// <summary>
/// This node does not support a toolbar.
/// </summary>
Machinata.Reporting.Node.ParserTestNode.defaults.supportsToolbar = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.ParserTestNode.defaults.chrome = "solid";


Machinata.Reporting.Node.ParserTestNode.init = function (instance, config, json, nodeElem) {

    var filter = json.filter;
    if (json.isAny != null) filter = Machinata.Parser.convertIsAnyArrayToTextFilter(json.isAny);
    if (json.notAny != null) filter = Machinata.Parser.convertNotAnyArrayToTextFilter(json.notAny);

    var result = null;
    try {
        result = Machinata.Parser.parseTextFilter(filter, json.input);
    } catch (error) {
        result = "error: " + error;
    }

    nodeElem.addClass("type-InfoNode");
    var bgElem = $("<div class='node-bg'></div>").appendTo(nodeElem);
    $("<div class='message'></div>").text("Input: " + json.input).appendTo(bgElem);
    $("<div class='message'></div>").text("Filter: " + filter + (json.isAny != null ? " (isAny:" + JSON.stringify(json.isAny) + ")" : "") + (json.notAny != null ? " (notAny:" + JSON.stringify(json.notAny) + ")" : "")).appendTo(bgElem);
    $("<div class='message'></div>").text("Expected: " + json.expected + (json.expected == result ? "" : " !!! <<<<<<")).appendTo(bgElem);
    $("<div class='message'></div>").text("Result: " + result).appendTo(bgElem);
    if (json.expected != result) bgElem.css("background-color", "red");

};
Machinata.Reporting.Node.ParserTestNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-section.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-section.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Inserts a basic title element (h1,h2,h3...).
/// These SectionNodes serve as a way to logically split a report into 
/// different chapters and sections, and can be used to build an overview or table-of-contents.
///
/// ## Title Level
/// To support different types of readers and print-modes, the SectionNode
/// will automatically create the appropriate hN-element based on it's ```titleLevel``` 
/// int setting or the style name. If the style name for example contains ```h1```, a html node
/// ```<h1/>``` will be inserted.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.SectionNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.SectionNode.defaults = {};
Machinata.Reporting.Node.SectionNode.defaults.supportsToolbar = false;

/// <summary>
/// If ```true```, the SectionNode is ignored if it has no ```style``` or the ```style``` is ```null```.
/// </summary>
Machinata.Reporting.Node.SectionNode.defaults.ignoreIfStyleIsNull = false;

/// <summary>
/// If set, defines the level of the h1,h2,h3... html element.
/// </summary>
Machinata.Reporting.Node.SectionNode.defaults.titleLevel = null;


Machinata.Reporting.Node.SectionNode.init = function (instance, config, json, nodeElem) {

    // Init
    var styleName = null;
    if (json.styles != null && json.styles.length > 0) styleName = json.styles[0];

    // Ignore?
    if (json.ignoreIfStyleIsNull == true && styleName == null) return;

    // Derive the title level (h1,h2,h3...) from the style
    if (styleName != null) {
        if (styleName.toLowerCase().contains("h1")) json.titleLevel = 1;
        else if (styleName.toLowerCase().contains("h2")) json.titleLevel = 2;
        else if (styleName.toLowerCase().contains("h3")) json.titleLevel = 3;
        else if (styleName.toLowerCase().contains("h4")) json.titleLevel = 4;
        else if (styleName.toLowerCase().contains("h5")) json.titleLevel = 5;
        else if (styleName.toLowerCase().contains("h6")) json.titleLevel = 6;
    }
    if (json.titleLevel == null) json.titleLevel = 1; // fallback

    // Create H html element
    var titleElem = $("<h" + json.titleLevel + "></h" + json.titleLevel + ">");
    titleElem.addClass("section-title");
    titleElem.text(Machinata.Reporting.Text.resolve(instance,json.mainTitle));
    titleElem.attr("id", "toc_" + Machinata.Reporting.uid());
    if (styleName != null) titleElem.addClass(styleName);
    nodeElem.append(titleElem);

};
Machinata.Reporting.Node.SectionNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-paragraph.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-paragraph.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Basic paragraph node for displaying a block of text.
/// The node style will drive the look the paragraph.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.ParagraphNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ParagraphNode.defaults = {};

/// <summary>
/// By default ParagraphNode have a ```light``` chrome.
/// </summary>
Machinata.Reporting.Node.ParagraphNode.defaults.chrome = "light";

/// <summary>
/// This node does not support being added to dashboards...
/// </summary>
Machinata.Reporting.Node.ParagraphNode.defaults.supportsDashboard = false;

/// <summary>
/// The main body resolvable text to display.
/// </summary>
Machinata.Reporting.Node.ParagraphNode.defaults.content = null;

/// <summary>
/// The lead resolvable text to display ontop of the main body.
/// Typically, the design will place this much larger than main text body.
/// </summary>
Machinata.Reporting.Node.ParagraphNode.defaults.lead = null;

/// <summary>
/// If true, adds a shortcut tool for copying the text to clipboard.
/// </summary>
Machinata.Reporting.Node.ParagraphNode.defaults.addCopyToClipboardTool = false;

Machinata.Reporting.Node.ParagraphNode.init = function (instance, config, json, nodeElem) {

    // Init texts
    var leadTextType = "h3";
    var contentTextType = "p";
    //if (json.style == "overviewParagraphStyle") {
    //    leadTextType = "h2";
    //    contentTextType = "h3";
    //}
    var leadText = Machinata.Reporting.Text.resolve(instance,json["lead"]);
    var contentText = Machinata.Reporting.Text.resolve(instance,json["content"]);

    // Create lead element
    var containerElem = $("<div class='body node-bg'></div>");
    if (leadText != null) {
        var elem = $("<" + leadTextType + "></" + leadTextType + ">");
        elem.addClass("lead");
        elem.text(leadText);
        containerElem.append(elem);
    }

    // Create content element
    if (contentText != null) {
        var paragraphs = contentText.split("\n");
        $.each(paragraphs, function (index, p) {
            var elem = $("<" + contentTextType + "></" + contentTextType + ">");
            elem.addClass("content");
            elem.text(p);
            containerElem.append(elem);
        });
    }

    nodeElem.append(containerElem);

    // Tools
    if (json.addCopyToClipboardTool == true) {
        Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.copy-to-clipboard"), "copy", function () {
            Machinata.UI.copyElementToClipboard(containerElem);
            Machinata.messageDialog(Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied'), Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied.text')).show();
        });
    }

};
Machinata.Reporting.Node.ParagraphNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-table.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-table.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// A table node using HTML elements.
/// Supports filters, sticky headers, sorting and automatic grouping and merging of headers.
///
/// ## Sorting Rows
/// By default all tables can be sorted by clicking on the column headers. If a table has nested rows, then
/// only the first level is sorted. Row dimension groups always stay in place, regardless of the sort. This
/// means that all sorting happens within each row dimension group.
///
/// ## Filterting Rows
/// You can include a simple row search & filter tool by setting ```allowRowFiltering``` to ```true```.
/// Note that totals are not updated when filtering, as well as other cells that might lose 
/// meaning if neighboring rows are hidden due to filters. Thus one must consider the type of data to enable this feature on.
///
/// Filters can contain some minimal semantic:
///  - exact match: ```'text'```
///  - not: ```!'text'```
///  - less than: ```<100``` (also ```<=```)
///  - greater than: ```>100``` (also ```<=```)
///  - and: ```>100 and <102```
///  - or: ```'USD' or 'EUR'```
///  - range: ```10 - 30```
/// 
/// As soon as a filter contains logical semantic (such as or, and, !), texts must be escaped. This allows
/// for the best of both worlds: a lazy input such as "hello" with does a partial match search, and
/// the powerful mode with semantics for exact match filtering such as ("'hello'").
///
/// You can set pre-defined filters using the ```filters``` property.
///
/// ## Nested Rows
/// Rows can be nested by including an additional array of dimension elements as ```childRows``` for each row 
/// dimension element. For nested rows, especially when ```nestedRowsAreInteractive``` is ```true```, each row
/// can be preconfigured as expanded or collapsed through it's ```expanded``` property.
///
/// ## Linking Rows and Cells
/// Any cell (fact) can be linked by setting the ```link````property on the fact. 
/// Additionaly, an entire row can be linked by setting the row dimension element ```link````property.
/// Furthermore, one can also link only the row label (the first cell in the row) by setting the row dimension element ```labelLink````property.
/// A column header can be linked by setting the column dimension element ```labelLink````property. When linking column headers, one must ensure that other functionality such as ```allowRowSorting``` and ```allowRowFiltering``` are disabled. In general, it is not suggested to use column header links.
/// 
/// All links follow the standard linking API (see Machinata.Reporting.Node.Defaults.link).
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.VerticalTableNode = {};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults = {};

/// <summary>
/// By default, tables have a ```light``` chrome.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.chrome = "light";

/// <summary>
/// This node does not support being added to dashboards...
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.supportsDashboard = false;

/// <summary>
/// Defines the minimum number of rows that the table must have before the header
/// automatically becomes sticky.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.stickyHeadersMinRows = 5;

/// <summary>
/// If enabled, the user may configure the table columns through a basic configuration UI.
/// If you would like a column to be initially hidden, you can set the property ```display``` to
/// ```false``` on a column.
/// You can use this setting together with column ```importance``` and the node setting ```maxColumnImportanceForDisplay``` to
/// automatically set a grouped set of columns that are initially displayed to the user.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.allowColumnConfiguration = false;

/// <summary>
/// If enabled, the user may filter the table row. Row filtering should only be enabled
/// on large tables where searching for cells makes sense. Tables with calculated totals 
/// and row filtering may provide a confusing (and inaccurate) view. You cannot row filter
/// nested tables.
/// By default this is ```false```.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.allowRowFiltering = false;

/// <summary>
/// If enabled, the row filters are shown for all the columns of the table.
/// If ```allowRowFiltering``` is enabled, ```allowRowFiltering``` will show the filters when the user uses the
/// corresponding toolbar tool.
/// By default this is ```false```.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.showRowFiltering = false;

/// <summary>
/// If enabled, the user may sort the table rows using the column headers. 
/// If any header cell has a link, this feature is automatically disabled.
/// By default this is ```true```.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.allowRowSorting = true;

/// <summary>
/// If not null, header groups are only displayed if they meet this minimum count.
/// By default this is ```2``` (meaning that a single group is not shown).
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.headerGroupsMinimumRequired = 2;

/// <summary>
/// If true, header groups are not shown if they have no labels. This takes into account empty-string group labels as well 
/// (meaning that if all header groups have empty string labels, they will not be shown).
/// By default this is ```true```.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.headerGroupsHideIfNoLabels = true;

/// <summary>
/// If true, row group headers are not shown if they have no labels. This takes into account empty-string group labels as well 
/// By default this is ```true```.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.rowGroupHeadersHideIfNoLables = true;

/// <summary>
/// If true, header groups are spaced using DOM table cells.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.insertHeaderSpacerCells = false;

/// <summary>
/// If an integer, each column or column group is automatically evaluated to and it's ```display``` value is automatically
/// set based on if it has a lower or equal ```importance``` than ```maxColumnImportanceForDisplay```.
/// If ```null```, this property has no effect.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.maxColumnImportanceForDisplay = null;

/// <summary>
/// If ```true```, nested rows are able to be collapsed and expanded by the user.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.nestedRowsAreInteractive = true;

/// <summary>
/// If ```true```, grouped rows with header facts are able to be collapsed and expanded by the user.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.groupedRowsAreInteractive = true;

/// <summary>
/// If ```true```, the user can easily copy the table to clipboard.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.addCopyToClipboardTool = true;

/// <summary>
/// If ```true```, line-breaks (\n) will be rendered in the table data (cells).
/// This is achieved using the CSS stack and ```white-space: pre-line```
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.defaults.insertLineBreaksInCells = true;

/// <summary>
/// If set, a drilldown binding from this table (source table) to a other table (target table) is automatically created for all table cells.
/// This is especially useful if creating pivot-like tables, where one pivoted table data links to
/// the full data set.
///
/// To get the automatic system to work, one should set the following properties for 
/// ```automaticTableDrilldown```:
///  - ```tableNodeId```: the node id of the target table to which to drilldown to
///  - ```tableColumnIdForRow```: the target column id which is mapped from the source table
///  - ```tableColumnIdForColumn```: the target column id which is mapped from the source table
///  - ```tableColumnIdForTotal```: the source column id which represents the total column (needed to change the drilldown behaviour to on total columns)
///  - ```tableRowIdForTotal```: the source row id which represents the total row (needed to change the drilldown behaviour to on total rows)
/// 
/// Of course, the ```automaticTableDrilldown``` data must match exactly the ids of the 
/// tables which are to be bound together.
///
/// Internally, this feature will generate links on the various facts, column headers, or row labels using
/// the ```link.drilldown``` feature (see Machinata.Reporting.Node.Defaults.link).
///
/// Note: one can also individually bind rows via ```automaticTableDrilldown``` on a row element.

/// For more information on table filters, see ```Machinata.Reporting.Node.VerticalTableNode.defaults.filters```.
/// </summary>
/// <example>
/// ## Automtic drilldown:
/// ```
/// "automaticTableDrilldown": {
///     "tableNodeId": "tableForDrilldown1",
///     "tableColumnIdForRow": "Type",
///     "tableColumnIdForColumn": "Currency",
///     "tableColumnIdForTotal": "Total",
///     "tableRowIdForTotal": "Total"
/// }
/// ```
/// ## Custom Drilldown from table cell (fact) using filter value:
/// ```
/// "link": {
///     "nodeId": "tableForDrilldown1",
///         "drilldown": {
///         "filters": [
///             {
///                 "columnId": "Currency",
///                 "value": "EUR"
///             },
///             {
///                 "columnId": "Type",
///                 "expression": "!'BUY'"
///             }
///         ]
///     },
///     "tooltip": { "resolved": "Custom drilldown on BUY EUR" }
/// }
/// ```
/// ## Custom Drilldown from table cell (fact) using isAny/notAny:
/// ```
/// "link": {
///     "nodeId": "tableForDrilldown1",
///         "drilldown": {
///         "filters": [
///             {
///                 "columnId": "Currency",
///                 "isAny": ["EUR"]
///             },
///             {
///                 "columnId": "Type",
///                 "notAny": ["BUY"]
///             }
///         ]
///     },
///     "tooltip": { "resolved": "Custom drilldown on BUY EUR" }
/// }
/// ```
/// </example>
Machinata.Reporting.Node.VerticalTableNode.defaults.automaticTableDrilldown = null;


/// <summary>
/// If set, one can define a predefined set of filters to apply to the table.
/// Typically this is used along with ```allowRowFiltering``` and ```showRowFiltering```, however these
/// do not need to be enabled to apply the filtering.
///
/// The filters are provided as an array of filters, where each filter can have the following properties:
///  - ```columnId```: the id of the column to which the filter applies to (string) (required)
///  - ```name```: the name of the filter for a named filter. If this is provided then the filter will be visualized as a single (removable) tag in the filter input field. (string) (optional)
///
/// Each filter must have one of the following type of filtering properties (only one):
///  - ```value```: the string value to be filtered for. Values are automatically escaped (string) 
///  - ```expression```: a filter expression to filter for. For more details on expression see below. (string)
///  - ```isAny```: an array of strings to filter for using OR. This will automatically create the appropriate expression. (string array)
///  - ```notAny```: an array of strings to filter against using !AND. This will automatically create the appropriate expression. (string array)
///
/// ## Multiple Filters Per Column
/// When using multiple filters for a single column (ie multiple filters have the same columnId),
/// the filters are combined as AND. Adding multiple filters for a single column is only recommended via named filters,
/// as expression or value filters cannot be properly displayed to the user.
/// 
/// ## Expressions
/// Expressions in filters allow for some simple yet powerful syntax within filters. The expression language
/// has been purposefully crafted with the end-user in mind, which can use expressions from the table filters UI.
/// The expression parser behind the filters is provided by ```Machinata.Parser.parseTextFilter```.
/// 
/// The following filter expressions are supported:
///  - exact match: ```"keyword"```,```'keyword'```
///  - not: ```!"keyword"```, ```!100```
///  - less than: ```< 100```, ```<100```, ```<= 100```
///  - greater than: ```> 100```, ```>100```, ```>= 100```
///  - and: ```> 100 and < 102```
///  - or: ```'EUR' or 'USD'```
///  - range: ```10 - 30```
///
/// String literals are provided by the ```'``` or ```"``` character, and can be escaped through ```\'``` or ```\"``` characters.
/// The util method Machinata.Parser.escapeString can be used to escape a string.
///
/// Numbers are represented through the regex ```/^-?\d+\.?\d*$/``` and table cell content is normalized to basic types
/// using ```Machinata.Parser.normalizeStringInputToBasicType```, where some characters (```'``` and ```,```) are stripped before testing for number.
///
/// Note: when using expressions you must use the ```expression``` property.
/// 
/// </summary>
/// <example>
/// ```
/// ## Simple filters:
/// ```
/// "filters": [
///     {
///         "columnId": "Currency",
///         "value": "EUR"
///     },
///     {
///         "columnId": "Type",
///         "expression": "!'BUY'"
///     }
/// ]
/// ```
/// ## Filters using isAny/notAny:
/// ```
/// "filters": [
///     {
///         "columnId": "Currency",
///         "isAny": ["EUR"]
///     },
///     {
///         "columnId": "Type",
///         "notAny": ["BUY"]
///     }
/// ]
/// ```
/// ## Named filters:
/// ```
/// "filters": [
///     {
///         "columnId": "Currency",
///         "isAny": ["EUR","CHF","USD","JPY"],
///         "name": "Others"
///     },
///     {
///         "columnId": "Type",
///         "expression": "'Other' or 'Cash and Cash Equivalents' or 'FX'",
///         "name": "Others"
///     }
/// ]
/// ```
/// </example>
Machinata.Reporting.Node.VerticalTableNode.defaults.filters = null;

/// <summary>
/// Common helper routing for building a HTML table with the given table JSON data.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.buildTable = function (instance, config, json, nodeElem, opts) {
    // Options
    if (opts == null) opts = {};
    if (opts.interactive == null) opts.interactive = true; 
    if (opts.includeFormattingInformation == null) opts.includeFormattingInformation = false;
    
    // Create table elem
    var tableElem = $("<table class='machinata-reporting-table'></table>");
    var tableHeadElem = $("<thead class='table-head'></thead>").appendTo(tableElem);

    // Init
    var allGroupLabelsEmpty = true;
    var columnIdToColumnMap = {}; // contains a map from column ids to their column defintions
    var columnIdToGroupMap = {}; // contains a map from column ids to their groups
    var groupNumber = 0;
    var dataRequiresStatsCompilation = false;
    var didAddRowLabel = false; // set to true if any row contains a label
    var numColumns = 0;

    // Line breaks?
    if (json.insertLineBreaksInCells == true) {
        tableElem.addClass("option-white-space-as-newlines");
    }

    // Preflight for column selection
    $.each(json.columnDimension.dimensionGroups, function (index, groupJSON) {
        // Validate importance
        if (json.maxColumnImportanceForDisplay != null && groupJSON.importance != null && groupJSON.importance > json.maxColumnImportanceForDisplay) {
            if (groupJSON.display == null) groupJSON.display = false;
        }
        $.each(groupJSON.dimensionElements, function (index, columnJSON) {
            // Validate importance
            if (json.maxColumnImportanceForDisplay != null && columnJSON.importance != null && columnJSON.importance > json.maxColumnImportanceForDisplay) {
                if (columnJSON.display == null) columnJSON.display = false;
            }
        });
    });

    // Header groups
    var headerGroupsElem = $("<tr class='header groups'></tr>");

    // Placeholder for labels
    var headerGroupsLabelElem = $("<th class='label' data-col-id='LABEL'></th>").appendTo(headerGroupsElem);
    headerGroupsLabelElem.addClass("is-empty");
    $.each(json.columnDimension.dimensionGroups, function (index, groupJSON) {

        // Don't display?
        if (groupJSON.display == false) {
            return;
        }

        groupNumber++;

        // Spacer
        if (groupNumber > 1 && json.insertHeaderSpacerCells == true) {
            $("<th class='spacer'>&#160;</th>").appendTo(headerGroupsElem);
        }
        // Create th elem
        var headerElem = $("<th></th>").appendTo(headerGroupsElem);
        headerElem.attr("colspan", groupJSON.dimensionElements.length);
        headerElem.attr("data-grp-id", groupJSON.id);
        headerElem.addClass("group-type-" + groupJSON.groupType);
        if (groupJSON.valueType != null) headerElem.addClass("type-" + groupJSON.valueType);
        var groupText = Machinata.Reporting.Text.resolve(instance,groupJSON.name);
        if (groupText != null && groupText != "") allGroupLabelsEmpty = false;
        headerElem.text(groupText);
        headerElem.addClass("importance-" + groupJSON.importance);
    });
    // Add the header groups?
    // We only add header groups if the minimum number is reached and if they all have a label
    var addHeaderGroups = true;
    if (json.headerGroupsMinimumRequired != null && json.columnDimension.dimensionGroups.length < json.headerGroupsMinimumRequired) {
        addHeaderGroups = false;
    }
    if (json.headerGroupsHideIfNoLabels == true && allGroupLabelsEmpty == true) {
        addHeaderGroups = false;
    }
    if(addHeaderGroups == true) headerGroupsElem.appendTo(tableHeadElem);

    // Headers
    var headerRowElem = $("<tr class='header columns'></tr>").appendTo(tableHeadElem);
    var rowTemplateElem = $("<tr class='table-row'></tr>");
    groupNumber = 0;

    // Placeholder for labels
    var headerLabelElem = $("<th class='label' data-col-id='LABEL'></th>").appendTo(headerRowElem);//if (json.rowHeaderName != null) headerLabelElem.text(Machinata.Reporting.Text.resolve(instance,json.rowHeaderName));
    if (json.rowHeaderName != null) {
        headerLabelElem.text(Machinata.Reporting.Text.resolve(instance, json.rowHeaderName));
    } else {
        headerLabelElem.addClass("is-empty");
    }
    $("<td class='label' data-col-id='LABEL'></th>").appendTo(rowTemplateElem);
    $.each(json.columnDimension.dimensionGroups, function (index, groupJSON) {

        // Don't display?
        if (groupJSON.display == false) {
            return;
        }

        groupNumber++;

        // Spacer
        if (groupNumber > 1 && json.insertHeaderSpacerCells == true) {
            $("<th class='spacer'>&#160;</th>").appendTo(headerRowElem);
            $("<td class='spacer'>&#160;</th>").appendTo(rowTemplateElem);
        }
        // Columns
        $.each(groupJSON.dimensionElements, function (index, columnJSON) {
            numColumns++;

            // Don't display?
            if (columnJSON.display == false) {
                return;
            }

            // Init
            var headerTitle = Machinata.Reporting.Text.resolve(instance, columnJSON.name);

            // Register in map
            columnIdToColumnMap[columnJSON.id] = columnJSON;
            columnIdToGroupMap[columnJSON.id] = groupJSON;

            // Automatic table drilldown for column header?
            var automaticTableDrilldown = columnJSON.automaticTableDrilldown || json.automaticTableDrilldown;
            if (opts.interactive == true && automaticTableDrilldown != null && columnJSON.labelLink == null) {
                var cellFilters = [];
                var drilldownColumnID = columnJSON.id;
                var drilldownColumnJSON = columnIdToColumnMap[columnJSON.id];
                var drilldownColumnValue = Machinata.Reporting.Text.resolve(instance, drilldownColumnJSON.name);
                var drilldownTooltipValue = "";
                if (drilldownColumnID != automaticTableDrilldown.tableColumnIdForTotal) {
                    cellFilters.push({
                        "columnId": automaticTableDrilldown.tableColumnIdForColumn,
                        "isAny": [drilldownColumnValue],
                        "name": drilldownColumnValue
                    });
                    drilldownTooltipValue += " " + drilldownColumnValue;
                }
                columnJSON.labelLink = {
                    "nodeId": automaticTableDrilldown.tableNodeId,
                    "tooltip": { "resolved": Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on") + drilldownTooltipValue },
                    "drilldown": { "filters": cellFilters },
                };
                if (cellFilters.length == 0) columnJSON.labelLink.tooltip.resolved = Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on-total");
            }

            // Create th elem
            var headerElem = $("<th></th>").appendTo(headerRowElem);
            headerElem.addClass("column");
            headerElem.addClass("importance-" + columnJSON.importance);
            headerElem.addClass("type-" + columnJSON.valueType);
            headerElem.addClass("group-type-" + groupJSON.groupType);
            headerElem.attr("data-col-id", columnJSON.id);
            headerElem.text(headerTitle);

            // Label link?
            if (opts.interactive == true && columnJSON.labelLink != null) {
                headerElem.addClass("has-link");
                headerElem.attr("title", Machinata.Reporting.Text.resolve(instance, columnJSON.labelLink.tooltip));
                headerElem.click(function () {
                    if (columnJSON.labelLink.drilldown != null) {
                        tableElem.find(".selected-drilldown").removeClass("selected-drilldown");
                        headerElem.addClass("selected-drilldown");
                    }
                    Machinata.Reporting.Tools.openLink(instance, columnJSON.labelLink);
                });
                // Register so that we can later disable sorting
                json._state.headerLabelHasLink = true;
            }

            // Create td elem (for template)
            var tdElem = $("<td class='data'></td>").appendTo(rowTemplateElem);
            tdElem.attr("data-col-id", columnJSON.id);
            tdElem.addClass("type-" + columnJSON.valueType);
            tdElem.attr("data-type", columnJSON.valueType);

            // Special handling for grouped columns (such as bar charts
            if (groupJSON.groupType == "bars") {
                headerElem.text("");
                if (index == 0) {
                    headerElem.attr("colspan", groupJSON.dimensionElements.length);
                    tdElem.attr("colspan", groupJSON.dimensionElements.length);
                    headerElem.attr("data-th-grp-id", groupJSON.id);
                    tdElem.attr("data-td-grp-id", groupJSON.id);
                    dataRequiresStatsCompilation = true;
                } else {
                    headerElem.remove();
                    tdElem.remove();
                }
            }
        });

    });

    // Stats compilation?
    var tableStatsMinValue = {};
    var tableStatsMaxValue = {};
    if (dataRequiresStatsCompilation == true) {
        $.each(json.rowDimension.dimensionGroups, function (groupIndex, groupJSON) {
            $.each(groupJSON.dimensionElements, function (rowIndex, rowJSON) {

                // ROW

                $.each(rowJSON.facts, function (index, factJSON) {

                    // COLUMN
                    if (tableStatsMinValue[factJSON.col] == null || factJSON.val < tableStatsMinValue[factJSON.col]) {
                        tableStatsMinValue[factJSON.col] = factJSON.val;
                    }
                    if (tableStatsMaxValue[factJSON.col] == null || factJSON.val > tableStatsMaxValue[factJSON.col]) {
                        tableStatsMaxValue[factJSON.col] = factJSON.val;
                    }
                    var columnGroupJSON = columnIdToGroupMap[factJSON.col];
                    if (columnGroupJSON != null) {
                        if (tableStatsMinValue[columnGroupJSON.id] == null || factJSON.val < tableStatsMinValue[columnGroupJSON.id]) {
                            tableStatsMinValue[columnGroupJSON.id] = factJSON.val;
                        }
                        if (tableStatsMaxValue[columnGroupJSON.id] == null || factJSON.val > tableStatsMaxValue[columnGroupJSON.id]) {
                            tableStatsMaxValue[columnGroupJSON.id] = factJSON.val;
                        }
                    }
                    
                });
            });
        });
    }
    tableElem.addClass("num-columns-" + numColumns);
    if (numColumns == 1) tableElem.addClass("option-single-column");
    else tableElem.addClass("option-multi-column");

    // Row groups
    groupNumber = 0;
    json.numRows = 0;
    var maxRowColspan = 0;
    $.each(json.rowDimension.dimensionGroups, function (groupIndex, groupJSON) {

        // Register and create new tbody group
        groupNumber++;
        var tbodyElem = $("<tbody class='table-body'></tbody>").appendTo(tableElem);
        tbodyElem.addClass("importance-" + groupJSON.importance);
        tbodyElem.addClass("group-" + groupNumber);

        // Initial group header
        var groupName = Machinata.Reporting.Text.resolve(instance,groupJSON.name);
        var headerGroupRowJSON = null;
        if ((groupName != null && groupName != "") || json.rowGroupHeadersHideIfNoLables == false) {
            // Create header row
            var rowElem = createRow(json.numRows, groupJSON, 0, null, null);
            rowElem.addClass("group-header");
            rowElem.addClass("static"); // for tablesorter widget
            // Extract label
            var labelElem = rowElem.find("[data-col-id='LABEL']");
            if (labelElem.length == 0) {
                labelElem = rowElem.find("td").first(); // if no label, fallback to first cell
            } else {
                didAddRowLabel = true;
            }
            // Calculate colspan
            var colSpan = 1;
            var tdi = 1;
            var tdElems = rowElem.find("td");
            while (tdi < tdElems.length) {
                tdi++;
                var tdElem = tdElems.eq(tdi);
                if (tdElem.hasClass("has-definition")) {
                    break;
                } else {
                    tdElem.addClass("mark-for-deletion");
                    colSpan++;
                }
            }
            rowElem.find("td.mark-for-deletion").remove();
            if (colSpan > 1) {
                labelElem.attr("colspan", colSpan);
                labelElem.addClass("is-spanning");
            }
            if (colSpan > maxRowColspan) maxRowColspan = colSpan;
            if (json.groupedRowsAreInteractive == true && groupJSON.dimensionElements.length > 0) {
                // Register class
                rowElem.addClass("has-child-rows");
                tableElem.addClass("has-nested-rows");
                // Make clickable
                if (opts.interactive == true) {
                    if (groupJSON.expanded == false) {
                        rowElem.addClass("collapsed");
                    } else {
                        rowElem.addClass("expanded");
                    }
                    rowElem.find("td").first().prepend(Machinata.Reporting.buildIcon(instance,"expand")).prepend(Machinata.Reporting.buildIcon(instance,"collapse"));
                    rowElem.addClass("toggable");
                    rowElem.click(function () {
                        Machinata.Reporting.Node.VerticalTableNode._toggleRowInternal(tableElem, $(this));
                    });
                }
            }
            // Register
            headerGroupRowJSON = groupJSON;
        }
        tableElem.addClass("max-row-colspan-" + maxRowColspan);
        if (maxRowColspan > 1) {
            tableElem.addClass("has-row-with-colspan");
        }

        // Row create helper function
        function createRow(rowIndex, rowJSON, rowIndent, parentRowJSON, parentRowElem) {
            // ROW
            //if (rowIndex > 300) return; //TODO: @dan allow a dynamic UI for loading lots of rows
            var rowElem = rowTemplateElem.clone().appendTo(tbodyElem);
            rowElem.attr("data-row-id", rowJSON.id);
            rowElem.addClass("importance-" + rowJSON.importance);
            json.numRows++;
            var label = Machinata.Reporting.Text.resolve(instance, rowJSON.name);

            // Automatic table drilldown for entire row?
            var automaticTableDrilldown = rowJSON.automaticTableDrilldown || json.automaticTableDrilldown;
            if (opts.interactive == true && automaticTableDrilldown != null && rowJSON.labelLink == null) {
                var cellFilters = [];
                var drilldownRowValue = label;
                var drilldownRowId = rowJSON.id;
                var drilldownTooltipValue = "";
                if (drilldownRowId != automaticTableDrilldown.tableRowIdForTotal) {
                    cellFilters.push({
                        "columnId": automaticTableDrilldown.tableColumnIdForRow,
                        "isAny": [drilldownRowValue],
                        "name": drilldownRowValue
                    });
                    drilldownTooltipValue += " " + drilldownRowValue;
                }
                rowJSON.labelLink = {
                    "nodeId": automaticTableDrilldown.tableNodeId,
                    "tooltip": { "resolved": Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on") + drilldownTooltipValue },
                    "drilldown": { "filters": cellFilters },
                };
                if (cellFilters.length == 0) rowJSON.labelLink.tooltip.resolved = Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on-total");
            }
            
            // Parent or header?
            if (parentRowJSON != null && parentRowElem != null) {
                // Has a parent row
                rowElem.addClass("is-child-row");
                rowElem.addClass("tablesorter-childRow"); // for tablesorter widget
                rowElem.attr("data-parent-row-id", parentRowJSON.id);
                json.allowRowFiltering = false; // do not allow row filtering!
            } else if (json.groupedRowsAreInteractive == true && headerGroupRowJSON != null) {
                // Has header group
                rowElem.attr("data-parent-row-id", headerGroupRowJSON.id);
                if (groupJSON.expanded == false) {
                    rowElem.addClass("hidden");
                }
            }

            //TODO: 
            //if (rowJSON["class"] != null) rowElem.addClass("class-" + rowJSON["class"]);
            //if (rowJSON["class"] == "total") rowElem.addClass("static").attr("data-row-index", "100%");

            // Row label
            if (label != null && label != "") {
                didAddRowLabel = true;
                var labelElem = rowElem.find("[data-col-id='LABEL']"); //TODO: this is probably a performance bottleneck
                labelElem.text(label);
                labelElem.attr("data-text", rowJSON.sort || label);
                labelElem.attr("data-sort", rowJSON.sort || label);

                // Label link
                if (opts.interactive == true && rowJSON.labelLink != null) {
                    labelElem.addClass("has-link");
                    labelElem.attr("title", Machinata.Reporting.Text.resolve(instance, rowJSON.labelLink.tooltip));
                    labelElem.click(function () {
                        if (rowJSON.labelLink.drilldown != null) {
                            tableElem.find(".selected-drilldown").removeClass("selected-drilldown");
                            labelElem.addClass("selected-drilldown");
                        }
                        Machinata.Reporting.Tools.openLink(instance, rowJSON.labelLink);
                    });
                }
            } else {
                var labelElem = rowElem.find("[data-col-id='LABEL']"); //TODO: this is probably a performance bottleneck
                labelElem.addClass("is-empty");
            }

            // Indent?
            if (rowIndent == null) rowIndent = 0;
            if (rowJSON.indent != null) rowIndent += rowJSON.indent;
            if (rowIndent > 0) {
                rowElem.addClass("indent-" + rowIndent);
            }

            

            // Link?
            if (opts.interactive == true && rowJSON.link != null) {
                rowElem.addClass("has-link");
                rowElem.attr("title", Machinata.Reporting.Text.resolve(instance,rowJSON.link.tooltip));
                rowElem.click(function () {
                    if (rowJSON.link.drilldown != null) {
                        tableElem.find(".selected-drilldown").removeClass("selected-drilldown");
                        rowElem.addClass("selected-drilldown");
                    }
                    Machinata.Reporting.Tools.openLink(instance,rowJSON.link);
                });
            }

            // Row data columnms (facts)
            $.each(rowJSON.facts || rowJSON.headerFacts, function (index, factJSON) {

                // COLUMN

                // Automatic table drilldown for cell?
                if (opts.interactive == true && automaticTableDrilldown != null && factJSON.link == null) {
                    var cellFilters = [];
                    var drilldownRowValue = label;
                    var drilldownRowId = rowJSON.id;
                    var drilldownColumnID = factJSON.col;
                    var drilldownColumnJSON = columnIdToColumnMap[factJSON.col];
                    var drilldownColumnValue = Machinata.Reporting.Text.resolve(instance,drilldownColumnJSON.name);
                    var drilldownTooltipValue = "";
                    if (drilldownRowId != automaticTableDrilldown.tableRowIdForTotal) {
                        cellFilters.push({
                            "columnId": automaticTableDrilldown.tableColumnIdForRow,
                            "isAny": [drilldownRowValue],
                            "name": drilldownRowValue
                        });
                        drilldownTooltipValue += " " + drilldownRowValue;
                    }
                    if (drilldownColumnID != automaticTableDrilldown.tableColumnIdForTotal) {
                        cellFilters.push({
                            "columnId": automaticTableDrilldown.tableColumnIdForColumn,
                            "isAny": [drilldownColumnValue],
                            "name": drilldownColumnValue
                        });
                        drilldownTooltipValue += " " + drilldownColumnValue;
                    }
                    factJSON.link = {
                        "nodeId": automaticTableDrilldown.tableNodeId,
                        "tooltip": { "resolved": Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on") + drilldownTooltipValue },
                        "drilldown": { "filters": cellFilters },
                    };
                    if (cellFilters.length == 0) factJSON.link.tooltip.resolved = Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on-total");
                }

                // Find matching column
                // Normally, each fact has it's own column, but some are virtually combined into a single column as a group (such as bar charts)
                var dataElem = null;
                var columnGroupJSON = columnIdToGroupMap[factJSON.col]; // gets the column group defintion, if any
                if (columnGroupJSON != null && columnGroupJSON.groupType == "bars") {
                    dataElem = rowElem.find("[data-td-grp-id='" + columnGroupJSON.id + "']");

                    // Chart cell

                    if (columnGroupJSON.groupType == "bars") {
                        // Lookup theme
                        var columnName = factJSON.col;
                        var shade = config.themeColorShadeNames[0]; //fallback
                        $.each(columnGroupJSON.dimensionElements, function (index, columnJSON) {
                            if (columnJSON.id == factJSON.col) {
                                if (columnJSON.colorShade != null) {
                                    shade = columnJSON.colorShade;
                                } else {
                                    // Cycle all shades
                                    shade = Machinata.Reporting.Config.themeColorShadeNames[index % Machinata.Reporting.Config.themeColorShadeNames.length];
                                }
                                /* DEPRECATED:
                                // Do we have exactly two?
                                if (columnGroupJSON.dimensionElements.length == 2) {
                                    // Use neg/pos color shades
                                    columnName = Machinata.Reporting.Text.resolve(instance,columnJSON.name);
                                    if (index == 0) {
                                        if (factJSON.val < 0) shade = config.themeNegativePositiveShadeNames[0];
                                        else shade = config.themeNegativePositiveShadeNames[1];
                                    } else {
                                        if (factJSON.val < 0) shade = config.themeNegativePositiveGrayShadeNames[0];
                                        else shade = config.themeNegativePositiveGrayShadeNames[1];
                                    }
                                } else {
                                    // Cycle all shades
                                    shade = Machinata.Reporting.Config.themeColorShadeNames[index % Machinata.Reporting.Config.themeColorShadeNames.length];
                                }*/
                            }
                        });
                        // Get the relative value according to min max
                        var min = tableStatsMinValue[columnGroupJSON.id];
                        var max = tableStatsMaxValue[columnGroupJSON.id];
                        // Balance min/max
                        if (min < 0 && max > 0) {
                            if (Math.abs(min) < Math.abs(max)) min = max * -1;
                            else if (Math.abs(min) > Math.abs(max)) max = min * -1;
                        }
                        var val = factJSON.val;
                        var pPos = 0;
                        var pNeg = 0;
                        if (val > 0) pPos = val / max;
                        if (val < 0) pNeg = val / min;
                        var barsElem = $("<div class='balanced-bars'></div>");
                        var tooltip = columnName + ": " + factJSON.resolved;//todo col
                        // Positive bar
                        if (max >= 0) {
                            var barPositiveElem = Machinata.UI.microBar(pPos, tooltip).addClass("positive");
                            barPositiveElem.find(".bar").addClass("theme-bg-" + shade);
                            barsElem.append(barPositiveElem);
                            barsElem.addClass("has-positive");
                        }
                        // Negative bar
                        if (min < 0) {
                            var barNegativeElem = Machinata.UI.microBar(pNeg, tooltip).addClass("negative");
                            barNegativeElem.find(".bar").addClass("theme-bg-" + shade);
                            barsElem.append(barNegativeElem);
                            barsElem.addClass("has-negative");
                        }

                        dataElem.append(barsElem);
                    }
                } else {

                    // Text cell

                    // Find matching fact column and apply data
                    dataElem = rowElem.find("[data-col-id='" + factJSON.col + "']"); //TODO: this is probably a performance bottleneck
                    dataElem.text(factJSON.resolved);
                    if (opts.includeFormattingInformation == true) {
                        // Add raw value attribute
                        if (factJSON.val != null) {
                            dataElem.attr("data-value", factJSON.val);
                        } else {
                            dataElem.attr("data-value", factJSON.resolved);
                        }
                        // Add format attribute
                        //TODO: not yet integrated (see valueType instead)
                        //dataElem.attr("data-format", factJSON.val);
                    }
                    dataElem.attr("data-text", factJSON.sort || factJSON.resolved);
                    dataElem.attr("data-sort", factJSON.sort || factJSON.val);

                    // Overwrite type?
                    if (factJSON.valueType != null) {
                        dataElem.addClass("type-" + factJSON.valueType);
                        dataElem.attr("data-type", factJSON.valueType);
                    }

                    // Tooltip?
                    if (factJSON.tooltip != null) {
                        dataElem.attr("title", Machinata.Reporting.Text.resolve(instance,factJSON.tooltip));
                    }

                }

                // Mark as having explicit fact defintion
                dataElem.addClass("has-definition");

                // Link?
                if (opts.interactive == true && factJSON.link != null) {
                    dataElem.addClass("has-link");
                    dataElem.attr("title", Machinata.Reporting.Text.resolve(instance,factJSON.link.tooltip));
                    dataElem.click(function () {
                        if (factJSON.link.drilldown != null) {
                            tableElem.find(".selected-drilldown").removeClass("selected-drilldown");
                            dataElem.addClass("selected-drilldown");
                        }
                        Machinata.Reporting.Tools.openLink(instance,factJSON.link);
                    });
                }

                // Add alert?
                if (factJSON.alert != null) {
                    dataElem.addClass("has-icon");
                    var icon = factJSON.alert.icon;
                    if (icon == null) icon = "alert"; // fallback
                    var iconElem = Machinata.Reporting.buildIcon(instance, icon)
                        .addClass("alert")
                        .attr("title", Machinata.Reporting.Text.resolve(instance, factJSON.alert.hint || factJSON.alert.tooltip));
                    dataElem.prepend(iconElem);
                }

                // Add info?
                if (factJSON.info != null) {
                    dataElem.addClass("has-icon");
                    var icon = factJSON.info.icon;
                    if (icon == null) icon = "info"; // fallback
                    var iconElem = Machinata.Reporting.buildIcon(instance, icon)
                        .addClass("info")
                        .click(function () {
                            Machinata.Reporting.Tools.showInfoDialog(instance, config, factJSON.info);
                        })
                        .attr("title", Machinata.Reporting.Text.resolve(instance, factJSON.info.tooltip));
                    dataElem.append(iconElem);
                }

                // Add icon?
                if (factJSON.icon != null) {
                    dataElem.addClass("has-icon");
                    if (factJSON.icon == "trend") {
                        if (factJSON.val > 0) {
                            dataElem.addClass("green-number");
                            //dataElem.append("<span class='icon " + Machinata.Reporting.icon("trend-up") + "'></span>");
                            dataElem.append(Machinata.Reporting.buildIcon(instance,"trend-up"));
                        } else {
                            dataElem.addClass("red-number");
                            //dataElem.append("<span class='icon " + Machinata.Reporting.icon("trend-down") + "'></span>");
                            dataElem.append(Machinata.Reporting.buildIcon(instance,"trend-down"));
                        }
                    } else {
                        //dataElem.append("<span class='icon " + Machinata.Reporting.icon(factJSON.icon) + "'></span>");
                        dataElem.append(Machinata.Reporting.buildIcon(instance,factJSON.icon));
                    }
                }

                // Add tag?
                if (factJSON.tag != null) {
                    dataElem.addClass("has-tag");
                    var tagElem = $("<span class='tag'></span>");
                    var tagTitle = Machinata.Reporting.Text.resolve(instance, factJSON.tag.title);
                    tagElem.text(tagTitle);
                    if (factJSON.tag.colorShade != null) {
                        tagElem.css("background-color", Machinata.Reporting.getThemeColorByShade(config, json.theme, factJSON.tag.colorShade));
                        tagElem.css("color", Machinata.Reporting.getThemeTextColorByShade(config, json.theme, factJSON.tag.colorShade));
                    }
                    if (factJSON.tag.icon != null) {
                        tagElem.append(Machinata.Reporting.buildIcon(instance, factJSON.icon));
                    }
                    if (factJSON.tag.hint != null) {
                        tagElem.attr("title", Machinata.Reporting.Text.resolve(instance, factJSON.tag.hint));
                    }
                    dataElem.append(tagElem);
                    // Make sure to register in data-text (search/filter/export need this)
                    if (dataElem.attr("data-text") == null) {
                        dataElem.attr("data-text", tagTitle);
                    } else {
                        dataElem.attr("data-text", dataElem.attr("data-text")+" "+tagTitle);
                    }
                }

                // Add color?
                if (factJSON.color != null) {
                    if (factJSON.color == "green") dataElem.addClass("green-number");
                    else if (factJSON.color == "red") dataElem.addClass("red-number");
                    else console.warn("VerticalTableNode fact color " + factJSON.color + " is not supported!");
                }
            });

            // Nested rows?!
            if (rowJSON.childRows != null) {
                if (rowJSON.childRows.length > 0) {
                    // Register class
                    rowElem.addClass("has-child-rows");
                    tableElem.addClass("has-nested-rows");
                    // Make clickable
                    if (opts.interactive == true && json.nestedRowsAreInteractive == true) {
                        rowElem.addClass("toggable");
                        rowElem.find("td").first().prepend(Machinata.Reporting.buildIcon(instance,"expand")).prepend(Machinata.Reporting.buildIcon(instance,"collapse"));
                        rowElem.click(function () {
                            Machinata.Reporting.Node.VerticalTableNode._toggleRowInternal(tableElem, $(this));
                        });
                    }
                }
                $.each(rowJSON.childRows, function (childRowIndex, childRowJSON) {
                    createRow(childRowIndex, childRowJSON, rowIndent + 1, rowJSON, rowElem); //TODO: what do we do about the index?
                });

                Machinata.Reporting.Node.VerticalTableNode._toggleRowInternal(tableElem, rowElem, rowJSON.expanded != false);
            }

            return rowElem;
        }

        // Process each row
        $.each(groupJSON.dimensionElements, function (rowIndex, rowJSON) {

            var rowElem = createRow(rowIndex, rowJSON);

            // Last in group
            if (rowIndex == groupJSON.dimensionElements.length - 1 && groupIndex != json.rowDimension.dimensionGroups.length - 1) {
                rowElem.addClass("last-in-group");
            }
            
        });
    });

    // Post-processing

    // Did we never add a label?
    if (didAddRowLabel == false) {
        tableElem.find("td.label,th.label").remove();
    }

    // Show row filtering
    if (json.showRowFiltering == true) {
        tableElem.addClass("option-filter");
    }

    return tableElem;
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.VerticalTableNode._toggleRowInternal = function (tableElem, rowElem, show) {

    // Helper method for recursion...
    function _toggleAllChildrenRows(rowElem, show) {
        var selector = "[data-parent-row-id='" + rowElem.attr("data-row-id") + "']";
        var childRowElems = tableElem.find(selector);
        if (show == true) {
            childRowElems.removeClass("hidden");
        } else {
            childRowElems.addClass("hidden");
        }
        // Recurse
        childRowElems.each(function () {
            if (show == true && $(this).hasClass("collapsed")) return;
            _toggleAllChildrenRows($(this), show);
        });
    }

    // Parent state
    if (show == null) show = !rowElem.hasClass("expanded");
    if (show == true) {
        rowElem.addClass("expanded");
        rowElem.removeClass("collapsed");
    } else {
        rowElem.removeClass("expanded");
        rowElem.addClass("collapsed");
    }

    // Initial toggle
    _toggleAllChildrenRows(rowElem, show);
};



/// <summary>
/// Toggles a set of table columns or groups on the table.
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.toggleColumn = function (instance, config, json, nodeElem, colId, grpId, show) {
    if (show == null) show = true; //TODO: @dan

    // Init selection
    var tableElem = nodeElem.data("table");
    var elemsCols = null;
    var elemsGrps;
    if (colId != null) elemsCols =tableElem.find("[data-col-id='" + colId + "']");
    if (grpId != null) elemsGrps = tableElem.find("[data-grp-id='" + grpId + "']");

    // Toggle
    if (show == true) {
        if (elemsCols != null) elemsCols.show();
        if (elemsGrps != null) elemsGrps.show();
    } else {
        if (elemsCols != null) elemsCols.hide();
        if (elemsGrps != null) elemsGrps.hide();
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.rebuild = function (instance, config, json, nodeElem, containerElem) {
    if (containerElem == null) containerElem = nodeElem;

    // Already exists?
    if (nodeElem.data("table") != null) {
        nodeElem.data("table").remove();
    }

    // Create table elem
    var tableElem = this.buildTable(instance, config, json, nodeElem, {
        interactive: true
    });
    tableElem.data("node", nodeElem); // bind the nodeElem to the tableElem
    containerElem.append(tableElem);
    nodeElem.data("table", tableElem); // bind the tableElem to the nodeElem
    containerElem.data("table", tableElem); // bind the tableElem to the containerElem

    // Make sortable and filterabile
    // See https://mottie.github.io/tablesorter/docs/ for more documentation
    // Filter plugin: https://mottie.github.io/tablesorter/docs/example-node-filter.html
    // Static row plugin: https://mottie.github.io/tablesorter/docs/example-node-static-row.html
    if (json.allowRowSorting == true) {
        // Make sure we are not using json.automaticTableDrilldown and that no header has a link
        if (json.automaticTableDrilldown == null && json._state.headerLabelHasLink != true) {
            Machinata.Reporting.Tools.makeTableSortable(instance, tableElem);
        }
    }

    // Make filterable
    if (json.allowRowFiltering == true || json.filters != null) {
        Machinata.Reporting.Tools.makeTableFilterable(instance, tableElem, json.filters); // pass in the original filters, this saves us from having to refilter later...
    }

    // Make sticky, but only if it makes sense
    if (json.stickyHeadersMinRows != null && json.numRows > json.stickyHeadersMinRows && config.profile != "webprint") {
        // https://github.com/jmosbech/StickyTableHeaders
        tableElem.stickyTableHeaders({
            cacheHeaderHeight: true,
            fixedOffset: $('#header')
        });
        tableElem.on("enabledStickiness.stickyTableHeaders", function () {
            $(this).addClass("header-is-sticky");
        });
        tableElem.on("disabledStickiness.stickyTableHeaders", function () {
            $(this).removeClass("header-is-sticky");
        });
        // If we have a sidescroller, we must update the sticky table headers to match the scroll position
        if (tableElem.parent().hasClass("side-scroller")) {
            tableElem.parent()[0].addEventListener("scroll", function () {
                tableElem.trigger('resize.stickyTableHeaders');
            },false);
        }
    }

    return tableElem;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.showTableFilters = function (instance, nodeElem) {
    nodeElem.data("table").addClass("option-filter");
    nodeElem.find(".machinata-reporting-toolbar .tool-filter").addClass("active");
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.hideTableFilters = function (instance, nodeElem) {
    nodeElem.data("table").removeClass("option-filter");
    nodeElem.find(".machinata-reporting-toolbar .tool-filter").removeClass("active");
    Machinata.Filter.Tables.resetFilters(nodeElem.data("table"));
};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.init = function (instance, config, json, nodeElem) {
    var self = this;

    // Build container for table (side scroller)
    var containerElem = $("<div class='side-scroller'></div>").appendTo(nodeElem);
        
    // Initial rebuild
    Machinata.Reporting.Node.VerticalTableNode.rebuild(instance, config, json, nodeElem, containerElem);
    

    // Export
    Machinata.Reporting.Node.registerExportOptions(instance, config, json, nodeElem, {
        "xlsx": "Excel",
        "csv": "CSV",
    });


    // Copy
    if (json.addCopyToClipboardTool == true) {
        Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.copy-to-clipboard"), "copy", function () {
            // Create a raw copy of table
            //TODO: this doesnt include the filters sorts - do we want that?
            //TODO: LibreOffice doesnt copy table nicely
            var tempTableElem = self.buildTable(instance, config, json, nodeElem, {
                interactive: false
            });
            Machinata.Reporting.Tools.copyElementToClipboard(tempTableElem, Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied'), Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied.table'), true);
        });
    }

    // Filter
    if (json.allowRowFiltering == true) {
        // Add tool
        nodeElem.addClass("option-allow-row-filtering");
        var filterToolElem = Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.search-filter"), "filter", function (toolElem) {
            if (nodeElem.data("table").hasClass("option-filter")) {
                Machinata.Reporting.Node.VerticalTableNode.hideTableFilters(instance, nodeElem);
            } else {
                Machinata.Reporting.Node.VerticalTableNode.showTableFilters(instance, nodeElem);
            }
        }, "fullscreen-supported");

        // Do we have preset filters?
        if (json.filters != null) {
            // Toggle toolbar element
            nodeElem.data("table").addClass("option-filter");
            filterToolElem.addClass("active");
        }
    }

    // Column selection
    if (json.allowColumnConfiguration == true) {
        nodeElem.addClass("option-allow-column-configuration");
        Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.configure"), "configure", function () {
            // Create a UI for each column
            var diag = Machinata.messageDialog(Machinata.Reporting.Text.translate(instance, 'reporting.nodes.configure'), '');
            diag.elem.append($("<p></p>").text(Machinata.Reporting.Text.translate(instance, 'reporting.tables.select-columns')));
            var checkboxesElem = $("<div></div>");
            var checkboxesCount = 0;
            $.each(json.columnDimension.dimensionGroups, function (index, groupJSON) {
                $.each(groupJSON.dimensionElements, function (index, columnJSON) {
                    var checkboxUIElem = Machinata.Reporting.buildCheckbox(instance, Machinata.Reporting.Text.resolve(instance, columnJSON.name), columnJSON.display != false);
                    checkboxUIElem.find("input")
                        .attr("data-grp-id", groupJSON.id)
                        .attr("data-col-id", columnJSON.id)
                        .on("change", function () {
                            //TODO: limit max checked columns?
                            var checked = $(this).is(':checked');
                            columnJSON.display = checked;
                        });
                    /*var checkboxId = Machinata.Reporting.uid();
                    var checkboxUIElem = $('<div class="machinata-reporting-checkbox"><input type="checkbox"/><label></label></div>');
                    checkboxUIElem.find("label").append(Machinata.Reporting.buildIcon(instance,"check"));
                    checkboxUIElem.find("label")
                        .attr("for", checkboxId)
                        .append(Machinata.Reporting.Text.resolve(instance,columnJSON.name));
                    if(columnJSON.display != false) checkboxUIElem.find("input").attr("checked", "checked")
                    checkboxUIElem.find("input")
                        .attr("id", checkboxId)
                        .attr("data-grp-id", groupJSON.id)
                        .attr("data-col-id", columnJSON.id)
                        .on("change", function () {
                            //TODO: limit max checked columns?
                            var checked = $(this).is(':checked');
                            columnJSON.display = checked;
                        });*/
                    checkboxesElem.append(checkboxUIElem);
                    checkboxesCount++;
                });
            });
            if (checkboxesCount > 8) {
                checkboxesElem.css("column-count", "2");
                checkboxesElem.css("column-gap", config.padding+"px");
            }
            diag.elem.append(checkboxesElem);
            diag.cancelButton();
            diag.okayButton();
            diag.okay(function () {
                // User wants an update - call rebuild
                Machinata.Reporting.Node.VerticalTableNode.rebuild(instance, config, json, nodeElem, containerElem);
            });
            diag.show();
        });
    }


    // Do we have preset highlight?
    if (config.highlight != null) {
        config.highlight = config.highlight.toLowerCase();
        nodeElem.data("table").find("td").each(function () {
            var dataElem = $(this);
            var dataElemSearch = dataElem.text().toLowerCase();
            if (dataElemSearch.indexOf(config.highlight) != -1) {
                dataElem.addClass("selected-highlight");
            }
        });
    }

    // Do we have preset sorts?
    //TODO: Support this on the data side as well
    if (json.sorts != null) {
        // Compile filter array (needed by tablesorter)
        var sortArray = []; // For example, [[1,0], [2,0]]
        // Find matching value in config
        for (sortKey in json.sorts) {
            // Register 
            var sortDir = 0;
            if (json.sorts[sortKey] == "asc") sortDir = 0;
            if (json.sorts[sortKey] == "desc") sortDir = 1;
            // The value contains an array of instructions for per-column sorting and direction in the format: 
            // [[columnIndex, sortDirection], ... ] where columnIndex is a zero-based index for your columns left-to-right and sortDirection is 0 for Ascending and 1 for Descending. A valid argument that sorts ascending first by column 1 and then column 2 looks like: [[0,0],[1,0]].
            // Note: the above documentation is misleading: if you have groups, then each group offsets the column by one.
            // Instead of using the column header index, we just go look it up
            var columnHeaderElem = nodeElem.data("table").find("th[data-name='" + sortKey + "']");
            sortArray.push([parseInt(columnHeaderElem.attr("data-column")), sortDir]);
        }
        // Apply sort
        nodeElem.data("table").trigger('sorton', [sortArray]); // From documentation: $( 'table' ).trigger( 'sorton', [ [[0,0],[2,0]] ] );
    }


    // Events
    nodeElem.on(Machinata.Reporting.Events.REBUILD_TABLE_SIGNAL, function () {
        Machinata.Reporting.Node.VerticalTableNode.rebuild(instance, config, json, nodeElem, containerElem);
    });

};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    var self = this;
    if (format == "xlsx" || format =="csv") {
        var tempTableElem = self.buildTable(instance, config, json, nodeElem, {
            interactive: false,
            includeFormattingInformation: true,
        });
    
        var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
        workbook = Machinata.Reporting.Export.createExcelDataForTable(instance, config, json, workbook, tempTableElem,format);
        Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
        return true;
    }

    if (format == "xls_OLD") {
        var tempTableElem = self.buildTable(instance, config, json, nodeElem, {
            interactive: false,
            includeFormattingInformation: true,
        });
        Machinata.Data.exportTableAsExcel(tempTableElem, filename);
        return true;
    }
    if (format == "csv_OLD") {
        var tempTableElem = self.buildTable(instance, config, json, nodeElem, {
            interactive: false,
            includeFormattingInformation: true,
        });
        Machinata.Data.exportTableAsCSV(tempTableElem, filename);
        return true;
    }
    return false;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VerticalTableNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};











/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-vega.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-vega.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// This abstract Node type provides the infrastructure needed for displaying
/// and managing Vega-based chart Nodes.
/// This Node implementation also provides some useful helper functions, such as
/// createVegaLegend(), for doing mundane Vega tasks. Through the applyGlobalVegaSpec(),
/// implementing Nodes only need to provide the Node-specific Vega specs - common Vega
/// spec stuff such as config and styles are provided by VegaNode automatically.
/// Nodes inheriting the VegaNode should call the parent methods before executing their own.
///
/// ## Chart Data
/// Data for the vega charts are (for obvious reasons) not integrated into the specs.
/// The data is automatically bound in using the ```Machinata.Reporting.Node.VegaNode.applyVegaData``` interface.
/// Here the data from the node JSON is bound into the spec when needed.
///
/// ### JSON Date/Times
/// Date/times should always be provided in Unix Epoch Milliseconds long format.
///
/// ### Themes
/// All Vega-Nodes must have a valid theme registered for it.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.VegaNode = {};

/// <summary>
/// Supported defaults for VegaNode Node types.
/// Note that due to the nature of JavaScript these are actually not automatically
/// inherited to implementing Nodes - you must redefine them.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults = {};

/// <summary>
/// If true, a legend will automatically be inserted via createVegaLegend().
/// To use the automatic legend, you must implement in the vega spec the 
/// following scales which use the mark group key to resolve:
///  - ```legendLabel```
///  - ```legendColor```
/// Optionally, the vega spec data set 'legendSelected' can be provided to
/// create a legend that is interactive (toggable).
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.insertLegend = false;

/// <summary>
/// For charts that support legends, this defines the number of columns.
/// Implementing chart types will define their own default settings.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendColumns = 1;

/// <summary>
/// For charts that support legends, this property optionally defines the 
/// minimum number of rows (in space) the legend should occupy.
/// This is especially useful for aligning the size of the chart area across multiple charts if
/// the legend data varies (here it is recommended to find the common ```legendColumns``` and ```legendMinRows```
/// that suits all the charts).
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendMinRows = null;

/// <summary>
/// For charts that support legends, this property defines the position of the chart legend.
/// Supported positions:
///  - ```left-top```: Place the legend to the top-left of the chart, in the top corner.
///  - ```right-top```: Place the legend to the right of the chart, in the top corner.
///  - ```top-left```: Place the legend above the top of the chart, on the left side.
///  - ```bottom-left```: Place the legend below the bottom of the chart, on the left side.
/// By default ```bottom```.
/// If the chart node does not define this setting, then the global default ```Machinata.Reporting.Config.legendPosition``` is used.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendPosition = "bottom";

/// <summary>
/// For render modes that have fixed chart dimensions (such as print), the legend position
/// can differ depending on the orientation using the ```legendPositionPortrait``` 
/// and ```legendPositionLandscape``` properties.
/// See ```legendPosition``` for supported positions.
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendPositionPortrait = null;

/// <summary>
/// For render modes that have fixed chart dimensions (such as print), the legend position
/// can differ depending on the orientation using the ```legendPositionPortrait``` 
/// and ```legendPositionLandscape``` properties.
/// See ```legendPosition``` for supported positions.
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendPositionLandscape = null;

/// <summary>
/// For charts that support legends, if ```legendSiblingsAutoBalance``` is not explicitly ```false``` then
/// chart legends are automatically balanced with regards to their siblings (ie charts next to 
/// the current chart).
/// When using this feature, you do not have to provide ```legendColumns``` or ```legendMinRows```,
/// as this feature will automatically set these settings. You can optionally set ```legendColumns``` to
/// force a specific look.
/// Currently this only works if the following properties are defined as well:
///  - ```legendSiblingsExpectedMinItems```
///  - ```legendSiblingsExpectedMaxItems```
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendSiblingsAutoBalance = true;

/// <summary>
/// For charts that support legends and are auto-balanced, this property
/// hints to how the legend should be sized. 
/// This property must equal the minimum number of legend items across all
/// neighboring siblings (including itself).
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendSiblingsExpectedMinItems = null;

/// <summary>
/// For charts that support legends and are auto-balanced, this property
/// hints to how the legend should be sized. 
/// This property must equal the maximum number of legend items across all
/// neighboring siblings (including itself).
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendSiblingsExpectedMaxItems = null;

/// <summary>
/// If set to ```true```, the legend will be reversed in order.
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.VegaNode.defaults.legendReversed = false;


/// <summary>
/// Applies the common vega spec for all VegaNode implementations.
/// You do not need to call this from an implementing node, this is done automatically by the init.
/// </summary>
Machinata.Reporting.Node.VegaNode.applyGlobalVegaSpec = function (instance, config, json, nodeElem, spec) {
    // Init
    var self = this;
    // General
    spec["$schema"] = "https://vega.github.io/schema/vega/v5.json";
    spec["padding"] = config.chartPadding; // fixes some small inaccuraces in font measuring, especially in nodejs environment
    spec["autosize"] = {
        "type": "fit"
    };
    // Signals
    if (spec["signals"] == null) spec["signals"] = [];
    spec["signals"].push({
        "name": "widthInPercentOfMedium",
        "update": "width / " + config.mediumContentWidthSize
    });
    spec["signals"].push({
        "name": "isLayoutedOnHalfMediumWidth",
        "update": "widthInPercentOfMedium < 0.6"
    });
    spec["signals"].push({
        "name": "aspectRatio",
        "update": "width / height"
    });
    spec["signals"].push({
        "name": "config_profile",
        "init": "'" + config.profile + "'"
    });
    spec["signals"].push({
        "name": "config_medium",
        "init": "'" + config.medium + "'"
    });
    spec["signals"].push({
        "name": "responsiveLayout", // needs to be updated whenever the view changes size
        "init": "'" + Machinata.Reporting.Responsive.getReportLayout(instance) + "'"
    });
    spec["signals"].push({
        "name": "responsiveSize", // needs to be updated whenever the view changes size
        "update": "config_medium == 'screen' && width < 400 ? 'tiny' : 'regular'"
    });
    spec["signals"].push({
        "name": "config_h1Size",
        "init": config.h1Size
    });
    spec["signals"].push({
        "name": "config_chartTextSize",
        "init": config.chartTextSize
    });
    spec["signals"].push({
        "name": "config_titleSize",
        "update": "responsiveLayout == 'mobile' ? (" + config.titleSize + " * " + config.mobileTitleSizeFactor + ") : " + config.titleSize
    });
    spec["signals"].push({
        "name": "config_subtitleSize",
        "update": "responsiveLayout == 'mobile' ? (" + config.subtitleSize + " * " + config.mobileSubtitleSizeFactor + ") : " + config.subtitleSize
    });
    spec["signals"].push({
        "name": "config_labelSize",
        "update": "responsiveLayout == 'mobile' ? (" + config.labelSize + " * " + config.mobileLabelSizeFactor + ") : " + config.labelSize
    });
    // Default configs
    spec["config"] = {
        "mark": {
            "font": config.textFont,
            "fontSize": config.chartTextSize
        },
        "text": {
            "font": config.textFont,
            "fontSize": config.chartTextSize
        },
        "style": {
            "text": {
                "font": config.textFont,
                //"fontWeight": "bold",
                "fontSize": config.chartTextSize
            },
            "subtitle": {
                "font": config.subtitleFont,
                //"fontWeight": "bold",
                "fontSize": config.subtitleSize
            },
            "label": {
                "font": config.labelFont,
                //"fontWeight": "bold",
                "fontSize": config.labelSize
            },
            "number": {
                "font": config.numberFont
            }
        },
        "axis": {
            "ticks": false,
            "tickWidth": config.gridLineSize,
            "offset": 0, // The orthogonal offset in pixels by which to displace the axis from its position along the edge of the chart.
            "gridOpacity": 1.0,
            "gridColor": config.gridColor,
            "gridWidth": config.gridLineSize,
            "labelLimit": json.axisLabelLimit || config.axisLabelLimit, // The maximum allowed length in pixels of axis tick labels.
            "labelSeparation": json.axisLabelSeparation || config.axisLabelSeparation, // The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default 0). This property is ignored if labelOverlap resolution is not enabled. ≥ 5.0
            "labelOverlap": json.axisLabelOverlap || config.axisLabelOverlap, // The strategy to use for resolving overlap of axis labels. If false (the default), no overlap reduction is attempted. If set to true or "parity", a strategy of removing every other label is used (this works well for standard linear axes). If set to "greedy", a linear scan of the labels is performed, removing any label that overlaps with the last visible label (this often works better for log-scaled axes).
            "labelPadding": json.axisLabelPadding || config.axisLabelPadding, // The padding in pixels between labels and ticks.
            "labelFlushOffset": 0, // Indicates the number of pixels by which to offset flush-adjusted labels (default 0). For example, a value of 2 will push flush-adjusted labels 2 pixels outward from the center of the axis. Offsets can help the labels better visually group with corresponding axis ticks.
            "labelFont": config.axisFont,
            "labelFontSize": config.axisSize,
            "labelFontWeight": config.axisLabelFontWeight,
            //"labelOffset": 20, // Position offset in pixels to apply to labels, in addition to tickOffset.
            "titleFont": config.textFont,
            "titleFontSize": config.chartTextSize,
            "titleFontWeight": "normal"
        },
        "legend": {
            "labelFont": config.legendFont,
            "labelFontSize": config.legendSize,
            "labelColor": (json.chrome == "dark" ? "white" : null),
            "padding": 0,
            "layout": {
                //"bounds": "full"
            }
        }
    };
    return spec;
};


/// <summary>
/// Applies the common vega legend spec for VegaNode implementations that use the automatic legend.
/// You do not need to call this from an implementing node, this is done automatically by the init.
/// </summary>
Machinata.Reporting.Node.VegaNode.applyLegendVegaSpec = function (instance, config, json, nodeElem, spec) {
    var self = this;
    var insertLegend = json.insertLegend;

    // All legend data "empty", or no legend data at all? 
    // If so, we turn off the legend
    if (json.insertLegend == true && json.legendData == null) {
        insertLegend = false; // no legend data
    } if (json.insertLegend == true && json.legendData != null) {
        var allEmpty = true;
        for (var i = 0; i < json.legendData.length; i++) {
            if (json.legendData[i].title != null && json.legendData[i].title != "") {
                allEmpty = false;
                break;
            }
        }
        if (allEmpty == true) {
            insertLegend = false;
        }
    }

    if (insertLegend == true) {

        Machinata.debug("Machinata.Reporting.Node.VegaNode.applyLegendVegaSpec");
        Machinata.debug("  " + "node id:" + json.id);

        json.legendIsInteractive = false; // This feature is deprecated

        // Auto orient?
        //TODO @dan


        // Reverse legend order?
        var legendData = [];
        for (var i = 0; i < json.legendData.length; i++) {
            // Register the key
            if (json.legendReversed == true) {
                legendData.splice(0, 0, json.legendData[i]); // insert (reverse)
            } else {
                legendData.push(json.legendData[i]); // push
            }
        }
        

        var actualLegendItemCount = legendData.length;

        // Auto balance?
        if (json.legendSiblingsAutoBalance != false && json.legendSiblingsExpectedMaxItems != null && json.legendMinRows == null) {
            // Set columns, if not explicitly set.
            if (json.legendColumns == null) {
                json.legendColumns = 1; // fallback
                if (json.legendSiblingsExpectedMaxItems > 2) json.legendColumns = 2;
                if (json.legendSiblingsExpectedMaxItems > 8) json.legendColumns = 3;
            }
            // Set rows
            json.legendMinRows = Math.ceil(json.legendSiblingsExpectedMaxItems / json.legendColumns);
        }


        // Apply min rows
        // Here we add fake data to ensure that we reach the minimum number of rows
        //TODO: incorporate columns
        if (json.legendMinRows != null) {
            var columns = (json.legendColumns || 1);
            while (legendData.length < json.legendMinRows * columns) {
                Machinata.debug("  " + "Adding blank legend item for min rows: " + json.legendMinRows);
                legendData.push({
                    key: "BLANK_" + legendData.length,
                    symbol: "blank"
                });
            }
        }

        // Clip columns down if not needed
        if (json.legendMinRows == null) {
            if (json.legendColumns > 1 && actualLegendItemCount == 1) {
                json.legendColumns = 1;
            }
        }

        // Compile an array of all legend keys (we need this for our custom scales)
        var legendKeys = [];
        for (var i = 0; i < legendData.length; i++) {
            // Apply default type
            if (legendData[i].symbol == null) legendData[i].symbol = "square";
            legendKeys.push(legendData[i].key);
        }

        // Legend data definitions
        spec["data"].push({
            "name": "legendData",
            "values": legendData
        });
        spec["data"].push({
            "name": "legendSelected",
            "on": []
        });

        // Legend scale definitions
        spec["scales"].push({
            "name": "legendDataScale",
            "type": "ordinal",
            "domain": legendKeys,
            "range": legendKeys
        });

        // Legend position
        var legendWidthAllottedSpace = 1.0;
        var legendHeightAllottedSpace = 1.0;
        var legendForceColumns = null;
        var legendForceRows = null;
        function getLegendOrient(key) {
            // First, test for the key (ie legendPositionPortrait)
            var legendOrient = Machinata.Reporting.Config[key]; // fallback
            if (json[key] != null) legendOrient = json[key];
            else if (config[key] != null) legendOrient = config[key];
            // If nothing, fallback to legendPosition
            if (legendOrient == null) {
                legendOrient = Machinata.Reporting.Config.legendPosition; // fallback
                if (json.legendPosition != null) legendOrient = json.legendPosition;
                else if (config.legendPosition != null) legendOrient = config.legendPosition;
            }
            // Convert to vega position
            if (legendOrient == "left-top") {
                legendOrient = "left";
                legendForceColumns = 1;
                legendWidthAllottedSpace = 0.35;
            } else if (legendOrient == "right-top") {
                legendOrient = "right";
                legendForceColumns = 1;
                legendWidthAllottedSpace = 0.35;
            } else if (legendOrient == "top-left") {
                legendOrient = "top";
            } else if (legendOrient == "bottom-left") {
                legendOrient = "bottom";
            } else {
                legendOrient = "bottom";
            }
            return legendOrient;
        }
        var legendOrient = getLegendOrient("legendPosition");
        if (json.width != null && json.height != null) {
            if ((json.width / json.height) > 1.0) legendOrient = getLegendOrient("legendPositionLandscape");
            else legendOrient = getLegendOrient("legendPositionPortrait");
        }
        if (legendForceColumns != null) json.legendColumns = legendForceColumns;
        

        // Label max width
        var labelMaxWidthSignal = "(" + config.legendLabelMaxWidth + ")";
        if (true) {
            // Automatically clip by reverse engineering the vega spacing used for the legend
            // We provide this as a signal, since on web the charts are responsive...
            var columnsSafe = 1;
            if (json.legendColumns != null) columnsSafe = json.legendColumns; // legendColumns is not always defined
            var legendSymbolSpace = (columnsSafe) * (config.legendSymbolSize + config.legendSymbolStroke + + config.legendSymbolStroke);
            var legendColumnPaddingSpace = (columnsSafe - 1) * (config.legendColumnPadding);
            // Javascript calculation
            
            if (json.width != null && json.height != null) {
                var labelMaxWidthPrecomputed = Math.min(config.legendLabelMaxWidth, Math.floor((((json.width * legendWidthAllottedSpace) - legendSymbolSpace - legendColumnPaddingSpace) / json.legendColumns) - (0.5 * config.legendSymbolSize)));
                //console.log(labelMaxWidthPrecomputed);
                labelMaxWidthSignal = "(" + labelMaxWidthPrecomputed + ")";
            } else {
                // Vega signal of same calculation
                labelMaxWidthSignal = "min( " + config.legendLabelMaxWidth + ", floor( ((width*" + legendWidthAllottedSpace + " - " + legendSymbolSpace + " - " + legendColumnPaddingSpace + ") / " + columnsSafe + ") - (0.5 * " + config.legendSymbolSize + ") ) )";
            }
        }

        // Create legend spec
        if (spec["legends"] == null) spec["legends"] = [];
        spec["legends"].push({
            "fill": "legendDataScale", //legendDataScale
            "direction": "vertical",
            "orient": legendOrient, // Note: bottom-left doesnt work, only suppported is bottom
            //"orient": { "signal": legendOrientSignal}, // Note: signals dont work properly... Note: bottom-left doesnt work, only suppported is bottom
            "gridAlign": "none",
            //"symbolType": { "signal": "data('legendData')[datum.index].symbol == 'dot' ? '" + config.legendSymbolForDot + "' : (data('legendData')[datum.index].symbol == 'diamond' ? '" + config.legendSymbolForDiamond+"' : '" + config.legendSymbolForBar+"')   " },
            "symbolType": { "signal": "data('legendData')[datum.index].symbol == 'dot' ? '" + config.legendSymbolForDot + "' : data('legendData')[datum.index].symbol == 'diamond' ? '" + config.legendSymbolForDiamond + "' : data('legendData')[datum.index].symbol == 'line' ? '" + config.legendSymbolForLine + "' : data('legendData')[datum.index].symbol == 'bar'? '" + config.legendSymbolForBar + "' : '" + config.legendSymbolForUnknown + "'"  },
            /*
            "symbolType": [
                {
                    "test": "data('legendData')[datum.index].symbol == 'dot'",
                    "value": "'" + config.legendSymbolForDot + "'"
                },
                {
                    "test": "data('legendData')[datum.index].symbol == 'diamond'",
                    "value": "'" + config.legendSymbolForDiamond + "'"
                },
                {
                    "test": "data('legendData')[datum.index].symbol == 'line'",
                    "value": "'" + config.legendSymbolForLine + "'"
                },
                {
                    "test": "data('legendData')[datum.index].symbol == 'bar'",
                    "value": "'" + config.legendSymbolForBar + "'"
                },
                {
                    "value": "'" + config.legendSymbolForUnknown + "'" // fallback
                },
            ],vega doesn't allow this, unfortunately*/
            "symbolSize": (config.legendSymbolSize * config.legendSymbolSize), // The area in pixels of the symbols bounding box. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.
            "symbolStrokeColor": null,
            "symbolStrokeWidth": config.legendSymbolStroke,
            "labelLimit": { "signal": labelMaxWidthSignal}, // precompiled signal
            "columns": json.legendColumns,
            "columnPadding": config.legendColumnPadding,
            "rowPadding": config.legendRowPadding,
            "padding": config.legendPadding,
            "clipHeight": config.legendSymbolSize + config.legendSymbolStroke, // Note: the stroke exceeds the symbol bounds since the vega stroke always pushes out from the boundary
            "encode": {
                "title": {
                    "update": {

                    }
                },
                "labels": {
                    "name": "legendLabel",
                    "interactive": true,
                    "update": {
                        "opacity": [
                          { "test": "!length(data('legendSelected')) || indata('legendSelected', 'value', datum.value)", "value": 1 },
                          { "value": 0.2 }
                        ],
                        "text": {
                            //"signal": "data('legendData')[datum.index].title" // use pre computed title
                            "signal": "scale('legendLabel',datum.value)" // use label scale with key
                            //"scale": "legendLabel", "field": "value" // use key (datum value)
                        }
                    }
                },
                "symbols": {
                    "name": "legendSymbol",
                    "interactive": true,
                    "update": {
                        "opacity": [
                          { "test": "!length(data('legendSelected')) || indata('legendSelected', 'value', datum.value)", "value": 1 },
                          { "value": 0.2 }
                        ],
                        "fill": [
                            {
                                "test": "data('legendData')[datum.index].symbol == 'line'",
                                "value": "transparent"
                            },
                            {
                                "scale": "legendColor",
                                "field": "value"
                            },
                        ],
                        "stroke": [
                            {
                                "scale": "legendColor",
                                "field": "value"
                            },
                        ],
                    }
                },
                "legend": {
                }
            }
        });

    } else {

        // Some charts rely on the legend datas to exist...
        spec["data"].push({
            "name": "legendSelected",
            "on": []
        });
    }
};

/// <summary>
/// Returns a JSON vega spec. The returned JSON should not have any data values, as these
/// are bound in by applyVegaData(). When defining a data source, use ```"values": null```.
/// Every VegaNode implemention must implement this method. 
/// </summary>
Machinata.Reporting.Node.VegaNode.getVegaSpec = function (instance, config, json, nodeElem) { };

/// <summary>
/// Applys the data from the node JSON into the vega spec (since the spec is 'dataless').
/// For example, if your node as a array property 'facts', you would implement
///     ```spec["data"][0].values = json.facts;```
/// Every VegaNode implemention must implement this method. 
///
/// TODO: DEPRECATE!!!
///
/// </summary>
Machinata.Reporting.Node.VegaNode.applyVegaData = function (instance, config, json, nodeElem, spec) { };

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.compileVegaSpec = function (instance, config, json, nodeElem) {
    // Get implementation
    var self = this;
    var impl = Machinata.Reporting.Node[json.nodeType];

    // Get spec and apply data
    var spec = impl.getVegaSpec(instance, config, json, nodeElem);
    impl.applyVegaData(instance, config, json, nodeElem, spec);

    // Apply global spec and parse
    self.applyGlobalVegaSpec(instance, config, json, nodeElem, spec);
    self.applyLegendVegaSpec(instance, config, json, nodeElem, spec);
    
    return spec;
};

/// <summary>
/// Sets up the node for containing a responsive Vega view, including parsing and compiling the spec,
/// and registering common functionality such as tooltips.
/// Every VegaNode implemention must call this method at the begginning of its own
/// init(). Typically, a VegaNode implementation does not need to do anything since
/// most is handled by the getVegaSpec() method.
/// </summary>
Machinata.Reporting.Node.VegaNode.init = function (instance, config, json, nodeElem) {

    // Basic validation
    if (config == null) throw "Machinata.Reporting.Node.VegaNode.init: config JSON cannot be null (parameter config)!";
    if (json == null) throw "Machinata.Reporting.Node.VegaNode.init: node JSON cannot be null (parameter json)!";
    if (json.theme == null) throw "Machinata.Reporting.Node.VegaNode.init: node theme cannot be null (json.theme)! Please make sure to set a theme.";

    // Validate theme
    if (json.theme != null && Machinata.Reporting.getTheme(json.theme) == null) {
        console.warn("The theme '" + json.theme + "' for node " + json.id + " is not valid.");
        json.theme = "default";
    }

    // Headless?
    if (config.headless == true && nodeElem == null) {
        //nodeElem = $("<div></div>").appendTo($("body"));
        return;
    }

    // Non-headless validation
    if (nodeElem == null) throw "Machinata.Reporting.Node.VegaNode.init: node Elem cannot be null (parameter nodeElem)!";

    // Tools
    Machinata.Reporting.Node.registerExportOptions(instance, config, json, nodeElem, {
        "svg": "SVG",
        "png": "PNG",
        "xlsx": "Excel",
        "csv": "CSV",
        //"jpeg": "JPG", // vega doesnt support this
    });

    // Get spec and apply data
    var spec = Machinata.Reporting.Node.VegaNode.compileVegaSpec(instance, config, json, nodeElem);
    var parserOptions = {};
    if (config.cspCompliance == true) parserOptions.ast = true;
    var parsedVegaSpec = vega.parse(spec, null, parserOptions);
    //nodeElem.data("vega-parsed-specs", parsedVegaSpec);

    // Create container element
    nodeElem.addClass("type-VegaNode");
    nodeElem.addClass("avoid-page-break");
    var vegaContainer = $("<div class='node-bg vegaview'></div>");
    nodeElem.append(vegaContainer);

    // Create vega view
    var vegaView = new vega.View(parsedVegaSpec, {
        expr: config.cspCompliance == true ? vega.expressionInterpreter : null, // https://vega.github.io/vega/usage/interpreter/
        renderer: 'svg',
        container: vegaContainer[0],
        responsive: false, // has no effect
        hover: true,
    });
    if (Machinata.DebugEnabled == true) vegaView.logLevel(vega.Info);


    // Register custom tooltip handler
    // Our custom sanitize allows us to build tabular tooltips. We don't use the standard mechanism since
    // it is not possible to modify the keys in runtime (it must be a string)
    if (true) {
        var tooltipOptions = {
            theme: 'custom',
            sanitize: function (value) {
                return String(value)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/\n/g, '<br/>')
                    .replace(/\[break\]/g, '<br/>')
                    .replace(/\[colon\]/g, ':&nbsp;')
                    .replace(/\[title\]/g, '<div class="title">')
                    .replace(/\[\/title\]/g, '</div>')
                    .replace(/\[items\]/g, '<table>')
                    .replace(/\[\/items\]/g, '</table>')
                    .replace(/\[key\]/g, '<td class="key">')
                    .replace(/\[\/key\]/g, ':&nbsp;</td>')
                    .replace(/\[val\]/g, '<td class="value">')
                    .replace(/\[\/val\]/g, '</td>')
                    .replace(/\[item\]/g, '<tr>')
                    .replace(/\[\/item\]/g, '</tr>');
            }
        };
        var tooltipHandler = new vegaTooltip.Handler(tooltipOptions);
        vegaView.tooltip(tooltipHandler.call);
    }

    // Bind user events
    // https://vega.github.io/vega/docs/event-streams/
    // https://stackoverflow.com/questions/53949805/react-vega-get-data-on-click-event-add-event-listener-for-click-events
    var impl = Machinata.Reporting.Node[json.nodeType];
    if (impl != null && impl.onMarkClick != null) {
        Machinata.debug("VegaNode.onMarkClick", "binding click for " + json.nodeType);
        vegaView.addEventListener('click', function (event, item) {
            if (item != null && item.datum != null) Machinata.debug("VegaNode.onMarkClick",item.datum);
            impl.onMarkClick(instance, config, json, nodeElem, event, item);
        });
    }

    // Register with node
    nodeElem.data("vega-container", vegaContainer);
    nodeElem.data("vega-view", vegaView);
};



/// <summary>
/// Draws the vega view.
/// Every VegaNode implemention must call this method at the begginning of its own
/// draw().
/// </summary>
Machinata.Reporting.Node.VegaNode.draw = function (instance, config, json, nodeElem) {
    var VERBOSE_VEGA_DRAW_LOGGING = false;

    // Extract vega elements
    var vegaContainer = nodeElem.data("vega-container");
    if (VERBOSE_VEGA_DRAW_LOGGING) console.log("Machinata.Reporting.Node.VegaNode.draw", "container size ==>",vegaContainer.width(), vegaContainer.height());
    // Update the view
    var vegaView = nodeElem.data("vega-view");
    vegaView.signal("responsiveLayout", Machinata.Reporting.Responsive.getReportLayout(instance)); // update the new responsive layout
    if (nodeElem.data("vega-firstdraw") != false) {
        // First draw
        if (VERBOSE_VEGA_DRAW_LOGGING) console.log("Machinata.Reporting.Node.VegaNode.draw", "vega-firstdraw == true");
        nodeElem.data("vega-firstdraw", false);
        vegaView
            .width(vegaContainer.width())
            .height(vegaContainer.height())
            .run();
        
    } else {
        // Subsequent draws (resize)
        if (VERBOSE_VEGA_DRAW_LOGGING) console.log("Machinata.Reporting.Node.VegaNode.draw", "vega-firstdraw ==>", false, "vegaView.width ==> ", vegaView.width());
        vegaView
            .width(vegaContainer.width())
            .height(vegaContainer.height())
            .resize() // subsequent draws we call the vega view resize...
            .run();
        if (VERBOSE_VEGA_DRAW_LOGGING) console.log("Machinata.Reporting.Node.VegaNode.draw", "vegaView.width ==> ", vegaView.width(), "width signal ==>", vegaView.signal("width"));
    }

    
    
};

/// <summary>
/// Outputs a dataset to the console.
/// Note: Machinata.DebugEnabled must be enabled
/// </summary>
Machinata.Reporting.Node.VegaNode.debugOutputDataSet = function (nodeElem, dataset) {
    if (Machinata.DebugEnabled == true) {
        console.log(nodeElem.data("vega-view").data(dataset));
    }
};




/// <summary>
/// Helper method to export common chart formats.
/// </summary>
Machinata.Reporting.Node.VegaNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    var self = this;

    if (format == "svg" || format == "png") {
        // Create a new view, disjoint from the currently rendered one...

        // Get spec and apply data
        var spec = Machinata.Reporting.Node.VegaNode.compileVegaSpec(instance, config, json, nodeElem);
        var parserOptions = {};
        if (config.cspCompliance == true) parserOptions.ast = true;
        var parsedVegaSpec = vega.parse(spec, null, parserOptions);

        // Create vega view
        var vegaContainer = nodeElem.data("vega-container");
        var vegaView = new vega.View(parsedVegaSpec, {
            expr: config.cspCompliance == true ? vega.expressionInterpreter : null, // https://vega.github.io/vega/usage/interpreter/
            renderer: 'svg',
            container: null,
            responsive: false, // has no effect
            hover: false,
        });

        // Set background
        var backgroundColor = "white"; //fallback
        if (json.chrome == "dark") {
            try {
                backgroundColor = window.getComputedStyle(vegaContainer[0]).getPropertyValue("background-color");
            } catch (error) {
                backgroundColor = "white"; //fallback
            }
        }
        if (backgroundColor == "rgba(0, 0, 0, 0)") backgroundColor = "white"; //fallback sanity
        vegaView.background(backgroundColor);

        // Do initial resize and render
        vegaView
            .width(vegaContainer.width())
            .height(vegaContainer.height())
            .run();

        // Generate a PNG/SVG snapshot and then download the image
        var promise = vegaView.toImageURL(format).then(function (url) {
            if (Machinata.Device.isMSIE() == true) {
                throw Machinata.Reporting.Text.translate(instance, "reporting.unsupported-browser-feature")
            }
            // Create a link to the blob and invoke the click, so that a nice download type event is triggered for the user
            var link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('target', '_blank');
            link.setAttribute('download', filename);
            link.dispatchEvent(new MouseEvent('click'));
        }).catch(function (err) {
            console.warn(err);
            Machinata.messageDialog(Machinata.Reporting.Text.translate(instance, "reporting.nodes.export"), Machinata.Reporting.Text.translate(instance, "reporting.nodes.export.error") + " " + err).show()
        });


        return true;
    } else if (format == "xlsx" || format == "csv") {
        // Load the implementation and call it's specific excel export
        var impl = Machinata.Reporting.Node[json.nodeType];
        if (impl.exportExcelFormat == null) return false; // make sure user is notified
        return impl.exportExcelFormat(instance, config, json, nodeElem, format, filename);
    }
    return false;
};






/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-vega-util.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-vega-util.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.VegaNode.Util = {};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.createLegendForGroupedSeries = function (instance, config, json, seriesGroups, opts) {
    var legendMap = {};
    var legendData = [];
    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];
        for (var si = 0; si < seriesGroup.series.length; si++) {
            var serie = seriesGroup.series[si];
            var serieKey = seriesGroup.id + "_" + serie.id;
            var serieTitle = Machinata.Reporting.Text.resolve(instance, serie.title);
            var serieSymbol = "square"; // fallback
            if (serie.chartType == "line") serieSymbol = "line";
            if (serie.chartType == "area") serieSymbol = "square";
            var legendDatum = {
                key: serieKey,
                title: serieTitle,
                symbol: serieSymbol
            };
            legendMap[serieKey] = legendDatum;
            if (opts != null && opts.reverseOrder == true) {
                legendData.splice(0, 0, legendDatum); // insert
            } else {
                legendData.push(legendDatum); // push
            }
        }
    } 
    json.legendData = legendData;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.createLegendForSeries = function (instance, config, json, series, opts) {
    var legendData = [];
    for (var si = 0; si < series.length; si++) {
        var serie = series[si];
        var serieKey = serie.id; 
        var serieTitle = Machinata.Reporting.Text.resolve(instance, serie.title); 
        var legendDatum = {
            key: serieKey,
            title: serieTitle
        };
        legendData.push(legendDatum);
    }
    json.legendData = legendData;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.createLegendForSeriesFacts = function (instance, config, json, series, opts) {
    var legendMap = {};
    var legendData = [];
    for (var si = 0; si < series.length; si++) {
        var serie = series[si];
        for (var fi = 0; fi < serie.facts.length; fi++) {
            var fact = serie.facts[fi];
            var factTitle = Machinata.Reporting.Text.resolve(instance, fact.category);
            var factKey = factTitle; //TODO
            if (legendMap[factKey] == null) {
                var legendDatum = {
                    key: factKey,
                    title: factTitle
                };
                if (fact.symbolType != null) legendDatum.symbol = fact.symbolType;
                legendMap[factKey] = legendDatum;
                legendData.push(legendDatum);
            }
        }
    }
    json.legendData = legendData;
};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.getNiceDomain = function (domain) {
    return d3.scaleLinear().domain([domain[0], domain[1]]).nice().domain();
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.getNiceStep = function (step) {
    return d3.scaleLinear().domain([0, step]).nice().domain()[1];
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.autoSnapSeriesAxis = function (instance, config, json, series, opts) {
    // Init
    Machinata.debug("Machinata.Reporting.Node.VegaNode.Util.autoSnapSeriesAxis:");
    Machinata.debug("  " + "node id: " + json.id);
    if (opts == null) opts = {};
    if (opts.axisKey == null) throw "The axisKey must be set (usually xAxis or yAxis) for Machinata.Reporting.Node.VegaNode.Util.autoSnapSeriesAxis!";
    if (opts.stackedSeries == null) opts.stackedSeries = false; // Note: when we say we want to stack series, we want to stack each serie ontop of each other whithin a category
    if (opts.tickCount == null) opts.tickCount = config.axisTargetTickCount; // Fallback

    // Get min/max
    var minVal = null; // Facts min/max values
    var maxVal = null; // Facts min/max values
    var serieMinTotalVal = null; // Series total min/max values
    var serieMaxTotalVal = null; // Series total min/max values
    var categoryMinTotalVal = null; // Categories total min/max values
    var categoryMaxTotalVal = null; // Categories total min/max values
    var categories = {};
    for (var si = 0; si < series.length; si++) {
        var serie = series[si];
        serie.totalValue = null; // tracks the total value of a serie
        if (serie[opts.axisKey] == null) serie[opts.axisKey] = {};
        for (var fi = 0; fi < serie.facts.length; fi++) {
            var fact = serie.facts[fi];
            // Set axis format?
            if (fact.format != null && serie[opts.axisKey].format == null) {
                Machinata.debug("  "+"axis format was null, setting based on first fact format");
                console.log("  "+"axis format was null, setting based on first fact format");
                serie[opts.axisKey].format = fact.format;
            }
            if (fact.formatType != null && serie[opts.axisKey].formatType == null) {
                Machinata.debug("  " + "axis formatType was null, setting based on first fact format");
                serie[opts.axisKey].formatType = fact.formatType;
            }
            if (fact.val != null) {
                // Validate 
                if (opts.stackedSeries == true && fact.val < 0) throw "A stacked series cannot have negative values."
                // Track fact min/max
                if (fact.val < minVal || minVal == null) minVal = fact.val;
                if (fact.val > maxVal || maxVal == null) maxVal = fact.val;
                // Track series total
                if (serie.totalValue == null) serie.totalValue = 0;
                // Track categories total
                var category = categories[fact.category.resolved];
                if (category == null) {
                    category = { "key": fact.category.resolved,"totalValue": 0};
                    categories[category.key] = category;
                }
                // Track the stacking value (this makes drawing later very easy and cheap)
                fact.stackedValA = category.totalValue; // pre value
                category.totalValue += fact.val; 
                serie.totalValue += fact.val;
                fact.stackedValB = category.totalValue; // post value
            }
        }
        if (serie.totalValue != null && (serie.totalValue < serieMinTotalVal || serieMinTotalVal == null)) serieMinTotalVal = serie.totalValue;
        if (serie.totalValue != null && (serie.totalValue > serieMaxTotalVal || serieMaxTotalVal == null)) serieMaxTotalVal = serie.totalValue;
    }

    // Stacked? If so the min / max should reflect the series total min max
    if (opts.stackedSeries == true) {
        
        // Get the min/max over all categories
        Machinata.Util.each(categories, function (key,category) {
            if (category.totalValue != null && (category.totalValue < categoryMinTotalVal || categoryMinTotalVal == null)) categoryMinTotalVal = category.totalValue;
            if (category.totalValue != null && (category.totalValue > categoryMaxTotalVal || categoryMaxTotalVal == null)) categoryMaxTotalVal = category.totalValue;
        });
        Machinata.debug("  " + "calc categoryMinTotalVal/categoryMaxTotalVal: " + categoryMinTotalVal + "/" + categoryMaxTotalVal);
        minVal = categoryMinTotalVal;
        maxVal = categoryMaxTotalVal;
    }

    // Debug out
    Machinata.debug("  " + "calc min/max: " + minVal + "/" + maxVal);

    // Balance?
    if (opts.balance == true) {
        var minMaxAbsVal = Math.max(Math.abs(minVal), Math.abs(maxVal));
        if (minVal < 0 && maxVal > 0) {
            minVal = -minMaxAbsVal;
            maxVal = +minMaxAbsVal;
        } else {
            minVal = Math.min(0, minVal);
            maxVal = Math.max(0, maxVal);
        }
        Machinata.debug("  " + "balanced min/max: " + minVal + "/" + maxVal);

    }

    // Snap to zero?
    // We do so if either both min/max are >0, or min/max < 0
    if (opts.snapToZero == true) {
        if (minVal >= 0 && maxVal >= 0) {
            minVal = 0;
        } else if (minVal < 0 && maxVal < 0) {
            maxVal = 0;
        }
        Machinata.debug("  " + "zero-snap min/max: " + minVal + "/" + maxVal);
    }

    // Add margin
    if (opts.margin != null) {
        if (minVal < 0) minVal = minVal + (minVal * opts.margin);
        if (maxVal > 0) maxVal = maxVal + (maxVal * opts.margin);
        Machinata.debug("  " + "margined min/max: " + minVal + "/" + maxVal);
    }

    // Use D3's nice algorithm to snap the domain to nice round values...
    if (opts.niceDomain == true) {
        // See https://github.com/d3/d3-scale/blob/master/src/nice.js
        // See https://github.com/d3/d3-scale/blob/v2.2.2/README.md#continuous_nice
        var d3NiceDomain = d3.scaleLinear().domain([minVal, maxVal]).nice().domain();
        minVal = d3NiceDomain[0];
        maxVal = d3NiceDomain[1];
        Machinata.debug("  " + "niced min/max: " + minVal + "/" + maxVal);
    }


    // Set min max on axis's
    Machinata.debug("  " + "new min/max: " + minVal + "/" + maxVal);
    for (var si = 0; si < series.length; si++) {
        var serie = series[si];
        if (serie[opts.axisKey] == null) serie[opts.axisKey] = {};
        // We only update the min/max if it has not already been explicitly set...
        if (serie[opts.axisKey].minValue == null) serie[opts.axisKey].minValue = minVal;
        if (serie[opts.axisKey].maxValue == null) serie[opts.axisKey].maxValue = maxVal;
        if (serie[opts.axisKey].formatType == null) serie[opts.axisKey].formatType = "number"; //fallback
    }

    // Set tick values, set formatting
    for (var si = 0; si < series.length; si++) {
        var serie = series[si];
        var axis = serie[opts.axisKey];
        if (axis.minValue != null && axis.maxValue != null) {
            if (axis.requestedMinValue == null) axis.requestedMinValue = axis.minValue;
            if (axis.requestedMaxValue == null) axis.requestedMaxValue = axis.maxValue;
            Machinata.Reporting.Node.VegaNode.Util.automaticallySetAxisTickValues(axis, opts.tickCount, opts.niceDomain, opts.extendToDomain);
            Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatAxis(axis);
        }
    }
    
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.autoSnapMultiSeriesAxis = function (instance, config, json, opts) {
    //TODO: @dankrusi: make this more generic
    //TODO: @dankrusi: refactor to options params

    // Init
    Machinata.debug("Machinata.Reporting.Node.VegaNode.Util.autoSnapMultiSeriesAxis:");
    Machinata.debug("  "+"node id: "+json.id);

    // Pre process
    // Here we track all the min/max, and track the absolute min/max across all series
    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];
        if (seriesGroup.yAxis == null) seriesGroup.yAxis = {}; // Make sure the axis exists
        var minValue = null;
        var maxValue = null;
        for (var si = 0; si < seriesGroup.series.length; si++) {
            var serie = seriesGroup.series[si];
            for (var fi = 0; fi < serie.facts.length; fi++) {
                var fact = serie.facts[fi];
                if (fact.y != null && (fact.y < minValue || minValue == null)) minValue = fact.y;
                if (fact.y != null && (fact.y > maxValue || maxValue == null)) maxValue = fact.y;
            }
        }
        Machinata.debug("  " + "orig " + seriesGroup.id + ": ");
        Machinata.debug("  " + "  " + "min: " + seriesGroup.yAxis.minValue);
        Machinata.debug("  " + "  " + "max: " + seriesGroup.yAxis.maxValue);
        Machinata.debug("  " + "calc " + seriesGroup.id + ": ");
        Machinata.debug("  " + "  " + "min: " + minValue);
        Machinata.debug("  " + "  " + "max: " + maxValue);

        // Snap to zero?
        // We do so if either both min/max are >0, or min/max < 0
        if (json.autoSnapYAxisSnapToZero == true) {
            if (minValue >= 0 && maxValue >= 0) {
                minValue = 0;
            } else if (minValue < 0 && maxValue < 0) {
                maxValue = 0;
            }
            Machinata.debug("  " + "snapped to zero " + seriesGroup.id + ": ");
            Machinata.debug("  " + "  " + "min: " + minValue);
            Machinata.debug("  " + "  " + "max: " + maxValue);
        }

        // Add margin
        if (json.autoSnapYAxisMargin != null) {
            if (minValue < 0) minValue = minValue * (1.0 + json.autoSnapYAxisMargin);
            if (maxValue > 0) maxValue = maxValue * (1.0 + json.autoSnapYAxisMargin);

            Machinata.debug("  " + "margined " + seriesGroup.id + ": ");
            Machinata.debug("  " + "  " + "margin: " + json.autoSnapYAxisMargin);
            Machinata.debug("  " + "  " + "min: " + minValue);
            Machinata.debug("  " + "  " + "max: " + maxValue);
        }

        // Use D3's nice algorithm to snap the domain to nice round values...
        if (json.autoSnapYAxisNiceDomain == true) {
            // See https://github.com/d3/d3-scale/blob/master/src/nice.js
            // See https://github.com/d3/d3-scale/blob/v2.2.2/README.md#continuous_nice
            var domain = Machinata.Reporting.Node.VegaNode.Util.getNiceDomain([minValue, maxValue]);
            minValue = domain[0];
            maxValue = domain[1];
            Machinata.debug("  " + "niced " + seriesGroup.id + ": ");
            Machinata.debug("  " + "  " + "min: " + minValue);
            Machinata.debug("  " + "  " + "max: " + maxValue);
        }

        // Register, for now
        seriesGroup.yAxis.calcMinValue = minValue;
        seriesGroup.yAxis.calcMaxValue = maxValue;
        seriesGroup.yAxis.calcBandwidth = maxValue - minValue;

    }

    // Apply the strategy...
    if (json.autoSnapYAxisStategy == "proportional") {

        // Proportional strategy...

        // Track top/bottom min/max ratios (we use the upper value)
        var maxTopRatio = 0;
        var maxBottomRatio = 0;
        for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
            var seriesGroup = json.seriesGroups[sgi];
            if (seriesGroup.yAxis.preBandwidth != 0) {
                maxTopRatio = Math.max(maxTopRatio, seriesGroup.yAxis.calcMaxValue * (1) / seriesGroup.yAxis.calcBandwidth);
                maxBottomRatio = Math.min(maxBottomRatio, seriesGroup.yAxis.calcMinValue * (1) / seriesGroup.yAxis.calcBandwidth);
            }
        }
        // Apply each axis domain according to the max ratios
        for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
            var seriesGroup = json.seriesGroups[sgi];
            if (json.seriesGroups.length == 1) {
                // Exception if we only have one series group (we use the series group calculated value)
                seriesGroup.yAxis.strategyMinValue = seriesGroup.yAxis.calcMinValue;
                seriesGroup.yAxis.strategyMaxValue = seriesGroup.yAxis.calcMaxValue;
            } else if (seriesGroup.yAxis.calcBandwidth != 0) {
                seriesGroup.yAxis.strategyMinValue = maxBottomRatio * seriesGroup.yAxis.calcBandwidth;
                seriesGroup.yAxis.strategyMaxValue = maxTopRatio * seriesGroup.yAxis.calcBandwidth;
            }
        }

    } else if (json.autoSnapYAxisStategy == "none") {

        // No strategy...

        // Apply each axis domain according to the max ratios
        for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
            var seriesGroup = json.seriesGroups[sgi];
            seriesGroup.yAxis.strategyMinValue = minValue;
            seriesGroup.yAxis.strategyMaxValue = maxValue;
        }

    }else {

        throw "The auto snap strategy " + json.autoSnapYAxisStategy + " is not supported! Please check yout autoSnapYAxisStategy setting.";

    }

    // Check each group to see if a yaxis min/max is missing
    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];

        // Don't apply a strategy min/max value if one has been manually set...
        if (seriesGroup.yAxis.minValue != null && seriesGroup.yAxis.maxValue != null) {
            seriesGroup.yAxis.requestedMinValue = seriesGroup.yAxis.minValue;
            seriesGroup.yAxis.requestedMaxValue = seriesGroup.yAxis.maxValue;
            continue;
        }

        // Set the axis value to those provided by the strategy
        seriesGroup.yAxis.minValue = seriesGroup.yAxis.strategyMinValue;
        seriesGroup.yAxis.maxValue = seriesGroup.yAxis.strategyMaxValue;
        seriesGroup.yAxis.requestedMinValue = seriesGroup.yAxis.strategyMinValue;
        seriesGroup.yAxis.requestedMaxValue = seriesGroup.yAxis.strategyMaxValue;
        Machinata.debug("  " + "strategy " + seriesGroup.id + ": ");
        Machinata.debug("  " + "  " + "min: " + seriesGroup.yAxis.strategyMinValue);
        Machinata.debug("  " + "  " + "max: " + seriesGroup.yAxis.strategyMaxValue);
    }

    // Check each group to see if a insertYZeroRule is set but no axis crosses the zero mark?
    if (json.insertYZeroRule == true) {
        var aSeriesGroupCrossesZeroMark = false;
        for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
            var seriesGroup = json.seriesGroups[sgi];
            if (seriesGroup.yAxis.minValue <= 0 && seriesGroup.yAxis.maxValue >= 0) {
                aSeriesGroupCrossesZeroMark = true;
                break;
            }
        }
        if (aSeriesGroupCrossesZeroMark != true) {
            // Disable the zero mark
            json.insertYZeroRule = false;
        }
    }

    // Set tick values
    if (true) {

        // Reference: d3 ticks() source: https://github.com/d3/d3-array/blob/master/src/ticks.js
        Machinata.debug("will set ticks manually:")
        var tickCount = json.autoSnapYAxisTickCount;
        if (tickCount == null) tickCount = config.axisTargetTickCount; //TODO: @dankrusi what about if we want responsive?
        var tries = 0;
        var maxTries = 10;
        var currentAxisBoundFitScaleFactor = 1.0;
        while (tries < maxTries) {
            tries++;
            Machinata.debug("  "+"try", tries);
            var allAxisWithinRequestedBounds = true;
            for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
                var axis = json.seriesGroups[sgi].yAxis;
                if (sgi == 0) {
                    Machinata.Reporting.Node.VegaNode.Util.automaticallySetAxisTickValues(axis, tickCount, json.autoSnapYAxisNiceDomain);
                } else {
                    var refAxis = json.seriesGroups[0].yAxis;
                    var axisBandwidth = (axis.requestedMaxValue - axis.requestedMinValue);
                    var refAxisBandwidth = (refAxis.requestedMaxValue - refAxis.requestedMinValue);
                    var bandwidthFactor = (axisBandwidth / refAxisBandwidth) * currentAxisBoundFitScaleFactor;
                    //console.log("axisBandwidth", axisBandwidth);
                    //console.log("refAxisBandwidth", refAxisBandwidth);
                    //console.log("bandwidthFactor", bandwidthFactor);
                    axis.values = [];
                    for (var ti = 0; ti < refAxis.values.length; ti++) {
                        var refAxisTickValue = refAxis.values[ti];
                        var tickValue = refAxisTickValue * bandwidthFactor;
                        //console.log("tick", ti, refAxisTickValue, tickValue)
                        axis.values.push(tickValue);
                    }
                    Machinata.debug("  " +"refAxis values",refAxis.values);
                    Machinata.debug("  " +"axis values",axis.values);
                }
                // Register
                axis.minValue = axis.values[0];
                axis.maxValue = axis.values[axis.values.length - 1];
                // Check if within bounds
                if (axis.minValue > axis.requestedMinValue || axis.maxValue < axis.requestedMaxValue) {
                    allAxisWithinRequestedBounds = false;
                    Machinata.debug("  " +"axis " + sgi + " does not fit bounds:");
                } else {
                    Machinata.debug("  " +"axis " + sgi + " fits bounds:");

                }
                Machinata.debug("  " + "requested", axis.requestedMinValue, axis.requestedMaxValue);
                Machinata.debug("  " + "current", axis.minValue, axis.maxValue);
                
            }
            if (allAxisWithinRequestedBounds == false) {
                Machinata.debug("  " +"not allAxisWithinRequestedBounds!");
                currentAxisBoundFitScaleFactor += 0.05;
            } else {
                Machinata.debug("  " + "allAxisWithinRequestedBounds! Finishing...");
                break;
            }
        }

        
    }

    // Automatically set the axis format?
    if (true) {
        for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
            var axis = json.seriesGroups[sgi].yAxis;
            Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatAxis(axis);
        }
    }

};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.automaticallySetAxisTickValues = function (axis, tickCount, niceDomain, extendToDomain) {
    Machinata.debug("  " + "automatically set axis tick values:");
    if (axis.tickCount != null) tickCount = axis.tickCount;
    var scale = d3.scaleLinear().domain([axis.minValue, axis.maxValue]);
    Machinata.debug("  " + "raw scale", scale.domain());
    if (niceDomain == true) scale = scale.nice(tickCount);
    Machinata.debug("  " + "niced scale", scale.domain());
    var ticks = scale.ticks(tickCount);
    Machinata.debug("  " + "ticks", ticks);
    if (axis.requestedMinValue != null && axis.requestedMaxValue != null && extendToDomain != false) axis.values = Machinata.Reporting.Node.VegaNode.Util.extendTicksToDomain(ticks, axis.requestedMinValue, axis.requestedMaxValue);
    else axis.values = ticks;
    Machinata.debug("  " + "values", axis.values);
    Machinata.debug("  " + "ticks domain", axis.values[0], axis.values[axis.values.length - 1]);

    return axis.values;
};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatEdgeNumbers = function (facts) {
    var fullNumberFormat = d3.format(".0%");
    for (var i = 0; i < facts.length; i++) {
        var fact = facts[i];
        if (fact.format != null && fact.format.endsWith("%")) {
            // If the fact is between -1% and 1% (very small) or greater than 99.5% (very large, but not 100%), 
            // we use the facts full formatting, otherwise we use a standard full number percent format
            // that is simplified (ie 43% instead of 43.04%)...
            if ((fact.val <= -0.01 || fact.val >= 0.01) && fact.val <= 0.995 && fact.val != 1) fact.resolved = fullNumberFormat(fact.val);
        }
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatAxis = function (axis) {
    // We only support number formats
    if (axis.formatType == "number" && axis.format != null && axis.values != null) {
        Machinata.debug("Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatAxis:");
        if (axis.format.startsWith(".") && axis.format.endsWith("%")) {
            // Percent formatting ".5%"
            Machinata.debug("  " + "automatically formatting percent axis...");
            var minValue = axis.values[0];
            var maxValue = axis.values[axis.values.length-1];
            var tickCount = axis.values.length;
            var stepWidth = (maxValue - minValue) / (tickCount-1);
            var decPoints = -Math.ceil(Math.log10(stepWidth)); // from bmpi https://banknotes.atlassian.net/secure/RapidBoard.jspa?rapidView=7&projectKey=NGR&modal=detail&selectedIssue=NGR-817&assignee=5cf767844ddcda0e7cb95b49
            if (isFinite(decPoints) == false) decPoints = 0; // make sure this never fails
            Machinata.debug("  old format", axis.format);
            decPoints--; // TODO: @bmpi: for some reason this needs to be subracted one...?
            if (decPoints < 0) decPoints = 0; // make sure this never fails
            axis.format = "." + (decPoints) + "%";
            Machinata.debug("  new format", axis.format);
            axis.formatSource = "Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatAxis";
        } else if (axis.format.startsWith(".") && axis.format.endsWith("f")) {
            // Decimal formatting ".f%"
            Machinata.debug("  " + "automatically formatting decimal axis...");
            var minValue = axis.values[0];
            var maxValue = axis.values[axis.values.length - 1];
            var tickCount = axis.values.length;
            var stepWidth = (maxValue - minValue) / (tickCount - 1);
            var decPoints = -Math.ceil(Math.log10(stepWidth)); // from bmpi https://banknotes.atlassian.net/secure/RapidBoard.jspa?rapidView=7&projectKey=NGR&modal=detail&selectedIssue=NGR-817&assignee=5cf767844ddcda0e7cb95b49
            if (isFinite(decPoints) == false) decPoints = 0; // make sure this never fails
            Machinata.debug("  old format", axis.format);
            decPoints++; // TODO: @bmpi: for some reason this needs to be added one...?
            if (decPoints < 0) decPoints = 0; // make sure this never fails
            axis.format = "." + (decPoints) + "f";
            Machinata.debug("  new format", axis.format);
            axis.formatSource = "Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatAxis";
        } else {
            Machinata.debug("  " + "unsupported automatic format:"+axis.format);
        }
    }
};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.extendTicksToDomain = function (ticks, requestedMin, requestedMax) {
    // Sanity
    if (ticks.length < 2) return ticks; // we need at least two ticks
    // Init
    var tries = 0;
    var maxTries = 4;
    while (tries < maxTries) {
        tries++;
        var minValue = ticks[0];
        var maxValue = ticks[ticks.length - 1];
        var step = ticks[1] - ticks[0]; // Note: this will have a floating point error on small numbers
        var stepNiced = Machinata.Reporting.Node.VegaNode.Util.getNiceStep(step);
        if (minValue > requestedMin) {
            if (tries == 1) Machinata.debug("Automatically extending axis ticks:");
            Machinata.debug(" adding to front:", step, stepNiced);
            ticks.unshift(minValue - stepNiced);
        } if (maxValue < requestedMax) {
            if (tries == 1) Machinata.debug("Automatically extending axis ticks:");
            Machinata.debug("  adding to back", step, stepNiced);
            ticks.push(maxValue + stepNiced);
        } else {
            return ticks;
        }
    }
    return ticks;
};


/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis = function (instance, config, json, axisDefinition) {
    // Ticks on bottom
    if (axisDefinition.orient == "bottom" && axisDefinition.ticks == null && config.axisBottomShowTicks == true) {
        axisDefinition.ticks = true;
        axisDefinition.tickSize = config.axisBottomTickSize;
    }
    // Offset on bottom (only if no ticks)
    else if (axisDefinition.orient == "bottom" && axisDefinition.offset == null && config.axisBottomOffset > 0) {
        axisDefinition.offset = config.axisBottomOffset;
    }
    // Angle on bottom
    if (axisDefinition.orient == "bottom" && json.xAxisLabelAngle != null) {
        // Figure out label overlap. Usually we want greedy, but if they are rotated enough we use false (off)
        var labelOverlap = "greedy"; // default
        if (json.xAxisLabelAngle != null && (json.xAxisLabelAngle >= 45 || json.xAxisLabelAngle <= -45)) {
            labelOverlap = "greedy";
            axisDefinition.labelBound = false;
        }
        if (json.xAxisLabelAngle != null && (json.xAxisLabelAngle == -90)) {
            axisDefinition.labelBaseline = "middle"; // Vertical text baseline of axis tick labels, overriding the default setting for the current axis orientation. One of alphabetic (default), top, middle, bottom, line-top, or line-bottom. The line-top and line-bottom values ≥ 5.10 operate similarly to top and bottom, but are calculated relative to the lineHeight rather than fontSize alone.
        }
        // Define axis
        axisDefinition.labelAngle = json.xAxisLabelAngle; // Angle in degrees of axis tick labels
        axisDefinition.labelAlign = "right"; // Horizontal text alignment of axis tick labels, overriding the default setting for the current axis orientation.
        axisDefinition.labelOverlap = labelOverlap; // The strategy to use for resolving overlap of axis labels. If false (the default), no overlap reduction is attempted. If set to true or "parity", a strategy of removing every other label is used (this works well for standard linear axes). If set to "greedy", a linear scan of the labels is performed, removing any label that overlaps with the last visible label (this often works better for log-scaled axes).
        axisDefinition.labelSeparation = 0; // The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default 0). This property is ignored if labelOverlap resolution is not enabled.
    } else if (axisDefinition.orient == "bottom") {
        axisDefinition.labelAngle = { "signal": "responsiveSize == 'tiny' ? 90 : 0" }; 
        axisDefinition.labelBaseline = { "signal": "responsiveSize == 'tiny' ? 'middle' : 'top'" }; 
        axisDefinition.labelAlign = { "signal": "responsiveSize == 'tiny' ? 'left' : 'center'" }; 
        
    }
    // Apply tooltips
    if (json.xAxisShowTooltipsInLabel == true) {
        // Make sure encoding exists
        if (axisDefinition["encode"] == null) axisDefinition["encode"] = {};
        if (axisDefinition["encode"]["labels"] == null) axisDefinition["encode"]["labels"] = {};
        if (axisDefinition["encode"]["labels"]["enter"] == null) axisDefinition["encode"]["labels"]["enter"] = {};
        // Apply
        axisDefinition["encode"]["labels"]["interactive"] = true;
        axisDefinition["encode"]["labels"]["enter"]["tooltip"] = { "signal": "scale('xScaleTooltip',datum.value)" };
        
    }
    // Alternating label offset
    // EXPERIMENTAL!
    if (json.xAxisUseAlternatingLabelPositioning == true) {
        // Make sure encoding exists
        if (axisDefinition["encode"] == null) axisDefinition["encode"] = {};
        if (axisDefinition["encode"]["labels"] == null) axisDefinition["encode"]["labels"] = {};
        if (axisDefinition["encode"]["labels"]["update"] == null) axisDefinition["encode"]["labels"]["update"] = {};
        // Apply
        // This uses the scale called xScaleIndex to determine if even/odd, and then jumps the label around
        axisDefinition["encode"]["labels"]["update"]["dy"] = { "signal": "scale('xScaleIndex',datum.value) % 2 == 0 ? 0 : 20" };
        //axisDefinition["labelOverlap"] = "greedy";
        axisDefinition.labelAngle = 0; // don't allow
    }
    return axisDefinition;
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-donut.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-donut.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.DonutNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults = {};

/// <summary>
/// Donuts and pies have a ```solid``` chrome.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_1x1];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.supportsToolbar = true;

/// <summary>
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.insertLegend = true;

/// <summary>
/// Defines the inner radius in decimal percent.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.innerRadius = 0.5;

/// <summary>
/// Defines the outer radius in decimal percent.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.outerRadius = 1.0;

/// <summary>
/// If ```true```, displays labels inside the slices with a slide angle larger than ```sliceLablesMinimumDegrees```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabels = true;

/// <summary>
/// If ```true```, includes the slice value in the label.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabelsShowValue = true;

/// <summary>
/// If ```true```, includes the slice category in the label.
/// If this feature is used, care must be taken to ensure that the category size/length matches
/// the area given by the pie/donut slices.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabelsShowCategory = false;

/// <summary>
/// If ```true```, includes the slice value in the legend label.
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.legendLabelsShowValue = false;

/// <summary>
/// If ```true```, includes the slice category in the label.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.legendLabelsShowCategory = true;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the minimum slice angle required for the label to display.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabelsMinimumDegrees = 36;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the offset from the outer edge in pixels.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabelsOffsetPixels = 4;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the font size in pixels for the labels.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabelsSize = Machinata.Reporting.Config.chartTextSize;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the maximum width a label can have (in pixels).
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabelsLengthLimit = 160;

/// <summary>
/// If ```sliceLabels``` is enabled, defines whether slice labels should be placed on the inside or outside of the slices.
/// 
/// The following options are supported:
///  - ```inside-corner```: labels are placed on the inside corner of the slices, with the text rotated accordingly.
///  - ```inside-center```: labels are placed on the inside center of the slices.
///  - ```outside-center```: labels are placed on the outside of the slices, centered along the edge of the slice with the text aligned right or left depending on the quadrant. EXPERIMENTAL - DO NOT USE IN PRODUCTION.
/// 
/// By default ```inside-corner```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sliceLabelsPosition = "inside-corner";

/// <summary>
/// If set, sorts the facts automatically.
/// Value can either be ```descending``` or ```ascending```.
/// If no value is set, then the order of the data is used.
/// Note: For donuts/pies it is recommending to always use descending fact sort.
/// Note: Sorting the facts does not affect the legend order.
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.sortFacts = null;

/// <summary>
/// If enabled, if the fact is between -1% and 1% (very small) or greater than 99.5% (very large, but not 100%),
/// we use the facts full formatting (```fact.format```), otherwise we use a standard full number percent format
/// that is simplified (ie 43% instead of 43.04%)...
/// For this setting to work, the fact format specified (```fact.format```) must be of type percent (ie '.2%').
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.DonutNode.defaults.automaticallyFormatEdgeNumbers = true;


Machinata.Reporting.Node.DonutNode.getVegaSpec = function (instance, config, json, nodeElem) {



    // Create the sort (collection) transform. If no sort is given, we just provide an empty transform
    var collectTransform = {"type": "collect"};
    if (json.sortFacts != false && json.sortFacts != null) {
        collectTransform["sort"] = {
            "field": "fact.val",
            "order": [json.sortFacts]
        };
    }
    // Create slice label template
    var sliceLabelTemplate = "''";
    if (json.sliceLabels == true && json.sliceLabelsShowCategory == true) sliceLabelTemplate += " + datum.fact.category.resolved";
    if (json.sliceLabels == true && json.sliceLabelsShowCategory == true && json.sliceLabelsShowValue == true) sliceLabelTemplate += " + ': '";
    if (json.sliceLabels == true && json.sliceLabelsShowValue == true) sliceLabelTemplate += " + datum.valResolved";

    // Create legend label template
    var legendLabelTemplate = "''";
    if (json.legendLabelsShowCategory == true) legendLabelTemplate += " + datum.fact.category.resolved";
    if (json.legendLabelsShowCategory == true && json.legendLabelsShowValue == true) legendLabelTemplate += " + ': '";
    if (json.legendLabelsShowValue == true) legendLabelTemplate += " + datum.valResolved";

    return {
        "data": [
          {
              "name": "series",
              "values": null
          },
          {
              "name": "seriesResolved",
              "source": "series",
              "transform": [
                  {
                      "type": "flatten",
                      "fields": ["facts"],
                      "as": ["fact"]
                  }
              ]
          },
          {
              "name": "facts",
              "source": "seriesResolved",
              "transform": [
                  { "type": "formula", "initonly": true, "as": "key", "expr": "datum.fact.category.resolved" },
                  { "type": "formula", "initonly": true, "as": "valResolved", "expr": "datum.fact.resolved" },
                  { "type": "formula", "initonly": true, "as": "tooltipResolved", "expr": "datum.fact.category.resolved + ': ' + datum.valResolved" },
                  { "type": "formula", "initonly": true, "as": "labelResolved", "expr": legendLabelTemplate }, // for legend
                  { "type": "formula", "initonly": true, "as": "sliceLabelResolved", "expr": sliceLabelTemplate },
                  collectTransform,
                {
                    "type": "pie",
                    "field": "fact.val",
                    "startAngle": 0,
                    "endAngle": 6.29,
                    "sort": false
                  },
                  { "type": "formula", "initonly": true, "as": "midAngle", "expr": "(datum.startAngle + datum.endAngle) / 2" },
                  { "type": "formula", "initonly": true, "as": "hideSliceLabel", "expr": "((datum['endAngle'] - datum['startAngle'])*(180/PI) < " + json.sliceLabelsMinimumDegrees + ")" },
              ]
            }, 
            // Dynamically set the data source for inside labels depending on settings
            json.sliceLabelsPosition == "inside-corner" ? {
                "name": "factsForInsideCornerLabels",
                "source": "facts"
            } : {
                    "name": "factsForInsideCornerLabels",
                "values": [] // no data
            },
            json.sliceLabelsPosition == "outside-center" ? {
                "name": "factsForOutsideCenterLabels",
                "source": "facts"
            } : {
                "name": "factsForOutsideCenterLabels",
                "values": [] // no data
            },
            json.sliceLabelsPosition == "inside-center" ? {
                "name": "factsForInsideCenterLabels",
                "source": "facts"
            } : {
                    "name": "factsForInsideCenterLabels",
                "values": [] // no data
            }
        ],
        "signals": [
            {
                "name": "drawZeroLine",
                "init": "scale('color',data('facts')[0].key) == scale('color',data('facts')[length(data('facts'))-1].key)",
            },
            {
                "name": "innerRadius",
                "update": "(min(width,height) / 2)*" + json.innerRadius,
                
            },
            {
                "name": "outerRadius",
                "update": "(min(width,height) / 2)*" + json.outerRadius,
            },
            {
                "name": "chartTextSize",
                "update": json.chartTextSize,
            },
            {
                "name": "calculatedWidth",
                "update": "width",
            },
            {
                "name": "calculatedHeight",
                "update": "height",
            }
        ],
        "scales": [
          {
              "name": "color",
              "type": "ordinal",
              "domain": { "data": "facts", "field": "key" },
              "range": { "scheme": json.theme }
          },
          {
              "name": "sliceTextColor",
              "type": "ordinal",
              "domain": { "data": "facts", "field": "key" },
              "range": { "scheme": "text-on-" + json.theme }
          },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "facts", "field": "key" },
                "range": { "data": "facts", "field": "labelResolved" }
            },
          {
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "facts", "field": "key" },
              "range": { "scheme": json.theme }
          },
        ],

        "marks": [
            {
                "name": "masterGroupForSizing",
                "type": "group",
                "clip": false,
                "encode": {
                    "update": {
                        //"width": { "signal": "calculatedWidth + chartTextSize*6" },
                        //"height": { "signal": "calculatedHeight + chartTextSize*6" },
                    }
                },
                "marks": [
                    {
                        "name": "markSlices",
                        "type": "arc",
                        "from": { "data": "facts" },
                        "encode": {
                            "enter": {
                                "fill": { "scale": "color", "field": "key" },
                            },
                            "update": {
                                "x": { "signal": "width / 2" },
                                "y": { "signal": "height / 2" },
                                "startAngle": { "field": "startAngle" },
                                "endAngle": { "field": "endAngle" },
                                "tooltip": { "field": "tooltipResolved" },
                                "padAngle": { "value": 0 },
                                "innerRadius": { "signal": "innerRadius" },
                                "outerRadius": { "signal": "outerRadius" },
                                "cornerRadius": { "value": 0 }
                            }
                        }
                    },
                    {
                        "name": "markSliceLabelsInsideText",
                        "type": "text",
                        "from": {
                            "data": "factsForInsideCornerLabels"
                        },
                        "encode": {
                            "enter": {
                                "text": {
                                    // Only show the label if it meets the requirements of a min angle
                                    "signal": "if(" + json.sliceLabels + " == false || datum['hideSliceLabel'], null, datum.sliceLabelResolved)"
                                },
                                "fill": { "scale": "sliceTextColor", "field": "key" },

                                "fontSize": { "value": json.sliceLabelsSize },
                                "limit": { "value": json.sliceLabelsLengthLimit },
                                "align": {
                                    // This depends on whether the label is on the left right side
                                    "signal": "if(datum['endAngle']*(180/PI) < 180, 'right', 'left')"
                                },
                                "baseline": {
                                    // This depends on whether the label is on the left right side
                                    "signal": "if(datum['endAngle']*(180/PI) < 180, 'bottom', 'top')"
                                },
                                "dx": {
                                    // This depends on whether the label is on the left right side
                                    "signal": "if(datum['endAngle']*(180/PI) < 180, -" + json.sliceLabelsOffsetPixels + ", " + json.sliceLabelsOffsetPixels + ")"
                                },
                                "dy": {
                                    // This depends on whether the label is on the left right side
                                    "signal": "if(datum['endAngle']*(180/PI) < 180, -" + json.sliceLabelsOffsetPixels + ", " + json.sliceLabelsOffsetPixels + ")"
                                },
                            },
                            "update": {
                                "tooltip": { "field": "tooltipResolved" },
                                "x": {
                                    "signal": "width / 2"
                                },
                                "y": {
                                    "signal": "height / 2"
                                },
                                "radius": {
                                    "signal": "(min(width,height) / 2)*1"
                                },
                                "theta": {
                                    "signal": "datum['endAngle']"
                                },
                                "angle": {
                                    // The angle is the endAngle value, but we need to add 90 degrees depending on whether its on the left/right side
                                    "signal": "if(datum['endAngle']*(180/PI) < 180, (datum['endAngle']*(180/PI))-90, (datum['endAngle']*(180/PI))+90)"
                                }
                            }
                        }
                    },
                    {
                        "name": "markSliceLabelsOutsideText",
                        "type": "text",
                        "from": {
                            "data": "factsForOutsideCenterLabels"
                        },
                        "encode": {
                            "enter": {
                                "text": {
                                    // Only show the label if it meets the requirements of a min angle
                                    "signal": "if(" + json.sliceLabels + " == false || datum['hideSliceLabel'], null, datum.sliceLabelResolved)"
                                },
                                //"fill": { "scale": "sliceTextColor", "field": "key" },
                                "limit": { "value": json.sliceLabelsLengthLimit },
                                "fontSize": { "value": json.sliceLabelsSize },
                                "align": {
                                    // This depends on whether the label is on the left right side
                                    "signal": "if(datum['midAngle']*(180/PI) > 180, 'right', 'left')"
                                },
                                "baseline": {
                                    // This depends on whether the label is on the top or bottom side
                                    "signal": "if(datum['midAngle']*(180/PI) < 90 || datum['midAngle']*(180/PI) > 360-90, 'bottom', 'top')"
                                },
                            },
                            "update": {
                                "tooltip": { "field": "tooltipResolved" },
                                "x": {
                                    "signal": "width / 2"
                                },
                                "y": {
                                    "signal": "height / 2"
                                },
                                "radius": {
                                    "signal": "(outerRadius)*1 + " + json.sliceLabelsOffsetPixels * 2
                                },
                                "theta": {
                                    "signal": "datum['midAngle']"
                                },
                                "angle": {
                                    // The angle is the endAngle value, but we need to add 90 degrees depending on whether its on the left/right side
                                    "signal": "0"
                                    //"signal": "if(datum['endAngle']*(180/PI) < 180, (datum['endAngle']*(180/PI))-90, (datum['endAngle']*(180/PI))+90)"
                                }
                            }
                        }
                    },
                    {
                        "name": "markSliceLabelsInsideCenterText",
                        "type": "text",
                        "from": {
                            "data": "factsForInsideCenterLabels"
                        },
                        "encode": {
                            "enter": {
                                "text": {
                                    // Only show the label if it meets the requirements of a min angle
                                    "signal": "if(" + json.sliceLabels + " == false || datum['hideSliceLabel'], null, datum.sliceLabelResolved)"
                                },
                                "fill": { "scale": "sliceTextColor", "field": "key" },
                                "limit": { "value": json.sliceLabelsLengthLimit },
                                "fontSize": { "value": json.sliceLabelsSize },
                                "align": {
                                    // This depends on whether the label is on the left right side
                                    "signal": "'center'"
                                },
                                "baseline": {
                                    // This depends on whether the label is on the top or bottom side
                                    "signal": "'middle'"
                                },
                            },
                            "update": {
                                "tooltip": { "field": "tooltipResolved" },
                                "x": {
                                    "signal": "width / 2"
                                },
                                "y": {
                                    "signal": "height / 2"
                                },
                                "radius": {
                                    "signal": "(outerRadius+innerRadius)/2"
                                },
                                "theta": {
                                    "signal": "datum['midAngle']"
                                },
                                "angle": {
                                    // The angle is the endAngle value, but we need to add 90 degrees depending on whether its on the left/right side
                                    "signal": "0"
                                    //"signal": "if(datum['endAngle']*(180/PI) < 180, (datum['endAngle']*(180/PI))-90, (datum['endAngle']*(180/PI))+90)"
                                }
                            }
                        }
                    },
                    {
                        "type": "rect",
                        "encode": {
                            "enter": {
                                "fill": {
                                    "value": (json.chrome == "dark" ? config.darkColor : (json.chrome == "solid" ? config.solidColor : config.whiteColor))
                                },
                                "opacity": {
                                    "signal": "drawZeroLine == true ? 1 : 0"
                                }
                            },
                            "update": {

                                "x": {
                                    "signal": "width / 2"
                                },
                                "y": {
                                    "signal": "0"
                                },
                                "width": {
                                    "signal": config.domainLineSize
                                },
                                "height": {
                                    "signal": "(outerRadius - innerRadius) + 0" //  + config.domainLineSize
                                },

                            }
                        }
                    }
                ]
            },
          
        ]
    };
};

Machinata.Reporting.Node.DonutNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    spec["data"][0].values = json.series;
};


Machinata.Reporting.Node.DonutNode.init = function (instance, config, json, nodeElem) {
    // Create legend
    Machinata.Reporting.Node.VegaNode.Util.createLegendForSeriesFacts(instance, config, json, json.series);

    // Normalize facts to rounded percentages, but only if fact is very edge of boundaries...
    if (json.automaticallyFormatEdgeNumbers == true) {
        for (var si = 0; si < json.series.length; si++) {
            Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatEdgeNumbers(json.series[si].facts);
        }
    }

    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.DonutNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.DonutNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Node.DonutNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {
  
    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-pie.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-pie.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.DonutNode</inherits>
Machinata.Reporting.Node.PieNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PieNode.defaults = {};

/// <summary>
/// Donuts and pies have a ```solid``` chrome.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_1x1];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.supportsToolbar = true;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.insertLegend = true;

/// <summary>
/// Defines the inner radius in decimal percent.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.innerRadius = 0.0;

/// <summary>
/// Defines the outer radius in decimal percent.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.outerRadius = 1.0;

/// <summary>
/// If ```true```, displays labels inside the slices with a slide angle larger than ```sliceLablesMinimumDegrees```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabels = true;

/// <summary>
/// If ```true```, includes the slice value in the label.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabelsShowValue = true;

/// <summary>
/// If ```true```, includes the slice category in the label.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabelsShowCategory = false;

/// <summary>
/// If ```true```, includes the slice value in the legend label.
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.legendLabelsShowValue = false;


/// <summary>
/// If ```true```, includes the slice category in the label.
/// If this feature is used, care must be taken to ensure that the category size/length matches
/// the area given by the pie/donut slices.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.legendLabelsShowCategory = true;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the minimum slice angle required for the label to display.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabelsMinimumDegrees = 36;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the offset from the outer edge in pixels.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabelsOffsetPixels = 4;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the font size in pixels for the labels.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabelsSize = Machinata.Reporting.Config.chartTextSize;

/// <summary>
/// If ```sliceLabels``` is enabled, defines the maximum width a label can have (in pixels).
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabelsLengthLimit = 160;

/// <summary>
/// If ```sliceLabels``` is enabled, defines whether slice labels should be placed on the inside or outside of the slices.
/// 
/// The following options are supported:
///  - ```inside-corner```: labels are placed on the inside corner of the slices, with the text rotated accordingly.
///  - ```inside-center```: labels are placed on the inside center of the slices.
///  - ```outside-center```: labels are placed on the outside of the slices, centered along the edge of the slice with the text aligned right or left depending on the quadrant. EXPERIMENTAL - DO NOT USE IN PRODUCTION.
/// 
/// By default ```inside-corner```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sliceLabelsPosition = "inside-corner";

/// <summary>
/// If set, sorts the facts automatically.
/// Value can either be ```descending``` or ```ascending```.
/// If no value is set, then the order of the data is used.
/// Note: For donuts/pies it is recommending to always use descending fact sort.
/// Note: Sorting the facts does not affect the legend order.
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.sortFacts = null;

/// <summary>
/// If enabled, if the fact is between -1% and 1% (very small) or greater than 99.5% (very large, but not 100%),
/// we use the facts full formatting (```fact.format```), otherwise we use a standard full number percent format
/// that is simplified (ie 43% instead of 43.04%)...
/// For this setting to work, the fact format specified (```fact.format```) must be of type percent (ie '.2%').
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.PieNode.defaults.automaticallyFormatEdgeNumbers = true;


Machinata.Reporting.Node.PieNode.getVegaSpec = function (instance, config, json, nodeElem) {
    // Call parent
    return Machinata.Reporting.Node["DonutNode"].getVegaSpec(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.PieNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Call parent
    Machinata.Reporting.Node["DonutNode"].applyVegaData(instance, config, json, nodeElem, spec);
};
Machinata.Reporting.Node.PieNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["DonutNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.PieNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["DonutNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.PieNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["DonutNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};



Machinata.Reporting.Node.PieNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {

    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook,format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};





/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-gauge.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-gauge.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.GaugeNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults = {};

/// <summary>
/// ```solid``` chrome by default.
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.supportsDashboard = true;

/// <summary>
/// We do support a toolbar.
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.supportsToolbar = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_1x1];

/// <summary>
/// Legends are not necessary by default.
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.insertLegend = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.innerRadius = 0.5;

/// <summary>
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.outerRadius = 1.0;

/// <summary>
/// By default we use the ```magenta``` theme.
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.theme = "magenta";

/// <summary>
/// Exports are not necessary.
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.disableExport = true;

/// <summary>
/// The stroke width of the status arc line and it's arrow head, in pixels.
/// </summary>
Machinata.Reporting.Node.GaugeNode.defaults.statusArcLineSize = 2; // was 4


Machinata.Reporting.Node.GaugeNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var theme = Machinata.Reporting.getTheme(json.theme);
    var gray = Machinata.Reporting.getTheme("gray");
    return {
        "data": [
          {
              "name": "status",
              "values": null,
          },
          {
              "name": "segments",
              "values": null,
              "transform": [
                {
                    "type": "identifier",
                    "as": "index",
                },
                {
                    "type": "formula",
                    "as": "value",
                    "expr": "1"
                },
                {
                    "type": "formula",
                    "as": "color",
                    "expr": "datum.active == true ? 1 : 4"
                },
                {
                    "type": "formula",
                    "as": "colorShade",
                    "expr": "datum.active == true ? 'dark' : 'gray3'"
                },
                {
                    "type": "formula",
                    "as": "titleResolved",
                    "expr": "datum.title.resolved"
                },
                {
                    "type": "pie",
                    "field": "value",
                    "startAngle": 0,
                    "endAngle": { "signal": "PI * 2" },
                    "sort": false
                }
              ]
          },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
        ],
        "signals": [
            {
                "name": "getChartBackgroundColor",
                "init": json.chrome == "light" ? "'white'" : "scale('grayColorByShade','gray1')",
            },
            {
                "name": "getLabelText",
                "update": "data('status')[0].title.resolved",
            },
            {
                "name": "getLabelFontSize",
                "update": "getLabelText.length <= 3 ? getLargeLabelFontSize : getDynamicLabelFontSize",
            },
            {
                "name": "getDynamicLabelFontSize",
                "update": "max((min(width,height)/2)*0.1, config_chartTextSize)",
            },
            {
                "name": "getLargeLabelFontSize",
                "update": "config_subtitleSize",
            },
            {
                "name": "gaugeArea",
                "update": "min(width,height)",
            },
        ],
        "scales": [
          {
              "name": "grayColorByShade",
              "type": "ordinal",
              "domain": { "data": "grayShades", "field": "data" },
              "range": { "scheme": "gray" }
          },
          {
              "name": "colorByShade",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": json.theme }
          }
        ],

        "marks": [
          {
              "type": "arc",
              "from": { "data": "segments" },
              "encode": {
                  "enter": {
                      "fill": { "scale": "colorByShade", "field": "colorShade" }
                  },
                  "update": {
                      "x": { "signal": "width / 2" },
                      "y": { "signal": "height / 2" },
                      "startAngle": { "field": "startAngle" },
                      "endAngle": { "field": "endAngle" },
                      "tooltip": { "field": "titleResolved" },
                      //"padAngle": { "value": 0.03 },
                      "innerRadius": { "signal": "(gaugeArea / 2)*" + json.innerRadius },
                      "outerRadius": { "signal": "(gaugeArea / 2)*" + json.outerRadius },
                      "strokeCap": { "value": "square" }
                  }
              }
          },
          {
              "type": "arc",
              "from": { "data": "segments" },
              //"transform": [
              //      { "type": "filter", "expr": "datum.index < 3" },
              //],
              "encode": {
                  "enter": {
                      "stroke": { "signal": "datum.index == 1 ? 'transparent' : getChartBackgroundColor" },
                      "strokeWidth": { "value": json.statusArcLineSize }
                  },
                  "update": {
                      "x": { "signal": "width / 2" },
                      "y": { "signal": "height / 2" },
                      "startAngle": { "field": "startAngle" },
                      "endAngle": { "field": "startAngle" },
                      "tooltip": { "field": "resolved" },
                      //"padAngle": { "value": 0.03 },
                      "innerRadius": { "signal": "(gaugeArea / 2)*" + json.innerRadius + " - " + (json.statusArcLineSize / 2) },
                      "outerRadius": { "signal": "(gaugeArea / 2)*" + json.outerRadius + " + " + (json.statusArcLineSize / 2) },
                      "strokeCap": { "value": "square" }
                  }
              }
          },
          {
              "type": "arc",
              "from": { "data": "status" },
              "encode": {
                  "enter": {
                      "fill": { "scale": "colorByShade", "value": "bright" },
                      "tooltip": { "signal": "if(datum.tooltip, datum.tooltip.resolved, null)" }
                  },
                  "update": {
                      "x": { "signal": "width / 2" },
                      "y": { "signal": "height / 2" },
                      "startAngle": { "value": 0.0 },
                      "endAngle": { "signal": "(data('status')[0].value / length(data('segments')))*(PI*2)" },
                      "innerRadius": { "signal": "(gaugeArea / 2)*" + (json.innerRadius + 0.1) },
                      "outerRadius": { "signal": "(gaugeArea / 2)*" + (json.outerRadius - 0.1) }
                  }
              }
          },
          {
              "type": "arc",
              "from": { "data": "status" },
              "encode": {
                  "enter": {
                      "fill": { "scale": "grayColorByShade", "value": 'gray2' },
                      "tooltip": { "signal": "if(datum.tooltip, datum.tooltip.resolved, null)" }
                  },
                  "update": {
                      "x": { "signal": "width / 2" },
                      "y": { "signal": "height / 2" },
                      "startAngle": { "value": 0 },
                      "endAngle": { "signal": "(data('status')[0].value*0.99 / length(data('segments')))*(PI*2)" },
                      "innerRadius": { "signal": "(gaugeArea / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + " -" + (json.statusArcLineSize / 2) },
                      "outerRadius": { "signal": "(gaugeArea / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + " +" + (json.statusArcLineSize / 2) }
                  }
              }
          },
          {
              "type": "symbol",
              "encode": {
                  "enter": {
                      "stroke": { "scale": "grayColorByShade", "value": 'gray2' },
                      "strokeWidth": { "value": (json.statusArcLineSize) },
                      "shape": { "value": "M-1,1L0,0L-1,-1" },
                      "size": { "signal": "(gaugeArea / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + " *4.0" }, // at normal res should be about 1000
                      "tooltip": { "signal": "if(datum.tooltip, datum.tooltip.resolved, null)" }
                  },
                  "update": {
                      "angle": { "signal": "(data('status')[0].value*0.99 / length(data('segments')))*360" },
                      "x": { "signal": "width/2 + sin((data('status')[0].value*0.99 / length(data('segments')))*(PI*2))*  (min(width,height) / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + "" },
                      "y": { "signal": "height/2 - cos((data('status')[0].value*0.99 / length(data('segments')))*(PI*2))*  (min(width,height) / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + "" },
                  }
              }
          },
          {
              "type": "text",
              "style": "text",
              "encode": {
                  "enter": {
                      "fontWeight": { "value": "bold" },
                      "text": { "signal": "getLabelText" },
                      "align": { "value": "center" },
                      "baseline": { "value": "middle" },
                  },
                  "update": {
                      "fontSize": { "signal": "getLabelFontSize" }, // Dynamically size the font, but make sure we meet the minimum font size requirement
                      "x": { "signal": "width/2" },
                      "y": { "signal": "height/2" },
                  }
              }
          }
        ]
    };
};
Machinata.Reporting.Node.GaugeNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    spec["data"][1].values = json.segments;
    spec["data"][0].values = [json.status];
};

Machinata.Reporting.Node.GaugeNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.GaugeNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.GaugeNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};









/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-linecolumn.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-linecolumn.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// ## Axis's
/// Scaling Engine: ```Machinata.Reporting.Node.VegaNode.Util.autoSnapMultiSeriesAxis```
/// </summary>
/// <example>
/// See ```example-report-linecolumns.json``` for complete example usages.
/// </example>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.LineColumnNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults = {};

/// <summary>
/// By default charts are on solid chrome.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.supportsToolbar = true;

/// <summary>
/// Yes, insert a legend by default.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.insertLegend = true;

/// <summary>
/// Mark legend as interactive.
/// Deprecated.
/// </summary>
/// <deprecated/>
Machinata.Reporting.Node.LineColumnNode.defaults.legendIsInteractive = false;

/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.legendColumns = 2;

/// <summary>
/// Defines the amount of padding (or spacing) for bar-groups (in percent relative to bandwidth).
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.barBandPadding = 0.2;

/// <summary>
/// If true, a seperate x-zero rule is displayed.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.insertXZeroRule = false;

/// <summary>
/// If true, the x-axis grid is shown.
/// Default is ```false```.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.showXAxisGrid = false;

/// <summary>
/// If true, the x-axis title is shown.
/// Default is ```false```.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.showXAxisTitle = false;

/// <summary>
/// If true, the y-axis title is shown.
/// Default is ```false```.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.showYAxisTitle = false;

/// <summary>
/// If true, a seperate y-zero rule at 0 is displayed.
/// Note that if this is enabled, it will force the axis domain to cover the zero-mark.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.insertYZeroRule = true;

/// <summary>
/// Set the global x-axis scale type. Can be any vega supported scale type as long as the data matches.
/// Note: For time-scales, you should ensure that the fact x-values are in Unix Epoch Format (milliseconds).
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.globalXAxisScaleType = "time";

/// <summary>
/// If ```true```, labels will automatically be removed if they overlap the boundries of the axis by ```config.padding/2```.
/// By default ```true```,
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.globalXAxisLabelBound = true;

/// <summary>
/// When ```true```, the Y-Axis domains are automatically adjusted through different mechanisms
/// to make the axis' as pretty and nice as possible, especially when using multiple seriesGroups with
/// different axis domains.
///
/// With charts with multiple seriesGroups, each successive group's axis is always snapped to the first groups
/// domain through a multiple of 0.5.
///
/// Note: If a series-group contains a yAxis definitions with a minValue
/// and maxValue, then the autoSnap is not performed on this series. 
/// It is not recommended to mix manually-set axis domains with autoSnapped domains.
///
/// This feature spans across all Y-Axis (ie all series groups).
///
/// By default ```true```.
///  
/// See also:
///  - Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisStategy
///  - Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisMargin
///  - Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisNiceDomain
///  - Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisSnapToZero
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxis = true;

/// <summary>
/// When ```autoSnapYAxis``` is ```true```, defines the margin to add to the axis domain
/// in decimal percent.
/// By default ```0.05```, or 5%.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisMargin = 0.05;

/// <summary>
/// When ```autoSnapYAxis``` is ```true```, rounds the axis' domain to nice numbers.
/// Uses D3's domain scale ```nice()```.
/// By default ```true```
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisNiceDomain = true;

/// <summary>
/// When ```autoSnapYAxis``` is ```true```, snaps the axis' domain min value to zero. This only happens
/// if all values are either ```> 0``` or all values are ```< 0```.
/// By default ```true``` 
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisSnapToZero = true;

/// <summary>
/// Defines the strategy to use when adjusting the series groups y-axis automatically.
/// By default ```proportional```.
///
/// Valid strategies:
///  - ```proportional```: scales the axis domains proportionally, keeping a common domain ratio between all series
///  - ```none```: no additional strategy is applied (other than the nicing and margin)
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisStategy = "proportional";

/// <summary>
/// If set and ```autoSnapYAxis``` is ```true```, this defines a target number of ticks
/// for all series y-axis. It is not gauranteed that axis's have exactly said number of ticks.
/// The closest human-friendly tick step and tick count will be used.
/// If unset, this configuration will use the global axis config value ```Machinata.Reporting.Config.axisTargetTickCount```
///
/// By default ```null```.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.autoSnapYAxisTickCount = null;

/// <summary>
/// For scatterplots, the symbol type.
/// Can be:
///  - ```circle```
///  - ```square```
///  - ```triangle```
///  - ```diamond```
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.scatterPlotSymbolType = "circle";

/// <summary>
/// The width and height size (bounding box) for scatterplot symbols, in pixels.
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.scatterPlotSymbolSize = 16;


/// <summary>
/// Defines the maximum width of a bar in pixels. If there is not enough space, then the bar may be
/// smaller.
/// By default ```Machinata.Reporting.Config.verticalBarMaxSize```
/// </summary>
Machinata.Reporting.Node.LineColumnNode.defaults.barMaxSize = Machinata.Reporting.Config.verticalBarMaxSize;


Machinata.Reporting.Node.LineColumnNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var yaxisTickCount = null;
    //yaxisTickCount = 11;
    //alert(yaxisTickCount);
    return {
        "data": [
          {
              "name": "seriesGroups",
              "values": null,
          },
          {
              "name": "allSeries",
              "source": "seriesGroups",
              "transform": [
                {
                    "type": "flatten",
                    "fields": [
                      "series"
                    ],
                    "as": [
                      "serie"
                    ]
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum.id + '_' + datum.serie.id"
                }
              ]
          },
          {
              "name": "allSeriesResolved",
              "source": "allSeries",
              "transform": [
                { "type": "formula", "initonly": true, "as": "colorResolved", "expr": "(datum.serie.colorShade ? scale('colorByShade',datum.serie.colorShade) : scale('colorByKey',datum.key))" },
                { "type": "formula", "initonly": true, "as": "titleResolved", "expr": "datum.serie.title.resolved" },
                { "type": "formula", "initonly": true, "as": "type", "expr": "datum.serie.chartType" },
                { "type": "formula", "initonly": true, "as": "xAxisTransform", "expr": "datum.xAxis.transform" },
                { "type": "formula", "initonly": true, "as": "xAxisTitleResolved", "expr": "datum.xAxis.title != null ? datum.xAxis.title.resolved : null" },
                { "type": "formula", "initonly": true, "as": "yAxisTitleResolved", "expr": "datum.yAxis.title != null ? datum.yAxis.title.resolved : null" },
              ]
          },
            {
                "name": "allFlattened",
                "source": "allSeriesResolved",
                "transform": [
                  {
                      "type": "flatten",
                      "fields": [
                        "serie.facts"
                      ],
                      "as": [
                        "fact"
                      ]
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "factY",
                      "expr": "datum.fact.y"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "factX",
                      "expr": "datum.fact.x"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "factZ",
                      "expr": "datum.fact.z"
                  }
                ]
            },
            {
                "name": "allFlattenedBars",
                "source": "allFlattened",
                "transform": [
                  {
                      "type": "filter",
                      "expr": "datum.type == 'column'"
                  }
                ]
            },
            {
                "name": "xZeroData",
                /*"_comment": "Dummy data set to drive displaying the x-zero rule",*/
                "values": [0],
                "transform": [
                  {
                      "type": "filter",
                      "expr": "" + json.insertXZeroRule + " == true"
                  }
                ]
            },
            {
                "name": "yZeroData",
                /*"_comment": "Dummy data set to drive displaying the y-zero rule",*/
                "values": [0],
                "transform": [
                  {
                      "type": "filter",
                      "expr": "" + json.insertYZeroRule + " == true"
                  }
                ]
            },
        ],
        "signals": [
            {
                "name": "globalXScalePadding",
                /*"_comment": "This is a pre-computed value for the global x scale padding left and right to ensure there is room for the bars on the edge. If there are no bars, then we just use the standard padding",*/
                "update": "if(   data('allFlattenedBars').length > 0,    width / data('allFlattenedBars').length , " + (config.padding*3)+")"
            },
        ],
        "scales": [
    
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": config.themeColorShadeNames,
                "range": { "scheme": json.theme }
            },
          {
              "name": "colorByKey",
              "type": "ordinal",
              "domain": { "data": "allSeries", "field": "key" },
              "range": { "scheme": json.theme }
          },
          {
              "name": "color",
              "type": "ordinal",
              "domain": { "data": "allSeriesResolved", "field": "key" },
              "range": { "data": "allSeriesResolved", "field": "colorResolved" },
          },
          {
              "name": "debugColor",
              "type": "ordinal",
              "domain": {
                  "data": "allSeriesResolved",
                  "field": "key"
              },
              "range": {
                  "scheme": "category20"
              }
          },
          {
              // Provide the proper color for the legend
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "allSeriesResolved", "field": "key" },
              "range": { "data": "allSeriesResolved", "field": "colorResolved" },
          },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "allSeriesResolved", "field": "key" },
                "range": { "data": "allSeriesResolved", "field": "titleResolved" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisMinValue",
                "type": "ordinal",
                "domain": ["xAxisMinValue"],
                "range": { "data": "seriesGroups", "field": "xAxis.minValue" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisMaxValue",
                "type": "ordinal",
                "domain": ["xAxisMaxValue"],
                "range": { "data": "seriesGroups", "field": "xAxis.maxValue" }
            },
            {
                "name": "xScaleGlobal",
                /*"_comment": "This x-scale is used by everyone. Thus the chart groups are 'tight' with each other.",*/
                "type": json.globalXAxisScaleType,
                "domain": {
                    "data": "allFlattened",
                    "field": "factX"
                },
                "domainMin": {
                    "signal": "scale('xAxisMinValue','xAxisMinValue')",
                },
                "domainMax": {
                    "signal": "scale('xAxisMaxValue','xAxisMaxValue')",
                },
                "range": "width",
                "padding": { "signal": "globalXScalePadding" },
                //"padding": 30, // debugging only
            },
            {
                "name": "zScaleGlobal",
                "type": "linear",
                "domain": {
                    "data": "allFlattened",
                    "field": "factZ"
                },
                "range": [1,10],
            }
        ],
        "marks": [
          {
              /*"_comment": "Explodes the seriesGroups into individual group marks",*/
              "name": "groupGroups",
              "type": "group",
              "encode": {
                  "update": {
                      "width": {
                          "signal": "width"
                      },
                      "height": {
                          "signal": "height"
                      }
                  }
              },
              "from": {
                  "facet": {
                      "data": "seriesGroups",
                      "name": "facetGroups",
                      "groupby": "id"
                  }
              },
              "data": [],
              "marks": [
                {
                    /*"_comment": "Here we have a single group with all its series. At this stage we do an axis and scale",*/
                    "name": "groupSeries",
                    "type": "group",
                    "encode": {
                        "update": {
                            "width": {
                                "signal": "width"
                            },
                            "height": {
                                "signal": "height"
                            }
                        }
                    },
                    "data": [
                      {
                          "name": "series",
                          "source": "facetGroups",
                          "transform": [
                            {
                                "type": "flatten",
                                "fields": [
                                  "series"
                                ],
                                "as": [
                                  "serie"
                                ]
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "key",
                                "expr": "datum.id + '_' + datum.serie.id"
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "titleResolved",
                                "expr": "datum.serie.titleResolved"
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "chartType",
                                "expr": "datum.serie.chartType"
                            }
                          ]
                      },
                      {
                          "name": "flattened",
                          "source": "series",
                          "transform": [
                            {
                                "type": "flatten",
                                "fields": [
                                  "serie.facts"
                                ],
                                "as": [
                                  "fact"
                                ]
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factKey",
                                  "expr": "datum.key"
                              },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "factY",
                                "expr": "datum.fact.y"
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "factX",
                                "expr": "datum.fact.x"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factTitle",
                                  "expr": "(datum.fact && datum.fact.title) ? datum.fact.title.resolved : null"
                              },
                          ]
                      },
                      {
                          "name": "bars",
                          "source": "flattened",
                          "transform": [
                            {
                                "type": "filter",
                                "expr": "datum.chartType == 'column'"
                            }
                          ]
                      },
                      {
                          "name": "lines",
                          "source": "flattened",
                          "transform": [
                            {
                                "type": "filter",
                                "expr": "datum.chartType == 'line'"
                            },
                            {
                                "type": "identifier", 
                                "as": "sortId"
                            },
                            {
                                "type": "collect",
                                "sort": {
                                    "field": "sortId",
                                    "order": ["descending"] // Lines are sorted descending (we want the first to be on top)
                                }
                            }
                          ]
                      },
                      {
                          "name": "scatterplots",
                          "source": "flattened",
                          "transform": [
                            {
                                "type": "filter",
                                "expr": "datum.chartType == 'scatterplot'"
                            }
                          ]
                      }
                    ],
                    "scales": [
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "xAxisFormat",
                            "type": "ordinal",
                            "domain": ["xAxisFormat"],
                            "range": { "data": "series", "field": "xAxis.format" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "xAxisFormatType",
                            "type": "ordinal",
                            "domain": ["xAxisFormatType"],
                            "range": { "data": "series", "field": "xAxis.formatType" }
                        },
                      {
                          "name": "xScaleBar",
                          "type": "band",
                          "domain": {
                              "data": "bars",
                              "field": "factX"
                          },
                          "range": "width",
                          "padding": json.barBandPadding
                      },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisMinValue",
                            "type": "ordinal",
                            "domain": ["yAxisMinValue"],
                            "range": { "data": "series", "field": "yAxis.minValue" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisMaxValue",
                            "type": "ordinal",
                            "domain": ["yAxisMaxValue"],
                            "range": { "data": "series", "field": "yAxis.maxValue" }
                        },
                        {
                          "name": "yScale",
                          "type": "linear",
                          "domain": {
                              "data": "flattened",
                              "field": "factY"
                          },
                          "domainMin": {
                              "signal": "scale('yAxisMinValue','yAxisMinValue')",//"scale('yAxisMinValue','yAxisMinValue')",
                          },
                          "domainMax": {
                              "signal": "scale('yAxisMaxValue','yAxisMaxValue')",
                          },
                          "padding": config.yAxisLabelPadding,
                          //"padding": 30, // testing only
                          "range": "height",
                          "round": true, // setting round to false will cause a strange decoupled yaxis where the zero round is floating off
                            "zero": json._yAxisZero, // Boolean flag indicating if the scale domain should include zero. The default value is true for linear, sqrt and pow, and false otherwise.
                          "nice": json._yAxisNice // was true
                          //"nice": { "signal": "scale('yAxisTickCount','yAxisTickCount')" }
                          //"nice": true // setting nice to true will cause the axis domain to snap to a value, leading to a side affect that two axis' no longer align, setting it to false will cause the top/bottom of the bars/lines to hang over the edge of the yaxis
                      },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisOrient",
                            "type": "ordinal",
                            "domain": ["yAxisOrient"],
                            "range": { "data": "series", "field": "yAxis.orient" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisFormat",
                            "type": "ordinal",
                            "domain": ["yAxisFormat"],
                            "range": { "data": "series", "field": "yAxis.format" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisFormatType",
                            "type": "ordinal",
                            "domain": ["yAxisFormatType"],
                            "range": { "data": "series", "field": "yAxis.formatType" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "seriesIndex",
                            "type": "ordinal",
                            "domain": ["seriesIndex"],
                            "range": { "data": "series", "field": "index" }
                        }
                    ],
                    "axes": [

                        Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json,{
                            "orient": "bottom",
                            "scale": "xScaleGlobal",
                            "domain": false,
                            //"tickWidth": { "signal": "scale('seriesIndex','seriesIndex')" },
                            "format": { "signal": "if(scale('xAxisFormat','xAxisFormat') == null, ' ', scale('xAxisFormat','xAxisFormat'))" }, // If the format is null, use empty string ' ', otherwise 
                            "formatType": { "signal": "scale('xAxisFormatType','xAxisFormatType')" },
                            "values": { "signal": "scale('seriesIndex','seriesIndex') != 0 ? [] : data('series')[0].xAxis.values" }, // set values to [] if the series index is not 0, this ensures that values are set to nothing if not the first series, and thus preventing the axis from displaying multiple times
                            "title": (json.showXAxisTitle == true ? { "signal": "data('series')[0].xAxis.title != null ? data('series')[0].xAxis.title.resolved : null" } : null), // Vega can't not show a title other than if we set it to null hard, thus we doe this before compiling the spec (with an extra runtime check for safety)
                            "grid": json.showXAxisGrid,
                            "labelBound": (json.globalXAxisLabelBound == true ? (config.padding/2) : false), // Indicates if labels should be hidden if they exceed the axis range. If false (the default) no bounds overlap analysis is performed. If true, labels will be hidden if they exceed the axis range by more than 1 pixel. If this property is a number, it specifies the pixel tolerance: the maximum amount by which a label bounding box may exceed the axis range.
                            "tickCount": { "signal": "data('series')[0].xAxis.tickCount" },
                            //"translate": { "signal": "random()*20" }, // testing only
                            //"grid": true, // testing only
                            //"domain": true,  // testing only
                            //"labelFlush": true,  // testing only // Indicates if labels at the beginning or end of the axis should be aligned flush with the scale range. If a number, indicates a pixel distance threshold: labels with anchor coordinates within the threshold distance for an axis end-point will be flush-adjusted. If true, a default threshold of 1 pixel is used. Flush alignment for a horizontal axis will left-align labels near the beginning of the axis and right-align labels near the end. For vertical axes, bottom and top text baselines will be applied instead.
                            //"labelBound": false,  // testing only // Indicates if labels should be hidden if they exceed the axis range. If false (the default) no bounds overlap analysis is performed. If true, labels will be hidden if they exceed the axis range by more than 1 pixel. If this property is a number, it specifies the pixel tolerance: the maximum amount by which a label bounding box may exceed the axis range.
                        }),
                      
                        Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json,{
                          "orient": "left",
                          "scale": "yScale",
                          "tickSize": 0,
                          "tickRound": true,
                          "tickCount": yaxisTickCount,
                          "format": { "signal": "scale('yAxisFormat','yAxisFormat')" },
                          "formatType": { "signal": "scale('yAxisFormatType','yAxisFormatType')" },
                          "title": (json.showYAxisTitle == true ? { "signal": "data('series')[0].yAxis.title != null ? data('series')[0].yAxis.title.resolved : null" } : null), // Vega can't not show a title other than if we set it to null hard, thus we doe this before compiling the spec (with an extra runtime check for safety)
                          "zindex": 1,
                          "grid": true,
                          "domain": false,
                          "values": { "signal": "data('series')[0].yAxis.values" },
                          "encode": {
                              "labels": {
                                  "update": {
                                      "text": {
                                          "signal": "scale('yAxisOrient','yAxisOrient') == 'left' ? datum.label : ' '"
                                      }
                                  }
                              },
                              "grid": {
                                  "update": {
                                      "opacity": {
                                          "signal": "scale('yAxisOrient','yAxisOrient') == 'left' ? 1 : 0"
                                      }
                                  }
                              }
                          }
                      }),
                        Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json,{
                          "orient": "right",
                          "scale": "yScale",
                          "tickSize": 0,
                          "tickCount": yaxisTickCount,
                          "tickRound": true,
                          "format": { "signal": "scale('yAxisFormat','yAxisFormat')" },
                          "formatType": { "signal": "scale('yAxisFormatType','yAxisFormatType')" },
                          "title": (json.showYAxisTitle == true ? { "signal": "(scale('yAxisOrient','yAxisOrient') == 'right' && data('series')[0].yAxis.title != null) ? data('series')[0].yAxis.title.resolved : null" } : null), // Vega can't not show a title other than if we set it to null hard, thus we doe this before compiling the spec (with an extra runtime check for safety)
                          "zindex": 1,
                          "grid": false, //(Machinata.DebugEnabled == true ? true : false), // always hidden (unless in debug mode)
                          "domain": false,
                          "values": { "signal": "data('series')[0].yAxis.values" },
                          "encode": {
                              "labels": {
                                  "update": {
                                      "text": {
                                          "signal": "scale('yAxisOrient','yAxisOrient') == 'right' ? datum.label : ' '"
                                      }
                                  }
                              }
                          }
                        }),
                    ],
                    "marks": [
                      {
                          /*"_comment": "BARS MASTER GROUPS - hold on to your seat: its about to get complicated: first we do a transfrom on our xScaleGlobal on factX to move to the proper position. This is offset to snap to the left edge, not the center of tick. Then we facet the bars by factX. At the stage we are grouped in on a region that the bars could theoretically fill entirely for their factX (ie left edge 'Jan' to right edge 'Jan'). Now we create a band scale for the bars to test if the calculated bar width is larger than maxBarSize. We save the bar width to barWidthAdjusted that limits the width. From this we create another band scale that takes this into account and has it's range to a custom width where the width is not the entire 'Jan' area, but rather the barWidthAdjusted*numberOfBars. Using this scale we draw the bars, each offset by the different of the totalBarWidthAdjusted (the actual combined width of the bars) and the entire width ('Jan' left edge to right edge)",*/
                          "type": "group",
                          "clip": true,
                          "zindex": 1,
                          "from": {
                              "facet": {
                                  "data": "bars",
                                  "name": "facetBars",
                                  "groupby": "factX"
                              }
                          },
                          "encode": {
                              "update": {
                                  "x": {
                                      "scale": "xScaleGlobal",
                                      "field": "factX",
                                      "offset": {
                                          "scale": "xScaleBar",
                                          "band": 1,
                                          "mult": -0.5
                                      }
                                  }
                              }
                          },
                            "signals": [
                                {
                                    "name": "width",
                                    /*"_comment": "This is the entire width space of the bars for this x value",*/
                                    "update": "bandwidth('xScaleBar')"
                                },
                                {
                                    "name": "barWidthRaw",
                                    /*"_comment": "This is the calculated width of an individual bar, if it where to be unbound",*/
                                    "update": "bandwidth('barPosRawScale')"
                                },
                                {
                                    "name": "barWidthAdjusted",
                                    /*"_comment": "This is the calculated width of an individual bar set to a limit of barMaxSize",*/
                                    "update": "min( barWidthRaw, " + json.barMaxSize + " )"
                                },
                                {
                                    "name": "barCount",
                                    /*"_comment": "The actual count of bars", //BUG: what if a single facet does not have the entire set of bars?*/
                                    "update": "data('facetBars').length"
                                },
                                {
                                    "name": "totalBarWidthAdjusted",
                                    /*"_comment": "This is the total width of our adjusted bars. We need this for the actual scale, barPosAdjustedScale",*/
                                    "update": "barWidthAdjusted * barCount"
                                }
                          ],
                          "scales": [
                            {
                                "name": "barPosRawScale",
                                  "type": "band",
                                "range": "width",
                                "domain": {
                                    "data": "facetBars",
                                    "field": "factKey"
                                }
                              }, {
                                  "name": "barPosAdjustedScale",
                                  "type": "band",
                                  "align": 0.5,
                                  "range": { "signal": "[0,totalBarWidthAdjusted]" },
                                  "domain": {
                                      "data": "facetBars",
                                      "field": "factKey"
                                  }
                              }
                          ],
                          "marks": [
                            {
                                "name": "bars",
                                "from": {
                                    "data": "facetBars"
                                },
                                "type": "rect",
                                "encode": {
                                    "enter": {
                                        
                                        "fill": {
                                            "scale": "color",
                                            "field": "key"
                                        }
                                    },
                                    "update": {
                                        "x": { "signal": "scale('barPosAdjustedScale',datum.factKey) + (width-totalBarWidthAdjusted)/2" }, // we add the difference in size to center the entire group of bars again
                                        //"x": {
                                        //    "scale": "pos",
                                        //    "field": "factKey"
                                        //},
                                        //"width": { "signal":"barWidth"},
                                        "width": { "signal": "bandwidth('barPosAdjustedScale')" },
                                        //"width": {
                                        //    "scale": "pos",
                                        //    "band": 1
                                        //},
                                        "y": {
                                            "scale": "yScale",
                                            "field": "factY"
                                        },
                                        "y2": {
                                            "scale": "yScale",
                                            "value": 0
                                        },
                                        "tooltip": [
                                            {
                                                // Show tooltip only if we are visible
                                                "test": "(!length(data('legendSelected')) || indata('legendSelected', 'value', datum.key))",
                                                "signal": "'[title]' + scale('legendLabel',datum.factKey) + '[/title][items][item]' + format(datum.factY,scale('yAxisFormat','yAxisFormat')) + '[/item][/items]'"
                                            },
                                            { "value": null }
                                        ],
                                        "opacity": [
                                            { "test": "(!length(data('legendSelected')) || indata('legendSelected', 'value', datum.key))", "value": 1.0 },
                                            { "value": 0.0 }
                                        ],
                                    }
                                }
                            }
                          ]
                      },
                      {
                          /*"_comment": "LINES MASTER GROUPS",*/
                          "type": "group",
                          "clip": true,
                          "zindex": 3,
                          "from": {
                              "facet": {
                                  "data": "lines",
                                  "name": "facetLines",
                                  "groupby": "factKey"
                              }
                          },
                          "marks": [
                            {
                                "type": "line",
                                "from": {
                                    "data": "facetLines"
                                },
                                "encode": {
                                    "enter": {
                                        "stroke": {
                                            "scale": "color",
                                            "field": "key"
                                        },
                                        "strokeWidth": {
                                            "value": config.graphLineSize
                                        },
                                        "defined": {
                                            "signal": "datum.factY != null ? true : false"
                                        }
                                    },
                                    "update": {
                                        "x": {
                                            "scale": "xScaleGlobal",
                                            "field": "factX",
                                            //"offset": {
                                            //    "scale": "xScaleBar",
                                            //    "band": 1,
                                            //    "mult": 0
                                            //}
                                        },
                                        "y": {
                                            "scale": "yScale",
                                            "field": "factY"
                                        },
                                        "opacity": [
                                            { "test": "(!length(data('legendSelected')) || indata('legendSelected', 'value', datum.key))", "value": 1.0 },
                                            { "value": 0.0 }
                                        ],
                                    }
                                }
                            },
                            {
                                "type": "rect",
                                /*"_comment": "These are transparent rects for the tooltip",*/
                                "from": {
                                    "data": "facetLines"
                                },
                                "encode": {
                                    "enter": {
                                        "width": {
                                            "value": 10,
                                        },
                                        "height": {
                                            "value": 10,
                                        },
                                        "fill": {
                                            "value": "transparent"
                                        },
                                    },
                                    "update": {
                                        "xc": {
                                            "scale": "xScaleGlobal",
                                            "field": "factX",
                                            //"offset": {
                                            //    "scale": "xScaleBar",
                                            //    "band": 1,
                                            //    "mult": 0
                                            //}
                                        },
                                        "yc": {
                                            "scale": "yScale",
                                            "field": "factY"
                                        },
                                        "tooltip": [
                                            {
                                                // Show tooltip only if we have a value
                                                "test": "datum.factY == null",
                                                "value": null
                                            },
                                            {
                                                // Show tooltip only if we are visible
                                                "test": "(!length(data('legendSelected')) || indata('legendSelected', 'value', datum.key))",
                                                "signal": "'[title]' + scale('legendLabel',datum.factKey) + '[/title][items][item]' + format(datum.factY,scale('yAxisFormat','yAxisFormat')) + '[/item][/items]'"
                                                //"signal": "scale('legendLabel',datum.factKey) + ': ' + format(datum.factY,scale('yAxisFormat','yAxisFormat'))"
                                            },
                                            { "value": null }
                                        ]
                                    }
                                }
                            }
                          ]
                      },
                      {
                          /*"_comment": "Y-ZERO RULE",*/
                          "from": {
                              "data": "yZeroData"
                          },
                          "name": "yzero",
                          "zindex": 4,
                          "type": "rule",
                          "encode": {
                              "enter": {
                                  "stroke": { "value": "black" },
                                  "strokeWidth": { "value": config.domainLineSize }
                              },
                              "update": {
                                  "x": { "value": 0 },
                                  "x2": { "signal": "width" },
                                  "y": { "signal": "scale('yScale',0)" }
                              }
                          }
                      },
                      {
                          /*"_comment": "X-ZERO RULE",*/
                          "from": {
                              "data": "xZeroData"
                          },
                          "name": "xzero",
                          "zindex": 4,
                          "type": "rule",
                          "encode": {
                              "enter": {
                                  "stroke": { "value": "black" },
                                  "strokeWidth": { "value": config.domainLineSize }
                              },
                              "update": {
                                  "y": { "value": 0 },
                                  "y2": { "signal": "height" },
                                  "x": { "signal": "scale('xScaleGlobal',0)" }
                              }
                          }
                      },
                      {
                          /*"_comment": "SCATTERPLOT MASTER GROUPS",*/
                          "type": "group",
                          "clip": false,
                          "zindex": 5,
                          "from": {
                              "facet": {
                                  "data": "scatterplots",
                                  "name": "facetScatterplots",
                                  "groupby": "factKey"
                              }
                          },
                          "marks": [
                            {
                                "type": "symbol",
                                "from": {
                                    "data": "facetScatterplots"
                                },
                                "encode": {
                                    "enter": {
                                        "fill": {
                                            "scale": "color",
                                            "field": "key"
                                        },
                                    },
                                    "update": {
                                        "shape": { "value": json.scatterPlotSymbolType },
                                        "size": { "signal": (json.scatterPlotSymbolSize * json.scatterPlotSymbolSize) + " * (datum.fact.z ? scale('zScaleGlobal',datum.fact.z) : 1)" },
                                        "xc": {
                                            "scale": "xScaleGlobal",
                                            "field": "factX"
                                        },
                                        "yc": {
                                            "scale": "yScale",
                                            "field": "factY"
                                        },
                                        "opacity": [
                                            { "test": "(!length(data('legendSelected')) || indata('legendSelected', 'value', datum.key))", "value": 1.0 },
                                            { "value": 0.0 }
                                        ],
                                        "tooltip": [
                                            {
                                                // Show tooltip only if we are visible
                                                "test": "(!length(data('legendSelected')) || indata('legendSelected', 'value', datum.key))",
                                                "signal": "'[title]' + scale('legendLabel',datum.factKey) + (datum.factTitle ? ': '+datum.factTitle : '') + '[/title][items]' + '[item][key]' +  datum.xAxis.title.resolved   + '[/key][val]' +   format(datum.factX,scale('xAxisFormat','xAxisFormat')) + '[/val][/item]' + '[item][key]' +  datum.yAxis.title.resolved   + '[/key][val]' +   format(datum.factY,scale('yAxisFormat','yAxisFormat')) + '[/val][/item]'  + '[/items]'"
                                            },
                                            { "value": null }
                                        ]
                                    }
                                }
                            }
                          ]
                      }
                    ]
                }
              ]
          }
        ]
    };
};
Machinata.Reporting.Node.LineColumnNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert series
    spec["data"][0].values = json.seriesGroups;
};




Machinata.Reporting.Node.LineColumnNode.init = function (instance, config, json, nodeElem) {

    // Init
    json._yAxisNice = true; // As a fallback we let vega do its nice...
    json._yAxisZero = json.insertYZeroRule; // axis needs zero if we want to show the rule...

    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];
        seriesGroup.index = sgi;
    }

    // Generate legend data
    Machinata.Reporting.Node.VegaNode.Util.createLegendForGroupedSeries(instance, config, json, json.seriesGroups);

    // Autosnap? We only do this if there are multiple series groups...
    if (json.autoSnapYAxis == true) {
        json._yAxisNice = false;
        json._yAxisZero = json.autoSnapYAxisSnapToZero;
        Machinata.Reporting.Node.VegaNode.Util.autoSnapMultiSeriesAxis(instance, config, json);
    }

    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.LineColumnNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.LineColumnNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LineColumnNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {

    Machinata.debug("exportExcelFormat: json", json);

    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForSeriesGroupsChart(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-scatterplot.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-scatterplot.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// A graph-based scatterplot chart.
///
/// This node used the LineColumnNode underlying engine to display the data and drive the axes, thus
/// it shares the same data structure. 
/// 
/// Each serie must have the ```chartType``` of ```scatterplot```. 
/// 
/// Each fact may define the optional ```z``` property, which adjusts the fact symbol's size through a multiplier between
/// ```1``` and ```10```.
/// </summary>
/// <example>
/// See ```example-report-scatterplot.json``` for complete example usages.
/// </example>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.LineColumnNode</inherits>
Machinata.Reporting.Node.ScatterPlotNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults = {};

/// <summary>
/// By default charts are on solid chrome.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.supportsToolbar = true;

/// <summary>
/// Yes, insert a legend by default.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.insertLegend = true;

/// <summary>
/// Mark legend as interactive.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.legendIsInteractive = Machinata.Reporting.Node.LineColumnNode.defaults.legendIsInteractive;

/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.legendColumns = 2;

/// <summary>
/// Sets the correct legend data source for the automatic legend.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.legendDataSource = Machinata.Reporting.Node.LineColumnNode.defaults.legendDataSource;

/// <summary>
/// If true, a seperate x-zero rule is displayed.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.insertXZeroRule = true;

/// <summary>
/// If true, a seperate y-zero rule is displayed.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.insertYZeroRule = true;

/// <summary>
/// If defined, adds the given number of pixels to the y-scale.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.yScalePadding = 20;

/// <summary>
/// If true, the x-axis grid is shown.
/// Default is ```true```.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.showXAxisGrid = true;

/// <summary>
/// If true, the x-axis title is shown.
/// Default is ```true```.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.showXAxisTitle = true;

/// <summary>
/// If true, the y-axis title is shown.
/// Default is ```true```.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.showYAxisTitle = true;

/// <summary>
/// Set the global x-axis scale type. Can be any vega supported scale type as long as the data matches.
/// Note: For time-scales, you should ensure that the fact x-values are in Unix Epoch Format (milliseconds).
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.globalXAxisScaleType = "linear";

/// <summary>
/// If ```true```, labels will automatically be removed if they overlap the boundries of the axis by ```config.padding/2```.
/// By default ```true```,
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.globalXAxisLabelBound = true;

/// <summary>
/// For scatterplots, the symbol type.
/// Can be:
///  - ```circle```
///  - ```square```
///  - ```triangle```
///  - ```diamond```
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.scatterPlotSymbolType = "circle";

/// <summary>
/// The width and height size (bounding box) for scatterplot symbols, in pixels.
/// This value will be multiplied by the fact z value (if any).
/// By default this is ```Machinata.Reporting.Config.graphSymbolSize```.
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.scatterPlotSymbolSize = Machinata.Reporting.Config.graphSymbolSize;



/// <summary>
/// </summary>
Machinata.Reporting.Node.ScatterPlotNode.defaults.barMaxSize = 0;


Machinata.Reporting.Node.ScatterPlotNode.getVegaSpec = function (instance, config, json, nodeElem) {
    return Machinata.Reporting.Node.LineColumnNode.getVegaSpec(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.ScatterPlotNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    Machinata.Reporting.Node.LineColumnNode.applyVegaData(instance, config, json, nodeElem, spec);
};
Machinata.Reporting.Node.ScatterPlotNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["LineColumnNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.ScatterPlotNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["LineColumnNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.ScatterPlotNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["LineColumnNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-toggle.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-toggle.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// For each child in ```children```, this node will create a toggle interface that 
/// can switch between the nodes.
/// 
/// ## Toggle Title
/// Children nodes can contain the additional JSON property ```toggleTitle```. If this is defined,
/// then this is used for the tab title. Furthermore, the ToggleNode property ```toggleTitles``` can also be defined
/// to map a toggle title for each child node. If no title is provided, we fallback to the the node's standard ```mainTitle```
/// property. 
/// Defining a toggle title is good practice to ensure that tabs/lists always have short, concice titles.
///
/// ## Chrome
/// Unless explicitly set, the ToggleNode will automatically detect its chrome based on the childrens
/// chrome. This is important to ensure that the tab-bar chrome matches the toggle nodes.
/// 
/// ## UX
/// Toggles should always contain nodes with similar data and UI sizes. It is best practice to make
/// sure that toggle children do not cause the layout to jump around too much. For charts use the same
/// layout sizes, for tables that can differ in row-count, make sure the row counts are similar. For nodes
/// that take up more space than single screen-height, using an alternate to ToggleNode is recommended.
///
/// ## Screens
/// You should never break children nodes of a ToggleNode into different screens. A toggle node may be a screen itself, 
/// but it should not contain any further screens.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.ToggleNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults = {};

/// <summary>
/// This node does not support being added to dashboards...
/// Toggle children should be added to dashboards instead.
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.supportsDashboard = false;

/// <summary>
/// Toolbars are provided by children nodes...
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.supportsToolbar = false;

/// <summary>
/// If set to a node id, this property will set the initial tab that is active.
/// If ```null``` or unset, the first child node will be set as the active tab.
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.initialTab = null;

/// <summary>
/// When ```true```, a tab bar is automatically added at the bottom of the ToggleNode
/// that allows the toggling of nodes.
///
/// By default this is ```true```.
///
/// Note: either the ```tabSelection```, ```listSelection``` or ```menuSelection``` must be enabled in order
/// to allow for a user to toggle between nodes.
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.tabSelection = true;

/// <summary>
/// When ```true```, a select list is automatically added at the top of the ToggleNode
/// that allows the toggling of nodes.
///
/// By default this is ```false```. 
///
/// Can be combined with ```tabSelection: true```, however
/// the usability of having both tab selection and list selection is questionable.
///
/// Note: either the ```tabSelection```, ```listSelection``` or ```menuSelection``` must be enabled in order
/// to allow for a user to toggle between nodes.
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.listSelection = false;


/// <summary>
/// When ```true```, a menu (tab menu) is automatically added to the node's menubar on the top of the node.
///
/// By default this is ```false```. 
///
/// Should NOT be combined with ```tabSelection: true```.
///
/// Note: either the ```tabSelection```, ```listSelection``` or ```menuSelection``` must be enabled in order
/// to allow for a user to toggle between nodes.
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.menuSelection = false;

/// <summary>
/// When ```true```, a menu (tab menu) is displayed in it's soft version.
///
/// By default this is ```false```. 
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.useSoftTabMenuForMenuSelection = false;

/// <summary>
/// If defined, this array of translatable texts defines the toggle titles to use for the children
/// nodes. The array length must match that of the children number.
/// </summary>
/// <example>
/// ```
/// "toggleTitles": [
///     {
///         "resolved": "Child 1 Title"
///     },
///     {
///         "resolved": "Child 2 Title"
///     }
/// ]
/// ```
/// </example>
Machinata.Reporting.Node.ToggleNode.defaults.toggleTitles = null;


/// <summary>
/// When ```true```, this node's content is automatically exploded.
/// By default this is ```false```, but the ```webprint``` profile has a 
/// built-in override on this setting for ```true```.
/// </summary>
Machinata.Reporting.Node.ToggleNode.defaults.explodeChildren = false;

/// <summary>
/// Shows the current tab for ```tabId```, automatically updating any related toggle UI.
/// </summary>
Machinata.Reporting.Node.ToggleNode.showTab = function (instance, config, json, nodeElem, tabId) {
    // Init
    var childrensElem = nodeElem.data("children");
    var selectElem = nodeElem.data("select");
    var menuElem = nodeElem.data("menubar");
    var tabsElem = nodeElem.data("subtoolbar");
    // Hide others
    childrensElem.children().hide();
    if (tabsElem != null) tabsElem.find(".tab").removeClass("selected");
    if (menuElem != null) menuElem.find(".tab").removeClass("selected");
    // Show target node
    var targetNodeElem = childrensElem.find("[data-node-id=" + tabId+"]");
    targetNodeElem.children(".node-config-placeholder").empty().append(nodeElem.data("config-elem"));
    targetNodeElem.show();
    if (targetNodeElem.length == 0) console.warn("Machinata.Reporting.Node.ToggleNode.showTab: tab "+tabId+" doesn't exist.");
    // Select tab
    if (tabsElem != null) tabsElem.find(".tab[data-target-id='" + tabId + "']").addClass("selected");
    // Select menu button
    if (menuElem != null) menuElem.find(".tab[data-target-id='" + tabId + "']").addClass("selected");
    // Select list option
    if (selectElem != null) {
        selectElem.val(tabId);
    }
    // Register
    json._state.currentTab = tabId;
    // Make sure childrens is visible
    childrensElem.show();
    // Call responsive update
    //Machinata.Responsive.updateResponsiveElements(); // deprecated
    // Call redraw
    //targetNodeElem.trigger("machinata-reporting-redraw-node");
    targetNodeElem.trigger(Machinata.Reporting.Events.REDRAW_NODE_AND_CHILDREN_SIGNAL); // we now include all children, since they never got drawn in the first place
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ToggleNode.init = function (instance, config, json, nodeElem) {

    // Allow the toggle node?
    if (json.explodeChildren == true) {
        nodeElem.addClass("exploded");
        return;
    }

    // Init
    var self = this;

    // Bar selector?
    if (json.menuSelection == true) {
        nodeElem.data("menubar", Machinata.Reporting.buildMenubar(instance, { softMenuBar: json.useSoftTabMenuForMenuSelection }).appendTo(nodeElem));
        nodeElem.addClass("menu-selection");
    }

    // Childrens container
    var childrensElem = $("<div class='children'></div>").appendTo(nodeElem);
    childrensElem.hide();
    nodeElem.data("children", childrensElem);

    // List selector?
    if (json.listSelection == true) {
        var configurationElem = $("<div class='node-config machinata-reporting-config'></div>");
        var selectWrapperElem = $('<div class="machinata-reporting-select-wrapper"><select class="machinata-reporting-select"></select></div>');
        selectWrapperElem.append(Machinata.Reporting.buildIcon(instance,"chevron-down"));
        configurationElem.append(selectWrapperElem);
        var selectElem = selectWrapperElem.find("select");
        selectElem.on("change", function () {
            var targetId = selectElem.val();
            self.showTab(instance, config, json, nodeElem, targetId);
        });
        configurationElem.append($("<div class='clear'/>"));
        nodeElem.data("select", selectElem);
        nodeElem.data("config-elem", configurationElem);
        nodeElem.addClass("list-selection");
    }

    // Subtoolbar
    if (json.tabSelection == true) {
        // Create the sub tooltab for tabs
        var toolbarElem = Machinata.Reporting.buildToolbar(instance);
        toolbarElem.addClass("option-small");
        toolbarElem.addClass("machinata-reporting-subtoolbar");
        toolbarElem.addClass("toggle-toolbar");
        nodeElem.append(toolbarElem);
        nodeElem.data("subtoolbar", toolbarElem);
        nodeElem.addClass("tab-selection");
    }

    // Create all tabs...
    $.each(json.children, function (index, childJSON) {
        // Get title
        var toggleTitle = Machinata.Reporting.Text.resolve(instance,childJSON.toggleTitle);
        if (toggleTitle == null && json.toggleTitles != null) {
            // Try toggle node lookup
            if (json.toggleTitles.length >= index) {
                var titleFromParent = Machinata.Reporting.Text.resolve(instance,json.toggleTitles[index]);
                if (titleFromParent != null) toggleTitle = titleFromParent;
            }
        }
        if (toggleTitle == null) {
            // Fallback to mainTitle
            toggleTitle = Machinata.Reporting.Text.resolve(instance,childJSON.mainTitle);
        }
        // Add sub tab for this node
        if (json.tabSelection == true) {
            var tabElem = Machinata.Reporting.addSubTab(instance, nodeElem, toggleTitle, null, function (clickedElem) {
                var targetId = clickedElem.attr("data-target-id");
                self.showTab(instance, config, json, nodeElem, targetId);
            });
            tabElem.attr("data-target-id", childJSON.id);
        }
        // Menu item?
        if (json.menuSelection == true) {
            var buttonElem = Machinata.Reporting.addMenubarButton(instance, nodeElem, toggleTitle, function (clickedElem) {
                var targetId = clickedElem.attr("data-target-id");
                self.showTab(instance, config, json, nodeElem, targetId);
            }, { softMenuBar: json.useSoftTabMenuForMenuSelection });
            buttonElem.addClass("tab").attr("data-target-id", childJSON.id);
        }
        // Select option?
        if (json.listSelection == true) {
            nodeElem.data("select").append($("<option></option>").attr("value", childJSON.id).text(toggleTitle));
        }
        // Register the initial tab, if not manually set
        if (json.initialTab == null) {
            json.initialTab = childJSON.id;
        }
    });
};
Machinata.Reporting.Node.ToggleNode.postBuild = function (instance, config, json, nodeElem) {
    // Allow the toggle node?
    if (json.explodeChildren == true) {
        return;
    }

    // Automatically set the chrome (if not set manually)
    // This needs to be done after the children have been built, since we need to inherit defaults
    if (json.chrome == null) {
        var firstChildChrome = nodeElem.find(".machinata-reporting-node").first().attr("data-chrome");
        json.chrome = firstChildChrome;
        nodeElem.addClass("chrome-" + json.chrome);
        nodeElem.attr("chrome", json.chrome);
        if (nodeElem.data("subtoolbar") != null) nodeElem.data("subtoolbar").addClass("option-" + json.chrome);
    }
    // List selector?
    if (json.listSelection == true) {
        var childrensElem = nodeElem.data("children");
        childrensElem.children(".machinata-reporting-node").each(function () {
            var childNodeElem = $(this);
            var toolbarElem = childNodeElem.children(".machinata-reporting-toolbar");
            if (toolbarElem.length == 0) {
                // Insert at top of node
                childNodeElem.prepend($("<div class='node-config-placeholder'></div>"));
            } else {
                // Insert just after toolbar
                $("<div class='node-config-placeholder'></div>").insertAfter(toolbarElem);
            }
            
        });
    }
    // Initial tab
    // BUG: Vega doesn't like this here, the bounds calculations are off
    // Moved to draw below...
    //this.showTab(instance, config, json, nodeElem, json.initialTab);
    //BUG: tabs with children that invoke a redraw will prematurely call the draw and thus the initial showTab before the entire children tree is built
    // Mark as built 
    json._state.childrenBuilt = true;
};
Machinata.Reporting.Node.ToggleNode.draw = function (instance, config, json, nodeElem) {
    // Allow the toggle node?
    if (json.explodeChildren == true) {
        return;
    }

    // Initial draw
    // FIX: If not tab has been displayed before, then we show the first at this stage...
    //BUG: tabs with children that invoke a redraw will prematurely call the draw and thus the initial showTab before the entire children tree is built
    if (json._state.currentTab == null && json._state.childrenBuilt == true) this.showTab(instance, config, json, nodeElem, json.initialTab);  
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-hbar.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-hbar.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// ## Axis's
/// Scaling Engine: ```Machinata.Reporting.Node.VegaNode.Util.autoSnapSeriesAxis```
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.HBarNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults = {};

/// <summary>
/// By default charts are ```solid```.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support toolbar.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.supportsToolbar = true;

/// <summary>
/// No legends for this chart.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.insertLegend = true;

/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.legendColumns = 2;

/// <summary>
/// Defines the main yScale band padding for the bars, in decimal-percent.
/// Default is ```0.3```.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.bandPaddingPercent = 0.3;

/// <summary>
/// Defines the the width ratio the labels on the left side should use.
/// Default is ```0.5```.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.labelRatio = 0.5;

/// <summary>
/// Defines the maximum height of a bar in pixels. If there is not enough space, then the bar may be
/// smaller.
/// By default this is ```Machinata.Reporting.Config.horizontalBarMaxSize```.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.barMaxSize = Machinata.Reporting.Config.horizontalBarMaxSize;

/// <summary>
/// If not zero, a bar with a non-zero value is snapped to this size (in pixels).
/// By default ```3```.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.barMinValueWidth = 3;

/// <summary>
/// When ```true```, the X-Axis domain is automatically adjusted through different mechanisms
/// to make the axis' as pretty and nice as possible. 
///
/// Note: If a series contains a xAxis definitions with a minValue
/// and maxValue, then the autoSnap is not performed on this series.
///
/// By default ```true```.
///  
/// See also:
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisSnapToZero
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisNiceDomain
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisMargin
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisBalance
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxis = true;

/// <summary>
/// When ```autoSnapXAxis``` is ```true```, snaps the axis' domain min value to zero. This only happens
/// if all values are either ```> 0``` or all values are ```< 0```.
/// By default ```true``` 
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisSnapToZero = true;

/// <summary>
/// When ```autoSnapXAxis``` is ```true```, rounds the axis' domain to nice numbers.
/// Uses D3's domain scale ```nice()```.
/// By default ```true```
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisNiceDomain = true;

/// <summary>
/// By default ```false```
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisExtendToDomain = false;

/// <summary>
/// When ```autoSnapXAxis``` is ```true```, defines the margin to add to the axis domain
/// in decimal percent.
/// By default ```0.05```, or 5%.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisMargin = 0.10;

/// <summary>
/// When ```autoSnapXAxis``` is ```true```, this feature will automaticall balance the domain on negative and positive. 
/// Only applies to domains that span from negative to positive.
/// By default ```true``` 
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisBalance = true;

/// <summary>
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.autoSnapXAxisTickCount = 5;

/// <summary>
/// When ```fillChartSpace``` is ```false```, and there is enough space, the bars
/// are automatically stacked from top to bottom, not filling the entire chart space. 
/// If there is not enough space, then the bars are fit to the
/// chart area.
/// By default ```true``` on web, ```false``` for print.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.fillChartSpace = true;

/// <summary>
/// By default we use a ```greedy``` overlap strategy.
/// </summary>
Machinata.Reporting.Node.HBarNode.defaults.axisLabelOverlap = "greedy";


/// <summary>
/// </summary>
Machinata.Reporting.Node.HBarNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var ROUND = (config.roundToNearestFullPixel ? "round" : ""); // template for rounding function to use (ie non if not requested by config)
    return {
        "data": [
          {
              "name": "series",
              "values": null
          },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
          {
              "name": "facts",
              "source": "series",
              "transform": [
                {
                    "type": "flatten",
                    "fields": ["facts"],
                    "as": ["fact"]
                }
              ]
          },
          {
              "name": "factsResolved",
              "source": "facts",
              "transform": [

                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum.id" // serie id
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "category",
                      "expr": "datum.fact.category"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "label",
                      "expr": "datum.fact.label"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "val",
                    "expr": "datum.fact.val"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "categoryResolved",
                    "expr": "datum.category.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "titleResolved",
                    "expr": "datum.title.resolved"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "valResolved",
                      "expr": "datum.title != null ? (datum.title.resolved + ': ' + datum.fact.resolved) : (datum.fact.resolved)"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "labelResolved",
                      "expr": "datum.label != null ? (datum.label.resolved) : (null)"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "groupResolved",
                    "expr": "datum.group ? datum.group.resolved : datum.category.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "formatType",
                    "expr": "datum.fact.formatType ? datum.fact.formatType : 'number'" // default
                },
                /*{
                    "type": "formula",
                    "initonly": true,
                    "as": "format_OLD",
                    "expr": "datum.fact.format ? datum.fact.format : '.1%'" 
                },*/
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "format",
                    "expr": "(data('series')[0].xAxis != null && data('series')[0].xAxis.format != null) ? data('series')[0].xAxis.format : '.1%'"  // TODO: @bmpi, default fallback
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "serieId",
                    "expr": "datum.id"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "colorResolved",
                      "expr": "datum.colorShade != null ? scale('colorByShade',datum.colorShade) : scale('color',datum.serieId)"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "textColorResolved",
                      "expr": "datum.colorShade != null ? scale('colorByShadeText',datum.colorShade) : scale('colorText',datum.serieId)"
                  }
              ]
          },
          {
              "name": "factsCategories",
              "source": "factsResolved",
              "transform": [
                {
                    "type": "aggregate",
                    "groupby": ["groupResolved"],
                    "groupby": ["groupResolved","categoryResolved"]
                }
              ]
          }
        ],
        "signals": [
            {
                "name": "xScaleRightLabelFlush",
                /*"_comment": "If we have minus to positive, use this label flush",*/
                //"init": "if(data('series')[0].xAxis.minValue < 0 && data('series')[0].xAxis.maxValue > 0, " + json.xAxisLabelFlushPixels + ",   false  )"
                //"init": "true" // Old method deprecated to ensure labels are ALWAYS flush
                "init": "false" // Old method deprecated to ensure labels are ALWAYS flush
            },
            {
                "name": "numCategories",
                "update": "domain('factsByCategoryScale').length" //TODO
            },
            {
                "name": "numSeries",
                "update": "domain('factsByKeyScale').length"
            },
            {
                "name": "heightRaw",
                "update": "height"
            },
            {
                "name": "chartPadding",
                "init": config.padding
            },
            {
                "name": "heightPerBar",
                "update": json.barMaxSize
            },
            {
                "name": "heightPerCategory",
                "update": "heightPerBar * numSeries"
            },
            {
                "name": "heightForAxis",
                "update": Math.round(config.axisLabelPadding + (config.axisSize) + config.axisLabelPadding)
            },
            {
                "name": "heightNeeded",
                /*"_comment": "In theory, this should return the space needed for the maximum bar height. This emulates the way the vega scales use the inner/outer padding",*/
                "update": "round( heightPerCategory * (numCategories)* (1.0 + " + json.bandPaddingPercent + " + " + json.bandPaddingPercent +") + heightForAxis )"
            },
            {
                "name": "heightAdjusted",
                /*"_comment": "If our heightNeeded is less than the height, we use that. Otherwise we set the max height of the drawing area...",*/
                "update": (
                    json.fillChartSpace == true ?
                        "heightRaw" // fillChartSpace == true, the heightAdjusted is just the total area
                        :
                        "(heightNeeded+heightForAxis > heightRaw) ? heightRaw : heightNeeded-heightForAxis" // fillChartSpace == false
                )
            },
        ],
        "scales": [
            {
                "name": "color",
                "type": "ordinal",
                "domain": { "data": "series", "field": "id" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorText",
                "type": "ordinal",
                "domain": { "data": "series", "field": "id" },
                "range": { "scheme": "text-on-" +json.theme }
            },
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByShadeText",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": "text-on-" + json.theme }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisFormat",
                "type": "ordinal",
                "domain": ["xAxisFormat"],
                "range": { "data": "factsResolved", "field": "format" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisFormatType",
                "type": "ordinal",
                "domain": ["xAxisFormatType"],
                "range": { "data": "factsResolved", "field": "formatType" }
            },
            {
                "name": "factsByCategoryScale",
                "type": "band",
                "range": { "signal": "[0,height]" },
                "domain": { "data": "factsResolved", "field": "categoryResolved" }
            },
            {
                "name": "factsByKeyScale",
                "type": "band",
                "range": { "signal": "[0,height]" },
                "domain": { "data": "factsResolved", "field": "key" }
            },
          {
              // Provide the proper color for the legend
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "factsResolved", "field": "serieId" },
              "range": { "data": "factsResolved", "field": "colorResolved" },
          },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "factsResolved", "field": "serieId" },
                "range": { "data": "factsResolved", "field": "titleResolved" }
            },
        ],
        "marks": [
            /*{
                "type": "group",
                //"_comment": "DEBUG GROUP FOR HEIGHT ADJUSTED",
                "encode": {
                    "update": {
                        "opacity": { "signal": "0.4" },
                        "width": { "signal": "width/3" },
                        "height": { "signal": "heightAdjusted" },
                        "fill": { "signal": "'red'" }
                    }
                }
            },
            {
                "type": "group",
                //"_comment": "DEBUG GROUP FOR HEIGHT ADJUSTED",
                "encode": {
                    "update": {
                        "opacity": { "signal": "0.4" },
                        "width": { "signal": "width/2" },
                        "height": { "signal": "heightRaw" },
                        "fill": { "signal": "'yellow'" }
                    }
                }
            },*/
            // Begin wrapper group (only used for signals - we need a signal namespace that has the legend already subtracting the drawing area) (except legend)
            {
                "type": "group",
                /*"_comment": "DEBUG GROUP FOR WRAPPER",*/
                "signals": [
                    
                ],
                "encode": {
                    "update": {
                        "width": { "signal": "width" },
                        "height": { "signal": "height" },
                        // DEBUGGING:
                        //"fill": { "signal": "'yellow'" }
                    }
                },
                "marks": [
                    /*{
                        "type": "group",
                        "encode": {
                            "update": {
                                "opacity": { "signal": "0.4" },
                                "width": { "signal": "width/5" },
                                "height": { "signal": "height" },
                                "fill": { "signal": "'blue'" }
                            }
                        }
                    },*/
                    // Begin sizer group (sizes all master groups) (except legend)
                    {
                        "type": "group",
                        /*"_comment": "SIZER GROUP - this is used to clip the height of the contained groups, allowing the legend to appear at the bottom but the axis' snapped to this group",*/
                        "encode": {
                            "update": {
                                "width": { "signal": "width" },
                                "height": { "signal": "heightAdjusted > heightRaw ? heightRaw : heightAdjusted" },
                                // DEBUGGING:
                                //"fill": { "signal": "heightNeeded > height ? 'green' : null" },
                                //"tooltip": { "signal": "'heightNeeded: '+heightNeeded + ', heightAdjusted: '+heightAdjusted + ',heightPerBar:'+heightPerBar + ',heightPerCategory:'+heightPerCategory + ',height:'+height  + ',numCategories:'+numCategories  + ',numSeries:'+numSeries" }
                            }
                        },
                        "signals": [
                            {
                                /*"_comment": "This signal re-limits the height size (again) because the axis beneath will cause a reflow/recalculation in fillChartSpace == false mode (growing). If fillChartSpace is true, then the height is ignored (via a signal name rename)...",*/
                                "name": json.fillChartSpace == false ? "height" : "height_unused",
                                "update": "heightAdjusted > height ? height : heightAdjusted" // make sure we dont go bigger than height
                            },
                            {
                                /*"_comment": "This signal limits the bar size by automatically limiting the total space allowed",*/
                                "name": "categoryHeight",
                                "update": "(bandwidth('yScale') / numSeries) > " + json.barMaxSize + " ? numSeries*" + json.barMaxSize + " : bandwidth('yScale')"
                            },
                        ],
                        "scales": [
                            {
                                /*"_comment": "This is the main y scale bandwidth for groups of bars with padding",*/
                                "name": "yScale",
                                "type": "band",
                                "domain": {
                                    "data": "factsResolved",
                                    "field": "categoryResolved"
                                },
                                "range": "height",
                                "round": true,
                                "paddingInner": json.bandPaddingPercent,
                                "paddingOuter": json.bandPaddingPercent / 2
                            },
                            {
                                /*"_comment": "This is the main y scale bandwidth for groups of bars WITHOUT padding",*/
                                "name": "yScaleNoPadding",
                                "type": "band",
                                "domain": {
                                    "data": "factsResolved",
                                    "field": "categoryResolved"
                                },
                                "range": "height",
                                "padding": 0
                            },
                        ],
                        "marks": [
                            /*{
                                "type": "group",
                                "_comment": "DEBUG GROUP FOR HEIGHT WITHIN DRAWING AREA",
                                "encode": {
                                    "update": {
                                        "opacity": { "signal": "0.4" },
                                        "width": { "signal": "width/4" },
                                        "height": { "signal": "height" },
                                        "fill": { "signal": "'green'" },
                                        "tooltip": { "signal": "'height:' + height + ', heightRaw: ' + heightRaw + ', heightAdjusted: ' + heightAdjusted + ', heightNeeded: ' + heightNeeded" }
                                    }
                                }
                            },*/
                            // Begin master groups (LEFT, RIGHT, OVERLAY)
                            {
                                "type": "group",
                                /*"_comment": "This is the OVERLAY horizontal rules group",*/
                                "encode": {
                                    "enter": {
                                        //"fill": { "value": "yellow" },
                                    },
                                    "update": {
                                        "x": { "value": 0, },
                                        "width": { "signal": "width" },
                                        "height": { "signal": "height" }
                                    }
                                },
                                "scales": [
                                    {
                                        "name": "xScaleOverlay",
                                        "type": "linear",
                                        "round": true,
                                        "domain": [0, 1],
                                        "range": [0, { "signal": "width" }],
                                    }
                                ],
                                "axes": [
                                    Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json,{
                                        /*"_comment": "This is an fake axis with the same formatting as the right side axis to make sure we have exactly the same dimensions",*/
                                        "orient": "bottom",
                                        "scale": "xScaleOverlay",
                                        "values": ['INVALID_VALUE'],
                                        "labelFontWeight": json.xAxisLabelFontWeight,
                                        "labelOpacity": 0,
                                        "domain": false,
                                    })
                                ],
                                "marks": [
                                    {
                                        "name": "yzero",
                                        /*"_comment": "bottom rule that spans from left to right",*/
                                        "zindex": 2,
                                        "type": "rule",
                                        "encode": {
                                            "enter": {
                                                "stroke": { "value": config.domainLineColor },
                                                "strokeWidth": { "value": config.domainLineSize }
                                            },
                                            "update": {
                                                "x": { "value": 0 },
                                                "x2": { "signal": "width" },
                                                "y": { "signal": "round(height)" + (config.domainLineSize == 1 ? "-0.5" : "") } // -0.5 odd vega bug?
                                            }
                                        }
                                    },
                                    {
                                        "type": "group",
                                        "from": {
                                            "facet": {
                                                "data": "factsCategories",
                                                "name": "facetGroups",
                                                "groupby": "groupResolved"
                                            }
                                        },
                                        "encode": {
                                            "update": {
                                                "y": {
                                                    "scale": "yScale",
                                                    "field": "groupResolved"
                                                }
                                            }
                                        },
                                        "signals": [
                                            {
                                                "name": "height",
                                                "update": "bandwidth('yScale')"
                                            }
                                        ],
                                        "scales": [
                                            {
                                                "name": "groupPos",
                                                "type": "band",
                                                "range": "height",
                                                "round": true,
                                                "domain": {
                                                    "data": "facetGroups",
                                                    "field": "groupResolved"
                                                }
                                            }
                                        ],
                                        "marks": [
                                            {

                                                "name": "xzero",
                                                "from": {
                                                    "data": "facetGroups"
                                                },
                                                "zindex": 2,
                                                "type": "rule",
                                                "encode": {
                                                    "enter": {
                                                        "stroke": {
                                                            "value": config.gridColor
                                                        },
                                                    },
                                                    "update": {

                                                        "opacity": {
                                                            "signal": "scale('yScaleNoPadding',datum.categoryResolved) == 0 ? 0 : 1"
                                                        },
                                                        //"tooltip": {
                                                        //    "signal": "scale('yScaleNoPadding',datum.categoryResolved)"
                                                        //},
                                                        "x": {
                                                            "value": 0
                                                        },
                                                        "x2": {
                                                            "signal": "width"
                                                        },
                                                        "y": {
                                                            //"signal": "height + bandwidth('yScale')*0.1"
                                                            //"signal": "floor(0 - bandwidth('yScale')*" + (json.bandPaddingPercent / 2) + ")"
                                                            //"signal": "-ceil(bandwidth('yScale'))*0.3"
                                                            "signal": ROUND + "( -bandwidth('yScaleNoPadding')/2 * " + json.bandPaddingPercent + " ) + 0.5" // +0.5 odd vega bug?
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "group",
                                /*"_comment": "This is the LEFT side labels group",*/
                                "encode": {
                                    "enter": {
                                        //"fill": { "value": "blue" },
                                    },
                                    "update": {
                                        "x": { "value": 0, },
                                        //"x2": { "signal": "width", },
                                        "width": { "signal": ROUND + "( width*" + json.labelRatio + " )" },
                                        "height": { "signal": "height" }
                                    }
                                },
                                "signals": [
                                    {
                                        "name": "widthAdjusted",
                                        "update": ROUND + "( width*" + json.labelRatio + " )"
                                    }
                                ],
                                "scales": [
                                    {
                                        "name": "xScaleLeft",
                                        "type": "linear",
                                        "round": true,
                                        "domain": [0, 1],
                                        "range": [0, { "signal": "width*" + json.labelRatio }],
                                    }
                                ],
                                "axes": [
                                    Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json,{
                                        /*"_comment": "This is an fake axis with the same formatting as the right side axis to make sure we have exactly the same dimensions",*/
                                        "orient": "bottom",
                                        "scale": "xScaleLeft",
                                        "values": ['INVALID_VALUE'],
                                        "labelFontWeight": json.xAxisLabelFontWeight,
                                        "labelOpacity": 0,
                                        "domain": false,
                                    })
                                ],
                                "marks": [
                                    {
                                        "type": "group",
                                        "from": {
                                            "facet": {
                                                "data": "factsCategories",
                                                "name": "facetGroups",
                                                "groupby": "groupResolved"
                                            }
                                        },
                                        "encode": {
                                            "update": {
                                                "y": {
                                                    "signal": ROUND + "( scale('yScale',datum.groupResolved) )",
                                                    //"scale": "yScale",
                                                    //"field": "groupResolved"
                                                }
                                            }
                                        },
                                        "signals": [
                                            {
                                                "name": "height",
                                                "update": ROUND + "( bandwidth('yScale') )"
                                            }
                                        ],
                                        "scales": [
                                            {
                                                "name": "groupPos",
                                                "type": "band",
                                                "range": "height",
                                                "domain": {
                                                    "data": "facetGroups",
                                                    "field": "groupResolved"
                                                }
                                            }
                                        ],
                                        "marks": [
                                            {
                                                "name": "labels",
                                                "from": {
                                                    "data": "facetGroups"
                                                },
                                                "type": "text",
                                                "encode": {
                                                    "enter": {
                                                        "baseline": {
                                                            "value": "middle"
                                                        },
                                                        "text": {
                                                            "signal": "datum.categoryResolved"
                                                        },
                                                        "ellipsis": { "value": config.textTruncationEllipsis }
                                                    },
                                                    "update": {
                                                        "y": {
                                                            "signal": ROUND + "( scale('groupPos',datum.groupResolved) + bandwidth('yScale')/2 )",
                                                            //"scale": "groupPos",
                                                            //"field": "groupResolved"
                                                        },
                                                        "height": {
                                                            "scale": "groupPos",
                                                            "band": 1
                                                        },
                                                        "x": {
                                                            "scale": "xScaleLeft",
                                                            "value": 0
                                                        },
                                                        "limit": {
                                                            "signal": "widthAdjusted - "+config.padding
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "group",
                                /*"_comment": "This is the RIGHT side bars group",*/
                                "encode": {
                                    "enter": {
                                        //"fill": { "value": "red" },
                                    },
                                    "update": {
                                        "x": { "signal": ROUND + "( width*" + json.labelRatio + " )", },
                                        //"x2": { "signal": "width", },
                                        "width": { "signal": ROUND + "( width * (1-" + json.labelRatio + ") )" },
                                        "height": { "signal": "height" }
                                    }
                                },
                                "signals": [
                                    {
                                        "name": "widthAdjusted",
                                        "update": ROUND + "( width * (1-" + json.labelRatio + ") )"
                                    }
                                ],
                                "scales": [
                                    {
                                        "name": "xScaleRight",
                                        "type": "linear",
                                        "domain": {
                                            "data": "factsResolved",
                                            "field": "val"
                                        },
                                        "domainMin": {
                                            "signal": "data('series')[0].xAxis != null ? data('series')[0].xAxis.minValue : null",
                                        },
                                        "domainMax": {
                                            "signal": "data('series')[0].xAxis != null ? data('series')[0].xAxis.maxValue : null",
                                        },
                                        "padding": config.padding, // Expands the scale domain to accommodate the specified number of pixels on each of the scale range. The scale range must represent pixels for this parameter to function as intended. Padding adjustment is performed prior to all other adjustments, including the effects of the zero, nice, domainMin, and domainMax properties.
                                        "range": [0, { "signal": "width * (1-" + json.labelRatio+")" }],
                                        "round": true, // If true, rounds numeric output values to integers. Helpful for snapping to the pixel grid.
                                        "zero": true, // Boolean flag indicating if the scale domain should include zero. The default value is true for linear, sqrt and pow, and false otherwise.
                                        "nice": false // If true, there is a bug when the domain spans from minus to plus. Extends the domain so that it starts and ends on nice round values. This method typically modifies the scale’s domain, and may only extend the bounds to the nearest round value. Nicing is useful if the domain is computed from data and may be irregular. For example, for a domain of [0.201479…, 0.996679…], a nice domain might be [0.2, 1.0]. Domain values set via domainMin and domainMax (but not domainRaw) are subject to nicing. Using a number value for this parameter (representing a desired tick count) allows greater control over the step size used to extend the bounds, guaranteeing that the returned ticks will exactly cover the domain.
                                    }
                                ],
                                "axes": [
                                    Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json,{
                                        /*"_comment": "This is the actual axis with the values",*/
                                        "orient": "bottom",
                                        "scale": "xScaleRight",
                                        //"labelPadding": 0,
                                        //"labelOverlap": "parity", // The strategy to use for resolving overlap of axis labels. If false (the default), no overlap reduction is attempted. If set to true or "parity", a strategy of removing every other label is used (this works well for standard linear axes). If set to "greedy", a linear scan of the labels is performed, removing any label that overlaps with the last visible label (this often works better for log-scaled axes).
                                        //"labelSeparation": json.xAxisLabelSeparation, // The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default 0). This property is ignored if labelOverlap resolution is not enabled. ≥ 5.0
                                        //"labelFontWeight": json.xAxisLabelFontWeight,
                                        "labelFlush": { "signal": "xScaleRightLabelFlush" }, // Indicates if labels at the beginning or end of the axis should be aligned flush with the scale range. If a number, indicates a pixel distance threshold: labels with anchor coordinates within the threshold distance for an axis end-point will be flush-adjusted. If true, a default threshold of 1 pixel is used. Flush alignment for a horizontal axis will left-align labels near the beginning of the axis and right-align labels near the end. For vertical axes, bottom and top text baselines will be applied instead.
                                        "labelBound": false, //{ "signal": "xScaleRightLabelBound" }, // Indicates if labels should be hidden if they exceed the axis range. If false (the default) no bounds overlap analysis is performed. If true, labels will be hidden if they exceed the axis range by more than 1 pixel. If this property is a number, it specifies the pixel tolerance: the maximum amount by which a label bounding box may exceed the axis range.
                                        "values": { "signal": "data('series')[0].xAxis != null? data('series')[0].xAxis.values : null" }, // Indicates if labels at the beginning or end of the axis should be aligned flush with the scale range. If a number, indicates a pixel distance threshold: labels with anchor coordinates within the threshold distance for an axis end-point will be flush-adjusted. If true, a default threshold of 1 pixel is used. Flush alignment for a horizontal axis will left-align labels near the beginning of the axis and right-align labels near the end. For vertical axes, bottom and top text baselines will be applied instead.
                                        "domain": false,
                                        "format": { "signal": "scale('xAxisFormat','xAxisFormat')" },
                                        "formatType": { "signal": "scale('xAxisFormatType','xAxisFormatType')" }
                                    })
                                ],
                                "marks": [

                                    {
                                        "type": "group",
                                        "from": {
                                            "facet": {
                                                "data": "factsResolved",
                                                "name": "facetGroups",
                                                "groupby": "categoryResolved"
                                            }
                                        },
                                        "encode": {
                                            "update": {
                                                "y": {
                                                    "signal": ROUND + "( scale('yScale',datum.categoryResolved) )",
                                                    //"scale": "yScale",
                                                    //"field": "categoryResolved"
                                                }
                                            }
                                        },
                                        "signals": [
                                            {
                                                "name": "height",
                                                "update": "categoryHeight"
                                            },
                                            {
                                                "name": "fullHeight",
                                                "update": "bandwidth('yScale')"
                                            },
                                            {
                                                "name": "barMinValueWidth",
                                                "update": json.barMinValueWidth,
                                            },
                                        ],
                                        "scales": [
                                            {
                                                "name": "seriesPos",
                                                "type": "band",
                                                "range": "height",
                                                "round": true,
                                                "domain": {
                                                    "data": "factsResolved",
                                                    "field": "key"
                                                }
                                            }
                                        ],
                                        "marks": [
                                            {
                                                "name": "bars",
                                                /*"_comment": "This displays the actual bar using the group fill, but can also contain children such as the fact label",*/
                                                "from": {
                                                    "data": "facetGroups"
                                                },
                                                "type": "group",
                                                "signals": [
                                                    
                                                ],
                                                "encode": {
                                                    "enter": {
                                                        "tooltip": {
                                                            "signal": "datum.valResolved"
                                                            //"signal": "'DEBUG: ' + xScaleRightLabelFlush",
                                                            //"signal": "'DEBUG: ' + scale('seriesPos',datum.id) + '/' + bandwidth('seriesPos') + '/'+ datum.id + '/'+ datum.valResolved",
                                                            //"signal": "'DEBUG: '+(scale('xScaleRight',datum.val)-scale('xScaleRight',0))"
                                                            //"signal": "'DEBUG: '+scale('xAxisFormatType','xAxisFormatType')"
                                                        },
                                                        "fill": {
                                                            "signal": "datum.colorResolved"
                                                        }
                                                    },
                                                    "update": {
                                                        "y": {
                                                            "signal": ROUND + "( scale('seriesPos',datum.id) + (fullHeight-height)/2 )"
                                                        },
                                                        "height": {
                                                            "signal": ROUND + "( bandwidth('seriesPos') )"
                                                            //"scale": "seriesPos",
                                                            //"band": 1
                                                        },
                                                        "x": {
                                                            "signal": ROUND + "( scale('xScaleRight',0) )"
                                                            //"scale": "xScaleRight",
                                                            //"value": 0
                                                        },
                                                        "width": [
                                                            {
                                                                "test": "datum.val < 0 && (scale('xScaleRight',datum.val)-scale('xScaleRight',0)) > -barMinValueWidth",
                                                                "value": -json.barMinValueWidth
                                                            },
                                                            {
                                                                "test": "datum.val > 0 && (scale('xScaleRight',datum.val)-scale('xScaleRight',0)) < +barMinValueWidth",
                                                                "value": json.barMinValueWidth
                                                            },
                                                            {
                                                                "signal": ROUND + "( (scale('xScaleRight',datum.val)-scale('xScaleRight',0)) )"
                                                            }
                                                        ]
                                                    }
                                                },
                                                "marks": [
                                                    {
                                                        "type": "text",
                                                        "encode": {
                                                            
                                                            "enter": {
                                                                "tooltip": {
                                                                    "signal": "parent.valResolved"
                                                                },
                                                                "baseline": {
                                                                    "value": "middle"
                                                                },
                                                                "text": {
                                                                    "signal": "parent.labelResolved"
                                                                },
                                                                "fill": {
                                                                    "signal": "parent.textColorResolved"
                                                                },
                                                                "align": {
                                                                    "signal": "parent.val < 0 ? 'right' : 'left'"
                                                                },
                                                            },
                                                            "update": {
                                                                "x": {
                                                                    "signal": "parent.val < 0 ? (-chartPadding/2) : (chartPadding/2)"
                                                                },
                                                                "y": {
                                                                    "signal": "( bandwidth('seriesPos')/2 )"
                                                                }
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "name": "xzero",
                                        "zindex": 2,
                                        "type": "rule",
                                        "encode": {
                                            "enter": {
                                                "stroke": {
                                                    "value": config.domainLineColor
                                                },
                                                "strokeWidth": {
                                                    "value": config.domainLineSize
                                                }
                                            },
                                            "update": {
                                                "x": {
                                                    "signal": "scale('xScaleRight',0)" + (config.domainLineSize == 1 ? "-0.5" : "") // -0.5 odd vega bug?
                                                    //"scale": "xScaleRight",
                                                    //"value": 0
                                                },
                                                "y": {
                                                    "value": 0
                                                },
                                                "y2": {
                                                    "signal": "height"
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                        ]
                    },
                ]
            }
        ]
    };
};
Machinata.Reporting.Node.HBarNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert series
    spec["data"][0].values = json.series;
};
Machinata.Reporting.Node.HBarNode.init = function (instance, config, json, nodeElem) {

    // Generate legend data
    Machinata.Reporting.Node.VegaNode.Util.createLegendForSeries(instance, config, json, json.series);

    // Use our own axis snapping tool?
    if (json.autoSnapXAxis == true) {
        Machinata.Reporting.Node.VegaNode.Util.autoSnapSeriesAxis(
            instance, 
            config,
            json,
            json.series,
            {
                axisKey: "xAxis",
                snapToZero: json.autoSnapXAxisSnapToZero,
                niceDomain: json.autoSnapXAxisNiceDomain,
                extendToDomain: json.autoSnapXAxisExtendToDomain,
                margin: json.autoSnapXAxisMargin,
                balance: json.autoSnapXAxisBalance,
                tickCount: json.autoSnapXAxisTickCount,
            }
        );
    }


    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.HBarNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.HBarNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};
/// <summary>
/// </summary>
Machinata.Reporting.Node.HBarNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {

    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};







/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-vbar.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-vbar.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// ## Axis's
/// Scaling Engine: ```Machinata.Reporting.Node.VegaNode.Util.autoSnapSeriesAxis```
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.VBarNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults = {};

/// <summary>
/// By default charts are ```solid```.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.chrome = "solid";
/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support toolbar.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.supportsToolbar = true;

/// <summary>
/// Legends for this chart.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.insertLegend = true;

/// <summary>
/// Sets the number of columns to use for legends. 
/// By default we use```2```.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.legendColumns = 2;

/// <summary>
/// Defines the amount of padding (or spacing) for bar-groups (in percent relative to bandwidth).
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.barBandPadding = 0.2;

/// <summary>
/// Defines the maximum width of a bar in pixels. If there is not enough space, then the bar may be
/// smaller.
/// By default ```Machinata.Reporting.Config.verticalBarMaxSize```
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.barMaxSize = Machinata.Reporting.Config.verticalBarMaxSize;

/// <summary>
/// When ```true```, the Y-Axis domain is automatically adjusted through different mechanisms
/// to make the axis' as pretty and nice as possible.
/// 
/// Note: If a series contains a yAxis definitions with a minValue
/// and maxValue, then the autoSnap is not performed on this series.
///
/// By default ```true```.
///  
/// See also:
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapYAxisSnapToZero
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapYAxisNiceDomain
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapYAxisMargin
///  - Machinata.Reporting.Node.HBarNode.defaults.autoSnapYAxisBalance
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.autoSnapYAxis = true;

/// <summary>
/// When ```autoSnapYAxis``` is ```true```, snaps the axis' domain min value to zero. This only happens
/// if all values are either ```> 0``` or all values are ```< 0```.
/// By default ```true``` 
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.autoSnapYAxisSnapToZero = true;

/// <summary>
/// When ```autoSnapYAxis``` is ```true```, rounds the axis' domain to nice numbers.
/// Uses D3's domain scale ```nice()```.
/// By default ```true```
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.autoSnapYAxisNiceDomain = true;

/// <summary>
/// When ```autoSnapYAxis``` is ```true```, defines the margin to add to the axis domain
/// in decimal percent.
/// By default ```0.05```, or 5%.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.autoSnapYAxisMargin = 0.05;

/// <summary>
/// When ```autoSnapYAxis``` is ```true```, this feature will automaticall balance the domain on negative and positive. 
/// Only applies to domains that span from negative to positive.
/// By default ```true``` 
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.autoSnapYAxisBalance = true;

/// <summary>
/// When enabled, the bars will automatically stack within their categories. 
/// All fact values must be positive, 
/// or the chart will not render.
/// If ```autoSnapYAxis``` is enabled, the y-axis domain will automatically be adjusted to account
/// for the new limits. If it is disabled, you must ensure that the y-axis domain accounts for largest
/// category total.
/// By default ```false``` 
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.stackedSeries = false;

/// <summary>
/// If ```stackedSeries``` is ```true```, then the multiple defines the total width of each stacked bar
/// relative to what a single bar width would take. This ensures a consistent design while allowing for a more
/// practical bar width in stacked mode.
/// By default ```4``` 
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.stackedSeriesBarWidthMultiple = 4;

/// <summary>
/// By default we use a ```greedy``` overlap strategy.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.axisLabelOverlap = "greedy";

/// <summary>
/// Defines the maximum characters a x-axis label can have before is line-breaked.
/// Note that x-axis labels are allowed maximum two lines.
/// By default ```10```
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.xAxisLabelLimitChars = 12;

/// <summary>
/// The maximumum number of lines a label can span. If the maximum lines exceed, the 
/// ```xAxisLabelLimitChars``` is automatically postfixed.
/// By default ```2```.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.xAxisLabelLimitLines = 3;

/// <summary>
/// When ```true```, facts can have tooltips which are displayed on the x-axis labels.
/// If a lable was automatically truncated, a tooltip is automatically generated (if not already set).
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.VBarNode.defaults.xAxisShowTooltipsInLabel = false;

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.VBarNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var stackedSeriesBandwidthSize = json.stackedSeriesBarWidthMultiple;
    var stackedSeriesFakeDomain = [];
    for (var i = 0; i < stackedSeriesBandwidthSize; i++) stackedSeriesFakeDomain.push(i);
    return {
        "data": [
          {
              "name": "series",
              "values": null
          },
          {
              "name": "domain",
              "values": null
          },

            {
                "name": "empty",
                "values": []
            },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
          {
              "name": "facts",
              "source": "series",
              "transform": [
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "yAxisFormatType",
                      "expr": "(datum.yAxis && datum.yAxis.formatType) ? datum.yAxis.formatType : 'number'" // default
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "yAxisFormat",
                      "expr": "(datum.yAxis && datum.yAxis.format) ? datum.yAxis.format : '.1%'" // default
                  },
                {
                    "type": "flatten",
                    "fields": ["facts"],
                    "as": ["fact"]
                }
              ]
          },
          {
              "name": "factsResolved",
              "source": "facts",
              "transform": [

                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum.id" //TODO
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "category",
                    "expr": "datum.fact.category"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "val",
                    "expr": "datum.fact.val"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "categoryResolved",
                    "expr": "datum.category.resolved"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "xAxisCategoryResolved",
                      "expr": "datum.fact.categoryLineBreaked != null ? datum.fact.categoryLineBreaked : datum.category.resolved"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "titleResolved",
                    "expr": "datum.title.resolved"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "valResolved",
                    "expr": "datum.title != null ? (datum.titleResolved + ': ' + datum.fact.resolved) : (datum.fact.resolved)"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "tooltipResolved",
                      "expr": "datum.fact.tooltip != null ? datum.fact.tooltip.resolved : null"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "groupResolved",
                    "expr": "datum.group ? datum.group.resolved : datum.category.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "serieId",
                    "expr": "datum.id"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "colorResolved",
                    "expr": "datum.colorShade != null ? scale('colorByShade',datum.colorShade) : scale('color',datum.serieId)"
                  }
              ]
          }
        ],
        "signals": [
            
        ],
        "scales": [
            {
                "name": "color",
                "type": "ordinal",
                "domain": { "data": "series", "field": "id" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": json.theme }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "yAxisFormat",
                "type": "ordinal",
                "domain": ["yAxisFormat"],
                "range": { "data": "factsResolved", "field": "yAxisFormat" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "yAxisFormatType",
                "type": "ordinal",
                "domain": ["yAxisFormatType"],
                "range": { "data": "factsResolved", "field": "yAxisFormatType" }
            },
          {
              /*"_comment": "This is the main y scale bandwidth for groups of bars WITHOUT padding",*/
              "name": "yScaleNoPadding",
              "type": "band",
              "domain": {
                  "data": "factsResolved",
                  "field": "categoryResolved"
              },
              "range": "height",
              "padding": 0
          },
          {
              // Provide the proper color for the legend
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "factsResolved", "field": "serieId" },
              "range": { "data": "factsResolved", "field": "colorResolved" },
          },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "factsResolved", "field": "serieId" },
                "range": { "data": "factsResolved", "field": "titleResolved" }
            },
            {
                // Provide the proper tooltip for the axis
                "name": "xScaleTooltip",
                "type": "ordinal",
                "domain": { "data": "factsResolved", "field": "categoryResolved" },
                "range": { "data": "factsResolved", "field": "tooltipResolved" },
            },
            {
                // Provide the proper label for the x-axis
                "name": "xScaleLabel",
                "type": "ordinal",
                "domain": { "data": "factsResolved", "field": "categoryResolved" },
                "range": { "data": "factsResolved", "field": "xAxisCategoryResolved" }
            },
            {
                "name": "xScale",
                "type": "band",
                "domain": {
                    "data": "factsResolved",
                    "field": "categoryResolved"
                },
                "padding": json.barBandPadding,
                //"padding": json.xScalePadding,
                "range": "width",
                "round": true, // setting round to false will cause a strange decoupled yaxis where the zero round is floating off
                "zero": true,
                "nice": true
                //"nice": { "signal": "scale('yAxisTickCount','yAxisTickCount')" }
                //"nice": true // setting nice to true will cause the axis domain to snap to a value, leading to a side affect that two axis' no longer align, setting it to false will cause the top/bottom of the bars/lines to hang over the edge of the yaxis
            },
            {
                "name": "yScale",
                "type": "linear",
                "domain": {
                    "data": "factsResolved",
                    "field": "val"
                },
                //"domainMin": {
                //    "signal": "factsDomainMin",
                //},
                //"domainMax": {
                //    "signal": "factsDomainMax",
                //},
                "domainMin": {
                    "signal": "data('series')[0].yAxis != null ? data('series')[0].yAxis.minValue : null",
                },
                "domainMax": {
                    "signal": "data('series')[0].yAxis != null ? data('series')[0].yAxis.maxValue : null",
                },
                "padding": config.yAxisLabelPadding,
                "range": "height",
                "round": true, // setting round to false will cause a strange decoupled yaxis where the zero round is floating off
                "zero": true,
                "nice": true
                //"nice": { "signal": "scale('yAxisTickCount','yAxisTickCount')" }
                //"nice": true // setting nice to true will cause the axis domain to snap to a value, leading to a side affect that two axis' no longer align, setting it to false will cause the top/bottom of the bars/lines to hang over the edge of the yaxis
            },
            {
                "name": "xScaleBar",
                /*"_comment": "Defines the individual bar scale for each category. If we are stacking the series, then we don't care about how many series we have, but we still use this scale to create a multiple of the size of what a single bar will look like...",*/
                "type": "band",
                "range": "width",
                "domain": json.stackedSeries == true ? stackedSeriesFakeDomain : { "data": "factsResolved", "field": "key" }
            }
            
        ],
        "axes": [
            Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json, {
                "orient": "bottom",
                "scale": "xScale",
                "domain": false,

                "ticks": json.xAxisHidden ? false : null, // special handling for hidden x-axis
                "labels": json.xAxisHidden ? false : null, // special handling for hidden x-axis

                //"format": { "signal": "if(scale('xAxisFormat','xAxisFormat') == null, ' ', scale('xAxisFormat','xAxisFormat'))" }, // If the format is null, use empty string ' ', otherwise 
                //"formatType": { "signal": "scale('xAxisFormatType','xAxisFormatType')" },
                //"values": { "signal": "data('series')[0].xAxis.values" },
                //"title": (json.showXAxisTitle == true ? { "signal": "data('series')[0].xAxis.title != null ? data('series')[0].xAxis.title.resolved : null" } : null), // Vega can't not show a title other than if we set it to null hard, thus we doe this before compiling the spec (with an extra runtime check for safety)
                //"grid": json.showXAxisGrid,
                //"labelOverlap": true, // tells vega to remove labels that overlap
                "encode": {
                    "labels": {
                        "update": {
                            "text": { "signal": "scale('xScaleLabel',datum.value)" }
                        }
                    }
                }
            }),
            {
                "orient": "left",
                "scale": "yScale",
                "tickSize": 0,
                "tickRound": true,
                "tickCount": { "signal": "data('series')[0].yAxis != null ? data('series')[0].yAxis.tickCount : null" },
                //"labelPadding": 4,
                "format": { "signal": "scale('yAxisFormat','yAxisFormat')" },
                "formatType": { "signal": "scale('yAxisFormatType','yAxisFormatType')" },
                "zindex": 1,
                "grid": true,
                "domain": false
            }
        ],
        "marks": [
          {
              /*"_comment": "BARS GROUPS",*/
              "type": "group",
              "zindex": 2,
              "from": {
                  "facet": {
                      "data": "factsResolved",
                      "name": "facet",
                      "groupby": "categoryResolved"
                  }
              },
              "encode": {
                  "update": {
                      "x": { "scale": "xScale", "field": "categoryResolved" }
                  }
              },
              "signals": [
                    { "name": "numCategories", "update": "domain('xScaleBar').length" },
                    {
                        /*"_comment": "This signal limits the bar size by automatically limiting the total space allowed",*/
                        "name": "width",
                        "update": "(bandwidth('xScale') / numCategories) > " + json.barMaxSize + " ? numCategories*" + json.barMaxSize + " : bandwidth('xScale')"
                    },
                    { "name": "fullWidth", "update": "bandwidth('xScale')" }
              ],
              "scales": [
                {
                    "name": "seriesPos",
                    "type": "band",
                    "range": "width",
                    "domain": { "data": "factsResolved", "field": "key" }
                }
              ],
              "marks": [
                {
                    /*"_comment": "SINGLE BARS - side by side",*/
                      "name": "bars",
                      "from": { "data": json.stackedSeries != true ? "facet" : "empty" },
                    "type": "rect",
                    "encode": {
                        "enter": {
                            "fill": { "field": "colorResolved" },
                            "tooltip": {"signal": "datum.valResolved"},
                        },
                        "update": {
                            "x": { "signal": "scale('seriesPos',datum.key) + (fullWidth-width)/2" },
                            "width": { "scale": "seriesPos", "band": 1 },
                            "y": { "scale": "yScale", "field": "val" },
                            "y2": { "scale": "yScale", "value": 0 }
                        }
                    }
                  },
                  {
                      /*"_comment": "STACKED BARS",*/
                      "name": "bars_stacked",
                      "from": { "data": json.stackedSeries == true ? "facet" : "empty" },
                      "type": "rect",
                      "encode": {
                          "enter": {
                              "fill": { "field": "colorResolved" },
                              "tooltip": { "signal": "datum.valResolved" },
                          },
                          "update": {
                              "x": { "signal": "scale('seriesPos',datum.key)*0 + (fullWidth-width)/2" },
                              "width": { "signal": "width" },
                              "y": { "signal": "scale('yScale',datum.fact.stackedValA)" },
                              "y2": { "signal": "scale('yScale',datum.fact.stackedValB)" },
                          }
                      }
                  }
              ]
          },
          {
              /*"_comment": "Y-ZERO RULE",*/
              "name": "yzero",
              "zindex": 3,
              "type": "rule",
              "encode": {
                  "enter": {
                      "stroke": { "value": config.domainLineColor },
                      "strokeWidth": { "value": config.domainLineSize }
                  },
                  "update": {
                      "x": { "value": 0 },
                      "x2": { "signal": "width" },
                      "y": { "signal": "scale('yScale',0)" }
                  }
              }
          }
        ]
    };
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.VBarNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert series
    spec["data"][0].values = json.series;
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.VBarNode.init = function (instance, config, json, nodeElem) {

    // Convert serie titles into multilines...
    if (json.xAxisLabelLimitChars != null && json.xAxisLabelLimitChars > 0) {
        Machinata.Util.each(json.series, function (index, jsonSerie) {
            Machinata.Util.each(jsonSerie.facts, function (index, jsonFact) {
                var catResolved = Machinata.Reporting.Text.resolve(instance,jsonFact.category);
                var catLineBreaked = null;
                catLineBreaked = Machinata.Reporting.Tools.lineBreakString(catResolved, {
                    maxCharsPerLine: json.xAxisLabelLimitChars,
                    maxLines: json.xAxisLabelLimitLines,
                    wordSeparator: " ",
                    ellipsis: config.textTruncationEllipsis,
                    appendEllipsisOnLastLine: true,
                    returnArray: true
                });
                jsonFact.categoryLineBreaked = catLineBreaked;
                if (jsonFact.tooltip == null && catLineBreaked.length > 1) {
                    jsonFact.tooltip = {
                        resolved: catResolved
                    }
                }
            });
        });
    }

    // Generate legend data
    Machinata.Reporting.Node.VegaNode.Util.createLegendForSeries(instance, config, json, json.series);

    // Use our own axis snapping tool?
    if (json.autoSnapYAxis == true) {
        Machinata.Reporting.Node.VegaNode.Util.autoSnapSeriesAxis(
            instance, 
            config,
            json,
            json.series,
            {
                axisKey: "yAxis",
                snapToZero: json.autoSnapYAxisSnapToZero,
                niceDomain: json.autoSnapYAxisNiceDomain,
                margin: json.autoSnapYAxisMargin,
                balance: json.autoSnapYAxisBalance,
                stackedSeries: json.stackedSeries,
                tickCount: json.autoSnapYAxisTickCount
            }
        );
    }

    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.VBarNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.VBarNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.VBarNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {
    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};






/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-symboledvbar.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-symboledvbar.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.SymboledVBarNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults = {};

/// <summary>
/// By default charts are ```solid```.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support toolbar.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.supportsToolbar = true;

/// <summary>
/// No legends for this chart.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.insertLegend = true;

/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.legendColumns = 2;

/// <summary>
/// Defines the amount of padding (or spacing) for bar-groups (in percent relative to bandwidth).
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.barBandPadding = 0.2;

/// <summary>
/// Defines the size of the line values relative to its min/max bar (in decimal percent).
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.lineFactSize = 1.0;

/// <summary>
/// Defines the size of the symbol values.
/// By default this is ```Machinata.Reporting.Config.graphSymbolSize```.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.symbolFactSize = Machinata.Reporting.Config.graphSymbolSize;;

/// <summary>
/// Defines the maximum width of a bar in pixels. If there is not enough space, then the bar may be
/// smaller.
/// By default this is set to ```Machinata.Reporting.Config.verticalBarMaxSize * 2```.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.barMaxSize = Machinata.Reporting.Config.verticalBarMaxSize * 2;

/// <summary>
/// By default we use a ```greedy``` overlap strategy.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.axisLabelOverlap = "greedy";

/// <summary>
/// Defines the maximum characters a x-axis label can have before is line-breaked.
/// Note that x-axis labels are allowed maximum ```xAxisLabelLimitLines``` lines.
/// By default ```12```
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.xAxisLabelLimitChars = 12;

/// <summary>
/// The maximumum number of lines a label can span. If the maximum lines exceed, the 
/// ```xAxisLabelLimitChars``` is automatically postfixed.
/// By default ```2```.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.xAxisLabelLimitLines = 3;

/// <summary>
/// If ```true```, the legend data is automatically sorted by symbol type.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.automaticallySortLegendBySymbolType = true;

/// <summary>
/// When ```true```, facts can have tooltips which are displayed on the x-axis labels.
/// If a lable was automatically truncated, a tooltip is automatically generated (if not already set).
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.defaults.xAxisShowTooltipsInLabel = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.getVegaSpec = function (instance, config, json, nodeElem) {
    return {
        "data": [
            {
                "name": "series",
                "values": null
            },
            {
                "name": "seriesTitles", // we have to provide these pre-computed, because there is no way around vega not providing a ordinal range from data with duplicate values...
                "values": null
            },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
          {
              "name": "seriesResolved",
              "source": "series",
              "transform": [
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum.id"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "titleResolved",
                      "expr": "datum.title.resolved"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "tooltipResolved",
                      "expr": "datum.tooltip != null ? datum.tooltip.resolved : null"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "xAxisTitleResolved",
                      "expr": "datum.titleLineBreaked != null ? datum.titleLineBreaked : datum.title.resolved"
                  },
              ]
          },
          {
              "name": "facts",
              "source": "seriesResolved",
              "transform": [
                {
                    "type": "flatten",
                    "fields": ["facts"],
                    "as": ["fact"]
                }
              ]
          },
          {
              "name": "factsResolved",
              "source": "facts",
              "transform": [

                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum.id" //TODO
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "category",
                    "expr": "datum.fact.category"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "val",
                    "expr": "datum.fact.val"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "categoryResolved",
                      "expr": "datum.category.resolved"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "symbolType",
                    "expr": "datum.fact.symbolType"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "titleResolved",
                    "expr": "datum.title.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "valResolved",
                    "expr": "datum.fact.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "formatType",
                    "expr": "datum.formatType ? datum.formatTyped : 'number'" // default
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "format",
                    "expr": "datum.format ? datum.format : '.1%'" // default
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "serieId",
                    "expr": "datum.id"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "legendKey",
                    "expr": "datum.categoryResolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "legendLabel",
                    "expr": "datum.categoryResolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "colorResolved",
                    "expr": "datum.fact.colorShade != null ? scale('colorByShade',datum.fact.colorShade) : ( datum.symbolType == 'line' ? scale('colorByShade','gray4') : (datum.symbolType == 'dot' ? scale('colorByShade','mid') : ( datum.symbolType == 'diamond' ? scale('colorByShade','dark') : scale('colorByShade','gray3') )   ) )"
                }
              ]
          },
          {
              "name": "factsSymbolTypes",
              "source": "factsResolved",
              "transform": [
                {
                    "type": "filter", 
                    "expr": "datum.symbolType != 'max'"
                },
                {
                    "type": "aggregate",
                    //"groupby": ["symbolType", "categoryResolved", "colorResolved"]
                    "groupby": ["legendKey", "legendLabel", "colorResolved"]
                }
              ]
          },
          {
              "name": "factsStats",
              "source": "factsResolved",
              "transform": [
                {
                    "type": "aggregate",
                    "fields": ["val", "val"],
                    "ops": ["min", "max"],
                    "as": ["valMin", "valMax"]
                }
              ]
          }
        ],
        "signals": [
            {
                "name": "factsValMin",
                /*"_comment": "Just gets the min value from the aggregate data",*/
                "init": "data('factsStats')[0].valMin"
            },
            {
                "name": "factsValMax",
                /*"_comment": "Just gets the max value from the aggregate data",*/
                "init": "data('factsStats')[0].valMax"
            },
            {
                "name": "factsValAbsMinMax",
                /*"_comment": "Gets the absolute max domain value",*/
                "init": "max(abs(factsValMin),abs(factsValMax))"
            },
            {
                "name": "factsDomainMin",
                /*"_comment": "If our domain spans minus and positive, then we use the factsValAbsMinMax value, otherwise we use the 0 or a minus value",*/
                "init": "if(factsValMin < 0 && factsValMax > 0   ,   -factsValAbsMinMax,  min(0, factsValMin)  ) "
            },
            {
                "name": "factsDomainMax",
                /*"_comment": "Just like factsDomainMax, just in reverse",*/
                "init": "if(factsValMin < 0 && factsValMax > 0   ,   +factsValAbsMinMax,   max(0, factsValMax)  )"
            },
            {
                "name": "configAxisSize",
                "init": config.axisSize
            },
        ],
        "scales": [
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": json.theme }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "yAxisFormat",
                "type": "ordinal",
                "domain": ["yAxisFormat"],
                "range": { "data": "factsResolved", "field": "format" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "yAxisFormatType",
                "type": "ordinal",
                "domain": ["yAxisFormatType"],
                "range": { "data": "factsResolved", "field": "formatType" }
            },
          {
              /*"_comment": "This is the main y scale bandwidth for groups of bars WITHOUT padding",*/
              "name": "yScaleNoPadding",
              "type": "band",
              "domain": {
                  "data": "factsResolved",
                  "field": "categoryResolved"
              },
              "range": "height",
              "padding": 0
          },
          {
              // Provide the proper color for the legend
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "factsSymbolTypes", "field": "legendKey" },
              "range": { "data": "factsSymbolTypes", "field": "colorResolved" }, // BUG: if two keys have same color, the ordinal scale ignores it
              //"range": { "signal": "data('factsSymbolTypes')" },
            },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "factsSymbolTypes", "field": "legendKey" },
                "range": { "data": "factsSymbolTypes", "field": "legendLabel" }
            },
            {
                // Provide the proper tooltip for the axis
                "name": "xScaleTooltip",
                "type": "ordinal",
                "domain": { "data": "seriesResolved", "field": "key" },
                "range": { "data": "seriesResolved", "field": "tooltipResolved" },
            },
            {
                // Provide the proper label for the x-axis
                // Note: range must be unique if using data, else must provide a signal!
                "name": "xScaleLabel",
                "type": "ordinal",
                "domain": { "data": "seriesResolved", "field": "key" },
                "range": { "signal": "data('seriesTitles')" },
                //"range": { "data": "seriesResolved", "field": "xAxisTitleResolved" }
            },
            /*{
                // Provide the proper index of the xscale ticks
                "name": "xScaleIndex",
                "type": "band",
                "domain": { "data": "seriesResolved", "field": "key" },
                "range": { "step": 1 }
            },*/
            {
                "name": "xScale",
                "type": "band",
                "domain": {
                    "data": "seriesResolved",
                    "field": "key"
                },
                "padding": json.barBandPadding,
                "range": "width",
                "round": true, // setting round to false will cause a strange decoupled yaxis where the zero round is floating off
                "zero": true,
                "nice": true
                //"nice": { "signal": "scale('yAxisTickCount','yAxisTickCount')" }
                //"nice": true // setting nice to true will cause the axis domain to snap to a value, leading to a side affect that two axis' no longer align, setting it to false will cause the top/bottom of the bars/lines to hang over the edge of the yaxis
            },
            {
                "name": "yScale",
                "type": "linear",
                "domain": {
                    "data": "factsResolved",
                    "field": "val"
                },
                "domainMin": {
                    "signal": "data('series')[0].yAxis != null ? data('series')[0].yAxis.minValue : factsDomainMin",
                },
                "domainMax": {
                    "signal": "data('series')[0].yAxis != null ? data('series')[0].yAxis.maxValue : factsDomainMax",
                },
                "padding": config.yAxisLabelPadding,
                "range": "height",
                "round": true, // setting round to false will cause a strange decoupled yaxis where the zero round is floating off
                "zero": true,
                "nice": true
            }
            
        ],
        "axes": [     
            Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance, config, json,{
                "orient": "bottom",
                "scale": "xScale",
                "domain": false,
                //"labelOverlap": json.axisLabelOverlap, // The strategy to use for resolving overlap of axis labels. If false (the default), no overlap reduction is attempted. If set to true or "parity", a strategy of removing every other label is used (this works well for standard linear axes). If set to "greedy", a linear scan of the labels is performed, removing any label that overlaps with the last visible label (this often works better for log-scaled axes).
                //"labelSeparation": json.axisLabelSeperation // The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default 0). This property is ignored if labelOverlap resolution is not enabled.
                "encode": {
                    "labels": {
                        "update": {
                            "text": { "signal": "scale('xScaleLabel',datum.value)" },
                            "dy": { "signal": ((json.xAxisLabelAngle == -90 && json.xAxisLabelLimitChars > 0) ? "(scale('xScaleLabel',datum.value).length-1) * -1 * configAxisSize * 0.7" : "0") } // since vega doesnt center multiline labels properly, we have to do it ourselves...
                        }
                    }
                }
            }),
            {
                "orient": "left",
                "scale": "yScale",
                "tickSize": 0,
                "tickRound": true,
                "tickCount": json.yAxisTickCount,
                //"labelPadding": 4,
                //"format": { "signal": "scale('yAxisFormat','yAxisFormat')" },
                "format": { "signal": "(data('series')[0].yAxis != null && data('series')[0].yAxis.format != null) ? data('series')[0].yAxis.format : scale('yAxisFormat','yAxisFormat')" },
                //"formatType": { "signal": "scale('yAxisFormatType','yAxisFormatType')" },
                "formatType": { "signal": "(data('series')[0].yAxis != null && data('series')[0].yAxis.formatType != null) ? data('series')[0].yAxis.formatType : scale('yAxisFormatType','yAxisFormatType')" },
                "zindex": 1,
                "grid": true,
                "domain": false
            }
        ],
        "marks": [
          {
              "type": "group",
              "zindex": 4,
              "from": {
                  "facet": {
                      "name": "facet",
                      "data": "factsResolved",
                      "groupby": "key"
                  }
              },
              "data": [
                  {
                      "name": "facetSymbols",
                      "source": "facet",
                      "transform": [
                        { "type": "filter", "expr": "datum.symbolType == 'dot' || datum.symbolType == 'diamond'" }
                      ]
                  },
                  {
                      "name": "facetMin",
                      "source": "facet",
                      "transform": [
                        { "type": "filter", "expr": "datum.symbolType == 'min'" }
                      ]
                  },
                  {
                      "name": "facetMax",
                      "source": "facet",
                      "transform": [
                        { "type": "filter", "expr": "datum.symbolType == 'max'" }
                      ]
                  },
                  {
                      "name": "facetLine",
                      "source": "facet",
                      "transform": [
                        { "type": "filter", "expr": "datum.symbolType == 'line'" }
                      ]
                  }
              ],
              "encode": {
                  "update": {
                      "x": { "scale": "xScale", "field": "key" }
                  }
              },
              "signals": [
                    {
                        /*"_comment": "This signal limits the bar size by automatically limiting the total space allowed",*/
                        "name": "width",
                        "update": "(bandwidth('xScale')) > " + json.barMaxSize + " ? " + json.barMaxSize + " : bandwidth('xScale')"
                    },
                    { "name": "fullWidth", "update": "bandwidth('xScale')" },
              ],
              "marks": [
                  
                {
                    "name": "bars",
                    "type": "group",
                    "encode": {
                        "update": {
                            "x": { "signal": "fullWidth/2 - width/2" },
                            "width": { "signal": "width" }
                        }
                    },
                    "marks": [
                        {
                            "type": "rect",
                            "from": {
                                "data": "facetMin"
                            },
                            "encode": {
                                "enter": {
                                    "fill": { "signal": "datum.colorResolved" },
                                    "tooltip": { "signal": "datum.titleResolved + ' ' + datum.categoryResolved + ': ' + datum.valResolved + ' - ' + data('facetMax')[0].valResolved" }
                                },
                                "update": {
                                    "x": { "signal": "0" },
                                    "x2": { "signal": "width" },
                                    "y": { "signal": "scale('yScale',data('facetMax')[0].val)" }, // max
                                    "y2": { "signal": "scale('yScale',datum.val)" }, // min
                                }
                            }
                        },
                        {
                            "type": "rect",
                            "from": {
                                "data": "facetLine"
                            },
                            "encode": {
                                "enter": {
                                    "fill": { "signal": "datum.colorResolved" },
                                    "tooltip": { "signal": "datum.titleResolved + ' ' + datum.categoryResolved + ': ' + datum.valResolved" }
                                },
                                "update": {
                                    "x": { "signal": "width*" + (1.0-json.lineFactSize) },
                                    "x2": { "signal": "width - width*" + (1.0 - json.lineFactSize) },
                                    "y": { "signal": "scale('yScale',datum.val)-" + (config.graphLineSize) }, 
                                    "y2": { "signal": "scale('yScale',datum.val)+" + (config.graphLineSize) }, 
                                }
                            }
                        },
                        {
                            "type": "symbol",
                            "from": {
                                "data": "facetSymbols"
                            },
                            "encode": {
                                "enter": {
                                    "shape": { "signal": "datum.symbolType == 'dot' ? 'circle' : datum.symbolType" },
                                    "fill": { "signal": "datum.colorResolved" },
                                    "tooltip": { "signal": "datum.titleResolved + ' ' + datum.categoryResolved + ': ' + datum.valResolved" }
                                },
                                "update": {
                                    "x": { "signal": "width/2" },
                                    "y": { "scale": "yScale", "field": "val" },
                                    "size": { "signal": json.symbolFactSize * json.symbolFactSize }
                                }
                            }
                        }
                    ]
                }
              ]
          },
          {
              /*"_comment": "Y-ZERO GROUP - we need a group so that we can dynamically toggle it on off due to vegas limitations - we do this via the clip property on the group. Note that we don't want to clip if the zero is on the edge (since the line has a middle-out thickness)",*/
              "name": "yzerotoggle",
              "zindex": 3,
              "type": "group",
              "encode": {
                  "enter": {
                      "clip": { "signal": "(scale('yScale',0) > height || scale('yScale',0) < 0) ? true : false" }
                  },
                  "update": {
                      "x": { "value": 0 },
                      "y": { "value": 0 },
                      "width": { "signal": "width" },
                      "height": { "signal": "height" }
                  }
              },
              "marks": [
                  {
                      /*"_comment": "Y-ZERO RULE",*/
                      "name": "yzero",
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "stroke": { "value": "black" },
                              "strokeWidth": { "value": config.domainLineSize }
                          },
                          "update": {
                              "x": { "value": 0 },
                              "x2": { "signal": "width" },
                              "y": { "signal": "scale('yScale',0)" }
                          }
                      }
                  }
              ]
            }
            
        ]
    };
};
Machinata.Reporting.Node.SymboledVBarNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert series
    spec["data"][0].values = json.series;
    spec["data"][1].values = json._state.allSeriesTitles;
};
Machinata.Reporting.Node.SymboledVBarNode.init = function (instance, config, json, nodeElem) {

    // Convert serie titles into multilines...
    var maxXAxisLabelLines = 0;
    if (json.xAxisLabelLimitChars != null && json.xAxisLabelLimitChars > 0) {
        Machinata.Util.each(json.series, function (index, jsonSerie) {
            var titleResolved = Machinata.Reporting.Text.resolve(instance,jsonSerie.title);
            var titleLineBreaked = null;
            titleLineBreaked = Machinata.Reporting.Tools.lineBreakString(titleResolved, {
                maxCharsPerLine: json.xAxisLabelLimitChars,
                maxLines: json.xAxisLabelLimitLines,
                wordSeparator: " ",
                ellipsis: config.textTruncationEllipsis,
                appendEllipsisOnLastLine: true,
                returnArray: true
            });
            jsonSerie.titleLineBreaked = titleLineBreaked;
            maxXAxisLabelLines = Math.max(maxXAxisLabelLines, jsonSerie.titleLineBreaked.length);
            if (jsonSerie.tooltip == null && titleLineBreaked.length > 1) {
                jsonSerie.tooltip = {
                    resolved: titleResolved
                }
            }
        });
    }
    json._state.allSeriesTitles = [];
    Machinata.Util.each(json.series, function (index, jsonSerie) {
        json._state.allSeriesTitles.push(jsonSerie.titleLineBreaked || jsonSerie.title.resolved);
    });

    // Generate legend data
    Machinata.Reporting.Node.VegaNode.Util.createLegendForSeriesFacts(instance, config, json, json.series);
    
    // Convert legend data to common legend symbols
    for (var i = 0; i < json.legendData.length; i++) {
        var legendDatum = json.legendData[i];
        if (legendDatum.symbol == "max") {

            legendDatum.symbol = "square";
            legendDatum.symbolOrder = "01_a_max";

        } else if (legendDatum.symbol == "min") {

            legendDatum.symbol = "square";
            legendDatum.symbolOrder = "01_b_min";

        } else if (legendDatum.symbol == "line") {

            legendDatum.symbol = "square";
            legendDatum.symbolOrder = "02_square";

        } else if (legendDatum.symbol == "dot") {

            legendDatum.symbol = "dot";
            legendDatum.symbolOrder = "03_dot";

        } else if (legendDatum.symbol == "diamond") {

            legendDatum.symbol = "diamond";
            legendDatum.symbolOrder = "04_diamond";

        } else {

            legendDatum.symbol = "square" // fallback
            legendDatum.symbolOrder = "01_unknown" // fallback

        }
    }

    // Sort
    if (json.automaticallySortLegendBySymbolType == true) {
        json.legendData.sort(function (a, b) {
            return (a.symbolOrder > b.symbolOrder);
        });
    }

    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.SymboledVBarNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.SymboledVBarNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.SymboledVBarNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {

    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};








/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-component.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-component.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.ComponentNode = {};
Machinata.Reporting.Node.ComponentNode.defaults = {
    supportsToolbar: false,
};

Machinata.Reporting.Node.ComponentNode.init = function (instance, config, json, nodeElem) {

    // Flatten slotChildren into actual child
    $.each(json.children, function (index, childJSON) {
        // Find matching reference (by id) in slotChildren
        $.each(json.slotChildren, function (key, value) {
            if (value == index) {
                // We have a match
                // Register directly in child json
                childJSON.slotNumber = value;
                childJSON.slotKey = key;
                childJSON.slotClass = key.replace("{", "").replace("}", "");
                childJSON.additionalCSSClasses = "slot-child slot-"+childJSON.slotNumber + " slot-" + childJSON.slotClass;
                return;
            }
        });
    });


};
Machinata.Reporting.Node.ComponentNode.postBuild = function (instance, config, json, nodeElem) {
    nodeElem.append($("<div class='clear'></div>"));
};
Machinata.Reporting.Node.ComponentNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-metrics.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-metrics.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// A generic node for displaying different formats of metrics (key/values) in flexible
/// grid or tabular formats. Items in the metrics node can be grouped (for example to create
/// a grid of items where each group becomes a row). Metrics nodes always build the items the same,
/// but allow for CSS to steer exactly how they are displayed to the user, and more importantly
/// allow for dynamic layouts that adjust to the screen size (for example, collapsing a 3x3 grid into a 3x9
/// layout).
///
/// ## Metrics Items
/// Each group (in ```itemGroups```) contains items with the following properties:
///  - ```label```: resolvable text that labels this item
///  - ```value```: resolvable text representing the item value
///  - ```subValue```: resolvable text representing a additional value (usually for comparison)
///  - ```subDelta```: delta object that shows a difference value, typically colored with an arrow icon
///  - ```alert```: alert object that shows a either a alert flag or a alert icon
///  - ```number```: if defined, the item will automatically include the number
///  - ```date```: if defined, the item will automatically generate a calendar stub, Unix Epoch Milliseconds format 
///  - ```icon```: if defined, the item will automatically generate a icon stub, registered icon (string), see ```Machinata.Reporting.icon()```
///  - ```link```: if defined, the item will clickable and display a link arrow, link JSON object (See Machinata.Reporting.Tools.openLink for more details) 
/// 
/// An item's design usually revolves around the item value. This means that in most cases the value will be
/// the largest component.
/// 
/// ## Numbering
/// To create a numbered list, just set the ```number``` property for each item.
/// 
/// ## Delta Object
/// Format for specifying a difference value. Can have the following properties:
///  - ```label```: resolvable text that labels this delta
///  - ```icon```: registered icon (string), typically ```trend-up``` or ```trend-down```
///  - ```color```: registered color (string), typically ```green``` or ```red```
/// 
/// ## Alert Object
/// Format for specifying a item alert. Either a flag is displayed or an icon is displayed.
/// In most cases specifying a color is not necessary.
/// Can have the following properties:
///  - ```label```: resolvable text that labels this alert (usually as a tooltip), optional
///  - ```flag```: boolean indicating to show a alert flag
///  - ```icon```: registered icon (string), typically ```alert``` or ```info```
///  - ```color```: registered color (string), typically ```green``` or ```red```, optional
///
/// </summary>
/// <example>
/// ## Overview Example with Deltas
/// ```
/// {
///     "nodeType": "MetricsNode",
///     "style": "CS_W_Block2x2",
///     "chrome": "dark",
///     "mainTitle": {
///         "resolved":  "Mandate information"
///     },
///     "subTitle": {
///         "resolved":  "Fixed income active"
///     },
///     "itemGroups": [
///         {
///             "items": [
///                 {
///                     "label": { "resolved":  "Investment Grade Global II" },
///                     "value": { "resolved":  "153.28m" },
///                     "subLabel": { "resolved":  "Total Assets in USD" }
///                 }
///             ]
///         },
///         {
///             "items": [
///                 {
///                     "label": { "resolved": "MTD return" },
///                     "value": { "resolved": "2.06%" },
///                     "subValue": { "resolved": "bench 2.19%" }
///                     "subDelta": {
///                         "icon": "trend-up",
///                         "color": "green",
///                         "label": { "resolved": "delta 0.41%" }
///                     }
///                 },
///                 {
///                     "label": { "resolved":  "YTD return" },
///                     "value": { "resolved":  "4.55%" },
///                     "subValue": { "resolved":  "bench 6.19%" }
///                     "subDelta": {
///                         "icon": "trend-up",
///                         "color": "red",
///                         "label": { "resolved": "delta 0.66%" }
///                     }
///                 }
///             ]
///         },
///         {
///             "items": [
///                 {
///                     "label": { "resolved": "Average duration, years" },
///                     "value": { "resolved": "5.8" }
///                 },
///                 {
///                     "label": { "resolved":  "Average rating, S&P" },
///                     "value": { "resolved":  "A+" }
///                 }
///             ]
///         }
///     ]
/// }
/// ```
/// </example>
/// <type>class</type>
Machinata.Reporting.Node.MetricsNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.defaults = {};

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.MetricsNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.MetricsNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_1x1];

/// <summary>
/// By default MetricsNodes have a ```solid``` chrome.
/// </summary>
Machinata.Reporting.Node.MetricsNode.defaults.chrome = "solid";

/// <summary>
/// If ```true```, the user can easily copy the text to clipboard.
/// By default ```true```.
/// Note: Experimental
/// </summary>
Machinata.Reporting.Node.MetricsNode.defaults.addCopyToClipboardTool = true;

/// <summary>
/// If ```true```, the metrics mode will always layout as "compressed". Usually this is only
/// done if the node is pressed for size (ie its space is smaller than a half of a full layout width).
/// However, this setting can be useful if the items for the metrics node are anticipated to cause a space issue and fadeout
/// is not wished.
/// If the style ```CS_W_AlwaysLayoutAsCompressed``` is set, then this setting will automatically be set to ```true```.
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.MetricsNode.defaults.alwaysLayoutAsCompressed = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.createDeltaElement = function (instance, config, deltaJSON, className) {
    var elem = $("<div class='delta'></div>").addClass(className);
    if (deltaJSON.color != null) elem.addClass("color-" + deltaJSON.color);
    if (deltaJSON.label != null) {
        var text = Machinata.Reporting.Text.resolve(instance,deltaJSON.label);
        elem.append($("<span class='delta-label'></span>").text(text));
    }
    if (deltaJSON.icon != null) {
        //elem.append($("<span class='icon'></span>").addClass(Machinata.Reporting.icon(deltaJSON.icon)));
        elem.append(Machinata.Reporting.buildIcon(instance,deltaJSON.icon).addClass("delta-icon"));
    }
    return elem;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.createAlertElement = function (instance, config, alertJSON, className) {
    var elem = $("<div class='alert'></div>").addClass(className);
    if (alertJSON.icon != null) {
        elem.addClass("option-icon");
        //elem.append($("<span class='icon'></span>").addClass(Machinata.Reporting.icon(alertJSON.icon)));
        elem.append(Machinata.Reporting.buildIcon(instance,alertJSON.icon));
    } else {
        elem.addClass("option-flag");
    }
    if (alertJSON.color != null) elem.addClass("color-" + alertJSON.color);
    if (alertJSON.label != null) elem.attr("title", Machinata.Reporting.Text.resolve(instance,alertJSON.label));
    return elem;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.buildGrid = function (instance, config, json, containerElem) {
    // Container
    if (containerElem == null) containerElem = $("<div></div>");

    // Pre-process
    var maxColumns = 0;
    var maxRows = 0;
    var node_hasIcon = false;
    var node_hasDate = false;
    var node_hasSpan = false;
    var node_hasLink = false;
    var node_hasAlert = false;
    var node_hasValue = false;
    var node_hasLabel = false;
    var node_hasSubValue = false;
    var node_hasSubLabel = false;
    var node_hasSubDelta = false;
    var node_hasNumber = false;
    var node_isKeyValue = true;
    var layout = "";
    $.each(json.itemGroups, function (index, groupJSON) {
        var groupLayout = "1x" + groupJSON.items.length;
        $.each(groupJSON.items, function (index, itemJSON) {
            if (groupJSON.items.length > maxColumns) maxColumns = groupJSON.items.length;
        });
        layout += "-" + groupLayout;
    });
    maxRows = json.itemGroups.length;

    var itemsElem = $("<table class='items'></table>");
    var groupNumber = 0;
    var itemsCount = 1;
    $.each(json.itemGroups, function (index, groupJSON) {
        groupNumber++;
        var groupElem = $("<td class='group'></td>").addClass("group-" + groupNumber).appendTo(itemsElem);
        var itemNumber = 0;
        groupElem.addClass("layout-1x" + groupJSON.items.length);
        $.each(groupJSON.items, function (index, itemJSON) {
            // Create item

            var item_hasIcon = false;
            var item_hasDate = false;
            var item_hasSpan = false;
            var item_hasLink = false;
            var item_hasAlert = false;
            var item_hasValue = false;
            var item_hasLabel = false;
            var item_hasSubValue = false;
            var item_hasSubLabel = false;
            var item_hasSubDelta = false;
            var item_hasNumber = false;
            var item_isKeyValue = true;
            itemNumber++;
            var itemElem = $("<td class='item'></td>").addClass("item-" + itemNumber);

            // Link
            if (itemJSON.link != null) {
                item_hasLink = true;
                node_hasLink = true;
                itemElem.addClass("is-link");
                //var elem = $("<div class='link-icon'></div>").addClass(Machinata.Reporting.icon("arrow-right"));
                var elem = Machinata.Reporting.buildIcon(instance,"arrow-right").addClass("link-icon");
                itemElem.click(function () {
                    Machinata.Reporting.Tools.openLink(instance,itemJSON.link);
                });
                //itemElem.append($("<div class='link-bg'></div>"));
                itemElem.append(elem);
            }

            // UIs
            if (itemJSON.alert != null) {
                item_hasAlert = true;
                node_hasAlert = true;
                var elem = Machinata.Reporting.Node.MetricsNode.createAlertElement(instance, config, itemJSON.alert, null);
                itemElem.append(elem);
            }
            if (itemJSON.icon != null) {
                item_hasNumber = true;
                node_hasNumber = true;
                //var elem = $("<div class='icon tag'></div>").addClass(Machinata.Reporting.icon(itemJSON.icon));
                //var elem = Machinata.Reporting.buildIcon(instance,itemJSON.icon).addClass("tag");
                var elem = $("<div class='icon tag'></div>").append(Machinata.Reporting.buildIcon(instance,itemJSON.icon));
                itemElem.append(elem);
            }
            if (itemJSON.number != null) {
                item_hasIcon = true;
                node_hasIcon = true;
                var elem = $("<div class='number theme-number-font tag'></div>");
                elem.text(itemJSON.number);
                itemElem.append(elem);
            }
            if (itemJSON.date != null) {
                item_hasDate = true;
                node_hasDate = true;
                var elem = $("<div class='date tag'></div>");
                var monthText = d3.timeFormat("%b")(itemJSON.date);
                var dayText = d3.timeFormat("%d")(itemJSON.date);
                elem.append($("<div class='month'></div>").text(monthText));
                elem.append($("<div class='day'></div>").text(dayText));
                itemElem.append(elem);
            }

            // Texts
            if (itemJSON.label != null) {
                item_hasLabel = true;
                node_hasLabel = true;
                var text = Machinata.Reporting.Text.resolve(instance,itemJSON.label);
                itemElem.append($("<div class='label'></div>").text(text));
            }
            if (itemJSON.value != null) {
                item_hasValue = true;
                node_hasValue = true;
                var text = Machinata.Reporting.Text.resolve(instance,itemJSON.value);
                itemElem.append($("<div class='value theme-number-font'></div>").text(text));
            }
            if (itemJSON.subValue != null) {
                item_hasSubValue = true;
                node_hasSubValue = true;
                var text = Machinata.Reporting.Text.resolve(instance,itemJSON.subValue);
                itemElem.append($("<div class='subValue theme-number-font'></div>").text(text));
            }
            if (itemJSON.subLabel != null) {
                item_hasSubLabel = true;
                node_hasSubLabel = true;
                var text = Machinata.Reporting.Text.resolve(instance,itemJSON.subLabel);
                itemElem.append($("<div class='subLabel'></div>").text(text));
            }
            if (itemJSON.subDelta != null) {
                item_hasSubDelta = true;
                node_hasSubDelta = true;
                itemElem.addClass("has-subdelta");
                var elem = Machinata.Reporting.Node.MetricsNode.createDeltaElement(instance, config, itemJSON.subDelta, "subdelta");
                itemElem.append(elem);
            }

            itemElem.append($("<div class='line'></div>"));

            // Helper classes
            item_isKeyValue = (item_hasValue == true && item_hasLabel == true);
            if (item_isKeyValue == true) itemElem.addClass("is-key-value");
            else itemElem.addClass("not-key-value");
            if (item_hasAlert == true) itemElem.addClass("has-alert");
            else itemElem.addClass("no-alert");
            if (item_hasValue == true) itemElem.addClass("has-value");
            else itemElem.addClass("no-value");
            if (item_hasLabel == true) itemElem.addClass("has-label");
            else itemElem.addClass("no-label");
            if (item_hasSubValue == true) itemElem.addClass("has-subvalue");
            else itemElem.addClass("no-subvalue");
            if (item_hasSubLabel == true) itemElem.addClass("has-sublabel");
            else itemElem.addClass("no-sublabel");
            if (item_hasSubDelta == true) itemElem.addClass("has-subdelta");
            else itemElem.addClass("no-subdelta");
            if (item_hasNumber == true) itemElem.addClass("has-number");
            else itemElem.addClass("no-number");
            if (item_hasDate == true) itemElem.addClass("has-date");
            else itemElem.addClass("no-date");
            if (item_hasIcon == true) itemElem.addClass("has-icon");
            else itemElem.addClass("no-icon");

            itemElem.appendTo(groupElem);

            if (item_isKeyValue == false) node_isKeyValue = false;

        });

        // Do we need a virtual column span?
        if (groupJSON.items.length < maxColumns && groupJSON.items.length == 1) {
            groupElem.find(".item").attr("colspan", 10).addClass("option-spanned"); //TODO: why is colspan set to 10?
            node_hasSpan = true;
        }
    });

    // Helper classes
    if (node_hasSpan == true) {
        containerElem.addClass("has-span");
    } else {
        itemsElem.addClass("is-grid");
        itemsElem.addClass("grid-" + maxColumns + "x" + maxRows);
    }
    itemsElem.addClass("max-columns-" + maxColumns);
    itemsElem.addClass("max-rows-" + maxRows);
    if (node_isKeyValue == true) itemsElem.addClass("is-key-value");
    else itemsElem.addClass("not-key-value");
    if (node_hasAlert == true) itemsElem.addClass("has-alert");
    else itemsElem.addClass("no-alert");
    if (node_hasValue == true) itemsElem.addClass("has-value");
    else itemsElem.addClass("no-value");
    if (node_hasLabel == true) itemsElem.addClass("has-label");
    else itemsElem.addClass("no-label");
    if (node_hasSubValue == true) itemsElem.addClass("has-subvalue");
    else itemsElem.addClass("no-subvalue");
    if (node_hasSubLabel == true) itemsElem.addClass("has-sublabel");
    else itemsElem.addClass("no-sublabel");
    if (node_hasSubDelta == true) itemsElem.addClass("has-subdelta");
    else itemsElem.addClass("no-subdelta");
    if (node_hasNumber == true) itemsElem.addClass("has-number");
    else itemsElem.addClass("no-number");
    if (node_hasDate == true) itemsElem.addClass("has-date");
    else itemsElem.addClass("no-date");
    if (node_hasIcon == true) itemsElem.addClass("has-icon");
    else itemsElem.addClass("no-icon");

    containerElem.addClass("layout" + layout);
    containerElem.addClass("items-count-" + itemsCount);
    containerElem.append(itemsElem);

    return containerElem;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.buildTable = function (instance, config, json) {
    
    var itemsElem = $("<table></table>");
    $.each(json.itemGroups, function (index, groupJSON) {
        var itemNumber = 0;
        $.each(groupJSON.items, function (index, itemJSON) {
            // Create item
            var itemElem = $("<tr></tr>");

            // Link
            if (itemJSON.link != null) {

            }

            // UIs
            if (itemJSON.alert != null) {
                
            }
            if (itemJSON.icon != null) {
                
            }
            if (itemJSON.number != null) {
                $("<td></td>").text(itemJSON.number).appendTo(itemElem);
            }
            if (itemJSON.date != null) {
                var monthText = d3.timeFormat("%b")(itemJSON.date);
                var dayText = d3.timeFormat("%d")(itemJSON.date);
                $("<td></td>").text(monthText + " " + dayText).appendTo(itemElem);
            }

            // Texts
            if (itemJSON.label != null){
                $("<td></td>").text(Machinata.Reporting.Text.resolve(instance,itemJSON.label)).appendTo(itemElem);
            }
            if (itemJSON.value != null){
                $("<td></td>").text(Machinata.Reporting.Text.resolve(instance,itemJSON.value)).appendTo(itemElem);
            }
            if (itemJSON.subLabel != null){
                $("<td></td>").text(Machinata.Reporting.Text.resolve(instance,itemJSON.subLabel)).appendTo(itemElem);
            }
            if (itemJSON.subValue != null){
                $("<td></td>").text(Machinata.Reporting.Text.resolve(instance,itemJSON.subValue)).appendTo(itemElem);
            }
            if (itemJSON.subDelta != null){
                $("<td></td>").text(Machinata.Reporting.Text.resolve(instance,itemJSON.subDelta.label)).appendTo(itemElem);
            }
             
            itemElem.appendTo(itemsElem);
        });
    });

    return itemsElem;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.init = function (instance, config, json, nodeElem) {
    var self = this;

    // Container  
    var faderElem = $("<div class='bottom-fader option-overflow-only option-bottom-content '></div>").appendTo(nodeElem);
    var containerElem = $("<div class='sizer node-bg option-fullsize-content'></div>").appendTo(nodeElem);

    // Apply some settings from styles
    if (json.styles != null) {
        for (var i = 0; i < json.styles.length; i++) {
            if (json.styles[i] == "CS_W_AlwaysLayoutAsCompressed") {
                json.alwaysLayoutAsCompressed = true;
                break;
            }
        }
    }

    // Grid
    Machinata.Reporting.Node.MetricsNode.buildGrid(instance, config, json, containerElem);

    // Tools
    if (json.addCopyToClipboardTool == true) {
        Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.copy-to-clipboard"), "copy", function () {
            var tempGridElem = self.buildTable(instance, config, json);
            Machinata.Reporting.Tools.copyElementToClipboard(tempGridElem, Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied'), Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied.grid'), true);
        });
    }

};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.resize = function (instance, config, json, nodeElem) {
    // Init
    var sizerElem = nodeElem.find(".sizer");
    var itemsElem = nodeElem.find(".items");
    var isCompressed = false;
    var isOverflowing = false;
    // Compressed?
    if (json.alwaysLayoutAsCompressed == true || sizerElem.width() < config.nodeSizeMinWidthUncompressed) {
        isCompressed = true;
    }
    // Overflow?
    if (itemsElem.height() - config.lineSize * 2 > sizerElem.height()) { // we subtract two line sizes due to border issues in the measurement
        isOverflowing = true;
    }
    // Update
    if (isCompressed == true) {
        nodeElem.addClass("is-compressed");
    } else {
        nodeElem.removeClass("is-compressed");
    }
    if (isOverflowing == true) { 
        nodeElem.addClass("is-overflowing");
    } else {
        nodeElem.removeClass("is-overflowing");
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MetricsNode.draw = function (instance, config, json, nodeElem) {
    
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-placeholder.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-placeholder.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Inserts a bare-bones node with a resolved placeholder text from ```text```.
/// This node can be used to design a report which is missing some components
/// or has not yet been fully designed.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.PlaceholderNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PlaceholderNode.defaults = {
    chrome: "solid",
    supportsToolbar: true,
    addStandardTools: false
};

/// <summary>
/// The resolved text to display in the node. If not text is provided, then the default
/// text ```Placeholder``` is displayed.
/// </summary>
Machinata.Reporting.Node.PlaceholderNode.defaults.text = null;

Machinata.Reporting.Node.PlaceholderNode.init = function (instance, config, json, nodeElem) {
       
    // Create text with vertical alignment
    var tableElem = $("<div class='vertical-aligner node-bg'><div class='vertical-alignee text'></div></div>");
    var textToShow = Machinata.Reporting.Text.resolve(instance,json.text);
    if (textToShow == null) textToShow = "Placeholder";
    tableElem.find(".text").text(textToShow);
    nodeElem.append(tableElem);

};
Machinata.Reporting.Node.PlaceholderNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-dashboard.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-dashboard.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// A user-customizable dashboard consisting of multiple child nodes.
/// Uses LayoutNode as the underlying layout driver, but adds a layer
/// of dashboard board functionality over the top.
/// Note: NOT FOR PRODUCTION USE (current POC)
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.DashboardNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.DashboardNode.defaults = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.DashboardNode.defaults.addStandardTools = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.DashboardNode.init = function (instance, config, json, nodeElem) {
    Machinata.Reporting.Node.LayoutNode.init(instance, config, json, nodeElem);
    nodeElem.addClass("type-LayoutNode");
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.DashboardNode.postBuild = function (instance, config, json, nodeElem) {
    Machinata.Reporting.Node.LayoutNode.postBuild(instance, config, json, nodeElem);

    
    // Initialize Packery
    var grid = nodeElem.packery({
        itemSelector: '.layout-child',
        gutter: 0,
        columnWidth: 0,
        rowHeight: 0,
        transitionDuration: 0 // for the first transition we dont want an animation
    });

    // Make all items draggable
    var items = grid.find('.layout-child');
    items.draggable({
        stop: function () {
            // When the user finishes a drag, we need to
            nodeElem.packery('layout');
        }
    });

    // Bind drag events to Packery
    grid.packery('bindUIDraggableEvents', items);

    // Bind events
    grid.on('layoutComplete', function (event, items) {
    });
    grid.on('dragItemPositioned', function (event, draggedItem) {
    });
    grid.on('fitComplete', function (event, item) {
    });
    grid.on('removeComplete', function (event, removedItems) {
    });

    // Initial packery update
    // Note: to ensure that the browser dom building has enough time, we split
    // this out to a different thread task via a timeout
    setTimeout(function () {
        nodeElem.packery('layout');
        nodeElem.packery({
            transitionDuration: '0.4s'
        });
    }, 1);
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.DashboardNode.draw = function (instance, config, json, nodeElem) {
    Machinata.Reporting.Node.LayoutNode.draw(instance, config, json, nodeElem);

    // Further packery updates
    // Note: to ensure that the browser dom resizing has enough time, we split
    // this out to a different thread task via a timeout
    setTimeout(function () {
        nodeElem.packery('layout');
    }, 1);
};



















/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-layout.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-layout.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// This nodes provides various means for creating dynamic and fixed layouts. A LayoutNode
/// should act solely as a container, and not define any specific ```chrome``` or invoke a 
/// toolbar.
///
/// ## Dynamic System
/// With it's default dynamic behaviour, the LayoutNode drives the CSS stack to begin and 
/// dynamic block system where each child can define it's own style and size.
///
/// ## Slot System
/// When using the slot system, the LayoutNode's style defines a pre-defined layout where
/// each of the LayoutNode's children is assigned a slot and adjusted (layouted) according
/// to the layout. Each layout must be registered with the ```Machinata.Reporting.registerLayout```
/// function.
///
/// ## Registering Layouts
/// See ```Machinata.Reporting.registerLayout```.
/// </summary>
/// <type>class</type>
/// <example>
/// ### Dynamic System (without registration)
/// ```
/// {
///     "nodeType": "LayoutNode",
///     "children": [
///         {
///             "nodeType": "PlaceholderNode",
///             "style": "XYZ",
///             "mainTitle": {
///                 "resolved": "Left node"
///             }
///         },
///         {
///             "nodeType": "PlaceholderNode",
///             "style": "ABC",
///             "mainTitle": {
///                 "resolved": "Center node"
///             }
///         },
///         {
///             "nodeType": "PlaceholderNode",
///             "style": "123",
///             "mainTitle": {
///                 "resolved": "Right node"
///             }
///         }
///     ]
/// }
/// ```
/// ### Slot System (layout registration required)
/// ```
/// {
///     "nodeType": "LayoutNode",
///     "style": "CS_W_Overview_PanelTrailerSmall",
///     "slotChildren": {
///         "{left}": 0,
///         "{center}": 1,
///         "{right}": 2
///     },
///     "children": [
///         {
///             "nodeType": "PlaceholderNode",
///             "mainTitle": {
///                 "resolved": "Left node"
///             }
///         },
///         {
///             "nodeType": "PlaceholderNode",
///             "mainTitle": {
///                 "resolved": "Center node"
///             }
///         },
///         {
///             "nodeType": "PlaceholderNode",
///             "mainTitle": {
///                 "resolved": "Right node"
///             }
///         }
///     ]
/// }
/// ```
/// </example>
Machinata.Reporting.Node.LayoutNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LayoutNode.defaults = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LayoutNode.defaults.addStandardTools = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.LayoutNode.init = function (instance, config, json, nodeElem) {

    var LAYOUT_DEBUG_ENABLED = false; // will be deprecated

    // Init
    var nodeRequiresChildrenResort = false;
    var styleName = null;
    if (json.styles != null && json.styles.length > 0) styleName = json.styles[0];

    // Get layout
    if (LAYOUT_DEBUG_ENABLED) console.log(Machinata.Reporting._layouts);
    if (LAYOUT_DEBUG_ENABLED) console.log("searching layout " + json.style);
    var layoutJSON = null;
    if (styleName != null) layoutJSON = Machinata.Reporting.getLayout(styleName);
    if (layoutJSON != null) {
        if (LAYOUT_DEBUG_ENABLED) console.log("got layout " + layoutJSON.name);
    }

    // Flatten slotChildren into actual child
    // Note: we treat styles a bit special here, instead of overwriting if set by the layout, we add them (merge them in)
    $.each(json.children, function (index, childJSON) {
        // Find matching reference (by id) in slotChildren
        if (childJSON.additionalCSSClasses == null) childJSON.additionalCSSClasses = "";
        childJSON.additionalCSSClasses += " layout-child";
        $.each(json.slotChildren, function (key, value) {
            if (value == index) {
                // We have a match
                // Register directly in child json
                if (LAYOUT_DEBUG_ENABLED) console.log("found slot match " + key + " index " + value);
                childJSON.slotNumber = value;
                childJSON.slotKey = key;
                childJSON.slotClass = key.replace("{", "").replace("}", "");
                childJSON.additionalCSSClasses += " slot-child slot-" + childJSON.slotNumber + " slot-" + childJSON.slotClass;
                // Additional styles from self?
                if (childJSON.style != null) childJSON.additionalCSSClasses += " style-" + childJSON.style;
                if (childJSON.styles != null) {
                    for (var si = 0; si < childJSON.styles.length; si++) {
                        childJSON.additionalCSSClasses += " style-" + childJSON.styles[si];
                    }
                }
                // Merge in layout configuration
                if (layoutJSON != null) {
                    // Additional style from layout?
                    if (layoutJSON.style != null) childJSON.additionalCSSClasses += " style-" + layoutJSON.style;
                    if (layoutJSON.styles != null) {
                        for (var si = 0; si < layoutJSON.styles.length; si++) {
                            childJSON.additionalCSSClasses += " style-" + layoutJSON.styles[si];
                        }
                    }
                    // Find mathing slot
                    $.each(layoutJSON.children, function (layoutChildIndex, layoutChildJSON) {
                        if (LAYOUT_DEBUG_ENABLED) console.log("compare " + layoutChildJSON.slotKey + " w " + childJSON.slotKey);
                        if (layoutChildJSON.slotKey == childJSON.slotKey) {
                            // Match!
                            // Merge layoutChildJSON in our childJSON...
                            $.extend(childJSON, layoutChildJSON);
                            childJSON.slotIndex = layoutChildIndex;
                            if (layoutChildJSON.style != null) childJSON.additionalCSSClasses += " style-" + layoutChildJSON.style;
                            if (layoutChildJSON.styles != null) {
                                for (var si = 0; si < layoutChildJSON.styles.length; si++) {
                                    childJSON.additionalCSSClasses += " style-" + layoutChildJSON.styles[si];
                                }
                            }
                            if (LAYOUT_DEBUG_ENABLED) console.log("found matching layout child slot " + layoutChildJSON.slotKey);
                            if (LAYOUT_DEBUG_ENABLED) console.log("   final index is " + childJSON.slotIndex);
                            if (layoutChildIndex != index) {
                                if (LAYOUT_DEBUG_ENABLED) console.log("   index mismatch! will require resort");
                                nodeRequiresChildrenResort = true;
                            }
                        }
                    });
                }
                // Further properties...
                
                return;
            }
        });
    });

    // Resort, only if needed
    if (nodeRequiresChildrenResort == true) {
        json.children.sort(function (a, b) {
            return a.slotIndex > b.slotIndex;
        });
    }

};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LayoutNode.postBuild = function (instance, config, json, nodeElem) {
    // For floating layouts we need this...
    nodeElem.append($("<div class='clear'></div>"));
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LayoutNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-theme-test.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-theme-test.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// A very basic node to test themes. This node will generate a pallet for the theme including
/// a text overlay in the proper theme shade overlay color.
/// 
/// Note: This node should not be used in production.
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.ThemeTestNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ThemeTestNode.defaults = {};

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.ThemeTestNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// </summary>
Machinata.Reporting.Node.ThemeTestNode.defaults.chrome = "solid";

/// <summary>
/// </summary>
Machinata.Reporting.Node.ThemeTestNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var shadeNamesToUse = config.themeColorShadeNames;
    if (json.theme == "gray") {
        shadeNamesToUse = config.themeGrayShadeNames;
    }
    return {
        "data": [
          {
              "name": "colorShades",
                "values": shadeNamesToUse
          },
        ],
        "scales": [
          {
              "name": "color",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": json.theme }
          },
          {
              "name": "textColor",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": "text-on-" + json.theme }
          },
          {
              "name": "xscale",
              "type": "band",
              "domain": { "data": "colorShades", "field": "data" },
              "range": "width",
              "padding": 0.0,
              "round": true
          }
        ],

        "marks": [
          {
              "type": "rect",
              "from": { "data": "colorShades" },
              "encode": {
                  "enter": {
                      "x": { "scale": "xscale", "field": "data" },
                      "width": { "scale": "xscale", "band": 1 },
                      "y": { "signal": "height" },
                      "y2": { "value": 0 }
                  },
                  "update": {
                      "fill": { "scale": "color", "field": "data" }
                  }
              }
          },
          {
              "type": "text",
              "from": { "data": "colorShades" },
              "encode": {
                  "enter": {
                      "x": { "signal": "scale('xscale',datum.data) + bandwidth('xscale')/2" },
                      "y": { "signal": "height/2" },
                      "align": { "value": "center" },
                      "baseline": { "value": "middle" },
                      "fontWeight": { "value": "bold" },
                      "fontSize": { "value": 14 },
                  },
                  "update": {
                      "fill": { "scale": "textColor", "field": "data" },
                      "text": { "signal": "['"+json.theme+"' + ' ' + datum.data , scale('color',datum.data)]" }
                  }
              }
          }
        ]
    };
};
Machinata.Reporting.Node.ThemeTestNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    
};
Machinata.Reporting.Node.ThemeTestNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.ThemeTestNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.ThemeTestNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};









/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-contact.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-contact.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Node for displaying contact information or user information.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.ContactNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.ContactNode.defaults = {};


/// <summary>
/// By default ContactNode have a ```solid``` chrome.
/// </summary>
Machinata.Reporting.Node.ContactNode.defaults.chrome = "solid";

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.ContactNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.ContactNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_1x1];

/// <summary>
/// If true, a round photo is generated and shown until the user interacts with the node.
/// By default ContactNode have a round style.
/// </summary>
Machinata.Reporting.Node.ContactNode.defaults.roundPhoto = true;

/// <summary>
/// By default ContactNode have a ```W_RoundPhoto``` style.
/// Available styles:
///  - ```W_RoundPhoto```
///  - ```W_SquarePhoto```
/// Note: styles are automatically applied as needed depending on the ```roundPhoto``` setting.
/// </summary>
Machinata.Reporting.Node.ContactNode.defaults.style = "W_RoundPhoto";

/// <summary>
/// No tools for ContactNode
/// </summary>
Machinata.Reporting.Node.ContactNode.defaults.addStandardTools = false;


/// <summary>
/// The contact JSON object that contains the data to display.
/// Possible properties:
///  - ```photo```: a resolvable image asset
///  - ```name```: a resolvable text (first and last name)
///  - ```jobTitle```: a resolvable text
///  - ```phone```: a resolvable text (will be automatically linked)
///  - ```email```: a resolvable text (will be automatically linked)
///  - ```website```: a resolvable text (will be automatically linked)
/// </summary>
/// <example>
/// ```
/// "contact": {
///     "photo": {
///         "filename": "QRCodeTest.png",
///         "mimeType": "image/png",
///         "encoding": "base64",
///         "data": "iVBORw0KGgoAAAANSUhEUgAAABUAAAAVAQMAAACT2TfVAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP//8i138cAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABcSURBVAiZY2Bcws5Qq/udwdVUnMF1LRCXijPUpn5nYAxhZ/jP/p9BZ44/g9De8wwHg58zXHvfzsBoGs/wn0+dgdHqPEPtI3sG1x52Btf8dgbX6+UMtZHxDIzu/AAr6RmSv9DdfQAAAABJRU5ErkJggg=="
///     },
///     "name": { "resolved": "Frederick Patel" },
///     "jobTitle": { "resolved": "Senior Analyst, Credit Suisse" },
///     "phone": { "resolved": "+41 44 123 45 61" },
///     "email": { "resolved": "frederick.patel@credit-suisse.com" }
///     "website": { "resolved": "credit-suisse.com" }
/// }
/// ```
/// </example>
Machinata.Reporting.Node.ContactNode.defaults.contact = null;


Machinata.Reporting.Node.ContactNode.init = function (instance, config, json, nodeElem) {
    // Container
    var containerElem = $("<div class='node-bg option-fullsize-content '></div>");
    if (json.roundPhoto == true) nodeElem.addClass("style-W_RoundPhoto");
    else nodeElem.addClass("style-W_SquarePhoto");

    // Profile photo
    if (json.contact.photo) {
        var photoShimElem = $("<div class='photo shim'></div>"); //Note: this shim is used to get the proper sizing, unfortunately this was not possible CSS only
        var photoElem = $("<div class='photo'></div>");
        photoElem.css("background-image", "url(" + Machinata.Reporting.Asset.resolve(json.contact.photo) + ")");
        // Bind interaction
        photoElem.hover(function () {
            photoElem.css("width", "100%");
            photoElem.css("height", "100%");
            photoElem.addClass("expand");
        }, function () {
            photoElem.css("width", photoShimElem.width());
            photoElem.css("height", photoShimElem.height());
            photoElem.removeClass("expand");
        });
        // Append
        containerElem.append(photoShimElem);
        containerElem.append(photoElem);
    }

    // Bottom
    var bottomElem = $("<div class='option-bottom-content option-padded-content'></div>").appendTo(containerElem);
    if (json.contact.name != null) {
        $("<div class='name main-property'></div>").text(Machinata.Reporting.Text.resolve(instance,json.contact.name)).appendTo(bottomElem);
    }
    if (json.contact.jobTitle != null) {
        $("<div class='jobTitle sub-property'></div>").text(Machinata.Reporting.Text.resolve(instance,json.contact.jobTitle)).appendTo(bottomElem);
    }
    if (json.contact.phone != null) {
        var txt = Machinata.Reporting.Text.resolve(instance,json.contact.phone);
        $("<a class='phone sub-property'></a>").text(txt).appendTo(bottomElem).attr("href", "tel:" + txt);
    }
    if (json.contact.email != null) {
        var txt = Machinata.Reporting.Text.resolve(instance,json.contact.email);
        $("<a class='email sub-property'></a>").text(txt).appendTo(bottomElem).attr("href", "mailto:" + txt);
    }
    if (json.contact.website != null) {
        var txt = Machinata.Reporting.Text.resolve(instance,json.contact.website);
        $("<a class='website sub-property'></a>").text(txt).appendTo(bottomElem).attr("href", "https://" + txt);
    }

    nodeElem.append(containerElem);


};
Machinata.Reporting.Node.ContactNode.resize = function (instance, config, json, nodeElem) {
    // If we use round mode, update the size depending on the node bg
    // Unfortunately we cannot do this in CSS since the height can't be derived from the width
    // We need a fixed size for the CSS transition to work on the hover
    if (json.roundPhoto == true) {
        var heightRatio = 0.42;
        if (nodeElem.find(".node-bg").height() < 240) heightRatio = 0.36;
        var nodeAR = nodeElem.find(".node-bg").width() / nodeElem.find(".node-bg").height();
        var photoW = nodeElem.find(".node-bg").width() * heightRatio;
        if (nodeAR > 1.5) {
            photoW = nodeElem.find(".node-bg").height() * 0.66; // very landscape type size
        }
        var photoH = photoW;
        nodeElem.find(".photo").width(photoW).height(photoH);
    } else {
        var heightRatio = 0.6;
        if (nodeElem.find(".node-bg").height() < 240) heightRatio = 0.5;
        var photoW = nodeElem.find(".node-bg").width();
        var photoH = nodeElem.find(".node-bg").height() * heightRatio;
        nodeElem.find(".photo").width(photoW).height(photoH);
    }
};
Machinata.Reporting.Node.ContactNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-offlinemap.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-offlinemap.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


//TODO: register all currencies in the world

/// <summary>
/// Powerful map that will automatically populate a world map with data points.
/// This chart can automatically translate facts with currencies to their geographic
/// locations, taking into account that some currencies (such as EUR) cover multiple
/// disjoint regions.
///
/// This node is designed for use with offline data (static maps). See OnlineMapNode for
/// more interactive version using map tiles.
///
/// The map facts should always have numbers (values) represented by percentages. The resolved format
/// can be customized if wanted, however the ```autoFormatEdgeNumbers``` must be turned off. Facts with 
/// long category texts are not supported.
/// 
/// ## Generated Vega Data Streams
/// The map node ships out-of-the-box with all country 110m borders and an
/// extensive list of world properties (such as currencies, names, latlons).
/// You must match facts with this database using the fact ```mapKey``` and the 
/// node setting ```keyProperty```.
///
/// ### worldFeatures
/// TOPOJSON 110m country borders
///
/// ### worldProperties
/// List of country properties that are merged into facts in order to map
/// facts to their world feature (such as a country border feature)
/// 
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.OfflineMapNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults = {};

/// <summary>
/// Maps should always be on a light chrome.
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.chrome = "light";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_4x2, Machinata.Reporting.Layouts.BLOCK_2x2];

/// <summary>
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.supportsToolbar = true;

/// <summary>
/// Maps don't have legends.
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.insertLegend = false;

/// <summary>
/// If set to ```true```, flags are shown for each fact.
/// By default ```true```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.showFlags = true;

/// <summary>
/// Defines the color theme to use for the territories which have underlying facts.
/// By default ```infographic```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.territoryTheme = "infographic";

/// <summary>
/// If ```true```, territories opacity is set using the underlying fact val.
/// By default ```false```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.territoryOpacityUsesFactVal = false;

/// <summary>
/// Multiplier used to make all flags higher or shorter.
/// By default ```1.0```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.flagPoleSize = 1.0;

/// <summary>
/// Multiplier used to make all flags wider.
/// By default ```1.0```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.flagWidth = 1.0;

/// <summary>
/// If a fact value cannot be looked up or mapped to a geographical location (such as 'Others'),
/// this is used.
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.fallbackLatitude = -27;

/// <summary>
/// If a fact value cannot be looked up or mapped to a geographical location (such as 'Others'),
/// this is used.
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.fallbackLongitude = -137.0;

/// <summary>
/// The ```projection``` object is optional and defines how the world
/// projection is done. If not projection is defined, then a western-centered mercator projection
/// is used.
/// 
/// ## Projection JSON
/// - ```type```: defines the projection type. Either ```mercator``` or ```orthographic``` (string)
/// - ```scale```: defines the projection scale (size) (int). This alters the underlying projection scale, which can be interpreted differently by each projection type. Set the scale to 'auto' to have the scale automatically set so that the projection fits (more or less)
/// - ```zoom```: defines the projection zoom (size), relative to the scale. This is typically much easier to set than using the scale. At ```1.0``` with scale set to ```auto```, the map should fit nicely in the chart area.
/// - ```center```: defines the center of the map, ie this will translate the map (must be an int array with two values, the first for latitude -180 to 180 and the second for longitude -90 to 90) (int[])
/// </summary>
/// <example>
/// ```
/// "projection": {
///     "type": "orthographic",
///     "scale": "auto",
///     "zoom": 1.0,
///     "center": [0, 20]
/// }
/// ```
/// </example>
Machinata.Reporting.Node.OfflineMapNode.defaults.projection = null;

/// <summary>
/// The ```facts``` object is required and defines the data points to display.
/// This property is bound into vega as a dataset.
///
/// The facts are highly pre-processed within vega and organized to automatically assign
/// a discrete color from the ```infographic``` theme as well as adjust the flag banner size.
///
/// Facts that can't be matched to a corresponding location on the map (such as a category 'Others') are placed 
/// on ```fallbackLatitude``` and ```fallbackLongitude```.
/// 
/// ## Fact JSON
/// - ```mapKey```: serves to pinpoint where on the map the fact should be placed. The resolved category should always match a corresponding ```keyProperty``` in the country datase.  If wanting to display currency categories on a map, make sure the this is a ISO 4217 upper-case currency, and the node setting ```keyProperty``` is set to ```currency```.
/// - ```val```: the value of the data point (float/int)
/// - ```category```: translatable text that labels the data point. If no ```mapKey``` is provided, this resolved value is used as a fallback.
/// - ```resolved```: the resolved value to display (string)
/// - ```latlon```: optional float[] with two numbers latitude and longitude (for example, ```"latlon": [7.971241, -130.341857]```. If defined, this will fix the data point marker to this location.
/// </summary>
/// <example>
/// ### Automatic Position with keyProperty set to 'currency'
/// ```
/// {
///     "val": 0.22,
///     "category": { "resolved": "EUR" },
///     "mapKey": "EUR",
///     "resolved": "22%"
/// }
/// ```
/// ### Automatic Position with keyProperty set to 'iso_a2'
/// ```
/// {
///     "val": 0.22,
///     "category": { "resolved": "Germany" },
///     "mapKey": "DE",
///     "resolved": "22%"
/// }
/// ```
/// ### Automatic Position with keyProperty set to 'currency' and fallback to resolved category
/// ```
/// {
///     "val": 0.22,
///     "category": { "resolved": "EUR" },
///     "resolved": "22%"
/// }
/// ```
/// ### Automatic Position with keyProperty set to 'iso_a2' and fallback to resolved category
/// ```
/// {
///     "val": 0.22,
///     "category": { "resolved": "DE" },
///     "resolved": "22%"
/// }
/// ```
/// ### Custom Position
/// ```
/// {
///     "val": 0.72,
///     "category": { "resolved": "Pacific" },
///     "resolved": "72%",
///     "latlon": [7.971241, -130.341857]
/// }
/// ```
/// </example>
Machinata.Reporting.Node.OfflineMapNode.defaults.facts = null;

/// <summary>
/// Defines which feature to use from the TOPOJSON 110m country file.
/// 
/// ## Features Available
///  - ```countries```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.features = "countries";

/// <summary>
/// Defines the lookup property used to resolve a fact's ISO-N3 code which is used
/// to map the facts to its feature (TOPOJSON uses ids with ISO-N3) via the fact category. 
/// The default is ```currency``` (ISO 4217), though a common key property might be ```iso_a2``` or ```iso_a3```.
/// 
/// ## Known Properties
/// The following can be used:
///  - ```currency```: "XYZ" (ISO 4217)
///  - ```iso_n3```: 756,
///  - ```sovereignt```: "Switzerland",
///  - ```sov_a3```: "CHE",
///  - ```admin```: "Switzerland",
///  - ```adm0_a3```: "CHE",
///  - ```geounit```: "Switzerland",
///  - ```gu_a3```: "CHE",
///  - ```subunit```: "Switzerland",
///  - ```su_a3```: "CHE",
///  - ```name```: "Switzerland",
///  - ```name_long```: "Switzerland",
///  - ```brk_a3```: "CHE",
///  - ```brk_name```: "Switzerland",
///  - ```abbrev```: "Switz.",
///  - ```postal```: "CH",
///  - ```formal_en```: "Swiss Confederation",
///  - ```iso_a2```: "CH",
///  - ```iso_a3```: "CHE",
///  - ```un_a3```: 756,
///  - ```wb_a2```: "CH",
///  - ```wb_a3```: "CHE",
///  - ```adm0_a3_is```: "CHE",
///  - ```adm0_a3_us```: "CHE",
///  - ```continent```: "Europe",
///  - ```region_un```: "Europe",
///  - ```subregion```: "Western Europe",
///  - ```region_wb```: "Europe & Central Asia"
///
/// The following have special attached layouts:
///  - ```currency```
///  - ```continent```
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.keyProperty = "currency";

/// <summary>
/// If enabled, if the fact is between -1% and 1% (very small) or greater than 99.5% (very large, but not 100%),
/// we use the facts full formatting, otherwise we use a standard full number percent format
/// that is simplified (ie 43% instead of 43.04%)...
/// For this setting to work, the fact format specified must be of type percent (ie '.2%').
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.automaticallyFormatEdgeNumbers = true;

/// <summary>
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.automaticallySetFlagMinWidth = true;

/// <summary>
/// If not ```null```, will specify the label size for the flags and thus all derived dimensions.
/// By default flag labels will use the standard text label size.
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.defaults.labelSize = null;

/// <summary>
/// </summary>
Machinata.Reporting.Node.OfflineMapNode.getVegaSpec = function (instance, config, json, nodeElem) {
    // Initialize some shortcuts for all the different dimensions we need
    // All dimensions are based off of the flag value label font size
    // Note: these have been ported to signals...
    //var flagTextSize = json.labelSize;
    //if (flagTextSize == null || flagTextSize == "auto") flagTextSize = config.labelSize;
    //var flagTextPadding = Math.round(flagTextSize * 0.1);
    //var flagHeight = flagTextPadding + flagTextSize + flagTextPadding;
    //var flagLabelTextSize = flagHeight;
    //var flagPoleHeight = flagHeight * 3.0;
    //var flagMinWidth = flagHeight * 1.5;
    //var flagMaxWidth = flagHeight * 5.5 * json.flagWidth;


    // Normalize facts to rounded percentages, but only if fact is very edge of boundaries...
    if (json.automaticallyFormatEdgeNumbers == true) {
        Machinata.Reporting.Node.VegaNode.Util.automaticallyFormatEdgeNumbers(json.facts);
    }

    // Validate flagMinWidth
    var flagMinWidthCalculated = null;
    if (json.automaticallySetFlagMinWidth == true) {
        flagMinWidthCalculated = 0;
        var flagTextSize = json.labelSize;
        if (flagTextSize == null || flagTextSize == "auto") flagTextSize = config.labelSize;
        for (var i = 0; i < json.facts.length; i++) {
            var fact = json.facts[i];
            var label = fact.resolved;
            var approxLen = Machinata.Reporting.Tools.measureStringApproximately(config, label,flagTextSize);
            if (approxLen > flagMinWidthCalculated) flagMinWidthCalculated = approxLen;
        }
        flagMinWidthCalculated = Math.round(flagMinWidthCalculated*0.9);
    }

    // Round everything
    //flagTextPadding = Math.round(flagTextPadding);
    //flagLabelTextSize = Math.round(flagLabelTextSize);
    //flagPoleHeight = Math.round(flagPoleHeight);
    //flagMinWidth = Math.round(flagMinWidth);
    //flagMaxWidth = Math.round(flagMaxWidth);

    return {
        "data": [

          {
              "name": "facts",
              "values": null
          },
          {
              "name": "projection",
              "values": null
          },
          {
              "name": "worldProperties",
              /*"_comment": "Provides country properties for the TOPOJSON features. These can be joined on the key 'iso_a2', for example.",*/
              "values": Machinata.Reporting.Node.OfflineMapNode.TOPOJSON_110M_PROPERTIES
          },
          {
              "name": "factsResolved",
              "descriptions": "Resolves the facts somewhat based on our incoming data",
              "source": "facts",
              "transform": [
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                      "expr": "datum.mapKey != null ? datum.mapKey : datum.category.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "categoryResolved",
                    "expr": "datum.category.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "valResolved",
                    "expr": "datum.resolved"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "formatType",
                    "expr": "datum.formatType ? datum.formatTyped : 'number'" // default
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "format",
                    "expr": "datum.format ? datum.format : '.1%'" // default
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "tooltipResolved",
                    "expr": "datum.categoryResolved + ': ' + datum.valResolved + (datum.link != null && datum.link.tooltip ? '[break]'+datum.link.tooltip.resolved : '')" // default
                  },
                // Note: the resolved rank we now do in javascript, since its a much better algo
                /*{
                    "type": "collect",
                    "sort": { "field": "val" }
                },
                {
                    "type": "identifier",
                    "as": "rankResolved",
                }*/ 
              ]
          },
          {
              "name": "factsResolvedWithISON3",
              /*"_comment": "factsResolved joined with worldProperties so we now the iso_n3 and centroidOffset...",*/
              "source": "factsResolved",
              "transform": [
                {
                    /*"_comment": "Join to the properties on key == currency. We need the properties in order to get the iso_n3, which the 110M_Features only contains.",*/
                    "type": "lookup",
                    "from": "worldProperties",
                    "key": json.keyProperty,
                    "fields": ["key"],
                    "values": ["iso_n3", "latlon", "flagHeightMultiplier"],
                    "as":     ["iso_n3", "latlonDefault", "flagHeightMultiplier"]
                },
                {
                    /*"_comment": "If there is no lat lon registered, then make sure at least we have a default to fallback",*/
                    "type": "formula",
                    "initonly": true,
                    "as": "latlonResolved",
                    "expr": "datum.latlon ? datum.latlon : (datum.latlonDefault ? datum.latlonDefault : [" + json.fallbackLatitude + ","+json.fallbackLongitude+"])" // default
                },
                {
                    "type": "formula",
                    "expr": "datum.latlonResolved[0]",
                    "as": "lat"
                },
                {
                    "type": "formula",
                    "expr": "datum.latlonResolved[1]",
                    "as": "lon"
                },
                {
                    "type": "geopoint",
                    "projection": "projection",
                    "fields": ["lon", "lat"]
                },
                {
                    "type": "formula",
                    "expr": "round((flagPoleHeight * " + json.flagPoleSize + " * (datum.flagHeightMultiplier ? datum.flagHeightMultiplier : 1)) * flagPoleHeightMultiplierForSmallCharts)",
                    "as": "flagPoleHeightResolved"
                }
              ]
          },
          {
              "name": "factsExploded",
              /*"_comment": "This is actually worldProperties joined with factsResolved so that we have the inverse relation of each matching worldProperty for each fact key. This allows us to match multiple features in the end for each fact (for example, EUR will match multiple countries!)",*/
              "source": "worldProperties",
              "transform": [
                {
                    /*"_comment": "Join to the properties on key == currency. We need the properties in order to get the iso_n3, which the 110M_Features only contains.",*/
                    "type": "lookup",
                    "from": "factsResolved",
                    "key": "key",
                    "fields": [json.keyProperty],
                    "values": ["val", "key", "valResolved", "categoryResolved", "tooltipResolved", "rankResolved", "link"]
                },
                { "type": "filter", "expr": "datum.key != null" }
              ]
          },
          {
              /*"_comment": "These are the 110M TOPOJSON features (shapes). We have country outlines here which we select. The id of each feature is according to ISO-N3",*/
              "name": "worldFeatures",
              "values": Machinata.Reporting.Node.OfflineMapNode.TOPOJSON_110M_FEATURES,
              "format": {
                  "type": "topojson",
                  "feature": json.features
              },
          },
          {
              /*"_comment": "These are the 110M TOPOJSON features (shapes). We have country outlines here which we select.",*/
              "name": "worldFeaturesExplodedFacts",
              "source": "worldFeatures",
              "transform": [
                  {
                      /*"_comment": "Join on our facts",*/
                      "type": "lookup",
                      "from": "factsExploded",
                      "key": "iso_n3",
                      "fields": ["id"],
                      "values": ["val", "key", "valResolved", "categoryResolved", "tooltipResolved", "rankResolved", "iso_a2" , "link"]
                  },
              ]
          },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
        ],
        "signals": [
            {
                "name": "flagTextSize",
                "update": json.labelSize ? json.labelSize : "config_labelSize"
            },
            {
                "name": "flagTextPadding",
                "update": "round(flagTextSize * 0.1)"
            },
            {
                "name": "flagWidth",
                "update": json.flagWidth
            },
            {
                "name": "flagHeight",
                "update": "flagTextPadding + flagTextSize + flagTextPadding"
            },
            {
                "name": "flagLabelTextSize",
                "update": "round(flagHeight)"
            },
            {
                "name": "flagPoleHeight",
                "update": "round(flagHeight * 3.0)"
            },
            {
                "name": "flagMinWidth",
                "update": flagMinWidthCalculated != null ? flagMinWidthCalculated : "round(flagHeight * 1.5)"
            },
            {
                "name": "flagMaxWidth",
                "update": "round(flagHeight * 5.5 * flagWidth)"
            },

            {
                "name": "flagWidthMultiplierForSmallCharts",
                "update": "isLayoutedOnHalfMediumWidth ? 0.5 : 1.0"
            },
            {
                "name": "flagPoleHeightMultiplierForSmallCharts",
                "update": "isLayoutedOnHalfMediumWidth ? 0.7 : 1.0"
            },
            {
                // The range is the flagMinWidth to flagMaxWidth*factor, but at least flagMinWidth to flagMinWidth
                "name": "flagWidthRange",
                "update": "[flagMinWidth, max(flagMinWidth,flagMaxWidth*flagWidthMultiplierForSmallCharts)]"
            },
            {
                "name": "projectionTypeFromData",
                "init": "data('projection')[0]['type']"
            },
            {
                "name": "projectionScaleFromData",
                "init": "data('projection')[0]['scale']"
            },
            {
                "name": "projectionZoomFromData",
                "init": "data('projection')[0]['zoom'] != null ? data('projection')[0]['zoom'] : 1.0"
            },
            {
                "name": "chartSize",
                "update": "min(width,height)"
            },
            {
                "name": "projectionWidth",
                "update": "projectionTypeFromData == 'mercator' ? 960 : 500"
            },
            {
                "name": "projectionHeight",
                "update": "projectionTypeFromData == 'mercator' ? 500 : 500"
            },
            {
                "name": "projectionZeroScale",
                "update": "projectionTypeFromData == 'mercator' ? 128 : 100"
            },
            {
                "name": "projectionAR",
                "update": "projectionWidth/projectionHeight" // < 1.0 is portrait, > 1.0 is landscape
            },
            {
                "name": "chartAR",
                "update": "width/height" // < 1.0 is portrait, > 1.0 is landscape
            },
            {
                "name": "projectionResizeFactor",
                "update": "(projectionAR >= chartAR ? (width/projectionWidth) : (height/projectionHeight))"
            },
            {
                "name": "projectionScaleAuto",
                "update": "projectionResizeFactor * 120"
            },
            {
                "name": "projectionScale",
                "update": "projectionScaleFromData == 'auto' ? projectionScaleAuto : projectionScaleFromData"
            },
            {
                "name": "projectionCenter",
                "init": "data('projection')[0]['center']"
            },
            {
                "name": "projectionTranslate",
                "update": "[width / 2, height / 2]"
            },


            // Events
            {
                "name": "featureClick",
                "on": [
                    { "events": "shape:click", "update": "null" } // we handle it outside of vega in onMarkClick
                ]
            }


        ],
        "projections": [
            {
                "name": "projection",
                "type": { "signal": "projectionTypeFromData" },
                "scale": { "signal": "projectionScale * projectionZoomFromData" },
                //"rotate": [{ "signal": "rotateX" }, 0, 0],
                "center": { "signal": "projectionCenter" },
                "translate": { "signal": "projectionTranslate" },
                "clipExtent": { "signal": "[[0, 0], [width, height]]" }
            }
        ],
        "scales": [
            {
                "name": "colorFill",
                "type": "quantize",
                "domain": { "data": "factsResolved", "field": "rankResolved" },
                "range": { "scheme": json.territoryTheme },
                "reverse": true
            },
            {
                "name": "flagWidth",
                "type": "linear",
                "domain": { "data": "factsResolved", "field": "val" },
                "range": { "signal":"flagWidthRange"}
            },
          {
              "name": "grayColorByShade",
              "type": "ordinal",
              "domain": { "data": "grayShades", "field": "data" },
              "range": { "scheme": "gray" }
          },
          {
              "name": "colorByShade",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": json.theme }
          },
          {
              "name": "textColorByShade",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": "text-on-" + json.theme }
          },
          {
              "name": "grayColor",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": "gray" }
          }
        ],
        "marks": [
            {
                "clip": true, // makes sure that when we scale it doesnt push open the chart size
                "type": "group",
                "encode": {
                    "update": {
                        "width": { "signal": "width" },
                        "height": { "signal": "height" }
                    }
                },
                "marks": [

                    {
                        /*"_comment": "These are the country outlines and shapes",*/
                        "type": "shape",
                        "from": { "data": "worldFeaturesExplodedFacts" },
                        "encode": {
                            "enter": {
                                "strokeWidth": { "value": config.lineSize },
                                "stroke": { "value": "white" },
                                //debug:"fill": { "signal": "datum.val != null ? 'red' : 'gray'" },
                                "fill": { "signal": json.territoryOpacityUsesFactVal == true ? "scale('grayColorByShade','gray4')" : "datum.val != null ? scale('colorFill',datum.rankResolved) : scale('grayColorByShade','gray1')" },
                                "opacity": { "signal": json.territoryOpacityUsesFactVal == true ? "datum.val" : "1"},
                                "tooltip": { "signal": "datum.tooltipResolved" + (Machinata.DebugEnabled == true ? " + '[break]iso_n3='+datum.id + '[break]iso_a2='+datum.iso_a2 + '[break]scale='+projectionScale+'[break]rankResolved='+datum.rankResolved + '[break]val='+datum.val" : "") },
                                "cursor": { "signal": "datum.link != null ? 'pointer' : null"},
                            },
                            "update": {
                                "width": { "signal": "width" },
                                "height": { "signal": "height" },
                            }
                        },
                        "transform": [
                            { "type": "geoshape", "projection": "projection" }
                        ]
                    },
                    (json.showFlags != true) ? { "type": "group"} : {
                        "type": "group",
                        /*"_comment": "This is the first (FLAG POLE) of two master groups for the flag symbols. There are two groups due to the overlapping nature that works much better this way (ie poles never overlap flags/labels)",*/
                        "from": {
                            "facet": {
                                "data": "factsResolvedWithISON3",
                                "name": "factsResolvedWithISON3Faceted",
                                "groupby": "key"
                            }
                        },

                        "marks": [

                            {
                                "type": "group",
                                /*"_comment": "This is the group for the flag symbol. It is translated for the projection and center of the feature (times offset, if any)",*/
                                "from": {
                                    "data": "factsResolvedWithISON3Faceted"
                                },
                                "encode": {
                                    "enter": {
                                    },
                                    "update": {
                                        "x": { "signal": "round(datum.x)" }, // uses the values calculated by the geoshape transform
                                        "y": { "signal": "round(datum.y)" }
                                    }
                                },
                                "marks": [
                                    {
                                        /*"_comment": "This is the FLAGPOLE",*/
                                        "from": {
                                            "data": "factsResolvedWithISON3Faceted"
                                        },
                                        "type": "rect",
                                        "encode": {
                                            "enter": {
                                                "x": { "value": 0 },
                                                "width": { "value": config.lineSize },
                                                "fill": { "value": "black" }
                                            },
                                            "update": {
                                                "y": { "signal": "-datum.flagPoleHeightResolved" },
                                                "height": { "signal": "datum.flagPoleHeightResolved" },
                                            }
                                        }
                                    }
                                ]
                            },
                        ]
                    },
                    (json.showFlags != true) ? { "type": "group" } : {
                        "type": "group",
                        /*"_comment": "This is the second (FLAG + LABELS) of two master groups for the flag symbols. There are two groups due to the overlapping nature that works much better this way (ie poles never overlap flags/labels)",*/
                        "from": {
                            "facet": {
                                "data": "factsResolvedWithISON3",
                                "name": "factsResolvedWithISON3Faceted",
                                "groupby": "key"
                            }
                        },
                        "marks": [
                            {
                                "type": "group",
                                /*"_comment": "This is the master group for the flag symbol. It is translated for the projection and center of the feature (times offset, if any)",*/
                                "from": {
                                    "data": "factsResolvedWithISON3Faceted"
                                },
                                "encode": {
                                    "update": {
                                        "x": { "signal": "round(datum.x)" }, // uses the values calculated by the geoshape transform
                                        "y": { "signal": "round(datum.y)" }
                                    }
                                },
                                "marks": [
                                    {
                                        /*"_comment": "This is the FLAG",*/
                                        "from": {
                                            "data": "factsResolvedWithISON3Faceted"
                                        },
                                        "type": "rect",
                                        "encode": {
                                            "enter": {
                                                "x": { "value": 0 },
                                                "fill": { "signal": "scale('colorByShade','mid')" },
                                                "tooltip": { "field": "tooltipResolved" },
                                                "cursor": { "signal": "datum.link != null ? 'pointer' : null" },
                                            },
                                            "update": {
                                                "y": { "signal": "-datum.flagPoleHeightResolved" }, // -1 is for font problems
                                                "width": { "signal": "round(scale('flagWidth',datum.val))" },
                                                "height": { "signal": "flagHeight" },
                                            }
                                        }
                                    },
                                    {
                                        /*"_comment": "This is the VAL LABEL",*/
                                        "from": {
                                            "data": "factsResolvedWithISON3Faceted"
                                        },
                                        "type": "text",
                                        "encode": {
                                            "enter": {
                                                "interactive": false,
                                                "fill": { "signal": "scale('textColorByShade','mid')" },
                                                "baseline": { "value": "middle" },
                                                "x": { "value": 0 },
                                                "text": { "field": "valResolved" },
                                                "tooltip": { "field": "tooltipResolved" },
                                                "cursor": { "signal": "datum.link != null ? 'pointer' : null" },
                                            },
                                            "update": {
                                                "dx": { "signal": "flagTextPadding" },
                                                "fontSize": { "signal": "flagTextSize" },
                                                "y": { "signal": "-datum.flagPoleHeightResolved + (flagHeight / 2)" },
                                            }
                                        }
                                    },
                                    {
                                        /*"_comment": "This is the CATEGORY LABEL",*/
                                        "from": {
                                            "data": "factsResolvedWithISON3Faceted"
                                        },
                                        "type": "text",
                                        "encode": {
                                            "enter": {
                                                "interactive": false,
                                                "align": { "value": "right" },
                                                "baseline": { "value": "middle" },
                                                "x": { "value": 0 },
                                                "text": { "field": "categoryResolved" },
                                                "cursor": { "signal": "datum.link != null ? 'pointer' : null" },
                                            },
                                            "update": {
                                                "fontSize": { "signal": "flagLabelTextSize" },
                                                "dx": { "signal": "-flagTextPadding*2" },
                                                "y": { "signal": "-datum.flagPoleHeightResolved + (flagHeight / 2)" },
                                            }
                                        }
                                    }
                                ]
                            },
                        ]
                    },
                ]
            }
        ]
    };
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    spec["data"][0].values = json.facts;
    spec["data"][1].values = [json.projection];
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.init = function (instance, config, json, nodeElem) {
    // Projection
    if (json.projection == null) {
        json.projection = {
            "type": "mercator",
            "scale": "auto",
            "center": [0, 45]
        }
    } else {
        if (json.projection.type == null) json.projection.type = "mercator";
        if (json.projection.scale == null) json.projection.scale = "auto";
        if (json.projection.zoom == null) json.projection.zoom = 1.0;
        if (json.projection.center == null) json.projection.center = [0, 45];
    }
    /*
    // Automatic region?
    if (json.keyProperty == "region") {
        json.keyProperty = "region_wb"; //TODO: migrate to own property!
        if (json.facts != null) {
            for (var i = 0; i < json.facts.length; i++) {
                var fact = json.facts[i];
                if (fact.category.resolved == "EMEA") {
                    fact.mapKey = "Europe & Central Asia";
                    fact.latlon = [44.266725, 17.879451];
                } else if (fact.category.resolved == "America") {
                    fact.mapKey = "North America";
                    fact.latlon = [37.988251, -103.241359];
                } else if (fact.category.resolved == "Africa") {
                    fact.mapKey = "Sub-Saharan Africa";
                    fact.latlon = [2.836701, 19.934625];
                } else if (fact.category.resolved == "Asia") {
                    fact.mapKey = "East Asia & Pacific";
                    fact.latlon = [25.574377, 105.438416];
                } else if (fact.category.resolved == "Oceania") {
                    fact.mapKey = "Oceania";
                    fact.latlon = [-26.317768, 89.172179];
                } else if (fact.category.resolved == "Other") {
                    fact.mapKey = "Other";
                    fact.latlon = [-14.018309, -119.910662];
                }
            }
        }
    }*/
    if (json.keyProperty == "continent") {
        json.keyProperty = "continent"; //TODO: migrate to own property!
        if (json.facts != null) {
            for (var i = 0; i < json.facts.length; i++) {
                var fact = json.facts[i];
                if (fact.category.resolved == "Europe") {
                    fact.mapKey = "Europe";
                    fact.latlon = [44.875712, 5.006955];
                } else if (fact.category.resolved == "North America") {
                    fact.mapKey = "North America";
                    fact.latlon = [34.559544, -95.248948];
                } else if (fact.category.resolved == "South America") {
                    fact.mapKey = "South America";
                    fact.latlon = [-22.422489, -62.743144];
                } else if (fact.category.resolved == "Africa") {
                    fact.mapKey = "Africa";
                    fact.latlon = [1.987171, 20.565401];
                } else if (fact.category.resolved == "Asia") {
                    fact.mapKey = "Asia";
                    fact.latlon = [26.293407, 84.842430];
                } else if (fact.category.resolved == "Oceania" || fact.category.resolved == "Australia/Oceania") {
                    fact.mapKey = "Oceania";
                    fact.latlon = [-26.317768, 89.172179];
                } else if (fact.category.resolved == "Other") {
                    fact.mapKey = "Other";
                    fact.latlon = [-44.018309, -119.910662];
                }
            }
        }
    }
    // Auto rank facts
    // This looks rather complicated, but its actually simple: 
    // for each fact unique value we need a rank for the value (in order)
    // This is all we do here... We find all the unique values, then sort them, then 
    // assign the index of the sort results to each fact's value.
    // We need this so that we can create a good shading system. If we were to just
    // shade based on a scale, then any fact with a large weight (like 50%) will push all
    // facts with lower numbers out of the scale to basically one flat color... This way with 
    // the ranking system we distribute the color no matter how the numbers are...
    if (true) {
        var valDictionary = {};
        var valArray =[];
        for (var i = 0; i < json.facts.length; i++) {
            var fact = json.facts[i];
            if (valDictionary[fact.val] == null) valArray.push(fact.val);
            valDictionary[fact.val] = 0;
        }
        valArray.sort(function (a, b) {
            return a - b;
        });
        for (var i = 0; i < Object.keys(valDictionary).length; i++) {
            var key = Object.keys(valDictionary)[i];
            valDictionary[key] = valArray.indexOf(parseFloat(key));
        }
        for (var i = 0; i < json.facts.length; i++) {
            var fact = json.facts[i];
            fact.rankResolved = valDictionary[fact.val];
        }
    }
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
    
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.onMarkClick = function (instance, config, json, nodeElem, event, item) {
    // If the item has a link json attached to it, we "open" it
    if (item != null && item.datum != null && item.datum.link != null) {
        Machinata.Reporting.Tools.openLink(instance, item.datum.link);
    }
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {
    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryFacts(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.TOPOJSON_110M_PROPERTIES = [
   {
       "iso_n3": -99,
       "sovereignt": "Kosovo",
       "sov_a3": "KOS",
       "admin": "Kosovo",
       "adm0_a3": "KOS",
       "geounit": "Kosovo",
       "gu_a3": "KOS",
       "subunit": "Kosovo",
       "su_a3": "KOS",
       "name": "Kosovo",
       "name_long": "Kosovo",
       "brk_a3": "B57",
       "brk_name": "Kosovo",
       "abbrev": "Kos.",
       "postal": "KO",
       "formal_en": "Republic of Kosovo",
       "iso_a2": "-99",
       "iso_a3": "-99",
       "un_a3": -99,
       "wb_a2": "KV",
       "wb_a3": "KSV",
       "adm0_a3_is": "SRB",
       "adm0_a3_us": "KOS",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia"
   },
   {
       "iso_n3": -99,
       "sovereignt": "Somaliland",
       "sov_a3": "SOL",
       "admin": "Somaliland",
       "adm0_a3": "SOL",
       "geounit": "Somaliland",
       "gu_a3": "SOL",
       "subunit": "Somaliland",
       "su_a3": "SOL",
       "name": "Somaliland",
       "name_long": "Somaliland",
       "brk_a3": "B30",
       "brk_name": "Somaliland",
       "abbrev": "Solnd.",
       "postal": "SL",
       "formal_en": "Republic of Somaliland",
       "iso_a2": "-99",
       "iso_a3": "-99",
       "un_a3": -99,
       "wb_a2": "-99",
       "wb_a3": "-99",
       "adm0_a3_is": "SOM",
       "adm0_a3_us": "SOM",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa"
   },
   {
       "iso_n3": -99,
       "sovereignt": "Northern Cyprus",
       "sov_a3": "CYN",
       "admin": "Northern Cyprus",
       "adm0_a3": "CYN",
       "geounit": "Northern Cyprus",
       "gu_a3": "CYN",
       "subunit": "Northern Cyprus",
       "su_a3": "CYN",
       "name": "N. Cyprus",
       "name_long": "Northern Cyprus",
       "brk_a3": "B20",
       "brk_name": "N. Cyprus",
       "abbrev": "N. Cy.",
       "postal": "CN",
       "formal_en": "Turkish Republic of Northern Cyprus",
       "iso_a2": "-99",
       "iso_a3": "-99",
       "un_a3": -99,
       "wb_a2": "-99",
       "wb_a3": "-99",
       "adm0_a3_is": "CYP",
       "adm0_a3_us": "CYP",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Europe & Central Asia"
   },
   {
       "currency": "AFN",
       "latlon": [
          33,
          65
       ],
       "iso_n3": 4,
       "sovereignt": "Afghanistan",
       "sov_a3": "AFG",
       "admin": "Afghanistan",
       "adm0_a3": "AFG",
       "geounit": "Afghanistan",
       "gu_a3": "AFG",
       "subunit": "Afghanistan",
       "su_a3": "AFG",
       "name": "Afghanistan",
       "name_long": "Afghanistan",
       "brk_a3": "AFG",
       "brk_name": "Afghanistan",
       "abbrev": "Afg.",
       "postal": "AF",
       "formal_en": "Islamic State of Afghanistan",
       "iso_a2": "AF",
       "iso_a3": "AFG",
       "un_a3": 4,
       "wb_a2": "AF",
       "wb_a3": "AFG",
       "adm0_a3_is": "AFG",
       "adm0_a3_us": "AFG",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "South Asia"
   },
   {
       "currency": "AOA",
       "latlon": [
          -12.5,
          18.5
       ],
       "iso_n3": 24,
       "sovereignt": "Angola",
       "sov_a3": "AGO",
       "admin": "Angola",
       "adm0_a3": "AGO",
       "geounit": "Angola",
       "gu_a3": "AGO",
       "subunit": "Angola",
       "su_a3": "AGO",
       "name": "Angola",
       "name_long": "Angola",
       "brk_a3": "AGO",
       "brk_name": "Angola",
       "abbrev": "Ang.",
       "postal": "AO",
       "formal_en": "People's Republic of Angola",
       "iso_a2": "AO",
       "iso_a3": "AGO",
       "un_a3": 24,
       "wb_a2": "AO",
       "wb_a3": "AGO",
       "adm0_a3_is": "AGO",
       "adm0_a3_us": "AGO",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa"
   },
   {
       "currency": "ALL",
       "latlon": [
          41,
          20
       ],
       "iso_n3": 8,
       "sovereignt": "Albania",
       "sov_a3": "ALB",
       "admin": "Albania",
       "adm0_a3": "ALB",
       "geounit": "Albania",
       "gu_a3": "ALB",
       "subunit": "Albania",
       "su_a3": "ALB",
       "name": "Albania",
       "name_long": "Albania",
       "brk_a3": "ALB",
       "brk_name": "Albania",
       "abbrev": "Alb.",
       "postal": "AL",
       "formal_en": "Republic of Albania",
       "iso_a2": "AL",
       "iso_a3": "ALB",
       "un_a3": 8,
       "wb_a2": "AL",
       "wb_a3": "ALB",
       "adm0_a3_is": "ALB",
       "adm0_a3_us": "ALB",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia"
   },
   {
       "currency": "AED",
       "latlon": [
          24,
          54
       ],
       "iso_n3": 784,
       "sovereignt": "United Arab Emirates",
       "sov_a3": "ARE",
       "admin": "United Arab Emirates",
       "adm0_a3": "ARE",
       "geounit": "United Arab Emirates",
       "gu_a3": "ARE",
       "subunit": "United Arab Emirates",
       "su_a3": "ARE",
       "name": "United Arab Emirates",
       "name_long": "United Arab Emirates",
       "brk_a3": "ARE",
       "brk_name": "United Arab Emirates",
       "abbrev": "U.A.E.",
       "postal": "AE",
       "formal_en": "United Arab Emirates",
       "iso_a2": "AE",
       "iso_a3": "ARE",
       "un_a3": 784,
       "wb_a2": "AE",
       "wb_a3": "ARE",
       "adm0_a3_is": "ARE",
       "adm0_a3_us": "ARE",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa"
   },
   {
       "currency": "ARS",
       "latlon": [
          -34,
          -64
       ],
       "iso_n3": 32,
       "sovereignt": "Argentina",
       "sov_a3": "ARG",
       "admin": "Argentina",
       "adm0_a3": "ARG",
       "geounit": "Argentina",
       "gu_a3": "ARG",
       "subunit": "Argentina",
       "su_a3": "ARG",
       "name": "Argentina",
       "name_long": "Argentina",
       "brk_a3": "ARG",
       "brk_name": "Argentina",
       "abbrev": "Arg.",
       "postal": "AR",
       "formal_en": "Argentine Republic",
       "iso_a2": "AR",
       "iso_a3": "ARG",
       "un_a3": 32,
       "wb_a2": "AR",
       "wb_a3": "ARG",
       "adm0_a3_is": "ARG",
       "adm0_a3_us": "ARG",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean"
   },
   {
       "currency": "AMD",
       "latlon": [
          40,
          45
       ],
       "iso_n3": 51,
       "sovereignt": "Armenia",
       "sov_a3": "ARM",
       "admin": "Armenia",
       "adm0_a3": "ARM",
       "geounit": "Armenia",
       "gu_a3": "ARM",
       "subunit": "Armenia",
       "su_a3": "ARM",
       "name": "Armenia",
       "name_long": "Armenia",
       "brk_a3": "ARM",
       "brk_name": "Armenia",
       "abbrev": "Arm.",
       "postal": "ARM",
       "formal_en": "Republic of Armenia",
       "iso_a2": "AM",
       "iso_a3": "ARM",
       "un_a3": 51,
       "wb_a2": "AM",
       "wb_a3": "ARM",
       "adm0_a3_is": "ARM",
       "adm0_a3_us": "ARM",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Europe & Central Asia"
   },
   {
       "latlon": [
          -90,
          0
       ],
       "iso_n3": 10,
       "sovereignt": "Antarctica",
       "sov_a3": "ATA",
       "admin": "Antarctica",
       "adm0_a3": "ATA",
       "geounit": "Antarctica",
       "gu_a3": "ATA",
       "subunit": "Antarctica",
       "su_a3": "ATA",
       "name": "Antarctica",
       "name_long": "Antarctica",
       "brk_a3": "ATA",
       "brk_name": "Antarctica",
       "abbrev": "Ant.",
       "postal": "AQ",
       "formal_en": "",
       "iso_a2": "AQ",
       "iso_a3": "ATA",
       "un_a3": -99,
       "wb_a2": "-99",
       "wb_a3": "-99",
       "adm0_a3_is": "ATA",
       "adm0_a3_us": "ATA",
       "continent": "Antarctica",
       "region_un": "Antarctica",
       "subregion": "Antarctica",
       "region_wb": "Antarctica"
   },
   {
       "_comment": "TODO",
       "iso_n3": 260,
       "sovereignt": "France",
       "sov_a3": "FR1",
       "admin": "French Southern and Antarctic Lands",
       "adm0_a3": "ATF",
       "geounit": "French Southern and Antarctic Lands",
       "gu_a3": "ATF",
       "subunit": "French Southern and Antarctic Lands",
       "su_a3": "ATF",
       "name": "Fr. S. Antarctic Lands",
       "name_long": "French Southern and Antarctic Lands",
       "brk_a3": "ATF",
       "brk_name": "Fr. S. and Antarctic Lands",
       "abbrev": "Fr. S.A.L.",
       "postal": "TF",
       "formal_en": "Territory of the French Southern and Antarctic Lands",
       "iso_a2": "TF",
       "iso_a3": "ATF",
       "un_a3": -99,
       "wb_a2": "-99",
       "wb_a3": "-99",
       "adm0_a3_is": "ATF",
       "adm0_a3_us": "ATF",
       "continent": "Seven seas (open ocean)",
       "region_un": "Seven seas (open ocean)",
       "subregion": "Seven seas (open ocean)",
       "region_wb": "Sub-Saharan Africa",
       "currency": "EUR",
       "latlon": [
          -49.25,
          69.167
       ]
   },
   {
       "currency": "AUD",
       "latlon": [
          -27,
          133
       ],
       "iso_n3": 36,
       "sovereignt": "Australia",
       "sov_a3": "AU1",
       "admin": "Australia",
       "adm0_a3": "AUS",
       "geounit": "Australia",
       "gu_a3": "AUS",
       "subunit": "Australia",
       "su_a3": "AUS",
       "name": "Australia",
       "name_long": "Australia",
       "brk_a3": "AUS",
       "brk_name": "Australia",
       "abbrev": "Auz.",
       "postal": "AU",
       "formal_en": "Commonwealth of Australia",
       "iso_a2": "AU",
       "iso_a3": "AUS",
       "un_a3": 36,
       "wb_a2": "AU",
       "wb_a3": "AUS",
       "adm0_a3_is": "AUS",
       "adm0_a3_us": "AUS",
       "continent": "Oceania",
       "region_un": "Oceania",
       "subregion": "Australia and New Zealand",
       "region_wb": "East Asia & Pacific"
   },
   {
       "iso_n3": 40,
       "sovereignt": "Austria",
       "sov_a3": "AUT",
       "admin": "Austria",
       "adm0_a3": "AUT",
       "geounit": "Austria",
       "gu_a3": "AUT",
       "subunit": "Austria",
       "su_a3": "AUT",
       "name": "Austria",
       "name_long": "Austria",
       "brk_a3": "AUT",
       "brk_name": "Austria",
       "abbrev": "Aust.",
       "postal": "A",
       "formal_en": "Republic of Austria",
       "iso_a2": "AT",
       "iso_a3": "AUT",
       "un_a3": 40,
       "wb_a2": "AT",
       "wb_a3": "AUT",
       "adm0_a3_is": "AUT",
       "adm0_a3_us": "AUT",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Western Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          47.33333333,
          13.33333333
       ]
   },
   {
       "iso_n3": 31,
       "sovereignt": "Azerbaijan",
       "sov_a3": "AZE",
       "admin": "Azerbaijan",
       "adm0_a3": "AZE",
       "geounit": "Azerbaijan",
       "gu_a3": "AZE",
       "subunit": "Azerbaijan",
       "su_a3": "AZE",
       "name": "Azerbaijan",
       "name_long": "Azerbaijan",
       "brk_a3": "AZE",
       "brk_name": "Azerbaijan",
       "abbrev": "Aze.",
       "postal": "AZ",
       "formal_en": "Republic of Azerbaijan",
       "iso_a2": "AZ",
       "iso_a3": "AZE",
       "un_a3": 31,
       "wb_a2": "AZ",
       "wb_a3": "AZE",
       "adm0_a3_is": "AZE",
       "adm0_a3_us": "AZE",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "AZN",
       "latlon": [
          40.5,
          47.5
       ]
   },
   {
       "iso_n3": 108,
       "sovereignt": "Burundi",
       "sov_a3": "BDI",
       "admin": "Burundi",
       "adm0_a3": "BDI",
       "geounit": "Burundi",
       "gu_a3": "BDI",
       "subunit": "Burundi",
       "su_a3": "BDI",
       "name": "Burundi",
       "name_long": "Burundi",
       "brk_a3": "BDI",
       "brk_name": "Burundi",
       "abbrev": "Bur.",
       "postal": "BI",
       "formal_en": "Republic of Burundi",
       "iso_a2": "BI",
       "iso_a3": "BDI",
       "un_a3": 108,
       "wb_a2": "BI",
       "wb_a3": "BDI",
       "adm0_a3_is": "BDI",
       "adm0_a3_us": "BDI",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "BIF",
       "latlon": [
          -3.5,
          30
       ]
   },
   {
       "iso_n3": 56,
       "sovereignt": "Belgium",
       "sov_a3": "BEL",
       "admin": "Belgium",
       "adm0_a3": "BEL",
       "geounit": "Belgium",
       "gu_a3": "BEL",
       "subunit": "Belgium",
       "su_a3": "BEL",
       "name": "Belgium",
       "name_long": "Belgium",
       "brk_a3": "BEL",
       "brk_name": "Belgium",
       "abbrev": "Belg.",
       "postal": "B",
       "formal_en": "Kingdom of Belgium",
       "iso_a2": "BE",
       "iso_a3": "BEL",
       "un_a3": 56,
       "wb_a2": "BE",
       "wb_a3": "BEL",
       "adm0_a3_is": "BEL",
       "adm0_a3_us": "BEL",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Western Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          50.83333333,
          4
       ]
   },
   {
       "iso_n3": 204,
       "sovereignt": "Benin",
       "sov_a3": "BEN",
       "admin": "Benin",
       "adm0_a3": "BEN",
       "geounit": "Benin",
       "gu_a3": "BEN",
       "subunit": "Benin",
       "su_a3": "BEN",
       "name": "Benin",
       "name_long": "Benin",
       "brk_a3": "BEN",
       "brk_name": "Benin",
       "abbrev": "Benin",
       "postal": "BJ",
       "formal_en": "Republic of Benin",
       "iso_a2": "BJ",
       "iso_a3": "BEN",
       "un_a3": 204,
       "wb_a2": "BJ",
       "wb_a3": "BEN",
       "adm0_a3_is": "BEN",
       "adm0_a3_us": "BEN",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          9.5,
          2.25
       ]
   },
   {
       "iso_n3": 854,
       "sovereignt": "Burkina Faso",
       "sov_a3": "BFA",
       "admin": "Burkina Faso",
       "adm0_a3": "BFA",
       "geounit": "Burkina Faso",
       "gu_a3": "BFA",
       "subunit": "Burkina Faso",
       "su_a3": "BFA",
       "name": "Burkina Faso",
       "name_long": "Burkina Faso",
       "brk_a3": "BFA",
       "brk_name": "Burkina Faso",
       "abbrev": "B.F.",
       "postal": "BF",
       "formal_en": "Burkina Faso",
       "iso_a2": "BF",
       "iso_a3": "BFA",
       "un_a3": 854,
       "wb_a2": "BF",
       "wb_a3": "BFA",
       "adm0_a3_is": "BFA",
       "adm0_a3_us": "BFA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          13,
          -2
       ]
   },
   {
       "iso_n3": 50,
       "sovereignt": "Bangladesh",
       "sov_a3": "BGD",
       "admin": "Bangladesh",
       "adm0_a3": "BGD",
       "geounit": "Bangladesh",
       "gu_a3": "BGD",
       "subunit": "Bangladesh",
       "su_a3": "BGD",
       "name": "Bangladesh",
       "name_long": "Bangladesh",
       "brk_a3": "BGD",
       "brk_name": "Bangladesh",
       "abbrev": "Bang.",
       "postal": "BD",
       "formal_en": "People's Republic of Bangladesh",
       "iso_a2": "BD",
       "iso_a3": "BGD",
       "un_a3": 50,
       "wb_a2": "BD",
       "wb_a3": "BGD",
       "adm0_a3_is": "BGD",
       "adm0_a3_us": "BGD",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "South Asia",
       "currency": "BDT",
       "latlon": [
          24,
          90
       ]
   },
   {
       "iso_n3": 100,
       "sovereignt": "Bulgaria",
       "sov_a3": "BGR",
       "admin": "Bulgaria",
       "adm0_a3": "BGR",
       "geounit": "Bulgaria",
       "gu_a3": "BGR",
       "subunit": "Bulgaria",
       "su_a3": "BGR",
       "name": "Bulgaria",
       "name_long": "Bulgaria",
       "brk_a3": "BGR",
       "brk_name": "Bulgaria",
       "abbrev": "Bulg.",
       "postal": "BG",
       "formal_en": "Republic of Bulgaria",
       "iso_a2": "BG",
       "iso_a3": "BGR",
       "un_a3": 100,
       "wb_a2": "BG",
       "wb_a3": "BGR",
       "adm0_a3_is": "BGR",
       "adm0_a3_us": "BGR",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "BGN",
       "latlon": [
          43,
          25
       ]
   },
   {
       "iso_n3": 44,
       "sovereignt": "The Bahamas",
       "sov_a3": "BHS",
       "admin": "The Bahamas",
       "adm0_a3": "BHS",
       "geounit": "The Bahamas",
       "gu_a3": "BHS",
       "subunit": "The Bahamas",
       "su_a3": "BHS",
       "name": "Bahamas",
       "name_long": "Bahamas",
       "brk_a3": "BHS",
       "brk_name": "Bahamas",
       "abbrev": "Bhs.",
       "postal": "BS",
       "formal_en": "Commonwealth of the Bahamas",
       "iso_a2": "BS",
       "iso_a3": "BHS",
       "un_a3": 44,
       "wb_a2": "BS",
       "wb_a3": "BHS",
       "adm0_a3_is": "BHS",
       "adm0_a3_us": "BHS",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Caribbean",
       "region_wb": "Latin America & Caribbean",
       "currency": "BSD",
       "latlon": [
          24.25,
          -76
       ]
   },
   {
       "iso_n3": 70,
       "sovereignt": "Bosnia and Herzegovina",
       "sov_a3": "BIH",
       "admin": "Bosnia and Herzegovina",
       "adm0_a3": "BIH",
       "geounit": "Bosnia and Herzegovina",
       "gu_a3": "BIH",
       "subunit": "Bosnia and Herzegovina",
       "su_a3": "BIH",
       "name": "Bosnia and Herz.",
       "name_long": "Bosnia and Herzegovina",
       "brk_a3": "BIH",
       "brk_name": "Bosnia and Herz.",
       "abbrev": "B.H.",
       "postal": "BiH",
       "formal_en": "Bosnia and Herzegovina",
       "iso_a2": "BA",
       "iso_a3": "BIH",
       "un_a3": 70,
       "wb_a2": "BA",
       "wb_a3": "BIH",
       "adm0_a3_is": "BIH",
       "adm0_a3_us": "BIH",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "BAM",
       "latlon": [
          44,
          18
       ]
   },
   {
       "iso_n3": 112,
       "sovereignt": "Belarus",
       "sov_a3": "BLR",
       "admin": "Belarus",
       "adm0_a3": "BLR",
       "geounit": "Belarus",
       "gu_a3": "BLR",
       "subunit": "Belarus",
       "su_a3": "BLR",
       "name": "Belarus",
       "name_long": "Belarus",
       "brk_a3": "BLR",
       "brk_name": "Belarus",
       "abbrev": "Bela.",
       "postal": "BY",
       "formal_en": "Republic of Belarus",
       "iso_a2": "BY",
       "iso_a3": "BLR",
       "un_a3": 112,
       "wb_a2": "BY",
       "wb_a3": "BLR",
       "adm0_a3_is": "BLR",
       "adm0_a3_us": "BLR",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "BYR",
       "latlon": [
          53,
          28
       ]
   },
   {
       "iso_n3": 84,
       "sovereignt": "Belize",
       "sov_a3": "BLZ",
       "admin": "Belize",
       "adm0_a3": "BLZ",
       "geounit": "Belize",
       "gu_a3": "BLZ",
       "subunit": "Belize",
       "su_a3": "BLZ",
       "name": "Belize",
       "name_long": "Belize",
       "brk_a3": "BLZ",
       "brk_name": "Belize",
       "abbrev": "Belize",
       "postal": "BZ",
       "formal_en": "Belize",
       "iso_a2": "BZ",
       "iso_a3": "BLZ",
       "un_a3": 84,
       "wb_a2": "BZ",
       "wb_a3": "BLZ",
       "adm0_a3_is": "BLZ",
       "adm0_a3_us": "BLZ",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "BZD",
       "latlon": [
          17.25,
          -88.75
       ]
   },
   {
       "iso_n3": 68,
       "sovereignt": "Bolivia",
       "sov_a3": "BOL",
       "admin": "Bolivia",
       "adm0_a3": "BOL",
       "geounit": "Bolivia",
       "gu_a3": "BOL",
       "subunit": "Bolivia",
       "su_a3": "BOL",
       "name": "Bolivia",
       "name_long": "Bolivia",
       "brk_a3": "BOL",
       "brk_name": "Bolivia",
       "abbrev": "Bolivia",
       "postal": "BO",
       "formal_en": "Plurinational State of Bolivia",
       "iso_a2": "BO",
       "iso_a3": "BOL",
       "un_a3": 68,
       "wb_a2": "BO",
       "wb_a3": "BOL",
       "adm0_a3_is": "BOL",
       "adm0_a3_us": "BOL",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "BOB",
       "latlon": [
          -17,
          -65
       ]
   },
   {
       "iso_n3": 76,
       "sovereignt": "Brazil",
       "sov_a3": "BRA",
       "admin": "Brazil",
       "adm0_a3": "BRA",
       "geounit": "Brazil",
       "gu_a3": "BRA",
       "subunit": "Brazil",
       "su_a3": "BRA",
       "name": "Brazil",
       "name_long": "Brazil",
       "brk_a3": "BRA",
       "brk_name": "Brazil",
       "abbrev": "Brazil",
       "postal": "BR",
       "formal_en": "Federative Republic of Brazil",
       "iso_a2": "BR",
       "iso_a3": "BRA",
       "un_a3": 76,
       "wb_a2": "BR",
       "wb_a3": "BRA",
       "adm0_a3_is": "BRA",
       "adm0_a3_us": "BRA",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "BRL",
       "latlon": [
          -10,
          -55
       ]
   },
   {
       "iso_n3": 96,
       "sovereignt": "Brunei",
       "sov_a3": "BRN",
       "admin": "Brunei",
       "adm0_a3": "BRN",
       "geounit": "Brunei",
       "gu_a3": "BRN",
       "subunit": "Brunei",
       "su_a3": "BRN",
       "name": "Brunei",
       "name_long": "Brunei Darussalam",
       "brk_a3": "BRN",
       "brk_name": "Brunei",
       "abbrev": "Brunei",
       "postal": "BN",
       "formal_en": "Negara Brunei Darussalam",
       "iso_a2": "BN",
       "iso_a3": "BRN",
       "un_a3": 96,
       "wb_a2": "BN",
       "wb_a3": "BRN",
       "adm0_a3_is": "BRN",
       "adm0_a3_us": "BRN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "BND",
       "latlon": [
          4.5,
          114.66666666
       ]
   },
   {
       "iso_n3": 64,
       "sovereignt": "Bhutan",
       "sov_a3": "BTN",
       "admin": "Bhutan",
       "adm0_a3": "BTN",
       "geounit": "Bhutan",
       "gu_a3": "BTN",
       "subunit": "Bhutan",
       "su_a3": "BTN",
       "name": "Bhutan",
       "name_long": "Bhutan",
       "brk_a3": "BTN",
       "brk_name": "Bhutan",
       "abbrev": "Bhutan",
       "postal": "BT",
       "formal_en": "Kingdom of Bhutan",
       "iso_a2": "BT",
       "iso_a3": "BTN",
       "un_a3": 64,
       "wb_a2": "BT",
       "wb_a3": "BTN",
       "adm0_a3_is": "BTN",
       "adm0_a3_us": "BTN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "South Asia",
       "currency": "BTN",
       "latlon": [
          27.5,
          90.5
       ]
   },
   {
       "iso_n3": 72,
       "sovereignt": "Botswana",
       "sov_a3": "BWA",
       "admin": "Botswana",
       "adm0_a3": "BWA",
       "geounit": "Botswana",
       "gu_a3": "BWA",
       "subunit": "Botswana",
       "su_a3": "BWA",
       "name": "Botswana",
       "name_long": "Botswana",
       "brk_a3": "BWA",
       "brk_name": "Botswana",
       "abbrev": "Bwa.",
       "postal": "BW",
       "formal_en": "Republic of Botswana",
       "iso_a2": "BW",
       "iso_a3": "BWA",
       "un_a3": 72,
       "wb_a2": "BW",
       "wb_a3": "BWA",
       "adm0_a3_is": "BWA",
       "adm0_a3_us": "BWA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Southern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "BWP",
       "latlon": [
          -22,
          24
       ]
   },
   {
       "iso_n3": 140,
       "sovereignt": "Central African Republic",
       "sov_a3": "CAF",
       "admin": "Central African Republic",
       "adm0_a3": "CAF",
       "geounit": "Central African Republic",
       "gu_a3": "CAF",
       "subunit": "Central African Republic",
       "su_a3": "CAF",
       "name": "Central African Rep.",
       "name_long": "Central African Republic",
       "brk_a3": "CAF",
       "brk_name": "Central African Rep.",
       "abbrev": "C.A.R.",
       "postal": "CF",
       "formal_en": "Central African Republic",
       "iso_a2": "CF",
       "iso_a3": "CAF",
       "un_a3": 140,
       "wb_a2": "CF",
       "wb_a3": "CAF",
       "adm0_a3_is": "CAF",
       "adm0_a3_us": "CAF",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XAF",
       "latlon": [
          7,
          21
       ]
   },
   {
       "currency": "CAD",
       "latlon": [
           62,
           -116
       ],
       "iso_n3": 124,
       "sovereignt": "Canada",
       "sov_a3": "CAN",
       "admin": "Canada",
       "adm0_a3": "CAN",
       "geounit": "Canada",
       "gu_a3": "CAN",
       "subunit": "Canada",
       "su_a3": "CAN",
       "name": "Canada",
       "name_long": "Canada",
       "brk_a3": "CAN",
       "brk_name": "Canada",
       "abbrev": "Can.",
       "postal": "CA",
       "formal_en": "Canada",
       "iso_a2": "CA",
       "iso_a3": "CAN",
       "un_a3": 124,
       "wb_a2": "CA",
       "wb_a3": "CAN",
       "adm0_a3_is": "CAN",
       "adm0_a3_us": "CAN",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Northern America",
       "region_wb": "North America"
   },
   {
       "currency": "CHF",
       "latlon": [
          47,
          8
       ],
       "flagHeightMultiplier": 2.05,
       "iso_n3": 756,
       "sovereignt": "Switzerland",
       "sov_a3": "CHE",
       "admin": "Switzerland",
       "adm0_a3": "CHE",
       "geounit": "Switzerland",
       "gu_a3": "CHE",
       "subunit": "Switzerland",
       "su_a3": "CHE",
       "name": "Switzerland",
       "name_long": "Switzerland",
       "brk_a3": "CHE",
       "brk_name": "Switzerland",
       "abbrev": "Switz.",
       "postal": "CH",
       "formal_en": "Swiss Confederation",
       "iso_a2": "CH",
       "iso_a3": "CHE",
       "un_a3": 756,
       "wb_a2": "CH",
       "wb_a3": "CHE",
       "adm0_a3_is": "CHE",
       "adm0_a3_us": "CHE",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Western Europe",
       "region_wb": "Europe & Central Asia"
   },
   {
       "iso_n3": 152,
       "sovereignt": "Chile",
       "sov_a3": "CHL",
       "admin": "Chile",
       "adm0_a3": "CHL",
       "geounit": "Chile",
       "gu_a3": "CHL",
       "subunit": "Chile",
       "su_a3": "CHL",
       "name": "Chile",
       "name_long": "Chile",
       "brk_a3": "CHL",
       "brk_name": "Chile",
       "abbrev": "Chile",
       "postal": "CL",
       "formal_en": "Republic of Chile",
       "iso_a2": "CL",
       "iso_a3": "CHL",
       "un_a3": 152,
       "wb_a2": "CL",
       "wb_a3": "CHL",
       "adm0_a3_is": "CHL",
       "adm0_a3_us": "CHL",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "CLF",
       "latlon": [
          -30,
          -71
       ]
   },
   {
       "currency": "CNY",
       "latlon": [
          35,
          105
       ],
       "iso_n3": 156,
       "sovereignt": "China",
       "sov_a3": "CH1",
       "admin": "China",
       "adm0_a3": "CHN",
       "geounit": "China",
       "gu_a3": "CHN",
       "subunit": "China",
       "su_a3": "CHN",
       "name": "China",
       "name_long": "China",
       "brk_a3": "CHN",
       "brk_name": "China",
       "abbrev": "China",
       "postal": "CN",
       "formal_en": "People's Republic of China",
       "iso_a2": "CN",
       "iso_a3": "CHN",
       "un_a3": 156,
       "wb_a2": "CN",
       "wb_a3": "CHN",
       "adm0_a3_is": "CHN",
       "adm0_a3_us": "CHN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Eastern Asia",
       "region_wb": "East Asia & Pacific"
   },
   {
       "iso_n3": 384,
       "sovereignt": "Ivory Coast",
       "sov_a3": "CIV",
       "admin": "Ivory Coast",
       "adm0_a3": "CIV",
       "geounit": "Ivory Coast",
       "gu_a3": "CIV",
       "subunit": "Ivory Coast",
       "su_a3": "CIV",
       "name": "Côte d'Ivoire",
       "name_long": "Côte d'Ivoire",
       "brk_a3": "CIV",
       "brk_name": "Côte d'Ivoire",
       "abbrev": "I.C.",
       "postal": "CI",
       "formal_en": "Republic of Ivory Coast",
       "iso_a2": "CI",
       "iso_a3": "CIV",
       "un_a3": 384,
       "wb_a2": "CI",
       "wb_a3": "CIV",
       "adm0_a3_is": "CIV",
       "adm0_a3_us": "CIV",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          8,
          -5
       ]
   },
   {
       "iso_n3": 120,
       "sovereignt": "Cameroon",
       "sov_a3": "CMR",
       "admin": "Cameroon",
       "adm0_a3": "CMR",
       "geounit": "Cameroon",
       "gu_a3": "CMR",
       "subunit": "Cameroon",
       "su_a3": "CMR",
       "name": "Cameroon",
       "name_long": "Cameroon",
       "brk_a3": "CMR",
       "brk_name": "Cameroon",
       "abbrev": "Cam.",
       "postal": "CM",
       "formal_en": "Republic of Cameroon",
       "iso_a2": "CM",
       "iso_a3": "CMR",
       "un_a3": 120,
       "wb_a2": "CM",
       "wb_a3": "CMR",
       "adm0_a3_is": "CMR",
       "adm0_a3_us": "CMR",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XAF",
       "latlon": [
          6,
          12
       ]
   },
   {
       "iso_n3": 180,
       "sovereignt": "Democratic Republic of the Congo",
       "sov_a3": "COD",
       "admin": "Democratic Republic of the Congo",
       "adm0_a3": "COD",
       "geounit": "Democratic Republic of the Congo",
       "gu_a3": "COD",
       "subunit": "Democratic Republic of the Congo",
       "su_a3": "COD",
       "name": "Dem. Rep. Congo",
       "name_long": "Democratic Republic of the Congo",
       "brk_a3": "COD",
       "brk_name": "Democratic Republic of the Congo",
       "abbrev": "D.R.C.",
       "postal": "DRC",
       "formal_en": "Democratic Republic of the Congo",
       "iso_a2": "CD",
       "iso_a3": "COD",
       "un_a3": 180,
       "wb_a2": "ZR",
       "wb_a3": "ZAR",
       "adm0_a3_is": "COD",
       "adm0_a3_us": "COD",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "CDF",
       "latlon": [
          0,
          25
       ]
   },
   {
       "iso_n3": 178,
       "sovereignt": "Republic of Congo",
       "sov_a3": "COG",
       "admin": "Republic of Congo",
       "adm0_a3": "COG",
       "geounit": "Republic of Congo",
       "gu_a3": "COG",
       "subunit": "Republic of Congo",
       "su_a3": "COG",
       "name": "Congo",
       "name_long": "Republic of Congo",
       "brk_a3": "COG",
       "brk_name": "Republic of Congo",
       "abbrev": "Rep. Congo",
       "postal": "CG",
       "formal_en": "Republic of Congo",
       "iso_a2": "CG",
       "iso_a3": "COG",
       "un_a3": 178,
       "wb_a2": "CG",
       "wb_a3": "COG",
       "adm0_a3_is": "COG",
       "adm0_a3_us": "COG",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XAF",
       "latlon": [
          -1,
          15
       ]
   },
   {
       "iso_n3": 170,
       "sovereignt": "Colombia",
       "sov_a3": "COL",
       "admin": "Colombia",
       "adm0_a3": "COL",
       "geounit": "Colombia",
       "gu_a3": "COL",
       "subunit": "Colombia",
       "su_a3": "COL",
       "name": "Colombia",
       "name_long": "Colombia",
       "brk_a3": "COL",
       "brk_name": "Colombia",
       "abbrev": "Col.",
       "postal": "CO",
       "formal_en": "Republic of Colombia",
       "iso_a2": "CO",
       "iso_a3": "COL",
       "un_a3": 170,
       "wb_a2": "CO",
       "wb_a3": "COL",
       "adm0_a3_is": "COL",
       "adm0_a3_us": "COL",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "COP",
       "latlon": [
          4,
          -72
       ]
   },
   {
       "iso_n3": 188,
       "sovereignt": "Costa Rica",
       "sov_a3": "CRI",
       "admin": "Costa Rica",
       "adm0_a3": "CRI",
       "geounit": "Costa Rica",
       "gu_a3": "CRI",
       "subunit": "Costa Rica",
       "su_a3": "CRI",
       "name": "Costa Rica",
       "name_long": "Costa Rica",
       "brk_a3": "CRI",
       "brk_name": "Costa Rica",
       "abbrev": "C.R.",
       "postal": "CR",
       "formal_en": "Republic of Costa Rica",
       "iso_a2": "CR",
       "iso_a3": "CRI",
       "un_a3": 188,
       "wb_a2": "CR",
       "wb_a3": "CRI",
       "adm0_a3_is": "CRI",
       "adm0_a3_us": "CRI",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "CRC",
       "latlon": [
          10,
          -84
       ]
   },
   {
       "iso_n3": 192,
       "sovereignt": "Cuba",
       "sov_a3": "CUB",
       "admin": "Cuba",
       "adm0_a3": "CUB",
       "geounit": "Cuba",
       "gu_a3": "CUB",
       "subunit": "Cuba",
       "su_a3": "CUB",
       "name": "Cuba",
       "name_long": "Cuba",
       "brk_a3": "CUB",
       "brk_name": "Cuba",
       "abbrev": "Cuba",
       "postal": "CU",
       "formal_en": "Republic of Cuba",
       "iso_a2": "CU",
       "iso_a3": "CUB",
       "un_a3": 192,
       "wb_a2": "CU",
       "wb_a3": "CUB",
       "adm0_a3_is": "CUB",
       "adm0_a3_us": "CUB",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Caribbean",
       "region_wb": "Latin America & Caribbean",
       "currency": "CUC",
       "latlon": [
          21.5,
          -80
       ]
   },
   {
       "iso_n3": 196,
       "sovereignt": "Cyprus",
       "sov_a3": "CYP",
       "admin": "Cyprus",
       "adm0_a3": "CYP",
       "geounit": "Cyprus",
       "gu_a3": "CYP",
       "subunit": "Cyprus",
       "su_a3": "CYP",
       "name": "Cyprus",
       "name_long": "Cyprus",
       "brk_a3": "CYP",
       "brk_name": "Cyprus",
       "abbrev": "Cyp.",
       "postal": "CY",
       "formal_en": "Republic of Cyprus",
       "iso_a2": "CY",
       "iso_a3": "CYP",
       "un_a3": 196,
       "wb_a2": "CY",
       "wb_a3": "CYP",
       "adm0_a3_is": "CYP",
       "adm0_a3_us": "CYP",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          35,
          33
       ]
   },
   {
       "iso_n3": 203,
       "sovereignt": "Czech Republic",
       "sov_a3": "CZE",
       "admin": "Czech Republic",
       "adm0_a3": "CZE",
       "geounit": "Czech Republic",
       "gu_a3": "CZE",
       "subunit": "Czech Republic",
       "su_a3": "CZE",
       "name": "Czech Rep.",
       "name_long": "Czech Republic",
       "brk_a3": "CZE",
       "brk_name": "Czech Rep.",
       "abbrev": "Cz. Rep.",
       "postal": "CZ",
       "formal_en": "Czech Republic",
       "iso_a2": "CZ",
       "iso_a3": "CZE",
       "un_a3": 203,
       "wb_a2": "CZ",
       "wb_a3": "CZE",
       "adm0_a3_is": "CZE",
       "adm0_a3_us": "CZE",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "CZK",
       "latlon": [
          49.75,
          15.5
       ]
   },
   {
       "currency": "EUR",
       "latlon": [
          51,
          9
       ],
       "iso_n3": 276,
       "sovereignt": "Germany",
       "sov_a3": "DEU",
       "admin": "Germany",
       "adm0_a3": "DEU",
       "geounit": "Germany",
       "gu_a3": "DEU",
       "subunit": "Germany",
       "su_a3": "DEU",
       "name": "Germany",
       "name_long": "Germany",
       "brk_a3": "DEU",
       "brk_name": "Germany",
       "abbrev": "Ger.",
       "postal": "D",
       "formal_en": "Federal Republic of Germany",
       "iso_a2": "DE",
       "iso_a3": "DEU",
       "un_a3": 276,
       "wb_a2": "DE",
       "wb_a3": "DEU",
       "adm0_a3_is": "DEU",
       "adm0_a3_us": "DEU",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Western Europe",
       "region_wb": "Europe & Central Asia"
   },
   {
       "iso_n3": 262,
       "sovereignt": "Djibouti",
       "sov_a3": "DJI",
       "admin": "Djibouti",
       "adm0_a3": "DJI",
       "geounit": "Djibouti",
       "gu_a3": "DJI",
       "subunit": "Djibouti",
       "su_a3": "DJI",
       "name": "Djibouti",
       "name_long": "Djibouti",
       "brk_a3": "DJI",
       "brk_name": "Djibouti",
       "abbrev": "Dji.",
       "postal": "DJ",
       "formal_en": "Republic of Djibouti",
       "iso_a2": "DJ",
       "iso_a3": "DJI",
       "un_a3": 262,
       "wb_a2": "DJ",
       "wb_a3": "DJI",
       "adm0_a3_is": "DJI",
       "adm0_a3_us": "DJI",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Middle East & North Africa",
       "currency": "DJF",
       "latlon": [
          11.5,
          43
       ]
   },
   {
       "iso_n3": 208,
       "sovereignt": "Denmark",
       "sov_a3": "DN1",
       "admin": "Denmark",
       "adm0_a3": "DNK",
       "geounit": "Denmark",
       "gu_a3": "DNK",
       "subunit": "Denmark",
       "su_a3": "DNK",
       "name": "Denmark",
       "name_long": "Denmark",
       "brk_a3": "DNK",
       "brk_name": "Denmark",
       "abbrev": "Den.",
       "postal": "DK",
       "formal_en": "Kingdom of Denmark",
       "iso_a2": "DK",
       "iso_a3": "DNK",
       "un_a3": 208,
       "wb_a2": "DK",
       "wb_a3": "DNK",
       "adm0_a3_is": "DNK",
       "adm0_a3_us": "DNK",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "DKK",
       "latlon": [
          56,
          10
       ]
   },
   {
       "iso_n3": 214,
       "sovereignt": "Dominican Republic",
       "sov_a3": "DOM",
       "admin": "Dominican Republic",
       "adm0_a3": "DOM",
       "geounit": "Dominican Republic",
       "gu_a3": "DOM",
       "subunit": "Dominican Republic",
       "su_a3": "DOM",
       "name": "Dominican Rep.",
       "name_long": "Dominican Republic",
       "brk_a3": "DOM",
       "brk_name": "Dominican Rep.",
       "abbrev": "Dom. Rep.",
       "postal": "DO",
       "formal_en": "Dominican Republic",
       "iso_a2": "DO",
       "iso_a3": "DOM",
       "un_a3": 214,
       "wb_a2": "DO",
       "wb_a3": "DOM",
       "adm0_a3_is": "DOM",
       "adm0_a3_us": "DOM",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Caribbean",
       "region_wb": "Latin America & Caribbean",
       "currency": "DOP",
       "latlon": [
          19,
          -70.66666666
       ]
   },
   {
       "iso_n3": 12,
       "sovereignt": "Algeria",
       "sov_a3": "DZA",
       "admin": "Algeria",
       "adm0_a3": "DZA",
       "geounit": "Algeria",
       "gu_a3": "DZA",
       "subunit": "Algeria",
       "su_a3": "DZA",
       "name": "Algeria",
       "name_long": "Algeria",
       "brk_a3": "DZA",
       "brk_name": "Algeria",
       "abbrev": "Alg.",
       "postal": "DZ",
       "formal_en": "People's Democratic Republic of Algeria",
       "iso_a2": "DZ",
       "iso_a3": "DZA",
       "un_a3": 12,
       "wb_a2": "DZ",
       "wb_a3": "DZA",
       "adm0_a3_is": "DZA",
       "adm0_a3_us": "DZA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Northern Africa",
       "region_wb": "Middle East & North Africa",
       "currency": "DZD",
       "latlon": [
          28,
          3
       ]
   },
   {
       "iso_n3": 218,
       "sovereignt": "Ecuador",
       "sov_a3": "ECU",
       "admin": "Ecuador",
       "adm0_a3": "ECU",
       "geounit": "Ecuador",
       "gu_a3": "ECU",
       "subunit": "Ecuador",
       "su_a3": "ECU",
       "name": "Ecuador",
       "name_long": "Ecuador",
       "brk_a3": "ECU",
       "brk_name": "Ecuador",
       "abbrev": "Ecu.",
       "postal": "EC",
       "formal_en": "Republic of Ecuador",
       "iso_a2": "EC",
       "iso_a3": "ECU",
       "un_a3": 218,
       "wb_a2": "EC",
       "wb_a3": "ECU",
       "adm0_a3_is": "ECU",
       "adm0_a3_us": "ECU",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "USD_DISABLED",
       "latlon": [
          -2,
          -77.5
       ]
   },
   {
       "iso_n3": 818,
       "sovereignt": "Egypt",
       "sov_a3": "EGY",
       "admin": "Egypt",
       "adm0_a3": "EGY",
       "geounit": "Egypt",
       "gu_a3": "EGY",
       "subunit": "Egypt",
       "su_a3": "EGY",
       "name": "Egypt",
       "name_long": "Egypt",
       "brk_a3": "EGY",
       "brk_name": "Egypt",
       "abbrev": "Egypt",
       "postal": "EG",
       "formal_en": "Arab Republic of Egypt",
       "iso_a2": "EG",
       "iso_a3": "EGY",
       "un_a3": 818,
       "wb_a2": "EG",
       "wb_a3": "EGY",
       "adm0_a3_is": "EGY",
       "adm0_a3_us": "EGY",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Northern Africa",
       "region_wb": "Middle East & North Africa",
       "currency": "EGP",
       "latlon": [
          27,
          30
       ]
   },
   {
       "iso_n3": 232,
       "sovereignt": "Eritrea",
       "sov_a3": "ERI",
       "admin": "Eritrea",
       "adm0_a3": "ERI",
       "geounit": "Eritrea",
       "gu_a3": "ERI",
       "subunit": "Eritrea",
       "su_a3": "ERI",
       "name": "Eritrea",
       "name_long": "Eritrea",
       "brk_a3": "ERI",
       "brk_name": "Eritrea",
       "abbrev": "Erit.",
       "postal": "ER",
       "formal_en": "State of Eritrea",
       "iso_a2": "ER",
       "iso_a3": "ERI",
       "un_a3": 232,
       "wb_a2": "ER",
       "wb_a3": "ERI",
       "adm0_a3_is": "ERI",
       "adm0_a3_us": "ERI",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "ERN",
       "latlon": [
          15,
          39
       ]
   },
   {
       "iso_n3": 732,
       "sovereignt": "Western Sahara",
       "sov_a3": "SAH",
       "admin": "Western Sahara",
       "adm0_a3": "SAH",
       "geounit": "Western Sahara",
       "gu_a3": "SAH",
       "subunit": "Western Sahara",
       "su_a3": "SAH",
       "name": "W. Sahara",
       "name_long": "Western Sahara",
       "brk_a3": "B28",
       "brk_name": "W. Sahara",
       "abbrev": "W. Sah.",
       "postal": "WS",
       "formal_en": "Sahrawi Arab Democratic Republic",
       "iso_a2": "EH",
       "iso_a3": "ESH",
       "un_a3": 732,
       "wb_a2": "-99",
       "wb_a3": "-99",
       "adm0_a3_is": "MAR",
       "adm0_a3_us": "SAH",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Northern Africa",
       "region_wb": "Middle East & North Africa",
       "currency": "MAD",
       "latlon": [
          24.5,
          -13
       ]
   },
   {
       "currency": "EUR",
       "latlon": [
          40,
          -4
       ],
       "iso_n3": 724,
       "sovereignt": "Spain",
       "sov_a3": "ESP",
       "admin": "Spain",
       "adm0_a3": "ESP",
       "geounit": "Spain",
       "gu_a3": "ESP",
       "subunit": "Spain",
       "su_a3": "ESP",
       "name": "Spain",
       "name_long": "Spain",
       "brk_a3": "ESP",
       "brk_name": "Spain",
       "abbrev": "Sp.",
       "postal": "E",
       "formal_en": "Kingdom of Spain",
       "iso_a2": "ES",
       "iso_a3": "ESP",
       "un_a3": 724,
       "wb_a2": "ES",
       "wb_a3": "ESP",
       "adm0_a3_is": "ESP",
       "adm0_a3_us": "ESP",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia"
   },
   {
       "iso_n3": 233,
       "sovereignt": "Estonia",
       "sov_a3": "EST",
       "admin": "Estonia",
       "adm0_a3": "EST",
       "geounit": "Estonia",
       "gu_a3": "EST",
       "subunit": "Estonia",
       "su_a3": "EST",
       "name": "Estonia",
       "name_long": "Estonia",
       "brk_a3": "EST",
       "brk_name": "Estonia",
       "abbrev": "Est.",
       "postal": "EST",
       "formal_en": "Republic of Estonia",
       "iso_a2": "EE",
       "iso_a3": "EST",
       "un_a3": 233,
       "wb_a2": "EE",
       "wb_a3": "EST",
       "adm0_a3_is": "EST",
       "adm0_a3_us": "EST",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          59,
          26
       ]
   },
   {
       "iso_n3": 231,
       "sovereignt": "Ethiopia",
       "sov_a3": "ETH",
       "admin": "Ethiopia",
       "adm0_a3": "ETH",
       "geounit": "Ethiopia",
       "gu_a3": "ETH",
       "subunit": "Ethiopia",
       "su_a3": "ETH",
       "name": "Ethiopia",
       "name_long": "Ethiopia",
       "brk_a3": "ETH",
       "brk_name": "Ethiopia",
       "abbrev": "Eth.",
       "postal": "ET",
       "formal_en": "Federal Democratic Republic of Ethiopia",
       "iso_a2": "ET",
       "iso_a3": "ETH",
       "un_a3": 231,
       "wb_a2": "ET",
       "wb_a3": "ETH",
       "adm0_a3_is": "ETH",
       "adm0_a3_us": "ETH",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "ETB",
       "latlon": [
          8,
          38
       ]
   },
   {
       "iso_n3": 246,
       "sovereignt": "Finland",
       "sov_a3": "FI1",
       "admin": "Finland",
       "adm0_a3": "FIN",
       "geounit": "Finland",
       "gu_a3": "FIN",
       "subunit": "Finland",
       "su_a3": "FIN",
       "name": "Finland",
       "name_long": "Finland",
       "brk_a3": "FIN",
       "brk_name": "Finland",
       "abbrev": "Fin.",
       "postal": "FIN",
       "formal_en": "Republic of Finland",
       "iso_a2": "FI",
       "iso_a3": "FIN",
       "un_a3": 246,
       "wb_a2": "FI",
       "wb_a3": "FIN",
       "adm0_a3_is": "FIN",
       "adm0_a3_us": "FIN",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          64,
          26
       ]
   },
   {
       "iso_n3": 242,
       "sovereignt": "Fiji",
       "sov_a3": "FJI",
       "admin": "Fiji",
       "adm0_a3": "FJI",
       "geounit": "Fiji",
       "gu_a3": "FJI",
       "subunit": "Fiji",
       "su_a3": "FJI",
       "name": "Fiji",
       "name_long": "Fiji",
       "brk_a3": "FJI",
       "brk_name": "Fiji",
       "abbrev": "Fiji",
       "postal": "FJ",
       "formal_en": "Republic of Fiji",
       "iso_a2": "FJ",
       "iso_a3": "FJI",
       "un_a3": 242,
       "wb_a2": "FJ",
       "wb_a3": "FJI",
       "adm0_a3_is": "FJI",
       "adm0_a3_us": "FJI",
       "continent": "Oceania",
       "region_un": "Oceania",
       "subregion": "Melanesia",
       "region_wb": "East Asia & Pacific",
       "currency": "FJD",
       "latlon": [
          -18,
          175
       ]
   },
   {
       "iso_n3": 238,
       "sovereignt": "United Kingdom",
       "sov_a3": "GB1",
       "admin": "Falkland Islands",
       "adm0_a3": "FLK",
       "geounit": "Falkland Islands",
       "gu_a3": "FLK",
       "subunit": "Falkland Islands",
       "su_a3": "FLK",
       "name": "Falkland Is.",
       "name_long": "Falkland Islands",
       "brk_a3": "B12",
       "brk_name": "Falkland Is.",
       "abbrev": "Flk. Is.",
       "postal": "FK",
       "formal_en": "Falkland Islands",
       "iso_a2": "FK",
       "iso_a3": "FLK",
       "un_a3": 238,
       "wb_a2": "-99",
       "wb_a3": "-99",
       "adm0_a3_is": "FLK",
       "adm0_a3_us": "FLK",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "FKP",
       "latlon": [
          -51.75,
          -59
       ]
   },
   {
       "currency": "EUR",
       "latlon": [
          46,
          2
       ],
       "iso_n3": 250,
       "sovereignt": "France",
       "sov_a3": "FR1",
       "admin": "France",
       "adm0_a3": "FRA",
       "geounit": "France",
       "gu_a3": "FRA",
       "subunit": "France",
       "su_a3": "FRA",
       "name": "France",
       "name_long": "France",
       "brk_a3": "FRA",
       "brk_name": "France",
       "abbrev": "Fr.",
       "postal": "F",
       "formal_en": "French Republic",
       "iso_a2": "FR",
       "iso_a3": "FRA",
       "un_a3": 250,
       "wb_a2": "FR",
       "wb_a3": "FRA",
       "adm0_a3_is": "FRA",
       "adm0_a3_us": "FRA",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Western Europe",
       "region_wb": "Europe & Central Asia"
   },
   {
       "iso_n3": 266,
       "sovereignt": "Gabon",
       "sov_a3": "GAB",
       "admin": "Gabon",
       "adm0_a3": "GAB",
       "geounit": "Gabon",
       "gu_a3": "GAB",
       "subunit": "Gabon",
       "su_a3": "GAB",
       "name": "Gabon",
       "name_long": "Gabon",
       "brk_a3": "GAB",
       "brk_name": "Gabon",
       "abbrev": "Gabon",
       "postal": "GA",
       "formal_en": "Gabonese Republic",
       "iso_a2": "GA",
       "iso_a3": "GAB",
       "un_a3": 266,
       "wb_a2": "GA",
       "wb_a3": "GAB",
       "adm0_a3_is": "GAB",
       "adm0_a3_us": "GAB",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XAF",
       "latlon": [
          -1,
          11.75
       ]
   },
   {
       "currency": "GBP",
       "flagHeightMultiplier": 1.1,
       "iso_n3": 826,
       "sovereignt": "United Kingdom",
       "sov_a3": "GB1",
       "admin": "United Kingdom",
       "adm0_a3": "GBR",
       "geounit": "United Kingdom",
       "gu_a3": "GBR",
       "subunit": "United Kingdom",
       "su_a3": "GBR",
       "name": "United Kingdom",
       "name_long": "United Kingdom",
       "brk_a3": "GBR",
       "brk_name": "United Kingdom",
       "abbrev": "U.K.",
       "postal": "GB",
       "formal_en": "United Kingdom of Great Britain and Northern Ireland",
       "iso_a2": "GB",
       "iso_a3": "GBR",
       "un_a3": 826,
       "wb_a2": "GB",
       "wb_a3": "GBR",
       "adm0_a3_is": "GBR",
       "adm0_a3_us": "GBR",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "latlon": [
          54,
          -2
       ]
   },
   {
       "iso_n3": 268,
       "sovereignt": "Georgia",
       "sov_a3": "GEO",
       "admin": "Georgia",
       "adm0_a3": "GEO",
       "geounit": "Georgia",
       "gu_a3": "GEO",
       "subunit": "Georgia",
       "su_a3": "GEO",
       "name": "Georgia",
       "name_long": "Georgia",
       "brk_a3": "GEO",
       "brk_name": "Georgia",
       "abbrev": "Geo.",
       "postal": "GE",
       "formal_en": "Georgia",
       "iso_a2": "GE",
       "iso_a3": "GEO",
       "un_a3": 268,
       "wb_a2": "GE",
       "wb_a3": "GEO",
       "adm0_a3_is": "GEO",
       "adm0_a3_us": "GEO",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "GEL",
       "latlon": [
          42,
          43.5
       ]
   },
   {
       "iso_n3": 288,
       "sovereignt": "Ghana",
       "sov_a3": "GHA",
       "admin": "Ghana",
       "adm0_a3": "GHA",
       "geounit": "Ghana",
       "gu_a3": "GHA",
       "subunit": "Ghana",
       "su_a3": "GHA",
       "name": "Ghana",
       "name_long": "Ghana",
       "brk_a3": "GHA",
       "brk_name": "Ghana",
       "abbrev": "Ghana",
       "postal": "GH",
       "formal_en": "Republic of Ghana",
       "iso_a2": "GH",
       "iso_a3": "GHA",
       "un_a3": 288,
       "wb_a2": "GH",
       "wb_a3": "GHA",
       "adm0_a3_is": "GHA",
       "adm0_a3_us": "GHA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "GHS",
       "latlon": [
          8,
          -2
       ]
   },
   {
       "iso_n3": 324,
       "sovereignt": "Guinea",
       "sov_a3": "GIN",
       "admin": "Guinea",
       "adm0_a3": "GIN",
       "geounit": "Guinea",
       "gu_a3": "GIN",
       "subunit": "Guinea",
       "su_a3": "GIN",
       "name": "Guinea",
       "name_long": "Guinea",
       "brk_a3": "GIN",
       "brk_name": "Guinea",
       "abbrev": "Gin.",
       "postal": "GN",
       "formal_en": "Republic of Guinea",
       "iso_a2": "GN",
       "iso_a3": "GIN",
       "un_a3": 324,
       "wb_a2": "GN",
       "wb_a3": "GIN",
       "adm0_a3_is": "GIN",
       "adm0_a3_us": "GIN",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "GNF",
       "latlon": [
          11,
          -10
       ]
   },
   {
       "iso_n3": 270,
       "sovereignt": "Gambia",
       "sov_a3": "GMB",
       "admin": "Gambia",
       "adm0_a3": "GMB",
       "geounit": "Gambia",
       "gu_a3": "GMB",
       "subunit": "Gambia",
       "su_a3": "GMB",
       "name": "Gambia",
       "name_long": "The Gambia",
       "brk_a3": "GMB",
       "brk_name": "Gambia",
       "abbrev": "Gambia",
       "postal": "GM",
       "formal_en": "Republic of the Gambia",
       "iso_a2": "GM",
       "iso_a3": "GMB",
       "un_a3": 270,
       "wb_a2": "GM",
       "wb_a3": "GMB",
       "adm0_a3_is": "GMB",
       "adm0_a3_us": "GMB",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "GMD",
       "latlon": [
          13.46666666,
          -16.56666666
       ]
   },
   {
       "iso_n3": 624,
       "sovereignt": "Guinea Bissau",
       "sov_a3": "GNB",
       "admin": "Guinea Bissau",
       "adm0_a3": "GNB",
       "geounit": "Guinea Bissau",
       "gu_a3": "GNB",
       "subunit": "Guinea Bissau",
       "su_a3": "GNB",
       "name": "Guinea-Bissau",
       "name_long": "Guinea-Bissau",
       "brk_a3": "GNB",
       "brk_name": "Guinea-Bissau",
       "abbrev": "GnB.",
       "postal": "GW",
       "formal_en": "Republic of Guinea-Bissau",
       "iso_a2": "GW",
       "iso_a3": "GNB",
       "un_a3": 624,
       "wb_a2": "GW",
       "wb_a3": "GNB",
       "adm0_a3_is": "GNB",
       "adm0_a3_us": "GNB",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          12,
          -15
       ]
   },
   {
       "iso_n3": 226,
       "sovereignt": "Equatorial Guinea",
       "sov_a3": "GNQ",
       "admin": "Equatorial Guinea",
       "adm0_a3": "GNQ",
       "geounit": "Equatorial Guinea",
       "gu_a3": "GNQ",
       "subunit": "Equatorial Guinea",
       "su_a3": "GNQ",
       "name": "Eq. Guinea",
       "name_long": "Equatorial Guinea",
       "brk_a3": "GNQ",
       "brk_name": "Eq. Guinea",
       "abbrev": "Eq. G.",
       "postal": "GQ",
       "formal_en": "Republic of Equatorial Guinea",
       "iso_a2": "GQ",
       "iso_a3": "GNQ",
       "un_a3": 226,
       "wb_a2": "GQ",
       "wb_a3": "GNQ",
       "adm0_a3_is": "GNQ",
       "adm0_a3_us": "GNQ",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XAF",
       "latlon": [
          2,
          10
       ]
   },
   {
       "iso_n3": 300,
       "sovereignt": "Greece",
       "sov_a3": "GRC",
       "admin": "Greece",
       "adm0_a3": "GRC",
       "geounit": "Greece",
       "gu_a3": "GRC",
       "subunit": "Greece",
       "su_a3": "GRC",
       "name": "Greece",
       "name_long": "Greece",
       "brk_a3": "GRC",
       "brk_name": "Greece",
       "abbrev": "Greece",
       "postal": "GR",
       "formal_en": "Hellenic Republic",
       "iso_a2": "GR",
       "iso_a3": "GRC",
       "un_a3": 300,
       "wb_a2": "GR",
       "wb_a3": "GRC",
       "adm0_a3_is": "GRC",
       "adm0_a3_us": "GRC",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          39,
          22
       ]
   },
   {
       "iso_n3": 304,
       "sovereignt": "Denmark",
       "sov_a3": "DN1",
       "admin": "Greenland",
       "adm0_a3": "GRL",
       "geounit": "Greenland",
       "gu_a3": "GRL",
       "subunit": "Greenland",
       "su_a3": "GRL",
       "name": "Greenland",
       "name_long": "Greenland",
       "brk_a3": "GRL",
       "brk_name": "Greenland",
       "abbrev": "Grlnd.",
       "postal": "GL",
       "formal_en": "Greenland",
       "iso_a2": "GL",
       "iso_a3": "GRL",
       "un_a3": 304,
       "wb_a2": "GL",
       "wb_a3": "GRL",
       "adm0_a3_is": "GRL",
       "adm0_a3_us": "GRL",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Northern America",
       "region_wb": "Europe & Central Asia",
       "currency": "DKK",
       "latlon": [
          72,
          -40
       ]
   },
   {
       "iso_n3": 320,
       "sovereignt": "Guatemala",
       "sov_a3": "GTM",
       "admin": "Guatemala",
       "adm0_a3": "GTM",
       "geounit": "Guatemala",
       "gu_a3": "GTM",
       "subunit": "Guatemala",
       "su_a3": "GTM",
       "name": "Guatemala",
       "name_long": "Guatemala",
       "brk_a3": "GTM",
       "brk_name": "Guatemala",
       "abbrev": "Guat.",
       "postal": "GT",
       "formal_en": "Republic of Guatemala",
       "iso_a2": "GT",
       "iso_a3": "GTM",
       "un_a3": 320,
       "wb_a2": "GT",
       "wb_a3": "GTM",
       "adm0_a3_is": "GTM",
       "adm0_a3_us": "GTM",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "GTQ",
       "latlon": [
          15.5,
          -90.25
       ]
   },
   {
       "iso_n3": 328,
       "sovereignt": "Guyana",
       "sov_a3": "GUY",
       "admin": "Guyana",
       "adm0_a3": "GUY",
       "geounit": "Guyana",
       "gu_a3": "GUY",
       "subunit": "Guyana",
       "su_a3": "GUY",
       "name": "Guyana",
       "name_long": "Guyana",
       "brk_a3": "GUY",
       "brk_name": "Guyana",
       "abbrev": "Guy.",
       "postal": "GY",
       "formal_en": "Co-operative Republic of Guyana",
       "iso_a2": "GY",
       "iso_a3": "GUY",
       "un_a3": 328,
       "wb_a2": "GY",
       "wb_a3": "GUY",
       "adm0_a3_is": "GUY",
       "adm0_a3_us": "GUY",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "GYD",
       "latlon": [
          5,
          -59
       ]
   },
   {
       "iso_n3": 340,
       "sovereignt": "Honduras",
       "sov_a3": "HND",
       "admin": "Honduras",
       "adm0_a3": "HND",
       "geounit": "Honduras",
       "gu_a3": "HND",
       "subunit": "Honduras",
       "su_a3": "HND",
       "name": "Honduras",
       "name_long": "Honduras",
       "brk_a3": "HND",
       "brk_name": "Honduras",
       "abbrev": "Hond.",
       "postal": "HN",
       "formal_en": "Republic of Honduras",
       "iso_a2": "HN",
       "iso_a3": "HND",
       "un_a3": 340,
       "wb_a2": "HN",
       "wb_a3": "HND",
       "adm0_a3_is": "HND",
       "adm0_a3_us": "HND",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "HNL",
       "latlon": [
          15,
          -86.5
       ]
   },
   {
       "iso_n3": 191,
       "sovereignt": "Croatia",
       "sov_a3": "HRV",
       "admin": "Croatia",
       "adm0_a3": "HRV",
       "geounit": "Croatia",
       "gu_a3": "HRV",
       "subunit": "Croatia",
       "su_a3": "HRV",
       "name": "Croatia",
       "name_long": "Croatia",
       "brk_a3": "HRV",
       "brk_name": "Croatia",
       "abbrev": "Cro.",
       "postal": "HR",
       "formal_en": "Republic of Croatia",
       "iso_a2": "HR",
       "iso_a3": "HRV",
       "un_a3": 191,
       "wb_a2": "HR",
       "wb_a3": "HRV",
       "adm0_a3_is": "HRV",
       "adm0_a3_us": "HRV",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "HRK",
       "latlon": [
          45.16666666,
          15.5
       ]
   },
   {
       "iso_n3": 332,
       "sovereignt": "Haiti",
       "sov_a3": "HTI",
       "admin": "Haiti",
       "adm0_a3": "HTI",
       "geounit": "Haiti",
       "gu_a3": "HTI",
       "subunit": "Haiti",
       "su_a3": "HTI",
       "name": "Haiti",
       "name_long": "Haiti",
       "brk_a3": "HTI",
       "brk_name": "Haiti",
       "abbrev": "Haiti",
       "postal": "HT",
       "formal_en": "Republic of Haiti",
       "iso_a2": "HT",
       "iso_a3": "HTI",
       "un_a3": 332,
       "wb_a2": "HT",
       "wb_a3": "HTI",
       "adm0_a3_is": "HTI",
       "adm0_a3_us": "HTI",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Caribbean",
       "region_wb": "Latin America & Caribbean",
       "currency": "HTG",
       "latlon": [
          19,
          -72.41666666
       ]
   },
   {
       "iso_n3": 348,
       "sovereignt": "Hungary",
       "sov_a3": "HUN",
       "admin": "Hungary",
       "adm0_a3": "HUN",
       "geounit": "Hungary",
       "gu_a3": "HUN",
       "subunit": "Hungary",
       "su_a3": "HUN",
       "name": "Hungary",
       "name_long": "Hungary",
       "brk_a3": "HUN",
       "brk_name": "Hungary",
       "abbrev": "Hun.",
       "postal": "HU",
       "formal_en": "Republic of Hungary",
       "iso_a2": "HU",
       "iso_a3": "HUN",
       "un_a3": 348,
       "wb_a2": "HU",
       "wb_a3": "HUN",
       "adm0_a3_is": "HUN",
       "adm0_a3_us": "HUN",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "HUF",
       "latlon": [
          47,
          20
       ]
   },
   {
       "iso_n3": 360,
       "sovereignt": "Indonesia",
       "sov_a3": "IDN",
       "admin": "Indonesia",
       "adm0_a3": "IDN",
       "geounit": "Indonesia",
       "gu_a3": "IDN",
       "subunit": "Indonesia",
       "su_a3": "IDN",
       "name": "Indonesia",
       "name_long": "Indonesia",
       "brk_a3": "IDN",
       "brk_name": "Indonesia",
       "abbrev": "Indo.",
       "postal": "INDO",
       "formal_en": "Republic of Indonesia",
       "iso_a2": "ID",
       "iso_a3": "IDN",
       "un_a3": 360,
       "wb_a2": "ID",
       "wb_a3": "IDN",
       "adm0_a3_is": "IDN",
       "adm0_a3_us": "IDN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "IDR",
       "latlon": [
          -5,
          120
       ]
   },
   {
       "iso_n3": 356,
       "sovereignt": "India",
       "sov_a3": "IND",
       "admin": "India",
       "adm0_a3": "IND",
       "geounit": "India",
       "gu_a3": "IND",
       "subunit": "India",
       "su_a3": "IND",
       "name": "India",
       "name_long": "India",
       "brk_a3": "IND",
       "brk_name": "India",
       "abbrev": "India",
       "postal": "IND",
       "formal_en": "Republic of India",
       "iso_a2": "IN",
       "iso_a3": "IND",
       "un_a3": 356,
       "wb_a2": "IN",
       "wb_a3": "IND",
       "adm0_a3_is": "IND",
       "adm0_a3_us": "IND",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "South Asia",
       "currency": "INR",
       "flagHeightMultiplier": 0.9,
       "latlon": [
          20,
          77
       ]
   },
   {
       "iso_n3": 372,
       "sovereignt": "Ireland",
       "sov_a3": "IRL",
       "admin": "Ireland",
       "adm0_a3": "IRL",
       "geounit": "Ireland",
       "gu_a3": "IRL",
       "subunit": "Ireland",
       "su_a3": "IRL",
       "name": "Ireland",
       "name_long": "Ireland",
       "brk_a3": "IRL",
       "brk_name": "Ireland",
       "abbrev": "Ire.",
       "postal": "IRL",
       "formal_en": "Ireland",
       "iso_a2": "IE",
       "iso_a3": "IRL",
       "un_a3": 372,
       "wb_a2": "IE",
       "wb_a3": "IRL",
       "adm0_a3_is": "IRL",
       "adm0_a3_us": "IRL",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          53,
          -8
       ]
   },
   {
       "iso_n3": 364,
       "sovereignt": "Iran",
       "sov_a3": "IRN",
       "admin": "Iran",
       "adm0_a3": "IRN",
       "geounit": "Iran",
       "gu_a3": "IRN",
       "subunit": "Iran",
       "su_a3": "IRN",
       "name": "Iran",
       "name_long": "Iran",
       "brk_a3": "IRN",
       "brk_name": "Iran",
       "abbrev": "Iran",
       "postal": "IRN",
       "formal_en": "Islamic Republic of Iran",
       "iso_a2": "IR",
       "iso_a3": "IRN",
       "un_a3": 364,
       "wb_a2": "IR",
       "wb_a3": "IRN",
       "adm0_a3_is": "IRN",
       "adm0_a3_us": "IRN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "IRR",
       "latlon": [
          32,
          53
       ]
   },
   {
       "iso_n3": 368,
       "sovereignt": "Iraq",
       "sov_a3": "IRQ",
       "admin": "Iraq",
       "adm0_a3": "IRQ",
       "geounit": "Iraq",
       "gu_a3": "IRQ",
       "subunit": "Iraq",
       "su_a3": "IRQ",
       "name": "Iraq",
       "name_long": "Iraq",
       "brk_a3": "IRQ",
       "brk_name": "Iraq",
       "abbrev": "Iraq",
       "postal": "IRQ",
       "formal_en": "Republic of Iraq",
       "iso_a2": "IQ",
       "iso_a3": "IRQ",
       "un_a3": 368,
       "wb_a2": "IQ",
       "wb_a3": "IRQ",
       "adm0_a3_is": "IRQ",
       "adm0_a3_us": "IRQ",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "IQD",
       "latlon": [
          33,
          44
       ]
   },
   {
       "iso_n3": 352,
       "sovereignt": "Iceland",
       "sov_a3": "ISL",
       "admin": "Iceland",
       "adm0_a3": "ISL",
       "geounit": "Iceland",
       "gu_a3": "ISL",
       "subunit": "Iceland",
       "su_a3": "ISL",
       "name": "Iceland",
       "name_long": "Iceland",
       "brk_a3": "ISL",
       "brk_name": "Iceland",
       "abbrev": "Iceland",
       "postal": "IS",
       "formal_en": "Republic of Iceland",
       "iso_a2": "IS",
       "iso_a3": "ISL",
       "un_a3": 352,
       "wb_a2": "IS",
       "wb_a3": "ISL",
       "adm0_a3_is": "ISL",
       "adm0_a3_us": "ISL",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "ISK",
       "latlon": [
          65,
          -18
       ]
   },
   {
       "iso_n3": 376,
       "sovereignt": "Israel",
       "sov_a3": "ISR",
       "admin": "Israel",
       "adm0_a3": "ISR",
       "geounit": "Israel",
       "gu_a3": "ISR",
       "subunit": "Israel",
       "su_a3": "ISR",
       "name": "Israel",
       "name_long": "Israel",
       "brk_a3": "ISR",
       "brk_name": "Israel",
       "abbrev": "Isr.",
       "postal": "IS",
       "formal_en": "State of Israel",
       "iso_a2": "IL",
       "iso_a3": "ISR",
       "un_a3": 376,
       "wb_a2": "IL",
       "wb_a3": "ISR",
       "adm0_a3_is": "ISR",
       "adm0_a3_us": "ISR",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "ILS",
       "latlon": [
          31.47,
          35.13
       ]
   },
   {
       "iso_n3": 380,
       "sovereignt": "Italy",
       "sov_a3": "ITA",
       "admin": "Italy",
       "adm0_a3": "ITA",
       "geounit": "Italy",
       "gu_a3": "ITA",
       "subunit": "Italy",
       "su_a3": "ITA",
       "name": "Italy",
       "name_long": "Italy",
       "brk_a3": "ITA",
       "brk_name": "Italy",
       "abbrev": "Italy",
       "postal": "I",
       "formal_en": "Italian Republic",
       "iso_a2": "IT",
       "iso_a3": "ITA",
       "un_a3": 380,
       "wb_a2": "IT",
       "wb_a3": "ITA",
       "adm0_a3_is": "ITA",
       "adm0_a3_us": "ITA",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          42.83333333,
          12.83333333
       ]
   },
   {
       "iso_n3": 388,
       "sovereignt": "Jamaica",
       "sov_a3": "JAM",
       "admin": "Jamaica",
       "adm0_a3": "JAM",
       "geounit": "Jamaica",
       "gu_a3": "JAM",
       "subunit": "Jamaica",
       "su_a3": "JAM",
       "name": "Jamaica",
       "name_long": "Jamaica",
       "brk_a3": "JAM",
       "brk_name": "Jamaica",
       "abbrev": "Jam.",
       "postal": "J",
       "formal_en": "Jamaica",
       "iso_a2": "JM",
       "iso_a3": "JAM",
       "un_a3": 388,
       "wb_a2": "JM",
       "wb_a3": "JAM",
       "adm0_a3_is": "JAM",
       "adm0_a3_us": "JAM",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Caribbean",
       "region_wb": "Latin America & Caribbean",
       "currency": "JMD",
       "latlon": [
          18.25,
          -77.5
       ]
   },
   {
       "iso_n3": 400,
       "sovereignt": "Jordan",
       "sov_a3": "JOR",
       "admin": "Jordan",
       "adm0_a3": "JOR",
       "geounit": "Jordan",
       "gu_a3": "JOR",
       "subunit": "Jordan",
       "su_a3": "JOR",
       "name": "Jordan",
       "name_long": "Jordan",
       "brk_a3": "JOR",
       "brk_name": "Jordan",
       "abbrev": "Jord.",
       "postal": "J",
       "formal_en": "Hashemite Kingdom of Jordan",
       "iso_a2": "JO",
       "iso_a3": "JOR",
       "un_a3": 400,
       "wb_a2": "JO",
       "wb_a3": "JOR",
       "adm0_a3_is": "JOR",
       "adm0_a3_us": "JOR",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "JOD",
       "latlon": [
          31,
          36
       ]
   },
   {
       "iso_n3": 392,
       "sovereignt": "Japan",
       "sov_a3": "JPN",
       "admin": "Japan",
       "adm0_a3": "JPN",
       "geounit": "Japan",
       "gu_a3": "JPN",
       "subunit": "Japan",
       "su_a3": "JPN",
       "name": "Japan",
       "name_long": "Japan",
       "brk_a3": "JPN",
       "brk_name": "Japan",
       "abbrev": "Japan",
       "postal": "J",
       "formal_en": "Japan",
       "iso_a2": "JP",
       "iso_a3": "JPN",
       "un_a3": 392,
       "wb_a2": "JP",
       "wb_a3": "JPN",
       "adm0_a3_is": "JPN",
       "adm0_a3_us": "JPN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "JPY",
       "flagHeightMultiplier": 1.65,
       "latlon": [
          36,
          138
       ]
   },
   {
       "iso_n3": 398,
       "sovereignt": "Kazakhstan",
       "sov_a3": "KAZ",
       "admin": "Kazakhstan",
       "adm0_a3": "KAZ",
       "geounit": "Kazakhstan",
       "gu_a3": "KAZ",
       "subunit": "Kazakhstan",
       "su_a3": "KAZ",
       "name": "Kazakhstan",
       "name_long": "Kazakhstan",
       "brk_a3": "KAZ",
       "brk_name": "Kazakhstan",
       "abbrev": "Kaz.",
       "postal": "KZ",
       "formal_en": "Republic of Kazakhstan",
       "iso_a2": "KZ",
       "iso_a3": "KAZ",
       "un_a3": 398,
       "wb_a2": "KZ",
       "wb_a3": "KAZ",
       "adm0_a3_is": "KAZ",
       "adm0_a3_us": "KAZ",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Central Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "KZT",
       "latlon": [
          48,
          68
       ]
   },
   {
       "iso_n3": 404,
       "sovereignt": "Kenya",
       "sov_a3": "KEN",
       "admin": "Kenya",
       "adm0_a3": "KEN",
       "geounit": "Kenya",
       "gu_a3": "KEN",
       "subunit": "Kenya",
       "su_a3": "KEN",
       "name": "Kenya",
       "name_long": "Kenya",
       "brk_a3": "KEN",
       "brk_name": "Kenya",
       "abbrev": "Ken.",
       "postal": "KE",
       "formal_en": "Republic of Kenya",
       "iso_a2": "KE",
       "iso_a3": "KEN",
       "un_a3": 404,
       "wb_a2": "KE",
       "wb_a3": "KEN",
       "adm0_a3_is": "KEN",
       "adm0_a3_us": "KEN",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "KES",
       "latlon": [
          1,
          38
       ]
   },
   {
       "iso_n3": 417,
       "sovereignt": "Kyrgyzstan",
       "sov_a3": "KGZ",
       "admin": "Kyrgyzstan",
       "adm0_a3": "KGZ",
       "geounit": "Kyrgyzstan",
       "gu_a3": "KGZ",
       "subunit": "Kyrgyzstan",
       "su_a3": "KGZ",
       "name": "Kyrgyzstan",
       "name_long": "Kyrgyzstan",
       "brk_a3": "KGZ",
       "brk_name": "Kyrgyzstan",
       "abbrev": "Kgz.",
       "postal": "KG",
       "formal_en": "Kyrgyz Republic",
       "iso_a2": "KG",
       "iso_a3": "KGZ",
       "un_a3": 417,
       "wb_a2": "KG",
       "wb_a3": "KGZ",
       "adm0_a3_is": "KGZ",
       "adm0_a3_us": "KGZ",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Central Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "KGS",
       "latlon": [
          41,
          75
       ]
   },
   {
       "iso_n3": 116,
       "sovereignt": "Cambodia",
       "sov_a3": "KHM",
       "admin": "Cambodia",
       "adm0_a3": "KHM",
       "geounit": "Cambodia",
       "gu_a3": "KHM",
       "subunit": "Cambodia",
       "su_a3": "KHM",
       "name": "Cambodia",
       "name_long": "Cambodia",
       "brk_a3": "KHM",
       "brk_name": "Cambodia",
       "abbrev": "Camb.",
       "postal": "KH",
       "formal_en": "Kingdom of Cambodia",
       "iso_a2": "KH",
       "iso_a3": "KHM",
       "un_a3": 116,
       "wb_a2": "KH",
       "wb_a3": "KHM",
       "adm0_a3_is": "KHM",
       "adm0_a3_us": "KHM",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "KHR",
       "latlon": [
          13,
          105
       ]
   },
   {
       "iso_n3": 410,
       "sovereignt": "South Korea",
       "sov_a3": "KOR",
       "admin": "South Korea",
       "adm0_a3": "KOR",
       "geounit": "South Korea",
       "gu_a3": "KOR",
       "subunit": "South Korea",
       "su_a3": "KOR",
       "name": "Korea",
       "name_long": "Republic of Korea",
       "brk_a3": "KOR",
       "brk_name": "Republic of Korea",
       "abbrev": "S.K.",
       "postal": "KR",
       "formal_en": "Republic of Korea",
       "iso_a2": "KR",
       "iso_a3": "KOR",
       "un_a3": 410,
       "wb_a2": "KR",
       "wb_a3": "KOR",
       "adm0_a3_is": "KOR",
       "adm0_a3_us": "KOR",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "KRW",
       "latlon": [
          37,
          127.5
       ]
   },
   {
       "iso_n3": 414,
       "sovereignt": "Kuwait",
       "sov_a3": "KWT",
       "admin": "Kuwait",
       "adm0_a3": "KWT",
       "geounit": "Kuwait",
       "gu_a3": "KWT",
       "subunit": "Kuwait",
       "su_a3": "KWT",
       "name": "Kuwait",
       "name_long": "Kuwait",
       "brk_a3": "KWT",
       "brk_name": "Kuwait",
       "abbrev": "Kwt.",
       "postal": "KW",
       "formal_en": "State of Kuwait",
       "iso_a2": "KW",
       "iso_a3": "KWT",
       "un_a3": 414,
       "wb_a2": "KW",
       "wb_a3": "KWT",
       "adm0_a3_is": "KWT",
       "adm0_a3_us": "KWT",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "KWD",
       "latlon": [
          29.5,
          45.75
       ]
   },
   {
       "iso_n3": 418,
       "sovereignt": "Laos",
       "sov_a3": "LAO",
       "admin": "Laos",
       "adm0_a3": "LAO",
       "geounit": "Laos",
       "gu_a3": "LAO",
       "subunit": "Laos",
       "su_a3": "LAO",
       "name": "Lao PDR",
       "name_long": "Lao PDR",
       "brk_a3": "LAO",
       "brk_name": "Laos",
       "abbrev": "Laos",
       "postal": "LA",
       "formal_en": "Lao People's Democratic Republic",
       "iso_a2": "LA",
       "iso_a3": "LAO",
       "un_a3": 418,
       "wb_a2": "LA",
       "wb_a3": "LAO",
       "adm0_a3_is": "LAO",
       "adm0_a3_us": "LAO",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "LAK",
       "latlon": [
          18,
          105
       ]
   },
   {
       "iso_n3": 422,
       "sovereignt": "Lebanon",
       "sov_a3": "LBN",
       "admin": "Lebanon",
       "adm0_a3": "LBN",
       "geounit": "Lebanon",
       "gu_a3": "LBN",
       "subunit": "Lebanon",
       "su_a3": "LBN",
       "name": "Lebanon",
       "name_long": "Lebanon",
       "brk_a3": "LBN",
       "brk_name": "Lebanon",
       "abbrev": "Leb.",
       "postal": "LB",
       "formal_en": "Lebanese Republic",
       "iso_a2": "LB",
       "iso_a3": "LBN",
       "un_a3": 422,
       "wb_a2": "LB",
       "wb_a3": "LBN",
       "adm0_a3_is": "LBN",
       "adm0_a3_us": "LBN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "LBP",
       "latlon": [
          33.83333333,
          35.83333333
       ]
   },
   {
       "iso_n3": 430,
       "sovereignt": "Liberia",
       "sov_a3": "LBR",
       "admin": "Liberia",
       "adm0_a3": "LBR",
       "geounit": "Liberia",
       "gu_a3": "LBR",
       "subunit": "Liberia",
       "su_a3": "LBR",
       "name": "Liberia",
       "name_long": "Liberia",
       "brk_a3": "LBR",
       "brk_name": "Liberia",
       "abbrev": "Liberia",
       "postal": "LR",
       "formal_en": "Republic of Liberia",
       "iso_a2": "LR",
       "iso_a3": "LBR",
       "un_a3": 430,
       "wb_a2": "LR",
       "wb_a3": "LBR",
       "adm0_a3_is": "LBR",
       "adm0_a3_us": "LBR",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "LRD",
       "latlon": [
          6.5,
          -9.5
       ]
   },
   {
       "iso_n3": 434,
       "sovereignt": "Libya",
       "sov_a3": "LBY",
       "admin": "Libya",
       "adm0_a3": "LBY",
       "geounit": "Libya",
       "gu_a3": "LBY",
       "subunit": "Libya",
       "su_a3": "LBY",
       "name": "Libya",
       "name_long": "Libya",
       "brk_a3": "LBY",
       "brk_name": "Libya",
       "abbrev": "Libya",
       "postal": "LY",
       "formal_en": "Libya",
       "iso_a2": "LY",
       "iso_a3": "LBY",
       "un_a3": 434,
       "wb_a2": "LY",
       "wb_a3": "LBY",
       "adm0_a3_is": "LBY",
       "adm0_a3_us": "LBY",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Northern Africa",
       "region_wb": "Middle East & North Africa",
       "currency": "LYD",
       "latlon": [
          25,
          17
       ]
   },
   {
       "iso_n3": 144,
       "sovereignt": "Sri Lanka",
       "sov_a3": "LKA",
       "admin": "Sri Lanka",
       "adm0_a3": "LKA",
       "geounit": "Sri Lanka",
       "gu_a3": "LKA",
       "subunit": "Sri Lanka",
       "su_a3": "LKA",
       "name": "Sri Lanka",
       "name_long": "Sri Lanka",
       "brk_a3": "LKA",
       "brk_name": "Sri Lanka",
       "abbrev": "Sri L.",
       "postal": "LK",
       "formal_en": "Democratic Socialist Republic of Sri Lanka",
       "iso_a2": "LK",
       "iso_a3": "LKA",
       "un_a3": 144,
       "wb_a2": "LK",
       "wb_a3": "LKA",
       "adm0_a3_is": "LKA",
       "adm0_a3_us": "LKA",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "South Asia",
       "currency": "LKR",
       "latlon": [
          7,
          81
       ]
   },
   {
       "iso_n3": 426,
       "sovereignt": "Lesotho",
       "sov_a3": "LSO",
       "admin": "Lesotho",
       "adm0_a3": "LSO",
       "geounit": "Lesotho",
       "gu_a3": "LSO",
       "subunit": "Lesotho",
       "su_a3": "LSO",
       "name": "Lesotho",
       "name_long": "Lesotho",
       "brk_a3": "LSO",
       "brk_name": "Lesotho",
       "abbrev": "Les.",
       "postal": "LS",
       "formal_en": "Kingdom of Lesotho",
       "iso_a2": "LS",
       "iso_a3": "LSO",
       "un_a3": 426,
       "wb_a2": "LS",
       "wb_a3": "LSO",
       "adm0_a3_is": "LSO",
       "adm0_a3_us": "LSO",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Southern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "LSL",
       "latlon": [
          -29.5,
          28.5
       ]
   },
   {
       "iso_n3": 440,
       "sovereignt": "Lithuania",
       "sov_a3": "LTU",
       "admin": "Lithuania",
       "adm0_a3": "LTU",
       "geounit": "Lithuania",
       "gu_a3": "LTU",
       "subunit": "Lithuania",
       "su_a3": "LTU",
       "name": "Lithuania",
       "name_long": "Lithuania",
       "brk_a3": "LTU",
       "brk_name": "Lithuania",
       "abbrev": "Lith.",
       "postal": "LT",
       "formal_en": "Republic of Lithuania",
       "iso_a2": "LT",
       "iso_a3": "LTU",
       "un_a3": 440,
       "wb_a2": "LT",
       "wb_a3": "LTU",
       "adm0_a3_is": "LTU",
       "adm0_a3_us": "LTU",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          56,
          24
       ]
   },
   {
       "iso_n3": 442,
       "sovereignt": "Luxembourg",
       "sov_a3": "LUX",
       "admin": "Luxembourg",
       "adm0_a3": "LUX",
       "geounit": "Luxembourg",
       "gu_a3": "LUX",
       "subunit": "Luxembourg",
       "su_a3": "LUX",
       "name": "Luxembourg",
       "name_long": "Luxembourg",
       "brk_a3": "LUX",
       "brk_name": "Luxembourg",
       "abbrev": "Lux.",
       "postal": "L",
       "formal_en": "Grand Duchy of Luxembourg",
       "iso_a2": "LU",
       "iso_a3": "LUX",
       "un_a3": 442,
       "wb_a2": "LU",
       "wb_a3": "LUX",
       "adm0_a3_is": "LUX",
       "adm0_a3_us": "LUX",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Western Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          49.75,
          6.16666666
       ]
   },
   {
       "iso_n3": 428,
       "sovereignt": "Latvia",
       "sov_a3": "LVA",
       "admin": "Latvia",
       "adm0_a3": "LVA",
       "geounit": "Latvia",
       "gu_a3": "LVA",
       "subunit": "Latvia",
       "su_a3": "LVA",
       "name": "Latvia",
       "name_long": "Latvia",
       "brk_a3": "LVA",
       "brk_name": "Latvia",
       "abbrev": "Lat.",
       "postal": "LV",
       "formal_en": "Republic of Latvia",
       "iso_a2": "LV",
       "iso_a3": "LVA",
       "un_a3": 428,
       "wb_a2": "LV",
       "wb_a3": "LVA",
       "adm0_a3_is": "LVA",
       "adm0_a3_us": "LVA",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          57,
          25
       ]
   },
   {
       "iso_n3": 504,
       "sovereignt": "Morocco",
       "sov_a3": "MAR",
       "admin": "Morocco",
       "adm0_a3": "MAR",
       "geounit": "Morocco",
       "gu_a3": "MAR",
       "subunit": "Morocco",
       "su_a3": "MAR",
       "name": "Morocco",
       "name_long": "Morocco",
       "brk_a3": "MAR",
       "brk_name": "Morocco",
       "abbrev": "Mor.",
       "postal": "MA",
       "formal_en": "Kingdom of Morocco",
       "iso_a2": "MA",
       "iso_a3": "MAR",
       "un_a3": 504,
       "wb_a2": "MA",
       "wb_a3": "MAR",
       "adm0_a3_is": "MAR",
       "adm0_a3_us": "MAR",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Northern Africa",
       "region_wb": "Middle East & North Africa",
       "currency": "MAD",
       "latlon": [
          32,
          -5
       ]
   },
   {
       "iso_n3": 498,
       "sovereignt": "Moldova",
       "sov_a3": "MDA",
       "admin": "Moldova",
       "adm0_a3": "MDA",
       "geounit": "Moldova",
       "gu_a3": "MDA",
       "subunit": "Moldova",
       "su_a3": "MDA",
       "name": "Moldova",
       "name_long": "Moldova",
       "brk_a3": "MDA",
       "brk_name": "Moldova",
       "abbrev": "Mda.",
       "postal": "MD",
       "formal_en": "Republic of Moldova",
       "iso_a2": "MD",
       "iso_a3": "MDA",
       "un_a3": 498,
       "wb_a2": "MD",
       "wb_a3": "MDA",
       "adm0_a3_is": "MDA",
       "adm0_a3_us": "MDA",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "MDL",
       "latlon": [
          47,
          29
       ]
   },
   {
       "iso_n3": 450,
       "sovereignt": "Madagascar",
       "sov_a3": "MDG",
       "admin": "Madagascar",
       "adm0_a3": "MDG",
       "geounit": "Madagascar",
       "gu_a3": "MDG",
       "subunit": "Madagascar",
       "su_a3": "MDG",
       "name": "Madagascar",
       "name_long": "Madagascar",
       "brk_a3": "MDG",
       "brk_name": "Madagascar",
       "abbrev": "Mad.",
       "postal": "MG",
       "formal_en": "Republic of Madagascar",
       "iso_a2": "MG",
       "iso_a3": "MDG",
       "un_a3": 450,
       "wb_a2": "MG",
       "wb_a3": "MDG",
       "adm0_a3_is": "MDG",
       "adm0_a3_us": "MDG",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "MGA",
       "latlon": [
          -20,
          47
       ]
   },
   {
       "iso_n3": 484,
       "sovereignt": "Mexico",
       "sov_a3": "MEX",
       "admin": "Mexico",
       "adm0_a3": "MEX",
       "geounit": "Mexico",
       "gu_a3": "MEX",
       "subunit": "Mexico",
       "su_a3": "MEX",
       "name": "Mexico",
       "name_long": "Mexico",
       "brk_a3": "MEX",
       "brk_name": "Mexico",
       "abbrev": "Mex.",
       "postal": "MX",
       "formal_en": "United Mexican States",
       "iso_a2": "MX",
       "iso_a3": "MEX",
       "un_a3": 484,
       "wb_a2": "MX",
       "wb_a3": "MEX",
       "adm0_a3_is": "MEX",
       "adm0_a3_us": "MEX",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "MXN",
       "latlon": [
          23,
          -102
       ]
   },
   {
       "iso_n3": 807,
       "sovereignt": "Macedonia",
       "sov_a3": "MKD",
       "admin": "Macedonia",
       "adm0_a3": "MKD",
       "geounit": "Macedonia",
       "gu_a3": "MKD",
       "subunit": "Macedonia",
       "su_a3": "MKD",
       "name": "Macedonia",
       "name_long": "Macedonia",
       "brk_a3": "MKD",
       "brk_name": "Macedonia",
       "abbrev": "Mkd.",
       "postal": "MK",
       "formal_en": "Former Yugoslav Republic of Macedonia",
       "iso_a2": "MK",
       "iso_a3": "MKD",
       "un_a3": 807,
       "wb_a2": "MK",
       "wb_a3": "MKD",
       "adm0_a3_is": "MKD",
       "adm0_a3_us": "MKD",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "MKD",
       "latlon": [
          41.83333333,
          22
       ]
   },
   {
       "iso_n3": 466,
       "sovereignt": "Mali",
       "sov_a3": "MLI",
       "admin": "Mali",
       "adm0_a3": "MLI",
       "geounit": "Mali",
       "gu_a3": "MLI",
       "subunit": "Mali",
       "su_a3": "MLI",
       "name": "Mali",
       "name_long": "Mali",
       "brk_a3": "MLI",
       "brk_name": "Mali",
       "abbrev": "Mali",
       "postal": "ML",
       "formal_en": "Republic of Mali",
       "iso_a2": "ML",
       "iso_a3": "MLI",
       "un_a3": 466,
       "wb_a2": "ML",
       "wb_a3": "MLI",
       "adm0_a3_is": "MLI",
       "adm0_a3_us": "MLI",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          17,
          -4
       ]
   },
   {
       "iso_n3": 104,
       "sovereignt": "Myanmar",
       "sov_a3": "MMR",
       "admin": "Myanmar",
       "adm0_a3": "MMR",
       "geounit": "Myanmar",
       "gu_a3": "MMR",
       "subunit": "Myanmar",
       "su_a3": "MMR",
       "name": "Myanmar",
       "name_long": "Myanmar",
       "brk_a3": "MMR",
       "brk_name": "Myanmar",
       "abbrev": "Myan.",
       "postal": "MM",
       "formal_en": "Republic of the Union of Myanmar",
       "iso_a2": "MM",
       "iso_a3": "MMR",
       "un_a3": 104,
       "wb_a2": "MM",
       "wb_a3": "MMR",
       "adm0_a3_is": "MMR",
       "adm0_a3_us": "MMR",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "MMK",
       "latlon": [
          22,
          98
       ]
   },
   {
       "iso_n3": 499,
       "sovereignt": "Montenegro",
       "sov_a3": "MNE",
       "admin": "Montenegro",
       "adm0_a3": "MNE",
       "geounit": "Montenegro",
       "gu_a3": "MNE",
       "subunit": "Montenegro",
       "su_a3": "MNE",
       "name": "Montenegro",
       "name_long": "Montenegro",
       "brk_a3": "MNE",
       "brk_name": "Montenegro",
       "abbrev": "Mont.",
       "postal": "ME",
       "formal_en": "Montenegro",
       "iso_a2": "ME",
       "iso_a3": "MNE",
       "un_a3": 499,
       "wb_a2": "ME",
       "wb_a3": "MNE",
       "adm0_a3_is": "MNE",
       "adm0_a3_us": "MNE",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          42.5,
          19.3
       ]
   },
   {
       "iso_n3": 496,
       "sovereignt": "Mongolia",
       "sov_a3": "MNG",
       "admin": "Mongolia",
       "adm0_a3": "MNG",
       "geounit": "Mongolia",
       "gu_a3": "MNG",
       "subunit": "Mongolia",
       "su_a3": "MNG",
       "name": "Mongolia",
       "name_long": "Mongolia",
       "brk_a3": "MNG",
       "brk_name": "Mongolia",
       "abbrev": "Mong.",
       "postal": "MN",
       "formal_en": "Mongolia",
       "iso_a2": "MN",
       "iso_a3": "MNG",
       "un_a3": 496,
       "wb_a2": "MN",
       "wb_a3": "MNG",
       "adm0_a3_is": "MNG",
       "adm0_a3_us": "MNG",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "MNT",
       "latlon": [
          46,
          105
       ]
   },
   {
       "iso_n3": 508,
       "sovereignt": "Mozambique",
       "sov_a3": "MOZ",
       "admin": "Mozambique",
       "adm0_a3": "MOZ",
       "geounit": "Mozambique",
       "gu_a3": "MOZ",
       "subunit": "Mozambique",
       "su_a3": "MOZ",
       "name": "Mozambique",
       "name_long": "Mozambique",
       "brk_a3": "MOZ",
       "brk_name": "Mozambique",
       "abbrev": "Moz.",
       "postal": "MZ",
       "formal_en": "Republic of Mozambique",
       "iso_a2": "MZ",
       "iso_a3": "MOZ",
       "un_a3": 508,
       "wb_a2": "MZ",
       "wb_a3": "MOZ",
       "adm0_a3_is": "MOZ",
       "adm0_a3_us": "MOZ",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "MZN",
       "latlon": [
          -18.25,
          35
       ]
   },
   {
       "iso_n3": 478,
       "sovereignt": "Mauritania",
       "sov_a3": "MRT",
       "admin": "Mauritania",
       "adm0_a3": "MRT",
       "geounit": "Mauritania",
       "gu_a3": "MRT",
       "subunit": "Mauritania",
       "su_a3": "MRT",
       "name": "Mauritania",
       "name_long": "Mauritania",
       "brk_a3": "MRT",
       "brk_name": "Mauritania",
       "abbrev": "Mrt.",
       "postal": "MR",
       "formal_en": "Islamic Republic of Mauritania",
       "iso_a2": "MR",
       "iso_a3": "MRT",
       "un_a3": 478,
       "wb_a2": "MR",
       "wb_a3": "MRT",
       "adm0_a3_is": "MRT",
       "adm0_a3_us": "MRT",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "MRU",
       "latlon": [
          20,
          -12
       ]
   },
   {
       "iso_n3": 454,
       "sovereignt": "Malawi",
       "sov_a3": "MWI",
       "admin": "Malawi",
       "adm0_a3": "MWI",
       "geounit": "Malawi",
       "gu_a3": "MWI",
       "subunit": "Malawi",
       "su_a3": "MWI",
       "name": "Malawi",
       "name_long": "Malawi",
       "brk_a3": "MWI",
       "brk_name": "Malawi",
       "abbrev": "Mal.",
       "postal": "MW",
       "formal_en": "Republic of Malawi",
       "iso_a2": "MW",
       "iso_a3": "MWI",
       "un_a3": 454,
       "wb_a2": "MW",
       "wb_a3": "MWI",
       "adm0_a3_is": "MWI",
       "adm0_a3_us": "MWI",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "MWK",
       "latlon": [
          -13.5,
          34
       ]
   },
   {
       "iso_n3": 458,
       "sovereignt": "Malaysia",
       "sov_a3": "MYS",
       "admin": "Malaysia",
       "adm0_a3": "MYS",
       "geounit": "Malaysia",
       "gu_a3": "MYS",
       "subunit": "Malaysia",
       "su_a3": "MYS",
       "name": "Malaysia",
       "name_long": "Malaysia",
       "brk_a3": "MYS",
       "brk_name": "Malaysia",
       "abbrev": "Malay.",
       "postal": "MY",
       "formal_en": "Malaysia",
       "iso_a2": "MY",
       "iso_a3": "MYS",
       "un_a3": 458,
       "wb_a2": "MY",
       "wb_a3": "MYS",
       "adm0_a3_is": "MYS",
       "adm0_a3_us": "MYS",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "MYR",
       "latlon": [
          2.5,
          112.5
       ]
   },
   {
       "iso_n3": 516,
       "sovereignt": "Namibia",
       "sov_a3": "NAM",
       "admin": "Namibia",
       "adm0_a3": "NAM",
       "geounit": "Namibia",
       "gu_a3": "NAM",
       "subunit": "Namibia",
       "su_a3": "NAM",
       "name": "Namibia",
       "name_long": "Namibia",
       "brk_a3": "NAM",
       "brk_name": "Namibia",
       "abbrev": "Nam.",
       "postal": "NA",
       "formal_en": "Republic of Namibia",
       "iso_a2": "NA",
       "iso_a3": "NAM",
       "un_a3": 516,
       "wb_a2": "NA",
       "wb_a3": "NAM",
       "adm0_a3_is": "NAM",
       "adm0_a3_us": "NAM",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Southern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "NAD",
       "latlon": [
          -22,
          17
       ]
   },
   {
       "iso_n3": 540,
       "sovereignt": "France",
       "sov_a3": "FR1",
       "admin": "New Caledonia",
       "adm0_a3": "NCL",
       "geounit": "New Caledonia",
       "gu_a3": "NCL",
       "subunit": "New Caledonia",
       "su_a3": "NCL",
       "name": "New Caledonia",
       "name_long": "New Caledonia",
       "brk_a3": "NCL",
       "brk_name": "New Caledonia",
       "abbrev": "New C.",
       "postal": "NC",
       "formal_en": "New Caledonia",
       "iso_a2": "NC",
       "iso_a3": "NCL",
       "un_a3": 540,
       "wb_a2": "NC",
       "wb_a3": "NCL",
       "adm0_a3_is": "NCL",
       "adm0_a3_us": "NCL",
       "continent": "Oceania",
       "region_un": "Oceania",
       "subregion": "Melanesia",
       "region_wb": "East Asia & Pacific",
       "currency": "XPF",
       "latlon": [
          -21.5,
          165.5
       ]
   },
   {
       "iso_n3": 562,
       "sovereignt": "Niger",
       "sov_a3": "NER",
       "admin": "Niger",
       "adm0_a3": "NER",
       "geounit": "Niger",
       "gu_a3": "NER",
       "subunit": "Niger",
       "su_a3": "NER",
       "name": "Niger",
       "name_long": "Niger",
       "brk_a3": "NER",
       "brk_name": "Niger",
       "abbrev": "Niger",
       "postal": "NE",
       "formal_en": "Republic of Niger",
       "iso_a2": "NE",
       "iso_a3": "NER",
       "un_a3": 562,
       "wb_a2": "NE",
       "wb_a3": "NER",
       "adm0_a3_is": "NER",
       "adm0_a3_us": "NER",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          16,
          8
       ]
   },
   {
       "iso_n3": 566,
       "sovereignt": "Nigeria",
       "sov_a3": "NGA",
       "admin": "Nigeria",
       "adm0_a3": "NGA",
       "geounit": "Nigeria",
       "gu_a3": "NGA",
       "subunit": "Nigeria",
       "su_a3": "NGA",
       "name": "Nigeria",
       "name_long": "Nigeria",
       "brk_a3": "NGA",
       "brk_name": "Nigeria",
       "abbrev": "Nigeria",
       "postal": "NG",
       "formal_en": "Federal Republic of Nigeria",
       "iso_a2": "NG",
       "iso_a3": "NGA",
       "un_a3": 566,
       "wb_a2": "NG",
       "wb_a3": "NGA",
       "adm0_a3_is": "NGA",
       "adm0_a3_us": "NGA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "NGN",
       "latlon": [
          10,
          8
       ]
   },
   {
       "iso_n3": 558,
       "sovereignt": "Nicaragua",
       "sov_a3": "NIC",
       "admin": "Nicaragua",
       "adm0_a3": "NIC",
       "geounit": "Nicaragua",
       "gu_a3": "NIC",
       "subunit": "Nicaragua",
       "su_a3": "NIC",
       "name": "Nicaragua",
       "name_long": "Nicaragua",
       "brk_a3": "NIC",
       "brk_name": "Nicaragua",
       "abbrev": "Nic.",
       "postal": "NI",
       "formal_en": "Republic of Nicaragua",
       "iso_a2": "NI",
       "iso_a3": "NIC",
       "un_a3": 558,
       "wb_a2": "NI",
       "wb_a3": "NIC",
       "adm0_a3_is": "NIC",
       "adm0_a3_us": "NIC",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "NIO",
       "latlon": [
          13,
          -85
       ]
   },
   {
       "iso_n3": 528,
       "sovereignt": "Netherlands",
       "sov_a3": "NL1",
       "admin": "Netherlands",
       "adm0_a3": "NLD",
       "geounit": "Netherlands",
       "gu_a3": "NLD",
       "subunit": "Netherlands",
       "su_a3": "NLD",
       "name": "Netherlands",
       "name_long": "Netherlands",
       "brk_a3": "NLD",
       "brk_name": "Netherlands",
       "abbrev": "Neth.",
       "postal": "NL",
       "formal_en": "Kingdom of the Netherlands",
       "iso_a2": "NL",
       "iso_a3": "NLD",
       "un_a3": 528,
       "wb_a2": "NL",
       "wb_a3": "NLD",
       "adm0_a3_is": "NLD",
       "adm0_a3_us": "NLD",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Western Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          52.5,
          5.75
       ]
   },
   {
       "iso_n3": 578,
       "sovereignt": "Norway",
       "sov_a3": "NOR",
       "admin": "Norway",
       "adm0_a3": "NOR",
       "geounit": "Norway",
       "gu_a3": "NOR",
       "subunit": "Norway",
       "su_a3": "NOR",
       "name": "Norway",
       "name_long": "Norway",
       "brk_a3": "NOR",
       "brk_name": "Norway",
       "abbrev": "Nor.",
       "postal": "N",
       "formal_en": "Kingdom of Norway",
       "iso_a2": "NO",
       "iso_a3": "NOR",
       "un_a3": 578,
       "wb_a2": "NO",
       "wb_a3": "NOR",
       "adm0_a3_is": "NOR",
       "adm0_a3_us": "NOR",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "NOK",
       "latlon": [
          62,
          10
       ]
   },
   {
       "iso_n3": 524,
       "sovereignt": "Nepal",
       "sov_a3": "NPL",
       "admin": "Nepal",
       "adm0_a3": "NPL",
       "geounit": "Nepal",
       "gu_a3": "NPL",
       "subunit": "Nepal",
       "su_a3": "NPL",
       "name": "Nepal",
       "name_long": "Nepal",
       "brk_a3": "NPL",
       "brk_name": "Nepal",
       "abbrev": "Nepal",
       "postal": "NP",
       "formal_en": "Nepal",
       "iso_a2": "NP",
       "iso_a3": "NPL",
       "un_a3": 524,
       "wb_a2": "NP",
       "wb_a3": "NPL",
       "adm0_a3_is": "NPL",
       "adm0_a3_us": "NPL",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "South Asia",
       "currency": "NPR",
       "latlon": [
          28,
          84
       ]
   },
   {
       "iso_n3": 554,
       "sovereignt": "New Zealand",
       "sov_a3": "NZ1",
       "admin": "New Zealand",
       "adm0_a3": "NZL",
       "geounit": "New Zealand",
       "gu_a3": "NZL",
       "subunit": "New Zealand",
       "su_a3": "NZL",
       "name": "New Zealand",
       "name_long": "New Zealand",
       "brk_a3": "NZL",
       "brk_name": "New Zealand",
       "abbrev": "N.Z.",
       "postal": "NZ",
       "formal_en": "New Zealand",
       "iso_a2": "NZ",
       "iso_a3": "NZL",
       "un_a3": 554,
       "wb_a2": "NZ",
       "wb_a3": "NZL",
       "adm0_a3_is": "NZL",
       "adm0_a3_us": "NZL",
       "continent": "Oceania",
       "region_un": "Oceania",
       "subregion": "Australia and New Zealand",
       "region_wb": "East Asia & Pacific",
       "currency": "NZD",
       "latlon": [
          -41,
          174
       ]
   },
   {
       "iso_n3": 512,
       "sovereignt": "Oman",
       "sov_a3": "OMN",
       "admin": "Oman",
       "adm0_a3": "OMN",
       "geounit": "Oman",
       "gu_a3": "OMN",
       "subunit": "Oman",
       "su_a3": "OMN",
       "name": "Oman",
       "name_long": "Oman",
       "brk_a3": "OMN",
       "brk_name": "Oman",
       "abbrev": "Oman",
       "postal": "OM",
       "formal_en": "Sultanate of Oman",
       "iso_a2": "OM",
       "iso_a3": "OMN",
       "un_a3": 512,
       "wb_a2": "OM",
       "wb_a3": "OMN",
       "adm0_a3_is": "OMN",
       "adm0_a3_us": "OMN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "OMR",
       "latlon": [
          21,
          57
       ]
   },
   {
       "iso_n3": 586,
       "sovereignt": "Pakistan",
       "sov_a3": "PAK",
       "admin": "Pakistan",
       "adm0_a3": "PAK",
       "geounit": "Pakistan",
       "gu_a3": "PAK",
       "subunit": "Pakistan",
       "su_a3": "PAK",
       "name": "Pakistan",
       "name_long": "Pakistan",
       "brk_a3": "PAK",
       "brk_name": "Pakistan",
       "abbrev": "Pak.",
       "postal": "PK",
       "formal_en": "Islamic Republic of Pakistan",
       "iso_a2": "PK",
       "iso_a3": "PAK",
       "un_a3": 586,
       "wb_a2": "PK",
       "wb_a3": "PAK",
       "adm0_a3_is": "PAK",
       "adm0_a3_us": "PAK",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Southern Asia",
       "region_wb": "South Asia",
       "currency": "PKR",
       "latlon": [
          30,
          70
       ]
   },
   {
       "iso_n3": 591,
       "sovereignt": "Panama",
       "sov_a3": "PAN",
       "admin": "Panama",
       "adm0_a3": "PAN",
       "geounit": "Panama",
       "gu_a3": "PAN",
       "subunit": "Panama",
       "su_a3": "PAN",
       "name": "Panama",
       "name_long": "Panama",
       "brk_a3": "PAN",
       "brk_name": "Panama",
       "abbrev": "Pan.",
       "postal": "PA",
       "formal_en": "Republic of Panama",
       "iso_a2": "PA",
       "iso_a3": "PAN",
       "un_a3": 591,
       "wb_a2": "PA",
       "wb_a3": "PAN",
       "adm0_a3_is": "PAN",
       "adm0_a3_us": "PAN",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "PAB",
       "latlon": [
          9,
          -80
       ]
   },
   {
       "iso_n3": 604,
       "sovereignt": "Peru",
       "sov_a3": "PER",
       "admin": "Peru",
       "adm0_a3": "PER",
       "geounit": "Peru",
       "gu_a3": "PER",
       "subunit": "Peru",
       "su_a3": "PER",
       "name": "Peru",
       "name_long": "Peru",
       "brk_a3": "PER",
       "brk_name": "Peru",
       "abbrev": "Peru",
       "postal": "PE",
       "formal_en": "Republic of Peru",
       "iso_a2": "PE",
       "iso_a3": "PER",
       "un_a3": 604,
       "wb_a2": "PE",
       "wb_a3": "PER",
       "adm0_a3_is": "PER",
       "adm0_a3_us": "PER",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "PEN",
       "latlon": [
          -10,
          -76
       ]
   },
   {
       "iso_n3": 608,
       "sovereignt": "Philippines",
       "sov_a3": "PHL",
       "admin": "Philippines",
       "adm0_a3": "PHL",
       "geounit": "Philippines",
       "gu_a3": "PHL",
       "subunit": "Philippines",
       "su_a3": "PHL",
       "name": "Philippines",
       "name_long": "Philippines",
       "brk_a3": "PHL",
       "brk_name": "Philippines",
       "abbrev": "Phil.",
       "postal": "PH",
       "formal_en": "Republic of the Philippines",
       "iso_a2": "PH",
       "iso_a3": "PHL",
       "un_a3": 608,
       "wb_a2": "PH",
       "wb_a3": "PHL",
       "adm0_a3_is": "PHL",
       "adm0_a3_us": "PHL",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "PHP",
       "latlon": [
          13,
          122
       ]
   },
   {
       "iso_n3": 598,
       "sovereignt": "Papua New Guinea",
       "sov_a3": "PNG",
       "admin": "Papua New Guinea",
       "adm0_a3": "PNG",
       "geounit": "Papua New Guinea",
       "gu_a3": "PNG",
       "subunit": "Papua New Guinea",
       "su_a3": "PN1",
       "name": "Papua New Guinea",
       "name_long": "Papua New Guinea",
       "brk_a3": "PN1",
       "brk_name": "Papua New Guinea",
       "abbrev": "P.N.G.",
       "postal": "PG",
       "formal_en": "Independent State of Papua New Guinea",
       "iso_a2": "PG",
       "iso_a3": "PNG",
       "un_a3": 598,
       "wb_a2": "PG",
       "wb_a3": "PNG",
       "adm0_a3_is": "PNG",
       "adm0_a3_us": "PNG",
       "continent": "Oceania",
       "region_un": "Oceania",
       "subregion": "Melanesia",
       "region_wb": "East Asia & Pacific",
       "currency": "PGK",
       "latlon": [
          -6,
          147
       ]
   },
   {
       "iso_n3": 616,
       "sovereignt": "Poland",
       "sov_a3": "POL",
       "admin": "Poland",
       "adm0_a3": "POL",
       "geounit": "Poland",
       "gu_a3": "POL",
       "subunit": "Poland",
       "su_a3": "POL",
       "name": "Poland",
       "name_long": "Poland",
       "brk_a3": "POL",
       "brk_name": "Poland",
       "abbrev": "Pol.",
       "postal": "PL",
       "formal_en": "Republic of Poland",
       "iso_a2": "PL",
       "iso_a3": "POL",
       "un_a3": 616,
       "wb_a2": "PL",
       "wb_a3": "POL",
       "adm0_a3_is": "POL",
       "adm0_a3_us": "POL",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "PLN",
       "latlon": [
          52,
          20
       ]
   },
   {
       "iso_n3": 630,
       "sovereignt": "United States of America",
       "sov_a3": "US1",
       "admin": "Puerto Rico",
       "adm0_a3": "PRI",
       "geounit": "Puerto Rico",
       "gu_a3": "PRI",
       "subunit": "Puerto Rico",
       "su_a3": "PRI",
       "name": "Puerto Rico",
       "name_long": "Puerto Rico",
       "brk_a3": "PRI",
       "brk_name": "Puerto Rico",
       "abbrev": "P.R.",
       "postal": "PR",
       "formal_en": "Commonwealth of Puerto Rico",
       "iso_a2": "PR",
       "iso_a3": "PRI",
       "un_a3": 630,
       "wb_a2": "PR",
       "wb_a3": "PRI",
       "adm0_a3_is": "PRI",
       "adm0_a3_us": "PRI",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Caribbean",
       "region_wb": "Latin America & Caribbean",
       "currency": "USD_DISABLED",
       "latlon": [
          18.25,
          -66.5
       ]
   },
   {
       "iso_n3": 408,
       "sovereignt": "North Korea",
       "sov_a3": "PRK",
       "admin": "North Korea",
       "adm0_a3": "PRK",
       "geounit": "North Korea",
       "gu_a3": "PRK",
       "subunit": "North Korea",
       "su_a3": "PRK",
       "name": "Dem. Rep. Korea",
       "name_long": "Dem. Rep. Korea",
       "brk_a3": "PRK",
       "brk_name": "Dem. Rep. Korea",
       "abbrev": "N.K.",
       "postal": "KP",
       "formal_en": "Democratic People's Republic of Korea",
       "iso_a2": "KP",
       "iso_a3": "PRK",
       "un_a3": 408,
       "wb_a2": "KP",
       "wb_a3": "PRK",
       "adm0_a3_is": "PRK",
       "adm0_a3_us": "PRK",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "KPW",
       "latlon": [
          40,
          127
       ]
   },
   {
       "iso_n3": 620,
       "sovereignt": "Portugal",
       "sov_a3": "PRT",
       "admin": "Portugal",
       "adm0_a3": "PRT",
       "geounit": "Portugal",
       "gu_a3": "PRT",
       "subunit": "Portugal",
       "su_a3": "PR1",
       "name": "Portugal",
       "name_long": "Portugal",
       "brk_a3": "PR1",
       "brk_name": "Portugal",
       "abbrev": "Port.",
       "postal": "P",
       "formal_en": "Portuguese Republic",
       "iso_a2": "PT",
       "iso_a3": "PRT",
       "un_a3": 620,
       "wb_a2": "PT",
       "wb_a3": "PRT",
       "adm0_a3_is": "PRT",
       "adm0_a3_us": "PRT",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          39.5,
          -8
       ]
   },
   {
       "iso_n3": 600,
       "sovereignt": "Paraguay",
       "sov_a3": "PRY",
       "admin": "Paraguay",
       "adm0_a3": "PRY",
       "geounit": "Paraguay",
       "gu_a3": "PRY",
       "subunit": "Paraguay",
       "su_a3": "PRY",
       "name": "Paraguay",
       "name_long": "Paraguay",
       "brk_a3": "PRY",
       "brk_name": "Paraguay",
       "abbrev": "Para.",
       "postal": "PY",
       "formal_en": "Republic of Paraguay",
       "iso_a2": "PY",
       "iso_a3": "PRY",
       "un_a3": 600,
       "wb_a2": "PY",
       "wb_a3": "PRY",
       "adm0_a3_is": "PRY",
       "adm0_a3_us": "PRY",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "PYG",
       "latlon": [
          -23,
          -58
       ]
   },
   {
       "iso_n3": 275,
       "sovereignt": "Israel",
       "sov_a3": "ISR",
       "admin": "Palestine",
       "adm0_a3": "PSX",
       "geounit": "Palestine",
       "gu_a3": "PSX",
       "subunit": "Palestine",
       "su_a3": "PSX",
       "name": "Palestine",
       "name_long": "Palestine",
       "brk_a3": "PSX",
       "brk_name": "Palestine",
       "abbrev": "Pal.",
       "postal": "PAL",
       "formal_en": "West Bank and Gaza",
       "iso_a2": "PS",
       "iso_a3": "PSE",
       "un_a3": 275,
       "wb_a2": "GZ",
       "wb_a3": "WBG",
       "adm0_a3_is": "PSE",
       "adm0_a3_us": "PSX",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "ILS",
       "latlon": [
          31.9,
          35.2
       ]
   },
   {
       "iso_n3": 634,
       "sovereignt": "Qatar",
       "sov_a3": "QAT",
       "admin": "Qatar",
       "adm0_a3": "QAT",
       "geounit": "Qatar",
       "gu_a3": "QAT",
       "subunit": "Qatar",
       "su_a3": "QAT",
       "name": "Qatar",
       "name_long": "Qatar",
       "brk_a3": "QAT",
       "brk_name": "Qatar",
       "abbrev": "Qatar",
       "postal": "QA",
       "formal_en": "State of Qatar",
       "iso_a2": "QA",
       "iso_a3": "QAT",
       "un_a3": 634,
       "wb_a2": "QA",
       "wb_a3": "QAT",
       "adm0_a3_is": "QAT",
       "adm0_a3_us": "QAT",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "QAR",
       "latlon": [
          25.5,
          51.25
       ]
   },
   {
       "iso_n3": 642,
       "sovereignt": "Romania",
       "sov_a3": "ROU",
       "admin": "Romania",
       "adm0_a3": "ROU",
       "geounit": "Romania",
       "gu_a3": "ROU",
       "subunit": "Romania",
       "su_a3": "ROU",
       "name": "Romania",
       "name_long": "Romania",
       "brk_a3": "ROU",
       "brk_name": "Romania",
       "abbrev": "Rom.",
       "postal": "RO",
       "formal_en": "Romania",
       "iso_a2": "RO",
       "iso_a3": "ROU",
       "un_a3": 642,
       "wb_a2": "RO",
       "wb_a3": "ROM",
       "adm0_a3_is": "ROU",
       "adm0_a3_us": "ROU",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "RON",
       "latlon": [
          46,
          25
       ]
   },
   {
       "currency": "RUB",
       "latlon": [
          70,
          120
       ],
       "iso_n3": 643,
       "sovereignt": "Russia",
       "sov_a3": "RUS",
       "admin": "Russia",
       "adm0_a3": "RUS",
       "geounit": "Russia",
       "gu_a3": "RUS",
       "subunit": "Russia",
       "su_a3": "RUS",
       "name": "Russia",
       "name_long": "Russian Federation",
       "brk_a3": "RUS",
       "brk_name": "Russia",
       "abbrev": "Rus.",
       "postal": "RUS",
       "formal_en": "Russian Federation",
       "iso_a2": "RU",
       "iso_a3": "RUS",
       "un_a3": 643,
       "wb_a2": "RU",
       "wb_a3": "RUS",
       "adm0_a3_is": "RUS",
       "adm0_a3_us": "RUS",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia"
   },
   {
       "iso_n3": 646,
       "sovereignt": "Rwanda",
       "sov_a3": "RWA",
       "admin": "Rwanda",
       "adm0_a3": "RWA",
       "geounit": "Rwanda",
       "gu_a3": "RWA",
       "subunit": "Rwanda",
       "su_a3": "RWA",
       "name": "Rwanda",
       "name_long": "Rwanda",
       "brk_a3": "RWA",
       "brk_name": "Rwanda",
       "abbrev": "Rwa.",
       "postal": "RW",
       "formal_en": "Republic of Rwanda",
       "iso_a2": "RW",
       "iso_a3": "RWA",
       "un_a3": 646,
       "wb_a2": "RW",
       "wb_a3": "RWA",
       "adm0_a3_is": "RWA",
       "adm0_a3_us": "RWA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "RWF",
       "latlon": [
          -2,
          30
       ]
   },
   {
       "iso_n3": 682,
       "sovereignt": "Saudi Arabia",
       "sov_a3": "SAU",
       "admin": "Saudi Arabia",
       "adm0_a3": "SAU",
       "geounit": "Saudi Arabia",
       "gu_a3": "SAU",
       "subunit": "Saudi Arabia",
       "su_a3": "SAU",
       "name": "Saudi Arabia",
       "name_long": "Saudi Arabia",
       "brk_a3": "SAU",
       "brk_name": "Saudi Arabia",
       "abbrev": "Saud.",
       "postal": "SA",
       "formal_en": "Kingdom of Saudi Arabia",
       "iso_a2": "SA",
       "iso_a3": "SAU",
       "un_a3": 682,
       "wb_a2": "SA",
       "wb_a3": "SAU",
       "adm0_a3_is": "SAU",
       "adm0_a3_us": "SAU",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "SAR",
       "latlon": [
          25,
          45
       ]
   },
   {
       "iso_n3": 729,
       "sovereignt": "Sudan",
       "sov_a3": "SDN",
       "admin": "Sudan",
       "adm0_a3": "SDN",
       "geounit": "Sudan",
       "gu_a3": "SDN",
       "subunit": "Sudan",
       "su_a3": "SDN",
       "name": "Sudan",
       "name_long": "Sudan",
       "brk_a3": "SDN",
       "brk_name": "Sudan",
       "abbrev": "Sudan",
       "postal": "SD",
       "formal_en": "Republic of the Sudan",
       "iso_a2": "SD",
       "iso_a3": "SDN",
       "un_a3": 729,
       "wb_a2": "SD",
       "wb_a3": "SDN",
       "adm0_a3_is": "SDN",
       "adm0_a3_us": "SDN",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Northern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "SDG",
       "latlon": [
          15,
          30
       ]
   },
   {
       "iso_n3": 686,
       "sovereignt": "Senegal",
       "sov_a3": "SEN",
       "admin": "Senegal",
       "adm0_a3": "SEN",
       "geounit": "Senegal",
       "gu_a3": "SEN",
       "subunit": "Senegal",
       "su_a3": "SEN",
       "name": "Senegal",
       "name_long": "Senegal",
       "brk_a3": "SEN",
       "brk_name": "Senegal",
       "abbrev": "Sen.",
       "postal": "SN",
       "formal_en": "Republic of Senegal",
       "iso_a2": "SN",
       "iso_a3": "SEN",
       "un_a3": 686,
       "wb_a2": "SN",
       "wb_a3": "SEN",
       "adm0_a3_is": "SEN",
       "adm0_a3_us": "SEN",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          14,
          -14
       ]
   },
   {
       "iso_n3": 90,
       "sovereignt": "Solomon Islands",
       "sov_a3": "SLB",
       "admin": "Solomon Islands",
       "adm0_a3": "SLB",
       "geounit": "Solomon Islands",
       "gu_a3": "SLB",
       "subunit": "Solomon Islands",
       "su_a3": "SLB",
       "name": "Solomon Is.",
       "name_long": "Solomon Islands",
       "brk_a3": "SLB",
       "brk_name": "Solomon Is.",
       "abbrev": "S. Is.",
       "postal": "SB",
       "formal_en": "",
       "iso_a2": "SB",
       "iso_a3": "SLB",
       "un_a3": 90,
       "wb_a2": "SB",
       "wb_a3": "SLB",
       "adm0_a3_is": "SLB",
       "adm0_a3_us": "SLB",
       "continent": "Oceania",
       "region_un": "Oceania",
       "subregion": "Melanesia",
       "region_wb": "East Asia & Pacific",
       "currency": "SBD",
       "latlon": [
          -8,
          159
       ]
   },
   {
       "iso_n3": 694,
       "sovereignt": "Sierra Leone",
       "sov_a3": "SLE",
       "admin": "Sierra Leone",
       "adm0_a3": "SLE",
       "geounit": "Sierra Leone",
       "gu_a3": "SLE",
       "subunit": "Sierra Leone",
       "su_a3": "SLE",
       "name": "Sierra Leone",
       "name_long": "Sierra Leone",
       "brk_a3": "SLE",
       "brk_name": "Sierra Leone",
       "abbrev": "S.L.",
       "postal": "SL",
       "formal_en": "Republic of Sierra Leone",
       "iso_a2": "SL",
       "iso_a3": "SLE",
       "un_a3": 694,
       "wb_a2": "SL",
       "wb_a3": "SLE",
       "adm0_a3_is": "SLE",
       "adm0_a3_us": "SLE",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "SLL",
       "latlon": [
          8.5,
          -11.5
       ]
   },
   {
       "iso_n3": 222,
       "sovereignt": "El Salvador",
       "sov_a3": "SLV",
       "admin": "El Salvador",
       "adm0_a3": "SLV",
       "geounit": "El Salvador",
       "gu_a3": "SLV",
       "subunit": "El Salvador",
       "su_a3": "SLV",
       "name": "El Salvador",
       "name_long": "El Salvador",
       "brk_a3": "SLV",
       "brk_name": "El Salvador",
       "abbrev": "El. S.",
       "postal": "SV",
       "formal_en": "Republic of El Salvador",
       "iso_a2": "SV",
       "iso_a3": "SLV",
       "un_a3": 222,
       "wb_a2": "SV",
       "wb_a3": "SLV",
       "adm0_a3_is": "SLV",
       "adm0_a3_us": "SLV",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Central America",
       "region_wb": "Latin America & Caribbean",
       "currency": "SVC",
       "latlon": [
          13.83333333,
          -88.91666666
       ]
   },
   {
       "iso_n3": 706,
       "sovereignt": "Somalia",
       "sov_a3": "SOM",
       "admin": "Somalia",
       "adm0_a3": "SOM",
       "geounit": "Somalia",
       "gu_a3": "SOM",
       "subunit": "Somalia",
       "su_a3": "SOM",
       "name": "Somalia",
       "name_long": "Somalia",
       "brk_a3": "SOM",
       "brk_name": "Somalia",
       "abbrev": "Som.",
       "postal": "SO",
       "formal_en": "Federal Republic of Somalia",
       "iso_a2": "SO",
       "iso_a3": "SOM",
       "un_a3": 706,
       "wb_a2": "SO",
       "wb_a3": "SOM",
       "adm0_a3_is": "SOM",
       "adm0_a3_us": "SOM",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "SOS",
       "latlon": [
          10,
          49
       ]
   },
   {
       "iso_n3": 688,
       "sovereignt": "Republic of Serbia",
       "sov_a3": "SRB",
       "admin": "Republic of Serbia",
       "adm0_a3": "SRB",
       "geounit": "Republic of Serbia",
       "gu_a3": "SRB",
       "subunit": "Republic of Serbia",
       "su_a3": "SRB",
       "name": "Serbia",
       "name_long": "Serbia",
       "brk_a3": "SRB",
       "brk_name": "Serbia",
       "abbrev": "Serb.",
       "postal": "RS",
       "formal_en": "Republic of Serbia",
       "iso_a2": "RS",
       "iso_a3": "SRB",
       "un_a3": 688,
       "wb_a2": "YF",
       "wb_a3": "SRB",
       "adm0_a3_is": "SRB",
       "adm0_a3_us": "SRB",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "RSD",
       "latlon": [
          44,
          21
       ]
   },
   {
       "iso_n3": 728,
       "sovereignt": "South Sudan",
       "sov_a3": "SDS",
       "admin": "South Sudan",
       "adm0_a3": "SDS",
       "geounit": "South Sudan",
       "gu_a3": "SDS",
       "subunit": "South Sudan",
       "su_a3": "SDS",
       "name": "S. Sudan",
       "name_long": "South Sudan",
       "brk_a3": "SDS",
       "brk_name": "S. Sudan",
       "abbrev": "S. Sud.",
       "postal": "SS",
       "formal_en": "Republic of South Sudan",
       "iso_a2": "SS",
       "iso_a3": "SSD",
       "un_a3": 728,
       "wb_a2": "SS",
       "wb_a3": "SSD",
       "adm0_a3_is": "SSD",
       "adm0_a3_us": "SDS",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "SSP",
       "latlon": [
          7,
          30
       ]
   },
   {
       "iso_n3": 740,
       "sovereignt": "Suriname",
       "sov_a3": "SUR",
       "admin": "Suriname",
       "adm0_a3": "SUR",
       "geounit": "Suriname",
       "gu_a3": "SUR",
       "subunit": "Suriname",
       "su_a3": "SUR",
       "name": "Suriname",
       "name_long": "Suriname",
       "brk_a3": "SUR",
       "brk_name": "Suriname",
       "abbrev": "Sur.",
       "postal": "SR",
       "formal_en": "Republic of Suriname",
       "iso_a2": "SR",
       "iso_a3": "SUR",
       "un_a3": 740,
       "wb_a2": "SR",
       "wb_a3": "SUR",
       "adm0_a3_is": "SUR",
       "adm0_a3_us": "SUR",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "SRD",
       "latlon": [
          4,
          -56
       ]
   },
   {
       "iso_n3": 703,
       "sovereignt": "Slovakia",
       "sov_a3": "SVK",
       "admin": "Slovakia",
       "adm0_a3": "SVK",
       "geounit": "Slovakia",
       "gu_a3": "SVK",
       "subunit": "Slovakia",
       "su_a3": "SVK",
       "name": "Slovakia",
       "name_long": "Slovakia",
       "brk_a3": "SVK",
       "brk_name": "Slovakia",
       "abbrev": "Svk.",
       "postal": "SK",
       "formal_en": "Slovak Republic",
       "iso_a2": "SK",
       "iso_a3": "SVK",
       "un_a3": 703,
       "wb_a2": "SK",
       "wb_a3": "SVK",
       "adm0_a3_is": "SVK",
       "adm0_a3_us": "SVK",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "latlon": [
          48.66666666,
          19.5
       ]
   },
   {
       "iso_n3": 705,
       "sovereignt": "Slovenia",
       "sov_a3": "SVN",
       "admin": "Slovenia",
       "adm0_a3": "SVN",
       "geounit": "Slovenia",
       "gu_a3": "SVN",
       "subunit": "Slovenia",
       "su_a3": "SVN",
       "name": "Slovenia",
       "name_long": "Slovenia",
       "brk_a3": "SVN",
       "brk_name": "Slovenia",
       "abbrev": "Slo.",
       "postal": "SLO",
       "formal_en": "Republic of Slovenia",
       "iso_a2": "SI",
       "iso_a3": "SVN",
       "un_a3": 705,
       "wb_a2": "SI",
       "wb_a3": "SVN",
       "adm0_a3_is": "SVN",
       "adm0_a3_us": "SVN",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Southern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "EUR",
       "_comment": "Since this is the EUR marker, we have offset it",
       "latlon_ACTUAL": [
          46.11666666,
          14.81666666
       ],
       "flagHeightMultiplier": 0.90,
       "latlon": [45.203223, -4.754679]
   },
   {
       "iso_n3": 752,
       "sovereignt": "Sweden",
       "sov_a3": "SWE",
       "admin": "Sweden",
       "adm0_a3": "SWE",
       "geounit": "Sweden",
       "gu_a3": "SWE",
       "subunit": "Sweden",
       "su_a3": "SWE",
       "name": "Sweden",
       "name_long": "Sweden",
       "brk_a3": "SWE",
       "brk_name": "Sweden",
       "abbrev": "Swe.",
       "postal": "S",
       "formal_en": "Kingdom of Sweden",
       "iso_a2": "SE",
       "iso_a3": "SWE",
       "un_a3": 752,
       "wb_a2": "SE",
       "wb_a3": "SWE",
       "adm0_a3_is": "SWE",
       "adm0_a3_us": "SWE",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Northern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "SEK",
       "latlon": [
          62,
          15
       ]
   },
   {
       "iso_n3": 748,
       "sovereignt": "Swaziland",
       "sov_a3": "SWZ",
       "admin": "Swaziland",
       "adm0_a3": "SWZ",
       "geounit": "Swaziland",
       "gu_a3": "SWZ",
       "subunit": "Swaziland",
       "su_a3": "SWZ",
       "name": "Swaziland",
       "name_long": "Swaziland",
       "brk_a3": "SWZ",
       "brk_name": "Swaziland",
       "abbrev": "Swz.",
       "postal": "SW",
       "formal_en": "Kingdom of Swaziland",
       "iso_a2": "SZ",
       "iso_a3": "SWZ",
       "un_a3": 748,
       "wb_a2": "SZ",
       "wb_a3": "SWZ",
       "adm0_a3_is": "SWZ",
       "adm0_a3_us": "SWZ",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Southern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "SZL",
       "latlon": [
          -26.5,
          31.5
       ]
   },
   {
       "iso_n3": 760,
       "sovereignt": "Syria",
       "sov_a3": "SYR",
       "admin": "Syria",
       "adm0_a3": "SYR",
       "geounit": "Syria",
       "gu_a3": "SYR",
       "subunit": "Syria",
       "su_a3": "SYR",
       "name": "Syria",
       "name_long": "Syria",
       "brk_a3": "SYR",
       "brk_name": "Syria",
       "abbrev": "Syria",
       "postal": "SYR",
       "formal_en": "Syrian Arab Republic",
       "iso_a2": "SY",
       "iso_a3": "SYR",
       "un_a3": 760,
       "wb_a2": "SY",
       "wb_a3": "SYR",
       "adm0_a3_is": "SYR",
       "adm0_a3_us": "SYR",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "SYP",
       "latlon": [
          35,
          38
       ]
   },
   {
       "iso_n3": 148,
       "sovereignt": "Chad",
       "sov_a3": "TCD",
       "admin": "Chad",
       "adm0_a3": "TCD",
       "geounit": "Chad",
       "gu_a3": "TCD",
       "subunit": "Chad",
       "su_a3": "TCD",
       "name": "Chad",
       "name_long": "Chad",
       "brk_a3": "TCD",
       "brk_name": "Chad",
       "abbrev": "Chad",
       "postal": "TD",
       "formal_en": "Republic of Chad",
       "iso_a2": "TD",
       "iso_a3": "TCD",
       "un_a3": 148,
       "wb_a2": "TD",
       "wb_a3": "TCD",
       "adm0_a3_is": "TCD",
       "adm0_a3_us": "TCD",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Middle Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XAF",
       "latlon": [
          15,
          19
       ]
   },
   {
       "iso_n3": 768,
       "sovereignt": "Togo",
       "sov_a3": "TGO",
       "admin": "Togo",
       "adm0_a3": "TGO",
       "geounit": "Togo",
       "gu_a3": "TGO",
       "subunit": "Togo",
       "su_a3": "TGO",
       "name": "Togo",
       "name_long": "Togo",
       "brk_a3": "TGO",
       "brk_name": "Togo",
       "abbrev": "Togo",
       "postal": "TG",
       "formal_en": "Togolese Republic",
       "iso_a2": "TG",
       "iso_a3": "TGO",
       "un_a3": 768,
       "wb_a2": "TG",
       "wb_a3": "TGO",
       "adm0_a3_is": "TGO",
       "adm0_a3_us": "TGO",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Western Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "XOF",
       "latlon": [
          8,
          1.16666666
       ]
   },
   {
       "iso_n3": 764,
       "sovereignt": "Thailand",
       "sov_a3": "THA",
       "admin": "Thailand",
       "adm0_a3": "THA",
       "geounit": "Thailand",
       "gu_a3": "THA",
       "subunit": "Thailand",
       "su_a3": "THA",
       "name": "Thailand",
       "name_long": "Thailand",
       "brk_a3": "THA",
       "brk_name": "Thailand",
       "abbrev": "Thai.",
       "postal": "TH",
       "formal_en": "Kingdom of Thailand",
       "iso_a2": "TH",
       "iso_a3": "THA",
       "un_a3": 764,
       "wb_a2": "TH",
       "wb_a3": "THA",
       "adm0_a3_is": "THA",
       "adm0_a3_us": "THA",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "THB",
       "latlon": [
          15,
          100
       ]
   },
   {
       "iso_n3": 762,
       "sovereignt": "Tajikistan",
       "sov_a3": "TJK",
       "admin": "Tajikistan",
       "adm0_a3": "TJK",
       "geounit": "Tajikistan",
       "gu_a3": "TJK",
       "subunit": "Tajikistan",
       "su_a3": "TJK",
       "name": "Tajikistan",
       "name_long": "Tajikistan",
       "brk_a3": "TJK",
       "brk_name": "Tajikistan",
       "abbrev": "Tjk.",
       "postal": "TJ",
       "formal_en": "Republic of Tajikistan",
       "iso_a2": "TJ",
       "iso_a3": "TJK",
       "un_a3": 762,
       "wb_a2": "TJ",
       "wb_a3": "TJK",
       "adm0_a3_is": "TJK",
       "adm0_a3_us": "TJK",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Central Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "TJS",
       "latlon": [
          39,
          71
       ]
   },
   {
       "iso_n3": 795,
       "sovereignt": "Turkmenistan",
       "sov_a3": "TKM",
       "admin": "Turkmenistan",
       "adm0_a3": "TKM",
       "geounit": "Turkmenistan",
       "gu_a3": "TKM",
       "subunit": "Turkmenistan",
       "su_a3": "TKM",
       "name": "Turkmenistan",
       "name_long": "Turkmenistan",
       "brk_a3": "TKM",
       "brk_name": "Turkmenistan",
       "abbrev": "Turkm.",
       "postal": "TM",
       "formal_en": "Turkmenistan",
       "iso_a2": "TM",
       "iso_a3": "TKM",
       "un_a3": 795,
       "wb_a2": "TM",
       "wb_a3": "TKM",
       "adm0_a3_is": "TKM",
       "adm0_a3_us": "TKM",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Central Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "TMT",
       "latlon": [
          40,
          60
       ]
   },
   {
       "iso_n3": 626,
       "sovereignt": "East Timor",
       "sov_a3": "TLS",
       "admin": "East Timor",
       "adm0_a3": "TLS",
       "geounit": "East Timor",
       "gu_a3": "TLS",
       "subunit": "East Timor",
       "su_a3": "TLS",
       "name": "Timor-Leste",
       "name_long": "Timor-Leste",
       "brk_a3": "TLS",
       "brk_name": "Timor-Leste",
       "abbrev": "T.L.",
       "postal": "TL",
       "formal_en": "Democratic Republic of Timor-Leste",
       "iso_a2": "TL",
       "iso_a3": "TLS",
       "un_a3": 626,
       "wb_a2": "TP",
       "wb_a3": "TMP",
       "adm0_a3_is": "TLS",
       "adm0_a3_us": "TLS",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "USD_DISABLED",
       "latlon": [
          -8.83333333,
          125.91666666
       ]
   },
   {
       "iso_n3": 780,
       "sovereignt": "Trinidad and Tobago",
       "sov_a3": "TTO",
       "admin": "Trinidad and Tobago",
       "adm0_a3": "TTO",
       "geounit": "Trinidad and Tobago",
       "gu_a3": "TTO",
       "subunit": "Trinidad and Tobago",
       "su_a3": "TTO",
       "name": "Trinidad and Tobago",
       "name_long": "Trinidad and Tobago",
       "brk_a3": "TTO",
       "brk_name": "Trinidad and Tobago",
       "abbrev": "Tr.T.",
       "postal": "TT",
       "formal_en": "Republic of Trinidad and Tobago",
       "iso_a2": "TT",
       "iso_a3": "TTO",
       "un_a3": 780,
       "wb_a2": "TT",
       "wb_a3": "TTO",
       "adm0_a3_is": "TTO",
       "adm0_a3_us": "TTO",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Caribbean",
       "region_wb": "Latin America & Caribbean",
       "currency": "TTD",
       "latlon": [
          11,
          -61
       ]
   },
   {
       "iso_n3": 788,
       "sovereignt": "Tunisia",
       "sov_a3": "TUN",
       "admin": "Tunisia",
       "adm0_a3": "TUN",
       "geounit": "Tunisia",
       "gu_a3": "TUN",
       "subunit": "Tunisia",
       "su_a3": "TUN",
       "name": "Tunisia",
       "name_long": "Tunisia",
       "brk_a3": "TUN",
       "brk_name": "Tunisia",
       "abbrev": "Tun.",
       "postal": "TN",
       "formal_en": "Republic of Tunisia",
       "iso_a2": "TN",
       "iso_a3": "TUN",
       "un_a3": 788,
       "wb_a2": "TN",
       "wb_a3": "TUN",
       "adm0_a3_is": "TUN",
       "adm0_a3_us": "TUN",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Northern Africa",
       "region_wb": "Middle East & North Africa",
       "currency": "TND",
       "latlon": [
          34,
          9
       ]
   },
   {
       "iso_n3": 792,
       "sovereignt": "Turkey",
       "sov_a3": "TUR",
       "admin": "Turkey",
       "adm0_a3": "TUR",
       "geounit": "Turkey",
       "gu_a3": "TUR",
       "subunit": "Turkey",
       "su_a3": "TUR",
       "name": "Turkey",
       "name_long": "Turkey",
       "brk_a3": "TUR",
       "brk_name": "Turkey",
       "abbrev": "Tur.",
       "postal": "TR",
       "formal_en": "Republic of Turkey",
       "iso_a2": "TR",
       "iso_a3": "TUR",
       "un_a3": 792,
       "wb_a2": "TR",
       "wb_a3": "TUR",
       "adm0_a3_is": "TUR",
       "adm0_a3_us": "TUR",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "TRY",
       "latlon": [
          39,
          35
       ]
   },
   {
       "iso_n3": 158,
       "sovereignt": "Taiwan",
       "sov_a3": "TWN",
       "admin": "Taiwan",
       "adm0_a3": "TWN",
       "geounit": "Taiwan",
       "gu_a3": "TWN",
       "subunit": "Taiwan",
       "su_a3": "TWN",
       "name": "Taiwan",
       "name_long": "Taiwan",
       "brk_a3": "B77",
       "brk_name": "Taiwan",
       "abbrev": "Taiwan",
       "postal": "TW",
       "formal_en": "",
       "iso_a2": "TW",
       "iso_a3": "TWN",
       "un_a3": -99,
       "wb_a2": "-99",
       "wb_a3": "-99",
       "adm0_a3_is": "TWN",
       "adm0_a3_us": "TWN",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "TWD",
       "latlon": [
          23.5,
          121
       ]
   },
   {
       "iso_n3": 834,
       "sovereignt": "United Republic of Tanzania",
       "sov_a3": "TZA",
       "admin": "United Republic of Tanzania",
       "adm0_a3": "TZA",
       "geounit": "Tanzania",
       "gu_a3": "TZA",
       "subunit": "Tanzania",
       "su_a3": "TZA",
       "name": "Tanzania",
       "name_long": "Tanzania",
       "brk_a3": "TZA",
       "brk_name": "Tanzania",
       "abbrev": "Tanz.",
       "postal": "TZ",
       "formal_en": "United Republic of Tanzania",
       "iso_a2": "TZ",
       "iso_a3": "TZA",
       "un_a3": 834,
       "wb_a2": "TZ",
       "wb_a3": "TZA",
       "adm0_a3_is": "TZA",
       "adm0_a3_us": "TZA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "TZS",
       "latlon": [
          -6,
          35
       ]
   },
   {
       "iso_n3": 800,
       "sovereignt": "Uganda",
       "sov_a3": "UGA",
       "admin": "Uganda",
       "adm0_a3": "UGA",
       "geounit": "Uganda",
       "gu_a3": "UGA",
       "subunit": "Uganda",
       "su_a3": "UGA",
       "name": "Uganda",
       "name_long": "Uganda",
       "brk_a3": "UGA",
       "brk_name": "Uganda",
       "abbrev": "Uga.",
       "postal": "UG",
       "formal_en": "Republic of Uganda",
       "iso_a2": "UG",
       "iso_a3": "UGA",
       "un_a3": 800,
       "wb_a2": "UG",
       "wb_a3": "UGA",
       "adm0_a3_is": "UGA",
       "adm0_a3_us": "UGA",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "UGX",
       "latlon": [
          1,
          32
       ]
   },
   {
       "iso_n3": 804,
       "sovereignt": "Ukraine",
       "sov_a3": "UKR",
       "admin": "Ukraine",
       "adm0_a3": "UKR",
       "geounit": "Ukraine",
       "gu_a3": "UKR",
       "subunit": "Ukraine",
       "su_a3": "UKR",
       "name": "Ukraine",
       "name_long": "Ukraine",
       "brk_a3": "UKR",
       "brk_name": "Ukraine",
       "abbrev": "Ukr.",
       "postal": "UA",
       "formal_en": "Ukraine",
       "iso_a2": "UA",
       "iso_a3": "UKR",
       "un_a3": 804,
       "wb_a2": "UA",
       "wb_a3": "UKR",
       "adm0_a3_is": "UKR",
       "adm0_a3_us": "UKR",
       "continent": "Europe",
       "region_un": "Europe",
       "subregion": "Eastern Europe",
       "region_wb": "Europe & Central Asia",
       "currency": "UAH",
       "latlon": [
          49,
          32
       ]
   },
   {
       "iso_n3": 858,
       "sovereignt": "Uruguay",
       "sov_a3": "URY",
       "admin": "Uruguay",
       "adm0_a3": "URY",
       "geounit": "Uruguay",
       "gu_a3": "URY",
       "subunit": "Uruguay",
       "su_a3": "URY",
       "name": "Uruguay",
       "name_long": "Uruguay",
       "brk_a3": "URY",
       "brk_name": "Uruguay",
       "abbrev": "Ury.",
       "postal": "UY",
       "formal_en": "Oriental Republic of Uruguay",
       "iso_a2": "UY",
       "iso_a3": "URY",
       "un_a3": 858,
       "wb_a2": "UY",
       "wb_a3": "URY",
       "adm0_a3_is": "URY",
       "adm0_a3_us": "URY",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "UYI",
       "latlon": [
          -33,
          -56
       ]
   },
   {
       "iso_n3": 840,
       "currency": "USD",
       "latlon": [
          38,
          -108
       ],
       "flagHeightMultiplier": 1.0,
       "sovereignt": "United States of America",
       "sov_a3": "US1",
       "admin": "United States of America",
       "adm0_a3": "USA",
       "geounit": "United States of America",
       "gu_a3": "USA",
       "subunit": "United States of America",
       "su_a3": "USA",
       "name": "United States",
       "name_long": "United States",
       "brk_a3": "USA",
       "brk_name": "United States",
       "abbrev": "U.S.A.",
       "postal": "US",
       "formal_en": "United States of America",
       "iso_a2": "US",
       "iso_a3": "USA",
       "un_a3": 840,
       "wb_a2": "US",
       "wb_a3": "USA",
       "adm0_a3_is": "USA",
       "adm0_a3_us": "USA",
       "continent": "North America",
       "region_un": "Americas",
       "subregion": "Northern America",
       "region_wb": "North America"
   },
   {
       "iso_n3": 860,
       "sovereignt": "Uzbekistan",
       "sov_a3": "UZB",
       "admin": "Uzbekistan",
       "adm0_a3": "UZB",
       "geounit": "Uzbekistan",
       "gu_a3": "UZB",
       "subunit": "Uzbekistan",
       "su_a3": "UZB",
       "name": "Uzbekistan",
       "name_long": "Uzbekistan",
       "brk_a3": "UZB",
       "brk_name": "Uzbekistan",
       "abbrev": "Uzb.",
       "postal": "UZ",
       "formal_en": "Republic of Uzbekistan",
       "iso_a2": "UZ",
       "iso_a3": "UZB",
       "un_a3": 860,
       "wb_a2": "UZ",
       "wb_a3": "UZB",
       "adm0_a3_is": "UZB",
       "adm0_a3_us": "UZB",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Central Asia",
       "region_wb": "Europe & Central Asia",
       "currency": "UZS",
       "latlon": [
          41,
          64
       ]
   },
   {
       "iso_n3": 862,
       "sovereignt": "Venezuela",
       "sov_a3": "VEN",
       "admin": "Venezuela",
       "adm0_a3": "VEN",
       "geounit": "Venezuela",
       "gu_a3": "VEN",
       "subunit": "Venezuela",
       "su_a3": "VEN",
       "name": "Venezuela",
       "name_long": "Venezuela",
       "brk_a3": "VEN",
       "brk_name": "Venezuela",
       "abbrev": "Ven.",
       "postal": "VE",
       "formal_en": "Bolivarian Republic of Venezuela",
       "iso_a2": "VE",
       "iso_a3": "VEN",
       "un_a3": 862,
       "wb_a2": "VE",
       "wb_a3": "VEN",
       "adm0_a3_is": "VEN",
       "adm0_a3_us": "VEN",
       "continent": "South America",
       "region_un": "Americas",
       "subregion": "South America",
       "region_wb": "Latin America & Caribbean",
       "currency": "VES",
       "latlon": [
          8,
          -66
       ]
   },
   {
       "iso_n3": 704,
       "sovereignt": "Vietnam",
       "sov_a3": "VNM",
       "admin": "Vietnam",
       "adm0_a3": "VNM",
       "geounit": "Vietnam",
       "gu_a3": "VNM",
       "subunit": "Vietnam",
       "su_a3": "VNM",
       "name": "Vietnam",
       "name_long": "Vietnam",
       "brk_a3": "VNM",
       "brk_name": "Vietnam",
       "abbrev": "Viet.",
       "postal": "VN",
       "formal_en": "Socialist Republic of Vietnam",
       "iso_a2": "VN",
       "iso_a3": "VNM",
       "un_a3": 704,
       "wb_a2": "VN",
       "wb_a3": "VNM",
       "adm0_a3_is": "VNM",
       "adm0_a3_us": "VNM",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "South-Eastern Asia",
       "region_wb": "East Asia & Pacific",
       "currency": "VND",
       "latlon": [
          16.16666666,
          107.83333333
       ]
   },
   {
       "iso_n3": 548,
       "sovereignt": "Vanuatu",
       "sov_a3": "VUT",
       "admin": "Vanuatu",
       "adm0_a3": "VUT",
       "geounit": "Vanuatu",
       "gu_a3": "VUT",
       "subunit": "Vanuatu",
       "su_a3": "VUT",
       "name": "Vanuatu",
       "name_long": "Vanuatu",
       "brk_a3": "VUT",
       "brk_name": "Vanuatu",
       "abbrev": "Van.",
       "postal": "VU",
       "formal_en": "Republic of Vanuatu",
       "iso_a2": "VU",
       "iso_a3": "VUT",
       "un_a3": 548,
       "wb_a2": "VU",
       "wb_a3": "VUT",
       "adm0_a3_is": "VUT",
       "adm0_a3_us": "VUT",
       "continent": "Oceania",
       "region_un": "Oceania",
       "subregion": "Melanesia",
       "region_wb": "East Asia & Pacific",
       "currency": "VUV",
       "latlon": [
          -16,
          167
       ]
   },
   {
       "iso_n3": 887,
       "sovereignt": "Yemen",
       "sov_a3": "YEM",
       "admin": "Yemen",
       "adm0_a3": "YEM",
       "geounit": "Yemen",
       "gu_a3": "YEM",
       "subunit": "Yemen",
       "su_a3": "YEM",
       "name": "Yemen",
       "name_long": "Yemen",
       "brk_a3": "YEM",
       "brk_name": "Yemen",
       "abbrev": "Yem.",
       "postal": "YE",
       "formal_en": "Republic of Yemen",
       "iso_a2": "YE",
       "iso_a3": "YEM",
       "un_a3": 887,
       "wb_a2": "RY",
       "wb_a3": "YEM",
       "adm0_a3_is": "YEM",
       "adm0_a3_us": "YEM",
       "continent": "Asia",
       "region_un": "Asia",
       "subregion": "Western Asia",
       "region_wb": "Middle East & North Africa",
       "currency": "YER",
       "latlon": [
          15,
          48
       ]
   },
   {
       "iso_n3": 710,
       "sovereignt": "South Africa",
       "sov_a3": "ZAF",
       "admin": "South Africa",
       "adm0_a3": "ZAF",
       "geounit": "South Africa",
       "gu_a3": "ZAF",
       "subunit": "South Africa",
       "su_a3": "ZAF",
       "name": "South Africa",
       "name_long": "South Africa",
       "brk_a3": "ZAF",
       "brk_name": "South Africa",
       "abbrev": "S.Af.",
       "postal": "ZA",
       "formal_en": "Republic of South Africa",
       "iso_a2": "ZA",
       "iso_a3": "ZAF",
       "un_a3": 710,
       "wb_a2": "ZA",
       "wb_a3": "ZAF",
       "adm0_a3_is": "ZAF",
       "adm0_a3_us": "ZAF",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Southern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "ZAR",
       "latlon": [
          -29,
          24
       ]
   },
   {
       "iso_n3": 894,
       "sovereignt": "Zambia",
       "sov_a3": "ZMB",
       "admin": "Zambia",
       "adm0_a3": "ZMB",
       "geounit": "Zambia",
       "gu_a3": "ZMB",
       "subunit": "Zambia",
       "su_a3": "ZMB",
       "name": "Zambia",
       "name_long": "Zambia",
       "brk_a3": "ZMB",
       "brk_name": "Zambia",
       "abbrev": "Zambia",
       "postal": "ZM",
       "formal_en": "Republic of Zambia",
       "iso_a2": "ZM",
       "iso_a3": "ZMB",
       "un_a3": 894,
       "wb_a2": "ZM",
       "wb_a3": "ZMB",
       "adm0_a3_is": "ZMB",
       "adm0_a3_us": "ZMB",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "ZMK",
       "latlon": [
          -15,
          30
       ]
   },
   {
       "iso_n3": 716,
       "sovereignt": "Zimbabwe",
       "sov_a3": "ZWE",
       "admin": "Zimbabwe",
       "adm0_a3": "ZWE",
       "geounit": "Zimbabwe",
       "gu_a3": "ZWE",
       "subunit": "Zimbabwe",
       "su_a3": "ZWE",
       "name": "Zimbabwe",
       "name_long": "Zimbabwe",
       "brk_a3": "ZWE",
       "brk_name": "Zimbabwe",
       "abbrev": "Zimb.",
       "postal": "ZW",
       "formal_en": "Republic of Zimbabwe",
       "iso_a2": "ZW",
       "iso_a3": "ZWE",
       "un_a3": 716,
       "wb_a2": "ZW",
       "wb_a3": "ZWE",
       "adm0_a3_is": "ZWE",
       "adm0_a3_us": "ZWE",
       "continent": "Africa",
       "region_un": "Africa",
       "subregion": "Eastern Africa",
       "region_wb": "Sub-Saharan Africa",
       "currency": "USD_DISABLED",
       "latlon": [
          -20,
          30
       ]
   }
];

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.OfflineMapNode.TOPOJSON_110M_FEATURES = {"type":"Topology","objects":{"countries":{"type":"GeometryCollection","geometries":[{"type":"Polygon","arcs":[[0,1,2,3,4,5]],"id":4},{"type":"MultiPolygon","arcs":[[[6,7,8,9]],[[10,11,12]]],"id":24},{"type":"Polygon","arcs":[[13,14,15,16,17]],"id":8},{"type":"Polygon","arcs":[[18,19,20,21,22]],"id":784},{"type":"MultiPolygon","arcs":[[[23,24]],[[25,26,27,28,29,30]]],"id":32},{"type":"Polygon","arcs":[[31,32,33,34,35]],"id":51},{"type":"MultiPolygon","arcs":[[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]]],"id":10},{"type":"Polygon","arcs":[[44]],"id":260},{"type":"MultiPolygon","arcs":[[[45]],[[46]]],"id":36},{"type":"Polygon","arcs":[[47,48,49,50,51,52,53]],"id":40},{"type":"MultiPolygon","arcs":[[[54,-35]],[[55,56,-33,57,58]]],"id":31},{"type":"Polygon","arcs":[[59,60,61]],"id":108},{"type":"Polygon","arcs":[[62,63,64,65,66]],"id":56},{"type":"Polygon","arcs":[[67,68,69,70,71]],"id":204},{"type":"Polygon","arcs":[[72,73,74,-70,75,76]],"id":854},{"type":"Polygon","arcs":[[77,78,79]],"id":50},{"type":"Polygon","arcs":[[80,81,82,83,84,85]],"id":100},{"type":"MultiPolygon","arcs":[[[86]],[[87]],[[88]]],"id":44},{"type":"Polygon","arcs":[[89,90,91]],"id":70},{"type":"Polygon","arcs":[[92,93,94,95,96]],"id":112},{"type":"Polygon","arcs":[[97,98,99]],"id":84},{"type":"Polygon","arcs":[[100,101,102,103,-31]],"id":68},{"type":"Polygon","arcs":[[-27,104,-103,105,106,107,108,109,110,111,112]],"id":76},{"type":"Polygon","arcs":[[113,114]],"id":96},{"type":"Polygon","arcs":[[115,116]],"id":64},{"type":"Polygon","arcs":[[117,118,119,120]],"id":72},{"type":"Polygon","arcs":[[121,122,123,124,125,126,127]],"id":140},{"type":"MultiPolygon","arcs":[[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[138,139,140,141]],[[142]],[[143]],[[144]],[[145]],[[146]],[[147]],[[148]],[[149]],[[150]],[[151]],[[152]],[[153]],[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]]],"id":124},{"type":"Polygon","arcs":[[-51,161,162,163]],"id":756},{"type":"MultiPolygon","arcs":[[[-24,164]],[[-30,165,166,-101]]],"id":152},{"type":"MultiPolygon","arcs":[[[167]],[[168,169,170,171,172,173,-117,174,175,176,177,-4,178,179,180,181,182,183]]],"id":156},{"type":"Polygon","arcs":[[184,185,186,187,-73,188]],"id":384},{"type":"Polygon","arcs":[[189,190,191,192,193,194,-128,195]],"id":120},{"type":"Polygon","arcs":[[196,197,-60,198,199,200,201,-10,202,-13,203,-126,204]],"id":180},{"type":"Polygon","arcs":[[-12,205,206,-196,-127,-204]],"id":178},{"type":"Polygon","arcs":[[207,208,209,210,211,-107,212]],"id":170},{"type":"Polygon","arcs":[[213,214,215,216]],"id":188},{"type":"Polygon","arcs":[[217]],"id":192},{"type":"Polygon","arcs":[[218,219]],"id":-99},{"type":"Polygon","arcs":[[220,-220]],"id":196},{"type":"Polygon","arcs":[[-53,221,222,223]],"id":203},{"type":"Polygon","arcs":[[224,225,-222,-52,-164,226,227,-64,228,229,230]],"id":276},{"type":"Polygon","arcs":[[231,232,233,234]],"id":262},{"type":"MultiPolygon","arcs":[[[235]],[[-231,236]]],"id":208},{"type":"Polygon","arcs":[[237,238]],"id":214},{"type":"Polygon","arcs":[[239,240,241,242,243,244,245,246]],"id":12},{"type":"Polygon","arcs":[[247,-208,248]],"id":218},{"type":"Polygon","arcs":[[249,250,251,252,253]],"id":818},{"type":"Polygon","arcs":[[254,255,256,-235]],"id":232},{"type":"Polygon","arcs":[[257,258,259,260]],"id":724},{"type":"Polygon","arcs":[[261,262,263]],"id":233},{"type":"Polygon","arcs":[[-234,264,265,266,267,268,269,-255]],"id":231},{"type":"Polygon","arcs":[[270,271,272,273]],"id":246},{"type":"MultiPolygon","arcs":[[[274]],[[275]]],"id":242},{"type":"Polygon","arcs":[[276]],"id":238},{"type":"MultiPolygon","arcs":[[[281,-227,-163,282,283,-259,284,-66]]],"id":250},{"type":"Polygon","arcs":[[285,286,-190,-207]],"id":266},{"type":"MultiPolygon","arcs":[[[287,288]],[[289]]],"id":826},{"type":"Polygon","arcs":[[290,291,-58,-32,292]],"id":268},{"type":"Polygon","arcs":[[293,-189,-77,294]],"id":288},{"type":"Polygon","arcs":[[295,296,297,298,299,300,-187]],"id":324},{"type":"Polygon","arcs":[[301,302]],"id":270},{"type":"Polygon","arcs":[[303,304,-299]],"id":624},{"type":"Polygon","arcs":[[305,-191,-287]],"id":226},{"type":"MultiPolygon","arcs":[[[306]],[[307,-15,308,-84,309]]],"id":300},{"type":"Polygon","arcs":[[310]],"id":304},{"type":"Polygon","arcs":[[311,312,-100,313,314,315]],"id":320},{"type":"Polygon","arcs":[[316,317,-109,318]],"id":328},{"type":"Polygon","arcs":[[319,320,-315,321,322]],"id":340},{"type":"Polygon","arcs":[[323,-92,324,325,326,327]],"id":191},{"type":"Polygon","arcs":[[-239,328]],"id":332},{"type":"Polygon","arcs":[[-48,329,330,331,332,-328,333]],"id":348},{"type":"MultiPolygon","arcs":[[[334]],[[335,336]],[[337]],[[338]],[[339]],[[340]],[[341]],[[342]],[[343,344]],[[345]],[[346]],[[347,348]],[[349]]],"id":360},{"type":"Polygon","arcs":[[-177,350,-175,-116,-174,351,-80,352,353]],"id":356},{"type":"Polygon","arcs":[[354,-288]],"id":372},{"type":"Polygon","arcs":[[355,-6,356,357,358,359,-55,-34,-57,360]],"id":364},{"type":"Polygon","arcs":[[361,362,363,364,365,366,-359]],"id":368},{"type":"Polygon","arcs":[[367]],"id":352},{"type":"Polygon","arcs":[[368,369,370,-254,371,372,373]],"id":376},{"type":"MultiPolygon","arcs":[[[374]],[[375]],[[376,377,-283,-162,-50]]],"id":380},{"type":"Polygon","arcs":[[378]],"id":388},{"type":"Polygon","arcs":[[-369,379,-365,380,381,-371,382]],"id":400},{"type":"MultiPolygon","arcs":[[[383]],[[384]],[[385]]],"id":392},{"type":"Polygon","arcs":[[386,387,388,389,-181,390]],"id":398},{"type":"Polygon","arcs":[[391,392,393,394,-267,395]],"id":404},{"type":"Polygon","arcs":[[-391,-180,396,397]],"id":417},{"type":"Polygon","arcs":[[398,399,400,401]],"id":116},{"type":"Polygon","arcs":[[402,403]],"id":410},{"type":"Polygon","arcs":[[-18,404,405,406]],"id":-99},{"type":"Polygon","arcs":[[407,408,-363]],"id":414},{"type":"Polygon","arcs":[[409,410,-172,411,-400]],"id":418},{"type":"Polygon","arcs":[[-373,412,413]],"id":422},{"type":"Polygon","arcs":[[414,415,-296,-186]],"id":430},{"type":"Polygon","arcs":[[416,-247,417,418,-252,419,420]],"id":434},{"type":"Polygon","arcs":[[421]],"id":144},{"type":"Polygon","arcs":[[422]],"id":426},{"type":"Polygon","arcs":[[423,424,425,-93,426]],"id":440},{"type":"Polygon","arcs":[[-228,-282,-65]],"id":442},{"type":"Polygon","arcs":[[427,-264,428,-94,-426]],"id":428},{"type":"Polygon","arcs":[[-244,429,430]],"id":504},{"type":"Polygon","arcs":[[431,432]],"id":498},{"type":"Polygon","arcs":[[433]],"id":450},{"type":"Polygon","arcs":[[434,-98,-313,435,436]],"id":484},{"type":"Polygon","arcs":[[-407,437,-85,-309,-14]],"id":807},{"type":"Polygon","arcs":[[438,-241,439,-74,-188,-301,440]],"id":466},{"type":"Polygon","arcs":[[441,-78,-352,-173,-411,442]],"id":104},{"type":"Polygon","arcs":[[443,-325,-91,444,-405,-17]],"id":499},{"type":"Polygon","arcs":[[445,-183]],"id":496},{"type":"Polygon","arcs":[[446,447,448,449,450,451,452,453]],"id":508},{"type":"Polygon","arcs":[[454,455,456,-242,-439]],"id":478},{"type":"Polygon","arcs":[[-454,457,458]],"id":454},{"type":"MultiPolygon","arcs":[[[459,460]],[[-348,461,-115,462]]],"id":458},{"type":"Polygon","arcs":[[463,-8,464,-119,465]],"id":516},{"type":"Polygon","arcs":[[466]],"id":540},{"type":"Polygon","arcs":[[-75,-440,-240,-417,467,-194,468,-71]],"id":562},{"type":"Polygon","arcs":[[469,-72,-469,-193]],"id":566},{"type":"Polygon","arcs":[[470,-323,471,-215]],"id":558},{"type":"Polygon","arcs":[[-229,-63,472]],"id":528},{"type":"MultiPolygon","arcs":[[[473,-274,474,475]],[[476]],[[477]],[[478]]],"id":578},{"type":"Polygon","arcs":[[-351,-176]],"id":524},{"type":"MultiPolygon","arcs":[[[479]],[[480]]],"id":554},{"type":"MultiPolygon","arcs":[[[481,482,-22,483]],[[-20,484]]],"id":512},{"type":"Polygon","arcs":[[-178,-354,485,-357,-5]],"id":586},{"type":"Polygon","arcs":[[486,-217,487,-210]],"id":591},{"type":"Polygon","arcs":[[-167,488,-249,-213,-106,-102]],"id":604},{"type":"MultiPolygon","arcs":[[[489]],[[490]],[[491]],[[492]],[[493]],[[494]],[[495]]],"id":608},{"type":"MultiPolygon","arcs":[[[496]],[[497]],[[-344,498]],[[499]]],"id":598},{"type":"Polygon","arcs":[[-226,500,501,-427,-97,502,503,-223]],"id":616},{"type":"Polygon","arcs":[[504]],"id":630},{"type":"Polygon","arcs":[[505,506,-404,507,-169]],"id":408},{"type":"Polygon","arcs":[[-261,508]],"id":620},{"type":"Polygon","arcs":[[-104,-105,-26]],"id":600},{"type":"Polygon","arcs":[[-383,-370]],"id":275},{"type":"Polygon","arcs":[[509,510]],"id":634},{"type":"Polygon","arcs":[[511,-433,512,513,-81,514,-332]],"id":642},{"type":"MultiPolygon","arcs":[[[515]],[[-502,516,-424]],[[517]],[[518]],[[519]],[[520]],[[521]],[[-506,-184,-446,-182,-390,522,-59,-292,523,524,-95,-429,-263,525,-271,-474,526]],[[527]],[[528]],[[529]]],"id":643},{"type":"Polygon","arcs":[[530,-61,-198,531]],"id":646},{"type":"Polygon","arcs":[[-243,-457,532,-430]],"id":732},{"type":"Polygon","arcs":[[533,-381,-364,-409,534,-511,535,-23,-483,536]],"id":682},{"type":"Polygon","arcs":[[537,538,-123,539,-420,-251,540,-256,-270,541]],"id":729},{"type":"Polygon","arcs":[[542,-268,-395,543,-205,-125,544,-538]],"id":728},{"type":"Polygon","arcs":[[545,-455,-441,-300,-305,546,-303]],"id":686},{"type":"MultiPolygon","arcs":[[[547]],[[548]],[[549]],[[550]],[[551]]],"id":90},{"type":"Polygon","arcs":[[552,-297,-416]],"id":694},{"type":"Polygon","arcs":[[553,-316,-321]],"id":222},{"type":"Polygon","arcs":[[-265,-233,554,555]],"id":-99},{"type":"Polygon","arcs":[[-396,-266,-556,556]],"id":706},{"type":"Polygon","arcs":[[-86,-438,-406,-445,-90,-324,-333,-515]],"id":688},{"type":"Polygon","arcs":[[557,-279,558,-110,-318]],"id":740},{"type":"Polygon","arcs":[[-504,559,-330,-54,-224]],"id":703},{"type":"Polygon","arcs":[[-49,-334,-327,560,-377]],"id":705},{"type":"Polygon","arcs":[[-475,-273,561]],"id":752},{"type":"Polygon","arcs":[[562,-450]],"id":748},{"type":"Polygon","arcs":[[-380,-374,-414,563,564,-366]],"id":760},{"type":"Polygon","arcs":[[-468,-421,-540,-122,-195]],"id":148},{"type":"Polygon","arcs":[[565,-295,-76,-69]],"id":768},{"type":"Polygon","arcs":[[566,-461,567,-443,-410,-399]],"id":764},{"type":"Polygon","arcs":[[-397,-179,-3,568]],"id":762},{"type":"Polygon","arcs":[[-356,569,-388,570,-1]],"id":795},{"type":"Polygon","arcs":[[571,-336]],"id":626},{"type":"Polygon","arcs":[[572]],"id":780},{"type":"Polygon","arcs":[[-246,573,-418]],"id":788},{"type":"MultiPolygon","arcs":[[[-293,-36,-360,-367,-565,574]],[[-310,-83,575]]],"id":792},{"type":"Polygon","arcs":[[576]],"id":158},{"type":"Polygon","arcs":[[-393,577,-447,-459,578,-201,579,-199,-62,-531,580]],"id":834},{"type":"Polygon","arcs":[[-532,-197,-544,-394,-581]],"id":800},{"type":"Polygon","arcs":[[-525,581,-513,-432,-512,-331,-560,-503,-96]],"id":804},{"type":"Polygon","arcs":[[-113,582,-28]],"id":858},{"type":"MultiPolygon","arcs":[[[583]],[[584]],[[585]],[[586]],[[587]],[[588,-437,589,-139]],[[590]],[[591]],[[592]],[[-141,593]]],"id":840},{"type":"Polygon","arcs":[[-571,-387,-398,-569,-2]],"id":860},{"type":"Polygon","arcs":[[594,-319,-108,-212]],"id":862},{"type":"Polygon","arcs":[[595,-401,-412,-171]],"id":704},{"type":"MultiPolygon","arcs":[[[596]],[[597]]],"id":548},{"type":"Polygon","arcs":[[598,-537,-482]],"id":887},{"type":"Polygon","arcs":[[-466,-118,599,-451,-563,-449,600],[-423]],"id":710},{"type":"Polygon","arcs":[[-458,-453,601,-120,-465,-7,-202,-579]],"id":894},{"type":"Polygon","arcs":[[-600,-121,-602,-452]],"id":716}]},"land":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[595,401,566,459,567,441,78,352,485,357,361,407,534,509,535,18,484,20,483,598,533,381,249,540,256,231,554,556,391,577,447,600,463,8,202,10,205,285,305,191,469,67,565,293,184,414,552,297,303,546,301,545,455,532,430,244,573,418,252,371,412,563,574,290,523,581,513,81,575,307,15,443,325,560,377,283,259,508,257,284,66,472,229,236,224,500,516,424,427,261,525,271,561,475,526,506,402,507,169],[123,544,538],[199,579],[542,268,541],[388,522,55,360,569]],[[24,164]],[[582,28,165,488,247,208,486,213,470,319,553,311,435,589,139,593,141,588,434,98,313,321,471,215,487,210,594,316,557,279,111],[558,277]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]],[[44]],[[45]],[[46]],[[86]],[[87]],[[88]],[[461,113,462,348]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[142]],[[143]],[[144]],[[145]],[[146]],[[147]],[[148]],[[149]],[[150]],[[151]],[[152]],[[153]],[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[167]],[[217]],[[218,220]],[[235]],[[237,328]],[[274]],[[275]],[[276]],[[280]],[[288,354]],[[289]],[[306]],[[310]],[[334]],[[336,571]],[[337]],[[338]],[[339]],[[340]],[[341]],[[342]],[[344,498]],[[345]],[[346]],[[349]],[[367]],[[374]],[[375]],[[378]],[[383]],[[384]],[[385]],[[421]],[[433]],[[466]],[[476]],[[477]],[[478]],[[479]],[[480]],[[489]],[[490]],[[491]],[[492]],[[493]],[[494]],[[495]],[[496]],[[497]],[[499]],[[504]],[[515]],[[517]],[[518]],[[519]],[[520]],[[521]],[[527]],[[528]],[[529]],[[547]],[[548]],[[549]],[[550]],[[551]],[[572]],[[576]],[[583]],[[584]],[[585]],[[586]],[[587]],[[590]],[[591]],[[592]],[[596]],[[597]]]}]}},"arcs":[[[67002,71642],[284,-224],[209,79],[58,268],[219,89],[157,180],[55,472],[234,114],[44,211],[131,-158],[84,-19]],[[68477,72654],[154,-4],[210,-124]],[[68841,72526],[85,-72],[201,189],[93,-114],[90,271],[166,-12],[43,86],[29,239],[120,205],[150,-134],[-30,-181],[84,-28],[-26,-496],[110,-194],[97,125],[123,58],[173,265],[192,-44],[286,-1]],[[70827,72688],[50,-169]],[[70877,72519],[-162,-67],[-141,-109],[-319,-68],[-298,-124],[-163,-258],[66,-250],[32,-294],[-139,-248],[12,-227],[-76,-213],[-265,18],[110,-390],[-177,-150],[-118,-356],[15,-355],[-108,-166],[-103,55],[-212,-77],[-31,-166],[-207,1],[-154,-334],[-10,-503],[-361,-246],[-194,52],[-56,-129],[-166,75],[-278,-88],[-465,301]],[[66909,68203],[252,536],[-23,380],[-210,100],[-22,375],[-91,472],[119,323],[-121,87],[76,430],[113,736]],[[56642,44124],[29,-184],[-32,-286],[49,-277],[-41,-222],[24,-203],[-579,7],[-13,-1880],[188,-483],[181,-369]],[[56448,40227],[-510,-241],[-673,83],[-192,284],[-1126,-26],[-42,-41],[-166,267],[-180,17],[-166,-100],[-134,-113]],[[53259,40357],[-26,372],[38,519],[96,541],[15,254],[90,532],[66,243],[159,386],[90,263],[29,438],[-15,335],[-83,211],[-74,358],[-68,355],[15,122],[85,235],[-84,570],[-57,396],[-139,374],[26,115]],[[53422,46976],[115,79],[80,-11],[98,71],[820,-8],[68,-440],[80,-354],[64,-191],[106,-309],[184,47],[91,83],[154,-83],[42,148],[69,344],[172,23],[15,103],[142,2],[-24,-213],[337,5],[5,-372],[56,-228],[-41,-356],[21,-363],[93,-219],[-15,-703],[68,54],[121,-15],[172,89],[127,-35]],[[53383,47159],[-74,444]],[[53309,47603],[112,255],[84,100],[104,-203]],[[53609,47755],[-101,-124],[-45,-152],[-9,-258],[-71,-62]],[[55719,75309],[-35,-201],[39,-254],[115,-144]],[[55838,74710],[-5,-155],[-91,-85],[-16,-192],[-129,-287]],[[55597,73991],[-48,41],[-5,130],[-154,199],[-24,281],[23,403],[38,184],[-47,93]],[[55380,75322],[-18,188],[120,291],[18,-111],[75,52]],[[55575,75742],[59,-159],[66,-60],[19,-214]],[[64327,64904],[49,29],[11,-162],[217,93],[230,-15],[168,-18],[190,400],[207,379],[176,364]],[[65575,65974],[52,-202]],[[65627,65772],[38,-466]],[[65665,65306],[-142,-3],[-23,-384],[50,-82],[-126,-117],[-1,-241],[-81,-245],[-7,-238]],[[65335,63996],[-56,-125],[-835,298],[-106,599],[-11,136]],[[31400,18145],[-168,16],[-297,1],[0,1319]],[[30935,19481],[106,-274],[139,-443],[361,-355],[389,-147],[-125,-296],[-264,-29],[-141,208]],[[32587,37434],[511,-964],[227,-89],[339,-437],[286,-231],[40,-261],[-273,-898],[280,-160],[312,-91],[220,95],[252,453],[45,521]],[[34826,35372],[138,114],[139,-341],[-6,-472],[-234,-326],[-186,-241],[-314,-573],[-370,-806]],[[33993,32727],[-70,-473],[-74,-607],[3,-588],[-61,-132],[-21,-382]],[[33770,30545],[-19,-308],[353,-506],[-38,-408],[173,-257],[-14,-289],[-267,-757],[-412,-317],[-557,-123],[-305,59],[59,-352],[-57,-442],[51,-298],[-167,-208],[-284,-82],[-267,216],[-108,-155],[39,-587],[188,-178],[152,186],[82,-307],[-255,-183],[-223,-367],[-41,-595],[-66,-316],[-262,-2],[-218,-302],[-80,-443],[273,-433],[266,-119],[-96,-531],[-328,-333],[-180,-692],[-254,-234],[-113,-276],[89,-614],[185,-342],[-117,30]],[[30952,19680],[-257,93],[-672,79],[-115,344],[6,443],[-185,-38],[-98,214],[-24,626],[213,260],[88,375],[-33,299],[148,504],[101,782],[-30,347],[122,112],[-30,223],[-129,118],[92,248],[-126,224],[-65,682],[112,120],[-47,720],[65,605],[75,527],[166,215],[-84,576],[-1,543],[210,386],[-7,494],[159,576],[1,544],[-72,108],[-128,1020],[171,607],[-27,572],[100,537],[182,555],[196,367],[-83,232],[58,190],[-9,985],[302,291],[96,614],[-34,148]],[[31359,37147],[231,534],[364,-144],[163,-427],[109,475],[316,-24],[45,-127]],[[62106,74858],[386,92]],[[62492,74950],[57,-155],[106,-103],[-56,-148],[148,-202],[-78,-189],[118,-160],[124,-97],[7,-410]],[[62918,73486],[-101,-17]],[[62817,73469],[-113,342],[1,91],[-123,-2],[-82,159],[-58,-16]],[[62442,74043],[-109,172],[-207,147],[27,288],[-47,208]],[[33452,3290],[-82,-301],[-81,-266],[-582,81],[-621,-35],[-348,197],[0,23],[-152,174],[625,-23],[599,-58],[207,243],[147,208],[288,-243]],[[5775,3611],[-533,-81],[-364,208],[-163,209],[-11,35],[-180,162],[169,220],[517,-93],[277,-185],[212,-209],[76,-266]],[[37457,4468],[342,-255],[120,-359],[33,-254],[11,-301],[-430,-186],[-452,-150],[-522,-139],[-582,-116],[-658,35],[-365,197],[49,243],[593,162],[239,197],[174,254],[126,220],[168,209],[180,243],[141,0],[414,127],[419,-127]],[[16330,7154],[359,-93],[332,104],[-158,-208],[-261,-151],[-386,47],[-278,208],[60,197],[332,-104]],[[15122,7165],[425,-231],[-164,23],[-359,58],[-381,162],[202,127],[277,-139]],[[22505,8080],[305,-81],[304,69],[163,-335],[-217,46],[-337,-23],[-343,23],[-376,-35],[-283,116],[-146,243],[174,104],[353,-81],[403,-46]],[[30985,8657],[33,-266],[-49,-231],[-76,-220],[-326,-81],[-311,-116],[-364,11],[136,232],[-327,-81],[-310,-81],[-212,174],[-16,243],[305,231],[190,70],[321,-23],[82,301],[16,219],[-6,475],[158,278],[256,93],[147,-220],[65,-220],[120,-267],[92,-254],[76,-267]],[[0,529],[16,-5],[245,344],[501,-185],[32,21],[294,188],[38,-7],[32,-4],[402,-246],[352,246],[63,34],[816,104],[265,-138],[130,-71],[419,-196],[789,-151],[625,-185],[1072,-139],[800,162],[1181,-116],[669,-185],[734,174],[773,162],[60,278],[-1094,23],[-898,139],[-234,231],[-745,128],[49,266],[103,243],[104,220],[-55,243],[-462,162],[-212,209],[-430,185],[675,-35],[642,93],[402,-197],[495,173],[457,220],[223,197],[-98,243],[-359,162],[-408,174],[-571,35],[-500,81],[-539,58],[-180,220],[-359,185],[-217,208],[-87,672],[136,-58],[250,-185],[457,58],[441,81],[228,-255],[441,58],[370,127],[348,162],[315,197],[419,58],[-11,220],[-97,220],[81,208],[359,104],[163,-196],[425,115],[321,151],[397,12],[375,57],[376,139],[299,128],[337,127],[218,-35],[190,-46],[414,81],[370,-104],[381,11],[364,81],[375,-57],[414,-58],[386,23],[403,-12],[413,-11],[381,23],[283,174],[337,92],[349,-127],[331,104],[300,208],[179,-185],[98,-208],[180,-197],[288,174],[332,-220],[375,-70],[321,-162],[392,35],[354,104],[418,-23],[376,-81],[381,-104],[147,254],[-180,197],[-136,209],[-359,46],[-158,220],[-60,220],[-98,440],[213,-81],[364,-35],[359,35],[327,-93],[283,-174],[119,-208],[376,-35],[359,81],[381,116],[342,70],[283,-139],[370,46],[239,451],[224,-266],[321,-104],[348,58],[228,-232],[365,-23],[337,-69],[332,-128],[218,220],[108,209],[278,-232],[381,58],[283,-127],[190,-197],[370,58],[288,127],[283,151],[337,81],[392,69],[354,81],[272,127],[163,186],[65,254],[-32,244],[-87,231],[-98,232],[-87,231],[-71,209],[-16,231],[27,232],[130,220],[109,243],[44,231],[-55,255],[-32,232],[136,266],[152,173],[180,220],[190,186],[223,173],[109,255],[152,162],[174,151],[267,34],[174,186],[196,115],[228,70],[202,150],[157,186],[218,69],[163,-151],[-103,-196],[-283,-174],[-120,-127],[-206,92],[-229,-58],[-190,-139],[-202,-150],[-136,-174],[-38,-231],[17,-220],[130,-197],[-190,-139],[-261,-46],[-153,-197],[-163,-185],[-174,-255],[-44,-220],[98,-243],[147,-185],[229,-139],[212,-185],[114,-232],[60,-220],[82,-232],[130,-196],[82,-220],[38,-544],[81,-220],[22,-232],[87,-231],[-38,-313],[-152,-243],[-163,-197],[-370,-81],[-125,-208],[-169,-197],[-419,-220],[-370,-93],[-348,-127],[-376,-128],[-223,-243],[-446,-23],[-489,23],[-441,-46],[-468,0],[87,-232],[424,-104],[311,-162],[174,-208],[-310,-185],[-479,58],[-397,-151],[-17,-243],[-11,-232],[327,-196],[60,-220],[353,-220],[588,-93],[500,-162],[398,-185],[506,-186],[690,-92],[681,-162],[473,-174],[517,-197],[272,-278],[136,-220],[337,209],[457,173],[484,186],[577,150],[495,162],[691,12],[680,-81],[560,-139],[180,255],[386,173],[702,12],[550,127],[522,128],[577,81],[614,104],[430,150],[-196,209],[-119,208],[0,220],[-539,-23],[-571,-93],[-544,0],[-77,220],[39,440],[125,128],[397,138],[468,139],[337,174],[337,174],[251,231],[380,104],[376,81],[190,47],[430,23],[408,81],[343,116],[337,139],[305,139],[386,185],[245,197],[261,173],[82,232],[-294,139],[98,243],[185,185],[288,116],[305,139],[283,185],[217,232],[136,277],[202,163],[331,-35],[136,-197],[332,-23],[11,220],[142,231],[299,-58],[71,-220],[331,-34],[360,104],[348,69],[315,-34],[120,-243],[305,196],[283,105],[315,81],[310,81],[283,139],[310,92],[240,128],[168,208],[207,-151],[288,81],[202,-277],[157,-209],[316,116],[125,232],[283,162],[365,-35],[108,-220],[229,220],[299,69],[326,23],[294,-11],[310,-70],[300,-34],[130,-197],[180,-174],[304,104],[327,24],[315,0],[310,11],[278,81],[294,70],[245,162],[261,104],[283,58],[212,162],[152,324],[158,197],[288,-93],[109,-208],[239,-139],[289,46],[196,-208],[206,-151],[283,139],[98,255],[250,104],[289,197],[272,81],[326,116],[218,127],[228,139],[218,127],[261,-69],[250,208],[180,162],[261,-11],[229,139],[54,208],[234,162],[228,116],[278,93],[256,46],[244,-35],[262,-58],[223,-162],[27,-254],[245,-197],[168,-162],[332,-70],[185,-162],[229,-162],[266,-35],[223,116],[240,243],[261,-127],[272,-70],[261,-69],[272,-46],[277,0],[229,-614],[-11,-150],[-33,-267],[-266,-150],[-218,-220],[38,-232],[310,12],[-38,-232],[-141,-220],[-131,-243],[212,-185],[321,-58],[321,104],[153,232],[92,220],[153,185],[174,174],[70,208],[147,289],[174,58],[316,24],[277,69],[283,93],[136,231],[82,220],[190,220],[272,151],[234,115],[153,197],[157,104],[202,93],[277,-58],[250,58],[272,69],[305,-34],[201,162],[142,393],[103,-162],[131,-278],[234,-115],[266,-47],[267,70],[283,-46],[261,-12],[174,58],[234,-35],[212,-127],[250,81],[300,0],[255,81],[289,-81],[185,197],[141,196],[191,163],[348,439],[179,-81],[212,-162],[185,-208],[354,-359],[272,-12],[256,0],[299,70],[299,81],[229,162],[190,174],[310,23],[207,127],[218,-116],[141,-185],[196,-185],[305,23],[190,-150],[332,-151],[348,-58],[288,47],[218,185],[185,185],[250,46],[251,-81],[288,-58],[261,93],[250,0],[245,-58],[256,-58],[250,104],[299,93],[283,23],[316,0],[255,58],[251,46],[76,290],[11,243],[174,-162],[49,-266],[92,-244],[115,-196],[234,-105],[315,35],[365,12],[250,35],[364,0],[262,11],[364,-23],[310,-46],[196,-186],[-54,-220],[179,-173],[299,-139],[310,-151],[360,-104],[375,-92],[283,-93],[315,-12],[180,197],[245,-162],[212,-185],[245,-139],[337,-58],[321,-69],[136,-232],[316,-139],[212,-208],[310,-93],[321,12],[299,-35],[332,12],[332,-47],[310,-81],[288,-139],[289,-116],[195,-173],[-32,-232],[-147,-208],[-125,-266],[-98,-209],[-131,-243],[-364,-93],[-163,-208],[-360,-127],[-125,-232],[-190,-220],[-201,-185],[-115,-243],[-70,-220],[-28,-266],[6,-220],[158,-232],[60,-220],[130,-208],[517,-81],[109,-255],[-501,-93],[-424,-127],[-528,-23],[-234,-336],[-49,-278],[-119,-220],[-147,-220],[370,-196],[141,-244],[239,-219],[338,-197],[386,-186],[419,-185],[636,-185],[142,-289],[800,-128],[53,-45],[208,-175],[767,151],[636,-186],[-99520,-142]],[[69148,21851],[179,-186],[263,-74],[9,-112],[-77,-269],[-427,-38],[-7,314],[41,244],[19,121]],[[90387,26479],[269,-204],[151,81],[217,113],[166,-39],[20,-702],[-95,-203],[-29,-476],[-97,162],[-193,-412],[-57,32],[-171,19],[-171,505],[-38,390],[-160,515],[7,271],[181,-52]],[[89877,42448],[100,-464],[179,223],[92,-250],[133,-231],[-29,-262],[60,-506],[42,-295],[70,-72],[75,-505],[-27,-307],[90,-400],[301,-309],[197,-281],[186,-257],[-37,-143],[159,-371],[108,-639],[111,130],[113,-256],[68,91],[48,-626],[197,-363],[129,-226],[217,-478],[78,-475],[7,-337],[-19,-365],[132,-502],[-16,-523],[-48,-274],[-75,-527],[6,-339],[-55,-423],[-123,-538],[-205,-290],[-102,-458],[-93,-292],[-82,-510],[-107,-294],[-70,-442],[-36,-407],[14,-187],[-159,-205],[-311,-22],[-257,-242],[-127,-229],[-168,-254],[-230,262],[-170,104],[43,308],[-152,-112],[-243,-428],[-240,160],[-158,94],[-159,42],[-269,171],[-179,364],[-52,449],[-64,298],[-137,240],[-267,71],[91,287],[-67,438],[-136,-408],[-247,-109],[146,327],[42,341],[107,289],[-22,438],[-226,-504],[-174,-202],[-106,-470],[-217,243],[9,313],[-174,429],[-147,221],[52,137],[-356,358],[-195,17],[-267,287],[-498,-56],[-359,-211],[-317,-197],[-265,39],[-294,-303],[-241,-137],[-53,-309],[-103,-240],[-236,-15],[-174,-52],[-246,107],[-199,-64],[-191,-27],[-165,-315],[-81,26],[-140,-167],[-133,-187],[-203,23],[-186,0],[-295,377],[-149,113],[6,338],[138,81],[47,134],[-10,212],[34,411],[-31,350],[-147,598],[-45,337],[12,336],[-111,385],[-7,174],[-123,235],[-35,463],[-158,467],[-39,252],[122,-255],[-93,548],[137,-171],[83,-229],[-5,303],[-138,465],[-26,186],[-65,177],[31,341],[56,146],[38,295],[-29,346],[114,425],[21,-450],[118,406],[225,198],[136,252],[212,217],[126,46],[77,-73],[219,220],[168,66],[42,129],[74,54],[153,-14],[292,173],[151,262],[71,316],[163,300],[13,236],[7,321],[194,502],[117,-510],[119,118],[-99,279],[87,287],[122,-128],[34,449],[152,291],[67,233],[140,101],[4,165],[122,-69],[5,148],[122,85],[134,80],[205,-271],[155,-350],[173,-4],[177,-56],[-59,325],[133,473],[126,155],[-44,147],[121,338],[168,208],[142,-70],[234,111],[-5,302],[-204,195],[148,86],[184,-147],[148,-242],[234,-151],[79,60],[172,-182],[162,169],[105,-51],[65,113],[127,-292],[-74,-316],[-105,-239],[-96,-20],[32,-236],[-81,-295],[-99,-291],[20,-166],[221,-327],[214,-189],[143,-204],[201,-350],[78,1],[145,-151],[43,-183],[265,-200],[183,202],[55,317],[56,262],[34,324],[85,470],[-39,286],[20,171],[-32,339],[37,445],[53,120],[-43,197],[67,313],[52,325],[7,168],[104,222],[78,-289],[19,-371],[70,-71],[11,-249],[101,-300],[21,-335],[-10,-214]],[[54716,79012],[-21,-241],[-156,-2],[53,-128],[-92,-380]],[[54500,78261],[-53,-100],[-243,-14],[-140,-134],[-229,45]],[[53835,78058],[-398,153],[-62,205],[-274,-102],[-32,-113],[-169,84]],[[52900,78285],[-142,16],[-125,108],[42,145],[-10,104]],[[52665,78658],[83,33],[141,-164],[39,156],[245,-25],[199,106],[133,-18],[87,-121],[26,100],[-40,385],[100,75],[98,272]],[[53776,79457],[206,-190],[157,242],[98,44],[215,-180],[131,30],[128,-111]],[[54711,79292],[-23,-75],[28,-205]],[[62817,73469],[-190,78],[-141,273],[-44,223]],[[63495,75281],[146,-311],[141,-419],[130,-28],[85,-159],[-228,-47],[-49,-459],[-48,-207],[-101,-138],[7,-293]],[[63578,73220],[-69,-29],[-173,309],[95,292],[-82,174],[-104,-44],[-327,-436]],[[62492,74950],[68,96],[207,-169],[149,-36],[38,70],[-136,319],[72,82]],[[62890,75312],[78,-20],[191,-359],[122,-40],[48,150],[166,238]],[[58149,47921],[-17,713],[-70,268]],[[58062,48902],[169,-46],[85,336],[147,-38]],[[58463,49154],[16,-233],[60,-134],[3,-192],[-69,-124],[-108,-308],[-101,-214],[-115,-28]],[[50920,80916],[204,-47],[257,123],[176,-258],[153,-138]],[[51710,80596],[-32,-400]],[[51678,80196],[-72,-22],[-30,-331]],[[51576,79843],[-243,269],[-143,-46],[-194,279],[-129,237],[-129,10],[-40,207]],[[50698,80799],[222,117]],[[50747,54278],[-229,-69]],[[50518,54209],[-69,407],[13,1357],[-56,122],[-11,290],[-96,207],[-85,174],[35,311]],[[50249,57077],[96,67],[56,258],[136,56],[61,176]],[[50598,57634],[93,173],[100,2],[212,-340]],[[51003,57469],[-11,-197],[62,-350],[-54,-238],[29,-159],[-135,-366],[-86,-181],[-52,-372],[7,-376],[-16,-952]],[[49214,56277],[-190,152],[-130,-22],[-97,-149],[-125,125],[-49,195],[-125,129]],[[48498,56707],[-18,343],[76,250],[-7,200],[221,490],[41,405],[76,144],[134,-79],[116,120],[38,152],[216,265],[53,184],[259,246],[153,84],[70,-114],[178,3]],[[50104,59400],[-22,-286],[37,-269],[156,-386],[9,-286],[320,-134],[-6,-405]],[[50249,57077],[-243,13]],[[50006,57090],[-128,47],[-90,-96],[-123,43],[-482,-27],[-7,-336],[38,-444]],[[75742,63602],[-6,-424],[-97,90],[18,-476]],[[75657,62792],[-79,308],[-16,301],[-53,285],[-116,344],[-256,23],[25,-243],[-87,-329],[-118,120],[-41,-108],[-78,65],[-108,53]],[[74730,63611],[-43,486],[-96,444],[47,356],[-171,159],[62,215],[173,220],[-200,313],[98,401],[220,-255],[133,-30],[24,-410],[265,-81],[257,8],[160,-101],[-128,-500],[-124,-34],[-86,-336],[152,-306],[46,377],[76,2],[147,-937]],[[56293,76715],[80,-243],[108,43],[213,-92],[408,-31],[138,150],[327,138],[202,-215],[163,-62]],[[57932,76403],[-144,-245],[-101,-422],[89,-337]],[[57776,75399],[-239,79],[-283,-186]],[[57254,75292],[-3,-294],[-252,-56],[-196,206],[-222,-162],[-206,17]],[[56375,75003],[-20,391],[-139,189]],[[56216,75583],[46,84],[-30,70],[47,188],[105,185],[-135,255],[-24,216],[68,134]],[[28462,64617],[-68,-29],[-70,340],[-104,171],[60,375],[84,-23],[97,-491],[1,-343]],[[28383,66284],[-303,-95],[-19,219],[130,47],[184,-18],[8,-153]],[[28611,66290],[-48,-420],[-51,75],[4,309],[-124,234],[-1,67],[220,-265]],[[55279,77084],[100,2],[-69,-260],[134,-227],[-41,-278],[-65,-27]],[[55338,76294],[-52,-53],[-90,-138],[-41,-325]],[[55155,75778],[-246,224],[-105,247],[-106,130],[-127,221],[-61,183],[-136,277],[59,245],[99,-136],[60,123],[130,13],[239,-98],[192,8],[126,-131]],[[56523,82432],[268,-4],[302,223],[64,333],[228,190],[-26,264]],[[57359,83438],[169,100],[298,228]],[[57826,83766],[293,-149],[39,-146],[146,70],[272,-141],[27,-277],[-60,-159],[174,-387],[113,-108],[-16,-107],[187,-104],[80,-157],[-108,-129],[-224,20],[-54,-55],[66,-196],[68,-379]],[[58829,81362],[-239,-35],[-85,-129],[-18,-298],[-111,57],[-250,-28],[-73,138],[-104,-103],[-105,86],[-218,12],[-310,141],[-281,47],[-215,-14],[-152,-160],[-133,-23]],[[56535,81053],[-6,263],[-85,274],[166,121],[2,235],[-77,225],[-12,261]],[[25238,61101],[-2,87],[33,27],[51,-70],[99,357],[53,8]],[[25472,61510],[1,-87],[53,-3],[-5,-160],[-45,-256],[24,-91],[-29,-212],[18,-56],[-32,-299],[-55,-156],[-50,-19],[-55,-205]],[[25297,59966],[-83,0],[22,667],[2,468]],[[31359,37147],[-200,-81],[-109,814],[-150,663],[88,572],[-146,250],[-37,426],[-136,402]],[[30669,40193],[175,638],[-119,496],[63,199],[-49,219],[108,295],[6,503],[13,415],[60,200],[-240,951]],[[30686,44109],[206,-50],[143,13],[62,179],[243,239],[147,222],[363,100],[-29,-443],[34,-227],[-23,-396],[302,-529],[311,-98],[109,-220],[188,-117],[115,-172],[175,6],[161,-175],[12,-342],[55,-172],[3,-255],[-81,-10],[107,-688],[533,-24],[-41,-342],[30,-233],[151,-166],[66,-367],[-49,-465],[-77,-259],[27,-337],[-87,-122]],[[33842,38659],[-4,182],[-259,302],[-258,9],[-484,-172],[-133,-520],[-7,-318],[-110,-708]],[[34826,35372],[54,341],[38,350],[0,325],[-100,107],[-104,-96],[-103,26],[-33,228],[-26,541],[-52,177],[-187,160],[-114,-116],[-293,113],[18,802],[-82,329]],[[30686,44109],[-157,-102],[-126,68],[18,898],[-228,-348],[-245,15],[-105,315],[-184,34],[59,254],[-155,359],[-115,532],[73,108],[0,250],[168,171],[-28,319],[71,206],[20,275],[318,402],[227,114],[37,89],[251,-28]],[[30585,48040],[125,1620],[6,256],[-43,339],[-123,215],[1,430],[156,97],[56,-61],[9,226],[-162,61],[-4,370],[541,-13],[92,203],[77,-187],[55,-349],[52,73]],[[31423,51320],[153,-312],[216,38],[54,181],[206,138],[115,97],[32,250],[198,168],[-15,124],[-235,51],[-39,372],[12,396],[-125,153],[52,55],[206,-76],[221,-148],[80,140],[200,92],[310,221],[102,225],[-37,167]],[[33129,53652],[145,26],[64,-136],[-36,-259],[96,-90],[63,-274],[-77,-209],[-44,-502],[71,-299],[20,-274],[171,-277],[137,-29],[30,116],[88,25],[126,104],[90,157],[154,-50],[67,21]],[[34294,51702],[151,-48],[25,120],[-46,118],[28,171],[112,-53],[131,61],[159,-125]],[[34854,51946],[121,-122],[86,160],[62,-25],[38,-166],[133,42],[107,224],[85,436],[164,540]],[[35650,53035],[95,28],[69,-327],[155,-1033],[149,-97],[7,-408],[-208,-487],[86,-178],[491,-92],[10,-593],[211,388],[349,-212],[462,-361],[135,-346],[-45,-327],[323,182],[540,-313],[415,23],[411,-489],[355,-662],[214,-170],[237,-24],[101,-186],[94,-752],[46,-358],[-110,-977],[-142,-385],[-391,-822],[-177,-668],[-206,-513],[-69,-11],[-78,-435],[20,-1107],[-77,-910],[-30,-390],[-88,-233],[-49,-790],[-282,-771],[-47,-610],[-225,-256],[-65,-355],[-302,2],[-437,-227],[-195,-263],[-311,-173],[-327,-470],[-235,-586],[-41,-441],[46,-326],[-51,-597],[-63,-289],[-195,-325],[-308,-1040],[-244,-468],[-189,-277],[-127,-562],[-183,-337]],[[35174,30629],[-77,334],[122,280],[-160,402],[-218,327],[-286,379],[-103,-18],[-279,457],[-180,-63]],[[81723,53254],[110,221],[236,323]],[[82069,53798],[-13,-291],[-16,-377],[-133,19],[-58,-202],[-126,307]],[[75471,66988],[113,-189],[-20,-363],[-227,-17],[-234,39],[-175,-92],[-252,224],[-6,119]],[[74670,66709],[184,439],[150,150],[198,-137],[147,-14],[122,-159]],[[58175,37528],[-393,-435],[-249,-442],[-93,-393],[-83,-222],[-152,-47],[-48,-283],[-28,-184],[-178,-138],[-226,29],[-133,166],[-117,71],[-135,-137],[-68,-283],[-132,-177],[-139,-264],[-199,-60],[-62,207],[26,360],[-165,562],[-75,88]],[[55526,35946],[0,1725],[274,20],[8,2105],[207,19],[428,207],[106,-243],[177,231],[85,2],[156,133]],[[56967,40145],[50,-44]],[[57017,40101],[107,-473],[56,-105],[87,-342],[315,-649],[119,-64],[0,-208],[82,-375],[215,-90],[177,-267]],[[54244,54965],[229,44],[52,152],[46,-11],[69,-134],[350,226],[118,230],[145,207],[-28,208],[78,54],[269,-36],[261,273],[201,645],[141,239],[176,101]],[[56351,57163],[31,-253],[160,-369],[1,-241],[-45,-246],[18,-184],[96,-170]],[[56612,55700],[212,-258]],[[56824,55442],[152,-239],[2,-192],[187,-308],[116,-255],[70,-355],[208,-234],[44,-187]],[[57603,53672],[-91,-63],[-178,14],[-209,62],[-104,-51],[-41,-143],[-90,-18],[-110,125],[-309,-295],[-127,60],[-38,-46],[-83,-357],[-207,115],[-203,59],[-177,218],[-229,200],[-149,-190],[-108,-300],[-25,-412]],[[55125,52650],[-178,33],[-188,99],[-166,-313],[-146,-550]],[[54447,51919],[-29,172],[-12,269],[-127,190],[-103,305],[-23,212],[-132,309],[23,176],[-28,249],[21,458],[67,107],[140,599]],[[32315,78082],[202,-79],[257,16],[-137,-242],[-102,-38],[-353,250],[-69,198],[105,183],[97,-288]],[[32831,79592],[-135,-11],[-360,186],[-258,279],[96,49],[365,-148],[284,-247],[8,-108]],[[15692,79240],[-140,-82],[-456,269],[-84,209],[-248,207],[-50,168],[-286,107],[-107,321],[24,137],[291,-129],[171,-89],[261,-63],[94,-204],[138,-280],[277,-244],[115,-327]],[[34407,80527],[-184,-517],[181,199],[187,-126],[-98,-206],[247,-162],[128,144],[277,-182],[-86,-433],[194,101],[36,-313],[86,-367],[-117,-520],[-125,-22],[-183,111],[60,484],[-77,75],[-322,-513],[-166,21],[196,277],[-267,144],[-298,-35],[-539,18],[-43,175],[173,208],[-121,160],[234,356],[287,941],[172,336],[241,204],[129,-26],[-54,-160],[-148,-372]],[[13005,82584],[131,-76],[267,47],[-84,-671],[242,-475],[-111,1],[-167,270],[-103,272],[-140,184],[-51,260],[16,188]],[[27981,87304],[-108,-310],[-123,50],[-73,176],[13,41],[107,177],[114,-13],[70,-121]],[[27250,87631],[-325,-326],[-196,13],[-61,160],[207,273],[381,-6],[-6,-114]],[[26344,89371],[51,-259],[143,91],[161,-155],[304,-203],[318,-184],[25,-281],[204,46],[199,-196],[-247,-186],[-432,142],[-156,266],[-275,-314],[-396,-306],[-95,346],[-377,-57],[242,292],[35,465],[95,542],[201,-49]],[[28926,90253],[-312,-30],[-69,289],[118,331],[255,82],[217,-163],[3,-253],[-32,-82],[-180,-174]],[[23431,91410],[-173,-207],[-374,179],[-226,-65],[-380,266],[245,183],[194,256],[295,-168],[166,-106],[84,-112],[169,-226]],[[31350,77248],[-181,334],[0,805],[-123,171],[-187,-100],[-92,155],[-212,-446],[-84,-460],[-99,-269],[-118,-91],[-89,-30],[-28,-146],[-512,0],[-422,-4],[-125,-109],[-294,-425],[-34,-46],[-89,-231],[-255,1],[-273,-3],[-125,-93],[44,-116],[25,-181],[-5,-60],[-363,-293],[-286,-93],[-323,-316],[-70,0],[-94,93],[-31,85],[6,61],[61,207],[131,325],[81,349],[-56,514],[-59,536],[-290,277],[35,105],[-41,73],[-76,0],[-56,93],[-14,140],[-54,-61],[-75,18],[17,59],[-65,58],[-27,155],[-216,189],[-224,197],[-272,229],[-261,214],[-248,-167],[-91,-6],[-342,154],[-225,-77],[-269,183],[-284,94],[-194,36],[-86,100],[-49,325],[-94,-3],[-1,-227],[-575,0],[-951,0],[-944,0],[-833,0],[-834,0],[-819,0],[-847,0],[-273,0],[-825,0],[-788,0]],[[15878,79530],[-38,1],[-537,581],[-199,255],[-503,244],[-155,523],[40,363],[-356,252],[-48,476],[-336,429],[-6,304]],[[13740,82958],[154,285],[-7,373],[-473,376],[-284,674],[-173,424],[-255,266],[-187,242],[-147,306],[-279,-192],[-270,-330],[-247,388],[-194,259],[-271,164],[-273,17],[1,3364],[2,2193]],[[10837,91767],[518,-142],[438,-285],[289,-54],[244,247],[336,184],[413,-72],[416,259],[455,148],[191,-245],[207,138],[62,278],[192,-63],[470,-530],[369,401],[38,-449],[341,97],[105,173],[337,-34],[424,-248],[650,-217],[383,-100],[272,38],[374,-300],[-390,-293],[502,-127],[750,70],[236,103],[296,-354],[302,299],[-283,251],[179,202],[338,27],[223,59],[224,-141],[279,-321],[310,47],[491,-266],[431,94],[405,-14],[-32,367],[247,103],[431,-200],[-2,-559],[177,471],[223,-16],[126,594],[-298,364],[-324,239],[22,653],[329,429],[366,-95],[281,-261],[378,-666],[-247,-290],[517,-120],[-1,-604],[371,463],[332,-380],[-83,-438],[269,-399],[290,427],[202,510],[16,649],[394,-46],[411,-87],[373,-293],[17,-293],[-207,-315],[196,-316],[-36,-288],[-544,-413],[-386,-91],[-287,178],[-83,-297],[-268,-498],[-81,-259],[-322,-399],[-397,-39],[-220,-250],[-18,-384],[-323,-74],[-340,-479],[-301,-665],[-108,-466],[-16,-686],[409,-99],[125,-553],[130,-448],[388,117],[517,-256],[277,-225],[199,-279],[348,-163],[294,-248],[459,-34],[302,-58],[-45,-511],[86,-594],[201,-661],[414,-561],[214,192],[150,607],[-145,934],[-196,311],[445,276],[314,415],[154,411],[-23,395],[-188,502],[-338,445],[328,619],[-121,535],[-93,922],[194,137],[476,-161],[286,-57],[230,155],[258,-200],[342,-343],[85,-229],[495,-45],[-8,-496],[92,-747],[254,-92],[201,-348],[402,328],[266,652],[184,274],[216,-527],[362,-754],[307,-709],[-112,-371],[370,-333],[250,-338],[442,-152],[179,-189],[110,-500],[216,-78],[112,-223],[20,-664],[-202,-222],[-199,-207],[-458,-210],[-349,-486],[-470,-96],[-594,125],[-417,4],[-287,-41],[-233,-424],[-354,-262],[-401,-782],[-320,-545],[236,97],[446,776],[583,493],[415,58],[246,-289],[-262,-397],[88,-637],[91,-446],[361,-295],[459,86],[278,664],[19,-429],[180,-214],[-344,-387],[-615,-351],[-276,-239],[-310,-426],[-211,44],[-11,500],[483,488],[-445,-19],[-309,-72]],[[18287,93781],[-139,-277],[618,179],[386,-298],[314,302],[254,-194],[227,-580],[140,244],[-197,606],[244,86],[276,-94],[311,-239],[175,-575],[86,-417],[466,-293],[502,-279],[-31,-260],[-456,-48],[178,-227],[-94,-217],[-503,93],[-478,160],[-322,-36],[-522,-201],[-704,-88],[-494,-56],[-151,279],[-379,161],[-246,-66],[-343,468],[185,62],[429,101],[392,-26],[362,103],[-537,138],[-594,-47],[-394,12],[-146,217],[644,237],[-428,-9],[-485,156],[233,443],[193,235],[744,359],[284,-114]],[[20972,93958],[-244,-390],[-434,413],[95,83],[372,24],[211,-130]],[[28794,93770],[25,-163],[-296,17],[-299,13],[-304,-80],[-80,36],[-306,313],[12,213],[133,39],[636,-63],[479,-325]],[[25955,93803],[219,-369],[256,477],[704,242],[477,-611],[-42,-387],[550,172],[263,235],[616,-299],[383,-282],[36,-258],[515,134],[290,-376],[670,-234],[242,-238],[263,-553],[-510,-275],[654,-386],[441,-130],[400,-543],[437,-39],[-87,-414],[-487,-687],[-342,253],[-437,568],[-359,-74],[-35,-338],[292,-344],[377,-272],[114,-157],[181,-584],[-96,-425],[-350,160],[-697,473],[393,-509],[289,-357],[45,-206],[-753,236],[-596,343],[-337,287],[97,167],[-414,304],[-405,286],[5,-171],[-803,-94],[-235,203],[183,435],[522,10],[571,76],[-92,211],[96,294],[360,576],[-77,261],[-107,203],[-425,286],[-563,201],[178,150],[-294,367],[-245,34],[-219,201],[-149,-175],[-503,-76],[-1011,132],[-588,174],[-450,89],[-231,207],[290,270],[-394,2],[-88,599],[213,528],[286,241],[717,158],[-204,-382]],[[22123,94208],[331,-124],[496,75],[72,-172],[-259,-283],[420,-254],[-50,-532],[-455,-229],[-268,50],[-192,225],[-690,456],[5,189],[567,-73],[-306,386],[329,286]],[[24112,93575],[-298,-442],[-317,22],[-173,519],[4,294],[145,251],[276,161],[579,-20],[530,-144],[-415,-526],[-331,-115]],[[16539,92755],[-731,-285],[-147,259],[-641,312],[119,250],[192,432],[241,388],[-272,362],[939,93],[397,-123],[709,-33],[270,-171],[298,-249],[-349,-149],[-681,-415],[-344,-414],[0,-257]],[[23996,94879],[-151,-229],[-403,44],[-337,155],[148,266],[399,159],[243,-208],[101,-187]],[[22639,95907],[212,-273],[9,-303],[-127,-440],[-458,-60],[-298,94],[5,345],[-455,-46],[-18,457],[299,-18],[419,201],[390,-34],[22,77]],[[19941,95601],[109,-210],[247,99],[291,-26],[49,-289],[-169,-281],[-940,-91],[-701,-256],[-423,-14],[-35,193],[577,261],[-1255,-70],[-389,106],[379,577],[262,165],[782,-199],[493,-350],[485,-45],[-397,565],[255,215],[286,-68],[94,-282]],[[23699,96131],[308,-190],[547,1],[240,-194],[-64,-222],[319,-134],[177,-140],[374,-26],[406,-50],[441,128],[566,51],[451,-42],[298,-223],[62,-244],[-174,-157],[-414,-127],[-355,72],[-797,-91],[-570,-11],[-449,73],[-738,190],[-96,325],[-34,293],[-279,258],[-574,72],[-322,183],[104,242],[573,-37]],[[17722,96454],[-38,-454],[-214,-205],[-259,-29],[-517,-252],[-444,-91],[-377,128],[472,442],[570,383],[426,-9],[381,87]],[[23933,96380],[-126,-17],[-521,38],[-74,165],[559,-9],[195,-109],[-33,-68]],[[19392,96485],[-518,-170],[-411,191],[224,188],[406,60],[392,-92],[-93,-177]],[[19538,97019],[-339,-115],[-461,1],[5,84],[285,177],[149,-27],[361,-120]],[[23380,96697],[-411,-122],[-226,138],[-119,221],[-22,245],[360,-24],[162,-39],[332,-205],[-76,-214]],[[22205,96856],[108,-247],[-453,66],[-457,192],[-619,21],[268,176],[-335,142],[-21,227],[546,-81],[751,-215],[212,-281]],[[25828,97644],[334,-190],[-381,-176],[-513,-445],[-492,-42],[-575,76],[-299,240],[4,215],[220,157],[-508,-4],[-306,196],[-176,268],[193,262],[192,180],[285,42],[-122,135],[646,30],[355,-315],[468,-127],[455,-112],[220,-390]],[[30972,99681],[742,-47],[597,-75],[508,-161],[-12,-157],[-678,-257],[-672,-119],[-251,-133],[605,3],[-656,-358],[-452,-167],[-476,-483],[-573,-98],[-177,-120],[-841,-64],[383,-74],[-192,-105],[230,-292],[-264,-202],[-429,-167],[-132,-232],[-388,-176],[39,-134],[475,23],[6,-144],[-742,-355],[-726,163],[-816,-91],[-414,71],[-525,31],[-35,284],[514,133],[-137,427],[170,41],[742,-255],[-379,379],[-450,113],[225,229],[492,141],[79,206],[-392,231],[-118,304],[759,-26],[220,-64],[433,216],[-625,68],[-972,-38],[-491,201],[-232,239],[-324,173],[-61,202],[413,112],[324,19],[545,96],[409,220],[344,-30],[300,-166],[211,319],[367,95],[498,65],[849,24],[148,-63],[802,100],[601,-38],[602,-37]],[[52900,78285],[-22,-242],[-122,-100],[-206,75],[-60,-239],[-132,-19],[-48,94],[-156,-200],[-134,-28],[-120,126]],[[51900,77752],[-95,259],[-133,-92],[5,267],[203,332],[-9,150],[126,-54],[77,101]],[[52074,78715],[236,-4],[57,128],[298,-181]],[[31400,18145],[-92,-239],[-238,-183],[-137,19],[-164,48],[-202,177],[-291,86],[-350,330],[-283,317],[-383,662],[229,-124],[390,-395],[369,-212],[143,271],[90,405],[256,244],[198,-70]],[[30952,19680],[-247,4],[-134,-145],[-250,-213],[-45,-552],[-118,-14],[-313,192],[-318,412],[-346,338],[-87,374],[79,346],[-140,393],[-36,1007],[119,568],[293,457],[-422,172],[265,522],[94,982],[309,-208],[145,1224],[-186,157],[-87,-738],[-175,83],[87,845],[95,1095],[127,404],[-80,576],[-22,666],[117,19],[170,954],[192,945],[118,881],[-64,885],[83,487],[-34,730],[163,721],[50,1143],[89,1227],[87,1321],[-20,967],[-58,832]],[[30452,39739],[143,151],[74,303]],[[80649,61615],[-240,-284],[-228,183],[-8,509],[137,267],[304,166],[159,-14],[62,-226],[-122,-260],[-64,-341]],[[86288,75628],[-179,348],[-111,-331],[-429,-254],[44,-312],[-241,22],[-131,185],[-191,-419],[-306,-318],[-227,-379]],[[84517,74170],[-388,-171],[-204,-277],[-300,-161],[148,274],[-58,230],[220,397],[-147,310],[-242,-209],[-314,-411],[-171,-381],[-272,-29],[-142,-275],[147,-400],[227,-97],[9,-265],[220,-173],[311,422],[247,-230],[179,-15],[45,-310],[-393,-165],[-130,-319],[-270,-296],[-142,-414],[299,-325],[109,-581],[169,-541],[189,-454],[-5,-439],[-174,-161],[66,-315],[164,-184],[-43,-481],[-71,-468],[-155,-53],[-203,-640],[-225,-775],[-258,-705],[-382,-545],[-386,-498],[-313,-68],[-170,-262],[-96,192],[-157,-294],[-388,-296],[-294,-90],[-95,-624],[-154,-35],[-73,429],[66,228],[-373,189],[-131,-96]],[[80013,63313],[-280,154],[-132,240],[44,340],[-254,108],[-134,222],[-236,-315],[-271,-68],[-221,3],[-149,-145]],[[78380,63852],[-144,-86],[42,-676],[-148,16],[-25,139]],[[78105,63245],[-9,244],[-203,-172],[-121,109],[-206,222],[81,490],[-176,115],[-66,544],[-293,-98],[33,701],[263,493],[11,487],[-8,452],[-121,141],[-93,348],[-162,-44]],[[77035,67277],[-300,89],[94,248],[-130,367],[-198,-249],[-233,145],[-321,-376],[-252,-439],[-224,-74]],[[74670,66709],[-23,465],[-170,-124]],[[74477,67050],[-324,57],[-314,136],[-225,259],[-216,117],[-93,284],[-157,84],[-280,385],[-223,182],[-115,-141]],[[72530,68413],[-386,413],[-273,374],[-78,651],[200,-79],[9,301],[-111,303],[28,482],[-298,692]],[[71621,71550],[-457,239],[-82,454],[-205,276]],[[70827,72688],[-42,337],[10,230],[-169,134],[-91,-59],[-70,546]],[[70465,73876],[79,136],[-39,138],[266,279],[192,116],[294,-80],[105,378],[356,70],[99,234],[438,320],[39,134]],[[72294,75601],[-22,337],[190,154],[-250,1026],[550,236],[143,131],[200,1058],[551,-194],[155,267],[13,592],[230,56],[212,393]],[[74266,79657],[109,49]],[[74375,79706],[73,-413],[233,-313],[396,-222],[192,-476],[-107,-690],[100,-256],[330,-101],[374,-83],[336,-368],[171,-66],[127,-544],[163,-351],[306,14],[574,-133],[369,82],[274,-88],[411,-359],[336,1],[123,-184],[324,318],[448,205],[417,22],[324,208],[200,316],[194,199],[-45,195],[-89,227],[146,381],[156,-53],[286,-120],[277,313],[423,229],[204,391],[195,168],[404,78],[219,-66],[30,210],[-251,413],[-223,189],[-214,-219],[-274,92],[-157,-74],[-72,241],[197,590],[135,446]],[[82410,80055],[333,-223],[392,373],[-3,260],[251,627],[155,189],[-4,326],[-152,141],[229,294],[345,106],[369,16],[415,-176],[244,-217],[172,-596],[104,-254],[97,-363],[103,-579],[483,-189],[329,-420],[112,-555],[423,-1],[240,233],[459,175],[-146,-532],[-107,-216],[-96,-647],[-186,-575],[-338,104],[-238,-208],[73,-506],[-40,-698],[-142,-16],[2,-300]],[[49206,53531],[-126,-7],[-194,116],[-178,-7],[-329,-103],[-193,-170],[-275,-217],[-54,15]],[[47857,53158],[22,487],[26,74],[-8,233],[-118,247],[-88,40],[-81,162],[60,262],[-28,286],[13,172]],[[47655,55121],[44,0],[17,258],[-22,114],[27,82],[103,71],[-69,473],[-64,245],[23,200],[55,46]],[[47769,56610],[36,54],[77,-89],[215,-5],[51,172],[48,-11],[80,67],[43,-253],[65,74],[114,88]],[[49214,56277],[74,-841],[-117,-496],[-73,-667],[121,-509],[-13,-233]],[[53632,51919],[-35,32],[-164,-76],[-169,79],[-132,-38]],[[53132,51916],[-452,13]],[[52680,51929],[40,466],[-108,391],[-127,100],[-56,265],[-72,85],[4,163]],[[52361,53399],[71,418],[132,570],[81,6],[165,345],[105,10],[156,-243],[191,199],[26,246],[63,238],[43,299],[148,243],[56,414],[59,132],[39,307],[74,377],[234,457],[14,196],[31,107],[-110,235]],[[53939,57955],[9,188],[78,34]],[[54026,58177],[111,-378],[18,-392],[-10,-393],[151,-537],[-155,6],[-78,-42],[-127,60],[-60,-279],[164,-345],[121,-100],[39,-245],[87,-407],[-43,-160]],[[54447,51919],[-20,-319],[-220,140],[-225,156],[-350,23]],[[58564,52653],[-16,-691],[111,-80],[-89,-210],[-107,-157],[-106,-308],[-59,-274],[-15,-475],[-65,-225],[-2,-446]],[[58216,49787],[-80,-165],[-10,-351],[-38,-46],[-26,-323]],[[58149,47921],[50,-544],[-27,-307]],[[58172,47070],[55,-343],[161,-330]],[[58388,46397],[150,-745]],[[58538,45652],[-109,60],[-373,-99],[-75,-71],[-79,-377],[62,-261],[-49,-699],[-34,-593],[75,-105],[194,-230],[76,107],[23,-637],[-212,5],[-114,325],[-103,252],[-213,82],[-62,310],[-170,-187],[-222,83],[-93,268],[-176,55],[-131,-15],[-15,184],[-96,15]],[[53422,46976],[-39,183]],[[53609,47755],[73,-60],[95,226],[152,-6],[17,-167],[104,-105],[164,370],[161,289],[71,189],[-10,486],[121,574],[127,304],[183,285],[32,189],[7,216],[45,205],[-14,335],[34,524],[55,368],[83,316],[16,357]],[[57603,53672],[169,-488],[124,-71],[75,99],[128,-39],[155,125],[66,-252],[244,-393]],[[53309,47603],[-228,626]],[[53081,48229],[212,326],[-105,391],[95,148],[187,73],[23,261],[148,-283],[245,-25],[85,279],[36,393],[-31,461],[-131,350],[120,684],[-69,117],[-207,-48],[-78,305],[21,258]],[[29063,50490],[-119,140],[-137,195],[-79,-94],[-235,82],[-68,255],[-52,-10],[-278,338]],[[28095,51396],[-37,183],[103,44],[-12,296],[65,214],[138,40],[117,371],[106,310],[-102,141],[52,343],[-62,540],[59,155],[-44,500],[-112,315]],[[28366,54848],[36,287],[89,-43],[52,176],[-64,348],[34,86]],[[28513,55702],[143,-18],[209,412],[114,63],[3,195],[51,500],[159,274],[175,11],[22,123],[218,-49],[218,298],[109,132],[134,285],[98,-36],[73,-156],[-54,-199]],[[30185,57537],[-178,-99],[-71,-295],[-107,-169],[-81,-220],[-34,-422],[-77,-345],[144,-40],[35,-271],[62,-130],[21,-238],[-33,-219],[10,-123],[69,-49],[66,-207],[357,57],[161,-75],[196,-508],[112,63],[200,-32],[158,68],[99,-102],[-50,-318],[-62,-199],[-22,-423],[56,-393],[79,-175],[9,-133],[-140,-294],[100,-130],[74,-207],[85,-589]],[[30585,48040],[-139,314],[-83,14],[179,602],[-213,276],[-166,-51],[-101,103],[-153,-157],[-207,74],[-163,620],[-129,152],[-89,279],[-184,280],[-74,-56]],[[26954,55439],[-151,131],[-56,124],[32,103],[-11,130],[-77,142],[-109,116],[-95,76],[-19,173],[-73,105],[18,-172],[-55,-141],[-64,164],[-89,58],[-38,120],[2,179],[36,187],[-78,83],[64,114]],[[26191,57131],[42,76],[183,-156],[63,77],[89,-50],[46,-121],[82,-40],[66,126]],[[26762,57043],[70,-321],[108,-238],[130,-252]],[[27070,56232],[-107,-53],[1,-238],[58,-88],[-41,-70],[10,-107],[-23,-120],[-14,-117]],[[27147,64280],[240,-42],[219,-7],[261,-201],[110,-216],[260,66],[98,-138],[235,-366],[173,-267],[92,8],[165,-120],[-20,-167],[205,-24],[210,-242],[-33,-138],[-185,-75],[-187,-29],[-191,46],[-398,-57],[186,329],[-113,154],[-179,39],[-96,171],[-66,336],[-157,-23],[-259,159],[-83,124],[-362,91],[-97,115],[104,148],[-273,30],[-199,-307],[-115,-8],[-40,-144],[-138,-65],[-118,56],[146,183],[60,213],[126,131],[142,116],[210,56],[67,65]],[[59092,71341],[19,3],[40,143],[200,-8],[253,176],[-188,-251],[21,-111]],[[59437,71293],[-30,21],[-53,-45],[-42,12],[-14,-22],[-5,59],[-20,37],[-54,6],[-75,-51],[-52,31]],[[59437,71293],[8,-48],[-285,-240],[-136,77],[-64,237],[132,22]],[[53776,79457],[-157,254],[-141,142],[-30,249],[-49,176],[202,129],[103,147],[200,114],[70,113],[73,-68],[124,62]],[[54171,80775],[132,-191],[207,-51],[-17,-163],[151,-122],[41,153],[191,-66],[26,-185],[207,-36],[127,-291]],[[55236,79823],[-82,-1],[-43,-106],[-64,-26],[-18,-134],[-54,-28],[-7,-55],[-95,-61],[-123,10],[-39,-130]],[[52756,83065],[4,-228],[281,-138],[-3,-210],[283,111],[156,162],[313,-233],[132,-189]],[[53922,82340],[64,-300],[-77,-158],[101,-210],[69,-316],[-22,-204],[114,-377]],[[52074,78715],[35,421],[140,404],[-400,109],[-131,155]],[[51718,79804],[16,259],[-56,133]],[[51710,80596],[-47,619],[167,0],[70,222],[69,541],[-51,200]],[[51918,82178],[54,125],[232,32],[52,-130],[188,291],[-63,222],[-13,335]],[[52368,83053],[210,-78],[178,90]],[[61966,58083],[66,-183],[-9,-245],[-158,-142],[119,-161]],[[61984,57352],[-102,-317]],[[61882,57035],[-62,106],[-67,-42],[-155,10],[-4,180],[-22,163],[94,277],[98,261]],[[61764,57990],[119,-51],[83,144]],[[53524,83435],[-166,-478],[-291,333],[-39,246],[408,195],[88,-296]],[[52368,83053],[-113,328],[-8,604],[46,159],[80,177],[244,37],[98,163],[223,167],[-9,-304],[-82,-192],[33,-166],[151,-89],[-68,-223],[-83,64],[-200,-425],[76,-288]],[[30080,62227],[34,101],[217,-3],[165,-152],[73,15],[50,-209],[152,11],[-9,-176],[124,-21],[136,-217],[-103,-240],[-132,128],[-127,-25],[-92,28],[-50,-107],[-106,-37],[-43,144],[-92,-85],[-111,-405],[-71,94],[-14,170]],[[30081,61241],[5,161],[-71,177],[68,99],[21,228],[-24,321]],[[53333,64447],[-952,-1126],[-804,-1161],[-392,-263]],[[51185,61897],[-308,-58],[-3,376],[-129,96],[-173,169],[-66,277],[-937,1289],[-937,1289]],[[48632,65335],[-1045,1431]],[[47587,66766],[6,114],[-1,40]],[[47592,66920],[-2,700],[449,436],[277,90],[227,159],[107,295],[324,234],[12,438],[161,51],[126,219],[363,99],[51,230],[-73,125],[-96,624],[-17,359],[-104,379]],[[49397,71358],[267,323],[300,102],[175,244],[268,180],[471,105],[459,48],[140,-87],[262,232],[297,5],[113,-137],[190,35]],[[52339,72408],[-57,-303],[44,-563],[-65,-487],[-171,-330],[24,-445],[227,-352],[3,-143],[171,-238],[118,-1061]],[[52633,68486],[90,-522],[15,-274],[-49,-482],[21,-270],[-36,-323],[24,-371],[-110,-247],[164,-431],[11,-253],[99,-330],[130,109],[219,-275],[122,-370]],[[27693,48568],[148,442],[-60,258],[-106,-275],[-166,259],[56,167],[-47,536],[97,89],[52,368],[105,381],[-20,241],[153,126],[190,236]],[[29063,50490],[38,-449],[-86,-384],[-303,-619],[-334,-233],[-170,-514],[-53,-398],[-157,-243],[-116,298],[-113,64],[-114,-47],[-8,216],[79,141],[-33,246]],[[59700,68010],[-78,-238],[-60,-446],[-75,-308],[-65,-103],[-93,191],[-125,263],[-198,847],[-29,-53],[115,-624],[171,-594],[210,-920],[102,-321],[90,-334],[249,-654],[-55,-103],[9,-384],[323,-530],[49,-121]],[[60240,63578],[-1102,0],[-1077,0],[-1117,0]],[[56944,63578],[0,2175],[0,2101],[-83,476],[71,365],[-43,253],[101,283]],[[56990,69231],[369,10],[268,-156],[275,-175],[129,-92],[214,188],[114,169],[245,49],[198,-75],[75,-293],[65,193],[222,-140],[217,-33],[137,149]],[[59518,69025],[182,-1015]],[[61764,57990],[-95,191],[-114,346],[-124,190],[-71,204],[-242,237],[-191,7],[-67,124],[-163,-139],[-168,268],[-87,-441],[-323,124]],[[60119,59101],[-30,236],[120,868],[27,393],[88,181],[204,97],[141,337]],[[60669,61213],[161,-684],[77,-542],[152,-288],[379,-558],[154,-336],[151,-341],[87,-203],[136,-178]],[[47490,75324],[14,420],[-114,257],[393,426],[340,-106],[373,3],[296,-101],[230,31],[449,-19]],[[49471,76235],[111,-230],[511,-268],[101,127],[313,-267],[322,77]],[[50829,75674],[15,-344],[-263,-393],[-356,-125],[-25,-199],[-171,-327],[-107,-481],[108,-338],[-160,-263],[-60,-384],[-210,-118],[-197,-454],[-352,-9],[-265,11],[-174,-209],[-106,-223],[-136,49],[-103,199],[-79,340],[-259,92]],[[47929,72498],[-23,195],[103,222],[38,161],[-96,175],[77,388],[-111,355],[120,48],[11,280],[45,86],[3,461],[129,160],[-78,296],[-162,21],[-47,-75],[-164,0],[-70,289],[-113,-86],[-101,-150]],[[56753,84725],[32,349],[-102,-75],[-176,210],[-24,340],[351,164],[350,86],[301,-97],[287,17]],[[57772,85719],[42,-103],[-198,-341],[83,-551],[-120,-187]],[[57579,84537],[-229,1],[-239,219],[-121,73],[-237,-105]],[[61882,57035],[-61,-209],[103,-325],[102,-285],[106,-210],[909,-702],[233,4]],[[63274,55308],[-785,-1773],[-362,-26],[-247,-417],[-178,-11],[-76,-186]],[[61626,52895],[-190,0],[-112,200],[-254,-247],[-82,-247],[-185,47],[-62,68],[-65,-16],[-87,6],[-352,502],[-193,0],[-95,194],[0,332],[-145,99]],[[59804,53833],[-164,643],[-127,137],[-48,236],[-141,288],[-171,42],[95,337],[147,14],[42,181]],[[59437,55711],[-4,531]],[[59433,56242],[82,618],[132,166],[28,241],[119,451],[168,293],[112,582],[45,508]],[[57942,91385],[-41,-414],[425,-394],[-256,-445],[323,-673],[-187,-506],[250,-440],[-113,-385],[411,-405],[-105,-301],[-258,-341],[-594,-755]],[[57797,86326],[-504,-47],[-489,-216],[-452,-125],[-161,323],[-269,193],[62,582],[-135,533],[133,345],[252,371],[635,640],[185,124],[-28,250],[-387,279]],[[56639,89578],[-93,230],[-8,910],[-433,402],[-371,289]],[[55734,91409],[167,156],[309,-312],[362,29],[298,-143],[265,262],[137,433],[431,200],[356,-235],[-117,-414]],[[99547,40335],[96,-171],[-46,-308],[-172,-81],[-153,73],[-27,260],[107,203],[126,-74],[69,98]],[[0,41087],[57,27],[-34,-284],[-23,-32],[99822,-145],[-177,-124],[-36,220],[139,121],[88,33],[-99836,184]],[[33000,19946],[333,354],[236,-148],[167,237],[222,-266],[-83,-207],[-375,-177],[-125,207],[-236,-266],[-139,266]],[[34854,51946],[70,252],[24,269],[48,253],[-107,349]],[[34889,53069],[-22,404],[144,508]],[[35011,53981],[95,-65],[204,-140],[294,-499],[46,-242]],[[52655,75484],[-92,-456],[-126,120],[-64,398],[56,219],[179,226],[47,-507]],[[51576,79843],[62,-52],[80,13]],[[51900,77752],[-11,-167],[82,-222],[-97,-180],[72,-457],[151,-75],[-32,-256]],[[52065,76395],[-252,-334],[-548,160],[-404,-192],[-32,-355]],[[49471,76235],[144,354],[53,1177],[-287,620],[-205,299],[-424,227],[-28,431],[360,129],[466,-152],[-88,669],[263,-254],[646,461],[84,484],[243,119]],[[53081,48229],[-285,596],[-184,488],[-169,610],[9,196],[61,189],[67,430],[56,438]],[[52636,51176],[94,35],[404,-6],[-2,711]],[[48278,82406],[-210,122],[-172,-9],[57,317],[-57,317]],[[47896,83153],[233,24],[298,-365],[-149,-406]],[[49165,85222],[-297,-639],[283,81],[304,-3],[-72,-481],[-250,-530],[287,-38],[22,-62],[248,-697],[190,-95],[171,-673],[79,-233],[337,-113],[-34,-378],[-142,-173],[111,-305],[-250,-310],[-371,6],[-473,-163],[-130,116],[-183,-276],[-257,67],[-195,-226],[-148,118],[407,621],[249,127],[-2,1],[-434,98],[-79,235],[291,183],[-152,319],[52,387],[413,-54],[1,0],[40,343],[-186,364],[-4,8],[-337,104],[-66,160],[101,264],[-92,163],[-149,-279],[-17,569],[-140,301],[101,611],[216,480],[222,-47],[335,49]],[[61542,75120],[42,252],[-70,403],[-160,218],[-154,68],[-102,181]],[[61098,76242],[34,70],[235,-101],[409,-96],[378,-283],[48,-110],[169,93],[259,-124],[85,-242],[175,-137]],[[62106,74858],[-268,290],[-296,-28]],[[50294,54083],[-436,-346],[-154,-203],[-250,-171],[-248,168]],[[50006,57090],[-20,-184],[116,-305],[-1,-429],[27,-466],[69,-215],[-61,-532],[22,-294],[74,-375],[62,-207]],[[47655,55121],[-78,15],[-57,-238],[-78,3],[-55,126],[19,237],[-116,362],[-73,-67],[-59,-13]],[[47158,55546],[-77,-34],[3,217],[-44,155],[9,171],[-60,249],[-78,211],[-222,1],[-65,-112],[-76,-13],[-48,-128],[-32,-163],[-148,-260]],[[46320,55840],[-122,349],[-108,232],[-71,76],[-69,118],[-32,261],[-41,130],[-80,97]],[[45797,57103],[123,288],[84,-11],[73,99],[61,1],[44,78],[-24,196],[31,62],[5,200]],[[46194,58016],[134,-6],[200,-144],[61,13],[21,66],[151,-47],[40,33]],[[46801,57931],[16,-216],[44,1],[73,78],[46,-19],[77,-150],[119,-48],[76,128],[90,79],[67,83],[55,-15],[62,-130],[33,-163],[114,-248],[-57,-152],[-11,-192],[59,58],[35,-69],[-15,-176],[85,-170]],[[45321,58350],[36,262]],[[45357,58612],[302,17],[63,140],[88,9],[110,-145],[86,-3],[92,99],[56,-170],[-120,-133],[-121,11],[-119,124],[-103,-136],[-50,-5],[-67,-83],[-253,13]],[[45797,57103],[-149,247],[-117,39],[-63,166],[1,90],[-84,125],[-18,127]],[[45367,57897],[147,96],[92,-19],[75,67],[513,-25]],[[52636,51176],[-52,90],[96,663]],[[56583,71675],[152,-199],[216,34],[207,-42],[-7,-103],[151,71],[-35,-175],[-400,-50],[3,98],[-339,115],[52,251]],[[57237,74699],[-169,17],[-145,56],[-336,-154],[192,-332],[-141,-96],[-154,-1],[-147,305],[-52,-130],[62,-353],[139,-277],[-105,-129],[155,-273],[137,-171],[4,-334],[-257,157],[82,-302],[-176,-62],[105,-521],[-184,-8],[-228,257],[-104,473],[-49,393],[-108,272],[-143,337],[-18,168]],[[55838,74710],[182,53],[106,129],[150,-12],[46,103],[53,20]],[[57254,75292],[135,-157],[-86,-369],[-66,-67]],[[37010,99398],[932,353],[975,-27],[354,218],[982,57],[2219,-74],[1737,-469],[-513,-227],[-1062,-26],[-1496,-58],[140,-105],[984,65],[836,-204],[540,181],[231,-212],[-305,-344],[707,220],[1348,229],[833,-114],[156,-253],[-1132,-420],[-157,-136],[-888,-102],[643,-28],[-324,-431],[-224,-383],[9,-658],[333,-386],[-434,-24],[-457,-187],[513,-313],[65,-502],[-297,-55],[360,-508],[-617,-42],[322,-241],[-91,-208],[-391,-91],[-388,-2],[348,-400],[4,-263],[-549,244],[-143,-158],[375,-148],[364,-361],[105,-476],[-495,-114],[-214,228],[-344,340],[95,-401],[-322,-311],[732,-25],[383,-32],[-745,-515],[-755,-466],[-813,-204],[-306,-2],[-288,-228],[-386,-624],[-597,-414],[-192,-24],[-370,-145],[-399,-138],[-238,-365],[-4,-415],[-141,-388],[-453,-472],[112,-462],[-125,-488],[-142,-577],[-391,-36],[-410,482],[-556,3],[-269,324],[-186,577],[-481,735],[-141,385],[-38,530],[-384,546],[100,435],[-186,208],[275,691],[418,220],[110,247],[58,461],[-318,-209],[-151,-88],[-249,-84],[-341,193],[-19,401],[109,314],[258,9],[567,-157],[-478,375],[-249,202],[-276,-83],[-232,147],[310,550],[-169,220],[-220,409],[-335,626],[-353,230],[3,247],[-745,346],[-590,43],[-743,-24],[-677,-44],[-323,188],[-482,372],[729,186],[559,31],[-1188,154],[-627,241],[39,229],[1051,285],[1018,284],[107,214],[-750,213],[243,235],[961,413],[404,63],[-115,265],[658,156],[854,93],[853,5],[303,-184],[737,325],[663,-221],[390,-46],[577,-192],[-660,318],[38,253]],[[24973,58695],[-142,103],[-174,11],[-127,117],[-149,244]],[[24381,59170],[7,172],[32,138],[-39,111],[133,481],[357,2],[7,201],[-45,36],[-31,128],[-103,136],[-103,198],[125,1],[1,333],[259,1],[257,-7]],[[25297,59966],[90,-107],[24,88],[82,-75]],[[25493,59872],[-127,-225],[-131,-166],[-20,-113],[22,-116],[-58,-150]],[[25179,59102],[-65,-37],[15,-69],[-52,-66],[-95,-149],[-9,-86]],[[33400,55523],[183,-217],[171,-385],[8,-304],[105,-14],[149,-289],[109,-205]],[[34125,54109],[-44,-532],[-169,-154],[15,-139],[-51,-305],[123,-429],[89,-1],[37,-333],[169,-514]],[[33129,53652],[-188,448],[75,163],[-5,273],[171,95],[69,110],[-95,220],[24,215],[220,347]],[[25745,58251],[-48,185],[-84,51]],[[25613,58487],[19,237],[-38,64],[-57,42],[-122,-70],[-10,79],[-84,95],[-60,118],[-82,50]],[[25493,59872],[29,-23],[61,104],[79,8],[26,-48],[43,29],[129,-53],[128,15],[90,66],[32,66],[89,-31],[66,-40],[73,14],[55,51],[127,-82],[44,-13],[85,-110],[80,-132],[101,-91],[73,-162]],[[26903,59440],[-95,12],[-38,-81],[-97,-77],[-70,0],[-61,-76],[-56,27],[-47,90],[-29,-17],[-36,-141],[-27,5],[-4,-121],[-97,-163],[-51,-70],[-29,-74],[-82,120],[-60,-158],[-58,4],[-65,-14],[6,-290],[-41,-5],[-35,-135],[-86,-25]],[[55230,77704],[67,-229],[89,-169],[-107,-222]],[[55155,75778],[-31,-100]],[[55124,75678],[-261,218],[-161,213],[-254,176],[-233,434],[56,45],[-127,248],[-5,200],[-179,93],[-85,-255],[-82,198],[6,205],[10,9]],[[53809,77462],[194,-20],[51,100],[94,-97],[109,-11],[-1,165],[97,60],[27,239],[221,157]],[[54601,78055],[88,-73],[208,-253],[229,-114],[104,89]],[[30081,61241],[-185,100],[-131,-41],[-169,43],[-130,-110],[-149,184],[24,190],[256,-82],[210,-47],[100,131],[-127,256],[2,226],[-175,92],[62,163],[170,-26],[241,-93]],[[54716,79012],[141,-151],[103,-65],[233,73],[22,118],[111,18],[135,92],[30,-38],[130,74],[66,139],[91,36],[297,-180],[59,61]],[[56134,79189],[155,-161],[19,-159]],[[56308,78869],[-170,-123],[-131,-401],[-168,-401],[-223,-111]],[[55616,77833],[-173,26],[-213,-155]],[[54601,78055],[-54,200],[-47,6]],[[83531,44530],[-117,-11],[-368,414],[259,116],[146,-180],[97,-180],[-17,-159]],[[84713,45326],[28,-117],[5,-179]],[[84746,45030],[-181,-441],[-238,-130],[-33,71],[25,201],[119,360],[275,235]],[[82749,45797],[100,-158],[172,48],[69,-251],[-321,-119],[-193,-79],[-149,5],[95,340],[153,5],[74,209]],[[84139,45797],[-41,-328],[-417,-168],[-370,73],[0,216],[220,123],[174,-177],[185,45],[249,216]],[[80172,46575],[533,-59],[61,244],[515,-284],[101,-383],[417,-108],[341,-351],[-317,-225],[-306,238],[-251,-16],[-288,44],[-260,106],[-322,225],[-204,59],[-116,-74],[-506,243],[-48,254],[-255,44],[191,564],[337,-35],[224,-231],[115,-45],[38,-210]],[[87423,46908],[-143,-402],[-27,445],[49,212],[58,200],[63,-173],[0,-282]],[[85346,48536],[-104,-196],[-192,108],[-54,254],[281,29],[69,-195]],[[86241,48752],[101,-452],[-234,244],[-232,49],[-157,-39],[-192,21],[65,325],[344,24],[305,-172]],[[89166,49043],[5,-1925],[4,-1925]],[[89175,45193],[-247,485],[-282,118],[-69,-168],[-352,-18],[118,481],[175,164],[-72,642],[-134,496],[-538,500],[-229,50],[-417,546],[-82,-287],[-107,-52],[-63,216],[-1,257],[-212,290],[299,213],[198,-11],[-23,156],[-407,1],[-110,352],[-248,109],[-117,293],[374,143],[142,192],[446,-242],[44,-220],[78,-955],[287,-354],[232,627],[319,356],[247,1],[238,-206],[206,-212],[298,-113]],[[84788,51419],[-223,-587],[-209,-113],[-267,115],[-463,-29],[-243,-85],[-39,-447],[248,-526],[150,268],[518,201],[-22,-272],[-121,86],[-121,-347],[-245,-229],[263,-757],[-50,-203],[249,-682],[-2,-388],[-148,-173],[-109,207],[134,484],[-273,-229],[-69,164],[36,228],[-200,346],[21,576],[-186,-179],[24,-689],[11,-846],[-176,-85],[-119,173],[79,544],[-43,570],[-117,4],[-86,405],[115,387],[40,469],[139,891],[58,243],[237,439],[217,-174],[350,-82],[319,25],[275,429],[48,-132]],[[85746,51249],[-15,-517],[-143,58],[-42,-359],[114,-312],[-78,-71],[-112,374],[-82,755],[56,472],[92,215],[20,-322],[164,-52],[26,-241]],[[80461,51765],[47,-395],[190,-334],[179,121],[177,-43],[162,299],[133,52],[263,-166],[226,126],[143,822],[107,205],[96,672],[319,0],[241,-100]],[[82744,53024],[-158,-533],[204,-560],[-48,-272],[312,-546],[-329,-70],[-93,-403],[12,-535],[-267,-404],[-7,-589],[-107,-903],[-41,210],[-316,-266],[-110,361],[-198,34],[-139,189],[-330,-212],[-101,285],[-182,-32],[-229,68],[-43,793],[-138,164],[-134,505],[-38,517],[32,548],[165,392]],[[79393,47122],[-308,-12],[-234,494],[-356,482],[-119,358],[-210,481],[-138,443],[-212,827],[-244,493],[-81,508],[-103,461],[-250,372],[-145,506],[-209,330],[-290,652],[-24,300],[178,-24],[430,-114],[246,-577],[215,-401],[153,-246],[263,-635],[283,-9],[233,-405],[161,-495],[211,-270],[-111,-482],[159,-205],[100,-15],[47,-412],[97,-330],[204,-52],[135,-374],[-70,-735],[-11,-914]],[[72530,68413],[-176,-268],[-108,-553],[269,-224],[262,-289],[362,-332],[381,-76],[160,-301],[215,-56],[334,-138],[231,10],[32,234],[-36,375],[21,255]],[[77035,67277],[20,-224],[-97,-108],[23,-364],[-199,107],[-359,-408],[8,-338],[-153,-496],[-14,-288],[-124,-487],[-217,135],[-11,-612],[-63,-201],[30,-251],[-137,-140]],[[74730,63611],[-39,-216],[-189,7],[-343,-122],[16,-445],[-148,-349],[-400,-398],[-311,-695],[-209,-373],[-276,-387],[-1,-271],[-138,-146],[-251,-212],[-129,-31],[-84,-450],[58,-769],[15,-490],[-118,-561],[-1,-1004],[-144,-29],[-126,-450],[84,-195],[-253,-168],[-93,-401],[-112,-170],[-263,552],[-128,827],[-107,596],[-97,279],[-148,568],[-69,739],[-48,369],[-253,811],[-115,1145],[-83,756],[1,716],[-54,553],[-404,-353],[-196,70],[-362,716],[133,214],[-82,232],[-326,501]],[[68937,64577],[185,395],[612,-2],[-56,507],[-156,300],[-31,455],[-182,265],[306,619],[323,-45],[290,620],[174,599],[270,593],[-4,421],[236,342],[-224,292],[-96,400],[-99,517],[137,255],[421,-144],[310,88],[268,496]],[[48278,82406],[46,-422],[-210,-528],[-493,-349],[-393,89],[225,617],[-145,601],[378,463],[210,276]],[[64978,72558],[244,114],[197,338],[186,-17],[122,110],[197,-55],[308,-299],[221,-65],[318,-523],[207,-21],[24,-498]],[[66909,68203],[137,-310],[112,-357],[266,-260],[7,-520],[133,-96],[23,-272],[-400,-305],[-105,-687]],[[67082,65396],[-523,179],[-303,136],[-313,76],[-118,725],[-133,105],[-214,-106],[-280,-286],[-339,196],[-281,454],[-267,168],[-186,561],[-205,788],[-149,-96],[-177,196],[-104,-231]],[[63490,68261],[-153,311],[-3,314],[-89,0],[46,428],[-143,449],[-340,324],[-193,562],[65,461],[139,204],[-21,345],[-182,177],[-180,705]],[[62436,72541],[-152,473],[55,183],[-87,678],[190,168]],[[63578,73220],[88,-436],[263,-123],[193,-296],[395,-102],[434,156],[27,139]],[[63490,68261],[-164,29]],[[63326,68290],[-187,49],[-204,-567]],[[62935,67772],[-516,47],[-784,1188],[-413,414],[-335,160]],[[60887,69581],[-112,720]],[[60775,70301],[615,614],[105,715],[-26,431],[152,146],[142,369]],[[61763,72576],[119,92],[324,-77],[97,-150],[133,100]],[[45969,89843],[-64,-382],[314,-403],[-361,-451],[-801,-405],[-240,-107],[-365,87],[-775,187],[273,261],[-605,289],[492,114],[-12,174],[-583,137],[188,385],[421,87],[433,-400],[422,321],[349,-167],[453,315],[461,-42]],[[59922,69905],[-49,-186]],[[59873,69719],[-100,82],[-58,-394],[69,-66],[-71,-81],[-12,-156],[131,80]],[[59832,69184],[7,-230],[-139,-944]],[[59518,69025],[80,194],[-19,34],[74,276],[56,446],[40,149],[8,6]],[[59757,70130],[93,-1],[25,104],[75,8]],[[59950,70241],[4,-242],[-38,-90],[6,-4]],[[54311,73167],[-100,-465],[41,-183],[-58,-303],[-213,222],[-141,64],[-387,300],[38,304],[325,-54],[284,64],[211,51]],[[52558,74927],[166,-419],[-39,-782],[-126,38],[-113,-197],[-105,156],[-11,713],[-64,338],[153,-30],[139,183]],[[53835,78058],[-31,-291],[67,-251]],[[53871,77516],[-221,86],[-226,-210],[15,-293],[-34,-168],[91,-301],[261,-298],[140,-488],[309,-476],[217,3],[68,-130],[-78,-118],[249,-214],[204,-178],[238,-308],[29,-111],[-52,-211],[-154,276],[-242,97],[-116,-382],[200,-219],[-33,-309],[-116,-35],[-148,-506],[-116,-46],[1,181],[57,317],[60,126],[-108,342],[-85,298],[-115,74],[-82,255],[-179,107],[-120,238],[-206,38],[-217,267],[-254,384],[-189,340],[-86,585],[-138,68],[-226,195],[-128,-80],[-161,-274],[-115,-43]],[[28453,61504],[187,-53],[147,-142],[46,-161],[-195,-11],[-84,-99],[-156,95],[-159,215],[34,135],[116,41],[64,-20]],[[59922,69905],[309,-234],[544,630]],[[60887,69581],[-53,-89],[-556,-296],[277,-591],[-92,-101],[-46,-197],[-212,-82],[-66,-213],[-120,-182],[-310,94]],[[59709,67924],[-9,86]],[[59832,69184],[41,173],[0,362]],[[87399,70756],[35,-203],[-156,-357],[-114,189],[-143,-137],[-73,-346],[-181,168],[2,281],[154,352],[158,-68],[114,248],[204,-127]],[[89159,72524],[-104,-472],[48,-296],[-145,-416],[-355,-278],[-488,-36],[-396,-675],[-186,227],[-12,442],[-483,-130],[-329,-279],[-325,-11],[282,-435],[-186,-1004],[-179,-248],[-135,229],[69,533],[-176,172],[-113,405],[263,182],[145,371],[280,306],[203,403],[553,177],[297,-121],[291,1050],[185,-282],[408,591],[158,229],[174,723],[-47,664],[117,374],[295,108],[152,-819],[-9,-479],[-256,-595],[4,-610]],[[89974,76679],[195,-126],[197,250],[62,-663],[-412,-162],[-244,-587],[-436,404],[-152,-646],[-308,-9],[-39,587],[138,455],[296,33],[81,817],[83,460],[326,-615],[213,-198]],[[69711,75551],[-159,-109],[-367,-412],[-121,-422],[-104,-4],[-76,280],[-353,19],[-57,484],[-135,4],[21,593],[-333,431],[-476,-46],[-326,-86],[-265,533],[-227,223],[-431,423],[-52,51],[-715,-349],[11,-2178]],[[65546,74986],[-142,-29],[-195,463],[-188,166],[-315,-123],[-123,-197]],[[64583,75266],[-15,144],[68,246],[-53,206],[-322,202],[-125,530],[-154,150],[-9,192],[270,-56],[11,432],[236,96],[243,-88],[50,576],[-50,365],[-278,-28],[-236,144],[-321,-260],[-259,-124]],[[63639,77993],[-142,96],[29,304],[-177,395],[-207,-17],[-235,401],[160,448],[-81,120],[222,649],[285,-342],[35,431],[573,643],[434,15],[612,-409],[329,-239],[295,249],[440,12],[356,-306],[80,175],[391,-25],[69,280],[-450,406],[267,288],[-52,161],[266,153],[-200,405],[127,202],[1039,205],[136,146],[695,218],[250,245],[499,-127],[88,-612],[290,144],[356,-202],[-23,-322],[267,33],[696,558],[-102,-185],[355,-457],[620,-1500],[148,309],[383,-340],[399,151],[154,-106],[133,-341],[194,-115],[119,-251],[358,79],[147,-361]],[[72294,75601],[-171,87],[-140,212],[-412,62],[-461,16],[-100,-65],[-396,248],[-158,-122],[-43,-349],[-457,204],[-183,-84],[-62,-259]],[[61551,49585],[-195,-236],[-68,-246],[-104,-44],[-40,-416],[-89,-238],[-54,-393],[-112,-195]],[[60889,47817],[-399,590],[-19,343],[-1007,1203],[-47,65]],[[59417,50018],[-3,627],[80,239],[137,391],[101,431],[-123,678],[-32,296],[-132,411]],[[59445,53091],[171,352],[188,390]],[[61626,52895],[-243,-670],[3,-2152],[165,-488]],[[70465,73876],[-526,-89],[-343,192],[-301,-46],[26,340],[303,-98],[101,182]],[[69725,74357],[212,-58],[355,425],[-329,311],[-198,-147],[-205,223],[234,382],[-83,58]],[[78495,57780],[-66,713],[178,492],[359,112],[261,-84]],[[79227,59013],[229,-232],[126,407],[246,-217]],[[79828,58971],[64,-394],[-34,-708],[-467,-455],[122,-358],[-292,-43],[-240,-238]],[[78981,56775],[-233,87],[-112,307],[-141,611]],[[85652,73393],[240,-697],[68,-383],[3,-681],[-105,-325],[-252,-113],[-222,-245],[-250,-51],[-31,322],[51,443],[-122,615],[206,99],[-190,506]],[[85048,72883],[17,54],[124,-21],[108,266],[197,29],[118,39],[40,143]],[[55575,75742],[52,132]],[[55627,75874],[66,43],[38,196],[50,33],[40,-84],[52,-36],[36,-94],[46,-28],[54,-110],[39,4],[-31,-144],[-33,-71],[9,-44]],[[55993,75539],[-62,-23],[-164,-91],[-13,-121],[-35,5]],[[63326,68290],[58,-261],[-25,-135],[89,-445]],[[63448,67449],[-196,-16],[-69,282],[-248,57]],[[79227,59013],[90,266],[12,500],[-224,515],[-18,583],[-211,480],[-210,40],[-56,-205],[-163,-17],[-83,104],[-293,-353],[-6,530],[68,623],[-188,27],[-16,355],[-120,182]],[[77809,62643],[59,218],[237,384]],[[78380,63852],[162,-466],[125,-537],[342,-5],[108,-515],[-178,-155],[-80,-212],[333,-353],[231,-699],[175,-520],[210,-411],[70,-418],[-50,-590]],[[59757,70130],[99,482],[138,416],[5,21]],[[59999,71049],[125,-31],[45,-231],[-151,-223],[-68,-323]],[[47857,53158],[-73,-5],[-286,282],[-252,449],[-237,324],[-187,381]],[[46822,54589],[66,189],[15,172],[126,320],[129,276]],[[54125,64088],[-197,-220],[-156,324],[-439,255]],[[52633,68486],[136,137],[24,250],[-30,244],[191,228],[86,189],[135,170],[16,454]],[[53191,70158],[326,-204],[117,51],[232,-98],[368,-264],[130,-526],[250,-114],[391,-248],[296,-293],[136,153],[133,272],[-65,452],[87,288],[200,277],[192,80],[375,-121],[95,-264],[104,-2],[88,-101],[276,-70],[68,-195]],[[56944,63578],[0,-1180],[-320,-2],[-3,-248]],[[56621,62148],[-1108,1131],[-1108,1132],[-280,-323]],[[72718,55024],[-42,-615],[-116,-168],[-242,-135],[-132,470],[-49,849],[126,959],[192,-328],[129,-416],[134,-616]],[[58049,33472],[96,-178],[-85,-288],[-47,-192],[-155,-93],[-51,-188],[-99,-59],[-209,454],[148,374],[151,232],[130,120],[121,-182]],[[56314,82678],[-23,150],[30,162],[-123,94],[-291,103]],[[55907,83187],[-59,497]],[[55848,83684],[318,181],[466,-38],[273,59],[39,-123],[148,-38],[267,-287]],[[56523,82432],[-67,182],[-142,64]],[[55848,83684],[10,445],[136,371],[262,202],[221,-442],[223,12],[53,453]],[[57579,84537],[134,-136],[24,-287],[89,-348]],[[47592,66920],[-42,0],[7,-317],[-172,-19],[-90,-134],[-126,0],[-100,76],[-234,-63],[-91,-460],[-86,-44],[-131,-745],[-386,-637],[-92,-816],[-114,-265],[-33,-213],[-625,-48],[-5,1]],[[45272,63236],[13,274],[106,161],[91,308],[-18,200],[96,417],[155,376],[93,95],[74,344],[6,315],[100,365],[185,216],[177,603],[5,8],[139,227],[259,65],[218,404],[140,158],[232,493],[-70,735],[106,508],[37,312],[179,399],[278,270],[206,244],[186,612],[87,362],[205,-2],[167,-251],[264,41],[288,-131],[121,-6]],[[57394,79070],[66,87],[185,58],[204,-184],[115,-22],[125,-159],[-20,-200],[101,-97],[40,-247],[97,-150],[-19,-88],[52,-60],[-74,-44],[-164,18],[-27,81],[-58,-47],[20,-106],[-76,-188],[-49,-203],[-70,-64]],[[57842,77455],[-50,270],[30,252],[-9,259],[-160,352],[-89,249],[-86,175],[-84,58]],[[63761,43212],[74,-251],[69,-390],[45,-711],[72,-276],[-28,-284],[-49,-174],[-94,347],[-53,-175],[53,-438],[-24,-250],[-77,-137],[-18,-500],[-109,-689],[-137,-814],[-172,-1120],[-106,-821],[-125,-685],[-226,-140],[-243,-250],[-160,151],[-220,211],[-77,312],[-18,524],[-98,471],[-26,425],[50,426],[128,102],[1,197],[133,447],[25,377],[-65,280],[-52,372],[-23,544],[97,331],[38,375],[138,22],[155,121],[103,107],[122,7],[158,337],[229,364],[83,297],[-38,253],[118,-71],[153,410],[6,356],[92,264],[96,-254]],[[23016,65864],[-107,-518],[-49,-426],[-20,-791],[-27,-289],[48,-322],[86,-288],[56,-458],[184,-440],[65,-337],[109,-291],[295,-157],[114,-247],[244,165],[212,60],[208,106],[175,101],[176,241],[67,345],[22,496],[48,173],[188,155],[294,137],[246,-21],[169,50],[66,-125],[-9,-285],[-149,-351],[-66,-360],[51,-103],[-42,-255],[-69,-461],[-71,152],[-58,-10]],[[24381,59170],[-314,636],[-144,191],[-226,155],[-156,-43],[-223,-223],[-140,-58],[-196,156],[-208,112],[-260,271],[-208,83],[-314,275],[-233,282],[-70,158],[-155,35],[-284,187],[-116,270],[-299,335],[-139,373],[-66,288],[93,57],[-29,169],[64,153],[1,204],[-93,266],[-25,235],[-94,298],[-244,587],[-280,462],[-135,368],[-238,241],[-51,145],[42,365],[-142,138],[-164,287],[-69,412],[-149,48],[-162,311],[-130,288],[-12,184],[-149,446],[-99,452],[5,227],[-201,234],[-93,-25],[-159,163],[-44,-240],[46,-284],[27,-444],[95,-243],[206,-407],[46,-139],[42,-42],[37,-203],[49,8],[56,-381],[85,-150],[59,-210],[174,-300],[92,-550],[83,-259],[77,-277],[15,-311],[134,-20],[112,-268],[100,-264],[-6,-106],[-117,-217],[-49,3],[-74,359],[-181,337],[-201,286],[-142,150],[9,432],[-42,320],[-132,183],[-191,264],[-37,-76],[-70,154],[-171,143],[-164,343],[20,44],[115,-33],[103,221],[10,266],[-214,422],[-163,163],[-102,369],[-103,388],[-129,472],[-113,531]],[[17464,69802],[316,46],[353,64],[-26,-116],[419,-287],[634,-416],[552,4],[221,0],[0,244],[481,0],[102,-210],[142,-186],[165,-260],[92,-309],[69,-325],[144,-178],[230,-177],[175,467],[227,11],[196,-236],[139,-404],[96,-346],[164,-337],[61,-414],[78,-277],[217,-184],[197,-130],[108,18]],[[55993,75539],[95,35],[128,9]],[[46619,59216],[93,107],[47,348],[88,14],[194,-165],[157,117],[107,-39],[42,131],[1114,9],[62,414],[-48,73],[-134,2550],[-134,2550],[425,10]],[[51185,61897],[1,-1361],[-152,-394],[-24,-364],[-247,-94],[-379,-51],[-102,-210],[-178,-23]],[[46801,57931],[13,184],[-24,229],[-104,166],[-54,338],[-13,368]],[[77375,56448],[-27,439],[86,452],[-94,350],[23,644],[-113,306],[-90,707],[-50,746],[-121,490],[-183,-297],[-315,-421],[-156,53],[-172,138],[96,732],[-58,554],[-218,681],[34,213],[-163,76],[-197,481]],[[77809,62643],[-159,-137],[-162,-256],[-196,-26],[-127,-639],[-117,-107],[134,-519],[177,-431],[113,-390],[-101,-514],[-96,-109],[66,-296],[185,-470],[32,-330],[-4,-274],[108,-539],[-152,-551],[-135,-607]],[[55380,75322],[-58,46],[-78,192],[-120,118]],[[55338,76294],[74,-101],[40,-82],[91,-63],[106,-123],[-22,-51]],[[74375,79706],[292,102],[530,509],[423,278],[242,-182],[289,-8],[186,-276],[277,-22],[402,-148],[270,411],[-113,348],[288,612],[311,-244],[252,-69],[327,-152],[53,-443],[394,-248],[263,109],[351,78],[279,-78],[272,-284],[168,-302],[258,6],[350,-96],[255,146],[366,98],[407,416],[166,-63],[146,-198],[331,49]],[[59599,43773],[209,48],[334,-166],[73,74],[193,16],[99,177],[167,-10],[303,230],[221,342]],[[61198,44484],[45,-265],[-11,-588],[34,-519],[11,-923],[49,-290],[-83,-422],[-108,-410],[-177,-366],[-254,-225],[-313,-287],[-313,-634],[-107,-108],[-194,-420],[-115,-136],[-23,-421],[132,-448],[54,-346],[4,-177],[49,29],[-8,-579],[-45,-275],[65,-101],[-41,-245],[-116,-211],[-229,-199],[-334,-320],[-122,-219],[24,-248],[71,-40],[-24,-311]],[[59119,34780],[-211,5]],[[58908,34785],[-24,261],[-41,265]],[[58843,35311],[-23,212],[49,659],[-72,419],[-133,832]],[[58664,37433],[292,671],[74,426],[42,53],[31,348],[-45,175],[12,442],[54,409],[0,748],[-145,190],[-132,43],[-60,146],[-128,125],[-232,-12],[-18,220]],[[58409,41417],[-26,421],[843,487]],[[59226,42325],[159,-284],[77,54],[110,-149],[16,-237],[-59,-274],[21,-417],[181,-365],[85,410],[120,124],[-24,760],[-116,427],[-100,191],[-97,-9],[-77,768],[77,449]],[[46619,59216],[-184,405],[-168,435],[-184,157],[-133,173],[-155,-6],[-135,-129],[-138,51],[-96,-189]],[[45426,60113],[-24,318],[78,291],[34,557],[-30,583],[-34,294],[28,295],[-72,281],[-146,255]],[[45260,62987],[60,197],[1088,-4],[-53,853],[68,304],[261,53],[-9,1512],[911,-31],[1,895]],[[59226,42325],[-147,153],[85,549],[87,205],[-53,490],[56,479],[47,160],[-71,501],[-131,264]],[[59099,45126],[273,-110],[55,-164],[95,-275],[77,-804]],[[78372,54256],[64,-56],[164,-356],[116,-396],[16,-398],[-29,-269],[27,-203],[20,-349],[98,-163],[109,-523],[-5,-199],[-197,-40],[-263,438],[-329,469],[-32,301],[-161,395],[-38,489],[-100,322],[30,431],[-61,250]],[[77801,54399],[48,105],[227,-258],[22,-304],[183,71],[91,243]],[[80461,51765],[204,-202],[214,110],[56,500],[119,112],[333,128],[199,467],[137,374]],[[82069,53798],[214,411],[140,462],[112,2],[143,-299],[13,-257],[183,-165],[231,-177],[-20,-232],[-186,-29],[50,-289],[-205,-201]],[[54540,33696],[-207,446],[-108,432],[-62,575],[-68,428],[-93,910],[-7,707],[-35,322],[-108,243],[-144,489],[-146,708],[-60,371],[-226,577],[-17,453]],[[56448,40227],[228,134],[180,-34],[109,-133],[2,-49]],[[55526,35946],[0,-2182],[-248,-302],[-149,-43],[-175,112],[-125,43],[-47,252],[-109,162],[-133,-292]],[[96049,38125],[228,-366],[144,-272],[-105,-142],[-153,160],[-199,266],[-179,313],[-184,416],[-38,201],[119,-9],[156,-201],[122,-200],[89,-166]],[[54125,64088],[68,-919],[104,-153],[4,-188],[116,-203],[-60,-254],[-107,-1199],[-15,-769],[-354,-557],[-120,-778],[115,-219],[0,-380],[178,-13],[-28,-279]],[[53939,57955],[-52,-13],[-188,647],[-65,24],[-217,-331],[-215,173],[-150,34],[-80,-83],[-163,18],[-164,-252],[-141,-14],[-337,305],[-131,-145],[-142,10],[-104,223],[-279,221],[-298,-70],[-72,-128],[-39,-340],[-80,-238],[-19,-527]],[[52361,53399],[-289,-213],[-105,31],[-107,-132],[-222,13],[-149,370],[-91,427],[-197,389],[-209,-7],[-245,1]],[[26191,57131],[-96,186],[-130,238],[-61,200],[-117,185],[-140,267],[31,91],[46,-88],[21,41]],[[26903,59440],[-24,-57],[-14,-132],[29,-216],[-64,-202],[-30,-237],[-9,-261],[15,-152],[7,-266],[-43,-58],[-26,-253],[19,-156],[-56,-151],[12,-159],[43,-97]],[[50920,80916],[143,162],[244,869],[380,248],[231,-17]],[[58639,91676],[-473,-237],[-224,-54]],[[55734,91409],[-172,-24],[-41,-389],[-523,95],[-74,-329],[-267,2],[-183,-421],[-278,-655],[-431,-831],[101,-202],[-97,-234],[-275,10],[-180,-554],[17,-784],[177,-300],[-92,-694],[-231,-405],[-122,-341]],[[53063,85353],[-187,363],[-548,-684],[-371,-138],[-384,301],[-99,635],[-88,1363],[256,381],[733,496],[549,609],[508,824],[668,1141],[465,444],[763,741],[610,259],[457,-31],[423,489],[506,-26],[499,118],[869,-433],[-358,-158],[305,-371]],[[56867,96577],[-620,-241],[-490,137],[191,152],[-167,189],[575,119],[110,-222],[401,-134]],[[55069,97669],[915,-440],[-699,-233],[-155,-435],[-243,-111],[-132,-490],[-335,-23],[-598,361],[252,210],[-416,170],[-541,499],[-216,463],[757,212],[152,-207],[396,8],[105,202],[408,20],[350,-206]],[[57068,98086],[545,-207],[-412,-318],[-806,-70],[-819,98],[-50,163],[-398,11],[-304,271],[858,165],[403,-142],[281,177],[702,-148]],[[98060,26404],[63,-244],[198,239],[80,-249],[0,-249],[-103,-274],[-182,-435],[-142,-238],[103,-284],[-214,-7],[-238,-223],[-75,-387],[-157,-597],[-219,-264],[-138,-169],[-256,13],[-180,194],[-302,42],[-46,217],[149,438],[349,583],[179,111],[200,225],[238,310],[167,306],[123,441],[106,149],[41,330],[195,273],[61,-251]],[[98502,29218],[202,-622],[5,403],[126,-161],[41,-447],[224,-192],[188,-48],[158,226],[141,-69],[-67,-524],[-85,-345],[-212,12],[-74,-179],[26,-254],[-41,-110],[-105,-319],[-138,-404],[-214,-236],[-48,155],[-116,85],[160,486],[-91,326],[-299,236],[8,214],[201,206],[47,455],[-13,382],[-113,396],[8,104],[-133,244],[-218,523],[-117,418],[104,46],[151,-328],[216,-153],[78,-526]],[[64752,60417],[-91,413],[-217,975]],[[64444,61805],[833,591],[185,1182],[-127,418]],[[65665,65306],[125,-404],[155,-214],[203,-78],[165,-107],[125,-339],[75,-196],[100,-75],[-1,-132],[-101,-352],[-44,-166],[-117,-189],[-104,-404],[-126,31],[-58,-141],[-44,-300],[34,-395],[-26,-72],[-128,2],[-174,-221],[-27,-288],[-63,-125],[-173,5],[-109,-149],[1,-238],[-134,-165],[-153,56],[-186,-199],[-128,-34]],[[65575,65974],[80,201],[35,-51],[-26,-244],[-37,-108]],[[68937,64577],[-203,150],[-83,424],[-215,450],[-512,-111],[-451,-11],[-391,-83]],[[28366,54848],[-93,170],[-59,319],[68,158],[-70,40],[-52,196],[-138,164],[-122,-38],[-56,-205],[-112,-149],[-61,-20],[-27,-123],[132,-321],[-75,-76],[-40,-87],[-130,-30],[-48,353],[-36,-101],[-92,35],[-56,238],[-114,39],[-72,69],[-119,-1],[-8,-128],[-32,89]],[[27070,56232],[100,-212],[-6,-126],[111,-26],[26,48],[77,-145],[136,42],[119,150],[168,119],[95,176],[153,-34],[-10,-58],[155,-21],[124,-102],[90,-177],[105,-164]],[[30452,39739],[-279,340],[-24,242],[-551,593],[-498,646],[-214,365],[-115,488],[46,170],[-236,775],[-274,1090],[-262,1177],[-114,269],[-87,435],[-216,386],[-198,239],[90,264],[-134,563],[86,414],[221,373]],[[85104,55551],[28,-392],[16,-332],[-94,-540],[-102,602],[-130,-300],[89,-435],[-79,-277],[-327,343],[-78,428],[84,280],[-176,280],[-87,-245],[-131,23],[-205,-330],[-46,173],[109,498],[175,166],[151,223],[98,-268],[212,162],[45,264],[196,15],[-16,457],[225,-280],[23,-297],[20,-218]],[[84439,56653],[-100,-195],[-87,-373],[-87,-175],[-171,409],[57,158],[70,165],[30,367],[153,35],[-44,-398],[205,570],[-26,-563]],[[82917,56084],[-369,-561],[136,414],[200,364],[167,409],[146,587],[49,-482],[-183,-325],[-146,-406]],[[83856,57606],[166,-183],[177,1],[-5,-247],[-129,-251],[-176,-178],[-10,275],[20,301],[-43,282]],[[84861,57766],[78,-660],[-214,157],[5,-199],[68,-364],[-132,-133],[-11,416],[-84,31],[-43,357],[163,-47],[-4,224],[-169,451],[266,-13],[77,-220]],[[83757,58301],[-74,-510],[-119,295],[-142,450],[238,-22],[97,-213]],[[83700,61512],[171,-168],[85,153],[26,-150],[-46,-245],[95,-423],[-73,-491],[-164,-196],[-43,-476],[62,-471],[147,-65],[123,70],[347,-328],[-27,-321],[91,-142],[-29,-272],[-216,290],[-103,310],[-71,-217],[-177,354],[-253,-87],[-138,130],[14,244],[87,151],[-83,136],[-36,-213],[-137,340],[-41,257],[-11,566],[112,-195],[29,925],[90,535],[169,-1]],[[93299,46550],[-78,-59],[-120,227],[-122,375],[-59,450],[38,57],[30,-175],[84,-134],[135,-375],[131,-200],[-39,-166]],[[92217,47343],[-146,-48],[-44,-166],[-152,-144],[-142,-138],[-148,1],[-228,171],[-158,165],[23,183],[249,-86],[152,46],[42,283],[40,15],[27,-314],[158,45],[78,202],[155,211],[-30,348],[166,11],[56,-97],[-5,-327],[-93,-361]],[[89166,49043],[482,-407],[513,-338],[192,-302],[154,-297],[43,-349],[462,-365],[68,-313],[-256,-64],[62,-393],[248,-388],[180,-627],[159,20],[-11,-262],[215,-100],[-84,-111],[295,-249],[-30,-171],[-184,-41],[-69,153],[-238,66],[-281,89],[-216,377],[-158,325],[-144,517],[-362,259],[-235,-169],[-170,-195],[35,-436],[-218,-203],[-155,99],[-288,25]],[[92538,47921],[-87,-157],[-52,348],[-65,229],[-126,193],[-158,252],[-200,174],[77,143],[150,-166],[94,-130],[117,-142],[111,-248],[106,-189],[33,-307]],[[53922,82340],[189,174],[434,273],[350,200],[277,-100],[21,-144],[268,-7]],[[55461,82736],[342,-67],[511,9]],[[56535,81053],[139,-515],[-29,-166],[-138,-69],[-252,-491],[71,-266],[-60,35]],[[56266,79581],[-264,227],[-200,-84],[-131,61],[-165,-127],[-140,210],[-114,-81],[-16,36]],[[31588,61519],[142,-52],[50,-118],[-71,-149],[-209,4],[-163,-21],[-16,253],[40,86],[227,-3]],[[86288,75628],[39,-104]],[[86327,75524],[-106,36],[-120,-200],[-83,-202],[10,-424],[-143,-130],[-50,-105],[-104,-174],[-185,-97],[-121,-159],[-9,-256],[-32,-65],[111,-96],[157,-259]],[[85048,72883],[-135,112],[-34,-111],[-81,-49],[-10,112],[-72,54],[-75,94],[76,260],[66,69],[-25,108],[71,319],[-18,96],[-163,65],[-131,158]],[[47929,72498],[-112,-153],[-146,83],[-143,-65],[42,462],[-26,363],[-124,55],[-67,224],[22,386],[111,215],[20,239],[58,355],[-6,250],[-56,212],[-12,200]],[[64113,65205],[-18,430],[75,310],[76,64],[84,-185],[5,-346],[-61,-348]],[[64274,65130],[-77,-42],[-84,117]],[[56308,78869],[120,127],[172,-65],[178,-3],[129,-144],[95,91],[205,56],[69,139],[118,0]],[[57842,77455],[124,-109],[131,95],[126,-101]],[[58223,77340],[6,-152],[-135,-128],[-84,56],[-78,-713]],[[56293,76715],[-51,103],[65,99],[-69,74],[-87,-133],[-162,172],[-22,244],[-169,139],[-31,188],[-151,232]],[[89901,80562],[280,-1046],[-411,195],[-171,-854],[271,-605],[-8,-413],[-211,356],[-182,-457],[-51,496],[31,575],[-32,638],[64,446],[13,790],[-163,581],[24,808],[257,271],[-110,274],[123,83],[73,-391],[96,-569],[-7,-581],[114,-597]],[[55461,82736],[63,260],[383,191]],[[99999,92429],[-305,-30],[-49,187],[-99645,247],[36,24],[235,-1],[402,-169],[-24,-81],[-286,-141],[-363,-36],[99999,0]],[[89889,93835],[-421,-4],[-569,66],[-49,31],[263,234],[348,54],[394,-226],[34,-155]],[[91869,94941],[-321,-234],[-444,53],[-516,233],[66,192],[518,-89],[697,-155]],[[90301,95224],[-219,-439],[-1023,16],[-461,-139],[-550,384],[149,406],[366,111],[734,-26],[1004,-313]],[[65981,92363],[-164,-52],[-907,77],[-74,262],[-503,158],[-40,320],[284,126],[-10,323],[551,503],[-255,73],[665,518],[-75,268],[621,312],[917,380],[925,110],[475,220],[541,76],[193,-233],[-187,-184],[-984,-293],[-848,-282],[-863,-562],[-414,-577],[-435,-568],[56,-491],[531,-484]],[[63639,77993],[-127,-350],[-269,-97],[-276,-610],[252,-561],[-27,-398],[303,-696]],[[61098,76242],[-354,499],[-317,223],[-240,347],[202,95],[231,494],[-156,234],[410,241],[-8,129],[-249,-95]],[[60617,78409],[9,262],[143,165],[269,43],[44,197],[-62,326],[113,310],[-3,173],[-410,192],[-162,-6],[-172,277],[-213,-94],[-352,208],[6,116],[-99,256],[-222,29],[-23,183],[70,120],[-178,334],[-288,-57],[-84,30],[-70,-134],[-104,23]],[[57772,85719],[316,327],[-291,280]],[[58639,91676],[286,206],[456,-358],[761,-140],[1050,-668],[213,-281],[18,-393],[-308,-311],[-454,-157],[-1240,449],[-204,-75],[453,-433],[18,-274],[18,-604],[358,-180],[217,-153],[36,286],[-168,254],[177,224],[672,-368],[233,144],[-186,433],[647,578],[256,-34],[260,-206],[161,406],[-231,352],[136,353],[-204,367],[777,-190],[158,-331],[-351,-73],[1,-328],[219,-203],[429,128],[68,377],[580,282],[970,507],[209,-29],[-273,-359],[344,-61],[199,202],[521,16],[412,245],[317,-356],[315,391],[-291,343],[145,195],[820,-179],[385,-185],[1006,-675],[186,309],[-282,313],[-8,125],[-335,58],[92,280],[-149,461],[-8,189],[512,535],[183,537],[206,116],[736,-156],[57,-328],[-263,-479],[173,-189],[89,-413],[-63,-809],[307,-362],[-120,-395],[-544,-839],[318,-87],[110,213],[306,151],[74,293],[240,281],[-162,336],[130,390],[-304,49],[-67,328],[222,593],[-361,482],[497,398],[-64,421],[139,13],[145,-328],[-109,-570],[297,-108],[-127,426],[465,233],[577,31],[513,-337],[-247,492],[-28,630],[483,119],[669,-26],[602,77],[-226,309],[321,388],[319,16],[540,293],[734,79],[93,162],[729,55],[227,-133],[624,314],[510,-10],[77,255],[265,252],[656,242],[476,-191],[-378,-146],[629,-90],[75,-292],[254,143],[812,-7],[626,-289],[223,-221],[-69,-307],[-307,-175],[-730,-328],[-209,-175],[345,-83],[410,-149],[251,112],[141,-379],[122,153],[444,93],[892,-97],[67,-276],[1162,-88],[15,451],[590,-104],[443,4],[449,-312],[128,-378],[-165,-247],[349,-465],[437,-240],[268,620],[446,-266],[473,159],[538,-182],[204,166],[455,-83],[-201,549],[367,256],[2509,-384],[236,-351],[727,-451],[1122,112],[553,-98],[231,-244],[-33,-432],[342,-168],[372,121],[492,15],[525,-116],[526,66],[484,-526],[344,189],[-224,378],[123,262],[886,-165],[578,36],[799,-282],[-99610,-258],[681,-451],[728,-588],[-24,-367],[187,-147],[-64,429],[754,-88],[544,-553],[-276,-257],[-455,-61],[-7,-578],[-111,-122],[-260,17],[-212,206],[-369,172],[-62,257],[-283,96],[-315,-76],[-151,207],[60,219],[-333,-140],[126,-278],[-158,-251],[99997,-3],[-357,-260],[-360,44],[250,-315],[166,-487],[128,-159],[32,-244],[-71,-157],[-518,129],[-777,-445],[-247,-69],[-425,-415],[-403,-362],[-102,-269],[-397,409],[-724,-464],[-126,219],[-268,-253],[-371,81],[-90,-388],[-333,-572],[10,-239],[316,-132],[-37,-860],[-258,-22],[-119,-494],[116,-255],[-486,-302],[-96,-674],[-415,-144],[-83,-600],[-400,-551],[-103,407],[-119,862],[-155,1313],[134,819],[234,353],[14,276],[432,132],[496,744],[479,608],[499,471],[223,833],[-337,-50],[-167,-487],[-705,-649],[-227,727],[-717,-201],[-696,-990],[230,-362],[-620,-154],[-430,-61],[20,427],[-431,90],[-344,-291],[-850,102],[-914,-175],[-899,-1153],[-1065,-1394],[438,-74],[136,-370],[270,-132],[178,295],[305,-38],[401,-650],[9,-503],[-217,-590],[-23,-705],[-126,-945],[-418,-855],[-94,-409],[-377,-688],[-374,-682],[-179,-349],[-370,-346],[-175,-8],[-175,287],[-373,-432],[-43,-197]],[[79187,96845],[-1566,-228],[507,776],[229,66],[208,-38],[704,-336],[-82,-240]],[[64204,98169],[-373,-78],[-250,-45],[-39,-97],[-324,-98],[-301,140],[158,185],[-618,18],[542,107],[422,8],[57,-160],[159,142],[262,97],[412,-129],[-107,-90]],[[77760,97184],[-606,-73],[-773,170],[-462,226],[-213,423],[-379,117],[722,404],[600,133],[540,-297],[640,-572],[-69,-531]],[[58449,49909],[110,-333],[-16,-348],[-80,-74]],[[58216,49787],[67,-60],[166,182]],[[45260,62987],[12,249]],[[61883,60238],[-37,252],[-83,178],[-22,236],[-143,212],[-148,495],[-79,482],[-192,406],[-124,97],[-184,563],[-32,411],[12,350],[-159,655],[-130,231],[-150,122],[-92,339],[15,133],[-77,306],[-81,132],[-108,440],[-170,476],[-141,406],[-139,-3],[44,325],[12,206],[34,236]],[[63448,67449],[109,-510],[137,-135],[47,-207],[190,-249],[16,-243],[-27,-197],[35,-199],[80,-165],[37,-194],[41,-145]],[[64274,65130],[53,-226]],[[64444,61805],[-801,-226],[-259,-266],[-199,-620],[-130,-99],[-70,197],[-106,-30],[-269,60],[-50,59],[-321,-14],[-75,-53],[-114,153],[-74,-290],[28,-249],[-121,-189]],[[59434,56171],[-39,12],[5,294],[-33,203],[-143,233],[-34,426],[34,436],[-129,41],[-19,-132],[-167,-30],[67,-173],[23,-355],[-152,-324],[-138,-426],[-144,-61],[-233,345],[-105,-122],[-29,-172],[-143,-112],[-9,-122],[-277,0],[-38,122],[-200,20],[-100,-101],[-77,51],[-143,344],[-48,163],[-200,-81],[-76,-274],[-72,-528],[-95,-111],[-85,-65]],[[56635,55672],[-23,28]],[[56351,57163],[3,143],[-102,174],[-3,343],[-58,228],[-98,-34],[28,217],[72,246],[-32,245],[92,181],[-58,138],[73,365],[127,435],[240,-41],[-14,2345]],[[60240,63578],[90,-580],[-61,-107],[40,-608],[102,-706],[106,-145],[152,-219]],[[59433,56242],[1,-71]],[[59434,56171],[3,-460]],[[59445,53091],[-171,-272],[-195,1],[-224,-138],[-176,132],[-115,-161]],[[56824,55442],[-189,230]],[[45357,58612],[-115,460],[-138,210],[122,112],[134,415],[66,304]],[[45367,57897],[-46,453]],[[95032,44386],[78,-203],[-194,4],[-106,363],[166,-142],[56,-22]],[[94680,44747],[-108,-14],[-170,60],[-58,91],[17,235],[183,-93],[91,-124],[45,-155]],[[94910,44908],[-42,-109],[-206,512],[-57,353],[94,0],[100,-473],[111,-283]],[[94409,45654],[12,-119],[-218,251],[-152,212],[-104,197],[41,60],[128,-142],[228,-272],[65,-187]],[[93760,46238],[-56,-33],[-121,134],[-114,243],[14,99],[166,-250],[111,-193]],[[46822,54589],[-75,44],[-200,238],[-144,316],[-49,216],[-34,437]],[[25613,58487],[-31,-139],[-161,9],[-100,57],[-115,117],[-154,37],[-79,127]],[[61984,57352],[91,-109],[54,-245],[125,-247],[138,-2],[262,151],[302,70],[245,184],[138,39],[99,108],[158,20]],[[63596,57321],[-2,-9],[-1,-244],[0,-596],[0,-308],[-125,-363],[-194,-493]],[[63596,57321],[89,12],[128,88],[147,59],[132,202],[105,2],[6,-163],[-25,-344],[1,-310],[-59,-214],[-78,-639],[-134,-659],[-172,-755],[-238,-866],[-237,-661],[-327,-806],[-278,-479],[-415,-586],[-259,-450],[-304,-715],[-64,-312],[-63,-140]],[[34125,54109],[333,-119],[30,107],[225,43],[298,-159]],[[34889,53069],[109,-351],[-49,-254],[-24,-270],[-71,-248]],[[56266,79581],[-77,-154],[-55,-238]],[[53809,77462],[62,54]],[[56639,89578],[-478,-167],[-269,-413],[43,-361],[-441,-475],[-537,-509],[-202,-832],[198,-416],[265,-328],[-255,-666],[-289,-138],[-106,-992],[-157,-554],[-337,57],[-158,-468],[-321,-27],[-89,558],[-232,671],[-211,835]],[[58908,34785],[-56,-263],[-163,-63],[-166,320],[-2,204],[76,222],[26,172],[80,42],[140,-108]],[[59999,71049],[-26,452],[68,243]],[[60041,71744],[74,129],[75,130],[15,329],[91,-115],[306,165],[147,-112],[229,2],[320,222],[149,-10],[316,92]],[[50518,54209],[-224,-126]],[[78495,57780],[-249,271],[-238,-11],[41,464],[-245,-3],[-22,-650],[-150,-863],[-90,-522],[19,-428],[181,-18],[113,-539],[50,-512],[155,-338],[168,-69],[144,-306]],[[77801,54399],[-110,227],[-47,292],[-148,334],[-135,280],[-45,-347],[-53,328],[30,369],[82,566]],[[68841,72526],[156,598],[-60,440],[-204,140],[72,261],[232,-28],[132,326],[89,380],[371,137],[-58,-274],[40,-164],[114,15]],[[64978,72558],[-52,417],[40,618],[-216,200],[71,405],[-184,34],[61,498],[262,-145],[244,189],[-202,355],[-80,338],[-224,-151],[-28,-433],[-87,383]],[[65546,74986],[313,8],[-45,297],[237,204],[234,343],[374,-312],[30,-471],[106,-121],[301,27],[93,-108],[137,-609],[317,-408],[181,-278],[291,-289],[369,-253],[-7,-362]],[[84713,45326],[32,139],[239,133],[194,20],[87,74],[105,-74],[-102,-160],[-289,-258],[-233,-170]],[[32866,56937],[160,77],[58,-21],[-11,-440],[-232,-65],[-50,53],[81,163],[-6,233]],[[52339,72408],[302,239],[195,-71],[-9,-299],[236,217],[20,-113],[-139,-290],[-2,-273],[96,-147],[-36,-511],[-183,-297],[53,-322],[143,-10],[70,-281],[106,-92]],[[60041,71744],[-102,268],[105,222],[-169,-51],[-233,136],[-191,-340],[-421,-66],[-225,317],[-300,20],[-64,-245],[-192,-70],[-268,314],[-303,-11],[-165,588],[-203,328],[135,459],[-176,283],[308,565],[428,23],[117,449],[529,-78],[334,383],[324,167],[459,13],[485,-417],[399,-228],[323,91],[239,-53],[328,309]],[[57776,75399],[33,-228],[243,-190],[-51,-145],[-330,-33],[-118,-182],[-232,-319],[-87,276],[3,121]],[[83826,64992],[-167,-947],[-119,-485],[-146,499],[-32,438],[163,581],[223,447],[127,-176],[-49,-357]],[[60889,47817],[-128,-728],[16,-335],[178,-216],[8,-153],[-76,-357],[16,-180],[-18,-282],[97,-370],[115,-583],[101,-129]],[[59099,45126],[-157,177],[-177,100],[-111,99],[-116,150]],[[58388,46397],[-161,331],[-55,342]],[[58449,49909],[98,71],[304,-7],[566,45]],[[60617,78409],[-222,-48],[-185,-191],[-260,-31],[-239,-220],[16,-368],[136,-142],[284,35],[-55,-210],[-304,-103],[-377,-342],[-154,121],[61,277],[-304,173],[50,113],[265,197],[-80,135],[-432,149],[-19,221],[-257,-73],[-103,-325],[-215,-437]],[[35174,30629],[-121,-372],[-313,-328],[-205,118],[-151,-63],[-256,253],[-189,-19],[-169,327]],[[6794,61855],[-41,-99],[-69,84],[8,165],[-46,216],[14,65],[48,97],[-19,116],[16,55],[21,-11],[107,-100],[49,-51],[45,-79],[71,-207],[-7,-33],[-108,-126],[-89,-92]],[[6645,62777],[-94,-43],[-47,125],[-32,48],[-3,37],[27,50],[99,-56],[73,-90],[-23,-71]],[[6456,63091],[-9,-63],[-149,17],[21,72],[137,-26]],[[6207,63177],[-15,-34],[-19,8],[-97,21],[-35,133],[-11,24],[74,82],[23,-38],[80,-196]],[[5737,63567],[-33,-58],[-93,107],[14,43],[43,58],[64,-12],[5,-138]],[[31350,77248],[48,-194],[-296,-286],[-286,-204],[-293,-175],[-147,-351],[-47,-133],[-3,-313],[92,-313],[115,-15],[-29,216],[83,-131],[-22,-169],[-188,-96],[-133,11],[-205,-103],[-121,-29],[-162,-29],[-231,-171],[408,111],[82,-112],[-389,-177],[-177,-1],[8,72],[-84,-164],[82,-27],[-60,-424],[-203,-455],[-20,152],[-61,30],[-91,148],[57,-318],[69,-105],[5,-223],[-89,-230],[-157,-472],[-25,24],[86,402],[-142,225],[-33,491],[-53,-255],[59,-375],[-183,93],[191,-191],[12,-562],[79,-41],[29,-204],[39,-591],[-176,-439],[-288,-175],[-182,-346],[-139,-38],[-141,-217],[-39,-199],[-305,-383],[-157,-281],[-131,-351],[-43,-419],[50,-411],[92,-505],[124,-418],[1,-256],[132,-685],[-9,-398],[-12,-230],[-69,-361],[-83,-75],[-137,72],[-44,259],[-105,136],[-148,508],[-129,452],[-42,231],[57,393],[-77,325],[-217,494],[-108,90],[-281,-268],[-49,30],[-135,275],[-174,147],[-314,-75],[-247,66],[-212,-41],[-114,-92],[50,-157],[-5,-240],[59,-117],[-53,-77],[-103,87],[-104,-112],[-202,18],[-207,312],[-242,-73],[-202,137],[-173,-42],[-234,-138],[-253,-438],[-276,-255],[-152,-282],[-63,-266],[-3,-407],[14,-284],[52,-201]],[[17464,69802],[-46,302],[-180,340],[-130,71],[-30,169],[-156,30],[-100,159],[-258,59],[-71,95],[-33,324],[-270,594],[-231,821],[10,137],[-123,195],[-215,495],[-38,482],[-148,323],[61,489],[-10,507],[-89,453],[109,557],[34,536],[33,536],[-50,792],[-88,506],[-80,274],[33,115],[402,-200],[148,-558],[69,156],[-45,484],[-94,485]],[[7498,84325],[-277,-225],[-142,152],[-43,277],[252,210],[148,90],[185,-40],[117,-183],[-240,-281]],[[4006,85976],[-171,-92],[-182,110],[-168,161],[274,101],[220,-54],[27,-226]],[[2297,88264],[171,-113],[173,61],[225,-156],[276,-79],[-23,-64],[-211,-125],[-211,128],[-106,107],[-245,-34],[-66,52],[17,223]],[[13740,82958],[-153,223],[-245,188],[-78,515],[-358,478],[-150,558],[-267,38],[-441,15],[-326,170],[-574,613],[-266,112],[-486,211],[-385,-51],[-546,272],[-330,252],[-309,-125],[58,-411],[-154,-38],[-321,-123],[-245,-199],[-308,-126],[-39,348],[125,580],[295,182],[-76,148],[-354,-329],[-190,-394],[-400,-420],[203,-287],[-262,-424],[-299,-248],[-278,-180],[-69,-261],[-434,-305],[-87,-278],[-325,-252],[-191,45],[-259,-165],[-282,-201],[-231,-197],[-477,-169],[-43,99],[304,276],[271,182],[296,324],[345,66],[137,243],[385,353],[62,119],[205,208],[48,448],[141,349],[-320,-179],[-90,102],[-150,-215],[-181,300],[-75,-212],[-104,294],[-278,-236],[-170,0],[-24,352],[50,216],[-179,211],[-361,-113],[-235,277],[-190,142],[-1,334],[-214,252],[108,340],[226,330],[99,303],[225,43],[191,-94],[224,285],[201,-51],[212,183],[-52,270],[-155,106],[205,228],[-170,-7],[-295,-128],[-85,-131],[-219,131],[-392,-67],[-407,142],[-117,238],[-351,343],[390,247],[620,289],[228,0],[-38,-296],[586,23],[-225,366],[-342,225],[-197,296],[-267,252],[-381,187],[155,309],[493,19],[350,270],[66,287],[284,281],[271,68],[526,262],[256,-40],[427,315],[421,-124],[201,-266],[123,114],[469,-35],[-16,-136],[425,-101],[283,59],[585,-186],[534,-56],[214,-77],[370,96],[421,-177],[302,-83]],[[30185,57537],[-8,-139],[-163,-69],[91,-268],[-3,-309],[-123,-344],[105,-468],[120,38],[62,427],[-86,208],[-14,447],[346,241],[-38,278],[97,186],[100,-415],[195,-9],[180,-330],[11,-195],[249,-6],[297,61],[159,-264],[213,-74],[155,185],[4,149],[344,35],[333,9],[-236,-175],[95,-279],[222,-44],[210,-291],[45,-473],[144,13],[109,-139]],[[80013,63313],[-371,-505],[-231,-558],[-61,-410],[212,-623],[260,-772],[252,-365],[169,-475],[127,-1093],[-37,-1039],[-232,-389],[-318,-381],[-227,-492],[-346,-550],[-101,378],[78,401],[-206,335]],[[96623,40851],[-92,-78],[-93,259],[10,158],[175,-339]],[[96418,41756],[45,-476],[-75,74],[-58,-32],[-39,163],[-6,453],[133,-182]],[[64752,60417],[-201,-158],[-54,-263],[-6,-201],[-277,-249],[-444,-276],[-249,-417],[-122,-33],[-83,35],[-163,-245],[-177,-114],[-233,-30],[-70,-34],[-61,-156],[-73,-43],[-43,-150],[-137,13],[-89,-80],[-192,30],[-72,345],[8,323],[-46,174],[-54,437],[-80,243],[56,29],[-29,270],[34,114],[-12,257]],[[58175,37528],[113,-7],[134,-100],[94,71],[148,-59]],[[59119,34780],[-70,-430],[-32,-491],[-72,-267],[-190,-298],[-54,-86],[-118,-300],[-77,-303],[-158,-424],[-314,-609],[-196,-355],[-210,-269],[-290,-229],[-141,-31],[-36,-164],[-169,88],[-138,-113],[-301,114],[-168,-72],[-115,31],[-286,-233],[-238,-94],[-171,-223],[-127,-14],[-117,210],[-94,11],[-120,264],[-13,-82],[-37,159],[2,346],[-90,396],[89,108],[-7,453],[-182,553],[-139,501],[-1,1],[-199,768]],[[58409,41417],[-210,-81],[-159,-235],[-33,-205],[-100,-46],[-241,-486],[-154,-383],[-94,-13],[-90,68],[-311,65]]],"bbox":[-180,-85.60903777459767,180,83.64513000000001],"transform":{"scale":[0.0036000360003600037,0.00169255860333201],"translate":[-180,-85.60903777459767]}};





/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-multigauge.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-multigauge.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.MultiGaugeNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults = {};

/// <summary>
/// ```solid``` chrome by default.
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_4x2, Machinata.Reporting.Layouts.BLOCK_2x2];

/// <summary>
/// We do support a toolbar.
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.supportsToolbar = true;

/// <summary>
/// Legends are not necessary by default.
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.insertLegend = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.innerRadius = 0.5;

/// <summary>
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.outerRadius = 1.0;

/// <summary>
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.arcPadAngle = 2;

/// <summary>
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.layoutPadding = 18;


/// <summary>
/// The stroke width of the status arc line and it's arrow head, in pixels.
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.statusArcLineSize = 2; // was 4


/// <summary>
/// If set, a predifined maximum value for all the facts can be used (no fact should exceed this value).
/// If unset (null), the maximum value is automatically determined based on the facts.
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.defaults.maximumStatusValue = null;



Machinata.Reporting.Node.MultiGaugeNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var arcSliceActive = 'gray4';
    var arcSliceInactive = 'gray2';
    var labelColor = "black";
    if (json.chrome == "dark") {
        arcSliceActive = 'gray4';
        arcSliceInactive = 'gray5';
        labelColor = "white";
    }

    return {
        "data": [
          {
              "name": "facts",
              "values": null,
              "transform": [
                {
                    "type": "formula",
                    "as": "valAbs",
                    "expr": "abs(datum.val)"
                },
              ]
          },
          {
              "name": "factsResolved",
              "source": "facts",
              "transform": [
                {
                    "type": "identifier",
                    "as": "index",
                },
                {
                    "type": "formula",
                    "as": "categoryResolved",
                    "expr": "datum.category.resolved"
                },
                {
                    "type": "formula",
                    "as": "valAdjusted",
                    // This is either:
                    // the value adjusted to 0.0-1.0 based on the valScale scale (ie the largest fact value is 1.0)
                    // or 
                    // based on the maximumStatusValue value (factValue/maximumStatusValue), limited to max 1.0
                    "expr": json.maximumStatusValue == null ? "datum.val > 0 ? +max(scale('valScale',datum.valAbs),0.1) : -max(scale('valScale',datum.valAbs),0.1)" : "datum.val > 0 ? +min(datum.val/maximumStatusValue,1.0) : max(datum.val/maximumStatusValue,-1.0)"
                  },
                  {
                      "type": "formula",
                      "as": "valAdjusted",
                      "expr": "datum.val == 0 ? 0 : datum.valAdjusted"
                  },
                  {
                      "type": "formula",
                      "as": "valAdjustedForArrowHead",
                      "expr": "datum.valAdjusted > 0 ? max(datum.valAdjusted - 0.012,0) : min(datum.valAdjusted + 0.012,0)"
                  }
              ]
          },
          {
              "name": "factsGridded",
              "source": "factsResolved",
              "transform": [
                {
                    "type": "formula",
                    "as": "gridColumn",
                    "expr": "(datum.index-1) % columns"
                },
                {
                    "type": "formula",
                    "as": "gridRow",
                    "expr": "floor( (datum.index-1) / columns)"
                }
              ]
          },
          //{
          //    "name": "layoutInfo",
          //    "source": "factsGridded",
          //    "transform": [
          //      {
          //          "type": "aggregate",
          //          "fields": ["gridColumn", "gridRow"],
          //          "ops": ["max", "max"],
          //          "as": ["columns", "rows"]
          //      }
          //    ]
          //},
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
        ],
        "scales": [
          {
              "name": "numFactsToColumnsScale",
              "type": "linear",
              "domain": [0,1,2,3,4,5,6,7,8,9,10],
              "range":  [0,1,2,3,4,3,3,4,4,3, 5]
          },
          {
              "name": "valScale",
              "type": "linear",
              "domain": { "data": "facts", "field": "valAbs" },
              "range": [0,1]
          },
          {
              "name": "grayColorByShade",
              "type": "ordinal",
              "domain": { "data": "grayShades", "field": "data" },
              "range": { "scheme": "gray" }
          },
          {
              "name": "colorByShade",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": json.theme }
          }
        ],
        //NOTE: The vega layout is buggy in responsive mode (it doesnt re-fill space once shrunk)
        //"layout": {
        //    "columns": 4,
        //    "padding": 0
        //},
        "signals": [
            {
                "name": "maximumStatusValue",
                "init": json.maximumStatusValue
            },
            {
                "name": "numFacts",
                "init": "length(data('facts'))"
            },
            {
                // Column calculator, uses provided value if given
                "name": "_columns",
                "init": json.gaugeColumns || "numFacts > 10 ? 4 : scale('numFactsToColumnsScale',numFacts)"
            },
            {
                // Rows calculator, uses provided value if given
                "name": "_rows",
                "init": json.gaugeRows || "numFacts / _columns"
            },
            {
                // Actual columns to use, on aspect ratios less than 1 (portrait) fixed 2 columns
                "name": "columns",
                "update": "aspectRatio > 1.0 ? _columns : 2"
            },
            {
                // Actual rows to use, on aspect ratios less than 1 (portrait) fixed 2 columns
                "name": "rows",
                "update": "aspectRatio > 1.0 ? _rows : ceil(numFacts / 2.0)"
            },
            {
                "name": "itemWidth",
                "update": "width / columns"
            },
            {
                "name": "itemHeight",
                "update": "height / rows"
            },
            {
                "name": "_layoutPadding",
                "init": "" + json.layoutPadding + ""
            },
            {
                "name": "layoutPadding",
                "update": "responsiveLayout == 'mobile'||'tablet' ? _layoutPadding/2 : _layoutPadding"
            },
            {
                "name": "subtitleSize",
                "update": "min(itemWidth,itemHeight) < 210 ? (" + config.subtitleSize + " * " + config.mobileSubtitleSizeFactor + ") : " + config.subtitleSize
            },
            {
                "name": "labelSize",
                "update": "min(itemWidth,itemHeight) < 210 ? (" + config.labelSize + " * " + config.mobileLabelSizeFactor + ") : " + config.labelSize
            },
        ],

        "marks": [
          {
              "type": "group",
              "from": { "data": "factsGridded" },
              "signals": [
                  { "name": "outerWidth", "update": "itemWidth" },
                  { "name": "outerHeight", "update": "itemHeight" },
                  { "name": "itemX", "update": "itemWidth" },
                  { "name": "itemY", "update": "itemHeight" },
                  { "name": "data", "init": "parent" }
              ],
                "encode": {
                    "enter": {
                        "clip": { "value": true }
                    },
                  "update": {
                        "width": { "signal": "itemWidth" },
                        "height": { "signal": "itemHeight" },
                        "x": { "signal": "itemWidth * datum.gridColumn" },
                        "y": { "signal": "itemHeight * datum.gridRow" }
                    }
              },
              "marks": [
                  {
                      "type": "group",
                      "encode": {
                          "update": {
                              "x": { "signal": "layoutPadding" },
                              "y": { "signal": "layoutPadding" },
                              "width": { "signal": "outerWidth - layoutPadding*2" },
                              "height": { "signal": "outerHeight - layoutPadding*2" },
                              "clip": { "value": true }
                          }
                      },
                      "signals": [
                          { "name": "innerWidth", "update": "outerWidth - layoutPadding*2" },
                          { "name": "innerHeight", "update": "outerHeight - layoutPadding*2" },
                          { "name": "innerSize", "update": "min(innerWidth,innerHeight)" }
                      ],
                      "marks": [
                          {
                              "type": "arc",
                              /*"_comment": "BACKGROUND ARC LEFT",*/
                              "encode": {
                                  "enter": {
                                      //"fill": { "scale": "grayColorByShade", "value": "gray3" }
                                      "fill": { "signal": "data.valAdjusted < 0 ? scale('grayColorByShade','" + arcSliceActive + "') : scale('grayColorByShade','" + arcSliceInactive+"')" }
                                  },
                                  "update": {
                                      "x": { "signal": "innerWidth / 2" },
                                      "y": { "signal": "innerHeight / 2" },
                                      "startAngle": { "signal": "0" },
                                      "endAngle": { "signal": "-PI" },
                                      "padAngle": { "signal": "(PI/180) * " + json.arcPadAngle },
                                      "innerRadius": { "signal": "(innerSize / 2)*" + json.innerRadius },
                                      "outerRadius": { "signal": "(innerSize / 2)*" + json.outerRadius }
                                  }
                              }
                          },
                            {
                                "type": "arc",
                                /*"_comment": "BACKGROUND ARC RIGHT",*/
                                "encode": {
                                    "enter": {
                                        //"fill": { "scale": "grayColorByShade", "value": "gray3" }
                                        "fill": { "signal": "data.valAdjusted > 0 ? scale('grayColorByShade','" + arcSliceActive + "') : scale('grayColorByShade','" + arcSliceInactive+"')" }
                                    },
                                    "update": {
                                        "x": { "signal": "innerWidth / 2" },
                                        "y": { "signal": "innerHeight / 2" },
                                        "startAngle": { "signal": "0" },
                                        "endAngle": { "signal": "PI" },
                                        "padAngle": { "signal": "(PI/180) * " + json.arcPadAngle },
                                        "innerRadius": { "signal": "(innerSize / 2)*" + json.innerRadius },
                                        "outerRadius": { "signal": "(innerSize / 2)*" + json.outerRadius },
                                    }
                                }
                            },
                            {
                                "type": "arc",
                                /*"_comment": "VALUE ARC",*/
                                "encode": {
                                    "enter": {
                                        "fill": { "signal": "data.valAdjusted > 0 ? scale('colorByShade','bright') : scale('colorByShade','bright')" } // always bright
                                    },
                                    "update": {
                                        "x": { "signal": "innerWidth / 2" },
                                        "y": { "signal": "innerHeight / 2" },
                                        "startAngle": { "signal": "0" },
                                        "endAngle": { "signal": "PI * data.valAdjusted" },
                                        "padAngle": { "signal": "(PI/180) * " + json.arcPadAngle },
                                        "innerRadius": { "signal": "(innerSize / 2)*" + (json.innerRadius + 0.1) },
                                        "outerRadius": { "signal": "(innerSize / 2)*" + (json.outerRadius - 0.1) }
                                    }
                                }
                            },
                            {
                                "type": "arc",
                                /*"_comment": "VALUE LINE",*/
                                "encode": {
                                    "enter": {
                                        "fill": { "value": "white" } //TODO
                                    },
                                    "update": {
                                        "x": { "signal": "innerWidth / 2" },
                                        "y": { "signal": "innerHeight / 2" },
                                        "startAngle": { "signal": "0" },
                                        "endAngle": { "signal": "PI * data.valAdjusted * 0.99" },
                                        "padAngle": { "signal": "(PI/180) * " + json.arcPadAngle },
                                        "innerRadius": { "signal": "(innerSize / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + " - " + (json.statusArcLineSize / 2) },
                                        "outerRadius": { "signal": "(innerSize / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + " + " + (json.statusArcLineSize / 2) }
                                    }
                                }
                            },
                            {
                                "type": "rect",
                                /*"_comment": "VALUE FOOT",*/
                                "encode": {
                                    "enter": {
                                        "fill": { "value": "white" } //TODO
                                    },
                                    "update": {
                                        "x": { "signal": "(innerWidth/2)-" + (json.statusArcLineSize * 2/2) },
                                        "y": { "signal": "(innerHeight/2) - (innerSize/2)*" + json.outerRadius },
                                        "width": { "value": (json.statusArcLineSize*2) },
                                        "height": { "signal": "(innerSize/2) * " + (json.outerRadius - json.innerRadius) },
                                        
                                    }
                                }
                            },
                            {
                                "type": "symbol",
                                /*"_comment": "ARROW HEAD",*/
                                "encode": {
                                    "enter": {
                                        "opacity": { "signal": "data.valAdjusted == 0 ? 0 : 1" },
                                        "stroke": { "value": "white" },
                                        //"strokeWidth": { "value": 4 },
                                        "strokeWidth": { "value": (json.statusArcLineSize) },
                                        "shape": { "value": "M-1,1L0,0L-1,-1" },
                                        "size": { "signal": "(innerSize / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + " *4.0" }, // at normal res should be about 1000
                                    },
                                    "update": {
                                        "angle": { "signal": "(data.valAdjusted > 0 ? (data.valAdjusted * 180) : (data.valAdjusted * 180)+180)" },
                                        "x": { "signal": "innerWidth/2  + sin(PI * data.valAdjustedForArrowHead)*  (innerSize / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + "" },
                                        "y": { "signal": "innerHeight/2 - cos(PI * data.valAdjustedForArrowHead)*  (innerSize / 2)*" + ((json.innerRadius + json.outerRadius) / 2) + "" },
                                    }
                                }
                            },
                            {
                                "type": "text",
                                /*"_comment": "CATEGORY LABEL",*/
                                "encode": {
                                    "enter": {
                                        "align": { "value": "center" },
                                        "baseline": { "value": "bottom" },
                                        "text": { "signal": "data.categoryResolved" },
                                        "fill": { "value": labelColor }
                                    },
                                    "update": {
                                        "fontSize": { "signal": "labelSize" },
                                        "dy": { "signal": "-labelSize/3" },
                                        "x": { "signal": "innerWidth/2" },
                                        "y": { "signal": "innerHeight/2" },
                                    }
                                }
                            },
                            {
                                "type": "text",
                                /*"_comment": "VAL LABEL",*/
                                "encode": {
                                    "enter": {
                                        "dy": { "signal": "0" },
                                        "align": { "value": "center" },
                                        "baseline": { "value": "top" },
                                        "text": { "signal": "data.resolved" },
                                        "fill": { "value": labelColor }
                                    },
                                    "update": {
                                        "fontSize": { "signal": "subtitleSize" },
                                        "x": { "signal": "innerWidth/2" },
                                        "y": { "signal": "innerHeight/2" }
                                    }
                                }
                            }
                      ]
                  },
                
                
              ]
          }
        ]
    };
};
Machinata.Reporting.Node.MultiGaugeNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    spec["data"][0].values = json.facts;
};
Machinata.Reporting.Node.MultiGaugeNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    if (nodeElem != null) nodeElem.addClass("numfacts-"+json.facts.length);
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.MultiGaugeNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.MultiGaugeNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.MultiGaugeNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {

    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryFacts(instance, config, json, workbook,format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};








/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-pivot.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-pivot.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// A simple interactive pivot for VerticalTableNode.
/// This node is compatible with any VerticalTableNode, 
/// and only requires a few additional properties (```pivotData```, ```pivotAggregation```)  to work.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.PivotTableNode = {};


/// <summary>
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults = {};

/// <summary>
/// This node does not support being added to dashboards...
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.supportsDashboard = false;

/// <summary>
/// Defines the default table column (id) to use for the pivot operation rows.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.pivotRow = null;

/// <summary>
/// Defines the default table column (id) to use for the pivot operation columns.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.pivotColumn = null;

/// <summary>
/// Required. Defines the table column (id) to use for the pivot operation data.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.pivotData = null;

/// <summary>
/// Required. Defines the pivot operation aggregation type.
/// Possible values are:
///  - ```percent```: calculates a pivot based on total sum, displayed in percent
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.pivotAggregation = null;

/// <summary>
/// Required. The D3 format to use for the pivot calculations.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.pivotAggregationFormat = null;

/// <summary>
/// If ```true```, then a pivot calculation can be done on the same column. The data can be argued to be
/// meaningless, however there can be UX advantages to allowing this.
/// data. By default ```false```.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.allowPivotOnSameColumn = false;

/// <summary>
/// If ```true```, then each pivot result fact can be drilled down on, exposing the underlying
/// data. By default ```true```.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.allowPivotResultsDrilldown = true;

/// <summary>
/// If ```true```, the drilldown results table will expose the filters to the user, allow the user
/// to further explore the drilldown.
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.showPivotResultsDrilldownFilters = false;


/// <summary>
/// Defines the chart type to use for charts that have all positive values.
/// Default is ```DonutNode```.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.chartTypePositiveValues = "DonutNode";

/// <summary>
/// Defines the chart type to use for charts that have negative values.
/// Default is ```VBarNode```.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.chartTypeNegativeValues = "HBarNode";

/// <summary>
/// When ```true```, the chart legends are automaticall balanced so that they will have
/// the same count of rows, thus taking up the same amount of space.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.chartBalancedLegends = true;

/// <summary>
/// Defines the number of columns for the chart legends.
/// Default is ```2```.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.chartLegendColumns = 2;

/// <summary>
/// Pivots are by default ```light``` chrome.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.defaults.chrome = "light";

/// <summary>
/// Rebuilds the pivot data and charts using the currently set ```pivotRow``` and ```pivotColumn```.
/// </summary>
Machinata.Reporting.Node.PivotTableNode.rebuild = function (instance, config, json, nodeElem) {
    
    // Debug
    Machinata.debug("PivotTableNode.rebuild()");
    Machinata.debug("  pivotRow: " + json.pivotRow);
    Machinata.debug("  pivotColumn: " + json.pivotColumn);
    Machinata.debug("  pivotData: " + json.pivotData);
    Machinata.debug("  pivotAggregation: " + json.pivotAggregation);
    Machinata.debug("  pivotFormat: " + json.pivotFormat);

    // Init
    var pivotElem = nodeElem.data("pivot-elem");
    pivotElem.empty();
    var formatterAggregation = d3.format(json.pivotAggregationFormat);


    // Create table data for pivotted data...
    var pivotData = {};
    pivotData.columnDimension = {};
    pivotData.columnDimension.dimensionGroups = [{
        "id": json.columnDimension.dimensionGroups[0].id+"-pivot",
        "importance": 2,
        "dimensionElements": []
    }];
    pivotData.rowDimension = {};
    pivotData.rowDimension.dimensionGroups = [{
        "id": json.rowDimension.dimensionGroups[0].id + "-pivot",
        "importance": 2,
        "dimensionElements": []
    }];
    pivotData.allowRowFiltering = true;

    // Chart data
    //TODO: refactor chart title extractions....
    var chart1Title = json.pivotRow; //fallback
    $.each(json.columnDimension.dimensionGroups, function (index, dimensionGroupJSON) {
        $.each(dimensionGroupJSON.dimensionElements, function (index, dimensionElementJSON) {
            if (dimensionElementJSON.id == json.pivotRow) {
                var resolvedTitle = Machinata.Reporting.Text.resolve(instance,dimensionElementJSON.name);
                if (resolvedTitle != null) chart1Title = resolvedTitle;
            }
        });
    });
    var chart1Node = {
        "nodeType": json.chartTypePositiveValues,
        "theme": json.theme,
        "chrome": json.chrome,
        "sortFacts": "descending",
        "legendColumns": json.chartLegendColumns, 
        "series": [{
            "id": "s0",
            "title": { "resolved": chart1Title }, 
            "facts": []
        }]
    };
    var chart2Title = json.pivotColumn; // fallback
    $.each(json.columnDimension.dimensionGroups, function (index, dimensionGroupJSON) {
        $.each(dimensionGroupJSON.dimensionElements, function (index, dimensionElementJSON) {
            if (dimensionElementJSON.id == json.pivotColumn) {
                var resolvedTitle = Machinata.Reporting.Text.resolve(instance,dimensionElementJSON.name);
                if (resolvedTitle != null) chart2Title = resolvedTitle;
            }
        });
    });
    var chart2Node = {
        "nodeType": json.chartTypePositiveValues,
        "theme": json.theme,
        "chrome": json.chrome,
        "sortFacts": "descending",
        "legendColumns": json.chartLegendColumns,
        "series": [{
            "id": "s0",
            "title": { "resolved": chart2Title }, 
            "facts": []
        }]
    };
    var chartsLayoutNode = {
        "nodeType": "LayoutNode",
        "style": "CS_W_Two_Columns", //TODO
        "slotChildren": {
            "{left}": 0,
            "{right}": 1
        },
        "children": []
    };
    chartsLayoutNode.children.push(chart1Node);
    chartsLayoutNode.children.push(chart2Node);

    // Pivot table columns (based on pivotColumn) (label is not needed)
    {
        // Find all matching pivotColumn facts
        $.each(json.rowDimension.dimensionGroups, function (index, groupJSON) {
            $.each(groupJSON.dimensionElements, function (index, rowJSON) {
                $.each(rowJSON.facts, function (index, factJSON) {
                    // Match?
                    if (factJSON.col == json.pivotColumn) {
                        var factId = factJSON.resolved; //TODO
                        // New? We only add new discovieres
                        var exists = false;
                        $.each(pivotData.columnDimension.dimensionGroups[0].dimensionElements, function (index, columnJSON) {
                            if (columnJSON.id == factId) {
                                exists = true;
                                return;
                            }
                        });
                        if (exists == true) return;
                        var newColumnJSON = {
                            "id": factId,
                            "name": {
                                "resolved": factJSON.resolved
                            },
                            "sort": factJSON.val,
                            "importance": 2,
                            "valueType": "string"
                        };
                        pivotData.columnDimension.dimensionGroups[0].dimensionElements.push(newColumnJSON);
                    }
                });
            });
        });
        //TODO: SORT!
        // Total column
        var totalColumnJSON = {
            "id": "total-col",
            "name": {
                "resolved": Machinata.Reporting.Text.translate(instance, "reporting.total-row")
            },
            "importance": 1,
            "valueType": "string"
        };
        pivotData.columnDimension.dimensionGroups[0].dimensionElements.push(totalColumnJSON);
    }

    // Pivot table rows (based on pivotRow)
    {
        // Find all matching pivotRow facts
        $.each(json.rowDimension.dimensionGroups, function (index, groupJSON) {
            $.each(groupJSON.dimensionElements, function (index, rowJSON) {
                $.each(rowJSON.facts, function (index, factJSON) {
                    // Match?
                    if (factJSON.col == json.pivotRow) {
                        var factId = factJSON.resolved; //TODO
                        // New? We only add new discovieres
                        var exists = false;
                        $.each(pivotData.rowDimension.dimensionGroups[0].dimensionElements, function (index, columnJSON) {
                            if (columnJSON.id == factId) {
                                exists = true;
                                return;
                            }
                        });
                        if (exists == true) return;
                        // Create row definition
                        var newRowJSON = {
                            "id": factId,
                            "name": {
                                "resolved": factJSON.resolved
                            },
                            "importance": 2,
                            "facts": []
                        };
                        pivotData.rowDimension.dimensionGroups[0].dimensionElements.push(newRowJSON);
                    }
                });
            });
        });
        //TODO: SORT!
        // Total row

    }

    // Compile pivot aggregate values
    var totalRowData = {}; // contains the total for each column
    // Lets go through each cell in our pivot...
    $.each(pivotData.rowDimension.dimensionGroups[0].dimensionElements, function (index, privotRowJSON) {
        var rowTotal = 0;
        $.each(pivotData.columnDimension.dimensionGroups[0].dimensionElements, function (index, pivotColumnJSON) {
            //console.log(pivotColumnJSON.id + " x " + privotRowJSON.id);
            var sum = 0; // set to null to leave blank
            var hasValue = false;
            // Lets go through the original data to get total
            $.each(json.rowDimension.dimensionGroups, function (index, dataGroupJSON) {
                $.each(dataGroupJSON.dimensionElements, function (index, dataRowJSON) {
                    // Does the element match?
                    var val = null;
                    var rowMatches = false;
                    var columnMatches = false;
                    $.each(dataRowJSON.facts, function (index, dataFactJSON) {
                        if (dataFactJSON.col == json.pivotData) val = dataFactJSON.val;
                        if (dataFactJSON.col == json.pivotColumn && dataFactJSON.resolved == pivotColumnJSON.name.resolved) rowMatches = true;
                        if (dataFactJSON.col == json.pivotRow && dataFactJSON.resolved == privotRowJSON.name.resolved) columnMatches = true;
                    });
                    //console.log("rowMatches="+rowMatches+", columnMatches="+columnMatches+", val="+val);
                    if (rowMatches == true && columnMatches == true && val != null) {
                        if (sum == null) sum = 0;
                        sum += val;
                        hasValue = true;
                        //console.log("match! new sum = "+sum);
                    }
                });
            });
            // Create fact
            if (pivotColumnJSON.id == "total-col") sum = rowTotal;
            var newPivotFact = {
                "val": sum,
                "resolved": sum,
                "col": pivotColumnJSON.id
            };
            // Fact drilldown
            if (json.allowPivotResultsDrilldown == true) {
                var drilldown = {};
                drilldown.filters = [];
                if (pivotColumnJSON.id != "total-col") {
                    drilldown.filters.push({
                        "columnId": json.pivotColumn,
                        "isAny": [ Machinata.Reporting.Text.resolve(instance, pivotColumnJSON.name) ]
                    });
                }
                drilldown.filters.push({
                    "columnId": json.pivotRow,
                    "isAny": [ Machinata.Reporting.Text.resolve(instance, privotRowJSON.name) ]
                });
                if (hasValue == true || pivotColumnJSON.id == "total-col") {
                    newPivotFact.link = {
                        "tooltip": {
                            "resolved": Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on") + Machinata.Reporting.Text.resolve(instance,pivotColumnJSON.name) + " " + Machinata.Reporting.Text.resolve(instance,privotRowJSON.name)
                        },
                        "elementId": json.id + "_DATA",
                        "drilldown": drilldown
                    };
                }
            }
            privotRowJSON.facts.push(newPivotFact);
            if (pivotColumnJSON.id == "total-col") privotRowJSON.totalFact = newPivotFact; // shortcut for later
            if (sum != null && rowTotal == null) rowTotal = 0;
            if (sum != null) rowTotal += sum;
            // Register in totals row
            if (totalRowData[pivotColumnJSON.id] == null && sum != null) totalRowData[pivotColumnJSON.id] = 0;
            if (sum != null) totalRowData[pivotColumnJSON.id] += sum;
        });
    });
    // Add totals row
    var totalSum = null;
    {
        // Create row json 
        var newRowJSON = {
            "id": "total-row",
            "name": {
                "resolved": "Total" //TODO
            },
            "importance": 1,
            "facts": []
        };
        pivotData.rowDimension.dimensionGroups[0].dimensionElements.push(newRowJSON);
        // Add each total column cell
        $.each(totalRowData, function (key, val) {
            // Totals fact
            var newPivotFact = {
                "val": val,
                "resolved": val,
                "col": key
            };
            if (key == "total-col") totalSum = val;
            // Fact drilldown
            if (json.allowPivotResultsDrilldown == true) {
                var tooltip = Machinata.Reporting.Text.translate(instance, "reporting.tables.drilldown-on-total");
                var drilldown = {};
                drilldown.filters = [];
                if (key != "total-col") {
                    drilldown.filters.push({
                        "columnId": json.pivotColumn,
                        "value": key
                    });
                    tooltip += " " + key;
                }
                newPivotFact.link = {
                    "tooltip": {
                        "resolved": tooltip
                    },
                    "elementId": json.id + "_DATA",
                    "drilldown": drilldown
                };
            }
            newRowJSON.facts.push(newPivotFact);
        });
    }
    //console.log("pivot total = " + totalSum);


    // Make percent?
    if (json.pivotAggregation == "percent") {
        // Go through each row and update
        $.each(pivotData.rowDimension.dimensionGroups, function (index, pivotGroupJSON) {
            $.each(pivotGroupJSON.dimensionElements, function (index, pivotRowJSON) {
                $.each(pivotRowJSON.facts, function (index, pivotFactJSON) {
                    //pivotFactJSON.tooltip = {"resolved":pivotFactJSON.val};
                    pivotFactJSON.val = pivotFactJSON.val / totalSum;
                    pivotFactJSON.resolved = formatterAggregation(pivotFactJSON.val);
                });
            });
        });
    }

    // Create chart1/chart2 data facts
    var allValuesPositive = true;
    $.each(pivotData.rowDimension.dimensionGroups[0].dimensionElements, function (index, pivotRowJSON) {
        if (pivotRowJSON.id == "total-row") {
            // This is our chart 2
            $.each(pivotRowJSON.facts, function (index, factJSON) {
                if (factJSON.col == "total-col") return;
                if (factJSON.val < 0) allValuesPositive = false;
                chart2Node.series[0].facts.push(
                    {
                        "val": factJSON.val,
                        "resolved": factJSON.resolved,
                        "category": { "resolved": factJSON.col }
                    }
                );
            });
        } else if (pivotRowJSON.totalFact != null) {
            // This our chart 1
            if (pivotRowJSON.totalFact.val < 0) allValuesPositive = false;
            chart1Node.series[0].facts.push(
                {
                    "val": pivotRowJSON.totalFact.val,
                    "resolved": pivotRowJSON.totalFact.resolved,
                    "category": { "resolved": Machinata.Reporting.Text.resolve(instance,pivotRowJSON.name) }
                }
            );
        }
    });

    // Change chart type based on whether there exist negative values
    if (allValuesPositive != true) {
        chart1Node.nodeType = json.chartTypeNegativeValues;
        chart2Node.nodeType = json.chartTypeNegativeValues;
    }

    // Balance the chart legends?
    if (json.chartBalancedLegends == true && chart1Node != null && chart2Node != null) {
        // Here we fix the legend rows to the max of both charts, taking into account the columns configured.
        var maxFacts = Math.max(chart1Node.series[0].facts.length, chart2Node.series[0].facts.length);
        chart1Node.legendMinRows = Math.ceil(maxFacts / (chart1Node.legendColumns || 1));
        chart2Node.legendMinRows = Math.ceil(maxFacts / (chart2Node.legendColumns || 1));
    }

    // Create charts
    var chartsElem = $("<div class='charts'></div>");
    pivotElem.append(chartsElem);
    {
        var chartsNodeElem = Machinata.Reporting.buildContents(instance, config, chartsLayoutNode, json, chartsElem);
        //Machinata.Responsive.detectNewResponsiveElements(); // deprecated
        //Machinata.Responsive.updateResponsiveElements(); // deprecated
        nodeElem.data("charts-elem", chartsElem);
        chartsElem.find(".machinata-reporting-node").trigger("machinata-reporting-redraw-node");
    }

    // Create table elem with pivoted data
    var tablePivotElem = Machinata.Reporting.Node.VerticalTableNode.buildTable(instance, config, pivotData, nodeElem, {
        interactive: true
    });
    tablePivotElem.attr("id", json.id + "_PIVOT");
    tablePivotElem.addClass("pivot-table");
    pivotElem.append(tablePivotElem);

    


};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PivotTableNode.init = function (instance, config, json, nodeElem) {


    // Create dimension selector
    var selectWrapperElem = $('<div class="machinata-reporting-select-wrapper"><select class="machinata-reporting-select"></select></div>');
    selectWrapperElem.append(Machinata.Reporting.buildIcon(instance,"chevron-down"));
    {
        var selectElem = selectWrapperElem.find("select");
        $.each(json.columnDimension.dimensionGroups, function (index, groupJSON) {
            $.each(groupJSON.dimensionElements, function (index, columnJSON) {
                // Exclude the pivot data row (doesnt make sense)
                if (columnJSON.id == json.pivotData) return;
                // Create option
                var optElem = $("<option></option>");
                optElem.text(Machinata.Reporting.Text.resolve(instance,columnJSON.name));
                optElem.attr("value", columnJSON.id);
                optElem.attr("data-column-id", columnJSON.id);
                selectElem.append(optElem);
                //TODO: Set default pivot selections
            });
        });
    }

    // Create configuration UI
    var configurationElem = $("<div class='node-config machinata-reporting-config'></div>");
    var pivotRowSelectElem = selectWrapperElem.clone().appendTo(configurationElem);
    pivotRowSelectElem.find("option[value='" + json.pivotRow + "']").attr("selected", "selected");
    pivotRowSelectElem.on("change", function () {
        // Validate the change
        var newRow = pivotRowSelectElem.find(":selected").attr("value");
        if (newRow == json.pivotColumn && json.allowPivotOnSameColumn != true) {
            // Revert back
            pivotRowSelectElem.find("select").val(json.pivotRow);
            return;
        }
        json.pivotRow = newRow;
        Machinata.Reporting.Node.PivotTableNode.rebuild(instance, config, json, nodeElem);
    });
    nodeElem.data("pivot-row-select", pivotRowSelectElem);
    var crossElem = Machinata.Reporting.buildIcon(instance,"cross").addClass("machinata-reporting-cross");
    configurationElem.append(crossElem);
    var pivotColumnSelectElem = selectWrapperElem.clone().appendTo(configurationElem);
    pivotColumnSelectElem.find("option[value='" + json.pivotColumn + "']").attr("selected", "selected");
    pivotColumnSelectElem.on("change", function () {
        // Validate the change
        var newColumn = pivotColumnSelectElem.find(":selected").attr("value");
        if (newColumn == json.pivotRow && json.allowPivotOnSameColumn != true) {
            // Revert back
            pivotColumnSelectElem.find("select").val(json.pivotColumn);
            return;
        }
        json.pivotColumn = newColumn
        Machinata.Reporting.Node.PivotTableNode.rebuild(instance, config, json, nodeElem);
    });
    nodeElem.data("pivot-column-select", pivotColumnSelectElem);
    configurationElem.append("<div class='clear'></div>");
    nodeElem.append(configurationElem);

    // Pivot results container
    var pivotElem = $("<div class='pivot-results'></div>").appendTo(nodeElem);
    nodeElem.data("pivot-elem", pivotElem);


    // Create table elem with drilldown data
    if (json.allowPivotResultsDrilldown == true) {

        // Create table data for drilldown (just a copy of the driving data)...
        var drilldownData = {};
        drilldownData.id = json.id + "_DATA";
        drilldownData.columnDimension = json.columnDimension;
        drilldownData.rowDimension = json.rowDimension;
        if (json.showPivotResultsDrilldownFilters == true) {
            drilldownData.showRowFiltering = true;
        }

        // Table
        var tableDrilldownElem = Machinata.Reporting.Node.VerticalTableNode.buildTable(instance, config, drilldownData, nodeElem, {
            interactive: true
        });
        Machinata.Reporting.Tools.makeTableSortable(instance, tableDrilldownElem);
        Machinata.Reporting.Tools.makeTableFilterable(instance, tableDrilldownElem);
        tableDrilldownElem.hide();
        tableDrilldownElem.attr("id", drilldownData.id);
        tableDrilldownElem.addClass("drilldown-table");
        nodeElem.append(tableDrilldownElem);
    }

    // Do rebuild of pivot data
    Machinata.Reporting.Node.PivotTableNode.rebuild(instance, config, json, nodeElem);

    // Export
    Machinata.Reporting.Node.registerExportOptions(instance, config, json, nodeElem, {
        "xlsx": "Excel",
        "csv": "CSV",
    });

};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PivotTableNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {

    Machinata.debug("Machinata.Reporting.Node.PivotTableNode.exportFormat", instance, config, json, nodeElem, format, filename);

    if (format == "xlsx" || format == "csv") {
      
        var tempTableElem = Machinata.Reporting.Node.VerticalTableNode.buildTable(instance, config, json, nodeElem, {
            interactive: false,
            includeFormattingInformation: true,
        });

        var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
        workbook = Machinata.Reporting.Export.createExcelDataForTable(instance, config, json, workbook, tempTableElem, format);
        Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
        return true;
    }
   
    return false;
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PivotTableNode.draw = function (instance, config, json, nodeElem) {
    
};











/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-pack.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-pack.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <example>
/// See ```example-report-packs.json``` for complete example usages.
/// </example>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.LineColumnNode</inherits>
Machinata.Reporting.Node.PackNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PackNode.defaults = {};

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.chrome = "light";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_4x2, Machinata.Reporting.Layouts.BLOCK_2x2];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.supportsToolbar = true;

/// <summary>
/// Yes, insert a legend by default.
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.insertLegend = true;


/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.legendColumns = 3;

/// <summary>
/// Sets the correct legend data source for the automatic legend.
/// </summary>
Machinata.Reporting.Node.PackNode.defaults.legendDataSource = "factsLegend";

Machinata.Reporting.Node.PackNode.getVegaSpec = function (instance, config, json, nodeElem) {
    return {
        "data": [
          {
              "name": "facts",
              "values": null
          },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
          {
              "name": "factsResolved",
              "source": "facts",
              "transform": [
                {
                    "type": "stratify",
                    "key": "id",
                    "parentKey": "parent"
                },
                {
                    "type": "pack",
                    "field": json.weightingKey,
                    "padding": 4,
                    "sort": { "field": json.weightingKey },
                    "size": [{ "signal": "width" }, { "signal": "height" }]
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum." + json.shadingKey
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "colorResolved",
                    "expr": "datum.depth == 0 ? scale('grayByShade','gray3') : ( datum.depth == 1 ? scale('grayByShade','gray1') :  scale('color',datum." + json.shadingKey+") )  "
                },
              ]
          },
          {
              "name": "factsPacked",
              "source": "factsResolved",
              "transform": [
                    
                    
              ]
          },
          {
              "name": "factsLegend",
              "source": "factsResolved",
              "transform": [
                    { "type": "filter", "expr": "datum.depth >= 2" },
                    {
                        "type": "aggregate",
                        "groupby": [json.shadingKey, "colorResolved", "key"],
                    }

              ]
          }
        ],
        "signals": [
            
        ],
        "scales": [
            {
                "name": "color",
                "type": "ordinal",
                "domain": { "data": "facts", "field": json.shadingKey },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorFill",
                "type": "quantize",
                "domain": [0,1],
                "range": { "scheme": "infographic" },
                "reverse": true
            },
            {
                "name": "legendColor",
                "type": "ordinal",
                "domain": { "data": "factsLegend", "field": "key" },
                "range": { "data": "factsLegend", "field": "colorResolved" },
            },
            {
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "factsLegend", "field": "key" },
                "range": { "data": "factsLegend", "field": json.shadingKey }
            },
            {
                "name": "grayColor",
                "type": "ordinal",
                "domain": { "data": "facts", "field": "id" },
                "range": { "scheme": "gray" }
            },
            {
                "name": "infographicColor",
                "type": "ordinal",
                "domain": { "data": "facts", "field": "id" },
                "range": { "scheme": "infographic" }
            },
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "grayByShade",
                "type": "ordinal",
                "domain": { "data": "grayShades", "field": "data" },
                "range": { "scheme": "gray" }
            },
        ],
        "marks": [
          {
              "type": "symbol",
              "from": { "data": "factsPacked" },
              "encode": {
                  "enter": {
                      "shape": { "value": "circle" },
                      "tooltip": { "signal": "datum.titleResolved + (datum." + json.weightingKey + " ? ': '+format(datum." + json.weightingKey + ",'.2s')+', '+datum.weight+', '+datum." + json.shadingKey + " : '')" }
                  },
                  "update": {
                      "x": { "field": "x" },
                      "y": { "field": "y" },
                      "size": { "signal": "4 * datum.r * datum.r" },
                      "stroke": { "value": "black" },
                      "strokeWidth": { "value": 0 },
                      "fill": { "signal": "datum.colorResolved" },
                  },
                  "hover": {
                      //"strokeWidth": { "value": 2 },
                  }
              }
          }
        ]
    };
};
Machinata.Reporting.Node.PackNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    spec["data"][0].values = json.facts;
};
Machinata.Reporting.Node.PackNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.PackNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);

    Machinata.Reporting.Node.VegaNode.debugOutputDataSet(nodeElem, 'factsLegend');
};
Machinata.Reporting.Node.PackNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-sunburst.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-sunburst.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// </summary>
/// <example>
/// See ```example-report-packs.json``` for complete example usages.
/// </example>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.LineColumnNode</inherits>
Machinata.Reporting.Node.SunburstNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults = {};

/// <summary>
/// 
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.chrome = "light";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_4x2, Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.supportsToolbar = true;

/// <summary>
/// Yes, insert a legend by default.
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.insertLegend = true;


/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.legendColumns = 3;

/// <summary>
/// Sets the correct legend data source for the automatic legend.
/// </summary>
Machinata.Reporting.Node.SunburstNode.defaults.legendDataSource = "factsLegend";

Machinata.Reporting.Node.SunburstNode.getVegaSpec = function (instance, config, json, nodeElem) {
    return {
        "data": [
          {
              "name": "facts",
              "values": null
          },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
          {
              "name": "factsPartitioned",
              "source": "facts",
              "transform": [
                {
                    "type": "stratify",
                    "key": "id",
                    "parentKey": "parent"
                },
                {
                    "type": "partition",
                    "field": json.weightingKey,
                    "sort": {"field": json.weightingKey},
                    "size": [{ "signal": "2 * PI" }, { "signal": "min(width,height) / 2" }],
                    "as": ["a0", "r0", "a1", "r1", "depth", "children"]
                }
              ]
          },
          {
              "name": "factsResolved",
              "source": "factsPartitioned",
              "transform": [
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum." + json.shadingKey
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "colorResolved",
                    "expr": "datum.depth == 0 ? scale('grayByShade','gray3') : ( datum.depth == 1 ? scale('color',datum.id) :  scale('color',datum.parent) )  "
                },
              ]
          },
          {
              "name": "factsLegend",
              "source": "factsResolved",
              "transform": [
                    { "type": "filter", "expr": "datum.depth == 1" },
                    {
                        "type": "aggregate",
                        "groupby": [json.shadingKey, "colorResolved", "key"],
                    }

              ]
          }
        ],
        "signals": [
            
        ],
        "scales": [
            {
                "name": "color",
                "type": "ordinal",
                "domain": { "data": "factsPartitioned", "field": json.shadingKey },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorFill",
                "type": "quantize",
                "domain": [0,1],
                "range": { "scheme": "infographic" },
                "reverse": true
            },
            {
                "name": "legendColor",
                "type": "ordinal",
                "domain": { "data": "factsLegend", "field": "key" },
                "range": { "data": "factsLegend", "field": "colorResolved" },
            },
            {
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "factsLegend", "field": "key" },
                "range": { "data": "factsLegend", "field": json.shadingKey }
            },
            {
                "name": "grayColor",
                "type": "ordinal",
                "domain": { "data": "facts", "field": "id" },
                "range": { "scheme": "gray" }
            },
            {
                "name": "infographicColor",
                "type": "ordinal",
                "domain": { "data": "facts", "field": "id" },
                "range": { "scheme": "infographic" }
            },
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "grayByShade",
                "type": "ordinal",
                "domain": { "data": "grayShades", "field": "data" },
                "range": { "scheme": "gray" }
            },
        ],
        "marks": [
            {
                "type": "arc",
                "from": { "data": "factsResolved" },
                "encode": {
                    "enter": {
                        "x": { "signal": "width / 2" },
                        "y": { "signal": "height / 2" },
                        "fill": { "signal": "datum.colorResolved" },

                        "opacity": { "signal": "datum.depth == 0 ? 0 : datum.depth == 1 ? 1.0 : 1/datum.depth" }
                        //"tooltip": { "signal": "datum.name + (datum.size ? ', ' + datum.size + ' bytes' : '')" }
                    },
                    "update": {
                        "startAngle": { "field": "a0" },
                        "endAngle": { "field": "a1" },
                        "innerRadius": { "field": "r0" },
                        "outerRadius": { "field": "r1" },
                        "stroke": { "value": "white" },
                        "strokeWidth": { "value": 1 },
                        "zindex": { "value": 0 },
                    },
                    "hover": {
                        "stroke": { "value": "red" },
                        "strokeWidth": { "value": 2 },
                        "zindex": { "value": 1 }
                    }
                }
            }
          /*{
              "type": "symbol",
              "from": { "data": "factsPacked" },
              "encode": {
                  "enter": {
                      "shape": { "value": "circle" },
                      "tooltip": { "signal": "datum.titleResolved + (datum." + json.weightingKey + " ? ': '+format(datum." + json.weightingKey + ",'.2s')+', '+datum.weight+', '+datum." + json.shadingKey + " : '')" }
                  },
                  "update": {
                      "x": { "field": "x" },
                      "y": { "field": "y" },
                      "size": { "signal": "4 * datum.r * datum.r" },
                      "stroke": { "value": "black" },
                      "strokeWidth": { "value": 0 },
                      "fill": { "signal": "datum.colorResolved" },
                  },
                  "hover": {
                      //"strokeWidth": { "value": 2 },
                  }
              }
          }*/
        ]
    };
};
Machinata.Reporting.Node.SunburstNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    //TODO: temporary patch of fact data to make it relative
    if (false) {
        var map = {};
        for (var i = 0; i < json.facts.length; i++) {
            var fact = json.facts[i];
            map[fact.id] = fact;
        }
        for (var i = 0; i < json.facts.length; i++) {
            var fact = json.facts[i];
            if (fact.parent == null) continue;
            var parent = map[fact.parent];
            fact.marketValueRelative = (fact.marketValue / parent.marketValue);
        }
        console.log(json.facts);
    }
    spec["data"][0].values = json.facts;
};
Machinata.Reporting.Node.SunburstNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.SunburstNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);

    Machinata.Reporting.Node.VegaNode.debugOutputDataSet(nodeElem, 'factsLegend');
    Machinata.Reporting.Node.VegaNode.debugOutputDataSet(nodeElem, 'factsResolved');
};
Machinata.Reporting.Node.SunburstNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-richtext.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-richtext.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Basic node for displaying a block of rich text.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.RichTextNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.RichTextNode.defaults = {};

/// <summary>
/// By default RichTextNode have a ```light``` chrome.
/// </summary>
Machinata.Reporting.Node.RichTextNode.defaults.chrome = "light";

/// <summary>
/// This node does not support being added to dashboards...
/// </summary>
Machinata.Reporting.Node.RichTextNode.defaults.supportsDashboard = false;

/// <summary>
/// The main resolvable richt-text to display in HTML format.
/// The HTML must be fully qualified HTML (for example, a ```img``` should always be contained in a ```p``` and without any styling information.
/// Supported HTML tags:
///  - ```h1```: title heading
///  - ```h2```: subtitle heading
///  - ```h3```: heading
///  - ```p```: paragraph
///  - ```img```: inline image
///  - ```ul```: un-ordered list
///  - ```ol```: ordered list
///  - ```li```: list item (requires a list parent)
///  - ```a```: text link (renders with underline)
///  - ```b```/```strong```: strong (renders bold)
///  - ```em```: emphasis (renders italic, nesting not supported)
///  - ```u```: underline (not recommended, confuses users with link)
///  - ```i```: idiomatic text (renders italic)
/// </summary>
/// <example>
/// ### Texts
/// ```
/// <h1>Title</h1>
/// <h2>Subtitle</h2>
/// <p>Paragraph text in long form.</p>
/// <p>Second paragraph text in long form.</p>
/// ```
/// ### Images
/// ```
/// <p><img src="data:image/png;base64,iVBORw0KGgoAAA"/></p>
/// ```
/// ### Links
/// ```
/// <p><a href="/more/information">More information</a></p>
/// ```
/// ### Lists
/// ```
/// <ul><li>Item 1</li><li>Item 2</li><li>Item 3</li></ul>
/// ```
/// </example>
Machinata.Reporting.Node.RichTextNode.defaults.html = null;

/// <summary>
/// If ```true```, the user can easily copy the text to clipboard.
/// By default ```true```.
/// </summary>
Machinata.Reporting.Node.RichTextNode.defaults.addCopyToClipboardTool = true;

/// <summary>
/// If ```true```, the ```html``` property must be fully-qualified HTML, or even just plain text.
/// It is highly recommended to set this to ```true``` to ensure a safe and secure injection of markup code into the page.
/// By default ```false```.
/// </summary>
Machinata.Reporting.Node.RichTextNode.defaults.requireFullyQualifiedHTML = false;

Machinata.Reporting.Node.RichTextNode.init = function (instance, config, json, nodeElem) {

    // Init
    var html = Machinata.Reporting.Text.resolve(instance,json["html"]);

    // Create body with html
    var containerElem = $("<div class='body'></div>");
    if (html != null) {
        if (json.requireFullyQualifiedHTML == false) {
            // Detect if contains HTML, if so set the node html to value, otherwise set as text
            var isHTML = Machinata.String.isHTML(html);
            if (isHTML == true) {
                containerElem.html(html);
            } else {
                containerElem.text(html);
            }
        } else {
            // Create new node, then append to dom
            containerElem.append($(html));
        }
    }
    nodeElem.append(containerElem);

    // Tools
    if (json.addCopyToClipboardTool == true) {
        Machinata.Reporting.addTool(instance, nodeElem, Machinata.Reporting.Text.translate(instance, "reporting.nodes.copy-to-clipboard"), "copy", function () {
            Machinata.Reporting.Tools.copyElementToClipboard(containerElem, Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied'), Machinata.Reporting.Text.translate(instance, 'reporting.nodes.copied.text'));
        });
    }
};
Machinata.Reporting.Node.RichTextNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-link.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-link.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Node for displaying a link to a external or embedded resource.
/// Link Nodes don't have toolbars, and are used to supplement a visual node (as a child) as a trailer.
/// The node's mainTitle defines the text to display.
/// A Link Node must have either a ```attachment``` (embedded resource) or a ```link```.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.LinkNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LinkNode.defaults = {};


/// <summary>
/// By default LinkNode have a ```light``` chrome.
/// </summary>
Machinata.Reporting.Node.LinkNode.defaults.chrome = "light";

/// <summary>
/// This node does not support being added to dashboards...
/// </summary>
Machinata.Reporting.Node.LinkNode.defaults.supportsDashboard = false;

/// <summary>
/// No tools for LinkNode
/// </summary>
Machinata.Reporting.Node.LinkNode.defaults.addStandardTools = false;

/// <summary>
/// No toolbar for LinkNode
/// </summary>
Machinata.Reporting.Node.LinkNode.defaults.supportsToolbar = false;

/// <summary>
/// Marks the attachment as a file download.
/// </summary>
Machinata.Reporting.Node.LinkNode.defaults.downloadAttachmentToBrowser = false;


/// <summary>
/// The attachment JSON asset object that contains the data for the attachment. 
/// </summary>
/// <example>
/// ```
/// "attachment": {
///     "filename": "CS_PaperReport_long-v2.pdf",
///     "mimeType": "application/pdf",
///     "encoding": "base64",
///     "data": "JVBERi0xLjcNJeLjz9MNCjE2MyAwIG9iag08PC9MaW5lYXJ..."
/// }
/// ```
/// </example>
Machinata.Reporting.Node.LinkNode.defaults.attachment = null;

/// <summary>
/// The link JSON for the external resource. See Machinata.Reporting.Node.Defaults.link.
/// </summary>
Machinata.Reporting.Node.LinkNode.defaults.link = null;


/// <summary>
/// </summary>
Machinata.Reporting.Node.LinkNode.init = function (instance, config, json, nodeElem) {
    // Container
    var linkElem = $("<a class='machinata-reporting-button option-link'></a>");
    linkElem.text(Machinata.Reporting.Text.resolve(instance,json.mainTitle));
    if (json.attachment != null) {
        linkElem.attr("title", json.attachment.filename);
        if (json.downloadAttachmentToBrowser == true) {
            linkElem.append(Machinata.Reporting.buildIcon(instance,"download"));
        } else {
            linkElem.append(Machinata.Reporting.buildIcon(instance,"arrow-right"));
        }
    } else {
        if(json.link.tooltip != null) linkElem.attr("title", Machinata.Reporting.Text.resolve(instance,json.link.tooltip));
        linkElem.append(Machinata.Reporting.buildIcon(instance,"arrow-right"));
    }

    // Link interaction
    linkElem.click(function (event) {
        event.preventDefault();
        if (json.attachment != null) {
            // Attachment
            if (json.downloadAttachmentToBrowser == true) {
                Machinata.Data.exportDataAsBlob(
                    json.attachment.data,
                    json.attachment.mimeType,
                    json.attachment.filename
                );
            } else {
                Machinata.Data.openDataInNewWindow(
                    json.attachment.data,
                    json.attachment.mimeType,
                    json.attachment.filename
                );
            }
        } else {
            // Link
            Machinata.Reporting.Tools.openLink(instance,json.link);
        }
    });
    
    nodeElem.append(linkElem);


};
Machinata.Reporting.Node.LinkNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-coresatellite.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-coresatellite.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// A specialized infographic that shows a planet surrounded by a series of satellites.
/// If the node is used in tight space, one must make sure to configure the label settings to ensure that
/// the text is properly truncated.
///
/// Currently only two series are officially supported: 
///  * Serie 1: The planet (one fact)
///  * Serie 2: The satellites (one to six facts)
///
/// Planet labels are included in the center of the planet in bold, while satellite labels are included on the 
/// outside of the satellite and autmatically aligned away from the planet. These labels are automatically line-breaked
/// and/or truncated using the following settings:
///  * ```planetLabelLimitPixels```
///  * ```planetLabelLimitChars```
///  * ```planetLabelLimitLines```
///  * ```planetLabelLimitEllipsis```
///  * ```satelliteLabelLimitPixels```
///  * ```satelliteLabelLimitChars```
///  * ```satelliteLabelLimitLines```
///  * ```satelliteLabelLimitEllipsis```
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.CoreSatelliteNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults = {};

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Donuts and pies have a ```solid``` chrome.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.supportsToolbar = true;

/// <summary>
/// The chart never has a legend.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.insertLegend = false;

/// <summary>
/// If ```true```, sorts the facts automatically. Otherwise the facts are displayed in the order
/// of the data structure...
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.sortFacts = false;

/// <summary>
/// The pixel limit (width) of a planet label. If the label exceeds, the ```planetLabelLimitEllipsis```
/// is automatically postfixed.
/// This setting is a fallback incase the automatic line breaking functions do not succeed due to long words.
/// By default ```300```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.planetLabelLimitPixels = 300;

/// <summary>
/// The number of characters allowed on the label per line. If the label exceeds this character
/// count, the label is automatically split into lines.
/// By default ```8```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.planetLabelLimitChars = 8;

/// <summary>
/// The maximumum number of lines a label can span. If the maximum lines exceed, the 
/// ```planetLabelLimitEllipsis``` is automatically postfixed.
/// By default ```8```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.planetLabelLimitLines = 8;

/// <summary>
/// The ellipsis string to use.
/// By default ```Machinata.Reporting.Config.textTruncationEllipsis```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.planetLabelLimitEllipsis = Machinata.Reporting.Config.textTruncationEllipsis;

/// <summary>
/// Adds a line-break space before the planet value.
/// By default ```true``` for web, ```false``` for print.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.planetLabelAddSpaceBeforeValue = true;

/// <summary>
/// The pixel limit (width) of a planet label. If the label exceeds, the ```satelliteLabelLimitEllipsis```
/// is automatically postfixed.
/// This setting is a fallback incase the automatic line breaking functions do not succeed due to long words.
/// By default ```300```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.satelliteLabelLimitPixels = 300;

/// <summary>
/// The number of characters allowed on the label per line. If the label exceeds this character
/// count, the label is automatically split into lines.
/// By default ```24```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.satelliteLabelLimitChars = 24;

/// <summary>
/// The maximumum number of lines a label can span. If the maximum lines exceed, the 
/// ```satelliteLabelLimitEllipsis``` is automatically postfixed.
/// By default ```3```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.satelliteLabelLimitLines = 3;

/// <summary>
/// The ellipsis string to use.
/// By default ```Machinata.Reporting.Config.textTruncationEllipsis```.
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.defaults.satelliteLabelLimitEllipsis = Machinata.Reporting.Config.textTruncationEllipsis;


/// <summary>
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.getVegaSpec = function (instance, config, json, nodeElem) {
    // Helper function (macro) to calculate multi-line offset
    function calculateMultilineOffset(numberLinesSignal, fontSize) {
        // "-(parent.labelResolvedLineBreaked.length*" + config.labelSize*1.5 + ")/2 + (" + config.labelSize*1.5/2 + ")"
        var lineHeight = fontSize * 1.2; // this seems to be the line height after some testing
        return "( +(" + lineHeight / 2 + ") -(" + numberLinesSignal + "*" + lineHeight + ")/2 )";
    }
    // Create the sort (collection) transform. If no sort is given, we just provide an empty transform
    var collectTransform = {"type": "collect"};
    if (json.sortFacts != false && json.sortFacts != null) {
        collectTransform["sort"] = {
            "field": "fact.val",
            "order": [json.sortFacts]
        };
    }
    return {
        "data": [
          {
              "name": "series",
              "values": null
          },
          {
              "name": "seriesResolved",
              "source": "series",
              "transform": [
                  {
                      "type": "flatten",
                      "fields": ["facts"],
                      "as": ["fact"]
                  }
              ]
          },
          {
              "name": "factsResolved",
              "source": "seriesResolved",
              "transform": [
                  { "type": "formula", "initonly": true, "as": "key", "expr": "datum.fact.category.resolved" },
                  { "type": "formula", "initonly": true, "as": "valResolved", "expr": "datum.fact.resolved" },
                  { "type": "formula", "initonly": true, "as": "tooltipResolved", "expr": "datum.fact.category.resolved + ': ' + datum.valResolved" },
                  { "type": "formula", "initonly": true, "as": "labelResolved", "expr": "datum.fact.category.resolved" },
                  { "type": "formula", "initonly": true, "as": "labelResolvedLineBreaked", "expr": "datum.fact.categoryLineBreaked" },
                  { "type": "formula", "initonly": true, "as": "serieSize", "expr": "(scale('serieSize',datum.serieIndex)) * (1/datum.serieTotal) * 0.4" },
                  { "type": "formula", "initonly": true, "as": "serieOffset", "expr": "(datum.serieSize*4.2)*datum.serieIndex" },
                  { "type": "formula", "initonly": true, "as": "factAngle", "expr": "(datum.fact.factIndex/datum.fact.factTotal)*(360) + (360/datum.fact.factTotal)/2" },
                  collectTransform
              ]
          },

          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
        ],
        "signals": [
            {
                "name": "drawSize",
                "update": "min(width,height)",

            },
            {
                "name": "centerX",
                "update": "width/2",
            },
            {
                "name": "centerY",
                "update": "height/2",
            }
        ],
        "scales": [

          {
              "name": "colorByShade",
              "type": "ordinal",
              "domain": { "data": "colorShades", "field": "data" },
              "range": { "scheme": json.theme }
          },
          {
              "name": "grayColor",
              "type": "ordinal",
              "domain": { "data": "grayShades", "field": "data" },
              "range": { "scheme": "gray" }
          },
          {
              "name": "serieColor",
              "type": "ordinal",
              "domain": { "data": "seriesResolved", "field": "serieIndex" },
              "range": { "scheme": json.theme }
          },
          {
              "name": "serieArcColor",
              "type": "ordinal",
              "domain": { "data": "seriesResolved", "field": "serieIndex" },
              "range": { "scheme": "gray" }
          },
          {
              "name": "serieTextColor",
              "type": "ordinal",
              "domain": { "data": "seriesResolved", "field": "serieIndex" },
              "range": { "scheme": "text-on-" + json.theme }
          },
          {
              "name": "color",
              "type": "ordinal",
              "domain": { "data": "factsResolved", "field": "key" },
              "range": { "scheme": json.theme }
          },
          {
              "name": "sliceTextColor",
              "type": "ordinal",
              "domain": { "data": "factsResolved", "field": "key" },
              "range": { "scheme": "text-on-" + json.theme }
          },
          {
              "name": "serieSize",
              "type": "linear",
              "domain": { "data": "seriesResolved", "field": "serieIndex" },
              "range": [1.0,0.5]
          },
        ],

        "marks": [
            {
                "name": "planetSeriesLines",
                /*"_comment": "We have to draw these first in th background of all series",*/
                "type": "group",
                "from": {
                    "facet": {
                        "data": "factsResolved",
                        "name": "facetSeries",
                        "groupby": "id"
                    }
                },
                "marks": [
                    {
                        "name": "planetLines",
                        /*"_comment": "This group has a single line from a to b. The line must be in a group, otherwise the lines are connected.",*/
                        "type": "group",
                        "from": {
                            "data": "facetSeries",
                        },
                        "marks": [
                            {
                                "name": "planetLine",
                                /*"_comment": "Planet line from planet center to center...",*/
                                "type": "rule",
                                "encode": {
                                    "enter": {
                                        "stroke": {
                                            "signal": "scale('grayColor','gray3')"
                                        },
                                        "strokeWidth": {
                                            "value": (config.padding / 2)
                                        }
                                    },
                                    "update": {
                                        "x": {
                                            "signal": "centerX"
                                        },
                                        "y": {
                                            "signal": "centerY"
                                        },
                                        "x2": {
                                            "signal": "centerX + (drawSize*parent.serieOffset)*cos((parent.factAngle-90)*(PI/180))"
                                        },
                                        "y2": {
                                            "signal": "centerY + (drawSize*parent.serieOffset)*sin((parent.factAngle-90)*(PI/180))"
                                        }
                                    }
                                }
                            },
                        ]
                    }
                ]
            },
          {
              "name": "planetSeries",
              "type": "group",
              "from": {
                  "facet": {
                      "data": "factsResolved",
                      "name": "facetSeries",
                      "groupby": "id"
                  }
              },
              "marks": [
                  {
                      "name": "planets",
                      /*"_comment": "This group moves to the center point of the planet based on its angle",*/
                      "type": "group",
                      "from": {
                          "data": "facetSeries",
                      },
                      "encode": {
                          "update": {
                              "xc": {
                                  "signal": "centerX + (drawSize*datum.serieOffset)*cos((datum.factAngle-90)*(PI/180))"
                              },
                              "yc": {
                                  "signal": "centerY + (drawSize*datum.serieOffset)*sin((datum.factAngle-90)*(PI/180))"
                              }
                          }
                      },
                      "marks": [
                          {
                              "name": "planetSphereBG",
                              /*"_comment": "Planet circle bg...",*/
                              "type": "arc",
                              "encode": {
                                  "enter": {
                                      "fill": {
                                          "signal": "scale('grayColor','gray3')"
                                      },
                                      "startAngle": {
                                          "signal": "0"
                                      },
                                      "endAngle": {
                                          "signal": "2*PI"
                                      },
                                      "xc": {
                                          "signal": "0"
                                      },
                                      "yc": {
                                          "signal": "0"
                                      },
                                      "innerRadius": {
                                          "signal": "0"
                                      },
                                      "tooltip": {
                                          "signal": "parent.tooltipResolved"
                                      }
                                  },
                                  "update": {
                                      "outerRadius": {
                                          "signal": "drawSize*parent.serieSize + " + (config.padding / 2)
                                      }
                                  }
                              }
                          },
                          {
                              "name": "planetSphereArcs",
                              /*"_comment": "Planet circle arc bg...",*/
                              "type": "arc",
                              "encode": {
                                  "enter": {
                                      "fill": {
                                          "signal": "scale('grayColor','gray4')"
                                          //"signal": "scale('serieColor',parent.serieIndex)"
                                          //"signal": "scale('serieArcColor',parent.serieIndex)"
                                      },
                                      "startAngle": {
                                          "signal": "0"
                                      },
                                      "endAngle": {
                                          "signal": "2*PI * parent.fact.val"
                                      },
                                      "xc": {
                                          "signal": "0"
                                      },
                                      "yc": {
                                          "signal": "0"
                                      },
                                      "innerRadius": {
                                          "signal": "0"
                                      },
                                      "tooltip": {
                                          "signal": "parent.tooltipResolved"
                                      }
                                  },
                                  "update": {
                                      "outerRadius": {
                                          "signal": "drawSize*parent.serieSize + "+(config.padding/2)
                                      }
                                  }
                              }
                          },
                          {
                              "name": "planetSpheres",
                              /*"_comment": "Planet circles...",*/
                              "type": "arc",
                              "encode": {
                                  "enter": {
                                      "fill": {
                                          "signal": "scale('serieColor',parent.serieIndex)"
                                      },
                                      "startAngle": {
                                          "signal": "0"
                                      },
                                      "endAngle": {
                                          "signal": "2*PI"
                                      },
                                      "xc": {
                                          "signal": "0"
                                      },
                                      "yc": {
                                          "signal": "0"
                                      },
                                      "innerRadius": {
                                          "signal": "0"
                                      },
                                      "tooltip": {
                                          "signal": "parent.tooltipResolved"
                                      }
                                  },
                                  "update": {
                                      "outerRadius": {
                                          "signal": "drawSize*parent.serieSize"
                                      }
                                  }
                              }
                          },
                          {
                              "name": "planetInsideLabels",
                              /*"_comment": "Text labels ontop of circle",*/
                              "type": "text",
                              "encode": {
                                  "enter": {
                                      "text": { "signal": "parent.serieIndex == 0 ? parent.labelResolvedLineBreaked : parent.valResolved" },
                                      "xc": { "value": 0 },
                                      "yc": { "value": 0 },
                                      "dy": { "signal": "parent.serieIndex != 0 ? 0 : "+calculateMultilineOffset("parent.labelResolvedLineBreaked.length",config.labelSize) },
                                      "align": { "value": "center" },
                                      "baseline": { "value": "middle" },
                                      "fill": { "signal": "scale('serieTextColor',parent.serieIndex)" },
                                      //"stroke": { "signal": "scale('serieColor',parent.serieIndex)" }, doesnt work, stroke is inside text
                                      //"strokeWidth": { "value": 1 },
                                      "font": { "value": config.labelFont },
                                      "fontSize": { "value": config.labelSize },
                                      "fontWeight": { "value": "bold" },// TODO??
                                      "tooltip": {
                                          "signal": "parent.tooltipResolved"
                                      } 
                                  },
                                  "update": {

                                  }
                              }
                          },
                          {
                              "name": "planetOutsideLabels",
                              /*"_comment": "Text labels next to circle",*/
                              "type": "text",
                              "encode": {
                                  "enter": {
                                      "text": { "signal": "parent.serieIndex == 0 ? null : parent.labelResolvedLineBreaked" },
                                      "dy": { "signal": "parent.serieIndex == 0 ? 0 : " + calculateMultilineOffset("parent.labelResolvedLineBreaked.length", config.textSize) },
                                      "yc": { "value": 0 },
                                      "fontSize": { "value": config.chartTextSize },
                                      "align": { "signal": "(parent.factAngle >= 180 ? 'right' : 'left')" },
                                      "baseline": { "value": "middle" },
                                      "limit": { "value": json.planetLabelLimitPixels },
                                      "ellipsis": { "value": json.planetLabelLimitEllipsis },
                                      "tooltip": {
                                          "signal": "parent.tooltipResolved"
                                      }
                                  },
                                  "update": {

                                      "xc": { "signal": "  (drawSize*parent.serieSize+"+(config.padding*1.5)+")  * (parent.factAngle >= 180 ? -1 : 1)" },
                                  }
                              }
                          }
                      ]
                  }
              ]
          }
        ]
    };
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    spec["data"][0].values = json.series;
};


/// <summary>
/// </summary>
Machinata.Reporting.Node.CoreSatelliteNode.init = function (instance, config, json, nodeElem) {
    // Pre-index series
    for (var s = 0; s < json.series.length; s++) {
        json.series[s].serieIndex = s;
        json.series[s].serieTotal = json.series.length;
        for (var f = 0; f < json.series[s].facts.length; f++) {
            json.series[s].facts[f].factIndex = f;
            json.series[s].facts[f].factTotal = json.series[s].facts.length;
            // Create string array for planet label
            var catResolved = Machinata.Reporting.Text.resolve(instance,json.series[s].facts[f].category);
            var categoryLineBreaked = null;
            if (s == 0) {
                // Planet label...
                categoryLineBreaked = Machinata.Reporting.Tools.lineBreakString(catResolved, {
                    maxCharsPerLine: json.planetLabelLimitChars,
                    maxLines: json.planetLabelLimitLines,
                    wordSeparator: " ",
                    ellipsis: json.planetLabelLimitEllipsis,
                    appendEllipsisOnLastLine: true,
                    returnArray: true
                });
                if (categoryLineBreaked == null) categoryLineBreaked = [];
                // Add spacer line break
                // Add value
                if (json.planetLabelAddSpaceBeforeValue == true && categoryLineBreaked.length < (json.planetLabelLimitLines)) categoryLineBreaked.push(" ");
                categoryLineBreaked.push(json.series[s].facts[f].resolved);
            } else {
                // Satellite label...
                categoryLineBreaked = Machinata.Reporting.Tools.lineBreakString(catResolved, {
                    maxCharsPerLine: json.satelliteLabelLimitChars,
                    maxLines: json.satelliteLabelLimitLines,
                    wordSeparator: " ",
                    ellipsis: json.planetLabelLimitEllipsis,
                    appendEllipsisOnLastLine: true,
                    returnArray: true
                });
            }
            // Register
            json.series[s].facts[f].categoryLineBreaked = categoryLineBreaked;
        }
    }
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.CoreSatelliteNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.CoreSatelliteNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};


Machinata.Reporting.Node.CoreSatelliteNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {

    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};









/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-calibration-test.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-calibration-test.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// 
/// Note: This node should not be used in production.
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.CalibrationTestNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults = {};

/// <summary>
/// We have a solid chrome by default.
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// By default ```auto```. Defines the layout-dpi size of the blocks in the ruler.
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.blockSize = 'auto';

/// <summary>
/// By default ```auto```. Defines the number of blocks/ticks to show in the ruler.
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.numberOfBlocks = "auto";

/// <summary>
/// The units to work with. Can be ether ```px```, ```mm```, or ```in```.
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.units = "px";

/// <summary>
/// If ```true```, will show the font in different sizes.
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.showTextSizes = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.textSizesMin = 8;

/// <summary>
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.defaults.textSizesMax = 40;

/// <summary>
/// </summary>
Machinata.Reporting.Node.CalibrationTestNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var ruleSize = 10;
    var blockSizePX = 10; // default
    var blockSizeInUnits = 10; // default
    var numberOfBlocks = 10; // default
    var widthInUnitsSignal = "width";
    var heightInUnitsSignal = "height";
    if (json.unit == "px") {
        if (json.blockSize == null || json.blockSize == "auto") blockSizeInUnits = 10;
        if (json.numberOfBlocks == null || json.numberOfBlocks == "auto") numberOfBlocks = 10;
        blockSizePX = blockSizeInUnits;
    } else if (json.unit == "mm") {
        if (json.blockSize == null || json.blockSize == "auto") blockSizeInUnits = 10;
        if (json.numberOfBlocks == null || json.numberOfBlocks == "auto") numberOfBlocks = 10;
        blockSizePX = Machinata.Reporting.Tools.convertMillimetersToPixels(config,blockSizeInUnits);
        widthInUnitsSignal = "width / " + Machinata.Reporting.Tools.convertMillimetersToPixels(config,1);
        heightInUnitsSignal = "height / " + Machinata.Reporting.Tools.convertMillimetersToPixels(config,1);
    } else if (json.unit == "in") {
        if (json.blockSize == null || json.blockSize == "auto") blockSizeInUnits = 1 / 8;
        if (json.numberOfBlocks == null || json.numberOfBlocks == "auto") numberOfBlocks = 8;
        blockSizePX = Machinata.Reporting.Tools.convertInchesToPixels(config,blockSizeInUnits);
        widthInUnitsSignal = "width / " + Machinata.Reporting.Tools.convertInchesToPixels(config,1);
        heightInUnitsSignal = "height / " + Machinata.Reporting.Tools.convertInchesToPixels(config,1);
    }

    var textSizes = [];
    var totalTextSize = 0;
    if (json.showTextSizes == true) {
        for (var s = json.textSizesMin; s <= json.textSizesMax; s += 2) {
            totalTextSize += s;
            textSizes.push({
                size: s,
                offset: totalTextSize
            });
        }
    }

    return {
        "data": [
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "blocks",
              "transform": [
                  { "type": "sequence", "start": 0, "stop": numberOfBlocks, "as": "index" }
              ]
          },
          {
              "name": "textSizes",
              "values": textSizes
          },
        ],
        "scales": [
        ],
        "signals": [
            {
                "name": "drawSize",
                "update": "min(width,height)",
            },
            {
                "name": "centerX",
                "update": "width/2",
            },
            {
                "name": "centerY",
                "update": "height/2",
            },
            {
                "name": "widthInUnits",
                "update": widthInUnitsSignal,
            },
            {
                "name": "heightInUnits",
                "update": heightInUnitsSignal,
            }
        ],
        "marks": [
            {
                "type": "group",
                /*"_comment": "CROPPER",*/
                "marks": []
            },
            {
                "type": "group",
                /*"_comment": "FONT CALIBRATION TEXT FONT",*/
                "marks": [
                    {
                        "type": "text",
                        "from": { "data": "textSizes" },
                        "encode": {
                            "enter": {
                                "align": { "value": "left" },
                                "baseline": { "value": "top" },
                                "font": { "value": config.textFont },
                                "fontSize": { "signal": "datum.size" },
                            },
                            "update": {
                                "x": { "signal": ruleSize/2 },
                                "y": { "signal": "20+datum.offset" },
                                "text": { "signal": "datum.size + 'px' + (datum.size == " + config.chartTextSize + " ? ' default' : '')" },
                            }
                        }
                    },
                ]
            },
            {
                "type": "group",
                /*"_comment": "FONT CALIBRATION NUMBER FONT",*/
                "marks": [
                    {
                        "type": "text",
                        "from": { "data": "textSizes" },
                        "encode": {
                            "enter": {
                                "align": { "value": "right" },
                                "baseline": { "value": "top" },
                                "font": { "value": config.numberFont },
                                "fontSize": { "signal": "datum.size" },
                            },
                            "update": {
                                "x": { "signal": "width - "+ruleSize / 2 },
                                "y": { "signal": "20+datum.offset" },
                                "text": { "signal": "(datum.size == " + config.chartTextSize + " ? 'default ' : '') + datum.size + 'px'" },
                            }
                        }
                    },
                ]
            },
          {
              "type": "group",
              /*"_comment": "RULER CALIBRATION BLOCKS",*/
              "encode": {
                  "update": {
                      "x": { "signal": "centerX" },
                      "y": { "signal": "centerY - ("+blockSizePX+" * data('blocks').length)/2" },
                  }
              },
              "marks": [
                  {
                      "type": "group",
                      "from": { "data": "blocks" },
                      "encode": {
                          "update": {
                              "xc": { "signal": "0" },
                              "yc": { "signal": "datum.index * " + blockSizePX },
                          }
                      },
                      "marks": [
                          {
                              "type": "rect",
                              "encode": {
                                  "update": {
                                      "fill": { "signal": "parent.index % 2 == 0 ? 'black' : 'lightgray'" },
                                      
                                      "width": { "value": blockSizePX },
                                      "height": { "value": blockSizePX }
                                  }
                              }
                          },
                          {
                              "type": "text",
                              "encode": {
                                  "enter": {
                                      "dx": { "value": blockSizePX * 1.5 },
                                      "dy": [
                                          {
                                              "test": "parent.index == 0",
                                              "value": 0,
                                          },
                                          {
                                              "test": "parent.index == data('blocks').length-1",
                                              "value": blockSizePX,
                                          },
                                          {
                                              "value": 0
                                          }
                                      ],
                                      "align": { "value": "left" },
                                      "baseline": { "value": "middle" },
                                      "fontSize": { "value": 10 },
                                  },
                                  "update": {
                                      "text": [
                                          {
                                              "test": "parent.index == 0",
                                              "signal": "(parent.index * " + blockSizePX + ") + '"+json.unit+"'",
                                          },
                                          {
                                              "test": "parent.index == data('blocks').length-1",
                                              "signal": "((parent.index+1) * " + blockSizeInUnits + ") + '" + json.unit + "' + ' / ' + format((parent.index+1) * " + blockSizePX + ",',.2f') + 'px' + ' @ ' + " + config.layoutingDPI + "+ 'dpi'",
                                          },
                                          {
                                              "value": null
                                          }
                                      ],
                                  }
                              }
                          }
                      ]
                  },
              ]
          },
          {
              "type": "text",
              "encode": {
                  "enter": {
                      "dx": { "value": ruleSize/2 },
                      "dy": { "value": ruleSize/2 },
                      "align": { "value": "left" },
                      "baseline": { "value": "top" },
                      "fontSize": { "value": 10 },
                  },
                  "update": {
                      "text": {
                          "signal": "format(widthInUnits,',.2f') + 'x' + format(heightInUnits,',.2f') + '" + json.unit + "' + ' / ' + width + 'x' + height + 'px' + ' @ ' + " + config.layoutingDPI + "+ 'dpi'"
                      }
                  }
              }
          },
          {
              "type": "group",
              /*"_comment": "TOP LEFT CROP MARKS",*/
              "marks": [
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": 0 },
                              "y": { "signal": 0 },
                              "x2": { "signal": ruleSize },
                              "y2": { "signal": 0 }
                          }
                      }
                  },
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": 0 },
                              "y": { "signal": 0 },
                              "x2": { "signal": 0 },
                              "y2": { "signal": ruleSize }
                          }
                      }
                  }
              ]
          },
          {
              "type": "group",
              /*"_comment": "BOTTOM LEFT CROP MARKS",*/
              "marks": [
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": 0 },
                              "y": { "signal": "height-0.5" },
                              "x2": { "signal": ruleSize },
                              "y2": { "signal": "height-0.5" }
                          }
                      }
                  },
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": 0 },
                              "y": { "signal": "height-0.5" },
                              "x2": { "signal": 0 },
                              "y2": { "signal": "height-0.5-" + ruleSize }
                          }
                      }
                  }
              ]
          },
          {
              "type": "group",
              /*"_comment": "TOP RIGHT CROP MARKS",*/
              "marks": [
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": "width" },
                              "y": { "signal": 0 },
                              "x2": { "signal": "width-"+ruleSize },
                              "y2": { "signal": 0 }
                          }
                      }
                  },
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": "width" },
                              "y": { "signal": 0 },
                              "x2": { "signal": "width" },
                              "y2": { "signal": ruleSize }
                          }
                      }
                  }
              ]
          },
          {
              "type": "group",
              /*"_comment": "BOTTOM RIGHT CROP MARKS",*/
              "marks": [
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": "width" },
                              "y": { "signal": "height-0.5" },
                              "x2": { "signal": "width-" + ruleSize },
                              "y2": { "signal": "height-0.5" }
                          }
                      }
                  },
                  {
                      "type": "rule",
                      "encode": {
                          "enter": {
                              "strokeWidth": { "value": 1 }
                          },
                          "update": {
                              "x": { "signal": "width" },
                              "y": { "signal": "height-0.5" },
                              "x2": { "signal": "width" },
                              "y2": { "signal": "height-0.5-" + ruleSize }
                          }
                      }
                  }
              ]
          }
        ]
    };
};
Machinata.Reporting.Node.CalibrationTestNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    
};
Machinata.Reporting.Node.CalibrationTestNode.init = function (instance, config, json, nodeElem) {

    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.CalibrationTestNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.CalibrationTestNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};















/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-font-test.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-font-test.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// 
/// Note: This node should not be used in production.
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.FontTestNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults = {
    chrome: "solid"
};

/// <summary>
/// We have a solid chrome by default.
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// By default ```auto```. Defines the layout-dpi size of the blocks in the ruler.
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.blockSize = 'auto';

/// <summary>
/// By default ```auto```. Defines the number of blocks/ticks to show in the ruler.
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.numberOfBlocks = "auto";

/// <summary>
/// The units to work with. Can be ether ```px```, ```mm```, or ```in```.
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.units = "px";

/// <summary>
/// If ```true```, will show the font in different sizes.
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.showTextSizes = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.textSizesMin = 8;

/// <summary>
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.metricsTest = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.testText = "abcdefghijklmnop ABCDEFGHIJKLMNOP 0123456789 !@#$%^&*(),'\";:";

/// <summary>
/// </summary>
Machinata.Reporting.Node.FontTestNode.defaults.fontConfigToTest = "text";

/// <summary>
/// </summary>
Machinata.Reporting.Node.FontTestNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var EMPTY_GROUP = { "type": "group" };
    var font = config[json.fontConfigToTest + "Font"];
    var size = config[json.fontConfigToTest + "Size"];
    if (json.fontConfigToTest == "number") {
        size = config.chartTextSize;
    }
    if (json.fontConfigToTest == "system") {
        font = "sans-serif"
        size = config.chartTextSize;
    }
    var measurement = {};
    if (json.metricsTest == true) {
        var fontString = size + "px " + font;
        var canvas = Machinata.Imaging.createDrawingCanvas(1, 1);
        var context = canvas.getContext('2d');
        context.font = fontString;
        measurement = context.measureText(json.testText);
        console.log("measured dims are:", measurement);
    }
    return {
        "data": [
          
        ],
        "scales": [
        ],
        "signals": [
            
        ],
        "marks": [
            json.metricsTest==true ? EMPTY_GROUP : {
                "type": "group",
                /*"_comment": "CROPPER, DISPLAY FONT",*/
                "encode": {
                    "enter": {
                        "clip": { "value": true },
                    },
                    "update": {
                        "width": { "signal": "width" },
                        "height": { "signal": "height" }
                    }
                },
                "marks": [
                    {
                        "type": "text",
                        "encode": {
                            "enter": {
                                "align": { "value": "center" },
                                "baseline": { "value": "top" },
                                "font": { "value": font },
                                "fontSize": { "signal": size },
                            },
                            "update": {
                                "x": { "signal": "width/2" },
                                "y": { "signal": (size * 0.5) },
                                "text": { "value": json.fontConfigToTest + ", " + size + "px (" + font + ")" },
                            }
                        }
                    },
                    {
                        "type": "text",
                        "encode": {
                            "enter": {
                                "align": { "value": "center" },
                                "baseline": { "value": "top" },
                                "font": { "value": font },
                                "fontSize": { "signal": size },
                            },
                            "update": {
                                "x": { "signal": "width/2" },
                                "y": { "signal": (size * 2.5) },
                                "text": { "value": json.testText },
                            }
                        }
                    },
                    {
                        "type": "text",
                        "encode": {
                            "enter": {
                                "align": { "value": "center" },
                                "baseline": { "value": "top" },
                                "font": { "value": font },
                                "fontSize": { "signal": size * 10 },
                            },
                            "update": {
                                "x": { "signal": "width/2" },
                                "y": { "signal": (size * 4.5) },
                                "text": { "value": json.testText.split(' ') },
                            }
                        }
                    },
                ]
            },
            json.metricsTest==false ? EMPTY_GROUP : {
                "type": "group",
                /*"_comment": "CROPPER, DISPLAY METRICS",*/
                "encode": {
                    "enter": {
                        "clip": { "value": true },
                    },
                    "update": {
                        "width": { "signal": "width" },
                        "height": { "signal": "height" }
                    }
                },
                "marks": [
                    {
                        "type": "text",
                        "encode": {
                            "enter": {
                                "align": { "value": "center" },
                                "baseline": { "value": "top" },
                                "font": { "value": font },
                                "fontSize": { "signal": size },
                            },
                            "update": {
                                "x": { "signal": "width/2" },
                                "y": { "signal": (size * 0.5) },
                                "text": { "value": json.fontConfigToTest + ", " + size + "px (" + font + ")" },
                            }
                        }
                    },
                    {
                        "type": "text",
                        "encode": {
                            "enter": {
                                "align": { "value": "center" },
                                "baseline": { "value": "middle" },
                                "font": { "value": font },
                                "fontSize": { "signal": size },
                            },
                            "update": {
                                "x": { "signal": "width/2" },
                                "y": { "signal": "height/2" },
                                "text": { "value": json.testText },
                            }
                        }
                    },
                    {
                        "type": "rect",
                        "encode": {
                            "enter": {
                                "fill": { "value": "" },
                                "stroke": { "value": "red" },
                                "strokeWidth": { "value": 1 }
                            },
                            "update": {
                                "xc": { "signal": "width/2" },
                                "yc": { "signal": "height/2" },
                                "width": { "signal": measurement.width },
                                "height": { "signal": measurement.actualBoundingBoxAscent + measurement.actualBoundingBoxDescent }
                            }
                        }
                    },
                    {
                        "type": "rule",
                        "encode": {
                            "enter": {
                                "stroke": { "value": "green" },
                                "strokeWidth": { "value": 1 }
                            },
                            "update": {
                                "x": { "signal": "width/2 - "+measurement.width/2 },
                                "x2": { "signal": "width/2 + " + measurement.width/2 },
                                "y": { "signal": "height/2 + " + (-(measurement.actualBoundingBoxAscent + measurement.actualBoundingBoxDescent) / 2 + measurement.actualBoundingBoxAscent) },
                                "y2": { "signal": "height/2 + " + (-(measurement.actualBoundingBoxAscent + measurement.actualBoundingBoxDescent) / 2 + measurement.actualBoundingBoxAscent) }
                            }
                        }
                    }
                ]
            }
        ]
    };
};
Machinata.Reporting.Node.FontTestNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    
};
Machinata.Reporting.Node.FontTestNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.FontTestNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.FontTestNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};









/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-icon-test.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-icon-test.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// A very simple node that displays all the required icons for the reporting system.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.IconTestNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.IconTestNode.defaults = {};

/// <summary>
/// This node does not support a toolbar.
/// </summary>
Machinata.Reporting.Node.IconTestNode.defaults.chrome = "solid";


Machinata.Reporting.Node.IconTestNode.init = function (instance, config, json, nodeElem) {

    var containerElem = $("<div class='node-bg'></div>");
    nodeElem.append(containerElem);

    function addIcon(name) {
        var iconElem = Machinata.Reporting.buildIcon(instance,name);
        iconElem.css("border", "1px solid black");
        iconElem.css("margin", "1rem");
        iconElem.attr("title",name);
        containerElem.append(iconElem);
    }
    addIcon("arrow-left");
    addIcon("arrow-right");
    addIcon("chevron-left");
    addIcon("chevron-right");
    addIcon("chevron-up");
    addIcon("chevron-down");
    addIcon("alert");
    addIcon("info");
    addIcon("trend-up");
    addIcon("trend-down");
    addIcon("fullscreen");
    addIcon("print");
    addIcon("check");
    addIcon("copy");
    addIcon("filter");
    addIcon("export");
    addIcon("download");
    addIcon("report");
    addIcon("configure");
    addIcon("cross");
    addIcon("glossary");
    addIcon("calendar");
    addIcon("chart");
    addIcon("share");
    addIcon("expand");
    addIcon("collapse");
    addIcon("list");
    addIcon("ask-question");
    addIcon("add-to-dashboard");
    addIcon("add-to-presentation");
    addIcon("debug");
    addIcon("more");
    addIcon("studio");
};
Machinata.Reporting.Node.IconTestNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-vega-test.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-vega-test.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// 
/// Note: This node should not be used in production.
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.VegaTestNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaTestNode.defaults = {};

/// <summary>
/// We have a solid chrome by default.
/// </summary>
Machinata.Reporting.Node.VegaTestNode.defaults.chrome =  "solid";



/// <summary>
/// </summary>
Machinata.Reporting.Node.VegaTestNode.getVegaSpec = function (instance, config, json, nodeElem) {
    
    return {
        "data": [
            {
                "name": "table",
                "values": [
                    { "x": 0, "y": 28000000, "c": 0 }, { "x": 0, "y": 55000000, "c": 1 },
                    { "x": 1, "y": 43000000, "c": 0 }, { "x": 1, "y": 91000000, "c": 1 },
                    { "x": 2, "y": 81000000, "c": 0 }, { "x": 2, "y": 53000000, "c": 1 },
                    { "x": 3, "y": 19000000, "c": 0 }, { "x": 3, "y": 87000000, "c": 1 },
                    { "x": 4, "y": 52000000, "c": 0 }, { "x": 4, "y": 48000000, "c": 1 },
                    { "x": 5, "y": 24000000, "c": 0 }, { "x": 5, "y": 49000000, "c": 1 },
                    { "x": 6, "y": 87000000, "c": 0 }, { "x": 6, "y": 66000000, "c": 1 },
                    { "x": 7, "y": 17000000, "c": 0 }, { "x": 7, "y": 27000000, "c": 1 },
                    { "x": 8, "y": 68000000, "c": 0 }, { "x": 8, "y": 16000000, "c": 1 },
                    { "x": 9, "y": 49000000, "c": 0 }, { "x": 9, "y": 15000000, "c": 1 }
                ],
                "transform": [
                    {
                        "type": "stack",
                        "groupby": ["x"],
                        "sort": { "field": "c" },
                        "field": "y"
                    }
                ]
            }
        ],

        "scales": [
            {
                "name": "x",
                "type": "band",
                "range": "width",
                "domain": { "data": "table", "field": "x" }
            },
            {
                "name": "y",
                "type": "linear",
                "range": "height",
                "nice": true, "zero": true,
                "domain": { "data": "table", "field": "y1" }
            },
            {
                "name": "color",
                "type": "ordinal",
                "range": "category",
                "domain": { "data": "table", "field": "c" }
            }
        ],

        "axes": [
            {
                "orient": "bottom",
                "scale": "x",
                "zindex": 1
            },
            {
                "orient": "left",
                "scale": "y",
                "zindex": 1,
                "translate": 0
            }
        ],

        "marks": [
            {
                "type": "rect",
                "from": { "data": "table" },
                "encode": {
                    "enter": {
                        "x": { "scale": "x", "field": "x" },
                        "width": { "scale": "x", "band": 1, "offset": -1 },
                        "y": { "scale": "y", "field": "y0" },
                        "y2": { "scale": "y", "field": "y1" },
                        "fill": { "scale": "color", "field": "c" }
                    },
                    "update": {
                        "fillOpacity": { "value": 1 }
                    },
                    "hover": {
                        "fillOpacity": { "value": 0.5 }
                    }
                }
            }
        ]
    };
};
Machinata.Reporting.Node.VegaTestNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    
};
Machinata.Reporting.Node.VegaTestNode.init = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.VegaTestNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.VegaTestNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};









/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-stackedarea.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-stackedarea.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// ## Axis's
/// Scaling Engine: ```Machinata.Reporting.Node.VegaNode.Util.autoSnapMultiSeriesAxis```
/// </summary>
/// <example>
/// See ```example-report-stackedarea.json``` for complete example usages.
/// </example>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.StackedAreaNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults = {};

/// <summary>
/// By default charts are on solid chrome.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportsToolbar = true;

/// <summary>
/// Yes, insert a legend by default.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.insertLegend = true;

/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.legendColumns = 2;

/// <summary>
/// Set the global x-axis scale type. Can be any vega supported scale type as long as the data matches.
/// Note: For time-scales, you should ensure that the fact x-values are in Unix Epoch Format (milliseconds).
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.xAxisScaleType = "time";

/// <summary>
/// If ```true```, labels will automatically be removed if they overlap the boundries of the axis by ```config.padding/2```.
/// By default ```true```,
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.xAxisLabelBound = true;


/// <summary>
/// If set, defines the angle in degrees of axis labels. Typically this would be set to -45.
/// By default ```null``` (off),
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.xAxisLabelAngle = null;



/// <summary>
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var emptyGroup = {
        "type": "group",
        /*"_comment": "HELPER GROUP FOR INSERTING EMPTY MARKS AT RUNTIME...",*/
    };
    return {
        "data": [
          {
              "name": "seriesGroups",
              "values": null,
          },
          {
              "name": "allSeries",
              "source": "seriesGroups",
              "transform": [
                {
                    "type": "flatten",
                    "fields": [
                      "series"
                    ],
                    "as": [
                      "serie"
                    ]
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum.id + '_' + datum.serie.id"
                }
              ]
          },
          {
              "name": "allSeriesResolved",
              "source": "allSeries",
              "transform": [
                { "type": "formula", "initonly": true, "as": "colorResolved", "expr": "(datum.serie.colorShade ? scale('colorByShade',datum.serie.colorShade) : scale('colorByKey',datum.key))" },
                  { "type": "formula", "initonly": true, "as": "textColorResolved", "expr": "(datum.serie.colorShade ? scale('colorByShadeText',datum.serie.colorShade) : scale('colorByKeyText',datum.key))" },
                { "type": "formula", "initonly": true, "as": "titleResolved", "expr": "datum.serie.title.resolved" },
                { "type": "formula", "initonly": true, "as": "type", "expr": "'area'" }, // hardcoded
                { "type": "formula", "initonly": true, "as": "xAxisTransform", "expr": "datum.xAxis.transform" },
              ]
          },
            {
                "name": "allFlattened",
                "source": "allSeriesResolved",
                "transform": [
                  {
                      "type": "flatten",
                      "fields": [
                        "serie.facts"
                      ],
                      "as": [
                        "fact"
                      ]
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "factY",
                      "expr": "datum.fact.y"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "factX",
                      "expr": "datum.fact.x"
                  }
                ]
            },
            
        ],
        "signals": [
            {
                "name": "configLegendSymbolSize",
                "init": config.legendSymbolSize
            },
            {
                "name": "configPadding",
                "init": config.padding
            },
            {
                "name": "configLegendRowHeightWithPadding",
                "init": config.legendSymbolSize + config.legendSymbolStroke + config.legendRowPadding 
            }
        ],
        "scales": [
    
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": config.themeColorShadeNames,
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByShadeText",
                "type": "ordinal",
                "domain": config.themeColorShadeNames,
                "range": { "scheme": "text-on-" + json.theme }
            },
            {
                "name": "colorByKey",
                "type": "ordinal",
                "domain": { "data": "allSeries", "field": "key" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByKeyText",
                "type": "ordinal",
                "domain": { "data": "allSeries", "field": "key" },
                "range": { "scheme": "text-on-" + json.theme }
            },
            {
                "name": "color",
                "type": "ordinal",
                "domain": { "data": "allSeriesResolved", "field": "key" },
                "range": { "data": "allSeriesResolved", "field": "colorResolved" },
            },
            {
                "name": "textColor",
                "type": "ordinal",
                "domain": { "data": "allSeriesResolved", "field": "key" },
                "range": { "data": "allSeriesResolved", "field": "textColorResolved" },
            },
          {
              "name": "debugColor",
              "type": "ordinal",
              "domain": {
                  "data": "allSeriesResolved",
                  "field": "key"
              },
              "range": {
                  "scheme": "category20"
              }
          },
          {
              // Provide the proper color for the legend
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "allSeriesResolved", "field": "key" },
              "range": { "data": "allSeriesResolved", "field": "colorResolved" },
          },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "allSeriesResolved", "field": "key" },
                "range": { "data": "allSeriesResolved", "field": "titleResolved" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisMinValue",
                "type": "ordinal",
                "domain": ["xAxisMinValue"],
                "range": { "data": "seriesGroups", "field": "xAxis.minValue" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisMaxValue",
                "type": "ordinal",
                "domain": ["xAxisMaxValue"],
                "range": { "data": "seriesGroups", "field": "xAxis.maxValue" }
            },
            {
                "name": "xScale",
                /*"_comment": "This x-scale is used by everyone. Thus the chart groups are 'tight' with each other.",*/
                "type": json.xAxisScaleType,
                "domain": {
                    "data": "allFlattened",
                    "field": "factX"
                },
                "domainMin": {
                    "signal": "scale('xAxisMinValue','xAxisMinValue')",
                },
                "domainMax": {
                    "signal": "scale('xAxisMaxValue','xAxisMaxValue')",
                },
                "range": "width",
                "padding": { "signal": (config.padding * 4) },
                //"padding": 30, // debugging only
            }
        ],
        "marks": [
          {
              /*"_comment": "Explodes the seriesGroups into individual group marks",*/
              "name": "groupGroups",
              "type": "group",
              "encode": {
                  "update": {
                      "width": {
                          "signal": "width"
                      },
                      "height": {
                          "signal": "height"
                      }
                  }
              },
              "from": {
                  "facet": {
                      "data": "seriesGroups",
                      "name": "facetGroups",
                      "groupby": "id"
                  }
              },
              "data": [],
              "marks": [
                {
                    /*"_comment": "Here we have a single group with all its series. At this stage we do an axis and scale",*/
                    "name": "groupSeries",
                    "type": "group",
                    "encode": {
                        "update": {
                            "width": {
                                "signal": "width"
                            },
                            "height": {
                                "signal": "height"
                            }
                        }
                    },
                    "data": [
                      {
                          "name": "series",
                          "source": "facetGroups",
                          "transform": [
                            {
                                "type": "flatten",
                                "fields": [
                                  "series"
                                ],
                                "as": [
                                  "serie"
                                ]
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "key",
                                "expr": "datum.id + '_' + datum.serie.id"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "titleResolved",
                                  "expr": "datum.serie.titleResolved"
                              },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "chartType",
                                "expr": "datum.serie.chartType"
                            }
                          ]
                      },
                      {
                          "name": "flattened",
                          "source": "series",
                          "transform": [
                            {
                                "type": "flatten",
                                "fields": [
                                  "serie.facts"
                                ],
                                "as": [
                                  "fact"
                                ]
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "factKey",
                                "expr": "datum.key"
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "factY",
                                "expr": "datum.fact.y"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factX",
                                  "expr": "datum.fact.x"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factStackY0",
                                  "expr": "datum.fact.stackY0"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factStackY1",
                                  "expr": "datum.fact.stackY1"
                              },
                              {
                                  "type": "identifier",
                                  "as": "sortId"
                              },
                              {
                                  "type": "collect",
                                  "sort": {
                                      "field": "sortId",
                                      "order": ["ascending"] // Stacks are sorted ascending to mimick Excel behaviour
                                  }
                              },
                              /*{
                                  // >>> this is the stacking
                                  "type": "stack",
                                  "groupby": ["factX"],
                                  "field": "factY"
                              }*/
                          ]
                      }
                    ],
                    "scales": [
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "xAxisFormat",
                            "type": "ordinal",
                            "domain": ["xAxisFormat"],
                            "range": { "data": "series", "field": "xAxis.format" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "xAxisFormatType",
                            "type": "ordinal",
                            "domain": ["xAxisFormatType"],
                            "range": { "data": "series", "field": "xAxis.formatType" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisMinValue",
                            "type": "ordinal",
                            "domain": ["yAxisMinValue"],
                            "range": { "data": "series", "field": "yAxis.minValue" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisMaxValue",
                            "type": "ordinal",
                            "domain": ["yAxisMaxValue"],
                            "range": { "data": "series", "field": "yAxis.maxValue" }
                        },
                        {
                          "name": "yScale",
                          "type": "linear",
                          "domain": {
                              "data": "flattened",
                              "field": "factStackY1"
                          },
                          "domainMin": {
                              "signal": "scale('yAxisMinValue','yAxisMinValue')",//"scale('yAxisMinValue','yAxisMinValue')",
                          },
                          "domainMax": {
                              "signal": "scale('yAxisMaxValue','yAxisMaxValue')",
                          },
                          "padding": config.yAxisLabelPadding,
                          //"padding": 30, // testing only
                          "range": "height",
                          "round": true, // setting round to false will cause a strange decoupled yaxis where the zero round is floating off
                          "zero": true,
                          "nice": true // vega does nice
                          //"nice": { "signal": "scale('yAxisTickCount','yAxisTickCount')" }
                          //"nice": true // setting nice to true will cause the axis domain to snap to a value, leading to a side affect that two axis' no longer align, setting it to false will cause the top/bottom of the bars/lines to hang over the edge of the yaxis
                      },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisOrient",
                            "type": "ordinal",
                            "domain": ["yAxisOrient"],
                            "range": { "data": "series", "field": "yAxis.orient" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisFormat",
                            "type": "ordinal",
                            "domain": ["yAxisFormat"],
                            "range": { "data": "series", "field": "yAxis.format" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisFormatType",
                            "type": "ordinal",
                            "domain": ["yAxisFormatType"],
                            "range": { "data": "series", "field": "yAxis.formatType" }
                        }
                    ],
                    "axes": [

                        Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance,config,json,{
                            "orient": "bottom",
                            "scale": "xScale",
                            "domain": false,
                            "format": { "signal": "if(scale('xAxisFormat','xAxisFormat') == null, ' ', scale('xAxisFormat','xAxisFormat'))" }, // If the format is null, use empty string ' ', otherwise 
                            "formatType": { "signal": "scale('xAxisFormatType','xAxisFormatType')" },
                            "values": { "signal": "data('series')[0].xAxis.values" },
                            "grid": false,
                            "labelBound": (json.xAxisLabelBound == true ? (config.padding/2) : false), // Indicates if labels should be hidden if they exceed the axis range. If false (the default) no bounds overlap analysis is performed. If true, labels will be hidden if they exceed the axis range by more than 1 pixel. If this property is a number, it specifies the pixel tolerance: the maximum amount by which a label bounding box may exceed the axis range.
                            "tickCount": { "signal": "data('series')[0].xAxis.tickCount" }
                        }),
                      
                      {
                          "orient": "left",
                          "scale": "yScale",
                          "tickSize": 0,
                          "tickRound": true,
                          "format": { "signal": "scale('yAxisFormat','yAxisFormat')" },
                          "formatType": { "signal": "scale('yAxisFormatType','yAxisFormatType')" },
                          "zindex": 1,
                          "grid": true,
                          "domain": false,
                          "values": { "signal": "data('series')[0].yAxis.values" },
                      }
                    ],
                    "marks": [
                      {
                          /*"_comment": "AREAS MASTER GROUPS",*/
                          "type": "group",
                          "clip": false,
                          "zindex": 3,
                          "from": {
                              "facet": {
                                  "data": "flattened",
                                  "name": "facet",
                                  "groupby": "factKey"
                              }
                            },
                          "marks": [
                            {
                                "type": "area",
                                "from": {
                                    "data": "facet"
                                },
                                "encode": {
                                    "enter": {
                                        "interpolate": { "value": "linear" },
                                        "x": {
                                            "scale": "xScale",
                                            "field": "factX",
                                        },
                                        "y": {
                                            "scale": "yScale",
                                            "field": "factStackY0"
                                        },
                                        "y2": {
                                            "scale": "yScale",
                                            "field": "factStackY1"
                                        },
                                        "fill": {
                                            "scale": "color",
                                            "field": "key"
                                        },
                                        "defined": {
                                            "signal": "datum.factY != null ? true : false"
                                        }
                                    },
                                }
                            },
                            {
                                "type": "rect",
                                /*"_comment": "These are transparent rects for the tooltip",*/
                                "from": {
                                    "data": "facet"
                                },
                                "encode": {
                                    "enter": {
                                        "fill": {
                                            "value": "transparent" // should be transparent
                                        },
                                    },
                                    "update": {
                                        "width": {
                                            "signal": "width / data('facet').length"
                                        },
                                        "xc": {
                                            "scale": "xScale",
                                            "field": "factX",
                                        },
                                        "y": {
                                            "scale": "yScale",
                                            "field": "factStackY0"
                                        },
                                        "y2": {
                                            "scale": "yScale",
                                            "field": "factStackY1"
                                        },
                                        "tooltip": [
                                            {
                                                // Show tooltip only if we have a value
                                                "test": "datum.factY == null",
                                                "value": null
                                            },
                                            { "signal": "scale('legendLabel',datum.factKey) + ': ' + format(datum.factY,scale('yAxisFormat','yAxisFormat'))" }
                                        ]
                                    }
                                }
                              },
                              /*{
                                  "type": "text",
                                  "_comment": "TEXT LABELS ON CHART FOR SERIES (AREAS)",
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {
                                          "fill": {
                                              "signal": "scale('textColor',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "'red'"
                                          },
                                          "text": {
                                              "signal": "scale('legendLabel',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].key"
                                          },
                                          "baseline": {
                                              "value": "middle"
                                          },
                                          "align": {
                                              "value": "right"
                                          },
                                          "dx": {
                                              "value": -config.padding
                                          },
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "scale('xScale',data('facet')[0].factX)",
                                          },
                                          "y": {
                                              "signal": "scale('yScale', data('facet')[0].y1 - (data('facet')[0].y1-data('facet')[0].y0)/2 )",
                                          },
                                          "tooltip": [
                                              
                                              { "value": null }
                                          ]
                                      }
                                  }
                              },*/
                              /*{
                                  "type": "text",
                                  "_comment": "TEXT LABELS NEXT TO CHART FOR SERIES (AREAS)",
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {
                                          
                                          "text": {
                                              "signal": "scale('legendLabel',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].key"
                                          },
                                          "baseline": {
                                              "value": "middle"
                                          },
                                          "align": {
                                              "value": "left"
                                          },
                                          "dx": {
                                              "value": config.padding*5
                                          },
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "scale('xScale',data('facet')[0].factX)",
                                          },
                                          "y": {
                                              "signal": "scale('yScale', data('facet')[0].y1 - (data('facet')[0].y1-data('facet')[0].y0)/2 )",
                                          },
                                          "tooltip": [

                                              { "value": null }
                                          ]
                                      }
                                  }
                              }*/
                              /*{
                                  "type": "rule",
                                  "_comment": "CONNECTING LINES FOR SERIES (AREAS)",
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {

                                          "tooltip": {
                                              "signal": "scale('legendLabel',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].key"
                                          },
                                          "stroke": {
                                              "signal": "scale('color',data('facet')[0].key)"
                                          },
                                          "strokeWidth": {
                                              "value": config.lineSize
                                          },
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "scale('xScale',data('facet')[0].factX) + configPadding",
                                          },
                                          "y": {
                                              "signal": "scale('yScale', data('facet')[0].y1 - (data('facet')[0].y1-data('facet')[0].y0)/2 )",
                                          },
                                          "x2": {
                                              "signal": "width + configPadding*2",
                                          },
                                          "y2": {
                                              "signal": "(data('facet')[0].serie.serieIndex * configLegendRowHeightWithPadding) + configLegendSymbolSize/2",
                                          },
                                          "tooltip": {
                                              // DEBUGGING
                                              "signal": "data('facet')[0].serie.serieIndex "
                                          },
                                      }
                                  }
                              },*/
                              json.connectSeriesToLegend != true ? emptyGroup : {
                                  "type": "group",
                                  /*"_comment": "CONNECTING LINES FOR SERIES (AREAS)",*/
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "round( scale('xScale',data('facet')[0].factX) + configPadding )",
                                          },
                                          "width": {
                                              "signal": "configPadding*4",
                                          },
                                          "height": {
                                              "signal": "height",
                                          },
                                          "y": {
                                              "signal": "0",
                                          },
                                          "tooltip": {
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].serie.serieIndex "
                                          },
                                      }
                                  },
                                  "signals": [
                                      {
                                          "name": "connectorWidth",
                                          "update": "connectorNumTotal * 6",
                                      },
                                      {
                                          "name": "connectorOffset",
                                          "update": "round( ((connectorWidth) / connectorNumTotal) * connectorIndex )",
                                      },
                                      {
                                          "name": "connectorIndex",
                                          "update": "data('facet')[0].serie.serieIndex",
                                      },
                                      {
                                          "name": "connectorNumTotal",
                                          "update": "data('allSeries').length",
                                      },
                                      {
                                          "name": "connectorYStart",
                                          "update": "round( scale('yScale', data('facet')[0].factStackY1 - (data('facet')[0].factStackY1-data('facet')[0].factStackY0)/2 ) )",
                                      },
                                      {
                                          "name": "connectorYEnd",
                                          "update": "round( (data('facet')[0].serie.serieIndex * configLegendRowHeightWithPadding) + configLegendSymbolSize/2 )",
                                      }
                                  ],
                                  "marks": [
                                      {
                                          "type": "rule",
                                          "encode": {
                                              "enter": {
                                                  "stroke": {
                                                      //"signal": "scale('color',data('facet')[0].key)"
                                                      "value": config.gridColor
                                                  },
                                                  "strokeWidth": {
                                                      "value": config.lineSize
                                                  },
                                              },
                                              "update": {
                                                  "x": {
                                                      "signal": "0",
                                                  },
                                                  "x2": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "y": {
                                                      "signal": "connectorYStart",
                                                  },
                                                  "y2": {
                                                      "signal": "connectorYStart",
                                                  },
                                              }
                                          }
                                      },
                                      {
                                          "type": "rule",
                                          "encode": {
                                              "enter": {
                                                  "stroke": {
                                                      //"signal": "scale('color',data('facet')[0].key)"
                                                      "value": config.gridColor
                                                  },
                                                  "strokeWidth": {
                                                      "value": config.lineSize
                                                  },
                                              },
                                              "update": {
                                                  "x": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "x2": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "y": {
                                                      "signal": "connectorYStart",
                                                  },
                                                  "y2": {
                                                      "signal": "connectorYEnd",
                                                  },
                                              }
                                          }
                                      },
                                      {
                                          "type": "rule",
                                          "encode": {
                                              "enter": {
                                                  "stroke": {
                                                      //"signal": "scale('color',data('facet')[0].key)"
                                                      "value": config.gridColor
                                                  },
                                                  "strokeWidth": {
                                                      "value": config.lineSize
                                                  },
                                              },
                                              "update": {
                                                  "x": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "x2": {
                                                      "signal": "connectorWidth + configPadding",
                                                  },
                                                  "y": {
                                                      "signal": "connectorYEnd",
                                                  },
                                                  "y2": {
                                                      "signal": "connectorYEnd",
                                                  },
                                              }
                                          }
                                      }
                                  ]
                              }
                          ]
                      }
                    ]
                }
              ]
          }
        ]
    };
};
Machinata.Reporting.Node.StackedAreaNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert series
    spec["data"][0].values = json.seriesGroups;
};




Machinata.Reporting.Node.StackedAreaNode.init = function (instance, config, json, nodeElem) {

    // Init
    var seriesCount = 0;
    var legendReverseOrder = false;
    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];
        seriesGroup.index = sgi;
        for (var si = 0; si < seriesGroup.series.length; si++) {
            var serie = seriesGroup.series[si];
            serie.serieIndex = seriesCount;
            seriesCount++;
        }
    }

    // Automatically add some helper classes for sizing...
    if (nodeElem != null) {
        if (seriesCount > 0 && seriesCount <= 5) {
            nodeElem.addClass("series-count-range-0-5");
        } else if (seriesCount > 5 && seriesCount <= 10) {
            nodeElem.addClass("series-count-range-5-10");
        } else if (seriesCount > 10 && seriesCount <= 15) {
            nodeElem.addClass("series-count-range-10-15");
        } else if (seriesCount > 15 && seriesCount <= 20) {
            nodeElem.addClass("series-count-range-15-20");
        } else if (seriesCount > 20 && seriesCount <= 30) {
            nodeElem.addClass("series-count-range-20-30");
        }
        nodeElem.addClass("series-count-" + seriesCount);
    }

    // Do our own stacking...
    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];
        var xStackTable = {};
        for (var si = 0; si < seriesGroup.series.length; si++) {
            var serie = seriesGroup.series[si];
            for (var fi = 0; fi < serie.facts.length; fi++) {
                var fact = serie.facts[fi];
                // Init empty (on first entry on x)
                if (xStackTable[fact.x] == null) {
                    if (si == 0) xStackTable[fact.x] = 0;
                    else console.warn("Machinata.Reporting.Node.StackedAreaNode.init: series stack doesnt overlap! This means that the series have different x values, which is not supported.");
                }
                // Append
                fact.stackY0 = xStackTable[fact.x];
                fact.stackY1 = fact.stackY0 + fact.y;
                if (isNaN(fact.stackY0)) console.warn("fact " + si + "." + fi +" stackY0 is NaN");
                if (isNaN(fact.stackY1)) console.warn("fact " + si + "." + fi +" stackY1 is NaN");
                xStackTable[fact.x] = fact.stackY1;
            }
        }
    }

    // If we have more series than theme colors, we automatically switch to a connected-legend mode...
    /*var theme = Machinata.Reporting.getTheme(json.theme);
    if (theme != null && seriesCount > theme.length) {
        json.legendPosition = "right-top";
        json.legendColumns = 1;
        legendReverseOrder = true;
    }*/

    // Generate legend data
    if (json.legendPosition == "right-top") legendReverseOrder = true;
    Machinata.Reporting.Node.VegaNode.Util.createLegendForGroupedSeries(instance, config, json, json.seriesGroups, { reverseOrder: legendReverseOrder});


    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.StackedAreaNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.StackedAreaNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-cashflow.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-cashflow.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Cash-Flow Graphic for Private Client Partners (exclusive).
///
/// ### Bucket Titles
/// The bucket titles are automatically line-breaked, 
/// but you can also define your own using the \n character. A bucket title should never
/// be more than two lines.
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.PCPCashFlowGraphicNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults = {};

/// <summary>
/// This is a infographic, thus ```light```.
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.chrome = "light";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_4x2, Machinata.Reporting.Layouts.BLOCK_4x4];

/// <summary>
/// Yes, we support toolbar.
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.supportsToolbar = true;

/// <summary>
/// No legends for this chart.
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.insertLegend = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.titleSize = 22;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.titleLineHeight = 1.2;


/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.labelSize = 12;


/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.valueSize = 22;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.valueLargeSize = 22;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.symbolSize = 18;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.symbolFontWeight = "bold";

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.strokeDash = "4,4";

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.titleMaxCharsPerLine = 16;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.graphicAlignment = "middle";

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.beginAndEndBucketsAlignLeft = false;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.bucketFactHeight = 60;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.bucketFactPaddingMultiplier = 1;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.defaults.chartBorderMultiplier = 0.5;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PCPCashFlowGraphicNode.getVegaSpec = function (instance, config, json, nodeElem) {
    return {
        "data": [
            {
                "name": "buckets",
                "values": null
            },
            {
                "name": "bucketsResolved",
                "source": "buckets",
                "transform": [
                    
                ]
            },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          }
        ],
        "signals": [
            {
                "name": "chartPadding",
                /*"_comment": "NOTE: padding is reserved by vega (will cause strange behaviour)",*/
                "init": config.padding
            },
            {
                "name": "chartBorder",
                /*"_comment": "NOTE: padding is reserved by vega (will cause strange behaviour)",*/
                "init": config.padding * json.chartBorderMultiplier
            },
            {
                "name": "titleSize",
                "init": json.titleSize
            },
            {
                "name": "titleLineHeight",
                "init": "titleSize * "+json.titleLineHeight // default
            },
            {
                "name": "labelSize",
                "init": json.labelSize
            },
            {
                "name": "valueSize",
                "init": json.valueSize
            },
            {
                "name": "valueLargeSize",
                "init": json.valueLargeSize
            },
            {
                "name": "symbolSize",
                "init": json.symbolSize
            },
            {
                "name": "symbolFontWeight",
                "init": "'" + json.symbolFontWeight + "'"
            },
            {
                "name": "highlightBGColor",
                "init": "scale('colorByShade','mid')"
            },
            {
                "name": "highlightFGColor",
                "init": "scale('colorByShadeText','mid')"
            },
            {
                "name": "solidBGColor",
                "init": "scale('colorByShade','gray3')"
            },
            {
                "name": "solidFGColor",
                "init": "scale('colorByShadeText','gray3')"
            },
            {
                "name": "borderedBGColor",
                "init": "'transparent'"
            },
            {
                "name": "borderedFGColor",
                "init": "'black'"
            },
            {
                "name": "graphicAlignment",
                "init": "'" + json.graphicAlignment + "'"
            },
            {
                "name": "numberOfBuckets",
                "init": json._numberOfBuckets
            },
            {
                "name": "numberOfBucketsWithoutSymbol",
                "init": json._numberOfBucketsWithoutSymbol
            },
            {
                "name": "numberOfBucketsWithSymbol",
                "init": json._numberOfBucketsWithSymbol
            },
            {
                "name": "maxBucketFacts",
                "init": json._maxBucketFacts
            },
            {
                "name": "symbolConnectionWidth",
                "update": "80",
            },
            {
                "name": "symbolRadius",
                "update": "13",
            },
            {
                "name": "bucketFactHeight",
                "update": json.bucketFactHeight,
            },
            {
                "name": "bucketFactPaddingMultiplier",
                "update": json.bucketFactPaddingMultiplier,
            },
            {
                "name": "widthNeededForSymbols",
                "update": "numberOfBucketsWithSymbol * symbolConnectionWidth",
            },
            {
                "name": "bucketWidthExcludingSymbol",
                "update": "(width - widthNeededForSymbols - chartBorder) / numberOfBuckets",
            },
            {
                "name": "bucketHeight",
                "update": "bucketFactHeight * (maxBucketFacts+1)",
            },
        ],
        "scales": [
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByShadeText",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": "text-on-"+json.theme }
            },
            
            
        ],
        "marks": [
            {
                "clip": true, // makes sure that when we scale it doesnt push open the chart size
                "type": "group",
                "encode": {
                    "update": {
                        "width": { "signal": "width" },
                        "height": { "signal": "height" }
                    }
                },
                "marks": [
                    {
                        /*"_comment": "BUCKETS GROUPS",*/
                        "type": "group",
                        "from": { "data": "bucketsResolved" },
                        "signals": [
                            {
                                /*"_comment": "Expose the bucket datum to all marks...",*/
                                "name": "bucketData",
                                "update": "parent",
                            },
                        ],
                        "data": [
                            {
                                /*"_comment": "Since vega can't hide groups or marks, we need this data selector to filter our buckets that dont have symbols (for the symbol connection)",*/
                                "name": "bucketSymbol",
                                "source": "bucketsResolved",
                                "transform": [
                                    {
                                        "type": "filter",
                                        "expr": "datum._bucketIndex == bucketData._bucketIndex && datum.bucketSymbol != null"
                                    }
                                ]
                            }
                        ],
                        "encode": {
                            "enter": {
                                // DEBUGGING
                                //"tooltip": { "signal": "'bucket:'+datum.titleResolved" },
                                //"stroke": { "value": "rgba(255,0,0,1.0)" },
                                //"fill": { "value": "rgba(255,0,0,0.1)" },
                            },
                            "update": {
                                "x": { "signal": "bucketWidthExcludingSymbol * datum._bucketIndex + (datum._bucketSymbolsPreceedingThisBucket * symbolConnectionWidth) + chartBorder/2" },
                                "width": { "signal": "datum.bucketSymbol == null ? (bucketWidthExcludingSymbol) : (symbolConnectionWidth + bucketWidthExcludingSymbol)" },
                                "y": { "signal": " graphicAlignment == 'middle' ? ((height-bucketHeight)/2) : (chartPadding)" },
                                "height": { "signal": "bucketHeight" }
                            }
                        },
                        "marks": [
                            {
                                /*"_comment": "BUCKET SYMBOL CONNECTION",*/
                                "type": "group",
                                "from": { "data": "bucketSymbol" },
                                "encode": {
                                    "enter": {
                                        // DEBUGGING
                                        //"stroke": { "value": "rgba(0,255,0,1.0)" },
                                        //"fill": { "value": "rgba(0,255,0,0.1)" },
                                    },
                                    "update": {
                                        "x": { "signal": "0" },
                                        "width": { "signal": "symbolConnectionWidth" },
                                        "y": { "signal": "bucketFactHeight * 1 " },
                                        "height": { "signal": "bucketFactHeight - chartBorder" }
                                    }
                                },
                                "signals": [
                                    {
                                        /*"_comment": "shortcut signal...",*/
                                        "name": "groupWidth",
                                        "update": "symbolConnectionWidth",
                                    },
                                    {
                                        /*"_comment": "shortcut signal...",*/
                                        "name": "groupHeight",
                                        "update": "bucketFactHeight - chartBorder",
                                    },
                                ],
                                "marks": [
                                    {
                                        "type": "rule",
                                        "encode": {
                                            "enter": {
                                                "stroke": { "signal": "borderedFGColor" },
                                                "strokeDash": { "value": json.strokeDash.split(",") },
                                                "strokeWidth": { "value": config.lineSize },
                                            },
                                            "update": {
                                                "x": { "signal": "0" },
                                                "x2": { "signal": "groupWidth/2 - symbolRadius" },
                                                "y": { "signal": "groupHeight/2" },
                                                "y2": { "signal": "groupHeight/2" }
                                            }
                                        },
                                    },
                                    {
                                        "type": "rule",
                                        "encode": {
                                            "enter": {
                                                "stroke": { "signal": "borderedFGColor" },
                                                "strokeDash": { "value": json.strokeDash.split(",") },
                                                "strokeWidth": { "value": config.lineSize }, 
                                            },
                                            "update": {
                                                "x": { "signal": "groupWidth/2 + symbolRadius" },
                                                "x2": { "signal": "groupWidth" },
                                                "y": { "signal": "groupHeight/2" },
                                                "y2": { "signal": "groupHeight/2" }
                                            }
                                        },
                                    },
                                    {
                                        "type": "arc",
                                        "encode": {
                                            "enter": {
                                                "stroke": { "signal": "borderedFGColor" },
                                                "strokeDash": { "value": json.strokeDash.split(",") },
                                                "strokeWidth": { "value": config.lineSize },
                                                "startAngle": { "signal": "-PI/2 + 0" },
                                                "endAngle": { "signal": "-PI/2 + PI*2" },
                                                "outerRadius": { "signal": "symbolRadius" },
                                            },
                                            "update": {
                                                "xc": { "signal": "groupWidth/2" },
                                                "yc": { "signal": "groupHeight/2" },
                                            }
                                        },
                                    },
                                    {
                                        "type": "text",
                                        "encode": {
                                            "enter": {
                                                "fontSize": { "signal": "symbolSize" },
                                                "fontWeight": { "signal": "symbolFontWeight" },
                                                "text": { "signal": "bucketData.bucketSymbol" },
                                                "baseline": { "value": "middle" },
                                                "align": { "value": "center" },
                                                "fill": { "signal": "highlightBGColor" },
                                            },
                                            "update": {
                                                "xc": { "signal": "groupWidth/2" },
                                                "yc": { "signal": "groupHeight/2" },
                                            }
                                        },
                                    }
                                ]
                            },
                            {
                                /*"_comment": "BUCKET CONTENTS",*/
                                "type": "group",
                                "data": [
                                    {
                                        "name": "bucketFacts",
                                        "source": "bucketsResolved",
                                        "transform": [
                                            {
                                                "type": "flatten",
                                                "fields": [
                                                    "facts"
                                                ],
                                                "as": [
                                                    "fact"
                                                ]
                                            },
                                            {
                                                "type": "filter",
                                                "expr": "datum.fact._bucketIndex == bucketData._bucketIndex"
                                            }
                                        ]
                                    }
                                ],
                                "encode": {
                                    "enter": {
                                        // DEBUGGING
                                        //"stroke": { "value": "rgba(0,0,255,1.0)" },
                                        //"fill": { "value": "rgba(0,0,255,0.1)" },
                                        //"tooltip": { "signal": "parent.titleResolved" },
                                    },
                                    "update": {
                                        "x": { "signal": "bucketData.bucketSymbol == null ? 0 : symbolConnectionWidth" },
                                        "width": { "signal": "bucketWidthExcludingSymbol" },
                                        "y": { "signal": "0" },
                                        "height": { "signal": "bucketHeight" }
                                    }
                                },
                                "marks": [
                                    {
                                        /*"_comment": "BUCKET TITLE (label)",*/
                                        "type": "text",
                                        "font": config.subtitleFont,
                                        "encode": {
                                            "enter": {
                                                "text": { "signal": "bucketData.titleResolved" },
                                                "fill": { "signal": "highlightBGColor" },

                                                "align": { "signal": "bucketData.textAlign == 'right' ? 'right' : 'left'" },
                                                "fontSize": { "signal": "titleSize" },
                                                "baseline": { "value": "bottom" },
                                                // DEBUGGING
                                                //"stroke": { "value": "rgba(255,0,0,1.0)" },
                                                //"fill": { "value": "rgba(255,0,0,0.1)" },
                                                //"tooltip": { "signal": "bucketData.titleResolved.length" },
                                            },
                                            "update": {
                                                "x": { "signal": "bucketData.textAlign == 'right' ? (bucketWidthExcludingSymbol) : 0" },
                                                "y": { "signal": "bucketFactHeight * 1  - (chartPadding*bucketFactPaddingMultiplier) - ((bucketData.titleResolved.length-1)*titleLineHeight)" },
                                            }
                                        }
                                    },
                                    {
                                        /*"_comment": "BUCKET FACT ITEMS",*/
                                        "type": "group",
                                        "from": { "data": "bucketFacts" },
                                        "encode": {
                                            "enter": {
                                                "stroke": { "signal": "highlightBGColor" },
                                                "strokeWidth": { "signal": "datum.fact.factStyle == 'bordered' ? chartBorder/2 : 0" },
                                                "fill": [
                                                    { "test": "datum.fact.factStyle == 'solid'", "signal": "highlightBGColor" },
                                                    { "test": "datum.fact.factStyle == 'default'", "signal": "solidBGColor" },
                                                    { "value": null }
                                                ],
                                                // DEBUGGING
                                                //"stroke": { "value": "rgba(255,0,0,1.0)" },
                                                //"fill": { "value": "rgba(255,0,0,0.1)" },
                                            },
                                            "update": {
                                                "x": { "signal": "0" },
                                                "width": { "signal": "bucketWidthExcludingSymbol" },
                                                "y": { "signal": "bucketFactHeight * (datum.fact._factIndex + 1)" },
                                                "height": { "signal": "bucketFactHeight - chartBorder" }
                                            }
                                        },
                                        "signals": [
                                            {
                                                /*"_comment": "shortcut signal...",*/
                                                "name": "groupWidth",
                                                "update": "bucketWidthExcludingSymbol",
                                            },
                                            {
                                                /*"_comment": "shortcut signal...",*/
                                                "name": "groupHeight",
                                                "update": "bucketFactHeight - chartBorder",
                                            },
                                        ],
                                        "marks": [
                                            {
                                                /*"_comment": "FACT LABEL",*/
                                                "type": "text",
                                                "encode": {
                                                    "enter": {
                                                        "text": { "signal": "parent.fact.title.resolved" },
                                                        "baseline": { "value": "top" },
                                                        "fontSize": { "signal": "labelSize" },
                                                        "align": { "signal": "bucketData.textAlign == 'right' ? 'right' : 'left'" },
                                                        "fill": [
                                                            { "test": "parent.fact.factStyle == 'solid'", "signal": "highlightFGColor" },
                                                            { "test": "parent.fact.factStyle == 'default'", "signal": "solidFGColor" },
                                                            { "signal": "solidFGColor" }
                                                        ],
                                                    },
                                                    "update": {
                                                        "x": { "signal": "bucketData.textAlign == 'right' ? (groupWidth-chartPadding*bucketFactPaddingMultiplier) : (0+chartPadding*bucketFactPaddingMultiplier)" },
                                                        "y": { "signal": "chartPadding*bucketFactPaddingMultiplier" },
                                                    }
                                                }
                                            },
                                            {
                                                /*"_comment": "FACT VALUE",*/
                                                "type": "text",
                                                "font": config.numberFont,
                                                "encode": {
                                                    "enter": {
                                                        "text": { "signal": "parent.fact.resolved" },
                                                        "baseline": { "value": "top" },
                                                        "fontSize": { "signal": "parent.fact._factIndex == 0 ? valueLargeSize : valueSize" },
                                                        "fontWeight": { "signal": "parent.fact._factIndex == 0 ? 'bold' : null" },
                                                        "align": { "signal": "bucketData.textAlign == 'right' ? 'right' : 'left'" },
                                                        "fill": [
                                                            { "test": "parent.fact.factStyle == 'solid'", "signal": "highlightFGColor" },
                                                            { "test": "parent.fact.factStyle == 'default'", "signal": "highlightBGColor" },
                                                            { "signal": "highlightBGColor" }
                                                        ],
                                                    },
                                                    "update": {
                                                        "x": { "signal": "bucketData.textAlign == 'right' ? (groupWidth-chartPadding*bucketFactPaddingMultiplier) : (0+chartPadding*bucketFactPaddingMultiplier)" },
                                                        "y": { "signal": "labelSize + chartPadding*bucketFactPaddingMultiplier + chartBorder" },
                                                    }
                                                }
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
          
        ]
    };
};
Machinata.Reporting.Node.PCPCashFlowGraphicNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert Buckets
    spec["data"][0].values = json.buckets;
};

Machinata.Reporting.Node.PCPCashFlowGraphicNode.init = function (instance, config, json, nodeElem) {
    // Process data
    json._numberOfBuckets = json.buckets.length;
    json._numberOfBucketsWithSymbol = 0;
    json._numberOfBucketsWithoutSymbol = 0;
    json._maxBucketFacts = 0;
    for (var b = 0; b < json.buckets.length; b++) {
        var bucket = json.buckets[b];
        bucket._bucketIndex = b;
        bucket._bucketSymbolsPreceedingThisBucket = json._numberOfBucketsWithSymbol;
        if (bucket.bucketStyle == null) {
            if (b == 0) bucket.bucketStyle = "begin";
            else if (b == json.buckets.length-1) bucket.bucketStyle = "end";
            else bucket.bucketStyle = "operator";
        }
        if (bucket.textAlign == null) {
            if (json.beginAndEndBucketsAlignLeft == true) {
                if (bucket.bucketStyle == "begin" || bucket.bucketStyle == "end") bucket.textAlign = "left";
                else bucket.textAlign = "right";
            } else {
                bucket.textAlign = "right";
            }
        }
        if (bucket.bucketSymbol != null) json._numberOfBucketsWithSymbol++;
        else json._numberOfBucketsWithoutSymbol++;
        json._maxBucketFacts = Math.max(json._maxBucketFacts, bucket.facts.length);

        bucket.titleResolved = Machinata.Reporting.Text.resolve(instance, bucket.title);
        if (bucket.titleResolved.indexOf("\n") != -1) {
            // Includes line breaks already
            // Split into array
            bucket.titleResolved = bucket.titleResolved.split("\n");
        } else {
            bucket.titleResolved = Machinata.Reporting.Tools.lineBreakString(bucket.titleResolved, {
                maxCharsPerLine: json.titleMaxCharsPerLine,
                maxLines: 2,
                wordSeparator: " ",
                ellipsis: config.textTruncationEllipsis,
                appendEllipsisOnLastLine: true,
                returnArray: true
            });
        }
        


        for (var f = 0; f < bucket.facts.length; f++) {
            var fact = bucket.facts[f];
            fact._bucketIndex = bucket._bucketIndex;
            fact._factIndex = f;
            if (fact.factStyle == null) {
                if (bucket.bucketStyle == "begin" || bucket.bucketStyle == "end") {
                    fact.factStyle = "bordered";
                } else {
                    if (f == 0) fact.factStyle = "solid";
                    else fact.factStyle = "default";
                }
            }
        }
    }
    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.PCPCashFlowGraphicNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.PCPCashFlowGraphicNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};









/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-stackedarea.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-stackedarea.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// ## Axis's
/// Scaling Engine: ```Machinata.Reporting.Node.VegaNode.Util.autoSnapMultiSeriesAxis```
/// </summary>
/// <example>
/// See ```example-report-stackedarea.json``` for complete example usages.
/// </example>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.StackedAreaNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults = {};

/// <summary>
/// By default charts are on solid chrome.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.chrome = "solid";

/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support the toolbar.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.supportsToolbar = true;

/// <summary>
/// Yes, insert a legend by default.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.insertLegend = true;

/// <summary>
/// Sets the number of columns to use for legends. By default we use ```2```.
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.legendColumns = 2;

/// <summary>
/// Set the global x-axis scale type. Can be any vega supported scale type as long as the data matches.
/// Note: For time-scales, you should ensure that the fact x-values are in Unix Epoch Format (milliseconds).
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.xAxisScaleType = "time";

/// <summary>
/// If ```true```, labels will automatically be removed if they overlap the boundries of the axis by ```config.padding/2```.
/// By default ```true```,
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.xAxisLabelBound = true;


/// <summary>
/// If set, defines the angle in degrees of axis labels. Typically this would be set to -45.
/// By default ```null``` (off),
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.defaults.xAxisLabelAngle = null;



/// <summary>
/// </summary>
Machinata.Reporting.Node.StackedAreaNode.getVegaSpec = function (instance, config, json, nodeElem) {
    var emptyGroup = {
        "type": "group",
        /*"_comment": "HELPER GROUP FOR INSERTING EMPTY MARKS AT RUNTIME...",*/
    };
    return {
        "data": [
          {
              "name": "seriesGroups",
              "values": null,
          },
          {
              "name": "allSeries",
              "source": "seriesGroups",
              "transform": [
                {
                    "type": "flatten",
                    "fields": [
                      "series"
                    ],
                    "as": [
                      "serie"
                    ]
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "key",
                    "expr": "datum.id + '_' + datum.serie.id"
                }
              ]
          },
          {
              "name": "allSeriesResolved",
              "source": "allSeries",
              "transform": [
                { "type": "formula", "initonly": true, "as": "colorResolved", "expr": "(datum.serie.colorShade ? scale('colorByShade',datum.serie.colorShade) : scale('colorByKey',datum.key))" },
                  { "type": "formula", "initonly": true, "as": "textColorResolved", "expr": "(datum.serie.colorShade ? scale('colorByShadeText',datum.serie.colorShade) : scale('colorByKeyText',datum.key))" },
                { "type": "formula", "initonly": true, "as": "titleResolved", "expr": "datum.serie.title.resolved" },
                { "type": "formula", "initonly": true, "as": "type", "expr": "'area'" }, // hardcoded
                { "type": "formula", "initonly": true, "as": "xAxisTransform", "expr": "datum.xAxis.transform" },
              ]
          },
            {
                "name": "allFlattened",
                "source": "allSeriesResolved",
                "transform": [
                  {
                      "type": "flatten",
                      "fields": [
                        "serie.facts"
                      ],
                      "as": [
                        "fact"
                      ]
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "factY",
                      "expr": "datum.fact.y"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "factX",
                      "expr": "datum.fact.x"
                  }
                ]
            },
            
        ],
        "signals": [
            {
                "name": "configLegendSymbolSize",
                "init": config.legendSymbolSize
            },
            {
                "name": "configPadding",
                "init": config.padding
            },
            {
                "name": "configLegendRowHeightWithPadding",
                "init": config.legendSymbolSize + config.legendSymbolStroke + config.legendRowPadding 
            }
        ],
        "scales": [
    
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": config.themeColorShadeNames,
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByShadeText",
                "type": "ordinal",
                "domain": config.themeColorShadeNames,
                "range": { "scheme": "text-on-" + json.theme }
            },
            {
                "name": "colorByKey",
                "type": "ordinal",
                "domain": { "data": "allSeries", "field": "key" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByKeyText",
                "type": "ordinal",
                "domain": { "data": "allSeries", "field": "key" },
                "range": { "scheme": "text-on-" + json.theme }
            },
            {
                "name": "color",
                "type": "ordinal",
                "domain": { "data": "allSeriesResolved", "field": "key" },
                "range": { "data": "allSeriesResolved", "field": "colorResolved" },
            },
            {
                "name": "textColor",
                "type": "ordinal",
                "domain": { "data": "allSeriesResolved", "field": "key" },
                "range": { "data": "allSeriesResolved", "field": "textColorResolved" },
            },
          {
              "name": "debugColor",
              "type": "ordinal",
              "domain": {
                  "data": "allSeriesResolved",
                  "field": "key"
              },
              "range": {
                  "scheme": "category20"
              }
          },
          {
              // Provide the proper color for the legend
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "allSeriesResolved", "field": "key" },
              "range": { "data": "allSeriesResolved", "field": "colorResolved" },
          },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "allSeriesResolved", "field": "key" },
                "range": { "data": "allSeriesResolved", "field": "titleResolved" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisMinValue",
                "type": "ordinal",
                "domain": ["xAxisMinValue"],
                "range": { "data": "seriesGroups", "field": "xAxis.minValue" }
            },
            {
                // This is a workaround/hack for Vega using a fixed scale
                "name": "xAxisMaxValue",
                "type": "ordinal",
                "domain": ["xAxisMaxValue"],
                "range": { "data": "seriesGroups", "field": "xAxis.maxValue" }
            },
            {
                "name": "xScale",
                /*"_comment": "This x-scale is used by everyone. Thus the chart groups are 'tight' with each other.",*/
                "type": json.xAxisScaleType,
                "domain": {
                    "data": "allFlattened",
                    "field": "factX"
                },
                "domainMin": {
                    "signal": "scale('xAxisMinValue','xAxisMinValue')",
                },
                "domainMax": {
                    "signal": "scale('xAxisMaxValue','xAxisMaxValue')",
                },
                "range": "width",
                "padding": { "signal": (config.padding * 4) },
                //"padding": 30, // debugging only
            }
        ],
        "marks": [
          {
              /*"_comment": "Explodes the seriesGroups into individual group marks",*/
              "name": "groupGroups",
              "type": "group",
              "encode": {
                  "update": {
                      "width": {
                          "signal": "width"
                      },
                      "height": {
                          "signal": "height"
                      }
                  }
              },
              "from": {
                  "facet": {
                      "data": "seriesGroups",
                      "name": "facetGroups",
                      "groupby": "id"
                  }
              },
              "data": [],
              "marks": [
                {
                    /*"_comment": "Here we have a single group with all its series. At this stage we do an axis and scale",*/
                    "name": "groupSeries",
                    "type": "group",
                    "encode": {
                        "update": {
                            "width": {
                                "signal": "width"
                            },
                            "height": {
                                "signal": "height"
                            }
                        }
                    },
                    "data": [
                      {
                          "name": "series",
                          "source": "facetGroups",
                          "transform": [
                            {
                                "type": "flatten",
                                "fields": [
                                  "series"
                                ],
                                "as": [
                                  "serie"
                                ]
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "key",
                                "expr": "datum.id + '_' + datum.serie.id"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "titleResolved",
                                  "expr": "datum.serie.titleResolved"
                              },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "chartType",
                                "expr": "datum.serie.chartType"
                            }
                          ]
                      },
                      {
                          "name": "flattened",
                          "source": "series",
                          "transform": [
                            {
                                "type": "flatten",
                                "fields": [
                                  "serie.facts"
                                ],
                                "as": [
                                  "fact"
                                ]
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "factKey",
                                "expr": "datum.key"
                            },
                            {
                                "type": "formula",
                                "initonly": true,
                                "as": "factY",
                                "expr": "datum.fact.y"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factX",
                                  "expr": "datum.fact.x"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factStackY0",
                                  "expr": "datum.fact.stackY0"
                              },
                              {
                                  "type": "formula",
                                  "initonly": true,
                                  "as": "factStackY1",
                                  "expr": "datum.fact.stackY1"
                              },
                              {
                                  "type": "identifier",
                                  "as": "sortId"
                              },
                              {
                                  "type": "collect",
                                  "sort": {
                                      "field": "sortId",
                                      "order": ["ascending"] // Stacks are sorted ascending to mimick Excel behaviour
                                  }
                              },
                              /*{
                                  // >>> this is the stacking
                                  "type": "stack",
                                  "groupby": ["factX"],
                                  "field": "factY"
                              }*/
                          ]
                      }
                    ],
                    "scales": [
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "xAxisFormat",
                            "type": "ordinal",
                            "domain": ["xAxisFormat"],
                            "range": { "data": "series", "field": "xAxis.format" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "xAxisFormatType",
                            "type": "ordinal",
                            "domain": ["xAxisFormatType"],
                            "range": { "data": "series", "field": "xAxis.formatType" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisMinValue",
                            "type": "ordinal",
                            "domain": ["yAxisMinValue"],
                            "range": { "data": "series", "field": "yAxis.minValue" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisMaxValue",
                            "type": "ordinal",
                            "domain": ["yAxisMaxValue"],
                            "range": { "data": "series", "field": "yAxis.maxValue" }
                        },
                        {
                          "name": "yScale",
                          "type": "linear",
                          "domain": {
                              "data": "flattened",
                              "field": "factStackY1"
                          },
                          "domainMin": {
                              "signal": "scale('yAxisMinValue','yAxisMinValue')",//"scale('yAxisMinValue','yAxisMinValue')",
                          },
                          "domainMax": {
                              "signal": "scale('yAxisMaxValue','yAxisMaxValue')",
                          },
                          "padding": config.yAxisLabelPadding,
                          //"padding": 30, // testing only
                          "range": "height",
                          "round": true, // setting round to false will cause a strange decoupled yaxis where the zero round is floating off
                          "zero": true,
                          "nice": true // vega does nice
                          //"nice": { "signal": "scale('yAxisTickCount','yAxisTickCount')" }
                          //"nice": true // setting nice to true will cause the axis domain to snap to a value, leading to a side affect that two axis' no longer align, setting it to false will cause the top/bottom of the bars/lines to hang over the edge of the yaxis
                      },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisOrient",
                            "type": "ordinal",
                            "domain": ["yAxisOrient"],
                            "range": { "data": "series", "field": "yAxis.orient" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisFormat",
                            "type": "ordinal",
                            "domain": ["yAxisFormat"],
                            "range": { "data": "series", "field": "yAxis.format" }
                        },
                        {
                            // This is a workaround/hack for Vega using a fixed scale
                            "name": "yAxisFormatType",
                            "type": "ordinal",
                            "domain": ["yAxisFormatType"],
                            "range": { "data": "series", "field": "yAxis.formatType" }
                        }
                    ],
                    "axes": [

                        Machinata.Reporting.Node.VegaNode.Util.applySettingsToVegaAxis(instance,config,json,{
                            "orient": "bottom",
                            "scale": "xScale",
                            "domain": false,
                            "format": { "signal": "if(scale('xAxisFormat','xAxisFormat') == null, ' ', scale('xAxisFormat','xAxisFormat'))" }, // If the format is null, use empty string ' ', otherwise 
                            "formatType": { "signal": "scale('xAxisFormatType','xAxisFormatType')" },
                            "values": { "signal": "data('series')[0].xAxis.values" },
                            "grid": false,
                            "labelBound": (json.xAxisLabelBound == true ? (config.padding/2) : false), // Indicates if labels should be hidden if they exceed the axis range. If false (the default) no bounds overlap analysis is performed. If true, labels will be hidden if they exceed the axis range by more than 1 pixel. If this property is a number, it specifies the pixel tolerance: the maximum amount by which a label bounding box may exceed the axis range.
                            "tickCount": { "signal": "data('series')[0].xAxis.tickCount" }
                        }),
                      
                      {
                          "orient": "left",
                          "scale": "yScale",
                          "tickSize": 0,
                          "tickRound": true,
                          "format": { "signal": "scale('yAxisFormat','yAxisFormat')" },
                          "formatType": { "signal": "scale('yAxisFormatType','yAxisFormatType')" },
                          "zindex": 1,
                          "grid": true,
                          "domain": false,
                          "values": { "signal": "data('series')[0].yAxis.values" },
                      }
                    ],
                    "marks": [
                      {
                          /*"_comment": "AREAS MASTER GROUPS",*/
                          "type": "group",
                          "clip": false,
                          "zindex": 3,
                          "from": {
                              "facet": {
                                  "data": "flattened",
                                  "name": "facet",
                                  "groupby": "factKey"
                              }
                            },
                          "marks": [
                            {
                                "type": "area",
                                "from": {
                                    "data": "facet"
                                },
                                "encode": {
                                    "enter": {
                                        "interpolate": { "value": "linear" },
                                        "x": {
                                            "scale": "xScale",
                                            "field": "factX",
                                        },
                                        "y": {
                                            "scale": "yScale",
                                            "field": "factStackY0"
                                        },
                                        "y2": {
                                            "scale": "yScale",
                                            "field": "factStackY1"
                                        },
                                        "fill": {
                                            "scale": "color",
                                            "field": "key"
                                        },
                                        "defined": {
                                            "signal": "datum.factY != null ? true : false"
                                        }
                                    },
                                }
                            },
                            {
                                "type": "rect",
                                /*"_comment": "These are transparent rects for the tooltip",*/
                                "from": {
                                    "data": "facet"
                                },
                                "encode": {
                                    "enter": {
                                        "fill": {
                                            "value": "transparent" // should be transparent
                                        },
                                    },
                                    "update": {
                                        "width": {
                                            "signal": "width / data('facet').length"
                                        },
                                        "xc": {
                                            "scale": "xScale",
                                            "field": "factX",
                                        },
                                        "y": {
                                            "scale": "yScale",
                                            "field": "factStackY0"
                                        },
                                        "y2": {
                                            "scale": "yScale",
                                            "field": "factStackY1"
                                        },
                                        "tooltip": [
                                            {
                                                // Show tooltip only if we have a value
                                                "test": "datum.factY == null",
                                                "value": null
                                            },
                                            { "signal": "scale('legendLabel',datum.factKey) + ': ' + format(datum.factY,scale('yAxisFormat','yAxisFormat'))" }
                                        ]
                                    }
                                }
                              },
                              /*{
                                  "type": "text",
                                  "_comment": "TEXT LABELS ON CHART FOR SERIES (AREAS)",
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {
                                          "fill": {
                                              "signal": "scale('textColor',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "'red'"
                                          },
                                          "text": {
                                              "signal": "scale('legendLabel',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].key"
                                          },
                                          "baseline": {
                                              "value": "middle"
                                          },
                                          "align": {
                                              "value": "right"
                                          },
                                          "dx": {
                                              "value": -config.padding
                                          },
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "scale('xScale',data('facet')[0].factX)",
                                          },
                                          "y": {
                                              "signal": "scale('yScale', data('facet')[0].y1 - (data('facet')[0].y1-data('facet')[0].y0)/2 )",
                                          },
                                          "tooltip": [
                                              
                                              { "value": null }
                                          ]
                                      }
                                  }
                              },*/
                              /*{
                                  "type": "text",
                                  "_comment": "TEXT LABELS NEXT TO CHART FOR SERIES (AREAS)",
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {
                                          
                                          "text": {
                                              "signal": "scale('legendLabel',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].key"
                                          },
                                          "baseline": {
                                              "value": "middle"
                                          },
                                          "align": {
                                              "value": "left"
                                          },
                                          "dx": {
                                              "value": config.padding*5
                                          },
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "scale('xScale',data('facet')[0].factX)",
                                          },
                                          "y": {
                                              "signal": "scale('yScale', data('facet')[0].y1 - (data('facet')[0].y1-data('facet')[0].y0)/2 )",
                                          },
                                          "tooltip": [

                                              { "value": null }
                                          ]
                                      }
                                  }
                              }*/
                              /*{
                                  "type": "rule",
                                  "_comment": "CONNECTING LINES FOR SERIES (AREAS)",
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {

                                          "tooltip": {
                                              "signal": "scale('legendLabel',data('facet')[0].key)"
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].key"
                                          },
                                          "stroke": {
                                              "signal": "scale('color',data('facet')[0].key)"
                                          },
                                          "strokeWidth": {
                                              "value": config.lineSize
                                          },
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "scale('xScale',data('facet')[0].factX) + configPadding",
                                          },
                                          "y": {
                                              "signal": "scale('yScale', data('facet')[0].y1 - (data('facet')[0].y1-data('facet')[0].y0)/2 )",
                                          },
                                          "x2": {
                                              "signal": "width + configPadding*2",
                                          },
                                          "y2": {
                                              "signal": "(data('facet')[0].serie.serieIndex * configLegendRowHeightWithPadding) + configLegendSymbolSize/2",
                                          },
                                          "tooltip": {
                                              // DEBUGGING
                                              "signal": "data('facet')[0].serie.serieIndex "
                                          },
                                      }
                                  }
                              },*/
                              json.connectSeriesToLegend != true ? emptyGroup : {
                                  "type": "group",
                                  /*"_comment": "CONNECTING LINES FOR SERIES (AREAS)",*/
                                  "zindex": 4,
                                  "encode": {
                                      "enter": {
                                      },
                                      "update": {
                                          "x": {
                                              "signal": "round( scale('xScale',data('facet')[0].factX) + configPadding )",
                                          },
                                          "width": {
                                              "signal": "configPadding*4",
                                          },
                                          "height": {
                                              "signal": "height",
                                          },
                                          "y": {
                                              "signal": "0",
                                          },
                                          "tooltip": {
                                              // DEBUGGING
                                              //"signal": "data('facet')[0].serie.serieIndex "
                                          },
                                      }
                                  },
                                  "signals": [
                                      {
                                          "name": "connectorWidth",
                                          "update": "connectorNumTotal * 6",
                                      },
                                      {
                                          "name": "connectorOffset",
                                          "update": "round( ((connectorWidth) / connectorNumTotal) * connectorIndex )",
                                      },
                                      {
                                          "name": "connectorIndex",
                                          "update": "data('facet')[0].serie.serieIndex",
                                      },
                                      {
                                          "name": "connectorNumTotal",
                                          "update": "data('allSeries').length",
                                      },
                                      {
                                          "name": "connectorYStart",
                                          "update": "round( scale('yScale', data('facet')[0].factStackY1 - (data('facet')[0].factStackY1-data('facet')[0].factStackY0)/2 ) )",
                                      },
                                      {
                                          "name": "connectorYEnd",
                                          "update": "round( (data('facet')[0].serie.serieIndex * configLegendRowHeightWithPadding) + configLegendSymbolSize/2 )",
                                      }
                                  ],
                                  "marks": [
                                      {
                                          "type": "rule",
                                          "encode": {
                                              "enter": {
                                                  "stroke": {
                                                      //"signal": "scale('color',data('facet')[0].key)"
                                                      "value": config.gridColor
                                                  },
                                                  "strokeWidth": {
                                                      "value": config.lineSize
                                                  },
                                              },
                                              "update": {
                                                  "x": {
                                                      "signal": "0",
                                                  },
                                                  "x2": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "y": {
                                                      "signal": "connectorYStart",
                                                  },
                                                  "y2": {
                                                      "signal": "connectorYStart",
                                                  },
                                              }
                                          }
                                      },
                                      {
                                          "type": "rule",
                                          "encode": {
                                              "enter": {
                                                  "stroke": {
                                                      //"signal": "scale('color',data('facet')[0].key)"
                                                      "value": config.gridColor
                                                  },
                                                  "strokeWidth": {
                                                      "value": config.lineSize
                                                  },
                                              },
                                              "update": {
                                                  "x": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "x2": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "y": {
                                                      "signal": "connectorYStart",
                                                  },
                                                  "y2": {
                                                      "signal": "connectorYEnd",
                                                  },
                                              }
                                          }
                                      },
                                      {
                                          "type": "rule",
                                          "encode": {
                                              "enter": {
                                                  "stroke": {
                                                      //"signal": "scale('color',data('facet')[0].key)"
                                                      "value": config.gridColor
                                                  },
                                                  "strokeWidth": {
                                                      "value": config.lineSize
                                                  },
                                              },
                                              "update": {
                                                  "x": {
                                                      "signal": "connectorOffset",
                                                  },
                                                  "x2": {
                                                      "signal": "connectorWidth + configPadding",
                                                  },
                                                  "y": {
                                                      "signal": "connectorYEnd",
                                                  },
                                                  "y2": {
                                                      "signal": "connectorYEnd",
                                                  },
                                              }
                                          }
                                      }
                                  ]
                              }
                          ]
                      }
                    ]
                }
              ]
          }
        ]
    };
};
Machinata.Reporting.Node.StackedAreaNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert series
    spec["data"][0].values = json.seriesGroups;
};




Machinata.Reporting.Node.StackedAreaNode.init = function (instance, config, json, nodeElem) {

    // Init
    var seriesCount = 0;
    var legendReverseOrder = false;
    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];
        seriesGroup.index = sgi;
        for (var si = 0; si < seriesGroup.series.length; si++) {
            var serie = seriesGroup.series[si];
            serie.serieIndex = seriesCount;
            seriesCount++;
        }
    }

    // Automatically add some helper classes for sizing...
    if (nodeElem != null) {
        if (seriesCount > 0 && seriesCount <= 5) {
            nodeElem.addClass("series-count-range-0-5");
        } else if (seriesCount > 5 && seriesCount <= 10) {
            nodeElem.addClass("series-count-range-5-10");
        } else if (seriesCount > 10 && seriesCount <= 15) {
            nodeElem.addClass("series-count-range-10-15");
        } else if (seriesCount > 15 && seriesCount <= 20) {
            nodeElem.addClass("series-count-range-15-20");
        } else if (seriesCount > 20 && seriesCount <= 30) {
            nodeElem.addClass("series-count-range-20-30");
        }
        nodeElem.addClass("series-count-" + seriesCount);
    }

    // Do our own stacking...
    for (var sgi = 0; sgi < json.seriesGroups.length; sgi++) {
        var seriesGroup = json.seriesGroups[sgi];
        var xStackTable = {};
        for (var si = 0; si < seriesGroup.series.length; si++) {
            var serie = seriesGroup.series[si];
            for (var fi = 0; fi < serie.facts.length; fi++) {
                var fact = serie.facts[fi];
                // Init empty (on first entry on x)
                if (xStackTable[fact.x] == null) {
                    if (si == 0) xStackTable[fact.x] = 0;
                    else console.warn("Machinata.Reporting.Node.StackedAreaNode.init: series stack doesnt overlap! This means that the series have different x values, which is not supported.");
                }
                // Append
                fact.stackY0 = xStackTable[fact.x];
                fact.stackY1 = fact.stackY0 + fact.y;
                if (isNaN(fact.stackY0)) console.warn("fact " + si + "." + fi +" stackY0 is NaN");
                if (isNaN(fact.stackY1)) console.warn("fact " + si + "." + fi +" stackY1 is NaN");
                xStackTable[fact.x] = fact.stackY1;
            }
        }
    }

    // If we have more series than theme colors, we automatically switch to a connected-legend mode...
    /*var theme = Machinata.Reporting.getTheme(json.theme);
    if (theme != null && seriesCount > theme.length) {
        json.legendPosition = "right-top";
        json.legendColumns = 1;
        legendReverseOrder = true;
    }*/

    // Generate legend data
    if (json.legendPosition == "right-top") legendReverseOrder = true;
    Machinata.Reporting.Node.VegaNode.Util.createLegendForGroupedSeries(instance, config, json, json.seriesGroups, { reverseOrder: legendReverseOrder});


    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.StackedAreaNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
};
Machinata.Reporting.Node.StackedAreaNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-onlinemap.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-onlinemap.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// A very simple node that displays a info message for testing and demonstration
/// purposes. A user on a production system should not see this.
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.OnlineMapNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.OnlineMapNode.defaults = {};

/// <summary>
/// This node supports a toolbar.
/// </summary>
Machinata.Reporting.Node.OnlineMapNode.defaults.supportsToolbar = true;

/// <summary>
/// </summary>
Machinata.Reporting.Node.OnlineMapNode.defaults.tileLayerAPIKey = null;



Machinata.Reporting.Node.OnlineMapNode.init = function (instance, config, json, nodeElem) {
    console.log("--------------------");
    console.log(nodeElem);
    // Validate Core JS Maps
    if (Machinata.Maps == null) throw "Machinata.Maps has not be loaded. Please include the Machinata Core Maps JS library machinata-maps-bundle.js to have ";

    // Validate that a API key has been explicitly set in reporting config
    if (json.tileLayerAPIKey == null) throw "No Tile Layer API Key configured"; 

    // Create UI
    //var bgElem = $("<div class='node-bg'></div>").appendTo($(".ui-card"));
    var mapElem = $("<div class='map' style='width:100%;height:400px;'></div>").appendTo(nodeElem);

    nodeElem.data("map-elem", mapElem);

    // Force our api key
    Machinata.Maps.DEFAULT_MAPS_ACCESS_TOKEN = json.tileLayerAPIKey;

    

};
Machinata.Reporting.Node.OnlineMapNode.postBuild = function (instance, config, json, nodeElem) {

    var mapElem = nodeElem.data("map-elem");
    // Create the map...
    var mapOptions = {
        minZoom: 3, // zoomed out
        //maxZoom: 7, // zoomed in
        doubleClickZoom: true,
        scrollWheelZoom: true
    };

    var options = {};
    options["providerOptions"] = mapOptions;

    var map = Machinata.Maps.createMap(mapElem, options);
    nodeElem.data("map", map);
   
};

Machinata.Reporting.Node.OnlineMapNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here...
    var map = nodeElem.data("map");
    var useCluster = json["useCluster"];
    var jitter = json["jitter"];

    // Fill into coordinates
    var markers = [];
    for (i = 0; i < json.facts.length; i++) {
        var fact = json.facts[i];

        // unwrap link url
        if (fact.link != null) {
            fact["link"] = fact.link.url;
        }

        markers.push(fact);

    }


    
    Machinata.Maps.addMarkersToMap(map, markers, useCluster, jitter);
};











/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-portal.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-portal.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// A very simple and efficient node that allows the integration of external content (a 'portal').
/// 
/// ## Handler Integration
/// Typically content should be integrated on-the-fly using the following handlers:
///  - ```Machinata.Reporting.Handler.portalNodeReady```
///  - ```Machinata.Reporting.Handler.portalNodeCleanup```
/// 
/// Additionally for the following handlers may prove usefull:
///  - ```Machinata.Reporting.Handler.portalNodeResize```
///  - ```Machinata.Reporting.Handler.portalNodeDraw```
///
/// Using this method, the integrator will get a call to ```Machinata.Reporting.Handler.portalNodeReady```
/// when the the PortalNode is ready and placed in the DOM. From there the element can be manipulated
/// and appended freely.
/// ```portalElementId````can be used to keep track of what type of content should be inserted (or alternatively additional
/// properties on the node JSON).
///
/// ## Static Content Integration
/// An alternate method, is to provide a id-selector via ```portalExistingContentElementId```.
/// If this element can be found in the DOM, then it will be cloned (deeply, including event handlers) and appended
/// to the node. The existing content element can be hidden (using the ```display:none``` style),
/// and will automatically the unhidden when added to the report node.
///
/// ## CSS Stack
/// An integrator must be aware that the portal will be exposed to the ```machinata-reporting-styling``` CSS class.
/// This means that generic HTML elements (such as a H1 or P) will inherit a series of styles.
/// It is best practice to use the existing styles and tools that the reporting CSS stack provideds, if possible, to ensure
/// a consistent look and feel for the report.
///
/// ## Design Implications and Challenges
/// Some thought and care must be given to ensure that the integration of foreign content
/// within a report doesn't interfere with the report user experience, and that the overall
/// look-and-feel of the report is not compromised.
/// Furthermore, attention should be put on advanced features, such as fullscreen and web-printing.
/// In these cases, the portal content may need to adapt to ensure the functionality of the features.
///
/// </summary>
/// <example>
/// ## Handler Integration: Report JSON
/// ```
/// ...
/// {
///     "nodeType": "PortalNode",
///     "portalElementId": "portal-test-1",
///     "portalElementClass": "my-own-css-stack"
/// }
/// ...
/// ```
/// ## Handler Integration: Handlers
/// ```
/// Machinata.Reporting.Handler.portalNodeReady = function (instance, nodeJSON, nodeElem, portalElem) {
///     console.log("Machinata.Reporting.Handler.portalNodeReady", nodeJSON.portalElementId);
///     // Make a decision on what portal content to inject...
///     if (nodeJSON.portalElementId == "portal-test-1") {
///         console.log("Will create content for ", nodeJSON.portalElementId, "...");
///         portalElem.append($("<h1/>").text("This is external content that was created on-the-fly via PortalNode and Machinata.Reporting.Handler.portalNodeReady."));
///     }
/// };
/// Machinata.Reporting.Handler.portalNodeResize = function (instance, nodeJSON, nodeElem, portalElem) {
///     console.log("Machinata.Reporting.Handler.portalNodeResize", nodeJSON.portalElementId);
/// };
/// Machinata.Reporting.Handler.portalNodeDraw = function (instance, nodeJSON, nodeElem, portalElem) {
///     console.log("Machinata.Reporting.Handler.portalNodeDraw", nodeJSON.portalElementId);
/// };
/// Machinata.Reporting.Handler.portalNodeCleanup = function (instance, nodeJSON, nodeElem, portalElem) {
///     console.log("Machinata.Reporting.Handler.portalNodeCleanup", nodeJSON.portalElementId);
/// };
/// ```
/// </example>
/// <type>class</type>
Machinata.Reporting.Node.PortalNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PortalNode.defaults = {};

/// <summary>
/// By default PortalNode have a ```light``` chrome.
/// </summary>
Machinata.Reporting.Node.PortalNode.defaults.chrome = "light";

/// <summary>
/// This node does not support being added to dashboards...
/// </summary>
Machinata.Reporting.Node.PortalNode.defaults.supportsDashboard = false;

/// <summary>
/// Typically not needed by this node.
/// </summary>
Machinata.Reporting.Node.PortalNode.defaults.addStandardTools = false;

/// <summary>
/// Not supported by this node.
/// </summary>
Machinata.Reporting.Node.PortalNode.defaults.addCopyToClipboardTool = false;

/// <summary>
/// Defines the element ID to add to the portal DOM element (if any).
/// Typically the exact type of content or node requested as a portal
/// can be derived from this id ```portalElementId```
/// </summary>
Machinata.Reporting.Node.PortalNode.defaults.portalElementId = null;

/// <summary>
/// Defines the element CSS class to add to the portal DOM element (if any).
/// </summary>
Machinata.Reporting.Node.PortalNode.defaults.portalElementClass = null;

/// <summary>
/// If defined, the content of the given existing DOM element (selected by its Id), will
/// be cloned and injected in the place of the portal. This can be useful for static sites
/// that wish to inject content into a report.
/// </summary>
/// <example>
/// ```<div id='my-portal'>Portal content...</div>```
/// ...
/// ```
/// {
///    "nodeType": "PortalNode",
///    "portalExistingContentElementId": "my-portal",
/// }
/// ```
/// </example>
Machinata.Reporting.Node.PortalNode.defaults.portalExistingContentElementId = null;

/// <summary>
/// </summary>
Machinata.Reporting.Node.PortalNode.init = function (instance, config, json, nodeElem) {

    // Init
    var portalElement = $("<div></div>");
    if (json.portalExistingContentElementId != null) {
        // See if this portal element already exists (by id)
        // If so, we use that
        var portalExistingContentElem = $("#" + json.portalExistingContentElementId);
        if (portalElement.length == 1) {
            portalElement = portalExistingContentElem.clone(true);
            portalElement.attr("id", ""); // make sure the original id is removed
            portalExistingContentElem.hide();
            portalElement.show();
        }
    }
    // Add classes/id
    portalElement.attr("id", json.portalElementId);
    if (json.portalElementClass != null) portalElement.addClass(json.portalElementClass);
    portalElement.addClass("machinata-reporting-portal");
    // Add to node DOM
    nodeElem.append(portalElement);
    // Register in state
    json._state.portalElement = portalElement;

};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PortalNode.postBuild = function (instance, config, json, nodeElem) {
    if (Machinata.Reporting.Handler.portalNodeReady != null) {
        Machinata.Reporting.Handler.portalNodeReady(instance, json, nodeElem, json._state.portalElement);
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PortalNode.draw = function (instance, config, json, nodeElem) {
    if (Machinata.Reporting.Handler.portalNodeDraw != null) {
        Machinata.Reporting.Handler.portalNodeDraw(instance, json, nodeElem, json._state.portalElement);
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PortalNode.resize = function (instance, config, json, nodeElem) {
    if (Machinata.Reporting.Handler.portalNodeResize != null) {
        Machinata.Reporting.Handler.portalNodeResize(instance, json, nodeElem, json._state.portalElement);
    }
};

/// <summary>
/// </summary>
Machinata.Reporting.Node.PortalNode.cleanup = function (instance, config, json, nodeElem) {
    if (Machinata.Reporting.Handler.portalNodeCleanup != null) {
        Machinata.Reporting.Handler.portalNodeCleanup(instance, json, nodeElem, json._state.portalElement);
    }
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-legend.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-legend.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// EXPERIMENTAL: NOT FOR PRODUCTION USE
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.LegendNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.LegendNode.defaults = {
    chrome: "light",
    supportsToolbar: false,
    addStandardTools: false
};


Machinata.Reporting.Node.LegendNode.init = function (instance, config, json, nodeElem) {
    var containerElem = $("<div class='node-bg'></div>").appendTo(nodeElem);
    // Legend
    var legendElem = Machinata.Reporting.Node.createHTMLLegendElem(instance, config, json, json.legendData).appendTo(containerElem);
};
Machinata.Reporting.Node.LegendNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here
};
Machinata.Reporting.Node.LegendNode.resize = function (instance, config, json, nodeElem) {
    // Nothing to do here
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-tilegrid.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-tilegrid.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// EXPERIMENTAL: NOT FOR PRODUCTION USE
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.TileGridNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.TileGridNode.defaults = {
    chrome: "solid",
    supportsToolbar: true,
    addStandardTools: false,
    tileColumns: 6,
    zoomOnHover: false,
    flipOnHover: false,
    zoomAmount: 2.5,
};

/// <summary>
/// The resolved text to display in the node. If not text is provided, then the default
/// text ```Placeholder``` is displayed.
/// </summary>
Machinata.Reporting.Node.TileGridNode.defaults.text = null;

Machinata.Reporting.Node.TileGridNode.init = function (instance, config, json, nodeElem) {
    var containerElem = $("<div class='node-bg'></div>").appendTo(nodeElem);
    var tilesElem = $("<div class='tiles'></div>").appendTo(containerElem);

    tilesElem.addClass("tile-hover-acton-" + json.hoverAction);


    for (var i = 0; i < json.items.length; i++) {

        var item = json.items[i];

        var tileElem = $("<div class='tile effect-flippable effect-zoomable'></div>").appendTo(tilesElem);
        var paddingElem = $("<div class='tile-padding flippable-contents zoomable-contents'></div>").appendTo(tileElem);
        var frontElem = $("<div class='tile-front flippable-front'></div>").appendTo(paddingElem);
        var backElem = $("<div class='tile-back flippable-back'></div>").appendTo(paddingElem);

        if (json.flipOnHover == true && item.back != null) {
            tileElem.addClass("option-flip-on-hover");
        }
        if (json.zoomOnHover == true) {
            var tileZoomAmount = json.zoomAmount;
            if (json.flipOnHover == true) tileZoomAmount = 1.5;
            console.log(json.flipOnHover,json.zoomAmount,tileZoomAmount);
            tileElem.addClass("option-zoom-on-hover");
            tileElem.addClass("option-zoom-amount-" + tileZoomAmount.toString().replace(".","-"));
        }

        // Build front and back
        function setupFace(faceElem, faceJSON) {
            if (faceJSON.image != null) {
                var imgElem = $("<img/>")
                    .attr("src", faceJSON.image)
                    .appendTo(faceElem);
            }
            if (faceJSON.html) {
                var textElem = $("<div class='text'></div>")
                    .html(Machinata.Reporting.Text.resolve(instance,faceJSON.html))
                    .appendTo(faceElem);
            }
            if (faceJSON.colorShade != null) {
                console.log((json.theme || "default") + "/" + faceJSON.colorShade, Machinata.Reporting.getThemeColorByShade(config, json.theme || "default", faceJSON.colorShade));
                faceElem.css("background-color", Machinata.Reporting.getThemeColorByShade(config, json.theme || "default", faceJSON.colorShade));
                if (faceJSON.html) {
                    faceElem.find(".text").css("color", Machinata.Reporting.getThemeColorByShade(config, "text-on-"+json.theme || "text-on-default", faceJSON.colorShade));
                }
            }
        }
        if (item.front != null) setupFace(frontElem, item.front);
        if (item.back != null) setupFace(backElem, item.back);
        

        if (item.tooltip != null) tileElem.attr("title", Machinata.Reporting.Text.resolve(instance, item.tooltip));

    }
    tilesElem.append("<div class='clear'/>");

    // Legend
    var legendData = [
        {
            "title": { "resolved": "Aligned" },
            "symbol": "square",
            "colorShade": "positive"
        },
        {
            "title": { "resolved": "Misaligned" },
            "symbol": "square",
            "colorShade": "negative"
        }
    ];
    //var legendElem = Machinata.Reporting.Node.createHTMLLegendElem(instance, config, json, legendData).appendTo(containerElem);

    // Apply colors
    nodeElem.find(".positive-bg").css("background-color", Machinata.Reporting.getThemeColorByShade(config, json.theme || "default", "positive"));
    nodeElem.find(".negative-bg").css("background-color", Machinata.Reporting.getThemeColorByShade(config, json.theme || "default", "negative"));
    nodeElem.find(".gray-bg").css("background-color", Machinata.Reporting.getThemeColorByIndex("default", 5));


};
Machinata.Reporting.Node.TileGridNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here
};
Machinata.Reporting.Node.TileGridNode.resize = function (instance, config, json, nodeElem) {
    // Nothing to do here
    //nodeElem.height(400);

    var ww = nodeElem.find(".tiles").width();
    var tileW = ww / json.tileColumns;
    var tileH = tileW; // titleW+12+12+1;

    if (tileW < 80) nodeElem.addClass("is-compressed");
    else nodeElem.removeClass("is-compressed");

    nodeElem.find(".tile").width(tileW).height(tileH);
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-infocard.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-infocard.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// EXPERIMENTAL: NOT FOR PRODUCTION USE
/// </summary>
/// <type>class</type>
Machinata.Reporting.Node.InfoCardNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.InfoCardNode.defaults = {
    chrome: "solid",
    supportsToolbar: true,
    addStandardTools: false
};

/// <summary>
/// The resolved text to display in the node. If not text is provided, then the default
/// text ```Placeholder``` is displayed.
/// </summary>
Machinata.Reporting.Node.InfoCardNode.defaults.text = null;

Machinata.Reporting.Node.InfoCardNode.init = function (instance, config, json, nodeElem) {
    var containerElem = $("<div class='node-bg sizer flippable'></div>").appendTo(nodeElem);

    var flippableElem = $("<div class='flippable-contents'></div>").appendTo(containerElem);
    var frontElem = $("<div class='flippable-front'></div>").appendTo(flippableElem);
    var backElem = $("<div class='flippable-back'></div>").appendTo(flippableElem);

        
    function buildPanel(elem, item) {
        var contentsElem = $("<div class='contents'></div>").appendTo(frontElem);


        var textElem = $("<div class='text'></div>").appendTo(contentsElem);
        textElem.html(Machinata.Reporting.Text.resolve(instance, item.html));
        
        $("<div class='clear'/>").insertAfter(textElem.find("h2,h3,h4").last());

        if (item.image != null) {
            var imgElem = $("<img class='DISABLED_effect-zoomable option-zoom-on-hover'/>");
            imgElem.attr("src", item.image);
            textElem.prepend(imgElem);
        }

        /*
        if (item.image != null) {
            var imgElem = $("<img class='image'/>").appendTo(contentsElem);
            imgElem.attr("src", item.image);
        }*/
    }

    buildPanel(frontElem, json.front);
    if (json.back != null) buildPanel(backElem, json.back);

    containerElem.find("img").addClass("dark-bg");
    //containerElem.addClass("gray-bg");


    // Apply colors
    nodeElem.find(".dark-bg").css("background-color", Machinata.Reporting.getThemeColorByIndex("gray", 0));
    nodeElem.find(".negative-bg").css("background-color", Machinata.Reporting.getThemeColorByIndex("default", 1));
    nodeElem.find(".gray-bg").css("background-color", Machinata.Reporting.getThemeColorByIndex("default", 5));


};
Machinata.Reporting.Node.InfoCardNode.draw = function (instance, config, json, nodeElem) {
    // Nothing to do here
};
Machinata.Reporting.Node.InfoCardNode.resize = function (instance, config, json, nodeElem) {
    // Nothing to do here

    var ww = nodeElem.width();
    var hh = ww / (16/9);

    nodeElem.find(".sizer").height(hh);
};










/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-node-radar.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-node-radar.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Beta
/// </summary>
/// <type>class</type>
/// <inherits>Machinata.Reporting.Node.VegaNode</inherits>
Machinata.Reporting.Node.RadarNode = {};

/// <summary>
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults = {};

/// <summary>
/// By default this chart is infographic-style ```light```.
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.chrome = "light";
/// <summary>
/// This node supports headless rendering...
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.supportsHeadlessRendering = true;

/// <summary>
/// This node supports being added to dashboards...
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.supportsDashboard = true;

/// <summary>
/// Defines which layout sizes are supported on the dashboard.
/// See ```Machinata.Reporting.Node.Defaults.supportedDashboardSizes```
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.supportedDashboardSizes = [Machinata.Reporting.Layouts.BLOCK_2x2, Machinata.Reporting.Layouts.BLOCK_2x1, Machinata.Reporting.Layouts.BLOCK_4x2];

/// <summary>
/// Yes, we support toolbar.
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.supportsToolbar = true;

/// <summary>
/// Legends for this chart.
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.insertLegend = true;

/// <summary>
/// Sets the number of columns to use for legends. 
/// By default we use```2```.
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.legendColumns = 2;

/// <summary>
/// Defines the outer radius in decimal percent.
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.outerRadius = 1.0;

/// <summary>
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.leftRightPadding = 80; //TODO: needs to be dynamic

/// <summary>
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.topBottomPadding = 40;

/// <summary>
/// Defines the line curve to use. Can be either ```linear``` or ```cardinal```.
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.radarLineCurve = "linear";

/// <summary>
/// </summary>
Machinata.Reporting.Node.RadarNode.defaults.fillOpacity = 0.5;

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.RadarNode.getVegaSpec = function (instance, config, json, nodeElem) {
    return {
        "data": [
          {
              "name": "series",
              "values": null
          },
            {
                "name": "empty",
                "description": "Used to dynamically remove a group (since vega still can't do this via a property)",
                "values": []
            },
          {
              "name": "colorShades",
              "values": config.themeColorShadeNames
          },
          {
              "name": "grayShades",
              "values": config.themeGrayShadeNames
          },
          {
              "name": "facts",
              "source": "series",
              "transform": [
                {
                    "type": "flatten",
                    "fields": ["facts"],
                    "as": ["fact"]
                }
              ]
          },
          {
              "name": "factsResolved",
              "source": "facts",
              "transform": [

                {
                    "type": "formula",
                    "initonly": true,
                    "as": "category",
                    "expr": "datum.fact.category"
                },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "val",
                    "expr": "datum.fact.val"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "categoryResolved",
                      "expr": "datum.category.resolved"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "tooltipResolved",
                      "expr": "datum.tooltip != null ? datum.tooltip.resolved : null"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "titleResolved",
                    "expr": "datum.title.resolved"
                  },
                {
                    "type": "formula",
                    "initonly": true,
                    "as": "valResolved",
                    "expr": "datum.title != null ? (datum.titleResolved + ': ' + datum.fact.resolved) : (datum.fact.resolved)"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "categoryTooltipResolved",
                      "expr": "datum.fact.categoryTooltip != null ? datum.fact.categoryTooltip.resolved : null"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "colorResolved",
                      "expr": "datum.colorShade != null ? scale('colorByShade',datum.colorShade) : scale('color',datum.id)"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "radarKey",
                      "expr": "datum.categoryResolved"
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "radarCategory",
                      "expr": "datum.id" // serie id
                  },
                  {
                      "type": "formula",
                      "initonly": true,
                      "as": "radarValue",
                      "expr": "datum.val"
                  }
              ]
            },
            {
                "name": "factsResolvedRadarKeys",
                "source": "factsResolved",
                "transform": [
                    {
                        "type": "aggregate",
                        "groupby": ["radarKey"]
                    }
                ]
            }
        ],
        "signals": [
            { "name": "fillOpacity", "init": json.fillOpacity },
            { "name": "leftRightPadding", "init": json.leftRightPadding },
            { "name": "topBottomPadding", "init": json.topBottomPadding },
            { "name": "outerRadius", "init": json.outerRadius },
            { "name": "lineInterpolation", "init": "'" + json.radarLineCurve+"-closed'" },
        ],
        "scales": [
            {
                "name": "color",
                "type": "ordinal",
                "domain": { "data": "series", "field": "id" },
                "range": { "scheme": json.theme }
            },
            {
                "name": "colorByShade",
                "type": "ordinal",
                "domain": { "data": "colorShades", "field": "data" },
                "range": { "scheme": json.theme }
            },
          {
              // Provide the proper color for the legend
              "name": "legendColor",
              "type": "ordinal",
              "domain": { "data": "factsResolved", "field": "radarCategory" },
              "range": { "data": "factsResolved", "field": "colorResolved" },
            },
            {
                // Provide the proper label for the legend
                "name": "legendLabel",
                "type": "ordinal",
                "domain": { "data": "factsResolved", "field": "radarCategory" },
                "range": { "data": "factsResolved", "field": "titleResolved" }
            },
            {
                // Provide the proper label for the legend
                "name": "radarCategoryTooltip",
                "type": "ordinal",
                "domain": { "data": "factsResolved", "field": "radarKey" },
                "range": { "data": "factsResolved", "field": "categoryTooltipResolved" }
            },

            {
                "name": "angular",
                "type": "point",
                "range": { "signal": "[-PI, PI]" },
                "padding": 0.5,
                "domain": { "data": "factsResolved", "field": "radarKey" }
            }
            
        ],
        "marks": [
            {
                "type": "group",
                "encode": {
                    "enter": {
                        // Move to center
                        "x": { "signal": "width/2" },
                        "y": { "signal": "height/2" }
                    }
                },
                "signals": [
                    { "name": "radius", "update": "(min(width-leftRightPadding,height-topBottomPadding) / 2) * outerRadius" }
                ],
                "scales": [

                    {
                        "name": "radial",
                        "type": "linear",
                        "range": { "signal": "[0, radius]" },
                        "zero": true,
                        "nice": false,
                        "domain": { "data": "factsResolved", "field": "radarValue" },
                        "domainMin": 0
                    },
                ],
                "marks": [
                    {
                        "type": "group",
                        "name": "categories",
                        "zindex": 1,
                        "from": {
                            "facet": { "data": "factsResolved", "name": "facet", "groupby": ["radarCategory"] }
                        },
                        "marks": [
                            {
                                // Area fill on line (translucent)
                                "type": "line",
                                "name": "category-fill",
                                "from": { "data": "facet" },
                                "encode": {
                                    "enter": {
                                        "interpolate": { "signal": "lineInterpolation" },
                                        "fill": { "signal": "datum.colorResolved" },
                                        "fillOpacity": { "signal": "fillOpacity" }
                                    },
                                    "update": {
                                        "x": { "signal": "scale('radial', datum.radarValue) * cos(scale('angular', datum.radarKey))" },
                                        "y": { "signal": "scale('radial', datum.radarValue) * sin(scale('angular', datum.radarKey))" },
                                    }
                                }
                            },
                            {
                                // Line (solid)
                                "type": "line",
                                "name": "category-line",
                                "from": { "data": "facet" },
                                "encode": {
                                    "enter": {
                                        "interpolate": { "signal": "lineInterpolation" },
                                        "stroke": { "signal": "datum.colorResolved" },
                                        "strokeWidth": { "value": config.graphLineSize },
                                        "strokeCap": { "value": "round" },
                                    },
                                    "update": {
                                        "x": { "signal": "scale('radial', datum.radarValue) * cos(scale('angular', datum.radarKey))" },
                                        "y": { "signal": "scale('radial', datum.radarValue) * sin(scale('angular', datum.radarKey))" },
                                    }
                                }
                            },
                            /*{
                                "type": "text",
                                "name": "value-text",
                                "from": { "data": "category-line" },
                                "encode": {
                                    "enter": {
                                        "text": { "signal": "datum.datum.radarValue" },
                                        "align": { "value": "center" },
                                        "baseline": { "value": "middle" },
                                        "fill": { "value": "black" }
                                    },
                                    "update": {
                                        "x": { "signal": "datum.x" },
                                        "y": { "signal": "datum.y" },
                                    }
                                }
                            },*/
                            {
                                "type": "symbol",
                                "name": "value-symbol",
                                "from": { "data": "category-line" },
                                "encode": {
                                    "enter": {
                                        "shape": { "value": "circle" },
                                        "size": { "value": 4 * config.graphLineSize * config.graphLineSize },
                                        "fill": { "signal": "datum.datum.colorResolved" },
                                    },
                                    "update": {
                                        "x": { "signal": "datum.x" },
                                        "y": { "signal": "datum.y" },
                                    }
                                }
                            },
                            {
                                "type": "symbol",
                                "name": "value-tooltip",
                                "from": { "data": "category-line" },
                                "encode": {
                                    "enter": {
                                        "shape": { "value": "circle" },
                                        "size": { "value": 10 * config.graphLineSize * config.graphLineSize },
                                        "tooltip": { "signal": "datum.datum.categoryResolved + '[break]' + datum.datum.valResolved" },
                                        "opacity": { "value": 0 },
                                    },
                                    "update": {
                                        "x": { "signal": "datum.x" },
                                        "y": { "signal": "datum.y" },
                                    }
                                }
                            }
                        ]
                    },
                    {
                        "type": "rule",
                        "name": "radial-grid",
                        "from": { "data": "factsResolvedRadarKeys" },
                        "zindex": 0,
                        "encode": {
                            "enter": {
                                "x": { "value": 0 },
                                "y": { "value": 0 },
                                "stroke": { "value": config.gridColor },
                                "strokeWidth": { "value": config.gridLineSize },
                                //"opacity": { "value": 0.2 }
                            },
                            "update": {
                                "x2": { "signal": "radius * cos(scale('angular', datum.radarKey))" },
                                "y2": { "signal": "radius * sin(scale('angular', datum.radarKey))" },
                            }
                        }
                    },
                    {
                        // Category labels
                        "type": "text",
                        "name": "key-label",
                        "from": { "data": "factsResolvedRadarKeys" },
                        "zindex": 1,
                        "encode": {
                            "enter": {
                                "text": { "field": "radarKey" },
                                "tooltip": { "signal": "scale('radarCategoryTooltip',datum.radarKey)" },
                                "align": [
                                    {
                                        "test": "abs(scale('angular', datum.radarKey)) > PI / 2",
                                        "value": "right"
                                    },
                                    {
                                        "value": "left"
                                    }
                                ],
                                "baseline": [
                                    {
                                        "test": "scale('angular', datum.radarKey) > 0", "value": "top"
                                    },
                                    {
                                        "test": "scale('angular', datum.radarKey) == 0", "value": "middle"
                                    },
                                    {
                                        "value": "bottom"
                                    }
                                ],
                                "fill": { "value": "black" },
                                "fontWeight": { "value": "bold" }
                            },
                            "update": {
                                "x": { "signal": "(radius + 5) * cos(scale('angular', datum.radarKey))" },
                                "y": { "signal": "(radius + 5) * sin(scale('angular', datum.radarKey))" },
                                
                            }
                        }
                    },
                    /*{
                        "type": "line",
                        "name": "outer-line",
                        "from": { "data": "radial-grid" },
                        "encode": {
                            "enter": {
                                "interpolate": { "value": "linear-closed" },
                                "stroke": { "value": "lightgray" },
                                "strokeWidth": { "value": 1 }
                            },
                            "update": {
                                "x": { "field": "x2" },
                                "y": { "field": "y2" },
                            }
                        }
                    }*/
                ]
            },
            
        ]
    };
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.RadarNode.applyVegaData = function (instance, config, json, nodeElem, spec) {
    // Insert series
    spec["data"][0].values = json.series;
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.RadarNode.init = function (instance, config, json, nodeElem) {

    // Convert fact category titles into multilines...
    //TODO: similar to this:
    /*
    if (json.xAxisLabelLimitChars != null && json.xAxisLabelLimitChars > 0) {
        Machinata.Util.each(json.series, function (index, jsonSerie) {
            Machinata.Util.each(jsonSerie.facts, function (index, jsonFact) {
                var catResolved = Machinata.Reporting.Text.resolve(instance,jsonFact.category);
                var catLineBreaked = null;
                catLineBreaked = Machinata.Reporting.Tools.lineBreakString(catResolved, {
                    maxCharsPerLine: json.xAxisLabelLimitChars,
                    maxLines: json.xAxisLabelLimitLines,
                    wordSeparator: " ",
                    ellipsis: config.textTruncationEllipsis,
                    appendEllipsisOnLastLine: true,
                    returnArray: true
                });
                jsonFact.categoryLineBreaked = catLineBreaked;
                if (jsonFact.tooltip == null && catLineBreaked.length > 1) {
                    jsonFact.tooltip = {
                        resolved: catResolved
                    }
                }
            });
        });
    }*/

    // Generate legend data
    Machinata.Reporting.Node.VegaNode.Util.createLegendForSeries(instance, config, json, json.series);

    // Call parent
    Machinata.Reporting.Node["VegaNode"].init(instance, config, json, nodeElem);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.RadarNode.draw = function (instance, config, json, nodeElem) {
    // Call parent
    Machinata.Reporting.Node["VegaNode"].draw(instance, config, json, nodeElem);
    // Debugging
    //Machinata.Reporting.Node.VegaNode.debugOutputDataSet(nodeElem, "factsResolved");
    //Machinata.Reporting.Node.VegaNode.debugOutputDataSet(nodeElem, "factsResolvedRadarKeys");
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.RadarNode.exportFormat = function (instance, config, json, nodeElem, format, filename) {
    // Call parent
    return Machinata.Reporting.Node["VegaNode"].exportFormat(instance, config, json, nodeElem, format, filename);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Reporting.Node.RadarNode.exportExcelFormat = function (instance, config, json, nodeElem, format, filename) {
    var workbook = Machinata.Reporting.Export.createExcelWorkbook(instance, config, json);
    workbook = Machinata.Reporting.Export.createExcelDataForCategoryChart(instance, config, json, workbook, format);
    Machinata.Reporting.Export.saveExcelWorkbook(instance, config, json, workbook, filename);
    return true;
};






/* -------------------------------------------------------------------------------------------------- */
/* machinata-reporting-responsive.js */
/* File: js/machinata-reporting-bundle.js/machinata-reporting-responsive.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Tools and extensions that make reports fully responsive.
/// </summary>
/// <type>namespace</type>
Machinata.Reporting.Responsive = {};

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP = "desktop";

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET = "tablet";

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE = "mobile";

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.LAYOUT_WIDTH_MOBILE = 450;

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.LAYOUT_WIDTH_TABLET = 800;

/// <summary>
/// Provides the handler used by Core JS Responsive to get the actual report layout (we don't use the page layout for the nodes).
/// </summary>
Machinata.Reporting.Responsive.layoutHandlerForCoreResponsive = function (elem, definition) {
    return elem.closest(".machinata-reporting-report").data("layout"); //TODO: what if someone is using a different selector?
};

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.getReportLayout = function (instance) {
    return instance._currentLayout;
    //if (instance._previousLayout == null) Machinata.Reporting.Responsive.updateReportLayout(instance,"Machinata.Reporting.Responsive.getReportLayout"); // make sure this has been called at least once before
    //return instance._previousLayout;
};

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.getReportLayoutForSize = function (instance, size) {
    var layout = Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP; //fallback
    if (size < Machinata.Reporting.Responsive.LAYOUT_WIDTH_MOBILE) layout = Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE;
    else if (size < Machinata.Reporting.Responsive.LAYOUT_WIDTH_TABLET) layout = Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET;
    return layout;
};

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.updateForContainerSize = function (instance) {
    Machinata.Reporting.Responsive.updateReportLayout(instance);
    instance.elems.content.find(".machinata-reporting-node").trigger(Machinata.Reporting.Events.REDRAW_NODE_SIGNAL);
};

/// <summary>
/// </summary>
Machinata.Reporting.Responsive.updateReportLayout = function (instance) {

    if (instance.config.automaticallySetLayoutMinMaxDimensions == true) {
        instance.elems.content.css("min-width", instance.config.layoutMinWidth);
        instance.elems.content.css("max-width", instance.config.layoutMaxWidth);
        instance.elems.content.css("margin-left", "auto");
        instance.elems.content.css("margin-right", "auto");
    }

    // Init
    var reportWidth = instance.elems.content.width();
    var reportLayout = Machinata.Reporting.Responsive.getReportLayoutForSize(instance, reportWidth);

    // Are we changing?
    var layoutIsChanging = instance._currentLayout != reportLayout;
    if (layoutIsChanging == true) {
        // Debug
        Machinata.debug("Machinata.Reporting.Responsive.updateReportLayout:");
        Machinata.debug("  width:" + reportWidth);
        Machinata.debug("  layout:" + instance._currentLayout + " > " + reportLayout);

        // Update the layout attributes
        instance._currentLayout = reportLayout;
        instance.elems.content.data("layout", reportLayout);

        // Update the layout classes
        instance.elems.content.addClass("layout-" + reportLayout);
        if (reportLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP) instance.elems.content.removeClass("layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP);
        if (reportLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET) instance.elems.content.removeClass("layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET);
        if (reportLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE) instance.elems.content.removeClass("layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE);
        if (instance.config.automaticallySetReportLayoutClassOnBody == true) {
            $("body").addClass("machinata-reporting-layout-" + reportLayout);
            if (reportLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP) $("body").removeClass("machinata-reporting-layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP);
            if (reportLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET) $("body").removeClass("machinata-reporting-layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET);
            if (reportLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE) $("body").removeClass("machinata-reporting-layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE);
        }
        
    }

    if (instance.config.automaticallySetPageLayoutClassOnBody == true) {
        var pageWidth = $("body").width();
        var pageLayout = Machinata.Reporting.Responsive.getReportLayoutForSize(instance, pageWidth);
        $("body").addClass("machinata-page-layout-" + pageLayout);
        if (pageLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP) $("body").removeClass("machinata-page-layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_DESKTOP);
        if (pageLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET) $("body").removeClass("machinata-page-layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_TABLET);
        if (pageLayout != Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE) $("body").removeClass("machinata-page-layout-" + Machinata.Reporting.Responsive.LAYOUT_NAME_MOBILE);
    }

};

/* -------------------------------------------------------------------------------------------------- */
/* jquery-namespace-postprocess.js */
/* File: js/machinata-reporting-bundle.js/jquery-namespace-postprocess.js */
/* -------------------------------------------------------------------------------------------------- */


}) (MACHINATA_GLOBAL.MACHINATA_JQUERY, MACHINATA_GLOBAL.MACHINATA_JQUERY); 

